var pP = Object.defineProperty;
var mP = (n, e, t) => e in n ? pP(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Bn = (n, e, t) => mP(n, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as Mt, jsx as Re, Fragment as pd } from "react/jsx-runtime";
import { a as c0, d as Mn, y as k6, R as gP, s as O6, A as _P, f as E2, J as D6, r as R6, e as Nx, g as yP, b as vm, X as Ix, Y as N6, h as S2, N as T3, M as A3, F as k3, j as vP, D as bP, k as EP, l as SP, m as CP, v as wP, n as xP, o as TP, p as AP, c as O3, x as I6, t as kP, u as OP, w as DP, z as RP, U as NP, _ as IP } from "./FilterSearch-BR-Q3sXQ.js";
import * as Ce from "react";
import si, { createContext as bf, useState as Wn, useEffect as An, useContext as rc, useRef as zn, forwardRef as Ef, useImperativeHandle as Lx, createElement as su, Children as Mx, useCallback as hr, useMemo as li, useLayoutEffect as L6, Component as M6, memo as LP, useReducer as Px, cloneElement as MP } from "react";
var P6 = {}, jx = {};
Object.defineProperty(jx, "__esModule", {
  value: !0
});
jx.confetti = VP;
var PP = ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"];
function jP(n, e, t, i, c) {
  return Array.from({ length: e }).map(function(a, s) {
    var r = document.createElement("div"), l = t[s % t.length];
    return r.style["background-color"] = l, r.style.width = i, r.style.height = c, r.style.position = "absolute", r.style.willChange = "transform, opacity", r.style.visibility = "hidden", n.appendChild(r), r;
  });
}
function BP(n, e, t, i) {
  var c = n * (Math.PI / 180), a = e * (Math.PI / 180);
  return {
    x: 0,
    y: 0,
    z: 0,
    wobble: i() * 10,
    wobbleSpeed: 0.1 + i() * 0.1,
    velocity: t * 0.5 + i() * t,
    angle2D: -c + (0.5 * a - i() * a),
    angle3D: -(Math.PI / 4) + i() * (Math.PI / 2),
    tiltAngle: i() * Math.PI,
    tiltAngleSpeed: 0.1 + i() * 0.3
  };
}
function FP(n, e, t, i) {
  n.physics.x += Math.cos(n.physics.angle2D) * n.physics.velocity, n.physics.y += Math.sin(n.physics.angle2D) * n.physics.velocity, n.physics.z += Math.sin(n.physics.angle3D) * n.physics.velocity, n.physics.wobble += n.physics.wobbleSpeed, i ? n.physics.velocity *= i : n.physics.velocity -= n.physics.velocity * t, n.physics.y += 3, n.physics.tiltAngle += n.physics.tiltAngleSpeed;
  var c = n.physics, a = c.x, s = c.y, r = c.z, l = c.tiltAngle, d = c.wobble, f = a + 10 * Math.cos(d), h = s + 10 * Math.sin(d), p = "translate3d(" + f + "px, " + h + "px, " + r + "px) rotate3d(1, 1, 1, " + l + "rad)";
  n.element.style.visibility = "visible", n.element.style.transform = p, n.element.style.opacity = 1 - e;
}
function UP(n, e, t, i, c, a) {
  var s = void 0;
  return new Promise(function(r) {
    function l(d) {
      s || (s = d);
      var f = d - s, h = s === d ? 0 : (d - s) / c;
      e.slice(0, Math.ceil(f / a)).forEach(function(p) {
        FP(p, h, t, i);
      }), d - s < c ? requestAnimationFrame(l) : (e.forEach(function(p) {
        if (p.element.parentNode === n)
          return n.removeChild(p.element);
      }), r());
    }
    requestAnimationFrame(l);
  });
}
var HP = {
  angle: 90,
  spread: 45,
  startVelocity: 45,
  elementCount: 50,
  width: "10px",
  height: "10px",
  perspective: "",
  colors: PP,
  duration: 3e3,
  stagger: 0,
  dragFriction: 0.1,
  random: Math.random
};
function zP(n) {
  return !n.stagger && n.delay && (n.stagger = n.delay), n;
}
function VP(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = Object.assign({}, HP, zP(e)), i = t.elementCount, c = t.colors, a = t.width, s = t.height, r = t.perspective, l = t.angle, d = t.spread, f = t.startVelocity, h = t.decay, p = t.dragFriction, g = t.duration, _ = t.stagger, b = t.random;
  n.style.perspective = r;
  var v = jP(n, i, c, a, s), E = v.map(function(C) {
    return {
      element: C,
      physics: BP(l, d, f, b)
    };
  });
  return UP(n, E, p, h, g, _);
}
Object.defineProperty(P6, "__esModule", {
  value: !0
});
var qP = /* @__PURE__ */ function() {
  function n(e, t) {
    for (var i = 0; i < t.length; i++) {
      var c = t[i];
      c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(e, c.key, c);
    }
  }
  return function(e, t, i) {
    return t && n(e.prototype, t), i && n(e, i), e;
  };
}(), j6 = si, GP = $P(j6), WP = jx;
function $P(n) {
  return n && n.__esModule ? n : { default: n };
}
function YP(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function XP(n, e) {
  if (!n)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : n;
}
function KP(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(n, e) : n.__proto__ = e);
}
var QP = {
  position: "relative"
}, ZP = function(n) {
  KP(e, n);
  function e(t) {
    YP(this, e);
    var i = XP(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
    return i.setRef = i.setRef.bind(i), i;
  }
  return qP(e, [{
    key: "componentDidUpdate",
    value: function(i) {
      !i.active && this.props.active && (0, WP.confetti)(this.container, this.props.config);
    }
  }, {
    key: "setRef",
    value: function(i) {
      this.container = i;
    }
  }, {
    key: "render",
    value: function() {
      return GP.default.createElement("div", { className: this.props.className, style: QP, ref: this.setRef });
    }
  }]), e;
}(j6.Component), JP = P6.default = ZP;
const ej = "_confetti_1jhkt_1", tj = {
  confetti: ej
}, B6 = bf({
  colorMode: void 0,
  setColorMode: () => {
  },
  isSidebarOpen: !1,
  toggleSidebar: () => {
  },
  confetti: () => {
  }
}), Xie = ({ children: n }) => {
  const [e, t] = Wn(
    void 0
  ), [i, c] = Wn(!1), [a, s] = Wn(!1), d = {
    colorMode: e,
    setColorMode: t,
    isSidebarOpen: i,
    toggleSidebar: () => {
      c(!i);
    },
    confetti: () => {
      s(!0), setTimeout(() => {
        s(!1);
      }, 100);
    }
  };
  An(() => {
    const h = window.document.documentElement, p = localStorage.getItem("theme");
    if (p) {
      t(p);
      return;
    }
    const g = h.dataset.theme;
    t(g ?? "light");
  }, []), An(() => {
    if (!e) return;
    const h = window.document.documentElement;
    h.dataset.theme = e, localStorage.setItem("theme", e);
  }, [e]);
  const f = {
    angle: 90,
    spread: 250,
    startVelocity: 50,
    width: "10px",
    height: "10px",
    elementCount: 170,
    dragFriction: 0.07,
    duration: 3500,
    stagger: 3,
    colors: [
      "#068cfc",
      "#1dc98d",
      "#ffbb33",
      "#fc3636",
      "#fb2d6e",
      "#ff5e24"
    ]
    // these are all the 500 colors (not gray)
  };
  return e ? /* @__PURE__ */ Mt(B6.Provider, { value: d, children: [
    n,
    /* @__PURE__ */ Re("div", { className: tj.confetti, children: /* @__PURE__ */ Re(JP, { active: a, config: f }) })
  ] }) : null;
};
/*! js-cookie v3.0.5 | MIT */
function Xv(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var i in t)
      n[i] = t[i];
  }
  return n;
}
var nj = {
  read: function(n) {
    return n[0] === '"' && (n = n.slice(1, -1)), n.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(n) {
    return encodeURIComponent(n).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Gw(n, e) {
  function t(c, a, s) {
    if (!(typeof document > "u")) {
      s = Xv({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), c = encodeURIComponent(c).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var r = "";
      for (var l in s)
        s[l] && (r += "; " + l, s[l] !== !0 && (r += "=" + s[l].split(";")[0]));
      return document.cookie = c + "=" + n.write(a, c) + r;
    }
  }
  function i(c) {
    if (!(typeof document > "u" || arguments.length && !c)) {
      for (var a = document.cookie ? document.cookie.split("; ") : [], s = {}, r = 0; r < a.length; r++) {
        var l = a[r].split("="), d = l.slice(1).join("=");
        try {
          var f = decodeURIComponent(l[0]);
          if (s[f] = n.read(d, f), c === f)
            break;
        } catch {
        }
      }
      return c ? s[c] : s;
    }
  }
  return Object.create(
    {
      set: t,
      get: i,
      remove: function(c, a) {
        t(
          c,
          "",
          Xv({}, a, {
            expires: -1
          })
        );
      },
      withAttributes: function(c) {
        return Gw(this.converter, Xv({}, this.attributes, c));
      },
      withConverter: function(c) {
        return Gw(Xv({}, this.converter, c), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(n) }
    }
  );
}
var Kie = Gw(nj, { path: "/" });
class J_ extends Error {
}
J_.prototype.name = "InvalidTokenError";
function rj(n) {
  return decodeURIComponent(atob(n).replace(/(.)/g, (e, t) => {
    let i = t.charCodeAt(0).toString(16).toUpperCase();
    return i.length < 2 && (i = "0" + i), "%" + i;
  }));
}
function ij(n) {
  let e = n.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return rj(e);
  } catch {
    return atob(e);
  }
}
function Qie(n, e) {
  if (typeof n != "string")
    throw new J_("Invalid token specified: must be a string");
  e || (e = {});
  const t = e.header === !0 ? 0 : 1, i = n.split(".")[t];
  if (typeof i != "string")
    throw new J_(`Invalid token specified: missing part #${t + 1}`);
  let c;
  try {
    c = ij(i);
  } catch (a) {
    throw new J_(`Invalid token specified: invalid base64 for part #${t + 1} (${a.message})`);
  }
  try {
    return JSON.parse(c);
  } catch (a) {
    throw new J_(`Invalid token specified: invalid json for part #${t + 1} (${a.message})`);
  }
}
const oj = bf(
  void 0
);
var F6 = { exports: {} };
/*!
 * Pusher JavaScript Library v8.4.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */
(function(n, e) {
  (function(i, c) {
    n.exports = c();
  })(window, function() {
    return (
      /******/
      function(t) {
        var i = {};
        function c(a) {
          if (i[a])
            return i[a].exports;
          var s = i[a] = {
            /******/
            i: a,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return t[a].call(s.exports, s, s.exports, c), s.l = !0, s.exports;
        }
        return c.m = t, c.c = i, c.d = function(a, s, r) {
          c.o(a, s) || Object.defineProperty(a, s, { enumerable: !0, get: r });
        }, c.r = function(a) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
        }, c.t = function(a, s) {
          if (s & 1 && (a = c(a)), s & 8 || s & 4 && typeof a == "object" && a && a.__esModule) return a;
          var r = /* @__PURE__ */ Object.create(null);
          if (c.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: a }), s & 2 && typeof a != "string") for (var l in a) c.d(r, l, (function(d) {
            return a[d];
          }).bind(null, l));
          return r;
        }, c.n = function(a) {
          var s = a && a.__esModule ? (
            /******/
            function() {
              return a.default;
            }
          ) : (
            /******/
            function() {
              return a;
            }
          );
          return c.d(s, "a", s), s;
        }, c.o = function(a, s) {
          return Object.prototype.hasOwnProperty.call(a, s);
        }, c.p = "", c(c.s = 2);
      }([
        /* 0 */
        /***/
        function(t, i, c) {
          var a = this && this.__extends || /* @__PURE__ */ function() {
            var b = function(v, E) {
              return b = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(C, y) {
                C.__proto__ = y;
              } || function(C, y) {
                for (var T in y) y.hasOwnProperty(T) && (C[T] = y[T]);
              }, b(v, E);
            };
            return function(v, E) {
              b(v, E);
              function C() {
                this.constructor = v;
              }
              v.prototype = E === null ? Object.create(E) : (C.prototype = E.prototype, new C());
            };
          }();
          Object.defineProperty(i, "__esModule", { value: !0 });
          var s = 256, r = (
            /** @class */
            function() {
              function b(v) {
                v === void 0 && (v = "="), this._paddingCharacter = v;
              }
              return b.prototype.encodedLength = function(v) {
                return this._paddingCharacter ? (v + 2) / 3 * 4 | 0 : (v * 8 + 5) / 6 | 0;
              }, b.prototype.encode = function(v) {
                for (var E = "", C = 0; C < v.length - 2; C += 3) {
                  var y = v[C] << 16 | v[C + 1] << 8 | v[C + 2];
                  E += this._encodeByte(y >>> 3 * 6 & 63), E += this._encodeByte(y >>> 2 * 6 & 63), E += this._encodeByte(y >>> 1 * 6 & 63), E += this._encodeByte(y >>> 0 * 6 & 63);
                }
                var T = v.length - C;
                if (T > 0) {
                  var y = v[C] << 16 | (T === 2 ? v[C + 1] << 8 : 0);
                  E += this._encodeByte(y >>> 3 * 6 & 63), E += this._encodeByte(y >>> 2 * 6 & 63), T === 2 ? E += this._encodeByte(y >>> 1 * 6 & 63) : E += this._paddingCharacter || "", E += this._paddingCharacter || "";
                }
                return E;
              }, b.prototype.maxDecodedLength = function(v) {
                return this._paddingCharacter ? v / 4 * 3 | 0 : (v * 6 + 7) / 8 | 0;
              }, b.prototype.decodedLength = function(v) {
                return this.maxDecodedLength(v.length - this._getPaddingLength(v));
              }, b.prototype.decode = function(v) {
                if (v.length === 0)
                  return new Uint8Array(0);
                for (var E = this._getPaddingLength(v), C = v.length - E, y = new Uint8Array(this.maxDecodedLength(C)), T = 0, A = 0, k = 0, N = 0, j = 0, I = 0, B = 0; A < C - 4; A += 4)
                  N = this._decodeChar(v.charCodeAt(A + 0)), j = this._decodeChar(v.charCodeAt(A + 1)), I = this._decodeChar(v.charCodeAt(A + 2)), B = this._decodeChar(v.charCodeAt(A + 3)), y[T++] = N << 2 | j >>> 4, y[T++] = j << 4 | I >>> 2, y[T++] = I << 6 | B, k |= N & s, k |= j & s, k |= I & s, k |= B & s;
                if (A < C - 1 && (N = this._decodeChar(v.charCodeAt(A)), j = this._decodeChar(v.charCodeAt(A + 1)), y[T++] = N << 2 | j >>> 4, k |= N & s, k |= j & s), A < C - 2 && (I = this._decodeChar(v.charCodeAt(A + 2)), y[T++] = j << 4 | I >>> 2, k |= I & s), A < C - 3 && (B = this._decodeChar(v.charCodeAt(A + 3)), y[T++] = I << 6 | B, k |= B & s), k !== 0)
                  throw new Error("Base64Coder: incorrect characters for decoding");
                return y;
              }, b.prototype._encodeByte = function(v) {
                var E = v;
                return E += 65, E += 25 - v >>> 8 & 6, E += 51 - v >>> 8 & -75, E += 61 - v >>> 8 & -15, E += 62 - v >>> 8 & 3, String.fromCharCode(E);
              }, b.prototype._decodeChar = function(v) {
                var E = s;
                return E += (42 - v & v - 44) >>> 8 & -s + v - 43 + 62, E += (46 - v & v - 48) >>> 8 & -s + v - 47 + 63, E += (47 - v & v - 58) >>> 8 & -s + v - 48 + 52, E += (64 - v & v - 91) >>> 8 & -s + v - 65 + 0, E += (96 - v & v - 123) >>> 8 & -s + v - 97 + 26, E;
              }, b.prototype._getPaddingLength = function(v) {
                var E = 0;
                if (this._paddingCharacter) {
                  for (var C = v.length - 1; C >= 0 && v[C] === this._paddingCharacter; C--)
                    E++;
                  if (v.length < 4 || E > 2)
                    throw new Error("Base64Coder: incorrect padding");
                }
                return E;
              }, b;
            }()
          );
          i.Coder = r;
          var l = new r();
          function d(b) {
            return l.encode(b);
          }
          i.encode = d;
          function f(b) {
            return l.decode(b);
          }
          i.decode = f;
          var h = (
            /** @class */
            function(b) {
              a(v, b);
              function v() {
                return b !== null && b.apply(this, arguments) || this;
              }
              return v.prototype._encodeByte = function(E) {
                var C = E;
                return C += 65, C += 25 - E >>> 8 & 6, C += 51 - E >>> 8 & -75, C += 61 - E >>> 8 & -13, C += 62 - E >>> 8 & 49, String.fromCharCode(C);
              }, v.prototype._decodeChar = function(E) {
                var C = s;
                return C += (44 - E & E - 46) >>> 8 & -s + E - 45 + 62, C += (94 - E & E - 96) >>> 8 & -s + E - 95 + 63, C += (47 - E & E - 58) >>> 8 & -s + E - 48 + 52, C += (64 - E & E - 91) >>> 8 & -s + E - 65 + 0, C += (96 - E & E - 123) >>> 8 & -s + E - 97 + 26, C;
              }, v;
            }(r)
          );
          i.URLSafeCoder = h;
          var p = new h();
          function g(b) {
            return p.encode(b);
          }
          i.encodeURLSafe = g;
          function _(b) {
            return p.decode(b);
          }
          i.decodeURLSafe = _, i.encodedLength = function(b) {
            return l.encodedLength(b);
          }, i.maxDecodedLength = function(b) {
            return l.maxDecodedLength(b);
          }, i.decodedLength = function(b) {
            return l.decodedLength(b);
          };
        },
        /* 1 */
        /***/
        function(t, i, c) {
          Object.defineProperty(i, "__esModule", { value: !0 });
          var a = "utf8: invalid string", s = "utf8: invalid source encoding";
          function r(f) {
            for (var h = new Uint8Array(l(f)), p = 0, g = 0; g < f.length; g++) {
              var _ = f.charCodeAt(g);
              _ < 128 ? h[p++] = _ : _ < 2048 ? (h[p++] = 192 | _ >> 6, h[p++] = 128 | _ & 63) : _ < 55296 ? (h[p++] = 224 | _ >> 12, h[p++] = 128 | _ >> 6 & 63, h[p++] = 128 | _ & 63) : (g++, _ = (_ & 1023) << 10, _ |= f.charCodeAt(g) & 1023, _ += 65536, h[p++] = 240 | _ >> 18, h[p++] = 128 | _ >> 12 & 63, h[p++] = 128 | _ >> 6 & 63, h[p++] = 128 | _ & 63);
            }
            return h;
          }
          i.encode = r;
          function l(f) {
            for (var h = 0, p = 0; p < f.length; p++) {
              var g = f.charCodeAt(p);
              if (g < 128)
                h += 1;
              else if (g < 2048)
                h += 2;
              else if (g < 55296)
                h += 3;
              else if (g <= 57343) {
                if (p >= f.length - 1)
                  throw new Error(a);
                p++, h += 4;
              } else
                throw new Error(a);
            }
            return h;
          }
          i.encodedLength = l;
          function d(f) {
            for (var h = [], p = 0; p < f.length; p++) {
              var g = f[p];
              if (g & 128) {
                var _ = void 0;
                if (g < 224) {
                  if (p >= f.length)
                    throw new Error(s);
                  var b = f[++p];
                  if ((b & 192) !== 128)
                    throw new Error(s);
                  g = (g & 31) << 6 | b & 63, _ = 128;
                } else if (g < 240) {
                  if (p >= f.length - 1)
                    throw new Error(s);
                  var b = f[++p], v = f[++p];
                  if ((b & 192) !== 128 || (v & 192) !== 128)
                    throw new Error(s);
                  g = (g & 15) << 12 | (b & 63) << 6 | v & 63, _ = 2048;
                } else if (g < 248) {
                  if (p >= f.length - 2)
                    throw new Error(s);
                  var b = f[++p], v = f[++p], E = f[++p];
                  if ((b & 192) !== 128 || (v & 192) !== 128 || (E & 192) !== 128)
                    throw new Error(s);
                  g = (g & 15) << 18 | (b & 63) << 12 | (v & 63) << 6 | E & 63, _ = 65536;
                } else
                  throw new Error(s);
                if (g < _ || g >= 55296 && g <= 57343)
                  throw new Error(s);
                if (g >= 65536) {
                  if (g > 1114111)
                    throw new Error(s);
                  g -= 65536, h.push(String.fromCharCode(55296 | g >> 10)), g = 56320 | g & 1023;
                }
              }
              h.push(String.fromCharCode(g));
            }
            return h.join("");
          }
          i.decode = d;
        },
        /* 2 */
        /***/
        function(t, i, c) {
          t.exports = c(3).default;
        },
        /* 3 */
        /***/
        function(t, i, c) {
          c.r(i);
          class a {
            constructor(le, ye) {
              this.lastId = 0, this.prefix = le, this.name = ye;
            }
            create(le) {
              this.lastId++;
              var ye = this.lastId, Be = this.prefix + ye, Ke = this.name + "[" + ye + "]", Ot = !1, Wt = function() {
                Ot || (le.apply(null, arguments), Ot = !0);
              };
              return this[ye] = Wt, { number: ye, id: Be, name: Ke, callback: Wt };
            }
            remove(le) {
              delete this[le.number];
            }
          }
          var s = new a("_pusher_script_", "Pusher.ScriptReceivers"), r = {
            VERSION: "8.4.0",
            PROTOCOL: 7,
            wsPort: 80,
            wssPort: 443,
            wsPath: "",
            httpHost: "sockjs.pusher.com",
            httpPort: 80,
            httpsPort: 443,
            httpPath: "/pusher",
            stats_host: "stats.pusher.com",
            authEndpoint: "/pusher/auth",
            authTransport: "ajax",
            activityTimeout: 12e4,
            pongTimeout: 3e4,
            unavailableTimeout: 1e4,
            userAuthentication: {
              endpoint: "/pusher/user-auth",
              transport: "ajax"
            },
            channelAuthorization: {
              endpoint: "/pusher/auth",
              transport: "ajax"
            },
            cdn_http: "http://js.pusher.com",
            cdn_https: "https://js.pusher.com",
            dependency_suffix: ""
          }, l = r;
          class d {
            constructor(le) {
              this.options = le, this.receivers = le.receivers || s, this.loading = {};
            }
            load(le, ye, Be) {
              var Ke = this;
              if (Ke.loading[le] && Ke.loading[le].length > 0)
                Ke.loading[le].push(Be);
              else {
                Ke.loading[le] = [Be];
                var Ot = qn.createScriptRequest(Ke.getPath(le, ye)), Wt = Ke.receivers.create(function(hn) {
                  if (Ke.receivers.remove(Wt), Ke.loading[le]) {
                    var Rn = Ke.loading[le];
                    delete Ke.loading[le];
                    for (var yr = function(ri) {
                      ri || Ot.cleanup();
                    }, Sr = 0; Sr < Rn.length; Sr++)
                      Rn[Sr](hn, yr);
                  }
                });
                Ot.send(Wt);
              }
            }
            getRoot(le) {
              var ye, Be = qn.getDocument().location.protocol;
              return le && le.useTLS || Be === "https:" ? ye = this.options.cdn_https : ye = this.options.cdn_http, ye.replace(/\/*$/, "") + "/" + this.options.version;
            }
            getPath(le, ye) {
              return this.getRoot(ye) + "/" + le + this.options.suffix + ".js";
            }
          }
          var f = new a("_pusher_dependencies", "Pusher.DependenciesReceivers"), h = new d({
            cdn_http: l.cdn_http,
            cdn_https: l.cdn_https,
            version: l.VERSION,
            suffix: l.dependency_suffix,
            receivers: f
          });
          const p = {
            baseUrl: "https://pusher.com",
            urls: {
              authenticationEndpoint: {
                path: "/docs/channels/server_api/authenticating_users"
              },
              authorizationEndpoint: {
                path: "/docs/channels/server_api/authorizing-users/"
              },
              javascriptQuickStart: {
                path: "/docs/javascript_quick_start"
              },
              triggeringClientEvents: {
                path: "/docs/client_api_guide/client_events#trigger-events"
              },
              encryptedChannelSupport: {
                fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
              }
            }
          };
          var _ = { buildLogSuffix: function(be) {
            const le = "See:", ye = p.urls[be];
            if (!ye)
              return "";
            let Be;
            return ye.fullUrl ? Be = ye.fullUrl : ye.path && (Be = p.baseUrl + ye.path), Be ? `${le} ${Be}` : "";
          } }, b;
          (function(be) {
            be.UserAuthentication = "user-authentication", be.ChannelAuthorization = "channel-authorization";
          })(b || (b = {}));
          class v extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class E extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class C extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class y extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class T extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class A extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class k extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class N extends Error {
            constructor(le) {
              super(le), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class j extends Error {
            constructor(le, ye) {
              super(ye), this.status = le, Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          var B = function(be, le, ye, Be, Ke) {
            const Ot = qn.createXHR();
            Ot.open("POST", ye.endpoint, !0), Ot.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            for (var Wt in ye.headers)
              Ot.setRequestHeader(Wt, ye.headers[Wt]);
            if (ye.headersProvider != null) {
              let hn = ye.headersProvider();
              for (var Wt in hn)
                Ot.setRequestHeader(Wt, hn[Wt]);
            }
            return Ot.onreadystatechange = function() {
              if (Ot.readyState === 4)
                if (Ot.status === 200) {
                  let hn, Rn = !1;
                  try {
                    hn = JSON.parse(Ot.responseText), Rn = !0;
                  } catch {
                    Ke(new j(200, `JSON returned from ${Be.toString()} endpoint was invalid, yet status code was 200. Data was: ${Ot.responseText}`), null);
                  }
                  Rn && Ke(null, hn);
                } else {
                  let hn = "";
                  switch (Be) {
                    case b.UserAuthentication:
                      hn = _.buildLogSuffix("authenticationEndpoint");
                      break;
                    case b.ChannelAuthorization:
                      hn = `Clients must be authorized to join private or presence channels. ${_.buildLogSuffix("authorizationEndpoint")}`;
                      break;
                  }
                  Ke(new j(Ot.status, `Unable to retrieve auth string from ${Be.toString()} endpoint - received status: ${Ot.status} from ${ye.endpoint}. ${hn}`), null);
                }
            }, Ot.send(le), Ot;
          };
          function U(be) {
            return $(ie(be));
          }
          var H = String.fromCharCode, Q = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Y = function(be) {
            var le = be.charCodeAt(0);
            return le < 128 ? be : le < 2048 ? H(192 | le >>> 6) + H(128 | le & 63) : H(224 | le >>> 12 & 15) + H(128 | le >>> 6 & 63) + H(128 | le & 63);
          }, ie = function(be) {
            return be.replace(/[^\x00-\x7F]/g, Y);
          }, ce = function(be) {
            var le = [0, 2, 1][be.length % 3], ye = be.charCodeAt(0) << 16 | (be.length > 1 ? be.charCodeAt(1) : 0) << 8 | (be.length > 2 ? be.charCodeAt(2) : 0), Be = [
              Q.charAt(ye >>> 18),
              Q.charAt(ye >>> 12 & 63),
              le >= 2 ? "=" : Q.charAt(ye >>> 6 & 63),
              le >= 1 ? "=" : Q.charAt(ye & 63)
            ];
            return Be.join("");
          }, $ = window.btoa || function(be) {
            return be.replace(/[\s\S]{1,3}/g, ce);
          };
          class te {
            constructor(le, ye, Be, Ke) {
              this.clear = ye, this.timer = le(() => {
                this.timer && (this.timer = Ke(this.timer));
              }, Be);
            }
            isRunning() {
              return this.timer !== null;
            }
            ensureAborted() {
              this.timer && (this.clear(this.timer), this.timer = null);
            }
          }
          var V = te;
          function K(be) {
            window.clearTimeout(be);
          }
          function ne(be) {
            window.clearInterval(be);
          }
          class J extends V {
            constructor(le, ye) {
              super(setTimeout, K, le, function(Be) {
                return ye(), null;
              });
            }
          }
          class L extends V {
            constructor(le, ye) {
              super(setInterval, ne, le, function(Be) {
                return ye(), Be;
              });
            }
          }
          var z = {
            now() {
              return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).valueOf();
            },
            defer(be) {
              return new J(0, be);
            },
            method(be, ...le) {
              var ye = Array.prototype.slice.call(arguments, 1);
              return function(Be) {
                return Be[be].apply(Be, ye.concat(arguments));
              };
            }
          }, ee = z;
          function q(be, ...le) {
            for (var ye = 0; ye < le.length; ye++) {
              var Be = le[ye];
              for (var Ke in Be)
                Be[Ke] && Be[Ke].constructor && Be[Ke].constructor === Object ? be[Ke] = q(be[Ke] || {}, Be[Ke]) : be[Ke] = Be[Ke];
            }
            return be;
          }
          function X() {
            for (var be = ["Pusher"], le = 0; le < arguments.length; le++)
              typeof arguments[le] == "string" ? be.push(arguments[le]) : be.push(pe(arguments[le]));
            return be.join(" : ");
          }
          function oe(be, le) {
            var ye = Array.prototype.indexOf;
            if (be === null)
              return -1;
            if (ye && be.indexOf === ye)
              return be.indexOf(le);
            for (var Be = 0, Ke = be.length; Be < Ke; Be++)
              if (be[Be] === le)
                return Be;
            return -1;
          }
          function ae(be, le) {
            for (var ye in be)
              Object.prototype.hasOwnProperty.call(be, ye) && le(be[ye], ye, be);
          }
          function _e(be) {
            var le = [];
            return ae(be, function(ye, Be) {
              le.push(Be);
            }), le;
          }
          function ve(be) {
            var le = [];
            return ae(be, function(ye) {
              le.push(ye);
            }), le;
          }
          function Ee(be, le, ye) {
            for (var Be = 0; Be < be.length; Be++)
              le.call(ye || window, be[Be], Be, be);
          }
          function we(be, le) {
            for (var ye = [], Be = 0; Be < be.length; Be++)
              ye.push(le(be[Be], Be, be, ye));
            return ye;
          }
          function ze(be, le) {
            var ye = {};
            return ae(be, function(Be, Ke) {
              ye[Ke] = le(Be);
            }), ye;
          }
          function Ie(be, le) {
            le = le || function(Ke) {
              return !!Ke;
            };
            for (var ye = [], Be = 0; Be < be.length; Be++)
              le(be[Be], Be, be, ye) && ye.push(be[Be]);
            return ye;
          }
          function je(be, le) {
            var ye = {};
            return ae(be, function(Be, Ke) {
              (le && le(Be, Ke, be, ye) || Be) && (ye[Ke] = Be);
            }), ye;
          }
          function qe(be) {
            var le = [];
            return ae(be, function(ye, Be) {
              le.push([Be, ye]);
            }), le;
          }
          function Ge(be, le) {
            for (var ye = 0; ye < be.length; ye++)
              if (le(be[ye], ye, be))
                return !0;
            return !1;
          }
          function Ze(be, le) {
            for (var ye = 0; ye < be.length; ye++)
              if (!le(be[ye], ye, be))
                return !1;
            return !0;
          }
          function tt(be) {
            return ze(be, function(le) {
              return typeof le == "object" && (le = pe(le)), encodeURIComponent(U(le.toString()));
            });
          }
          function Qe(be) {
            var le = je(be, function(Be) {
              return Be !== void 0;
            }), ye = we(qe(tt(le)), ee.method("join", "=")).join("&");
            return ye;
          }
          function ke(be) {
            var le = [], ye = [];
            return function Be(Ke, Ot) {
              var Wt, hn, Rn;
              switch (typeof Ke) {
                case "object":
                  if (!Ke)
                    return null;
                  for (Wt = 0; Wt < le.length; Wt += 1)
                    if (le[Wt] === Ke)
                      return { $ref: ye[Wt] };
                  if (le.push(Ke), ye.push(Ot), Object.prototype.toString.apply(Ke) === "[object Array]")
                    for (Rn = [], Wt = 0; Wt < Ke.length; Wt += 1)
                      Rn[Wt] = Be(Ke[Wt], Ot + "[" + Wt + "]");
                  else {
                    Rn = {};
                    for (hn in Ke)
                      Object.prototype.hasOwnProperty.call(Ke, hn) && (Rn[hn] = Be(Ke[hn], Ot + "[" + JSON.stringify(hn) + "]"));
                  }
                  return Rn;
                case "number":
                case "string":
                case "boolean":
                  return Ke;
              }
            }(be, "$");
          }
          function pe(be) {
            try {
              return JSON.stringify(be);
            } catch {
              return JSON.stringify(ke(be));
            }
          }
          class Se {
            constructor() {
              this.globalLog = (le) => {
                window.console && window.console.log && window.console.log(le);
              };
            }
            debug(...le) {
              this.log(this.globalLog, le);
            }
            warn(...le) {
              this.log(this.globalLogWarn, le);
            }
            error(...le) {
              this.log(this.globalLogError, le);
            }
            globalLogWarn(le) {
              window.console && window.console.warn ? window.console.warn(le) : this.globalLog(le);
            }
            globalLogError(le) {
              window.console && window.console.error ? window.console.error(le) : this.globalLogWarn(le);
            }
            log(le, ...ye) {
              var Be = X.apply(this, arguments);
              Ec.log ? Ec.log(Be) : Ec.logToConsole && le.bind(this)(Be);
            }
          }
          var he = new Se(), Te = function(be, le, ye, Be, Ke) {
            (ye.headers !== void 0 || ye.headersProvider != null) && he.warn(`To send headers with the ${Be.toString()} request, you must use AJAX, rather than JSONP.`);
            var Ot = be.nextAuthCallbackID.toString();
            be.nextAuthCallbackID++;
            var Wt = be.getDocument(), hn = Wt.createElement("script");
            be.auth_callbacks[Ot] = function(Sr) {
              Ke(null, Sr);
            };
            var Rn = "Pusher.auth_callbacks['" + Ot + "']";
            hn.src = ye.endpoint + "?callback=" + encodeURIComponent(Rn) + "&" + le;
            var yr = Wt.getElementsByTagName("head")[0] || Wt.documentElement;
            yr.insertBefore(hn, yr.firstChild);
          }, Me = Te;
          class Ye {
            constructor(le) {
              this.src = le;
            }
            send(le) {
              var ye = this, Be = "Error loading " + ye.src;
              ye.script = document.createElement("script"), ye.script.id = le.id, ye.script.src = ye.src, ye.script.type = "text/javascript", ye.script.charset = "UTF-8", ye.script.addEventListener ? (ye.script.onerror = function() {
                le.callback(Be);
              }, ye.script.onload = function() {
                le.callback(null);
              }) : ye.script.onreadystatechange = function() {
                (ye.script.readyState === "loaded" || ye.script.readyState === "complete") && le.callback(null);
              }, ye.script.async === void 0 && document.attachEvent && /opera/i.test(navigator.userAgent) ? (ye.errorScript = document.createElement("script"), ye.errorScript.id = le.id + "_error", ye.errorScript.text = le.name + "('" + Be + "');", ye.script.async = ye.errorScript.async = !1) : ye.script.async = !0;
              var Ke = document.getElementsByTagName("head")[0];
              Ke.insertBefore(ye.script, Ke.firstChild), ye.errorScript && Ke.insertBefore(ye.errorScript, ye.script.nextSibling);
            }
            cleanup() {
              this.script && (this.script.onload = this.script.onerror = null, this.script.onreadystatechange = null), this.script && this.script.parentNode && this.script.parentNode.removeChild(this.script), this.errorScript && this.errorScript.parentNode && this.errorScript.parentNode.removeChild(this.errorScript), this.script = null, this.errorScript = null;
            }
          }
          class et {
            constructor(le, ye) {
              this.url = le, this.data = ye;
            }
            send(le) {
              if (!this.request) {
                var ye = Qe(this.data), Be = this.url + "/" + le.number + "?" + ye;
                this.request = qn.createScriptRequest(Be), this.request.send(le);
              }
            }
            cleanup() {
              this.request && this.request.cleanup();
            }
          }
          var dt = function(be, le) {
            return function(ye, Be) {
              var Ke = "http" + (le ? "s" : "") + "://", Ot = Ke + (be.host || be.options.host) + be.options.path, Wt = qn.createJSONPRequest(Ot, ye), hn = qn.ScriptReceivers.create(function(Rn, yr) {
                s.remove(hn), Wt.cleanup(), yr && yr.host && (be.host = yr.host), Be && Be(Rn, yr);
              });
              Wt.send(hn);
            };
          }, We = {
            name: "jsonp",
            getAgent: dt
          }, nt = We;
          function ft(be, le, ye) {
            var Be = be + (le.useTLS ? "s" : ""), Ke = le.useTLS ? le.hostTLS : le.hostNonTLS;
            return Be + "://" + Ke + ye;
          }
          function At(be, le) {
            var ye = "/app/" + be, Be = "?protocol=" + l.PROTOCOL + "&client=js&version=" + l.VERSION + (le ? "&" + le : "");
            return ye + Be;
          }
          var ln = {
            getInitial: function(be, le) {
              var ye = (le.httpPath || "") + At(be, "flash=false");
              return ft("ws", le, ye);
            }
          }, Jt = {
            getInitial: function(be, le) {
              var ye = (le.httpPath || "/pusher") + At(be);
              return ft("http", le, ye);
            }
          }, zt = {
            getInitial: function(be, le) {
              return ft("http", le, le.httpPath || "/pusher");
            },
            getPath: function(be, le) {
              return At(be);
            }
          };
          class kt {
            constructor() {
              this._callbacks = {};
            }
            get(le) {
              return this._callbacks[Ft(le)];
            }
            add(le, ye, Be) {
              var Ke = Ft(le);
              this._callbacks[Ke] = this._callbacks[Ke] || [], this._callbacks[Ke].push({
                fn: ye,
                context: Be
              });
            }
            remove(le, ye, Be) {
              if (!le && !ye && !Be) {
                this._callbacks = {};
                return;
              }
              var Ke = le ? [Ft(le)] : _e(this._callbacks);
              ye || Be ? this.removeCallback(Ke, ye, Be) : this.removeAllCallbacks(Ke);
            }
            removeCallback(le, ye, Be) {
              Ee(le, function(Ke) {
                this._callbacks[Ke] = Ie(this._callbacks[Ke] || [], function(Ot) {
                  return ye && ye !== Ot.fn || Be && Be !== Ot.context;
                }), this._callbacks[Ke].length === 0 && delete this._callbacks[Ke];
              }, this);
            }
            removeAllCallbacks(le) {
              Ee(le, function(ye) {
                delete this._callbacks[ye];
              }, this);
            }
          }
          function Ft(be) {
            return "_" + be;
          }
          class ar {
            constructor(le) {
              this.callbacks = new kt(), this.global_callbacks = [], this.failThrough = le;
            }
            bind(le, ye, Be) {
              return this.callbacks.add(le, ye, Be), this;
            }
            bind_global(le) {
              return this.global_callbacks.push(le), this;
            }
            unbind(le, ye, Be) {
              return this.callbacks.remove(le, ye, Be), this;
            }
            unbind_global(le) {
              return le ? (this.global_callbacks = Ie(this.global_callbacks || [], (ye) => ye !== le), this) : (this.global_callbacks = [], this);
            }
            unbind_all() {
              return this.unbind(), this.unbind_global(), this;
            }
            emit(le, ye, Be) {
              for (var Ke = 0; Ke < this.global_callbacks.length; Ke++)
                this.global_callbacks[Ke](le, ye);
              var Ot = this.callbacks.get(le), Wt = [];
              if (Be ? Wt.push(ye, Be) : ye && Wt.push(ye), Ot && Ot.length > 0)
                for (var Ke = 0; Ke < Ot.length; Ke++)
                  Ot[Ke].fn.apply(Ot[Ke].context || window, Wt);
              else this.failThrough && this.failThrough(le, ye);
              return this;
            }
          }
          class In extends ar {
            constructor(le, ye, Be, Ke, Ot) {
              super(), this.initialize = qn.transportConnectionInitializer, this.hooks = le, this.name = ye, this.priority = Be, this.key = Ke, this.options = Ot, this.state = "new", this.timeline = Ot.timeline, this.activityTimeout = Ot.activityTimeout, this.id = this.timeline.generateUniqueID();
            }
            handlesActivityChecks() {
              return !!this.hooks.handlesActivityChecks;
            }
            supportsPing() {
              return !!this.hooks.supportsPing;
            }
            connect() {
              if (this.socket || this.state !== "initialized")
                return !1;
              var le = this.hooks.urls.getInitial(this.key, this.options);
              try {
                this.socket = this.hooks.getSocket(le, this.options);
              } catch (ye) {
                return ee.defer(() => {
                  this.onError(ye), this.changeState("closed");
                }), !1;
              }
              return this.bindListeners(), he.debug("Connecting", { transport: this.name, url: le }), this.changeState("connecting"), !0;
            }
            close() {
              return this.socket ? (this.socket.close(), !0) : !1;
            }
            send(le) {
              return this.state === "open" ? (ee.defer(() => {
                this.socket && this.socket.send(le);
              }), !0) : !1;
            }
            ping() {
              this.state === "open" && this.supportsPing() && this.socket.ping();
            }
            onOpen() {
              this.hooks.beforeOpen && this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options)), this.changeState("open"), this.socket.onopen = void 0;
            }
            onError(le) {
              this.emit("error", { type: "WebSocketError", error: le }), this.timeline.error(this.buildTimelineMessage({ error: le.toString() }));
            }
            onClose(le) {
              le ? this.changeState("closed", {
                code: le.code,
                reason: le.reason,
                wasClean: le.wasClean
              }) : this.changeState("closed"), this.unbindListeners(), this.socket = void 0;
            }
            onMessage(le) {
              this.emit("message", le);
            }
            onActivity() {
              this.emit("activity");
            }
            bindListeners() {
              this.socket.onopen = () => {
                this.onOpen();
              }, this.socket.onerror = (le) => {
                this.onError(le);
              }, this.socket.onclose = (le) => {
                this.onClose(le);
              }, this.socket.onmessage = (le) => {
                this.onMessage(le);
              }, this.supportsPing() && (this.socket.onactivity = () => {
                this.onActivity();
              });
            }
            unbindListeners() {
              this.socket && (this.socket.onopen = void 0, this.socket.onerror = void 0, this.socket.onclose = void 0, this.socket.onmessage = void 0, this.supportsPing() && (this.socket.onactivity = void 0));
            }
            changeState(le, ye) {
              this.state = le, this.timeline.info(this.buildTimelineMessage({
                state: le,
                params: ye
              })), this.emit(le, ye);
            }
            buildTimelineMessage(le) {
              return q({ cid: this.id }, le);
            }
          }
          class On {
            constructor(le) {
              this.hooks = le;
            }
            isSupported(le) {
              return this.hooks.isSupported(le);
            }
            createConnection(le, ye, Be, Ke) {
              return new In(this.hooks, le, ye, Be, Ke);
            }
          }
          var ui = new On({
            urls: ln,
            handlesActivityChecks: !1,
            supportsPing: !1,
            isInitialized: function() {
              return !!qn.getWebSocketAPI();
            },
            isSupported: function() {
              return !!qn.getWebSocketAPI();
            },
            getSocket: function(be) {
              return qn.createWebSocket(be);
            }
          }), Fr = {
            urls: Jt,
            handlesActivityChecks: !1,
            supportsPing: !0,
            isInitialized: function() {
              return !0;
            }
          }, er = q({
            getSocket: function(be) {
              return qn.HTTPFactory.createStreamingSocket(be);
            }
          }, Fr), $n = q({
            getSocket: function(be) {
              return qn.HTTPFactory.createPollingSocket(be);
            }
          }, Fr), un = {
            isSupported: function() {
              return qn.isXHRSupported();
            }
          }, en = new On(q({}, er, un)), bt = new On(q({}, $n, un)), Pt = {
            ws: ui,
            xhr_streaming: en,
            xhr_polling: bt
          }, fn = Pt, cn = new On({
            file: "sockjs",
            urls: zt,
            handlesActivityChecks: !0,
            supportsPing: !1,
            isSupported: function() {
              return !0;
            },
            isInitialized: function() {
              return window.SockJS !== void 0;
            },
            getSocket: function(be, le) {
              return new window.SockJS(be, null, {
                js_path: h.getPath("sockjs", {
                  useTLS: le.useTLS
                }),
                ignore_null_origin: le.ignoreNullOrigin
              });
            },
            beforeOpen: function(be, le) {
              be.send(JSON.stringify({
                path: le
              }));
            }
          }), Vn = {
            isSupported: function(be) {
              var le = qn.isXDRSupported(be.useTLS);
              return le;
            }
          }, En = new On(q({}, er, Vn)), Kt = new On(q({}, $n, Vn));
          fn.xdr_streaming = En, fn.xdr_polling = Kt, fn.sockjs = cn;
          var Dn = fn;
          class Kn extends ar {
            constructor() {
              super();
              var le = this;
              window.addEventListener !== void 0 && (window.addEventListener("online", function() {
                le.emit("online");
              }, !1), window.addEventListener("offline", function() {
                le.emit("offline");
              }, !1));
            }
            isOnline() {
              return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
            }
          }
          var vr = new Kn();
          class Ii {
            constructor(le, ye, Be) {
              this.manager = le, this.transport = ye, this.minPingDelay = Be.minPingDelay, this.maxPingDelay = Be.maxPingDelay, this.pingDelay = void 0;
            }
            createConnection(le, ye, Be, Ke) {
              Ke = q({}, Ke, {
                activityTimeout: this.pingDelay
              });
              var Ot = this.transport.createConnection(le, ye, Be, Ke), Wt = null, hn = function() {
                Ot.unbind("open", hn), Ot.bind("closed", Rn), Wt = ee.now();
              }, Rn = (yr) => {
                if (Ot.unbind("closed", Rn), yr.code === 1002 || yr.code === 1003)
                  this.manager.reportDeath();
                else if (!yr.wasClean && Wt) {
                  var Sr = ee.now() - Wt;
                  Sr < 2 * this.maxPingDelay && (this.manager.reportDeath(), this.pingDelay = Math.max(Sr / 2, this.minPingDelay));
                }
              };
              return Ot.bind("open", hn), Ot;
            }
            isSupported(le) {
              return this.manager.isAlive() && this.transport.isSupported(le);
            }
          }
          const vo = {
            decodeMessage: function(be) {
              try {
                var le = JSON.parse(be.data), ye = le.data;
                if (typeof ye == "string")
                  try {
                    ye = JSON.parse(le.data);
                  } catch {
                  }
                var Be = {
                  event: le.event,
                  channel: le.channel,
                  data: ye
                };
                return le.user_id && (Be.user_id = le.user_id), Be;
              } catch (Ke) {
                throw { type: "MessageParseError", error: Ke, data: be.data };
              }
            },
            encodeMessage: function(be) {
              return JSON.stringify(be);
            },
            processHandshake: function(be) {
              var le = vo.decodeMessage(be);
              if (le.event === "pusher:connection_established") {
                if (!le.data.activity_timeout)
                  throw "No activity timeout specified in handshake";
                return {
                  action: "connected",
                  id: le.data.socket_id,
                  activityTimeout: le.data.activity_timeout * 1e3
                };
              } else {
                if (le.event === "pusher:error")
                  return {
                    action: this.getCloseAction(le.data),
                    error: this.getCloseError(le.data)
                  };
                throw "Invalid handshake";
              }
            },
            getCloseAction: function(be) {
              return be.code < 4e3 ? be.code >= 1002 && be.code <= 1004 ? "backoff" : null : be.code === 4e3 ? "tls_only" : be.code < 4100 ? "refused" : be.code < 4200 ? "backoff" : be.code < 4300 ? "retry" : "refused";
            },
            getCloseError: function(be) {
              return be.code !== 1e3 && be.code !== 1001 ? {
                type: "PusherError",
                data: {
                  code: be.code,
                  message: be.reason || be.message
                }
              } : null;
            }
          };
          var qr = vo;
          class _r extends ar {
            constructor(le, ye) {
              super(), this.id = le, this.transport = ye, this.activityTimeout = ye.activityTimeout, this.bindListeners();
            }
            handlesActivityChecks() {
              return this.transport.handlesActivityChecks();
            }
            send(le) {
              return this.transport.send(le);
            }
            send_event(le, ye, Be) {
              var Ke = { event: le, data: ye };
              return Be && (Ke.channel = Be), he.debug("Event sent", Ke), this.send(qr.encodeMessage(Ke));
            }
            ping() {
              this.transport.supportsPing() ? this.transport.ping() : this.send_event("pusher:ping", {});
            }
            close() {
              this.transport.close();
            }
            bindListeners() {
              var le = {
                message: (Be) => {
                  var Ke;
                  try {
                    Ke = qr.decodeMessage(Be);
                  } catch (Ot) {
                    this.emit("error", {
                      type: "MessageParseError",
                      error: Ot,
                      data: Be.data
                    });
                  }
                  if (Ke !== void 0) {
                    switch (he.debug("Event recd", Ke), Ke.event) {
                      case "pusher:error":
                        this.emit("error", {
                          type: "PusherError",
                          data: Ke.data
                        });
                        break;
                      case "pusher:ping":
                        this.emit("ping");
                        break;
                      case "pusher:pong":
                        this.emit("pong");
                        break;
                    }
                    this.emit("message", Ke);
                  }
                },
                activity: () => {
                  this.emit("activity");
                },
                error: (Be) => {
                  this.emit("error", Be);
                },
                closed: (Be) => {
                  ye(), Be && Be.code && this.handleCloseEvent(Be), this.transport = null, this.emit("closed");
                }
              }, ye = () => {
                ae(le, (Be, Ke) => {
                  this.transport.unbind(Ke, Be);
                });
              };
              ae(le, (Be, Ke) => {
                this.transport.bind(Ke, Be);
              });
            }
            handleCloseEvent(le) {
              var ye = qr.getCloseAction(le), Be = qr.getCloseError(le);
              Be && this.emit("error", Be), ye && this.emit(ye, { action: ye, error: Be });
            }
          }
          class sr {
            constructor(le, ye) {
              this.transport = le, this.callback = ye, this.bindListeners();
            }
            close() {
              this.unbindListeners(), this.transport.close();
            }
            bindListeners() {
              this.onMessage = (le) => {
                this.unbindListeners();
                var ye;
                try {
                  ye = qr.processHandshake(le);
                } catch (Be) {
                  this.finish("error", { error: Be }), this.transport.close();
                  return;
                }
                ye.action === "connected" ? this.finish("connected", {
                  connection: new _r(ye.id, this.transport),
                  activityTimeout: ye.activityTimeout
                }) : (this.finish(ye.action, { error: ye.error }), this.transport.close());
              }, this.onClosed = (le) => {
                this.unbindListeners();
                var ye = qr.getCloseAction(le) || "backoff", Be = qr.getCloseError(le);
                this.finish(ye, { error: Be });
              }, this.transport.bind("message", this.onMessage), this.transport.bind("closed", this.onClosed);
            }
            unbindListeners() {
              this.transport.unbind("message", this.onMessage), this.transport.unbind("closed", this.onClosed);
            }
            finish(le, ye) {
              this.callback(q({ transport: this.transport, action: le }, ye));
            }
          }
          class br {
            constructor(le, ye) {
              this.timeline = le, this.options = ye || {};
            }
            send(le, ye) {
              this.timeline.isEmpty() || this.timeline.send(qn.TimelineTransport.getAgent(this, le), ye);
            }
          }
          class ao extends ar {
            constructor(le, ye) {
              super(function(Be, Ke) {
                he.debug("No callbacks on " + le + " for " + Be);
              }), this.name = le, this.pusher = ye, this.subscribed = !1, this.subscriptionPending = !1, this.subscriptionCancelled = !1;
            }
            authorize(le, ye) {
              return ye(null, { auth: "" });
            }
            trigger(le, ye) {
              if (le.indexOf("client-") !== 0)
                throw new v("Event '" + le + "' does not start with 'client-'");
              if (!this.subscribed) {
                var Be = _.buildLogSuffix("triggeringClientEvents");
                he.warn(`Client event triggered before channel 'subscription_succeeded' event . ${Be}`);
              }
              return this.pusher.send_event(le, ye, this.name);
            }
            disconnect() {
              this.subscribed = !1, this.subscriptionPending = !1;
            }
            handleEvent(le) {
              var ye = le.event, Be = le.data;
              if (ye === "pusher_internal:subscription_succeeded")
                this.handleSubscriptionSucceededEvent(le);
              else if (ye === "pusher_internal:subscription_count")
                this.handleSubscriptionCountEvent(le);
              else if (ye.indexOf("pusher_internal:") !== 0) {
                var Ke = {};
                this.emit(ye, Be, Ke);
              }
            }
            handleSubscriptionSucceededEvent(le) {
              this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : this.emit("pusher:subscription_succeeded", le.data);
            }
            handleSubscriptionCountEvent(le) {
              le.data.subscription_count && (this.subscriptionCount = le.data.subscription_count), this.emit("pusher:subscription_count", le.data);
            }
            subscribe() {
              this.subscribed || (this.subscriptionPending = !0, this.subscriptionCancelled = !1, this.authorize(this.pusher.connection.socket_id, (le, ye) => {
                le ? (this.subscriptionPending = !1, he.error(le.toString()), this.emit("pusher:subscription_error", Object.assign({}, {
                  type: "AuthError",
                  error: le.message
                }, le instanceof j ? { status: le.status } : {}))) : this.pusher.send_event("pusher:subscribe", {
                  auth: ye.auth,
                  channel_data: ye.channel_data,
                  channel: this.name
                });
              }));
            }
            unsubscribe() {
              this.subscribed = !1, this.pusher.send_event("pusher:unsubscribe", {
                channel: this.name
              });
            }
            cancelSubscription() {
              this.subscriptionCancelled = !0;
            }
            reinstateSubscription() {
              this.subscriptionCancelled = !1;
            }
          }
          class Zi extends ao {
            authorize(le, ye) {
              return this.pusher.config.channelAuthorizer({
                channelName: this.name,
                socketId: le
              }, ye);
            }
          }
          class di {
            constructor() {
              this.reset();
            }
            get(le) {
              return Object.prototype.hasOwnProperty.call(this.members, le) ? {
                id: le,
                info: this.members[le]
              } : null;
            }
            each(le) {
              ae(this.members, (ye, Be) => {
                le(this.get(Be));
              });
            }
            setMyID(le) {
              this.myID = le;
            }
            onSubscription(le) {
              this.members = le.presence.hash, this.count = le.presence.count, this.me = this.get(this.myID);
            }
            addMember(le) {
              return this.get(le.user_id) === null && this.count++, this.members[le.user_id] = le.user_info, this.get(le.user_id);
            }
            removeMember(le) {
              var ye = this.get(le.user_id);
              return ye && (delete this.members[le.user_id], this.count--), ye;
            }
            reset() {
              this.members = {}, this.count = 0, this.myID = null, this.me = null;
            }
          }
          var Lo = function(be, le, ye, Be) {
            function Ke(Ot) {
              return Ot instanceof ye ? Ot : new ye(function(Wt) {
                Wt(Ot);
              });
            }
            return new (ye || (ye = Promise))(function(Ot, Wt) {
              function hn(Sr) {
                try {
                  yr(Be.next(Sr));
                } catch (ri) {
                  Wt(ri);
                }
              }
              function Rn(Sr) {
                try {
                  yr(Be.throw(Sr));
                } catch (ri) {
                  Wt(ri);
                }
              }
              function yr(Sr) {
                Sr.done ? Ot(Sr.value) : Ke(Sr.value).then(hn, Rn);
              }
              yr((Be = Be.apply(be, le || [])).next());
            });
          };
          class La extends Zi {
            constructor(le, ye) {
              super(le, ye), this.members = new di();
            }
            authorize(le, ye) {
              super.authorize(le, (Be, Ke) => Lo(this, void 0, void 0, function* () {
                if (!Be)
                  if (Ke = Ke, Ke.channel_data != null) {
                    var Ot = JSON.parse(Ke.channel_data);
                    this.members.setMyID(Ot.user_id);
                  } else if (yield this.pusher.user.signinDonePromise, this.pusher.user.user_data != null)
                    this.members.setMyID(this.pusher.user.user_data.id);
                  else {
                    let Wt = _.buildLogSuffix("authorizationEndpoint");
                    he.error(`Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${Wt}, or the user should be signed in.`), ye("Invalid auth response");
                    return;
                  }
                ye(Be, Ke);
              }));
            }
            handleEvent(le) {
              var ye = le.event;
              if (ye.indexOf("pusher_internal:") === 0)
                this.handleInternalEvent(le);
              else {
                var Be = le.data, Ke = {};
                le.user_id && (Ke.user_id = le.user_id), this.emit(ye, Be, Ke);
              }
            }
            handleInternalEvent(le) {
              var ye = le.event, Be = le.data;
              switch (ye) {
                case "pusher_internal:subscription_succeeded":
                  this.handleSubscriptionSucceededEvent(le);
                  break;
                case "pusher_internal:subscription_count":
                  this.handleSubscriptionCountEvent(le);
                  break;
                case "pusher_internal:member_added":
                  var Ke = this.members.addMember(Be);
                  this.emit("pusher:member_added", Ke);
                  break;
                case "pusher_internal:member_removed":
                  var Ot = this.members.removeMember(Be);
                  Ot && this.emit("pusher:member_removed", Ot);
                  break;
              }
            }
            handleSubscriptionSucceededEvent(le) {
              this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : (this.members.onSubscription(le.data), this.emit("pusher:subscription_succeeded", this.members));
            }
            disconnect() {
              this.members.reset(), super.disconnect();
            }
          }
          var Ai = c(1), fr = c(0);
          class Ma extends Zi {
            constructor(le, ye, Be) {
              super(le, ye), this.key = null, this.nacl = Be;
            }
            authorize(le, ye) {
              super.authorize(le, (Be, Ke) => {
                if (Be) {
                  ye(Be, Ke);
                  return;
                }
                let Ot = Ke.shared_secret;
                if (!Ot) {
                  ye(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                  return;
                }
                this.key = Object(fr.decode)(Ot), delete Ke.shared_secret, ye(null, Ke);
              });
            }
            trigger(le, ye) {
              throw new A("Client events are not currently supported for encrypted channels");
            }
            handleEvent(le) {
              var ye = le.event, Be = le.data;
              if (ye.indexOf("pusher_internal:") === 0 || ye.indexOf("pusher:") === 0) {
                super.handleEvent(le);
                return;
              }
              this.handleEncryptedEvent(ye, Be);
            }
            handleEncryptedEvent(le, ye) {
              if (!this.key) {
                he.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                return;
              }
              if (!ye.ciphertext || !ye.nonce) {
                he.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + ye);
                return;
              }
              let Be = Object(fr.decode)(ye.ciphertext);
              if (Be.length < this.nacl.secretbox.overheadLength) {
                he.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${Be.length}`);
                return;
              }
              let Ke = Object(fr.decode)(ye.nonce);
              if (Ke.length < this.nacl.secretbox.nonceLength) {
                he.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${Ke.length}`);
                return;
              }
              let Ot = this.nacl.secretbox.open(Be, Ke, this.key);
              if (Ot === null) {
                he.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint..."), this.authorize(this.pusher.connection.socket_id, (Wt, hn) => {
                  if (Wt) {
                    he.error(`Failed to make a request to the authEndpoint: ${hn}. Unable to fetch new key, so dropping encrypted event`);
                    return;
                  }
                  if (Ot = this.nacl.secretbox.open(Be, Ke, this.key), Ot === null) {
                    he.error("Failed to decrypt event with new key. Dropping encrypted event");
                    return;
                  }
                  this.emit(le, this.getDataToEmit(Ot));
                });
                return;
              }
              this.emit(le, this.getDataToEmit(Ot));
            }
            getDataToEmit(le) {
              let ye = Object(Ai.decode)(le);
              try {
                return JSON.parse(ye);
              } catch {
                return ye;
              }
            }
          }
          class pa extends ar {
            constructor(le, ye) {
              super(), this.state = "initialized", this.connection = null, this.key = le, this.options = ye, this.timeline = this.options.timeline, this.usingTLS = this.options.useTLS, this.errorCallbacks = this.buildErrorCallbacks(), this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks), this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
              var Be = qn.getNetwork();
              Be.bind("online", () => {
                this.timeline.info({ netinfo: "online" }), (this.state === "connecting" || this.state === "unavailable") && this.retryIn(0);
              }), Be.bind("offline", () => {
                this.timeline.info({ netinfo: "offline" }), this.connection && this.sendActivityCheck();
              }), this.updateStrategy();
            }
            connect() {
              if (!(this.connection || this.runner)) {
                if (!this.strategy.isSupported()) {
                  this.updateState("failed");
                  return;
                }
                this.updateState("connecting"), this.startConnecting(), this.setUnavailableTimer();
              }
            }
            send(le) {
              return this.connection ? this.connection.send(le) : !1;
            }
            send_event(le, ye, Be) {
              return this.connection ? this.connection.send_event(le, ye, Be) : !1;
            }
            disconnect() {
              this.disconnectInternally(), this.updateState("disconnected");
            }
            isUsingTLS() {
              return this.usingTLS;
            }
            startConnecting() {
              var le = (ye, Be) => {
                ye ? this.runner = this.strategy.connect(0, le) : Be.action === "error" ? (this.emit("error", {
                  type: "HandshakeError",
                  error: Be.error
                }), this.timeline.error({ handshakeError: Be.error })) : (this.abortConnecting(), this.handshakeCallbacks[Be.action](Be));
              };
              this.runner = this.strategy.connect(0, le);
            }
            abortConnecting() {
              this.runner && (this.runner.abort(), this.runner = null);
            }
            disconnectInternally() {
              if (this.abortConnecting(), this.clearRetryTimer(), this.clearUnavailableTimer(), this.connection) {
                var le = this.abandonConnection();
                le.close();
              }
            }
            updateStrategy() {
              this.strategy = this.options.getStrategy({
                key: this.key,
                timeline: this.timeline,
                useTLS: this.usingTLS
              });
            }
            retryIn(le) {
              this.timeline.info({ action: "retry", delay: le }), le > 0 && this.emit("connecting_in", Math.round(le / 1e3)), this.retryTimer = new J(le || 0, () => {
                this.disconnectInternally(), this.connect();
              });
            }
            clearRetryTimer() {
              this.retryTimer && (this.retryTimer.ensureAborted(), this.retryTimer = null);
            }
            setUnavailableTimer() {
              this.unavailableTimer = new J(this.options.unavailableTimeout, () => {
                this.updateState("unavailable");
              });
            }
            clearUnavailableTimer() {
              this.unavailableTimer && this.unavailableTimer.ensureAborted();
            }
            sendActivityCheck() {
              this.stopActivityCheck(), this.connection.ping(), this.activityTimer = new J(this.options.pongTimeout, () => {
                this.timeline.error({ pong_timed_out: this.options.pongTimeout }), this.retryIn(0);
              });
            }
            resetActivityCheck() {
              this.stopActivityCheck(), this.connection && !this.connection.handlesActivityChecks() && (this.activityTimer = new J(this.activityTimeout, () => {
                this.sendActivityCheck();
              }));
            }
            stopActivityCheck() {
              this.activityTimer && this.activityTimer.ensureAborted();
            }
            buildConnectionCallbacks(le) {
              return q({}, le, {
                message: (ye) => {
                  this.resetActivityCheck(), this.emit("message", ye);
                },
                ping: () => {
                  this.send_event("pusher:pong", {});
                },
                activity: () => {
                  this.resetActivityCheck();
                },
                error: (ye) => {
                  this.emit("error", ye);
                },
                closed: () => {
                  this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3);
                }
              });
            }
            buildHandshakeCallbacks(le) {
              return q({}, le, {
                connected: (ye) => {
                  this.activityTimeout = Math.min(this.options.activityTimeout, ye.activityTimeout, ye.connection.activityTimeout || 1 / 0), this.clearUnavailableTimer(), this.setConnection(ye.connection), this.socket_id = this.connection.id, this.updateState("connected", { socket_id: this.socket_id });
                }
              });
            }
            buildErrorCallbacks() {
              let le = (ye) => (Be) => {
                Be.error && this.emit("error", { type: "WebSocketError", error: Be.error }), ye(Be);
              };
              return {
                tls_only: le(() => {
                  this.usingTLS = !0, this.updateStrategy(), this.retryIn(0);
                }),
                refused: le(() => {
                  this.disconnect();
                }),
                backoff: le(() => {
                  this.retryIn(1e3);
                }),
                retry: le(() => {
                  this.retryIn(0);
                })
              };
            }
            setConnection(le) {
              this.connection = le;
              for (var ye in this.connectionCallbacks)
                this.connection.bind(ye, this.connectionCallbacks[ye]);
              this.resetActivityCheck();
            }
            abandonConnection() {
              if (this.connection) {
                this.stopActivityCheck();
                for (var le in this.connectionCallbacks)
                  this.connection.unbind(le, this.connectionCallbacks[le]);
                var ye = this.connection;
                return this.connection = null, ye;
              }
            }
            updateState(le, ye) {
              var Be = this.state;
              if (this.state = le, Be !== le) {
                var Ke = le;
                Ke === "connected" && (Ke += " with new socket ID " + ye.socket_id), he.debug("State changed", Be + " -> " + Ke), this.timeline.info({ state: le, params: ye }), this.emit("state_change", { previous: Be, current: le }), this.emit(le, ye);
              }
            }
            shouldRetry() {
              return this.state === "connecting" || this.state === "connected";
            }
          }
          class Qn {
            constructor() {
              this.channels = {};
            }
            add(le, ye) {
              return this.channels[le] || (this.channels[le] = Pa(le, ye)), this.channels[le];
            }
            all() {
              return ve(this.channels);
            }
            find(le) {
              return this.channels[le];
            }
            remove(le) {
              var ye = this.channels[le];
              return delete this.channels[le], ye;
            }
            disconnect() {
              ae(this.channels, function(le) {
                le.disconnect();
              });
            }
          }
          function Pa(be, le) {
            if (be.indexOf("private-encrypted-") === 0) {
              if (le.config.nacl)
                return ma.createEncryptedChannel(be, le, le.config.nacl);
              let ye = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available", Be = _.buildLogSuffix("encryptedChannelSupport");
              throw new A(`${ye}. ${Be}`);
            } else {
              if (be.indexOf("private-") === 0)
                return ma.createPrivateChannel(be, le);
              if (be.indexOf("presence-") === 0)
                return ma.createPresenceChannel(be, le);
              if (be.indexOf("#") === 0)
                throw new E('Cannot create a channel with name "' + be + '".');
              return ma.createChannel(be, le);
            }
          }
          var lc = {
            createChannels() {
              return new Qn();
            },
            createConnectionManager(be, le) {
              return new pa(be, le);
            },
            createChannel(be, le) {
              return new ao(be, le);
            },
            createPrivateChannel(be, le) {
              return new Zi(be, le);
            },
            createPresenceChannel(be, le) {
              return new La(be, le);
            },
            createEncryptedChannel(be, le, ye) {
              return new Ma(be, le, ye);
            },
            createTimelineSender(be, le) {
              return new br(be, le);
            },
            createHandshake(be, le) {
              return new sr(be, le);
            },
            createAssistantToTheTransportManager(be, le, ye) {
              return new Ii(be, le, ye);
            }
          }, ma = lc;
          class vs {
            constructor(le) {
              this.options = le || {}, this.livesLeft = this.options.lives || 1 / 0;
            }
            getAssistant(le) {
              return ma.createAssistantToTheTransportManager(this, le, {
                minPingDelay: this.options.minPingDelay,
                maxPingDelay: this.options.maxPingDelay
              });
            }
            isAlive() {
              return this.livesLeft > 0;
            }
            reportDeath() {
              this.livesLeft -= 1;
            }
          }
          class Li {
            constructor(le, ye) {
              this.strategies = le, this.loop = !!ye.loop, this.failFast = !!ye.failFast, this.timeout = ye.timeout, this.timeoutLimit = ye.timeoutLimit;
            }
            isSupported() {
              return Ge(this.strategies, ee.method("isSupported"));
            }
            connect(le, ye) {
              var Be = this.strategies, Ke = 0, Ot = this.timeout, Wt = null, hn = (Rn, yr) => {
                yr ? ye(null, yr) : (Ke = Ke + 1, this.loop && (Ke = Ke % Be.length), Ke < Be.length ? (Ot && (Ot = Ot * 2, this.timeoutLimit && (Ot = Math.min(Ot, this.timeoutLimit))), Wt = this.tryStrategy(Be[Ke], le, { timeout: Ot, failFast: this.failFast }, hn)) : ye(!0));
              };
              return Wt = this.tryStrategy(Be[Ke], le, { timeout: Ot, failFast: this.failFast }, hn), {
                abort: function() {
                  Wt.abort();
                },
                forceMinPriority: function(Rn) {
                  le = Rn, Wt && Wt.forceMinPriority(Rn);
                }
              };
            }
            tryStrategy(le, ye, Be, Ke) {
              var Ot = null, Wt = null;
              return Be.timeout > 0 && (Ot = new J(Be.timeout, function() {
                Wt.abort(), Ke(!0);
              })), Wt = le.connect(ye, function(hn, Rn) {
                hn && Ot && Ot.isRunning() && !Be.failFast || (Ot && Ot.ensureAborted(), Ke(hn, Rn));
              }), {
                abort: function() {
                  Ot && Ot.ensureAborted(), Wt.abort();
                },
                forceMinPriority: function(hn) {
                  Wt.forceMinPriority(hn);
                }
              };
            }
          }
          class uc {
            constructor(le) {
              this.strategies = le;
            }
            isSupported() {
              return Ge(this.strategies, ee.method("isSupported"));
            }
            connect(le, ye) {
              return Mo(this.strategies, le, function(Be, Ke) {
                return function(Ot, Wt) {
                  if (Ke[Be].error = Ot, Ot) {
                    xf(Ke) && ye(!0);
                    return;
                  }
                  Ee(Ke, function(hn) {
                    hn.forceMinPriority(Wt.transport.priority);
                  }), ye(null, Wt);
                };
              });
            }
          }
          function Mo(be, le, ye) {
            var Be = we(be, function(Ke, Ot, Wt, hn) {
              return Ke.connect(le, ye(Ot, hn));
            });
            return {
              abort: function() {
                Ee(Be, cc);
              },
              forceMinPriority: function(Ke) {
                Ee(Be, function(Ot) {
                  Ot.forceMinPriority(Ke);
                });
              }
            };
          }
          function xf(be) {
            return Ze(be, function(le) {
              return !!le.error;
            });
          }
          function cc(be) {
            !be.error && !be.aborted && (be.abort(), be.aborted = !0);
          }
          class Jh {
            constructor(le, ye, Be) {
              this.strategy = le, this.transports = ye, this.ttl = Be.ttl || 1800 * 1e3, this.usingTLS = Be.useTLS, this.timeline = Be.timeline;
            }
            isSupported() {
              return this.strategy.isSupported();
            }
            connect(le, ye) {
              var Be = this.usingTLS, Ke = Ur(Be), Ot = Ke && Ke.cacheSkipCount ? Ke.cacheSkipCount : 0, Wt = [this.strategy];
              if (Ke && Ke.timestamp + this.ttl >= ee.now()) {
                var hn = this.transports[Ke.transport];
                hn && (["ws", "wss"].includes(Ke.transport) || Ot > 3 ? (this.timeline.info({
                  cached: !0,
                  transport: Ke.transport,
                  latency: Ke.latency
                }), Wt.push(new Li([hn], {
                  timeout: Ke.latency * 2 + 1e3,
                  failFast: !0
                }))) : Ot++);
              }
              var Rn = ee.now(), yr = Wt.pop().connect(le, function Sr(ri, Rl) {
                ri ? (so(Be), Wt.length > 0 ? (Rn = ee.now(), yr = Wt.pop().connect(le, Sr)) : ye(ri)) : (el(Be, Rl.transport.name, ee.now() - Rn, Ot), ye(null, Rl));
              });
              return {
                abort: function() {
                  yr.abort();
                },
                forceMinPriority: function(Sr) {
                  le = Sr, yr && yr.forceMinPriority(Sr);
                }
              };
            }
          }
          function bs(be) {
            return "pusherTransport" + (be ? "TLS" : "NonTLS");
          }
          function Ur(be) {
            var le = qn.getLocalStorage();
            if (le)
              try {
                var ye = le[bs(be)];
                if (ye)
                  return JSON.parse(ye);
              } catch {
                so(be);
              }
            return null;
          }
          function el(be, le, ye, Be) {
            var Ke = qn.getLocalStorage();
            if (Ke)
              try {
                Ke[bs(be)] = pe({
                  timestamp: ee.now(),
                  transport: le,
                  latency: ye,
                  cacheSkipCount: Be
                });
              } catch {
              }
          }
          function so(be) {
            var le = qn.getLocalStorage();
            if (le)
              try {
                delete le[bs(be)];
              } catch {
              }
          }
          class tl {
            constructor(le, { delay: ye }) {
              this.strategy = le, this.options = { delay: ye };
            }
            isSupported() {
              return this.strategy.isSupported();
            }
            connect(le, ye) {
              var Be = this.strategy, Ke, Ot = new J(this.options.delay, function() {
                Ke = Be.connect(le, ye);
              });
              return {
                abort: function() {
                  Ot.ensureAborted(), Ke && Ke.abort();
                },
                forceMinPriority: function(Wt) {
                  le = Wt, Ke && Ke.forceMinPriority(Wt);
                }
              };
            }
          }
          class ja {
            constructor(le, ye, Be) {
              this.test = le, this.trueBranch = ye, this.falseBranch = Be;
            }
            isSupported() {
              var le = this.test() ? this.trueBranch : this.falseBranch;
              return le.isSupported();
            }
            connect(le, ye) {
              var Be = this.test() ? this.trueBranch : this.falseBranch;
              return Be.connect(le, ye);
            }
          }
          class Tl {
            constructor(le) {
              this.strategy = le;
            }
            isSupported() {
              return this.strategy.isSupported();
            }
            connect(le, ye) {
              var Be = this.strategy.connect(le, function(Ke, Ot) {
                Ot && Be.abort(), ye(Ke, Ot);
              });
              return Be;
            }
          }
          function ns(be) {
            return function() {
              return be.isSupported();
            };
          }
          var dc = function(be, le, ye) {
            var Be = {};
            function Ke(bu, ol, np, rp, Lf) {
              var al = ye(be, bu, ol, np, rp, Lf);
              return Be[bu] = al, al;
            }
            var Ot = Object.assign({}, le, {
              hostNonTLS: be.wsHost + ":" + be.wsPort,
              hostTLS: be.wsHost + ":" + be.wssPort,
              httpPath: be.wsPath
            }), Wt = Object.assign({}, Ot, {
              useTLS: !0
            }), hn = Object.assign({}, le, {
              hostNonTLS: be.httpHost + ":" + be.httpPort,
              hostTLS: be.httpHost + ":" + be.httpsPort,
              httpPath: be.httpPath
            }), Rn = {
              loop: !0,
              timeout: 15e3,
              timeoutLimit: 6e4
            }, yr = new vs({
              minPingDelay: 1e4,
              maxPingDelay: be.activityTimeout
            }), Sr = new vs({
              lives: 2,
              minPingDelay: 1e4,
              maxPingDelay: be.activityTimeout
            }), ri = Ke("ws", "ws", 3, Ot, yr), Rl = Ke("wss", "ws", 3, Wt, yr), tp = Ke("sockjs", "sockjs", 1, hn), gu = Ke("xhr_streaming", "xhr_streaming", 1, hn, Sr), If = Ke("xdr_streaming", "xdr_streaming", 1, hn, Sr), uo = Ke("xhr_polling", "xhr_polling", 1, hn), os = Ke("xdr_polling", "xdr_polling", 1, hn), pi = new Li([ri], Rn), ga = new Li([Rl], Rn), rl = new Li([tp], Rn), Nl = new Li([
              new ja(ns(gu), gu, If)
            ], Rn), _u = new Li([
              new ja(ns(uo), uo, os)
            ], Rn), il = new Li([
              new ja(ns(Nl), new uc([
                Nl,
                new tl(_u, { delay: 4e3 })
              ]), _u)
            ], Rn), yu = new ja(ns(il), il, rl), vu;
            return le.useTLS ? vu = new uc([
              pi,
              new tl(yu, { delay: 2e3 })
            ]) : vu = new uc([
              pi,
              new tl(ga, { delay: 2e3 }),
              new tl(yu, { delay: 5e3 })
            ]), new Jh(new Tl(new ja(ns(ri), vu, yu)), Be, {
              ttl: 18e5,
              timeline: le.timeline,
              useTLS: le.useTLS
            });
          }, ra = dc, _d = function() {
            var be = this;
            be.timeline.info(be.buildTimelineMessage({
              transport: be.name + (be.options.useTLS ? "s" : "")
            })), be.hooks.isInitialized() ? be.changeState("initialized") : be.hooks.file ? (be.changeState("initializing"), h.load(be.hooks.file, { useTLS: be.options.useTLS }, function(le, ye) {
              be.hooks.isInitialized() ? (be.changeState("initialized"), ye(!0)) : (le && be.onError(le), be.onClose(), ye(!1));
            })) : be.onClose();
          }, Al = {
            getRequest: function(be) {
              var le = new window.XDomainRequest();
              return le.ontimeout = function() {
                be.emit("error", new C()), be.close();
              }, le.onerror = function(ye) {
                be.emit("error", ye), be.close();
              }, le.onprogress = function() {
                le.responseText && le.responseText.length > 0 && be.onChunk(200, le.responseText);
              }, le.onload = function() {
                le.responseText && le.responseText.length > 0 && be.onChunk(200, le.responseText), be.emit("finished", 200), be.close();
              }, le;
            },
            abortRequest: function(be) {
              be.ontimeout = be.onerror = be.onprogress = be.onload = null, be.abort();
            }
          }, Er = Al;
          const yd = 256 * 1024;
          class Tf extends ar {
            constructor(le, ye, Be) {
              super(), this.hooks = le, this.method = ye, this.url = Be;
            }
            start(le) {
              this.position = 0, this.xhr = this.hooks.getRequest(this), this.unloader = () => {
                this.close();
              }, qn.addUnloadListener(this.unloader), this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader && this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.send(le);
            }
            close() {
              this.unloader && (qn.removeUnloadListener(this.unloader), this.unloader = null), this.xhr && (this.hooks.abortRequest(this.xhr), this.xhr = null);
            }
            onChunk(le, ye) {
              for (; ; ) {
                var Be = this.advanceBuffer(ye);
                if (Be)
                  this.emit("chunk", { status: le, data: Be });
                else
                  break;
              }
              this.isBufferTooLong(ye) && this.emit("buffer_too_long");
            }
            advanceBuffer(le) {
              var ye = le.slice(this.position), Be = ye.indexOf(`
`);
              return Be !== -1 ? (this.position += Be + 1, ye.slice(0, Be)) : null;
            }
            isBufferTooLong(le) {
              return this.position === le.length && le.length > yd;
            }
          }
          var nl;
          (function(be) {
            be[be.CONNECTING = 0] = "CONNECTING", be[be.OPEN = 1] = "OPEN", be[be.CLOSED = 3] = "CLOSED";
          })(nl || (nl = {}));
          var ur = nl, vd = 1;
          class fc {
            constructor(le, ye) {
              this.hooks = le, this.session = lo(1e3) + "/" + kl(8), this.location = Yn(ye), this.readyState = ur.CONNECTING, this.openStream();
            }
            send(le) {
              return this.sendRaw(JSON.stringify([le]));
            }
            ping() {
              this.hooks.sendHeartbeat(this);
            }
            close(le, ye) {
              this.onClose(le, ye, !0);
            }
            sendRaw(le) {
              if (this.readyState === ur.OPEN)
                try {
                  return qn.createSocketRequest("POST", ni(Es(this.location, this.session))).start(le), !0;
                } catch {
                  return !1;
                }
              else
                return !1;
            }
            reconnect() {
              this.closeStream(), this.openStream();
            }
            onClose(le, ye, Be) {
              this.closeStream(), this.readyState = ur.CLOSED, this.onclose && this.onclose({
                code: le,
                reason: ye,
                wasClean: Be
              });
            }
            onChunk(le) {
              if (le.status === 200) {
                this.readyState === ur.OPEN && this.onActivity();
                var ye, Be = le.data.slice(0, 1);
                switch (Be) {
                  case "o":
                    ye = JSON.parse(le.data.slice(1) || "{}"), this.onOpen(ye);
                    break;
                  case "a":
                    ye = JSON.parse(le.data.slice(1) || "[]");
                    for (var Ke = 0; Ke < ye.length; Ke++)
                      this.onEvent(ye[Ke]);
                    break;
                  case "m":
                    ye = JSON.parse(le.data.slice(1) || "null"), this.onEvent(ye);
                    break;
                  case "h":
                    this.hooks.onHeartbeat(this);
                    break;
                  case "c":
                    ye = JSON.parse(le.data.slice(1) || "[]"), this.onClose(ye[0], ye[1], !0);
                    break;
                }
              }
            }
            onOpen(le) {
              this.readyState === ur.CONNECTING ? (le && le.hostname && (this.location.base = Po(this.location.base, le.hostname)), this.readyState = ur.OPEN, this.onopen && this.onopen()) : this.onClose(1006, "Server lost session", !0);
            }
            onEvent(le) {
              this.readyState === ur.OPEN && this.onmessage && this.onmessage({ data: le });
            }
            onActivity() {
              this.onactivity && this.onactivity();
            }
            onError(le) {
              this.onerror && this.onerror(le);
            }
            openStream() {
              this.stream = qn.createSocketRequest("POST", ni(this.hooks.getReceiveURL(this.location, this.session))), this.stream.bind("chunk", (le) => {
                this.onChunk(le);
              }), this.stream.bind("finished", (le) => {
                this.hooks.onFinished(this, le);
              }), this.stream.bind("buffer_too_long", () => {
                this.reconnect();
              });
              try {
                this.stream.start();
              } catch (le) {
                ee.defer(() => {
                  this.onError(le), this.onClose(1006, "Could not start streaming", !1);
                });
              }
            }
            closeStream() {
              this.stream && (this.stream.unbind_all(), this.stream.close(), this.stream = null);
            }
          }
          function Yn(be) {
            var le = /([^\?]*)\/*(\??.*)/.exec(be);
            return {
              base: le[1],
              queryString: le[2]
            };
          }
          function Es(be, le) {
            return be.base + "/" + le + "/xhr_send";
          }
          function ni(be) {
            var le = be.indexOf("?") === -1 ? "?" : "&";
            return be + le + "t=" + +/* @__PURE__ */ new Date() + "&n=" + vd++;
          }
          function Po(be, le) {
            var ye = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(be);
            return ye[1] + le + ye[3];
          }
          function lo(be) {
            return qn.randomInt(be);
          }
          function kl(be) {
            for (var le = [], ye = 0; ye < be; ye++)
              le.push(lo(32).toString(32));
            return le.join("");
          }
          var fi = fc, Or = {
            getReceiveURL: function(be, le) {
              return be.base + "/" + le + "/xhr_streaming" + be.queryString;
            },
            onHeartbeat: function(be) {
              be.sendRaw("[]");
            },
            sendHeartbeat: function(be) {
              be.sendRaw("[]");
            },
            onFinished: function(be, le) {
              be.onClose(1006, "Connection interrupted (" + le + ")", !1);
            }
          }, ep = Or, jo = {
            getReceiveURL: function(be, le) {
              return be.base + "/" + le + "/xhr" + be.queryString;
            },
            onHeartbeat: function() {
            },
            sendHeartbeat: function(be) {
              be.sendRaw("[]");
            },
            onFinished: function(be, le) {
              le === 200 ? be.reconnect() : be.onClose(1006, "Connection interrupted (" + le + ")", !1);
            }
          }, Mi = jo, Bo = {
            getRequest: function(be) {
              var le = qn.getXHRAPI(), ye = new le();
              return ye.onreadystatechange = ye.onprogress = function() {
                switch (ye.readyState) {
                  case 3:
                    ye.responseText && ye.responseText.length > 0 && be.onChunk(ye.status, ye.responseText);
                    break;
                  case 4:
                    ye.responseText && ye.responseText.length > 0 && be.onChunk(ye.status, ye.responseText), be.emit("finished", ye.status), be.close();
                    break;
                }
              }, ye;
            },
            abortRequest: function(be) {
              be.onreadystatechange = null, be.abort();
            }
          }, vi = Bo, Ol = {
            createStreamingSocket(be) {
              return this.createSocket(ep, be);
            },
            createPollingSocket(be) {
              return this.createSocket(Mi, be);
            },
            createSocket(be, le) {
              return new fi(be, le);
            },
            createXHR(be, le) {
              return this.createRequest(vi, be, le);
            },
            createRequest(be, le, ye) {
              return new Tf(be, le, ye);
            }
          }, hc = Ol;
          hc.createXDR = function(be, le) {
            return this.createRequest(Er, be, le);
          };
          var Af = hc, du = {
            nextAuthCallbackID: 1,
            auth_callbacks: {},
            ScriptReceivers: s,
            DependenciesReceivers: f,
            getDefaultStrategy: ra,
            Transports: Dn,
            transportConnectionInitializer: _d,
            HTTPFactory: Af,
            TimelineTransport: nt,
            getXHRAPI() {
              return window.XMLHttpRequest;
            },
            getWebSocketAPI() {
              return window.WebSocket || window.MozWebSocket;
            },
            setup(be) {
              window.Pusher = be;
              var le = () => {
                this.onDocumentBody(be.ready);
              };
              window.JSON ? le() : h.load("json2", {}, le);
            },
            getDocument() {
              return document;
            },
            getProtocol() {
              return this.getDocument().location.protocol;
            },
            getAuthorizers() {
              return { ajax: B, jsonp: Me };
            },
            onDocumentBody(be) {
              document.body ? be() : setTimeout(() => {
                this.onDocumentBody(be);
              }, 0);
            },
            createJSONPRequest(be, le) {
              return new et(be, le);
            },
            createScriptRequest(be) {
              return new Ye(be);
            },
            getLocalStorage() {
              try {
                return window.localStorage;
              } catch {
                return;
              }
            },
            createXHR() {
              return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
            },
            createXMLHttpRequest() {
              var be = this.getXHRAPI();
              return new be();
            },
            createMicrosoftXHR() {
              return new ActiveXObject("Microsoft.XMLHTTP");
            },
            getNetwork() {
              return vr;
            },
            createWebSocket(be) {
              var le = this.getWebSocketAPI();
              return new le(be);
            },
            createSocketRequest(be, le) {
              if (this.isXHRSupported())
                return this.HTTPFactory.createXHR(be, le);
              if (this.isXDRSupported(le.indexOf("https:") === 0))
                return this.HTTPFactory.createXDR(be, le);
              throw "Cross-origin HTTP requests are not supported";
            },
            isXHRSupported() {
              var be = this.getXHRAPI();
              return !!be && new be().withCredentials !== void 0;
            },
            isXDRSupported(be) {
              var le = be ? "https:" : "http:", ye = this.getProtocol();
              return !!window.XDomainRequest && ye === le;
            },
            addUnloadListener(be) {
              window.addEventListener !== void 0 ? window.addEventListener("unload", be, !1) : window.attachEvent !== void 0 && window.attachEvent("onunload", be);
            },
            removeUnloadListener(be) {
              window.addEventListener !== void 0 ? window.removeEventListener("unload", be, !1) : window.detachEvent !== void 0 && window.detachEvent("onunload", be);
            },
            randomInt(be) {
              return Math.floor(function() {
                return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
              }() * be);
            }
          }, qn = du, Ss;
          (function(be) {
            be[be.ERROR = 3] = "ERROR", be[be.INFO = 6] = "INFO", be[be.DEBUG = 7] = "DEBUG";
          })(Ss || (Ss = {}));
          var Ba = Ss;
          class kf {
            constructor(le, ye, Be) {
              this.key = le, this.session = ye, this.events = [], this.options = Be || {}, this.sent = 0, this.uniqueID = 0;
            }
            log(le, ye) {
              le <= this.options.level && (this.events.push(q({}, ye, { timestamp: ee.now() })), this.options.limit && this.events.length > this.options.limit && this.events.shift());
            }
            error(le) {
              this.log(Ba.ERROR, le);
            }
            info(le) {
              this.log(Ba.INFO, le);
            }
            debug(le) {
              this.log(Ba.DEBUG, le);
            }
            isEmpty() {
              return this.events.length === 0;
            }
            send(le, ye) {
              var Be = q({
                session: this.session,
                bundle: this.sent + 1,
                key: this.key,
                lib: "js",
                version: this.options.version,
                cluster: this.options.cluster,
                features: this.options.features,
                timeline: this.events
              }, this.options.params);
              return this.events = [], le(Be, (Ke, Ot) => {
                Ke || this.sent++, ye && ye(Ke, Ot);
              }), !0;
            }
            generateUniqueID() {
              return this.uniqueID++, this.uniqueID;
            }
          }
          class pc {
            constructor(le, ye, Be, Ke) {
              this.name = le, this.priority = ye, this.transport = Be, this.options = Ke || {};
            }
            isSupported() {
              return this.transport.isSupported({
                useTLS: this.options.useTLS
              });
            }
            connect(le, ye) {
              if (this.isSupported()) {
                if (this.priority < le)
                  return fu(new y(), ye);
              } else return fu(new N(), ye);
              var Be = !1, Ke = this.transport.createConnection(this.name, this.priority, this.options.key, this.options), Ot = null, Wt = function() {
                Ke.unbind("initialized", Wt), Ke.connect();
              }, hn = function() {
                Ot = ma.createHandshake(Ke, function(ri) {
                  Be = !0, Sr(), ye(null, ri);
                });
              }, Rn = function(ri) {
                Sr(), ye(ri);
              }, yr = function() {
                Sr();
                var ri;
                ri = pe(Ke), ye(new T(ri));
              }, Sr = function() {
                Ke.unbind("initialized", Wt), Ke.unbind("open", hn), Ke.unbind("error", Rn), Ke.unbind("closed", yr);
              };
              return Ke.bind("initialized", Wt), Ke.bind("open", hn), Ke.bind("error", Rn), Ke.bind("closed", yr), Ke.initialize(), {
                abort: () => {
                  Be || (Sr(), Ot ? Ot.close() : Ke.close());
                },
                forceMinPriority: (ri) => {
                  Be || this.priority < ri && (Ot ? Ot.close() : Ke.close());
                }
              };
            }
          }
          function fu(be, le) {
            return ee.defer(function() {
              le(be);
            }), {
              abort: function() {
              },
              forceMinPriority: function() {
              }
            };
          }
          const { Transports: hu } = qn;
          var mc = function(be, le, ye, Be, Ke, Ot) {
            var Wt = hu[ye];
            if (!Wt)
              throw new k(ye);
            var hn = (!be.enabledTransports || oe(be.enabledTransports, le) !== -1) && (!be.disabledTransports || oe(be.disabledTransports, le) === -1), Rn;
            return hn ? (Ke = Object.assign({ ignoreNullOrigin: be.ignoreNullOrigin }, Ke), Rn = new pc(le, Be, Ot ? Ot.getAssistant(Wt) : Wt, Ke)) : Rn = bd, Rn;
          }, bd = {
            isSupported: function() {
              return !1;
            },
            connect: function(be, le) {
              var ye = ee.defer(function() {
                le(new N());
              });
              return {
                abort: function() {
                  ye.ensureAborted();
                },
                forceMinPriority: function() {
                }
              };
            }
          };
          function rs(be) {
            if (be == null)
              throw "You must pass an options object";
            if (be.cluster == null)
              throw "Options object must provide a cluster";
            "disableStats" in be && he.warn("The disableStats option is deprecated in favor of enableStats");
          }
          const pu = (be, le) => {
            var ye = "socket_id=" + encodeURIComponent(be.socketId);
            for (var Be in le.params)
              ye += "&" + encodeURIComponent(Be) + "=" + encodeURIComponent(le.params[Be]);
            if (le.paramsProvider != null) {
              let Ke = le.paramsProvider();
              for (var Be in Ke)
                ye += "&" + encodeURIComponent(Be) + "=" + encodeURIComponent(Ke[Be]);
            }
            return ye;
          };
          var Ed = (be) => {
            if (typeof qn.getAuthorizers()[be.transport] > "u")
              throw `'${be.transport}' is not a recognized auth transport`;
            return (le, ye) => {
              const Be = pu(le, be);
              qn.getAuthorizers()[be.transport](qn, Be, be, b.UserAuthentication, ye);
            };
          };
          const ws = (be, le) => {
            var ye = "socket_id=" + encodeURIComponent(be.socketId);
            ye += "&channel_name=" + encodeURIComponent(be.channelName);
            for (var Be in le.params)
              ye += "&" + encodeURIComponent(Be) + "=" + encodeURIComponent(le.params[Be]);
            if (le.paramsProvider != null) {
              let Ke = le.paramsProvider();
              for (var Be in Ke)
                ye += "&" + encodeURIComponent(Be) + "=" + encodeURIComponent(Ke[Be]);
            }
            return ye;
          };
          var Of = (be) => {
            if (typeof qn.getAuthorizers()[be.transport] > "u")
              throw `'${be.transport}' is not a recognized auth transport`;
            return (le, ye) => {
              const Be = ws(le, be);
              qn.getAuthorizers()[be.transport](qn, Be, be, b.ChannelAuthorization, ye);
            };
          };
          const Fo = (be, le, ye) => {
            const Be = {
              authTransport: le.transport,
              authEndpoint: le.endpoint,
              auth: {
                params: le.params,
                headers: le.headers
              }
            };
            return (Ke, Ot) => {
              const Wt = be.channel(Ke.channelName);
              ye(Wt, Be).authorize(Ke.socketId, Ot);
            };
          };
          function xs(be, le) {
            let ye = {
              activityTimeout: be.activityTimeout || l.activityTimeout,
              cluster: be.cluster,
              httpPath: be.httpPath || l.httpPath,
              httpPort: be.httpPort || l.httpPort,
              httpsPort: be.httpsPort || l.httpsPort,
              pongTimeout: be.pongTimeout || l.pongTimeout,
              statsHost: be.statsHost || l.stats_host,
              unavailableTimeout: be.unavailableTimeout || l.unavailableTimeout,
              wsPath: be.wsPath || l.wsPath,
              wsPort: be.wsPort || l.wsPort,
              wssPort: be.wssPort || l.wssPort,
              enableStats: Sd(be),
              httpHost: _c(be),
              useTLS: yc(be),
              wsHost: Dl(be),
              userAuthenticator: mu(be),
              channelAuthorizer: vc(be, le)
            };
            return "disabledTransports" in be && (ye.disabledTransports = be.disabledTransports), "enabledTransports" in be && (ye.enabledTransports = be.enabledTransports), "ignoreNullOrigin" in be && (ye.ignoreNullOrigin = be.ignoreNullOrigin), "timelineParams" in be && (ye.timelineParams = be.timelineParams), "nacl" in be && (ye.nacl = be.nacl), ye;
          }
          function _c(be) {
            return be.httpHost ? be.httpHost : be.cluster ? `sockjs-${be.cluster}.pusher.com` : l.httpHost;
          }
          function Dl(be) {
            return be.wsHost ? be.wsHost : Df(be.cluster);
          }
          function Df(be) {
            return `ws-${be}.pusher.com`;
          }
          function yc(be) {
            return qn.getProtocol() === "https:" ? !0 : be.forceTLS !== !1;
          }
          function Sd(be) {
            return "enableStats" in be ? be.enableStats : "disableStats" in be ? !be.disableStats : !1;
          }
          function mu(be) {
            const le = Object.assign(Object.assign({}, l.userAuthentication), be.userAuthentication);
            return "customHandler" in le && le.customHandler != null ? le.customHandler : Ed(le);
          }
          function Pi(be, le) {
            let ye;
            return "channelAuthorization" in be ? ye = Object.assign(Object.assign({}, l.channelAuthorization), be.channelAuthorization) : (ye = {
              transport: be.authTransport || l.authTransport,
              endpoint: be.authEndpoint || l.authEndpoint
            }, "auth" in be && ("params" in be.auth && (ye.params = be.auth.params), "headers" in be.auth && (ye.headers = be.auth.headers)), "authorizer" in be && (ye.customHandler = Fo(le, ye, be.authorizer))), ye;
          }
          function vc(be, le) {
            const ye = Pi(be, le);
            return "customHandler" in ye && ye.customHandler != null ? ye.customHandler : Of(ye);
          }
          class Rf extends ar {
            constructor(le) {
              super(function(ye, Be) {
                he.debug(`No callbacks on watchlist events for ${ye}`);
              }), this.pusher = le, this.bindWatchlistInternalEvent();
            }
            handleEvent(le) {
              le.data.events.forEach((ye) => {
                this.emit(ye.name, ye);
              });
            }
            bindWatchlistInternalEvent() {
              this.pusher.connection.bind("message", (le) => {
                var ye = le.event;
                ye === "pusher_internal:watchlist_events" && this.handleEvent(le);
              });
            }
          }
          function Ts() {
            let be, le;
            return { promise: new Promise((Be, Ke) => {
              be = Be, le = Ke;
            }), resolve: be, reject: le };
          }
          var bc = Ts;
          class is extends ar {
            constructor(le) {
              super(function(ye, Be) {
                he.debug("No callbacks on user for " + ye);
              }), this.signin_requested = !1, this.user_data = null, this.serverToUserChannel = null, this.signinDonePromise = null, this._signinDoneResolve = null, this._onAuthorize = (ye, Be) => {
                if (ye) {
                  he.warn(`Error during signin: ${ye}`), this._cleanup();
                  return;
                }
                this.pusher.send_event("pusher:signin", {
                  auth: Be.auth,
                  user_data: Be.user_data
                });
              }, this.pusher = le, this.pusher.connection.bind("state_change", ({ previous: ye, current: Be }) => {
                ye !== "connected" && Be === "connected" && this._signin(), ye === "connected" && Be !== "connected" && (this._cleanup(), this._newSigninPromiseIfNeeded());
              }), this.watchlist = new Rf(le), this.pusher.connection.bind("message", (ye) => {
                var Be = ye.event;
                Be === "pusher:signin_success" && this._onSigninSuccess(ye.data), this.serverToUserChannel && this.serverToUserChannel.name === ye.channel && this.serverToUserChannel.handleEvent(ye);
              });
            }
            signin() {
              this.signin_requested || (this.signin_requested = !0, this._signin());
            }
            _signin() {
              this.signin_requested && (this._newSigninPromiseIfNeeded(), this.pusher.connection.state === "connected" && this.pusher.config.userAuthenticator({
                socketId: this.pusher.connection.socket_id
              }, this._onAuthorize));
            }
            _onSigninSuccess(le) {
              try {
                this.user_data = JSON.parse(le.user_data);
              } catch {
                he.error(`Failed parsing user data after signin: ${le.user_data}`), this._cleanup();
                return;
              }
              if (typeof this.user_data.id != "string" || this.user_data.id === "") {
                he.error(`user_data doesn't contain an id. user_data: ${this.user_data}`), this._cleanup();
                return;
              }
              this._signinDoneResolve(), this._subscribeChannels();
            }
            _subscribeChannels() {
              const le = (ye) => {
                ye.subscriptionPending && ye.subscriptionCancelled ? ye.reinstateSubscription() : !ye.subscriptionPending && this.pusher.connection.state === "connected" && ye.subscribe();
              };
              this.serverToUserChannel = new ao(`#server-to-user-${this.user_data.id}`, this.pusher), this.serverToUserChannel.bind_global((ye, Be) => {
                ye.indexOf("pusher_internal:") === 0 || ye.indexOf("pusher:") === 0 || this.emit(ye, Be);
              }), le(this.serverToUserChannel);
            }
            _cleanup() {
              this.user_data = null, this.serverToUserChannel && (this.serverToUserChannel.unbind_all(), this.serverToUserChannel.disconnect(), this.serverToUserChannel = null), this.signin_requested && this._signinDoneResolve();
            }
            _newSigninPromiseIfNeeded() {
              if (!this.signin_requested || this.signinDonePromise && !this.signinDonePromise.done)
                return;
              const { promise: le, resolve: ye, reject: Be } = bc();
              le.done = !1;
              const Ke = () => {
                le.done = !0;
              };
              le.then(Ke).catch(Ke), this.signinDonePromise = le, this._signinDoneResolve = ye;
            }
          }
          class hi {
            static ready() {
              hi.isReady = !0;
              for (var le = 0, ye = hi.instances.length; le < ye; le++)
                hi.instances[le].connect();
            }
            static getClientFeatures() {
              return _e(je({ ws: qn.Transports.ws }, function(le) {
                return le.isSupported({});
              }));
            }
            constructor(le, ye) {
              Nf(le), rs(ye), this.key = le, this.config = xs(ye, this), this.channels = ma.createChannels(), this.global_emitter = new ar(), this.sessionID = qn.randomInt(1e9), this.timeline = new kf(this.key, this.sessionID, {
                cluster: this.config.cluster,
                features: hi.getClientFeatures(),
                params: this.config.timelineParams || {},
                limit: 50,
                level: Ba.INFO,
                version: l.VERSION
              }), this.config.enableStats && (this.timelineSender = ma.createTimelineSender(this.timeline, {
                host: this.config.statsHost,
                path: "/timeline/v2/" + qn.TimelineTransport.name
              }));
              var Be = (Ke) => qn.getDefaultStrategy(this.config, Ke, mc);
              this.connection = ma.createConnectionManager(this.key, {
                getStrategy: Be,
                timeline: this.timeline,
                activityTimeout: this.config.activityTimeout,
                pongTimeout: this.config.pongTimeout,
                unavailableTimeout: this.config.unavailableTimeout,
                useTLS: !!this.config.useTLS
              }), this.connection.bind("connected", () => {
                this.subscribeAll(), this.timelineSender && this.timelineSender.send(this.connection.isUsingTLS());
              }), this.connection.bind("message", (Ke) => {
                var Ot = Ke.event, Wt = Ot.indexOf("pusher_internal:") === 0;
                if (Ke.channel) {
                  var hn = this.channel(Ke.channel);
                  hn && hn.handleEvent(Ke);
                }
                Wt || this.global_emitter.emit(Ke.event, Ke.data);
              }), this.connection.bind("connecting", () => {
                this.channels.disconnect();
              }), this.connection.bind("disconnected", () => {
                this.channels.disconnect();
              }), this.connection.bind("error", (Ke) => {
                he.warn(Ke);
              }), hi.instances.push(this), this.timeline.info({ instances: hi.instances.length }), this.user = new is(this), hi.isReady && this.connect();
            }
            channel(le) {
              return this.channels.find(le);
            }
            allChannels() {
              return this.channels.all();
            }
            connect() {
              if (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer) {
                var le = this.connection.isUsingTLS(), ye = this.timelineSender;
                this.timelineSenderTimer = new L(6e4, function() {
                  ye.send(le);
                });
              }
            }
            disconnect() {
              this.connection.disconnect(), this.timelineSenderTimer && (this.timelineSenderTimer.ensureAborted(), this.timelineSenderTimer = null);
            }
            bind(le, ye, Be) {
              return this.global_emitter.bind(le, ye, Be), this;
            }
            unbind(le, ye, Be) {
              return this.global_emitter.unbind(le, ye, Be), this;
            }
            bind_global(le) {
              return this.global_emitter.bind_global(le), this;
            }
            unbind_global(le) {
              return this.global_emitter.unbind_global(le), this;
            }
            unbind_all(le) {
              return this.global_emitter.unbind_all(), this;
            }
            subscribeAll() {
              var le;
              for (le in this.channels.channels)
                this.channels.channels.hasOwnProperty(le) && this.subscribe(le);
            }
            subscribe(le) {
              var ye = this.channels.add(le, this);
              return ye.subscriptionPending && ye.subscriptionCancelled ? ye.reinstateSubscription() : !ye.subscriptionPending && this.connection.state === "connected" && ye.subscribe(), ye;
            }
            unsubscribe(le) {
              var ye = this.channels.find(le);
              ye && ye.subscriptionPending ? ye.cancelSubscription() : (ye = this.channels.remove(le), ye && ye.subscribed && ye.unsubscribe());
            }
            send_event(le, ye, Be) {
              return this.connection.send_event(le, ye, Be);
            }
            shouldUseTLS() {
              return this.config.useTLS;
            }
            signin() {
              this.user.signin();
            }
          }
          hi.instances = [], hi.isReady = !1, hi.logToConsole = !1, hi.Runtime = qn, hi.ScriptReceivers = qn.ScriptReceivers, hi.DependenciesReceivers = qn.DependenciesReceivers, hi.auth_callbacks = qn.auth_callbacks;
          var Ec = i.default = hi;
          function Nf(be) {
            if (be == null)
              throw "You must pass your app key when you instantiate Pusher.";
          }
          qn.setup(hi);
        }
        /******/
      ])
    );
  });
})(F6);
var aj = F6.exports;
const Zie = /* @__PURE__ */ c0(aj), U6 = () => rc(oj), sj = "_notification_n4jk2_1", lj = "_notification__icon_n4jk2_37", uj = "_popIn_n4jk2_1", cj = "_notification__content_n4jk2_51", dj = "_notification__title_n4jk2_51", fj = "_notification__message_n4jk2_57", hj = "_notification__date_n4jk2_61", pj = "_notification__close_n4jk2_65", em = {
  notification: sj,
  "notification--clickable": "_notification--clickable_n4jk2_22",
  "notification--info": "_notification--info_n4jk2_25",
  "notification--success": "_notification--success_n4jk2_28",
  "notification--warning": "_notification--warning_n4jk2_31",
  "notification--error": "_notification--error_n4jk2_34",
  notification__icon: lj,
  popIn: uj,
  notification__content: cj,
  notification__title: dj,
  notification__message: fj,
  notification__date: hj,
  notification__close: pj,
  "notification--hidden": "_notification--hidden_n4jk2_88"
}, mj = Mn.bind(em), Jie = ({ data: n, onRemove: e }) => {
  const { type: t, title: i, message: c, icon: a, onClick: s } = n, [r, l] = Wn(!1), d = mj(em.notification, {
    [`notification--${t}`]: t,
    "notification--hidden": r,
    "notification--closeable": !s,
    "notification--clickable": !!s
  }), f = () => {
    if (a)
      return a;
    switch (t) {
      case "info":
        return /* @__PURE__ */ Re(_P, {});
      case "success":
        return /* @__PURE__ */ Re(O6, {});
      case "warning":
      case "error":
        return /* @__PURE__ */ Re(gP, {});
    }
  }, h = (g) => {
    s && (p(g), s());
  }, p = (g) => {
    g.stopPropagation(), l(!0), setTimeout(() => {
      e(n);
    }, 1e3);
  };
  return /* @__PURE__ */ Mt("div", { onClick: h, className: d, children: [
    /* @__PURE__ */ Re("div", { className: em.notification__icon, children: f() }),
    /* @__PURE__ */ Mt("div", { className: em.notification__content, children: [
      i && /* @__PURE__ */ Re("div", { className: em.notification__title, children: i }),
      /* @__PURE__ */ Re("p", { className: em.notification__message, children: c })
    ] }),
    !s && /* @__PURE__ */ Re(
      "button",
      {
        className: em.notification__close,
        onClick: p,
        children: /* @__PURE__ */ Re(k6, {})
      }
    )
  ] });
}, eoe = bf(void 0), Bx = () => rc(B6), Fx = (n, e) => {
  An(() => {
    const t = (c) => {
      const a = c.target;
      n.every((s) => s.current && !s.current.contains(a)) && e();
    }, i = (c) => {
      c.key === "Escape" && e();
    };
    return document.addEventListener("click", t), document.addEventListener("keydown", i), () => {
      document.removeEventListener("click", t), document.removeEventListener("keydown", i);
    };
  }, [n, e]);
}, gj = "_accordion_q1y4r_1", _j = {
  accordion: gj,
  "accordion--noMargin": "_accordion--noMargin_q1y4r_7"
}, yj = Mn.bind(_j), toe = (n) => {
  const { children: e, noMargin: t } = n, i = yj("accordion", {
    "accordion--no-margin": !!t
  });
  return /* @__PURE__ */ Re("div", { className: i, children: e });
}, vj = "_accordionItem_7me3k_1", bj = "_accordionTrigger_7me3k_1", Ej = "_accordionTriggerArrow_7me3k_20", Sj = "_accordionContent_7me3k_38", Cj = "_accordionContent__inner_7me3k_44", e1 = {
  accordionItem: vj,
  accordionTrigger: bj,
  accordionTriggerArrow: Ej,
  accordionContent: Sj,
  accordionContent__inner: Cj,
  "accordionItem--open": "_accordionItem--open_7me3k_47"
}, wj = Mn.bind(e1), noe = (n) => {
  const { name: e, open: t, setOpen: i, title: c, children: a } = n, s = zn(null), r = wj("accordionItem", {
    "accordionItem--open": t
  }), l = () => {
    i(e ? t ? void 0 : e : !t);
  };
  return /* @__PURE__ */ Mt(
    "div",
    {
      className: r,
      style: {
        "--accordion-content-height": s.current ? s.current.scrollHeight + "px" : "100vh"
      },
      children: [
        /* @__PURE__ */ Mt(
          "button",
          {
            onClick: l,
            className: e1.accordionTrigger,
            type: "button",
            children: [
              c,
              /* @__PURE__ */ Re("span", { className: e1.accordionTriggerArrow, children: /* @__PURE__ */ Re(E2, {}) })
            ]
          }
        ),
        /* @__PURE__ */ Re("div", { ref: s, className: e1.accordionContent, children: /* @__PURE__ */ Re("div", { className: e1.accordionContent__inner, children: a }) })
      ]
    }
  );
}, xj = "_button_cmmgh_1", Tj = "_dropdownIcon_cmmgh_343", Aj = "_loadWrapper_cmmgh_376", H6 = {
  button: xj,
  "button-icon": "_button-icon_cmmgh_33",
  "button-small": "_button-small_cmmgh_42",
  "button-tiny": "_button-tiny_cmmgh_58",
  "button-large": "_button-large_cmmgh_75",
  "button-outline": "_button-outline_cmmgh_107",
  "button-link": "_button-link_cmmgh_115",
  "button-secondary": "_button-secondary_cmmgh_125",
  "button-error": "_button-error_cmmgh_155",
  "button-warning": "_button-warning_cmmgh_185",
  "button-subtle": "_button-subtle_cmmgh_215",
  "button-support": "_button-support_cmmgh_245",
  "button-light": "_button-light_cmmgh_275",
  "button-disabled": "_button-disabled_cmmgh_305",
  "button-block": "_button-block_cmmgh_330",
  "button-loading": "_button-loading_cmmgh_333",
  "button-dropdown": "_button-dropdown_cmmgh_337",
  dropdownIcon: Tj,
  "dropdownIcon--open": "_dropdownIcon--open_cmmgh_351",
  "button-noPadding": "_button-noPadding_cmmgh_372",
  loadWrapper: Aj
}, kj = "_loader_53wyn_1", Oj = "_loaderBars_53wyn_13", Dj = "_loading_53wyn_1", Rj = {
  loader: kj,
  "loader--fill": "_loader--fill_53wyn_6",
  "loader-inline": "_loader-inline_53wyn_10",
  loaderBars: Oj,
  loading: Dj,
  "loaderBars--size-tiny": "_loaderBars--size-tiny_53wyn_32",
  "loaderBars--size-small": "_loaderBars--size-small_53wyn_39",
  "loaderBars--size-large": "_loaderBars--size-large_53wyn_46",
  "loaderBars--variant-outline": "_loaderBars--variant-outline_53wyn_53",
  "loaderBars--rotate": "_loaderBars--rotate_53wyn_57",
  "loaderBars--canvasColor": "_loaderBars--canvasColor_53wyn_60",
  "loaderBars--color-canvas": "_loaderBars--color-canvas_53wyn_60",
  "loaderBars--color-secondary": "_loaderBars--color-secondary_53wyn_67",
  "loaderBars--color-error": "_loaderBars--color-error_53wyn_74",
  "loaderBars--color-warning": "_loaderBars--color-warning_53wyn_81",
  "loaderBars--color-subtle": "_loaderBars--color-subtle_53wyn_88",
  "loaderBars--color-support": "_loaderBars--color-support_53wyn_95",
  "loaderBars--color-light": "_loaderBars--color-light_53wyn_102"
}, D3 = Mn.bind(Rj), Ux = (n) => {
  const { fill: e, inline: t, size: i, variant: c, rotate: a, canvasColor: s, color: r } = n, l = D3("loader", {
    "loader--fill": e,
    "loader--inline": t
  }), d = D3("loaderBars", {
    [`loaderBars--size-${i}`]: !!i,
    [`loaderBars--variant-${c}`]: !!c,
    "loaderBars--rotate": a,
    "loaderBars--canvasColor": s,
    [`loaderBars--color-${r}`]: !!n.color
  });
  return /* @__PURE__ */ Re("div", { className: l, children: /* @__PURE__ */ Mt("div", { className: d, children: [
    /* @__PURE__ */ Re("span", {}),
    /* @__PURE__ */ Re("span", {}),
    /* @__PURE__ */ Re("span", {})
  ] }) });
}, R3 = Mn.bind(H6), Fh = Ef(
  (n, e) => {
    const {
      children: t,
      onClick: i,
      color: c,
      variant: a,
      size: s,
      disabled: r,
      block: l,
      icon: d,
      loading: f,
      type: h = "button",
      dropdown: p = !1,
      dropdownOpen: g = !1,
      noPadding: _ = !1
    } = n, b = [
      "button",
      {
        [`button-${s}`]: !!s,
        [`button-${a}`]: !!a,
        [`button-${c}`]: !!c,
        "button-disabled": r,
        "button-icon": d,
        "button-block": l,
        "button-loading": f,
        "button-dropdown": p,
        "button-noPadding": _
      }
    ], v = R3(b), E = R3([
      "dropdownIcon",
      {
        "dropdownIcon--open": g
      }
    ]);
    return /* @__PURE__ */ Mt(
      "button",
      {
        className: v,
        onClick: i,
        disabled: r,
        type: h,
        ref: e,
        children: [
          f && /* @__PURE__ */ Re("div", { className: H6.loadWrapper, children: /* @__PURE__ */ Re(
            Ux,
            {
              size: "tiny",
              color: a ? c : "canvas"
            }
          ) }),
          t,
          p && /* @__PURE__ */ Re(E2, { className: E })
        ]
      }
    );
  }
), Nj = "_buttonGroup_yr7ng_1", Ij = {
  buttonGroup: Nj,
  "buttonGroup--noMargin": "_buttonGroup--noMargin_yr7ng_18",
  "buttonGroup--marginTop": "_buttonGroup--marginTop_yr7ng_21",
  "buttonGroup--inline": "_buttonGroup--inline_yr7ng_31",
  "buttonGroup--noWrap": "_buttonGroup--noWrap_yr7ng_34",
  "buttonGroup--dense": "_buttonGroup--dense_yr7ng_38"
}, Lj = Mn.bind(Ij), Mj = (n) => {
  const { children: e, noMargin: t, marginTop: i, inline: c, noWrap: a, dense: s } = n;
  return /* @__PURE__ */ Re("div", { className: Lj([
    "buttonGroup",
    {
      "buttonGroup--noMargin": t,
      "buttonGroup--marginTop": i,
      "buttonGroup--inline": c,
      "buttonGroup--noWrap": a,
      "buttonGroup--dense": s
    }
  ]), children: e });
}, Pj = "_calendarHeader_7hk57_1", jj = "_calendarHeaderButton_7hk57_7", Bj = "_calendarHeaderTitle_7hk57_19", Fj = "_calendarGrid_7hk57_27", Uj = "_calendarGridHeader_7hk57_27", Hj = "_calendarGridBody_7hk57_33", zj = "_calendarGridHeaderDay_7hk57_38", Vj = "_calendarGridDayButton_7hk57_48", td = {
  calendarHeader: Pj,
  calendarHeaderButton: jj,
  calendarHeaderTitle: Bj,
  calendarGrid: Fj,
  calendarGridHeader: Uj,
  calendarGridBody: Hj,
  calendarGridHeaderDay: zj,
  calendarGridDayButton: Vj,
  "calendarGridDayButton--today": "_calendarGridDayButton--today_7hk57_81",
  "calendarGridDayButton--subtle": "_calendarGridDayButton--subtle_7hk57_84",
  "calendarGridDayButton--disabled": "_calendarGridDayButton--disabled_7hk57_87",
  "calendarGridDayButton--selected": "_calendarGridDayButton--selected_7hk57_93"
}, qj = Mn.bind(td), Gj = (n) => {
  const { value: e, onChange: t, defaultTime: i = "00:00", minDate: c, maxDate: a } = n, [s, r] = Wn(() => {
    let v = /* @__PURE__ */ new Date();
    if (e)
      v = new Date(e);
    else {
      const [E, C] = i.split(":");
      v.setHours(Number(E)), v.setMinutes(Number(C));
    }
    return v.setSeconds(0), v.setDate(1), v;
  });
  An(() => {
    const v = (E) => {
      const C = new Date(E), [y, T] = i.split(":");
      return C.setHours(Number(y)), C.setMinutes(Number(T)), C.setSeconds(0), C.setDate(1), C;
    };
    if (c && !e) {
      const E = new Date(c);
      r(v(E));
    }
    if (a && !e) {
      const E = new Date(a);
      r(v(E));
    }
  }, [e, c, a, i]);
  const l = (v) => {
    const E = new Date(s);
    v === "back" ? E.setMonth(E.getMonth() - 1) : E.setMonth(E.getMonth() + 1), r(E);
  }, d = (v) => {
    t(v);
  }, f = () => document.documentElement.getAttribute("lang") ?? navigator.language, h = () => {
    const v = s.toLocaleString(f(), {
      month: "long",
      year: "numeric"
    });
    return v.charAt(0).toUpperCase() + v.slice(1);
  }, p = (v) => {
    const E = /* @__PURE__ */ new Date();
    return E.setDate(E.getDate() - E.getDay() + v + 1), E.toLocaleString(f(), { weekday: "short" });
  }, g = () => {
    const v = new Date(s);
    v.setDate(1);
    const E = new Date(s);
    E.setMonth(E.getMonth() + 1), E.setDate(0);
    const C = E.getDate(), y = (v.getDay() + 6) % 7, T = C + y;
    return Math.ceil(T / 7);
  }, _ = (v) => !!(c && new Date(v).setHours(0, 0, 0, 0) < new Date(c).setHours(0, 0, 0, 0) || a && new Date(v).setHours(0, 0, 0, 0) > new Date(a).setHours(0, 0, 0, 0)), b = (v) => e && v.toDateString() === e.toDateString();
  return /* @__PURE__ */ Re("div", { className: td.calendar, children: /* @__PURE__ */ Mt("div", { children: [
    /* @__PURE__ */ Mt("div", { className: td.calendarHeader, children: [
      /* @__PURE__ */ Re(
        "button",
        {
          type: "button",
          onClick: () => l("back"),
          className: td.calendarHeaderButton,
          children: /* @__PURE__ */ Re(D6, {})
        }
      ),
      /* @__PURE__ */ Re("div", { className: td.calendarHeaderTitle, children: h() }),
      /* @__PURE__ */ Re(
        "button",
        {
          type: "button",
          onClick: () => l("forward"),
          className: td.calendarHeaderButton,
          children: /* @__PURE__ */ Re(R6, {})
        }
      )
    ] }),
    /* @__PURE__ */ Mt("div", { className: td.calendarGrid, children: [
      /* @__PURE__ */ Re("div", { className: td.calendarGridHeader, children: Array.from({ length: 7 }).map((v, E) => /* @__PURE__ */ Re(
        "div",
        {
          className: td.calendarGridHeaderDay,
          children: p(E)
        },
        E
      )) }),
      /* @__PURE__ */ Re("div", { className: td.calendarGridBody, children: Array.from({ length: g() * 7 }).map(
        (v, E) => {
          const C = new Date(s), y = (C.getDay() + 6) % 7, T = E - y;
          C.setDate(
            s.getDate() + T
          );
          const A = [
            "calendarGridDayButton",
            {
              "calendarGridDayButton--today": C.toDateString() === (/* @__PURE__ */ new Date()).toDateString(),
              "calendarGridDayButton--subtle": C.getMonth() !== s.getMonth(),
              "calendarGridDayButton--disabled": _(C),
              "calendarGridDayButton--selected": b(C)
            }
          ];
          return /* @__PURE__ */ Re(
            "button",
            {
              type: "button",
              disabled: _(C),
              className: qj(A),
              onClick: () => d(C),
              children: C.getDate()
            },
            E
          );
        }
      ) })
    ] })
  ] }) });
};
var Wj = function(e) {
  return $j(e) && !Yj(e);
};
function $j(n) {
  return !!n && typeof n == "object";
}
function Yj(n) {
  var e = Object.prototype.toString.call(n);
  return e === "[object RegExp]" || e === "[object Date]" || Qj(n);
}
var Xj = typeof Symbol == "function" && Symbol.for, Kj = Xj ? Symbol.for("react.element") : 60103;
function Qj(n) {
  return n.$$typeof === Kj;
}
function Zj(n) {
  return Array.isArray(n) ? [] : {};
}
function $b(n, e) {
  return e.clone !== !1 && e.isMergeableObject(n) ? C1(Zj(n), n, e) : n;
}
function Jj(n, e, t) {
  return n.concat(e).map(function(i) {
    return $b(i, t);
  });
}
function eB(n, e, t) {
  var i = {};
  return t.isMergeableObject(n) && Object.keys(n).forEach(function(c) {
    i[c] = $b(n[c], t);
  }), Object.keys(e).forEach(function(c) {
    !t.isMergeableObject(e[c]) || !n[c] ? i[c] = $b(e[c], t) : i[c] = C1(n[c], e[c], t);
  }), i;
}
function C1(n, e, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || Jj, t.isMergeableObject = t.isMergeableObject || Wj;
  var i = Array.isArray(e), c = Array.isArray(n), a = i === c;
  return a ? i ? t.arrayMerge(n, e, t) : eB(n, e, t) : $b(e, t);
}
C1.all = function(e, t) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(i, c) {
    return C1(i, c, t);
  }, {});
};
var Ww = C1, z6 = typeof global == "object" && global && global.Object === Object && global, tB = typeof self == "object" && self && self.Object === Object && self, md = z6 || tB || Function("return this")(), Vh = md.Symbol, V6 = Object.prototype, nB = V6.hasOwnProperty, rB = V6.toString, Y_ = Vh ? Vh.toStringTag : void 0;
function iB(n) {
  var e = nB.call(n, Y_), t = n[Y_];
  try {
    n[Y_] = void 0;
    var i = !0;
  } catch {
  }
  var c = rB.call(n);
  return i && (e ? n[Y_] = t : delete n[Y_]), c;
}
var oB = Object.prototype, aB = oB.toString;
function sB(n) {
  return aB.call(n);
}
var lB = "[object Null]", uB = "[object Undefined]", N3 = Vh ? Vh.toStringTag : void 0;
function Tm(n) {
  return n == null ? n === void 0 ? uB : lB : N3 && N3 in Object(n) ? iB(n) : sB(n);
}
function q6(n, e) {
  return function(t) {
    return n(e(t));
  };
}
var Hx = q6(Object.getPrototypeOf, Object);
function Am(n) {
  return n != null && typeof n == "object";
}
var cB = "[object Object]", dB = Function.prototype, fB = Object.prototype, G6 = dB.toString, hB = fB.hasOwnProperty, pB = G6.call(Object);
function I3(n) {
  if (!Am(n) || Tm(n) != cB)
    return !1;
  var e = Hx(n);
  if (e === null)
    return !0;
  var t = hB.call(e, "constructor") && e.constructor;
  return typeof t == "function" && t instanceof t && G6.call(t) == pB;
}
function mB() {
  this.__data__ = [], this.size = 0;
}
function W6(n, e) {
  return n === e || n !== n && e !== e;
}
function C2(n, e) {
  for (var t = n.length; t--; )
    if (W6(n[t][0], e))
      return t;
  return -1;
}
var gB = Array.prototype, _B = gB.splice;
function yB(n) {
  var e = this.__data__, t = C2(e, n);
  if (t < 0)
    return !1;
  var i = e.length - 1;
  return t == i ? e.pop() : _B.call(e, t, 1), --this.size, !0;
}
function vB(n) {
  var e = this.__data__, t = C2(e, n);
  return t < 0 ? void 0 : e[t][1];
}
function bB(n) {
  return C2(this.__data__, n) > -1;
}
function EB(n, e) {
  var t = this.__data__, i = C2(t, n);
  return i < 0 ? (++this.size, t.push([n, e])) : t[i][1] = e, this;
}
function Sf(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var i = n[e];
    this.set(i[0], i[1]);
  }
}
Sf.prototype.clear = mB;
Sf.prototype.delete = yB;
Sf.prototype.get = vB;
Sf.prototype.has = bB;
Sf.prototype.set = EB;
function SB() {
  this.__data__ = new Sf(), this.size = 0;
}
function CB(n) {
  var e = this.__data__, t = e.delete(n);
  return this.size = e.size, t;
}
function wB(n) {
  return this.__data__.get(n);
}
function xB(n) {
  return this.__data__.has(n);
}
function M1(n) {
  var e = typeof n;
  return n != null && (e == "object" || e == "function");
}
var TB = "[object AsyncFunction]", AB = "[object Function]", kB = "[object GeneratorFunction]", OB = "[object Proxy]";
function $6(n) {
  if (!M1(n))
    return !1;
  var e = Tm(n);
  return e == AB || e == kB || e == TB || e == OB;
}
var ow = md["__core-js_shared__"], L3 = function() {
  var n = /[^.]+$/.exec(ow && ow.keys && ow.keys.IE_PROTO || "");
  return n ? "Symbol(src)_1." + n : "";
}();
function DB(n) {
  return !!L3 && L3 in n;
}
var RB = Function.prototype, NB = RB.toString;
function km(n) {
  if (n != null) {
    try {
      return NB.call(n);
    } catch {
    }
    try {
      return n + "";
    } catch {
    }
  }
  return "";
}
var IB = /[\\^$.*+?()[\]{}|]/g, LB = /^\[object .+?Constructor\]$/, MB = Function.prototype, PB = Object.prototype, jB = MB.toString, BB = PB.hasOwnProperty, FB = RegExp(
  "^" + jB.call(BB).replace(IB, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function UB(n) {
  if (!M1(n) || DB(n))
    return !1;
  var e = $6(n) ? FB : LB;
  return e.test(km(n));
}
function HB(n, e) {
  return n == null ? void 0 : n[e];
}
function Om(n, e) {
  var t = HB(n, e);
  return UB(t) ? t : void 0;
}
var w1 = Om(md, "Map"), x1 = Om(Object, "create");
function zB() {
  this.__data__ = x1 ? x1(null) : {}, this.size = 0;
}
function VB(n) {
  var e = this.has(n) && delete this.__data__[n];
  return this.size -= e ? 1 : 0, e;
}
var qB = "__lodash_hash_undefined__", GB = Object.prototype, WB = GB.hasOwnProperty;
function $B(n) {
  var e = this.__data__;
  if (x1) {
    var t = e[n];
    return t === qB ? void 0 : t;
  }
  return WB.call(e, n) ? e[n] : void 0;
}
var YB = Object.prototype, XB = YB.hasOwnProperty;
function KB(n) {
  var e = this.__data__;
  return x1 ? e[n] !== void 0 : XB.call(e, n);
}
var QB = "__lodash_hash_undefined__";
function ZB(n, e) {
  var t = this.__data__;
  return this.size += this.has(n) ? 0 : 1, t[n] = x1 && e === void 0 ? QB : e, this;
}
function bm(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var i = n[e];
    this.set(i[0], i[1]);
  }
}
bm.prototype.clear = zB;
bm.prototype.delete = VB;
bm.prototype.get = $B;
bm.prototype.has = KB;
bm.prototype.set = ZB;
function JB() {
  this.size = 0, this.__data__ = {
    hash: new bm(),
    map: new (w1 || Sf)(),
    string: new bm()
  };
}
function eF(n) {
  var e = typeof n;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? n !== "__proto__" : n === null;
}
function w2(n, e) {
  var t = n.__data__;
  return eF(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
function tF(n) {
  var e = w2(this, n).delete(n);
  return this.size -= e ? 1 : 0, e;
}
function nF(n) {
  return w2(this, n).get(n);
}
function rF(n) {
  return w2(this, n).has(n);
}
function iF(n, e) {
  var t = w2(this, n), i = t.size;
  return t.set(n, e), this.size += t.size == i ? 0 : 1, this;
}
function Yh(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var i = n[e];
    this.set(i[0], i[1]);
  }
}
Yh.prototype.clear = JB;
Yh.prototype.delete = tF;
Yh.prototype.get = nF;
Yh.prototype.has = rF;
Yh.prototype.set = iF;
var oF = 200;
function aF(n, e) {
  var t = this.__data__;
  if (t instanceof Sf) {
    var i = t.__data__;
    if (!w1 || i.length < oF - 1)
      return i.push([n, e]), this.size = ++t.size, this;
    t = this.__data__ = new Yh(i);
  }
  return t.set(n, e), this.size = t.size, this;
}
function d0(n) {
  var e = this.__data__ = new Sf(n);
  this.size = e.size;
}
d0.prototype.clear = SB;
d0.prototype.delete = CB;
d0.prototype.get = wB;
d0.prototype.has = xB;
d0.prototype.set = aF;
function sF(n, e) {
  for (var t = -1, i = n == null ? 0 : n.length; ++t < i && e(n[t], t, n) !== !1; )
    ;
  return n;
}
var M3 = function() {
  try {
    var n = Om(Object, "defineProperty");
    return n({}, "", {}), n;
  } catch {
  }
}();
function Y6(n, e, t) {
  e == "__proto__" && M3 ? M3(n, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : n[e] = t;
}
var lF = Object.prototype, uF = lF.hasOwnProperty;
function X6(n, e, t) {
  var i = n[e];
  (!(uF.call(n, e) && W6(i, t)) || t === void 0 && !(e in n)) && Y6(n, e, t);
}
function x2(n, e, t, i) {
  var c = !t;
  t || (t = {});
  for (var a = -1, s = e.length; ++a < s; ) {
    var r = e[a], l = void 0;
    l === void 0 && (l = n[r]), c ? Y6(t, r, l) : X6(t, r, l);
  }
  return t;
}
function cF(n, e) {
  for (var t = -1, i = Array(n); ++t < n; )
    i[t] = e(t);
  return i;
}
var dF = "[object Arguments]";
function P3(n) {
  return Am(n) && Tm(n) == dF;
}
var K6 = Object.prototype, fF = K6.hasOwnProperty, hF = K6.propertyIsEnumerable, pF = P3(/* @__PURE__ */ function() {
  return arguments;
}()) ? P3 : function(n) {
  return Am(n) && fF.call(n, "callee") && !hF.call(n, "callee");
}, P1 = Array.isArray;
function mF() {
  return !1;
}
var Q6 = typeof exports == "object" && exports && !exports.nodeType && exports, j3 = Q6 && typeof module == "object" && module && !module.nodeType && module, gF = j3 && j3.exports === Q6, B3 = gF ? md.Buffer : void 0, _F = B3 ? B3.isBuffer : void 0, Z6 = _F || mF, yF = 9007199254740991, vF = /^(?:0|[1-9]\d*)$/;
function bF(n, e) {
  var t = typeof n;
  return e = e ?? yF, !!e && (t == "number" || t != "symbol" && vF.test(n)) && n > -1 && n % 1 == 0 && n < e;
}
var EF = 9007199254740991;
function J6(n) {
  return typeof n == "number" && n > -1 && n % 1 == 0 && n <= EF;
}
var SF = "[object Arguments]", CF = "[object Array]", wF = "[object Boolean]", xF = "[object Date]", TF = "[object Error]", AF = "[object Function]", kF = "[object Map]", OF = "[object Number]", DF = "[object Object]", RF = "[object RegExp]", NF = "[object Set]", IF = "[object String]", LF = "[object WeakMap]", MF = "[object ArrayBuffer]", PF = "[object DataView]", jF = "[object Float32Array]", BF = "[object Float64Array]", FF = "[object Int8Array]", UF = "[object Int16Array]", HF = "[object Int32Array]", zF = "[object Uint8Array]", VF = "[object Uint8ClampedArray]", qF = "[object Uint16Array]", GF = "[object Uint32Array]", Ni = {};
Ni[jF] = Ni[BF] = Ni[FF] = Ni[UF] = Ni[HF] = Ni[zF] = Ni[VF] = Ni[qF] = Ni[GF] = !0;
Ni[SF] = Ni[CF] = Ni[MF] = Ni[wF] = Ni[PF] = Ni[xF] = Ni[TF] = Ni[AF] = Ni[kF] = Ni[OF] = Ni[DF] = Ni[RF] = Ni[NF] = Ni[IF] = Ni[LF] = !1;
function WF(n) {
  return Am(n) && J6(n.length) && !!Ni[Tm(n)];
}
function zx(n) {
  return function(e) {
    return n(e);
  };
}
var e7 = typeof exports == "object" && exports && !exports.nodeType && exports, d1 = e7 && typeof module == "object" && module && !module.nodeType && module, $F = d1 && d1.exports === e7, aw = $F && z6.process, o0 = function() {
  try {
    var n = d1 && d1.require && d1.require("util").types;
    return n || aw && aw.binding && aw.binding("util");
  } catch {
  }
}(), F3 = o0 && o0.isTypedArray, YF = F3 ? zx(F3) : WF, XF = Object.prototype, KF = XF.hasOwnProperty;
function t7(n, e) {
  var t = P1(n), i = !t && pF(n), c = !t && !i && Z6(n), a = !t && !i && !c && YF(n), s = t || i || c || a, r = s ? cF(n.length, String) : [], l = r.length;
  for (var d in n)
    (e || KF.call(n, d)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    c && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    bF(d, l))) && r.push(d);
  return r;
}
var QF = Object.prototype;
function Vx(n) {
  var e = n && n.constructor, t = typeof e == "function" && e.prototype || QF;
  return n === t;
}
var ZF = q6(Object.keys, Object), JF = Object.prototype, eU = JF.hasOwnProperty;
function tU(n) {
  if (!Vx(n))
    return ZF(n);
  var e = [];
  for (var t in Object(n))
    eU.call(n, t) && t != "constructor" && e.push(t);
  return e;
}
function n7(n) {
  return n != null && J6(n.length) && !$6(n);
}
function qx(n) {
  return n7(n) ? t7(n) : tU(n);
}
function nU(n, e) {
  return n && x2(e, qx(e), n);
}
function rU(n) {
  var e = [];
  if (n != null)
    for (var t in Object(n))
      e.push(t);
  return e;
}
var iU = Object.prototype, oU = iU.hasOwnProperty;
function aU(n) {
  if (!M1(n))
    return rU(n);
  var e = Vx(n), t = [];
  for (var i in n)
    i == "constructor" && (e || !oU.call(n, i)) || t.push(i);
  return t;
}
function Gx(n) {
  return n7(n) ? t7(n, !0) : aU(n);
}
function sU(n, e) {
  return n && x2(e, Gx(e), n);
}
var r7 = typeof exports == "object" && exports && !exports.nodeType && exports, U3 = r7 && typeof module == "object" && module && !module.nodeType && module, lU = U3 && U3.exports === r7, H3 = lU ? md.Buffer : void 0, z3 = H3 ? H3.allocUnsafe : void 0;
function uU(n, e) {
  if (e)
    return n.slice();
  var t = n.length, i = z3 ? z3(t) : new n.constructor(t);
  return n.copy(i), i;
}
function i7(n, e) {
  var t = -1, i = n.length;
  for (e || (e = Array(i)); ++t < i; )
    e[t] = n[t];
  return e;
}
function cU(n, e) {
  for (var t = -1, i = n == null ? 0 : n.length, c = 0, a = []; ++t < i; ) {
    var s = n[t];
    e(s, t, n) && (a[c++] = s);
  }
  return a;
}
function o7() {
  return [];
}
var dU = Object.prototype, fU = dU.propertyIsEnumerable, V3 = Object.getOwnPropertySymbols, Wx = V3 ? function(n) {
  return n == null ? [] : (n = Object(n), cU(V3(n), function(e) {
    return fU.call(n, e);
  }));
} : o7;
function hU(n, e) {
  return x2(n, Wx(n), e);
}
function a7(n, e) {
  for (var t = -1, i = e.length, c = n.length; ++t < i; )
    n[c + t] = e[t];
  return n;
}
var pU = Object.getOwnPropertySymbols, s7 = pU ? function(n) {
  for (var e = []; n; )
    a7(e, Wx(n)), n = Hx(n);
  return e;
} : o7;
function mU(n, e) {
  return x2(n, s7(n), e);
}
function l7(n, e, t) {
  var i = e(n);
  return P1(n) ? i : a7(i, t(n));
}
function gU(n) {
  return l7(n, qx, Wx);
}
function _U(n) {
  return l7(n, Gx, s7);
}
var $w = Om(md, "DataView"), Yw = Om(md, "Promise"), Xw = Om(md, "Set"), Kw = Om(md, "WeakMap"), q3 = "[object Map]", yU = "[object Object]", G3 = "[object Promise]", W3 = "[object Set]", $3 = "[object WeakMap]", Y3 = "[object DataView]", vU = km($w), bU = km(w1), EU = km(Yw), SU = km(Xw), CU = km(Kw), df = Tm;
($w && df(new $w(new ArrayBuffer(1))) != Y3 || w1 && df(new w1()) != q3 || Yw && df(Yw.resolve()) != G3 || Xw && df(new Xw()) != W3 || Kw && df(new Kw()) != $3) && (df = function(n) {
  var e = Tm(n), t = e == yU ? n.constructor : void 0, i = t ? km(t) : "";
  if (i)
    switch (i) {
      case vU:
        return Y3;
      case bU:
        return q3;
      case EU:
        return G3;
      case SU:
        return W3;
      case CU:
        return $3;
    }
  return e;
});
var wU = Object.prototype, xU = wU.hasOwnProperty;
function TU(n) {
  var e = n.length, t = new n.constructor(e);
  return e && typeof n[0] == "string" && xU.call(n, "index") && (t.index = n.index, t.input = n.input), t;
}
var X3 = md.Uint8Array;
function $x(n) {
  var e = new n.constructor(n.byteLength);
  return new X3(e).set(new X3(n)), e;
}
function AU(n, e) {
  var t = e ? $x(n.buffer) : n.buffer;
  return new n.constructor(t, n.byteOffset, n.byteLength);
}
var kU = /\w*$/;
function OU(n) {
  var e = new n.constructor(n.source, kU.exec(n));
  return e.lastIndex = n.lastIndex, e;
}
var K3 = Vh ? Vh.prototype : void 0, Q3 = K3 ? K3.valueOf : void 0;
function DU(n) {
  return Q3 ? Object(Q3.call(n)) : {};
}
function RU(n, e) {
  var t = e ? $x(n.buffer) : n.buffer;
  return new n.constructor(t, n.byteOffset, n.length);
}
var NU = "[object Boolean]", IU = "[object Date]", LU = "[object Map]", MU = "[object Number]", PU = "[object RegExp]", jU = "[object Set]", BU = "[object String]", FU = "[object Symbol]", UU = "[object ArrayBuffer]", HU = "[object DataView]", zU = "[object Float32Array]", VU = "[object Float64Array]", qU = "[object Int8Array]", GU = "[object Int16Array]", WU = "[object Int32Array]", $U = "[object Uint8Array]", YU = "[object Uint8ClampedArray]", XU = "[object Uint16Array]", KU = "[object Uint32Array]";
function QU(n, e, t) {
  var i = n.constructor;
  switch (e) {
    case UU:
      return $x(n);
    case NU:
    case IU:
      return new i(+n);
    case HU:
      return AU(n, t);
    case zU:
    case VU:
    case qU:
    case GU:
    case WU:
    case $U:
    case YU:
    case XU:
    case KU:
      return RU(n, t);
    case LU:
      return new i();
    case MU:
    case BU:
      return new i(n);
    case PU:
      return OU(n);
    case jU:
      return new i();
    case FU:
      return DU(n);
  }
}
var Z3 = Object.create, ZU = /* @__PURE__ */ function() {
  function n() {
  }
  return function(e) {
    if (!M1(e))
      return {};
    if (Z3)
      return Z3(e);
    n.prototype = e;
    var t = new n();
    return n.prototype = void 0, t;
  };
}();
function JU(n) {
  return typeof n.constructor == "function" && !Vx(n) ? ZU(Hx(n)) : {};
}
var eH = "[object Map]";
function tH(n) {
  return Am(n) && df(n) == eH;
}
var J3 = o0 && o0.isMap, nH = J3 ? zx(J3) : tH, rH = "[object Set]";
function iH(n) {
  return Am(n) && df(n) == rH;
}
var e4 = o0 && o0.isSet, oH = e4 ? zx(e4) : iH, aH = 1, sH = 2, lH = 4, u7 = "[object Arguments]", uH = "[object Array]", cH = "[object Boolean]", dH = "[object Date]", fH = "[object Error]", c7 = "[object Function]", hH = "[object GeneratorFunction]", pH = "[object Map]", mH = "[object Number]", d7 = "[object Object]", gH = "[object RegExp]", _H = "[object Set]", yH = "[object String]", vH = "[object Symbol]", bH = "[object WeakMap]", EH = "[object ArrayBuffer]", SH = "[object DataView]", CH = "[object Float32Array]", wH = "[object Float64Array]", xH = "[object Int8Array]", TH = "[object Int16Array]", AH = "[object Int32Array]", kH = "[object Uint8Array]", OH = "[object Uint8ClampedArray]", DH = "[object Uint16Array]", RH = "[object Uint32Array]", wi = {};
wi[u7] = wi[uH] = wi[EH] = wi[SH] = wi[cH] = wi[dH] = wi[CH] = wi[wH] = wi[xH] = wi[TH] = wi[AH] = wi[pH] = wi[mH] = wi[d7] = wi[gH] = wi[_H] = wi[yH] = wi[vH] = wi[kH] = wi[OH] = wi[DH] = wi[RH] = !0;
wi[fH] = wi[c7] = wi[bH] = !1;
function f1(n, e, t, i, c, a) {
  var s, r = e & aH, l = e & sH, d = e & lH;
  if (s !== void 0)
    return s;
  if (!M1(n))
    return n;
  var f = P1(n);
  if (f) {
    if (s = TU(n), !r)
      return i7(n, s);
  } else {
    var h = df(n), p = h == c7 || h == hH;
    if (Z6(n))
      return uU(n, r);
    if (h == d7 || h == u7 || p && !c) {
      if (s = l || p ? {} : JU(n), !r)
        return l ? mU(n, sU(s, n)) : hU(n, nU(s, n));
    } else {
      if (!wi[h])
        return c ? n : {};
      s = QU(n, h, r);
    }
  }
  a || (a = new d0());
  var g = a.get(n);
  if (g)
    return g;
  a.set(n, s), oH(n) ? n.forEach(function(v) {
    s.add(f1(v, e, t, v, n, a));
  }) : nH(n) && n.forEach(function(v, E) {
    s.set(E, f1(v, e, t, E, n, a));
  });
  var _ = d ? l ? _U : gU : l ? Gx : qx, b = f ? void 0 : _(n);
  return sF(b || n, function(v, E) {
    b && (E = v, v = n[E]), X6(s, E, f1(v, e, t, E, n, a));
  }), s;
}
var NH = 1, IH = 4;
function t1(n) {
  return f1(n, NH | IH);
}
var t4 = Array.isArray, n4 = Object.keys, LH = Object.prototype.hasOwnProperty, MH = typeof Element < "u";
function Qw(n, e) {
  if (n === e) return !0;
  if (n && e && typeof n == "object" && typeof e == "object") {
    var t = t4(n), i = t4(e), c, a, s;
    if (t && i) {
      if (a = n.length, a != e.length) return !1;
      for (c = a; c-- !== 0; )
        if (!Qw(n[c], e[c])) return !1;
      return !0;
    }
    if (t != i) return !1;
    var r = n instanceof Date, l = e instanceof Date;
    if (r != l) return !1;
    if (r && l) return n.getTime() == e.getTime();
    var d = n instanceof RegExp, f = e instanceof RegExp;
    if (d != f) return !1;
    if (d && f) return n.toString() == e.toString();
    var h = n4(n);
    if (a = h.length, a !== n4(e).length)
      return !1;
    for (c = a; c-- !== 0; )
      if (!LH.call(e, h[c])) return !1;
    if (MH && n instanceof Element && e instanceof Element)
      return n === e;
    for (c = a; c-- !== 0; )
      if (s = h[c], !(s === "_owner" && n.$$typeof) && !Qw(n[s], e[s]))
        return !1;
    return !0;
  }
  return n !== n && e !== e;
}
var PH = function(e, t) {
  try {
    return Qw(e, t);
  } catch (i) {
    if (i.message && i.message.match(/stack|recursion/i) || i.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", i.name, i.message), !1;
    throw i;
  }
};
const jh = /* @__PURE__ */ c0(PH);
var jH = process.env.NODE_ENV === "production";
function da(n, e) {
  if (!jH) {
    var t = "Warning: " + e;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
var BH = 4;
function r4(n) {
  return f1(n, BH);
}
function f7(n, e) {
  for (var t = -1, i = n == null ? 0 : n.length, c = Array(i); ++t < i; )
    c[t] = e(n[t], t, n);
  return c;
}
var FH = "[object Symbol]";
function Yx(n) {
  return typeof n == "symbol" || Am(n) && Tm(n) == FH;
}
var UH = "Expected a function";
function Xx(n, e) {
  if (typeof n != "function" || e != null && typeof e != "function")
    throw new TypeError(UH);
  var t = function() {
    var i = arguments, c = e ? e.apply(this, i) : i[0], a = t.cache;
    if (a.has(c))
      return a.get(c);
    var s = n.apply(this, i);
    return t.cache = a.set(c, s) || a, s;
  };
  return t.cache = new (Xx.Cache || Yh)(), t;
}
Xx.Cache = Yh;
var HH = 500;
function zH(n) {
  var e = Xx(n, function(i) {
    return t.size === HH && t.clear(), i;
  }), t = e.cache;
  return e;
}
var VH = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qH = /\\(\\)?/g, GH = zH(function(n) {
  var e = [];
  return n.charCodeAt(0) === 46 && e.push(""), n.replace(VH, function(t, i, c, a) {
    e.push(c ? a.replace(qH, "$1") : i || t);
  }), e;
}), WH = 1 / 0;
function $H(n) {
  if (typeof n == "string" || Yx(n))
    return n;
  var e = n + "";
  return e == "0" && 1 / n == -WH ? "-0" : e;
}
var YH = 1 / 0, i4 = Vh ? Vh.prototype : void 0, o4 = i4 ? i4.toString : void 0;
function h7(n) {
  if (typeof n == "string")
    return n;
  if (P1(n))
    return f7(n, h7) + "";
  if (Yx(n))
    return o4 ? o4.call(n) : "";
  var e = n + "";
  return e == "0" && 1 / n == -YH ? "-0" : e;
}
function XH(n) {
  return n == null ? "" : h7(n);
}
function p7(n) {
  return P1(n) ? f7(n, $H) : Yx(n) ? [n] : i7(GH(XH(n)));
}
var Zw = { exports: {} }, Jr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a4;
function KH() {
  if (a4) return Jr;
  a4 = 1;
  var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, i = n ? Symbol.for("react.fragment") : 60107, c = n ? Symbol.for("react.strict_mode") : 60108, a = n ? Symbol.for("react.profiler") : 60114, s = n ? Symbol.for("react.provider") : 60109, r = n ? Symbol.for("react.context") : 60110, l = n ? Symbol.for("react.async_mode") : 60111, d = n ? Symbol.for("react.concurrent_mode") : 60111, f = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, g = n ? Symbol.for("react.memo") : 60115, _ = n ? Symbol.for("react.lazy") : 60116, b = n ? Symbol.for("react.block") : 60121, v = n ? Symbol.for("react.fundamental") : 60117, E = n ? Symbol.for("react.responder") : 60118, C = n ? Symbol.for("react.scope") : 60119;
  function y(A) {
    if (typeof A == "object" && A !== null) {
      var k = A.$$typeof;
      switch (k) {
        case e:
          switch (A = A.type, A) {
            case l:
            case d:
            case i:
            case a:
            case c:
            case h:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case r:
                case f:
                case _:
                case g:
                case s:
                  return A;
                default:
                  return k;
              }
          }
        case t:
          return k;
      }
    }
  }
  function T(A) {
    return y(A) === d;
  }
  return Jr.AsyncMode = l, Jr.ConcurrentMode = d, Jr.ContextConsumer = r, Jr.ContextProvider = s, Jr.Element = e, Jr.ForwardRef = f, Jr.Fragment = i, Jr.Lazy = _, Jr.Memo = g, Jr.Portal = t, Jr.Profiler = a, Jr.StrictMode = c, Jr.Suspense = h, Jr.isAsyncMode = function(A) {
    return T(A) || y(A) === l;
  }, Jr.isConcurrentMode = T, Jr.isContextConsumer = function(A) {
    return y(A) === r;
  }, Jr.isContextProvider = function(A) {
    return y(A) === s;
  }, Jr.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === e;
  }, Jr.isForwardRef = function(A) {
    return y(A) === f;
  }, Jr.isFragment = function(A) {
    return y(A) === i;
  }, Jr.isLazy = function(A) {
    return y(A) === _;
  }, Jr.isMemo = function(A) {
    return y(A) === g;
  }, Jr.isPortal = function(A) {
    return y(A) === t;
  }, Jr.isProfiler = function(A) {
    return y(A) === a;
  }, Jr.isStrictMode = function(A) {
    return y(A) === c;
  }, Jr.isSuspense = function(A) {
    return y(A) === h;
  }, Jr.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === i || A === d || A === a || A === c || A === h || A === p || typeof A == "object" && A !== null && (A.$$typeof === _ || A.$$typeof === g || A.$$typeof === s || A.$$typeof === r || A.$$typeof === f || A.$$typeof === v || A.$$typeof === E || A.$$typeof === C || A.$$typeof === b);
  }, Jr.typeOf = y, Jr;
}
var ei = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s4;
function QH() {
  return s4 || (s4 = 1, process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, i = n ? Symbol.for("react.fragment") : 60107, c = n ? Symbol.for("react.strict_mode") : 60108, a = n ? Symbol.for("react.profiler") : 60114, s = n ? Symbol.for("react.provider") : 60109, r = n ? Symbol.for("react.context") : 60110, l = n ? Symbol.for("react.async_mode") : 60111, d = n ? Symbol.for("react.concurrent_mode") : 60111, f = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, g = n ? Symbol.for("react.memo") : 60115, _ = n ? Symbol.for("react.lazy") : 60116, b = n ? Symbol.for("react.block") : 60121, v = n ? Symbol.for("react.fundamental") : 60117, E = n ? Symbol.for("react.responder") : 60118, C = n ? Symbol.for("react.scope") : 60119;
    function y(Ee) {
      return typeof Ee == "string" || typeof Ee == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ee === i || Ee === d || Ee === a || Ee === c || Ee === h || Ee === p || typeof Ee == "object" && Ee !== null && (Ee.$$typeof === _ || Ee.$$typeof === g || Ee.$$typeof === s || Ee.$$typeof === r || Ee.$$typeof === f || Ee.$$typeof === v || Ee.$$typeof === E || Ee.$$typeof === C || Ee.$$typeof === b);
    }
    function T(Ee) {
      if (typeof Ee == "object" && Ee !== null) {
        var we = Ee.$$typeof;
        switch (we) {
          case e:
            var ze = Ee.type;
            switch (ze) {
              case l:
              case d:
              case i:
              case a:
              case c:
              case h:
                return ze;
              default:
                var Ie = ze && ze.$$typeof;
                switch (Ie) {
                  case r:
                  case f:
                  case _:
                  case g:
                  case s:
                    return Ie;
                  default:
                    return we;
                }
            }
          case t:
            return we;
        }
      }
    }
    var A = l, k = d, N = r, j = s, I = e, B = f, U = i, H = _, Q = g, Y = t, ie = a, ce = c, $ = h, te = !1;
    function V(Ee) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(Ee) || T(Ee) === l;
    }
    function K(Ee) {
      return T(Ee) === d;
    }
    function ne(Ee) {
      return T(Ee) === r;
    }
    function J(Ee) {
      return T(Ee) === s;
    }
    function L(Ee) {
      return typeof Ee == "object" && Ee !== null && Ee.$$typeof === e;
    }
    function z(Ee) {
      return T(Ee) === f;
    }
    function ee(Ee) {
      return T(Ee) === i;
    }
    function q(Ee) {
      return T(Ee) === _;
    }
    function X(Ee) {
      return T(Ee) === g;
    }
    function oe(Ee) {
      return T(Ee) === t;
    }
    function ae(Ee) {
      return T(Ee) === a;
    }
    function _e(Ee) {
      return T(Ee) === c;
    }
    function ve(Ee) {
      return T(Ee) === h;
    }
    ei.AsyncMode = A, ei.ConcurrentMode = k, ei.ContextConsumer = N, ei.ContextProvider = j, ei.Element = I, ei.ForwardRef = B, ei.Fragment = U, ei.Lazy = H, ei.Memo = Q, ei.Portal = Y, ei.Profiler = ie, ei.StrictMode = ce, ei.Suspense = $, ei.isAsyncMode = V, ei.isConcurrentMode = K, ei.isContextConsumer = ne, ei.isContextProvider = J, ei.isElement = L, ei.isForwardRef = z, ei.isFragment = ee, ei.isLazy = q, ei.isMemo = X, ei.isPortal = oe, ei.isProfiler = ae, ei.isStrictMode = _e, ei.isSuspense = ve, ei.isValidElementType = y, ei.typeOf = T;
  }()), ei;
}
process.env.NODE_ENV === "production" ? Zw.exports = KH() : Zw.exports = QH();
var ZH = Zw.exports, Kx = ZH, JH = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, ez = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, tz = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, m7 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Qx = {};
Qx[Kx.ForwardRef] = tz;
Qx[Kx.Memo] = m7;
function l4(n) {
  return Kx.isMemo(n) ? m7 : Qx[n.$$typeof] || JH;
}
var nz = Object.defineProperty, rz = Object.getOwnPropertyNames, u4 = Object.getOwnPropertySymbols, iz = Object.getOwnPropertyDescriptor, oz = Object.getPrototypeOf, c4 = Object.prototype;
function g7(n, e, t) {
  if (typeof e != "string") {
    if (c4) {
      var i = oz(e);
      i && i !== c4 && g7(n, i, t);
    }
    var c = rz(e);
    u4 && (c = c.concat(u4(e)));
    for (var a = l4(n), s = l4(e), r = 0; r < c.length; ++r) {
      var l = c[r];
      if (!ez[l] && !(t && t[l]) && !(s && s[l]) && !(a && a[l])) {
        var d = iz(e, l);
        try {
          nz(n, l, d);
        } catch {
        }
      }
    }
  }
  return n;
}
var az = g7;
const sz = /* @__PURE__ */ c0(az);
function ai() {
  return ai = Object.assign || function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, ai.apply(this, arguments);
}
function _7(n, e) {
  n.prototype = Object.create(e.prototype), n.prototype.constructor = n, n.__proto__ = e;
}
function Uh(n, e) {
  if (n == null) return {};
  var t = {}, i = Object.keys(n), c, a;
  for (a = 0; a < i.length; a++)
    c = i[a], !(e.indexOf(c) >= 0) && (t[c] = n[c]);
  return t;
}
function d4(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
var T2 = /* @__PURE__ */ bf(void 0);
T2.displayName = "FormikContext";
var lz = T2.Provider, uz = T2.Consumer;
function gd() {
  var n = rc(T2);
  return n || (process.env.NODE_ENV !== "production" ? da(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : da()), n;
}
var f4 = function(e) {
  return Array.isArray(e) && e.length === 0;
}, Jo = function(e) {
  return typeof e == "function";
}, j1 = function(e) {
  return e !== null && typeof e == "object";
}, cz = function(e) {
  return String(Math.floor(Number(e))) === e;
}, sw = function(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}, Zx = function(e) {
  return Mx.count(e) === 0;
}, lw = function(e) {
  return j1(e) && Jo(e.then);
};
function dz(n) {
  if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u")
    return null;
  try {
    return n.activeElement || n.body;
  } catch {
    return n.body;
  }
}
function rr(n, e, t, i) {
  i === void 0 && (i = 0);
  for (var c = p7(e); n && i < c.length; )
    n = n[c[i++]];
  return i !== c.length && !n || n === void 0 ? t : n;
}
function cd(n, e, t) {
  for (var i = r4(n), c = i, a = 0, s = p7(e); a < s.length - 1; a++) {
    var r = s[a], l = rr(n, s.slice(0, a + 1));
    if (l && (j1(l) || Array.isArray(l)))
      c = c[r] = r4(l);
    else {
      var d = s[a + 1];
      c = c[r] = cz(d) && Number(d) >= 0 ? [] : {};
    }
  }
  return (a === 0 ? n : c)[s[a]] === t ? n : (t === void 0 ? delete c[s[a]] : c[s[a]] = t, a === 0 && t === void 0 && delete i[s[a]], i);
}
function y7(n, e, t, i) {
  t === void 0 && (t = /* @__PURE__ */ new WeakMap()), i === void 0 && (i = {});
  for (var c = 0, a = Object.keys(n); c < a.length; c++) {
    var s = a[c], r = n[s];
    j1(r) ? t.get(r) || (t.set(r, !0), i[s] = Array.isArray(r) ? [] : {}, y7(r, e, t, i[s])) : i[s] = e;
  }
  return i;
}
function fz(n, e) {
  switch (e.type) {
    case "SET_VALUES":
      return ai({}, n, {
        values: e.payload
      });
    case "SET_TOUCHED":
      return ai({}, n, {
        touched: e.payload
      });
    case "SET_ERRORS":
      return jh(n.errors, e.payload) ? n : ai({}, n, {
        errors: e.payload
      });
    case "SET_STATUS":
      return ai({}, n, {
        status: e.payload
      });
    case "SET_ISSUBMITTING":
      return ai({}, n, {
        isSubmitting: e.payload
      });
    case "SET_ISVALIDATING":
      return ai({}, n, {
        isValidating: e.payload
      });
    case "SET_FIELD_VALUE":
      return ai({}, n, {
        values: cd(n.values, e.payload.field, e.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return ai({}, n, {
        touched: cd(n.touched, e.payload.field, e.payload.value)
      });
    case "SET_FIELD_ERROR":
      return ai({}, n, {
        errors: cd(n.errors, e.payload.field, e.payload.value)
      });
    case "RESET_FORM":
      return ai({}, n, e.payload);
    case "SET_FORMIK_STATE":
      return e.payload(n);
    case "SUBMIT_ATTEMPT":
      return ai({}, n, {
        touched: y7(n.values, !0),
        isSubmitting: !0,
        submitCount: n.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return ai({}, n, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return ai({}, n, {
        isSubmitting: !1
      });
    default:
      return n;
  }
}
var Zp = {}, Kv = {};
function hz(n) {
  var e = n.validateOnChange, t = e === void 0 ? !0 : e, i = n.validateOnBlur, c = i === void 0 ? !0 : i, a = n.validateOnMount, s = a === void 0 ? !1 : a, r = n.isInitialValid, l = n.enableReinitialize, d = l === void 0 ? !1 : l, f = n.onSubmit, h = Uh(n, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), p = ai({
    validateOnChange: t,
    validateOnBlur: c,
    validateOnMount: s,
    onSubmit: f
  }, h), g = zn(p.initialValues), _ = zn(p.initialErrors || Zp), b = zn(p.initialTouched || Kv), v = zn(p.initialStatus), E = zn(!1), C = zn({});
  process.env.NODE_ENV !== "production" && An(function() {
    typeof r > "u" || (process.env.NODE_ENV !== "production" ? da(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : da());
  }, []), An(function() {
    return E.current = !0, function() {
      E.current = !1;
    };
  }, []);
  var y = Wn(0), T = y[1], A = zn({
    values: t1(p.initialValues),
    errors: t1(p.initialErrors) || Zp,
    touched: t1(p.initialTouched) || Kv,
    status: t1(p.initialStatus),
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), k = A.current, N = hr(function(ke) {
    var pe = A.current;
    A.current = fz(pe, ke), pe !== A.current && T(function(Se) {
      return Se + 1;
    });
  }, []), j = hr(function(ke, pe) {
    return new Promise(function(Se, he) {
      var Te = p.validate(ke, pe);
      Te == null ? Se(Zp) : lw(Te) ? Te.then(function(Me) {
        Se(Me || Zp);
      }, function(Me) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", Me), he(Me);
      }) : Se(Te);
    });
  }, [p.validate]), I = hr(function(ke, pe) {
    var Se = p.validationSchema, he = Jo(Se) ? Se(pe) : Se, Te = pe && he.validateAt ? he.validateAt(pe, ke) : mz(ke, he);
    return new Promise(function(Me, Ye) {
      Te.then(function() {
        Me(Zp);
      }, function(et) {
        et.name === "ValidationError" ? Me(pz(et)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", et), Ye(et));
      });
    });
  }, [p.validationSchema]), B = hr(function(ke, pe) {
    return new Promise(function(Se) {
      return Se(C.current[ke].validate(pe));
    });
  }, []), U = hr(function(ke) {
    var pe = Object.keys(C.current).filter(function(he) {
      return Jo(C.current[he].validate);
    }), Se = pe.length > 0 ? pe.map(function(he) {
      return B(he, rr(ke, he));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(Se).then(function(he) {
      return he.reduce(function(Te, Me, Ye) {
        return Me === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || Me && (Te = cd(Te, pe[Ye], Me)), Te;
      }, {});
    });
  }, [B]), H = hr(function(ke) {
    return Promise.all([U(ke), p.validationSchema ? I(ke) : {}, p.validate ? j(ke) : {}]).then(function(pe) {
      var Se = pe[0], he = pe[1], Te = pe[2], Me = Ww.all([Se, he, Te], {
        arrayMerge: gz
      });
      return Me;
    });
  }, [p.validate, p.validationSchema, U, j, I]), Q = tu(function(ke) {
    return ke === void 0 && (ke = k.values), N({
      type: "SET_ISVALIDATING",
      payload: !0
    }), H(ke).then(function(pe) {
      return E.current && (N({
        type: "SET_ISVALIDATING",
        payload: !1
      }), N({
        type: "SET_ERRORS",
        payload: pe
      })), pe;
    });
  });
  An(function() {
    s && E.current === !0 && jh(g.current, p.initialValues) && Q(g.current);
  }, [s, Q]);
  var Y = hr(function(ke) {
    var pe = ke && ke.values ? ke.values : g.current, Se = ke && ke.errors ? ke.errors : _.current ? _.current : p.initialErrors || {}, he = ke && ke.touched ? ke.touched : b.current ? b.current : p.initialTouched || {}, Te = ke && ke.status ? ke.status : v.current ? v.current : p.initialStatus;
    g.current = pe, _.current = Se, b.current = he, v.current = Te;
    var Me = function() {
      N({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!ke && !!ke.isSubmitting,
          errors: Se,
          touched: he,
          status: Te,
          values: pe,
          isValidating: !!ke && !!ke.isValidating,
          submitCount: ke && ke.submitCount && typeof ke.submitCount == "number" ? ke.submitCount : 0
        }
      });
    };
    if (p.onReset) {
      var Ye = p.onReset(k.values, we);
      lw(Ye) ? Ye.then(Me) : Me();
    } else
      Me();
  }, [p.initialErrors, p.initialStatus, p.initialTouched, p.onReset]);
  An(function() {
    E.current === !0 && !jh(g.current, p.initialValues) && d && (g.current = p.initialValues, Y(), s && Q(g.current));
  }, [d, p.initialValues, Y, s, Q]), An(function() {
    d && E.current === !0 && !jh(_.current, p.initialErrors) && (_.current = p.initialErrors || Zp, N({
      type: "SET_ERRORS",
      payload: p.initialErrors || Zp
    }));
  }, [d, p.initialErrors]), An(function() {
    d && E.current === !0 && !jh(b.current, p.initialTouched) && (b.current = p.initialTouched || Kv, N({
      type: "SET_TOUCHED",
      payload: p.initialTouched || Kv
    }));
  }, [d, p.initialTouched]), An(function() {
    d && E.current === !0 && !jh(v.current, p.initialStatus) && (v.current = p.initialStatus, N({
      type: "SET_STATUS",
      payload: p.initialStatus
    }));
  }, [d, p.initialStatus, p.initialTouched]);
  var ie = tu(function(ke) {
    if (C.current[ke] && Jo(C.current[ke].validate)) {
      var pe = rr(k.values, ke), Se = C.current[ke].validate(pe);
      return lw(Se) ? (N({
        type: "SET_ISVALIDATING",
        payload: !0
      }), Se.then(function(he) {
        return he;
      }).then(function(he) {
        N({
          type: "SET_FIELD_ERROR",
          payload: {
            field: ke,
            value: he
          }
        }), N({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (N({
        type: "SET_FIELD_ERROR",
        payload: {
          field: ke,
          value: Se
        }
      }), Promise.resolve(Se));
    } else if (p.validationSchema)
      return N({
        type: "SET_ISVALIDATING",
        payload: !0
      }), I(k.values, ke).then(function(he) {
        return he;
      }).then(function(he) {
        N({
          type: "SET_FIELD_ERROR",
          payload: {
            field: ke,
            value: rr(he, ke)
          }
        }), N({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), ce = hr(function(ke, pe) {
    var Se = pe.validate;
    C.current[ke] = {
      validate: Se
    };
  }, []), $ = hr(function(ke) {
    delete C.current[ke];
  }, []), te = tu(function(ke, pe) {
    N({
      type: "SET_TOUCHED",
      payload: ke
    });
    var Se = pe === void 0 ? c : pe;
    return Se ? Q(k.values) : Promise.resolve();
  }), V = hr(function(ke) {
    N({
      type: "SET_ERRORS",
      payload: ke
    });
  }, []), K = tu(function(ke, pe) {
    var Se = Jo(ke) ? ke(k.values) : ke;
    N({
      type: "SET_VALUES",
      payload: Se
    });
    var he = pe === void 0 ? t : pe;
    return he ? Q(Se) : Promise.resolve();
  }), ne = hr(function(ke, pe) {
    N({
      type: "SET_FIELD_ERROR",
      payload: {
        field: ke,
        value: pe
      }
    });
  }, []), J = tu(function(ke, pe, Se) {
    N({
      type: "SET_FIELD_VALUE",
      payload: {
        field: ke,
        value: pe
      }
    });
    var he = Se === void 0 ? t : Se;
    return he ? Q(cd(k.values, ke, pe)) : Promise.resolve();
  }), L = hr(function(ke, pe) {
    var Se = pe, he = ke, Te;
    if (!sw(ke)) {
      ke.persist && ke.persist();
      var Me = ke.target ? ke.target : ke.currentTarget, Ye = Me.type, et = Me.name, dt = Me.id, We = Me.value, nt = Me.checked, ft = Me.outerHTML, At = Me.options, ln = Me.multiple;
      Se = pe || et || dt, !Se && process.env.NODE_ENV !== "production" && h4({
        htmlContent: ft,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), he = /number|range/.test(Ye) ? (Te = parseFloat(We), isNaN(Te) ? "" : Te) : /checkbox/.test(Ye) ? yz(rr(k.values, Se), nt, We) : At && ln ? _z(At) : We;
    }
    Se && J(Se, he);
  }, [J, k.values]), z = tu(function(ke) {
    if (sw(ke))
      return function(pe) {
        return L(pe, ke);
      };
    L(ke);
  }), ee = tu(function(ke, pe, Se) {
    pe === void 0 && (pe = !0), N({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: ke,
        value: pe
      }
    });
    var he = Se === void 0 ? c : Se;
    return he ? Q(k.values) : Promise.resolve();
  }), q = hr(function(ke, pe) {
    ke.persist && ke.persist();
    var Se = ke.target, he = Se.name, Te = Se.id, Me = Se.outerHTML, Ye = pe || he || Te;
    !Ye && process.env.NODE_ENV !== "production" && h4({
      htmlContent: Me,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), ee(Ye, !0);
  }, [ee]), X = tu(function(ke) {
    if (sw(ke))
      return function(pe) {
        return q(pe, ke);
      };
    q(ke);
  }), oe = hr(function(ke) {
    Jo(ke) ? N({
      type: "SET_FORMIK_STATE",
      payload: ke
    }) : N({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return ke;
      }
    });
  }, []), ae = hr(function(ke) {
    N({
      type: "SET_STATUS",
      payload: ke
    });
  }, []), _e = hr(function(ke) {
    N({
      type: "SET_ISSUBMITTING",
      payload: ke
    });
  }, []), ve = tu(function() {
    return N({
      type: "SUBMIT_ATTEMPT"
    }), Q().then(function(ke) {
      var pe = ke instanceof Error, Se = !pe && Object.keys(ke).length === 0;
      if (Se) {
        var he;
        try {
          if (he = ze(), he === void 0)
            return;
        } catch (Te) {
          throw Te;
        }
        return Promise.resolve(he).then(function(Te) {
          return E.current && N({
            type: "SUBMIT_SUCCESS"
          }), Te;
        }).catch(function(Te) {
          if (E.current)
            throw N({
              type: "SUBMIT_FAILURE"
            }), Te;
        });
      } else if (E.current && (N({
        type: "SUBMIT_FAILURE"
      }), pe))
        throw ke;
    });
  }), Ee = tu(function(ke) {
    if (ke && ke.preventDefault && Jo(ke.preventDefault) && ke.preventDefault(), ke && ke.stopPropagation && Jo(ke.stopPropagation) && ke.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var pe = dz();
      pe !== null && pe instanceof HTMLButtonElement && (pe.attributes && pe.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? da(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : da()));
    }
    ve().catch(function(Se) {
      console.warn("Warning: An unhandled error was caught from submitForm()", Se);
    });
  }), we = {
    resetForm: Y,
    validateForm: Q,
    validateField: ie,
    setErrors: V,
    setFieldError: ne,
    setFieldTouched: ee,
    setFieldValue: J,
    setStatus: ae,
    setSubmitting: _e,
    setTouched: te,
    setValues: K,
    setFormikState: oe,
    submitForm: ve
  }, ze = tu(function() {
    return f(k.values, we);
  }), Ie = tu(function(ke) {
    ke && ke.preventDefault && Jo(ke.preventDefault) && ke.preventDefault(), ke && ke.stopPropagation && Jo(ke.stopPropagation) && ke.stopPropagation(), Y();
  }), je = hr(function(ke) {
    return {
      value: rr(k.values, ke),
      error: rr(k.errors, ke),
      touched: !!rr(k.touched, ke),
      initialValue: rr(g.current, ke),
      initialTouched: !!rr(b.current, ke),
      initialError: rr(_.current, ke)
    };
  }, [k.errors, k.touched, k.values]), qe = hr(function(ke) {
    return {
      setValue: function(Se, he) {
        return J(ke, Se, he);
      },
      setTouched: function(Se, he) {
        return ee(ke, Se, he);
      },
      setError: function(Se) {
        return ne(ke, Se);
      }
    };
  }, [J, ee, ne]), Ge = hr(function(ke) {
    var pe = j1(ke), Se = pe ? ke.name : ke, he = rr(k.values, Se), Te = {
      name: Se,
      value: he,
      onChange: z,
      onBlur: X
    };
    if (pe) {
      var Me = ke.type, Ye = ke.value, et = ke.as, dt = ke.multiple;
      Me === "checkbox" ? Ye === void 0 ? Te.checked = !!he : (Te.checked = !!(Array.isArray(he) && ~he.indexOf(Ye)), Te.value = Ye) : Me === "radio" ? (Te.checked = he === Ye, Te.value = Ye) : et === "select" && dt && (Te.value = Te.value || [], Te.multiple = !0);
    }
    return Te;
  }, [X, z, k.values]), Ze = li(function() {
    return !jh(g.current, k.values);
  }, [g.current, k.values]), tt = li(function() {
    return typeof r < "u" ? Ze ? k.errors && Object.keys(k.errors).length === 0 : r !== !1 && Jo(r) ? r(p) : r : k.errors && Object.keys(k.errors).length === 0;
  }, [r, Ze, k.errors, p]), Qe = ai({}, k, {
    initialValues: g.current,
    initialErrors: _.current,
    initialTouched: b.current,
    initialStatus: v.current,
    handleBlur: X,
    handleChange: z,
    handleReset: Ie,
    handleSubmit: Ee,
    resetForm: Y,
    setErrors: V,
    setFormikState: oe,
    setFieldTouched: ee,
    setFieldValue: J,
    setFieldError: ne,
    setStatus: ae,
    setSubmitting: _e,
    setTouched: te,
    setValues: K,
    submitForm: ve,
    validateForm: Q,
    validateField: ie,
    isValid: tt,
    dirty: Ze,
    unregisterField: $,
    registerField: ce,
    getFieldProps: Ge,
    getFieldMeta: je,
    getFieldHelpers: qe,
    validateOnBlur: c,
    validateOnChange: t,
    validateOnMount: s
  });
  return Qe;
}
function roe(n) {
  var e = hz(n), t = n.component, i = n.children, c = n.render, a = n.innerRef;
  return Lx(a, function() {
    return e;
  }), process.env.NODE_ENV !== "production" && An(function() {
    n.render && (process.env.NODE_ENV !== "production" ? da(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : da());
  }, []), su(lz, {
    value: e
  }, t ? su(t, e) : c ? c(e) : i ? Jo(i) ? i(e) : Zx(i) ? null : Mx.only(i) : null);
}
function h4(n) {
  var e = n.htmlContent, t = n.documentationAnchorLink, i = n.handlerName;
  console.warn("Warning: Formik called `" + i + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + e + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + t + `
  `);
}
function pz(n) {
  var e = {};
  if (n.inner) {
    if (n.inner.length === 0)
      return cd(e, n.path, n.message);
    for (var c = n.inner, t = Array.isArray(c), i = 0, c = t ? c : c[Symbol.iterator](); ; ) {
      var a;
      if (t) {
        if (i >= c.length) break;
        a = c[i++];
      } else {
        if (i = c.next(), i.done) break;
        a = i.value;
      }
      var s = a;
      rr(e, s.path) || (e = cd(e, s.path, s.message));
    }
  }
  return e;
}
function mz(n, e, t, i) {
  t === void 0 && (t = !1);
  var c = Jw(n);
  return e[t ? "validateSync" : "validate"](c, {
    abortEarly: !1,
    context: c
  });
}
function Jw(n) {
  var e = Array.isArray(n) ? [] : {};
  for (var t in n)
    if (Object.prototype.hasOwnProperty.call(n, t)) {
      var i = String(t);
      Array.isArray(n[i]) === !0 ? e[i] = n[i].map(function(c) {
        return Array.isArray(c) === !0 || I3(c) ? Jw(c) : c !== "" ? c : void 0;
      }) : I3(n[i]) ? e[i] = Jw(n[i]) : e[i] = n[i] !== "" ? n[i] : void 0;
    }
  return e;
}
function gz(n, e, t) {
  var i = n.slice();
  return e.forEach(function(a, s) {
    if (typeof i[s] > "u") {
      var r = t.clone !== !1, l = r && t.isMergeableObject(a);
      i[s] = l ? Ww(Array.isArray(a) ? [] : {}, a, t) : a;
    } else t.isMergeableObject(a) ? i[s] = Ww(n[s], a, t) : n.indexOf(a) === -1 && i.push(a);
  }), i;
}
function _z(n) {
  return Array.from(n).filter(function(e) {
    return e.selected;
  }).map(function(e) {
    return e.value;
  });
}
function yz(n, e, t) {
  if (typeof n == "boolean")
    return !!e;
  var i = [], c = !1, a = -1;
  if (Array.isArray(n))
    i = n, a = n.indexOf(t), c = a >= 0;
  else if (!t || t == "true" || t == "false")
    return !!e;
  return e && t && !c ? i.concat(t) : c ? i.slice(0, a).concat(i.slice(a + 1)) : i;
}
var vz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? L6 : An;
function tu(n) {
  var e = zn(n);
  return vz(function() {
    e.current = n;
  }), hr(function() {
    for (var t = arguments.length, i = new Array(t), c = 0; c < t; c++)
      i[c] = arguments[c];
    return e.current.apply(void 0, i);
  }, []);
}
function Dm(n) {
  var e = n.validate, t = n.name, i = n.render, c = n.children, a = n.as, s = n.component, r = n.className, l = Uh(n, ["validate", "name", "render", "children", "as", "component", "className"]), d = gd(), f = Uh(d, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && An(function() {
    i && (process.env.NODE_ENV !== "production" ? da(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + t + '" render={({field, form}) => ...} /> with <Field name="' + t + '">{({field, form, meta}) => ...}</Field>') : da()), a && c && Jo(c) && (process.env.NODE_ENV !== "production" ? da(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : da()), s && c && Jo(c) && (process.env.NODE_ENV !== "production" ? da(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : da()), i && c && !Zx(c) && (process.env.NODE_ENV !== "production" ? da(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : da());
  }, []);
  var h = f.registerField, p = f.unregisterField;
  An(function() {
    return h(t, {
      validate: e
    }), function() {
      p(t);
    };
  }, [h, p, t, e]);
  var g = f.getFieldProps(ai({
    name: t
  }, l)), _ = f.getFieldMeta(t), b = {
    field: g,
    form: f
  };
  if (i)
    return i(ai({}, b, {
      meta: _
    }));
  if (Jo(c))
    return c(ai({}, b, {
      meta: _
    }));
  if (s) {
    if (typeof s == "string") {
      var v = l.innerRef, E = Uh(l, ["innerRef"]);
      return su(s, ai({
        ref: v
      }, g, E, {
        className: r
      }), c);
    }
    return su(s, ai({
      field: g,
      form: f
    }, l, {
      className: r
    }), c);
  }
  var C = a || "input";
  if (typeof C == "string") {
    var y = l.innerRef, T = Uh(l, ["innerRef"]);
    return su(C, ai({
      ref: y
    }, g, T, {
      className: r
    }), c);
  }
  return su(C, ai({}, g, l, {
    className: r
  }), c);
}
var bz = /* @__PURE__ */ Ef(function(n, e) {
  var t = n.action, i = Uh(n, ["action"]), c = t ?? "#", a = gd(), s = a.handleReset, r = a.handleSubmit;
  return su("form", ai({
    onSubmit: r,
    ref: e,
    onReset: s,
    action: c
  }, i));
});
bz.displayName = "Form";
function v7(n) {
  var e = function(c) {
    return su(uz, null, function(a) {
      return a || (process.env.NODE_ENV !== "production" ? da(!1, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + n.name) : da()), su(n, ai({}, c, {
        formik: a
      }));
    });
  }, t = n.displayName || n.name || n.constructor && n.constructor.name || "Component";
  return e.WrappedComponent = n, e.displayName = "FormikConnect(" + t + ")", sz(
    e,
    n
    // cast type to ComponentClass (even if SFC)
  );
}
var Ez = function(e, t, i) {
  var c = Em(e), a = c[t];
  return c.splice(t, 1), c.splice(i, 0, a), c;
}, Sz = function(e, t, i) {
  var c = Em(e), a = c[t];
  return c[t] = c[i], c[i] = a, c;
}, uw = function(e, t, i) {
  var c = Em(e);
  return c.splice(t, 0, i), c;
}, Cz = function(e, t, i) {
  var c = Em(e);
  return c[t] = i, c;
}, Em = function(e) {
  if (e) {
    if (Array.isArray(e))
      return [].concat(e);
    var t = Object.keys(e).map(function(i) {
      return parseInt(i);
    }).reduce(function(i, c) {
      return c > i ? c : i;
    }, 0);
    return Array.from(ai({}, e, {
      length: t + 1
    }));
  } else return [];
}, p4 = function(e, t) {
  var i = typeof e == "function" ? e : t;
  return function(c) {
    if (Array.isArray(c) || j1(c)) {
      var a = Em(c);
      return i(a);
    }
    return c;
  };
}, b7 = /* @__PURE__ */ function(n) {
  _7(e, n);
  function e(i) {
    var c;
    return c = n.call(this, i) || this, c.updateArrayField = function(a, s, r) {
      var l = c.props, d = l.name, f = l.formik.setFormikState;
      f(function(h) {
        var p = p4(r, a), g = p4(s, a), _ = cd(h.values, d, a(rr(h.values, d))), b = r ? p(rr(h.errors, d)) : void 0, v = s ? g(rr(h.touched, d)) : void 0;
        return f4(b) && (b = void 0), f4(v) && (v = void 0), ai({}, h, {
          values: _,
          errors: r ? cd(h.errors, d, b) : h.errors,
          touched: s ? cd(h.touched, d, v) : h.touched
        });
      });
    }, c.push = function(a) {
      return c.updateArrayField(function(s) {
        return [].concat(Em(s), [t1(a)]);
      }, !1, !1);
    }, c.handlePush = function(a) {
      return function() {
        return c.push(a);
      };
    }, c.swap = function(a, s) {
      return c.updateArrayField(function(r) {
        return Sz(r, a, s);
      }, !0, !0);
    }, c.handleSwap = function(a, s) {
      return function() {
        return c.swap(a, s);
      };
    }, c.move = function(a, s) {
      return c.updateArrayField(function(r) {
        return Ez(r, a, s);
      }, !0, !0);
    }, c.handleMove = function(a, s) {
      return function() {
        return c.move(a, s);
      };
    }, c.insert = function(a, s) {
      return c.updateArrayField(function(r) {
        return uw(r, a, s);
      }, function(r) {
        return uw(r, a, null);
      }, function(r) {
        return uw(r, a, null);
      });
    }, c.handleInsert = function(a, s) {
      return function() {
        return c.insert(a, s);
      };
    }, c.replace = function(a, s) {
      return c.updateArrayField(function(r) {
        return Cz(r, a, s);
      }, !1, !1);
    }, c.handleReplace = function(a, s) {
      return function() {
        return c.replace(a, s);
      };
    }, c.unshift = function(a) {
      var s = -1;
      return c.updateArrayField(function(r) {
        var l = r ? [a].concat(r) : [a];
        return s = l.length, l;
      }, function(r) {
        return r ? [null].concat(r) : [null];
      }, function(r) {
        return r ? [null].concat(r) : [null];
      }), s;
    }, c.handleUnshift = function(a) {
      return function() {
        return c.unshift(a);
      };
    }, c.handleRemove = function(a) {
      return function() {
        return c.remove(a);
      };
    }, c.handlePop = function() {
      return function() {
        return c.pop();
      };
    }, c.remove = c.remove.bind(d4(c)), c.pop = c.pop.bind(d4(c)), c;
  }
  var t = e.prototype;
  return t.componentDidUpdate = function(c) {
    this.props.validateOnChange && this.props.formik.validateOnChange && !jh(rr(c.formik.values, c.name), rr(this.props.formik.values, this.props.name)) && this.props.formik.validateForm(this.props.formik.values);
  }, t.remove = function(c) {
    var a;
    return this.updateArrayField(
      // so this gets call 3 times
      function(s) {
        var r = s ? Em(s) : [];
        return a || (a = r[c]), Jo(r.splice) && r.splice(c, 1), Jo(r.every) && r.every(function(l) {
          return l === void 0;
        }) ? [] : r;
      },
      !0,
      !0
    ), a;
  }, t.pop = function() {
    var c;
    return this.updateArrayField(
      // so this gets call 3 times
      function(a) {
        var s = a.slice();
        return c || (c = s && s.pop && s.pop()), s;
      },
      !0,
      !0
    ), c;
  }, t.render = function() {
    var c = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    }, a = this.props, s = a.component, r = a.render, l = a.children, d = a.name, f = a.formik, h = Uh(f, ["validate", "validationSchema"]), p = ai({}, c, {
      form: h,
      name: d
    });
    return s ? su(s, p) : r ? r(p) : l ? typeof l == "function" ? l(p) : Zx(l) ? null : Mx.only(l) : null;
  }, e;
}(M6);
b7.defaultProps = {
  validateOnChange: !0
};
var ioe = /* @__PURE__ */ v7(b7), wz = /* @__PURE__ */ function(n) {
  _7(e, n);
  function e() {
    return n.apply(this, arguments) || this;
  }
  var t = e.prototype;
  return t.shouldComponentUpdate = function(c) {
    return rr(this.props.formik.errors, this.props.name) !== rr(c.formik.errors, this.props.name) || rr(this.props.formik.touched, this.props.name) !== rr(c.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(c).length;
  }, t.render = function() {
    var c = this.props, a = c.component, s = c.formik, r = c.render, l = c.children, d = c.name, f = Uh(c, ["component", "formik", "render", "children", "name"]), h = rr(s.touched, d), p = rr(s.errors, d);
    return h && p ? r ? Jo(r) ? r(p) : null : l ? Jo(l) ? l(p) : null : a ? su(a, f, p) : p : null;
  }, e;
}(M6), xz = /* @__PURE__ */ v7(wz);
const Tz = "_checkbox_1o8ar_1", Az = "_checkmarkWrapper_1o8ar_8", kz = "_checkmark_1o8ar_8", Oz = "_checkBox__content_1o8ar_49", Dz = "_checkBox__label_1o8ar_55", Rz = "_checkBox__description_1o8ar_63", Ju = {
  checkbox: Tz,
  checkmarkWrapper: Az,
  checkmark: kz,
  checkBox__content: Oz,
  checkBox__label: Dz,
  checkBox__description: Rz,
  "checkbox--flip": "_checkbox--flip_1o8ar_70",
  "checkbox--block": "_checkbox--block_1o8ar_81"
}, E7 = Mn.bind(Ju), ooe = (n) => {
  const {
    name: e,
    label: t,
    description: i,
    disabled: c,
    block: a,
    flip: s = !1,
    value: r
  } = n, l = E7("checkbox", {
    "checkbox--block": a,
    "checkbox--flip": s
  });
  return /* @__PURE__ */ Mt("div", { className: l, children: [
    /* @__PURE__ */ Mt("div", { className: Ju.checkmarkWrapper, children: [
      /* @__PURE__ */ Re(
        Dm,
        {
          type: "checkbox",
          name: e,
          disabled: c,
          value: r,
          id: e
        }
      ),
      /* @__PURE__ */ Re("span", { className: Ju.checkmark, children: /* @__PURE__ */ Re(Nx, {}) })
    ] }),
    /* @__PURE__ */ Mt("div", { className: Ju.checkBox__content, children: [
      /* @__PURE__ */ Re(
        "label",
        {
          className: Ju.checkBox__label,
          htmlFor: e,
          dangerouslySetInnerHTML: { __html: t ?? "" }
        }
      ),
      i && /* @__PURE__ */ Re(
        "p",
        {
          className: Ju.checkBox__description,
          dangerouslySetInnerHTML: { __html: i ?? "" }
        }
      )
    ] })
  ] });
}, aoe = (n) => {
  const {
    name: e,
    checked: t,
    onChange: i,
    disabled: c,
    label: a,
    description: s,
    block: r,
    flip: l = !1
  } = n, d = () => i(!t), f = E7("checkbox", {
    "checkbox--block": r,
    "checkbox--flip": l
  });
  return /* @__PURE__ */ Mt("div", { className: f, children: [
    /* @__PURE__ */ Mt("div", { className: Ju.checkmarkWrapper, children: [
      /* @__PURE__ */ Re(
        "input",
        {
          type: "checkbox",
          checked: t,
          id: e,
          onChange: d,
          disabled: c
        }
      ),
      /* @__PURE__ */ Re("span", { className: Ju.checkmark, children: /* @__PURE__ */ Re(Nx, {}) })
    ] }),
    /* @__PURE__ */ Mt("div", { className: Ju.checkBox__content, children: [
      /* @__PURE__ */ Re(
        "label",
        {
          className: Ju.checkBox__label,
          htmlFor: e,
          dangerouslySetInnerHTML: { __html: a ?? "" }
        }
      ),
      s && /* @__PURE__ */ Re(
        "p",
        {
          className: Ju.checkBox__description,
          dangerouslySetInnerHTML: { __html: s ?? "" }
        }
      )
    ] })
  ] });
}, Nz = "_container_zj9w0_1", Iz = {
  container: Nz
}, Lz = ({ children: n }) => /* @__PURE__ */ Re("div", { className: Iz.container, children: n });
var Jx = {}, Yb = function() {
  return Yb = Object.assign || function(n) {
    for (var e, t = 1, i = arguments.length; t < i; t++) for (var c in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, c) && (n[c] = e[c]);
    return n;
  }, Yb.apply(this, arguments);
}, Mz = function() {
  function n(e, t, i) {
    var c = this;
    this.endVal = t, this.options = i, this.version = "2.8.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: !0, useGrouping: !0, useIndianSeparators: !1, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", enableScrollSpy: !1, scrollSpyDelay: 200, scrollSpyOnce: !1 }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(a) {
      c.startTime || (c.startTime = a);
      var s = a - c.startTime;
      c.remaining = c.duration - s, c.useEasing ? c.countDown ? c.frameVal = c.startVal - c.easingFn(s, 0, c.startVal - c.endVal, c.duration) : c.frameVal = c.easingFn(s, c.startVal, c.endVal - c.startVal, c.duration) : c.frameVal = c.startVal + (c.endVal - c.startVal) * (s / c.duration);
      var r = c.countDown ? c.frameVal < c.endVal : c.frameVal > c.endVal;
      c.frameVal = r ? c.endVal : c.frameVal, c.frameVal = Number(c.frameVal.toFixed(c.options.decimalPlaces)), c.printValue(c.frameVal), s < c.duration ? c.rAF = requestAnimationFrame(c.count) : c.finalEndVal !== null ? c.update(c.finalEndVal) : c.options.onCompleteCallback && c.options.onCompleteCallback();
    }, this.formatNumber = function(a) {
      var s, r, l, d, f = a < 0 ? "-" : "";
      s = Math.abs(a).toFixed(c.options.decimalPlaces);
      var h = (s += "").split(".");
      if (r = h[0], l = h.length > 1 ? c.options.decimal + h[1] : "", c.options.useGrouping) {
        d = "";
        for (var p = 3, g = 0, _ = 0, b = r.length; _ < b; ++_) c.options.useIndianSeparators && _ === 4 && (p = 2, g = 1), _ !== 0 && g % p == 0 && (d = c.options.separator + d), g++, d = r[b - _ - 1] + d;
        r = d;
      }
      return c.options.numerals && c.options.numerals.length && (r = r.replace(/[0-9]/g, function(v) {
        return c.options.numerals[+v];
      }), l = l.replace(/[0-9]/g, function(v) {
        return c.options.numerals[+v];
      })), f + c.options.prefix + r + l + c.options.suffix;
    }, this.easeOutExpo = function(a, s, r, l) {
      return r * (1 - Math.pow(2, -10 * a / l)) * 1024 / 1023 + s;
    }, this.options = Yb(Yb({}, this.defaults), i), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(t), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof e == "string" ? document.getElementById(e) : e, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, e) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
      return c.handleScroll(c);
    }), window.onscroll = function() {
      window.onScrollFns.forEach(function(a) {
        return a();
      });
    }, this.handleScroll(this)));
  }
  return n.prototype.handleScroll = function(e) {
    if (e && window && !e.once) {
      var t = window.innerHeight + window.scrollY, i = e.el.getBoundingClientRect(), c = i.top + window.pageYOffset, a = i.top + i.height + window.pageYOffset;
      a < t && a > window.scrollY && e.paused ? (e.paused = !1, setTimeout(function() {
        return e.start();
      }, e.options.scrollSpyDelay), e.options.scrollSpyOnce && (e.once = !0)) : (window.scrollY > a || c > t) && !e.paused && e.reset();
    }
  }, n.prototype.determineDirectionAndSmartEasing = function() {
    var e = this.finalEndVal ? this.finalEndVal : this.endVal;
    this.countDown = this.startVal > e;
    var t = e - this.startVal;
    if (Math.abs(t) > this.options.smartEasingThreshold && this.options.useEasing) {
      this.finalEndVal = e;
      var i = this.countDown ? 1 : -1;
      this.endVal = e + i * this.options.smartEasingAmount, this.duration = this.duration / 2;
    } else this.endVal = e, this.finalEndVal = null;
    this.finalEndVal !== null ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
  }, n.prototype.start = function(e) {
    this.error || (this.options.onStartCallback && this.options.onStartCallback(), e && (this.options.onCompleteCallback = e), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
  }, n.prototype.pauseResume = function() {
    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
  }, n.prototype.reset = function() {
    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
  }, n.prototype.update = function(e) {
    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(e), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
  }, n.prototype.printValue = function(e) {
    var t;
    if (this.el) {
      var i = this.formattingFn(e);
      !((t = this.options.plugin) === null || t === void 0) && t.render ? this.options.plugin.render(this.el, i) : this.el.tagName === "INPUT" ? this.el.value = i : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = i : this.el.innerHTML = i;
    }
  }, n.prototype.ensureNumber = function(e) {
    return typeof e == "number" && !isNaN(e);
  }, n.prototype.validateValue = function(e) {
    var t = Number(e);
    return this.ensureNumber(t) ? t : (this.error = "[CountUp] invalid start or end value: ".concat(e), null);
  }, n.prototype.resetDuration = function() {
    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
  }, n;
}();
const Pz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CountUp: Mz
}, Symbol.toStringTag, { value: "Module" })), jz = /* @__PURE__ */ yP(Pz);
Object.defineProperty(Jx, "__esModule", { value: !0 });
var fa = si, Bz = jz;
function Fz(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var i, c, a, s, r = [], l = !0, d = !1;
    try {
      if (a = (t = t.call(n)).next, e !== 0) for (; !(l = (i = a.call(t)).done) && (r.push(i.value), r.length !== e); l = !0) ;
    } catch (f) {
      d = !0, c = f;
    } finally {
      try {
        if (!l && t.return != null && (s = t.return(), Object(s) !== s)) return;
      } finally {
        if (d) throw c;
      }
    }
    return r;
  }
}
function m4(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);
    e && (i = i.filter(function(c) {
      return Object.getOwnPropertyDescriptor(n, c).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Xb(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? m4(Object(t), !0).forEach(function(i) {
      zz(n, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : m4(Object(t)).forEach(function(i) {
      Object.defineProperty(n, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return n;
}
function Uz(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(n, e || "default");
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Hz(n) {
  var e = Uz(n, "string");
  return typeof e == "symbol" ? e : String(e);
}
function zz(n, e, t) {
  return e = Hz(e), e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function ex() {
  return ex = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, ex.apply(this, arguments);
}
function Vz(n, e) {
  if (n == null) return {};
  var t = {}, i = Object.keys(n), c, a;
  for (a = 0; a < i.length; a++)
    c = i[a], !(e.indexOf(c) >= 0) && (t[c] = n[c]);
  return t;
}
function S7(n, e) {
  if (n == null) return {};
  var t = Vz(n, e), i, c;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (c = 0; c < a.length; c++)
      i = a[c], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(n, i) && (t[i] = n[i]);
  }
  return t;
}
function qz(n, e) {
  return Gz(n) || Fz(n, e) || Wz(n, e) || $z();
}
function Gz(n) {
  if (Array.isArray(n)) return n;
}
function Wz(n, e) {
  if (n) {
    if (typeof n == "string") return g4(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return g4(n, e);
  }
}
function g4(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, i = new Array(e); t < e; t++) i[t] = n[t];
  return i;
}
function $z() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Yz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? fa.useLayoutEffect : fa.useEffect;
function Ku(n) {
  var e = fa.useRef(n);
  return Yz(function() {
    e.current = n;
  }), fa.useCallback(function() {
    for (var t = arguments.length, i = new Array(t), c = 0; c < t; c++)
      i[c] = arguments[c];
    return e.current.apply(void 0, i);
  }, []);
}
var Xz = function(e, t) {
  var i = t.decimal, c = t.decimals, a = t.duration, s = t.easingFn, r = t.end, l = t.formattingFn, d = t.numerals, f = t.prefix, h = t.separator, p = t.start, g = t.suffix, _ = t.useEasing, b = t.useGrouping, v = t.useIndianSeparators, E = t.enableScrollSpy, C = t.scrollSpyDelay, y = t.scrollSpyOnce, T = t.plugin;
  return new Bz.CountUp(e, r, {
    startVal: p,
    duration: a,
    decimal: i,
    decimalPlaces: c,
    easingFn: s,
    formattingFn: l,
    numerals: d,
    separator: h,
    prefix: f,
    suffix: g,
    plugin: T,
    useEasing: _,
    useIndianSeparators: v,
    useGrouping: b,
    enableScrollSpy: E,
    scrollSpyDelay: C,
    scrollSpyOnce: y
  });
}, Kz = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"], Qz = {
  decimal: ".",
  separator: ",",
  delay: null,
  prefix: "",
  suffix: "",
  duration: 2,
  start: 0,
  decimals: 0,
  startOnMount: !0,
  enableReinitialize: !0,
  useEasing: !0,
  useGrouping: !0,
  useIndianSeparators: !1
}, C7 = function(e) {
  var t = Object.fromEntries(Object.entries(e).filter(function(I) {
    var B = qz(I, 2), U = B[1];
    return U !== void 0;
  })), i = fa.useMemo(function() {
    return Xb(Xb({}, Qz), t);
  }, [e]), c = i.ref, a = i.startOnMount, s = i.enableReinitialize, r = i.delay, l = i.onEnd, d = i.onStart, f = i.onPauseResume, h = i.onReset, p = i.onUpdate, g = S7(i, Kz), _ = fa.useRef(), b = fa.useRef(), v = fa.useRef(!1), E = Ku(function() {
    return Xz(typeof c == "string" ? c : c.current, g);
  }), C = Ku(function(I) {
    var B = _.current;
    if (B && !I)
      return B;
    var U = E();
    return _.current = U, U;
  }), y = Ku(function() {
    var I = function() {
      return C(!0).start(function() {
        l == null || l({
          pauseResume: T,
          reset: A,
          start: N,
          update: k
        });
      });
    };
    r && r > 0 ? b.current = setTimeout(I, r * 1e3) : I(), d == null || d({
      pauseResume: T,
      reset: A,
      update: k
    });
  }), T = Ku(function() {
    C().pauseResume(), f == null || f({
      reset: A,
      start: N,
      update: k
    });
  }), A = Ku(function() {
    C().el && (b.current && clearTimeout(b.current), C().reset(), h == null || h({
      pauseResume: T,
      start: N,
      update: k
    }));
  }), k = Ku(function(I) {
    C().update(I), p == null || p({
      pauseResume: T,
      reset: A,
      start: N
    });
  }), N = Ku(function() {
    A(), y();
  }), j = Ku(function(I) {
    a && (I && A(), y());
  });
  return fa.useEffect(function() {
    v.current ? s && j(!0) : (v.current = !0, j());
  }, [s, v, j, r, e.start, e.suffix, e.prefix, e.duration, e.separator, e.decimals, e.decimal, e.formattingFn]), fa.useEffect(function() {
    return function() {
      A();
    };
  }, [A]), {
    start: N,
    pauseResume: T,
    reset: A,
    update: k,
    getCountUp: C
  };
}, Zz = ["className", "redraw", "containerProps", "children", "style"], Jz = function(e) {
  var t = e.className, i = e.redraw, c = e.containerProps, a = e.children, s = e.style, r = S7(e, Zz), l = fa.useRef(null), d = fa.useRef(!1), f = C7(Xb(Xb({}, r), {}, {
    ref: l,
    startOnMount: typeof a != "function" || e.delay === 0,
    // component manually restarts
    enableReinitialize: !1
  })), h = f.start, p = f.reset, g = f.update, _ = f.pauseResume, b = f.getCountUp, v = Ku(function() {
    h();
  }), E = Ku(function(T) {
    e.preserveValue || p(), g(T);
  }), C = Ku(function() {
    if (typeof e.children == "function" && !(l.current instanceof Element)) {
      console.error(`Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`);
      return;
    }
    b();
  });
  fa.useEffect(function() {
    C();
  }, [C]), fa.useEffect(function() {
    d.current && E(e.end);
  }, [e.end, E]);
  var y = i && e;
  return fa.useEffect(function() {
    i && d.current && v();
  }, [v, i, y]), fa.useEffect(function() {
    !i && d.current && v();
  }, [v, i, e.start, e.suffix, e.prefix, e.duration, e.separator, e.decimals, e.decimal, e.className, e.formattingFn]), fa.useEffect(function() {
    d.current = !0;
  }, []), typeof a == "function" ? a({
    countUpRef: l,
    start: h,
    reset: p,
    update: g,
    pauseResume: _,
    getCountUp: b
  }) : /* @__PURE__ */ fa.createElement("span", ex({
    className: t,
    ref: l,
    style: s
  }, c), typeof e.start < "u" ? b().formattingFn(e.start) : "");
}, soe = Jx.default = Jz;
Jx.useCountUp = C7;
const eV = "_dropdownWrapper_tlzps_1", tV = "_dropdown_tlzps_1", w7 = {
  dropdownWrapper: eV,
  "dropdownWrapper--block": "_dropdownWrapper--block_tlzps_4",
  dropdown: tV,
  "dropdown--left": "_dropdown--left_tlzps_18",
  "dropdown--right": "_dropdown--right_tlzps_22"
}, _4 = Mn.bind(w7), y4 = Ef((n, e) => {
  const {
    align: t = "left",
    block: i,
    children: c,
    color: a,
    disabled: s,
    icon: r,
    label: l,
    maxWidth: d,
    minWidth: f = "100%",
    size: h,
    variant: p,
    width: g
  } = n, _ = si.useRef(null), b = si.useRef(null), [v, E] = Wn(!1), [C, y] = Wn(t);
  Lx(e, () => ({
    open: () => {
      E(!0);
    },
    close: () => {
      E(!1);
    }
  })), Fx([_], () => {
    E(!1);
  }), An(() => {
    v ? b.current && (t ? y(t) : b.current.getBoundingClientRect().right >= window.innerWidth ? y("right") : y("left"), b.current.style.top = "calc(100% + .25rem)", d && (b.current.style.maxWidth = `${d}`), f && (b.current.style.minWidth = `${f}`), g && (b.current.style.width = `${g}`)) : y("left");
  }, [v, d, f, g, t]);
  const T = () => {
    E(!v);
  }, A = _4("dropdown", {
    "dropdown--left": C === "left",
    "dropdown--right": C === "right"
  }), k = _4("dropdownWrapper", {
    "dropdownWrapper--block": !!i
  });
  return /* @__PURE__ */ Mt("div", { ref: _, className: k, children: [
    /* @__PURE__ */ Mt(
      Fh,
      {
        block: i,
        color: a,
        disabled: s,
        size: h,
        onClick: T,
        variant: p,
        dropdown: !!l,
        dropdownOpen: v,
        icon: !!(r && !l),
        children: [
          r && r,
          l && l
        ]
      }
    ),
    v && /* @__PURE__ */ Re("div", { ref: b, className: A, children: /* @__PURE__ */ Re("ul", { className: w7.dropdownList, children: c }) })
  ] });
}), nV = "_dropdownItemWrapper_1fxr3_1", rV = "_dropdownItem_1fxr3_1", iV = "_dropdownItemLabelWrapper_1fxr3_26", oV = "_dropdownItemIcon_1fxr3_30", aV = "_dropdownItemLabel_1fxr3_26", sV = "_dropdownItemButton_1fxr3_56", lV = "_dropdownItemError_1fxr3_70", uV = "_dropdownItemDisabled_1fxr3_76", tm = {
  dropdownItemWrapper: nV,
  dropdownItem: rV,
  dropdownItemLabelWrapper: iV,
  dropdownItemIcon: oV,
  dropdownItemLabel: aV,
  dropdownItemButton: sV,
  dropdownItemError: lV,
  dropdownItemDisabled: uV
}, v4 = Mn.bind(tm), Qv = ({
  label: n,
  onClick: e,
  icon: t,
  children: i,
  error: c = !1,
  disabled: a = !1
}) => {
  const s = v4("dropdownItem", {
    dropdownItemButton: !0,
    dropdownItemError: c,
    dropdownItemDisabled: a
  }), r = v4("dropdownItem", {
    dropdownItemError: c,
    dropdownItemDisabled: a
  }), l = () => {
    if (n)
      return /* @__PURE__ */ Mt("div", { className: tm.dropdownItemLabelWrapper, children: [
        t && /* @__PURE__ */ Re("div", { className: tm.dropdownItemIcon, children: t }),
        /* @__PURE__ */ Re("div", { className: tm.dropdownItemLabel, children: n })
      ] });
  };
  return /* @__PURE__ */ Re("li", { className: tm.dropdownItemWrapper, children: e ? /* @__PURE__ */ Mt(
    "button",
    {
      onClick: e,
      className: s,
      disabled: a,
      children: [
        l(),
        i && /* @__PURE__ */ Re("div", { className: tm.dropdownChildren, children: i })
      ]
    }
  ) : /* @__PURE__ */ Mt("div", { className: r, children: [
    l(),
    i && /* @__PURE__ */ Re("div", { className: tm.dropdownChildren, children: i })
  ] }) });
};
var x7 = { exports: {} };
(function(n, e) {
  (function(i, c) {
    n.exports = c();
  })(window, function() {
    return i = [function(a, s, r) {
      r.d(s, "f", function() {
        return N;
      }), r.d(s, "a", function() {
        return j;
      }), r.d(s, "e", function() {
        return I;
      }), r.d(s, "b", function() {
        return H;
      }), r.d(s, "d", function() {
        return Q;
      }), r.d(s, "m", function() {
        return Y;
      }), r.d(s, "i", function() {
        return ie;
      }), r.d(s, "n", function() {
        return ce;
      }), r.d(s, "j", function() {
        return $;
      }), r.d(s, "k", function() {
        return te;
      }), r.d(s, "l", function() {
        return V;
      }), r.d(s, "h", function() {
        return K;
      }), r.d(s, "g", function() {
        return ne;
      }), r.d(s, "c", function() {
        return q;
      });
      var l = r(8);
      function d(X) {
        return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(oe) {
          return typeof oe;
        } : function(oe) {
          return oe && typeof Symbol == "function" && oe.constructor === Symbol && oe !== Symbol.prototype ? "symbol" : typeof oe;
        })(X);
      }
      function f(X, oe) {
        var ae, _e = Object.keys(X);
        return Object.getOwnPropertySymbols && (ae = Object.getOwnPropertySymbols(X), oe && (ae = ae.filter(function(ve) {
          return Object.getOwnPropertyDescriptor(X, ve).enumerable;
        })), _e.push.apply(_e, ae)), _e;
      }
      function h(X) {
        for (var oe = 1; oe < arguments.length; oe++) {
          var ae = arguments[oe] != null ? arguments[oe] : {};
          oe % 2 ? f(Object(ae), !0).forEach(function(_e) {
            (function(Ee, we, ze) {
              (we = T(we)) in Ee ? Object.defineProperty(Ee, we, { value: ze, enumerable: !0, configurable: !0, writable: !0 }) : Ee[we] = ze;
            })(X, _e, ae[_e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(X, Object.getOwnPropertyDescriptors(ae)) : f(Object(ae)).forEach(function(_e) {
            Object.defineProperty(X, _e, Object.getOwnPropertyDescriptor(ae, _e));
          });
        }
        return X;
      }
      function p(X, oe, ae) {
        return oe = _(oe), function(ve, Ee) {
          if (Ee && (d(Ee) === "object" || typeof Ee == "function")) return Ee;
          if (Ee !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
          return function(ze) {
            if (ze !== void 0) return ze;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(ve);
        }(X, g() ? Reflect.construct(oe, ae || [], _(X).constructor) : oe.apply(X, ae));
      }
      function g() {
        try {
          var X = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
          }));
        } catch {
        }
        return (g = function() {
          return !!X;
        })();
      }
      function _(X) {
        return (_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ae) {
          return ae.__proto__ || Object.getPrototypeOf(ae);
        })(X);
      }
      function b(X, oe) {
        if (typeof oe != "function" && oe !== null) throw new TypeError("Super expression must either be null or a function");
        X.prototype = Object.create(oe && oe.prototype, { constructor: { value: X, writable: !0, configurable: !0 } }), Object.defineProperty(X, "prototype", { writable: !1 }), oe && v(X, oe);
      }
      function v(X, oe) {
        return (v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_e, ve) {
          return _e.__proto__ = ve, _e;
        })(X, oe);
      }
      function E(X, oe) {
        if (!(X instanceof oe)) throw new TypeError("Cannot call a class as a function");
      }
      function C(X, oe) {
        for (var ae = 0; ae < oe.length; ae++) {
          var _e = oe[ae];
          _e.enumerable = _e.enumerable || !1, _e.configurable = !0, "value" in _e && (_e.writable = !0), Object.defineProperty(X, T(_e.key), _e);
        }
      }
      function y(X, oe, ae) {
        return oe && C(X.prototype, oe), Object.defineProperty(X, "prototype", { writable: !1 }), X;
      }
      function T(X) {
        return X = function(ae, _e) {
          if (d(ae) != "object" || !ae) return ae;
          var ve = ae[Symbol.toPrimitive];
          if (ve === void 0) return (_e === "string" ? String : Number)(ae);
          if (d(_e = ve.call(ae, _e || "default")) != "object") return _e;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }(X, "string"), d(X) == "symbol" ? X : String(X);
      }
      var A = function() {
        function X() {
          E(this, X), this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
        }
        return y(X, [{ key: "parentNode", get: function() {
          return this.parent;
        }, set: function(ae) {
          this.parent = ae;
        } }, { key: "previousSibling", get: function() {
          return this.prev;
        }, set: function(ae) {
          this.prev = ae;
        } }, { key: "nextSibling", get: function() {
          return this.next;
        }, set: function(ae) {
          this.next = ae;
        } }, { key: "cloneNode", value: function() {
          return ne(this, 0 < arguments.length && arguments[0] !== void 0 && arguments[0]);
        } }]), X;
      }(), k = function() {
        function X(oe) {
          var ae;
          return E(this, X), (ae = p(this, X)).data = oe, ae;
        }
        return b(X, A), y(X, [{ key: "nodeValue", get: function() {
          return this.data;
        }, set: function(ae) {
          this.data = ae;
        } }]), X;
      }(), N = function() {
        function X() {
          var oe;
          return E(this, X), (oe = p(this, X, arguments)).type = l.ElementType.Text, oe;
        }
        return b(X, k), y(X, [{ key: "nodeType", get: function() {
          return 3;
        } }]), X;
      }(), j = function() {
        function X() {
          var oe;
          return E(this, X), (oe = p(this, X, arguments)).type = l.ElementType.Comment, oe;
        }
        return b(X, k), y(X, [{ key: "nodeType", get: function() {
          return 8;
        } }]), X;
      }(), I = function() {
        function X(oe, ae) {
          return E(this, X), (ae = p(this, X, [ae])).name = oe, ae.type = l.ElementType.Directive, ae;
        }
        return b(X, k), y(X, [{ key: "nodeType", get: function() {
          return 1;
        } }]), X;
      }(), B = function() {
        function X(oe) {
          var ae;
          return E(this, X), (ae = p(this, X)).children = oe, ae;
        }
        return b(X, A), y(X, [{ key: "firstChild", get: function() {
          var ae;
          return (ae = this.children[0]) !== null && ae !== void 0 ? ae : null;
        } }, { key: "lastChild", get: function() {
          return 0 < this.children.length ? this.children[this.children.length - 1] : null;
        } }, { key: "childNodes", get: function() {
          return this.children;
        }, set: function(ae) {
          this.children = ae;
        } }]), X;
      }(), U = function() {
        function X() {
          var oe;
          return E(this, X), (oe = p(this, X, arguments)).type = l.ElementType.CDATA, oe;
        }
        return b(X, B), y(X, [{ key: "nodeType", get: function() {
          return 4;
        } }]), X;
      }(), H = function() {
        function X() {
          var oe;
          return E(this, X), (oe = p(this, X, arguments)).type = l.ElementType.Root, oe;
        }
        return b(X, B), y(X, [{ key: "nodeType", get: function() {
          return 9;
        } }]), X;
      }(), Q = function() {
        function X(oe, ae) {
          var _e = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : [], ve = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : oe === "script" ? l.ElementType.Script : oe === "style" ? l.ElementType.Style : l.ElementType.Tag;
          return E(this, X), (_e = p(this, X, [_e])).name = oe, _e.attribs = ae, _e.type = ve, _e;
        }
        return b(X, B), y(X, [{ key: "nodeType", get: function() {
          return 1;
        } }, { key: "tagName", get: function() {
          return this.name;
        }, set: function(ae) {
          this.name = ae;
        } }, { key: "attributes", get: function() {
          var ae = this;
          return Object.keys(this.attribs).map(function(_e) {
            var ve;
            return { name: _e, value: ae.attribs[_e], namespace: (ve = ae["x-attribsNamespace"]) === null || ve === void 0 ? void 0 : ve[_e], prefix: (ve = ae["x-attribsPrefix"]) === null || ve === void 0 ? void 0 : ve[_e] };
          });
        } }]), X;
      }();
      function Y(X) {
        return Object(l.isTag)(X);
      }
      function ie(X) {
        return X.type === l.ElementType.CDATA;
      }
      function ce(X) {
        return X.type === l.ElementType.Text;
      }
      function $(X) {
        return X.type === l.ElementType.Comment;
      }
      function te(X) {
        return X.type === l.ElementType.Directive;
      }
      function V(X) {
        return X.type === l.ElementType.Root;
      }
      function K(X) {
        return Object.prototype.hasOwnProperty.call(X, "children");
      }
      function ne(X) {
        var oe, ae = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
        if (ce(X)) oe = new N(X.data);
        else if ($(X)) oe = new j(X.data);
        else if (Y(X)) {
          var _e = ae ? J(X.children) : [], ve = new Q(X.name, h({}, X.attribs), _e);
          _e.forEach(function(Ie) {
            return Ie.parent = ve;
          }), X.namespace != null && (ve.namespace = X.namespace), X["x-attribsNamespace"] && (ve["x-attribsNamespace"] = h({}, X["x-attribsNamespace"])), X["x-attribsPrefix"] && (ve["x-attribsPrefix"] = h({}, X["x-attribsPrefix"])), oe = ve;
        } else if (ie(X)) {
          var _e = ae ? J(X.children) : [], Ee = new U(_e);
          _e.forEach(function(je) {
            return je.parent = Ee;
          }), oe = Ee;
        } else if (V(X)) {
          var we = ae ? J(X.children) : [], ze = new H(we);
          we.forEach(function(Ie) {
            return Ie.parent = ze;
          }), X["x-mode"] && (ze["x-mode"] = X["x-mode"]), oe = ze;
        } else {
          if (!te(X)) throw new Error("Not implemented yet: ".concat(X.type));
          we = new I(X.name, X.data), X["x-name"] != null && (we["x-name"] = X["x-name"], we["x-publicId"] = X["x-publicId"], we["x-systemId"] = X["x-systemId"]), oe = we;
        }
        return oe.startIndex = X.startIndex, oe.endIndex = X.endIndex, X.sourceCodeLocation != null && (oe.sourceCodeLocation = X.sourceCodeLocation), oe;
      }
      function J(X) {
        for (var oe = X.map(function(_e) {
          return ne(_e, !0);
        }), ae = 1; ae < oe.length; ae++) oe[ae].prev = oe[ae - 1], oe[ae - 1].next = oe[ae];
        return oe;
      }
      function L(X) {
        return (L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(oe) {
          return typeof oe;
        } : function(oe) {
          return oe && typeof Symbol == "function" && oe.constructor === Symbol && oe !== Symbol.prototype ? "symbol" : typeof oe;
        })(X);
      }
      function z(X, oe) {
        for (var ae = 0; ae < oe.length; ae++) {
          var _e = oe[ae];
          _e.enumerable = _e.enumerable || !1, _e.configurable = !0, "value" in _e && (_e.writable = !0), Object.defineProperty(X, function(Ee) {
            return Ee = function(ze, Ie) {
              if (L(ze) != "object" || !ze) return ze;
              var je = ze[Symbol.toPrimitive];
              if (je === void 0) return (Ie === "string" ? String : Number)(ze);
              if (L(Ie = je.call(ze, Ie || "default")) != "object") return Ie;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(Ee, "string"), L(Ee) == "symbol" ? Ee : String(Ee);
          }(_e.key), _e);
        }
      }
      var ee = { withStartIndices: !1, withEndIndices: !1, xmlMode: !1 }, q = function() {
        function X(oe, ae, _e) {
          (function(Ee, we) {
            if (!(Ee instanceof we)) throw new TypeError("Cannot call a class as a function");
          })(this, X), this.dom = [], this.root = new H(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof ae == "function" && (_e = ae, ae = ee), L(oe) === "object" && (ae = oe, oe = void 0), this.callback = oe ?? null, this.options = ae ?? ee, this.elementCB = _e ?? null;
        }
        return function(ae, _e, ve) {
          _e && z(ae.prototype, _e), Object.defineProperty(ae, "prototype", { writable: !1 });
        }(X, [{ key: "onparserinit", value: function(ae) {
          this.parser = ae;
        } }, { key: "onreset", value: function() {
          this.dom = [], this.root = new H(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        } }, { key: "onend", value: function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        } }, { key: "onerror", value: function(ae) {
          this.handleCallback(ae);
        } }, { key: "onclosetag", value: function() {
          this.lastNode = null;
          var ae = this.tagStack.pop();
          this.options.withEndIndices && (ae.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(ae);
        } }, { key: "onopentag", value: function(ae, _e) {
          var ve = this.options.xmlMode ? l.ElementType.Tag : void 0, ve = new Q(ae, _e, void 0, ve);
          this.addNode(ve), this.tagStack.push(ve);
        } }, { key: "ontext", value: function(ae) {
          var _e = this.lastNode;
          _e && _e.type === l.ElementType.Text ? (_e.data += ae, this.options.withEndIndices && (_e.endIndex = this.parser.endIndex)) : (ae = new N(ae), this.addNode(ae), this.lastNode = ae);
        } }, { key: "oncomment", value: function(ae) {
          this.lastNode && this.lastNode.type === l.ElementType.Comment ? this.lastNode.data += ae : (ae = new j(ae), this.addNode(ae), this.lastNode = ae);
        } }, { key: "oncommentend", value: function() {
          this.lastNode = null;
        } }, { key: "oncdatastart", value: function() {
          var ae = new N(""), _e = new U([ae]);
          this.addNode(_e), ae.parent = _e, this.lastNode = ae;
        } }, { key: "oncdataend", value: function() {
          this.lastNode = null;
        } }, { key: "onprocessinginstruction", value: function(ae, _e) {
          _e = new I(ae, _e), this.addNode(_e);
        } }, { key: "handleCallback", value: function(ae) {
          if (typeof this.callback == "function") this.callback(ae, this.dom);
          else if (ae) throw ae;
        } }, { key: "addNode", value: function(ae) {
          var _e = this.tagStack[this.tagStack.length - 1], ve = _e.children[_e.children.length - 1];
          this.options.withStartIndices && (ae.startIndex = this.parser.startIndex), this.options.withEndIndices && (ae.endIndex = this.parser.endIndex), _e.children.push(ae), ve && ((ae.prev = ve).next = ae), ae.parent = _e, this.lastNode = null;
        } }]), X;
      }();
    }, function(a, s) {
      a.exports = function(l) {
        return l && l.__esModule ? l : { default: l };
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      a.exports = { trueFunc: function() {
        return !0;
      }, falseFunc: function() {
        return !1;
      } };
    }, function(a, s, r) {
      r.r(s), r.d(s, "getOuterHTML", function() {
        return h;
      }), r.d(s, "getInnerHTML", function() {
        return p;
      }), r.d(s, "getText", function() {
        return g;
      }), r.d(s, "textContent", function() {
        return _;
      }), r.d(s, "innerText", function() {
        return b;
      }), r.d(s, "getChildren", function() {
        return v;
      }), r.d(s, "getParent", function() {
        return E;
      }), r.d(s, "getSiblings", function() {
        return C;
      }), r.d(s, "getAttributeValue", function() {
        return y;
      }), r.d(s, "hasAttrib", function() {
        return T;
      }), r.d(s, "getName", function() {
        return A;
      }), r.d(s, "nextElementSibling", function() {
        return k;
      }), r.d(s, "prevElementSibling", function() {
        return N;
      }), r.d(s, "removeElement", function() {
        return j;
      }), r.d(s, "replaceElement", function() {
        return I;
      }), r.d(s, "appendChild", function() {
        return B;
      }), r.d(s, "append", function() {
        return U;
      }), r.d(s, "prependChild", function() {
        return H;
      }), r.d(s, "prepend", function() {
        return Q;
      }), r.d(s, "filter", function() {
        return Y;
      }), r.d(s, "find", function() {
        return ie;
      }), r.d(s, "findOneChild", function() {
        return ce;
      }), r.d(s, "findOne", function() {
        return $;
      }), r.d(s, "existsOne", function() {
        return te;
      }), r.d(s, "findAll", function() {
        return V;
      }), r.d(s, "testElement", function() {
        return ee;
      }), r.d(s, "getElements", function() {
        return q;
      }), r.d(s, "getElementById", function() {
        return X;
      }), r.d(s, "getElementsByTagName", function() {
        return oe;
      }), r.d(s, "getElementsByTagType", function() {
        return ae;
      }), r.d(s, "removeSubsets", function() {
        return _e;
      }), r.d(s, "DocumentPosition", function() {
        return K;
      }), r.d(s, "compareDocumentPosition", function() {
        return ve;
      }), r.d(s, "uniqueSort", function() {
        return Ee;
      }), r.d(s, "getFeed", function() {
        return Ie;
      }), r.d(s, "isTag", function() {
        return l.m;
      }), r.d(s, "isCDATA", function() {
        return l.i;
      }), r.d(s, "isText", function() {
        return l.n;
      }), r.d(s, "isComment", function() {
        return l.j;
      }), r.d(s, "isDocument", function() {
        return l.l;
      }), r.d(s, "hasChildren", function() {
        return l.h;
      });
      var l = r(0), d = r(96), f = r(8);
      function h(pe, Se) {
        return Object(d.a)(pe, Se);
      }
      function p(pe, Se) {
        return Object(l.h)(pe) ? pe.children.map(function(he) {
          return h(he, Se);
        }).join("") : "";
      }
      function g(pe) {
        return Array.isArray(pe) ? pe.map(g).join("") : Object(l.m)(pe) ? pe.name === "br" ? `
` : g(pe.children) : Object(l.i)(pe) ? g(pe.children) : Object(l.n)(pe) ? pe.data : "";
      }
      function _(pe) {
        return Array.isArray(pe) ? pe.map(_).join("") : Object(l.h)(pe) && !Object(l.j)(pe) ? _(pe.children) : Object(l.n)(pe) ? pe.data : "";
      }
      function b(pe) {
        return Array.isArray(pe) ? pe.map(b).join("") : Object(l.h)(pe) && (pe.type === f.ElementType.Tag || Object(l.i)(pe)) ? b(pe.children) : Object(l.n)(pe) ? pe.data : "";
      }
      function v(pe) {
        return Object(l.h)(pe) ? pe.children : [];
      }
      function E(pe) {
        return pe.parent || null;
      }
      function C(pe) {
        var Se = E(pe);
        if (Se != null) return v(Se);
        for (var he = [pe], Te = pe.prev, Me = pe.next; Te != null; ) he.unshift(Te), Te = Te.prev;
        for (; Me != null; ) he.push(Me), Me = Me.next;
        return he;
      }
      function y(pe, Se) {
        return (pe = pe.attribs) === null || pe === void 0 ? void 0 : pe[Se];
      }
      function T(pe, Se) {
        return pe.attribs != null && Object.prototype.hasOwnProperty.call(pe.attribs, Se) && pe.attribs[Se] != null;
      }
      function A(pe) {
        return pe.name;
      }
      function k(pe) {
        for (var Se = pe.next; Se !== null && !Object(l.m)(Se); ) Se = Se.next;
        return Se;
      }
      function N(pe) {
        for (var Se = pe.prev; Se !== null && !Object(l.m)(Se); ) Se = Se.prev;
        return Se;
      }
      function j(pe) {
        var Se, he;
        pe.prev && (pe.prev.next = pe.next), pe.next && (pe.next.prev = pe.prev), !pe.parent || 0 <= (he = (Se = pe.parent.children).lastIndexOf(pe)) && Se.splice(he, 1), pe.next = null, pe.prev = null, pe.parent = null;
      }
      function I(pe, Se) {
        var he = Se.prev = pe.prev;
        he && (he.next = Se), (he = Se.next = pe.next) && (he.prev = Se), (he = Se.parent = pe.parent) && ((he = he.children)[he.lastIndexOf(pe)] = Se, pe.parent = null);
      }
      function B(pe, Se) {
        j(Se), Se.next = null, 1 < (Se.parent = pe).children.push(Se) ? ((pe = pe.children[pe.children.length - 2]).next = Se).prev = pe : Se.prev = null;
      }
      function U(pe, Se) {
        j(Se);
        var he = pe.parent, Te = pe.next;
        Se.next = Te, ((Se.prev = pe).next = Se).parent = he, Te ? (Te.prev = Se, he && (pe = he.children).splice(pe.lastIndexOf(Te), 0, Se)) : he && he.children.push(Se);
      }
      function H(pe, Se) {
        j(Se), Se.parent = pe, Se.prev = null, pe.children.unshift(Se) !== 1 ? ((pe = pe.children[1]).prev = Se).next = pe : Se.next = null;
      }
      function Q(pe, Se) {
        j(Se);
        var he, Te = pe.parent;
        Te && (he = Te.children).splice(he.indexOf(pe), 0, Se), pe.prev && (pe.prev.next = Se), Se.parent = Te, Se.prev = pe.prev, (Se.next = pe).prev = Se;
      }
      function Y(pe, Se) {
        var he = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2], Te = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : 1 / 0;
        return ie(pe, Array.isArray(Se) ? Se : [Se], he, Te);
      }
      function ie(pe, Se, he, Te) {
        for (var Me = [], Ye = [Se], et = [0]; ; ) if (et[0] >= Ye[0].length) {
          if (et.length === 1) return Me;
          Ye.shift(), et.shift();
        } else {
          var dt = Ye[0][et[0]++];
          if (pe(dt) && (Me.push(dt), --Te <= 0)) return Me;
          he && Object(l.h)(dt) && 0 < dt.children.length && (et.unshift(0), Ye.unshift(dt.children));
        }
      }
      function ce(pe, Se) {
        return Se.find(pe);
      }
      function $(pe, Se) {
        for (var he = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2], Te = null, Me = 0; Me < Se.length && !Te; Me++) {
          var Ye = Se[Me];
          Object(l.m)(Ye) && (pe(Ye) ? Te = Ye : he && 0 < Ye.children.length && (Te = $(pe, Ye.children, !0)));
        }
        return Te;
      }
      function te(pe, Se) {
        return Se.some(function(he) {
          return Object(l.m)(he) && (pe(he) || te(pe, he.children));
        });
      }
      function V(pe, Se) {
        for (var he = [], Te = [Se], Me = [0]; ; ) if (Me[0] >= Te[0].length) {
          if (Te.length === 1) return he;
          Te.shift(), Me.shift();
        } else {
          var Ye = Te[0][Me[0]++];
          Object(l.m)(Ye) && (pe(Ye) && he.push(Ye), 0 < Ye.children.length && (Me.unshift(0), Te.unshift(Ye.children)));
        }
      }
      var K, ne = { tag_name: function(Se) {
        return typeof Se == "function" ? function(he) {
          return Object(l.m)(he) && Se(he.name);
        } : Se === "*" ? l.m : function(he) {
          return Object(l.m)(he) && he.name === Se;
        };
      }, tag_type: function(Se) {
        return typeof Se == "function" ? function(he) {
          return Se(he.type);
        } : function(he) {
          return he.type === Se;
        };
      }, tag_contains: function(Se) {
        return typeof Se == "function" ? function(he) {
          return Object(l.n)(he) && Se(he.data);
        } : function(he) {
          return Object(l.n)(he) && he.data === Se;
        };
      } };
      function J(pe, Se) {
        return typeof Se == "function" ? function(he) {
          return Object(l.m)(he) && Se(he.attribs[pe]);
        } : function(he) {
          return Object(l.m)(he) && he.attribs[pe] === Se;
        };
      }
      function L(pe, Se) {
        return function(he) {
          return pe(he) || Se(he);
        };
      }
      function z(pe) {
        var Se = Object.keys(pe).map(function(he) {
          var Te = pe[he];
          return Object.prototype.hasOwnProperty.call(ne, he) ? ne[he](Te) : J(he, Te);
        });
        return Se.length === 0 ? null : Se.reduce(L);
      }
      function ee(pe, Se) {
        return !(pe = z(pe)) || pe(Se);
      }
      function q(Me, Se, he) {
        var Te = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : 1 / 0, Me = z(Me);
        return Me ? Y(Me, Se, he, Te) : [];
      }
      function X(pe, Se) {
        var he = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2];
        return Array.isArray(Se) || (Se = [Se]), $(J("id", pe), Se, he);
      }
      function oe(pe, Se) {
        var he = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2], Te = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : 1 / 0;
        return Y(ne.tag_name(pe), Se, he, Te);
      }
      function ae(pe, Se) {
        var he = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2], Te = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : 1 / 0;
        return Y(ne.tag_type(pe), Se, he, Te);
      }
      function _e(pe) {
        for (var Se = pe.length; 0 <= --Se; ) {
          var he = pe[Se];
          if (0 < Se && 0 <= pe.lastIndexOf(he, Se - 1)) pe.splice(Se, 1);
          else for (var Te = he.parent; Te; Te = Te.parent) if (pe.includes(Te)) {
            pe.splice(Se, 1);
            break;
          }
        }
        return pe;
      }
      function ve(pe, Se) {
        var he = [], Te = [];
        if (pe === Se) return 0;
        for (var Me = Object(l.h)(pe) ? pe : pe.parent; Me; ) he.unshift(Me), Me = Me.parent;
        for (Me = Object(l.h)(Se) ? Se : Se.parent; Me; ) Te.unshift(Me), Me = Me.parent;
        for (var Ye = Math.min(he.length, Te.length), et = 0; et < Ye && he[et] === Te[et]; ) et++;
        if (et === 0) return K.DISCONNECTED;
        var dt = he[et - 1], We = dt.children, nt = he[et], ft = Te[et];
        return We.indexOf(nt) > We.indexOf(ft) ? dt === Se ? K.FOLLOWING | K.CONTAINED_BY : K.FOLLOWING : dt === pe ? K.PRECEDING | K.CONTAINS : K.PRECEDING;
      }
      function Ee(pe) {
        return (pe = pe.filter(function(Se, he, Te) {
          return !Te.includes(Se, he + 1);
        })).sort(function(Se, he) {
          return (he = ve(Se, he)) & K.PRECEDING ? -1 : he & K.FOLLOWING ? 1 : 0;
        }), pe;
      }
      function we(pe, Se) {
        var he = typeof Symbol < "u" && pe[Symbol.iterator] || pe["@@iterator"];
        if (!he) {
          if (Array.isArray(pe) || (he = function(We, nt) {
            if (We) {
              if (typeof We == "string") return ze(We, nt);
              var ft = Object.prototype.toString.call(We).slice(8, -1);
              return (ft = ft === "Object" && We.constructor ? We.constructor.name : ft) === "Map" || ft === "Set" ? Array.from(We) : ft === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ft) ? ze(We, nt) : void 0;
            }
          }(pe)) || Se && pe && typeof pe.length == "number") {
            he && (pe = he);
            var Te = 0;
            return { s: Se = function() {
            }, n: function() {
              return Te >= pe.length ? { done: !0 } : { done: !1, value: pe[Te++] };
            }, e: function(We) {
              throw We;
            }, f: Se };
          }
          throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var Me, Ye = !0, et = !1;
        return { s: function() {
          he = he.call(pe);
        }, n: function() {
          var We = he.next();
          return Ye = We.done, We;
        }, e: function(We) {
          et = !0, Me = We;
        }, f: function() {
          try {
            Ye || he.return == null || he.return();
          } finally {
            if (et) throw Me;
          }
        } };
      }
      function ze(pe, Se) {
        (Se == null || Se > pe.length) && (Se = pe.length);
        for (var he = 0, Te = new Array(Se); he < Se; he++) Te[he] = pe[he];
        return Te;
      }
      function Ie(pe) {
        return (pe = Ze(ke, pe)) ? (pe.name === "feed" ? function(he) {
          var Te = he.children, Me = { type: "atom", items: oe("entry", Te).map(function(Ye) {
            var et = Ye.children, dt = { media: Ge(et) };
            return Qe(dt, "id", "id", et), Qe(dt, "title", "title", et), (Ye = (Ye = Ze("link", et)) === null || Ye === void 0 ? void 0 : Ye.attribs.href) && (dt.link = Ye), (Ye = tt("summary", et) || tt("content", et)) && (dt.description = Ye), (et = tt("updated", et)) && (dt.pubDate = new Date(et)), dt;
          }) };
          return Qe(Me, "id", "id", Te), Qe(Me, "title", "title", Te), (he = (he = Ze("link", Te)) === null || he === void 0 ? void 0 : he.attribs.href) && (Me.link = he), Qe(Me, "description", "subtitle", Te), (he = tt("updated", Te)) && (Me.updated = new Date(he)), Qe(Me, "author", "email", Te, !0), Me;
        } : function(he) {
          var Te = (Me = (Te = Ze("channel", he.children)) === null || Te === void 0 ? void 0 : Te.children) !== null && Me !== void 0 ? Me : [], Me = { type: he.name.substr(0, 3), id: "", items: oe("item", he.children).map(function(Ye) {
            var et = Ye.children;
            return Qe(Ye = { media: Ge(et) }, "id", "guid", et), Qe(Ye, "title", "title", et), Qe(Ye, "link", "link", et), Qe(Ye, "description", "description", et), (et = tt("pubDate", et) || tt("dc:date", et)) && (Ye.pubDate = new Date(et)), Ye;
          }) };
          return Qe(Me, "title", "title", Te), Qe(Me, "link", "link", Te), Qe(Me, "description", "description", Te), (he = tt("lastBuildDate", Te)) && (Me.updated = new Date(he)), Qe(Me, "author", "managingEditor", Te, !0), Me;
        })(pe) : null;
      }
      (r = K = K || {})[r.DISCONNECTED = 1] = "DISCONNECTED", r[r.PRECEDING = 2] = "PRECEDING", r[r.FOLLOWING = 4] = "FOLLOWING", r[r.CONTAINS = 8] = "CONTAINS", r[r.CONTAINED_BY = 16] = "CONTAINED_BY";
      var je = ["url", "type", "lang"], qe = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
      function Ge(pe) {
        return oe("media:content", pe).map(function(Se) {
          var he, Te = Se.attribs, Me = { medium: Te.medium, isDefault: !!Te.isDefault }, Ye = we(je);
          try {
            for (Ye.s(); !(he = Ye.n()).done; ) {
              var et = he.value;
              Te[et] && (Me[et] = Te[et]);
            }
          } catch (ft) {
            Ye.e(ft);
          } finally {
            Ye.f();
          }
          var dt, We = we(qe);
          try {
            for (We.s(); !(dt = We.n()).done; ) {
              var nt = dt.value;
              Te[nt] && (Me[nt] = parseInt(Te[nt], 10));
            }
          } catch (ft) {
            We.e(ft);
          } finally {
            We.f();
          }
          return Te.expression && (Me.expression = Te.expression), Me;
        });
      }
      function Ze(pe, Se) {
        return oe(pe, Se, !0, 1)[0];
      }
      function tt(pe, Se, he) {
        return _(oe(pe, Se, 2 < arguments.length && he !== void 0 && he, 1)).trim();
      }
      function Qe(pe, Se, he, Te, Me) {
        (Me = tt(he, Te, 4 < arguments.length && Me !== void 0 && Me)) && (pe[Se] = Me);
      }
      function ke(pe) {
        return pe === "rss" || pe === "feed" || pe === "rdf:RDF";
      }
    }, function(a, s, r) {
      var l = r(149);
      function d(f, h) {
        for (var p = 0; p < h.length; p++) {
          var g = h[p];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(f, l(g.key), g);
        }
      }
      a.exports = function(h, p, g) {
        return p && d(h.prototype, p), g && d(h, g), Object.defineProperty(h, "prototype", { writable: !1 }), h;
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      a.exports = function(l, d) {
        if (!(l instanceof d)) throw new TypeError("Cannot call a class as a function");
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(150), d = r(151), f = r(244);
      a.exports = function(p, g, _) {
        return g = l(g), f(p, d() ? Reflect.construct(g, _ || [], l(p).constructor) : g.apply(p, _));
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(97);
      a.exports = function(f, h) {
        if (typeof h != "function" && h !== null) throw new TypeError("Super expression must either be null or a function");
        f.prototype = Object.create(h && h.prototype, { constructor: { value: f, writable: !0, configurable: !0 } }), Object.defineProperty(f, "prototype", { writable: !1 }), h && l(f, h);
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l;
      function d(y) {
        return y.type === l.Tag || y.type === l.Script || y.type === l.Style;
      }
      r.r(s), r.d(s, "ElementType", function() {
        return l;
      }), r.d(s, "isTag", function() {
        return d;
      }), r.d(s, "Root", function() {
        return f;
      }), r.d(s, "Text", function() {
        return h;
      }), r.d(s, "Directive", function() {
        return p;
      }), r.d(s, "Comment", function() {
        return g;
      }), r.d(s, "Script", function() {
        return _;
      }), r.d(s, "Style", function() {
        return b;
      }), r.d(s, "Tag", function() {
        return v;
      }), r.d(s, "CDATA", function() {
        return E;
      }), r.d(s, "Doctype", function() {
        return C;
      }), (s = l = l || {}).Root = "root", s.Text = "text", s.Directive = "directive", s.Comment = "comment", s.Script = "script", s.Style = "style", s.Tag = "tag", s.CDATA = "cdata", s.Doctype = "doctype";
      var f = l.Root, h = l.Text, p = l.Directive, g = l.Comment, _ = l.Script, b = l.Style, v = l.Tag, E = l.CDATA, C = l.Doctype;
    }, function(a, s, r) {
      var l = r(149);
      a.exports = function(f, h, p) {
        return (h = l(h)) in f ? Object.defineProperty(f, h, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : f[h] = p, f;
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      (function(l) {
        function d(Ie) {
          return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(je) {
            return typeof je;
          } : function(je) {
            return je && typeof Symbol == "function" && je.constructor === Symbol && je !== Symbol.prototype ? "symbol" : typeof je;
          })(Ie);
        }
        function f(Ie) {
          return function(qe) {
            if (Array.isArray(qe)) return p(qe);
          }(Ie) || function(qe) {
            if (typeof Symbol < "u" && qe[Symbol.iterator] != null || qe["@@iterator"] != null) return Array.from(qe);
          }(Ie) || h(Ie) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }
        function h(Ie, je) {
          if (Ie) {
            if (typeof Ie == "string") return p(Ie, je);
            var qe = Object.prototype.toString.call(Ie).slice(8, -1);
            return (qe = qe === "Object" && Ie.constructor ? Ie.constructor.name : qe) === "Map" || qe === "Set" ? Array.from(Ie) : qe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(qe) ? p(Ie, je) : void 0;
          }
        }
        function p(Ie, je) {
          (je == null || je > Ie.length) && (je = Ie.length);
          for (var qe = 0, Ge = new Array(je); qe < je; qe++) Ge[qe] = Ie[qe];
          return Ge;
        }
        function g(Ie, je) {
          var qe, Ge = Object.keys(Ie);
          return Object.getOwnPropertySymbols && (qe = Object.getOwnPropertySymbols(Ie), je && (qe = qe.filter(function(Ze) {
            return Object.getOwnPropertyDescriptor(Ie, Ze).enumerable;
          })), Ge.push.apply(Ge, qe)), Ge;
        }
        function _(Ie) {
          for (var je = 1; je < arguments.length; je++) {
            var qe = arguments[je] != null ? arguments[je] : {};
            je % 2 ? g(Object(qe), !0).forEach(function(Ge) {
              (function(tt, Qe, ke) {
                (Qe = function(Se) {
                  return Se = function(Te, Me) {
                    if (d(Te) != "object" || !Te) return Te;
                    var Ye = Te[Symbol.toPrimitive];
                    if (Ye === void 0) return (Me === "string" ? String : Number)(Te);
                    if (d(Me = Ye.call(Te, Me || "default")) != "object") return Me;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }(Se, "string"), d(Se) == "symbol" ? Se : String(Se);
                }(Qe)) in tt ? Object.defineProperty(tt, Qe, { value: ke, enumerable: !0, configurable: !0, writable: !0 }) : tt[Qe] = ke;
              })(Ie, Ge, qe[Ge]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ie, Object.getOwnPropertyDescriptors(qe)) : g(Object(qe)).forEach(function(Ge) {
              Object.defineProperty(Ie, Ge, Object.getOwnPropertyDescriptor(qe, Ge));
            });
          }
          return Ie;
        }
        var b = r(38).default, v = r(1).default;
        Object.defineProperty(s, "__esModule", { value: !0 }), Object.defineProperty(s, "BodyComponent", { enumerable: !0, get: function() {
          return z.BodyComponent;
        } }), Object.defineProperty(s, "HeadComponent", { enumerable: !0, get: function() {
          return z.HeadComponent;
        } }), Object.defineProperty(s, "assignComponents", { enumerable: !0, get: function() {
          return ee.assignComponents;
        } }), Object.defineProperty(s, "components", { enumerable: !0, get: function() {
          return ee.default;
        } }), s.default = function(je) {
          var nt = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, er = "", qe = [];
          we && typeof nt.skeleton == "string" && (nt.skeleton = r(555)(nt.skeleton.charAt(0) === "." ? ce.default.resolve(l.cwd(), nt.skeleton) : nt.skeleton));
          var Se = {}, pe = {}, he = {}, Te = [], We = null, et = null;
          (we && nt.useMjmlConfigOptions || nt.mjmlConfigPath) && (Se = (ke = (Ye = (0, Ee.readMjmlConfig)(nt.mjmlConfigPath)).mjmlConfig).packages, pe = ke.options, Te = ke.preprocessors, et = Ye.componentRootPath, We = Ye.error, nt.useMjmlConfigOptions && (he = pe)), we && !We && nt.mjmlConfigPath && (0, Ee.handleMjmlConfigComponents)(Se, et, ee.registerComponent);
          var Ge, Ze = (dt = (At = _(_(_({}, he), nt), {}, { preprocessors: nt.preprocessors ? [].concat(f(Te), f(nt.preprocessors)) : Te })).beautify) !== void 0 && dt, tt = (Me = At.fonts) === void 0 ? { "Open Sans": "https://fonts.googleapis.com/css?family=Open+Sans:300,400,500,700", "Droid Sans": "https://fonts.googleapis.com/css?family=Droid+Sans:300,400,500,700", Lato: "https://fonts.googleapis.com/css?family=Lato:300,400,500,700", Roboto: "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700", Ubuntu: "https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" } : Me, Qe = At.keepComments, ke = (ft = At.minify) !== void 0 && ft, pe = (Ye = At.minifyOptions) === void 0 ? {} : Ye, Se = (We = At.ignoreIncludes) !== void 0 && We, he = (et = At.juiceOptions) === void 0 ? {} : et, Te = (nt = At.juicePreserveTags) === void 0 ? null : nt, Me = (dt = At.skeleton) === void 0 ? _e.default : dt, Ye = (ft = At.validationLevel) === void 0 ? "soft" : ft, et = (We = At.filePath) === void 0 ? "." : We, dt = (nt = At.actualPath) === void 0 ? "." : nt, We = (ft = At.noMigrateWarn) !== void 0 && ft, nt = At.preprocessors, ft = (ft = At.presets) === void 0 ? [] : ft, At = (At = At.printerSupport) !== void 0 && At, ln = _({}, ee.default), Jt = (0, J.assignDependencies)({}, J.dependencies), zt = function(un, en) {
            var bt = typeof Symbol < "u" && un[Symbol.iterator] || un["@@iterator"];
            if (!bt) {
              if (Array.isArray(un) || (bt = h(un)) || en && un && typeof un.length == "number") {
                bt && (un = bt);
                var Pt = 0;
                return { s: en = function() {
                }, n: function() {
                  return Pt >= un.length ? { done: !0 } : { done: !1, value: un[Pt++] };
                }, e: function(Kt) {
                  throw Kt;
                }, f: en };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var fn, cn = !0, Vn = !1;
            return { s: function() {
              bt = bt.call(un);
            }, n: function() {
              var Kt = bt.next();
              return cn = Kt.done, Kt;
            }, e: function(Kt) {
              Vn = !0, fn = Kt;
            }, f: function() {
              try {
                cn || bt.return == null || bt.return();
              } finally {
                if (Vn) throw fn;
              }
            } };
          }(ft);
          try {
            for (zt.s(); !(Ge = zt.n()).done; ) {
              var kt = Ge.value;
              (0, ee.assignComponents)(ln, kt.components), (0, J.assignDependencies)(Jt, kt.dependencies);
            }
          } catch ($n) {
            zt.e($n);
          } finally {
            zt.f();
          }
          typeof je == "string" && (je = (0, ne.default)(je, { keepComments: Qe, components: ln, filePath: et, actualPath: dt, preprocessors: nt, ignoreIncludes: Se })), je = (0, L.handleMjml3)(je, { noMigrateWarn: We });
          var Ft = { backgroundColor: "", beforeDoctype: "", breakpoint: "480px", classes: {}, classesDefault: {}, defaultAttributes: {}, htmlAttributes: {}, fonts: tt, inlineStyle: [], headStyle: {}, componentsHeadStyle: [], headRaw: [], mediaQueries: {}, preview: "", style: [], title: "", forceOWADesktop: (0, Q.default)(je, "attributes.owa", "mobile") === "desktop", lang: (0, Q.default)(je, "attributes.lang") || "und", dir: (0, Q.default)(je, "attributes.dir") || "auto" }, ar = { components: ln, dependencies: Jt, initializeType: ve.initializeType };
          switch (Ye) {
            case "skip":
              break;
            case "strict":
              if (0 < (qe = (0, J.default)(je, ar)).length) throw new ze(`ValidationError: 
 `.concat(qe.map(function($n) {
                return $n.formattedMessage;
              }).join(`
`)), qe);
              break;
            case "soft":
            default:
              qe = (0, J.default)(je, ar);
          }
          function In($n, un, en) {
            if (en = 2 < arguments.length && en !== void 0 ? en : H.default, $n) return (un = (0, z.initComponent)({ name: $n.tagName, initialDatas: _(_({}, en($n)), {}, { context: un }) })) !== null ? "handler" in un ? un.handler() : "render" in un ? un.render() : void 0 : void 0;
          }
          function On($n) {
            return function un(en) {
              var bt = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "", Pt = en.attributes, fn = en.tagName, cn = en.children, En = (0, Q.default)(en.attributes, "mj-class", "").split(" "), Vn = (0, I.default)(En, function(Dn, Ii) {
                var vr = Ft.classes[Ii], Ii = {};
                return Dn["css-class"] && (0, Q.default)(vr, "css-class") && (Ii = { "css-class": "".concat(Dn["css-class"], " ").concat(vr["css-class"]) }), _(_(_({}, Dn), vr), Ii);
              }, {}), En = (0, I.default)(bt.split(" "), function(Dn, Kn) {
                return _(_({}, Dn), (0, Q.default)(Ft.classesDefault, "".concat(Kn, ".").concat(fn)));
              }, {}), Kt = (0, Q.default)(Pt, "mj-class", bt);
              return _(_({}, en), {}, { attributes: _(_(_(_({}, Ft.defaultAttributes[fn]), Vn), En), (0, B.default)(Pt, ["mj-class"])), globalAttributes: _({}, Ft.defaultAttributes["mj-all"]), children: (0, U.default)(cn, function(Dn) {
                return un(Dn, Kt);
              }) });
            }($n);
          }
          if (nt = (0, ie.default)(je.children, { tagName: "mj-body" }), Se = (0, ie.default)(je.children, { tagName: "mj-head" }), We = (0, Y.default)(je.children, { tagName: "mj-raw" }), tt = { components: ln, globalData: Ft, addMediaQuery: function(un, Pt) {
            var bt = Pt.parsedWidth, Pt = Pt.unit;
            Ft.mediaQueries[un] = "{ width:".concat(bt).concat(Pt, " !important; max-width: ").concat(bt).concat(Pt, "; }");
          }, addHeadStyle: function(un, en) {
            Ft.headStyle[un] = en;
          }, addComponentHeadSyle: function(un) {
            Ft.componentsHeadStyle.push(un);
          }, setBackgroundColor: function(un) {
            Ft.backgroundColor = un;
          }, processing: function(un, en) {
            return In(un, en, On);
          } }, Ye = { components: ln, globalData: Ft, add: function(un) {
            for (var en, bt = arguments.length, Pt = new Array(1 < bt ? bt - 1 : 0), fn = 1; fn < bt; fn++) Pt[fn - 1] = arguments[fn];
            if (Array.isArray(Ft[un])) (en = Ft[un]).push.apply(en, Pt);
            else {
              if (!Object.prototype.hasOwnProperty.call(Ft, un)) throw Error("An mj-head element add an unkown head attribute : ".concat(un, " with params ").concat(Array.isArray(Pt) ? Pt.join("") : Pt));
              1 < Pt.length ? (0, j.default)(Ft[un][Pt[0]]) ? Ft[un][Pt[0]] = _(_({}, Ft[un][Pt[0]]), Pt[1]) : Ft[un][Pt[0]] = Pt[1] : Ft[un] = Pt[0];
            }
          } }, Ft.headRaw = In(Se, Ye), !(er = In(nt, tt, On))) throw new Error("Malformed MJML. Check that your structure is correct and enclosed in <mjml> tags.");
          var ui, Fr, er = (0, ae.default)(er);
          return We.length && (ui = We.filter(function($n) {
            return $n.attributes.position && $n.attributes.position === "file-start";
          })).length && (Ft.beforeDoctype = ui.map(function($n) {
            return $n.content;
          }).join(`
`)), (0, k.default)(Ft.htmlAttributes) || (Fr = (0, K.load)(er, { xmlMode: !0, decodeEntities: !1 }), (0, N.default)(Ft.htmlAttributes, function($n, un) {
            (0, N.default)($n, function(en, bt) {
              Fr(un).each(function() {
                Fr(this).attr(bt, en || "");
              });
            });
          }), er = Fr.root().html()), er = Me(_(_({ content: er }, Ft), {}, { printerSupport: At })), 0 < Ft.inlineStyle.length && (Te && (0, N.default)(Te, function($n, un) {
            $.default.codeBlocks[un] = $n;
          }), er = (0, $.default)(er, _({ applyStyleTags: !1, extraCss: Ft.inlineStyle.join(""), insertPreservedExtraCss: !1, removeStyleTags: !1 }, he))), er = (0, oe.default)(er), Ze && (console.warn('"beautify" option is deprecated in mjml-core and only available in mjml cli.'), er = (0, te.html)(er, { indent_size: 2, wrap_attributes_indent_size: 2, max_preserve_newline: 0, preserve_newlines: !1 })), ke && (console.warn('"minify" option is deprecated in mjml-core and only available in mjml cli.'), er = (0, V.minify)(er, _({ collapseWhitespace: !0, minifyCSS: !1, caseSensitive: !0, removeEmptyAttributes: !0 }, pe))), { html: er, json: je, errors: qe };
        }, Object.defineProperty(s, "handleMjmlConfig", { enumerable: !0, get: function() {
          return Ee.default;
        } }), Object.defineProperty(s, "initComponent", { enumerable: !0, get: function() {
          return z.initComponent;
        } }), Object.defineProperty(s, "initializeType", { enumerable: !0, get: function() {
          return ve.initializeType;
        } }), Object.defineProperty(s, "makeLowerBreakpoint", { enumerable: !0, get: function() {
          return q.default;
        } }), Object.defineProperty(s, "registerComponent", { enumerable: !0, get: function() {
          return ee.registerComponent;
        } }), Object.defineProperty(s, "suffixCssClasses", { enumerable: !0, get: function() {
          return X.default;
        } });
        var E = v(r(4)), C = v(r(5)), y = v(r(6)), T = v(r(7)), A = v(r(245)), k = v(r(152)), N = v(r(157)), j = v(r(19)), I = v(r(57)), B = v(r(172)), U = v(r(60)), H = v(r(25)), Q = v(r(43)), Y = v(r(118)), ie = v(r(47)), ce = v(r(22)), $ = v(r(346)), te = r(183), V = r(362), K = r(240), ne = v(r(138)), J = b(r(93)), L = r(517), z = r(519), ee = b(r(232)), q = v(r(545)), X = v(r(546)), oe = v(r(547)), ae = v(r(548)), _e = v(r(549)), ve = r(28), Ee = b(r(554)), we = r(228), ze = function(Ie) {
          function je(qe, Ge) {
            return (0, C.default)(this, je), (qe = (0, y.default)(this, je, [qe])).errors = Ge, qe;
          }
          return (0, T.default)(je, Ie), (0, E.default)(je);
        }((0, A.default)(Error));
        we && (0, Ee.default)(l.cwd(), ee.registerComponent);
      }).call(this, r(15));
    }, function(a, s, r) {
      var l = this && this.__createBinding || (Object.create ? function(B, U, H, Q) {
        Q === void 0 && (Q = H);
        var Y = Object.getOwnPropertyDescriptor(U, H);
        Y && ("get" in Y ? U.__esModule : !Y.writable && !Y.configurable) || (Y = { enumerable: !0, get: function() {
          return U[H];
        } }), Object.defineProperty(B, Q, Y);
      } : function(B, U, H, Q) {
        B[Q = Q === void 0 ? H : Q] = U[H];
      }), d = this && this.__setModuleDefault || (Object.create ? function(B, U) {
        Object.defineProperty(B, "default", { enumerable: !0, value: U });
      } : function(B, U) {
        B.default = U;
      }), f = this && this.__importStar || function(B) {
        if (B && B.__esModule) return B;
        var U = {};
        if (B != null) for (var H in B) H !== "default" && Object.prototype.hasOwnProperty.call(B, H) && l(U, B, H);
        return d(U, B), U;
      }, h = this && this.__importDefault || function(B) {
        return B && B.__esModule ? B : { default: B };
      };
      Object.defineProperty(s, "__esModule", { value: !0 }), s.decodeXML = s.decodeHTMLStrict = s.decodeHTMLAttribute = s.decodeHTML = s.determineBranch = s.EntityDecoder = s.DecodingMode = s.BinTrieFlags = s.fromCodePoint = s.replaceCodePoint = s.decodeCodePoint = s.xmlDecodeTree = s.htmlDecodeTree = void 0;
      var p = h(r(350));
      s.htmlDecodeTree = p.default, h = h(r(351)), s.xmlDecodeTree = h.default;
      var g = f(r(181));
      s.decodeCodePoint = g.default;
      var _, b, v, E, C = r(181);
      function y(B) {
        return B >= _.ZERO && B <= _.NINE;
      }
      Object.defineProperty(s, "replaceCodePoint", { enumerable: !0, get: function() {
        return C.replaceCodePoint;
      } }), Object.defineProperty(s, "fromCodePoint", { enumerable: !0, get: function() {
        return C.fromCodePoint;
      } }), (r = _ = _ || {})[r.NUM = 35] = "NUM", r[r.SEMI = 59] = "SEMI", r[r.EQUALS = 61] = "EQUALS", r[r.ZERO = 48] = "ZERO", r[r.NINE = 57] = "NINE", r[r.LOWER_A = 97] = "LOWER_A", r[r.LOWER_F = 102] = "LOWER_F", r[r.LOWER_X = 120] = "LOWER_X", r[r.LOWER_Z = 122] = "LOWER_Z", r[r.UPPER_A = 65] = "UPPER_A", r[r.UPPER_F = 70] = "UPPER_F", r[r.UPPER_Z = 90] = "UPPER_Z", (r = b = s.BinTrieFlags || (s.BinTrieFlags = {}))[r.VALUE_LENGTH = 49152] = "VALUE_LENGTH", r[r.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", r[r.JUMP_TABLE = 127] = "JUMP_TABLE", (r = v = v || {})[r.EntityStart = 0] = "EntityStart", r[r.NumericStart = 1] = "NumericStart", r[r.NumericDecimal = 2] = "NumericDecimal", r[r.NumericHex = 3] = "NumericHex", r[r.NamedEntity = 4] = "NamedEntity", (r = E = s.DecodingMode || (s.DecodingMode = {}))[r.Legacy = 0] = "Legacy", r[r.Strict = 1] = "Strict", r[r.Attribute = 2] = "Attribute";
      var T = (A.prototype.startEntity = function(B) {
        this.decodeMode = B, this.state = v.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, A.prototype.write = function(B, U) {
        switch (this.state) {
          case v.EntityStart:
            return B.charCodeAt(U) === _.NUM ? (this.state = v.NumericStart, this.consumed += 1, this.stateNumericStart(B, U + 1)) : (this.state = v.NamedEntity, this.stateNamedEntity(B, U));
          case v.NumericStart:
            return this.stateNumericStart(B, U);
          case v.NumericDecimal:
            return this.stateNumericDecimal(B, U);
          case v.NumericHex:
            return this.stateNumericHex(B, U);
          case v.NamedEntity:
            return this.stateNamedEntity(B, U);
        }
      }, A.prototype.stateNumericStart = function(B, U) {
        return U >= B.length ? -1 : (32 | B.charCodeAt(U)) === _.LOWER_X ? (this.state = v.NumericHex, this.consumed += 1, this.stateNumericHex(B, U + 1)) : (this.state = v.NumericDecimal, this.stateNumericDecimal(B, U));
      }, A.prototype.addToNumericResult = function(B, U, H, Q) {
        U !== H && (H -= U, this.result = this.result * Math.pow(Q, H) + parseInt(B.substr(U, H), Q), this.consumed += H);
      }, A.prototype.stateNumericHex = function(B, U) {
        for (var H = U; U < B.length; ) {
          var Q = B.charCodeAt(U);
          if (!y(Q) && !function(ie) {
            return ie >= _.UPPER_A && ie <= _.UPPER_F || ie >= _.LOWER_A && ie <= _.LOWER_F;
          }(Q)) return this.addToNumericResult(B, H, U, 16), this.emitNumericEntity(Q, 3);
          U += 1;
        }
        return this.addToNumericResult(B, H, U, 16), -1;
      }, A.prototype.stateNumericDecimal = function(B, U) {
        for (var H = U; U < B.length; ) {
          var Q = B.charCodeAt(U);
          if (!y(Q)) return this.addToNumericResult(B, H, U, 10), this.emitNumericEntity(Q, 2);
          U += 1;
        }
        return this.addToNumericResult(B, H, U, 10), -1;
      }, A.prototype.emitNumericEntity = function(B, U) {
        if (this.consumed <= U) return (U = this.errors) !== null && U !== void 0 && U.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (B === _.SEMI) this.consumed += 1;
        else if (this.decodeMode === E.Strict) return 0;
        return this.emitCodePoint((0, g.replaceCodePoint)(this.result), this.consumed), this.errors && (B !== _.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, A.prototype.stateNamedEntity = function(B, U) {
        for (var H = this.decodeTree, Q = H[this.treeIndex], Y = (Q & b.VALUE_LENGTH) >> 14; U < B.length; U++, this.excess++) {
          var ie = B.charCodeAt(U);
          if (this.treeIndex = N(H, Q, this.treeIndex + Math.max(1, Y), ie), this.treeIndex < 0) return this.result === 0 || this.decodeMode === E.Attribute && (Y === 0 || function($) {
            return $ === _.EQUALS || function(V) {
              return V >= _.UPPER_A && V <= _.UPPER_Z || V >= _.LOWER_A && V <= _.LOWER_Z || y(V);
            }($);
          }(ie)) ? 0 : this.emitNotTerminatedNamedEntity();
          if ((Y = ((Q = H[this.treeIndex]) & b.VALUE_LENGTH) >> 14) != 0) {
            if (ie === _.SEMI) return this.emitNamedEntityData(this.treeIndex, Y, this.consumed + this.excess);
            this.decodeMode !== E.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, A.prototype.emitNotTerminatedNamedEntity = function() {
        var B = this.result, U = (this.decodeTree[B] & b.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(B, U, this.consumed), (U = this.errors) !== null && U !== void 0 && U.missingSemicolonAfterCharacterReference(), this.consumed;
      }, A.prototype.emitNamedEntityData = function(B, U, H) {
        var Q = this.decodeTree;
        return this.emitCodePoint(U === 1 ? Q[B] & ~b.VALUE_LENGTH : Q[B + 1], H), U === 3 && this.emitCodePoint(Q[B + 2], H), H;
      }, A.prototype.end = function() {
        var B;
        switch (this.state) {
          case v.NamedEntity:
            return this.result === 0 || this.decodeMode === E.Attribute && this.result !== this.treeIndex ? 0 : this.emitNotTerminatedNamedEntity();
          case v.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case v.NumericHex:
            return this.emitNumericEntity(0, 3);
          case v.NumericStart:
            return (B = this.errors) !== null && B !== void 0 && B.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case v.EntityStart:
            return 0;
        }
      }, A);
      function A(B, U, H) {
        this.decodeTree = B, this.emitCodePoint = U, this.errors = H, this.state = v.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = E.Strict;
      }
      function k(B) {
        var U = "", H = new T(B, function(Q) {
          return U += (0, g.fromCodePoint)(Q);
        });
        return function(Y, ie) {
          for (var ce = 0, $ = 0; 0 <= ($ = Y.indexOf("&", $)); ) {
            U += Y.slice(ce, $), H.startEntity(ie);
            var te = H.write(Y, $ + 1);
            if (te < 0) {
              ce = $ + H.end();
              break;
            }
            ce = $ + te, $ = te === 0 ? ce + 1 : ce;
          }
          var V = U + Y.slice(ce);
          return U = "", V;
        };
      }
      function N(B, ie, H, Q) {
        var Y = (ie & b.BRANCH_LENGTH) >> 7, ie = ie & b.JUMP_TABLE;
        if (Y == 0) return ie != 0 && Q === ie ? H : -1;
        if (ie) return (ie = Q - ie) < 0 || Y <= ie ? -1 : B[H + ie] - 1;
        for (var ce = H, $ = ce + Y - 1; ce <= $; ) {
          var te = ce + $ >>> 1, V = B[te];
          if (V < Q) ce = 1 + te;
          else {
            if (!(Q < V)) return B[te + Y];
            $ = te - 1;
          }
        }
        return -1;
      }
      s.EntityDecoder = T, s.determineBranch = N;
      var j = k(p.default), I = k(h.default);
      s.decodeHTML = function(U, H) {
        return H === void 0 && (H = E.Legacy), j(U, H);
      }, s.decodeHTMLAttribute = function(U) {
        return j(U, E.Attribute);
      }, s.decodeHTMLStrict = function(U) {
        return j(U, E.Strict);
      }, s.decodeXML = function(U) {
        return I(U, E.Strict);
      };
    }, function(a, s) {
      a.exports = { AT_RULE: "at-rule", AT_RULE_BLOCK: "at-rule-block", AT_RULE_BLOCK_SCOPE: "at-rule-block-scope", COMMENT: "comment", NESTED_BLOCK: "nested-block", NESTED_BLOCK_SCOPE: "nested-block-scope", PROPERTY: "property", PROPERTY_BLOCK: "property-block", PROPERTY_NAME: "property-name", PROPERTY_VALUE: "property-value", RAW: "raw", RULE: "rule", RULE_SCOPE: "rule-scope" };
    }, function(a, s) {
      var r = Array.isArray;
      a.exports = r;
    }, function(a, s, r) {
      var l = r(128);
      function d(h, p) {
        h.output.push(typeof p == "string" ? p : p[1]);
      }
      function f() {
        return { output: [], store: d };
      }
      a.exports = { all: function(p) {
        var g = f();
        return l.all(g, p), g.output.join("");
      }, body: function(p) {
        var g = f();
        return l.body(g, p), g.output.join("");
      }, property: function(p, g) {
        var _ = f();
        return l.property(_, p, g, !0), _.output.join("");
      }, rules: function(p) {
        var g = f();
        return l.rules(g, p), g.output.join("");
      }, value: function(p) {
        var g = f();
        return l.value(g, p), g.output.join("");
      } };
    }, function(d, s) {
      var r, l, d = d.exports = {};
      function f() {
        throw new Error("setTimeout has not been defined");
      }
      function h() {
        throw new Error("clearTimeout has not been defined");
      }
      function p(A) {
        if (r === setTimeout) return setTimeout(A, 0);
        if ((r === f || !r) && setTimeout) return r = setTimeout, setTimeout(A, 0);
        try {
          return r(A, 0);
        } catch {
          try {
            return r.call(null, A, 0);
          } catch {
            return r.call(this, A, 0);
          }
        }
      }
      (function() {
        try {
          r = typeof setTimeout == "function" ? setTimeout : f;
        } catch {
          r = f;
        }
        try {
          l = typeof clearTimeout == "function" ? clearTimeout : h;
        } catch {
          l = h;
        }
      })();
      var g, _ = [], b = !1, v = -1;
      function E() {
        b && g && (b = !1, g.length ? _ = g.concat(_) : v = -1, _.length && C());
      }
      function C() {
        if (!b) {
          var A = p(E);
          b = !0;
          for (var k = _.length; k; ) {
            for (g = _, _ = []; ++v < k; ) g && g[v].run();
            v = -1, k = _.length;
          }
          g = null, b = !1, function(j) {
            if (l === clearTimeout) return clearTimeout(j);
            if ((l === h || !l) && clearTimeout) return l = clearTimeout, clearTimeout(j);
            try {
              l(j);
            } catch {
              try {
                return l.call(null, j);
              } catch {
                return l.call(this, j);
              }
            }
          }(A);
        }
      }
      function y(A, k) {
        this.fun = A, this.array = k;
      }
      function T() {
      }
      d.nextTick = function(A) {
        var k = new Array(arguments.length - 1);
        if (1 < arguments.length) for (var N = 1; N < arguments.length; N++) k[N - 1] = arguments[N];
        _.push(new y(A, k)), _.length !== 1 || b || p(C);
      }, y.prototype.run = function() {
        this.fun.apply(null, this.array);
      }, d.title = "browser", d.browser = !0, d.env = {}, d.argv = [], d.version = "", d.versions = {}, d.on = T, d.addListener = T, d.once = T, d.off = T, d.removeListener = T, d.removeAllListeners = T, d.emit = T, d.prependListener = T, d.prependOnceListener = T, d.listeners = function(A) {
        return [];
      }, d.binding = function(A) {
        throw new Error("process.binding is not supported");
      }, d.cwd = function() {
        return "/";
      }, d.chdir = function(A) {
        throw new Error("process.chdir is not supported");
      }, d.umask = function() {
        return 0;
      };
    }, function(a, s) {
      a.exports = { ASTERISK: "*", AT: "@", BACK_SLASH: "\\", CARRIAGE_RETURN: "\r", CLOSE_CURLY_BRACKET: "}", CLOSE_ROUND_BRACKET: ")", CLOSE_SQUARE_BRACKET: "]", COLON: ":", COMMA: ",", DOUBLE_QUOTE: '"', EXCLAMATION: "!", FORWARD_SLASH: "/", INTERNAL: "-clean-css-", NEW_LINE_NIX: `
`, OPEN_CURLY_BRACKET: "{", OPEN_ROUND_BRACKET: "(", OPEN_SQUARE_BRACKET: "[", SEMICOLON: ";", SINGLE_QUOTE: "'", SPACE: " ", TAB: "	", UNDERSCORE: "_" };
    }, function(a, s, f) {
      function l(h) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
          return typeof p;
        } : function(p) {
          return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
        })(h);
      }
      var d = f(154), f = (typeof self > "u" ? "undefined" : l(self)) == "object" && self && self.Object === Object && self, f = d || f || Function("return this")();
      a.exports = f;
    }, function(a, s) {
      function r(d) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        })(d);
      }
      var l = /* @__PURE__ */ function() {
        return this;
      }();
      try {
        l = l || new Function("return this")();
      } catch {
        (typeof window > "u" ? "undefined" : r(window)) === "object" && (l = window);
      }
      a.exports = l;
    }, function(a, s) {
      function r(l) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        })(l);
      }
      a.exports = function(d) {
        var f = r(d);
        return d != null && (f == "object" || f == "function");
      };
    }, function(a, s) {
      function r(l) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        })(l);
      }
      a.exports = function(d) {
        return d != null && r(d) == "object";
      };
    }, function(a, s, r) {
      function l(_) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
          return typeof b;
        } : function(b) {
          return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
        })(_);
      }
      var d = r(266), f = r(300), h = r(25), p = r(13), g = r(307);
      a.exports = function(b) {
        return typeof b == "function" ? b : b == null ? h : l(b) == "object" ? p(b) ? f(b[0], b[1]) : d(b) : g(b);
      };
    }, function(a, s) {
      function r() {
        return console.warn("fs should not be used in browser build"), null;
      }
      a.exports = { parse: r, resolve: r, join: r, dirname: r, isAbsolute: r };
    }, function(a, s, r) {
      (function(l) {
        var d = r(348), f = r(349), h = r(180);
        function p() {
          return _.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function g(J, L) {
          if (p() < L) throw new RangeError("Invalid typed array length");
          return _.TYPED_ARRAY_SUPPORT ? (J = new Uint8Array(L)).__proto__ = _.prototype : (J = J === null ? new _(L) : J).length = L, J;
        }
        function _(J, L, z) {
          if (!(_.TYPED_ARRAY_SUPPORT || this instanceof _)) return new _(J, L, z);
          if (typeof J != "number") return b(this, J, L, z);
          if (typeof L == "string") throw new Error("If encoding is specified then the first argument must be a string");
          return E(this, J);
        }
        function b(J, L, z, ee) {
          if (typeof L == "number") throw new TypeError('"value" argument must not be a number');
          return typeof ArrayBuffer < "u" && L instanceof ArrayBuffer ? function(X, oe, ae, _e) {
            if (oe.byteLength, ae < 0 || oe.byteLength < ae) throw new RangeError("'offset' is out of bounds");
            if (oe.byteLength < ae + (_e || 0)) throw new RangeError("'length' is out of bounds");
            return oe = ae === void 0 && _e === void 0 ? new Uint8Array(oe) : _e === void 0 ? new Uint8Array(oe, ae) : new Uint8Array(oe, ae, _e), _.TYPED_ARRAY_SUPPORT ? (X = oe).__proto__ = _.prototype : X = C(X, oe), X;
          }(J, L, z, ee) : typeof L == "string" ? function(X, oe, ae) {
            if (!_.isEncoding(ae = typeof ae != "string" || ae === "" ? "utf8" : ae)) throw new TypeError('"encoding" must be a valid string encoding');
            var _e = 0 | T(oe, ae);
            return X = (ae = (X = g(X, _e)).write(oe, ae)) !== _e ? X.slice(0, ae) : X;
          }(J, L, z) : function(X, oe) {
            if (_.isBuffer(oe)) {
              var ae = 0 | y(oe.length);
              return (X = g(X, ae)).length === 0 || oe.copy(X, 0, 0, ae), X;
            }
            if (oe) {
              if (typeof ArrayBuffer < "u" && oe.buffer instanceof ArrayBuffer || "length" in oe) return typeof oe.length != "number" || function(ve) {
                return ve != ve;
              }(oe.length) ? g(X, 0) : C(X, oe);
              if (oe.type === "Buffer" && h(oe.data)) return C(X, oe.data);
            }
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(J, L);
        }
        function v(J) {
          if (typeof J != "number") throw new TypeError('"size" argument must be a number');
          if (J < 0) throw new RangeError('"size" argument must not be negative');
        }
        function E(J, L) {
          if (v(L), J = g(J, L < 0 ? 0 : 0 | y(L)), !_.TYPED_ARRAY_SUPPORT) for (var z = 0; z < L; ++z) J[z] = 0;
          return J;
        }
        function C(J, L) {
          var z = L.length < 0 ? 0 : 0 | y(L.length);
          J = g(J, z);
          for (var ee = 0; ee < z; ee += 1) J[ee] = 255 & L[ee];
          return J;
        }
        function y(J) {
          if (J >= p()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + p().toString(16) + " bytes");
          return 0 | J;
        }
        function T(J, L) {
          if (_.isBuffer(J)) return J.length;
          if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(J) || J instanceof ArrayBuffer)) return J.byteLength;
          var z = (J = typeof J != "string" ? "" + J : J).length;
          if (z === 0) return 0;
          for (var ee = !1; ; ) switch (L) {
            case "ascii":
            case "latin1":
            case "binary":
              return z;
            case "utf8":
            case "utf-8":
            case void 0:
              return V(J).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * z;
            case "hex":
              return z >>> 1;
            case "base64":
              return K(J).length;
            default:
              if (ee) return V(J).length;
              L = ("" + L).toLowerCase(), ee = !0;
          }
        }
        function A(J, L, z) {
          var ee = J[L];
          J[L] = J[z], J[z] = ee;
        }
        function k(J, L, z, ee, q) {
          if (J.length === 0) return -1;
          if (typeof z == "string" ? (ee = z, z = 0) : 2147483647 < z ? z = 2147483647 : z < -2147483648 && (z = -2147483648), z = +z, (z = (z = isNaN(z) ? q ? 0 : J.length - 1 : z) < 0 ? J.length + z : z) >= J.length) {
            if (q) return -1;
            z = J.length - 1;
          } else if (z < 0) {
            if (!q) return -1;
            z = 0;
          }
          if (typeof L == "string" && (L = _.from(L, ee)), _.isBuffer(L)) return L.length === 0 ? -1 : N(J, L, z, ee, q);
          if (typeof L == "number") return L &= 255, _.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? (q ? Uint8Array.prototype.indexOf : Uint8Array.prototype.lastIndexOf).call(J, L, z) : N(J, [L], z, ee, q);
          throw new TypeError("val must be string, number or Buffer");
        }
        function N(J, L, z, ee, q) {
          var X = 1, oe = J.length, ae = L.length;
          if (ee !== void 0 && ((ee = String(ee).toLowerCase()) === "ucs2" || ee === "ucs-2" || ee === "utf16le" || ee === "utf-16le")) {
            if (J.length < 2 || L.length < 2) return -1;
            oe /= X = 2, ae /= 2, z /= 2;
          }
          function _e(Ie, je) {
            return X === 1 ? Ie[je] : Ie.readUInt16BE(je * X);
          }
          if (q) for (var ve = -1, Ee = z; Ee < oe; Ee++) if (_e(J, Ee) === _e(L, ve === -1 ? 0 : Ee - ve)) {
            if (Ee - (ve = ve === -1 ? Ee : ve) + 1 === ae) return ve * X;
          } else ve !== -1 && (Ee -= Ee - ve), ve = -1;
          else for (Ee = z = oe < z + ae ? oe - ae : z; 0 <= Ee; Ee--) {
            for (var we = !0, ze = 0; ze < ae; ze++) if (_e(J, Ee + ze) !== _e(L, ze)) {
              we = !1;
              break;
            }
            if (we) return Ee;
          }
          return -1;
        }
        function j(J, L, z, ee) {
          return ne(function(X) {
            for (var oe = [], ae = 0; ae < X.length; ++ae) oe.push(255 & X.charCodeAt(ae));
            return oe;
          }(L), J, z, ee);
        }
        function I(J, L, z) {
          z = Math.min(J.length, z);
          for (var ee = [], q = L; q < z; ) {
            var X, oe, ae, _e, ve = J[q], Ee = null, we = 239 < ve ? 4 : 223 < ve ? 3 : 191 < ve ? 2 : 1;
            if (q + we <= z) switch (we) {
              case 1:
                ve < 128 && (Ee = ve);
                break;
              case 2:
                (192 & (X = J[q + 1])) == 128 && 127 < (_e = (31 & ve) << 6 | 63 & X) && (Ee = _e);
                break;
              case 3:
                X = J[q + 1], oe = J[q + 2], (192 & X) == 128 && (192 & oe) == 128 && 2047 < (_e = (15 & ve) << 12 | (63 & X) << 6 | 63 & oe) && (_e < 55296 || 57343 < _e) && (Ee = _e);
                break;
              case 4:
                X = J[q + 1], oe = J[q + 2], ae = J[q + 3], (192 & X) == 128 && (192 & oe) == 128 && (192 & ae) == 128 && 65535 < (_e = (15 & ve) << 18 | (63 & X) << 12 | (63 & oe) << 6 | 63 & ae) && _e < 1114112 && (Ee = _e);
            }
            Ee === null ? (Ee = 65533, we = 1) : 65535 < Ee && (Ee -= 65536, ee.push(Ee >>> 10 & 1023 | 55296), Ee = 56320 | 1023 & Ee), ee.push(Ee), q += we;
          }
          return function(Ie) {
            var je = Ie.length;
            if (je <= B) return String.fromCharCode.apply(String, Ie);
            for (var qe = "", Ge = 0; Ge < je; ) qe += String.fromCharCode.apply(String, Ie.slice(Ge, Ge += B));
            return qe;
          }(ee);
        }
        s.Buffer = _, s.SlowBuffer = function(L) {
          return _.alloc(+(L = +L != L ? 0 : L));
        }, s.INSPECT_MAX_BYTES = 50, _.TYPED_ARRAY_SUPPORT = l.TYPED_ARRAY_SUPPORT !== void 0 ? l.TYPED_ARRAY_SUPPORT : function() {
          try {
            var L = new Uint8Array(1);
            return L.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
              return 42;
            } }, L.foo() === 42 && typeof L.subarray == "function" && L.subarray(1, 1).byteLength === 0;
          } catch {
            return !1;
          }
        }(), s.kMaxLength = p(), _.poolSize = 8192, _._augment = function(J) {
          return J.__proto__ = _.prototype, J;
        }, _.from = function(J, L, z) {
          return b(null, J, L, z);
        }, _.TYPED_ARRAY_SUPPORT && (_.prototype.__proto__ = Uint8Array.prototype, _.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && _[Symbol.species] === _ && Object.defineProperty(_, Symbol.species, { value: null, configurable: !0 })), _.alloc = function(J, L, z) {
          return function(q, X, oe, ae) {
            return v(X), X <= 0 || oe === void 0 ? g(q, X) : typeof ae == "string" ? g(q, X).fill(oe, ae) : g(q, X).fill(oe);
          }(null, J, L, z);
        }, _.allocUnsafe = function(J) {
          return E(null, J);
        }, _.allocUnsafeSlow = function(J) {
          return E(null, J);
        }, _.isBuffer = function(L) {
          return !(L == null || !L._isBuffer);
        }, _.compare = function(L, z) {
          if (!_.isBuffer(L) || !_.isBuffer(z)) throw new TypeError("Arguments must be Buffers");
          if (L === z) return 0;
          for (var ee = L.length, q = z.length, X = 0, oe = Math.min(ee, q); X < oe; ++X) if (L[X] !== z[X]) {
            ee = L[X], q = z[X];
            break;
          }
          return ee < q ? -1 : q < ee ? 1 : 0;
        }, _.isEncoding = function(L) {
          switch (String(L).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, _.concat = function(L, z) {
          if (!h(L)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (L.length === 0) return _.alloc(0);
          if (z === void 0) for (X = z = 0; X < L.length; ++X) z += L[X].length;
          for (var ee = _.allocUnsafe(z), q = 0, X = 0; X < L.length; ++X) {
            var oe = L[X];
            if (!_.isBuffer(oe)) throw new TypeError('"list" argument must be an Array of Buffers');
            oe.copy(ee, q), q += oe.length;
          }
          return ee;
        }, _.byteLength = T, _.prototype._isBuffer = !0, _.prototype.swap16 = function() {
          var L = this.length;
          if (L % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (var z = 0; z < L; z += 2) A(this, z, z + 1);
          return this;
        }, _.prototype.swap32 = function() {
          var L = this.length;
          if (L % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (var z = 0; z < L; z += 4) A(this, z, z + 3), A(this, z + 1, z + 2);
          return this;
        }, _.prototype.swap64 = function() {
          var L = this.length;
          if (L % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (var z = 0; z < L; z += 8) A(this, z, z + 7), A(this, z + 1, z + 6), A(this, z + 2, z + 5), A(this, z + 3, z + 4);
          return this;
        }, _.prototype.toString = function() {
          var L = 0 | this.length;
          return L == 0 ? "" : arguments.length === 0 ? I(this, 0, L) : (function(ee, q, X) {
            var oe = !1;
            if ((q = q === void 0 || q < 0 ? 0 : q) > this.length || (X = X === void 0 || X > this.length ? this.length : X) <= 0 || (X >>>= 0) <= (q >>>= 0)) return "";
            for (ee = ee || "utf8"; ; ) switch (ee) {
              case "hex":
                return function(_e, ve, Ee) {
                  var we = _e.length;
                  (!Ee || Ee < 0 || we < Ee) && (Ee = we);
                  for (var ze = "", Ie = ve = !ve || ve < 0 ? 0 : ve; Ie < Ee; ++Ie) ze += function(qe) {
                    return qe < 16 ? "0" + qe.toString(16) : qe.toString(16);
                  }(_e[Ie]);
                  return ze;
                }(this, q, X);
              case "utf8":
              case "utf-8":
                return I(this, q, X);
              case "ascii":
                return function(_e, ve, Ee) {
                  var we = "";
                  Ee = Math.min(_e.length, Ee);
                  for (var ze = ve; ze < Ee; ++ze) we += String.fromCharCode(127 & _e[ze]);
                  return we;
                }(this, q, X);
              case "latin1":
              case "binary":
                return function(_e, ve, Ee) {
                  var we = "";
                  Ee = Math.min(_e.length, Ee);
                  for (var ze = ve; ze < Ee; ++ze) we += String.fromCharCode(_e[ze]);
                  return we;
                }(this, q, X);
              case "base64":
                return function(_e, ve, Ee) {
                  return ve === 0 && Ee === _e.length ? d.fromByteArray(_e) : d.fromByteArray(_e.slice(ve, Ee));
                }(this, q, X);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return function(_e, ve, Ee) {
                  for (var we = _e.slice(ve, Ee), ze = "", Ie = 0; Ie < we.length; Ie += 2) ze += String.fromCharCode(we[Ie] + 256 * we[Ie + 1]);
                  return ze;
                }(this, q, X);
              default:
                if (oe) throw new TypeError("Unknown encoding: " + ee);
                ee = (ee + "").toLowerCase(), oe = !0;
            }
          }).apply(this, arguments);
        }, _.prototype.equals = function(L) {
          if (!_.isBuffer(L)) throw new TypeError("Argument must be a Buffer");
          return this === L || _.compare(this, L) === 0;
        }, _.prototype.inspect = function() {
          var L = "", z = s.INSPECT_MAX_BYTES;
          return 0 < this.length && (L = this.toString("hex", 0, z).match(/.{2}/g).join(" "), this.length > z && (L += " ... ")), "<Buffer " + L + ">";
        }, _.prototype.compare = function(L, z, ee, q, X) {
          if (!_.isBuffer(L)) throw new TypeError("Argument must be a Buffer");
          if (ee === void 0 && (ee = L ? L.length : 0), q === void 0 && (q = 0), X === void 0 && (X = this.length), (z = z === void 0 ? 0 : z) < 0 || ee > L.length || q < 0 || X > this.length) throw new RangeError("out of range index");
          if (X <= q && ee <= z) return 0;
          if (X <= q) return -1;
          if (ee <= z) return 1;
          if (this === L) return 0;
          for (var oe = (X >>>= 0) - (q >>>= 0), ae = (ee >>>= 0) - (z >>>= 0), _e = Math.min(oe, ae), ve = this.slice(q, X), Ee = L.slice(z, ee), we = 0; we < _e; ++we) if (ve[we] !== Ee[we]) {
            oe = ve[we], ae = Ee[we];
            break;
          }
          return oe < ae ? -1 : ae < oe ? 1 : 0;
        }, _.prototype.includes = function(L, z, ee) {
          return this.indexOf(L, z, ee) !== -1;
        }, _.prototype.indexOf = function(L, z, ee) {
          return k(this, L, z, ee, !0);
        }, _.prototype.lastIndexOf = function(L, z, ee) {
          return k(this, L, z, ee, !1);
        }, _.prototype.write = function(L, z, ee, q) {
          if (z === void 0) q = "utf8", ee = this.length, z = 0;
          else if (ee === void 0 && typeof z == "string") q = z, ee = this.length, z = 0;
          else {
            if (!isFinite(z)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            z |= 0, isFinite(ee) ? (ee |= 0, q === void 0 && (q = "utf8")) : (q = ee, ee = void 0);
          }
          var X = this.length - z;
          if ((ee === void 0 || X < ee) && (ee = X), 0 < L.length && (ee < 0 || z < 0) || z > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          q = q || "utf8";
          for (var oe = !1; ; ) switch (q) {
            case "hex":
              return function(_e, ve, Ee, we) {
                Ee = Number(Ee) || 0;
                var ze = _e.length - Ee;
                if ((!we || ze < (we = Number(we))) && (we = ze), (ze = ve.length) % 2 != 0) throw new TypeError("Invalid hex string");
                ze / 2 < we && (we = ze / 2);
                for (var Ie = 0; Ie < we; ++Ie) {
                  var je = parseInt(ve.substr(2 * Ie, 2), 16);
                  if (isNaN(je)) return Ie;
                  _e[Ee + Ie] = je;
                }
                return Ie;
              }(this, L, z, ee);
            case "utf8":
            case "utf-8":
              return function(_e, ve, Ee, we) {
                return ne(V(ve, _e.length - Ee), _e, Ee, we);
              }(this, L, z, ee);
            case "ascii":
              return j(this, L, z, ee);
            case "latin1":
            case "binary":
              return j(this, L, z, ee);
            case "base64":
              return function(_e, ve, Ee, we) {
                return ne(K(ve), _e, Ee, we);
              }(this, L, z, ee);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return function(_e, ve, Ee, we) {
                return ne(function(Ie, je) {
                  for (var qe, Ge, Ze = [], tt = 0; tt < Ie.length && !((je -= 2) < 0); ++tt) qe = (Ge = Ie.charCodeAt(tt)) >> 8, Ze.push(Ge %= 256), Ze.push(qe);
                  return Ze;
                }(ve, _e.length - Ee), _e, Ee, we);
              }(this, L, z, ee);
            default:
              if (oe) throw new TypeError("Unknown encoding: " + q);
              q = ("" + q).toLowerCase(), oe = !0;
          }
        }, _.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        };
        var B = 4096;
        function U(J, L, z) {
          if (J % 1 != 0 || J < 0) throw new RangeError("offset is not uint");
          if (z < J + L) throw new RangeError("Trying to access beyond buffer length");
        }
        function H(J, L, z, ee, q, X) {
          if (!_.isBuffer(J)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (q < L || L < X) throw new RangeError('"value" argument is out of bounds');
          if (z + ee > J.length) throw new RangeError("Index out of range");
        }
        function Q(J, L, z, ee) {
          L < 0 && (L = 65535 + L + 1);
          for (var q = 0, X = Math.min(J.length - z, 2); q < X; ++q) J[z + q] = (L & 255 << 8 * (ee ? q : 1 - q)) >>> 8 * (ee ? q : 1 - q);
        }
        function Y(J, L, z, ee) {
          L < 0 && (L = 4294967295 + L + 1);
          for (var q = 0, X = Math.min(J.length - z, 4); q < X; ++q) J[z + q] = L >>> 8 * (ee ? q : 3 - q) & 255;
        }
        function ie(J, L, z, ee) {
          if (z + ee > J.length) throw new RangeError("Index out of range");
          if (z < 0) throw new RangeError("Index out of range");
        }
        function ce(J, L, z, ee, q) {
          return q || ie(J, 0, z, 4), f.write(J, L, z, ee, 23, 4), z + 4;
        }
        function $(J, L, z, ee, q) {
          return q || ie(J, 0, z, 8), f.write(J, L, z, ee, 52, 8), z + 8;
        }
        _.prototype.slice = function(L, z) {
          var ee = this.length;
          if ((L = ~~L) < 0 ? (L += ee) < 0 && (L = 0) : ee < L && (L = ee), (z = z === void 0 ? ee : ~~z) < 0 ? (z += ee) < 0 && (z = 0) : ee < z && (z = ee), z < L && (z = L), _.TYPED_ARRAY_SUPPORT) (X = this.subarray(L, z)).__proto__ = _.prototype;
          else for (var q = z - L, X = new _(q, void 0), oe = 0; oe < q; ++oe) X[oe] = this[oe + L];
          return X;
        }, _.prototype.readUIntLE = function(L, z, ee) {
          L |= 0, z |= 0, ee || U(L, z, this.length);
          for (var q = this[L], X = 1, oe = 0; ++oe < z && (X *= 256); ) q += this[L + oe] * X;
          return q;
        }, _.prototype.readUIntBE = function(L, z, ee) {
          L |= 0, z |= 0, ee || U(L, z, this.length);
          for (var q = this[L + --z], X = 1; 0 < z && (X *= 256); ) q += this[L + --z] * X;
          return q;
        }, _.prototype.readUInt8 = function(L, z) {
          return z || U(L, 1, this.length), this[L];
        }, _.prototype.readUInt16LE = function(L, z) {
          return z || U(L, 2, this.length), this[L] | this[L + 1] << 8;
        }, _.prototype.readUInt16BE = function(L, z) {
          return z || U(L, 2, this.length), this[L] << 8 | this[L + 1];
        }, _.prototype.readUInt32LE = function(L, z) {
          return z || U(L, 4, this.length), (this[L] | this[L + 1] << 8 | this[L + 2] << 16) + 16777216 * this[L + 3];
        }, _.prototype.readUInt32BE = function(L, z) {
          return z || U(L, 4, this.length), 16777216 * this[L] + (this[L + 1] << 16 | this[L + 2] << 8 | this[L + 3]);
        }, _.prototype.readIntLE = function(L, z, ee) {
          L |= 0, z |= 0, ee || U(L, z, this.length);
          for (var q = this[L], X = 1, oe = 0; ++oe < z && (X *= 256); ) q += this[L + oe] * X;
          return (X *= 128) <= q && (q -= Math.pow(2, 8 * z)), q;
        }, _.prototype.readIntBE = function(L, z, ee) {
          L |= 0, z |= 0, ee || U(L, z, this.length);
          for (var q = z, X = 1, oe = this[L + --q]; 0 < q && (X *= 256); ) oe += this[L + --q] * X;
          return (X *= 128) <= oe && (oe -= Math.pow(2, 8 * z)), oe;
        }, _.prototype.readInt8 = function(L, z) {
          return z || U(L, 1, this.length), 128 & this[L] ? -1 * (255 - this[L] + 1) : this[L];
        }, _.prototype.readInt16LE = function(L, z) {
          return z || U(L, 2, this.length), 32768 & (L = this[L] | this[L + 1] << 8) ? 4294901760 | L : L;
        }, _.prototype.readInt16BE = function(L, z) {
          return z || U(L, 2, this.length), 32768 & (L = this[L + 1] | this[L] << 8) ? 4294901760 | L : L;
        }, _.prototype.readInt32LE = function(L, z) {
          return z || U(L, 4, this.length), this[L] | this[L + 1] << 8 | this[L + 2] << 16 | this[L + 3] << 24;
        }, _.prototype.readInt32BE = function(L, z) {
          return z || U(L, 4, this.length), this[L] << 24 | this[L + 1] << 16 | this[L + 2] << 8 | this[L + 3];
        }, _.prototype.readFloatLE = function(L, z) {
          return z || U(L, 4, this.length), f.read(this, L, !0, 23, 4);
        }, _.prototype.readFloatBE = function(L, z) {
          return z || U(L, 4, this.length), f.read(this, L, !1, 23, 4);
        }, _.prototype.readDoubleLE = function(L, z) {
          return z || U(L, 8, this.length), f.read(this, L, !0, 52, 8);
        }, _.prototype.readDoubleBE = function(L, z) {
          return z || U(L, 8, this.length), f.read(this, L, !1, 52, 8);
        }, _.prototype.writeUIntLE = function(L, z, ee, q) {
          L = +L, z |= 0, ee |= 0, q || H(this, L, z, ee, Math.pow(2, 8 * ee) - 1, 0);
          var X = 1, oe = 0;
          for (this[z] = 255 & L; ++oe < ee && (X *= 256); ) this[z + oe] = L / X & 255;
          return z + ee;
        }, _.prototype.writeUIntBE = function(L, z, ee, q) {
          L = +L, z |= 0, ee |= 0, q || H(this, L, z, ee, Math.pow(2, 8 * ee) - 1, 0);
          var X = ee - 1, oe = 1;
          for (this[z + X] = 255 & L; 0 <= --X && (oe *= 256); ) this[z + X] = L / oe & 255;
          return z + ee;
        }, _.prototype.writeUInt8 = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 1, 255, 0), _.TYPED_ARRAY_SUPPORT || (L = Math.floor(L)), this[z] = 255 & L, z + 1;
        }, _.prototype.writeUInt16LE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 2, 65535, 0), _.TYPED_ARRAY_SUPPORT ? (this[z] = 255 & L, this[z + 1] = L >>> 8) : Q(this, L, z, !0), z + 2;
        }, _.prototype.writeUInt16BE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 2, 65535, 0), _.TYPED_ARRAY_SUPPORT ? (this[z] = L >>> 8, this[z + 1] = 255 & L) : Q(this, L, z, !1), z + 2;
        }, _.prototype.writeUInt32LE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 4, 4294967295, 0), _.TYPED_ARRAY_SUPPORT ? (this[z + 3] = L >>> 24, this[z + 2] = L >>> 16, this[z + 1] = L >>> 8, this[z] = 255 & L) : Y(this, L, z, !0), z + 4;
        }, _.prototype.writeUInt32BE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 4, 4294967295, 0), _.TYPED_ARRAY_SUPPORT ? (this[z] = L >>> 24, this[z + 1] = L >>> 16, this[z + 2] = L >>> 8, this[z + 3] = 255 & L) : Y(this, L, z, !1), z + 4;
        }, _.prototype.writeIntLE = function(L, z, ee, q) {
          L = +L, z |= 0, q || H(this, L, z, ee, (q = Math.pow(2, 8 * ee - 1)) - 1, -q);
          var X = 0, oe = 1, ae = 0;
          for (this[z] = 255 & L; ++X < ee && (oe *= 256); ) L < 0 && ae === 0 && this[z + X - 1] !== 0 && (ae = 1), this[z + X] = (L / oe >> 0) - ae & 255;
          return z + ee;
        }, _.prototype.writeIntBE = function(L, z, ee, q) {
          L = +L, z |= 0, q || H(this, L, z, ee, (q = Math.pow(2, 8 * ee - 1)) - 1, -q);
          var X = ee - 1, oe = 1, ae = 0;
          for (this[z + X] = 255 & L; 0 <= --X && (oe *= 256); ) L < 0 && ae === 0 && this[z + X + 1] !== 0 && (ae = 1), this[z + X] = (L / oe >> 0) - ae & 255;
          return z + ee;
        }, _.prototype.writeInt8 = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 1, 127, -128), _.TYPED_ARRAY_SUPPORT || (L = Math.floor(L)), this[z] = 255 & (L = L < 0 ? 255 + L + 1 : L), z + 1;
        }, _.prototype.writeInt16LE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 2, 32767, -32768), _.TYPED_ARRAY_SUPPORT ? (this[z] = 255 & L, this[z + 1] = L >>> 8) : Q(this, L, z, !0), z + 2;
        }, _.prototype.writeInt16BE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 2, 32767, -32768), _.TYPED_ARRAY_SUPPORT ? (this[z] = L >>> 8, this[z + 1] = 255 & L) : Q(this, L, z, !1), z + 2;
        }, _.prototype.writeInt32LE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 4, 2147483647, -2147483648), _.TYPED_ARRAY_SUPPORT ? (this[z] = 255 & L, this[z + 1] = L >>> 8, this[z + 2] = L >>> 16, this[z + 3] = L >>> 24) : Y(this, L, z, !0), z + 4;
        }, _.prototype.writeInt32BE = function(L, z, ee) {
          return L = +L, z |= 0, ee || H(this, L, z, 4, 2147483647, -2147483648), L < 0 && (L = 4294967295 + L + 1), _.TYPED_ARRAY_SUPPORT ? (this[z] = L >>> 24, this[z + 1] = L >>> 16, this[z + 2] = L >>> 8, this[z + 3] = 255 & L) : Y(this, L, z, !1), z + 4;
        }, _.prototype.writeFloatLE = function(L, z, ee) {
          return ce(this, L, z, !0, ee);
        }, _.prototype.writeFloatBE = function(L, z, ee) {
          return ce(this, L, z, !1, ee);
        }, _.prototype.writeDoubleLE = function(L, z, ee) {
          return $(this, L, z, !0, ee);
        }, _.prototype.writeDoubleBE = function(L, z, ee) {
          return $(this, L, z, !1, ee);
        }, _.prototype.copy = function(L, z, ee, q) {
          if (ee = ee || 0, q || q === 0 || (q = this.length), z >= L.length && (z = L.length), (q = 0 < q && q < ee ? ee : q) === ee || L.length === 0 || this.length === 0) return 0;
          if ((z = z || 0) < 0) throw new RangeError("targetStart out of bounds");
          if (ee < 0 || ee >= this.length) throw new RangeError("sourceStart out of bounds");
          if (q < 0) throw new RangeError("sourceEnd out of bounds");
          q > this.length && (q = this.length);
          var X, oe = (q = L.length - z < q - ee ? L.length - z + ee : q) - ee;
          if (this === L && ee < z && z < q) for (X = oe - 1; 0 <= X; --X) L[X + z] = this[X + ee];
          else if (oe < 1e3 || !_.TYPED_ARRAY_SUPPORT) for (X = 0; X < oe; ++X) L[X + z] = this[X + ee];
          else Uint8Array.prototype.set.call(L, this.subarray(ee, ee + oe), z);
          return oe;
        }, _.prototype.fill = function(L, z, ee, q) {
          if (typeof L == "string") {
            var X;
            if (typeof z == "string" ? (q = z, z = 0, ee = this.length) : typeof ee == "string" && (q = ee, ee = this.length), L.length !== 1 || (X = L.charCodeAt(0)) < 256 && (L = X), q !== void 0 && typeof q != "string") throw new TypeError("encoding must be a string");
            if (typeof q == "string" && !_.isEncoding(q)) throw new TypeError("Unknown encoding: " + q);
          } else typeof L == "number" && (L &= 255);
          if (z < 0 || this.length < z || this.length < ee) throw new RangeError("Out of range index");
          if (ee <= z) return this;
          if (z >>>= 0, ee = ee === void 0 ? this.length : ee >>> 0, typeof (L = L || 0) == "number") for (_e = z; _e < ee; ++_e) this[_e] = L;
          else for (var oe = _.isBuffer(L) ? L : V(new _(L, q).toString()), ae = oe.length, _e = 0; _e < ee - z; ++_e) this[_e + z] = oe[_e % ae];
          return this;
        };
        var te = /[^+\/0-9A-Za-z-_]/g;
        function V(J, L) {
          var z;
          L = L || 1 / 0;
          for (var ee = J.length, q = null, X = [], oe = 0; oe < ee; ++oe) {
            if (55295 < (z = J.charCodeAt(oe)) && z < 57344) {
              if (!q) {
                if (56319 < z) {
                  -1 < (L -= 3) && X.push(239, 191, 189);
                  continue;
                }
                if (oe + 1 === ee) {
                  -1 < (L -= 3) && X.push(239, 191, 189);
                  continue;
                }
                q = z;
                continue;
              }
              if (z < 56320) {
                -1 < (L -= 3) && X.push(239, 191, 189), q = z;
                continue;
              }
              z = 65536 + (q - 55296 << 10 | z - 56320);
            } else q && -1 < (L -= 3) && X.push(239, 191, 189);
            if (q = null, z < 128) {
              if (--L < 0) break;
              X.push(z);
            } else if (z < 2048) {
              if ((L -= 2) < 0) break;
              X.push(z >> 6 | 192, 63 & z | 128);
            } else if (z < 65536) {
              if ((L -= 3) < 0) break;
              X.push(z >> 12 | 224, z >> 6 & 63 | 128, 63 & z | 128);
            } else {
              if (!(z < 1114112)) throw new Error("Invalid code point");
              if ((L -= 4) < 0) break;
              X.push(z >> 18 | 240, z >> 12 & 63 | 128, z >> 6 & 63 | 128, 63 & z | 128);
            }
          }
          return X;
        }
        function K(J) {
          return d.toByteArray(function(z) {
            if ((z = function(q) {
              return q.trim ? q.trim() : q.replace(/^\s+|\s+$/g, "");
            }(z).replace(te, "")).length < 2) return "";
            for (; z.length % 4 != 0; ) z += "=";
            return z;
          }(J));
        }
        function ne(J, L, z, ee) {
          for (var q = 0; q < ee && !(q + z >= L.length || q >= J.length); ++q) L[q + z] = J[q];
          return q;
        }
      }).call(this, r(18));
    }, function(a, s, r) {
      (function(l) {
        r.d(s, "a", function() {
          return h;
        }), r.d(s, "b", function() {
          return p;
        });
        var d = r(3), f = r(0);
        function h(g) {
          return function(b, v, E, C) {
            return typeof (b = l !== void 0 && l.isBuffer(b) ? b.toString() : b) == "string" ? g(b, v, E, C) : (C = b, !Array.isArray(C) && Object(f.l)(C) ? C : (p(C, b = new f.b([])), b));
          };
        }
        function p(g, _) {
          var b = Array.isArray(g) ? g : [g];
          _ ? _.children = b : _ = null;
          for (var v = 0; v < b.length; v++) {
            var E = b[v];
            E.parent && E.parent.children !== b && Object(d.removeElement)(E), _ ? (E.prev = b[v - 1] || null, E.next = b[v + 1] || null) : E.prev = E.next = null, E.parent = _;
          }
          return _;
        }
      }).call(this, r(23).Buffer);
    }, function(a, s) {
      a.exports = function(l) {
        return l;
      };
    }, function(a, s, r) {
      function l(T) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
          return typeof A;
        } : function(A) {
          return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
        })(T);
      }
      var d = r(185).roundingPrecisionFrom, f = r(48), h = { Zero: "0", One: "1", Two: "2" }, p = {};
      p[h.Zero] = {}, p[h.One] = { cleanupCharsets: !0, normalizeUrls: !0, optimizeBackground: !0, optimizeBorderRadius: !0, optimizeFilter: !0, optimizeFontWeight: !0, optimizeOutline: !0, removeEmpty: !0, removeNegativePaddings: !0, removeQuotes: !0, removeWhitespace: !0, replaceMultipleZeros: !0, replaceTimeUnits: !0, replaceZeroUnits: !0, roundingPrecision: d(void 0), selectorsSortingMethod: "standard", specialComments: "all", tidyAtRules: !0, tidyBlockScopes: !0, tidySelectors: !0, transform: function() {
      } }, p[h.Two] = { mergeAdjacentRules: !0, mergeIntoShorthands: !0, mergeMedia: !0, mergeNonAdjacentRules: !0, mergeSemantically: !1, overrideProperties: !0, removeEmpty: !0, reduceNonAdjacentRules: !0, removeDuplicateFontRules: !0, removeDuplicateMediaBlocks: !0, removeDuplicateRules: !0, removeUnusedAtRules: !1, restructureRules: !1, skipProperties: [] };
      var g = "all", _ = "false", b = "off", v = "true", E = "on";
      function C(T, A) {
        var k, N = f(p[T], {});
        for (k in N) typeof N[k] == "boolean" && (N[k] = A);
        return N;
      }
      function y(T) {
        switch (T) {
          case _:
          case b:
            return !1;
          case v:
          case E:
            return !0;
          default:
            return T;
        }
      }
      a.exports = { OptimizationLevel: h, optimizationLevelFrom: function(A) {
        var k = f(p, {}), N = h.Zero, j = h.One, I = h.Two;
        return A === void 0 ? delete k[I] : typeof (A = typeof A == "string" ? parseInt(A) : A) == "number" && A === parseInt(I) || (typeof A == "number" && A === parseInt(j) ? delete k[I] : typeof A == "number" && A === parseInt(N) ? (delete k[I], delete k[j]) : (j in (A = l(A) == "object" ? function(U) {
          for (var H, Q = f(U, {}), Y = 0; Y <= 2; Y++) (H = "" + Y) in Q && (Q[H] === void 0 || Q[H] === !1) && delete Q[H], H in Q && Q[H] === !0 && (Q[H] = {}), H in Q && typeof Q[H] == "string" && (Q[H] = function(ce, $) {
            return ce.split(";").reduce(function(te, K) {
              var K = (ne = K.split(":"))[0], ne = y(ne[1]);
              return K == "*" || g == K ? te = f(te, C($, ne)) : te[K] = ne, te;
            }, {});
          }(Q[H], H));
          return Q;
        }(A) : A) && "roundingPrecision" in A[j] && (A[j].roundingPrecision = d(A[j].roundingPrecision)), I in A && "skipProperties" in A[I] && typeof A[I].skipProperties == "string" && (A[I].skipProperties = A[I].skipProperties.split(",")), (N in A || j in A || I in A) && (k[N] = f(k[N], A[N])), j in A && "*" in A[j] && (k[j] = f(k[j], C(j, y(A[j]["*"]))), delete A[j]["*"]), j in A && g in A[j] && (k[j] = f(k[j], C(j, y(A[j].all))), delete A[j].all), j in A || I in A ? k[j] = f(k[j], A[j]) : delete k[j], I in A && "*" in A[I] && (k[I] = f(k[I], C(I, y(A[I]["*"]))), delete A[I]["*"]), I in A && g in A[I] && (k[I] = f(k[I], C(I, y(A[I].all))), delete A[I].all), I in A ? k[I] = f(k[I], A[I]) : delete k[I])), k;
      } };
    }, function(a, s, r) {
      function l(I) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(B) {
          return typeof B;
        } : function(B) {
          return B && typeof Symbol == "function" && B.constructor === Symbol && B !== Symbol.prototype ? "symbol" : typeof B;
        })(I);
      }
      var d = r(414);
      function f() {
        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
      }
      var h = /^([a-z0-9.+-]+:)/i, p = /:[0-9]*$/, g = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, _ = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", `
`, "	"]), b = ["'"].concat(_), v = ["%", "/", "?", ";", "#"].concat(b), E = ["/", "?", "#"], C = /^[+a-z0-9A-Z_-]{0,63}$/, y = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, T = { javascript: !0, "javascript:": !0 }, A = { javascript: !0, "javascript:": !0 }, k = { http: !0, https: !0, ftp: !0, gopher: !0, file: !0, "http:": !0, "https:": !0, "ftp:": !0, "gopher:": !0, "file:": !0 }, N = r(415);
      function j(I, B, U) {
        if (I && l(I) === "object" && I instanceof f) return I;
        var H = new f();
        return H.parse(I, B, U), H;
      }
      f.prototype.parse = function(I, B, U) {
        if (typeof I != "string") throw new TypeError("Parameter 'url' must be a string, not " + l(I));
        var H = I.indexOf("?"), Q = H !== -1 && H < I.indexOf("#") ? "?" : "#";
        (H = I.split(Q))[0] = H[0].replace(/\\/g, "/");
        var Y, ie, ce, $ = ($ = I = H.join(Q)).trim();
        if (!U && I.split("#").length === 1 && (ie = g.exec($))) return this.path = $, this.href = $, this.pathname = ie[1], ie[2] ? (this.search = ie[2], this.query = B ? N.parse(this.search.substr(1)) : this.search.substr(1)) : B && (this.search = "", this.query = {}), this;
        if ((ie = h.exec($)) && (ce = (ie = ie[0]).toLowerCase(), this.protocol = ce, $ = $.substr(ie.length)), (U || ie || $.match(/^\/\/[^@/]+@[^@/]+/)) && (!(Y = $.substr(0, 2) === "//") || ie && A[ie] || ($ = $.substr(2), this.slashes = !0)), !A[ie] && (Y || ie && !k[ie])) {
          for (var te = -1, V = 0; V < E.length; V++) (K = $.indexOf(E[V])) !== -1 && (te === -1 || K < te) && (te = K);
          (ve = te === -1 ? $.lastIndexOf("@") : $.lastIndexOf("@", te)) !== -1 && (Ee = $.slice(0, ve), $ = $.slice(ve + 1), this.auth = decodeURIComponent(Ee));
          for (var K, ne, te = -1, V = 0; V < v.length; V++) (K = $.indexOf(v[V])) !== -1 && (te === -1 || K < te) && (te = K);
          if (te === -1 && (te = $.length), this.host = $.slice(0, te), $ = $.slice(te), this.parseHost(), this.hostname = this.hostname || "", !(ne = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]")) for (var J = this.hostname.split(/\./), V = 0, L = J.length; V < L; V++) {
            var z = J[V];
            if (z && !z.match(C)) {
              for (var ee = "", q = 0, X = z.length; q < X; q++) 127 < z.charCodeAt(q) ? ee += "x" : ee += z[q];
              if (!ee.match(C)) {
                var oe = J.slice(0, V), ae = J.slice(V + 1), _e = z.match(y);
                _e && (oe.push(_e[1]), ae.unshift(_e[2])), ae.length && ($ = "/" + ae.join(".") + $), this.hostname = oe.join(".");
                break;
              }
            }
          }
          255 < this.hostname.length ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), ne || (this.hostname = d.toASCII(this.hostname));
          var ve = this.port ? ":" + this.port : "", Ee = this.hostname || "";
          this.host = Ee + ve, this.href += this.host, ne && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), $[0] !== "/" && ($ = "/" + $));
        }
        if (!T[ce]) for (V = 0, L = b.length; V < L; V++) {
          var we, ze = b[V];
          $.indexOf(ze) !== -1 && ((we = encodeURIComponent(ze)) === ze && (we = escape(ze)), $ = $.split(ze).join(we));
        }
        return (ne = $.indexOf("#")) !== -1 && (this.hash = $.substr(ne), $ = $.slice(0, ne)), (ne = $.indexOf("?")) !== -1 ? (this.search = $.substr(ne), this.query = $.substr(ne + 1), B && (this.query = N.parse(this.query)), $ = $.slice(0, ne)) : B && (this.search = "", this.query = {}), $ && (this.pathname = $), k[ce] && this.hostname && !this.pathname && (this.pathname = "/"), (this.pathname || this.search) && (ve = this.pathname || "", ce = this.search || "", this.path = ve + ce), this.href = this.format(), this;
      }, f.prototype.format = function() {
        var I = this.auth || "";
        I && (I = (I = encodeURIComponent(I)).replace(/%3A/i, ":"), I += "@");
        var B = this.protocol || "", U = this.pathname || "", H = this.hash || "", Q = !1, Y = "";
        return this.host ? Q = I + this.host : this.hostname && (Q = I + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (Q += ":" + this.port)), this.query && l(this.query) === "object" && Object.keys(this.query).length && (Y = N.stringify(this.query, { arrayFormat: "repeat", addQueryPrefix: !1 })), Y = this.search || Y && "?" + Y || "", B && B.substr(-1) !== ":" && (B += ":"), this.slashes || (!B || k[B]) && Q !== !1 ? (Q = "//" + (Q || ""), U && U.charAt(0) !== "/" && (U = "/" + U)) : Q = Q || "", H && H.charAt(0) !== "#" && (H = "#" + H), Y && Y.charAt(0) !== "?" && (Y = "?" + Y), B + Q + (U = U.replace(/[?#]/g, function(ie) {
          return encodeURIComponent(ie);
        })) + (Y = Y.replace("#", "%23")) + H;
      }, f.prototype.resolve = function(I) {
        return this.resolveObject(j(I, !1, !0)).format();
      }, f.prototype.resolveObject = function(I) {
        typeof I == "string" && ((ae = new f()).parse(I, !1, !0), I = ae);
        for (var B = new f(), U = Object.keys(this), H = 0; H < U.length; H++) {
          var Q = U[H];
          B[Q] = this[Q];
        }
        if (B.hash = I.hash, I.href === "") return B.href = B.format(), B;
        if (I.slashes && !I.protocol) {
          for (var Y = Object.keys(I), ie = 0; ie < Y.length; ie++) {
            var ce = Y[ie];
            ce !== "protocol" && (B[ce] = I[ce]);
          }
          return k[B.protocol] && B.hostname && !B.pathname && (B.pathname = "/", B.path = B.pathname), B.href = B.format(), B;
        }
        if (I.protocol && I.protocol !== B.protocol) {
          if (!k[I.protocol]) {
            for (var $ = Object.keys(I), te = 0; te < $.length; te++) {
              var V = $[te];
              B[V] = I[V];
            }
            return B.href = B.format(), B;
          }
          if (B.protocol = I.protocol, I.host || A[I.protocol]) B.pathname = I.pathname;
          else {
            for (var z = (I.pathname || "").split("/"); z.length && !(I.host = z.shift()); ) ;
            I.host || (I.host = ""), I.hostname || (I.hostname = ""), z[0] !== "" && z.unshift(""), z.length < 2 && z.unshift(""), B.pathname = z.join("/");
          }
          return B.search = I.search, B.query = I.query, B.host = I.host || "", B.auth = I.auth, B.hostname = I.hostname || I.host, B.port = I.port, (B.pathname || B.search) && (ne = B.pathname || "", J = B.search || "", B.path = ne + J), B.slashes = B.slashes || I.slashes, B.href = B.format(), B;
        }
        var K = B.pathname && B.pathname.charAt(0) === "/", ne = (ae = I.host || I.pathname && I.pathname.charAt(0) === "/") || K || B.host && I.pathname, J = ne, L = B.pathname && B.pathname.split("/") || [], z = I.pathname && I.pathname.split("/") || [];
        if ((K = B.protocol && !k[B.protocol]) && (B.hostname = "", B.port = null, B.host && (L[0] === "" ? L[0] = B.host : L.unshift(B.host)), B.host = "", I.protocol && (I.hostname = null, I.port = null, I.host && (z[0] === "" ? z[0] = I.host : z.unshift(I.host)), I.host = null), ne = ne && (z[0] === "" || L[0] === "")), ae) B.host = (I.host || I.host === "" ? I : B).host, B.hostname = (I.hostname || I.hostname === "" ? I : B).hostname, B.search = I.search, B.query = I.query, L = z;
        else if (z.length) (L = L || []).pop(), L = L.concat(z), B.search = I.search, B.query = I.query;
        else if (I.search != null) return K && (B.host = L.shift(), B.hostname = B.host, (oe = !!(B.host && 0 < B.host.indexOf("@")) && B.host.split("@")) && (B.auth = oe.shift(), B.hostname = oe.shift(), B.host = B.hostname)), B.search = I.search, B.query = I.query, B.pathname === null && B.search === null || (B.path = (B.pathname || "") + (B.search || "")), B.href = B.format(), B;
        if (!L.length) return B.pathname = null, B.search ? B.path = "/" + B.search : B.path = null, B.href = B.format(), B;
        for (var ee = L.slice(-1)[0], ae = (B.host || I.host || 1 < L.length) && (ee === "." || ee === "..") || ee === "", q = 0, X = L.length; 0 <= X; X--) (ee = L[X]) === "." ? L.splice(X, 1) : ee === ".." ? (L.splice(X, 1), q++) : q && (L.splice(X, 1), q--);
        if (!ne && !J) for (; q--; ) L.unshift("..");
        !ne || L[0] === "" || L[0] && L[0].charAt(0) === "/" || L.unshift(""), ae && L.join("/").substr(-1) !== "/" && L.push("");
        var oe, ae = L[0] === "" || L[0] && L[0].charAt(0) === "/";
        return K && (B.hostname = !ae && L.length ? L.shift() : "", B.host = B.hostname, (oe = !!(B.host && 0 < B.host.indexOf("@")) && B.host.split("@")) && (B.auth = oe.shift(), B.hostname = oe.shift(), B.host = B.hostname)), (ne = ne || B.host && L.length) && !ae && L.unshift(""), 0 < L.length ? B.pathname = L.join("/") : (B.pathname = null, B.path = null), B.pathname === null && B.search === null || (B.path = (B.pathname || "") + (B.search || "")), B.auth = I.auth || B.auth, B.slashes = B.slashes || I.slashes, B.href = B.format(), B;
      }, f.prototype.parseHost = function() {
        var I = this.host, B = p.exec(I);
        B && ((B = B[0]) !== ":" && (this.port = B.substr(1)), I = I.substr(0, I.length - B.length)), I && (this.hostname = I);
      }, s.parse = j, s.resolve = function(B, U) {
        return j(B, !1, !0).resolve(U);
      }, s.resolveObject = function(B, U) {
        return B ? j(B, !1, !0).resolveObject(U) : U;
      }, s.format = function(B) {
        return (B = typeof B == "string" ? j(B) : B) instanceof f ? B.format() : f.prototype.format.call(B);
      }, s.Url = f;
    }, function(a, s, b) {
      var l = b(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.types = s.initializeType = s.default = void 0;
      var d = l(b(5)), f = l(b(4)), h = l(b(47)), p = l(b(534)), g = l(b(536)), _ = s.types = {}, b = function(E) {
        if (_[E]) return _[E];
        var C = ((0, h.default)(g.default, function(y) {
          return !!E.match(y.matcher);
        }) || {}).typeConstructor;
        if (!C) throw new Error("No type found for ".concat(E));
        return _[E] = C(E), _[E];
      };
      s.initializeType = b, s.default = function() {
        function v(E) {
          (0, d.default)(this, v), this.value = E;
        }
        return (0, f.default)(v, [{ key: "isValid", value: function() {
          var C = this;
          return (0, p.default)(this.matchers, function(y) {
            return "".concat(C.value).match(y);
          });
        } }, { key: "getErrorMessage", value: function() {
          if (!this.isValid()) return (this.constructor.errorMessage || "has invalid value: ".concat(this.value, " for type ").concat(this.constructor.name, " ")).replace(/\$value/g, this.value);
        } }, { key: "getValue", value: function() {
          return this.value;
        } }], [{ key: "check", value: function(C) {
          return !!C.match(this.constructor.typeChecker);
        } }]), v;
      }();
    }, function(a, s, r) {
      var l = r(250), d = r(255);
      a.exports = function(h, p) {
        return p = d(h, p), l(p) ? p : void 0;
      };
    }, function(a, s, r) {
      var l = r(41), d = r(251), f = r(252), h = l ? l.toStringTag : void 0;
      a.exports = function(g) {
        return g == null ? g === void 0 ? "[object Undefined]" : "[object Null]" : (h && h in Object(g) ? d : f)(g);
      };
    }, function(a, s, r) {
      var l = r(71), d = r(100);
      a.exports = function(h) {
        return h != null && d(h.length) && !l(h);
      };
    }, function(a, s, r) {
      var l = r(159), d = r(98), f = r(31);
      a.exports = function(p) {
        return (f(p) ? l : d)(p);
      };
    }, function(a, s, r) {
      var l = r(45);
      a.exports = function(f) {
        if (typeof f == "string" || l(f)) return f;
        var h = f + "";
        return h == "0" && 1 / f == -1 / 0 ? "-0" : h;
      };
    }, function(a, s, r) {
      var l, d = r(377), f = r(378), h = r(380), p = r(48), g = { animation: { canOverride: f.generic.components([f.generic.time, f.generic.timingFunction, f.generic.time, f.property.animationIterationCount, f.property.animationDirection, f.property.animationFillMode, f.property.animationPlayState, f.property.animationName]), components: ["animation-duration", "animation-timing-function", "animation-delay", "animation-iteration-count", "animation-direction", "animation-fill-mode", "animation-play-state", "animation-name"], breakUp: d.multiplex(d.animation), defaultValue: "none", restore: h.multiplex(h.withoutDefaults), shorthand: !0, vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-delay": { canOverride: f.generic.time, componentOf: ["animation"], defaultValue: "0s", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-direction": { canOverride: f.property.animationDirection, componentOf: ["animation"], defaultValue: "normal", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-duration": { canOverride: f.generic.time, componentOf: ["animation"], defaultValue: "0s", intoMultiplexMode: "real", keepUnlessDefault: "animation-delay", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-fill-mode": { canOverride: f.property.animationFillMode, componentOf: ["animation"], defaultValue: "none", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-iteration-count": { canOverride: f.property.animationIterationCount, componentOf: ["animation"], defaultValue: "1", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-name": { canOverride: f.property.animationName, componentOf: ["animation"], defaultValue: "none", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-play-state": { canOverride: f.property.animationPlayState, componentOf: ["animation"], defaultValue: "running", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "animation-timing-function": { canOverride: f.generic.timingFunction, componentOf: ["animation"], defaultValue: "ease", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, background: { canOverride: f.generic.components([f.generic.image, f.property.backgroundPosition, f.property.backgroundSize, f.property.backgroundRepeat, f.property.backgroundAttachment, f.property.backgroundOrigin, f.property.backgroundClip, f.generic.color]), components: ["background-image", "background-position", "background-size", "background-repeat", "background-attachment", "background-origin", "background-clip", "background-color"], breakUp: d.multiplex(d.background), defaultValue: "0 0", restore: h.multiplex(h.background), shortestValue: "0", shorthand: !0 }, "background-attachment": { canOverride: f.property.backgroundAttachment, componentOf: ["background"], defaultValue: "scroll", intoMultiplexMode: "real" }, "background-clip": { canOverride: f.property.backgroundClip, componentOf: ["background"], defaultValue: "border-box", intoMultiplexMode: "real", shortestValue: "border-box" }, "background-color": { canOverride: f.generic.color, componentOf: ["background"], defaultValue: "transparent", intoMultiplexMode: "real", multiplexLastOnly: !0, nonMergeableValue: "none", shortestValue: "red" }, "background-image": { canOverride: f.generic.image, componentOf: ["background"], defaultValue: "none", intoMultiplexMode: "default" }, "background-origin": { canOverride: f.property.backgroundOrigin, componentOf: ["background"], defaultValue: "padding-box", intoMultiplexMode: "real", shortestValue: "border-box" }, "background-position": { canOverride: f.property.backgroundPosition, componentOf: ["background"], defaultValue: ["0", "0"], doubleValues: !0, intoMultiplexMode: "real", shortestValue: "0" }, "background-repeat": { canOverride: f.property.backgroundRepeat, componentOf: ["background"], defaultValue: ["repeat"], doubleValues: !0, intoMultiplexMode: "real" }, "background-size": { canOverride: f.property.backgroundSize, componentOf: ["background"], defaultValue: ["auto"], doubleValues: !0, intoMultiplexMode: "real", shortestValue: "0 0" }, bottom: { canOverride: f.property.bottom, defaultValue: "auto" }, border: { breakUp: d.border, canOverride: f.generic.components([f.generic.unit, f.property.borderStyle, f.generic.color]), components: ["border-width", "border-style", "border-color"], defaultValue: "none", overridesShorthands: ["border-bottom", "border-left", "border-right", "border-top"], restore: h.withoutDefaults, shorthand: !0, shorthandComponents: !0 }, "border-bottom": { breakUp: d.border, canOverride: f.generic.components([f.generic.unit, f.property.borderStyle, f.generic.color]), components: ["border-bottom-width", "border-bottom-style", "border-bottom-color"], defaultValue: "none", restore: h.withoutDefaults, shorthand: !0 }, "border-bottom-color": { canOverride: f.generic.color, componentOf: ["border-bottom", "border-color"], defaultValue: "none" }, "border-bottom-left-radius": { canOverride: f.generic.unit, componentOf: ["border-radius"], defaultValue: "0", vendorPrefixes: ["-moz-", "-o-"] }, "border-bottom-right-radius": { canOverride: f.generic.unit, componentOf: ["border-radius"], defaultValue: "0", vendorPrefixes: ["-moz-", "-o-"] }, "border-bottom-style": { canOverride: f.property.borderStyle, componentOf: ["border-bottom", "border-style"], defaultValue: "none" }, "border-bottom-width": { canOverride: f.generic.unit, componentOf: ["border-bottom", "border-width"], defaultValue: "medium", oppositeTo: "border-top-width", shortestValue: "0" }, "border-collapse": { canOverride: f.property.borderCollapse, defaultValue: "separate" }, "border-color": { breakUp: d.fourValues, canOverride: f.generic.components([f.generic.color, f.generic.color, f.generic.color, f.generic.color]), componentOf: ["border"], components: ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"], defaultValue: "none", restore: h.fourValues, shortestValue: "red", shorthand: !0 }, "border-left": { breakUp: d.border, canOverride: f.generic.components([f.generic.unit, f.property.borderStyle, f.generic.color]), components: ["border-left-width", "border-left-style", "border-left-color"], defaultValue: "none", restore: h.withoutDefaults, shorthand: !0 }, "border-left-color": { canOverride: f.generic.color, componentOf: ["border-color", "border-left"], defaultValue: "none" }, "border-left-style": { canOverride: f.property.borderStyle, componentOf: ["border-left", "border-style"], defaultValue: "none" }, "border-left-width": { canOverride: f.generic.unit, componentOf: ["border-left", "border-width"], defaultValue: "medium", oppositeTo: "border-right-width", shortestValue: "0" }, "border-radius": { breakUp: d.borderRadius, canOverride: f.generic.components([f.generic.unit, f.generic.unit, f.generic.unit, f.generic.unit]), components: ["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"], defaultValue: "0", restore: h.borderRadius, shorthand: !0, vendorPrefixes: ["-moz-", "-o-"] }, "border-right": { breakUp: d.border, canOverride: f.generic.components([f.generic.unit, f.property.borderStyle, f.generic.color]), components: ["border-right-width", "border-right-style", "border-right-color"], defaultValue: "none", restore: h.withoutDefaults, shorthand: !0 }, "border-right-color": { canOverride: f.generic.color, componentOf: ["border-color", "border-right"], defaultValue: "none" }, "border-right-style": { canOverride: f.property.borderStyle, componentOf: ["border-right", "border-style"], defaultValue: "none" }, "border-right-width": { canOverride: f.generic.unit, componentOf: ["border-right", "border-width"], defaultValue: "medium", oppositeTo: "border-left-width", shortestValue: "0" }, "border-style": { breakUp: d.fourValues, canOverride: f.generic.components([f.property.borderStyle, f.property.borderStyle, f.property.borderStyle, f.property.borderStyle]), componentOf: ["border"], components: ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"], defaultValue: "none", restore: h.fourValues, shorthand: !0 }, "border-top": { breakUp: d.border, canOverride: f.generic.components([f.generic.unit, f.property.borderStyle, f.generic.color]), components: ["border-top-width", "border-top-style", "border-top-color"], defaultValue: "none", restore: h.withoutDefaults, shorthand: !0 }, "border-top-color": { canOverride: f.generic.color, componentOf: ["border-color", "border-top"], defaultValue: "none" }, "border-top-left-radius": { canOverride: f.generic.unit, componentOf: ["border-radius"], defaultValue: "0", vendorPrefixes: ["-moz-", "-o-"] }, "border-top-right-radius": { canOverride: f.generic.unit, componentOf: ["border-radius"], defaultValue: "0", vendorPrefixes: ["-moz-", "-o-"] }, "border-top-style": { canOverride: f.property.borderStyle, componentOf: ["border-style", "border-top"], defaultValue: "none" }, "border-top-width": { canOverride: f.generic.unit, componentOf: ["border-top", "border-width"], defaultValue: "medium", oppositeTo: "border-bottom-width", shortestValue: "0" }, "border-width": { breakUp: d.fourValues, canOverride: f.generic.components([f.generic.unit, f.generic.unit, f.generic.unit, f.generic.unit]), componentOf: ["border"], components: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"], defaultValue: "medium", restore: h.fourValues, shortestValue: "0", shorthand: !0 }, clear: { canOverride: f.property.clear, defaultValue: "none" }, color: { canOverride: f.generic.color, defaultValue: "transparent", shortestValue: "red" }, cursor: { canOverride: f.property.cursor, defaultValue: "auto" }, display: { canOverride: f.property.display }, float: { canOverride: f.property.float, defaultValue: "none" }, font: { breakUp: d.font, canOverride: f.generic.components([f.property.fontStyle, f.property.fontVariant, f.property.fontWeight, f.property.fontStretch, f.generic.unit, f.generic.unit, f.property.fontFamily]), components: ["font-style", "font-variant", "font-weight", "font-stretch", "font-size", "line-height", "font-family"], restore: h.font, shorthand: !0 }, "font-family": { canOverride: f.property.fontFamily, defaultValue: "user|agent|specific" }, "font-size": { canOverride: f.generic.unit, defaultValue: "medium", shortestValue: "0" }, "font-stretch": { canOverride: f.property.fontStretch, defaultValue: "normal" }, "font-style": { canOverride: f.property.fontStyle, defaultValue: "normal" }, "font-variant": { canOverride: f.property.fontVariant, defaultValue: "normal" }, "font-weight": { canOverride: f.property.fontWeight, defaultValue: "normal", shortestValue: "400" }, height: { canOverride: f.generic.unit, defaultValue: "auto", shortestValue: "0" }, left: { canOverride: f.property.left, defaultValue: "auto" }, "line-height": { canOverride: f.generic.unitOrNumber, defaultValue: "normal", shortestValue: "0" }, "list-style": { canOverride: f.generic.components([f.property.listStyleType, f.property.listStylePosition, f.property.listStyleImage]), components: ["list-style-type", "list-style-position", "list-style-image"], breakUp: d.listStyle, restore: h.withoutDefaults, defaultValue: "outside", shortestValue: "none", shorthand: !0 }, "list-style-image": { canOverride: f.generic.image, componentOf: ["list-style"], defaultValue: "none" }, "list-style-position": { canOverride: f.property.listStylePosition, componentOf: ["list-style"], defaultValue: "outside", shortestValue: "inside" }, "list-style-type": { canOverride: f.property.listStyleType, componentOf: ["list-style"], defaultValue: "decimal|disc", shortestValue: "none" }, margin: { breakUp: d.fourValues, canOverride: f.generic.components([f.generic.unit, f.generic.unit, f.generic.unit, f.generic.unit]), components: ["margin-top", "margin-right", "margin-bottom", "margin-left"], defaultValue: "0", restore: h.fourValues, shorthand: !0 }, "margin-bottom": { canOverride: f.generic.unit, componentOf: ["margin"], defaultValue: "0", oppositeTo: "margin-top" }, "margin-left": { canOverride: f.generic.unit, componentOf: ["margin"], defaultValue: "0", oppositeTo: "margin-right" }, "margin-right": { canOverride: f.generic.unit, componentOf: ["margin"], defaultValue: "0", oppositeTo: "margin-left" }, "margin-top": { canOverride: f.generic.unit, componentOf: ["margin"], defaultValue: "0", oppositeTo: "margin-bottom" }, outline: { canOverride: f.generic.components([f.generic.color, f.property.outlineStyle, f.generic.unit]), components: ["outline-color", "outline-style", "outline-width"], breakUp: d.outline, restore: h.withoutDefaults, defaultValue: "0", shorthand: !0 }, "outline-color": { canOverride: f.generic.color, componentOf: ["outline"], defaultValue: "invert", shortestValue: "red" }, "outline-style": { canOverride: f.property.outlineStyle, componentOf: ["outline"], defaultValue: "none" }, "outline-width": { canOverride: f.generic.unit, componentOf: ["outline"], defaultValue: "medium", shortestValue: "0" }, overflow: { canOverride: f.property.overflow, defaultValue: "visible" }, "overflow-x": { canOverride: f.property.overflow, defaultValue: "visible" }, "overflow-y": { canOverride: f.property.overflow, defaultValue: "visible" }, padding: { breakUp: d.fourValues, canOverride: f.generic.components([f.generic.unit, f.generic.unit, f.generic.unit, f.generic.unit]), components: ["padding-top", "padding-right", "padding-bottom", "padding-left"], defaultValue: "0", restore: h.fourValues, shorthand: !0 }, "padding-bottom": { canOverride: f.generic.unit, componentOf: ["padding"], defaultValue: "0", oppositeTo: "padding-top" }, "padding-left": { canOverride: f.generic.unit, componentOf: ["padding"], defaultValue: "0", oppositeTo: "padding-right" }, "padding-right": { canOverride: f.generic.unit, componentOf: ["padding"], defaultValue: "0", oppositeTo: "padding-left" }, "padding-top": { canOverride: f.generic.unit, componentOf: ["padding"], defaultValue: "0", oppositeTo: "padding-bottom" }, position: { canOverride: f.property.position, defaultValue: "static" }, right: { canOverride: f.property.right, defaultValue: "auto" }, "text-align": { canOverride: f.property.textAlign, defaultValue: "left|right" }, "text-decoration": { canOverride: f.property.textDecoration, defaultValue: "none" }, "text-overflow": { canOverride: f.property.textOverflow, defaultValue: "none" }, "text-shadow": { canOverride: f.property.textShadow, defaultValue: "none" }, top: { canOverride: f.property.top, defaultValue: "auto" }, transform: { canOverride: f.property.transform, vendorPrefixes: ["-moz-", "-ms-", "-webkit-"] }, transition: { breakUp: d.multiplex(d.transition), canOverride: f.generic.components([f.property.transitionProperty, f.generic.time, f.generic.timingFunction, f.generic.time]), components: ["transition-property", "transition-duration", "transition-timing-function", "transition-delay"], defaultValue: "none", restore: h.multiplex(h.withoutDefaults), shorthand: !0, vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "transition-delay": { canOverride: f.generic.time, componentOf: ["transition"], defaultValue: "0s", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "transition-duration": { canOverride: f.generic.time, componentOf: ["transition"], defaultValue: "0s", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "transition-property": { canOverride: f.generic.propertyName, componentOf: ["transition"], defaultValue: "all", intoMultiplexMode: "placeholder", placeholderValue: "_", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "transition-timing-function": { canOverride: f.generic.timingFunction, componentOf: ["transition"], defaultValue: "ease", intoMultiplexMode: "real", vendorPrefixes: ["-moz-", "-o-", "-webkit-"] }, "vertical-align": { canOverride: f.property.verticalAlign, defaultValue: "baseline" }, visibility: { canOverride: f.property.visibility, defaultValue: "visible" }, "white-space": { canOverride: f.property.whiteSpace, defaultValue: "normal" }, width: { canOverride: f.generic.unit, defaultValue: "auto", shortestValue: "0" }, "z-index": { canOverride: f.property.zIndex, defaultValue: "auto" } }, _ = {};
      for (l in g) {
        var b = g[l];
        if ("vendorPrefixes" in b) {
          for (var v = 0; v < b.vendorPrefixes.length; v++) {
            var E = b.vendorPrefixes[v], C = function(T, A) {
              return "componentOf" in (T = p(g[T], {})) && (T.componentOf = T.componentOf.map(function(k) {
                return A + k;
              })), "components" in T && (T.components = T.components.map(function(k) {
                return A + k;
              })), "keepUnlessDefault" in T && (T.keepUnlessDefault = A + T.keepUnlessDefault), T;
            }(l, E);
            delete C.vendorPrefixes, _[E + l] = C;
          }
          delete b.vendorPrefixes;
        }
      }
      a.exports = p(g, _);
    }, function(a, s) {
      typeof Object.create == "function" ? a.exports = function(l, d) {
        d && (l.super_ = d, l.prototype = Object.create(d.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }));
      } : a.exports = function(l, d) {
        var f;
        d && (l.super_ = d, (f = function() {
        }).prototype = d.prototype, l.prototype = new f(), l.prototype.constructor = l);
      };
    }, function(a, s, r) {
      function l($) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(te) {
          return typeof te;
        } : function(te) {
          return te && typeof Symbol == "function" && te.constructor === Symbol && te !== Symbol.prototype ? "symbol" : typeof te;
        })($);
      }
      function d($) {
        try {
          return p('"use strict"; return (' + $ + ").constructor;")();
        } catch {
        }
      }
      var f, h = SyntaxError, p = Function, g = TypeError, _ = Object.getOwnPropertyDescriptor;
      if (_) try {
        _({}, "");
      } catch {
        _ = null;
      }
      function b() {
        throw new g();
      }
      var v = _ ? function() {
        try {
          return b;
        } catch {
          try {
            return _(arguments, "callee").get;
          } catch {
            return b;
          }
        }
      }() : b, E = r(418)(), T = r(420)(), C = Object.getPrototypeOf || (T ? function($) {
        return $.__proto__;
      } : null), y = {}, T = typeof Uint8Array < "u" && C ? C(Uint8Array) : f, A = { "%AggregateError%": typeof AggregateError > "u" ? f : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer > "u" ? f : ArrayBuffer, "%ArrayIteratorPrototype%": E && C ? C([][Symbol.iterator]()) : f, "%AsyncFromSyncIteratorPrototype%": f, "%AsyncFunction%": y, "%AsyncGenerator%": y, "%AsyncGeneratorFunction%": y, "%AsyncIteratorPrototype%": y, "%Atomics%": typeof Atomics > "u" ? f : Atomics, "%BigInt%": typeof BigInt > "u" ? f : BigInt, "%BigInt64Array%": typeof BigInt64Array > "u" ? f : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array > "u" ? f : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView > "u" ? f : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array > "u" ? f : Float32Array, "%Float64Array%": typeof Float64Array > "u" ? f : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? f : FinalizationRegistry, "%Function%": p, "%GeneratorFunction%": y, "%Int8Array%": typeof Int8Array > "u" ? f : Int8Array, "%Int16Array%": typeof Int16Array > "u" ? f : Int16Array, "%Int32Array%": typeof Int32Array > "u" ? f : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": E && C ? C(C([][Symbol.iterator]())) : f, "%JSON%": (typeof JSON > "u" ? "undefined" : l(JSON)) === "object" ? JSON : f, "%Map%": typeof Map > "u" ? f : Map, "%MapIteratorPrototype%": typeof Map < "u" && E && C ? C((/* @__PURE__ */ new Map())[Symbol.iterator]()) : f, "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise > "u" ? f : Promise, "%Proxy%": typeof Proxy > "u" ? f : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect > "u" ? f : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set > "u" ? f : Set, "%SetIteratorPrototype%": typeof Set < "u" && E && C ? C((/* @__PURE__ */ new Set())[Symbol.iterator]()) : f, "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? f : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": E && C ? C(""[Symbol.iterator]()) : f, "%Symbol%": E ? Symbol : f, "%SyntaxError%": h, "%ThrowTypeError%": v, "%TypedArray%": T, "%TypeError%": g, "%Uint8Array%": typeof Uint8Array > "u" ? f : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? f : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array > "u" ? f : Uint16Array, "%Uint32Array%": typeof Uint32Array > "u" ? f : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap > "u" ? f : WeakMap, "%WeakRef%": typeof WeakRef > "u" ? f : WeakRef, "%WeakSet%": typeof WeakSet > "u" ? f : WeakSet };
      if (C) try {
        null.error;
      } catch ($) {
        var j = C(C($));
        A["%Error.prototype%"] = j;
      }
      function k($, te) {
        var V, K = $;
        if (I(N, K) && (K = "%" + (V = N[K])[0] + "%"), I(A, K)) {
          var ne = A[K];
          if ((ne = ne === y ? function J(L) {
            var z, ee;
            return L === "%AsyncFunction%" ? z = d("async function () {}") : L === "%GeneratorFunction%" ? z = d("function* () {}") : L === "%AsyncGeneratorFunction%" ? z = d("async function* () {}") : L === "%AsyncGenerator%" ? (ee = J("%AsyncGeneratorFunction%")) && (z = ee.prototype) : L !== "%AsyncIteratorPrototype%" || (ee = J("%AsyncGenerator%")) && C && (z = C(ee.prototype)), A[L] = z;
          }(K) : ne) === void 0 && !te) throw new g("intrinsic " + $ + " exists, but is not available. Please file an issue!");
          return { alias: V, name: K, value: ne };
        }
        throw new h("intrinsic " + $ + " does not exist!");
      }
      var N = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, j = r(133), I = r(422), B = j.call(Function.call, Array.prototype.concat), U = j.call(Function.apply, Array.prototype.splice), H = j.call(Function.call, String.prototype.replace), Q = j.call(Function.call, String.prototype.slice), Y = j.call(Function.call, RegExp.prototype.exec), ie = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ce = /\\(\\)?/g;
      a.exports = function(te, V) {
        if (typeof te != "string" || te.length === 0) throw new g("intrinsic name must be a non-empty string");
        if (1 < arguments.length && typeof V != "boolean") throw new g('"allowMissing" argument must be a boolean');
        if (Y(/^%?[^%]*%?$/, te) === null) throw new h("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
        var K = function(ve) {
          var Ee = Q(ve, 0, 1), we = Q(ve, -1);
          if (Ee === "%" && we !== "%") throw new h("invalid intrinsic syntax, expected closing `%`");
          if (we === "%" && Ee !== "%") throw new h("invalid intrinsic syntax, expected opening `%`");
          var ze = [];
          return H(ve, ie, function(Ie, je, qe, Ge) {
            ze[ze.length] = qe ? H(Ge, ce, "$1") : je || Ie;
          }), ze;
        }(te), ne = 0 < K.length ? K[0] : "", J = k("%" + ne + "%", V), L = (J.name, J.value), z = !1;
        (J = J.alias) && (ne = J[0], U(K, B([0, 1], J)));
        for (var ee = 1, q = !0; ee < K.length; ee += 1) {
          var X = K[ee], oe = Q(X, 0, 1), ae = Q(X, -1);
          if ((oe === '"' || oe === "'" || oe === "`" || ae === '"' || ae === "'" || ae === "`") && oe !== ae) throw new h("property names with quotes must have matching quotes");
          if (X !== "constructor" && q || (z = !0), I(A, oe = "%" + (ne += "." + X) + "%")) L = A[oe];
          else if (L != null) {
            if (!(X in L)) {
              if (!V) throw new g("base intrinsic for " + te + " exists, but the property is not available.");
              return;
            }
            L = _ && ee + 1 >= K.length ? (q = !!(ae = _(L, X))) && "get" in ae && !("originalValue" in ae.get) ? ae.get : L[X] : (q = I(L, X), L[X]), q && !z && (A[oe] = L);
          }
        }
        return L;
      };
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(f) {
        var h = (p = (1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}).parseFloatToInt) === void 0 || p, p = l.exec(f.toString())[1];
        return { parsedWidth: ((h = { default: parseInt, px: parseInt, "%": h ? parseInt : parseFloat })[p] || h.default)(f), unit: p || "px" };
      };
      var l = /[\d.,]*(\D*)$/;
      a.exports = s.default;
    }, function(a, s, r) {
      var l = r(69).default;
      function d(f) {
        if (typeof WeakMap != "function") return null;
        var h = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap();
        return (d = function(_) {
          return _ ? p : h;
        })(f);
      }
      a.exports = function(h, p) {
        if (!p && h && h.__esModule) return h;
        if (h === null || l(h) != "object" && typeof h != "function") return { default: h };
        if ((p = d(p)) && p.has(h)) return p.get(h);
        var g, _, b = { __proto__: null }, v = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for (g in h) g !== "default" && Object.prototype.hasOwnProperty.call(h, g) && ((_ = v ? Object.getOwnPropertyDescriptor(h, g) : null) && (_.get || _.set) ? Object.defineProperty(b, g, _) : b[g] = h[g]);
        return b.default = h, p && p.set(h, b), b;
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      a.exports = function(l) {
        if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return l;
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, I) {
      var l = I(249), d = I(99), f = I(256), h = I(257), p = I(156), g = I(30), _ = I(155), b = "[object Map]", v = "[object Promise]", E = "[object Set]", C = "[object WeakMap]", y = "[object DataView]", T = _(l), A = _(d), k = _(f), N = _(h), j = _(p), I = g;
      (l && I(new l(new ArrayBuffer(1))) != y || d && I(new d()) != b || f && I(f.resolve()) != v || h && I(new h()) != E || p && I(new p()) != C) && (I = function(U) {
        var H = g(U);
        if (U = (U = H == "[object Object]" ? U.constructor : void 0) ? _(U) : "") switch (U) {
          case T:
            return y;
          case A:
            return b;
          case k:
            return v;
          case N:
            return E;
          case j:
            return C;
        }
        return H;
      }), a.exports = I;
    }, function(a, s, r) {
      r = r(17).Symbol, a.exports = r;
    }, function(a, s, r) {
      var l = r(74), d = r(55), f = r(265), h = r(13);
      a.exports = function(g, _) {
        return (h(g) ? l : d)(g, f(_));
      };
    }, function(a, s, r) {
      var l = r(80);
      a.exports = function(f, h, p) {
        return (h = f == null ? void 0 : l(f, h)) === void 0 ? p : h;
      };
    }, function(a, s, r) {
      var l = r(13), d = r(108), f = r(171), h = r(46);
      a.exports = function(g, _) {
        return l(g) ? g : d(g, _) ? [g] : f(h(g));
      };
    }, function(a, s, r) {
      function l(h) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
          return typeof p;
        } : function(p) {
          return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
        })(h);
      }
      var d = r(30), f = r(20);
      a.exports = function(p) {
        return l(p) == "symbol" || f(p) && d(p) == "[object Symbol]";
      };
    }, function(a, s, r) {
      var l = r(303);
      a.exports = function(f) {
        return f == null ? "" : l(f);
      };
    }, function(a, s, r) {
      r = r(341)(r(342)), a.exports = r;
    }, function(a, s) {
      function r(l) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        })(l);
      }
      a.exports = function l(d, f) {
        var h, p, g, _ = {};
        for (h in d) g = d[h], Array.isArray(g) ? _[h] = g.slice(0) : r(g) == "object" && g !== null ? _[h] = l(g, {}) : _[h] = g;
        for (p in f) g = f[p], p in _ && Array.isArray(g) ? _[p] = g.slice(0) : p in _ && r(g) == "object" && g !== null ? _[p] = l(_[p], g) : _[p] = g;
        return _;
      };
    }, function(a, s, r) {
      var l = r(126), d = r(16), f = r(12), h = { ASTERISK: "*", BACKSLASH: "\\", BANG: "!", BANG_SUFFIX_PATTERN: /!\w+$/, IMPORTANT_TOKEN: "!important", IMPORTANT_TOKEN_PATTERN: new RegExp("!important$", "i"), IMPORTANT_WORD: "important", IMPORTANT_WORD_PATTERN: new RegExp("important$", "i"), SUFFIX_BANG_PATTERN: /!$/, UNDERSCORE: "_", VARIABLE_REFERENCE_PATTERN: /var\(--.+\)$/ };
      function p(g) {
        var _ = function(E) {
          if (E.length < 3) return !1;
          var C = E[E.length - 1];
          return !!h.IMPORTANT_TOKEN_PATTERN.test(C[1]) || !(!h.IMPORTANT_WORD_PATTERN.test(C[1]) || !h.SUFFIX_BANG_PATTERN.test(E[E.length - 2][1]));
        }(g);
        _ && function(E) {
          var C = E[E.length - 1], y = E[E.length - 2];
          h.IMPORTANT_TOKEN_PATTERN.test(C[1]) ? C[1] = C[1].replace(h.IMPORTANT_TOKEN_PATTERN, "") : (C[1] = C[1].replace(h.IMPORTANT_WORD_PATTERN, ""), y[1] = y[1].replace(h.SUFFIX_BANG_PATTERN, "")), C[1].length === 0 && E.pop(), y[1].length === 0 && E.pop();
        }(g);
        var b = function(T) {
          var C = !1, y = T[1][1], T = T[T.length - 1];
          return y[0] == h.UNDERSCORE ? C = [l.UNDERSCORE] : y[0] == h.ASTERISK ? C = [l.ASTERISK] : T[1][0] == h.BANG && !T[1].match(h.IMPORTANT_WORD_PATTERN) || 0 < T[1].indexOf(h.BANG) && !T[1].match(h.IMPORTANT_WORD_PATTERN) && h.BANG_SUFFIX_PATTERN.test(T[1]) ? C = [l.BANG] : 0 < T[1].indexOf(h.BACKSLASH) && T[1].indexOf(h.BACKSLASH) == T[1].length - h.BACKSLASH.length - 1 ? C = [l.BACKSLASH, T[1].substring(T[1].indexOf(h.BACKSLASH) + 1)] : T[1].indexOf(h.BACKSLASH) === 0 && T[1].length == 2 && (C = [l.BACKSLASH, T[1].substring(1)]), C;
        }(g);
        return b[0] == l.ASTERISK || b[0] == l.UNDERSCORE ? function(E) {
          E[1][1] = E[1][1].substring(1);
        }(g) : b[0] != l.BACKSLASH && b[0] != l.BANG || function(E, C) {
          var y = E[E.length - 1];
          y[1] = y[1].substring(0, y[1].indexOf(C[0] == l.BACKSLASH ? h.BACKSLASH : h.BANG)).trim(), y[1].length === 0 && E.pop();
        }(g, b), { block: g[2] && g[2][0] == f.PROPERTY_BLOCK, components: [], dirty: !1, hack: b, important: _, name: g[1][1], multiplex: 3 < g.length && function(E) {
          for (var C, y = 3, T = E.length; y < T; y++) if ((C = E[y])[0] == f.PROPERTY_VALUE && (C[1] == d.COMMA || C[1] == d.FORWARD_SLASH)) return !0;
          return !1;
        }(g), position: 0, shorthand: !1, unused: !1, value: g.slice(2) };
      }
      a.exports = { all: function(_, b, v) {
        for (var E, C = [], y = _.length - 1; 0 <= y; y--) (E = _[y])[0] == f.PROPERTY && (!b && function(A) {
          for (var k, N = 2, j = A.length; N < j; N++) if ((k = A[N])[0] == f.PROPERTY_VALUE && function(B) {
            return h.VARIABLE_REFERENCE_PATTERN.test(B);
          }(k[1])) return 1;
        }(E) || v && -1 < v.indexOf(E[1][1]) || ((E = p(E)).all = _, E.position = y, C.unshift(E)));
        return C;
      }, single: p };
    }, function(a, s, r) {
      var l = r(89), d = Object.keys || function(C) {
        var y, T = [];
        for (y in C) T.push(y);
        return T;
      };
      a.exports = b, (a = Object.create(r(63))).inherits = r(35);
      var f = r(196), h = r(200);
      a.inherits(b, f);
      for (var p = d(h.prototype), g = 0; g < p.length; g++) {
        var _ = p[g];
        b.prototype[_] || (b.prototype[_] = h.prototype[_]);
      }
      function b(C) {
        if (!(this instanceof b)) return new b(C);
        f.call(this, C), h.call(this, C), C && C.readable === !1 && (this.readable = !1), C && C.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, C && C.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", v);
      }
      function v() {
        this.allowHalfOpen || this._writableState.ended || l.nextTick(E, this);
      }
      function E(C) {
        C.end();
      }
      Object.defineProperty(b.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
        return this._writableState.highWaterMark;
      } }), Object.defineProperty(b.prototype, "destroyed", { get: function() {
        return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
      }, set: function(y) {
        this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = y, this._writableState.destroyed = y);
      } }), b.prototype._destroy = function(C, y) {
        this.push(null), this.end(), l.nextTick(y, C);
      };
    }, function(a, s) {
      a.exports = {};
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(d, f) {
        var h = f.line, p = f.tagName, g = f.absoluteFilePath;
        return { line: h, message: d, tagName: p, formattedMessage: "Line ".concat(h, " of ").concat(g).concat(function(b) {
          return (b = b.includedIn) && b.length ? (b = b.slice().reverse().map(function(C) {
            var E = C.line, C = C.file;
            return "line ".concat(E, " of file ").concat(C);
          }).join(", itself included at "), ", included at ".concat(b)) : "";
        }(f), " (").concat(p, ") — ").concat(d) };
      }, a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(b) {
        var v = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
        return `
    `.concat(v ? h : l, `
    `).concat(b, `
    `).concat(v ? g : f, `
  `);
      }, s.endNegationConditionalTag = s.endConditionalTag = void 0, s.msoConditionalTag = function(b) {
        var v = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
        return `
    `.concat(v ? p : d, `
    `).concat(b, `
    `).concat(v ? g : f, `
  `);
      }, s.startNegationConditionalTag = s.startMsoNegationConditionalTag = s.startMsoConditionalTag = s.startConditionalTag = void 0;
      var l = s.startConditionalTag = "<!--[if mso | IE]>", d = s.startMsoConditionalTag = "<!--[if mso]>", f = s.endConditionalTag = "<![endif]-->", h = s.startNegationConditionalTag = "<!--[if !mso | IE]><!-->", p = s.startMsoNegationConditionalTag = "<!--[if !mso]><!-->", g = s.endNegationConditionalTag = "<!--<![endif]-->";
    }, function(a, s) {
      a.exports = function(r) {
        return r.webpackPolyfill || (r.deprecate = function() {
        }, r.paths = [], r.children || (r.children = []), Object.defineProperty(r, "loaded", { enumerable: !0, get: function() {
          return r.l;
        } }), Object.defineProperty(r, "id", { enumerable: !0, get: function() {
          return r.i;
        } }), r.webpackPolyfill = 1), r;
      };
    }, function(a, s, r) {
      var l = r(158), l = r(264)(l);
      a.exports = l;
    }, function(a, s) {
      function r(d) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        })(d);
      }
      var l = /^(?:0|[1-9]\d*)$/;
      a.exports = function(f, h) {
        var p = r(f);
        return !!(h = h ?? 9007199254740991) && (p == "number" || p != "symbol" && l.test(f)) && -1 < f && f % 1 == 0 && f < h;
      };
    }, function(a, s, r) {
      var l = r(160), d = r(55), f = r(21), h = r(310), p = r(13);
      a.exports = function(_, b, v) {
        var E = p(_) ? l : h, C = arguments.length < 3;
        return E(_, f(b, 4), v, C, d);
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = -1, h = l == null ? 0 : l.length, p = Array(h); ++f < h; ) p[f] = d(l[f], f, l);
        return p;
      };
    }, function(a, s, r) {
      var l = r(110), d = r(111);
      a.exports = function(h, p, g, _) {
        var b = !g;
        g = g || {};
        for (var v = -1, E = p.length; ++v < E; ) {
          var C = p[v], y = _ ? _(g[C], h[C], C, g, h) : void 0;
          y === void 0 && (y = h[C]), (b ? d : l)(g, C, y);
        }
        return g;
      };
    }, function(a, s, r) {
      var l = r(58), d = r(21), f = r(339), h = r(13);
      a.exports = function(g, _) {
        return (h(g) ? l : f)(g, d(_, 3));
      };
    }, function(a, s, r) {
      var l = r(179);
      a.exports = function(p) {
        var h = l(p), p = h % 1;
        return h == h ? p ? h - p : h : 0;
      };
    }, function(a, s, r) {
      var l = r(126), d = r(16);
      a.exports = function(h, p) {
        for (var g, _, b, v = h.length - 1; 0 <= v; v--) (g = h[v]).unused || (g.dirty || g.important || g.hack) && (p ? (_ = p(g), g.value = _) : _ = g.value, g.important && function(C) {
          C.value[C.value.length - 1][1] += "!important";
        }(g), g.hack && function(C) {
          C.hack[0] == l.UNDERSCORE ? C.name = "_" + C.name : C.hack[0] == l.ASTERISK ? C.name = "*" + C.name : C.hack[0] == l.BACKSLASH ? C.value[C.value.length - 1][1] += "\\" + C.hack[1] : C.hack[0] == l.BANG && (C.value[C.value.length - 1][1] += d.SPACE + "!ie");
        }(g), "all" in g && ((b = g.all[g.position])[1][1] = g.name, b.splice(2, b.length - 1), Array.prototype.push.apply(b, _)));
      };
    }, function(a, s, r) {
      function l(f) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
          return typeof h;
        } : function(h) {
          return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
        })(f);
      }
      function d(f) {
        return Object.prototype.toString.call(f);
      }
      s.isArray = function(h) {
        return Array.isArray ? Array.isArray(h) : d(h) === "[object Array]";
      }, s.isBoolean = function(h) {
        return typeof h == "boolean";
      }, s.isNull = function(h) {
        return h === null;
      }, s.isNullOrUndefined = function(h) {
        return h == null;
      }, s.isNumber = function(h) {
        return typeof h == "number";
      }, s.isString = function(h) {
        return typeof h == "string";
      }, s.isSymbol = function(h) {
        return l(h) === "symbol";
      }, s.isUndefined = function(h) {
        return h === void 0;
      }, s.isRegExp = function(h) {
        return d(h) === "[object RegExp]";
      }, s.isObject = function(h) {
        return l(h) === "object" && h !== null;
      }, s.isDate = function(h) {
        return d(h) === "[object Date]";
      }, s.isError = function(h) {
        return d(h) === "[object Error]" || h instanceof Error;
      }, s.isFunction = function(h) {
        return typeof h == "function";
      }, s.isPrimitive = function(h) {
        return h === null || typeof h == "boolean" || typeof h == "number" || typeof h == "string" || l(h) === "symbol" || h === void 0;
      }, s.isBuffer = r(23).Buffer.isBuffer;
    }, function(a, s) {
      s.getArg = function(C, y, T) {
        if (y in C) return C[y];
        if (arguments.length === 3) return T;
        throw new Error('"' + y + '" is a required argument.');
      };
      var r = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, l = /^data:.+\,.+$/;
      function d(E) {
        return (E = E.match(r)) ? { scheme: E[1], auth: E[2], host: E[3], port: E[4], path: E[5] } : null;
      }
      function f(E) {
        var C = "";
        return E.scheme && (C += E.scheme + ":"), C += "//", E.auth && (C += E.auth + "@"), E.host && (C += E.host), E.port && (C += ":" + E.port), E.path && (C += E.path), C;
      }
      function h(E) {
        var C = E, y = d(E);
        if (y) {
          if (!y.path) return E;
          C = y.path;
        }
        for (var T, E = s.isAbsolute(C), A = C.split(/\/+/), k = 0, N = A.length - 1; 0 <= N; N--) (T = A[N]) === "." ? A.splice(N, 1) : T === ".." ? k++ : 0 < k && (T === "" ? (A.splice(N + 1, k), k = 0) : (A.splice(N, 2), k--));
        return (C = A.join("/")) === "" && (C = E ? "/" : "."), y ? (y.path = C, f(y)) : C;
      }
      function p(E, C) {
        E === "" && (E = ".");
        var y = d(C = C === "" ? "." : C), T = d(E);
        return T && (E = T.path || "/"), y && !y.scheme ? (T && (y.scheme = T.scheme), f(y)) : y || C.match(l) ? C : !T || T.host || T.path ? (C = C.charAt(0) === "/" ? C : h(E.replace(/\/+$/, "") + "/" + C), T ? (T.path = C, f(T)) : C) : (T.host = C, f(T));
      }
      s.urlParse = d, s.urlGenerate = f, s.normalize = h, s.join = p, s.isAbsolute = function(E) {
        return E.charAt(0) === "/" || r.test(E);
      }, s.relative = function(C, y) {
        C = (C = C === "" ? "." : C).replace(/\/$/, "");
        for (var T = 0; y.indexOf(C + "/") !== 0; ) {
          var A = C.lastIndexOf("/");
          if (A < 0 || (C = C.slice(0, A)).match(/^([^\/]+:\/)?\/*$/)) return y;
          ++T;
        }
        return Array(T + 1).join("../") + y.substr(C.length + 1);
      };
      var g = !("__proto__" in /* @__PURE__ */ Object.create(null));
      function _(E) {
        return E;
      }
      function b(E) {
        if (E) {
          var C = E.length;
          if (!(C < 9) && E.charCodeAt(C - 1) === 95 && E.charCodeAt(C - 2) === 95 && E.charCodeAt(C - 3) === 111 && E.charCodeAt(C - 4) === 116 && E.charCodeAt(C - 5) === 111 && E.charCodeAt(C - 6) === 114 && E.charCodeAt(C - 7) === 112 && E.charCodeAt(C - 8) === 95 && E.charCodeAt(C - 9) === 95) {
            for (var y = C - 10; 0 <= y; y--) if (E.charCodeAt(y) !== 36) return;
            return 1;
          }
        }
      }
      function v(E, C) {
        return E === C ? 0 : E === null || C !== null && C < E ? 1 : -1;
      }
      s.toSetString = g ? _ : function(C) {
        return b(C) ? "$" + C : C;
      }, s.fromSetString = g ? _ : function(C) {
        return b(C) ? C.slice(1) : C;
      }, s.compareByOriginalPositions = function(C, y, T) {
        var A = v(C.source, y.source);
        return A !== 0 || (A = C.originalLine - y.originalLine) != 0 || (A = C.originalColumn - y.originalColumn) != 0 || T || (A = C.generatedColumn - y.generatedColumn) != 0 || (A = C.generatedLine - y.generatedLine) != 0 ? A : v(C.name, y.name);
      }, s.compareByGeneratedPositionsDeflated = function(C, y, T) {
        var A = C.generatedLine - y.generatedLine;
        return A !== 0 || (A = C.generatedColumn - y.generatedColumn) != 0 || T || (A = v(C.source, y.source)) !== 0 || (A = C.originalLine - y.originalLine) != 0 || (A = C.originalColumn - y.originalColumn) != 0 ? A : v(C.name, y.name);
      }, s.compareByGeneratedPositionsInflated = function(C, y) {
        var T = C.generatedLine - y.generatedLine;
        return T !== 0 || (T = C.generatedColumn - y.generatedColumn) != 0 || (T = v(C.source, y.source)) !== 0 || (T = C.originalLine - y.originalLine) != 0 || (T = C.originalColumn - y.originalColumn) != 0 ? T : v(C.name, y.name);
      }, s.parseSourceMapInput = function(C) {
        return JSON.parse(C.replace(/^\)]}'[^\n]*\n/, ""));
      }, s.computeSourceURL = function(C, y, T) {
        if (y = y || "", C && (C[C.length - 1] !== "/" && y[0] !== "/" && (C += "/"), y = C + y), T) {
          if (!(C = d(T))) throw new Error("sourceMapURL could not be parsed");
          !C.path || 0 <= (T = C.path.lastIndexOf("/")) && (C.path = C.path.substring(0, T + 1)), y = p(f(C), y);
        }
        return h(y);
      };
    }, function(a, s) {
      a.exports = { readFileSync: function() {
        return console.warn("fs should not be used in browser build"), null;
      } };
    }, function(a, s) {
      var r = /^(\w+:\/\/|\/\/)/;
      a.exports = function(d) {
        return r.test(d);
      };
    }, function(a, s, r) {
      var l = r(474), d = r(476);
      a.exports = function(h, p, g) {
        return l(d, h, p, g);
      };
    }, , function(a, s) {
      function r(l) {
        return a.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        }, a.exports.__esModule = !0, a.exports.default = a.exports, r(l);
      }
      a.exports = r, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      var r = Object.prototype;
      a.exports = function(d) {
        var f = d && d.constructor;
        return d === (typeof f == "function" && f.prototype || r);
      };
    }, function(a, s, r) {
      var l = r(30), d = r(19);
      a.exports = function(h) {
        return !!d(h) && ((h = l(h)) == "[object Function]" || h == "[object GeneratorFunction]" || h == "[object AsyncFunction]" || h == "[object Proxy]");
      };
    }, function(a, s, r) {
      var h = r(258), l = r(20), d = (r = Object.prototype).hasOwnProperty, f = r.propertyIsEnumerable, h = h(/* @__PURE__ */ function() {
        return arguments;
      }()) ? h : function(p) {
        return l(p) && d.call(p, "callee") && !f.call(p, "callee");
      };
      a.exports = h;
    }, function(a, s, r) {
      (function(l) {
        function d(_) {
          return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
            return typeof b;
          } : function(b) {
            return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
          })(_);
        }
        var g = r(17), f = r(259), h = d(s) == "object" && s && !s.nodeType && s, p = h && d(l) == "object" && l && !l.nodeType && l, g = (g = p && p.exports === h ? g.Buffer : void 0) ? g.isBuffer : void 0;
        l.exports = g || f;
      }).call(this, r(54)(a));
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = -1, h = l == null ? 0 : l.length; ++f < h && d(l[f], f, l) !== !1; ) ;
        return l;
      };
    }, function(a, s, p) {
      var l = p(268), d = p(269), f = p(270), h = p(271), p = p(272);
      function g(_) {
        var b = -1, v = _ == null ? 0 : _.length;
        for (this.clear(); ++b < v; ) {
          var E = _[b];
          this.set(E[0], E[1]);
        }
      }
      g.prototype.clear = l, g.prototype.delete = d, g.prototype.get = f, g.prototype.has = h, g.prototype.set = p, a.exports = g;
    }, function(a, s, r) {
      var l = r(77);
      a.exports = function(f, h) {
        for (var p = f.length; p--; ) if (l(f[p][0], h)) return p;
        return -1;
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return l === d || l != l && d != d;
      };
    }, function(a, s, r) {
      r = r(29)(Object, "create"), a.exports = r;
    }, function(a, s, r) {
      var l = r(286);
      a.exports = function(f, h) {
        return f = f.__data__, l(h) ? f[typeof h == "string" ? "string" : "hash"] : f.map;
      };
    }, function(a, s, r) {
      var l = r(44), d = r(33);
      a.exports = function(h, p) {
        for (var g = 0, _ = (p = l(p, h)).length; h != null && g < _; ) h = h[d(p[g++])];
        return g && g == _ ? h : void 0;
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        var f = -1, h = l.length;
        for (d = d || Array(h); ++f < h; ) d[f] = l[f];
        return d;
      };
    }, function(a, s, r) {
      var l = r(19), d = Object.create;
      function f() {
      }
      a.exports = function(h) {
        return l(h) ? d ? d(h) : (f.prototype = h, h = new f(), f.prototype = void 0, h) : {};
      };
    }, function(a, s, r) {
      function l(A) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(k) {
          return typeof k;
        } : function(k) {
          return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
        })(A);
      }
      var d = r(371).EOL, f = r(48), h = { AfterAtRule: "afterAtRule", AfterBlockBegins: "afterBlockBegins", AfterBlockEnds: "afterBlockEnds", AfterComment: "afterComment", AfterProperty: "afterProperty", AfterRuleBegins: "afterRuleBegins", AfterRuleEnds: "afterRuleEnds", BeforeBlockEnds: "beforeBlockEnds", BetweenSelectors: "betweenSelectors" }, p = { CarriageReturnLineFeed: `\r
`, LineFeed: `
`, System: d }, g = " ", _ = "	", b = { AroundSelectorRelation: "aroundSelectorRelation", BeforeBlockBegins: "beforeBlockBegins", BeforeValue: "beforeValue" }, v = { breaks: E(!1), breakWith: p.System, indentBy: 0, indentWith: g, spaces: C(!1), wrapAt: !1, semicolonAfterLastProperty: !1 };
      function E(A) {
        var k = {};
        return k[h.AfterAtRule] = A, k[h.AfterBlockBegins] = A, k[h.AfterBlockEnds] = A, k[h.AfterComment] = A, k[h.AfterProperty] = A, k[h.AfterRuleBegins] = A, k[h.AfterRuleEnds] = A, k[h.BeforeBlockEnds] = A, k[h.BetweenSelectors] = A, k;
      }
      function C(A) {
        var k = {};
        return k[b.AroundSelectorRelation] = A, k[b.BeforeBlockBegins] = A, k[b.BeforeValue] = A, k;
      }
      function y(A) {
        switch (A) {
          case "windows":
          case "crlf":
          case p.CarriageReturnLineFeed:
            return p.CarriageReturnLineFeed;
          case "unix":
          case "lf":
          case p.LineFeed:
            return p.LineFeed;
          default:
            return d;
        }
      }
      function T(A) {
        switch (A) {
          case "space":
            return g;
          case "tab":
            return _;
          default:
            return A;
        }
      }
      a.exports = { Breaks: h, Spaces: b, formatFrom: function(k) {
        return k !== void 0 && k !== !1 && (l(k) == "object" && "breakWith" in k && (k = f(k, { breakWith: y(k.breakWith) })), l(k) == "object" && "indentBy" in k && (k = f(k, { indentBy: parseInt(k.indentBy) })), l(k) == "object" && "indentWith" in k && (k = f(k, { indentWith: T(k.indentWith) })), l(k) == "object" || l(k) == "object" ? f(v, k) : typeof k == "string" && k == "beautify" ? f(v, { breaks: E(!0), indentBy: 2, spaces: C(!0) }) : typeof k == "string" && k == "keep-breaks" ? f(v, { breaks: { afterAtRule: !0, afterBlockBegins: !0, afterBlockEnds: !0, afterComment: !0, afterRuleEnds: !0, beforeBlockEnds: !0 } }) : typeof k == "string" ? f(v, function(j) {
          return j.split(";").reduce(function(I, U) {
            var U = (H = U.split(":"))[0], H = H[1];
            return U == "breaks" || U == "spaces" ? I[U] = function(Y) {
              return Y.split(",").reduce(function(ie, $) {
                var $ = (te = $.split("="))[0], te = te[1];
                return ie[$] = function(K) {
                  switch (K) {
                    case "false":
                    case "off":
                      return !1;
                    case "true":
                    case "on":
                      return !0;
                    default:
                      return K;
                  }
                }(te), ie;
              }, {});
            }(H) : U == "indentBy" || U == "wrapAt" ? I[U] = parseInt(H) : U == "indentWith" ? I[U] = T(H) : U == "breakWith" && (I[U] = y(H)), I;
          }, {});
        }(k)) : v);
      } };
    }, function(a, s) {
      a.exports = function(l) {
        var d = l[0], f = l[1];
        return (l = l[2]) ? l + ":" + d + ":" + f : d + ":" + f;
      };
    }, function(a, s, r) {
      var l = r(16), d = r(127), f = /\/deep\//, h = /^::/, p = [":dir", ":lang", ":not", ":nth-child", ":nth-last-child", ":nth-last-of-type", ":nth-of-type"], g = /[>\+~]/, _ = [":after", ":before", ":first-letter", ":first-line", ":lang"], b = ["::after", "::before", "::first-letter", "::first-line"], v = "double-quote", E = "single-quote", C = "root";
      a.exports = function(T, A, k, N) {
        for (var j, I = d(T, l.COMMA), B = 0, U = I.length; B < U; B++) if ((j = I[B]).length === 0 || function(Q) {
          return f.test(Q);
        }(j) || -1 < j.indexOf(l.COLON) && !function(Q, Y, ie, ce, $) {
          return function(V, K, ne) {
            for (var J, L = 0, z = V.length; L < z; L++) if (J = -1 < (J = V[L]).indexOf(l.OPEN_ROUND_BRACKET) ? J.substring(0, J.indexOf(l.OPEN_ROUND_BRACKET)) : J, K.indexOf(J) === -1 && ne.indexOf(J) === -1) return;
            return 1;
          }(Y, ie, ce) && function(V) {
            for (var K, ne, J, L = 0, z = V.length; L < z; L++)
              if (K = (J = -1 < (ne = (K = V[L]).indexOf(l.OPEN_ROUND_BRACKET))) ? K.substring(0, ne) : K, J && p.indexOf(K) == -1 || !J && -1 < p.indexOf(K)) return;
            return 1;
          }(Y) && (Y.length < 2 || !function(V, K) {
            for (var ne, J, L, z, ee = 0, q = 0, X = K.length; q < X && (ne = K[q], J = K[q + 1]); q++) if (L = V.indexOf(ne, ee), z = V.indexOf(ne, L + 1), L + ne.length == (ee = z) && (L = -1 < ne.indexOf(l.OPEN_ROUND_BRACKET) ? ne.substring(0, ne.indexOf(l.OPEN_ROUND_BRACKET)) : ne, z = -1 < J.indexOf(l.OPEN_ROUND_BRACKET) ? J.substring(0, J.indexOf(l.OPEN_ROUND_BRACKET)) : J, L != ":not" || z != ":not")) return 1;
          }(Q, Y)) && (Y.length < 2 || $ && function(V) {
            for (var K, ne = 0, J = 0, L = V.length; J < L; J++) if (function(ee) {
              return h.test(ee);
            }(K = V[J]) ? ne += -1 < b.indexOf(K) ? 1 : 0 : ne += -1 < _.indexOf(K) ? 1 : 0, 1 < ne) return;
            return 1;
          }(Y));
        }(j, function(Q) {
          for (var Y, ie, ce, $, te = [], V = [], K = C, ne = 0, J = !1, L = !1, z = 0, ee = Q.length; z < ee; z++) Y = Q[z], $ = !ce && g.test(Y), ie = K == v || K == E, ce ? V.push(Y) : Y == l.DOUBLE_QUOTE && K == C ? (V.push(Y), K = v) : Y == l.DOUBLE_QUOTE && K == v ? (V.push(Y), K = C) : Y == l.SINGLE_QUOTE && K == C ? (V.push(Y), K = E) : Y == l.SINGLE_QUOTE && K == E ? (V.push(Y), K = C) : ie ? V.push(Y) : Y == l.OPEN_ROUND_BRACKET ? (V.push(Y), ne++) : Y == l.CLOSE_ROUND_BRACKET && ne == 1 && J ? (V.push(Y), te.push(V.join("")), ne--, J = !(V = [])) : Y == l.CLOSE_ROUND_BRACKET ? (V.push(Y), ne--) : Y == l.COLON && ne === 0 && J && !L ? (te.push(V.join("")), (V = []).push(Y)) : Y != l.COLON || ne !== 0 || L ? Y == l.SPACE && ne === 0 && J || $ && ne === 0 && J ? (te.push(V.join("")), J = !(V = [])) : V.push(Y) : ((V = []).push(Y), J = !0), ce = Y == l.BACK_SLASH, L = Y == l.COLON;
          return 0 < V.length && J && te.push(V.join("")), te;
        }(j), A, k, N)) return !1;
        return !0;
      };
    }, function(a, s, r) {
      var l = r(376), d = r(381), f = r(129), h = r(130), p = r(49).all, g = r(184), _ = r(62), b = r(26).OptimizationLevel;
      a.exports = function v(E, C, y, T) {
        var A, k, N, j = T.options.level[b.Two], I = p(E, !1, j.skipProperties);
        for (f(I, T.validator, T.warnings), k = 0, N = I.length; k < N; k++) (A = I[k]).block && v(A.value[0][1], C, y, T);
        y && j.mergeIntoShorthands && l(I, T.validator), C && j.overrideProperties && d(I, y, T.options.compatibility, T.validator), _(I, h), g(I);
      };
    }, function(a, s, r) {
      var l = r(49).single, d = r(12);
      function f(h) {
        var p = l([d.PROPERTY, [d.PROPERTY_NAME, h.name]]);
        return p.important = h.important, p.hack = h.hack, p.unused = !1, p;
      }
      a.exports = { deep: function(p) {
        for (var g = f(p), _ = p.components.length - 1; 0 <= _; _--) {
          var b = f(p.components[_]);
          b.value = p.components[_].value.slice(0), g.components.unshift(b);
        }
        return g.dirty = !0, g.value = p.value.slice(0), g;
      }, shallow: f };
    }, function(a, s, r) {
      var l = r(190), d = r(387), f = /align\-items|box\-align|box\-pack|flex|justify/, h = /^border\-(top|right|bottom|left|color|style|width|radius)/;
      function p(Y, ie, A) {
        var k = Y[0], N = Y[1], j = Y[2], I = Y[5], B = Y[6], U = ie[0], H = ie[1], Q = ie[2], Y = ie[5], ie = ie[6];
        return !(k == "font" && U == "line-height" || U == "font" && k == "line-height" || f.test(k) && f.test(U) || j == Q && _(k) == _(U) && g(k) ^ g(U) || j == "border" && h.test(Q) && (k == "border" || k == Q || N != H && b(k, U)) || Q == "border" && h.test(j) && (U == "border" || U == j || N != H && b(k, U)) || j == "border" && Q == "border" && k != U && (v(k) && E(U) || E(k) && v(U)) || !(j != Q || !(k != U || j != Q || N != H && !function($, te) {
          return g($) && g(te) && $.split("-")[1] != te.split("-")[2];
        }(N, H)) || k != U && j == Q && k != j && U != Q || k != U && j == Q && N == H) && (!ie || !B || C(j) || C(Q) || l(Y, I, !1)) && d(I, Y, A));
      }
      function g(y) {
        return /^\-(?:moz|webkit|ms|o)\-/.test(y);
      }
      function _(y) {
        return y.replace(/^\-(?:moz|webkit|ms|o)\-/, "");
      }
      function b(y, T) {
        return y.split("-").pop() == T.split("-").pop();
      }
      function v(y) {
        return y == "border-top" || y == "border-right" || y == "border-bottom" || y == "border-left";
      }
      function E(y) {
        return y == "border-color" || y == "border-style" || y == "border-width";
      }
      function C(y) {
        return y == "font" || y == "line-height" || y == "list-style";
      }
      a.exports = { canReorder: function(T, A, k) {
        for (var N = A.length - 1; 0 <= N; N--) for (var j = T.length - 1; 0 <= j; j--) if (!p(T[j], A[N], k)) return !1;
        return !0;
      }, canReorderSingle: p };
    }, function(a, s, r) {
      (function(l) {
        l === void 0 || !l.version || l.version.indexOf("v0.") === 0 || l.version.indexOf("v1.") === 0 && l.version.indexOf("v1.8.") !== 0 ? a.exports = { nextTick: function(f, h, p, g) {
          if (typeof f != "function") throw new TypeError('"callback" argument must be a function');
          var _, b, v = arguments.length;
          switch (v) {
            case 0:
            case 1:
              return l.nextTick(f);
            case 2:
              return l.nextTick(function() {
                f.call(null, h);
              });
            case 3:
              return l.nextTick(function() {
                f.call(null, h, p);
              });
            case 4:
              return l.nextTick(function() {
                f.call(null, h, p, g);
              });
            default:
              for (_ = new Array(v - 1), b = 0; b < _.length; ) _[b++] = arguments[b];
              return l.nextTick(function() {
                f.apply(null, _);
              });
          }
        } } : a.exports = l;
      }).call(this, r(15));
    }, function(a, s) {
      (function(r) {
        a.exports = r;
      }).call(this, {});
    }, function(a, s) {
      var r = /^\/\//;
      a.exports = function(d) {
        return !r.test(d);
      };
    }, function(a, s, r) {
      var l = r(82), d = r(19);
      a.exports = function(h) {
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return new h();
            case 1:
              return new h(p[0]);
            case 2:
              return new h(p[0], p[1]);
            case 3:
              return new h(p[0], p[1], p[2]);
            case 4:
              return new h(p[0], p[1], p[2], p[3]);
            case 5:
              return new h(p[0], p[1], p[2], p[3], p[4]);
            case 6:
              return new h(p[0], p[1], p[2], p[3], p[4], p[5]);
            case 7:
              return new h(p[0], p[1], p[2], p[3], p[4], p[5], p[6]);
          }
          var g = l(h.prototype), _ = h.apply(g, p);
          return d(_) ? _ : g;
        };
      };
    }, function(a, s, r) {
      function l(y) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
          return typeof T;
        } : function(T) {
          return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
        })(y);
      }
      function d(y) {
        return function(A) {
          if (Array.isArray(A)) return h(A);
        }(y) || function(A) {
          if (typeof Symbol < "u" && A[Symbol.iterator] != null || A["@@iterator"] != null) return Array.from(A);
        }(y) || f(y) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function f(y, T) {
        if (y) {
          if (typeof y == "string") return h(y, T);
          var A = Object.prototype.toString.call(y).slice(8, -1);
          return (A = A === "Object" && y.constructor ? y.constructor.name : A) === "Map" || A === "Set" ? Array.from(y) : A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A) ? h(y, T) : void 0;
        }
      }
      function h(y, T) {
        (T == null || T > y.length) && (T = y.length);
        for (var A = 0, k = new Array(T); A < T; A++) k[A] = y[A];
        return k;
      }
      function p(y, T) {
        var A, k = Object.keys(y);
        return Object.getOwnPropertySymbols && (A = Object.getOwnPropertySymbols(y), T && (A = A.filter(function(N) {
          return Object.getOwnPropertyDescriptor(y, N).enumerable;
        })), k.push.apply(k, A)), k;
      }
      function g(y) {
        for (var T = 1; T < arguments.length; T++) {
          var A = arguments[T] != null ? arguments[T] : {};
          T % 2 ? p(Object(A), !0).forEach(function(k) {
            (function(j, I, B) {
              (I = function(H) {
                return H = function(Y, ie) {
                  if (l(Y) != "object" || !Y) return Y;
                  var ce = Y[Symbol.toPrimitive];
                  if (ce === void 0) return (ie === "string" ? String : Number)(Y);
                  if (l(ie = ce.call(Y, ie || "default")) != "object") return ie;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(H, "string"), l(H) == "symbol" ? H : String(H);
              }(I)) in j ? Object.defineProperty(j, I, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : j[I] = B;
            })(y, k, A[k]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(A)) : p(Object(A)).forEach(function(k) {
            Object.defineProperty(y, k, Object.getOwnPropertyDescriptor(A, k));
          });
        }
        return y;
      }
      var _ = r(38).default, b = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), Object.defineProperty(s, "assignDependencies", { enumerable: !0, get: function() {
        return E.assignDependencies;
      } }), s.default = function y(T) {
        var A = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, k = T.children, N = T.tagName, j = [], I = A.skipElements || C;
        if (A.dependencies == null && console.warn('"dependencies" option should be provided to mjml validator'), !I.includes(N)) for (var B = 0, U = Object.values(v.default); B < U.length; B++) {
          var H = (0, U[B])(T, g({ dependencies: E.default, skipElements: I }, A));
          Array.isArray(H) ? j.push.apply(j, d(H)) : H && j.push(H);
        }
        if (k && 0 < k.length) {
          var Q, Y = function($, te) {
            var V = typeof Symbol < "u" && $[Symbol.iterator] || $["@@iterator"];
            if (!V) {
              if (Array.isArray($) || (V = f($)) || te && $ && typeof $.length == "number") {
                V && ($ = V);
                var K = 0;
                return { s: te = function() {
                }, n: function() {
                  return K >= $.length ? { done: !0 } : { done: !1, value: $[K++] };
                }, e: function(ee) {
                  throw ee;
                }, f: te };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var ne, J = !0, L = !1;
            return { s: function() {
              V = V.call($);
            }, n: function() {
              var ee = V.next();
              return J = ee.done, ee;
            }, e: function(ee) {
              L = !0, ne = ee;
            }, f: function() {
              try {
                J || V.return == null || V.return();
              } finally {
                if (L) throw ne;
              }
            } };
          }(k);
          try {
            for (Y.s(); !(Q = Y.n()).done; ) {
              var ie = Q.value;
              j.push.apply(j, d(y(ie, A)));
            }
          } catch (ce) {
            Y.e(ce);
          } finally {
            Y.f();
          }
        }
        return j;
      }, Object.defineProperty(s, "dependencies", { enumerable: !0, get: function() {
        return E.default;
      } }), s.formatValidationError = void 0, Object.defineProperty(s, "registerDependencies", { enumerable: !0, get: function() {
        return E.registerDependencies;
      } }), Object.defineProperty(s, "registerRule", { enumerable: !0, get: function() {
        return v.registerRule;
      } }), Object.defineProperty(s, "rulesCollection", { enumerable: !0, get: function() {
        return v.default;
      } });
      var b = b(r(52)), v = _(r(510)), E = _(r(516)), C = ["mjml"];
      s.formatValidationError = b.default;
    }, function(a, s) {
      a.exports = function(l) {
        return l == null;
      };
    }, function(a, s) {
      function r(l) {
        throw (l = new Error("Cannot find module '" + l + "'")).code = "MODULE_NOT_FOUND", l;
      }
      r.keys = function() {
        return [];
      }, (a.exports = r.resolve = r).id = 95;
    }, function(a, s, r) {
      var l, d, f, h, p = r(8), g = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(z) {
        return z.charCodeAt(0);
      })), _ = new Uint16Array("Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(z) {
        return z.charCodeAt(0);
      })), b = /* @__PURE__ */ new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]), v = (r = String.fromCodePoint) !== null && r !== void 0 ? r : function(z) {
        var ee = "";
        return 65535 < z && (z -= 65536, ee += String.fromCharCode(z >>> 10 & 1023 | 55296), z = 56320 | 1023 & z), ee + String.fromCharCode(z);
      };
      function E(z) {
        return (E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ee) {
          return typeof ee;
        } : function(ee) {
          return ee && typeof Symbol == "function" && ee.constructor === Symbol && ee !== Symbol.prototype ? "symbol" : typeof ee;
        })(z);
      }
      function C(z, ee) {
        for (var q = 0; q < ee.length; q++) {
          var X = ee[q];
          X.enumerable = X.enumerable || !1, X.configurable = !0, "value" in X && (X.writable = !0), Object.defineProperty(z, function(ae) {
            return ae = function(ve, Ee) {
              if (E(ve) != "object" || !ve) return ve;
              var we = ve[Symbol.toPrimitive];
              if (we === void 0) return (Ee === "string" ? String : Number)(ve);
              if (E(Ee = we.call(ve, Ee || "default")) != "object") return Ee;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ae, "string"), E(ae) == "symbol" ? ae : String(ae);
          }(X.key), X);
        }
      }
      function y(z) {
        return z >= l.ZERO && z <= l.NINE;
      }
      (r = l = l || {})[r.NUM = 35] = "NUM", r[r.SEMI = 59] = "SEMI", r[r.EQUALS = 61] = "EQUALS", r[r.ZERO = 48] = "ZERO", r[r.NINE = 57] = "NINE", r[r.LOWER_A = 97] = "LOWER_A", r[r.LOWER_F = 102] = "LOWER_F", r[r.LOWER_X = 120] = "LOWER_X", r[r.LOWER_Z = 122] = "LOWER_Z", r[r.UPPER_A = 65] = "UPPER_A", r[r.UPPER_F = 70] = "UPPER_F", r[r.UPPER_Z = 90] = "UPPER_Z", (r = d = {})[r.VALUE_LENGTH = 49152] = "VALUE_LENGTH", r[r.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", r[r.JUMP_TABLE = 127] = "JUMP_TABLE", (r = f = f || {})[r.EntityStart = 0] = "EntityStart", r[r.NumericStart = 1] = "NumericStart", r[r.NumericDecimal = 2] = "NumericDecimal", r[r.NumericHex = 3] = "NumericHex", r[r.NamedEntity = 4] = "NamedEntity", (r = h = h || {})[r.Legacy = 0] = "Legacy", r[r.Strict = 1] = "Strict", r[r.Attribute = 2] = "Attribute";
      var T = function() {
        function z(ee, q, X) {
          (function(ae, _e) {
            if (!(ae instanceof _e)) throw new TypeError("Cannot call a class as a function");
          })(this, z), this.decodeTree = ee, this.emitCodePoint = q, this.errors = X, this.state = f.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = h.Strict;
        }
        return function(q, X, oe) {
          X && C(q.prototype, X), Object.defineProperty(q, "prototype", { writable: !1 });
        }(z, [{ key: "startEntity", value: function(q) {
          this.decodeMode = q, this.state = f.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        } }, { key: "write", value: function(q, X) {
          switch (this.state) {
            case f.EntityStart:
              return q.charCodeAt(X) === l.NUM ? (this.state = f.NumericStart, this.consumed += 1, this.stateNumericStart(q, X + 1)) : (this.state = f.NamedEntity, this.stateNamedEntity(q, X));
            case f.NumericStart:
              return this.stateNumericStart(q, X);
            case f.NumericDecimal:
              return this.stateNumericDecimal(q, X);
            case f.NumericHex:
              return this.stateNumericHex(q, X);
            case f.NamedEntity:
              return this.stateNamedEntity(q, X);
          }
        } }, { key: "stateNumericStart", value: function(q, X) {
          return X >= q.length ? -1 : (32 | q.charCodeAt(X)) === l.LOWER_X ? (this.state = f.NumericHex, this.consumed += 1, this.stateNumericHex(q, X + 1)) : (this.state = f.NumericDecimal, this.stateNumericDecimal(q, X));
        } }, { key: "addToNumericResult", value: function(q, X, oe, ae) {
          X !== oe && (oe -= X, this.result = this.result * Math.pow(ae, oe) + parseInt(q.substr(X, oe), ae), this.consumed += oe);
        } }, { key: "stateNumericHex", value: function(q, X) {
          for (var oe = X; X < q.length; ) {
            var ae = q.charCodeAt(X);
            if (!y(ae) && !function(ve) {
              return ve >= l.UPPER_A && ve <= l.UPPER_F || ve >= l.LOWER_A && ve <= l.LOWER_F;
            }(ae)) return this.addToNumericResult(q, oe, X, 16), this.emitNumericEntity(ae, 3);
            X += 1;
          }
          return this.addToNumericResult(q, oe, X, 16), -1;
        } }, { key: "stateNumericDecimal", value: function(q, X) {
          for (var oe = X; X < q.length; ) {
            var ae = q.charCodeAt(X);
            if (!y(ae)) return this.addToNumericResult(q, oe, X, 10), this.emitNumericEntity(ae, 2);
            X += 1;
          }
          return this.addToNumericResult(q, oe, X, 10), -1;
        } }, { key: "emitNumericEntity", value: function(q, X) {
          if (this.consumed <= X) return (X = this.errors) !== null && X !== void 0 && X.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (q === l.SEMI) this.consumed += 1;
          else if (this.decodeMode === h.Strict) return 0;
          return this.emitCodePoint(function(ae) {
            var _e;
            return 55296 <= ae && ae <= 57343 || 1114111 < ae ? 65533 : (_e = b.get(ae)) !== null && _e !== void 0 ? _e : ae;
          }(this.result), this.consumed), this.errors && (q !== l.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        } }, { key: "stateNamedEntity", value: function(q, X) {
          for (var oe = this.decodeTree, ae = oe[this.treeIndex], _e = (ae & d.VALUE_LENGTH) >> 14; X < q.length; X++, this.excess++) {
            var ve = q.charCodeAt(X);
            if (this.treeIndex = function(we, Ge, Ie, je) {
              var qe = (Ge & d.BRANCH_LENGTH) >> 7, Ge = Ge & d.JUMP_TABLE;
              if (qe == 0) return Ge != 0 && je === Ge ? Ie : -1;
              if (Ge) return (Ge = je - Ge) < 0 || qe <= Ge ? -1 : we[Ie + Ge] - 1;
              for (var Ze = Ie, tt = Ze + qe - 1; Ze <= tt; ) {
                var Qe = Ze + tt >>> 1, ke = we[Qe];
                if (ke < je) Ze = 1 + Qe;
                else {
                  if (!(je < ke)) return we[Qe + qe];
                  tt = Qe - 1;
                }
              }
              return -1;
            }(oe, ae, this.treeIndex + Math.max(1, _e), ve), this.treeIndex < 0) return this.result === 0 || this.decodeMode === h.Attribute && (_e === 0 || function(we) {
              return we === l.EQUALS || function(Ie) {
                return Ie >= l.UPPER_A && Ie <= l.UPPER_Z || Ie >= l.LOWER_A && Ie <= l.LOWER_Z || y(Ie);
              }(we);
            }(ve)) ? 0 : this.emitNotTerminatedNamedEntity();
            if ((_e = ((ae = oe[this.treeIndex]) & d.VALUE_LENGTH) >> 14) != 0) {
              if (ve === l.SEMI) return this.emitNamedEntityData(this.treeIndex, _e, this.consumed + this.excess);
              this.decodeMode !== h.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        } }, { key: "emitNotTerminatedNamedEntity", value: function() {
          var q = this.result, X = (this.decodeTree[q] & d.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(q, X, this.consumed), (X = this.errors) !== null && X !== void 0 && X.missingSemicolonAfterCharacterReference(), this.consumed;
        } }, { key: "emitNamedEntityData", value: function(q, X, oe) {
          var ae = this.decodeTree;
          return this.emitCodePoint(X === 1 ? ae[q] & ~d.VALUE_LENGTH : ae[q + 1], oe), X === 3 && this.emitCodePoint(ae[q + 2], oe), oe;
        } }, { key: "end", value: function() {
          var q;
          switch (this.state) {
            case f.NamedEntity:
              return this.result === 0 || this.decodeMode === h.Attribute && this.result !== this.treeIndex ? 0 : this.emitNotTerminatedNamedEntity();
            case f.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case f.NumericHex:
              return this.emitNumericEntity(0, 3);
            case f.NumericStart:
              return (q = this.errors) !== null && q !== void 0 && q.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case f.EntityStart:
              return 0;
          }
        } }]), z;
      }();
      function A(z) {
        var ee = "";
        return new T(z, function(q) {
          return ee += v(q);
        }), 1;
      }
      function k(z) {
        for (var ee = 1; ee < z.length; ee++) z[ee][0] += z[ee - 1][0] + 1;
        return z;
      }
      A(g), A(_), new Map(k([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(k([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(k([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(k([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
      var N = /["&'<>$\x80-\uFFFF]/g, j = /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]), I = String.prototype.codePointAt != null ? function(z, ee) {
        return z.codePointAt(ee);
      } : function(z, ee) {
        return (64512 & z.charCodeAt(ee)) == 55296 ? 1024 * (z.charCodeAt(ee) - 55296) + z.charCodeAt(ee + 1) - 56320 + 65536 : z.charCodeAt(ee);
      };
      function B(z) {
        for (var ee = "", ae = 0; (oe = N.exec(z)) !== null; ) var q = oe.index, X = z.charCodeAt(q), oe = j.get(X), ae = oe !== void 0 ? (ee += z.substring(ae, q) + oe, q + 1) : (ee += "".concat(z.substring(ae, q), "&#x").concat(I(z, q).toString(16), ";"), N.lastIndex += +((64512 & X) == 55296));
        return ee + z.substr(ae);
      }
      function U(z, ee) {
        return function(X) {
          for (var oe, ae = 0, _e = ""; oe = z.exec(X); ) ae !== oe.index && (_e += X.substring(ae, oe.index)), _e += ee.get(oe[0].charCodeAt(0)), ae = oe.index + 1;
          return _e + X.substring(ae);
        };
      }
      var H = U(/["&\u00A0]/g, /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]])), Q = U(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
      (_ = {})[_.XML = 0] = "XML", _[_.HTML = 1] = "HTML", (_ = {})[_.UTF8 = 0] = "UTF8", _[_.ASCII = 1] = "ASCII", _[_.Extensive = 2] = "Extensive", _[_.Attribute = 3] = "Attribute", _[_.Text = 4] = "Text";
      var Y = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function(z) {
        return [z.toLowerCase(), z];
      })), ie = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function(z) {
        return [z.toLowerCase(), z];
      }));
      function ce(z) {
        return (ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ee) {
          return typeof ee;
        } : function(ee) {
          return ee && typeof Symbol == "function" && ee.constructor === Symbol && ee !== Symbol.prototype ? "symbol" : typeof ee;
        })(z);
      }
      function $(z, ee) {
        var q, X = Object.keys(z);
        return Object.getOwnPropertySymbols && (q = Object.getOwnPropertySymbols(z), ee && (q = q.filter(function(oe) {
          return Object.getOwnPropertyDescriptor(z, oe).enumerable;
        })), X.push.apply(X, q)), X;
      }
      function te(z) {
        for (var ee = 1; ee < arguments.length; ee++) {
          var q = arguments[ee] != null ? arguments[ee] : {};
          ee % 2 ? $(Object(q), !0).forEach(function(X) {
            (function(ae, _e, ve) {
              (_e = function(we) {
                return we = function(Ie, je) {
                  if (ce(Ie) != "object" || !Ie) return Ie;
                  var qe = Ie[Symbol.toPrimitive];
                  if (qe === void 0) return (je === "string" ? String : Number)(Ie);
                  if (ce(je = qe.call(Ie, je || "default")) != "object") return je;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(we, "string"), ce(we) == "symbol" ? we : String(we);
              }(_e)) in ae ? Object.defineProperty(ae, _e, { value: ve, enumerable: !0, configurable: !0, writable: !0 }) : ae[_e] = ve;
            })(z, X, q[X]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(z, Object.getOwnPropertyDescriptors(q)) : $(Object(q)).forEach(function(X) {
            Object.defineProperty(z, X, Object.getOwnPropertyDescriptor(q, X));
          });
        }
        return z;
      }
      var V = /* @__PURE__ */ new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
      function K(z) {
        return z.replace(/"/g, "&quot;");
      }
      var ne = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
      s.a = function z(ee) {
        for (var q = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, X = ("length" in ee) ? ee : [ee], oe = "", ae = 0; ae < X.length; ae++) oe += function(ve, Ee) {
          switch (ve.type) {
            case p.Root:
              return z(ve.children, Ee);
            case p.Doctype:
            case p.Directive:
              return function(ze) {
                return "<".concat(ze.data, ">");
              }(ve);
            case p.Comment:
              return function(ze) {
                return "<!--".concat(ze.data, "-->");
              }(ve);
            case p.CDATA:
              return function(ze) {
                return "<![CDATA[".concat(ze.children[0].data, "]]>");
              }(ve);
            case p.Script:
            case p.Style:
            case p.Tag:
              return function(ze, Ie) {
                Ie.xmlMode === "foreign" && (ze.name = (qe = Y.get(ze.name)) !== null && qe !== void 0 ? qe : ze.name, ze.parent && J.has(ze.parent.name) && (Ie = te(te({}, Ie), {}, { xmlMode: !1 }))), !Ie.xmlMode && L.has(ze.name) && (Ie = te(te({}, Ie), {}, { xmlMode: "foreign" }));
                var je = "<".concat(ze.name), qe = function(Ze, tt) {
                  var Qe;
                  if (Ze) {
                    var ke = ((Qe = tt.encodeEntities) !== null && Qe !== void 0 ? Qe : tt.decodeEntities) === !1 ? K : tt.xmlMode || tt.encodeEntities !== "utf8" ? B : H;
                    return Object.keys(Ze).map(function(pe) {
                      var Se, he = (Se = Ze[pe]) !== null && Se !== void 0 ? Se : "";
                      return tt.xmlMode === "foreign" && (pe = (Se = ie.get(pe)) !== null && Se !== void 0 ? Se : pe), tt.emptyAttrs || tt.xmlMode || he !== "" ? "".concat(pe, '="').concat(ke(he), '"') : pe;
                    }).join(" ");
                  }
                }(ze.attribs, Ie);
                return qe && (je += " ".concat(qe)), ze.children.length === 0 && (Ie.xmlMode ? Ie.selfClosingTags !== !1 : Ie.selfClosingTags && ne.has(ze.name)) ? (Ie.xmlMode || (je += " "), je += "/>") : (je += ">", 0 < ze.children.length && (je += z(ze.children, Ie)), !Ie.xmlMode && ne.has(ze.name) || (je += "</".concat(ze.name, ">"))), je;
              }(ve, Ee);
            case p.Text:
              return function(ze, Ie) {
                var je, qe = ze.data || "";
                return qe = ((je = Ie.encodeEntities) !== null && je !== void 0 ? je : Ie.decodeEntities) === !1 || !Ie.xmlMode && ze.parent && V.has(ze.parent.name) ? qe : (Ie.xmlMode || Ie.encodeEntities !== "utf8" ? B : Q)(qe);
              }(ve, Ee);
          }
        }(X[ae], q);
        return oe;
      };
      var J = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]), L = /* @__PURE__ */ new Set(["svg", "math"]);
    }, function(a, s) {
      function r(l, d) {
        return a.exports = r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(h, p) {
          return h.__proto__ = p, h;
        }, a.exports.__esModule = !0, a.exports.default = a.exports, r(l, d);
      }
      a.exports = r, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(70), d = r(248), f = Object.prototype.hasOwnProperty;
      a.exports = function(p) {
        if (!l(p)) return d(p);
        var g, _ = [];
        for (g in Object(p)) f.call(p, g) && g != "constructor" && _.push(g);
        return _;
      };
    }, function(a, s, r) {
      r = r(29)(r(17), "Map"), a.exports = r;
    }, function(a, s) {
      a.exports = function(l) {
        return typeof l == "number" && -1 < l && l % 1 == 0 && l <= 9007199254740991;
      };
    }, function(a, s, r) {
      var d = r(260), l = r(102), d = (r = (r = r(103)) && r.isTypedArray) ? l(r) : d;
      a.exports = d;
    }, function(a, s) {
      a.exports = function(l) {
        return function(d) {
          return l(d);
        };
      };
    }, function(a, s, r) {
      (function(l) {
        function d(_) {
          return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
            return typeof b;
          } : function(b) {
            return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
          })(_);
        }
        var g = r(154), f = d(s) == "object" && s && !s.nodeType && s, h = f && d(l) == "object" && l && !l.nodeType && l, p = h && h.exports === f && g.process, g = function() {
          try {
            var _ = h && h.require && h.require("util").types;
            return _ || p && p.binding && p.binding("util");
          } catch {
          }
        }();
        l.exports = g;
      }).call(this, r(54)(a));
    }, function(a, s, g) {
      var l = g(75), d = g(273), f = g(274), h = g(275), p = g(276), g = g(277);
      function _(b) {
        b = this.__data__ = new l(b), this.size = b.size;
      }
      _.prototype.clear = d, _.prototype.delete = f, _.prototype.get = h, _.prototype.has = p, _.prototype.set = g, a.exports = _;
    }, function(a, s, p) {
      var l = p(278), d = p(285), f = p(287), h = p(288), p = p(289);
      function g(_) {
        var b = -1, v = _ == null ? 0 : _.length;
        for (this.clear(); ++b < v; ) {
          var E = _[b];
          this.set(E[0], E[1]);
        }
      }
      g.prototype.clear = l, g.prototype.delete = d, g.prototype.get = f, g.prototype.has = h, g.prototype.set = p, a.exports = g;
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = -1, h = d.length, p = l.length; ++f < h; ) l[p + f] = d[f];
        return l;
      };
    }, function(a, s, h) {
      var l = h(167), h = h(168), d = Object.prototype.propertyIsEnumerable, f = Object.getOwnPropertySymbols, h = f ? function(p) {
        return p == null ? [] : (p = Object(p), l(f(p), function(g) {
          return d.call(p, g);
        }));
      } : h;
      a.exports = h;
    }, function(a, s, r) {
      function l(g) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
          return typeof _;
        } : function(_) {
          return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
        })(g);
      }
      var d = r(13), f = r(45), h = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, p = /^\w*$/;
      a.exports = function(_, b) {
        if (d(_)) return !1;
        var v = l(_);
        return !(v != "number" && v != "symbol" && v != "boolean" && _ != null && !f(_)) || p.test(_) || !h.test(_) || b != null && _ in Object(b);
      };
    }, function(a, s, r) {
      var l = r(104), d = r(74), f = r(110), h = r(174), p = r(311), g = r(314), _ = r(81), b = r(315), v = r(316), E = r(165), C = r(114), y = r(40), T = r(317), A = r(318), k = r(323), N = r(13), j = r(73), I = r(324), B = r(19), U = r(326), H = r(32), Q = r(112), Y = "[object Arguments]", ie = "[object Function]", ce = "[object Object]", $ = {};
      $[Y] = $["[object Array]"] = $["[object ArrayBuffer]"] = $["[object DataView]"] = $["[object Boolean]"] = $["[object Date]"] = $["[object Float32Array]"] = $["[object Float64Array]"] = $["[object Int8Array]"] = $["[object Int16Array]"] = $["[object Int32Array]"] = $["[object Map]"] = $["[object Number]"] = $[ce] = $["[object RegExp]"] = $["[object Set]"] = $["[object String]"] = $["[object Symbol]"] = $["[object Uint8Array]"] = $["[object Uint8ClampedArray]"] = $["[object Uint16Array]"] = $["[object Uint32Array]"] = !0, $["[object Error]"] = $[ie] = $["[object WeakMap]"] = !1, a.exports = function te(V, K, ne, J, L, z) {
        var ee, q = 1 & K, X = 2 & K, oe = 4 & K;
        if ((ee = ne ? L ? ne(V, J, L, z) : ne(V) : ee) !== void 0) return ee;
        if (!B(V)) return V;
        var ae = N(V);
        if (ae) {
          if (ee = T(V), !q) return _(V, ee);
        } else {
          var _e = y(V), J = _e == ie || _e == "[object GeneratorFunction]";
          if (j(V)) return g(V, q);
          if (_e == ce || _e == Y || J && !L) {
            if (ee = X || J ? {} : k(V), !q) return X ? v(V, p(ee, V)) : b(V, h(ee, V));
          } else {
            if (!$[_e]) return L ? V : {};
            ee = A(V, _e, q);
          }
        }
        if (q = (z = z || new l()).get(V)) return q;
        z.set(V, ee), U(V) ? V.forEach(function(Ee) {
          ee.add(te(Ee, K, ne, Ee, V, z));
        }) : I(V) && V.forEach(function(Ee, we) {
          ee.set(we, te(Ee, K, ne, we, V, z));
        });
        var ve = ae ? void 0 : (oe ? X ? C : E : X ? Q : H)(V);
        return d(ve || V, function(Ee, we) {
          ve && (Ee = V[we = Ee]), f(ee, we, te(Ee, K, ne, we, V, z));
        }), ee;
      };
    }, function(a, s, r) {
      var l = r(111), d = r(77), f = Object.prototype.hasOwnProperty;
      a.exports = function(p, g, _) {
        var b = p[g];
        f.call(p, g) && d(b, _) && (_ !== void 0 || g in p) || l(p, g, _);
      };
    }, function(a, s, r) {
      var l = r(173);
      a.exports = function(f, h, p) {
        h == "__proto__" && l ? l(f, h, { configurable: !0, enumerable: !0, value: p, writable: !0 }) : f[h] = p;
      };
    }, function(a, s, r) {
      var l = r(159), d = r(312), f = r(31);
      a.exports = function(p) {
        return f(p) ? l(p, !0) : d(p);
      };
    }, function(a, s, r) {
      r = r(153)(Object.getPrototypeOf, Object), a.exports = r;
    }, function(a, s, r) {
      var l = r(166), d = r(175), f = r(112);
      a.exports = function(p) {
        return l(p, f, d);
      };
    }, function(a, s, r) {
      var l = r(164);
      a.exports = function(f) {
        var h = new f.constructor(f.byteLength);
        return new l(h).set(new l(f)), h;
      };
    }, function(a, s, r) {
      var l = r(333), d = r(336), f = r(177);
      a.exports = function(p) {
        return f(d(p, void 0, l), p + "");
      };
    }, function(a, s) {
      a.exports = function(l, d, f) {
        switch (f.length) {
          case 0:
            return l.call(d);
          case 1:
            return l.call(d, f[0]);
          case 2:
            return l.call(d, f[0], f[1]);
          case 3:
            return l.call(d, f[0], f[1], f[2]);
        }
        return l.apply(d, f);
      };
    }, function(a, s, r) {
      var l = r(167), d = r(340), f = r(21), h = r(13);
      a.exports = function(g, _) {
        return (h(g) ? l : d)(g, f(_, 3));
      };
    }, function(a, s) {
      a.exports = function(l, d, f, h) {
        for (var p = l.length, g = f + (h ? 1 : -1); h ? g-- : ++g < p; ) if (d(l[g], g, l)) return g;
        return -1;
      };
    }, function(a, s, f) {
      var l = f(352), d = f(355), f = f(357);
      s.Selector = d, s.Property = f, s.extract = function(p) {
        for (var g = 0, _ = [], b = "", v = 0, E = p.length; v < E; v++) {
          var C = p.charAt(v);
          g ? (C !== "]" && C !== ")" || g--, b += C) : C === "," ? (_.push(b), b = "") : (C !== "[" && C !== "(" || g++, (b.length || C !== "," && C !== `
` && C !== " ") && (b += C));
        }
        return b.length && _.push(b), _;
      }, s.parseCSS = function(h) {
        for (var p = (h = l.parse(h, { position: !0, comments: !0 })).stylesheet !== void 0 && h.stylesheet.rules ? h.stylesheet.rules : [], g = [], _ = 0, b = p.length; _ < b; _++) if (p[_].type == "rule") for (var v = p[_], E = v.selectors, C = 0, y = E.length; C < y; C++) g.push([E[C], v.declarations]);
        return g;
      }, s.getPreservedText = function(h, p, g) {
        for (var _ = (h = l.parse(h, { position: !0, comments: !0 })).stylesheet !== void 0 && h.stylesheet.rules ? h.stylesheet.rules : [], b = [], v = _.length - 1; 0 <= v; v--) (p.fontFaces && _[v].type === "font-face" || p.mediaQueries && _[v].type === "media" || p.keyFrames && _[v].type === "keyframes" || p.pseudos && _[v].selectors && this.matchesPseudo(_[v].selectors[0], g)) && b.unshift(l.stringify({ stylesheet: { rules: [_[v]] } }, { comments: !1, indentation: "  " })), _[v].position.start;
        return b.length !== 0 && `
` + b.join(`
`) + `
`;
      }, s.normalizeLineEndings = function(h) {
        return h.replace(/\r\n/g, `
`).replace(/\n/g, `\r
`);
      }, s.matchesPseudo = function(h, p) {
        return p.find(function(g) {
          return -1 < h.indexOf(g);
        });
      }, s.compareFunc = function(h, p) {
        for (var g = Math.min(h.length, p.length), _ = 0; _ < g; _++) if (h[_] !== p[_]) return h[_] > p[_] ? 1 : -1;
        return h.length - p.length;
      }, s.compare = function(h, p) {
        return s.compareFunc(h, p) == 1 ? h : p;
      }, s.getDefaultOptions = function(h) {
        return (h = Object.assign({ extraCss: "", insertPreservedExtraCss: !0, applyStyleTags: !0, removeStyleTags: !0, preserveMediaQueries: !0, preserveFontFaces: !0, preserveKeyFrames: !0, preservePseudos: !0, applyWidthAttributes: !0, applyHeightAttributes: !0, applyAttributesTableElements: !0, resolveCSSVariables: !0, url: "" }, h)).webResources = h.webResources || {}, h;
      };
    }, function(a, s, r) {
      (function(l) {
        a.exports = function(f) {
          return (function(p) {
            var g = [].slice.call(arguments, 1);
            g.unshift("[" + p + "]"), l.stderr.write(g.join(" ") + `
`);
          }).bind(null, f);
        };
      }).call(this, r(15));
    }, function(a, s, r) {
      var l;
      function d(f) {
        return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
          return typeof h;
        } : function(h) {
          return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
        })(f);
      }
      (function() {
        var f;
        (function() {
          var p = [function(b, v, E) {
            var C = E(1).Beautifier, y = E(5).Options;
            b.exports = function(A, k) {
              return new C(A, k).beautify();
            }, b.exports.defaultOptions = function() {
              return new y();
            };
          }, function(b, v, E) {
            var C = E(2).Output, y = E(3).Token, T = E(4), A = E(5).Options, k = E(7).Tokenizer, N = E(7).line_starters, j = E(7).positionable_operators, I = E(7).TOKEN;
            function B(ne, J) {
              return J.indexOf(ne) !== -1;
            }
            function U(ne, J) {
              return ne && ne.type === I.RESERVED && ne.text === J;
            }
            function H(ne, J) {
              return ne && ne.type === I.RESERVED && B(ne.text, J);
            }
            var Q = ["case", "return", "do", "if", "throw", "else", "await", "break", "continue", "async"], Y = function(J) {
              for (var L = {}, z = 0; z < J.length; z++) L[J[z].replace(/-/g, "_")] = J[z];
              return L;
            }(["before-newline", "after-newline", "preserve-newline"]), ie = [Y.before_newline, Y.preserve_newline];
            function ce(ne, J) {
              J.multiline_frame || J.mode === "ForInitializer" || J.mode === "Conditional" || ne.remove_indent(J.start_line_index);
            }
            function $(ne) {
              return ne === "ArrayLiteral";
            }
            function te(ne) {
              return B(ne, ["Expression", "ForInitializer", "Conditional"]);
            }
            function V(ne, J) {
              J = J || {}, this._source_text = ne || "", this._output = null, this._tokens = null, this._last_last_text = null, this._flags = null, this._previous_flags = null, this._flag_store = null, this._options = new A(J);
            }
            V.prototype.create_flags = function(ne, J) {
              var L = 0;
              return ne && (L = ne.indentation_level, !this._output.just_added_newline() && ne.line_indent_level > L && (L = ne.line_indent_level)), { mode: J, parent: ne, last_token: ne ? ne.last_token : new y(I.START_BLOCK, ""), last_word: ne ? ne.last_word : "", declaration_statement: !1, declaration_assignment: !1, multiline_frame: !1, inline_frame: !1, if_block: !1, else_block: !1, class_start_block: !1, do_block: !1, do_while: !1, import_block: !1, in_case_statement: !1, in_case: !1, case_body: !1, case_block: !1, indentation_level: L, alignment: 0, line_indent_level: ne ? ne.line_indent_level : L, start_line_index: this._output.get_line_number(), ternary_depth: 0 };
            }, V.prototype._reset = function(ne) {
              var J = ne.match(/^[\t ]*/)[0];
              return this._last_last_text = "", this._output = new C(this._options, J), this._output.raw = this._options.test_output_raw, this._flag_store = [], this.set_mode("BlockStatement"), J = new k(ne, this._options), this._tokens = J.tokenize(), ne;
            }, V.prototype.beautify = function() {
              if (this._options.disabled) return this._source_text;
              var ne = this._reset(this._source_text), J = this._options.eol;
              this._options.eol === "auto" && (J = `
`, ne && T.lineBreak.test(ne || "") && (J = ne.match(T.lineBreak)[0]));
              for (var L = this._tokens.next(); L; ) this.handle_token(L), this._last_last_text = this._flags.last_token.text, this._flags.last_token = L, L = this._tokens.next();
              return this._output.get_code(J);
            }, V.prototype.handle_token = function(ne, J) {
              ne.type === I.START_EXPR ? this.handle_start_expr(ne) : ne.type === I.END_EXPR ? this.handle_end_expr(ne) : ne.type === I.START_BLOCK ? this.handle_start_block(ne) : ne.type === I.END_BLOCK ? this.handle_end_block(ne) : ne.type === I.WORD || ne.type === I.RESERVED ? this.handle_word(ne) : ne.type === I.SEMICOLON ? this.handle_semicolon(ne) : ne.type === I.STRING ? this.handle_string(ne) : ne.type === I.EQUALS ? this.handle_equals(ne) : ne.type === I.OPERATOR ? this.handle_operator(ne) : ne.type === I.COMMA ? this.handle_comma(ne) : ne.type === I.BLOCK_COMMENT ? this.handle_block_comment(ne, J) : ne.type === I.COMMENT ? this.handle_comment(ne, J) : ne.type === I.DOT ? this.handle_dot(ne) : ne.type === I.EOF ? this.handle_eof(ne) : (ne.type, I.UNKNOWN, this.handle_unknown(ne, J));
            }, V.prototype.handle_whitespace_and_comments = function(ne, J) {
              var L = ne.newlines, z = this._options.keep_array_indentation && $(this._flags.mode);
              if (ne.comments_before) for (var ee = ne.comments_before.next(); ee; ) this.handle_whitespace_and_comments(ee, J), this.handle_token(ee, J), ee = ne.comments_before.next();
              if (z) for (var q = 0; q < L; q += 1) this.print_newline(0 < q, J);
              else if (this._options.max_preserve_newlines && L > this._options.max_preserve_newlines && (L = this._options.max_preserve_newlines), this._options.preserve_newlines && 1 < L) {
                this.print_newline(!1, J);
                for (var X = 1; X < L; X += 1) this.print_newline(!0, J);
              }
            };
            var K = ["async", "break", "continue", "return", "throw", "yield"];
            V.prototype.allow_wrap_or_preserved_newline = function(ne, J) {
              J = J !== void 0 && J, this._output.just_added_newline() || (J = this._options.preserve_newlines && ne.newlines || J, (B(this._flags.last_token.text, j) || B(ne.text, j)) && (ne = B(this._flags.last_token.text, j) && B(this._options.operator_position, ie) || B(ne.text, j), J = J && ne), J ? this.print_newline(!1, !0) : this._options.wrap_line_length && (H(this._flags.last_token, K) || this._output.set_wrap_point()));
            }, V.prototype.print_newline = function(ne, J) {
              if (!J && this._flags.last_token.text !== ";" && this._flags.last_token.text !== "," && this._flags.last_token.text !== "=" && (this._flags.last_token.type !== I.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++")) for (var L = this._tokens.peek(); !(this._flags.mode !== "Statement" || this._flags.if_block && U(L, "else") || this._flags.do_block); ) this.restore_mode();
              this._output.add_new_line(ne) && (this._flags.multiline_frame = !0);
            }, V.prototype.print_token_line_indentation = function(ne) {
              this._output.just_added_newline() && (this._options.keep_array_indentation && ne.newlines && (ne.text === "[" || $(this._flags.mode)) ? (this._output.current_line.set_indent(-1), this._output.current_line.push(ne.whitespace_before), this._output.space_before_token = !1) : this._output.set_indent(this._flags.indentation_level, this._flags.alignment) && (this._flags.line_indent_level = this._flags.indentation_level));
            }, V.prototype.print_token = function(ne) {
              var J;
              this._output.raw ? this._output.add_raw_token(ne) : (this._options.comma_first && ne.previous && ne.previous.type === I.COMMA && this._output.just_added_newline() && this._output.previous_line.last() === "," && (J = this._output.previous_line.pop(), this._output.previous_line.is_empty() && (this._output.previous_line.push(J), this._output.trim(!0), this._output.current_line.pop(), this._output.trim()), this.print_token_line_indentation(ne), this._output.add_token(","), this._output.space_before_token = !0), this.print_token_line_indentation(ne), this._output.non_breaking_space = !0, this._output.add_token(ne.text), this._output.previous_token_wrapped && (this._flags.multiline_frame = !0));
            }, V.prototype.indent = function() {
              this._flags.indentation_level += 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
            }, V.prototype.deindent = function() {
              0 < this._flags.indentation_level && (!this._flags.parent || this._flags.indentation_level > this._flags.parent.indentation_level) && (--this._flags.indentation_level, this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
            }, V.prototype.set_mode = function(ne) {
              this._flags ? (this._flag_store.push(this._flags), this._previous_flags = this._flags) : this._previous_flags = this.create_flags(null, ne), this._flags = this.create_flags(this._previous_flags, ne), this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
            }, V.prototype.restore_mode = function() {
              0 < this._flag_store.length && (this._previous_flags = this._flags, this._flags = this._flag_store.pop(), this._previous_flags.mode === "Statement" && ce(this._output, this._previous_flags), this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
            }, V.prototype.start_of_object_property = function() {
              return this._flags.parent.mode === "ObjectLiteral" && this._flags.mode === "Statement" && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || H(this._flags.last_token, ["get", "set"]));
            }, V.prototype.start_of_statement = function(ne) {
              return !!(H(this._flags.last_token, ["var", "let", "const"]) && ne.type === I.WORD || U(this._flags.last_token, "do") || (this._flags.parent.mode !== "ObjectLiteral" || this._flags.mode !== "Statement") && H(this._flags.last_token, K) && !ne.newlines || U(this._flags.last_token, "else") && (!U(ne, "if") || ne.comments_before) || this._flags.last_token.type === I.END_EXPR && (this._previous_flags.mode === "ForInitializer" || this._previous_flags.mode === "Conditional") || this._flags.last_token.type === I.WORD && this._flags.mode === "BlockStatement" && !this._flags.in_case && ne.text !== "--" && ne.text !== "++" && this._last_last_text !== "function" && ne.type !== I.WORD && ne.type !== I.RESERVED || this._flags.mode === "ObjectLiteral" && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || H(this._flags.last_token, ["get", "set"]))) && (this.set_mode("Statement"), this.indent(), this.handle_whitespace_and_comments(ne, !0), this.start_of_object_property() || this.allow_wrap_or_preserved_newline(ne, H(ne, ["do", "for", "if", "while"])), !0);
            }, V.prototype.handle_start_expr = function(ne) {
              this.start_of_statement(ne) || this.handle_whitespace_and_comments(ne);
              var J, L, z = "Expression";
              if (ne.text === "[") {
                if (this._flags.last_token.type === I.WORD || this._flags.last_token.text === ")") return H(this._flags.last_token, N) && (this._output.space_before_token = !0), this.print_token(ne), this.set_mode(z), this.indent(), void (this._options.space_in_paren && (this._output.space_before_token = !0));
                z = "ArrayLiteral", $(this._flags.mode) && (this._flags.last_token.text !== "[" && (this._flags.last_token.text !== "," || this._last_last_text !== "]" && this._last_last_text !== "}") || this._options.keep_array_indentation || this.print_newline()), B(this._flags.last_token.type, [I.START_EXPR, I.END_EXPR, I.WORD, I.OPERATOR, I.DOT]) || (this._output.space_before_token = !0);
              } else this._flags.last_token.type === I.RESERVED ? this._flags.last_token.text === "for" ? (this._output.space_before_token = this._options.space_before_conditional, z = "ForInitializer") : B(this._flags.last_token.text, ["if", "while", "switch"]) ? (this._output.space_before_token = this._options.space_before_conditional, z = "Conditional") : B(this._flags.last_word, ["await", "async"]) ? this._output.space_before_token = !0 : this._flags.last_token.text === "import" && ne.whitespace_before === "" ? this._output.space_before_token = !1 : !B(this._flags.last_token.text, N) && this._flags.last_token.text !== "catch" || (this._output.space_before_token = !0) : this._flags.last_token.type === I.EQUALS || this._flags.last_token.type === I.OPERATOR ? this.start_of_object_property() || this.allow_wrap_or_preserved_newline(ne) : this._flags.last_token.type === I.WORD ? (this._output.space_before_token = !1, J = this._tokens.peek(-3), this._options.space_after_named_function && J && (L = this._tokens.peek(-4), H(J, ["async", "function"]) || J.text === "*" && H(L, ["async", "function"]) ? this._output.space_before_token = !0 : this._flags.mode === "ObjectLiteral" ? J.text !== "{" && J.text !== "," && (J.text !== "*" || L.text !== "{" && L.text !== ",") || (this._output.space_before_token = !0) : this._flags.parent && this._flags.parent.class_start_block && (this._output.space_before_token = !0))) : this.allow_wrap_or_preserved_newline(ne), (this._flags.last_token.type === I.RESERVED && (this._flags.last_word === "function" || this._flags.last_word === "typeof") || this._flags.last_token.text === "*" && (B(this._last_last_text, ["function", "yield"]) || this._flags.mode === "ObjectLiteral" && B(this._last_last_text, ["{", ","]))) && (this._output.space_before_token = this._options.space_after_anon_function);
              this._flags.last_token.text === ";" || this._flags.last_token.type === I.START_BLOCK ? this.print_newline() : this._flags.last_token.type !== I.END_EXPR && this._flags.last_token.type !== I.START_EXPR && this._flags.last_token.type !== I.END_BLOCK && this._flags.last_token.text !== "." && this._flags.last_token.type !== I.COMMA || this.allow_wrap_or_preserved_newline(ne, ne.newlines), this.print_token(ne), this.set_mode(z), this._options.space_in_paren && (this._output.space_before_token = !0), this.indent();
            }, V.prototype.handle_end_expr = function(ne) {
              for (; this._flags.mode === "Statement"; ) this.restore_mode();
              this.handle_whitespace_and_comments(ne), this._flags.multiline_frame && this.allow_wrap_or_preserved_newline(ne, ne.text === "]" && $(this._flags.mode) && !this._options.keep_array_indentation), this._options.space_in_paren && (this._flags.last_token.type !== I.START_EXPR || this._options.space_in_empty_paren ? this._output.space_before_token = !0 : (this._output.trim(), this._output.space_before_token = !1)), this.deindent(), this.print_token(ne), this.restore_mode(), ce(this._output, this._previous_flags), this._flags.do_while && this._previous_flags.mode === "Conditional" && (this._previous_flags.mode = "Expression", this._flags.do_block = !1, this._flags.do_while = !1);
            }, V.prototype.handle_start_block = function(ne) {
              this.handle_whitespace_and_comments(ne);
              var J = this._tokens.peek(), L = this._tokens.peek(1);
              if (this._flags.last_word === "switch" && this._flags.last_token.type === I.END_EXPR ? (this.set_mode("BlockStatement"), this._flags.in_case_statement = !0) : this._flags.case_body ? this.set_mode("BlockStatement") : L && (B(L.text, [":", ","]) && B(J.type, [I.STRING, I.WORD, I.RESERVED]) || B(J.text, ["get", "set", "..."]) && B(L.type, [I.WORD, I.RESERVED])) ? B(this._last_last_text, ["class", "interface"]) && !B(L.text, [":", ","]) ? this.set_mode("BlockStatement") : this.set_mode("ObjectLiteral") : this._flags.last_token.type === I.OPERATOR && this._flags.last_token.text === "=>" || !B(this._flags.last_token.type, [I.EQUALS, I.START_EXPR, I.COMMA, I.OPERATOR]) && !H(this._flags.last_token, ["return", "throw", "import", "default"]) ? this.set_mode("BlockStatement") : this.set_mode("ObjectLiteral"), this._flags.last_token && H(this._flags.last_token.previous, ["class", "extends"]) && (this._flags.class_start_block = !0), J = (L = !J.comments_before && J.text === "}") && this._flags.last_word === "function" && this._flags.last_token.type === I.END_EXPR, this._options.brace_preserve_inline) {
                var z = 0, ee = null;
                this._flags.inline_frame = !0;
                do
                  if ((ee = this._tokens.peek((z += 1) - 1)).newlines) {
                    this._flags.inline_frame = !1;
                    break;
                  }
                while (ee.type !== I.EOF && (ee.type !== I.END_BLOCK || ee.opened !== ne));
              }
              (this._options.brace_style === "expand" || this._options.brace_style === "none" && ne.newlines) && !this._flags.inline_frame ? this._flags.last_token.type !== I.OPERATOR && (J || this._flags.last_token.type === I.EQUALS || H(this._flags.last_token, Q) && this._flags.last_token.text !== "else") ? this._output.space_before_token = !0 : this.print_newline(!1, !0) : (!$(this._previous_flags.mode) || this._flags.last_token.type !== I.START_EXPR && this._flags.last_token.type !== I.COMMA || (this._flags.last_token.type !== I.COMMA && !this._options.space_in_paren || (this._output.space_before_token = !0), (this._flags.last_token.type === I.COMMA || this._flags.last_token.type === I.START_EXPR && this._flags.inline_frame) && (this.allow_wrap_or_preserved_newline(ne), this._previous_flags.multiline_frame = this._previous_flags.multiline_frame || this._flags.multiline_frame, this._flags.multiline_frame = !1)), this._flags.last_token.type !== I.OPERATOR && this._flags.last_token.type !== I.START_EXPR && (B(this._flags.last_token.type, [I.START_BLOCK, I.SEMICOLON]) && !this._flags.inline_frame ? this.print_newline() : this._output.space_before_token = !0)), this.print_token(ne), this.indent(), L || this._options.brace_preserve_inline && this._flags.inline_frame || this.print_newline();
            }, V.prototype.handle_end_block = function(ne) {
              for (this.handle_whitespace_and_comments(ne); this._flags.mode === "Statement"; ) this.restore_mode();
              var J = this._flags.last_token.type === I.START_BLOCK;
              this._flags.inline_frame && !J ? this._output.space_before_token = !0 : this._options.brace_style === "expand" ? J || this.print_newline() : J || ($(this._flags.mode) && this._options.keep_array_indentation ? (this._options.keep_array_indentation = !1, this.print_newline(), this._options.keep_array_indentation = !0) : this.print_newline()), this.restore_mode(), this.print_token(ne);
            }, V.prototype.handle_word = function(ne) {
              if (ne.type === I.RESERVED && (B(ne.text, ["set", "get"]) && this._flags.mode !== "ObjectLiteral" || ne.text === "import" && B(this._tokens.peek().text, ["(", "."]) || B(ne.text, ["as", "from"]) && !this._flags.import_block || this._flags.mode === "ObjectLiteral" && this._tokens.peek().text === ":") && (ne.type = I.WORD), this.start_of_statement(ne) ? H(this._flags.last_token, ["var", "let", "const"]) && ne.type === I.WORD && (this._flags.declaration_statement = !0) : !ne.newlines || te(this._flags.mode) || this._flags.last_token.type === I.OPERATOR && this._flags.last_token.text !== "--" && this._flags.last_token.text !== "++" || this._flags.last_token.type === I.EQUALS || !this._options.preserve_newlines && H(this._flags.last_token, ["var", "let", "const", "set", "get"]) ? this.handle_whitespace_and_comments(ne) : (this.handle_whitespace_and_comments(ne), this.print_newline()), this._flags.do_block && !this._flags.do_while) {
                if (U(ne, "while")) return this._output.space_before_token = !0, this.print_token(ne), this._output.space_before_token = !0, void (this._flags.do_while = !0);
                this.print_newline(), this._flags.do_block = !1;
              }
              if (this._flags.if_block) if (!this._flags.else_block && U(ne, "else")) this._flags.else_block = !0;
              else {
                for (; this._flags.mode === "Statement"; ) this.restore_mode();
                this._flags.if_block = !1, this._flags.else_block = !1;
              }
              if (this._flags.in_case_statement && H(ne, ["case", "default"])) return this.print_newline(), this._flags.case_block || !this._flags.case_body && !this._options.jslint_happy || this.deindent(), this._flags.case_body = !1, this.print_token(ne), void (this._flags.in_case = !0);
              if (this._flags.last_token.type !== I.COMMA && this._flags.last_token.type !== I.START_EXPR && this._flags.last_token.type !== I.EQUALS && this._flags.last_token.type !== I.OPERATOR || this.start_of_object_property() || B(this._flags.last_token.text, ["+", "-"]) && this._last_last_text === ":" && this._flags.parent.mode === "ObjectLiteral" || this.allow_wrap_or_preserved_newline(ne), U(ne, "function")) return (B(this._flags.last_token.text, ["}", ";"]) || this._output.just_added_newline() && !B(this._flags.last_token.text, ["(", "[", "{", ":", "=", ","]) && this._flags.last_token.type !== I.OPERATOR) && (this._output.just_added_blankline() || ne.comments_before || (this.print_newline(), this.print_newline(!0))), this._flags.last_token.type === I.RESERVED || this._flags.last_token.type === I.WORD ? H(this._flags.last_token, ["get", "set", "new", "export"]) || H(this._flags.last_token, K) || U(this._flags.last_token, "default") && this._last_last_text === "export" || this._flags.last_token.text === "declare" ? this._output.space_before_token = !0 : this.print_newline() : this._flags.last_token.type === I.OPERATOR || this._flags.last_token.text === "=" ? this._output.space_before_token = !0 : !this._flags.multiline_frame && (te(this._flags.mode) || $(this._flags.mode)) || this.print_newline(), this.print_token(ne), void (this._flags.last_word = ne.text);
              var J = "NONE";
              this._flags.last_token.type === I.END_BLOCK ? this._previous_flags.inline_frame ? J = "SPACE" : !H(ne, ["else", "catch", "finally", "from"]) || this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && ne.newlines ? J = "NEWLINE" : (J = "SPACE", this._output.space_before_token = !0) : this._flags.last_token.type === I.SEMICOLON && this._flags.mode === "BlockStatement" ? J = "NEWLINE" : this._flags.last_token.type === I.SEMICOLON && te(this._flags.mode) ? J = "SPACE" : this._flags.last_token.type === I.STRING ? J = "NEWLINE" : this._flags.last_token.type === I.RESERVED || this._flags.last_token.type === I.WORD || this._flags.last_token.text === "*" && (B(this._last_last_text, ["function", "yield"]) || this._flags.mode === "ObjectLiteral" && B(this._last_last_text, ["{", ","])) ? J = "SPACE" : this._flags.last_token.type === I.START_BLOCK ? J = this._flags.inline_frame ? "SPACE" : "NEWLINE" : this._flags.last_token.type === I.END_EXPR && (this._output.space_before_token = !0, J = "NEWLINE"), H(ne, N) && this._flags.last_token.text !== ")" && (J = this._flags.inline_frame || this._flags.last_token.text === "else" || this._flags.last_token.text === "export" ? "SPACE" : "NEWLINE"), H(ne, ["else", "catch", "finally"]) ? (this._flags.last_token.type !== I.END_BLOCK || this._previous_flags.mode !== "BlockStatement" || this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && ne.newlines) && !this._flags.inline_frame ? this.print_newline() : (this._output.trim(!0), this._output.current_line.last() !== "}" && this.print_newline(), this._output.space_before_token = !0) : J === "NEWLINE" ? H(this._flags.last_token, Q) || this._flags.last_token.text === "declare" && H(ne, ["var", "let", "const"]) ? this._output.space_before_token = !0 : this._flags.last_token.type !== I.END_EXPR ? this._flags.last_token.type === I.START_EXPR && H(ne, ["var", "let", "const"]) || this._flags.last_token.text === ":" || (U(ne, "if") && U(ne.previous, "else") ? this._output.space_before_token = !0 : this.print_newline()) : H(ne, N) && this._flags.last_token.text !== ")" && this.print_newline() : this._flags.multiline_frame && $(this._flags.mode) && this._flags.last_token.text === "," && this._last_last_text === "}" ? this.print_newline() : J === "SPACE" && (this._output.space_before_token = !0), !ne.previous || ne.previous.type !== I.WORD && ne.previous.type !== I.RESERVED || (this._output.space_before_token = !0), this.print_token(ne), this._flags.last_word = ne.text, ne.type === I.RESERVED && (ne.text === "do" ? this._flags.do_block = !0 : ne.text === "if" ? this._flags.if_block = !0 : ne.text === "import" ? this._flags.import_block = !0 : this._flags.import_block && U(ne, "from") && (this._flags.import_block = !1));
            }, V.prototype.handle_semicolon = function(ne) {
              this.start_of_statement(ne) ? this._output.space_before_token = !1 : this.handle_whitespace_and_comments(ne);
              for (var J = this._tokens.peek(); !(this._flags.mode !== "Statement" || this._flags.if_block && U(J, "else") || this._flags.do_block); ) this.restore_mode();
              this._flags.import_block && (this._flags.import_block = !1), this.print_token(ne);
            }, V.prototype.handle_string = function(ne) {
              ne.text.startsWith("`") && ne.newlines === 0 && ne.whitespace_before === "" && (ne.previous.text === ")" || this._flags.last_token.type === I.WORD) || (this.start_of_statement(ne) ? this._output.space_before_token = !0 : (this.handle_whitespace_and_comments(ne), this._flags.last_token.type === I.RESERVED || this._flags.last_token.type === I.WORD || this._flags.inline_frame ? this._output.space_before_token = !0 : this._flags.last_token.type === I.COMMA || this._flags.last_token.type === I.START_EXPR || this._flags.last_token.type === I.EQUALS || this._flags.last_token.type === I.OPERATOR ? this.start_of_object_property() || this.allow_wrap_or_preserved_newline(ne) : !ne.text.startsWith("`") || this._flags.last_token.type !== I.END_EXPR || ne.previous.text !== "]" && ne.previous.text !== ")" || ne.newlines !== 0 ? this.print_newline() : this._output.space_before_token = !0)), this.print_token(ne);
            }, V.prototype.handle_equals = function(ne) {
              this.start_of_statement(ne) || this.handle_whitespace_and_comments(ne), this._flags.declaration_statement && (this._flags.declaration_assignment = !0), this._output.space_before_token = !0, this.print_token(ne), this._output.space_before_token = !0;
            }, V.prototype.handle_comma = function(ne) {
              this.handle_whitespace_and_comments(ne, !0), this.print_token(ne), this._output.space_before_token = !0, this._flags.declaration_statement ? (te(this._flags.parent.mode) && (this._flags.declaration_assignment = !1), this._flags.declaration_assignment ? (this._flags.declaration_assignment = !1, this.print_newline(!1, !0)) : this._options.comma_first && this.allow_wrap_or_preserved_newline(ne)) : this._flags.mode === "ObjectLiteral" || this._flags.mode === "Statement" && this._flags.parent.mode === "ObjectLiteral" ? (this._flags.mode === "Statement" && this.restore_mode(), this._flags.inline_frame || this.print_newline()) : this._options.comma_first && this.allow_wrap_or_preserved_newline(ne);
            }, V.prototype.handle_operator = function(ne) {
              var J = ne.text === "*" && (H(this._flags.last_token, ["function", "yield"]) || B(this._flags.last_token.type, [I.START_BLOCK, I.COMMA, I.END_BLOCK, I.SEMICOLON])), L = B(ne.text, ["-", "+"]) && (B(this._flags.last_token.type, [I.START_BLOCK, I.START_EXPR, I.EQUALS, I.OPERATOR]) || B(this._flags.last_token.text, N) || this._flags.last_token.text === ",");
              if (this.start_of_statement(ne) || this.handle_whitespace_and_comments(ne, !J), ne.text !== "*" || this._flags.last_token.type !== I.DOT) if (ne.text !== "::") if (B(ne.text, ["-", "+"]) && this.start_of_object_property()) this.print_token(ne);
              else {
                if (this._flags.last_token.type === I.OPERATOR && B(this._options.operator_position, ie) && this.allow_wrap_or_preserved_newline(ne), ne.text === ":" && this._flags.in_case) return this.print_token(ne), this._flags.in_case = !1, this._flags.case_body = !0, void (this._tokens.peek().type !== I.START_BLOCK ? (this.indent(), this.print_newline(), this._flags.case_block = !1) : (this._flags.case_block = !0, this._output.space_before_token = !0));
                var z = !0, ee = !0, q = !1;
                if (ne.text === ":" ? this._flags.ternary_depth === 0 ? z = !1 : (--this._flags.ternary_depth, q = !0) : ne.text === "?" && (this._flags.ternary_depth += 1), !L && !J && this._options.preserve_newlines && B(ne.text, j)) {
                  var X = ne.text === ":", oe = X && q, ae = X && !q;
                  switch (this._options.operator_position) {
                    case Y.before_newline:
                      return this._output.space_before_token = !ae, this.print_token(ne), X && !oe || this.allow_wrap_or_preserved_newline(ne), void (this._output.space_before_token = !0);
                    case Y.after_newline:
                      return this._output.space_before_token = !0, !X || oe ? this._tokens.peek().newlines ? this.print_newline(!1, !0) : this.allow_wrap_or_preserved_newline(ne) : this._output.space_before_token = !1, this.print_token(ne), void (this._output.space_before_token = !0);
                    case Y.preserve_newline:
                      return ae || this.allow_wrap_or_preserved_newline(ne), z = !(this._output.just_added_newline() || ae), this._output.space_before_token = z, this.print_token(ne), void (this._output.space_before_token = !0);
                  }
                }
                J ? (this.allow_wrap_or_preserved_newline(ne), z = !1, ee = (J = this._tokens.peek()) && B(J.type, [I.WORD, I.RESERVED])) : ne.text === "..." ? (this.allow_wrap_or_preserved_newline(ne), z = this._flags.last_token.type === I.START_BLOCK, ee = !1) : (B(ne.text, ["--", "++", "!", "~"]) || L) && (this._flags.last_token.type !== I.COMMA && this._flags.last_token.type !== I.START_EXPR || this.allow_wrap_or_preserved_newline(ne), ee = z = !1, !ne.newlines || ne.text !== "--" && ne.text !== "++" && ne.text !== "~" || ((L = H(this._flags.last_token, Q) && ne.newlines) && (this._previous_flags.if_block || this._previous_flags.else_block) && this.restore_mode(), this.print_newline(L, !0)), this._flags.last_token.text === ";" && te(this._flags.mode) && (z = !0), this._flags.last_token.type === I.RESERVED ? z = !0 : this._flags.last_token.type === I.END_EXPR ? z = !(this._flags.last_token.text === "]" && (ne.text === "--" || ne.text === "++")) : this._flags.last_token.type === I.OPERATOR && (z = B(ne.text, ["--", "-", "++", "+"]) && B(this._flags.last_token.text, ["--", "-", "++", "+"]), B(ne.text, ["+", "-"]) && B(this._flags.last_token.text, ["--", "++"]) && (ee = !0)), (this._flags.mode !== "BlockStatement" || this._flags.inline_frame) && this._flags.mode !== "Statement" || this._flags.last_token.text !== "{" && this._flags.last_token.text !== ";" || this.print_newline()), this._output.space_before_token = this._output.space_before_token || z, this.print_token(ne), this._output.space_before_token = ee;
              }
              else this.print_token(ne);
              else this.print_token(ne);
            }, V.prototype.handle_block_comment = function(ne, J) {
              return this._output.raw ? (this._output.add_raw_token(ne), void (ne.directives && ne.directives.preserve === "end" && (this._output.raw = this._options.test_output_raw))) : ne.directives ? (this.print_newline(!1, J), this.print_token(ne), ne.directives.preserve === "start" && (this._output.raw = !0), void this.print_newline(!1, !0)) : void (T.newline.test(ne.text) || ne.newlines ? this.print_block_commment(ne, J) : (this._output.space_before_token = !0, this.print_token(ne), this._output.space_before_token = !0));
            }, V.prototype.print_block_commment = function(ne, J) {
              var L, z, ee, q = function(_e) {
                for (var ve = [], Ee = (_e = _e.replace(T.allLineBreaks, `
`)).indexOf(`
`); Ee !== -1; ) ve.push(_e.substring(0, Ee)), Ee = (_e = _e.substring(Ee + 1)).indexOf(`
`);
                return _e.length && ve.push(_e), ve;
              }(ne.text), X = ne.whitespace_before, oe = X.length;
              if (this.print_newline(!1, J), this.print_token_line_indentation(ne), this._output.add_token(q[0]), this.print_newline(!1, J), 1 < q.length) {
                for (z = function(_e, ve) {
                  for (var Ee = 0; Ee < _e.length; Ee++) if (_e[Ee].trim().charAt(0) !== ve) return !1;
                  return !0;
                }(q = q.slice(1), "*"), ee = function(_e, ve) {
                  for (var Ee, we = 0, ze = _e.length; we < ze; we++) if ((Ee = _e[we]) && Ee.indexOf(ve) !== 0) return !1;
                  return !0;
                }(q, X), z && (this._flags.alignment = 1), L = 0; L < q.length; L++) z ? (this.print_token_line_indentation(ne), this._output.add_token(function(_e) {
                  return _e.replace(/^\s+/g, "");
                }(q[L]))) : ee && q[L] ? (this.print_token_line_indentation(ne), this._output.add_token(q[L].substring(oe))) : (this._output.current_line.set_indent(-1), this._output.add_token(q[L])), this.print_newline(!1, J);
                this._flags.alignment = 0;
              }
            }, V.prototype.handle_comment = function(ne, J) {
              ne.newlines ? this.print_newline(!1, J) : this._output.trim(!0), this._output.space_before_token = !0, this.print_token(ne), this.print_newline(!1, J);
            }, V.prototype.handle_dot = function(ne) {
              this.start_of_statement(ne) || this.handle_whitespace_and_comments(ne, !0), this._flags.last_token.text.match("^[0-9]+$") && (this._output.space_before_token = !0), H(this._flags.last_token, Q) ? this._output.space_before_token = !1 : this.allow_wrap_or_preserved_newline(ne, this._flags.last_token.text === ")" && this._options.break_chained_methods), this._options.unindent_chained_methods && this._output.just_added_newline() && this.deindent(), this.print_token(ne);
            }, V.prototype.handle_unknown = function(ne, J) {
              this.print_token(ne), ne.text[ne.text.length - 1] === `
` && this.print_newline(!1, J);
            }, V.prototype.handle_eof = function(ne) {
              for (; this._flags.mode === "Statement"; ) this.restore_mode();
              this.handle_whitespace_and_comments(ne);
            }, b.exports.Beautifier = V;
          }, function(b) {
            function v(y) {
              this.__parent = y, this.__character_count = 0, this.__indent_count = -1, this.__alignment_count = 0, this.__wrap_point_index = 0, this.__wrap_point_character_count = 0, this.__wrap_point_indent_count = -1, this.__wrap_point_alignment_count = 0, this.__items = [];
            }
            function E(y, T) {
              this.__cache = [""], this.__indent_size = y.indent_size, this.__indent_string = y.indent_char, y.indent_with_tabs || (this.__indent_string = new Array(y.indent_size + 1).join(y.indent_char)), T = T || "", 0 < y.indent_level && (T = new Array(y.indent_level + 1).join(this.__indent_string)), this.__base_string = T, this.__base_string_length = T.length;
            }
            function C(y, T) {
              this.__indent_cache = new E(y, T), this.raw = !1, this._end_with_newline = y.end_with_newline, this.indent_size = y.indent_size, this.wrap_line_length = y.wrap_line_length, this.indent_empty_lines = y.indent_empty_lines, this.__lines = [], this.previous_line = null, this.current_line = null, this.next_line = new v(this), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1, this.__add_outputline();
            }
            v.prototype.clone_empty = function() {
              var y = new v(this.__parent);
              return y.set_indent(this.__indent_count, this.__alignment_count), y;
            }, v.prototype.item = function(y) {
              return y < 0 ? this.__items[this.__items.length + y] : this.__items[y];
            }, v.prototype.has_match = function(y) {
              for (var T = this.__items.length - 1; 0 <= T; T--) if (this.__items[T].match(y)) return !0;
              return !1;
            }, v.prototype.set_indent = function(y, T) {
              this.is_empty() && (this.__indent_count = y || 0, this.__alignment_count = T || 0, this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count));
            }, v.prototype._set_wrap_point = function() {
              this.__parent.wrap_line_length && (this.__wrap_point_index = this.__items.length, this.__wrap_point_character_count = this.__character_count, this.__wrap_point_indent_count = this.__parent.next_line.__indent_count, this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count);
            }, v.prototype._should_wrap = function() {
              return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
            }, v.prototype._allow_wrap = function() {
              if (this._should_wrap()) {
                this.__parent.add_new_line();
                var y = this.__parent.current_line;
                return y.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count), y.__items = this.__items.slice(this.__wrap_point_index), this.__items = this.__items.slice(0, this.__wrap_point_index), y.__character_count += this.__character_count - this.__wrap_point_character_count, this.__character_count = this.__wrap_point_character_count, y.__items[0] === " " && (y.__items.splice(0, 1), --y.__character_count), !0;
              }
              return !1;
            }, v.prototype.is_empty = function() {
              return this.__items.length === 0;
            }, v.prototype.last = function() {
              return this.is_empty() ? null : this.__items[this.__items.length - 1];
            }, v.prototype.push = function(y) {
              this.__items.push(y);
              var T = y.lastIndexOf(`
`);
              T !== -1 ? this.__character_count = y.length - T : this.__character_count += y.length;
            }, v.prototype.pop = function() {
              var y = null;
              return this.is_empty() || (y = this.__items.pop(), this.__character_count -= y.length), y;
            }, v.prototype._remove_indent = function() {
              0 < this.__indent_count && (--this.__indent_count, this.__character_count -= this.__parent.indent_size);
            }, v.prototype._remove_wrap_indent = function() {
              0 < this.__wrap_point_indent_count && --this.__wrap_point_indent_count;
            }, v.prototype.trim = function() {
              for (; this.last() === " "; ) this.__items.pop(), --this.__character_count;
            }, v.prototype.toString = function() {
              var y = "";
              return this.is_empty() ? this.__parent.indent_empty_lines && (y = this.__parent.get_indent_string(this.__indent_count)) : (y = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count), y += this.__items.join("")), y;
            }, E.prototype.get_indent_size = function(y, T) {
              var A = this.__base_string_length;
              return y < 0 && (A = 0), (A += y * this.__indent_size) + (T || 0);
            }, E.prototype.get_indent_string = function(y, T) {
              var A = this.__base_string;
              return T = T || 0, y < 0 && (y = 0, A = ""), T += y * this.__indent_size, this.__ensure_cache(T), A + this.__cache[T];
            }, E.prototype.__ensure_cache = function(y) {
              for (; y >= this.__cache.length; ) this.__add_column();
            }, E.prototype.__add_column = function() {
              var y, T = this.__cache.length, A = "";
              this.__indent_size && T >= this.__indent_size && (T -= (y = Math.floor(T / this.__indent_size)) * this.__indent_size, A = new Array(y + 1).join(this.__indent_string)), T && (A += new Array(T + 1).join(" ")), this.__cache.push(A);
            }, C.prototype.__add_outputline = function() {
              this.previous_line = this.current_line, this.current_line = this.next_line.clone_empty(), this.__lines.push(this.current_line);
            }, C.prototype.get_line_number = function() {
              return this.__lines.length;
            }, C.prototype.get_indent_string = function(y, T) {
              return this.__indent_cache.get_indent_string(y, T);
            }, C.prototype.get_indent_size = function(y, T) {
              return this.__indent_cache.get_indent_size(y, T);
            }, C.prototype.is_empty = function() {
              return !this.previous_line && this.current_line.is_empty();
            }, C.prototype.add_new_line = function(y) {
              return !(this.is_empty() || !y && this.just_added_newline() || (this.raw || this.__add_outputline(), 0));
            }, C.prototype.get_code = function(y) {
              this.trim(!0);
              var T = this.current_line.pop();
              return T && (T[T.length - 1] === `
` && (T = T.replace(/\n+$/g, "")), this.current_line.push(T)), this._end_with_newline && this.__add_outputline(), T = this.__lines.join(`
`), y !== `
` ? T.replace(/[\n]/g, y) : T;
            }, C.prototype.set_wrap_point = function() {
              this.current_line._set_wrap_point();
            }, C.prototype.set_indent = function(y, T) {
              return this.next_line.set_indent(y = y || 0, T = T || 0), 1 < this.__lines.length ? (this.current_line.set_indent(y, T), !0) : (this.current_line.set_indent(), !1);
            }, C.prototype.add_raw_token = function(y) {
              for (var T = 0; T < y.newlines; T++) this.__add_outputline();
              this.current_line.set_indent(-1), this.current_line.push(y.whitespace_before), this.current_line.push(y.text), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1;
            }, C.prototype.add_token = function(y) {
              this.__add_space_before_token(), this.current_line.push(y), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = this.current_line._allow_wrap();
            }, C.prototype.__add_space_before_token = function() {
              this.space_before_token && !this.just_added_newline() && (this.non_breaking_space || this.set_wrap_point(), this.current_line.push(" "));
            }, C.prototype.remove_indent = function(y) {
              for (var T = this.__lines.length; y < T; ) this.__lines[y]._remove_indent(), y++;
              this.current_line._remove_wrap_indent();
            }, C.prototype.trim = function(y) {
              for (y = y !== void 0 && y, this.current_line.trim(); y && 1 < this.__lines.length && this.current_line.is_empty(); ) this.__lines.pop(), this.current_line = this.__lines[this.__lines.length - 1], this.current_line.trim();
              this.previous_line = 1 < this.__lines.length ? this.__lines[this.__lines.length - 2] : null;
            }, C.prototype.just_added_newline = function() {
              return this.current_line.is_empty();
            }, C.prototype.just_added_blankline = function() {
              return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
            }, C.prototype.ensure_empty_line_above = function(y, T) {
              for (var A = this.__lines.length - 2; 0 <= A; ) {
                var k = this.__lines[A];
                if (k.is_empty()) break;
                if (k.item(0).indexOf(y) !== 0 && k.item(-1) !== T) {
                  this.__lines.splice(A + 1, 0, new v(this)), this.previous_line = this.__lines[this.__lines.length - 2];
                  break;
                }
                A--;
              }
            }, b.exports.Output = C;
          }, function(b) {
            b.exports.Token = function(E, C, y, T) {
              this.type = E, this.text = C, this.comments_before = null, this.newlines = y || 0, this.whitespace_before = T || "", this.parent = null, this.next = null, this.previous = null, this.opened = null, this.closed = null, this.directives = null;
            };
          }, function(b, v) {
            var E = "\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc", C = "\\\\u[0-9a-fA-F]{4}|\\\\u\\{[0-9a-fA-F]+\\}", y = "(?:" + C + "|[\\x23\\x24\\x40\\x41-\\x5a\\x5f\\x61-\\x7a" + E + "])";
            v.identifier = new RegExp(y + "(?:\\\\u[0-9a-fA-F]{4}|\\\\u\\{[0-9a-fA-F]+\\}|[\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f])*", "g"), v.identifierStart = new RegExp(y), v.identifierMatch = new RegExp("(?:" + C + "|[\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a" + E + "\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f])+"), v.newline = /[\n\r\u2028\u2029]/, v.lineBreak = new RegExp(`\r
|` + v.newline.source), v.allLineBreaks = new RegExp(v.lineBreak.source, "g");
          }, function(b, v, E) {
            var C = E(6).Options, y = ["before-newline", "after-newline", "preserve-newline"];
            function T(A) {
              C.call(this, A, "js"), (A = this.raw_options.brace_style || null) === "expand-strict" ? this.raw_options.brace_style = "expand" : A === "collapse-preserve-inline" ? this.raw_options.brace_style = "collapse,preserve-inline" : this.raw_options.braces_on_own_line !== void 0 && (this.raw_options.brace_style = this.raw_options.braces_on_own_line ? "expand" : "collapse");
              var k = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
              this.brace_preserve_inline = !1, this.brace_style = "collapse";
              for (var N = 0; N < k.length; N++) k[N] === "preserve-inline" ? this.brace_preserve_inline = !0 : this.brace_style = k[N];
              this.unindent_chained_methods = this._get_boolean("unindent_chained_methods"), this.break_chained_methods = this._get_boolean("break_chained_methods"), this.space_in_paren = this._get_boolean("space_in_paren"), this.space_in_empty_paren = this._get_boolean("space_in_empty_paren"), this.jslint_happy = this._get_boolean("jslint_happy"), this.space_after_anon_function = this._get_boolean("space_after_anon_function"), this.space_after_named_function = this._get_boolean("space_after_named_function"), this.keep_array_indentation = this._get_boolean("keep_array_indentation"), this.space_before_conditional = this._get_boolean("space_before_conditional", !0), this.unescape_strings = this._get_boolean("unescape_strings"), this.e4x = this._get_boolean("e4x"), this.comma_first = this._get_boolean("comma_first"), this.operator_position = this._get_selection("operator_position", y), this.test_output_raw = this._get_boolean("test_output_raw"), this.jslint_happy && (this.space_after_anon_function = !0);
            }
            T.prototype = new C(), b.exports.Options = T;
          }, function(b) {
            function v(y, T) {
              this.raw_options = E(y, T), this.disabled = this._get_boolean("disabled"), this.eol = this._get_characters("eol", "auto"), this.end_with_newline = this._get_boolean("end_with_newline"), this.indent_size = this._get_number("indent_size", 4), this.indent_char = this._get_characters("indent_char", " "), this.indent_level = this._get_number("indent_level"), this.preserve_newlines = this._get_boolean("preserve_newlines", !0), this.max_preserve_newlines = this._get_number("max_preserve_newlines", 32786), this.preserve_newlines || (this.max_preserve_newlines = 0), this.indent_with_tabs = this._get_boolean("indent_with_tabs", this.indent_char === "	"), this.indent_with_tabs && (this.indent_char = "	", this.indent_size === 1 && (this.indent_size = 4)), this.wrap_line_length = this._get_number("wrap_line_length", this._get_number("max_char")), this.indent_empty_lines = this._get_boolean("indent_empty_lines"), this.templating = this._get_selection_list("templating", ["auto", "none", "django", "erb", "handlebars", "php", "smarty"], ["auto"]);
            }
            function E(y, T) {
              var A, k = {};
              for (A in y = C(y)) A !== T && (k[A] = y[A]);
              if (T && y[T]) for (A in y[T]) k[A] = y[T][A];
              return k;
            }
            function C(y) {
              var T, A = {};
              for (T in y) A[T.replace(/-/g, "_")] = y[T];
              return A;
            }
            v.prototype._get_array = function(y, T) {
              return T = T || [], d(y = this.raw_options[y]) === "object" ? y !== null && typeof y.concat == "function" && (T = y.concat()) : typeof y == "string" && (T = y.split(/[^a-zA-Z0-9_\/\-]+/)), T;
            }, v.prototype._get_boolean = function(y, T) {
              return (y = this.raw_options[y]) === void 0 ? !!T : !!y;
            }, v.prototype._get_characters = function(y, T) {
              return T = T || "", typeof (y = this.raw_options[y]) == "string" ? y.replace(/\\r/, "\r").replace(/\\n/, `
`).replace(/\\t/, "	") : T;
            }, v.prototype._get_number = function(y, T) {
              return y = this.raw_options[y], T = parseInt(T, 10), isNaN(T) && (T = 0), y = parseInt(y, 10), isNaN(y) ? T : y;
            }, v.prototype._get_selection = function(y, T, A) {
              if ((A = this._get_selection_list(y, T, A)).length !== 1) throw new Error("Invalid Option Value: The option '" + y + `' can only be one of the following values:
` + T + `
You passed in: '` + this.raw_options[y] + "'");
              return A[0];
            }, v.prototype._get_selection_list = function(y, T, A) {
              if (!T || T.length === 0) throw new Error("Selection list cannot be empty.");
              if (A = A || [T[0]], !this._is_valid_selection(A, T)) throw new Error("Invalid Default Value!");
              if (A = this._get_array(y, A), !this._is_valid_selection(A, T)) throw new Error("Invalid Option Value: The option '" + y + `' can contain only the following values:
` + T + `
You passed in: '` + this.raw_options[y] + "'");
              return A;
            }, v.prototype._is_valid_selection = function(y, T) {
              return y.length && T.length && !y.some(function(A) {
                return T.indexOf(A) === -1;
              });
            }, b.exports.Options = v, b.exports.normalizeOpts = C, b.exports.mergeOpts = E;
          }, function(b, v, Y) {
            var C = Y(8).InputScanner, y = Y(9).Tokenizer, $ = Y(9).TOKEN, T = Y(13).Directives, A = Y(4), k = Y(12).Pattern, N = Y(14).TemplatablePattern;
            function j(V, K) {
              return K.indexOf(V) !== -1;
            }
            var I = { START_EXPR: "TK_START_EXPR", END_EXPR: "TK_END_EXPR", START_BLOCK: "TK_START_BLOCK", END_BLOCK: "TK_END_BLOCK", WORD: "TK_WORD", RESERVED: "TK_RESERVED", SEMICOLON: "TK_SEMICOLON", STRING: "TK_STRING", EQUALS: "TK_EQUALS", OPERATOR: "TK_OPERATOR", COMMA: "TK_COMMA", BLOCK_COMMENT: "TK_BLOCK_COMMENT", COMMENT: "TK_COMMENT", DOT: "TK_DOT", UNKNOWN: "TK_UNKNOWN", START: $.START, RAW: $.RAW, EOF: $.EOF }, B = new T(/\/\*/, /\*\//), U = /0[xX][0123456789abcdefABCDEF_]*n?|0[oO][01234567_]*n?|0[bB][01_]*n?|\d[\d_]*n|(?:\.\d[\d_]*|\d[\d_]*\.?[\d_]*)(?:[eE][+-]?[\d_]+)?/, H = /[0-9]/, Q = /[^\d\.]/, Y = ">>> === !== &&= ??= ||= << && >= ** != == <= >> || ?? |> < / - + > : & % ? ^ | *".split(" ");
            $ = ($ = "\\?\\.(?!\\d) " + ($ = ">>>= ... >>= <<= === >>> !== **= &&= ??= ||= => ^= :: /= << <= == && -= >= >> != -- += ** || ?? ++ %= &= *= |= |> = ! ? > < : / ^ - + * & % ~ |").replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&")).replace(/ /g, "|");
            var ie, ce = new RegExp($), $ = (T = "continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export".split(",")).concat(["do", "in", "of", "else", "get", "set", "new", "catch", "finally", "typeof", "yield", "async", "await", "from", "as", "class", "extends"]), te = new RegExp("^(?:" + $.join("|") + ")$");
            (($ = function(K, ne) {
              y.call(this, K, ne), this._patterns.whitespace = this._patterns.whitespace.matching(/\u00A0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff/.source, /\u2028\u2029/.source), K = new k(this._input), ne = new N(this._input).read_options(this._options), this.__patterns = { template: ne, identifier: ne.starting_with(A.identifier).matching(A.identifierMatch), number: K.matching(U), punct: K.matching(ce), comment: K.starting_with(/\/\//).until(/[\n\r\u2028\u2029]/), block_comment: K.starting_with(/\/\*/).until_after(/\*\//), html_comment_start: K.matching(/<!--/), html_comment_end: K.matching(/-->/), include: K.starting_with(/#include/).until_after(A.lineBreak), shebang: K.starting_with(/#!/).until_after(A.lineBreak), xml: K.matching(/[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[^}]+?}|!\[CDATA\[[^\]]*?\]\]|)(\s*{[^}]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{([^{}]|{[^}]+?})+?}))*\s*(\/?)\s*>/), single_quote: ne.until(/['\\\n\r\u2028\u2029]/), double_quote: ne.until(/["\\\n\r\u2028\u2029]/), template_text: ne.until(/[`\\$]/), template_expression: ne.until(/[`}\\]/) };
            }).prototype = new y())._is_comment = function(V) {
              return V.type === I.COMMENT || V.type === I.BLOCK_COMMENT || V.type === I.UNKNOWN;
            }, $.prototype._is_opening = function(V) {
              return V.type === I.START_BLOCK || V.type === I.START_EXPR;
            }, $.prototype._is_closing = function(V, K) {
              return (V.type === I.END_BLOCK || V.type === I.END_EXPR) && K && (V.text === "]" && K.text === "[" || V.text === ")" && K.text === "(" || V.text === "}" && K.text === "{");
            }, $.prototype._reset = function() {
              ie = !1;
            }, $.prototype._get_next_token = function(V, K) {
              this._readWhitespace();
              var ne = this._input.peek();
              return ne === null ? this._create_token(I.EOF, "") : this._read_non_javascript(ne) || this._read_string(ne) || this._read_pair(ne, this._input.peek(1)) || this._read_word(V) || this._read_singles(ne) || this._read_comment(ne) || this._read_regexp(ne, V) || this._read_xml(ne, V) || this._read_punctuation() || this._create_token(I.UNKNOWN, this._input.next());
            }, $.prototype._read_word = function(V) {
              var K = this.__patterns.identifier.read();
              return K !== "" ? (K = K.replace(A.allLineBreaks, `
`), V.type !== I.DOT && (V.type !== I.RESERVED || V.text !== "set" && V.text !== "get") && te.test(K) ? K !== "in" && K !== "of" || V.type !== I.WORD && V.type !== I.STRING ? this._create_token(I.RESERVED, K) : this._create_token(I.OPERATOR, K) : this._create_token(I.WORD, K)) : (K = this.__patterns.number.read()) !== "" ? this._create_token(I.WORD, K) : void 0;
            }, $.prototype._read_singles = function(V) {
              var K = null;
              return V === "(" || V === "[" ? K = this._create_token(I.START_EXPR, V) : V === ")" || V === "]" ? K = this._create_token(I.END_EXPR, V) : V === "{" ? K = this._create_token(I.START_BLOCK, V) : V === "}" ? K = this._create_token(I.END_BLOCK, V) : V === ";" ? K = this._create_token(I.SEMICOLON, V) : V === "." && Q.test(this._input.peek(1)) ? K = this._create_token(I.DOT, V) : V === "," && (K = this._create_token(I.COMMA, V)), K && this._input.next(), K;
            }, $.prototype._read_pair = function(V, K) {
              var ne = null;
              return (ne = V === "#" && K === "{" ? this._create_token(I.START_BLOCK, V + K) : ne) && (this._input.next(), this._input.next()), ne;
            }, $.prototype._read_punctuation = function() {
              var V = this.__patterns.punct.read();
              if (V !== "") return V === "=" ? this._create_token(I.EQUALS, V) : V === "?." ? this._create_token(I.DOT, V) : this._create_token(I.OPERATOR, V);
            }, $.prototype._read_non_javascript = function(V) {
              var K = "";
              if (V === "#") {
                if (this._is_first_token() && (K = this.__patterns.shebang.read())) return this._create_token(I.UNKNOWN, K.trim() + `
`);
                if (K = this.__patterns.include.read()) return this._create_token(I.UNKNOWN, K.trim() + `
`);
                V = this._input.next();
                var ne = "#";
                if (this._input.hasNext() && this._input.testChar(H)) {
                  for (; ne += V = this._input.next(), this._input.hasNext() && V !== "#" && V !== "="; ) ;
                  return V === "#" || (this._input.peek() === "[" && this._input.peek(1) === "]" ? (ne += "[]", this._input.next(), this._input.next()) : this._input.peek() === "{" && this._input.peek(1) === "}" && (ne += "{}", this._input.next(), this._input.next())), this._create_token(I.WORD, ne);
                }
                this._input.back();
              } else if (V === "<" && this._is_first_token()) {
                if (K = this.__patterns.html_comment_start.read()) {
                  for (; this._input.hasNext() && !this._input.testChar(A.newline); ) K += this._input.next();
                  return ie = !0, this._create_token(I.COMMENT, K);
                }
              } else if (ie && V === "-" && (K = this.__patterns.html_comment_end.read())) return ie = !1, this._create_token(I.COMMENT, K);
              return null;
            }, $.prototype._read_comment = function(V) {
              var K, ne = null;
              return V === "/" && (K = "", this._input.peek(1) === "*" ? (K = this.__patterns.block_comment.read(), (V = B.get_directives(K)) && V.ignore === "start" && (K += B.readIgnored(this._input)), K = K.replace(A.allLineBreaks, `
`), (ne = this._create_token(I.BLOCK_COMMENT, K)).directives = V) : this._input.peek(1) === "/" && (K = this.__patterns.comment.read(), ne = this._create_token(I.COMMENT, K))), ne;
            }, $.prototype._read_string = function(V) {
              if (V !== "`" && V !== "'" && V !== '"') return null;
              var K = this._input.next();
              return this.has_char_escapes = !1, K += V === "`" ? this._read_string_recursive("`", !0, "${") : this._read_string_recursive(V), this.has_char_escapes && this._options.unescape_strings && (K = function(J) {
                for (var L, z = "", ee = new C(J), q = null; ee.hasNext(); ) if ((q = ee.match(/([\s]|[^\\]|\\\\)+/g)) && (z += q[0]), ee.peek() === "\\") {
                  if (ee.next(), ee.peek() === "x") q = ee.match(/x([0-9A-Fa-f]{2})/g);
                  else {
                    if (ee.peek() !== "u") {
                      z += "\\", ee.hasNext() && (z += ee.next());
                      continue;
                    }
                    q = (q = ee.match(/u([0-9A-Fa-f]{4})/g)) || ee.match(/u\{([0-9A-Fa-f]+)\}/g);
                  }
                  if (!q || 126 < (L = parseInt(q[1], 16)) && L <= 255 && q[0].indexOf("x") === 0) return J;
                  z += 0 <= L && L < 32 || 1114111 < L ? "\\" + q[0] : L === 34 || L === 39 || L === 92 ? "\\" + String.fromCharCode(L) : String.fromCharCode(L);
                }
                return z;
              }(K)), this._input.peek() === V && (K += this._input.next()), K = K.replace(A.allLineBreaks, `
`), this._create_token(I.STRING, K);
            }, $.prototype._allow_regexp_or_xml = function(V) {
              return V.type === I.RESERVED && j(V.text, ["return", "case", "throw", "else", "do", "typeof", "yield"]) || V.type === I.END_EXPR && V.text === ")" && V.opened.previous.type === I.RESERVED && j(V.opened.previous.text, ["if", "while", "for"]) || j(V.type, [I.COMMENT, I.START_EXPR, I.START_BLOCK, I.START, I.END_BLOCK, I.OPERATOR, I.EQUALS, I.EOF, I.SEMICOLON, I.COMMA]);
            }, $.prototype._read_regexp = function(V, K) {
              if (V === "/" && this._allow_regexp_or_xml(K)) {
                for (var ne = this._input.next(), J = !1, L = !1; this._input.hasNext() && (J || L || this._input.peek() !== V) && !this._input.testChar(A.newline); ) ne += this._input.peek(), J ? J = !1 : (J = this._input.peek() === "\\", this._input.peek() === "[" ? L = !0 : this._input.peek() === "]" && (L = !1)), this._input.next();
                return this._input.peek() === V && (ne += this._input.next(), ne += this._input.read(A.identifier)), this._create_token(I.STRING, ne);
              }
              return null;
            }, $.prototype._read_xml = function(V, K) {
              if (this._options.e4x && V === "<" && this._allow_regexp_or_xml(K)) {
                var ne = "", J = this.__patterns.xml.read_match();
                if (J) {
                  for (var L = J[2].replace(/^{\s+/, "{").replace(/\s+}$/, "}"), z = L.indexOf("{") === 0, ee = 0; J; ) {
                    var q = !!J[1], X = J[2];
                    if (!J[J.length - 1] && X.slice(0, 8) !== "![CDATA[" && (X === L || z && X.replace(/^{\s+/, "{").replace(/\s+}$/, "}")) && (q ? --ee : ++ee), ne += J[0], ee <= 0) break;
                    J = this.__patterns.xml.read_match();
                  }
                  return J || (ne += this._input.match(/[\s\S]*/g)[0]), ne = ne.replace(A.allLineBreaks, `
`), this._create_token(I.STRING, ne);
                }
              }
              return null;
            }, $.prototype._read_string_recursive = function(V, K, ne) {
              var J, L;
              V === "'" ? L = this.__patterns.single_quote : V === '"' ? L = this.__patterns.double_quote : V === "`" ? L = this.__patterns.template_text : V === "}" && (L = this.__patterns.template_expression);
              for (var z = L.read(), ee = ""; this._input.hasNext(); ) {
                if ((ee = this._input.next()) === V || !K && A.newline.test(ee)) {
                  this._input.back();
                  break;
                }
                ee === "\\" && this._input.hasNext() ? ((J = this._input.peek()) === "x" || J === "u" ? this.has_char_escapes = !0 : J === "\r" && this._input.peek(1) === `
` && this._input.next(), ee += this._input.next()) : ne && (ne === "${" && ee === "$" && this._input.peek() === "{" && (ee += this._input.next()), ne === ee && (ee += V === "`" ? this._read_string_recursive("}", K, "`") : this._read_string_recursive("`", K, "${"), this._input.hasNext() && (ee += this._input.next()))), z += ee += L.read();
              }
              return z;
            }, b.exports.Tokenizer = $, b.exports.TOKEN = I, b.exports.positionable_operators = Y.slice(), b.exports.line_starters = T.slice();
          }, function(b) {
            var v = RegExp.prototype.hasOwnProperty("sticky");
            function E(C) {
              this.__input = C || "", this.__input_length = this.__input.length, this.__position = 0;
            }
            E.prototype.restart = function() {
              this.__position = 0;
            }, E.prototype.back = function() {
              0 < this.__position && --this.__position;
            }, E.prototype.hasNext = function() {
              return this.__position < this.__input_length;
            }, E.prototype.next = function() {
              var C = null;
              return this.hasNext() && (C = this.__input.charAt(this.__position), this.__position += 1), C;
            }, E.prototype.peek = function(C) {
              var y = null;
              return C = C || 0, 0 <= (C += this.__position) && C < this.__input_length ? this.__input.charAt(C) : y;
            }, E.prototype.__match = function(C, y) {
              C.lastIndex = y;
              var T = C.exec(this.__input);
              return !T || v && C.sticky || T.index !== y && (T = null), T;
            }, E.prototype.test = function(C, y) {
              return y = y || 0, 0 <= (y += this.__position) && y < this.__input_length && !!this.__match(C, y);
            }, E.prototype.testChar = function(C, y) {
              return y = this.peek(y), C.lastIndex = 0, y !== null && C.test(y);
            }, E.prototype.match = function(C) {
              return (C = this.__match(C, this.__position)) ? this.__position += C[0].length : C = null, C;
            }, E.prototype.read = function(C, y, T) {
              var A, k = "";
              return C && (A = this.match(C)) && (k += A[0]), !y || !A && C || (k += this.readUntil(y, T)), k;
            }, E.prototype.readUntil = function(C, y) {
              var T = this.__position;
              return C.lastIndex = this.__position, (C = C.exec(this.__input)) ? (T = C.index, y && (T += C[0].length)) : T = this.__input_length, C = this.__input.substring(this.__position, T), this.__position = T, C;
            }, E.prototype.readUntilAfter = function(C) {
              return this.readUntil(C, !0);
            }, E.prototype.get_regexp = function(C, A) {
              var T = null, A = A && v ? "y" : "g";
              return typeof C == "string" && C !== "" ? T = new RegExp(C, A) : C && (T = new RegExp(C.source, A)), T;
            }, E.prototype.get_literal_regexp = function(C) {
              return RegExp(C.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
            }, E.prototype.peekUntilAfter = function(T) {
              var y = this.__position, T = this.readUntilAfter(T);
              return this.__position = y, T;
            }, E.prototype.lookBack = function(C) {
              var y = this.__position - 1;
              return y >= C.length && this.__input.substring(y - C.length, y).toLowerCase() === C;
            }, b.exports.InputScanner = E;
          }, function(b, v, E) {
            var C = E(8).InputScanner, y = E(3).Token, T = E(10).TokenStream, A = E(11).WhitespacePattern, k = { START: "TK_START", RAW: "TK_RAW", EOF: "TK_EOF" };
            (E = function(j, I) {
              this._input = new C(j), this._options = I || {}, this.__tokens = null, this._patterns = {}, this._patterns.whitespace = new A(this._input);
            }).prototype.tokenize = function() {
              var N;
              this._input.restart(), this.__tokens = new T(), this._reset();
              for (var j = new y(k.START, ""), I = null, B = [], U = new T(); j.type !== k.EOF; ) {
                for (N = this._get_next_token(j, I); this._is_comment(N); ) U.add(N), N = this._get_next_token(j, I);
                U.isEmpty() || (N.comments_before = U, U = new T()), N.parent = I, this._is_opening(N) ? (B.push(I), I = N) : I && this._is_closing(N, I) && ((N.opened = I).closed = N, I = B.pop(), N.parent = I), (N.previous = j).next = N, this.__tokens.add(N), j = N;
              }
              return this.__tokens;
            }, E.prototype._is_first_token = function() {
              return this.__tokens.isEmpty();
            }, E.prototype._reset = function() {
            }, E.prototype._get_next_token = function(N, j) {
              this._readWhitespace();
              var I = this._input.read(/.+/g);
              return I ? this._create_token(k.RAW, I) : this._create_token(k.EOF, "");
            }, E.prototype._is_comment = function(N) {
              return !1;
            }, E.prototype._is_opening = function(N) {
              return !1;
            }, E.prototype._is_closing = function(N, j) {
              return !1;
            }, E.prototype._create_token = function(N, j) {
              return new y(N, j, this._patterns.whitespace.newline_count, this._patterns.whitespace.whitespace_before_token);
            }, E.prototype._readWhitespace = function() {
              return this._patterns.whitespace.read();
            }, b.exports.Tokenizer = E, b.exports.TOKEN = k;
          }, function(b) {
            function v(E) {
              this.__tokens = [], this.__tokens_length = this.__tokens.length, this.__position = 0, this.__parent_token = E;
            }
            v.prototype.restart = function() {
              this.__position = 0;
            }, v.prototype.isEmpty = function() {
              return this.__tokens_length === 0;
            }, v.prototype.hasNext = function() {
              return this.__position < this.__tokens_length;
            }, v.prototype.next = function() {
              var E = null;
              return this.hasNext() && (E = this.__tokens[this.__position], this.__position += 1), E;
            }, v.prototype.peek = function(E) {
              var C = null;
              return E = E || 0, 0 <= (E += this.__position) && E < this.__tokens_length ? this.__tokens[E] : C;
            }, v.prototype.add = function(E) {
              this.__parent_token && (E.parent = this.__parent_token), this.__tokens.push(E), this.__tokens_length += 1;
            }, b.exports.TokenStream = v;
          }, function(b, v, E) {
            var C = E(12).Pattern;
            function y(T, A) {
              C.call(this, T, A), A ? this._line_regexp = this._input.get_regexp(A._line_regexp) : this.__set_whitespace_patterns("", ""), this.newline_count = 0, this.whitespace_before_token = "";
            }
            (y.prototype = new C()).__set_whitespace_patterns = function(T, A) {
              this._match_pattern = this._input.get_regexp("[" + (T += "\\t ") + (A += "\\n\\r") + "]+", !0), this._newline_regexp = this._input.get_regexp("\\r\\n|[" + A + "]");
            }, y.prototype.read = function() {
              this.newline_count = 0, this.whitespace_before_token = "";
              var T, A = this._input.read(this._match_pattern);
              return A === " " ? this.whitespace_before_token = " " : A && (T = this.__split(this._newline_regexp, A), this.newline_count = T.length - 1, this.whitespace_before_token = T[this.newline_count]), A;
            }, y.prototype.matching = function(T, A) {
              var k = this._create();
              return k.__set_whitespace_patterns(T, A), k._update(), k;
            }, y.prototype._create = function() {
              return new y(this._input, this);
            }, y.prototype.__split = function(T, A) {
              for (var k = T.lastIndex = 0, N = [], j = T.exec(A); j; ) N.push(A.substring(k, j.index)), k = j.index + j[0].length, j = T.exec(A);
              return k < A.length ? N.push(A.substring(k, A.length)) : N.push(""), N;
            }, b.exports.WhitespacePattern = y;
          }, function(b) {
            function v(E, C) {
              this._input = E, this._starting_pattern = null, this._match_pattern = null, this._until_pattern = null, this._until_after = !1, C && (this._starting_pattern = this._input.get_regexp(C._starting_pattern, !0), this._match_pattern = this._input.get_regexp(C._match_pattern, !0), this._until_pattern = this._input.get_regexp(C._until_pattern), this._until_after = C._until_after);
            }
            v.prototype.read = function() {
              var E = this._input.read(this._starting_pattern);
              return this._starting_pattern && !E || (E += this._input.read(this._match_pattern, this._until_pattern, this._until_after)), E;
            }, v.prototype.read_match = function() {
              return this._input.match(this._match_pattern);
            }, v.prototype.until_after = function(E) {
              var C = this._create();
              return C._until_after = !0, C._until_pattern = this._input.get_regexp(E), C._update(), C;
            }, v.prototype.until = function(E) {
              var C = this._create();
              return C._until_after = !1, C._until_pattern = this._input.get_regexp(E), C._update(), C;
            }, v.prototype.starting_with = function(E) {
              var C = this._create();
              return C._starting_pattern = this._input.get_regexp(E, !0), C._update(), C;
            }, v.prototype.matching = function(E) {
              var C = this._create();
              return C._match_pattern = this._input.get_regexp(E, !0), C._update(), C;
            }, v.prototype._create = function() {
              return new v(this._input, this);
            }, v.prototype._update = function() {
            }, b.exports.Pattern = v;
          }, function(b) {
            function v(E, C) {
              E = typeof E == "string" ? E : E.source, C = typeof C == "string" ? C : C.source, this.__directives_block_pattern = new RegExp(E + / beautify( \w+[:]\w+)+ /.source + C, "g"), this.__directive_pattern = / (\w+)[:](\w+)/g, this.__directives_end_ignore_pattern = new RegExp(E + /\sbeautify\signore:end\s/.source + C, "g");
            }
            v.prototype.get_directives = function(E) {
              if (!E.match(this.__directives_block_pattern)) return null;
              var C = {};
              this.__directive_pattern.lastIndex = 0;
              for (var y = this.__directive_pattern.exec(E); y; ) C[y[1]] = y[2], y = this.__directive_pattern.exec(E);
              return C;
            }, v.prototype.readIgnored = function(E) {
              return E.readUntilAfter(this.__directives_end_ignore_pattern);
            }, b.exports.Directives = v;
          }, function(b, v, E) {
            var C = E(12).Pattern, y = { django: !1, erb: !1, handlebars: !1, php: !1, smarty: !1 };
            function T(A, k) {
              C.call(this, A, k), this.__template_pattern = null, this._disabled = Object.assign({}, y), this._excluded = Object.assign({}, y), k && (this.__template_pattern = this._input.get_regexp(k.__template_pattern), this._excluded = Object.assign(this._excluded, k._excluded), this._disabled = Object.assign(this._disabled, k._disabled)), A = new C(A), this.__patterns = { handlebars_comment: A.starting_with(/{{!--/).until_after(/--}}/), handlebars_unescaped: A.starting_with(/{{{/).until_after(/}}}/), handlebars: A.starting_with(/{{/).until_after(/}}/), php: A.starting_with(/<\?(?:[= ]|php)/).until_after(/\?>/), erb: A.starting_with(/<%[^%]/).until_after(/[^%]%>/), django: A.starting_with(/{%/).until_after(/%}/), django_value: A.starting_with(/{{/).until_after(/}}/), django_comment: A.starting_with(/{#/).until_after(/#}/), smarty: A.starting_with(/{(?=[^}{\s\n])/).until_after(/[^\s\n]}/), smarty_comment: A.starting_with(/{\*/).until_after(/\*}/), smarty_literal: A.starting_with(/{literal}/).until_after(/{\/literal}/) };
            }
            (T.prototype = new C())._create = function() {
              return new T(this._input, this);
            }, T.prototype._update = function() {
              this.__set_templated_pattern();
            }, T.prototype.disable = function(A) {
              var k = this._create();
              return k._disabled[A] = !0, k._update(), k;
            }, T.prototype.read_options = function(A) {
              var k, N = this._create();
              for (k in y) N._disabled[k] = A.templating.indexOf(k) === -1;
              return N._update(), N;
            }, T.prototype.exclude = function(A) {
              var k = this._create();
              return k._excluded[A] = !0, k._update(), k;
            }, T.prototype.read = function() {
              for (var A = "", A = this._match_pattern ? this._input.read(this._starting_pattern) : this._input.read(this._starting_pattern, this.__template_pattern), k = this._read_template(); k; ) this._match_pattern ? k += this._input.read(this._match_pattern) : k += this._input.readUntil(this.__template_pattern), A += k, k = this._read_template();
              return this._until_after && (A += this._input.readUntilAfter(this._until_pattern)), A;
            }, T.prototype.__set_templated_pattern = function() {
              var A = [];
              this._disabled.php || A.push(this.__patterns.php._starting_pattern.source), this._disabled.handlebars || A.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.erb || A.push(this.__patterns.erb._starting_pattern.source), this._disabled.django || (A.push(this.__patterns.django._starting_pattern.source), A.push(this.__patterns.django_value._starting_pattern.source), A.push(this.__patterns.django_comment._starting_pattern.source)), this._disabled.smarty || A.push(this.__patterns.smarty._starting_pattern.source), this._until_pattern && A.push(this._until_pattern.source), this.__template_pattern = this._input.get_regexp("(?:" + A.join("|") + ")");
            }, T.prototype._read_template = function() {
              var A, k = "", N = this._input.peek();
              return N === "<" ? (A = this._input.peek(1), this._disabled.php || this._excluded.php || A !== "?" || (k = k || this.__patterns.php.read()), this._disabled.erb || this._excluded.erb || A !== "%" || (k = k || this.__patterns.erb.read())) : N === "{" && (this._disabled.handlebars || this._excluded.handlebars || (k = (k = (k = k || this.__patterns.handlebars_comment.read()) || this.__patterns.handlebars_unescaped.read()) || this.__patterns.handlebars.read()), this._disabled.django || (this._excluded.django || this._excluded.handlebars || (k = k || this.__patterns.django_value.read()), this._excluded.django || (k = (k = k || this.__patterns.django_comment.read()) || this.__patterns.django.read())), this._disabled.smarty || this._disabled.django && this._disabled.handlebars && (k = (k = (k = k || this.__patterns.smarty_comment.read()) || this.__patterns.smarty_literal.read()) || this.__patterns.smarty.read())), k;
            }, b.exports.TemplatablePattern = T;
          }], g = {}, _ = function b(v) {
            var E = g[v];
            return E !== void 0 || (E = g[v] = { exports: {} }, p[v](E, E.exports, b)), E.exports;
          }(0);
          f = _;
        })();
        var h = f;
        (l = (function() {
          return { js_beautify: h };
        }).apply(s, [])) === void 0 || (a.exports = l);
      })();
    }, function(a, s, r) {
      var l;
      function d(f) {
        return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
          return typeof h;
        } : function(h) {
          return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
        })(f);
      }
      (function() {
        var f;
        (function() {
          var p = [, , function(b) {
            function v(y) {
              this.__parent = y, this.__character_count = 0, this.__indent_count = -1, this.__alignment_count = 0, this.__wrap_point_index = 0, this.__wrap_point_character_count = 0, this.__wrap_point_indent_count = -1, this.__wrap_point_alignment_count = 0, this.__items = [];
            }
            function E(y, T) {
              this.__cache = [""], this.__indent_size = y.indent_size, this.__indent_string = y.indent_char, y.indent_with_tabs || (this.__indent_string = new Array(y.indent_size + 1).join(y.indent_char)), T = T || "", 0 < y.indent_level && (T = new Array(y.indent_level + 1).join(this.__indent_string)), this.__base_string = T, this.__base_string_length = T.length;
            }
            function C(y, T) {
              this.__indent_cache = new E(y, T), this.raw = !1, this._end_with_newline = y.end_with_newline, this.indent_size = y.indent_size, this.wrap_line_length = y.wrap_line_length, this.indent_empty_lines = y.indent_empty_lines, this.__lines = [], this.previous_line = null, this.current_line = null, this.next_line = new v(this), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1, this.__add_outputline();
            }
            v.prototype.clone_empty = function() {
              var y = new v(this.__parent);
              return y.set_indent(this.__indent_count, this.__alignment_count), y;
            }, v.prototype.item = function(y) {
              return y < 0 ? this.__items[this.__items.length + y] : this.__items[y];
            }, v.prototype.has_match = function(y) {
              for (var T = this.__items.length - 1; 0 <= T; T--) if (this.__items[T].match(y)) return !0;
              return !1;
            }, v.prototype.set_indent = function(y, T) {
              this.is_empty() && (this.__indent_count = y || 0, this.__alignment_count = T || 0, this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count));
            }, v.prototype._set_wrap_point = function() {
              this.__parent.wrap_line_length && (this.__wrap_point_index = this.__items.length, this.__wrap_point_character_count = this.__character_count, this.__wrap_point_indent_count = this.__parent.next_line.__indent_count, this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count);
            }, v.prototype._should_wrap = function() {
              return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
            }, v.prototype._allow_wrap = function() {
              if (this._should_wrap()) {
                this.__parent.add_new_line();
                var y = this.__parent.current_line;
                return y.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count), y.__items = this.__items.slice(this.__wrap_point_index), this.__items = this.__items.slice(0, this.__wrap_point_index), y.__character_count += this.__character_count - this.__wrap_point_character_count, this.__character_count = this.__wrap_point_character_count, y.__items[0] === " " && (y.__items.splice(0, 1), --y.__character_count), !0;
              }
              return !1;
            }, v.prototype.is_empty = function() {
              return this.__items.length === 0;
            }, v.prototype.last = function() {
              return this.is_empty() ? null : this.__items[this.__items.length - 1];
            }, v.prototype.push = function(y) {
              this.__items.push(y);
              var T = y.lastIndexOf(`
`);
              T !== -1 ? this.__character_count = y.length - T : this.__character_count += y.length;
            }, v.prototype.pop = function() {
              var y = null;
              return this.is_empty() || (y = this.__items.pop(), this.__character_count -= y.length), y;
            }, v.prototype._remove_indent = function() {
              0 < this.__indent_count && (--this.__indent_count, this.__character_count -= this.__parent.indent_size);
            }, v.prototype._remove_wrap_indent = function() {
              0 < this.__wrap_point_indent_count && --this.__wrap_point_indent_count;
            }, v.prototype.trim = function() {
              for (; this.last() === " "; ) this.__items.pop(), --this.__character_count;
            }, v.prototype.toString = function() {
              var y = "";
              return this.is_empty() ? this.__parent.indent_empty_lines && (y = this.__parent.get_indent_string(this.__indent_count)) : (y = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count), y += this.__items.join("")), y;
            }, E.prototype.get_indent_size = function(y, T) {
              var A = this.__base_string_length;
              return y < 0 && (A = 0), (A += y * this.__indent_size) + (T || 0);
            }, E.prototype.get_indent_string = function(y, T) {
              var A = this.__base_string;
              return T = T || 0, y < 0 && (y = 0, A = ""), T += y * this.__indent_size, this.__ensure_cache(T), A + this.__cache[T];
            }, E.prototype.__ensure_cache = function(y) {
              for (; y >= this.__cache.length; ) this.__add_column();
            }, E.prototype.__add_column = function() {
              var y, T = this.__cache.length, A = "";
              this.__indent_size && T >= this.__indent_size && (T -= (y = Math.floor(T / this.__indent_size)) * this.__indent_size, A = new Array(y + 1).join(this.__indent_string)), T && (A += new Array(T + 1).join(" ")), this.__cache.push(A);
            }, C.prototype.__add_outputline = function() {
              this.previous_line = this.current_line, this.current_line = this.next_line.clone_empty(), this.__lines.push(this.current_line);
            }, C.prototype.get_line_number = function() {
              return this.__lines.length;
            }, C.prototype.get_indent_string = function(y, T) {
              return this.__indent_cache.get_indent_string(y, T);
            }, C.prototype.get_indent_size = function(y, T) {
              return this.__indent_cache.get_indent_size(y, T);
            }, C.prototype.is_empty = function() {
              return !this.previous_line && this.current_line.is_empty();
            }, C.prototype.add_new_line = function(y) {
              return !(this.is_empty() || !y && this.just_added_newline() || (this.raw || this.__add_outputline(), 0));
            }, C.prototype.get_code = function(y) {
              this.trim(!0);
              var T = this.current_line.pop();
              return T && (T[T.length - 1] === `
` && (T = T.replace(/\n+$/g, "")), this.current_line.push(T)), this._end_with_newline && this.__add_outputline(), T = this.__lines.join(`
`), y !== `
` ? T.replace(/[\n]/g, y) : T;
            }, C.prototype.set_wrap_point = function() {
              this.current_line._set_wrap_point();
            }, C.prototype.set_indent = function(y, T) {
              return this.next_line.set_indent(y = y || 0, T = T || 0), 1 < this.__lines.length ? (this.current_line.set_indent(y, T), !0) : (this.current_line.set_indent(), !1);
            }, C.prototype.add_raw_token = function(y) {
              for (var T = 0; T < y.newlines; T++) this.__add_outputline();
              this.current_line.set_indent(-1), this.current_line.push(y.whitespace_before), this.current_line.push(y.text), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1;
            }, C.prototype.add_token = function(y) {
              this.__add_space_before_token(), this.current_line.push(y), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = this.current_line._allow_wrap();
            }, C.prototype.__add_space_before_token = function() {
              this.space_before_token && !this.just_added_newline() && (this.non_breaking_space || this.set_wrap_point(), this.current_line.push(" "));
            }, C.prototype.remove_indent = function(y) {
              for (var T = this.__lines.length; y < T; ) this.__lines[y]._remove_indent(), y++;
              this.current_line._remove_wrap_indent();
            }, C.prototype.trim = function(y) {
              for (y = y !== void 0 && y, this.current_line.trim(); y && 1 < this.__lines.length && this.current_line.is_empty(); ) this.__lines.pop(), this.current_line = this.__lines[this.__lines.length - 1], this.current_line.trim();
              this.previous_line = 1 < this.__lines.length ? this.__lines[this.__lines.length - 2] : null;
            }, C.prototype.just_added_newline = function() {
              return this.current_line.is_empty();
            }, C.prototype.just_added_blankline = function() {
              return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
            }, C.prototype.ensure_empty_line_above = function(y, T) {
              for (var A = this.__lines.length - 2; 0 <= A; ) {
                var k = this.__lines[A];
                if (k.is_empty()) break;
                if (k.item(0).indexOf(y) !== 0 && k.item(-1) !== T) {
                  this.__lines.splice(A + 1, 0, new v(this)), this.previous_line = this.__lines[this.__lines.length - 2];
                  break;
                }
                A--;
              }
            }, b.exports.Output = C;
          }, , , , function(b) {
            function v(y, T) {
              this.raw_options = E(y, T), this.disabled = this._get_boolean("disabled"), this.eol = this._get_characters("eol", "auto"), this.end_with_newline = this._get_boolean("end_with_newline"), this.indent_size = this._get_number("indent_size", 4), this.indent_char = this._get_characters("indent_char", " "), this.indent_level = this._get_number("indent_level"), this.preserve_newlines = this._get_boolean("preserve_newlines", !0), this.max_preserve_newlines = this._get_number("max_preserve_newlines", 32786), this.preserve_newlines || (this.max_preserve_newlines = 0), this.indent_with_tabs = this._get_boolean("indent_with_tabs", this.indent_char === "	"), this.indent_with_tabs && (this.indent_char = "	", this.indent_size === 1 && (this.indent_size = 4)), this.wrap_line_length = this._get_number("wrap_line_length", this._get_number("max_char")), this.indent_empty_lines = this._get_boolean("indent_empty_lines"), this.templating = this._get_selection_list("templating", ["auto", "none", "django", "erb", "handlebars", "php", "smarty"], ["auto"]);
            }
            function E(y, T) {
              var A, k = {};
              for (A in y = C(y)) A !== T && (k[A] = y[A]);
              if (T && y[T]) for (A in y[T]) k[A] = y[T][A];
              return k;
            }
            function C(y) {
              var T, A = {};
              for (T in y) A[T.replace(/-/g, "_")] = y[T];
              return A;
            }
            v.prototype._get_array = function(y, T) {
              return T = T || [], d(y = this.raw_options[y]) === "object" ? y !== null && typeof y.concat == "function" && (T = y.concat()) : typeof y == "string" && (T = y.split(/[^a-zA-Z0-9_\/\-]+/)), T;
            }, v.prototype._get_boolean = function(y, T) {
              return (y = this.raw_options[y]) === void 0 ? !!T : !!y;
            }, v.prototype._get_characters = function(y, T) {
              return T = T || "", typeof (y = this.raw_options[y]) == "string" ? y.replace(/\\r/, "\r").replace(/\\n/, `
`).replace(/\\t/, "	") : T;
            }, v.prototype._get_number = function(y, T) {
              return y = this.raw_options[y], T = parseInt(T, 10), isNaN(T) && (T = 0), y = parseInt(y, 10), isNaN(y) ? T : y;
            }, v.prototype._get_selection = function(y, T, A) {
              if ((A = this._get_selection_list(y, T, A)).length !== 1) throw new Error("Invalid Option Value: The option '" + y + `' can only be one of the following values:
` + T + `
You passed in: '` + this.raw_options[y] + "'");
              return A[0];
            }, v.prototype._get_selection_list = function(y, T, A) {
              if (!T || T.length === 0) throw new Error("Selection list cannot be empty.");
              if (A = A || [T[0]], !this._is_valid_selection(A, T)) throw new Error("Invalid Default Value!");
              if (A = this._get_array(y, A), !this._is_valid_selection(A, T)) throw new Error("Invalid Option Value: The option '" + y + `' can contain only the following values:
` + T + `
You passed in: '` + this.raw_options[y] + "'");
              return A;
            }, v.prototype._is_valid_selection = function(y, T) {
              return y.length && T.length && !y.some(function(A) {
                return T.indexOf(A) === -1;
              });
            }, b.exports.Options = v, b.exports.normalizeOpts = C, b.exports.mergeOpts = E;
          }, , function(b) {
            var v = RegExp.prototype.hasOwnProperty("sticky");
            function E(C) {
              this.__input = C || "", this.__input_length = this.__input.length, this.__position = 0;
            }
            E.prototype.restart = function() {
              this.__position = 0;
            }, E.prototype.back = function() {
              0 < this.__position && --this.__position;
            }, E.prototype.hasNext = function() {
              return this.__position < this.__input_length;
            }, E.prototype.next = function() {
              var C = null;
              return this.hasNext() && (C = this.__input.charAt(this.__position), this.__position += 1), C;
            }, E.prototype.peek = function(C) {
              var y = null;
              return C = C || 0, 0 <= (C += this.__position) && C < this.__input_length ? this.__input.charAt(C) : y;
            }, E.prototype.__match = function(C, y) {
              C.lastIndex = y;
              var T = C.exec(this.__input);
              return !T || v && C.sticky || T.index !== y && (T = null), T;
            }, E.prototype.test = function(C, y) {
              return y = y || 0, 0 <= (y += this.__position) && y < this.__input_length && !!this.__match(C, y);
            }, E.prototype.testChar = function(C, y) {
              return y = this.peek(y), C.lastIndex = 0, y !== null && C.test(y);
            }, E.prototype.match = function(C) {
              return (C = this.__match(C, this.__position)) ? this.__position += C[0].length : C = null, C;
            }, E.prototype.read = function(C, y, T) {
              var A, k = "";
              return C && (A = this.match(C)) && (k += A[0]), !y || !A && C || (k += this.readUntil(y, T)), k;
            }, E.prototype.readUntil = function(C, y) {
              var T = this.__position;
              return C.lastIndex = this.__position, (C = C.exec(this.__input)) ? (T = C.index, y && (T += C[0].length)) : T = this.__input_length, C = this.__input.substring(this.__position, T), this.__position = T, C;
            }, E.prototype.readUntilAfter = function(C) {
              return this.readUntil(C, !0);
            }, E.prototype.get_regexp = function(C, A) {
              var T = null, A = A && v ? "y" : "g";
              return typeof C == "string" && C !== "" ? T = new RegExp(C, A) : C && (T = new RegExp(C.source, A)), T;
            }, E.prototype.get_literal_regexp = function(C) {
              return RegExp(C.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
            }, E.prototype.peekUntilAfter = function(T) {
              var y = this.__position, T = this.readUntilAfter(T);
              return this.__position = y, T;
            }, E.prototype.lookBack = function(C) {
              var y = this.__position - 1;
              return y >= C.length && this.__input.substring(y - C.length, y).toLowerCase() === C;
            }, b.exports.InputScanner = E;
          }, , , , , function(b) {
            function v(E, C) {
              E = typeof E == "string" ? E : E.source, C = typeof C == "string" ? C : C.source, this.__directives_block_pattern = new RegExp(E + / beautify( \w+[:]\w+)+ /.source + C, "g"), this.__directive_pattern = / (\w+)[:](\w+)/g, this.__directives_end_ignore_pattern = new RegExp(E + /\sbeautify\signore:end\s/.source + C, "g");
            }
            v.prototype.get_directives = function(E) {
              if (!E.match(this.__directives_block_pattern)) return null;
              var C = {};
              this.__directive_pattern.lastIndex = 0;
              for (var y = this.__directive_pattern.exec(E); y; ) C[y[1]] = y[2], y = this.__directive_pattern.exec(E);
              return C;
            }, v.prototype.readIgnored = function(E) {
              return E.readUntilAfter(this.__directives_end_ignore_pattern);
            }, b.exports.Directives = v;
          }, , function(b, v, E) {
            var C = E(16).Beautifier, y = E(17).Options;
            b.exports = function(A, k) {
              return new C(A, k).beautify();
            }, b.exports.defaultOptions = function() {
              return new y();
            };
          }, function(b, v, E) {
            var C = E(17).Options, y = E(2).Output, T = E(8).InputScanner, A = new (E(13)).Directives(/\/\*/, /\*\//), k = /\r\n|[\r\n]/, N = /\r\n|[\r\n]/g, j = /\s/, I = /(?:\s|\n)+/g, B = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g, U = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
            function H(Q, Y) {
              this._source_text = Q || "", this._options = new C(Y), this._ch = null, this._input = null, this.NESTED_AT_RULE = { page: !0, "font-face": !0, keyframes: !0, media: !0, supports: !0, document: !0 }, this.CONDITIONAL_GROUP_RULE = { media: !0, supports: !0, document: !0 }, this.NON_SEMICOLON_NEWLINE_PROPERTY = ["grid-template-areas", "grid-template"];
            }
            H.prototype.eatString = function(Q) {
              var Y = "";
              for (this._ch = this._input.next(); this._ch; ) {
                if (Y += this._ch, this._ch === "\\") Y += this._input.next();
                else if (Q.indexOf(this._ch) !== -1 || this._ch === `
`) break;
                this._ch = this._input.next();
              }
              return Y;
            }, H.prototype.eatWhitespace = function(Q) {
              for (var Y = j.test(this._input.peek()), ie = 0; j.test(this._input.peek()); ) this._ch = this._input.next(), Q && this._ch === `
` && (ie === 0 || ie < this._options.max_preserve_newlines) && (ie++, this._output.add_new_line(!0));
              return Y;
            }, H.prototype.foundNestedPseudoClass = function() {
              for (var Q = 0, Y = 1, ie = this._input.peek(Y); ie; ) {
                if (ie === "{") return !0;
                if (ie === "(") Q += 1;
                else if (ie === ")") {
                  if (Q === 0) return !1;
                  --Q;
                } else if (ie === ";" || ie === "}") return !1;
                Y++, ie = this._input.peek(Y);
              }
              return !1;
            }, H.prototype.print_string = function(Q) {
              this._output.set_indent(this._indentLevel), this._output.non_breaking_space = !0, this._output.add_token(Q);
            }, H.prototype.preserveSingleSpace = function(Q) {
              Q && (this._output.space_before_token = !0);
            }, H.prototype.indent = function() {
              this._indentLevel++;
            }, H.prototype.outdent = function() {
              0 < this._indentLevel && this._indentLevel--;
            }, H.prototype.beautify = function() {
              if (this._options.disabled) return this._source_text;
              var Q = this._source_text, Y = this._options.eol;
              Y === "auto" && (Y = `
`, Q && k.test(Q || "") && (Y = Q.match(k)[0]));
              var ie = (Q = Q.replace(N, `
`)).match(/^[\t ]*/)[0];
              this._output = new y(this._options, ie), this._input = new T(Q), this._indentLevel = 0, this._nestedLevel = 0, this._ch = null;
              for (var ce, $, te, V = 0, K = !1, ne = !1, J = !1, L = !1, z = !1, ee = this._ch, q = !1; ce = this._input.read(I) !== "", $ = ee, this._ch = this._input.next(), this._ch === "\\" && this._input.hasNext() && (this._ch += this._input.next()), ee = this._ch, this._ch; ) if (this._ch === "/" && this._input.peek() === "*") {
                this._output.add_new_line(), this._input.back();
                var X = this._input.read(B), oe = A.get_directives(X);
                oe && oe.ignore === "start" && (X += A.readIgnored(this._input)), this.print_string(X), this.eatWhitespace(!0), this._output.add_new_line();
              } else if (this._ch === "/" && this._input.peek() === "/") this._output.space_before_token = !0, this._input.back(), this.print_string(this._input.read(U)), this.eatWhitespace(!0);
              else if (this._ch === "$") this.preserveSingleSpace(ce), this.print_string(this._ch), (X = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g)).match(/[ :]$/) && (X = this.eatString(": ").replace(/\s+$/, ""), this.print_string(X), this._output.space_before_token = !0), V === 0 && X.indexOf(":") !== -1 && (ne = !0, this.indent());
              else if (this._ch === "@") this.preserveSingleSpace(ce), this._input.peek() === "{" ? this.print_string(this._ch + this.eatString("}")) : (this.print_string(this._ch), (te = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g)).match(/[ :]$/) && (te = this.eatString(": ").replace(/\s+$/, ""), this.print_string(te), this._output.space_before_token = !0), V === 0 && te.indexOf(":") !== -1 ? (ne = !0, this.indent()) : te in this.NESTED_AT_RULE ? (this._nestedLevel += 1, te in this.CONDITIONAL_GROUP_RULE && (J = !0)) : V !== 0 || ne || (L = !0));
              else if (this._ch === "#" && this._input.peek() === "{") this.preserveSingleSpace(ce), this.print_string(this._ch + this.eatString("}"));
              else if (this._ch === "{") ne && (ne = !1, this.outdent()), L = !1, K = J ? (J = !1, this._indentLevel >= this._nestedLevel) : this._indentLevel >= this._nestedLevel - 1, this._options.newline_between_rules && K && this._output.previous_line && this._output.previous_line.item(-1) !== "{" && this._output.ensure_empty_line_above("/", ","), this._output.space_before_token = !0, this._options.brace_style === "expand" ? (this._output.add_new_line(), this.print_string(this._ch), this.indent(), this._output.set_indent(this._indentLevel)) : ($ === "(" ? this._output.space_before_token = !1 : $ !== "," && this.indent(), this.print_string(this._ch)), this.eatWhitespace(!0), this._output.add_new_line();
              else if (this._ch === "}") this.outdent(), this._output.add_new_line(), $ === "{" && this._output.trim(!0), ne && (this.outdent(), ne = !1), this.print_string(this._ch), K = !1, this._nestedLevel && this._nestedLevel--, this.eatWhitespace(!0), this._output.add_new_line(), this._options.newline_between_rules && !this._output.just_added_blankline() && this._input.peek() !== "}" && this._output.add_new_line(!0), this._input.peek() === ")" && (this._output.trim(!0), this._options.brace_style === "expand" && this._output.add_new_line(!0));
              else if (this._ch === ":") {
                for (var ae = 0; ae < this.NON_SEMICOLON_NEWLINE_PROPERTY.length; ae++) if (this._input.lookBack(this.NON_SEMICOLON_NEWLINE_PROPERTY[ae])) {
                  q = !0;
                  break;
                }
                !K && !J || this._input.lookBack("&") || this.foundNestedPseudoClass() || this._input.lookBack("(") || L || V !== 0 ? (this._input.lookBack(" ") && (this._output.space_before_token = !0), this._input.peek() === ":" ? (this._ch = this._input.next(), this.print_string("::")) : this.print_string(":")) : (this.print_string(":"), ne || (this._output.space_before_token = ne = !0, this.eatWhitespace(!0), this.indent()));
              } else this._ch === '"' || this._ch === "'" ? (this.preserveSingleSpace($ === '"' || $ === "'" || ce), this.print_string(this._ch + this.eatString(this._ch)), this.eatWhitespace(!0)) : this._ch === ";" ? (q = !1, V === 0 ? (ne && (this.outdent(), ne = !1), L = !1, this.print_string(this._ch), this.eatWhitespace(!0), this._input.peek() !== "/" && this._output.add_new_line()) : (this.print_string(this._ch), this.eatWhitespace(!0), this._output.space_before_token = !0)) : this._ch === "(" ? this._input.lookBack("url") ? (this.print_string(this._ch), this.eatWhitespace(), V++, this.indent(), this._ch = this._input.next(), this._ch === ")" || this._ch === '"' || this._ch === "'" ? this._input.back() : this._ch && (this.print_string(this._ch + this.eatString(")")), V && (V--, this.outdent()))) : (te = !1, this._input.lookBack("with") && (te = !0), this.preserveSingleSpace(ce || te), this.print_string(this._ch), ne && $ === "$" && this._options.selector_separator_newline ? (this._output.add_new_line(), z = !0) : (this.eatWhitespace(), V++, this.indent())) : this._ch === ")" ? (V && (V--, this.outdent()), z && this._input.peek() === ";" && this._options.selector_separator_newline && (z = !1, this.outdent(), this._output.add_new_line()), this.print_string(this._ch)) : this._ch === "," ? (this.print_string(this._ch), this.eatWhitespace(!0), !this._options.selector_separator_newline || ne && !z || V !== 0 || L ? this._output.space_before_token = !0 : this._output.add_new_line()) : this._ch !== ">" && this._ch !== "+" && this._ch !== "~" || ne || V !== 0 ? this._ch === "]" ? this.print_string(this._ch) : this._ch === "[" ? (this.preserveSingleSpace(ce), this.print_string(this._ch)) : this._ch === "=" ? (this.eatWhitespace(), this.print_string("="), j.test(this._ch) && (this._ch = "")) : this._ch !== "!" || this._input.lookBack("\\") ? (this.preserveSingleSpace($ === '"' || $ === "'" || ce), this.print_string(this._ch), !this._output.just_added_newline() && this._input.peek() === `
` && q && this._output.add_new_line()) : (this._output.space_before_token = !0, this.print_string(this._ch)) : this._options.space_around_combinator ? (this._output.space_before_token = !0, this.print_string(this._ch), this._output.space_before_token = !0) : (this.print_string(this._ch), this.eatWhitespace(), this._ch && j.test(this._ch) && (this._ch = ""));
              return this._output.get_code(Y);
            }, b.exports.Beautifier = H;
          }, function(b, v, E) {
            var C = E(6).Options;
            function y(T) {
              C.call(this, T, "css"), this.selector_separator_newline = this._get_boolean("selector_separator_newline", !0), this.newline_between_rules = this._get_boolean("newline_between_rules", !0), T = this._get_boolean("space_around_selector_separator"), this.space_around_combinator = this._get_boolean("space_around_combinator") || T;
              var A = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
              this.brace_style = "collapse";
              for (var k = 0; k < A.length; k++) A[k] !== "expand" ? this.brace_style = "collapse" : this.brace_style = A[k];
            }
            y.prototype = new C(), b.exports.Options = y;
          }], g = {}, _ = function b(v) {
            var E = g[v];
            return E !== void 0 || (E = g[v] = { exports: {} }, p[v](E, E.exports, b)), E.exports;
          }(15);
          f = _;
        })();
        var h = f;
        (l = (function() {
          return { css_beautify: h };
        }).apply(s, [])) === void 0 || (a.exports = l);
      })();
    }, function(a, s, r) {
      var l = r(370);
      function d(h, p) {
        return l(h[1], p[1]);
      }
      function f(h, p) {
        return h[1] > p[1] ? 1 : -1;
      }
      a.exports = function(p, g) {
        switch (g) {
          case "natural":
            return p.sort(d);
          case "standard":
            return p.sort(f);
          case "none":
          case !1:
            return p;
        }
      };
    }, function(a, s, r) {
      var l = r(83).Spaces, d = r(16), f = r(84), h = /[\s"'][iI]\s*\]/, p = /([\d\w])([iI])\]/g, g = /="([a-zA-Z][a-zA-Z\d\-_]+)"([iI])/g, _ = /="([a-zA-Z][a-zA-Z\d\-_]+)"(\s|\])/g, b = /^(?:(?:<!--|-->)\s*)+/, v = /='([a-zA-Z][a-zA-Z\d\-_]+)'([iI])/g, E = /='([a-zA-Z][a-zA-Z\d\-_]+)'(\s|\])/g, C = /[>\+~]/, y = /\s/;
      a.exports = function(A, k, N, j, I) {
        var B = [], U = [];
        function H($, te) {
          return I.push("HTML comment '" + te + "' at " + f($[2][0]) + ". Removing."), "";
        }
        for (var Q = 0, Y = A.length; Q < Y; Q++) {
          var ie = A[Q], ce = ie[1];
          (function(te) {
            for (var V, K, ne = !1, J = !1, L = 0, z = te.length; L < z; L++) {
              if (K = te[L], !V) if (K == d.SINGLE_QUOTE || K == d.DOUBLE_QUOTE) J = !J;
              else {
                if (!(J || K != d.CLOSE_CURLY_BRACKET && K != d.EXCLAMATION && K != "<" && K != d.SEMICOLON)) {
                  ne = !0;
                  break;
                }
                if (!J && L === 0 && C.test(K)) {
                  ne = !0;
                  break;
                }
              }
              V = K == d.BACK_SLASH;
            }
            return ne;
          })(ce = ce.replace(b, H.bind(null, ie))) ? I.push("Invalid selector '" + ie[1] + "' at " + f(ie[2][0]) + ". Ignoring.") : (ce = function(te) {
            return te.indexOf("'") == -1 && te.indexOf('"') == -1 ? te : te.replace(v, "=$1 $2").replace(E, "=$1$2").replace(g, "=$1 $2").replace(_, "=$1$2");
          }(ce = function(te, V) {
            for (var K, ne, J, L, z, ee, q, X, oe, ae, _e, ve = [], Ee = 0, we = !1, ze = !1, Ie = h.test(te), je = V && V.spaces[l.AroundSelectorRelation], qe = 0, Ge = te.length; qe < Ge; qe++) {
              if (ne = (K = te[qe]) == d.NEW_LINE_NIX, J = K == d.NEW_LINE_NIX && te[qe - 1] == d.CARRIAGE_RETURN, ee = q || X, ae = !oe && !L && Ee === 0 && C.test(K), _e = y.test(K), z && ee && J) ve.pop(), ve.pop();
              else if (L && ee && ne) ve.pop();
              else if (L) ve.push(K);
              else if (K != d.OPEN_SQUARE_BRACKET || ee) if (K != d.CLOSE_SQUARE_BRACKET || ee) if (K != d.OPEN_ROUND_BRACKET || ee) if (K != d.CLOSE_ROUND_BRACKET || ee) if (K != d.SINGLE_QUOTE || ee) if (K != d.DOUBLE_QUOTE || ee) if (K == d.SINGLE_QUOTE && ee) ve.push(K), q = !1;
              else if (K == d.DOUBLE_QUOTE && ee) ve.push(K), X = !1;
              else {
                if (_e && we && !je) continue;
                !_e && we && je ? (ve.push(d.SPACE), ve.push(K)) : _e && (oe || 0 < Ee) && !ee || _e && ze && !ee || (J || ne) && (oe || 0 < Ee) && ee || (ae && ze && !je ? (ve.pop(), ve.push(K)) : ae && !ze && je ? (ve.push(d.SPACE), ve.push(K)) : _e ? ve.push(d.SPACE) : ve.push(K));
              }
              else ve.push(K), X = !0;
              else ve.push(K), q = !0;
              else ve.push(K), Ee--;
              else ve.push(K), Ee++;
              else ve.push(K), oe = !1;
              else ve.push(K), oe = !0;
              z = L, L = K == d.BACK_SLASH, we = ae, ze = _e;
            }
            return Ie ? ve.join("").replace(p, "$1 $2]") : ve.join("");
          }(ce, j)), N && 0 < ce.indexOf("nav") && (ce = ce.replace(/\+nav(\S|$)/, "+ nav$1")), k && -1 < ce.indexOf("*+html ") || k && -1 < ce.indexOf("*:first-child+html ") || (-1 < ce.indexOf("*") && (ce = ce.replace(/\*([:#\.\[])/g, "$1").replace(/^(\:first\-child)?\+html/, "*$1+html")), -1 < U.indexOf(ce) || (ie[1] = ce, U.push(ce), B.push(ie))));
        }
        return B.length == 1 && B[0][1].length === 0 && (I.push("Empty selector '" + B[0][1] + "' at " + f(B[0][2][0]) + ". Ignoring."), B = []), B;
      };
    }, function(a, s) {
      a.exports = { ASTERISK: "asterisk", BANG: "bang", BACKSLASH: "backslash", UNDERSCORE: "underscore" };
    }, function(a, s, r) {
      var l = r(16);
      a.exports = function(f, h) {
        var p, g = l.OPEN_ROUND_BRACKET, _ = l.CLOSE_ROUND_BRACKET, b = 0, v = 0, E = 0, C = f.length, y = [];
        if (f.indexOf(h) == -1) return [f];
        if (f.indexOf(g) == -1) return f.split(h);
        for (; v < C; ) f[v] == g ? b++ : f[v] == _ && b--, b === 0 && 0 < v && v + 1 < C && f[v] == h && (y.push(f.substring(E, v)), E = v + 1), v++;
        return E < v + 1 && ((p = f.substring(E))[p.length - 1] == h && (p = p.substring(0, p.length - 1)), y.push(p)), y;
      };
    }, function(a, s, r) {
      var l = "", d = r(83).Breaks, f = r(83).Spaces, h = r(16), p = r(12);
      function g(k, N) {
        for (var j = k.store, I = 0, B = N.length; I < B; I++) j(k, N[I]), I < B - 1 && j(k, function(H) {
          return H.format ? h.COMMA + (E(H, d.BetweenSelectors) ? H.format.breakWith : l) + H.indentWith : h.COMMA;
        }(k));
      }
      function _(k, N) {
        for (var j = function(H) {
          for (var Q = H.length - 1; 0 <= Q && H[Q][0] == p.COMMENT; Q--) ;
          return Q;
        }(N), I = 0, B = N.length; I < B; I++) b(k, N, I, j);
      }
      function b(k, Q, j, I) {
        var B = k.store, U = Q[j], H = U[2], Q = H && H[0] === p.PROPERTY_BLOCK, Y = k.format ? !(!k.format.semicolonAfterLastProperty && !Q) || j < I : j < I || Q, ie = j === I;
        switch (U[0]) {
          case p.AT_RULE:
            B(k, U), B(k, A(k, d.AfterProperty, !1));
            break;
          case p.AT_RULE_BLOCK:
            g(k, U[1]), B(k, y(k, d.AfterRuleBegins, !0)), _(k, U[2]), B(k, T(k, d.AfterRuleEnds, !1, ie));
            break;
          case p.COMMENT:
            B(k, U);
            break;
          case p.PROPERTY:
            B(k, U[1]), B(k, function($) {
              return $.format ? h.COLON + (C($, f.BeforeValue) ? h.SPACE : l) : h.COLON;
            }(k)), H && v(k, U), B(k, Y ? A(k, d.AfterProperty, ie) : l);
            break;
          case p.RAW:
            B(k, U);
        }
      }
      function v(k, N) {
        var j, I, B = k.store;
        if (N[2][0] == p.PROPERTY_BLOCK) B(k, y(k, d.AfterBlockBegins, !1)), _(k, N[2][1]), B(k, T(k, d.AfterBlockEnds, !1, !0));
        else for (j = 2, I = N.length; j < I; j++) B(k, N[j]), j < I - 1 && (function(H) {
          return H[1][1] == "filter" || H[1][1] == "-ms-filter";
        }(N) || !function(H, Q, Y) {
          return !H.spaceAfterClosingBrace && function(ce) {
            return ce[1][1] == "background" || ce[1][1] == "transform" || ce[1][1] == "src";
          }(Q) && function(ce, $) {
            return ce[$][1][ce[$][1].length - 1] == h.CLOSE_ROUND_BRACKET;
          }(Q, Y) || function(ce, $) {
            return ce[$ + 1] && ce[$ + 1][1] == h.FORWARD_SLASH;
          }(Q, Y) || function(ce, $) {
            return ce[$][1] == h.FORWARD_SLASH;
          }(Q, Y) || function(ce, $) {
            return ce[$ + 1] && ce[$ + 1][1] == h.COMMA;
          }(Q, Y) || function(ce, $) {
            return ce[$][1] == h.COMMA;
          }(Q, Y);
        }(k, N, j)) && B(k, h.SPACE);
      }
      function E(k, N) {
        return k.format && k.format.breaks[N];
      }
      function C(k, N) {
        return k.format && k.format.spaces[N];
      }
      function y(k, N, j) {
        return k.format ? (k.indentBy += k.format.indentBy, k.indentWith = k.format.indentWith.repeat(k.indentBy), (j && C(k, f.BeforeBlockBegins) ? h.SPACE : l) + h.OPEN_CURLY_BRACKET + (E(k, N) ? k.format.breakWith : l) + k.indentWith) : h.OPEN_CURLY_BRACKET;
      }
      function T(k, N, j, I) {
        return k.format ? (k.indentBy -= k.format.indentBy, k.indentWith = k.format.indentWith.repeat(k.indentBy), (E(k, d.AfterProperty) || j && E(k, d.BeforeBlockEnds) ? k.format.breakWith : l) + k.indentWith + h.CLOSE_CURLY_BRACKET + (I ? l : (E(k, N) ? k.format.breakWith : l) + k.indentWith)) : h.CLOSE_CURLY_BRACKET;
      }
      function A(k, N, j) {
        return k.format ? h.SEMICOLON + (j || !E(k, N) ? l : k.format.breakWith + k.indentWith) : h.SEMICOLON;
      }
      a.exports = { all: function k(N, j) {
        for (var I, B, U = N.store, H = 0, Q = j.length; H < Q; H++) switch (B = H == Q - 1, (I = j[H])[0]) {
          case p.AT_RULE:
            U(N, I), U(N, A(N, d.AfterAtRule, B));
            break;
          case p.AT_RULE_BLOCK:
            g(N, I[1]), U(N, y(N, d.AfterRuleBegins, !0)), _(N, I[2]), U(N, T(N, d.AfterRuleEnds, !1, B));
            break;
          case p.NESTED_BLOCK:
            g(N, I[1]), U(N, y(N, d.AfterBlockBegins, !0)), k(N, I[2]), U(N, T(N, d.AfterBlockEnds, !0, B));
            break;
          case p.COMMENT:
            U(N, I), U(N, E(N, d.AfterComment) ? N.format.breakWith : l);
            break;
          case p.RAW:
            U(N, I);
            break;
          case p.RULE:
            g(N, I[1]), U(N, y(N, d.AfterRuleBegins, !0)), _(N, I[2]), U(N, T(N, d.AfterRuleEnds, !1, B));
        }
      }, body: _, property: b, rules: g, value: v };
    }, function(a, s, r) {
      var l = r(34), d = r(188);
      a.exports = function(h, p, g) {
        for (var _, b, v, E = h.length - 1; 0 <= E; E--) {
          var C = h[E], y = l[C.name];
          if (y && y.shorthand) {
            C.shorthand = !0, C.dirty = !0;
            try {
              if (C.components = y.breakUp(C, l, p), y.shorthandComponents) for (b = 0, v = C.components.length; b < v; b++) (_ = C.components[b]).components = l[_.name].breakUp(_, l, p);
            } catch (T) {
              if (!(T instanceof d)) throw T;
              C.components = [], g.push(T.message);
            }
            0 < C.components.length ? C.multiplex = C.components[0].multiplex : C.unused = !0;
          }
        }
      };
    }, function(a, s, r) {
      var l = r(34);
      a.exports = function(f) {
        var h = l[f.name];
        return h && h.shorthand ? h.restore(f, l) : f.value;
      };
    }, function(a, s, r) {
      var l = r(12), d = r(14).rules, f = r(14).value;
      a.exports = function h(p) {
        var g, _, b, v, E, C = [];
        if (p[0] == l.RULE) for (g = !/[\.\+>~]/.test(d(p[1])), v = 0, E = p[2].length; v < E; v++) (b = p[2][v])[0] == l.PROPERTY && (_ = b[1][1]).length !== 0 && _.indexOf("--") !== 0 && (b = f(b, v), C.push([_, b, function(T) {
          return T == "list-style" ? T : 0 < T.indexOf("-radius") ? "border-radius" : T == "border-collapse" || T == "border-spacing" || T == "border-image" ? T : T.indexOf("border-") === 0 && /^border\-\w+\-\w+$/.test(T) ? T.match(/border\-\w+/)[0] : T.indexOf("border-") === 0 && /^border\-\w+$/.test(T) ? "border" : T.indexOf("text-") === 0 || T == "-chrome-" ? T : T.replace(/^\-\w+\-/, "").match(/([a-zA-Z]+)/)[0].toLowerCase();
        }(_), p[2][v], _ + ":" + b, p[1], g]));
        else if (p[0] == l.NESTED_BLOCK) for (v = 0, E = p[2].length; v < E; v++) C = C.concat(h(p[2][v]));
        return C;
      };
    }, function(a, s, r) {
      var l = r(23), d = l.Buffer;
      function f(p, g) {
        for (var _ in p) g[_] = p[_];
      }
      function h(p, g, _) {
        return d(p, g, _);
      }
      d.from && d.alloc && d.allocUnsafe && d.allocUnsafeSlow ? a.exports = l : (f(l, s), s.Buffer = h), f(d, h), h.from = function(p, g, _) {
        if (typeof p == "number") throw new TypeError("Argument must not be a number");
        return d(p, g, _);
      }, h.alloc = function(p, g, _) {
        if (typeof p != "number") throw new TypeError("Argument must be a number");
        return p = d(p), g !== void 0 ? typeof _ == "string" ? p.fill(g, _) : p.fill(g) : p.fill(0), p;
      }, h.allocUnsafe = function(p) {
        if (typeof p != "number") throw new TypeError("Argument must be a number");
        return d(p);
      }, h.allocUnsafeSlow = function(p) {
        if (typeof p != "number") throw new TypeError("Argument must be a number");
        return l.SlowBuffer(p);
      };
    }, function(a, s, r) {
      r = r(421), a.exports = Function.prototype.bind || r;
    }, function(a, s, r) {
      var l = String.prototype.replace, d = /%20/g;
      a.exports = { default: "RFC3986", formatters: { RFC1738: function(h) {
        return l.call(h, d, "+");
      }, RFC3986: function(h) {
        return String(h);
      } }, RFC1738: "RFC1738", RFC3986: "RFC3986" };
    }, function(a, s, r) {
      var l = r(22), d = r(27), f = r(66), h = r(91), p = "http:";
      function g(_) {
        return f(_) || d.parse(p + "//" + _).host == _;
      }
      a.exports = function _(b, v, E) {
        var C, y, T, A, k, N, j = !v;
        if (E.length === 0) return !1;
        for (v && !h(b) && (b = p + b), C = v ? d.parse(b).host : b, y = v ? b : l.resolve(b), N = 0; N < E.length; N++) A = (T = E[N])[0] == "!", k = T.substring(1), j = A && v && g(k) ? j && !_(b, !0, [k]) : !A || v || g(k) ? A ? j && !0 : T == "all" || (v && T == "local" ? j || !1 : !(!v || T != "remote") || !(!v && T == "remote") && (!v && T == "local" || T === C || T === b || !(!v || y.indexOf(T) !== 0) || !v && y.indexOf(l.resolve(T)) === 0 || v != g(k) && j && !0)) : j && !_(b, !1, [k]);
        return j;
      };
    }, function(a, s, r) {
      function l(d) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        })(d);
      }
      a.exports = { clone: function d(f) {
        if (f instanceof Object) {
          var h, p = f instanceof Array ? [] : {};
          for (h in f) f.hasOwnProperty(h) && (p[h] = d(f[h]));
          return p;
        }
        return f;
      }, isPlainObject: function(f) {
        return !!f && l(f) === "object" && f.constructor === Object;
      }, shallowMerge: function(f, h) {
        if (f instanceof Object && h instanceof Object) for (var p in h) h.hasOwnProperty(p) && (f[p] = h[p]);
        return f;
      } };
    }, function(a, s, r) {
      a.exports = { join: function(d) {
        return 0 < d.length ? d.join("/") + "/" : "";
      }, resolveDotSegments: function(d) {
        var f = [];
        return d.forEach(function(h) {
          h !== ".." ? h !== "." && f.push(h) : 0 < f.length && f.splice(f.length - 1, 1);
        }), f;
      } };
    }, function(a, s, r) {
      (function(l) {
        function d(Y) {
          return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ie) {
            return typeof ie;
          } : function(ie) {
            return ie && typeof Symbol == "function" && ie.constructor === Symbol && ie !== Symbol.prototype ? "symbol" : typeof ie;
          })(Y);
        }
        function f(Y) {
          return function(ce) {
            if (Array.isArray(ce)) return h(ce);
          }(Y) || function(ce) {
            if (typeof Symbol < "u" && ce[Symbol.iterator] != null || ce["@@iterator"] != null) return Array.from(ce);
          }(Y) || function(ce, $) {
            if (ce) {
              if (typeof ce == "string") return h(ce, $);
              var te = Object.prototype.toString.call(ce).slice(8, -1);
              return (te = te === "Object" && ce.constructor ? ce.constructor.name : te) === "Map" || te === "Set" ? Array.from(ce) : te === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(te) ? h(ce, $) : void 0;
            }
          }(Y) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }
        function h(Y, ie) {
          (ie == null || ie > Y.length) && (ie = Y.length);
          for (var ce = 0, $ = new Array(ie); ce < ie; ce++) $[ce] = Y[ce];
          return $;
        }
        function p(Y, ie) {
          var ce, $ = Object.keys(Y);
          return Object.getOwnPropertySymbols && (ce = Object.getOwnPropertySymbols(Y), ie && (ce = ce.filter(function(te) {
            return Object.getOwnPropertyDescriptor(Y, te).enumerable;
          })), $.push.apply($, ce)), $;
        }
        function g(Y) {
          for (var ie = 1; ie < arguments.length; ie++) {
            var ce = arguments[ie] != null ? arguments[ie] : {};
            ie % 2 ? p(Object(ce), !0).forEach(function($) {
              (function(V, K, ne) {
                (K = function(L) {
                  return L = function(ee, q) {
                    if (d(ee) != "object" || !ee) return ee;
                    var X = ee[Symbol.toPrimitive];
                    if (X === void 0) return (q === "string" ? String : Number)(ee);
                    if (d(q = X.call(ee, q || "default")) != "object") return q;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }(L, "string"), d(L) == "symbol" ? L : String(L);
                }(K)) in V ? Object.defineProperty(V, K, { value: ne, enumerable: !0, configurable: !0, writable: !0 }) : V[K] = ne;
              })(Y, $, ce[$]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(ce)) : p(Object(ce)).forEach(function($) {
              Object.defineProperty(Y, $, Object.getOwnPropertyDescriptor(ce, $));
            });
          }
          return Y;
        }
        var _ = r(1).default;
        Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function Y(ie) {
          var ce = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, $ = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : [], te = (ee = ce.addEmptyAttributes) === void 0 || ee, V = (J = ce.components) === void 0 ? {} : J, K = (ee = ce.convertBooleans) === void 0 || ee, ne = (J = ce.keepComments) === void 0 || J, J = (ee = ce.filePath) === void 0 ? "." : ee, L = (ee = ce.actualPath) === void 0 ? "." : ee, z = (ee = ce.ignoreIncludes) !== void 0 && ee, ee = (ee = ce.preprocessors) === void 0 ? [] : ee, q = (0, b.default)((0, E.default)(function(Ge) {
            return Ge.endingTag;
          }), (0, v.default)(function(Ge) {
            return Ge.getTagName();
          }))(g({}, V)), X = l.cwd();
          if (U && J) try {
            X = N.default.lstatSync(J).isDirectory() ? J : k.default.dirname(J);
          } catch {
            throw new Error("Specified filePath does not exist");
          }
          var oe = null, ae = null;
          $.length;
          function _e(Ge, Ze) {
            return (0, C.default)(Ze.children, { tagName: Ge });
          }
          function ve(Ge, Ze, tt) {
            var Qe, ke = k.default.resolve(X, Ge);
            try {
              Qe = N.default.readFileSync(ke, "utf8");
            } catch {
              return ke = { line: tt, file: Ge, absoluteFilePath: k.default.resolve(X, L), parent: ae, tagName: "mj-raw", content: "<!-- mj-include fails to read file : ".concat(Ge, " at ").concat(ke, " -->"), children: [], errors: [{ type: "include", params: { file: Ge, partialPath: ke } }] }, void ae.children.push(ke);
            }
            Ze.type !== "html" ? (Ze = Ze["css-inline"] === "inline" ? { inline: "inline" } : {}, Ze = { line: tt, file: Ge, absoluteFilePath: k.default.resolve(X, L), tagName: "mj-style", content: Qe, children: [], attributes: Ze }, ze.push(Ze)) : (Qe = { line: tt, file: Ge, absoluteFilePath: k.default.resolve(X, L), parent: ae, tagName: "mj-raw", content: Qe }, ae.children.push(Qe));
          }
          function Ee(Ge, Ze) {
            var pe = k.default.resolve(X, Ge), tt = ae;
            if ((0, C.default)(ae.includedIn, { file: pe })) throw new Error("Circular inclusion detected on file : ".concat(pe));
            try {
              ke = N.default.readFileSync(pe, "utf8");
            } catch {
              return Ge = { line: Ze, file: Ge, absoluteFilePath: k.default.resolve(X, L), parent: ae, tagName: "mj-raw", content: "<!-- mj-include fails to read file : ".concat(Ge, " at ").concat(pe, " -->"), children: [], errors: [{ type: "include", params: { file: Ge, partialPath: pe } }] }, void ae.children.push(Ge);
            }
            var Qe, ke = ke.indexOf("<mjml>") === -1 ? "<mjml><mj-body>".concat(ke, "</mj-body></mjml>") : ke, ke = Y(ke, g(g({}, ce), {}, { filePath: pe, actualPath: pe }), [].concat(f(ae.includedIn), [{ file: ae.absoluteFilePath, line: Ze }])), pe = function(he) {
              var Te = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : ae;
              return he.map(function(Me) {
                return g(g({}, Me), {}, { parent: Te });
              });
            };
            ke.tagName === "mjml" && (Ze = _e("mj-body", ke), ke = _e("mj-head", ke), Ze && (Qe = pe(Ze.children), ae.children = [].concat(f(ae.children), f(Qe))), ke && ((Qe = _e("mj-head", oe)) || (oe.children.push({ file: L, absoluteFilePath: k.default.resolve(X, L), parent: oe, tagName: "mj-head", children: [], includedIn: [] }), Qe = _e("mj-head", oe)), ke = pe(ke.children, Qe), Qe.children = [].concat(f(Qe.children), f(ke))), ae = tt);
          }
          var we = 0, ze = [], Ie = { startIndex: 0, endIndex: 0 }, je = H(ie), qe = new A.Parser({ onopentag: function(Ze, tt) {
            var Qe = q.indexOf(Ze) !== -1;
            if (0 < we) Qe && (we += 1);
            else {
              if (Qe && (we += 1) === 1 && (Ie.startIndex = qe.startIndex, Ie.endIndex = qe.endIndex), Qe = (0, y.default)(je, function(ke) {
                return ke <= qe.startIndex;
              }) + 1, Ze === "mj-include") return z || !U ? void 0 : tt.type === "css" || tt.type === "html" ? void ve(decodeURIComponent(tt.path), tt, Qe) : void Ee(decodeURIComponent(tt.path), Qe);
              K && (tt = (0, I.default)(tt)), tt = { file: L, absoluteFilePath: U ? k.default.resolve(X, L) : L, line: Qe, includedIn: $, parent: ae, tagName: Ze, attributes: tt, children: [] }, ae ? ae.children.push(tt) : oe = tt, ae = tt;
            }
          }, onclosetag: function(Ze) {
            var tt;
            q.indexOf(Ze) !== -1 && (--we || Q(Ie, qe) || (tt = (tt = ie.substring(Ie.endIndex + 1, qe.endIndex).trim()).substring(0, tt.lastIndexOf("</".concat(Ze)))) && (ae.content = tt.trim())), 0 < we || Ze !== "mj-include" && (ae = ae && ae.parent || null);
          }, ontext: function(Ze) {
            0 < we || Ze && Ze.trim() && ae && (ae.content = "".concat(ae && ae.content || "").concat(Ze.trim()).trim());
          }, oncomment: function(Ze) {
            0 < we || ae && ne && ae.children.push({ line: (0, y.default)(je, function(tt) {
              return tt <= qe.startIndex;
            }) + 1, tagName: "mj-raw", content: "<!-- ".concat(Ze.trim(), " -->"), includedIn: $ });
          } }, { recognizeCDATA: !0, decodeEntities: !1, recognizeSelfClosing: !0, lowerCaseAttributeNames: !1 });
          if (ie = (0, b.default)(ee)(ie), qe.write(ie), qe.end(), !(0, T.default)(oe)) throw new Error("Parsing failed. Check your mjml.");
          return (0, j.default)(oe), te && (0, B.default)(oe), ze.length && ((te = (0, C.default)(oe.children, { tagName: "mj-head" })) ? te.children ? te.children = [].concat(f(te.children), ze) : te.children = ze : oe.children.push({ file: J, line: 0, tagName: "mj-head", children: ze })), oe;
        };
        var b = _(r(139)), v = _(r(504)), E = _(r(146)), C = _(r(47)), y = _(r(505)), T = _(r(19)), A = r(599), k = _(r(22)), N = _(r(65)), j = _(r(506)), I = _(r(507)), B = _(r(509)), U = r(228), H = function(ie) {
          for (var ce = /\n/gi, $ = [0]; ce.exec(ie); ) $.push(ce.lastIndex);
          return $;
        }, Q = function(ie, ce) {
          return ie.startIndex === ce.startIndex && ie.endIndex === ce.endIndex;
        };
        a.exports = s.default;
      }).call(this, r(15));
    }, function(a, s, r) {
      var l = r(67)("flow", r(502));
      l.placeholder = r(51), a.exports = l;
    }, function(a, s, r) {
      var l = r(217), d = r(478), f = r(479), h = r(219), p = r(493), g = r(143), _ = r(494), b = r(225), v = r(226), E = r(61), C = Math.max;
      a.exports = function(T, A, k, N, j, I, $, U) {
        var H = 2 & A;
        if (!H && typeof T != "function") throw new TypeError("Expected a function");
        var Q, Y, ie = N ? N.length : 0;
        ie || (A &= -97, N = j = void 0), $ = $ === void 0 ? $ : C(E($), 0), U = U === void 0 ? U : E(U), ie -= j ? j.length : 0, 64 & A && (Q = N, Y = j, N = j = void 0);
        var ce = H ? void 0 : g(T), $ = [T, A, k, N, j, Q, Y, I, $, U];
        return ce && _($, ce), T = $[0], A = $[1], k = $[2], N = $[3], j = $[4], !(U = $[9] = $[9] === void 0 ? H ? 0 : T.length : C($[9] - ie, 0)) && 24 & A && (A &= -25), k = A && A != 1 ? A == 8 || A == 16 ? f(T, A, U) : A != 32 && A != 33 || j.length ? h.apply(void 0, $) : p(T, A, k, N) : d(T, A, k), v((ce ? l : b)(k, $), T, A);
      };
    }, function(a, s, d) {
      var l = d(82), d = d(142);
      function f(h) {
        this.__wrapped__ = h, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
      }
      f.prototype = l(d.prototype), a.exports = f.prototype.constructor = f;
    }, function(a, s) {
      a.exports = function() {
      };
    }, function(a, s, d) {
      var l = d(218), d = d(481);
      a.exports = l ? function(f) {
        return l.get(f);
      } : d;
    }, function(a, s, d) {
      var l = d(82), d = d(142);
      function f(h, p) {
        this.__wrapped__ = h, this.__actions__ = [], this.__chain__ = !!p, this.__index__ = 0, this.__values__ = void 0;
      }
      f.prototype = l(d.prototype), a.exports = f.prototype.constructor = f;
    }, function(a, s) {
      var r = "__lodash_placeholder__";
      a.exports = function(d, f) {
        for (var h = -1, p = d.length, g = 0, _ = []; ++h < p; ) {
          var b = d[h];
          b !== f && b !== r || (d[h] = r, _[g++] = h);
        }
        return _;
      };
    }, function(a, s, r) {
      var l = r(67)("filter", r(118));
      l.placeholder = r(51), a.exports = l;
    }, function(a, s, r) {
      function l(g) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
          return typeof _;
        } : function(_) {
          return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
        })(g);
      }
      var d = r(77), f = r(31), h = r(56), p = r(19);
      a.exports = function(_, b, v) {
        if (!p(v)) return !1;
        var E = l(b);
        return !!(E == "number" ? f(v) && h(b, v.length) : E == "string" && b in v) && d(v[b], _);
      };
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.escapeText = s.escapeAttribute = s.escapeUTF8 = s.escape = s.encodeXML = s.getCodePoint = s.xmlReplacer = void 0, s.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
      var l = /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
      function d(h) {
        for (var p = "", v = 0; (b = s.xmlReplacer.exec(h)) !== null; ) var g = b.index, _ = h.charCodeAt(g), b = l.get(_), v = b !== void 0 ? (p += h.substring(v, g) + b, g + 1) : (p += "".concat(h.substring(v, g), "&#x").concat((0, s.getCodePoint)(h, g).toString(16), ";"), s.xmlReplacer.lastIndex += +((64512 & _) == 55296));
        return p + h.substr(v);
      }
      function f(h, p) {
        return function(_) {
          for (var b, v = 0, E = ""; b = h.exec(_); ) v !== b.index && (E += _.substring(v, b.index)), E += p.get(b[0].charCodeAt(0)), v = b.index + 1;
          return E + _.substring(v);
        };
      }
      s.getCodePoint = String.prototype.codePointAt != null ? function(h, p) {
        return h.codePointAt(p);
      } : function(h, p) {
        return (64512 & h.charCodeAt(p)) == 55296 ? 1024 * (h.charCodeAt(p) - 55296) + h.charCodeAt(p + 1) - 56320 + 65536 : h.charCodeAt(p);
      }, s.encodeXML = d, s.escape = d, s.escapeUTF8 = f(/[&<>'"]/g, l), s.escapeAttribute = f(/["&\u00A0]/g, /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]])), s.escapeText = f(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
    }, function(a, s, r) {
      var l = r(69).default, d = r(243);
      a.exports = function(h) {
        return h = d(h, "string"), l(h) == "symbol" ? h : String(h);
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      function r(l) {
        return a.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(f) {
          return f.__proto__ || Object.getPrototypeOf(f);
        }, a.exports.__esModule = !0, a.exports.default = a.exports, r(l);
      }
      a.exports = r, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      function r() {
        try {
          var l = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
          }));
        } catch {
        }
        return a.exports = r = function() {
          return !!l;
        }, a.exports.__esModule = !0, (a.exports.default = a.exports)();
      }
      a.exports = r, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(98), d = r(40), f = r(72), h = r(13), p = r(31), g = r(73), _ = r(70), b = r(101), v = Object.prototype.hasOwnProperty;
      a.exports = function(C) {
        if (C == null) return !0;
        if (p(C) && (h(C) || typeof C == "string" || typeof C.splice == "function" || g(C) || b(C) || f(C))) return !C.length;
        var y, T = d(C);
        if (T == "[object Map]" || T == "[object Set]") return !C.size;
        if (_(C)) return !l(C).length;
        for (y in C) if (v.call(C, y)) return !1;
        return !0;
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return function(f) {
          return l(d(f));
        };
      };
    }, function(a, s, r) {
      (function(l) {
        function d(f) {
          return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
            return typeof h;
          } : function(h) {
            return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
          })(f);
        }
        l = (l === void 0 ? "undefined" : d(l)) == "object" && l && l.Object === Object && l, a.exports = l;
      }).call(this, r(18));
    }, function(a, s) {
      var r = Function.prototype.toString;
      a.exports = function(d) {
        if (d != null) {
          try {
            return r.call(d);
          } catch {
          }
          try {
            return d + "";
          } catch {
          }
        }
        return "";
      };
    }, function(a, s, r) {
      r = r(29)(r(17), "WeakMap"), a.exports = r;
    }, function(a, s, r) {
      a.exports = r(42);
    }, function(a, s, r) {
      var l = r(261), d = r(32);
      a.exports = function(h, p) {
        return h && l(h, p, d);
      };
    }, function(a, s, r) {
      var l = r(263), d = r(72), f = r(13), h = r(73), p = r(56), g = r(101), _ = Object.prototype.hasOwnProperty;
      a.exports = function(v, E) {
        var C, y = f(v), T = !y && d(v), A = !y && !T && h(v), k = !y && !T && !A && g(v), N = y || T || A || k, j = N ? l(v.length, String) : [], I = j.length;
        for (C in v) !E && !_.call(v, C) || N && (C == "length" || A && (C == "offset" || C == "parent") || k && (C == "buffer" || C == "byteLength" || C == "byteOffset") || p(C, I)) || j.push(C);
        return j;
      };
    }, function(a, s) {
      a.exports = function(l, d, f, h) {
        var p = -1, g = l == null ? 0 : l.length;
        for (h && g && (f = l[++p]); ++p < g; ) f = d(f, l[p], p, l);
        return f;
      };
    }, function(a, s, r) {
      var l = r(290), d = r(20);
      a.exports = function f(h, p, g, _, b) {
        return h === p || (h == null || p == null || !d(h) && !d(p) ? h != h && p != p : l(h, p, g, _, f, b));
      };
    }, function(a, s, r) {
      var l = r(291), d = r(163), f = r(294);
      a.exports = function(p, g, _, b, v, E) {
        var C = 1 & _, y = p.length;
        if (y != (A = g.length) && !(C && y < A)) return !1;
        var T = E.get(p), A = E.get(g);
        if (T && A) return T == g && A == p;
        var k = -1, N = !0, j = 2 & _ ? new l() : void 0;
        for (E.set(p, g), E.set(g, p); ++k < y; ) {
          var I, B = p[k], U = g[k];
          if ((I = b ? C ? b(U, B, k, g, p, E) : b(B, U, k, p, g, E) : I) !== void 0) {
            if (I) continue;
            N = !1;
            break;
          }
          if (j) {
            if (!d(g, function(H, Q) {
              if (!f(j, Q) && (B === H || v(B, H, _, b, E))) return j.push(Q);
            })) {
              N = !1;
              break;
            }
          } else if (B !== U && !v(B, U, _, b, E)) {
            N = !1;
            break;
          }
        }
        return E.delete(p), E.delete(g), N;
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = -1, h = l == null ? 0 : l.length; ++f < h; ) if (d(l[f], f, l)) return !0;
        return !1;
      };
    }, function(a, s, r) {
      r = r(17).Uint8Array, a.exports = r;
    }, function(a, s, r) {
      var l = r(166), d = r(107), f = r(32);
      a.exports = function(p) {
        return l(p, f, d);
      };
    }, function(a, s, r) {
      var l = r(106), d = r(13);
      a.exports = function(h, p, g) {
        return p = p(h), d(h) ? p : l(p, g(h));
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = -1, h = l == null ? 0 : l.length, p = 0, g = []; ++f < h; ) {
          var _ = l[f];
          d(_, f, l) && (g[p++] = _);
        }
        return g;
      };
    }, function(a, s) {
      a.exports = function() {
        return [];
      };
    }, function(a, s, r) {
      var l = r(19);
      a.exports = function(f) {
        return f == f && !l(f);
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return function(f) {
          return f != null && f[l] === d && (d !== void 0 || l in Object(f));
        };
      };
    }, function(a, s, f) {
      var f = f(301), l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, d = /\\(\\)?/g, f = f(function(h) {
        var p = [];
        return h.charCodeAt(0) === 46 && p.push(""), h.replace(l, function(g, _, b, v) {
          p.push(b ? v.replace(d, "$1") : _ || g);
        }), p;
      });
      a.exports = f;
    }, function(a, s, r) {
      var l = r(58), d = r(109), f = r(328), h = r(44), p = r(59), g = r(332), b = r(116), _ = r(114), b = b(function(v, E) {
        var C = {};
        if (v == null) return C;
        var y = !1;
        E = l(E, function(A) {
          return A = h(A, v), y = y || 1 < A.length, A;
        }), p(v, _(v), C), y && (C = d(C, 7, g));
        for (var T = E.length; T--; ) f(C, E[T]);
        return C;
      });
      a.exports = b;
    }, function(a, s, d) {
      var l = d(29), d = function() {
        try {
          var f = l(Object, "defineProperty");
          return f({}, "", {}), f;
        } catch {
        }
      }();
      a.exports = d;
    }, function(a, s, r) {
      var l = r(59), d = r(32);
      a.exports = function(h, p) {
        return h && l(p, d(p), h);
      };
    }, function(a, s, h) {
      var l = h(106), d = h(113), f = h(107), h = h(168), h = Object.getOwnPropertySymbols ? function(p) {
        for (var g = []; p; ) l(g, f(p)), p = d(p);
        return g;
      } : h;
      a.exports = h;
    }, function(a, s, p) {
      var l = p(30), d = p(113), f = p(20), h = Function.prototype, p = Object.prototype, g = h.toString, _ = p.hasOwnProperty, b = g.call(Object);
      a.exports = function(E) {
        return !(!f(E) || l(E) != "[object Object]") && ((E = d(E)) === null || typeof (E = _.call(E, "constructor") && E.constructor) == "function" && E instanceof E && g.call(E) == b);
      };
    }, function(a, s, r) {
      var l = r(337), l = r(178)(l);
      a.exports = l;
    }, function(a, s) {
      var r = Date.now;
      a.exports = function(d) {
        var f = 0, h = 0;
        return function() {
          var p = r(), g = 16 - (p - h);
          if (h = p, 0 < g) {
            if (800 <= ++f) return arguments[0];
          } else f = 0;
          return d.apply(void 0, arguments);
        };
      };
    }, function(a, s, r) {
      var l = r(343);
      a.exports = function(f) {
        return f ? (f = l(f)) !== 1 / 0 && f !== -1 / 0 ? f == f ? f : 0 : 17976931348623157e292 * (f < 0 ? -1 : 1) : f === 0 ? f : 0;
      };
    }, function(a, s) {
      var r = {}.toString;
      a.exports = Array.isArray || function(l) {
        return r.call(l) == "[object Array]";
      };
    }, function(a, s, r) {
      var l;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.replaceCodePoint = s.fromCodePoint = void 0;
      var d = /* @__PURE__ */ new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
      function f(h) {
        var p;
        return 55296 <= h && h <= 57343 || 1114111 < h ? 65533 : (p = d.get(h)) !== null && p !== void 0 ? p : h;
      }
      s.fromCodePoint = (l = String.fromCodePoint) !== null && l !== void 0 ? l : function(h) {
        var p = "";
        return 65535 < h && (h -= 65536, p += String.fromCharCode(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), p + String.fromCharCode(h);
      }, s.replaceCodePoint = f, s.default = function(p) {
        return (0, s.fromCodePoint)(f(p));
      };
    }, function(a, s, r) {
      r(121)("lex"), a.exports = function(d) {
        var f, h, p, g, _ = "", b = 0, v = -1, E = 0, C = 1, y = "before-selector", T = [y], A = {}, k = [], N = ["media", "keyframes", { name: "-webkit-keyframes", type: "keyframes", prefix: "-webkit-" }, { name: "-moz-keyframes", type: "keyframes", prefix: "-moz-" }, { name: "-ms-keyframes", type: "keyframes", prefix: "-ms-" }, { name: "-o-keyframes", type: "keyframes", prefix: "-o-" }, "font-face", { name: "import", state: "before-at-value" }, { name: "charset", state: "before-at-value" }, "supports", "viewport", { name: "namespace", state: "before-at-value" }, "document", { name: "-moz-document", type: "document", prefix: "-moz-" }, "page"];
        function j(V) {
          return V ? T[T.length - 1 - V] : y;
        }
        function I(V) {
          return d[v + (V || 1)];
        }
        function B() {
          var V = T.pop();
          return y = T[T.length - 1], V;
        }
        function U(V) {
          return y = V, T.push(y), T.length;
        }
        function H(V) {
          var K = y;
          return T[T.length - 1] = y = V, K;
        }
        function Q(V) {
          var K;
          (V || 1) == 1 ? (d[v] == `
` ? (C++, b = 1) : b++, v++) : (1 < (K = d.slice(v, v + V).split(`
`)).length && (C += K.length - 1, b = 1), b += K[K.length - 1].length, v += V);
        }
        function Y() {
          A.end = { line: C, col: b }, k.push(A), _ = "", A = {};
        }
        function ie(V) {
          A = { type: V, start: { line: C, col: b } };
        }
        for (; f = function() {
          return Q(), d[v];
        }(); ) switch (f) {
          case " ":
            switch (j()) {
              case "selector":
              case "value":
              case "value-paren":
              case "at-group":
              case "at-value":
              case "comment":
              case "double-string":
              case "single-string":
                _ += f;
            }
            break;
          case `
`:
          case "	":
          case "\r":
          case "\f":
            switch (j()) {
              case "value":
              case "value-paren":
              case "at-group":
              case "comment":
              case "single-string":
              case "double-string":
              case "selector":
                _ += f;
                break;
              case "at-value":
                f === `
` && (A.value = _.trim(), Y(), B());
            }
            break;
          case ":":
            switch (j()) {
              case "name":
                A.name = _.trim(), _ = "", H("before-value");
                break;
              case "before-selector":
                _ += f, ie("selector"), U("selector");
                break;
              case "before-value":
                H("value"), _ += f;
                break;
              default:
                _ += f;
            }
            break;
          case ";":
            switch (j()) {
              case "name":
              case "before-value":
              case "value":
                0 < _.trim().length && (A.value = _.trim(), Y()), H("before-name");
                break;
              case "value-paren":
                _ += f;
                break;
              case "at-value":
                A.value = _.trim(), Y(), B();
                break;
              case "before-name":
                break;
              default:
                _ += f;
            }
            break;
          case "{":
            switch (j()) {
              case "selector":
                if (I(-1) === "\\") {
                  _ += f;
                  break;
                }
                A.text = _.trim(), Y(), H("before-name"), E += 1;
                break;
              case "at-group":
                switch (A.name = _.trim(), A.type) {
                  case "font-face":
                  case "viewport":
                  case "page":
                    U("before-name");
                    break;
                  default:
                    U("before-selector");
                }
                Y(), E += 1;
                break;
              case "name":
              case "at-rule":
                A.name = _.trim(), Y(), U("before-name"), E += 1;
                break;
              case "comment":
              case "double-string":
              case "single-string":
                _ += f;
                break;
              case "before-value":
                H("value"), _ += f;
            }
            break;
          case "}":
            switch (j()) {
              case "before-name":
              case "name":
              case "before-value":
              case "value":
                _ && (A.value = _.trim()), A.name && A.value && Y(), ie("end"), Y(), B(), j() === "at-group" && (ie("at-group-end"), Y(), B()), 0 < E && --E;
                break;
              case "at-group":
              case "before-selector":
              case "selector":
                if (I(-1) === "\\") {
                  _ += f;
                  break;
                }
                0 < E && j(1) === "at-group" && (ie("at-group-end"), Y()), 1 < E && B(), 0 < E && --E;
                break;
              case "double-string":
              case "single-string":
              case "comment":
                _ += f;
            }
            break;
          case '"':
          case "'":
            switch (j()) {
              case "double-string":
                f === '"' && I(-1) !== "\\" && B();
                break;
              case "single-string":
                f === "'" && I(-1) !== "\\" && B();
                break;
              case "before-at-value":
                H("at-value"), U(f === '"' ? "double-string" : "single-string");
                break;
              case "before-value":
                H("value"), U(f === '"' ? "double-string" : "single-string");
                break;
              case "comment":
                break;
              default:
                I(-1) !== "\\" && U(f === '"' ? "double-string" : "single-string");
            }
            _ += f;
            break;
          case "/":
            switch (j()) {
              case "comment":
              case "double-string":
              case "single-string":
                _ += f;
                break;
              case "before-value":
              case "selector":
              case "name":
              case "value":
                I(1) === "*" ? (g = function(K) {
                  return 0 < (K = d.slice(v).indexOf(K)) && K;
                }("*/")) && Q(g + 1) : (j() == "before-value" && H("value"), _ += f);
                break;
              default:
                I(1) === "*" ? (ie("comment"), U("comment"), Q()) : _ += f;
            }
            break;
          case "*":
            switch (j()) {
              case "comment":
                I(1) === "/" ? (A.text = _, Q(), Y(), B()) : _ += f;
                break;
              case "before-selector":
                _ += f, ie("selector"), U("selector");
                break;
              case "before-value":
                H("value"), _ += f;
                break;
              default:
                _ += f;
            }
            break;
          case "@":
            switch (j()) {
              case "comment":
              case "double-string":
              case "single-string":
                _ += f;
                break;
              case "before-value":
                H("value"), _ += f;
                break;
              default:
                for (var ce = !1, $ = 0, te = N.length; !ce && $ < te; ++$) !function(K) {
                  var ne = v + 1;
                  return K === d.slice(ne, ne + K.length);
                }(h = (p = N[$]).name || p) || (ce = !0, ie(h), U(p.state || "at-group"), Q(h.length), p.prefix && (A.prefix = p.prefix), p.type && (A.type = p.type));
                ce || (_ += f);
            }
            break;
          case "(":
            switch (j()) {
              case "value":
                U("value-paren");
                break;
              case "before-value":
                H("value");
            }
            _ += f;
            break;
          case ")":
            switch (j()) {
              case "value-paren":
                B();
                break;
              case "before-value":
                H("value");
            }
            _ += f;
            break;
          default:
            switch (j()) {
              case "before-selector":
                ie("selector"), U("selector");
                break;
              case "before-name":
                ie("property"), H("name");
                break;
              case "before-value":
                H("value");
                break;
              case "before-at-value":
                H("at-value");
            }
            _ += f;
        }
        return k;
      };
    }, function(a, s, r) {
      r = [r(122), r(123), r(361)], (r = (function(d, f, h) {
        function p(g, _) {
          return d.js_beautify(g, _);
        }
        return p.js = d.js_beautify, p.css = f.css_beautify, p.html = h.html_beautify, p.js_beautify = d.js_beautify, p.css_beautify = f.css_beautify, p.html_beautify = h.html_beautify, p;
      }).apply(s, r)) === void 0 || (a.exports = r);
    }, function(a, s) {
      a.exports = function(l) {
        for (var d = l.length - 1; 0 <= d; d--) {
          var f = l[d];
          f.unused && f.all.splice(f.position, 1);
        }
      };
    }, function(a, s, r) {
      function l(_) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
          return typeof b;
        } : function(b) {
          return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
        })(_);
      }
      var d = r(48), f = /^\d+$/, h = ["*", "all"], p = "off";
      function g(_) {
        return { ch: _, cm: _, em: _, ex: _, in: _, mm: _, pc: _, pt: _, px: _, q: _, rem: _, vh: _, vmax: _, vmin: _, vw: _, "%": _ };
      }
      a.exports = { DEFAULT: p, roundingPrecisionFrom: function(b) {
        return d(g(p), function(E) {
          return E == null || typeof E == "boolean" ? {} : typeof E == "number" && E == -1 ? g(p) : typeof E == "number" ? g(E) : typeof E == "string" && f.test(E) ? g(parseInt(E)) : typeof E != "string" || E != p ? l(E) != "object" ? E.split(",").reduce(function(C, T) {
            var T = (A = T.split("="))[0], A = parseInt(A[1]);
            return !isNaN(A) && A != -1 || (A = p), -1 < h.indexOf(T) ? C = d(C, g(A)) : C[T] = A, C;
          }, {}) : E : g(p);
        }(b));
      } };
    }, function(a, s, r) {
      var l = r(16);
      a.exports = function(f, h, p) {
        for (var g, _, b = h.value.length, v = p.value.length, E = Math.max(b, v), C = Math.min(b, v) - 1, y = 0; y < E; y++) if (g = h.value[y] && h.value[y][1] || g, _ = p.value[y] && p.value[y][1] || _, g != l.COMMA && _ != l.COMMA && !f(g, _, y, y <= C)) return !1;
        return !0;
      };
    }, function(a, s) {
      a.exports = function(l) {
        for (var d = l.value.length - 1; 0 <= d; d--) if (l.value[d][1] == "inherit") return !0;
        return !1;
      };
    }, function(a, s) {
      function r(l) {
        this.name = "InvalidPropertyError", this.message = l, this.stack = new Error().stack;
      }
      r.prototype = Object.create(Error.prototype), a.exports = r.prototype.constructor = r;
    }, function(a, s) {
      var r = /(?:^|\W)(\-\w+\-)/g;
      function l(d) {
        for (var f, h = []; (f = r.exec(d)) !== null; ) h.indexOf(f[0]) == -1 && h.push(f[0]);
        return h;
      }
      a.exports = { unique: l, same: function(f, h) {
        return l(f).sort().join(",") == l(h).sort().join(",");
      } };
    }, function(a, s) {
      var r = /\-\-.+$/;
      function l(d) {
        return d.replace(r, "");
      }
      a.exports = function(f, h, p) {
        for (var g, _, b, v, E = 0, C = f.length; E < C; E++) for (g = f[E][1], b = 0, v = h.length; b < v; b++)
          if (g == (_ = h[b][1]) || p && l(g) == l(_)) return !0;
        return !1;
      };
    }, function(a, s) {
      a.exports = function r(l) {
        for (var d = l.slice(0), f = 0, h = d.length; f < h; f++) Array.isArray(d[f]) && (d[f] = r(d[f]));
        return d;
      };
    }, function(a, s, r) {
      (function(l) {
        var d = r(402), f = r(194), h = r(412), p = r(413), g = r(27), _ = s;
        _.request = function(b, v) {
          b = typeof b == "string" ? g.parse(b) : h(b);
          var T = l.location.protocol.search(/^https?:$/) === -1 ? "http:" : "", E = b.protocol || T, C = b.hostname || b.host, y = b.port, T = b.path || "/";
          return C && C.indexOf(":") !== -1 && (C = "[" + C + "]"), b.url = (C ? E + "//" + C : "") + (y ? ":" + y : "") + T, b.method = (b.method || "GET").toUpperCase(), b.headers = b.headers || {}, b = new d(b), v && b.on("response", v), b;
        }, _.get = function(v, E) {
          return (E = _.request(v, E)).end(), E;
        }, _.ClientRequest = d, _.IncomingMessage = f.IncomingMessage, _.Agent = function() {
        }, _.Agent.defaultMaxSockets = 4, _.globalAgent = new _.Agent(), _.STATUS_CODES = p, _.METHODS = ["CHECKOUT", "CONNECT", "COPY", "DELETE", "GET", "HEAD", "LOCK", "M-SEARCH", "MERGE", "MKACTIVITY", "MKCOL", "MOVE", "NOTIFY", "OPTIONS", "PATCH", "POST", "PROPFIND", "PROPPATCH", "PURGE", "PUT", "REPORT", "SEARCH", "SUBSCRIBE", "TRACE", "UNLOCK", "UNSUBSCRIBE"];
      }).call(this, r(18));
    }, function(a, s, r) {
      (function(l) {
        s.fetch = _(l.fetch) && _(l.ReadableStream), s.writableStream = _(l.WritableStream), s.abortController = _(l.AbortController), s.blobConstructor = !1;
        try {
          new Blob([new ArrayBuffer(1)]), s.blobConstructor = !0;
        } catch {
        }
        var d;
        function f() {
          if (d !== void 0) return d;
          if (l.XMLHttpRequest) {
            d = new l.XMLHttpRequest();
            try {
              d.open("GET", l.XDomainRequest ? "/" : "https://example.com");
            } catch {
              d = null;
            }
          } else d = null;
          return d;
        }
        function h(b) {
          var v = f();
          if (!v) return !1;
          try {
            return v.responseType = b, v.responseType === b;
          } catch {
          }
          return !1;
        }
        var p = l.ArrayBuffer !== void 0, g = p && _(l.ArrayBuffer.prototype.slice);
        function _(b) {
          return typeof b == "function";
        }
        s.arraybuffer = s.fetch || p && h("arraybuffer"), s.msstream = !s.fetch && g && h("ms-stream"), s.mozchunkedarraybuffer = !s.fetch && p && h("moz-chunked-arraybuffer"), s.overrideMimeType = s.fetch || !!f() && _(f().overrideMimeType), s.vbArray = _(l.VBArray), d = null;
      }).call(this, r(18));
    }, function(a, s, r) {
      (function(l, d, f) {
        var h = r(193), p = r(35), g = r(195), _ = s.readyStates = { UNSENT: 0, OPENED: 1, HEADERS_RECEIVED: 2, LOADING: 3, DONE: 4 }, b = s.IncomingMessage = function(v, E, C, y) {
          var T = this;
          if (g.Readable.call(T), T._mode = C, T.headers = {}, T.rawHeaders = [], T.trailers = {}, T.rawTrailers = [], T.on("end", function() {
            l.nextTick(function() {
              T.emit("close");
            });
          }), C === "fetch") {
            if (T._fetchResponse = E, T.url = E.url, T.statusCode = E.status, T.statusMessage = E.statusText, E.headers.forEach(function(k, N) {
              T.headers[N.toLowerCase()] = k, T.rawHeaders.push(N, k);
            }), h.writableStream) {
              C = new WritableStream({ write: function(N) {
                return new Promise(function(j, I) {
                  T._destroyed ? I() : T.push(new f(N)) ? j() : T._resumeFetch = j;
                });
              }, close: function() {
                d.clearTimeout(y), T._destroyed || T.push(null);
              }, abort: function(N) {
                T._destroyed || T.emit("error", N);
              } });
              try {
                return void E.body.pipeTo(C).catch(function(k) {
                  d.clearTimeout(y), T._destroyed || T.emit("error", k);
                });
              } catch {
              }
            }
            var A = E.body.getReader();
            (function k() {
              A.read().then(function(N) {
                if (!T._destroyed) {
                  if (N.done) return d.clearTimeout(y), void T.push(null);
                  T.push(new f(N.value)), k();
                }
              }).catch(function(N) {
                d.clearTimeout(y), T._destroyed || T.emit("error", N);
              });
            })();
          } else T._xhr = v, T._pos = 0, T.url = v.responseURL, T.statusCode = v.status, T.statusMessage = v.statusText, v.getAllResponseHeaders().split(/\r?\n/).forEach(function(k) {
            var N = k.match(/^([^:]+):\s*(.*)/);
            N && ((k = N[1].toLowerCase()) === "set-cookie" ? (T.headers[k] === void 0 && (T.headers[k] = []), T.headers[k].push(N[2])) : T.headers[k] !== void 0 ? T.headers[k] += ", " + N[2] : T.headers[k] = N[2], T.rawHeaders.push(N[1], N[2]));
          }), T._charset = "x-user-defined", h.overrideMimeType || (!(v = T.rawHeaders["mime-type"]) || (v = v.match(/;\s*charset=([^;])(;|$)/)) && (T._charset = v[1].toLowerCase()), T._charset || (T._charset = "utf-8"));
        };
        p(b, g.Readable), b.prototype._read = function() {
          var v = this._resumeFetch;
          v && (this._resumeFetch = null, v());
        }, b.prototype._onXHRProgress = function() {
          var v = this, E = v._xhr, C = null;
          switch (v._mode) {
            case "text:vbarray":
              if (E.readyState !== _.DONE) break;
              try {
                C = new d.VBArray(E.responseBody).toArray();
              } catch {
              }
              if (C !== null) {
                v.push(new f(C));
                break;
              }
            case "text":
              try {
                C = E.responseText;
              } catch {
                v._mode = "text:vbarray";
                break;
              }
              if (C.length > v._pos) {
                var y = C.substr(v._pos);
                if (v._charset === "x-user-defined") {
                  for (var T = new f(y.length), A = 0; A < y.length; A++) T[A] = 255 & y.charCodeAt(A);
                  v.push(T);
                } else v.push(y, v._charset);
                v._pos = C.length;
              }
              break;
            case "arraybuffer":
              if (E.readyState !== _.DONE || !E.response) break;
              C = E.response, v.push(new f(new Uint8Array(C)));
              break;
            case "moz-chunked-arraybuffer":
              if (C = E.response, E.readyState !== _.LOADING || !C) break;
              v.push(new f(new Uint8Array(C)));
              break;
            case "ms-stream":
              if (C = E.response, E.readyState !== _.LOADING) break;
              var k = new d.MSStreamReader();
              k.onprogress = function() {
                k.result.byteLength > v._pos && (v.push(new f(new Uint8Array(k.result.slice(v._pos)))), v._pos = k.result.byteLength);
              }, k.onload = function() {
                v.push(null);
              }, k.readAsArrayBuffer(C);
          }
          v._xhr.readyState === _.DONE && v._mode !== "ms-stream" && v.push(null);
        };
      }).call(this, r(15), r(18), r(23).Buffer);
    }, function(a, s, r) {
      (((s = a.exports = r(196)).Stream = s).Readable = s).Writable = r(200), s.Duplex = r(50), s.Transform = r(202), s.PassThrough = r(410);
    }, function(a, s, r) {
      (function(A, d) {
        var f = r(89);
        a.exports = j;
        var h, p = r(180);
        function g(L, z) {
          return L.listeners(z).length;
        }
        j.ReadableState = N, r(197).EventEmitter;
        var _ = r(198), b = r(132).Buffer, v = (A !== void 0 ? A : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
        }, E = Object.create(r(63));
        E.inherits = r(35);
        var C, A = r(403), y = void 0, y = A && A.debuglog ? A.debuglog("stream") : function() {
        }, T = r(404), A = r(199);
        E.inherits(j, _);
        var k = ["error", "close", "destroy", "pause", "resume"];
        function N(L, oe) {
          var ee = oe instanceof (h = h || r(50));
          this.objectMode = !!(L = L || {}).objectMode, ee && (this.objectMode = this.objectMode || !!L.readableObjectMode);
          var q = L.highWaterMark, X = L.readableHighWaterMark, oe = this.objectMode ? 16 : 16384;
          this.highWaterMark = q || q === 0 ? q : ee && (X || X === 0) ? X : oe, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new T(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = L.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, L.encoding && (C = C || r(201).StringDecoder, this.decoder = new C(L.encoding), this.encoding = L.encoding);
        }
        function j(L) {
          if (h = h || r(50), !(this instanceof j)) return new j(L);
          this._readableState = new N(L, this), this.readable = !0, L && (typeof L.read == "function" && (this._read = L.read), typeof L.destroy == "function" && (this._destroy = L.destroy)), _.call(this);
        }
        function I(L, z, ee, q, X) {
          var oe, ae = L._readableState;
          return z === null ? (ae.reading = !1, function(ve, Ee) {
            var we;
            Ee.ended || (!Ee.decoder || (we = Ee.decoder.end()) && we.length && (Ee.buffer.push(we), Ee.length += Ee.objectMode ? 1 : we.length), Ee.ended = !0, H(ve));
          }(L, ae)) : (oe = X ? oe : function(ve, Ee) {
            var we;
            return we = !function(Ie) {
              return b.isBuffer(Ie) || Ie instanceof v;
            }(Ee) && typeof Ee != "string" && Ee !== void 0 && !ve.objectMode ? new TypeError("Invalid non-string/buffer chunk") : we;
          }(ae, z)) ? L.emit("error", oe) : ae.objectMode || z && 0 < z.length ? (typeof z == "string" || ae.objectMode || Object.getPrototypeOf(z) === b.prototype || (z = function(ve) {
            return b.from(ve);
          }(z)), q ? ae.endEmitted ? L.emit("error", new Error("stream.unshift() after end event")) : B(L, ae, z, !0) : ae.ended ? L.emit("error", new Error("stream.push() after EOF")) : (ae.reading = !1, ae.decoder && !ee ? (z = ae.decoder.write(z), ae.objectMode || z.length !== 0 ? B(L, ae, z, !1) : Y(L, ae)) : B(L, ae, z, !1))) : q || (ae.reading = !1), function(ve) {
            return !ve.ended && (ve.needReadable || ve.length < ve.highWaterMark || ve.length === 0);
          }(ae);
        }
        function B(L, z, ee, q) {
          z.flowing && z.length === 0 && !z.sync ? (L.emit("data", ee), L.read(0)) : (z.length += z.objectMode ? 1 : ee.length, q ? z.buffer.unshift(ee) : z.buffer.push(ee), z.needReadable && H(L)), Y(L, z);
        }
        Object.defineProperty(j.prototype, "destroyed", { get: function() {
          return this._readableState !== void 0 && this._readableState.destroyed;
        }, set: function(z) {
          this._readableState && (this._readableState.destroyed = z);
        } }), j.prototype.destroy = A.destroy, j.prototype._undestroy = A.undestroy, j.prototype._destroy = function(L, z) {
          this.push(null), z(L);
        }, j.prototype.push = function(L, z) {
          var ee, q = this._readableState;
          return q.objectMode ? ee = !0 : typeof L == "string" && ((z = z || q.defaultEncoding) !== q.encoding && (L = b.from(L, z), z = ""), ee = !0), I(this, L, z, !1, ee);
        }, j.prototype.unshift = function(L) {
          return I(this, L, null, !0, !1);
        }, j.prototype.isPaused = function() {
          return this._readableState.flowing === !1;
        }, j.prototype.setEncoding = function(L) {
          return C = C || r(201).StringDecoder, this._readableState.decoder = new C(L), this._readableState.encoding = L, this;
        };
        function U(L, z) {
          return L <= 0 || z.length === 0 && z.ended ? 0 : z.objectMode ? 1 : L != L ? (z.flowing && z.length ? z.buffer.head.data : z).length : (L > z.highWaterMark && (z.highWaterMark = function(q) {
            return 8388608 <= q ? q = 8388608 : (q--, q |= q >>> 1, q |= q >>> 2, q |= q >>> 4, q |= q >>> 8, q |= q >>> 16, q++), q;
          }(L)), L <= z.length ? L : z.ended ? z.length : (z.needReadable = !0, 0));
        }
        function H(L) {
          var z = L._readableState;
          z.needReadable = !1, z.emittedReadable || (y("emitReadable", z.flowing), z.emittedReadable = !0, z.sync ? f.nextTick(Q, L) : Q(L));
        }
        function Q(L) {
          y("emit readable"), L.emit("readable"), te(L);
        }
        function Y(L, z) {
          z.readingMore || (z.readingMore = !0, f.nextTick(ie, L, z));
        }
        function ie(L, z) {
          for (var ee = z.length; !z.reading && !z.flowing && !z.ended && z.length < z.highWaterMark && (y("maybeReadMore read 0"), L.read(0), ee !== z.length); ) ee = z.length;
          z.readingMore = !1;
        }
        function ce(L) {
          y("readable nexttick read 0"), L.read(0);
        }
        function $(L, z) {
          z.reading || (y("resume read 0"), L.read(0)), z.resumeScheduled = !1, z.awaitDrain = 0, L.emit("resume"), te(L), z.flowing && !z.reading && L.read(0);
        }
        function te(L) {
          var z = L._readableState;
          for (y("flow", z.flowing); z.flowing && L.read() !== null; ) ;
        }
        function V(L, z) {
          return z.length === 0 ? null : (z.objectMode ? ee = z.buffer.shift() : !L || L >= z.length ? (ee = z.decoder ? z.buffer.join("") : z.buffer.length === 1 ? z.buffer.head.data : z.buffer.concat(z.length), z.buffer.clear()) : ee = function(X, oe, ae) {
            var _e;
            return X < oe.head.data.length ? (_e = oe.head.data.slice(0, X), oe.head.data = oe.head.data.slice(X)) : _e = X === oe.head.data.length ? oe.shift() : (ae ? function(Ee, we) {
              var ze = we.head, Ie = 1, je = ze.data;
              for (Ee -= je.length; ze = ze.next; ) {
                var qe = ze.data, Ge = Ee > qe.length ? qe.length : Ee;
                if (Ge === qe.length ? je += qe : je += qe.slice(0, Ee), (Ee -= Ge) == 0) {
                  Ge === qe.length ? (++Ie, ze.next ? we.head = ze.next : we.head = we.tail = null) : (we.head = ze).data = qe.slice(Ge);
                  break;
                }
                ++Ie;
              }
              return we.length -= Ie, je;
            } : function(Ee, we) {
              var ze = b.allocUnsafe(Ee), Ie = we.head, je = 1;
              for (Ie.data.copy(ze), Ee -= Ie.data.length; Ie = Ie.next; ) {
                var qe = Ie.data, Ge = Ee > qe.length ? qe.length : Ee;
                if (qe.copy(ze, ze.length - Ee, 0, Ge), (Ee -= Ge) == 0) {
                  Ge === qe.length ? (++je, Ie.next ? we.head = Ie.next : we.head = we.tail = null) : (we.head = Ie).data = qe.slice(Ge);
                  break;
                }
                ++je;
              }
              return we.length -= je, ze;
            })(X, oe), _e;
          }(L, z.buffer, z.decoder), ee);
          var ee;
        }
        function K(L) {
          var z = L._readableState;
          if (0 < z.length) throw new Error('"endReadable()" called on non-empty stream');
          z.endEmitted || (z.ended = !0, f.nextTick(ne, z, L));
        }
        function ne(L, z) {
          L.endEmitted || L.length !== 0 || (L.endEmitted = !0, z.readable = !1, z.emit("end"));
        }
        function J(L, z) {
          for (var ee = 0, q = L.length; ee < q; ee++) if (L[ee] === z) return ee;
          return -1;
        }
        j.prototype.read = function(L) {
          y("read", L), L = parseInt(L, 10);
          var z = this._readableState, ee = L;
          if (L !== 0 && (z.emittedReadable = !1), L === 0 && z.needReadable && (z.length >= z.highWaterMark || z.ended)) return y("read: emitReadable", z.length, z.ended), (z.length === 0 && z.ended ? K : H)(this), null;
          if ((L = U(L, z)) === 0 && z.ended) return z.length === 0 && K(this), null;
          var q = z.needReadable;
          return y("need readable", q), (z.length === 0 || z.length - L < z.highWaterMark) && y("length less than watermark", q = !0), z.ended || z.reading ? y("reading or ended", q = !1) : q && (y("do read"), z.reading = !0, z.sync = !0, z.length === 0 && (z.needReadable = !0), this._read(z.highWaterMark), z.sync = !1, z.reading || (L = U(ee, z))), (q = 0 < L ? V(L, z) : null) === null ? (z.needReadable = !0, L = 0) : z.length -= L, z.length === 0 && (z.ended || (z.needReadable = !0), ee !== L && z.ended && K(this)), q !== null && this.emit("data", q), q;
        }, j.prototype._read = function(L) {
          this.emit("error", new Error("_read() is not implemented"));
        }, j.prototype.pipe = function(L, z) {
          var ee = this, q = this._readableState;
          switch (q.pipesCount) {
            case 0:
              q.pipes = L;
              break;
            case 1:
              q.pipes = [q.pipes, L];
              break;
            default:
              q.pipes.push(L);
          }
          function X() {
            y("onend"), L.end();
          }
          q.pipesCount += 1, y("pipe count=%d opts=%j", q.pipesCount, z), z = z && z.end === !1 || L === d.stdout || L === d.stderr ? Ie : X, q.endEmitted ? f.nextTick(z) : ee.once("end", z), L.on("unpipe", function je(qe, Ge) {
            y("onunpipe"), qe === ee && Ge && Ge.hasUnpiped === !1 && (Ge.hasUnpiped = !0, function() {
              y("cleanup"), L.removeListener("close", we), L.removeListener("finish", ze), L.removeListener("drain", oe), L.removeListener("error", Ee), L.removeListener("unpipe", je), ee.removeListener("end", X), ee.removeListener("end", Ie), ee.removeListener("data", ve), ae = !0, !q.awaitDrain || L._writableState && !L._writableState.needDrain || oe();
            }());
          });
          var oe = /* @__PURE__ */ function(qe) {
            return function() {
              var Ge = qe._readableState;
              y("pipeOnDrain", Ge.awaitDrain), Ge.awaitDrain && Ge.awaitDrain--, Ge.awaitDrain === 0 && g(qe, "data") && (Ge.flowing = !0, te(qe));
            };
          }(ee);
          L.on("drain", oe);
          var ae = !1, _e = !1;
          function ve(je) {
            y("ondata"), (_e = !1) !== L.write(je) || _e || ((q.pipesCount === 1 && q.pipes === L || 1 < q.pipesCount && J(q.pipes, L) !== -1) && !ae && (y("false write response, pause", q.awaitDrain), q.awaitDrain++, _e = !0), ee.pause());
          }
          function Ee(je) {
            y("onerror", je), Ie(), L.removeListener("error", Ee), g(L, "error") === 0 && L.emit("error", je);
          }
          function we() {
            L.removeListener("finish", ze), Ie();
          }
          function ze() {
            y("onfinish"), L.removeListener("close", we), Ie();
          }
          function Ie() {
            y("unpipe"), ee.unpipe(L);
          }
          return ee.on("data", ve), function(qe, Ge, Ze) {
            typeof qe.prependListener == "function" ? qe.prependListener(Ge, Ze) : qe._events && qe._events[Ge] ? p(qe._events[Ge]) ? qe._events[Ge].unshift(Ze) : qe._events[Ge] = [Ze, qe._events[Ge]] : qe.on(Ge, Ze);
          }(L, "error", Ee), L.once("close", we), L.once("finish", ze), L.emit("pipe", ee), q.flowing || (y("pipe resume"), ee.resume()), L;
        }, j.prototype.unpipe = function(L) {
          var z = this._readableState, ee = { hasUnpiped: !1 };
          if (z.pipesCount === 0) return this;
          if (z.pipesCount === 1) return L && L !== z.pipes || (L = L || z.pipes, z.pipes = null, z.pipesCount = 0, z.flowing = !1, L && L.emit("unpipe", this, ee)), this;
          if (!L) {
            var q = z.pipes, X = z.pipesCount;
            z.pipes = null, z.pipesCount = 0, z.flowing = !1;
            for (var oe = 0; oe < X; oe++) q[oe].emit("unpipe", this, { hasUnpiped: !1 });
            return this;
          }
          var ae = J(z.pipes, L);
          return ae === -1 || (z.pipes.splice(ae, 1), --z.pipesCount, z.pipesCount === 1 && (z.pipes = z.pipes[0]), L.emit("unpipe", this, ee)), this;
        }, j.prototype.addListener = j.prototype.on = function(L, z) {
          return z = _.prototype.on.call(this, L, z), L === "data" ? this._readableState.flowing !== !1 && this.resume() : L === "readable" && ((L = this._readableState).endEmitted || L.readableListening || (L.readableListening = L.needReadable = !0, L.emittedReadable = !1, L.reading ? L.length && H(this) : f.nextTick(ce, this))), z;
        }, j.prototype.resume = function() {
          var L = this._readableState;
          return L.flowing || (y("resume"), L.flowing = !0, function(ee, q) {
            q.resumeScheduled || (q.resumeScheduled = !0, f.nextTick($, ee, q));
          }(this, L)), this;
        }, j.prototype.pause = function() {
          return y("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (y("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
        }, j.prototype.wrap = function(L) {
          var z, ee = this, q = this._readableState, X = !1;
          for (z in L.on("end", function() {
            var ae;
            y("wrapped end"), !q.decoder || q.ended || (ae = q.decoder.end()) && ae.length && ee.push(ae), ee.push(null);
          }), L.on("data", function(ae) {
            y("wrapped data"), q.decoder && (ae = q.decoder.write(ae)), q.objectMode && ae == null || (q.objectMode || ae && ae.length) && (ee.push(ae) || (X = !0, L.pause()));
          }), L) this[z] === void 0 && typeof L[z] == "function" && (this[z] = /* @__PURE__ */ function(ae) {
            return function() {
              return L[ae].apply(L, arguments);
            };
          }(z));
          for (var oe = 0; oe < k.length; oe++) L.on(k[oe], this.emit.bind(this, k[oe]));
          return this._read = function(ae) {
            y("wrapped _read", ae), X && (X = !1, L.resume());
          }, this;
        }, Object.defineProperty(j.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
          return this._readableState.highWaterMark;
        } }), j._fromList = V;
      }).call(this, r(18), r(15));
    }, function(a, s, r) {
      function l(N) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        })(N);
      }
      var d = (typeof Reflect > "u" ? "undefined" : l(Reflect)) === "object" ? Reflect : null, f = d && typeof d.apply == "function" ? d.apply : function(j, I, B) {
        return Function.prototype.apply.call(j, I, B);
      }, h = d && typeof d.ownKeys == "function" ? d.ownKeys : Object.getOwnPropertySymbols ? function(j) {
        return Object.getOwnPropertyNames(j).concat(Object.getOwnPropertySymbols(j));
      } : function(j) {
        return Object.getOwnPropertyNames(j);
      }, p = Number.isNaN || function(j) {
        return j != j;
      };
      function g() {
        g.init.call(this);
      }
      a.exports = g, a.exports.once = function(j, I) {
        return new Promise(function(B, U) {
          function H(Y) {
            j.removeListener(I, Q), U(Y);
          }
          function Q() {
            typeof j.removeListener == "function" && j.removeListener("error", H), B([].slice.call(arguments));
          }
          k(j, I, Q, { once: !0 }), I !== "error" && function(ie, ce, $) {
            typeof ie.on == "function" && k(ie, "error", ce, $);
          }(j, H, { once: !0 });
        });
      }, (g.EventEmitter = g).prototype._events = void 0, g.prototype._eventsCount = 0, g.prototype._maxListeners = void 0;
      var _ = 10;
      function b(N) {
        if (typeof N != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + l(N));
      }
      function v(N) {
        return N._maxListeners === void 0 ? g.defaultMaxListeners : N._maxListeners;
      }
      function E(N, j, I, B) {
        var U, H;
        return b(I), (U = N._events) === void 0 ? (U = N._events = /* @__PURE__ */ Object.create(null), N._eventsCount = 0) : (U.newListener !== void 0 && (N.emit("newListener", j, I.listener || I), U = N._events), H = U[j]), H === void 0 ? (H = U[j] = I, ++N._eventsCount) : (typeof H == "function" ? H = U[j] = B ? [I, H] : [H, I] : B ? H.unshift(I) : H.push(I), 0 < (I = v(N)) && H.length > I && !H.warned && (H.warned = !0, (I = new Error("Possible EventEmitter memory leak detected. " + H.length + " " + String(j) + " listeners added. Use emitter.setMaxListeners() to increase limit")).name = "MaxListenersExceededWarning", I.emitter = N, I.type = j, I.count = H.length, function(Y) {
          console && console.warn && console.warn(Y);
        }(I))), N;
      }
      function C(N, j, I) {
        return (j = (function() {
          if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }).bind(N = { fired: !1, wrapFn: void 0, target: N, type: j, listener: I })).listener = I, N.wrapFn = j;
      }
      function y(N, j, I) {
        return (N = N._events) === void 0 || (j = N[j]) === void 0 ? [] : typeof j == "function" ? I ? [j.listener || j] : [j] : I ? function(U) {
          for (var H = new Array(U.length), Q = 0; Q < H.length; ++Q) H[Q] = U[Q].listener || U[Q];
          return H;
        }(j) : A(j, j.length);
      }
      function T(N) {
        var j = this._events;
        if (j !== void 0) {
          if (typeof (N = j[N]) == "function") return 1;
          if (N !== void 0) return N.length;
        }
        return 0;
      }
      function A(N, j) {
        for (var I = new Array(j), B = 0; B < j; ++B) I[B] = N[B];
        return I;
      }
      function k(N, j, I, B) {
        if (typeof N.on == "function") B.once ? N.once(j, I) : N.on(j, I);
        else {
          if (typeof N.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + l(N));
          N.addEventListener(j, function U(H) {
            B.once && N.removeEventListener(j, U), I(H);
          });
        }
      }
      Object.defineProperty(g, "defaultMaxListeners", { enumerable: !0, get: function() {
        return _;
      }, set: function(j) {
        if (typeof j != "number" || j < 0 || p(j)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + j + ".");
        _ = j;
      } }), g.init = function() {
        this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, g.prototype.setMaxListeners = function(j) {
        if (typeof j != "number" || j < 0 || p(j)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + j + ".");
        return this._maxListeners = j, this;
      }, g.prototype.getMaxListeners = function() {
        return v(this);
      }, g.prototype.emit = function(j) {
        for (var I = [], B = 1; B < arguments.length; B++) I.push(arguments[B]);
        var U, H = j === "error", Q = this._events;
        if (Q !== void 0) H = H && Q.error === void 0;
        else if (!H) return !1;
        if (H)
          throw (U = 0 < I.length ? I[0] : U) instanceof Error ? U : ((H = new Error("Unhandled error." + (U ? " (" + U.message + ")" : ""))).context = U, H);
        if ((j = Q[j]) === void 0) return !1;
        if (typeof j == "function") f(j, this, I);
        else for (var Y = j.length, ie = A(j, Y), B = 0; B < Y; ++B) f(ie[B], this, I);
        return !0;
      }, g.prototype.addListener = function(j, I) {
        return E(this, j, I, !1);
      }, g.prototype.on = g.prototype.addListener, g.prototype.prependListener = function(j, I) {
        return E(this, j, I, !0);
      }, g.prototype.once = function(j, I) {
        return b(I), this.on(j, C(this, j, I)), this;
      }, g.prototype.prependOnceListener = function(j, I) {
        return b(I), this.prependListener(j, C(this, j, I)), this;
      }, g.prototype.removeListener = function(j, I) {
        var B, U, H, Q, Y;
        if (b(I), (U = this._events) === void 0) return this;
        if ((B = U[j]) === void 0) return this;
        if (B === I || B.listener === I) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete U[j], U.removeListener && this.emit("removeListener", j, B.listener || I));
        else if (typeof B != "function") {
          for (H = -1, Q = B.length - 1; 0 <= Q; Q--) if (B[Q] === I || B[Q].listener === I) {
            Y = B[Q].listener, H = Q;
            break;
          }
          if (H < 0) return this;
          H === 0 ? B.shift() : function(ce, $) {
            for (; $ + 1 < ce.length; $++) ce[$] = ce[$ + 1];
            ce.pop();
          }(B, H), B.length === 1 && (U[j] = B[0]), U.removeListener !== void 0 && this.emit("removeListener", j, Y || I);
        }
        return this;
      }, g.prototype.off = g.prototype.removeListener, g.prototype.removeAllListeners = function(j) {
        var I, B = this._events;
        if (B === void 0) return this;
        if (B.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : B[j] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete B[j]), this;
        if (arguments.length === 0) {
          for (var U, H = Object.keys(B), Q = 0; Q < H.length; ++Q) (U = H[Q]) !== "removeListener" && this.removeAllListeners(U);
          return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
        }
        if (typeof (I = B[j]) == "function") this.removeListener(j, I);
        else if (I !== void 0) for (Q = I.length - 1; 0 <= Q; Q--) this.removeListener(j, I[Q]);
        return this;
      }, g.prototype.listeners = function(j) {
        return y(this, j, !0);
      }, g.prototype.rawListeners = function(j) {
        return y(this, j, !1);
      }, g.listenerCount = function(N, j) {
        return typeof N.listenerCount == "function" ? N.listenerCount(j) : T.call(N, j);
      }, g.prototype.listenerCount = T, g.prototype.eventNames = function() {
        return 0 < this._eventsCount ? h(this._events) : [];
      };
    }, function(a, s, r) {
      a.exports = r(197).EventEmitter;
    }, function(a, s, r) {
      var l = r(89);
      function d(f, h) {
        f.emit("error", h);
      }
      a.exports = { destroy: function(h, p) {
        var g = this, _ = this._readableState && this._readableState.destroyed, b = this._writableState && this._writableState.destroyed;
        return _ || b ? p ? p(h) : h && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, l.nextTick(d, this, h)) : l.nextTick(d, this, h)) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(h || null, function(v) {
          !p && v ? g._writableState ? g._writableState.errorEmitted || (g._writableState.errorEmitted = !0, l.nextTick(d, g, v)) : l.nextTick(d, g, v) : p && p(v);
        })), this;
      }, undestroy: function() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      } };
    }, function(a, s, r) {
      (function(l, d, T) {
        var h = r(89);
        function p(Y) {
          var ie = this;
          this.next = null, this.entry = null, this.finish = function() {
            (function($, te, V) {
              var K = $.entry;
              for ($.entry = null; K; ) {
                var ne = K.callback;
                te.pendingcb--, ne(V), K = K.next;
              }
              te.corkedRequestsFree.next = $;
            })(ie, Y);
          };
        }
        a.exports = N;
        var g, _ = !l.browser && -1 < ["v0.10", "v0.9."].indexOf(l.version.slice(0, 5)) ? d : h.nextTick;
        N.WritableState = k, (d = Object.create(r(63))).inherits = r(35);
        var b, v = { deprecate: r(408) }, E = r(198), C = r(132).Buffer, y = (T !== void 0 ? T : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
        }, T = r(199);
        function A() {
        }
        function k(Y, ie) {
          g = g || r(50);
          var ce = ie instanceof g;
          this.objectMode = !!(Y = Y || {}).objectMode, ce && (this.objectMode = this.objectMode || !!Y.writableObjectMode);
          var $ = Y.highWaterMark, te = Y.writableHighWaterMark, V = this.objectMode ? 16 : 16384;
          this.highWaterMark = $ || $ === 0 ? $ : ce && (te || te === 0) ? te : V, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, V = (this.destroyed = !1) === Y.decodeStrings, this.decodeStrings = !V, this.defaultEncoding = Y.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(K) {
            (function(J, L) {
              var z = J._writableState, ee = z.sync, q = z.writecb;
              (function(oe) {
                oe.writing = !1, oe.writecb = null, oe.length -= oe.writelen, oe.writelen = 0;
              })(z), L ? function(oe, ae, _e, ve, Ee) {
                --ae.pendingcb, _e ? (h.nextTick(Ee, ve), h.nextTick(Q, oe, ae), oe._writableState.errorEmitted = !0, oe.emit("error", ve)) : (Ee(ve), oe._writableState.errorEmitted = !0, oe.emit("error", ve), Q(oe, ae));
              }(J, z, ee, L, q) : ((L = U(z)) || z.corked || z.bufferProcessing || !z.bufferedRequest || B(J, z), ee ? _(I, J, z, L, q) : I(J, z, L, q));
            })(ie, K);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new p(this);
        }
        function N(Y) {
          if (g = g || r(50), !(b.call(N, this) || this instanceof g)) return new N(Y);
          this._writableState = new k(Y, this), this.writable = !0, Y && (typeof Y.write == "function" && (this._write = Y.write), typeof Y.writev == "function" && (this._writev = Y.writev), typeof Y.destroy == "function" && (this._destroy = Y.destroy), typeof Y.final == "function" && (this._final = Y.final)), E.call(this);
        }
        function j(Y, ie, ce, $, te, V, K) {
          ie.writelen = $, ie.writecb = K, ie.writing = !0, ie.sync = !0, ce ? Y._writev(te, ie.onwrite) : Y._write(te, V, ie.onwrite), ie.sync = !1;
        }
        function I(Y, ie, ce, $) {
          ce || function(V, K) {
            K.length === 0 && K.needDrain && (K.needDrain = !1, V.emit("drain"));
          }(Y, ie), ie.pendingcb--, $(), Q(Y, ie);
        }
        function B(Y, ie) {
          ie.bufferProcessing = !0;
          var ce = ie.bufferedRequest;
          if (Y._writev && ce && ce.next) {
            var $ = ie.bufferedRequestCount, te = new Array($);
            ($ = ie.corkedRequestsFree).entry = ce;
            for (var V = 0, K = !0; ce; ) (te[V] = ce).isBuf || (K = !1), ce = ce.next, V += 1;
            te.allBuffers = K, j(Y, ie, !0, ie.length, te, "", $.finish), ie.pendingcb++, ie.lastBufferedRequest = null, $.next ? (ie.corkedRequestsFree = $.next, $.next = null) : ie.corkedRequestsFree = new p(ie), ie.bufferedRequestCount = 0;
          } else {
            for (; ce; ) {
              var ne = ce.chunk, J = ce.encoding, L = ce.callback;
              if (j(Y, ie, !1, ie.objectMode ? 1 : ne.length, ne, J, L), ce = ce.next, ie.bufferedRequestCount--, ie.writing) break;
            }
            ce === null && (ie.lastBufferedRequest = null);
          }
          ie.bufferedRequest = ce, ie.bufferProcessing = !1;
        }
        function U(Y) {
          return Y.ending && Y.length === 0 && Y.bufferedRequest === null && !Y.finished && !Y.writing;
        }
        function H(Y, ie) {
          Y._final(function(ce) {
            ie.pendingcb--, ce && Y.emit("error", ce), ie.prefinished = !0, Y.emit("prefinish"), Q(Y, ie);
          });
        }
        function Q(Y, ie) {
          var ce = U(ie);
          return ce && (function(te, V) {
            V.prefinished || V.finalCalled || (typeof te._final == "function" ? (V.pendingcb++, V.finalCalled = !0, h.nextTick(H, te, V)) : (V.prefinished = !0, te.emit("prefinish")));
          }(Y, ie), ie.pendingcb === 0 && (ie.finished = !0, Y.emit("finish"))), ce;
        }
        d.inherits(N, E), k.prototype.getBuffer = function() {
          for (var ie = this.bufferedRequest, ce = []; ie; ) ce.push(ie), ie = ie.next;
          return ce;
        }, function() {
          try {
            Object.defineProperty(k.prototype, "buffer", { get: v.deprecate(function() {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
          } catch {
          }
        }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (b = Function.prototype[Symbol.hasInstance], Object.defineProperty(N, Symbol.hasInstance, { value: function(ie) {
          return !!b.call(this, ie) || this === N && ie && ie._writableState instanceof k;
        } })) : b = function(ie) {
          return ie instanceof this;
        }, N.prototype.pipe = function() {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, N.prototype.write = function(Y, ie, ce) {
          var $ = this._writableState, te = !1, V = !$.objectMode && function(ne) {
            return C.isBuffer(ne) || ne instanceof y;
          }(Y);
          return V && !C.isBuffer(Y) && (Y = function(ne) {
            return C.from(ne);
          }(Y)), typeof ie == "function" && (ce = ie, ie = null), ie = V ? "buffer" : ie || $.defaultEncoding, typeof ce != "function" && (ce = A), $.ended ? function(ne, J) {
            var L = new Error("write after end");
            ne.emit("error", L), h.nextTick(J, L);
          }(this, ce) : (V || function(ne, J, L, z) {
            var ee = !0, q = !1;
            return L === null ? q = new TypeError("May not write null values to stream") : typeof L == "string" || L === void 0 || J.objectMode || (q = new TypeError("Invalid non-string/buffer chunk")), q && (ne.emit("error", q), h.nextTick(z, q), ee = !1), ee;
          }(this, $, Y, ce)) && ($.pendingcb++, te = function(ne, J, L, z, ee, q) {
            L || z !== (oe = function(ve, Ee, we) {
              return Ee = !ve.objectMode && ve.decodeStrings !== !1 && typeof Ee == "string" ? C.from(Ee, we) : Ee;
            }(J, z, ee)) && (L = !0, ee = "buffer", z = oe);
            var X = J.objectMode ? 1 : z.length;
            J.length += X;
            var oe, ae = J.length < J.highWaterMark;
            return ae || (J.needDrain = !0), J.writing || J.corked ? (oe = J.lastBufferedRequest, J.lastBufferedRequest = { chunk: z, encoding: ee, isBuf: L, callback: q, next: null }, oe ? oe.next = J.lastBufferedRequest : J.bufferedRequest = J.lastBufferedRequest, J.bufferedRequestCount += 1) : j(ne, J, !1, X, z, ee, q), ae;
          }(this, $, V, Y, ie, ce)), te;
        }, N.prototype.cork = function() {
          this._writableState.corked++;
        }, N.prototype.uncork = function() {
          var Y = this._writableState;
          Y.corked && (Y.corked--, Y.writing || Y.corked || Y.bufferProcessing || !Y.bufferedRequest || B(this, Y));
        }, N.prototype.setDefaultEncoding = function(ie) {
          if (typeof ie == "string" && (ie = ie.toLowerCase()), !(-1 < ["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((ie + "").toLowerCase()))) throw new TypeError("Unknown encoding: " + ie);
          return this._writableState.defaultEncoding = ie, this;
        }, Object.defineProperty(N.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
          return this._writableState.highWaterMark;
        } }), N.prototype._write = function(Y, ie, ce) {
          ce(new Error("_write() is not implemented"));
        }, N.prototype._writev = null, N.prototype.end = function(Y, ie, ce) {
          var $ = this._writableState;
          typeof Y == "function" ? (ce = Y, ie = Y = null) : typeof ie == "function" && (ce = ie, ie = null), Y != null && this.write(Y, ie), $.corked && ($.corked = 1, this.uncork()), $.ending || function(V, K, ne) {
            K.ending = !0, Q(V, K), ne && (K.finished ? h.nextTick(ne) : V.once("finish", ne)), K.ended = !0, V.writable = !1;
          }(this, $, ce);
        }, Object.defineProperty(N.prototype, "destroyed", { get: function() {
          return this._writableState !== void 0 && this._writableState.destroyed;
        }, set: function(ie) {
          this._writableState && (this._writableState.destroyed = ie);
        } }), N.prototype.destroy = T.destroy, N.prototype._undestroy = T.undestroy, N.prototype._destroy = function(Y, ie) {
          this.end(), ie(Y);
        };
      }).call(this, r(15), r(406).setImmediate, r(18));
    }, function(a, s, r) {
      var l = r(409).Buffer, d = l.isEncoding || function(y) {
        switch ((y = "" + y) && y.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1;
        }
      };
      function f(y) {
        var T;
        switch (this.encoding = function(k) {
          var N = function(I) {
            if (!I) return "utf8";
            for (var B; ; ) switch (I) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return I;
              default:
                if (B) return;
                I = ("" + I).toLowerCase(), B = !0;
            }
          }(k);
          if (typeof N != "string" && (l.isEncoding === d || !d(k))) throw new Error("Unknown encoding: " + k);
          return N || k;
        }(y), this.encoding) {
          case "utf16le":
            this.text = g, this.end = _, T = 4;
            break;
          case "utf8":
            this.fillLast = p, T = 4;
            break;
          case "base64":
            this.text = b, this.end = v, T = 3;
            break;
          default:
            return this.write = E, void (this.end = C);
        }
        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = l.allocUnsafe(T);
      }
      function h(y) {
        return y <= 127 ? 0 : y >> 5 == 6 ? 2 : y >> 4 == 14 ? 3 : y >> 3 == 30 ? 4 : y >> 6 == 2 ? -1 : -2;
      }
      function p(y) {
        var T = this.lastTotal - this.lastNeed, A = function(N, j) {
          return (192 & j[0]) != 128 ? (N.lastNeed = 0, "�") : 1 < N.lastNeed && 1 < j.length ? (192 & j[1]) != 128 ? (N.lastNeed = 1, "�") : 2 < N.lastNeed && 2 < j.length && (192 & j[2]) != 128 ? (N.lastNeed = 2, "�") : void 0 : void 0;
        }(this, y);
        return A !== void 0 ? A : this.lastNeed <= y.length ? (y.copy(this.lastChar, T, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (y.copy(this.lastChar, T, 0, y.length), void (this.lastNeed -= y.length));
      }
      function g(y, T) {
        if ((y.length - T) % 2 != 0) return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = y[y.length - 1], y.toString("utf16le", T, y.length - 1);
        var A = y.toString("utf16le", T);
        return A && 55296 <= (T = A.charCodeAt(A.length - 1)) && T <= 56319 ? (this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1], A.slice(0, -1)) : A;
      }
      function _(y) {
        var T = y && y.length ? this.write(y) : "";
        return this.lastNeed ? (y = this.lastTotal - this.lastNeed, T + this.lastChar.toString("utf16le", 0, y)) : T;
      }
      function b(y, T) {
        var A = (y.length - T) % 3;
        return A == 0 ? y.toString("base64", T) : (this.lastNeed = 3 - A, this.lastTotal = 3, A == 1 ? this.lastChar[0] = y[y.length - 1] : (this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1]), y.toString("base64", T, y.length - A));
      }
      function v(y) {
        return y = y && y.length ? this.write(y) : "", this.lastNeed ? y + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : y;
      }
      function E(y) {
        return y.toString(this.encoding);
      }
      function C(y) {
        return y && y.length ? this.write(y) : "";
      }
      (s.StringDecoder = f).prototype.write = function(y) {
        if (y.length === 0) return "";
        var T, A;
        if (this.lastNeed) {
          if ((T = this.fillLast(y)) === void 0) return "";
          A = this.lastNeed, this.lastNeed = 0;
        } else A = 0;
        return A < y.length ? T ? T + this.text(y, A) : this.text(y, A) : T || "";
      }, f.prototype.end = function(T) {
        return T = T && T.length ? this.write(T) : "", this.lastNeed ? T + "�" : T;
      }, f.prototype.text = function(T, A) {
        var k = function(j, I, B) {
          var U = I.length - 1;
          if (U < B) return 0;
          var H = h(I[U]);
          return 0 <= H ? (0 < H && (j.lastNeed = H - 1), H) : --U < B || H === -2 ? 0 : 0 <= (H = h(I[U])) ? (0 < H && (j.lastNeed = H - 2), H) : !(--U < B || H === -2) && 0 <= (H = h(I[U])) ? (0 < H && (H === 2 ? H = 0 : j.lastNeed = H - 3), H) : 0;
        }(this, T, A);
        return this.lastNeed ? (this.lastTotal = k, k = T.length - (k - this.lastNeed), T.copy(this.lastChar, 0, k), T.toString("utf8", A, k)) : T.toString("utf8", A);
      }, f.prototype.fillLast = function(y) {
        if (this.lastNeed <= y.length) return y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, y.length), this.lastNeed -= y.length;
      };
    }, function(a, s, r) {
      a.exports = d;
      var l = r(50);
      function d(p) {
        if (!(this instanceof d)) return new d(p);
        l.call(this, p), this._transformState = { afterTransform: (function(_, b) {
          var v = this._transformState;
          v.transforming = !1;
          var E = v.writecb;
          if (!E) return this.emit("error", new Error("write callback called multiple times"));
          v.writechunk = null, (v.writecb = null) != b && this.push(b), E(_), (_ = this._readableState).reading = !1, (_.needReadable || _.length < _.highWaterMark) && this._read(_.highWaterMark);
        }).bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, p && (typeof p.transform == "function" && (this._transform = p.transform), typeof p.flush == "function" && (this._flush = p.flush)), this.on("prefinish", f);
      }
      function f() {
        var p = this;
        typeof this._flush == "function" ? this._flush(function(g, _) {
          h(p, g, _);
        }) : h(this, null, null);
      }
      function h(p, g, _) {
        if (g) return p.emit("error", g);
        if (_ != null && p.push(_), p._writableState.length) throw new Error("Calling transform done when ws.length != 0");
        if (p._transformState.transforming) throw new Error("Calling transform done when still transforming");
        return p.push(null);
      }
      (a = Object.create(r(63))).inherits = r(35), a.inherits(d, l), d.prototype.push = function(p, g) {
        return this._transformState.needTransform = !1, l.prototype.push.call(this, p, g);
      }, d.prototype._transform = function(p, g, _) {
        throw new Error("_transform() is not implemented");
      }, d.prototype._write = function(p, g, _) {
        var b = this._transformState;
        b.writecb = _, b.writechunk = p, b.writeencoding = g, b.transforming || (g = this._readableState, (b.needTransform || g.needReadable || g.length < g.highWaterMark) && this._read(g.highWaterMark));
      }, d.prototype._read = function(p) {
        var g = this._transformState;
        g.writechunk !== null && g.writecb && !g.transforming ? (g.transforming = !0, this._transform(g.writechunk, g.writeencoding, g.afterTransform)) : g.needTransform = !0;
      }, d.prototype._destroy = function(p, g) {
        var _ = this;
        l.prototype._destroy.call(this, p, function(b) {
          g(b), _.emit("close");
        });
      };
    }, function(a, s, r) {
      function l() {
        if (d) try {
          return d({}, "a", { value: 1 }), !0;
        } catch {
          return !1;
        }
        return !1;
      }
      var d = r(36)("%Object.defineProperty%", !0);
      l.hasArrayLengthDefineBug = function() {
        if (!l()) return null;
        try {
          return d([], "length", { value: 1 }).length !== 1;
        } catch {
          return !0;
        }
      }, a.exports = l;
    }, function(a, s, r) {
      if (r = r(36)("%Object.getOwnPropertyDescriptor%", !0)) try {
        r([], "length");
      } catch {
        r = null;
      }
      a.exports = r;
    }, function(a, s, _) {
      function l(b) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
          return typeof v;
        } : function(v) {
          return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
        })(b);
      }
      function d(b, v) {
        for (var E = v && v.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, C = 0; C < b.length; ++C) b[C] !== void 0 && (E[C] = b[C]);
        return E;
      }
      var f = _(134), h = Object.prototype.hasOwnProperty, p = Array.isArray, g = function() {
        for (var b = [], v = 0; v < 256; ++v) b.push("%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase());
        return b;
      }(), _ = function(v) {
        return !(!v || l(v) !== "object" || !(v.constructor && v.constructor.isBuffer && v.constructor.isBuffer(v)));
      };
      a.exports = { arrayToObject: d, assign: function(v, E) {
        return Object.keys(E).reduce(function(C, y) {
          return C[y] = E[y], C;
        }, v);
      }, combine: function(v, E) {
        return [].concat(v, E);
      }, compact: function(v) {
        for (var E = [{ obj: { o: v }, prop: "o" }], C = [], y = 0; y < E.length; ++y) for (var T = E[y], A = T.obj[T.prop], k = Object.keys(A), N = 0; N < k.length; ++N) {
          var j = k[N], I = A[j];
          l(I) === "object" && I !== null && C.indexOf(I) === -1 && (E.push({ obj: A, prop: j }), C.push(I));
        }
        return function(U) {
          for (; 1 < U.length; ) {
            var H = U.pop(), Q = H.obj[H.prop];
            if (p(Q)) {
              for (var Y = [], ie = 0; ie < Q.length; ++ie) Q[ie] !== void 0 && Y.push(Q[ie]);
              H.obj[H.prop] = Y;
            }
          }
        }(E), v;
      }, decode: function(v, E, C) {
        if (v = v.replace(/\+/g, " "), C === "iso-8859-1") return v.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(v);
        } catch {
          return v;
        }
      }, encode: function(v, E, C, y, T) {
        if (v.length === 0) return v;
        var A = v;
        if (l(v) === "symbol" ? A = Symbol.prototype.toString.call(v) : typeof v != "string" && (A = String(v)), C === "iso-8859-1") return escape(A).replace(/%u[0-9a-f]{4}/gi, function(I) {
          return "%26%23" + parseInt(I.slice(2), 16) + "%3B";
        });
        for (var k = "", N = 0; N < A.length; ++N) {
          var j = A.charCodeAt(N);
          j === 45 || j === 46 || j === 95 || j === 126 || 48 <= j && j <= 57 || 65 <= j && j <= 90 || 97 <= j && j <= 122 || T === f.RFC1738 && (j === 40 || j === 41) ? k += A.charAt(N) : j < 128 ? k += g[j] : j < 2048 ? k += g[192 | j >> 6] + g[128 | 63 & j] : j < 55296 || 57344 <= j ? k += g[224 | j >> 12] + g[128 | j >> 6 & 63] + g[128 | 63 & j] : (N += 1, j = 65536 + ((1023 & j) << 10 | 1023 & A.charCodeAt(N)), k += g[240 | j >> 18] + g[128 | j >> 12 & 63] + g[128 | j >> 6 & 63] + g[128 | 63 & j]);
        }
        return k;
      }, isBuffer: _, isRegExp: function(v) {
        return Object.prototype.toString.call(v) === "[object RegExp]";
      }, maybeMap: function(v, E) {
        if (p(v)) {
          for (var C = [], y = 0; y < v.length; y += 1) C.push(E(v[y]));
          return C;
        }
        return E(v);
      }, merge: function b(v, E, C) {
        if (!E) return v;
        if (l(E) !== "object") {
          if (p(v)) v.push(E);
          else {
            if (!v || l(v) !== "object") return [v, E];
            (C && (C.plainObjects || C.allowPrototypes) || !h.call(Object.prototype, E)) && (v[E] = !0);
          }
          return v;
        }
        if (!v || l(v) !== "object") return [v].concat(E);
        var y = v;
        return p(v) && !p(E) && (y = d(v, C)), p(v) && p(E) ? (E.forEach(function(T, A) {
          var k;
          h.call(v, A) ? (k = v[A]) && l(k) === "object" && T && l(T) === "object" ? v[A] = b(k, T, C) : v.push(T) : v[A] = T;
        }), v) : Object.keys(E).reduce(function(T, A) {
          var k = E[A];
          return h.call(T, A) ? T[A] = b(T[A], k, C) : T[A] = k, T;
        }, y);
      } };
    }, function(a, s, r) {
      s.SourceMapGenerator = r(207).SourceMapGenerator, s.SourceMapConsumer = r(441).SourceMapConsumer, s.SourceNode = r(444).SourceNode;
    }, function(a, s, r) {
      var l = r(208), d = r(64), f = r(209).ArraySet, h = r(440).MappingList;
      function p(g) {
        this._file = d.getArg(g = g || {}, "file", null), this._sourceRoot = d.getArg(g, "sourceRoot", null), this._skipValidation = d.getArg(g, "skipValidation", !1), this._sources = new f(), this._names = new f(), this._mappings = new h(), this._sourcesContents = null;
      }
      p.prototype._version = 3, p.fromSourceMap = function(_) {
        var b = _.sourceRoot, v = new p({ file: _.file, sourceRoot: b });
        return _.eachMapping(function(E) {
          var C = { generated: { line: E.generatedLine, column: E.generatedColumn } };
          E.source != null && (C.source = E.source, b != null && (C.source = d.relative(b, C.source)), C.original = { line: E.originalLine, column: E.originalColumn }, E.name != null && (C.name = E.name)), v.addMapping(C);
        }), _.sources.forEach(function(E) {
          var C = E;
          b !== null && (C = d.relative(b, E)), v._sources.has(C) || v._sources.add(C), (C = _.sourceContentFor(E)) != null && v.setSourceContent(E, C);
        }), v;
      }, p.prototype.addMapping = function(C) {
        var b = d.getArg(C, "generated"), v = d.getArg(C, "original", null), E = d.getArg(C, "source", null), C = d.getArg(C, "name", null);
        this._skipValidation || this._validateMapping(b, v, E, C), E != null && (E = String(E), this._sources.has(E) || this._sources.add(E)), C != null && (C = String(C), this._names.has(C) || this._names.add(C)), this._mappings.add({ generatedLine: b.line, generatedColumn: b.column, originalLine: v != null && v.line, originalColumn: v != null && v.column, source: E, name: C });
      }, p.prototype.setSourceContent = function(_, b) {
        this._sourceRoot != null && (_ = d.relative(this._sourceRoot, _)), b != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[d.toSetString(_)] = b) : this._sourcesContents && (delete this._sourcesContents[d.toSetString(_)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
      }, p.prototype.applySourceMap = function(_, b, v) {
        var E = b;
        if (b == null) {
          if (_.file == null) throw new Error(`SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`);
          E = _.file;
        }
        var C = this._sourceRoot;
        C != null && (E = d.relative(C, E));
        var y = new f(), T = new f();
        this._mappings.unsortedForEach(function(A) {
          A.source !== E || A.originalLine == null || (k = _.originalPositionFor({ line: A.originalLine, column: A.originalColumn })).source != null && (A.source = k.source, v != null && (A.source = d.join(v, A.source)), C != null && (A.source = d.relative(C, A.source)), A.originalLine = k.line, A.originalColumn = k.column, k.name != null && (A.name = k.name));
          var k = A.source;
          k == null || y.has(k) || y.add(k), (A = A.name) == null || T.has(A) || T.add(A);
        }, this), this._sources = y, this._names = T, _.sources.forEach(function(A) {
          var k = _.sourceContentFor(A);
          k != null && (v != null && (A = d.join(v, A)), C != null && (A = d.relative(C, A)), this.setSourceContent(A, k));
        }, this);
      }, p.prototype._validateMapping = function(_, b, v, E) {
        if (b && typeof b.line != "number" && typeof b.column != "number") throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
        if ((!(_ && "line" in _ && "column" in _ && 0 < _.line && 0 <= _.column) || b || v || E) && !(_ && "line" in _ && "column" in _ && b && "line" in b && "column" in b && 0 < _.line && 0 <= _.column && 0 < b.line && 0 <= b.column && v)) throw new Error("Invalid mapping: " + JSON.stringify({ generated: _, source: v, original: b, name: E }));
      }, p.prototype._serializeMappings = function() {
        for (var _, b, v, E = 0, C = 1, y = 0, T = 0, A = 0, k = 0, N = "", j = this._mappings.toArray(), I = 0, B = j.length; I < B; I++) {
          if (_ = "", (b = j[I]).generatedLine !== C) for (E = 0; b.generatedLine !== C; ) _ += ";", C++;
          else if (0 < I) {
            if (!d.compareByGeneratedPositionsInflated(b, j[I - 1])) continue;
            _ += ",";
          }
          _ += l.encode(b.generatedColumn - E), E = b.generatedColumn, b.source != null && (v = this._sources.indexOf(b.source), _ += l.encode(v - k), k = v, _ += l.encode(b.originalLine - 1 - T), T = b.originalLine - 1, _ += l.encode(b.originalColumn - y), y = b.originalColumn, b.name != null && (v = this._names.indexOf(b.name), _ += l.encode(v - A), A = v)), N += _;
        }
        return N;
      }, p.prototype._generateSourcesContent = function(_, b) {
        return _.map(function(v) {
          return this._sourcesContents ? (b != null && (v = d.relative(b, v)), v = d.toSetString(v), Object.prototype.hasOwnProperty.call(this._sourcesContents, v) ? this._sourcesContents[v] : null) : null;
        }, this);
      }, p.prototype.toJSON = function() {
        var _ = { version: this._version, sources: this._sources.toArray(), names: this._names.toArray(), mappings: this._serializeMappings() };
        return this._file != null && (_.file = this._file), this._sourceRoot != null && (_.sourceRoot = this._sourceRoot), this._sourcesContents && (_.sourcesContent = this._generateSourcesContent(_.sources, _.sourceRoot)), _;
      }, p.prototype.toString = function() {
        return JSON.stringify(this.toJSON());
      }, s.SourceMapGenerator = p;
    }, function(a, s, r) {
      var l = r(439);
      s.encode = function(f) {
        for (var h, p = "", g = function(b) {
          return b < 0 ? 1 + (-b << 1) : b << 1;
        }(f); h = 31 & g, 0 < (g >>>= 5) && (h |= 32), p += l.encode(h), 0 < g; ) ;
        return p;
      }, s.decode = function(f, h, p) {
        var g, _, b = f.length, v = 0, E = 0;
        do {
          if (b <= h) throw new Error("Expected more digits in base 64 VLQ value.");
          if ((_ = l.decode(f.charCodeAt(h++))) === -1) throw new Error("Invalid base64 digit: " + f.charAt(h - 1));
        } while (g = !!(32 & _), v += (_ &= 31) << E, E += 5, g);
        p.value = function(y) {
          var T = y >> 1;
          return (1 & y) == 1 ? -T : T;
        }(v), p.rest = h;
      };
    }, function(a, s, r) {
      var l = r(64), d = Object.prototype.hasOwnProperty, f = typeof Map < "u";
      function h() {
        this._array = [], this._set = f ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
      }
      h.fromArray = function(g, _) {
        for (var b = new h(), v = 0, E = g.length; v < E; v++) b.add(g[v], _);
        return b;
      }, h.prototype.size = function() {
        return f ? this._set.size : Object.getOwnPropertyNames(this._set).length;
      }, h.prototype.add = function(g, _) {
        var b = f ? g : l.toSetString(g), v = f ? this.has(g) : d.call(this._set, b), E = this._array.length;
        v && !_ || this._array.push(g), v || (f ? this._set.set(g, E) : this._set[b] = E);
      }, h.prototype.has = function(g) {
        return f ? this._set.has(g) : (g = l.toSetString(g), d.call(this._set, g));
      }, h.prototype.indexOf = function(g) {
        if (f) {
          var _ = this._set.get(g);
          if (0 <= _) return _;
        } else if (_ = l.toSetString(g), d.call(this._set, _)) return this._set[_];
        throw new Error('"' + g + '" is not in the set.');
      }, h.prototype.at = function(g) {
        if (0 <= g && g < this._array.length) return this._array[g];
        throw new Error("No element indexed by " + g);
      }, h.prototype.toArray = function() {
        return this._array.slice();
      }, s.ArraySet = h;
    }, function(a, s, r) {
      var l = r(22);
      a.exports = function(f, _, p) {
        var g = l.resolve(""), _ = l.resolve(g, _), b = l.dirname(_);
        return f.sources = f.sources.map(function(v) {
          return l.relative(p, l.resolve(b, v));
        }), f;
      };
    }, function(a, s, r) {
      var l = r(22), d = r(27);
      a.exports = function(h, p) {
        var g = l.dirname(p);
        return h.sources = h.sources.map(function(_) {
          return d.resolve(g, _);
        }), h;
      };
    }, function(a, s, r) {
      var l = r(127), d = /^\(/, f = /\)$/, h = /^@import/i, p = /['"]\s*/, g = /\s*['"]/, _ = /^url\(\s*/i, b = /\s*\)/i;
      a.exports = function(E) {
        return E = E.replace(h, "").trim().replace(_, "(").replace(b, ")").replace(p, "").replace(g, ""), [(E = l(E, " "))[0].replace(d, "").replace(f, ""), E.slice(1).join(" ")];
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return ("@import " + l + " " + d).trim();
      };
    }, function(a, s) {
      var r = /^@import/i;
      a.exports = function(d) {
        return r.test(d);
      };
    }, function(a, s, r) {
      function l(d, f) {
        var h = {};
        return d.forEach(function(p) {
          h[p] = 1;
        }), f ? function(p) {
          return h[p.toLowerCase()] === 1;
        } : function(p) {
          return h[p] === 1;
        };
      }
      s.createMap = l, s.createMapFromString = function(d, f) {
        return l(d.split(/,/), f);
      };
    }, function(a, s, r) {
      a.exports = { ABSOLUTE: "absolute", PATH_RELATIVE: "pathRelative", ROOT_RELATIVE: "rootRelative", SHORTEST: "shortest" };
    }, function(a, s, r) {
      var l = r(25), d = r(218);
      a.exports = d ? function(f, h) {
        return d.set(f, h), f;
      } : l;
    }, function(a, s, r) {
      r = (r = r(156)) && new r(), a.exports = r;
    }, function(a, s, r) {
      var l = r(220), d = r(221), f = r(480), h = r(92), p = r(222), g = r(227), _ = r(492), b = r(145), v = r(17), E = 1, C = 2, y = 8, T = 16, A = 128, k = 512;
      a.exports = function N(j, I, B, U, H, Q, Y, ie, ce, $) {
        var te = I & A, V = I & E, K = I & C, ne = I & (y | T), J = I & k, L = K ? void 0 : h(j);
        return function z() {
          for (var ee, _e = arguments.length, q = Array(_e), X = _e; X--; ) q[X] = arguments[X];
          if (ne && (oe = g(z), ee = f(q, oe)), U && (q = l(q, U, H, ne)), Q && (q = d(q, Q, Y, ne)), _e -= ee, ne && _e < $) {
            var ae = b(q, oe);
            return p(j, I, N, z.placeholder, B, q, ae, ie, ce, $ - _e);
          }
          var oe = V ? B : this, ae = K ? oe[j] : j, _e = q.length;
          return ie ? q = _(q, ie) : J && 1 < _e && q.reverse(), te && ce < _e && (q.length = ce), (ae = this && this !== v && this instanceof z ? L || h(ae) : ae).apply(oe, q);
        };
      };
    }, function(a, s) {
      var r = Math.max;
      a.exports = function(d, f, h, p) {
        for (var g = -1, _ = d.length, b = h.length, v = -1, E = f.length, C = r(_ - b, 0), y = Array(E + C), T = !p; ++v < E; ) y[v] = f[v];
        for (; ++g < b; ) (T || g < _) && (y[h[g]] = d[g]);
        for (; C--; ) y[v++] = d[g++];
        return y;
      };
    }, function(a, s) {
      var r = Math.max;
      a.exports = function(d, f, h, p) {
        for (var g = -1, _ = d.length, b = -1, v = h.length, E = -1, C = f.length, y = r(_ - v, 0), T = Array(y + C), A = !p; ++g < y; ) T[g] = d[g];
        for (var k = g; ++E < C; ) T[k + E] = f[E];
        for (; ++b < v; ) (A || g < _) && (T[k + h[b]] = d[g++]);
        return T;
      };
    }, function(a, s, r) {
      var l = r(223), d = r(225), f = r(226);
      a.exports = function(p, g, _, b, v, E, C, y, T, A) {
        var k = 8 & g;
        return g |= k ? 32 : 64, 4 & (g &= ~(k ? 64 : 32)) || (g &= -4), _ = _.apply(void 0, A = [p, g, v, k ? E : void 0, k ? C : void 0, k ? void 0 : E, k ? void 0 : C, y, T, A]), l(p) && d(_, A), _.placeholder = b, f(_, p, g);
      };
    }, function(a, s, r) {
      var l = r(141), d = r(143), f = r(224), h = r(483);
      a.exports = function(g) {
        var _ = f(g), b = h[_];
        return typeof b == "function" && _ in l.prototype && (g === b || !!(b = d(b)) && g === b[0]);
      };
    }, function(a, s, r) {
      var l = r(482), d = Object.prototype.hasOwnProperty;
      a.exports = function(h) {
        for (var p = h.name + "", g = l[p], _ = d.call(l, p) ? g.length : 0; _--; ) {
          var b = g[_], v = b.func;
          if (v == null || v == h) return b.name;
        }
        return p;
      };
    }, function(a, s, r) {
      var l = r(217), l = r(178)(l);
      a.exports = l;
    }, function(a, s, r) {
      var l = r(485), d = r(486), f = r(177), h = r(487);
      a.exports = function(g, _, b) {
        return f(g, d(_ += "", h(l(_), b)));
      };
    }, function(a, s) {
      a.exports = function(l) {
        return l.placeholder;
      };
    }, function(a, s) {
      a.exports = !1;
    }, function(a, s) {
      a.exports = function(l) {
        if (typeof l != "function") throw new TypeError("Expected a function");
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, d[0]);
            case 2:
              return !l.call(this, d[0], d[1]);
            case 3:
              return !l.call(this, d[0], d[1], d[2]);
          }
          return !l.apply(this, d);
        };
      };
    }, function(a, s, r) {
      r = r(524)(function(l, d, f) {
        return l + (f ? "-" : "") + d.toLowerCase();
      }), a.exports = r;
    }, function(a, s, r) {
      var l = r(46), d = /[\\^$.*+?()[\]{}|]/g, f = RegExp(d.source);
      a.exports = function(p) {
        return (p = l(p)) && f.test(p) ? p.replace(d, "\\$&") : p;
      };
    }, function(a, s, r) {
      function l(_, b) {
        (b == null || b > _.length) && (b = _.length);
        for (var v = 0, E = new Array(b); v < b; v++) E[v] = _[v];
        return E;
      }
      var d = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.assignComponents = g, s.default = void 0, s.registerComponent = function(b) {
        var v = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        g(p, [b]), b.dependencies && v.registerDependencies && (0, h.registerDependencies)(b.dependencies);
      };
      var f = d(r(230)), h = r(93), p = {};
      function g(_, b) {
        var v, E = function(T, A) {
          var k = typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
          if (!k) {
            if (Array.isArray(T) || (k = function(H, Q) {
              if (H) {
                if (typeof H == "string") return l(H, Q);
                var Y = Object.prototype.toString.call(H).slice(8, -1);
                return (Y = Y === "Object" && H.constructor ? H.constructor.name : Y) === "Map" || Y === "Set" ? Array.from(H) : Y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Y) ? l(H, Q) : void 0;
              }
            }(T)) || A && T && typeof T.length == "number") {
              k && (T = k);
              var N = 0;
              return { s: A = function() {
              }, n: function() {
                return N >= T.length ? { done: !0 } : { done: !1, value: T[N++] };
              }, e: function(H) {
                throw H;
              }, f: A };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var j, I = !0, B = !1;
          return { s: function() {
            k = k.call(T);
          }, n: function() {
            var H = k.next();
            return I = H.done, H;
          }, e: function(H) {
            B = !0, j = H;
          }, f: function() {
            try {
              I || k.return == null || k.return();
            } finally {
              if (B) throw j;
            }
          } };
        }(b);
        try {
          for (E.s(); !(v = E.n()).done; ) {
            var C = v.value;
            _[C.componentName || (0, f.default)(C.name)] = C;
          }
        } catch (y) {
          E.e(y);
        } finally {
          E.f();
        }
      }
      s.default = p;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(d) {
        for (var f = "", h = 0; h < d; h += 1) f += Math.floor(16 * Math.random()).toString(16);
        return f;
      }, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(565), d = r(566), f = r(25);
      a.exports = function(p) {
        return p && p.length ? l(p, f, d) : void 0;
      };
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "getStyles", value: function() {
          return { td: { background: this.getAttribute("background-color"), "font-size": this.getAttribute("font-size"), "font-family": this.getAttribute("font-family"), "font-weight": this.getAttribute("font-weight"), "letter-spacing": this.getAttribute("letter-spacing"), "line-height": this.getAttribute("line-height"), color: this.getAttribute("color"), "padding-bottom": this.getAttribute("padding-bottom"), "padding-left": this.getAttribute("padding-left"), "padding-right": this.getAttribute("padding-right"), "padding-top": this.getAttribute("padding-top"), padding: this.getAttribute("padding") }, table: { width: "100%", "border-bottom": this.getAttribute("border") } };
        } }, { key: "renderContent", value: function() {
          return `
      <td
        `.concat(this.htmlAttributes({ class: this.getAttribute("css-class"), style: "td" }), `
      >
        `).concat(this.getContent(), `
      </td>
    `);
        } }, { key: "render", value: function() {
          return `
      <div
        `.concat(this.htmlAttributes({ class: "mj-accordion-content" }), `
      >
        <table
          `).concat(this.htmlAttributes({ cellspacing: "0", cellpadding: "0", style: "table" }), `
        >
          <tbody>
            <tr>
              `).concat(this.renderContent(), `
            </tr>
          </tbody>
        </table>
      </div>
    `);
        } }]), b;
      }(g.BodyComponent);
      (0, p.default)(g, "componentName", "mj-accordion-text"), (0, p.default)(g, "endingTag", !0), (0, p.default)(g, "allowedAttributes", { "background-color": "color", "font-size": "unit(px)", "font-family": "string", "font-weight": "string", "letter-spacing": "unitWithNegative(px,em)", "line-height": "unit(px,%,)", color: "color", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}" }), (0, p.default)(g, "defaultAttributes", { "font-size": "13px", "line-height": "1", padding: "16px" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(r(5)), f = l(r(4)), h = l(r(6)), p = l(r(7)), g = l(r(9)), b = r(10), _ = l(r(53)), b = s.default = function(v) {
        function E() {
          return (0, d.default)(this, E), (0, h.default)(this, E, arguments);
        }
        return (0, p.default)(E, v), (0, f.default)(E, [{ key: "getStyles", value: function() {
          return { td: { width: "100%", "background-color": this.getAttribute("background-color"), color: this.getAttribute("color"), "font-size": this.getAttribute("font-size"), "font-family": this.getAttribute("font-family"), "padding-bottom": this.getAttribute("padding-bottom"), "padding-left": this.getAttribute("padding-left"), "padding-right": this.getAttribute("padding-right"), "padding-top": this.getAttribute("padding-top"), padding: this.getAttribute("padding") }, table: { width: "100%", "border-bottom": this.getAttribute("border") }, td2: { padding: "16px", background: this.getAttribute("background-color"), "vertical-align": this.getAttribute("icon-align") }, img: { display: "none", width: this.getAttribute("icon-width"), height: this.getAttribute("icon-height") } };
        } }, { key: "renderTitle", value: function() {
          return `
      <td
        `.concat(this.htmlAttributes({ class: this.getAttribute("css-class"), style: "td" }), `
      >
        `).concat(this.getContent(), `
      </td>
    `);
        } }, { key: "renderIcons", value: function() {
          return (0, _.default)(`
      <td
        `.concat(this.htmlAttributes({ class: "mj-accordion-ico", style: "td2" }), `
      >
        <img
          `).concat(this.htmlAttributes({ src: this.getAttribute("icon-wrapped-url"), alt: this.getAttribute("icon-wrapped-alt"), class: "mj-accordion-more", style: "img" }), `
        />
        <img
          `).concat(this.htmlAttributes({ src: this.getAttribute("icon-unwrapped-url"), alt: this.getAttribute("icon-unwrapped-alt"), class: "mj-accordion-less", style: "img" }), `
        />
      </td>
    `), !0);
        } }, { key: "render", value: function() {
          var y = [this.renderTitle(), this.renderIcons()], y = (this.getAttribute("icon-position") === "right" ? y : y.reverse()).join(`
`);
          return `
      <div `.concat(this.htmlAttributes({ class: "mj-accordion-title" }), `>
        <table
          `).concat(this.htmlAttributes({ cellspacing: "0", cellpadding: "0", style: "table" }), `
        >
          <tbody>
            <tr>
              `).concat(y, `
            </tr>
          </tbody>
        </table>
      </div>
    `);
        } }]), E;
      }(b.BodyComponent);
      (0, g.default)(b, "componentName", "mj-accordion-title"), (0, g.default)(b, "endingTag", !0), (0, g.default)(b, "allowedAttributes", { "background-color": "color", color: "color", "font-size": "unit(px)", "font-family": "string", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}" }), (0, g.default)(b, "defaultAttributes", { "font-size": "13px", padding: "16px" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(67)("join", r(586));
      l.placeholder = r(51), a.exports = l;
    }, function(a, s, r) {
      var l = r(67)("identity", r(25), r(587));
      l.placeholder = r(51), a.exports = l;
    }, function(a, s, r) {
      function l(I) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(B) {
          return typeof B;
        } : function(B) {
          return B && typeof Symbol == "function" && B.constructor === Symbol && B !== Symbol.prototype ? "symbol" : typeof B;
        })(I);
      }
      function d(I, B) {
        return function(H) {
          if (Array.isArray(H)) return H;
        }(I) || function(H, Q) {
          var Y = H == null ? null : typeof Symbol < "u" && H[Symbol.iterator] || H["@@iterator"];
          if (Y != null) {
            var ie, ce, $, te, V = [], K = !0, ne = !1;
            try {
              if ($ = (Y = Y.call(H)).next, Q !== 0) for (; !(K = (ie = $.call(Y)).done) && (V.push(ie.value), V.length !== Q); K = !0) ;
            } catch (J) {
              ne = !0, ce = J;
            } finally {
              try {
                if (!K && Y.return != null && (te = Y.return(), Object(te) !== te)) return;
              } finally {
                if (ne) throw ce;
              }
            }
            return V;
          }
        }(I, B) || f(I, B) || function() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function f(I, B) {
        if (I) {
          if (typeof I == "string") return h(I, B);
          var U = Object.prototype.toString.call(I).slice(8, -1);
          return (U = U === "Object" && I.constructor ? I.constructor.name : U) === "Map" || U === "Set" ? Array.from(I) : U === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(U) ? h(I, B) : void 0;
        }
      }
      function h(I, B) {
        (B == null || B > I.length) && (B = I.length);
        for (var U = 0, H = new Array(B); U < B; U++) H[U] = I[U];
        return H;
      }
      function p(I, B) {
        var U, H = Object.keys(I);
        return Object.getOwnPropertySymbols && (U = Object.getOwnPropertySymbols(I), B && (U = U.filter(function(Q) {
          return Object.getOwnPropertyDescriptor(I, Q).enumerable;
        })), H.push.apply(H, U)), H;
      }
      function g(I) {
        for (var B = 1; B < arguments.length; B++) {
          var U = arguments[B] != null ? arguments[B] : {};
          B % 2 ? p(Object(U), !0).forEach(function(H) {
            (function(Y, ie, ce) {
              (ie = function(te) {
                return te = function(K, ne) {
                  if (l(K) != "object" || !K) return K;
                  var J = K[Symbol.toPrimitive];
                  if (J === void 0) return (ne === "string" ? String : Number)(K);
                  if (l(ne = J.call(K, ne || "default")) != "object") return ne;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(te, "string"), l(te) == "symbol" ? te : String(te);
              }(ie)) in Y ? Object.defineProperty(Y, ie, { value: ce, enumerable: !0, configurable: !0, writable: !0 }) : Y[ie] = ce;
            })(I, H, U[H]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(I, Object.getOwnPropertyDescriptors(U)) : p(Object(U)).forEach(function(H) {
            Object.defineProperty(I, H, Object.getOwnPropertyDescriptor(U, H));
          });
        }
        return I;
      }
      var A = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var _ = A(r(5)), b = A(r(4)), v = A(r(6)), E = A(r(7)), C = A(r(9)), y = A(r(146)), j = A(r(237)), T = A(r(238)), A = A(r(139)), k = r(10), N = (0, A.default)((0, y.default)(T.default), (0, j.default)(" ")), j = s.default = function(I) {
        function B() {
          return (0, _.default)(this, B), (0, v.default)(this, B, arguments);
        }
        return (0, E.default)(B, I), (0, b.default)(B, [{ key: "getChildContext", value: function() {
          var H = this.getBoxWidths().box;
          return g(g({}, this.context), {}, { containerWidth: "".concat(H, "px") });
        } }, { key: "getStyles", value: function() {
          var H = this.context.containerWidth, Q = this.isFullWidth(), Y = this.getAttribute("background-url") ? { background: this.getBackground(), "background-position": this.getBackgroundString(), "background-repeat": this.getAttribute("background-repeat"), "background-size": this.getAttribute("background-size") } : { background: this.getAttribute("background-color"), "background-color": this.getAttribute("background-color") };
          return { tableFullwidth: g(g({}, Q ? Y : {}), {}, { width: "100%", "border-radius": this.getAttribute("border-radius") }), table: g(g({}, Q ? {} : Y), {}, { width: "100%", "border-radius": this.getAttribute("border-radius") }), td: { border: this.getAttribute("border"), "border-bottom": this.getAttribute("border-bottom"), "border-left": this.getAttribute("border-left"), "border-right": this.getAttribute("border-right"), "border-top": this.getAttribute("border-top"), direction: this.getAttribute("direction"), "font-size": "0px", padding: this.getAttribute("padding"), "padding-bottom": this.getAttribute("padding-bottom"), "padding-left": this.getAttribute("padding-left"), "padding-right": this.getAttribute("padding-right"), "padding-top": this.getAttribute("padding-top"), "text-align": this.getAttribute("text-align") }, div: g(g({}, Q ? {} : Y), {}, { margin: "0px auto", "border-radius": this.getAttribute("border-radius"), "max-width": H }), innerDiv: { "line-height": "0", "font-size": "0" } };
        } }, { key: "getBackground", value: function() {
          return N([this.getAttribute("background-color")].concat(function(Q) {
            return function(ie) {
              if (Array.isArray(ie)) return h(ie);
            }(Q) || function(ie) {
              if (typeof Symbol < "u" && ie[Symbol.iterator] != null || ie["@@iterator"] != null) return Array.from(ie);
            }(Q) || f(Q) || function() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }(this.hasBackground() ? ["url('".concat(this.getAttribute("background-url"), "')"), this.getBackgroundString(), "/ ".concat(this.getAttribute("background-size")), this.getAttribute("background-repeat")] : [])));
        } }, { key: "getBackgroundString", value: function() {
          var H = (Q = this.getBackgroundPosition()).posX, Q = Q.posY;
          return "".concat(H, " ").concat(Q);
        } }, { key: "getBackgroundPosition", value: function() {
          var H = (Q = this.parseBackgroundPosition()).x, Q = Q.y;
          return { posX: this.getAttribute("background-position-x") || H, posY: this.getAttribute("background-position-y") || Q };
        } }, { key: "parseBackgroundPosition", value: function() {
          var H = this.getAttribute("background-position").split(" ");
          if (H.length !== 1) return H.length !== 2 ? { x: "center", y: "top" } : (Q = H[0], H = H[1], ["top", "bottom"].includes(Q) || Q === "center" && ["left", "right"].includes(H) ? { x: H, y: Q } : { x: Q, y: H });
          var Q = H[0];
          return ["top", "bottom"].includes(Q) ? { x: "center", y: Q } : { x: Q, y: "center" };
        } }, { key: "hasBackground", value: function() {
          return this.getAttribute("background-url") != null;
        } }, { key: "isFullWidth", value: function() {
          return this.getAttribute("full-width") === "full-width";
        } }, { key: "renderBefore", value: function() {
          var H = this.context.containerWidth, Q = this.getAttribute("background-color") ? { bgcolor: this.getAttribute("background-color") } : {};
          return `
      <!--[if mso | IE]>
      <table
        `.concat(this.htmlAttributes(g({ align: "center", border: "0", cellpadding: "0", cellspacing: "0", class: (0, k.suffixCssClasses)(this.getAttribute("css-class"), "outlook"), role: "presentation", style: { width: "".concat(H) }, width: parseInt(H, 10) }, Q)), `
      >
        <tr>
          <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
      <![endif]-->
    `);
        } }, { key: "renderAfter", value: function() {
          return `
      <!--[if mso | IE]>
          </td>
        </tr>
      </table>
      <![endif]-->
    `;
        } }, { key: "renderWrappedChildren", value: function() {
          var H = this.props.children;
          return `
      <!--[if mso | IE]>
        <tr>
      <![endif]-->
      `.concat(this.renderChildren(H, { renderer: function(Y) {
            return Y.constructor.isRawElement() ? Y.render() : `
          <!--[if mso | IE]>
            <td
              `.concat(Y.htmlAttributes({ align: Y.getAttribute("align"), class: (0, k.suffixCssClasses)(Y.getAttribute("css-class"), "outlook"), style: "tdOutlook" }), `
            >
          <![endif]-->
            `).concat(Y.render(), `
          <!--[if mso | IE]>
            </td>
          <![endif]-->
    `);
          } }), `

      <!--[if mso | IE]>
        </tr>
      <![endif]-->
    `);
        } }, { key: "renderWithBackground", value: function(H) {
          function Q(ee) {
            return /^\d+(\.\d+)?%$/.test(ee);
          }
          var Y = this, ie = this.isFullWidth(), ce = this.context.containerWidth, $ = {}, te = (ne = this.getBackgroundPosition()).posX, V = ne.posY;
          switch (te) {
            case "left":
              te = "0%";
              break;
            case "center":
              te = "50%";
              break;
            case "right":
              te = "100%";
              break;
            default:
              Q(te) || (te = "50%");
          }
          switch (V) {
            case "top":
              V = "0%";
              break;
            case "center":
              V = "50%";
              break;
            case "bottom":
              V = "100%";
              break;
            default:
              Q(V) || (V = "0%");
          }
          var J = d(["x", "y"].map(function(ee) {
            var q = ee === "x", X = Y.getAttribute("background-repeat") === "repeat", oe = q ? te : V, ae = q ? te : V;
            return Q(oe) ? (ee = oe.match(/^(\d+(\.\d+)?)%$/)[1], ee = parseInt(ee, 10) / 100, ae = oe = X ? ee : (100 * ee - 50) / 100) : oe = ae = X ? q ? "0.5" : "0" : q ? "0" : "-0.5", [ae, oe];
          }, this), 2), K = (L = d(J[0], 2))[0], ne = L[1], J = (L = d(J[1], 2))[0], L = L[1];
          this.getAttribute("background-size") === "cover" || this.getAttribute("background-size") === "contain" ? $ = { size: "1,1", aspect: this.getAttribute("background-size") === "cover" ? "atleast" : "atmost" } : this.getAttribute("background-size") !== "auto" && ($ = (z = this.getAttribute("background-size").split(" ")).length === 1 ? { size: this.getAttribute("background-size"), aspect: "atmost" } : { size: z.join(",") });
          var z = this.getAttribute("background-repeat") === "no-repeat" ? "frame" : "tile";
          return this.getAttribute("background-size") === "auto" && (z = "tile", ne = K = 0.5, L = J = 0), `
      <!--[if mso | IE]>
        <v:rect `.concat(this.htmlAttributes({ style: ie ? { "mso-width-percent": "1000" } : { width: ce }, "xmlns:v": "urn:schemas-microsoft-com:vml", fill: "true", stroke: "false" }), `>
        <v:fill `).concat(this.htmlAttributes(g({ origin: "".concat(K, ", ").concat(J), position: "".concat(ne, ", ").concat(L), src: this.getAttribute("background-url"), color: this.getAttribute("background-color"), type: z }, $)), ` />
        <v:textbox style="mso-fit-shape-to-text:true" inset="0,0,0,0">
      <![endif]-->
          `).concat(H, `
        <!--[if mso | IE]>
        </v:textbox>
      </v:rect>
    <![endif]-->
    `);
        } }, { key: "renderSection", value: function() {
          var H = this.hasBackground();
          return `
      <div `.concat(this.htmlAttributes({ class: this.isFullWidth() ? null : this.getAttribute("css-class"), style: "div" }), `>
        `).concat(H ? "<div ".concat(this.htmlAttributes({ style: "innerDiv" }), ">") : "", `
        <table
          `).concat(this.htmlAttributes({ align: "center", background: this.isFullWidth() ? null : this.getAttribute("background-url"), border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "table" }), `
        >
          <tbody>
            <tr>
              <td
                `).concat(this.htmlAttributes({ style: "td" }), `
              >
                <!--[if mso | IE]>
                  <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                <![endif]-->
                  `).concat(this.renderWrappedChildren(), `
                <!--[if mso | IE]>
                  </table>
                <![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
        `).concat(H ? "</div>" : "", `
      </div>
    `);
        } }, { key: "renderFullWidth", value: function() {
          var H = this.hasBackground() ? this.renderWithBackground(`
        `.concat(this.renderBefore(), `
        `).concat(this.renderSection(), `
        `).concat(this.renderAfter(), `
      `)) : `
        `.concat(this.renderBefore(), `
        `).concat(this.renderSection(), `
        `).concat(this.renderAfter(), `
      `);
          return `
      <table
        `.concat(this.htmlAttributes({ align: "center", class: this.getAttribute("css-class"), background: this.getAttribute("background-url"), border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "tableFullwidth" }), `
      >
        <tbody>
          <tr>
            <td>
              `).concat(H, `
            </td>
          </tr>
        </tbody>
      </table>
    `);
        } }, { key: "renderSimple", value: function() {
          var H = this.renderSection();
          return `
      `.concat(this.renderBefore(), `
      `).concat(this.hasBackground() ? this.renderWithBackground(H) : H, `
      `).concat(this.renderAfter(), `
    `);
        } }, { key: "render", value: function() {
          return this.isFullWidth() ? this.renderFullWidth() : this.renderSimple();
        } }]), B;
      }(k.BodyComponent);
      (0, C.default)(j, "componentName", "mj-section"), (0, C.default)(j, "allowedAttributes", { "background-color": "color", "background-url": "string", "background-repeat": "enum(repeat,no-repeat)", "background-size": "string", "background-position": "string", "background-position-x": "string", "background-position-y": "string", border: "string", "border-bottom": "string", "border-left": "string", "border-radius": "string", "border-right": "string", "border-top": "string", direction: "enum(ltr,rtl)", "full-width": "enum(full-width,false,)", padding: "unit(px,%){1,4}", "padding-top": "unit(px,%)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "text-align": "enum(left,center,right)", "text-padding": "unit(px,%){1,4}" }), (0, C.default)(j, "defaultAttributes", { "background-repeat": "repeat", "background-size": "auto", "background-position": "top center", direction: "ltr", padding: "20px 0", "text-align": "center", "text-padding": "4px 4px 4px 0" }), a.exports = s.default;
    }, function(a, s, r) {
      r.r(s), r.d(s, "load", function() {
        return Bc;
      }), r.d(s, "html", function() {
        return A;
      }), r.d(s, "xml", function() {
        return k;
      }), r.d(s, "text", function() {
        return N;
      }), r.d(s, "contains", function() {
        return A0;
      }), r.d(s, "merge", function() {
        return xo;
      }), r.d(s, "parseHTML", function() {
        return Fd;
      }), r.d(s, "root", function() {
        return jt;
      });
      var l = {};
      r.r(l), r.d(l, "html", function() {
        return A;
      }), r.d(l, "xml", function() {
        return k;
      }), r.d(l, "text", function() {
        return N;
      }), r.d(l, "parseHTML", function() {
        return j;
      }), r.d(l, "root", function() {
        return I;
      }), r.d(l, "contains", function() {
        return B;
      }), r.d(l, "merge", function() {
        return U;
      });
      var yt = {};
      r.r(yt), r.d(yt, "attr", function() {
        return _e;
      }), r.d(yt, "prop", function() {
        return we;
      }), r.d(yt, "data", function() {
        return je;
      }), r.d(yt, "val", function() {
        return qe;
      }), r.d(yt, "removeAttr", function() {
        return tt;
      }), r.d(yt, "hasClass", function() {
        return Qe;
      }), r.d(yt, "addClass", function() {
        return ke;
      }), r.d(yt, "removeClass", function() {
        return pe;
      }), r.d(yt, "toggleClass", function() {
        return Se;
      });
      var Ve = {};
      r.r(Ve), r.d(Ve, "find", function() {
        return ep;
      }), r.d(Ve, "parent", function() {
        return Ol;
      }), r.d(Ve, "parents", function() {
        return hc;
      }), r.d(Ve, "parentsUntil", function() {
        return Af;
      }), r.d(Ve, "closest", function() {
        return du;
      }), r.d(Ve, "next", function() {
        return qn;
      }), r.d(Ve, "nextAll", function() {
        return Ss;
      }), r.d(Ve, "nextUntil", function() {
        return Ba;
      }), r.d(Ve, "prev", function() {
        return kf;
      }), r.d(Ve, "prevAll", function() {
        return pc;
      }), r.d(Ve, "prevUntil", function() {
        return fu;
      }), r.d(Ve, "siblings", function() {
        return hu;
      }), r.d(Ve, "children", function() {
        return mc;
      }), r.d(Ve, "contents", function() {
        return bd;
      }), r.d(Ve, "each", function() {
        return rs;
      }), r.d(Ve, "map", function() {
        return pu;
      }), r.d(Ve, "filter", function() {
        return Ed;
      }), r.d(Ve, "filterArray", function() {
        return ws;
      }), r.d(Ve, "is", function() {
        return gc;
      }), r.d(Ve, "not", function() {
        return Of;
      }), r.d(Ve, "has", function() {
        return Fo;
      }), r.d(Ve, "first", function() {
        return xs;
      }), r.d(Ve, "last", function() {
        return _c;
      }), r.d(Ve, "eq", function() {
        return Dl;
      }), r.d(Ve, "get", function() {
        return Df;
      }), r.d(Ve, "toArray", function() {
        return yc;
      }), r.d(Ve, "index", function() {
        return Sd;
      }), r.d(Ve, "slice", function() {
        return mu;
      }), r.d(Ve, "end", function() {
        return Pi;
      }), r.d(Ve, "add", function() {
        return vc;
      }), r.d(Ve, "addBack", function() {
        return Rf;
      });
      var De = {};
      r.r(De), r.d(De, "_makeDomArray", function() {
        return Ec;
      }), r.d(De, "appendTo", function() {
        return le;
      }), r.d(De, "prependTo", function() {
        return ye;
      }), r.d(De, "append", function() {
        return Be;
      }), r.d(De, "prepend", function() {
        return Ke;
      }), r.d(De, "wrap", function() {
        return Wt;
      }), r.d(De, "wrapInner", function() {
        return hn;
      }), r.d(De, "unwrap", function() {
        return Rn;
      }), r.d(De, "wrapAll", function() {
        return yr;
      }), r.d(De, "after", function() {
        return Sr;
      }), r.d(De, "insertAfter", function() {
        return ri;
      }), r.d(De, "before", function() {
        return Rl;
      }), r.d(De, "insertBefore", function() {
        return tp;
      }), r.d(De, "remove", function() {
        return gu;
      }), r.d(De, "replaceWith", function() {
        return If;
      }), r.d(De, "empty", function() {
        return uo;
      }), r.d(De, "html", function() {
        return os;
      }), r.d(De, "toString", function() {
        return pi;
      }), r.d(De, "text", function() {
        return ga;
      }), r.d(De, "clone", function() {
        return rl;
      });
      var ct = {};
      r.r(ct), r.d(ct, "css", function() {
        return il;
      });
      var Xr = {};
      r.r(Xr), r.d(Xr, "serialize", function() {
        return np;
      }), r.d(Xr, "serializeArray", function() {
        return rp;
      });
      var d = {};
      function f(M) {
        return (f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function h(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function p(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? h(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = function(Fe) {
                return Fe = function(Je, pt) {
                  if (f(Je) != "object" || !Je) return Je;
                  var Nt = Je[Symbol.toPrimitive];
                  if (Nt === void 0) return (pt === "string" ? String : Number)(Je);
                  if (f(pt = Nt.call(Je, pt || "default")) != "object") return pt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(Fe, "string"), f(Fe) == "symbol" ? Fe : String(Fe);
              }(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : h(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      r.r(d), r.d(d, "NS", function() {
        return Tt;
      }), r.d(d, "ATTRS", function() {
        return sl;
      }), r.d(d, "DOCUMENT_MODE", function() {
        return bo;
      }), r.d(d, "TAG_NAMES", function() {
        return ht;
      }), r.d(d, "TAG_ID", function() {
        return re;
      }), r.d(d, "getTagID", function() {
        return Cu;
      }), r.d(d, "SPECIAL_ELEMENTS", function() {
        return Td;
      }), r.d(d, "isNumberedHeader", function() {
        return ll;
      }), r.d(d, "hasUnescapedText", function() {
        return jf;
      });
      var g = { xml: !1, decodeEntities: !0 }, _ = { _useHtmlParser2: !0, xmlMode: !0 };
      function b(M) {
        return M != null && M.xml ? typeof M.xml == "boolean" ? _ : p(p({}, _), M.xml) : M ?? void 0;
      }
      var v = r(3);
      function E(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function C(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? E(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = function(Fe) {
                return Fe = function(Je, pt) {
                  if (y(Je) != "object" || !Je) return Je;
                  var Nt = Je[Symbol.toPrimitive];
                  if (Nt === void 0) return (pt === "string" ? String : Number)(Je);
                  if (y(pt = Nt.call(Je, pt || "default")) != "object") return pt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(Fe, "string"), y(Fe) == "symbol" ? Fe : String(Fe);
              }(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : E(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      function y(M) {
        return (y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function T(M, O, w) {
        return M ? M(O ?? M._root.children, null, void 0, w).toString() : "";
      }
      function A(M, O) {
        return T(this, function(R, W) {
          return !(W || y(R) !== "object" || R == null || "length" in R || "type" in R);
        }(M) ? void (O = M) : M, C(C(C({}, g), this == null ? void 0 : this._options), b(O ?? {})));
      }
      function k(M) {
        return T(this, M, C(C({}, this._options), {}, { xmlMode: !0 }));
      }
      function N(M) {
        for (var O = M || (this ? this.root() : []), w = "", R = 0; R < O.length; R++) w += Object(v.textContent)(O[R]);
        return w;
      }
      function j(M, O) {
        var w = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : typeof O == "boolean" && O;
        return M && typeof M == "string" ? (typeof O == "boolean" && (w = O), M = this.load(M, g, !1), w || M("script").remove(), M.root()[0].children.slice()) : null;
      }
      function I() {
        return this(this._root);
      }
      function B(M, O) {
        if (O === M) return !1;
        for (var w = O; w && w !== w.parent; ) if ((w = w.parent) === M) return !0;
        return !1;
      }
      function U(M, O) {
        if (H(M) && H(O)) {
          for (var w = M.length, R = +O.length, W = 0; W < R; W++) M[w++] = O[W];
          return M.length = w, M;
        }
      }
      function H(M) {
        if (Array.isArray(M)) return 1;
        if (y(M) === "object" && Object.prototype.hasOwnProperty.call(M, "length") && typeof M.length == "number" && !(M.length < 0)) {
          for (var O = 0; O < M.length; O++) if (!(O in M)) return;
          return 1;
        }
      }
      var Q, Y = r(0);
      function ie(M) {
        return M.cheerio != null;
      }
      function ce(M, O) {
        for (var w = M.length, R = 0; R < w; R++) O(M[R], R);
        return M;
      }
      function $(O) {
        var O = "length" in O ? Array.prototype.map.call(O, function(R) {
          return Object(Y.g)(R, !0);
        }) : [Object(Y.g)(O, !0)], w = new Y.b(O);
        return O.forEach(function(R) {
          R.parent = w;
        }), O;
      }
      function te(M) {
        var O = M.indexOf("<");
        if (!(O < 0 || O > M.length - 3)) {
          var w = M.charCodeAt(O + 1);
          return (w >= Q.LowerA && w <= Q.LowerZ || w >= Q.UpperA && w <= Q.UpperZ || w === Q.Exclamation) && M.includes(">", O + 2);
        }
      }
      function V(M) {
        return (V = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      (Ur = Q = Q || {})[Ur.LowerA = 97] = "LowerA", Ur[Ur.LowerZ = 122] = "LowerZ", Ur[Ur.UpperA = 65] = "UpperA", Ur[Ur.UpperZ = 90] = "UpperZ", Ur[Ur.Exclamation = 33] = "Exclamation";
      var K, ne, J = Object.prototype.hasOwnProperty, L = /\s+/, z = "data-", ee = { null: null, true: !0, false: !1 }, q = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, X = /^{[^]*}$|^\[[^]*]$/;
      function oe(M, O, w) {
        var R;
        if (M && Object(Y.m)(M)) return (R = M.attribs) !== null && R !== void 0 || (M.attribs = {}), O ? J.call(M.attribs, O) ? !w && q.test(O) ? O : M.attribs[O] : M.name === "option" && O === "value" ? N(M.children) : M.name !== "input" || M.attribs.type !== "radio" && M.attribs.type !== "checkbox" || O !== "value" ? void 0 : "on" : M.attribs;
      }
      function ae(M, O, w) {
        w === null ? Ge(M, O) : M.attribs[O] = "".concat(w);
      }
      function _e(M, O) {
        if (V(M) !== "object" && O === void 0) return 1 < arguments.length ? this : oe(this[0], M, this.options.xmlMode);
        if (typeof O != "function") return ce(this, function(w) {
          Object(Y.m)(w) && (V(M) === "object" ? Object.keys(M).forEach(function(R) {
            var W = M[R];
            ae(w, R, W);
          }) : ae(w, M, O));
        });
        if (typeof M != "string") throw new Error("Bad combination of arguments.");
        return ce(this, function(w, R) {
          Object(Y.m)(w) && ae(w, M, O.call(w, R, w.attribs[M]));
        });
      }
      function ve(M, O, w) {
        return O in M ? M[O] : !w && q.test(O) ? oe(M, O, !1) !== void 0 : oe(M, O, w);
      }
      function Ee(M, O, w, R) {
        O in M ? M[O] = w : ae(M, O, !R && q.test(O) ? w ? "" : null : "".concat(w));
      }
      function we(M, O) {
        var w = this;
        if (typeof M == "string" && O === void 0) {
          var R = this[0];
          if (!R || !Object(Y.m)(R)) return;
          switch (M) {
            case "style":
              var W = this.css(), ue = Object.keys(W);
              return ue.forEach(function(me, Ae) {
                W[Ae] = me;
              }), W.length = ue.length, W;
            case "tagName":
            case "nodeName":
              return R.name.toUpperCase();
            case "href":
            case "src":
              return ue = (ue = R.attribs) === null || ue === void 0 ? void 0 : ue[M], typeof URL > "u" || (M !== "href" || R.tagName !== "a" && R.name !== "link") && (M !== "src" || R.tagName !== "img" && R.tagName !== "iframe" && R.tagName !== "audio" && R.tagName !== "video" && R.tagName !== "source") || ue === void 0 || !this.options.baseURI ? ue : new URL(ue, this.options.baseURI).href;
            case "innerText":
              return Object(v.innerText)(R);
            case "textContent":
              return Object(v.textContent)(R);
            case "outerHTML":
              return this.clone().wrap("<container />").parent().html();
            case "innerHTML":
              return this.html();
            default:
              return ve(R, M, this.options.xmlMode);
          }
        }
        if (V(M) === "object" || O !== void 0) {
          if (typeof O != "function") return ce(this, function(me) {
            Object(Y.m)(me) && (V(M) === "object" ? Object.keys(M).forEach(function(Ae) {
              var Ne = M[Ae];
              Ee(me, Ae, Ne, w.options.xmlMode);
            }) : Ee(me, M, O, w.options.xmlMode));
          });
          if (V(M) === "object") throw new Error("Bad combination of arguments.");
          return ce(this, function(me, Ae) {
            Object(Y.m)(me) && Ee(me, M, O.call(me, Ae, ve(me, M, w.options.xmlMode)), w.options.xmlMode);
          });
        }
      }
      function ze(M, O, w) {
        var R = M;
        (M = R.data) !== null && M !== void 0 || (R.data = {}), V(O) === "object" ? Object.assign(R.data, O) : typeof O == "string" && w !== void 0 && (R.data[O] = w);
      }
      function Ie(M, O) {
        for (var w, R, W = O == null ? (w = Object.keys(M.attribs).filter(function(Ne) {
          return Ne.startsWith(z);
        })).map(function(Ne) {
          return function(ut) {
            return ut.replace(/[_.-](\w|$)/g, function(Je, pt) {
              return pt.toUpperCase();
            });
          }(Ne.slice(z.length));
        }) : (w = [z + function(Fe) {
          return Fe.replace(/[A-Z]/g, "-$&").toLowerCase();
        }(O)], [O]), ue = 0; ue < w.length; ++ue) {
          var me = w[ue], Ae = W[ue];
          if (J.call(M.attribs, me) && !J.call(M.data, Ae)) {
            if (R = M.attribs[me], J.call(ee, R)) R = ee[R];
            else if (R === String(Number(R))) R = Number(R);
            else if (X.test(R)) try {
              R = JSON.parse(R);
            } catch {
            }
            M.data[Ae] = R;
          }
        }
        return O == null ? M.data : R;
      }
      function je(M, O) {
        var w = this[0];
        if (w && Object(Y.m)(w)) {
          var R = w;
          return (w = R.data) !== null && w !== void 0 || (R.data = {}), M ? V(M) === "object" || O !== void 0 ? (ce(this, function(W) {
            Object(Y.m)(W) && (V(M) === "object" ? ze(W, M) : ze(W, M, O));
          }), this) : J.call(R.data, M) ? R.data[M] : Ie(R, M) : Ie(R);
        }
      }
      function qe(M) {
        var O = arguments.length === 0, w = this[0];
        if (!w || !Object(Y.m)(w)) return O ? void 0 : this;
        switch (w.name) {
          case "textarea":
            return this.text(M);
          case "select":
            var R = this.find("option:selected");
            if (O) return this.attr("multiple") ? R.toArray().map(function(me) {
              return N(me.children);
            }) : R.attr("value");
            if (this.attr("multiple") == null && V(M) === "object") return this;
            this.find("option").removeAttr("selected");
            for (var W = V(M) !== "object" ? [M] : M, ue = 0; ue < W.length; ue++) this.find('option[value="'.concat(W[ue], '"]')).attr("selected", "");
            return this;
          case "input":
          case "option":
            return O ? this.attr("value") : this.attr("value", M);
        }
      }
      function Ge(M, O) {
        M.attribs && J.call(M.attribs, O) && delete M.attribs[O];
      }
      function Ze(M) {
        return M ? M.trim().split(L) : [];
      }
      function tt(M) {
        for (var O = this, w = Ze(M), R = function(me) {
          ce(O, function(Ae) {
            Object(Y.m)(Ae) && Ge(Ae, w[me]);
          });
        }, W = 0; W < w.length; W++) R(W);
        return this;
      }
      function Qe(M) {
        return this.toArray().some(function(O) {
          var w = Object(Y.m)(O) && O.attribs.class, R = -1;
          if (w && M.length) for (; -1 < (R = w.indexOf(M, R + 1)); ) {
            var W = R + M.length;
            if ((R === 0 || L.test(w[R - 1])) && (W === w.length || L.test(w[W]))) return !0;
          }
          return !1;
        });
      }
      function ke(M) {
        if (typeof M == "function") return ce(this, function(Fe, ut) {
          var Je;
          Object(Y.m)(Fe) && (Je = Fe.attribs.class || "", ke.call([Fe], M.call(Fe, ut, Je)));
        });
        if (!M || typeof M != "string") return this;
        for (var O = M.split(L), w = this.length, R = 0; R < w; R++) {
          var W = this[R];
          if (Object(Y.m)(W)) {
            var ue = oe(W, "class", !1);
            if (ue) {
              for (var me = " ".concat(ue, " "), Ae = 0; Ae < O.length; Ae++) {
                var Ne = "".concat(O[Ae], " ");
                me.includes(" ".concat(Ne)) || (me += Ne);
              }
              ae(W, "class", me.trim());
            } else ae(W, "class", O.join(" ").trim());
          }
        }
        return this;
      }
      function pe(M) {
        if (typeof M == "function") return ce(this, function(W, ue) {
          Object(Y.m)(W) && pe.call([W], M.call(W, ue, W.attribs.class || ""));
        });
        var O = Ze(M), w = O.length, R = arguments.length === 0;
        return ce(this, function(W) {
          if (Object(Y.m)(W)) if (R) W.attribs.class = "";
          else {
            for (var ue = Ze(W.attribs.class), me = !1, Ae = 0; Ae < w; Ae++) {
              var Ne = ue.indexOf(O[Ae]);
              0 <= Ne && (ue.splice(Ne, 1), me = !0, Ae--);
            }
            me && (W.attribs.class = ue.join(" "));
          }
        });
      }
      function Se(M, O) {
        if (typeof M == "function") return ce(this, function(Je, pt) {
          Object(Y.m)(Je) && Se.call([Je], M.call(Je, pt, Je.attribs.class || "", O), O);
        });
        if (!M || typeof M != "string") return this;
        for (var w = M.split(L), R = w.length, W = typeof O == "boolean" ? O ? 1 : -1 : 0, ue = this.length, me = 0; me < ue; me++) {
          var Ae = this[me];
          if (Object(Y.m)(Ae)) {
            for (var Ne = Ze(Ae.attribs.class), Fe = 0; Fe < R; Fe++) {
              var ut = Ne.indexOf(w[Fe]);
              0 <= W && ut < 0 ? Ne.push(w[Fe]) : W <= 0 && 0 <= ut && Ne.splice(ut, 1);
            }
            Ae.attribs.class = Ne.join(" ");
          }
        }
        return this;
      }
      function he(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      (vi = K = K || {}).Attribute = "attribute", vi.Pseudo = "pseudo", vi.PseudoElement = "pseudo-element", vi.Tag = "tag", vi.Universal = "universal", vi.Adjacent = "adjacent", vi.Child = "child", vi.Descendant = "descendant", vi.Parent = "parent", vi.Sibling = "sibling", vi.ColumnCombinator = "column-combinator", (Ur = ne = ne || {}).Any = "any", Ur.Element = "element", Ur.End = "end", Ur.Equals = "equals", Ur.Exists = "exists", Ur.Hyphen = "hyphen", Ur.Not = "not", Ur.Start = "start";
      var Te = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, Me = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, Ye = /* @__PURE__ */ new Map([[126, ne.Element], [94, ne.Start], [36, ne.End], [42, ne.Any], [33, ne.Not], [124, ne.Hyphen]]), et = /* @__PURE__ */ new Set(["has", "not", "matches", "is", "where", "host", "host-context"]);
      function dt(M) {
        switch (M.type) {
          case K.Adjacent:
          case K.Child:
          case K.Descendant:
          case K.Parent:
          case K.Sibling:
          case K.ColumnCombinator:
            return !0;
          default:
            return !1;
        }
      }
      var We = /* @__PURE__ */ new Set(["contains", "icontains"]);
      function nt(M, O, w) {
        var R = parseInt(O, 16) - 65536;
        return R != R || w ? O : R < 0 ? String.fromCharCode(65536 + R) : String.fromCharCode(R >> 10 | 55296, 1023 & R | 56320);
      }
      function ft(M) {
        return M.replace(Me, nt);
      }
      function At(M) {
        return M === 39 || M === 34;
      }
      function ln(M) {
        return M === 32 || M === 9 || M === 10 || M === 12 || M === 13;
      }
      function Jt(M) {
        var O = [], w = function R(W, ue, me) {
          var Ae = [];
          function Ne(Pn) {
            if (!(kr = ue.slice(me + Pn).match(Te))) throw new Error("Expected name, found ".concat(ue.slice(me)));
            var kr = (kr = function(la, no) {
              return function(jr) {
                if (Array.isArray(jr)) return jr;
              }(la) || function(jr, gi) {
                var Wi = jr == null ? null : typeof Symbol < "u" && jr[Symbol.iterator] || jr["@@iterator"];
                if (Wi != null) {
                  var Gr, Ud, Vo, gl, _l = [], Zf = !0, yp = !1;
                  try {
                    if (Vo = (Wi = Wi.call(jr)).next, gi !== 0) for (; !(Zf = (Gr = Vo.call(Wi)).done) && (_l.push(Gr.value), _l.length !== gi); Zf = !0) ;
                  } catch (Vm) {
                    yp = !0, Ud = Vm;
                  } finally {
                    try {
                      if (!Zf && Wi.return != null && (gl = Wi.return(), Object(gl) !== gl)) return;
                    } finally {
                      if (yp) throw Ud;
                    }
                  }
                  return _l;
                }
              }(la, no) || function(jr, gi) {
                if (jr) {
                  if (typeof jr == "string") return he(jr, gi);
                  var Wi = Object.prototype.toString.call(jr).slice(8, -1);
                  return (Wi = Wi === "Object" && jr.constructor ? jr.constructor.name : Wi) === "Map" || Wi === "Set" ? Array.from(jr) : Wi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Wi) ? he(jr, gi) : void 0;
                }
              }(la, no) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }(kr, 1))[0];
            return me += Pn + kr.length, ft(kr);
          }
          function Fe(Pn) {
            for (me += Pn; me < ue.length && ln(ue.charCodeAt(me)); ) me++;
          }
          function ut() {
            for (var Pn = me += 1, kr = 1; 0 < kr && me < ue.length; me++) ue.charCodeAt(me) !== 40 || Je(me) ? ue.charCodeAt(me) !== 41 || Je(me) || kr-- : kr++;
            if (kr) throw new Error("Parenthesis not matched");
            return ft(ue.slice(Pn, me - 1));
          }
          function Je(Pn) {
            for (var kr = 0; ue.charCodeAt(--Pn) === 92; ) kr++;
            return (1 & kr) == 1;
          }
          function pt() {
            if (0 < Ae.length && dt(Ae[Ae.length - 1])) throw new Error("Did not expect successive traversals.");
          }
          function Nt(Pn) {
            0 < Ae.length && Ae[Ae.length - 1].type === K.Descendant ? Ae[Ae.length - 1].type = Pn : (pt(), Ae.push({ type: Pn }));
          }
          function Bt(Pn, kr) {
            Ae.push({ type: K.Attribute, name: Pn, action: kr, value: Ne(1), namespace: null, ignoreCase: "quirks" });
          }
          function Qt() {
            if (Ae.length && Ae[Ae.length - 1].type === K.Descendant && Ae.pop(), Ae.length === 0) throw new Error("Empty sub-selector");
            W.push(Ae);
          }
          if (Fe(0), ue.length === me) return me;
          e: for (; me < ue.length; ) {
            var Cn = ue.charCodeAt(me);
            switch (Cn) {
              case 32:
              case 9:
              case 10:
              case 12:
              case 13:
                Ae.length !== 0 && Ae[0].type === K.Descendant || (pt(), Ae.push({ type: K.Descendant })), Fe(1);
                break;
              case 62:
                Nt(K.Child), Fe(1);
                break;
              case 60:
                Nt(K.Parent), Fe(1);
                break;
              case 126:
                Nt(K.Sibling), Fe(1);
                break;
              case 43:
                Nt(K.Adjacent), Fe(1);
                break;
              case 46:
                Bt("class", ne.Element);
                break;
              case 35:
                Bt("id", ne.Equals);
                break;
              case 91:
                Fe(1);
                var mn = void 0, kn = null;
                ue.charCodeAt(me) === 124 ? mn = Ne(1) : ue.startsWith("*|", me) ? (kn = "*", mn = Ne(2)) : (mn = Ne(0), ue.charCodeAt(me) === 124 && ue.charCodeAt(me + 1) !== 61 && (kn = mn, mn = Ne(1))), Fe(0);
                var Zn = ne.Exists;
                if (cr = Ye.get(ue.charCodeAt(me))) {
                  if (Zn = cr, ue.charCodeAt(me + 1) !== 61) throw new Error("Expected `=`");
                  Fe(2);
                } else ue.charCodeAt(me) === 61 && (Zn = ne.Equals, Fe(1));
                var Dr = "", cr = null;
                if (Zn !== "exists") {
                  if (At(ue.charCodeAt(me))) {
                    for (var Kr = ue.charCodeAt(me), Nn = me + 1; Nn < ue.length && (ue.charCodeAt(Nn) !== Kr || Je(Nn)); ) Nn += 1;
                    if (ue.charCodeAt(Nn) !== Kr) throw new Error("Attribute value didn't end");
                    Dr = ft(ue.slice(me + 1, Nn)), me = Nn + 1;
                  } else {
                    for (var Oi = me; me < ue.length && (!ln(ue.charCodeAt(me)) && ue.charCodeAt(me) !== 93 || Je(me)); ) me += 1;
                    Dr = ft(ue.slice(Oi, me));
                  }
                  Fe(0), (Oi = 32 | ue.charCodeAt(me)) == 115 ? (cr = !1, Fe(1)) : Oi == 105 && (cr = !0, Fe(1));
                }
                if (ue.charCodeAt(me) !== 93) throw new Error("Attribute selector didn't terminate");
                me += 1, kn = { type: K.Attribute, name: mn, action: Zn, value: Dr, namespace: kn, ignoreCase: cr }, Ae.push(kn);
                break;
              case 58:
                if (ue.charCodeAt(me + 1) === 58) {
                  Ae.push({ type: K.PseudoElement, name: Ne(2).toLowerCase(), data: ue.charCodeAt(me) === 40 ? ut() : null });
                  continue;
                }
                var cr = Ne(1).toLowerCase(), zr = null;
                if (ue.charCodeAt(me) === 40) if (et.has(cr)) {
                  if (At(ue.charCodeAt(me + 1))) throw new Error("Pseudo-selector ".concat(cr, " cannot be quoted"));
                  if (me = R(zr = [], ue, me + 1), ue.charCodeAt(me) !== 41) throw new Error("Missing closing parenthesis in :".concat(cr, " (").concat(ue, ")"));
                  me += 1;
                } else zr = ut(), !We.has(cr) || (kn = zr.charCodeAt(0)) === zr.charCodeAt(zr.length - 1) && At(kn) && (zr = zr.slice(1, -1)), zr = ft(zr);
                Ae.push({ type: K.Pseudo, name: cr, data: zr });
                break;
              case 44:
                Qt(), Ae = [], Fe(1);
                break;
              default:
                if (ue.startsWith("/*", me)) {
                  if ((zr = ue.indexOf("*/", me + 2)) < 0) throw new Error("Comment was not terminated");
                  me = zr + 2, Ae.length === 0 && Fe(0);
                  break;
                }
                var To = null, tr = void 0;
                if (Cn === 42) me += 1, tr = "*";
                else if (Cn === 124) {
                  if (tr = "", ue.charCodeAt(me + 1) === 124) {
                    Nt(K.ColumnCombinator), Fe(2);
                    break;
                  }
                } else {
                  if (!Te.test(ue.slice(me))) break e;
                  tr = Ne(0);
                }
                ue.charCodeAt(me) === 124 && ue.charCodeAt(me + 1) !== 124 && (To = tr, ue.charCodeAt(me + 1) === 42 ? (tr = "*", me += 2) : tr = Ne(1)), Ae.push(tr === "*" ? { type: K.Universal, namespace: To } : { type: K.Tag, name: tr, namespace: To });
            }
          }
          return Qt(), me;
        }(O, "".concat(M), 0);
        if (w < M.length) throw new Error("Unmatched selector: ".concat(M.slice(w)));
        return O;
      }
      var zt = r(2), kt = r.n(zt);
      function Ft(M) {
        return function(w) {
          if (Array.isArray(w)) return ar(w);
        }(M) || function(w) {
          if (typeof Symbol < "u" && w[Symbol.iterator] != null || w["@@iterator"] != null) return Array.from(w);
        }(M) || function(w, R) {
          if (w) {
            if (typeof w == "string") return ar(w, R);
            var W = Object.prototype.toString.call(w).slice(8, -1);
            return (W = W === "Object" && w.constructor ? w.constructor.name : W) === "Map" || W === "Set" ? Array.from(w) : W === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(W) ? ar(w, R) : void 0;
          }
        }(M) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function ar(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var In = /* @__PURE__ */ new Map([[K.Universal, 50], [K.Tag, 30], [K.Attribute, 1], [K.Pseudo, 0]]);
      function On(M) {
        return !In.has(M.type);
      }
      var ui = /* @__PURE__ */ new Map([[ne.Exists, 10], [ne.Equals, 8], [ne.Not, 7], [ne.Start, 6], [ne.End, 6], [ne.Any, 5]]);
      function Fr(M) {
        for (var O = M.map(er), w = 1; w < M.length; w++) {
          var R = O[w];
          if (!(R < 0)) for (var W = w - 1; 0 <= W && R < O[W]; W--) {
            var ue = M[W + 1];
            M[W + 1] = M[W], M[W] = ue, O[W + 1] = O[W], O[W] = R;
          }
        }
      }
      function er(M) {
        var O, w = (O = In.get(M.type)) !== null && O !== void 0 ? O : -1;
        return M.type === K.Attribute ? (w = (O = ui.get(M.action)) !== null && O !== void 0 ? O : 4, M.action === ne.Equals && M.name === "id" && (w = 9), M.ignoreCase && (w >>= 1)) : M.type === K.Pseudo && (M.data ? M.name === "has" || M.name === "contains" ? w = 0 : Array.isArray(M.data) ? (w = Math.min.apply(Math, Ft(M.data.map(function(R) {
          return Math.min.apply(Math, Ft(R.map(er)));
        })))) < 0 && (w = 0) : w = 2 : w = 3), w;
      }
      var $n = /[-[\]{}()*+?.,\\^$|#\s]/g;
      function un(M) {
        return M.replace($n, "\\$&");
      }
      var en = /* @__PURE__ */ new Set(["accept", "accept-charset", "align", "alink", "axis", "bgcolor", "charset", "checked", "clear", "codetype", "color", "compact", "declare", "defer", "dir", "direction", "disabled", "enctype", "face", "frame", "hreflang", "http-equiv", "lang", "language", "link", "media", "method", "multiple", "nohref", "noresize", "noshade", "nowrap", "readonly", "rel", "rev", "rules", "scope", "scrolling", "selected", "shape", "target", "text", "type", "valign", "valuetype", "vlink"]);
      function bt(M, O) {
        return typeof M.ignoreCase == "boolean" ? M.ignoreCase : M.ignoreCase === "quirks" ? O.quirksMode : !O.xmlMode && en.has(M.name);
      }
      var Pt = { equals: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value;
        return bt(w, R) ? (me = me.toLowerCase(), function(Ae) {
          var Ne = W.getAttributeValue(Ae, ue);
          return Ne != null && Ne.length === me.length && Ne.toLowerCase() === me && O(Ae);
        }) : function(Ae) {
          return W.getAttributeValue(Ae, ue) === me && O(Ae);
        };
      }, hyphen: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value, Ae = me.length;
        return bt(w, R) ? (me = me.toLowerCase(), function(Fe) {
          var ut = W.getAttributeValue(Fe, ue);
          return ut != null && (ut.length === Ae || ut.charAt(Ae) === "-") && ut.substr(0, Ae).toLowerCase() === me && O(Fe);
        }) : function(Fe) {
          var ut = W.getAttributeValue(Fe, ue);
          return ut != null && (ut.length === Ae || ut.charAt(Ae) === "-") && ut.substr(0, Ae) === me && O(Fe);
        };
      }, element: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value;
        if (/\s/.test(me)) return kt.a.falseFunc;
        var Ae = new RegExp("(?:^|\\s)".concat(un(me), "(?:$|\\s)"), bt(w, R) ? "i" : "");
        return function(Fe) {
          var ut = W.getAttributeValue(Fe, ue);
          return ut != null && ut.length >= me.length && Ae.test(ut) && O(Fe);
        };
      }, exists: function(O, w, R) {
        var W = w.name, ue = R.adapter;
        return function(me) {
          return ue.hasAttrib(me, W) && O(me);
        };
      }, start: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value, Ae = me.length;
        return Ae === 0 ? kt.a.falseFunc : bt(w, R) ? (me = me.toLowerCase(), function(Ne) {
          var Fe = W.getAttributeValue(Ne, ue);
          return Fe != null && Fe.length >= Ae && Fe.substr(0, Ae).toLowerCase() === me && O(Ne);
        }) : function(Ne) {
          var Fe;
          return !((Fe = W.getAttributeValue(Ne, ue)) === null || Fe === void 0 || !Fe.startsWith(me)) && O(Ne);
        };
      }, end: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value, Ae = -me.length;
        return Ae == 0 ? kt.a.falseFunc : bt(w, R) ? (me = me.toLowerCase(), function(Ne) {
          var Fe;
          return ((Fe = W.getAttributeValue(Ne, ue)) === null || Fe === void 0 ? void 0 : Fe.substr(Ae).toLowerCase()) === me && O(Ne);
        }) : function(Ne) {
          var Fe;
          return !((Fe = W.getAttributeValue(Ne, ue)) === null || Fe === void 0 || !Fe.endsWith(me)) && O(Ne);
        };
      }, any: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value;
        if (me === "") return kt.a.falseFunc;
        if (bt(w, R)) {
          var Ae = new RegExp(un(me), "i");
          return function(Fe) {
            var ut = W.getAttributeValue(Fe, ue);
            return ut != null && ut.length >= me.length && Ae.test(ut) && O(Fe);
          };
        }
        return function(Ne) {
          var Fe;
          return !((Fe = W.getAttributeValue(Ne, ue)) === null || Fe === void 0 || !Fe.includes(me)) && O(Ne);
        };
      }, not: function(O, w, R) {
        var W = R.adapter, ue = w.name, me = w.value;
        return me === "" ? function(Ae) {
          return !!W.getAttributeValue(Ae, ue) && O(Ae);
        } : bt(w, R) ? (me = me.toLowerCase(), function(Ae) {
          var Ne = W.getAttributeValue(Ae, ue);
          return (Ne == null || Ne.length !== me.length || Ne.toLowerCase() !== me) && O(Ae);
        }) : function(Ae) {
          return W.getAttributeValue(Ae, ue) !== me && O(Ae);
        };
      } }, fn = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), cn = 48, Vn = 57;
      function En(M) {
        return function(w) {
          var R = w[0], W = w[1] - 1;
          if (W < 0 && R <= 0) return kt.a.falseFunc;
          if (R === -1) return function(Ae) {
            return Ae <= W;
          };
          if (R === 0) return function(Ae) {
            return Ae === W;
          };
          if (R === 1) return W < 0 ? kt.a.trueFunc : function(Ae) {
            return W <= Ae;
          };
          var ue = Math.abs(R), me = (W % ue + ue) % ue;
          return 1 < R ? function(Ae) {
            return W <= Ae && Ae % ue == me;
          } : function(Ae) {
            return Ae <= W && Ae % ue == me;
          };
        }(function(w) {
          if ((w = w.trim().toLowerCase()) === "even") return [2, 0];
          if (w === "odd") return [2, 1];
          var R = 0, W = 0, ue = Ae(), me = Ne();
          if (R < w.length && w.charAt(R) === "n" && (R++, W = ue * (me ?? 1), Fe(), R < w.length ? (ue = Ae(), Fe(), me = Ne()) : ue = me = 0), me === null || R < w.length) throw new Error("n-th rule couldn't be parsed ('".concat(w, "')"));
          return [W, ue * me];
          function Ae() {
            return w.charAt(R) === "-" ? (R++, -1) : (w.charAt(R) === "+" && R++, 1);
          }
          function Ne() {
            for (var ut = R, Je = 0; R < w.length && w.charCodeAt(R) >= cn && w.charCodeAt(R) <= Vn; ) Je = 10 * Je + (w.charCodeAt(R) - cn), R++;
            return R === ut ? null : Je;
          }
          function Fe() {
            for (; R < w.length && fn.has(w.charCodeAt(R)); ) R++;
          }
        }(M));
      }
      function Kt(M, O) {
        return function(w) {
          var R = O.getParent(w);
          return R != null && O.isTag(R) && M(w);
        };
      }
      var Dn = { contains: function(O, w, R) {
        var W = R.adapter;
        return function(me) {
          return O(me) && W.getText(me).includes(w);
        };
      }, icontains: function(O, w, R) {
        var W = R.adapter, ue = w.toLowerCase();
        return function(Ae) {
          return O(Ae) && W.getText(Ae).toLowerCase().includes(ue);
        };
      }, "nth-child": function(O, w, R) {
        var W = R.adapter, ue = R.equals, me = En(w);
        return me === kt.a.falseFunc ? kt.a.falseFunc : me === kt.a.trueFunc ? Kt(O, W) : function(Ne) {
          for (var Fe = W.getSiblings(Ne), ut = 0, Je = 0; Je < Fe.length && !ue(Ne, Fe[Je]); Je++) W.isTag(Fe[Je]) && ut++;
          return me(ut) && O(Ne);
        };
      }, "nth-last-child": function(O, w, R) {
        var W = R.adapter, ue = R.equals, me = En(w);
        return me === kt.a.falseFunc ? kt.a.falseFunc : me === kt.a.trueFunc ? Kt(O, W) : function(Ne) {
          for (var Fe = W.getSiblings(Ne), ut = 0, Je = Fe.length - 1; 0 <= Je && !ue(Ne, Fe[Je]); Je--) W.isTag(Fe[Je]) && ut++;
          return me(ut) && O(Ne);
        };
      }, "nth-of-type": function(O, w, R) {
        var W = R.adapter, ue = R.equals, me = En(w);
        return me === kt.a.falseFunc ? kt.a.falseFunc : me === kt.a.trueFunc ? Kt(O, W) : function(Ne) {
          for (var Fe = W.getSiblings(Ne), ut = 0, Je = 0; Je < Fe.length; Je++) {
            var pt = Fe[Je];
            if (ue(Ne, pt)) break;
            W.isTag(pt) && W.getName(pt) === W.getName(Ne) && ut++;
          }
          return me(ut) && O(Ne);
        };
      }, "nth-last-of-type": function(O, w, R) {
        var W = R.adapter, ue = R.equals, me = En(w);
        return me === kt.a.falseFunc ? kt.a.falseFunc : me === kt.a.trueFunc ? Kt(O, W) : function(Ne) {
          for (var Fe = W.getSiblings(Ne), ut = 0, Je = Fe.length - 1; 0 <= Je; Je--) {
            var pt = Fe[Je];
            if (ue(Ne, pt)) break;
            W.isTag(pt) && W.getName(pt) === W.getName(Ne) && ut++;
          }
          return me(ut) && O(Ne);
        };
      }, root: function(O, w, R) {
        var W = R.adapter;
        return function(ue) {
          var me = W.getParent(ue);
          return (me == null || !W.isTag(me)) && O(ue);
        };
      }, scope: function(O, w, R, W) {
        var ue = R.equals;
        return W && W.length !== 0 ? W.length === 1 ? function(me) {
          return ue(W[0], me) && O(me);
        } : function(me) {
          return W.includes(me) && O(me);
        } : Dn.root(O, w, R);
      }, hover: Kn("isHovered"), visited: Kn("isVisited"), active: Kn("isActive") };
      function Kn(M) {
        return function(w, R, W) {
          var ue = W.adapter[M];
          return typeof ue != "function" ? kt.a.falseFunc : function(Ae) {
            return ue(Ae) && w(Ae);
          };
        };
      }
      var vr = { empty: function(O, w) {
        var R = w.adapter;
        return !R.getChildren(O).some(function(W) {
          return R.isTag(W) || R.getText(W) !== "";
        });
      }, "first-child": function(O, ue) {
        var R, W = ue.adapter, ue = ue.equals;
        return W.prevElementSibling ? W.prevElementSibling(O) == null : (R = W.getSiblings(O).find(function(me) {
          return W.isTag(me);
        })) != null && ue(O, R);
      }, "last-child": function(O, w) {
        for (var R = w.adapter, W = w.equals, ue = R.getSiblings(O), me = ue.length - 1; 0 <= me; me--) {
          if (W(O, ue[me])) return !0;
          if (R.isTag(ue[me])) break;
        }
        return !1;
      }, "first-of-type": function(O, w) {
        for (var R = w.adapter, W = w.equals, ue = R.getSiblings(O), me = R.getName(O), Ae = 0; Ae < ue.length; Ae++) {
          var Ne = ue[Ae];
          if (W(O, Ne)) return !0;
          if (R.isTag(Ne) && R.getName(Ne) === me) break;
        }
        return !1;
      }, "last-of-type": function(O, w) {
        for (var R = w.adapter, W = w.equals, ue = R.getSiblings(O), me = R.getName(O), Ae = ue.length - 1; 0 <= Ae; Ae--) {
          var Ne = ue[Ae];
          if (W(O, Ne)) return !0;
          if (R.isTag(Ne) && R.getName(Ne) === me) break;
        }
        return !1;
      }, "only-of-type": function(O, w) {
        var R = w.adapter, W = w.equals, ue = R.getName(O);
        return R.getSiblings(O).every(function(me) {
          return W(O, me) || !R.isTag(me) || R.getName(me) !== ue;
        });
      }, "only-child": function(O, w) {
        var R = w.adapter, W = w.equals;
        return R.getSiblings(O).every(function(ue) {
          return W(O, ue) || !R.isTag(ue);
        });
      } };
      function Ii(M, O, w, R) {
        if (w === null) {
          if (M.length > R) throw new Error("Pseudo-class :".concat(O, " requires an argument"));
        } else if (M.length === R) throw new Error("Pseudo-class :".concat(O, " doesn't have any arguments"));
      }
      var vo = { "any-link": ":is(a, area, link)[href]", link: ":any-link:not(:visited)", disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`, enabled: ":not(:disabled)", checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)", required: ":is(input, select, textarea)[required]", optional: ":is(input, select, textarea):not([required])", selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)", checkbox: "[type=checkbox]", file: "[type=file]", password: "[type=password]", radio: "[type=radio]", reset: "[type=reset]", image: "[type=image]", submit: "[type=submit]", parent: ":not(:empty)", header: ":is(h1, h2, h3, h4, h5, h6)", button: ":is(button, input[type=button])", input: ":is(input, textarea, select, button)", text: "input:is(:not([type!='']), [type=text])" };
      function qr(M) {
        return function(w) {
          if (Array.isArray(w)) return _r(w);
        }(M) || function(w) {
          if (typeof Symbol < "u" && w[Symbol.iterator] != null || w["@@iterator"] != null) return Array.from(w);
        }(M) || function(w, R) {
          if (w) {
            if (typeof w == "string") return _r(w, R);
            var W = Object.prototype.toString.call(w).slice(8, -1);
            return (W = W === "Object" && w.constructor ? w.constructor.name : W) === "Map" || W === "Set" ? Array.from(w) : W === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(W) ? _r(w, R) : void 0;
          }
        }(M) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function _r(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var sr = {};
      function br(M, O) {
        return M === kt.a.falseFunc ? kt.a.falseFunc : function(w) {
          return O.isTag(w) && M(w);
        };
      }
      function ao(M, O) {
        var w = O.getSiblings(M);
        return w.length <= 1 || (M = w.indexOf(M)) < 0 || M === w.length - 1 ? [] : w.slice(M + 1).filter(O.isTag);
      }
      function Zi(M) {
        return { xmlMode: !!M.xmlMode, lowerCaseAttributeNames: !!M.lowerCaseAttributeNames, lowerCaseTags: !!M.lowerCaseTags, quirksMode: !!M.quirksMode, cacheResults: !!M.cacheResults, pseudos: M.pseudos, adapter: M.adapter, equals: M.equals };
      }
      var di = { is: vi = function(O, w, R, W, ue) {
        var me = ue(w, Zi(R), W);
        return me === kt.a.trueFunc ? O : me === kt.a.falseFunc ? kt.a.falseFunc : function(Ae) {
          return me(Ae) && O(Ae);
        };
      }, matches: vi, where: vi, not: function(O, w, R, W, ue) {
        var me = ue(w, Zi(R), W);
        return me === kt.a.falseFunc ? O : me === kt.a.trueFunc ? kt.a.falseFunc : function(Ae) {
          return !me(Ae) && O(Ae);
        };
      }, has: function(O, w, R, W, ue) {
        var me = R.adapter;
        (R = Zi(R)).relativeSelector = !0;
        var Ae = w.some(function(ut) {
          return ut.some(On);
        }) ? [sr] : void 0;
        if ((R = ue(w, R, Ae)) === kt.a.falseFunc) return kt.a.falseFunc;
        var Ne = br(R, me);
        if (Ae && R !== kt.a.trueFunc) {
          var Fe = (R = R.shouldTestNextSiblings) !== void 0 && R;
          return function(ut) {
            if (!O(ut)) return !1;
            Ae[0] = ut;
            var Je = me.getChildren(ut), Je = Fe ? [].concat(qr(Je), qr(ao(ut, me))) : Je;
            return me.existsOne(Ne, Je);
          };
        }
        return function(ut) {
          return O(ut) && me.existsOne(Ne, me.getChildren(ut));
        };
      } };
      function Lo(M, O) {
        return (M = O.getParent(M)) && O.isTag(M) ? M : null;
      }
      function La(M, O) {
        if (M) {
          if (typeof M == "string") return Ai(M, O);
          var w = Object.prototype.toString.call(M).slice(8, -1);
          return (w = w === "Object" && M.constructor ? M.constructor.name : w) === "Map" || w === "Set" ? Array.from(M) : w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w) ? Ai(M, O) : void 0;
        }
      }
      function Ai(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      function fr(M, O, w) {
        return lc(typeof M == "string" ? Jt(M) : M, O, w);
      }
      function Ma(M) {
        return M.type === K.Pseudo && (M.name === "scope" || Array.isArray(M.data) && M.data.some(function(O) {
          return O.some(Ma);
        }));
      }
      var pa = { type: K.Descendant }, Qn = { type: "_flexibleDescendant" }, Pa = { type: K.Pseudo, name: "scope", data: null };
      function lc(M, O, w) {
        var R;
        M.forEach(Fr), w = (R = O.context) !== null && R !== void 0 ? R : w;
        var W = Array.isArray(w), ue = w && (Array.isArray(w) ? w : [w]);
        if (O.relativeSelector !== !1) (function(Ne, Fe, ut) {
          var Je, pt = Fe.adapter, Nt = !(ut == null || !ut.every(function(Cn) {
            var mn = pt.isTag(Cn) && pt.getParent(Cn);
            return Cn === sr || mn && pt.isTag(mn);
          })), Bt = function(mn, kn) {
            var Zn = typeof Symbol < "u" && mn[Symbol.iterator] || mn["@@iterator"];
            if (!Zn) {
              if (Array.isArray(mn) || (Zn = La(mn)) || kn && mn && typeof mn.length == "number") {
                Zn && (mn = Zn);
                var Dr = 0;
                return { s: kn = function() {
                }, n: function() {
                  return Dr >= mn.length ? { done: !0 } : { done: !1, value: mn[Dr++] };
                }, e: function(zr) {
                  throw zr;
                }, f: kn };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var Kr, Nn = !0, Oi = !1;
            return { s: function() {
              Zn = Zn.call(mn);
            }, n: function() {
              var zr = Zn.next();
              return Nn = zr.done, zr;
            }, e: function(zr) {
              Oi = !0, Kr = zr;
            }, f: function() {
              try {
                Nn || Zn.return == null || Zn.return();
              } finally {
                if (Oi) throw Kr;
              }
            } };
          }(Ne);
          try {
            for (Bt.s(); !(Je = Bt.n()).done; ) {
              var Qt = Je.value;
              if (!(0 < Qt.length && On(Qt[0]) && Qt[0].type !== K.Descendant)) {
                if (!Nt || Qt.some(Ma)) continue;
                Qt.unshift(pa);
              }
              Qt.unshift(Pa);
            }
          } catch (Cn) {
            Bt.e(Cn);
          } finally {
            Bt.f();
          }
        })(M, O, ue);
        else if (M.some(function(Ae) {
          return 0 < Ae.length && On(Ae[0]);
        })) throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
        var me = !1;
        return (M = M.map(function(Ae) {
          var Ne, Fe;
          return 2 <= Ae.length && (Ne = (Fe = function(Je, pt) {
            return function(Bt) {
              if (Array.isArray(Bt)) return Bt;
            }(Je) || function(Bt, Qt) {
              var Cn = Bt == null ? null : typeof Symbol < "u" && Bt[Symbol.iterator] || Bt["@@iterator"];
              if (Cn != null) {
                var mn, kn, Zn, Dr, Kr = [], Nn = !0, Oi = !1;
                try {
                  if (Zn = (Cn = Cn.call(Bt)).next, Qt !== 0) for (; !(Nn = (mn = Zn.call(Cn)).done) && (Kr.push(mn.value), Kr.length !== Qt); Nn = !0) ;
                } catch (cr) {
                  Oi = !0, kn = cr;
                } finally {
                  try {
                    if (!Nn && Cn.return != null && (Dr = Cn.return(), Object(Dr) !== Dr)) return;
                  } finally {
                    if (Oi) throw kn;
                  }
                }
                return Kr;
              }
            }(Je, pt) || La(Je, pt) || function() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }(Ae, 2))[0], Fe = Fe[1], Ne.type !== K.Pseudo || Ne.name !== "scope" || (W && Fe.type === K.Descendant ? Ae[1] = Qn : Fe.type !== K.Adjacent && Fe.type !== K.Sibling || (me = !0))), function(Je, pt, Nt) {
            return Je.reduce(function(Bt, Qt) {
              return Bt === kt.a.falseFunc ? kt.a.falseFunc : function(mn, kn, Zn, Dr, Kr) {
                var Nn = Zn.adapter, Oi = Zn.equals;
                switch (kn.type) {
                  case K.PseudoElement:
                    throw new Error("Pseudo-elements are not supported by css-select");
                  case K.ColumnCombinator:
                    throw new Error("Column combinators are not yet supported by css-select");
                  case K.Attribute:
                    if (kn.namespace != null) throw new Error("Namespaced attributes are not yet supported by css-select");
                    return Zn.xmlMode && !Zn.lowerCaseAttributeNames || (kn.name = kn.name.toLowerCase()), Pt[kn.action](mn, kn, Zn);
                  case K.Pseudo:
                    return function(tr, Pn, kr, Ca, la) {
                      var no = Pn.name, ro = Pn.data;
                      if (Array.isArray(ro)) {
                        if (!(no in di)) throw new Error("Unknown pseudo-class :".concat(no, "(").concat(ro, ")"));
                        return di[no](tr, ro, kr, Ca, la);
                      }
                      var jr = (Pn = kr.pseudos) === null || Pn === void 0 ? void 0 : Pn[no];
                      if (typeof (Pn = typeof jr == "string" ? jr : vo[no]) == "string") {
                        if (ro != null) throw new Error("Pseudo ".concat(no, " doesn't have any arguments"));
                        return Pn = Jt(Pn), di.is(tr, Pn, kr, Ca, la);
                      }
                      if (typeof jr == "function") return Ii(jr, no, ro, 1), function(Wi) {
                        return jr(Wi, ro) && tr(Wi);
                      };
                      if (no in Dn) return Dn[no](tr, ro, kr, Ca);
                      if (no in vr) {
                        var gi = vr[no];
                        return Ii(gi, no, ro, 2), function(Wi) {
                          return gi(Wi, kr, ro) && tr(Wi);
                        };
                      }
                      throw new Error("Unknown pseudo-class :".concat(no));
                    }(mn, kn, Zn, Dr, Kr);
                  case K.Tag:
                    if (kn.namespace != null) throw new Error("Namespaced tag names are not yet supported by css-select");
                    var cr = kn.name;
                    return Zn.xmlMode && !Zn.lowerCaseTags || (cr = cr.toLowerCase()), function(tr) {
                      return Nn.getName(tr) === cr && mn(tr);
                    };
                  case K.Descendant:
                    if (Zn.cacheResults === !1 || typeof WeakSet > "u") return function(tr) {
                      for (var Pn = tr; Pn = Lo(Pn, Nn); ) if (mn(Pn)) return !0;
                      return !1;
                    };
                    var zr = /* @__PURE__ */ new WeakSet();
                    return function(tr) {
                      for (var Pn = tr; Pn = Lo(Pn, Nn); ) if (!zr.has(Pn)) {
                        if (Nn.isTag(Pn) && mn(Pn)) return !0;
                        zr.add(Pn);
                      }
                      return !1;
                    };
                  case "_flexibleDescendant":
                    return function(tr) {
                      var Pn = tr;
                      do
                        if (mn(Pn)) return !0;
                      while (Pn = Lo(Pn, Nn));
                      return !1;
                    };
                  case K.Parent:
                    return function(tr) {
                      return Nn.getChildren(tr).some(function(Pn) {
                        return Nn.isTag(Pn) && mn(Pn);
                      });
                    };
                  case K.Child:
                    return function(tr) {
                      return (tr = Nn.getParent(tr)) != null && Nn.isTag(tr) && mn(tr);
                    };
                  case K.Sibling:
                    return function(tr) {
                      for (var Pn = Nn.getSiblings(tr), kr = 0; kr < Pn.length; kr++) {
                        var Ca = Pn[kr];
                        if (Oi(tr, Ca)) break;
                        if (Nn.isTag(Ca) && mn(Ca)) return !0;
                      }
                      return !1;
                    };
                  case K.Adjacent:
                    return Nn.prevElementSibling ? function(tr) {
                      return (tr = Nn.prevElementSibling(tr)) != null && mn(tr);
                    } : function(tr) {
                      for (var Pn, kr = Nn.getSiblings(tr), Ca = 0; Ca < kr.length; Ca++) {
                        var la = kr[Ca];
                        if (Oi(tr, la)) break;
                        Nn.isTag(la) && (Pn = la);
                      }
                      return !!Pn && mn(Pn);
                    };
                  case K.Universal:
                    if (kn.namespace != null && kn.namespace !== "*") throw new Error("Namespaced universal selectors are not yet supported by css-select");
                    return mn;
                }
              }(Bt, Qt, pt, Nt, lc);
            }, (Je = pt.rootFunc) !== null && Je !== void 0 ? Je : kt.a.trueFunc);
          }(Ae, O, ue);
        }).reduce(ma, kt.a.falseFunc)).shouldTestNextSiblings = me, M;
      }
      function ma(M, O) {
        return O === kt.a.falseFunc || M === kt.a.trueFunc ? M : M === kt.a.falseFunc || O === kt.a.trueFunc ? O : function(R) {
          return M(R) || O(R);
        };
      }
      function vs(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var Li = function(O, w) {
        return O === w;
      }, uc = { adapter: v, equals: Li };
      function Mo(M) {
        var O = M ?? uc;
        return (M = O.adapter) !== null && M !== void 0 || (O.adapter = v), (M = O.equals) !== null && M !== void 0 || (O.equals = (M = (M = O.adapter) === null || M === void 0 ? void 0 : M.equals) !== null && M !== void 0 ? M : Li), O;
      }
      function xf(M) {
        return function(w, R, W) {
          return R = Mo(R), M(w, R, W);
        };
      }
      var cc = xf(lc);
      function Jh(M) {
        return function(w, R, W) {
          return W = Mo(W), typeof w != "function" && (w = fr(w, W, R)), R = bs(R, W.adapter, w.shouldTestNextSiblings), M(w, R, W);
        };
      }
      function bs(M, O, w) {
        return 2 < arguments.length && w !== void 0 && w && (M = function(W, ue) {
          for (var me = Array.isArray(W) ? W.slice(0) : [W], Ae = me.length, Ne = 0; Ne < Ae; Ne++) {
            var Fe = ao(me[Ne], ue);
            me.push.apply(me, function(Je) {
              return function(Nt) {
                if (Array.isArray(Nt)) return vs(Nt);
              }(Je) || function(Nt) {
                if (typeof Symbol < "u" && Nt[Symbol.iterator] != null || Nt["@@iterator"] != null) return Array.from(Nt);
              }(Je) || function(Nt, Bt) {
                if (Nt) {
                  if (typeof Nt == "string") return vs(Nt, Bt);
                  var Qt = Object.prototype.toString.call(Nt).slice(8, -1);
                  return (Qt = Qt === "Object" && Nt.constructor ? Nt.constructor.name : Qt) === "Map" || Qt === "Set" ? Array.from(Nt) : Qt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Qt) ? vs(Nt, Bt) : void 0;
                }
              }(Je) || function() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }(Fe));
          }
          return me;
        }(M, O)), Array.isArray(M) ? O.removeSubsets(M) : O.getChildren(M);
      }
      var Ur = Jh(function(M, O, w) {
        return M !== kt.a.falseFunc && O && O.length !== 0 ? w.adapter.findAll(M, O) : [];
      }), el = /* @__PURE__ */ new Set(["first", "last", "eq", "gt", "nth", "lt", "even", "odd"]);
      function so(M) {
        return M.type === "pseudo" && (!!el.has(M.name) || !(M.name !== "not" || !Array.isArray(M.data)) && M.data.some(function(O) {
          return O.some(so);
        }));
      }
      function tl(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      function ja(M) {
        var O, w = [], R = [], W = function(Ae, Ne) {
          var Fe = typeof Symbol < "u" && Ae[Symbol.iterator] || Ae["@@iterator"];
          if (!Fe) {
            if (Array.isArray(Ae) || (Fe = function(Qt, Cn) {
              if (Qt) {
                if (typeof Qt == "string") return tl(Qt, Cn);
                var mn = Object.prototype.toString.call(Qt).slice(8, -1);
                return (mn = mn === "Object" && Qt.constructor ? Qt.constructor.name : mn) === "Map" || mn === "Set" ? Array.from(Qt) : mn === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(mn) ? tl(Qt, Cn) : void 0;
              }
            }(Ae)) || Ne && Ae && typeof Ae.length == "number") {
              Fe && (Ae = Fe);
              var ut = 0;
              return { s: Ne = function() {
              }, n: function() {
                return ut >= Ae.length ? { done: !0 } : { done: !1, value: Ae[ut++] };
              }, e: function(Qt) {
                throw Qt;
              }, f: Ne };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var Je, pt = !0, Nt = !1;
          return { s: function() {
            Fe = Fe.call(Ae);
          }, n: function() {
            var Qt = Fe.next();
            return pt = Qt.done, Qt;
          }, e: function(Qt) {
            Nt = !0, Je = Qt;
          }, f: function() {
            try {
              pt || Fe.return == null || Fe.return();
            } finally {
              if (Nt) throw Je;
            }
          } };
        }(M);
        try {
          for (W.s(); !(O = W.n()).done; ) {
            var ue = O.value;
            (ue.some(so) ? w : R).push(ue);
          }
        } catch (me) {
          W.e(me);
        } finally {
          W.f();
        }
        return [R, w];
      }
      function Tl(M) {
        return (Tl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function ns(M) {
        return function(w) {
          if (Array.isArray(w)) return Er(w);
        }(M) || function(w) {
          if (typeof Symbol < "u" && w[Symbol.iterator] != null || w["@@iterator"] != null) return Array.from(w);
        }(M) || Al(M) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function dc(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function ra(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? dc(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = function(Fe) {
                return Fe = function(Je, pt) {
                  if (Tl(Je) != "object" || !Je) return Je;
                  var Nt = Je[Symbol.toPrimitive];
                  if (Nt === void 0) return (pt === "string" ? String : Number)(Je);
                  if (Tl(pt = Nt.call(Je, pt || "default")) != "object") return pt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(Fe, "string"), Tl(Fe) == "symbol" ? Fe : String(Fe);
              }(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : dc(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      function _d(M, O) {
        return function(R) {
          if (Array.isArray(R)) return R;
        }(M) || function(R, W) {
          var ue = R == null ? null : typeof Symbol < "u" && R[Symbol.iterator] || R["@@iterator"];
          if (ue != null) {
            var me, Ae, Ne, Fe, ut = [], Je = !0, pt = !1;
            try {
              if (Ne = (ue = ue.call(R)).next, W !== 0) for (; !(Je = (me = Ne.call(ue)).done) && (ut.push(me.value), ut.length !== W); Je = !0) ;
            } catch (Nt) {
              pt = !0, Ae = Nt;
            } finally {
              try {
                if (!Je && ue.return != null && (Fe = ue.return(), Object(Fe) !== Fe)) return;
              } finally {
                if (pt) throw Ae;
              }
            }
            return ut;
          }
        }(M, O) || Al(M, O) || function() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function Al(M, O) {
        if (M) {
          if (typeof M == "string") return Er(M, O);
          var w = Object.prototype.toString.call(M).slice(8, -1);
          return (w = w === "Object" && M.constructor ? M.constructor.name : w) === "Map" || w === "Set" ? Array.from(M) : w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w) ? Er(M, O) : void 0;
        }
      }
      function Er(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var yd = { type: K.Universal, namespace: null }, Tf = { type: K.Pseudo, name: "scope", data: null };
      function nl(M, O, w) {
        return ur([M], O, 2 < arguments.length && w !== void 0 ? w : {});
      }
      function ur(M, O, w) {
        var R = 2 < arguments.length && w !== void 0 ? w : {};
        return typeof O == "function" ? M.some(O) : (O = (w = _d(ja(Jt(O)), 2))[0], w = w[1], 0 < O.length && M.some(cc(O, R)) || w.some(function(W) {
          return 0 < Yn(W, M, R).length;
        }));
      }
      function vd(M, O, w) {
        return w = 2 < arguments.length && w !== void 0 ? w : {}, fc(Jt(M), O, w);
      }
      function fc(ue, O, w) {
        if (O.length === 0) return [];
        var R, W = _d(ja(ue), 2), ue = W[0], me = W[1];
        if (ue.length) {
          if (ue = lo(O, ue, w), me.length === 0) return ue;
          ue.length && (R = new Set(ue));
        }
        for (var Ae = 0; Ae < me.length && (R == null ? void 0 : R.size) !== O.length; Ae++) {
          var Ne = me[Ae];
          if ((R ? O.filter(function(Fe) {
            return v.isTag(Fe) && !R.has(Fe);
          }) : O).length === 0) break;
          if ((Ne = Yn(Ne, O, w)).length) if (R) Ne.forEach(function(Fe) {
            return R.add(Fe);
          });
          else {
            if (Ae === me.length - 1) return Ne;
            R = new Set(Ne);
          }
        }
        return R !== void 0 ? R.size === O.length ? O : O.filter(function(Fe) {
          return R.has(Fe);
        }) : [];
      }
      function Yn(M, O, w) {
        if (M.some(dt)) {
          var R = (W = w.root) !== null && W !== void 0 ? W : function(me) {
            for (; me.parent; ) me = me.parent;
            return me;
          }(O[0]), W = ra(ra({}, w), {}, { context: O, relativeSelector: !1 });
          return M.push(Tf), Es(R, M, W, !0, O.length);
        }
        return Es(O, M, w, !1, O.length);
      }
      function Es(M, O, w, R, W) {
        var ue = O.findIndex(so), me = O.slice(0, ue), Ae = O[ue], Ne = O.length - 1 === ue ? W : 1 / 0;
        if ((Ne = function(Je, pt, Nt) {
          var Bt = pt != null ? parseInt(pt, 10) : NaN;
          switch (Je) {
            case "first":
              return 1;
            case "nth":
            case "eq":
              return isFinite(Bt) ? 0 <= Bt ? Bt + 1 : 1 / 0 : 0;
            case "lt":
              return isFinite(Bt) ? 0 <= Bt ? Math.min(Bt, Nt) : 1 / 0 : 0;
            case "gt":
              return isFinite(Bt) ? 1 / 0 : 0;
            case "odd":
              return 2 * Nt;
            case "even":
              return 2 * Nt - 1;
            case "last":
            case "not":
              return 1 / 0;
          }
        }(Ae.name, Ae.data, Ne)) === 0) return [];
        var Ne = (me.length !== 0 || Array.isArray(M) ? me.length === 0 ? (Array.isArray(M) ? M : [M]).filter(v.isTag) : R || me.some(dt) ? ni(M, [me], w, Ne) : lo(M, [me], w) : v.getChildren(M).filter(v.isTag)).slice(0, Ne), Fe = function(Je, pt, Nt, Bt) {
          var Qt = typeof Nt == "string" ? parseInt(Nt, 10) : NaN;
          switch (Je) {
            case "first":
            case "lt":
              return pt;
            case "last":
              return 0 < pt.length ? [pt[pt.length - 1]] : pt;
            case "nth":
            case "eq":
              return isFinite(Qt) && Math.abs(Qt) < pt.length ? [Qt < 0 ? pt[pt.length + Qt] : pt[Qt]] : [];
            case "gt":
              return isFinite(Qt) ? pt.slice(Qt + 1) : [];
            case "even":
              return pt.filter(function(mn, kn) {
                return kn % 2 == 0;
              });
            case "odd":
              return pt.filter(function(mn, kn) {
                return kn % 2 == 1;
              });
            case "not":
              var Cn = new Set(fc(Nt, pt, Bt));
              return pt.filter(function(mn) {
                return !Cn.has(mn);
              });
          }
        }(Ae.name, Ne, Ae.data, w);
        return Fe.length === 0 || O.length === ue + 1 ? Fe : ((O = (Ae = O.slice(ue + 1)).some(dt)) ? (dt(Ae[0]) && ((ue = Ae[0].type) !== K.Sibling && ue !== K.Adjacent || (Fe = bs(Fe, v, !0)), Ae.unshift(yd)), w = ra(ra({}, w), {}, { relativeSelector: !1, rootFunc: function(Je) {
          return Fe.includes(Je);
        } })) : w.rootFunc && w.rootFunc !== zt.trueFunc && (w = ra(ra({}, w), {}, { rootFunc: zt.trueFunc })), Ae.some(so) ? Es(Fe, Ae, w, !1, W) : O ? ni(Fe, [Ae], w, W) : lo(Fe, [Ae], w));
      }
      function ni(M, O, w, R) {
        return Po(M, cc(O, w, M), R);
      }
      function Po(M, O, w) {
        return w = 2 < arguments.length && w !== void 0 ? w : 1 / 0, M = bs(M, v, O.shouldTestNextSiblings), v.find(function(R) {
          return v.isTag(R) && O(R);
        }, M, !0, w);
      }
      function lo(M, O, w) {
        return (M = (Array.isArray(M) ? M : [M]).filter(v.isTag)).length === 0 || (w = cc(O, w)) === zt.trueFunc ? M : M.filter(w);
      }
      function kl(M) {
        return function(w) {
          if (Array.isArray(w)) return fi(w);
        }(M) || function(w) {
          if (typeof Symbol < "u" && w[Symbol.iterator] != null || w["@@iterator"] != null) return Array.from(w);
        }(M) || function(w, R) {
          if (w) {
            if (typeof w == "string") return fi(w, R);
            var W = Object.prototype.toString.call(w).slice(8, -1);
            return (W = W === "Object" && w.constructor ? w.constructor.name : W) === "Map" || W === "Set" ? Array.from(w) : W === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(W) ? fi(w, R) : void 0;
          }
        }(M) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function fi(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var Or = /^\s*[~+]/;
      function ep(M) {
        if (!M) return this._make([]);
        var O = this.toArray();
        if (typeof M != "string") {
          var R = ie(M) ? M.toArray() : [M];
          return this._make(R.filter(function(ue) {
            return O.some(function(me) {
              return B(me, ue);
            });
          }));
        }
        var w = Or.test(M) ? O : this.children().toArray(), R = { context: O, root: (R = this._root) === null || R === void 0 ? void 0 : R[0], xmlMode: this.options.xmlMode, lowerCaseTags: this.options.lowerCaseTags, lowerCaseAttributeNames: this.options.lowerCaseAttributeNames, pseudos: this.options.pseudos, quirksMode: this.options.quirksMode };
        return this._make(function(ue, me, Ae, Ne) {
          var Fe = 2 < arguments.length && Ae !== void 0 ? Ae : {}, ut = 3 < arguments.length && Ne !== void 0 ? Ne : 1 / 0;
          return typeof ue == "function" ? Po(me, ue) : (ue = (Ne = _d(ja(Jt(ue)), 2))[0], Ne = Ne[1].map(function(Je) {
            return Es(me, Je, Fe, !0, ut);
          }), ue.length && Ne.push(ni(me, ue, Fe, ut)), Ne.length === 0 ? [] : Ne.length === 1 ? Ne[0] : v.uniqueSort(Ne.reduce(function(Je, pt) {
            return [].concat(ns(Je), ns(pt));
          })));
        }(M, w, R));
      }
      function jo(M) {
        return function(O) {
          for (var w = arguments.length, R = new Array(1 < w ? w - 1 : 0), W = 1; W < w; W++) R[W - 1] = arguments[W];
          return function(ue) {
            var me = M(O, this);
            return ue && (me = ws(me, ue, this.options.xmlMode, (ue = this._root) === null || ue === void 0 ? void 0 : ue[0])), this._make(1 < this.length && 1 < me.length ? R.reduce(function(Ae, Ne) {
              return Ne(Ae);
            }, me) : me);
          };
        };
      }
      function Mi(M) {
        for (var O = null, w = arguments.length, R = new Array(1 < w ? w - 1 : 0), W = 1; W < w; W++) R[W - 1] = arguments[W];
        var ue = jo(function(me, Ae) {
          var Ne = [];
          return ce(Ae, function(Fe) {
            for (var ut; (ut = me(Fe)) && (O == null || !O(ut, Ne.length)); Fe = ut) Ne.push(ut);
          }), Ne;
        }).apply(void 0, [M].concat(R));
        return function(me, Ae) {
          var Ne = this;
          return O = typeof me == "string" ? function(Fe) {
            return nl(Fe, me, Ne.options);
          } : me ? Cs(me) : null, Ae = ue.call(this, Ae), O = null, Ae;
        };
      }
      function Bo(M) {
        return Array.from(new Set(M));
      }
      var vi = jo(function(M, O) {
        for (var w, R = [], W = 0; W < O.length; W++) {
          var ue = M(O[W]);
          R.push(ue);
        }
        return (w = new Array()).concat.apply(w, R);
      }), Ol = (Ur = jo(function(M, O) {
        for (var w = [], R = 0; R < O.length; R++) {
          var W = M(O[R]);
          W !== null && w.push(W);
        }
        return w;
      }))(function(M) {
        return (M = M.parent) && !Object(Y.l)(M) ? M : null;
      }, Bo), hc = vi(function(M) {
        for (var O = []; M.parent && !Object(Y.l)(M.parent); ) O.push(M.parent), M = M.parent;
        return O;
      }, v.uniqueSort, function(M) {
        return M.reverse();
      }), Af = Mi(function(M) {
        return (M = M.parent) && !Object(Y.l)(M) ? M : null;
      }, v.uniqueSort, function(M) {
        return M.reverse();
      });
      function du(M) {
        var O, w = [];
        if (!M) return this._make(w);
        var R = { xmlMode: this.options.xmlMode, root: (O = this._root) === null || O === void 0 ? void 0 : O[0] }, W = typeof M == "string" ? function(ue) {
          return nl(ue, M, R);
        } : Cs(M);
        return ce(this, function(ue) {
          for (; ue && Object(Y.m)(ue); ) {
            if (W(ue, 0)) {
              w.includes(ue) || w.push(ue);
              break;
            }
            ue = ue.parent;
          }
        }), this._make(w);
      }
      var qn = Ur(function(M) {
        return Object(v.nextElementSibling)(M);
      }), Ss = vi(function(M) {
        for (var O = []; M.next; ) M = M.next, Object(Y.m)(M) && O.push(M);
        return O;
      }, Bo), Ba = Mi(function(M) {
        return Object(v.nextElementSibling)(M);
      }, Bo), kf = Ur(function(M) {
        return Object(v.prevElementSibling)(M);
      }), pc = vi(function(M) {
        for (var O = []; M.prev; ) M = M.prev, Object(Y.m)(M) && O.push(M);
        return O;
      }, Bo), fu = Mi(function(M) {
        return Object(v.prevElementSibling)(M);
      }, Bo), hu = vi(function(M) {
        return Object(v.getSiblings)(M).filter(function(O) {
          return Object(Y.m)(O) && O !== M;
        });
      }, v.uniqueSort), mc = vi(function(M) {
        return Object(v.getChildren)(M).filter(Y.m);
      }, Bo);
      function bd() {
        var M = this.toArray().reduce(function(O, w) {
          return Object(Y.h)(w) ? O.concat(w.children) : O;
        }, []);
        return this._make(M);
      }
      function rs(M) {
        for (var O = 0, w = this.length; O < w && M.call(this[O], O, this[O]) !== !1; ) ++O;
        return this;
      }
      function pu(M) {
        for (var O = [], w = 0; w < this.length; w++) {
          var R = this[w];
          (R = M.call(R, w, R)) != null && (O = O.concat(R));
        }
        return this._make(O);
      }
      function Cs(M) {
        return typeof M == "function" ? function(O, w) {
          return M.call(O, w, O);
        } : ie(M) ? function(O) {
          return Array.prototype.includes.call(M, O);
        } : function(O) {
          return M === O;
        };
      }
      function Ed(M) {
        return this._make(ws(this.toArray(), M, this.options.xmlMode, (M = this._root) === null || M === void 0 ? void 0 : M[0]));
      }
      function ws(M, O, w, R) {
        return typeof O == "string" ? vd(O, M, { xmlMode: w, root: R }) : M.filter(Cs(O));
      }
      function gc(M) {
        var O = this.toArray();
        return typeof M == "string" ? ur(O.filter(Y.m), M, this.options) : !!M && O.some(Cs(M));
      }
      function Of(M) {
        var O, w, R = this.toArray(), R = typeof M == "string" ? (O = new Set(vd(M, R, this.options)), R.filter(function(W) {
          return !O.has(W);
        })) : (w = Cs(M), R.filter(function(W, ue) {
          return !w(W, ue);
        }));
        return this._make(R);
      }
      function Fo(M) {
        var O = this;
        return this.filter(typeof M == "string" ? ":has(".concat(M, ")") : function(w, R) {
          return 0 < O._make(R).find(M).length;
        });
      }
      function xs() {
        return 1 < this.length ? this._make(this[0]) : this;
      }
      function _c() {
        return 0 < this.length ? this._make(this[this.length - 1]) : this;
      }
      function Dl(M) {
        return (M = +M) == 0 && this.length <= 1 ? this : (M < 0 && (M = this.length + M), this._make((M = this[M]) !== null && M !== void 0 ? M : []));
      }
      function Df(M) {
        return M == null ? this.toArray() : this[M < 0 ? this.length + M : M];
      }
      function yc() {
        return Array.prototype.slice.call(this);
      }
      function Sd(w) {
        var O, w = w == null ? (O = this.parent().children(), this[0]) : typeof w == "string" ? (O = this._make(w), this[0]) : (O = this, ie(w) ? w[0] : w);
        return Array.prototype.indexOf.call(O, w);
      }
      function mu(M, O) {
        return this._make(Array.prototype.slice.call(this, M, O));
      }
      function Pi() {
        var M;
        return (M = this.prevObject) !== null && M !== void 0 ? M : this._make([]);
      }
      function vc(M, O) {
        return O = this._make(M, O), O = Object(v.uniqueSort)([].concat(kl(this.get()), kl(O.get()))), this._make(O);
      }
      function Rf(M) {
        return this.prevObject ? this.add(M ? this.prevObject.filter(M) : this.prevObject) : this;
      }
      var Ts = r(24);
      function bc(M) {
        return function(w) {
          if (Array.isArray(w)) return hi(w);
        }(M) || function(w) {
          if (typeof Symbol < "u" && w[Symbol.iterator] != null || w["@@iterator"] != null) return Array.from(w);
        }(M) || is(M) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function is(M, O) {
        if (M) {
          if (typeof M == "string") return hi(M, O);
          var w = Object.prototype.toString.call(M).slice(8, -1);
          return (w = w === "Object" && M.constructor ? M.constructor.name : w) === "Map" || w === "Set" ? Array.from(M) : w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w) ? hi(M, O) : void 0;
        }
      }
      function hi(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      function Ec(M, O) {
        var w = this;
        return M == null ? [] : ie(M) ? O ? $(M.get()) : M.get() : Array.isArray(M) ? M.reduce(function(R, W) {
          return R.concat(w._makeDomArray(W, O));
        }, []) : typeof M == "string" ? this._parse(M, this.options, !1, null).children : O ? $([M]) : [M];
      }
      function Nf(M) {
        return function() {
          for (var O = this, w = arguments.length, R = new Array(w), W = 0; W < w; W++) R[W] = arguments[W];
          var ue = this.length - 1;
          return ce(this, function(me, Ae) {
            var Ne;
            Object(Y.h)(me) && (Ne = typeof R[0] == "function" ? R[0].call(me, Ae, O._render(me.children)) : R, Ae = O._makeDomArray(Ne, Ae < ue), M(Ae, me.children, me));
          });
        };
      }
      function be(M, O, w, R, W) {
        for (var ue, me = [O, w].concat(bc(R)), Ae = O === 0 ? null : M[O - 1], Ne = O + w >= M.length ? null : M[O + w], Fe = 0; Fe < R.length; ++Fe) {
          var ut, Je = R[Fe], pt = Je.parent;
          !pt || -1 < (ut = pt.children.indexOf(Je)) && (pt.children.splice(ut, 1), W === pt && ut < O && me[0]--), Je.parent = W, Je.prev && (Je.prev.next = (ue = Je.next) !== null && ue !== void 0 ? ue : null), Je.next && (Je.next.prev = (ue = Je.prev) !== null && ue !== void 0 ? ue : null), Je.prev = Fe === 0 ? Ae : R[Fe - 1], Je.next = Fe === R.length - 1 ? Ne : R[Fe + 1];
        }
        return Ae && (Ae.next = R[0]), Ne && (Ne.prev = R[R.length - 1]), M.splice.apply(M, bc(me));
      }
      function le(M) {
        return (ie(M) ? M : this._make(M)).append(this), this;
      }
      function ye(M) {
        return (ie(M) ? M : this._make(M)).prepend(this), this;
      }
      var Be = Nf(function(M, O, w) {
        be(O, O.length, 0, M, w);
      }), Ke = Nf(function(M, O, w) {
        be(O, 0, 0, M, w);
      });
      function Ot(M) {
        return function(O) {
          for (var w = this.length - 1, R = this.parents().last(), W = 0; W < this.length; W++) {
            var ue = this[W], me = typeof O == "function" ? O.call(ue, W, ue) : typeof O != "string" || te(O) ? O : R.find(O).clone();
            if ((me = function(Je, pt) {
              return function(Bt) {
                if (Array.isArray(Bt)) return Bt;
              }(Je) || function(Bt, Qt) {
                var Cn = Bt == null ? null : typeof Symbol < "u" && Bt[Symbol.iterator] || Bt["@@iterator"];
                if (Cn != null) {
                  var mn, kn, Zn, Dr, Kr = [], Nn = !0, Oi = !1;
                  try {
                    if (Zn = (Cn = Cn.call(Bt)).next, Qt !== 0) for (; !(Nn = (mn = Zn.call(Cn)).done) && (Kr.push(mn.value), Kr.length !== Qt); Nn = !0) ;
                  } catch (cr) {
                    Oi = !0, kn = cr;
                  } finally {
                    try {
                      if (!Nn && Cn.return != null && (Dr = Cn.return(), Object(Dr) !== Dr)) return;
                    } finally {
                      if (Oi) throw kn;
                    }
                  }
                  return Kr;
                }
              }(Je, pt) || is(Je, pt) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }(this._makeDomArray(me, W < w), 1)[0]) && Object(Y.h)(me)) {
              for (var Ae = me, Ne = 0; Ne < Ae.children.length; ) {
                var Fe = Ae.children[Ne];
                Object(Y.m)(Fe) ? (Ae = Fe, Ne = 0) : Ne++;
              }
              M(ue, Ae, [me]);
            }
          }
          return this;
        };
      }
      var Wt = Ot(function(M, O, w) {
        var R, W, ue = M.parent;
        ue && (W = (R = ue.children).indexOf(M), Object(Ts.b)([M], O), be(R, W, 0, w, ue));
      }), hn = Ot(function(M, O, w) {
        Object(Y.h)(M) && (Object(Ts.b)(M.children, O), Object(Ts.b)(w, M));
      });
      function Rn(M) {
        var O = this;
        return this.parent(M).not("body").each(function(w, R) {
          O._make(R).replaceWith(R.children);
        }), this;
      }
      function yr(M) {
        var O = this[0];
        if (O) {
          for (var w, R = this._make(typeof M == "function" ? M.call(O, 0, O) : M).insertBefore(O), W = 0; W < R.length; W++) R[W].type === "tag" && (w = R[W]);
          for (var ue = 0; w && ue < w.children.length; ) {
            var me = w.children[ue];
            me.type === "tag" ? (w = me, ue = 0) : ue++;
          }
          w && this._make(w).append(this);
        }
        return this;
      }
      function Sr() {
        for (var M = this, O = arguments.length, w = new Array(O), R = 0; R < O; R++) w[R] = arguments[R];
        var W = this.length - 1;
        return ce(this, function(ue, me) {
          var Ae, Ne, Fe = ue.parent;
          Object(Y.h)(ue) && Fe && ((Ne = (Ae = Fe.children).indexOf(ue)) < 0 || (ue = typeof w[0] == "function" ? w[0].call(ue, me, M._render(ue.children)) : w, be(Ae, Ne + 1, 0, M._makeDomArray(ue, me < W), Fe)));
        });
      }
      function ri(M) {
        var O = this;
        typeof M == "string" && (M = this._make(M)), this.remove();
        var w = [];
        return this._makeDomArray(M).forEach(function(R) {
          var W, ue = O.clone().toArray(), me = R.parent;
          me && ((R = (W = me.children).indexOf(R)) < 0 || (be(W, R + 1, 0, ue, me), w.push.apply(w, bc(ue))));
        }), this._make(w);
      }
      function Rl() {
        for (var M = this, O = arguments.length, w = new Array(O), R = 0; R < O; R++) w[R] = arguments[R];
        var W = this.length - 1;
        return ce(this, function(ue, me) {
          var Ae, Ne, Fe = ue.parent;
          Object(Y.h)(ue) && Fe && ((Ne = (Ae = Fe.children).indexOf(ue)) < 0 || (ue = typeof w[0] == "function" ? w[0].call(ue, me, M._render(ue.children)) : w, be(Ae, Ne, 0, M._makeDomArray(ue, me < W), Fe)));
        });
      }
      function tp(w) {
        var O = this, w = this._make(w);
        this.remove();
        var R = [];
        return ce(w, function(W) {
          var ue, me = O.clone().toArray(), Ae = W.parent;
          Ae && ((W = (ue = Ae.children).indexOf(W)) < 0 || (be(ue, W, 0, me, Ae), R.push.apply(R, bc(me))));
        }), this._make(R);
      }
      function gu(M) {
        return ce(M ? this.filter(M) : this, function(O) {
          Object(v.removeElement)(O), O.prev = O.next = O.parent = null;
        }), this;
      }
      function If(M) {
        var O = this;
        return ce(this, function(w, R) {
          var W, ue, me = w.parent;
          me && (W = me.children, ue = typeof M == "function" ? M.call(w, R, w) : M, R = O._makeDomArray(ue), Object(Ts.b)(R, null), ue = W.indexOf(w), be(W, ue, 1, R, me), R.includes(w) || (w.parent = w.prev = w.next = null));
        });
      }
      function uo() {
        return ce(this, function(M) {
          Object(Y.h)(M) && (M.children.forEach(function(O) {
            O.next = O.prev = O.parent = null;
          }), M.children.length = 0);
        });
      }
      function os(M) {
        var O = this;
        if (M !== void 0) return ce(this, function(R) {
          var W;
          Object(Y.h)(R) && (R.children.forEach(function(ue) {
            ue.next = ue.prev = ue.parent = null;
          }), W = ie(M) ? M.toArray() : O._parse("".concat(M), O.options, !1, R).children, Object(Ts.b)(W, R));
        });
        var w = this[0];
        return w && Object(Y.h)(w) ? this._render(w.children) : null;
      }
      function pi() {
        return this._render(this);
      }
      function ga(M) {
        var O = this;
        return M === void 0 ? N(this) : ce(this, typeof M == "function" ? function(w, R) {
          return O._make(w).text(M.call(w, R, N([w])));
        } : function(w) {
          var R;
          Object(Y.h)(w) && (w.children.forEach(function(W) {
            W.next = W.prev = W.parent = null;
          }), R = new Y.f("".concat(M)), Object(Ts.b)(R, w));
        });
      }
      function rl() {
        return this._make($(this.get()));
      }
      function Nl(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      function _u(M) {
        return (_u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function il(M, O) {
        return M != null && O != null || _u(M) === "object" && !Array.isArray(M) ? ce(this, function(w, R) {
          Object(Y.m)(w) && function W(ue, me, Ae, Ne) {
            var Fe;
            typeof me == "string" ? (Fe = yu(ue), (Ae = typeof Ae == "function" ? Ae.call(ue, Ne, Fe[me]) : Ae) === "" ? delete Fe[me] : Ae != null && (Fe[me] = Ae), ue.attribs.style = function(Je) {
              return Object.keys(Je).reduce(function(pt, Nt) {
                return "".concat(pt).concat(pt ? " " : "").concat(Nt, ": ").concat(Je[Nt], ";");
              }, "");
            }(Fe)) : _u(me) === "object" && Object.keys(me).forEach(function(ut, Je) {
              W(ue, ut, me[ut], Je);
            });
          }(w, M, O, R);
        }) : this.length !== 0 ? yu(this[0], M) : void 0;
      }
      function yu(M, O) {
        if (M && Object(Y.m)(M)) {
          var w = function(ue) {
            if (!(ue = (ue || "").trim())) return {};
            var me, Ae, Ne = {}, Fe = function(Bt, Qt) {
              var Cn = typeof Symbol < "u" && Bt[Symbol.iterator] || Bt["@@iterator"];
              if (!Cn) {
                if (Array.isArray(Bt) || (Cn = function(Nn, Oi) {
                  if (Nn) {
                    if (typeof Nn == "string") return Nl(Nn, Oi);
                    var cr = Object.prototype.toString.call(Nn).slice(8, -1);
                    return (cr = cr === "Object" && Nn.constructor ? Nn.constructor.name : cr) === "Map" || cr === "Set" ? Array.from(Nn) : cr === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(cr) ? Nl(Nn, Oi) : void 0;
                  }
                }(Bt)) || Qt && Bt && typeof Bt.length == "number") {
                  Cn && (Bt = Cn);
                  var mn = 0;
                  return { s: Qt = function() {
                  }, n: function() {
                    return mn >= Bt.length ? { done: !0 } : { done: !1, value: Bt[mn++] };
                  }, e: function(Nn) {
                    throw Nn;
                  }, f: Qt };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var kn, Zn = !0, Dr = !1;
              return { s: function() {
                Cn = Cn.call(Bt);
              }, n: function() {
                var Nn = Cn.next();
                return Zn = Nn.done, Nn;
              }, e: function(Nn) {
                Dr = !0, kn = Nn;
              }, f: function() {
                try {
                  Zn || Cn.return == null || Cn.return();
                } finally {
                  if (Dr) throw kn;
                }
              } };
            }(ue.split(";"));
            try {
              for (Fe.s(); !(Ae = Fe.n()).done; ) {
                var ut, Je = Ae.value, pt = Je.indexOf(":");
                pt < 1 || pt === Je.length - 1 ? 0 < (ut = Je.trimEnd()).length && me !== void 0 && (Ne[me] += ";".concat(ut)) : Ne[me = Je.slice(0, pt).trim()] = Je.slice(pt + 1).trim();
              }
            } catch (Nt) {
              Fe.e(Nt);
            } finally {
              Fe.f();
            }
            return Ne;
          }(M.attribs.style);
          if (typeof O == "string") return w[O];
          if (Array.isArray(O)) {
            var R = {};
            return O.forEach(function(W) {
              w[W] != null && (R[W] = w[W]);
            }), R;
          }
          return w;
        }
      }
      var vu = "input,select,textarea,keygen", bu = /%20/g, ol = /\r?\n/g;
      function np() {
        return this.serializeArray().map(function(M) {
          return "".concat(encodeURIComponent(M.name), "=").concat(encodeURIComponent(M.value));
        }).join("&").replace(bu, "+");
      }
      function rp() {
        var M = this;
        return this.map(function(O, w) {
          var R = M._make(w);
          return (Object(Y.m)(w) && w.name === "form" ? R.find(vu) : R.filter(vu)).toArray();
        }).filter('[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))').map(function(O, W) {
          var R = (W = M._make(W)).attr("name"), W = (W = W.val()) !== null && W !== void 0 ? W : "";
          return Array.isArray(W) ? W.map(function(ue) {
            return { name: R, value: ue.replace(ol, `\r
`) };
          }) : { name: R, value: W.replace(ol, `\r
`) };
        }).toArray();
      }
      function Lf(M, O, w) {
        return Object.defineProperty(M, "prototype", { writable: !1 }), M;
      }
      var al = Lf(function M(O, w, R) {
        if (function(me, Ae) {
          if (!(me instanceof Ae)) throw new TypeError("Cannot call a class as a function");
        }(this, M), this.length = 0, this.options = R, this._root = w, O) {
          for (var W = 0; W < O.length; W++) this[W] = O[W];
          this.length = O.length;
        }
      });
      function Sc(M) {
        return (Sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Cd(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, Mf(R.key), R);
        }
      }
      function Eu() {
        try {
          var M = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
          }));
        } catch {
        }
        return (Eu = function() {
          return !!M;
        })();
      }
      function Il(M) {
        return (Il = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(w) {
          return w.__proto__ || Object.getPrototypeOf(w);
        })(M);
      }
      function Su(M, O) {
        return (Su = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(R, W) {
          return R.__proto__ = W, R;
        })(M, O);
      }
      function ip(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function Cc(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? ip(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = Mf(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : ip(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      function Mf(M) {
        return M = function(w, R) {
          if (Sc(w) != "object" || !w) return w;
          var W = w[Symbol.toPrimitive];
          if (W === void 0) return (R === "string" ? String : Number)(w);
          if (Sc(R = W.call(w, R || "default")) != "object") return R;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }(M, "string"), Sc(M) == "symbol" ? M : String(M);
      }
      al.prototype.cheerio = "[cheerio object]", al.prototype.splice = Array.prototype.splice, al.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator], Object.assign(al.prototype, yt, Ve, De, ct, Xr);
      var Pe, Pm = /* @__PURE__ */ new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]);
      (yt = Pe = Pe || {})[yt.EOF = -1] = "EOF", yt[yt.NULL = 0] = "NULL", yt[yt.TABULATION = 9] = "TABULATION", yt[yt.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", yt[yt.LINE_FEED = 10] = "LINE_FEED", yt[yt.FORM_FEED = 12] = "FORM_FEED", yt[yt.SPACE = 32] = "SPACE", yt[yt.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", yt[yt.QUOTATION_MARK = 34] = "QUOTATION_MARK", yt[yt.NUMBER_SIGN = 35] = "NUMBER_SIGN", yt[yt.AMPERSAND = 38] = "AMPERSAND", yt[yt.APOSTROPHE = 39] = "APOSTROPHE", yt[yt.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", yt[yt.SOLIDUS = 47] = "SOLIDUS", yt[yt.DIGIT_0 = 48] = "DIGIT_0", yt[yt.DIGIT_9 = 57] = "DIGIT_9", yt[yt.SEMICOLON = 59] = "SEMICOLON", yt[yt.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", yt[yt.EQUALS_SIGN = 61] = "EQUALS_SIGN", yt[yt.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", yt[yt.QUESTION_MARK = 63] = "QUESTION_MARK", yt[yt.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", yt[yt.LATIN_CAPITAL_F = 70] = "LATIN_CAPITAL_F", yt[yt.LATIN_CAPITAL_X = 88] = "LATIN_CAPITAL_X", yt[yt.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", yt[yt.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", yt[yt.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", yt[yt.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", yt[yt.LATIN_SMALL_F = 102] = "LATIN_SMALL_F", yt[yt.LATIN_SMALL_X = 120] = "LATIN_SMALL_X", yt[yt.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z", yt[yt.REPLACEMENT_CHARACTER = 65533] = "REPLACEMENT_CHARACTER";
      var xt;
      function op(M) {
        return 55296 <= M && M <= 57343;
      }
      function jm(M) {
        return M !== 32 && M !== 10 && M !== 13 && M !== 9 && M !== 12 && 1 <= M && M <= 31 || 127 <= M && M <= 159;
      }
      function Bm(M) {
        return 64976 <= M && M <= 65007 || Pm.has(M);
      }
      function Pf(M) {
        return (Pf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Fm(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, function(ue) {
            return ue = function(Ae, Ne) {
              if (Pf(Ae) != "object" || !Ae) return Ae;
              var Fe = Ae[Symbol.toPrimitive];
              if (Fe === void 0) return (Ne === "string" ? String : Number)(Ae);
              if (Pf(Ne = Fe.call(Ae, Ne || "default")) != "object") return Ne;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ue, "string"), Pf(ue) == "symbol" ? ue : String(ue);
          }(R.key), R);
        }
      }
      (Ve = xt = xt || {}).controlCharacterInInputStream = "control-character-in-input-stream", Ve.noncharacterInInputStream = "noncharacter-in-input-stream", Ve.surrogateInInputStream = "surrogate-in-input-stream", Ve.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", Ve.endTagWithAttributes = "end-tag-with-attributes", Ve.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", Ve.unexpectedSolidusInTag = "unexpected-solidus-in-tag", Ve.unexpectedNullCharacter = "unexpected-null-character", Ve.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", Ve.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", Ve.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", Ve.missingEndTagName = "missing-end-tag-name", Ve.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", Ve.unknownNamedCharacterReference = "unknown-named-character-reference", Ve.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", Ve.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", Ve.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", Ve.eofBeforeTagName = "eof-before-tag-name", Ve.eofInTag = "eof-in-tag", Ve.missingAttributeValue = "missing-attribute-value", Ve.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", Ve.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", Ve.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", Ve.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", Ve.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", Ve.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", Ve.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", Ve.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", Ve.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", Ve.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", Ve.cdataInHtmlContent = "cdata-in-html-content", Ve.incorrectlyOpenedComment = "incorrectly-opened-comment", Ve.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", Ve.eofInDoctype = "eof-in-doctype", Ve.nestedComment = "nested-comment", Ve.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", Ve.eofInComment = "eof-in-comment", Ve.incorrectlyClosedComment = "incorrectly-closed-comment", Ve.eofInCdata = "eof-in-cdata", Ve.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", Ve.nullCharacterReference = "null-character-reference", Ve.surrogateCharacterReference = "surrogate-character-reference", Ve.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", Ve.controlCharacterReference = "control-character-reference", Ve.noncharacterCharacterReference = "noncharacter-character-reference", Ve.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", Ve.missingDoctypeName = "missing-doctype-name", Ve.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", Ve.duplicateAttribute = "duplicate-attribute", Ve.nonConformingDoctype = "non-conforming-doctype", Ve.missingDoctype = "missing-doctype", Ve.misplacedDoctype = "misplaced-doctype", Ve.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", Ve.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", Ve.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", Ve.openElementsLeftAfterEof = "open-elements-left-after-eof", Ve.abandonedHeadElementChild = "abandoned-head-element-child", Ve.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", Ve.nestedNoscriptInHead = "nested-noscript-in-head", Ve.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
      var Cr, Fa = 65536, wd = function() {
        function M(O) {
          (function(R, W) {
            if (!(R instanceof W)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.handler = O, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Fa, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
        }
        return function(w, R, W) {
          R && Fm(w.prototype, R), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "col", get: function() {
          return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
        } }, { key: "offset", get: function() {
          return this.droppedBufferSize + this.pos;
        } }, { key: "getError", value: function(w) {
          var R = this.line, W = this.col, ue = this.offset;
          return { code: w, startLine: R, endLine: R, startCol: W, endCol: W, startOffset: ue, endOffset: ue };
        } }, { key: "_err", value: function(w) {
          this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(w)));
        } }, { key: "_addGap", value: function() {
          this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
        } }, { key: "_processSurrogate", value: function(w) {
          if (this.pos !== this.html.length - 1) {
            var R = this.html.charCodeAt(this.pos + 1);
            if (function(ue) {
              return 56320 <= ue && ue <= 57343;
            }(R)) return this.pos++, this._addGap(), function(ue, me) {
              return 1024 * (ue - 55296) + 9216 + me;
            }(w, R);
          } else if (!this.lastChunkWritten) return this.endOfChunkHit = !0, Pe.EOF;
          return this._err(xt.surrogateInInputStream), w;
        } }, { key: "willDropParsedChunk", value: function() {
          return this.pos > this.bufferWaterline;
        } }, { key: "dropParsedChunk", value: function() {
          this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
        } }, { key: "write", value: function(w, R) {
          0 < this.html.length ? this.html += w : this.html = w, this.endOfChunkHit = !1, this.lastChunkWritten = R;
        } }, { key: "insertHtmlAtCurrentPos", value: function(w) {
          this.html = this.html.substring(0, this.pos + 1) + w + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
        } }, { key: "startsWith", value: function(w, R) {
          if (this.pos + w.length > this.html.length) return this.endOfChunkHit = !this.lastChunkWritten, !1;
          if (R) return this.html.startsWith(w, this.pos);
          for (var W = 0; W < w.length; W++) if ((32 | this.html.charCodeAt(this.pos + W)) !== w.charCodeAt(W)) return !1;
          return !0;
        } }, { key: "peek", value: function(w) {
          return (w = this.pos + w) >= this.html.length ? (this.endOfChunkHit = !this.lastChunkWritten, Pe.EOF) : (w = this.html.charCodeAt(w)) === Pe.CARRIAGE_RETURN ? Pe.LINE_FEED : w;
        } }, { key: "advance", value: function() {
          if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length) return this.endOfChunkHit = !this.lastChunkWritten, Pe.EOF;
          var w = this.html.charCodeAt(this.pos);
          return w === Pe.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, Pe.LINE_FEED) : w === Pe.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, op(w) && (w = this._processSurrogate(w)), this.handler.onParseError === null || 31 < w && w < 127 || w === Pe.LINE_FEED || w === Pe.CARRIAGE_RETURN || 159 < w && w < 64976 || this._checkForProblematicCharacters(w), w);
        } }, { key: "_checkForProblematicCharacters", value: function(w) {
          jm(w) ? this._err(xt.controlCharacterInInputStream) : Bm(w) && this._err(xt.noncharacterInInputStream);
        } }, { key: "retreat", value: function(w) {
          for (this.pos -= w; this.pos < this.lastGapPos; ) this.lastGapPos = this.gapStack.pop(), this.pos--;
          this.isEol = !1;
        } }]), M;
      }();
      function ap(M, O) {
        for (var w = M.attrs.length - 1; 0 <= w; w--) if (M.attrs[w].name === O) return M.attrs[w].value;
        return null;
      }
      (De = Cr = Cr || {})[De.CHARACTER = 0] = "CHARACTER", De[De.NULL_CHARACTER = 1] = "NULL_CHARACTER", De[De.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", De[De.START_TAG = 3] = "START_TAG", De[De.END_TAG = 4] = "END_TAG", De[De.COMMENT = 5] = "COMMENT", De[De.DOCTYPE = 6] = "DOCTYPE", De[De.EOF = 7] = "EOF", De[De.HIBERNATION = 8] = "HIBERNATION";
      var Tt, sl, bo, ht, re, ji = r(11);
      function ia(M) {
        return (ia = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Ll(M, O, w) {
        return (O = function(W) {
          return W = function(me, Ae) {
            if (ia(me) != "object" || !me) return me;
            var Ne = me[Symbol.toPrimitive];
            if (Ne === void 0) return (Ae === "string" ? String : Number)(me);
            if (ia(Ae = Ne.call(me, Ae || "default")) != "object") return Ae;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(W, "string"), ia(W) == "symbol" ? W : String(W);
        }(O)) in M ? Object.defineProperty(M, O, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : M[O] = w, M;
      }
      (ct = Tt = Tt || {}).HTML = "http://www.w3.org/1999/xhtml", ct.MATHML = "http://www.w3.org/1998/Math/MathML", ct.SVG = "http://www.w3.org/2000/svg", ct.XLINK = "http://www.w3.org/1999/xlink", ct.XML = "http://www.w3.org/XML/1998/namespace", ct.XMLNS = "http://www.w3.org/2000/xmlns/", (Xr = sl = sl || {}).TYPE = "type", Xr.ACTION = "action", Xr.ENCODING = "encoding", Xr.PROMPT = "prompt", Xr.NAME = "name", Xr.COLOR = "color", Xr.FACE = "face", Xr.SIZE = "size", (yt = bo = bo || {}).NO_QUIRKS = "no-quirks", yt.QUIRKS = "quirks", yt.LIMITED_QUIRKS = "limited-quirks", (Ve = ht = ht || {}).A = "a", Ve.ADDRESS = "address", Ve.ANNOTATION_XML = "annotation-xml", Ve.APPLET = "applet", Ve.AREA = "area", Ve.ARTICLE = "article", Ve.ASIDE = "aside", Ve.B = "b", Ve.BASE = "base", Ve.BASEFONT = "basefont", Ve.BGSOUND = "bgsound", Ve.BIG = "big", Ve.BLOCKQUOTE = "blockquote", Ve.BODY = "body", Ve.BR = "br", Ve.BUTTON = "button", Ve.CAPTION = "caption", Ve.CENTER = "center", Ve.CODE = "code", Ve.COL = "col", Ve.COLGROUP = "colgroup", Ve.DD = "dd", Ve.DESC = "desc", Ve.DETAILS = "details", Ve.DIALOG = "dialog", Ve.DIR = "dir", Ve.DIV = "div", Ve.DL = "dl", Ve.DT = "dt", Ve.EM = "em", Ve.EMBED = "embed", Ve.FIELDSET = "fieldset", Ve.FIGCAPTION = "figcaption", Ve.FIGURE = "figure", Ve.FONT = "font", Ve.FOOTER = "footer", Ve.FOREIGN_OBJECT = "foreignObject", Ve.FORM = "form", Ve.FRAME = "frame", Ve.FRAMESET = "frameset", Ve.H1 = "h1", Ve.H2 = "h2", Ve.H3 = "h3", Ve.H4 = "h4", Ve.H5 = "h5", Ve.H6 = "h6", Ve.HEAD = "head", Ve.HEADER = "header", Ve.HGROUP = "hgroup", Ve.HR = "hr", Ve.HTML = "html", Ve.I = "i", Ve.IMG = "img", Ve.IMAGE = "image", Ve.INPUT = "input", Ve.IFRAME = "iframe", Ve.KEYGEN = "keygen", Ve.LABEL = "label", Ve.LI = "li", Ve.LINK = "link", Ve.LISTING = "listing", Ve.MAIN = "main", Ve.MALIGNMARK = "malignmark", Ve.MARQUEE = "marquee", Ve.MATH = "math", Ve.MENU = "menu", Ve.META = "meta", Ve.MGLYPH = "mglyph", Ve.MI = "mi", Ve.MO = "mo", Ve.MN = "mn", Ve.MS = "ms", Ve.MTEXT = "mtext", Ve.NAV = "nav", Ve.NOBR = "nobr", Ve.NOFRAMES = "noframes", Ve.NOEMBED = "noembed", Ve.NOSCRIPT = "noscript", Ve.OBJECT = "object", Ve.OL = "ol", Ve.OPTGROUP = "optgroup", Ve.OPTION = "option", Ve.P = "p", Ve.PARAM = "param", Ve.PLAINTEXT = "plaintext", Ve.PRE = "pre", Ve.RB = "rb", Ve.RP = "rp", Ve.RT = "rt", Ve.RTC = "rtc", Ve.RUBY = "ruby", Ve.S = "s", Ve.SCRIPT = "script", Ve.SECTION = "section", Ve.SELECT = "select", Ve.SOURCE = "source", Ve.SMALL = "small", Ve.SPAN = "span", Ve.STRIKE = "strike", Ve.STRONG = "strong", Ve.STYLE = "style", Ve.SUB = "sub", Ve.SUMMARY = "summary", Ve.SUP = "sup", Ve.TABLE = "table", Ve.TBODY = "tbody", Ve.TEMPLATE = "template", Ve.TEXTAREA = "textarea", Ve.TFOOT = "tfoot", Ve.TD = "td", Ve.TH = "th", Ve.THEAD = "thead", Ve.TITLE = "title", Ve.TR = "tr", Ve.TRACK = "track", Ve.TT = "tt", Ve.U = "u", Ve.UL = "ul", Ve.SVG = "svg", Ve.VAR = "var", Ve.WBR = "wbr", Ve.XMP = "xmp", (De = re = re || {})[De.UNKNOWN = 0] = "UNKNOWN", De[De.A = 1] = "A", De[De.ADDRESS = 2] = "ADDRESS", De[De.ANNOTATION_XML = 3] = "ANNOTATION_XML", De[De.APPLET = 4] = "APPLET", De[De.AREA = 5] = "AREA", De[De.ARTICLE = 6] = "ARTICLE", De[De.ASIDE = 7] = "ASIDE", De[De.B = 8] = "B", De[De.BASE = 9] = "BASE", De[De.BASEFONT = 10] = "BASEFONT", De[De.BGSOUND = 11] = "BGSOUND", De[De.BIG = 12] = "BIG", De[De.BLOCKQUOTE = 13] = "BLOCKQUOTE", De[De.BODY = 14] = "BODY", De[De.BR = 15] = "BR", De[De.BUTTON = 16] = "BUTTON", De[De.CAPTION = 17] = "CAPTION", De[De.CENTER = 18] = "CENTER", De[De.CODE = 19] = "CODE", De[De.COL = 20] = "COL", De[De.COLGROUP = 21] = "COLGROUP", De[De.DD = 22] = "DD", De[De.DESC = 23] = "DESC", De[De.DETAILS = 24] = "DETAILS", De[De.DIALOG = 25] = "DIALOG", De[De.DIR = 26] = "DIR", De[De.DIV = 27] = "DIV", De[De.DL = 28] = "DL", De[De.DT = 29] = "DT", De[De.EM = 30] = "EM", De[De.EMBED = 31] = "EMBED", De[De.FIELDSET = 32] = "FIELDSET", De[De.FIGCAPTION = 33] = "FIGCAPTION", De[De.FIGURE = 34] = "FIGURE", De[De.FONT = 35] = "FONT", De[De.FOOTER = 36] = "FOOTER", De[De.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", De[De.FORM = 38] = "FORM", De[De.FRAME = 39] = "FRAME", De[De.FRAMESET = 40] = "FRAMESET", De[De.H1 = 41] = "H1", De[De.H2 = 42] = "H2", De[De.H3 = 43] = "H3", De[De.H4 = 44] = "H4", De[De.H5 = 45] = "H5", De[De.H6 = 46] = "H6", De[De.HEAD = 47] = "HEAD", De[De.HEADER = 48] = "HEADER", De[De.HGROUP = 49] = "HGROUP", De[De.HR = 50] = "HR", De[De.HTML = 51] = "HTML", De[De.I = 52] = "I", De[De.IMG = 53] = "IMG", De[De.IMAGE = 54] = "IMAGE", De[De.INPUT = 55] = "INPUT", De[De.IFRAME = 56] = "IFRAME", De[De.KEYGEN = 57] = "KEYGEN", De[De.LABEL = 58] = "LABEL", De[De.LI = 59] = "LI", De[De.LINK = 60] = "LINK", De[De.LISTING = 61] = "LISTING", De[De.MAIN = 62] = "MAIN", De[De.MALIGNMARK = 63] = "MALIGNMARK", De[De.MARQUEE = 64] = "MARQUEE", De[De.MATH = 65] = "MATH", De[De.MENU = 66] = "MENU", De[De.META = 67] = "META", De[De.MGLYPH = 68] = "MGLYPH", De[De.MI = 69] = "MI", De[De.MO = 70] = "MO", De[De.MN = 71] = "MN", De[De.MS = 72] = "MS", De[De.MTEXT = 73] = "MTEXT", De[De.NAV = 74] = "NAV", De[De.NOBR = 75] = "NOBR", De[De.NOFRAMES = 76] = "NOFRAMES", De[De.NOEMBED = 77] = "NOEMBED", De[De.NOSCRIPT = 78] = "NOSCRIPT", De[De.OBJECT = 79] = "OBJECT", De[De.OL = 80] = "OL", De[De.OPTGROUP = 81] = "OPTGROUP", De[De.OPTION = 82] = "OPTION", De[De.P = 83] = "P", De[De.PARAM = 84] = "PARAM", De[De.PLAINTEXT = 85] = "PLAINTEXT", De[De.PRE = 86] = "PRE", De[De.RB = 87] = "RB", De[De.RP = 88] = "RP", De[De.RT = 89] = "RT", De[De.RTC = 90] = "RTC", De[De.RUBY = 91] = "RUBY", De[De.S = 92] = "S", De[De.SCRIPT = 93] = "SCRIPT", De[De.SECTION = 94] = "SECTION", De[De.SELECT = 95] = "SELECT", De[De.SOURCE = 96] = "SOURCE", De[De.SMALL = 97] = "SMALL", De[De.SPAN = 98] = "SPAN", De[De.STRIKE = 99] = "STRIKE", De[De.STRONG = 100] = "STRONG", De[De.STYLE = 101] = "STYLE", De[De.SUB = 102] = "SUB", De[De.SUMMARY = 103] = "SUMMARY", De[De.SUP = 104] = "SUP", De[De.TABLE = 105] = "TABLE", De[De.TBODY = 106] = "TBODY", De[De.TEMPLATE = 107] = "TEMPLATE", De[De.TEXTAREA = 108] = "TEXTAREA", De[De.TFOOT = 109] = "TFOOT", De[De.TD = 110] = "TD", De[De.TH = 111] = "TH", De[De.THEAD = 112] = "THEAD", De[De.TITLE = 113] = "TITLE", De[De.TR = 114] = "TR", De[De.TRACK = 115] = "TRACK", De[De.TT = 116] = "TT", De[De.U = 117] = "U", De[De.UL = 118] = "UL", De[De.SVG = 119] = "SVG", De[De.VAR = 120] = "VAR", De[De.WBR = 121] = "WBR", De[De.XMP = 122] = "XMP";
      var xd = /* @__PURE__ */ new Map([[ht.A, re.A], [ht.ADDRESS, re.ADDRESS], [ht.ANNOTATION_XML, re.ANNOTATION_XML], [ht.APPLET, re.APPLET], [ht.AREA, re.AREA], [ht.ARTICLE, re.ARTICLE], [ht.ASIDE, re.ASIDE], [ht.B, re.B], [ht.BASE, re.BASE], [ht.BASEFONT, re.BASEFONT], [ht.BGSOUND, re.BGSOUND], [ht.BIG, re.BIG], [ht.BLOCKQUOTE, re.BLOCKQUOTE], [ht.BODY, re.BODY], [ht.BR, re.BR], [ht.BUTTON, re.BUTTON], [ht.CAPTION, re.CAPTION], [ht.CENTER, re.CENTER], [ht.CODE, re.CODE], [ht.COL, re.COL], [ht.COLGROUP, re.COLGROUP], [ht.DD, re.DD], [ht.DESC, re.DESC], [ht.DETAILS, re.DETAILS], [ht.DIALOG, re.DIALOG], [ht.DIR, re.DIR], [ht.DIV, re.DIV], [ht.DL, re.DL], [ht.DT, re.DT], [ht.EM, re.EM], [ht.EMBED, re.EMBED], [ht.FIELDSET, re.FIELDSET], [ht.FIGCAPTION, re.FIGCAPTION], [ht.FIGURE, re.FIGURE], [ht.FONT, re.FONT], [ht.FOOTER, re.FOOTER], [ht.FOREIGN_OBJECT, re.FOREIGN_OBJECT], [ht.FORM, re.FORM], [ht.FRAME, re.FRAME], [ht.FRAMESET, re.FRAMESET], [ht.H1, re.H1], [ht.H2, re.H2], [ht.H3, re.H3], [ht.H4, re.H4], [ht.H5, re.H5], [ht.H6, re.H6], [ht.HEAD, re.HEAD], [ht.HEADER, re.HEADER], [ht.HGROUP, re.HGROUP], [ht.HR, re.HR], [ht.HTML, re.HTML], [ht.I, re.I], [ht.IMG, re.IMG], [ht.IMAGE, re.IMAGE], [ht.INPUT, re.INPUT], [ht.IFRAME, re.IFRAME], [ht.KEYGEN, re.KEYGEN], [ht.LABEL, re.LABEL], [ht.LI, re.LI], [ht.LINK, re.LINK], [ht.LISTING, re.LISTING], [ht.MAIN, re.MAIN], [ht.MALIGNMARK, re.MALIGNMARK], [ht.MARQUEE, re.MARQUEE], [ht.MATH, re.MATH], [ht.MENU, re.MENU], [ht.META, re.META], [ht.MGLYPH, re.MGLYPH], [ht.MI, re.MI], [ht.MO, re.MO], [ht.MN, re.MN], [ht.MS, re.MS], [ht.MTEXT, re.MTEXT], [ht.NAV, re.NAV], [ht.NOBR, re.NOBR], [ht.NOFRAMES, re.NOFRAMES], [ht.NOEMBED, re.NOEMBED], [ht.NOSCRIPT, re.NOSCRIPT], [ht.OBJECT, re.OBJECT], [ht.OL, re.OL], [ht.OPTGROUP, re.OPTGROUP], [ht.OPTION, re.OPTION], [ht.P, re.P], [ht.PARAM, re.PARAM], [ht.PLAINTEXT, re.PLAINTEXT], [ht.PRE, re.PRE], [ht.RB, re.RB], [ht.RP, re.RP], [ht.RT, re.RT], [ht.RTC, re.RTC], [ht.RUBY, re.RUBY], [ht.S, re.S], [ht.SCRIPT, re.SCRIPT], [ht.SECTION, re.SECTION], [ht.SELECT, re.SELECT], [ht.SOURCE, re.SOURCE], [ht.SMALL, re.SMALL], [ht.SPAN, re.SPAN], [ht.STRIKE, re.STRIKE], [ht.STRONG, re.STRONG], [ht.STYLE, re.STYLE], [ht.SUB, re.SUB], [ht.SUMMARY, re.SUMMARY], [ht.SUP, re.SUP], [ht.TABLE, re.TABLE], [ht.TBODY, re.TBODY], [ht.TEMPLATE, re.TEMPLATE], [ht.TEXTAREA, re.TEXTAREA], [ht.TFOOT, re.TFOOT], [ht.TD, re.TD], [ht.TH, re.TH], [ht.THEAD, re.THEAD], [ht.TITLE, re.TITLE], [ht.TR, re.TR], [ht.TRACK, re.TRACK], [ht.TT, re.TT], [ht.U, re.U], [ht.UL, re.UL], [ht.SVG, re.SVG], [ht.VAR, re.VAR], [ht.WBR, re.WBR], [ht.XMP, re.XMP]]);
      function Cu(M) {
        return (M = xd.get(M)) !== null && M !== void 0 ? M : re.UNKNOWN;
      }
      var Vt = re, Td = Ll(Ll(Ll(Ll(Ll(Ll({}, Tt.HTML, /* @__PURE__ */ new Set([Vt.ADDRESS, Vt.APPLET, Vt.AREA, Vt.ARTICLE, Vt.ASIDE, Vt.BASE, Vt.BASEFONT, Vt.BGSOUND, Vt.BLOCKQUOTE, Vt.BODY, Vt.BR, Vt.BUTTON, Vt.CAPTION, Vt.CENTER, Vt.COL, Vt.COLGROUP, Vt.DD, Vt.DETAILS, Vt.DIR, Vt.DIV, Vt.DL, Vt.DT, Vt.EMBED, Vt.FIELDSET, Vt.FIGCAPTION, Vt.FIGURE, Vt.FOOTER, Vt.FORM, Vt.FRAME, Vt.FRAMESET, Vt.H1, Vt.H2, Vt.H3, Vt.H4, Vt.H5, Vt.H6, Vt.HEAD, Vt.HEADER, Vt.HGROUP, Vt.HR, Vt.HTML, Vt.IFRAME, Vt.IMG, Vt.INPUT, Vt.LI, Vt.LINK, Vt.LISTING, Vt.MAIN, Vt.MARQUEE, Vt.MENU, Vt.META, Vt.NAV, Vt.NOEMBED, Vt.NOFRAMES, Vt.NOSCRIPT, Vt.OBJECT, Vt.OL, Vt.P, Vt.PARAM, Vt.PLAINTEXT, Vt.PRE, Vt.SCRIPT, Vt.SECTION, Vt.SELECT, Vt.SOURCE, Vt.STYLE, Vt.SUMMARY, Vt.TABLE, Vt.TBODY, Vt.TD, Vt.TEMPLATE, Vt.TEXTAREA, Vt.TFOOT, Vt.TH, Vt.THEAD, Vt.TITLE, Vt.TR, Vt.TRACK, Vt.UL, Vt.WBR, Vt.XMP])), Tt.MATHML, /* @__PURE__ */ new Set([Vt.MI, Vt.MO, Vt.MN, Vt.MS, Vt.MTEXT, Vt.ANNOTATION_XML])), Tt.SVG, /* @__PURE__ */ new Set([Vt.TITLE, Vt.FOREIGN_OBJECT, Vt.DESC])), Tt.XLINK, /* @__PURE__ */ new Set()), Tt.XML, /* @__PURE__ */ new Set()), Tt.XMLNS, /* @__PURE__ */ new Set());
      function ll(M) {
        return M === Vt.H1 || M === Vt.H2 || M === Vt.H3 || M === Vt.H4 || M === Vt.H5 || M === Vt.H6;
      }
      var sp = /* @__PURE__ */ new Set([ht.STYLE, ht.SCRIPT, ht.XMP, ht.IFRAME, ht.NOEMBED, ht.NOFRAMES, ht.PLAINTEXT]);
      function jf(M, O) {
        return sp.has(M) || O && M === ht.NOSCRIPT;
      }
      function ki(M) {
        return (ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function lp(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, function(ue) {
            return ue = function(Ae, Ne) {
              if (ki(Ae) != "object" || !Ae) return Ae;
              var Fe = Ae[Symbol.toPrimitive];
              if (Fe === void 0) return (Ne === "string" ? String : Number)(Ae);
              if (ki(Ne = Fe.call(Ae, Ne || "default")) != "object") return Ne;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ue, "string"), ki(ue) == "symbol" ? ue : String(ue);
          }(R.key), R);
        }
      }
      var He, Um = /* @__PURE__ */ new Map([[128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
      (ct = He = He || {})[ct.DATA = 0] = "DATA", ct[ct.RCDATA = 1] = "RCDATA", ct[ct.RAWTEXT = 2] = "RAWTEXT", ct[ct.SCRIPT_DATA = 3] = "SCRIPT_DATA", ct[ct.PLAINTEXT = 4] = "PLAINTEXT", ct[ct.TAG_OPEN = 5] = "TAG_OPEN", ct[ct.END_TAG_OPEN = 6] = "END_TAG_OPEN", ct[ct.TAG_NAME = 7] = "TAG_NAME", ct[ct.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", ct[ct.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", ct[ct.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", ct[ct.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", ct[ct.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", ct[ct.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", ct[ct.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", ct[ct.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", ct[ct.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", ct[ct.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", ct[ct.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", ct[ct.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", ct[ct.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", ct[ct.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", ct[ct.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", ct[ct.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", ct[ct.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", ct[ct.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", ct[ct.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", ct[ct.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", ct[ct.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", ct[ct.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", ct[ct.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", ct[ct.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", ct[ct.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", ct[ct.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", ct[ct.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", ct[ct.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", ct[ct.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", ct[ct.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", ct[ct.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", ct[ct.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", ct[ct.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", ct[ct.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", ct[ct.COMMENT_START = 42] = "COMMENT_START", ct[ct.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", ct[ct.COMMENT = 44] = "COMMENT", ct[ct.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", ct[ct.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", ct[ct.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", ct[ct.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", ct[ct.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", ct[ct.COMMENT_END = 50] = "COMMENT_END", ct[ct.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", ct[ct.DOCTYPE = 52] = "DOCTYPE", ct[ct.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", ct[ct.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", ct[ct.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", ct[ct.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", ct[ct.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", ct[ct.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", ct[ct.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", ct[ct.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", ct[ct.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", ct[ct.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", ct[ct.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", ct[ct.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", ct[ct.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", ct[ct.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", ct[ct.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", ct[ct.CDATA_SECTION = 68] = "CDATA_SECTION", ct[ct.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", ct[ct.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", ct[ct.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", ct[ct.NAMED_CHARACTER_REFERENCE = 72] = "NAMED_CHARACTER_REFERENCE", ct[ct.AMBIGUOUS_AMPERSAND = 73] = "AMBIGUOUS_AMPERSAND", ct[ct.NUMERIC_CHARACTER_REFERENCE = 74] = "NUMERIC_CHARACTER_REFERENCE", ct[ct.HEXADEMICAL_CHARACTER_REFERENCE_START = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START", ct[ct.HEXADEMICAL_CHARACTER_REFERENCE = 76] = "HEXADEMICAL_CHARACTER_REFERENCE", ct[ct.DECIMAL_CHARACTER_REFERENCE = 77] = "DECIMAL_CHARACTER_REFERENCE", ct[ct.NUMERIC_CHARACTER_REFERENCE_END = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
      var Uo = { DATA: He.DATA, RCDATA: He.RCDATA, RAWTEXT: He.RAWTEXT, SCRIPT_DATA: He.SCRIPT_DATA, PLAINTEXT: He.PLAINTEXT, CDATA_SECTION: He.CDATA_SECTION };
      function wc(M) {
        return M >= Pe.DIGIT_0 && M <= Pe.DIGIT_9;
      }
      function xc(M) {
        return M >= Pe.LATIN_CAPITAL_A && M <= Pe.LATIN_CAPITAL_Z;
      }
      function Eo(M) {
        return function(w) {
          return w >= Pe.LATIN_SMALL_A && w <= Pe.LATIN_SMALL_Z;
        }(M) || xc(M);
      }
      function wu(M) {
        return Eo(M) || wc(M);
      }
      function Ml(M) {
        return M >= Pe.LATIN_CAPITAL_A && M <= Pe.LATIN_CAPITAL_F;
      }
      function Hm(M) {
        return M >= Pe.LATIN_SMALL_A && M <= Pe.LATIN_SMALL_F;
      }
      function Tc(M) {
        return M === Pe.SPACE || M === Pe.LINE_FEED || M === Pe.TABULATION || M === Pe.FORM_FEED;
      }
      function Ac(M) {
        return Tc(M) || M === Pe.SOLIDUS || M === Pe.GREATER_THAN_SIGN;
      }
      var w0 = function() {
        function M(O, w) {
          (function(W, ue) {
            if (!(W instanceof ue)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.options = O, this.handler = w, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = He.DATA, this.returnState = He.DATA, this.charRefCode = -1, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new wd(w), this.currentLocation = this.getCurrentLocation(-1);
        }
        return function(w, R, W) {
          R && lp(w.prototype, R), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "_err", value: function(w) {
          var R, W;
          (W = (R = this.handler).onParseError) !== null && W !== void 0 && W.call(R, this.preprocessor.getError(w));
        } }, { key: "getCurrentLocation", value: function(w) {
          return this.options.sourceCodeLocationInfo ? { startLine: this.preprocessor.line, startCol: this.preprocessor.col - w, startOffset: this.preprocessor.offset - w, endLine: -1, endCol: -1, endOffset: -1 } : null;
        } }, { key: "_runParsingLoop", value: function() {
          if (!this.inLoop) {
            for (this.inLoop = !0; this.active && !this.paused; ) {
              this.consumedAfterSnapshot = 0;
              var w = this._consume();
              this._ensureHibernation() || this._callState(w);
            }
            this.inLoop = !1;
          }
        } }, { key: "pause", value: function() {
          this.paused = !0;
        } }, { key: "resume", value: function(w) {
          if (!this.paused) throw new Error("Parser was already resumed");
          this.paused = !1, this.inLoop || (this._runParsingLoop(), this.paused || w != null && w());
        } }, { key: "write", value: function(w, R, W) {
          this.active = !0, this.preprocessor.write(w, R), this._runParsingLoop(), this.paused || W != null && W();
        } }, { key: "insertHtmlAtCurrentPos", value: function(w) {
          this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(w), this._runParsingLoop();
        } }, { key: "_ensureHibernation", value: function() {
          return !(!this.preprocessor.endOfChunkHit || (this._unconsume(this.consumedAfterSnapshot), this.active = !1));
        } }, { key: "_consume", value: function() {
          return this.consumedAfterSnapshot++, this.preprocessor.advance();
        } }, { key: "_unconsume", value: function(w) {
          this.consumedAfterSnapshot -= w, this.preprocessor.retreat(w);
        } }, { key: "_reconsumeInState", value: function(w, R) {
          this.state = w, this._callState(R);
        } }, { key: "_advanceBy", value: function(w) {
          this.consumedAfterSnapshot += w;
          for (var R = 0; R < w; R++) this.preprocessor.advance();
        } }, { key: "_consumeSequenceIfMatch", value: function(w, R) {
          return !!this.preprocessor.startsWith(w, R) && (this._advanceBy(w.length - 1), !0);
        } }, { key: "_createStartTagToken", value: function() {
          this.currentToken = { type: Cr.START_TAG, tagName: "", tagID: re.UNKNOWN, selfClosing: !1, ackSelfClosing: !1, attrs: [], location: this.getCurrentLocation(1) };
        } }, { key: "_createEndTagToken", value: function() {
          this.currentToken = { type: Cr.END_TAG, tagName: "", tagID: re.UNKNOWN, selfClosing: !1, ackSelfClosing: !1, attrs: [], location: this.getCurrentLocation(2) };
        } }, { key: "_createCommentToken", value: function(w) {
          this.currentToken = { type: Cr.COMMENT, data: "", location: this.getCurrentLocation(w) };
        } }, { key: "_createDoctypeToken", value: function(w) {
          this.currentToken = { type: Cr.DOCTYPE, name: w, forceQuirks: !1, publicId: null, systemId: null, location: this.currentLocation };
        } }, { key: "_createCharacterToken", value: function(w, R) {
          this.currentCharacterToken = { type: w, chars: R, location: this.currentLocation };
        } }, { key: "_createAttr", value: function(w) {
          this.currentAttr = { name: w, value: "" }, this.currentLocation = this.getCurrentLocation(0);
        } }, { key: "_leaveAttrName", value: function() {
          var w, R = this.currentToken;
          ap(R, this.currentAttr.name) === null ? (R.attrs.push(this.currentAttr), R.location && this.currentLocation && (((R = (w = R.location).attrs) !== null && R !== void 0 ? R : w.attrs = /* @__PURE__ */ Object.create(null))[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue())) : this._err(xt.duplicateAttribute);
        } }, { key: "_leaveAttrValue", value: function() {
          this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
        } }, { key: "prepareToken", value: function(w) {
          this._emitCurrentCharacterToken(w.location), this.currentToken = null, w.location && (w.location.endLine = this.preprocessor.line, w.location.endCol = this.preprocessor.col + 1, w.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
        } }, { key: "emitCurrentTagToken", value: function() {
          var w = this.currentToken;
          this.prepareToken(w), w.tagID = Cu(w.tagName), w.type === Cr.START_TAG ? (this.lastStartTagName = w.tagName, this.handler.onStartTag(w)) : (0 < w.attrs.length && this._err(xt.endTagWithAttributes), w.selfClosing && this._err(xt.endTagWithTrailingSolidus), this.handler.onEndTag(w)), this.preprocessor.dropParsedChunk();
        } }, { key: "emitCurrentComment", value: function(w) {
          this.prepareToken(w), this.handler.onComment(w), this.preprocessor.dropParsedChunk();
        } }, { key: "emitCurrentDoctype", value: function(w) {
          this.prepareToken(w), this.handler.onDoctype(w), this.preprocessor.dropParsedChunk();
        } }, { key: "_emitCurrentCharacterToken", value: function(w) {
          if (this.currentCharacterToken) {
            switch (w && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = w.startLine, this.currentCharacterToken.location.endCol = w.startCol, this.currentCharacterToken.location.endOffset = w.startOffset), this.currentCharacterToken.type) {
              case Cr.CHARACTER:
                this.handler.onCharacter(this.currentCharacterToken);
                break;
              case Cr.NULL_CHARACTER:
                this.handler.onNullCharacter(this.currentCharacterToken);
                break;
              case Cr.WHITESPACE_CHARACTER:
                this.handler.onWhitespaceCharacter(this.currentCharacterToken);
            }
            this.currentCharacterToken = null;
          }
        } }, { key: "_emitEOFToken", value: function() {
          var w = this.getCurrentLocation(0);
          w && (w.endLine = w.startLine, w.endCol = w.startCol, w.endOffset = w.startOffset), this._emitCurrentCharacterToken(w), this.handler.onEof({ type: Cr.EOF, location: w }), this.active = !1;
        } }, { key: "_appendCharToCurrentCharacterToken", value: function(w, R) {
          if (this.currentCharacterToken) {
            if (this.currentCharacterToken.type === w) return void (this.currentCharacterToken.chars += R);
            this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
          }
          this._createCharacterToken(w, R);
        } }, { key: "_emitCodePoint", value: function(w) {
          var R = Tc(w) ? Cr.WHITESPACE_CHARACTER : w === Pe.NULL ? Cr.NULL_CHARACTER : Cr.CHARACTER;
          this._appendCharToCurrentCharacterToken(R, String.fromCodePoint(w));
        } }, { key: "_emitChars", value: function(w) {
          this._appendCharToCurrentCharacterToken(Cr.CHARACTER, w);
        } }, { key: "_matchNamedCharacterReference", value: function(w) {
          for (var R = null, W = 0, ue = !1, me = 0, Ae = ji.htmlDecodeTree[0]; 0 <= me && !((me = Object(ji.determineBranch)(ji.htmlDecodeTree, Ae, me + 1, w)) < 0); w = this._consume()) {
            W += 1;
            var Ne = (Ae = ji.htmlDecodeTree[me]) & ji.BinTrieFlags.VALUE_LENGTH;
            if (Ne && (Ne = (Ne >> 14) - 1, w !== Pe.SEMICOLON && this._isCharacterReferenceInAttribute() && function(ut) {
              return ut === Pe.EQUALS_SIGN || wu(ut);
            }(this.preprocessor.peek(1)) ? (R = [Pe.AMPERSAND], me += Ne) : (R = Ne == 0 ? [ji.htmlDecodeTree[me] & ~ji.BinTrieFlags.VALUE_LENGTH] : Ne == 1 ? [ji.htmlDecodeTree[++me]] : [ji.htmlDecodeTree[++me], ji.htmlDecodeTree[++me]], W = 0, ue = w !== Pe.SEMICOLON), Ne == 0)) {
              this._consume();
              break;
            }
          }
          return this._unconsume(W), ue && !this.preprocessor.endOfChunkHit && this._err(xt.missingSemicolonAfterCharacterReference), this._unconsume(1), R;
        } }, { key: "_isCharacterReferenceInAttribute", value: function() {
          return this.returnState === He.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === He.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === He.ATTRIBUTE_VALUE_UNQUOTED;
        } }, { key: "_flushCodePointConsumedAsCharacterReference", value: function(w) {
          this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(w) : this._emitCodePoint(w);
        } }, { key: "_callState", value: function(w) {
          switch (this.state) {
            case He.DATA:
              this._stateData(w);
              break;
            case He.RCDATA:
              this._stateRcdata(w);
              break;
            case He.RAWTEXT:
              this._stateRawtext(w);
              break;
            case He.SCRIPT_DATA:
              this._stateScriptData(w);
              break;
            case He.PLAINTEXT:
              this._statePlaintext(w);
              break;
            case He.TAG_OPEN:
              this._stateTagOpen(w);
              break;
            case He.END_TAG_OPEN:
              this._stateEndTagOpen(w);
              break;
            case He.TAG_NAME:
              this._stateTagName(w);
              break;
            case He.RCDATA_LESS_THAN_SIGN:
              this._stateRcdataLessThanSign(w);
              break;
            case He.RCDATA_END_TAG_OPEN:
              this._stateRcdataEndTagOpen(w);
              break;
            case He.RCDATA_END_TAG_NAME:
              this._stateRcdataEndTagName(w);
              break;
            case He.RAWTEXT_LESS_THAN_SIGN:
              this._stateRawtextLessThanSign(w);
              break;
            case He.RAWTEXT_END_TAG_OPEN:
              this._stateRawtextEndTagOpen(w);
              break;
            case He.RAWTEXT_END_TAG_NAME:
              this._stateRawtextEndTagName(w);
              break;
            case He.SCRIPT_DATA_LESS_THAN_SIGN:
              this._stateScriptDataLessThanSign(w);
              break;
            case He.SCRIPT_DATA_END_TAG_OPEN:
              this._stateScriptDataEndTagOpen(w);
              break;
            case He.SCRIPT_DATA_END_TAG_NAME:
              this._stateScriptDataEndTagName(w);
              break;
            case He.SCRIPT_DATA_ESCAPE_START:
              this._stateScriptDataEscapeStart(w);
              break;
            case He.SCRIPT_DATA_ESCAPE_START_DASH:
              this._stateScriptDataEscapeStartDash(w);
              break;
            case He.SCRIPT_DATA_ESCAPED:
              this._stateScriptDataEscaped(w);
              break;
            case He.SCRIPT_DATA_ESCAPED_DASH:
              this._stateScriptDataEscapedDash(w);
              break;
            case He.SCRIPT_DATA_ESCAPED_DASH_DASH:
              this._stateScriptDataEscapedDashDash(w);
              break;
            case He.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
              this._stateScriptDataEscapedLessThanSign(w);
              break;
            case He.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
              this._stateScriptDataEscapedEndTagOpen(w);
              break;
            case He.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
              this._stateScriptDataEscapedEndTagName(w);
              break;
            case He.SCRIPT_DATA_DOUBLE_ESCAPE_START:
              this._stateScriptDataDoubleEscapeStart(w);
              break;
            case He.SCRIPT_DATA_DOUBLE_ESCAPED:
              this._stateScriptDataDoubleEscaped(w);
              break;
            case He.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
              this._stateScriptDataDoubleEscapedDash(w);
              break;
            case He.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
              this._stateScriptDataDoubleEscapedDashDash(w);
              break;
            case He.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
              this._stateScriptDataDoubleEscapedLessThanSign(w);
              break;
            case He.SCRIPT_DATA_DOUBLE_ESCAPE_END:
              this._stateScriptDataDoubleEscapeEnd(w);
              break;
            case He.BEFORE_ATTRIBUTE_NAME:
              this._stateBeforeAttributeName(w);
              break;
            case He.ATTRIBUTE_NAME:
              this._stateAttributeName(w);
              break;
            case He.AFTER_ATTRIBUTE_NAME:
              this._stateAfterAttributeName(w);
              break;
            case He.BEFORE_ATTRIBUTE_VALUE:
              this._stateBeforeAttributeValue(w);
              break;
            case He.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
              this._stateAttributeValueDoubleQuoted(w);
              break;
            case He.ATTRIBUTE_VALUE_SINGLE_QUOTED:
              this._stateAttributeValueSingleQuoted(w);
              break;
            case He.ATTRIBUTE_VALUE_UNQUOTED:
              this._stateAttributeValueUnquoted(w);
              break;
            case He.AFTER_ATTRIBUTE_VALUE_QUOTED:
              this._stateAfterAttributeValueQuoted(w);
              break;
            case He.SELF_CLOSING_START_TAG:
              this._stateSelfClosingStartTag(w);
              break;
            case He.BOGUS_COMMENT:
              this._stateBogusComment(w);
              break;
            case He.MARKUP_DECLARATION_OPEN:
              this._stateMarkupDeclarationOpen(w);
              break;
            case He.COMMENT_START:
              this._stateCommentStart(w);
              break;
            case He.COMMENT_START_DASH:
              this._stateCommentStartDash(w);
              break;
            case He.COMMENT:
              this._stateComment(w);
              break;
            case He.COMMENT_LESS_THAN_SIGN:
              this._stateCommentLessThanSign(w);
              break;
            case He.COMMENT_LESS_THAN_SIGN_BANG:
              this._stateCommentLessThanSignBang(w);
              break;
            case He.COMMENT_LESS_THAN_SIGN_BANG_DASH:
              this._stateCommentLessThanSignBangDash(w);
              break;
            case He.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
              this._stateCommentLessThanSignBangDashDash(w);
              break;
            case He.COMMENT_END_DASH:
              this._stateCommentEndDash(w);
              break;
            case He.COMMENT_END:
              this._stateCommentEnd(w);
              break;
            case He.COMMENT_END_BANG:
              this._stateCommentEndBang(w);
              break;
            case He.DOCTYPE:
              this._stateDoctype(w);
              break;
            case He.BEFORE_DOCTYPE_NAME:
              this._stateBeforeDoctypeName(w);
              break;
            case He.DOCTYPE_NAME:
              this._stateDoctypeName(w);
              break;
            case He.AFTER_DOCTYPE_NAME:
              this._stateAfterDoctypeName(w);
              break;
            case He.AFTER_DOCTYPE_PUBLIC_KEYWORD:
              this._stateAfterDoctypePublicKeyword(w);
              break;
            case He.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
              this._stateBeforeDoctypePublicIdentifier(w);
              break;
            case He.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
              this._stateDoctypePublicIdentifierDoubleQuoted(w);
              break;
            case He.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
              this._stateDoctypePublicIdentifierSingleQuoted(w);
              break;
            case He.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
              this._stateAfterDoctypePublicIdentifier(w);
              break;
            case He.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
              this._stateBetweenDoctypePublicAndSystemIdentifiers(w);
              break;
            case He.AFTER_DOCTYPE_SYSTEM_KEYWORD:
              this._stateAfterDoctypeSystemKeyword(w);
              break;
            case He.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
              this._stateBeforeDoctypeSystemIdentifier(w);
              break;
            case He.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
              this._stateDoctypeSystemIdentifierDoubleQuoted(w);
              break;
            case He.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
              this._stateDoctypeSystemIdentifierSingleQuoted(w);
              break;
            case He.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
              this._stateAfterDoctypeSystemIdentifier(w);
              break;
            case He.BOGUS_DOCTYPE:
              this._stateBogusDoctype(w);
              break;
            case He.CDATA_SECTION:
              this._stateCdataSection(w);
              break;
            case He.CDATA_SECTION_BRACKET:
              this._stateCdataSectionBracket(w);
              break;
            case He.CDATA_SECTION_END:
              this._stateCdataSectionEnd(w);
              break;
            case He.CHARACTER_REFERENCE:
              this._stateCharacterReference(w);
              break;
            case He.NAMED_CHARACTER_REFERENCE:
              this._stateNamedCharacterReference(w);
              break;
            case He.AMBIGUOUS_AMPERSAND:
              this._stateAmbiguousAmpersand(w);
              break;
            case He.NUMERIC_CHARACTER_REFERENCE:
              this._stateNumericCharacterReference(w);
              break;
            case He.HEXADEMICAL_CHARACTER_REFERENCE_START:
              this._stateHexademicalCharacterReferenceStart(w);
              break;
            case He.HEXADEMICAL_CHARACTER_REFERENCE:
              this._stateHexademicalCharacterReference(w);
              break;
            case He.DECIMAL_CHARACTER_REFERENCE:
              this._stateDecimalCharacterReference(w);
              break;
            case He.NUMERIC_CHARACTER_REFERENCE_END:
              this._stateNumericCharacterReferenceEnd(w);
              break;
            default:
              throw new Error("Unknown state");
          }
        } }, { key: "_stateData", value: function(w) {
          switch (w) {
            case Pe.LESS_THAN_SIGN:
              this.state = He.TAG_OPEN;
              break;
            case Pe.AMPERSAND:
              this.returnState = He.DATA, this.state = He.CHARACTER_REFERENCE;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitCodePoint(w);
              break;
            case Pe.EOF:
              this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateRcdata", value: function(w) {
          switch (w) {
            case Pe.AMPERSAND:
              this.returnState = He.RCDATA, this.state = He.CHARACTER_REFERENCE;
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.RCDATA_LESS_THAN_SIGN;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitChars("�");
              break;
            case Pe.EOF:
              this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateRawtext", value: function(w) {
          switch (w) {
            case Pe.LESS_THAN_SIGN:
              this.state = He.RAWTEXT_LESS_THAN_SIGN;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitChars("�");
              break;
            case Pe.EOF:
              this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptData", value: function(w) {
          switch (w) {
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_LESS_THAN_SIGN;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitChars("�");
              break;
            case Pe.EOF:
              this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_statePlaintext", value: function(w) {
          switch (w) {
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitChars("�");
              break;
            case Pe.EOF:
              this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateTagOpen", value: function(w) {
          if (Eo(w)) this._createStartTagToken(), this.state = He.TAG_NAME, this._stateTagName(w);
          else switch (w) {
            case Pe.EXCLAMATION_MARK:
              this.state = He.MARKUP_DECLARATION_OPEN;
              break;
            case Pe.SOLIDUS:
              this.state = He.END_TAG_OPEN;
              break;
            case Pe.QUESTION_MARK:
              this._err(xt.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = He.BOGUS_COMMENT, this._stateBogusComment(w);
              break;
            case Pe.EOF:
              this._err(xt.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
              break;
            default:
              this._err(xt.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = He.DATA, this._stateData(w);
          }
        } }, { key: "_stateEndTagOpen", value: function(w) {
          if (Eo(w)) this._createEndTagToken(), this.state = He.TAG_NAME, this._stateTagName(w);
          else switch (w) {
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingEndTagName), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
              break;
            default:
              this._err(xt.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = He.BOGUS_COMMENT, this._stateBogusComment(w);
          }
        } }, { key: "_stateTagName", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this.state = He.BEFORE_ATTRIBUTE_NAME;
              break;
            case Pe.SOLIDUS:
              this.state = He.SELF_CLOSING_START_TAG;
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentTagToken();
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.tagName += "�";
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              R.tagName += String.fromCodePoint(xc(w) ? w + 32 : w);
          }
        } }, { key: "_stateRcdataLessThanSign", value: function(w) {
          w === Pe.SOLIDUS ? this.state = He.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = He.RCDATA, this._stateRcdata(w));
        } }, { key: "_stateRcdataEndTagOpen", value: function(w) {
          Eo(w) ? (this.state = He.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(w)) : (this._emitChars("</"), this.state = He.RCDATA, this._stateRcdata(w));
        } }, { key: "handleSpecialEndTag", value: function(w) {
          if (!this.preprocessor.startsWith(this.lastStartTagName, !1)) return !this._ensureHibernation();
          switch (this._createEndTagToken(), this.currentToken.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              return this._advanceBy(this.lastStartTagName.length), this.state = He.BEFORE_ATTRIBUTE_NAME, !1;
            case Pe.SOLIDUS:
              return this._advanceBy(this.lastStartTagName.length), this.state = He.SELF_CLOSING_START_TAG, !1;
            case Pe.GREATER_THAN_SIGN:
              return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = He.DATA, !1;
            default:
              return !this._ensureHibernation();
          }
        } }, { key: "_stateRcdataEndTagName", value: function(w) {
          this.handleSpecialEndTag(w) && (this._emitChars("</"), this.state = He.RCDATA, this._stateRcdata(w));
        } }, { key: "_stateRawtextLessThanSign", value: function(w) {
          w === Pe.SOLIDUS ? this.state = He.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = He.RAWTEXT, this._stateRawtext(w));
        } }, { key: "_stateRawtextEndTagOpen", value: function(w) {
          Eo(w) ? (this.state = He.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(w)) : (this._emitChars("</"), this.state = He.RAWTEXT, this._stateRawtext(w));
        } }, { key: "_stateRawtextEndTagName", value: function(w) {
          this.handleSpecialEndTag(w) && (this._emitChars("</"), this.state = He.RAWTEXT, this._stateRawtext(w));
        } }, { key: "_stateScriptDataLessThanSign", value: function(w) {
          switch (w) {
            case Pe.SOLIDUS:
              this.state = He.SCRIPT_DATA_END_TAG_OPEN;
              break;
            case Pe.EXCLAMATION_MARK:
              this.state = He.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
              break;
            default:
              this._emitChars("<"), this.state = He.SCRIPT_DATA, this._stateScriptData(w);
          }
        } }, { key: "_stateScriptDataEndTagOpen", value: function(w) {
          Eo(w) ? (this.state = He.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(w)) : (this._emitChars("</"), this.state = He.SCRIPT_DATA, this._stateScriptData(w));
        } }, { key: "_stateScriptDataEndTagName", value: function(w) {
          this.handleSpecialEndTag(w) && (this._emitChars("</"), this.state = He.SCRIPT_DATA, this._stateScriptData(w));
        } }, { key: "_stateScriptDataEscapeStart", value: function(w) {
          w === Pe.HYPHEN_MINUS ? (this.state = He.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = He.SCRIPT_DATA, this._stateScriptData(w));
        } }, { key: "_stateScriptDataEscapeStartDash", value: function(w) {
          w === Pe.HYPHEN_MINUS ? (this.state = He.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = He.SCRIPT_DATA, this._stateScriptData(w));
        } }, { key: "_stateScriptDataEscaped", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitChars("�");
              break;
            case Pe.EOF:
              this._err(xt.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptDataEscapedDash", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.state = He.SCRIPT_DATA_ESCAPED, this._emitChars("�");
              break;
            case Pe.EOF:
              this._err(xt.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
              break;
            default:
              this.state = He.SCRIPT_DATA_ESCAPED, this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptDataEscapedDashDash", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this._emitChars("-");
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.SCRIPT_DATA, this._emitChars(">");
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.state = He.SCRIPT_DATA_ESCAPED, this._emitChars("�");
              break;
            case Pe.EOF:
              this._err(xt.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
              break;
            default:
              this.state = He.SCRIPT_DATA_ESCAPED, this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptDataEscapedLessThanSign", value: function(w) {
          w === Pe.SOLIDUS ? this.state = He.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Eo(w) ? (this._emitChars("<"), this.state = He.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(w)) : (this._emitChars("<"), this.state = He.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(w));
        } }, { key: "_stateScriptDataEscapedEndTagOpen", value: function(w) {
          Eo(w) ? (this.state = He.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(w)) : (this._emitChars("</"), this.state = He.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(w));
        } }, { key: "_stateScriptDataEscapedEndTagName", value: function(w) {
          this.handleSpecialEndTag(w) && (this._emitChars("</"), this.state = He.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(w));
        } }, { key: "_stateScriptDataDoubleEscapeStart", value: function(w) {
          if (this.preprocessor.startsWith("script", !1) && Ac(this.preprocessor.peek(6))) {
            this._emitCodePoint(w);
            for (var R = 0; R < 6; R++) this._emitCodePoint(this._consume());
            this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED;
          } else this._ensureHibernation() || (this.state = He.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(w));
        } }, { key: "_stateScriptDataDoubleEscaped", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._emitChars("�");
              break;
            case Pe.EOF:
              this._err(xt.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptDataDoubleEscapedDash", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars("�");
              break;
            case Pe.EOF:
              this._err(xt.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
              break;
            default:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptDataDoubleEscapedDashDash", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this._emitChars("-");
              break;
            case Pe.LESS_THAN_SIGN:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.SCRIPT_DATA, this._emitChars(">");
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars("�");
              break;
            case Pe.EOF:
              this._err(xt.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
              break;
            default:
              this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(w);
          }
        } }, { key: "_stateScriptDataDoubleEscapedLessThanSign", value: function(w) {
          w === Pe.SOLIDUS ? (this.state = He.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(w));
        } }, { key: "_stateScriptDataDoubleEscapeEnd", value: function(w) {
          if (this.preprocessor.startsWith("script", !1) && Ac(this.preprocessor.peek(6))) {
            this._emitCodePoint(w);
            for (var R = 0; R < 6; R++) this._emitCodePoint(this._consume());
            this.state = He.SCRIPT_DATA_ESCAPED;
          } else this._ensureHibernation() || (this.state = He.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(w));
        } }, { key: "_stateBeforeAttributeName", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.SOLIDUS:
            case Pe.GREATER_THAN_SIGN:
            case Pe.EOF:
              this.state = He.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(w);
              break;
            case Pe.EQUALS_SIGN:
              this._err(xt.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = He.ATTRIBUTE_NAME;
              break;
            default:
              this._createAttr(""), this.state = He.ATTRIBUTE_NAME, this._stateAttributeName(w);
          }
        } }, { key: "_stateAttributeName", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
            case Pe.SOLIDUS:
            case Pe.GREATER_THAN_SIGN:
            case Pe.EOF:
              this._leaveAttrName(), this.state = He.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(w);
              break;
            case Pe.EQUALS_SIGN:
              this._leaveAttrName(), this.state = He.BEFORE_ATTRIBUTE_VALUE;
              break;
            case Pe.QUOTATION_MARK:
            case Pe.APOSTROPHE:
            case Pe.LESS_THAN_SIGN:
              this._err(xt.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(w);
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.currentAttr.name += "�";
              break;
            default:
              this.currentAttr.name += String.fromCodePoint(xc(w) ? w + 32 : w);
          }
        } }, { key: "_stateAfterAttributeName", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.SOLIDUS:
              this.state = He.SELF_CLOSING_START_TAG;
              break;
            case Pe.EQUALS_SIGN:
              this.state = He.BEFORE_ATTRIBUTE_VALUE;
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentTagToken();
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              this._createAttr(""), this.state = He.ATTRIBUTE_NAME, this._stateAttributeName(w);
          }
        } }, { key: "_stateBeforeAttributeValue", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.QUOTATION_MARK:
              this.state = He.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              this.state = He.ATTRIBUTE_VALUE_SINGLE_QUOTED;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingAttributeValue), this.state = He.DATA, this.emitCurrentTagToken();
              break;
            default:
              this.state = He.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(w);
          }
        } }, { key: "_stateAttributeValueDoubleQuoted", value: function(w) {
          switch (w) {
            case Pe.QUOTATION_MARK:
              this.state = He.AFTER_ATTRIBUTE_VALUE_QUOTED;
              break;
            case Pe.AMPERSAND:
              this.returnState = He.ATTRIBUTE_VALUE_DOUBLE_QUOTED, this.state = He.CHARACTER_REFERENCE;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.currentAttr.value += "�";
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              this.currentAttr.value += String.fromCodePoint(w);
          }
        } }, { key: "_stateAttributeValueSingleQuoted", value: function(w) {
          switch (w) {
            case Pe.APOSTROPHE:
              this.state = He.AFTER_ATTRIBUTE_VALUE_QUOTED;
              break;
            case Pe.AMPERSAND:
              this.returnState = He.ATTRIBUTE_VALUE_SINGLE_QUOTED, this.state = He.CHARACTER_REFERENCE;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.currentAttr.value += "�";
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              this.currentAttr.value += String.fromCodePoint(w);
          }
        } }, { key: "_stateAttributeValueUnquoted", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this._leaveAttrValue(), this.state = He.BEFORE_ATTRIBUTE_NAME;
              break;
            case Pe.AMPERSAND:
              this.returnState = He.ATTRIBUTE_VALUE_UNQUOTED, this.state = He.CHARACTER_REFERENCE;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._leaveAttrValue(), this.state = He.DATA, this.emitCurrentTagToken();
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this.currentAttr.value += "�";
              break;
            case Pe.QUOTATION_MARK:
            case Pe.APOSTROPHE:
            case Pe.LESS_THAN_SIGN:
            case Pe.EQUALS_SIGN:
            case Pe.GRAVE_ACCENT:
              this._err(xt.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(w);
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              this.currentAttr.value += String.fromCodePoint(w);
          }
        } }, { key: "_stateAfterAttributeValueQuoted", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this._leaveAttrValue(), this.state = He.BEFORE_ATTRIBUTE_NAME;
              break;
            case Pe.SOLIDUS:
              this._leaveAttrValue(), this.state = He.SELF_CLOSING_START_TAG;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._leaveAttrValue(), this.state = He.DATA, this.emitCurrentTagToken();
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingWhitespaceBetweenAttributes), this.state = He.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(w);
          }
        } }, { key: "_stateSelfClosingStartTag", value: function(w) {
          switch (w) {
            case Pe.GREATER_THAN_SIGN:
              this.currentToken.selfClosing = !0, this.state = He.DATA, this.emitCurrentTagToken();
              break;
            case Pe.EOF:
              this._err(xt.eofInTag), this._emitEOFToken();
              break;
            default:
              this._err(xt.unexpectedSolidusInTag), this.state = He.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(w);
          }
        } }, { key: "_stateBogusComment", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentComment(R);
              break;
            case Pe.EOF:
              this.emitCurrentComment(R), this._emitEOFToken();
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.data += "�";
              break;
            default:
              R.data += String.fromCodePoint(w);
          }
        } }, { key: "_stateMarkupDeclarationOpen", value: function(w) {
          this._consumeSequenceIfMatch("--", !0) ? (this._createCommentToken(3), this.state = He.COMMENT_START) : this._consumeSequenceIfMatch("doctype", !1) ? (this.currentLocation = this.getCurrentLocation(8), this.state = He.DOCTYPE) : this._consumeSequenceIfMatch("[CDATA[", !0) ? this.inForeignNode ? this.state = He.CDATA_SECTION : (this._err(xt.cdataInHtmlContent), this._createCommentToken(8), this.currentToken.data = "[CDATA[", this.state = He.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(xt.incorrectlyOpenedComment), this._createCommentToken(2), this.state = He.BOGUS_COMMENT, this._stateBogusComment(w));
        } }, { key: "_stateCommentStart", value: function(w) {
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.COMMENT_START_DASH;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.abruptClosingOfEmptyComment), this.state = He.DATA;
              var R = this.currentToken;
              this.emitCurrentComment(R);
              break;
            default:
              this.state = He.COMMENT, this._stateComment(w);
          }
        } }, { key: "_stateCommentStartDash", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.COMMENT_END;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.abruptClosingOfEmptyComment), this.state = He.DATA, this.emitCurrentComment(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInComment), this.emitCurrentComment(R), this._emitEOFToken();
              break;
            default:
              R.data += "-", this.state = He.COMMENT, this._stateComment(w);
          }
        } }, { key: "_stateComment", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.COMMENT_END_DASH;
              break;
            case Pe.LESS_THAN_SIGN:
              R.data += "<", this.state = He.COMMENT_LESS_THAN_SIGN;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.data += "�";
              break;
            case Pe.EOF:
              this._err(xt.eofInComment), this.emitCurrentComment(R), this._emitEOFToken();
              break;
            default:
              R.data += String.fromCodePoint(w);
          }
        } }, { key: "_stateCommentLessThanSign", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.EXCLAMATION_MARK:
              R.data += "!", this.state = He.COMMENT_LESS_THAN_SIGN_BANG;
              break;
            case Pe.LESS_THAN_SIGN:
              R.data += "<";
              break;
            default:
              this.state = He.COMMENT, this._stateComment(w);
          }
        } }, { key: "_stateCommentLessThanSignBang", value: function(w) {
          w === Pe.HYPHEN_MINUS ? this.state = He.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = He.COMMENT, this._stateComment(w));
        } }, { key: "_stateCommentLessThanSignBangDash", value: function(w) {
          w === Pe.HYPHEN_MINUS ? this.state = He.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = He.COMMENT_END_DASH, this._stateCommentEndDash(w));
        } }, { key: "_stateCommentLessThanSignBangDashDash", value: function(w) {
          w !== Pe.GREATER_THAN_SIGN && w !== Pe.EOF && this._err(xt.nestedComment), this.state = He.COMMENT_END, this._stateCommentEnd(w);
        } }, { key: "_stateCommentEndDash", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.HYPHEN_MINUS:
              this.state = He.COMMENT_END;
              break;
            case Pe.EOF:
              this._err(xt.eofInComment), this.emitCurrentComment(R), this._emitEOFToken();
              break;
            default:
              R.data += "-", this.state = He.COMMENT, this._stateComment(w);
          }
        } }, { key: "_stateCommentEnd", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentComment(R);
              break;
            case Pe.EXCLAMATION_MARK:
              this.state = He.COMMENT_END_BANG;
              break;
            case Pe.HYPHEN_MINUS:
              R.data += "-";
              break;
            case Pe.EOF:
              this._err(xt.eofInComment), this.emitCurrentComment(R), this._emitEOFToken();
              break;
            default:
              R.data += "--", this.state = He.COMMENT, this._stateComment(w);
          }
        } }, { key: "_stateCommentEndBang", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.HYPHEN_MINUS:
              R.data += "--!", this.state = He.COMMENT_END_DASH;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.incorrectlyClosedComment), this.state = He.DATA, this.emitCurrentComment(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInComment), this.emitCurrentComment(R), this._emitEOFToken();
              break;
            default:
              R.data += "--!", this.state = He.COMMENT, this._stateComment(w);
          }
        } }, { key: "_stateDoctype", value: function(w) {
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this.state = He.BEFORE_DOCTYPE_NAME;
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(w);
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), this._createDoctypeToken(null);
              var R = this.currentToken;
              R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingWhitespaceBeforeDoctypeName), this.state = He.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(w);
          }
        } }, { key: "_stateBeforeDoctypeName", value: function(w) {
          if (xc(w)) this._createDoctypeToken(String.fromCharCode(w + 32)), this.state = He.DOCTYPE_NAME;
          else switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), this._createDoctypeToken("�"), this.state = He.DOCTYPE_NAME;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingDoctypeName), this._createDoctypeToken(null);
              var R = this.currentToken;
              R.forceQuirks = !0, this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), this._createDoctypeToken(null), (R = this.currentToken).forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._createDoctypeToken(String.fromCodePoint(w)), this.state = He.DOCTYPE_NAME;
          }
        } }, { key: "_stateDoctypeName", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this.state = He.AFTER_DOCTYPE_NAME;
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.name += "�";
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              R.name += String.fromCodePoint(xc(w) ? w + 32 : w);
          }
        } }, { key: "_stateAfterDoctypeName", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._consumeSequenceIfMatch("public", !1) ? this.state = He.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch("system", !1) ? this.state = He.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(xt.invalidCharacterSequenceAfterDoctypeName), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w));
          }
        } }, { key: "_stateAfterDoctypePublicKeyword", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this.state = He.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
              break;
            case Pe.QUOTATION_MARK:
              this._err(xt.missingWhitespaceAfterDoctypePublicKeyword), R.publicId = "", this.state = He.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              this._err(xt.missingWhitespaceAfterDoctypePublicKeyword), R.publicId = "", this.state = He.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingDoctypePublicIdentifier), R.forceQuirks = !0, this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingQuoteBeforeDoctypePublicIdentifier), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateBeforeDoctypePublicIdentifier", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.QUOTATION_MARK:
              R.publicId = "", this.state = He.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              R.publicId = "", this.state = He.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingDoctypePublicIdentifier), R.forceQuirks = !0, this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingQuoteBeforeDoctypePublicIdentifier), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateDoctypePublicIdentifierDoubleQuoted", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.QUOTATION_MARK:
              this.state = He.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.publicId += "�";
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.abruptDoctypePublicIdentifier), R.forceQuirks = !0, this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              R.publicId += String.fromCodePoint(w);
          }
        } }, { key: "_stateDoctypePublicIdentifierSingleQuoted", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.APOSTROPHE:
              this.state = He.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.publicId += "�";
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.abruptDoctypePublicIdentifier), R.forceQuirks = !0, this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              R.publicId += String.fromCodePoint(w);
          }
        } }, { key: "_stateAfterDoctypePublicIdentifier", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this.state = He.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
              break;
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.QUOTATION_MARK:
              this._err(xt.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              this._err(xt.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingQuoteBeforeDoctypeSystemIdentifier), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateBetweenDoctypePublicAndSystemIdentifiers", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.GREATER_THAN_SIGN:
              this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.QUOTATION_MARK:
              R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingQuoteBeforeDoctypeSystemIdentifier), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateAfterDoctypeSystemKeyword", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              this.state = He.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
              break;
            case Pe.QUOTATION_MARK:
              this._err(xt.missingWhitespaceAfterDoctypeSystemKeyword), R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              this._err(xt.missingWhitespaceAfterDoctypeSystemKeyword), R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingDoctypeSystemIdentifier), R.forceQuirks = !0, this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingQuoteBeforeDoctypeSystemIdentifier), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateBeforeDoctypeSystemIdentifier", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.QUOTATION_MARK:
              R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
              break;
            case Pe.APOSTROPHE:
              R.systemId = "", this.state = He.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.missingDoctypeSystemIdentifier), R.forceQuirks = !0, this.state = He.DATA, this.emitCurrentDoctype(R);
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.missingQuoteBeforeDoctypeSystemIdentifier), R.forceQuirks = !0, this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateDoctypeSystemIdentifierDoubleQuoted", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.QUOTATION_MARK:
              this.state = He.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.systemId += "�";
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.abruptDoctypeSystemIdentifier), R.forceQuirks = !0, this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              R.systemId += String.fromCodePoint(w);
          }
        } }, { key: "_stateDoctypeSystemIdentifierSingleQuoted", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.APOSTROPHE:
              this.state = He.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter), R.systemId += "�";
              break;
            case Pe.GREATER_THAN_SIGN:
              this._err(xt.abruptDoctypeSystemIdentifier), R.forceQuirks = !0, this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              R.systemId += String.fromCodePoint(w);
          }
        } }, { key: "_stateAfterDoctypeSystemIdentifier", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.SPACE:
            case Pe.LINE_FEED:
            case Pe.TABULATION:
            case Pe.FORM_FEED:
              break;
            case Pe.GREATER_THAN_SIGN:
              this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.EOF:
              this._err(xt.eofInDoctype), R.forceQuirks = !0, this.emitCurrentDoctype(R), this._emitEOFToken();
              break;
            default:
              this._err(xt.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = He.BOGUS_DOCTYPE, this._stateBogusDoctype(w);
          }
        } }, { key: "_stateBogusDoctype", value: function(w) {
          var R = this.currentToken;
          switch (w) {
            case Pe.GREATER_THAN_SIGN:
              this.emitCurrentDoctype(R), this.state = He.DATA;
              break;
            case Pe.NULL:
              this._err(xt.unexpectedNullCharacter);
              break;
            case Pe.EOF:
              this.emitCurrentDoctype(R), this._emitEOFToken();
          }
        } }, { key: "_stateCdataSection", value: function(w) {
          switch (w) {
            case Pe.RIGHT_SQUARE_BRACKET:
              this.state = He.CDATA_SECTION_BRACKET;
              break;
            case Pe.EOF:
              this._err(xt.eofInCdata), this._emitEOFToken();
              break;
            default:
              this._emitCodePoint(w);
          }
        } }, { key: "_stateCdataSectionBracket", value: function(w) {
          w === Pe.RIGHT_SQUARE_BRACKET ? this.state = He.CDATA_SECTION_END : (this._emitChars("]"), this.state = He.CDATA_SECTION, this._stateCdataSection(w));
        } }, { key: "_stateCdataSectionEnd", value: function(w) {
          switch (w) {
            case Pe.GREATER_THAN_SIGN:
              this.state = He.DATA;
              break;
            case Pe.RIGHT_SQUARE_BRACKET:
              this._emitChars("]");
              break;
            default:
              this._emitChars("]]"), this.state = He.CDATA_SECTION, this._stateCdataSection(w);
          }
        } }, { key: "_stateCharacterReference", value: function(w) {
          w === Pe.NUMBER_SIGN ? this.state = He.NUMERIC_CHARACTER_REFERENCE : wu(w) ? (this.state = He.NAMED_CHARACTER_REFERENCE, this._stateNamedCharacterReference(w)) : (this._flushCodePointConsumedAsCharacterReference(Pe.AMPERSAND), this._reconsumeInState(this.returnState, w));
        } }, { key: "_stateNamedCharacterReference", value: function(w) {
          var R = this._matchNamedCharacterReference(w);
          if (!this._ensureHibernation()) if (R) {
            for (var W = 0; W < R.length; W++) this._flushCodePointConsumedAsCharacterReference(R[W]);
            this.state = this.returnState;
          } else this._flushCodePointConsumedAsCharacterReference(Pe.AMPERSAND), this.state = He.AMBIGUOUS_AMPERSAND;
        } }, { key: "_stateAmbiguousAmpersand", value: function(w) {
          wu(w) ? this._flushCodePointConsumedAsCharacterReference(w) : (w === Pe.SEMICOLON && this._err(xt.unknownNamedCharacterReference), this._reconsumeInState(this.returnState, w));
        } }, { key: "_stateNumericCharacterReference", value: function(w) {
          this.charRefCode = 0, w === Pe.LATIN_SMALL_X || w === Pe.LATIN_CAPITAL_X ? this.state = He.HEXADEMICAL_CHARACTER_REFERENCE_START : wc(w) ? (this.state = He.DECIMAL_CHARACTER_REFERENCE, this._stateDecimalCharacterReference(w)) : (this._err(xt.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(Pe.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(Pe.NUMBER_SIGN), this._reconsumeInState(this.returnState, w));
        } }, { key: "_stateHexademicalCharacterReferenceStart", value: function(w) {
          (function(W) {
            return wc(W) || Ml(W) || Hm(W);
          })(w) ? (this.state = He.HEXADEMICAL_CHARACTER_REFERENCE, this._stateHexademicalCharacterReference(w)) : (this._err(xt.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(Pe.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(Pe.NUMBER_SIGN), this._unconsume(2), this.state = this.returnState);
        } }, { key: "_stateHexademicalCharacterReference", value: function(w) {
          Ml(w) ? this.charRefCode = 16 * this.charRefCode + w - 55 : Hm(w) ? this.charRefCode = 16 * this.charRefCode + w - 87 : wc(w) ? this.charRefCode = 16 * this.charRefCode + w - 48 : w === Pe.SEMICOLON ? this.state = He.NUMERIC_CHARACTER_REFERENCE_END : (this._err(xt.missingSemicolonAfterCharacterReference), this.state = He.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(w));
        } }, { key: "_stateDecimalCharacterReference", value: function(w) {
          wc(w) ? this.charRefCode = 10 * this.charRefCode + w - 48 : w === Pe.SEMICOLON ? this.state = He.NUMERIC_CHARACTER_REFERENCE_END : (this._err(xt.missingSemicolonAfterCharacterReference), this.state = He.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(w));
        } }, { key: "_stateNumericCharacterReferenceEnd", value: function(w) {
          var R;
          this.charRefCode === Pe.NULL ? (this._err(xt.nullCharacterReference), this.charRefCode = Pe.REPLACEMENT_CHARACTER) : 1114111 < this.charRefCode ? (this._err(xt.characterReferenceOutsideUnicodeRange), this.charRefCode = Pe.REPLACEMENT_CHARACTER) : op(this.charRefCode) ? (this._err(xt.surrogateCharacterReference), this.charRefCode = Pe.REPLACEMENT_CHARACTER) : Bm(this.charRefCode) ? this._err(xt.noncharacterCharacterReference) : !jm(this.charRefCode) && this.charRefCode !== Pe.CARRIAGE_RETURN || (this._err(xt.controlCharacterReference), (R = Um.get(this.charRefCode)) !== void 0 && (this.charRefCode = R)), this._flushCodePointConsumedAsCharacterReference(this.charRefCode), this._reconsumeInState(this.returnState, w);
        } }]), M;
      }();
      function Ad(M) {
        return (Ad = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Bf(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, function(ue) {
            return ue = function(Ae, Ne) {
              if (Ad(Ae) != "object" || !Ae) return Ae;
              var Fe = Ae[Symbol.toPrimitive];
              if (Fe === void 0) return (Ne === "string" ? String : Number)(Ae);
              if (Ad(Ne = Fe.call(Ae, Ne || "default")) != "object") return Ne;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ue, "string"), Ad(ue) == "symbol" ? ue : String(ue);
          }(R.key), R);
        }
      }
      function Mr(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var So, As = /* @__PURE__ */ new Set([re.DD, re.DT, re.LI, re.OPTGROUP, re.OPTION, re.P, re.RB, re.RP, re.RT, re.RTC]), xu = new Set([].concat(function(O) {
        return function(R) {
          if (Array.isArray(R)) return Mr(R);
        }(O) || function(R) {
          if (typeof Symbol < "u" && R[Symbol.iterator] != null || R["@@iterator"] != null) return Array.from(R);
        }(O) || function(R, W) {
          if (R) {
            if (typeof R == "string") return Mr(R, W);
            var ue = Object.prototype.toString.call(R).slice(8, -1);
            return (ue = ue === "Object" && R.constructor ? R.constructor.name : ue) === "Map" || ue === "Set" ? Array.from(R) : ue === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ue) ? Mr(R, W) : void 0;
          }
        }(O) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }(As), [re.CAPTION, re.COLGROUP, re.TBODY, re.TD, re.TFOOT, re.TH, re.THEAD, re.TR])), kd = /* @__PURE__ */ new Map([[re.APPLET, Tt.HTML], [re.CAPTION, Tt.HTML], [re.HTML, Tt.HTML], [re.MARQUEE, Tt.HTML], [re.OBJECT, Tt.HTML], [re.TABLE, Tt.HTML], [re.TD, Tt.HTML], [re.TEMPLATE, Tt.HTML], [re.TH, Tt.HTML], [re.ANNOTATION_XML, Tt.MATHML], [re.MI, Tt.MATHML], [re.MN, Tt.MATHML], [re.MO, Tt.MATHML], [re.MS, Tt.MATHML], [re.MTEXT, Tt.MATHML], [re.DESC, Tt.SVG], [re.FOREIGN_OBJECT, Tt.SVG], [re.TITLE, Tt.SVG]]), Ff = [re.H1, re.H2, re.H3, re.H4, re.H5, re.H6], Od = [re.TR, re.TEMPLATE, re.HTML], Dd = [re.TBODY, re.TFOOT, re.THEAD, re.TEMPLATE, re.HTML], Tu = [re.TABLE, re.TEMPLATE, re.HTML], up = [re.TD, re.TH], cp = function() {
        function M(O, w, R) {
          (function(ue, me) {
            if (!(ue instanceof me)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.treeAdapter = w, this.handler = R, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = re.UNKNOWN, this.current = O;
        }
        return function(w, R, W) {
          R && Bf(w.prototype, R), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "currentTmplContentOrNode", get: function() {
          return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
        } }, { key: "_indexOf", value: function(w) {
          return this.items.lastIndexOf(w, this.stackTop);
        } }, { key: "_isInTemplate", value: function() {
          return this.currentTagId === re.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Tt.HTML;
        } }, { key: "_updateCurrentElement", value: function() {
          this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
        } }, { key: "push", value: function(w, R) {
          this.stackTop++, this.items[this.stackTop] = w, this.current = w, this.tagIDs[this.stackTop] = R, this.currentTagId = R, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(w, R, !0);
        } }, { key: "pop", value: function() {
          var w = this.current;
          0 < this.tmplCount && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(w, !0);
        } }, { key: "replace", value: function(w, R) {
          w = this._indexOf(w), this.items[w] = R, w === this.stackTop && (this.current = R);
        } }, { key: "insertAfter", value: function(w, R, W) {
          w = this._indexOf(w) + 1, this.items.splice(w, 0, R), this.tagIDs.splice(w, 0, W), this.stackTop++, w === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, w === this.stackTop);
        } }, { key: "popUntilTagNamePopped", value: function(w) {
          for (var R = this.stackTop + 1; 0 < (R = this.tagIDs.lastIndexOf(w, R - 1)) && this.treeAdapter.getNamespaceURI(this.items[R]) !== Tt.HTML; ) ;
          this.shortenToLength(R < 0 ? 0 : R);
        } }, { key: "shortenToLength", value: function(w) {
          for (; this.stackTop >= w; ) {
            var R = this.current;
            0 < this.tmplCount && this._isInTemplate() && --this.tmplCount, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(R, this.stackTop < w);
          }
        } }, { key: "popUntilElementPopped", value: function(w) {
          w = this._indexOf(w), this.shortenToLength(w < 0 ? 0 : w);
        } }, { key: "popUntilPopped", value: function(w, R) {
          R = this._indexOfTagNames(w, R), this.shortenToLength(R < 0 ? 0 : R);
        } }, { key: "popUntilNumberedHeaderPopped", value: function() {
          this.popUntilPopped(Ff, Tt.HTML);
        } }, { key: "popUntilTableCellPopped", value: function() {
          this.popUntilPopped(up, Tt.HTML);
        } }, { key: "popAllUpToHtmlElement", value: function() {
          this.tmplCount = 0, this.shortenToLength(1);
        } }, { key: "_indexOfTagNames", value: function(w, R) {
          for (var W = this.stackTop; 0 <= W; W--) if (w.includes(this.tagIDs[W]) && this.treeAdapter.getNamespaceURI(this.items[W]) === R) return W;
          return -1;
        } }, { key: "clearBackTo", value: function(w, R) {
          R = this._indexOfTagNames(w, R), this.shortenToLength(R + 1);
        } }, { key: "clearBackToTableContext", value: function() {
          this.clearBackTo(Tu, Tt.HTML);
        } }, { key: "clearBackToTableBodyContext", value: function() {
          this.clearBackTo(Dd, Tt.HTML);
        } }, { key: "clearBackToTableRowContext", value: function() {
          this.clearBackTo(Od, Tt.HTML);
        } }, { key: "remove", value: function(w) {
          var R = this._indexOf(w);
          0 <= R && (R === this.stackTop ? this.pop() : (this.items.splice(R, 1), this.tagIDs.splice(R, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(w, !1)));
        } }, { key: "tryPeekProperlyNestedBodyElement", value: function() {
          return 1 <= this.stackTop && this.tagIDs[1] === re.BODY ? this.items[1] : null;
        } }, { key: "contains", value: function(w) {
          return -1 < this._indexOf(w);
        } }, { key: "getCommonAncestor", value: function(w) {
          return 0 <= (w = this._indexOf(w) - 1) ? this.items[w] : null;
        } }, { key: "isRootHtmlElementCurrent", value: function() {
          return this.stackTop === 0 && this.tagIDs[0] === re.HTML;
        } }, { key: "hasInScope", value: function(w) {
          for (var R = this.stackTop; 0 <= R; R--) {
            var W = this.tagIDs[R], ue = this.treeAdapter.getNamespaceURI(this.items[R]);
            if (W === w && ue === Tt.HTML) return !0;
            if (kd.get(W) === ue) return !1;
          }
          return !0;
        } }, { key: "hasNumberedHeaderInScope", value: function() {
          for (var w = this.stackTop; 0 <= w; w--) {
            var R = this.tagIDs[w], W = this.treeAdapter.getNamespaceURI(this.items[w]);
            if (ll(R) && W === Tt.HTML) return !0;
            if (kd.get(R) === W) return !1;
          }
          return !0;
        } }, { key: "hasInListItemScope", value: function(w) {
          for (var R = this.stackTop; 0 <= R; R--) {
            var W = this.tagIDs[R], ue = this.treeAdapter.getNamespaceURI(this.items[R]);
            if (W === w && ue === Tt.HTML) return !0;
            if ((W === re.UL || W === re.OL) && ue === Tt.HTML || kd.get(W) === ue) return !1;
          }
          return !0;
        } }, { key: "hasInButtonScope", value: function(w) {
          for (var R = this.stackTop; 0 <= R; R--) {
            var W = this.tagIDs[R], ue = this.treeAdapter.getNamespaceURI(this.items[R]);
            if (W === w && ue === Tt.HTML) return !0;
            if (W === re.BUTTON && ue === Tt.HTML || kd.get(W) === ue) return !1;
          }
          return !0;
        } }, { key: "hasInTableScope", value: function(w) {
          for (var R = this.stackTop; 0 <= R; R--) {
            var W = this.tagIDs[R];
            if (this.treeAdapter.getNamespaceURI(this.items[R]) === Tt.HTML) {
              if (W === w) return !0;
              if (W === re.TABLE || W === re.TEMPLATE || W === re.HTML) return !1;
            }
          }
          return !0;
        } }, { key: "hasTableBodyContextInTableScope", value: function() {
          for (var w = this.stackTop; 0 <= w; w--) {
            var R = this.tagIDs[w];
            if (this.treeAdapter.getNamespaceURI(this.items[w]) === Tt.HTML) {
              if (R === re.TBODY || R === re.THEAD || R === re.TFOOT) return !0;
              if (R === re.TABLE || R === re.HTML) return !1;
            }
          }
          return !0;
        } }, { key: "hasInSelectScope", value: function(w) {
          for (var R = this.stackTop; 0 <= R; R--) {
            var W = this.tagIDs[R];
            if (this.treeAdapter.getNamespaceURI(this.items[R]) === Tt.HTML) {
              if (W === w) return !0;
              if (W !== re.OPTION && W !== re.OPTGROUP) return !1;
            }
          }
          return !0;
        } }, { key: "generateImpliedEndTags", value: function() {
          for (; As.has(this.currentTagId); ) this.pop();
        } }, { key: "generateImpliedEndTagsThoroughly", value: function() {
          for (; xu.has(this.currentTagId); ) this.pop();
        } }, { key: "generateImpliedEndTagsWithExclusion", value: function(w) {
          for (; this.currentTagId !== w && xu.has(this.currentTagId); ) this.pop();
        } }]), M;
      }();
      function Uf(M) {
        return (Uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function dp(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, function(ue) {
            return ue = function(Ae, Ne) {
              if (Uf(Ae) != "object" || !Ae) return Ae;
              var Fe = Ae[Symbol.toPrimitive];
              if (Fe === void 0) return (Ne === "string" ? String : Number)(Ae);
              if (Uf(Ne = Fe.call(Ae, Ne || "default")) != "object") return Ne;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ue, "string"), Uf(ue) == "symbol" ? ue : String(ue);
          }(R.key), R);
        }
      }
      (Xr = So = {})[Xr.Marker = 0] = "Marker", Xr[Xr.Element = 1] = "Element";
      var Rd = { type: So.Marker }, Hf = function() {
        function M(O) {
          (function(R, W) {
            if (!(R instanceof W)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.treeAdapter = O, this.entries = [], this.bookmark = null;
        }
        return function(w, R, W) {
          R && dp(w.prototype, R), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "_getNoahArkConditionCandidates", value: function(w, R) {
          for (var W = [], ue = R.length, me = this.treeAdapter.getTagName(w), Ae = this.treeAdapter.getNamespaceURI(w), Ne = 0; Ne < this.entries.length; Ne++) {
            var Fe = this.entries[Ne];
            if (Fe.type === So.Marker) break;
            Fe = Fe.element, this.treeAdapter.getTagName(Fe) !== me || this.treeAdapter.getNamespaceURI(Fe) !== Ae || (Fe = this.treeAdapter.getAttrList(Fe)).length === ue && W.push({ idx: Ne, attrs: Fe });
          }
          return W;
        } }, { key: "_ensureNoahArkCondition", value: function(w) {
          if (!(this.entries.length < 3)) {
            var R = this.treeAdapter.getAttrList(w), W = this._getNoahArkConditionCandidates(w, R);
            if (!(W.length < 3)) for (var ue = new Map(R.map(function(Fe) {
              return [Fe.name, Fe.value];
            })), me = 0, Ae = 0; Ae < W.length; Ae++) {
              var Ne = W[Ae];
              Ne.attrs.every(function(Fe) {
                return ue.get(Fe.name) === Fe.value;
              }) && 3 <= (me += 1) && this.entries.splice(Ne.idx, 1);
            }
          }
        } }, { key: "insertMarker", value: function() {
          this.entries.unshift(Rd);
        } }, { key: "pushElement", value: function(w, R) {
          this._ensureNoahArkCondition(w), this.entries.unshift({ type: So.Element, element: w, token: R });
        } }, { key: "insertElementAfterBookmark", value: function(w, R) {
          var W = this.entries.indexOf(this.bookmark);
          this.entries.splice(W, 0, { type: So.Element, element: w, token: R });
        } }, { key: "removeEntry", value: function(w) {
          0 <= (w = this.entries.indexOf(w)) && this.entries.splice(w, 1);
        } }, { key: "clearToLastMarker", value: function() {
          var w = this.entries.indexOf(Rd);
          0 <= w ? this.entries.splice(0, w + 1) : this.entries.length = 0;
        } }, { key: "getElementEntryInScopeWithTagName", value: function(w) {
          var R = this, W = this.entries.find(function(ue) {
            return ue.type === So.Marker || R.treeAdapter.getTagName(ue.element) === w;
          });
          return W && W.type === So.Element ? W : null;
        } }, { key: "getElementEntry", value: function(w) {
          return this.entries.find(function(R) {
            return R.type === So.Element && R.element === w;
          });
        } }]), M;
      }();
      function kc(M) {
        return (kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Pl(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function Oc(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? Pl(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = function(Fe) {
                return Fe = function(Je, pt) {
                  if (kc(Je) != "object" || !Je) return Je;
                  var Nt = Je[Symbol.toPrimitive];
                  if (Nt === void 0) return (pt === "string" ? String : Number)(Je);
                  if (kc(pt = Nt.call(Je, pt || "default")) != "object") return pt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(Fe, "string"), kc(Fe) == "symbol" ? Fe : String(Fe);
              }(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : Pl(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      function jl(M) {
        return { nodeName: "#text", value: M, parentNode: null };
      }
      var Bl = { createDocument: function() {
        return { nodeName: "#document", mode: bo.NO_QUIRKS, childNodes: [] };
      }, createDocumentFragment: function() {
        return { nodeName: "#document-fragment", childNodes: [] };
      }, createElement: function(O, w, R) {
        return { nodeName: O, tagName: O, attrs: R, namespaceURI: w, childNodes: [], parentNode: null };
      }, createCommentNode: function(O) {
        return { nodeName: "#comment", data: O, parentNode: null };
      }, appendChild: function(O, w) {
        O.childNodes.push(w), w.parentNode = O;
      }, insertBefore: function(O, w, R) {
        R = O.childNodes.indexOf(R), O.childNodes.splice(R, 0, w), w.parentNode = O;
      }, setTemplateContent: function(O, w) {
        O.content = w;
      }, getTemplateContent: function(O) {
        return O.content;
      }, setDocumentType: function(O, w, R, W) {
        var ue = O.childNodes.find(function(me) {
          return me.nodeName === "#documentType";
        });
        ue ? (ue.name = w, ue.publicId = R, ue.systemId = W) : Bl.appendChild(O, { nodeName: "#documentType", name: w, publicId: R, systemId: W, parentNode: null });
      }, setDocumentMode: function(O, w) {
        O.mode = w;
      }, getDocumentMode: function(O) {
        return O.mode;
      }, detachNode: function(O) {
        var w;
        O.parentNode && (w = O.parentNode.childNodes.indexOf(O), O.parentNode.childNodes.splice(w, 1), O.parentNode = null);
      }, insertText: function(O, w) {
        if (0 < O.childNodes.length) {
          var R = O.childNodes[O.childNodes.length - 1];
          if (Bl.isTextNode(R)) return void (R.value += w);
        }
        Bl.appendChild(O, jl(w));
      }, insertTextBefore: function(O, w, R) {
        var W = O.childNodes[O.childNodes.indexOf(R) - 1];
        W && Bl.isTextNode(W) ? W.value += w : Bl.insertBefore(O, jl(w), R);
      }, adoptAttributes: function(O, w) {
        for (var R = new Set(O.attrs.map(function(ue) {
          return ue.name;
        })), W = 0; W < w.length; W++) R.has(w[W].name) || O.attrs.push(w[W]);
      }, getFirstChild: function(O) {
        return O.childNodes[0];
      }, getChildNodes: function(O) {
        return O.childNodes;
      }, getParentNode: function(O) {
        return O.parentNode;
      }, getAttrList: function(O) {
        return O.attrs;
      }, getTagName: function(O) {
        return O.tagName;
      }, getNamespaceURI: function(O) {
        return O.namespaceURI;
      }, getTextNodeContent: function(O) {
        return O.value;
      }, getCommentNodeContent: function(O) {
        return O.data;
      }, getDocumentTypeNodeName: function(O) {
        return O.name;
      }, getDocumentTypeNodePublicId: function(O) {
        return O.publicId;
      }, getDocumentTypeNodeSystemId: function(O) {
        return O.systemId;
      }, isTextNode: function(O) {
        return O.nodeName === "#text";
      }, isCommentNode: function(O) {
        return O.nodeName === "#comment";
      }, isDocumentTypeNode: function(O) {
        return O.nodeName === "#documentType";
      }, isElementNode: function(O) {
        return Object.prototype.hasOwnProperty.call(O, "tagName");
      }, setNodeSourceCodeLocation: function(O, w) {
        O.sourceCodeLocation = w;
      }, getNodeSourceCodeLocation: function(O) {
        return O.sourceCodeLocation;
      }, updateNodeSourceCodeLocation: function(O, w) {
        O.sourceCodeLocation = Oc(Oc({}, O.sourceCodeLocation), w);
      } }, zf = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", "-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", "-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", "-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", "-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"], fp = [].concat(zf, ["-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"]), x0 = /* @__PURE__ */ new Set(["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"]), ul = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], as = [].concat(ul, ["-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"]);
      function Dc(M, O) {
        return O.some(function(w) {
          return M.startsWith(w);
        });
      }
      var Fl = "text/html", ks = "application/xhtml+xml", Au = "definitionurl", cl = "definitionURL", hp = new Map(["attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function(M) {
        return [M.toLowerCase(), M];
      })), T0 = /* @__PURE__ */ new Map([["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: Tt.XLINK }], ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: Tt.XLINK }], ["xlink:href", { prefix: "xlink", name: "href", namespace: Tt.XLINK }], ["xlink:role", { prefix: "xlink", name: "role", namespace: Tt.XLINK }], ["xlink:show", { prefix: "xlink", name: "show", namespace: Tt.XLINK }], ["xlink:title", { prefix: "xlink", name: "title", namespace: Tt.XLINK }], ["xlink:type", { prefix: "xlink", name: "type", namespace: Tt.XLINK }], ["xml:base", { prefix: "xml", name: "base", namespace: Tt.XML }], ["xml:lang", { prefix: "xml", name: "lang", namespace: Tt.XML }], ["xml:space", { prefix: "xml", name: "space", namespace: Tt.XML }], ["xmlns", { prefix: "", name: "xmlns", namespace: Tt.XMLNS }], ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: Tt.XMLNS }]]), pp = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function(M) {
        return [M.toLowerCase(), M];
      })), Ua = /* @__PURE__ */ new Set([re.B, re.BIG, re.BLOCKQUOTE, re.BODY, re.BR, re.CENTER, re.CODE, re.DD, re.DIV, re.DL, re.DT, re.EM, re.EMBED, re.H1, re.H2, re.H3, re.H4, re.H5, re.H6, re.HEAD, re.HR, re.I, re.IMG, re.LI, re.LISTING, re.MENU, re.META, re.NOBR, re.OL, re.P, re.PRE, re.RUBY, re.S, re.SMALL, re.SPAN, re.STRONG, re.STRIKE, re.SUB, re.SUP, re.TABLE, re.TT, re.U, re.UL, re.VAR]);
      function Rc(M) {
        for (var O = 0; O < M.attrs.length; O++) if (M.attrs[O].name === Au) {
          M.attrs[O].name = cl;
          break;
        }
      }
      function ku(M) {
        for (var O = 0; O < M.attrs.length; O++) {
          var w = hp.get(M.attrs[O].name);
          w != null && (M.attrs[O].name = w);
        }
      }
      function xn(M) {
        for (var O = 0; O < M.attrs.length; O++) {
          var w = T0.get(M.attrs[O].name);
          w && (M.attrs[O].prefix = w.prefix, M.attrs[O].name = w.name, M.attrs[O].namespace = w.namespace);
        }
      }
      function ss(M) {
        return (ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Yr(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function Fn(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? Yr(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = Ar(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : Yr(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      function Tr(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, Ar(R.key), R);
        }
      }
      function Ar(M) {
        return M = function(w, R) {
          if (ss(w) != "object" || !w) return w;
          var W = w[Symbol.toPrimitive];
          if (W === void 0) return (R === "string" ? String : Number)(w);
          if (ss(R = W.call(w, R || "default")) != "object") return R;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }(M, "string"), ss(M) == "symbol" ? M : String(M);
      }
      var Xe, Gn = "hidden", bi = 8, oa = 3;
      (yt = Xe = Xe || {})[yt.INITIAL = 0] = "INITIAL", yt[yt.BEFORE_HTML = 1] = "BEFORE_HTML", yt[yt.BEFORE_HEAD = 2] = "BEFORE_HEAD", yt[yt.IN_HEAD = 3] = "IN_HEAD", yt[yt.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", yt[yt.AFTER_HEAD = 5] = "AFTER_HEAD", yt[yt.IN_BODY = 6] = "IN_BODY", yt[yt.TEXT = 7] = "TEXT", yt[yt.IN_TABLE = 8] = "IN_TABLE", yt[yt.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", yt[yt.IN_CAPTION = 10] = "IN_CAPTION", yt[yt.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", yt[yt.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", yt[yt.IN_ROW = 13] = "IN_ROW", yt[yt.IN_CELL = 14] = "IN_CELL", yt[yt.IN_SELECT = 15] = "IN_SELECT", yt[yt.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", yt[yt.IN_TEMPLATE = 17] = "IN_TEMPLATE", yt[yt.AFTER_BODY = 18] = "AFTER_BODY", yt[yt.IN_FRAMESET = 19] = "IN_FRAMESET", yt[yt.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", yt[yt.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", yt[yt.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
      var Ha = { startLine: -1, startCol: -1, startOffset: -1, endLine: -1, endCol: -1, endOffset: -1 }, ii = /* @__PURE__ */ new Set([re.TABLE, re.TBODY, re.TFOOT, re.THEAD, re.TR]), _a = { scriptingEnabled: !0, sourceCodeLocationInfo: !1, treeAdapter: Bl, onParseError: null }, dl = function() {
        function M(O, w) {
          var R = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null, W = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
          (function(me, Ae) {
            if (!(me instanceof Ae)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.fragmentContext = R, this.scriptHandler = W, this.currentToken = null, this.stopped = !1, this.insertionMode = Xe.INITIAL, this.originalInsertionMode = Xe.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = Fn(Fn({}, _a), O), this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = w ?? this.treeAdapter.createDocument(), this.tokenizer = new w0(this.options, this), this.activeFormattingElements = new Hf(this.treeAdapter), this.fragmentContextID = R ? Cu(this.treeAdapter.getTagName(R)) : re.UNKNOWN, this._setContextModes(R ?? this.document, this.fragmentContextID), this.openElements = new cp(this.document, this.treeAdapter, this);
        }
        return function(w, R, W) {
          R && Tr(w.prototype, R), W && Tr(w, W), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "getFragment", value: function() {
          var w = this.treeAdapter.getFirstChild(this.document), R = this.treeAdapter.createDocumentFragment();
          return this._adoptNodes(w, R), R;
        } }, { key: "_err", value: function(w, R, W) {
          this.onParseError && (w = { code: R, startLine: (w = (w = w.location) !== null && w !== void 0 ? w : Ha).startLine, startCol: w.startCol, startOffset: w.startOffset, endLine: W ? w.startLine : w.endLine, endCol: W ? w.startCol : w.endCol, endOffset: W ? w.startOffset : w.endOffset }, this.onParseError(w));
        } }, { key: "onItemPush", value: function(w, R, W) {
          var ue, me;
          (me = (ue = this.treeAdapter).onItemPush) !== null && me !== void 0 && me.call(ue, w), W && 0 < this.openElements.stackTop && this._setContextModes(w, R);
        } }, { key: "onItemPop", value: function(w, R) {
          var W, ue, me, Ae;
          this.options.sourceCodeLocationInfo && this._setEndLocation(w, this.currentToken), (ue = (W = this.treeAdapter).onItemPop) !== null && ue !== void 0 && ue.call(W, w, this.openElements.current), R && (Ae = this.openElements.stackTop === 0 && this.fragmentContext ? (me = this.fragmentContext, this.fragmentContextID) : (me = (Ae = this.openElements).current, Ae.currentTagId), this._setContextModes(me, Ae));
        } }, { key: "_setContextModes", value: function(w, R) {
          var W = w === this.document || this.treeAdapter.getNamespaceURI(w) === Tt.HTML;
          this.currentNotInHTML = !W, this.tokenizer.inForeignNode = !W && !this._isIntegrationPoint(R, w);
        } }, { key: "_switchToTextParsing", value: function(w, R) {
          this._insertElement(w, Tt.HTML), this.tokenizer.state = R, this.originalInsertionMode = this.insertionMode, this.insertionMode = Xe.TEXT;
        } }, { key: "switchToPlaintextParsing", value: function() {
          this.insertionMode = Xe.TEXT, this.originalInsertionMode = Xe.IN_BODY, this.tokenizer.state = Uo.PLAINTEXT;
        } }, { key: "_getAdjustedCurrentElement", value: function() {
          return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
        } }, { key: "_findFormInFragmentContext", value: function() {
          for (var w = this.fragmentContext; w; ) {
            if (this.treeAdapter.getTagName(w) === ht.FORM) {
              this.formElement = w;
              break;
            }
            w = this.treeAdapter.getParentNode(w);
          }
        } }, { key: "_initTokenizerForFragmentParsing", value: function() {
          if (this.fragmentContext && this.treeAdapter.getNamespaceURI(this.fragmentContext) === Tt.HTML) switch (this.fragmentContextID) {
            case re.TITLE:
            case re.TEXTAREA:
              this.tokenizer.state = Uo.RCDATA;
              break;
            case re.STYLE:
            case re.XMP:
            case re.IFRAME:
            case re.NOEMBED:
            case re.NOFRAMES:
            case re.NOSCRIPT:
              this.tokenizer.state = Uo.RAWTEXT;
              break;
            case re.SCRIPT:
              this.tokenizer.state = Uo.SCRIPT_DATA;
              break;
            case re.PLAINTEXT:
              this.tokenizer.state = Uo.PLAINTEXT;
          }
        } }, { key: "_setDocumentType", value: function(w) {
          var R = this, W = w.name || "", ue = w.publicId || "", me = w.systemId || "";
          this.treeAdapter.setDocumentType(this.document, W, ue, me), !w.location || (me = this.treeAdapter.getChildNodes(this.document).find(function(Ae) {
            return R.treeAdapter.isDocumentTypeNode(Ae);
          })) && this.treeAdapter.setNodeSourceCodeLocation(me, w.location);
        } }, { key: "_attachElementToTree", value: function(w, R) {
          var W;
          this.options.sourceCodeLocationInfo && (W = R && Fn(Fn({}, R), {}, { startTag: R }), this.treeAdapter.setNodeSourceCodeLocation(w, W)), this._shouldFosterParentOnInsertion() ? this._fosterParentElement(w) : (W = this.openElements.currentTmplContentOrNode, this.treeAdapter.appendChild(W, w));
        } }, { key: "_appendElement", value: function(w, R) {
          R = this.treeAdapter.createElement(w.tagName, R, w.attrs), this._attachElementToTree(R, w.location);
        } }, { key: "_insertElement", value: function(w, R) {
          R = this.treeAdapter.createElement(w.tagName, R, w.attrs), this._attachElementToTree(R, w.location), this.openElements.push(R, w.tagID);
        } }, { key: "_insertFakeElement", value: function(w, R) {
          w = this.treeAdapter.createElement(w, Tt.HTML, []), this._attachElementToTree(w, null), this.openElements.push(w, R);
        } }, { key: "_insertTemplate", value: function(w) {
          var R = this.treeAdapter.createElement(w.tagName, Tt.HTML, w.attrs), W = this.treeAdapter.createDocumentFragment();
          this.treeAdapter.setTemplateContent(R, W), this._attachElementToTree(R, w.location), this.openElements.push(R, w.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(W, null);
        } }, { key: "_insertFakeRootElement", value: function() {
          var w = this.treeAdapter.createElement(ht.HTML, Tt.HTML, []);
          this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(w, null), this.treeAdapter.appendChild(this.openElements.current, w), this.openElements.push(w, re.HTML);
        } }, { key: "_appendCommentNode", value: function(w, R) {
          var W = this.treeAdapter.createCommentNode(w.data);
          this.treeAdapter.appendChild(R, W), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(W, w.location);
        } }, { key: "_insertCharacters", value: function(w) {
          var R, W, ue, me;
          this._shouldFosterParentOnInsertion() ? (R = (ue = this._findFosterParentingLocation()).parent, (me = ue.beforeElement) ? this.treeAdapter.insertTextBefore(R, w.chars, me) : this.treeAdapter.insertText(R, w.chars)) : (R = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(R, w.chars)), w.location && (W = this.treeAdapter.getChildNodes(R), ue = me ? W.lastIndexOf(me) : W.length, R = W[ue - 1], this.treeAdapter.getNodeSourceCodeLocation(R) ? (W = (me = w.location).endLine, ue = me.endCol, me = me.endOffset, this.treeAdapter.updateNodeSourceCodeLocation(R, { endLine: W, endCol: ue, endOffset: me })) : this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(R, w.location));
        } }, { key: "_adoptNodes", value: function(w, R) {
          for (var W = this.treeAdapter.getFirstChild(w); W; W = this.treeAdapter.getFirstChild(w)) this.treeAdapter.detachNode(W), this.treeAdapter.appendChild(R, W);
        } }, { key: "_setEndLocation", value: function(w, R) {
          var W, ue;
          this.treeAdapter.getNodeSourceCodeLocation(w) && R.location && (ue = R.location, W = this.treeAdapter.getTagName(w), ue = R.type === Cr.END_TAG && W === R.tagName ? { endTag: Fn({}, ue), endLine: ue.endLine, endCol: ue.endCol, endOffset: ue.endOffset } : { endLine: ue.startLine, endCol: ue.startCol, endOffset: ue.startOffset }, this.treeAdapter.updateNodeSourceCodeLocation(w, ue));
        } }, { key: "shouldProcessStartTagTokenInForeignContent", value: function(w) {
          return !!this.currentNotInHTML && (W = this.openElements.stackTop === 0 && this.fragmentContext ? (R = this.fragmentContext, this.fragmentContextID) : (R = (W = this.openElements).current, W.currentTagId), (w.tagID !== re.SVG || this.treeAdapter.getTagName(R) !== ht.ANNOTATION_XML || this.treeAdapter.getNamespaceURI(R) !== Tt.MATHML) && (this.tokenizer.inForeignNode || (w.tagID === re.MGLYPH || w.tagID === re.MALIGNMARK) && !this._isIntegrationPoint(W, R, Tt.HTML)));
          var R, W;
        } }, { key: "_processToken", value: function(w) {
          switch (w.type) {
            case Cr.CHARACTER:
              this.onCharacter(w);
              break;
            case Cr.NULL_CHARACTER:
              this.onNullCharacter(w);
              break;
            case Cr.COMMENT:
              this.onComment(w);
              break;
            case Cr.DOCTYPE:
              this.onDoctype(w);
              break;
            case Cr.START_TAG:
              this._processStartTag(w);
              break;
            case Cr.END_TAG:
              this.onEndTag(w);
              break;
            case Cr.EOF:
              this.onEof(w);
              break;
            case Cr.WHITESPACE_CHARACTER:
              this.onWhitespaceCharacter(w);
          }
        } }, { key: "_isIntegrationPoint", value: function(w, R, W) {
          return function(me, Ae, Ne, Fe) {
            return (!Fe || Fe === Tt.HTML) && function(Je, pt, Nt) {
              if (pt === Tt.MATHML && Je === re.ANNOTATION_XML) {
                for (var Bt = 0; Bt < Nt.length; Bt++) if (Nt[Bt].name === sl.ENCODING) {
                  var Qt = Nt[Bt].value.toLowerCase();
                  return Qt === Fl || Qt === ks;
                }
              }
              return pt === Tt.SVG && (Je === re.FOREIGN_OBJECT || Je === re.DESC || Je === re.TITLE);
            }(me, Ae, Ne) || (!Fe || Fe === Tt.MATHML) && function(Je, pt) {
              return pt === Tt.MATHML && (Je === re.MI || Je === re.MO || Je === re.MN || Je === re.MS || Je === re.MTEXT);
            }(me, Ae);
          }(w, this.treeAdapter.getNamespaceURI(R), this.treeAdapter.getAttrList(R), W);
        } }, { key: "_reconstructActiveFormattingElements", value: function() {
          var w = this, R = this.activeFormattingElements.entries.length;
          if (R) for (var W = this.activeFormattingElements.entries.findIndex(function(Ae) {
            return Ae.type === So.Marker || w.openElements.contains(Ae.element);
          }), ue = W < 0 ? R - 1 : W - 1; 0 <= ue; ue--) {
            var me = this.activeFormattingElements.entries[ue];
            this._insertElement(me.token, this.treeAdapter.getNamespaceURI(me.element)), me.element = this.openElements.current;
          }
        } }, { key: "_closeTableCell", value: function() {
          this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Xe.IN_ROW;
        } }, { key: "_closePElement", value: function() {
          this.openElements.generateImpliedEndTagsWithExclusion(re.P), this.openElements.popUntilTagNamePopped(re.P);
        } }, { key: "_resetInsertionMode", value: function() {
          for (var w = this.openElements.stackTop; 0 <= w; w--) switch (w === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[w]) {
            case re.TR:
              return void (this.insertionMode = Xe.IN_ROW);
            case re.TBODY:
            case re.THEAD:
            case re.TFOOT:
              return void (this.insertionMode = Xe.IN_TABLE_BODY);
            case re.CAPTION:
              return void (this.insertionMode = Xe.IN_CAPTION);
            case re.COLGROUP:
              return void (this.insertionMode = Xe.IN_COLUMN_GROUP);
            case re.TABLE:
              return void (this.insertionMode = Xe.IN_TABLE);
            case re.BODY:
              return void (this.insertionMode = Xe.IN_BODY);
            case re.FRAMESET:
              return void (this.insertionMode = Xe.IN_FRAMESET);
            case re.SELECT:
              return void this._resetInsertionModeForSelect(w);
            case re.TEMPLATE:
              return void (this.insertionMode = this.tmplInsertionModeStack[0]);
            case re.HTML:
              return void (this.insertionMode = this.headElement ? Xe.AFTER_HEAD : Xe.BEFORE_HEAD);
            case re.TD:
            case re.TH:
              if (0 < w) return void (this.insertionMode = Xe.IN_CELL);
              break;
            case re.HEAD:
              if (0 < w) return void (this.insertionMode = Xe.IN_HEAD);
          }
          this.insertionMode = Xe.IN_BODY;
        } }, { key: "_resetInsertionModeForSelect", value: function(w) {
          if (0 < w) for (var R = w - 1; 0 < R; R--) {
            var W = this.openElements.tagIDs[R];
            if (W === re.TEMPLATE) break;
            if (W === re.TABLE) return void (this.insertionMode = Xe.IN_SELECT_IN_TABLE);
          }
          this.insertionMode = Xe.IN_SELECT;
        } }, { key: "_isElementCausesFosterParenting", value: function(w) {
          return ii.has(w);
        } }, { key: "_shouldFosterParentOnInsertion", value: function() {
          return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
        } }, { key: "_findFosterParentingLocation", value: function() {
          for (var w = this.openElements.stackTop; 0 <= w; w--) {
            var R = this.openElements.items[w];
            switch (this.openElements.tagIDs[w]) {
              case re.TEMPLATE:
                if (this.treeAdapter.getNamespaceURI(R) === Tt.HTML) return { parent: this.treeAdapter.getTemplateContent(R), beforeElement: null };
                break;
              case re.TABLE:
                var W = this.treeAdapter.getParentNode(R);
                return W ? { parent: W, beforeElement: R } : { parent: this.openElements.items[w - 1], beforeElement: null };
            }
          }
          return { parent: this.openElements.items[0], beforeElement: null };
        } }, { key: "_fosterParentElement", value: function(w) {
          var R = this._findFosterParentingLocation();
          R.beforeElement ? this.treeAdapter.insertBefore(R.parent, w, R.beforeElement) : this.treeAdapter.appendChild(R.parent, w);
        } }, { key: "_isSpecialElement", value: function(w, R) {
          return w = this.treeAdapter.getNamespaceURI(w), Td[w].has(R);
        } }, { key: "onCharacter", value: function(w) {
          if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) (function(W, ue) {
            W._insertCharacters(ue), W.framesetOk = !1;
          })(this, w);
          else switch (this.insertionMode) {
            case Xe.INITIAL:
              co(this, w);
              break;
            case Xe.BEFORE_HTML:
              Ei(this, w);
              break;
            case Xe.BEFORE_HEAD:
              fl(this, w);
              break;
            case Xe.IN_HEAD:
              Ji(this, w);
              break;
            case Xe.IN_HEAD_NO_SCRIPT:
              za(this, w);
              break;
            case Xe.AFTER_HEAD:
              eo(this, w);
              break;
            case Xe.IN_BODY:
            case Xe.IN_CAPTION:
            case Xe.IN_CELL:
            case Xe.IN_TEMPLATE:
              Ho(this, w);
              break;
            case Xe.TEXT:
            case Xe.IN_SELECT:
            case Xe.IN_SELECT_IN_TABLE:
              this._insertCharacters(w);
              break;
            case Xe.IN_TABLE:
            case Xe.IN_TABLE_BODY:
            case Xe.IN_ROW:
              zo(this, w);
              break;
            case Xe.IN_TABLE_TEXT:
              mp(this, w);
              break;
            case Xe.IN_COLUMN_GROUP:
              Nu(this, w);
              break;
            case Xe.AFTER_BODY:
              pl(this, w);
              break;
            case Xe.AFTER_AFTER_BODY:
              Pd(this, w);
          }
        } }, { key: "onNullCharacter", value: function(w) {
          if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) (function(W, ue) {
            ue.chars = "�", W._insertCharacters(ue);
          })(this, w);
          else switch (this.insertionMode) {
            case Xe.INITIAL:
              co(this, w);
              break;
            case Xe.BEFORE_HTML:
              Ei(this, w);
              break;
            case Xe.BEFORE_HEAD:
              fl(this, w);
              break;
            case Xe.IN_HEAD:
              Ji(this, w);
              break;
            case Xe.IN_HEAD_NO_SCRIPT:
              za(this, w);
              break;
            case Xe.AFTER_HEAD:
              eo(this, w);
              break;
            case Xe.TEXT:
              this._insertCharacters(w);
              break;
            case Xe.IN_TABLE:
            case Xe.IN_TABLE_BODY:
            case Xe.IN_ROW:
              zo(this, w);
              break;
            case Xe.IN_COLUMN_GROUP:
              Nu(this, w);
              break;
            case Xe.AFTER_BODY:
              pl(this, w);
              break;
            case Xe.AFTER_AFTER_BODY:
              Pd(this, w);
          }
        } }, { key: "onComment", value: function(w) {
          if (this.skipNextNewLine = !1, this.currentNotInHTML) Nc(this, w);
          else switch (this.insertionMode) {
            case Xe.INITIAL:
            case Xe.BEFORE_HTML:
            case Xe.BEFORE_HEAD:
            case Xe.IN_HEAD:
            case Xe.IN_HEAD_NO_SCRIPT:
            case Xe.AFTER_HEAD:
            case Xe.IN_BODY:
            case Xe.IN_TABLE:
            case Xe.IN_CAPTION:
            case Xe.IN_COLUMN_GROUP:
            case Xe.IN_TABLE_BODY:
            case Xe.IN_ROW:
            case Xe.IN_CELL:
            case Xe.IN_SELECT:
            case Xe.IN_SELECT_IN_TABLE:
            case Xe.IN_TEMPLATE:
            case Xe.IN_FRAMESET:
            case Xe.AFTER_FRAMESET:
              Nc(this, w);
              break;
            case Xe.IN_TABLE_TEXT:
              Ul(this, w);
              break;
            case Xe.AFTER_BODY:
              (function(W, ue) {
                W._appendCommentNode(ue, W.openElements.items[0]);
              })(this, w);
              break;
            case Xe.AFTER_AFTER_BODY:
            case Xe.AFTER_AFTER_FRAMESET:
              (function(W, ue) {
                W._appendCommentNode(ue, W.document);
              })(this, w);
          }
        } }, { key: "onDoctype", value: function(w) {
          switch (this.skipNextNewLine = !1, this.insertionMode) {
            case Xe.INITIAL:
              (function(W, ue) {
                W._setDocumentType(ue);
                var me = ue.forceQuirks ? bo.QUIRKS : function(Ne) {
                  if (Ne.name !== "html") return bo.QUIRKS;
                  var Fe = Ne.systemId;
                  if (Fe && Fe.toLowerCase() === "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd") return bo.QUIRKS;
                  if ((Ne = Ne.publicId) !== null) {
                    if (Ne = Ne.toLowerCase(), x0.has(Ne) || Dc(Ne, Fe === null ? fp : zf)) return bo.QUIRKS;
                    if (Dc(Ne, Fe === null ? ul : as)) return bo.LIMITED_QUIRKS;
                  }
                  return bo.NO_QUIRKS;
                }(ue);
                !function(Ne) {
                  return Ne.name === "html" && Ne.publicId === null && (Ne.systemId === null || Ne.systemId === "about:legacy-compat");
                }(ue) && W._err(ue, xt.nonConformingDoctype), W.treeAdapter.setDocumentMode(W.document, me), W.insertionMode = Xe.BEFORE_HTML;
              })(this, w);
              break;
            case Xe.BEFORE_HEAD:
            case Xe.IN_HEAD:
            case Xe.IN_HEAD_NO_SCRIPT:
            case Xe.AFTER_HEAD:
              this._err(w, xt.misplacedDoctype);
              break;
            case Xe.IN_TABLE_TEXT:
              Ul(this, w);
          }
        } }, { key: "onStartTag", value: function(w) {
          this.skipNextNewLine = !1, this.currentToken = w, this._processStartTag(w), w.selfClosing && !w.ackSelfClosing && this._err(w, xt.nonVoidHtmlElementStartTagWithTrailingSolidus);
        } }, { key: "_processStartTag", value: function(w) {
          this.shouldProcessStartTagTokenInForeignContent(w) ? function(W, ue) {
            var me;
            (function(Ne) {
              var Fe = Ne.tagID;
              return Fe === re.FONT && Ne.attrs.some(function(ut) {
                return (ut = ut.name) === sl.COLOR || ut === sl.SIZE || ut === sl.FACE;
              }) || Ua.has(Fe);
            })(ue) ? (Rs(W), W._startTagOutsideForeignContent(ue)) : (me = W._getAdjustedCurrentElement(), (me = W.treeAdapter.getNamespaceURI(me)) === Tt.MATHML ? Rc(ue) : me === Tt.SVG && (function(Ne) {
              var Fe = pp.get(Ne.tagName);
              Fe != null && (Ne.tagName = Fe, Ne.tagID = Cu(Ne.tagName));
            }(ue), ku(ue)), xn(ue), ue.selfClosing ? W._appendElement(ue, me) : W._insertElement(ue, me), ue.ackSelfClosing = !0);
          }(this, w) : this._startTagOutsideForeignContent(w);
        } }, { key: "_startTagOutsideForeignContent", value: function(w) {
          switch (this.insertionMode) {
            case Xe.INITIAL:
              co(this, w);
              break;
            case Xe.BEFORE_HTML:
              (function(W, ue) {
                ue.tagID === re.HTML ? (W._insertElement(ue, Tt.HTML), W.insertionMode = Xe.BEFORE_HEAD) : Ei(W, ue);
              })(this, w);
              break;
            case Xe.BEFORE_HEAD:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HTML:
                    Hr(W, ue);
                    break;
                  case re.HEAD:
                    W._insertElement(ue, Tt.HTML), W.headElement = W.openElements.current, W.insertionMode = Xe.IN_HEAD;
                    break;
                  default:
                    fl(W, ue);
                }
              })(this, w);
              break;
            case Xe.IN_HEAD:
              ya(this, w);
              break;
            case Xe.IN_HEAD_NO_SCRIPT:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HTML:
                    Hr(W, ue);
                    break;
                  case re.BASEFONT:
                  case re.BGSOUND:
                  case re.HEAD:
                  case re.LINK:
                  case re.META:
                  case re.NOFRAMES:
                  case re.STYLE:
                    ya(W, ue);
                    break;
                  case re.NOSCRIPT:
                    W._err(ue, xt.nestedNoscriptInHead);
                    break;
                  default:
                    za(W, ue);
                }
              })(this, w);
              break;
            case Xe.AFTER_HEAD:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HTML:
                    Hr(W, ue);
                    break;
                  case re.BODY:
                    W._insertElement(ue, Tt.HTML), W.framesetOk = !1, W.insertionMode = Xe.IN_BODY;
                    break;
                  case re.FRAMESET:
                    W._insertElement(ue, Tt.HTML), W.insertionMode = Xe.IN_FRAMESET;
                    break;
                  case re.BASE:
                  case re.BASEFONT:
                  case re.BGSOUND:
                  case re.LINK:
                  case re.META:
                  case re.NOFRAMES:
                  case re.SCRIPT:
                  case re.STYLE:
                  case re.TEMPLATE:
                  case re.TITLE:
                    W._err(ue, xt.abandonedHeadElementChild), W.openElements.push(W.headElement, re.HEAD), ya(W, ue), W.openElements.remove(W.headElement);
                    break;
                  case re.HEAD:
                    W._err(ue, xt.misplacedStartTagForHeadElement);
                    break;
                  default:
                    eo(W, ue);
                }
              })(this, w);
              break;
            case Xe.IN_BODY:
              Hr(this, w);
              break;
            case Xe.IN_TABLE:
              qi(this, w);
              break;
            case Xe.IN_TABLE_TEXT:
              Ul(this, w);
              break;
            case Xe.IN_CAPTION:
              (function(W, ue) {
                var me = ue.tagID;
                Nd.has(me) ? W.openElements.hasInTableScope(re.CAPTION) && (W.openElements.generateImpliedEndTags(), W.openElements.popUntilTagNamePopped(re.CAPTION), W.activeFormattingElements.clearToLastMarker(), W.insertionMode = Xe.IN_TABLE, qi(W, ue)) : Hr(W, ue);
              })(this, w);
              break;
            case Xe.IN_COLUMN_GROUP:
              $f(this, w);
              break;
            case Xe.IN_TABLE_BODY:
              Id(this, w);
              break;
            case Xe.IN_ROW:
              Ic(this, w);
              break;
            case Xe.IN_CELL:
              (function(W, ue) {
                var me = ue.tagID;
                Nd.has(me) ? (W.openElements.hasInTableScope(re.TD) || W.openElements.hasInTableScope(re.TH)) && (W._closeTableCell(), Ic(W, ue)) : Hr(W, ue);
              })(this, w);
              break;
            case Xe.IN_SELECT:
              Hl(this, w);
              break;
            case Xe.IN_SELECT_IN_TABLE:
              (function(W, ue) {
                var me = ue.tagID;
                me === re.CAPTION || me === re.TABLE || me === re.TBODY || me === re.TFOOT || me === re.THEAD || me === re.TR || me === re.TD || me === re.TH ? (W.openElements.popUntilTagNamePopped(re.SELECT), W._resetInsertionMode(), W._processStartTag(ue)) : Hl(W, ue);
              })(this, w);
              break;
            case Xe.IN_TEMPLATE:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.BASE:
                  case re.BASEFONT:
                  case re.BGSOUND:
                  case re.LINK:
                  case re.META:
                  case re.NOFRAMES:
                  case re.SCRIPT:
                  case re.STYLE:
                  case re.TEMPLATE:
                  case re.TITLE:
                    ya(W, ue);
                    break;
                  case re.CAPTION:
                  case re.COLGROUP:
                  case re.TBODY:
                  case re.TFOOT:
                  case re.THEAD:
                    W.tmplInsertionModeStack[0] = Xe.IN_TABLE, W.insertionMode = Xe.IN_TABLE, qi(W, ue);
                    break;
                  case re.COL:
                    W.tmplInsertionModeStack[0] = Xe.IN_COLUMN_GROUP, W.insertionMode = Xe.IN_COLUMN_GROUP, $f(W, ue);
                    break;
                  case re.TR:
                    W.tmplInsertionModeStack[0] = Xe.IN_TABLE_BODY, W.insertionMode = Xe.IN_TABLE_BODY, Id(W, ue);
                    break;
                  case re.TD:
                  case re.TH:
                    W.tmplInsertionModeStack[0] = Xe.IN_ROW, W.insertionMode = Xe.IN_ROW, Ic(W, ue);
                    break;
                  default:
                    W.tmplInsertionModeStack[0] = Xe.IN_BODY, W.insertionMode = Xe.IN_BODY, Hr(W, ue);
                }
              })(this, w);
              break;
            case Xe.AFTER_BODY:
              (function(W, ue) {
                (ue.tagID === re.HTML ? Hr : pl)(W, ue);
              })(this, w);
              break;
            case Xe.IN_FRAMESET:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HTML:
                    Hr(W, ue);
                    break;
                  case re.FRAMESET:
                    W._insertElement(ue, Tt.HTML);
                    break;
                  case re.FRAME:
                    W._appendElement(ue, Tt.HTML), ue.ackSelfClosing = !0;
                    break;
                  case re.NOFRAMES:
                    ya(W, ue);
                }
              })(this, w);
              break;
            case Xe.AFTER_FRAMESET:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HTML:
                    Hr(W, ue);
                    break;
                  case re.NOFRAMES:
                    ya(W, ue);
                }
              })(this, w);
              break;
            case Xe.AFTER_AFTER_BODY:
              (function(W, ue) {
                (ue.tagID === re.HTML ? Hr : Pd)(W, ue);
              })(this, w);
              break;
            case Xe.AFTER_AFTER_FRAMESET:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HTML:
                    Hr(W, ue);
                    break;
                  case re.NOFRAMES:
                    ya(W, ue);
                }
              })(this, w);
          }
        } }, { key: "onEndTag", value: function(w) {
          this.skipNextNewLine = !1, this.currentToken = w, this.currentNotInHTML ? function(W, ue) {
            if (ue.tagID !== re.P && ue.tagID !== re.BR) for (var me = W.openElements.stackTop; 0 < me; me--) {
              var Ae = W.openElements.items[me];
              if (W.treeAdapter.getNamespaceURI(Ae) === Tt.HTML) {
                W._endTagOutsideForeignContent(ue);
                break;
              }
              if ((Ae = W.treeAdapter.getTagName(Ae)).toLowerCase() === ue.tagName) {
                ue.tagName = Ae, W.openElements.shortenToLength(me);
                break;
              }
            }
            else Rs(W), W._endTagOutsideForeignContent(ue);
          }(this, w) : this._endTagOutsideForeignContent(w);
        } }, { key: "_endTagOutsideForeignContent", value: function(w) {
          switch (this.insertionMode) {
            case Xe.INITIAL:
              co(this, w);
              break;
            case Xe.BEFORE_HTML:
              (function(W, ue) {
                var me = ue.tagID;
                me !== re.HTML && me !== re.HEAD && me !== re.BODY && me !== re.BR || Ei(W, ue);
              })(this, w);
              break;
            case Xe.BEFORE_HEAD:
              (function(W, ue) {
                var me = ue.tagID;
                me === re.HEAD || me === re.BODY || me === re.HTML || me === re.BR ? fl(W, ue) : W._err(ue, xt.endTagWithoutMatchingOpenElement);
              })(this, w);
              break;
            case Xe.IN_HEAD:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.HEAD:
                    W.openElements.pop(), W.insertionMode = Xe.AFTER_HEAD;
                    break;
                  case re.BODY:
                  case re.BR:
                  case re.HTML:
                    Ji(W, ue);
                    break;
                  case re.TEMPLATE:
                    hl(W, ue);
                    break;
                  default:
                    W._err(ue, xt.endTagWithoutMatchingOpenElement);
                }
              })(this, w);
              break;
            case Xe.IN_HEAD_NO_SCRIPT:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.NOSCRIPT:
                    W.openElements.pop(), W.insertionMode = Xe.IN_HEAD;
                    break;
                  case re.BR:
                    za(W, ue);
                    break;
                  default:
                    W._err(ue, xt.endTagWithoutMatchingOpenElement);
                }
              })(this, w);
              break;
            case Xe.AFTER_HEAD:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.BODY:
                  case re.HTML:
                  case re.BR:
                    eo(W, ue);
                    break;
                  case re.TEMPLATE:
                    hl(W, ue);
                    break;
                  default:
                    W._err(ue, xt.endTagWithoutMatchingOpenElement);
                }
              })(this, w);
              break;
            case Xe.IN_BODY:
              Ru(this, w);
              break;
            case Xe.TEXT:
              (function(W, ue) {
                var me;
                ue.tagID === re.SCRIPT && (me = W.scriptHandler) !== null && me !== void 0 && me.call(W, W.openElements.current), W.openElements.pop(), W.insertionMode = W.originalInsertionMode;
              })(this, w);
              break;
            case Xe.IN_TABLE:
              Pr(this, w);
              break;
            case Xe.IN_TABLE_TEXT:
              Ul(this, w);
              break;
            case Xe.IN_CAPTION:
              (function(W, ue) {
                var me = ue.tagID;
                switch (me) {
                  case re.CAPTION:
                  case re.TABLE:
                    W.openElements.hasInTableScope(re.CAPTION) && (W.openElements.generateImpliedEndTags(), W.openElements.popUntilTagNamePopped(re.CAPTION), W.activeFormattingElements.clearToLastMarker(), W.insertionMode = Xe.IN_TABLE, me === re.TABLE && Pr(W, ue));
                    break;
                  case re.BODY:
                  case re.COL:
                  case re.COLGROUP:
                  case re.HTML:
                  case re.TBODY:
                  case re.TD:
                  case re.TFOOT:
                  case re.TH:
                  case re.THEAD:
                  case re.TR:
                    break;
                  default:
                    Ru(W, ue);
                }
              })(this, w);
              break;
            case Xe.IN_COLUMN_GROUP:
              (function(W, ue) {
                switch (ue.tagID) {
                  case re.COLGROUP:
                    W.openElements.currentTagId === re.COLGROUP && (W.openElements.pop(), W.insertionMode = Xe.IN_TABLE);
                    break;
                  case re.TEMPLATE:
                    hl(W, ue);
                    break;
                  case re.COL:
                    break;
                  default:
                    Nu(W, ue);
                }
              })(this, w);
              break;
            case Xe.IN_TABLE_BODY:
              oi(this, w);
              break;
            case Xe.IN_ROW:
              Ld(this, w);
              break;
            case Xe.IN_CELL:
              (function(W, ue) {
                var me = ue.tagID;
                switch (me) {
                  case re.TD:
                  case re.TH:
                    W.openElements.hasInTableScope(me) && (W.openElements.generateImpliedEndTags(), W.openElements.popUntilTagNamePopped(me), W.activeFormattingElements.clearToLastMarker(), W.insertionMode = Xe.IN_ROW);
                    break;
                  case re.TABLE:
                  case re.TBODY:
                  case re.TFOOT:
                  case re.THEAD:
                  case re.TR:
                    W.openElements.hasInTableScope(me) && (W._closeTableCell(), Ld(W, ue));
                    break;
                  case re.BODY:
                  case re.CAPTION:
                  case re.COL:
                  case re.COLGROUP:
                  case re.HTML:
                    break;
                  default:
                    Ru(W, ue);
                }
              })(this, w);
              break;
            case Xe.IN_SELECT:
              ls(this, w);
              break;
            case Xe.IN_SELECT_IN_TABLE:
              (function(W, ue) {
                var me = ue.tagID;
                me === re.CAPTION || me === re.TABLE || me === re.TBODY || me === re.TFOOT || me === re.THEAD || me === re.TR || me === re.TD || me === re.TH ? W.openElements.hasInTableScope(me) && (W.openElements.popUntilTagNamePopped(re.SELECT), W._resetInsertionMode(), W.onEndTag(ue)) : ls(W, ue);
              })(this, w);
              break;
            case Xe.IN_TEMPLATE:
              (function(W, ue) {
                ue.tagID === re.TEMPLATE && hl(W, ue);
              })(this, w);
              break;
            case Xe.AFTER_BODY:
              Md(this, w);
              break;
            case Xe.IN_FRAMESET:
              (function(W, ue) {
                ue.tagID !== re.FRAMESET || W.openElements.isRootHtmlElementCurrent() || (W.openElements.pop(), W.fragmentContext || W.openElements.currentTagId === re.FRAMESET || (W.insertionMode = Xe.AFTER_FRAMESET));
              })(this, w);
              break;
            case Xe.AFTER_FRAMESET:
              (function(W, ue) {
                ue.tagID === re.HTML && (W.insertionMode = Xe.AFTER_AFTER_FRAMESET);
              })(this, w);
              break;
            case Xe.AFTER_AFTER_BODY:
              Pd(this, w);
          }
        } }, { key: "onEof", value: function(w) {
          switch (this.insertionMode) {
            case Xe.INITIAL:
              co(this, w);
              break;
            case Xe.BEFORE_HTML:
              Ei(this, w);
              break;
            case Xe.BEFORE_HEAD:
              fl(this, w);
              break;
            case Xe.IN_HEAD:
              Ji(this, w);
              break;
            case Xe.IN_HEAD_NO_SCRIPT:
              za(this, w);
              break;
            case Xe.AFTER_HEAD:
              eo(this, w);
              break;
            case Xe.IN_BODY:
            case Xe.IN_TABLE:
            case Xe.IN_CAPTION:
            case Xe.IN_COLUMN_GROUP:
            case Xe.IN_TABLE_BODY:
            case Xe.IN_ROW:
            case Xe.IN_CELL:
            case Xe.IN_SELECT:
            case Xe.IN_SELECT_IN_TABLE:
              Gf(this, w);
              break;
            case Xe.TEXT:
              (function(W, ue) {
                W._err(ue, xt.eofInElementThatCanContainOnlyText), W.openElements.pop(), W.insertionMode = W.originalInsertionMode, W.onEof(ue);
              })(this, w);
              break;
            case Xe.IN_TABLE_TEXT:
              Ul(this, w);
              break;
            case Xe.IN_TEMPLATE:
              gp(this, w);
              break;
            case Xe.AFTER_BODY:
            case Xe.IN_FRAMESET:
            case Xe.AFTER_FRAMESET:
            case Xe.AFTER_AFTER_BODY:
            case Xe.AFTER_AFTER_FRAMESET:
              Vf(this, w);
          }
        } }, { key: "onWhitespaceCharacter", value: function(w) {
          if (this.skipNextNewLine && (this.skipNextNewLine = !1, w.chars.charCodeAt(0) === Pe.LINE_FEED)) {
            if (w.chars.length === 1) return;
            w.chars = w.chars.substr(1);
          }
          if (this.tokenizer.inForeignNode) this._insertCharacters(w);
          else switch (this.insertionMode) {
            case Xe.IN_HEAD:
            case Xe.IN_HEAD_NO_SCRIPT:
            case Xe.AFTER_HEAD:
            case Xe.TEXT:
            case Xe.IN_COLUMN_GROUP:
            case Xe.IN_SELECT:
            case Xe.IN_SELECT_IN_TABLE:
            case Xe.IN_FRAMESET:
            case Xe.AFTER_FRAMESET:
              this._insertCharacters(w);
              break;
            case Xe.IN_BODY:
            case Xe.IN_CAPTION:
            case Xe.IN_CELL:
            case Xe.IN_TEMPLATE:
            case Xe.AFTER_BODY:
            case Xe.AFTER_AFTER_BODY:
            case Xe.AFTER_AFTER_FRAMESET:
              Du(this, w);
              break;
            case Xe.IN_TABLE:
            case Xe.IN_TABLE_BODY:
            case Xe.IN_ROW:
              zo(this, w);
              break;
            case Xe.IN_TABLE_TEXT:
              Wf(this, w);
          }
        } }], [{ key: "parse", value: function(w, R) {
          return (R = new this(R)).tokenizer.write(w, !0), R.document;
        } }, { key: "getFragmentParser", value: function(w, R) {
          var W = Fn(Fn({}, _a), R);
          return w != null || (w = W.treeAdapter.createElement(ht.TEMPLATE, Tt.HTML, [])), R = W.treeAdapter.createElement("documentmock", Tt.HTML, []), (w = new this(W, R, w)).fragmentContextID === re.TEMPLATE && w.tmplInsertionModeStack.unshift(Xe.IN_TEMPLATE), w._initTokenizerForFragmentParsing(), w._insertFakeRootElement(), w._resetInsertionMode(), w._findFormInFragmentContext(), w;
        } }]), M;
      }();
      function Ou(M, O) {
        for (var w = 0; w < bi; w++) {
          var R = function(Ne, Fe) {
            var ut = Ne.activeFormattingElements.getElementEntryInScopeWithTagName(Fe.tagName);
            return ut ? Ne.openElements.contains(ut.element) ? Ne.openElements.hasInScope(Fe.tagID) || (ut = null) : (Ne.activeFormattingElements.removeEntry(ut), ut = null) : qf(Ne, Fe), ut;
          }(M, O);
          if (!R) break;
          var W = function(Ne, Fe) {
            for (var ut = null, Je = Ne.openElements.stackTop; 0 <= Je; Je--) {
              var pt = Ne.openElements.items[Je];
              if (pt === Fe.element) break;
              Ne._isSpecialElement(pt, Ne.openElements.tagIDs[Je]) && (ut = pt);
            }
            return ut || (Ne.openElements.shortenToLength(Je < 0 ? 0 : Je), Ne.activeFormattingElements.removeEntry(Fe)), ut;
          }(M, R);
          if (!W) break;
          M.activeFormattingElements.bookmark = R;
          var ue = function(Ne, Fe, ut) {
            for (var Je = Fe, pt = 0, Nt = Ne.openElements.getCommonAncestor(Fe); Nt !== ut; pt++, Nt = Bt) {
              var Bt = Ne.openElements.getCommonAncestor(Nt), Qt = Ne.activeFormattingElements.getElementEntry(Nt), Cn = Qt && oa <= pt;
              !Qt || Cn ? (Cn && Ne.activeFormattingElements.removeEntry(Qt), Ne.openElements.remove(Nt)) : (Nt = function(kn, Zn) {
                var Dr = kn.treeAdapter.getNamespaceURI(Zn.element), Dr = kn.treeAdapter.createElement(Zn.token.tagName, Dr, Zn.token.attrs);
                return kn.openElements.replace(Zn.element, Dr), Zn.element = Dr;
              }(Ne, Qt), Je === Fe && (Ne.activeFormattingElements.bookmark = Qt), Ne.treeAdapter.detachNode(Je), Ne.treeAdapter.appendChild(Nt, Je), Je = Nt);
            }
            return Je;
          }(M, W, R.element), me = M.openElements.getCommonAncestor(R.element);
          M.treeAdapter.detachNode(ue), me && function(Ne, Fe, ut) {
            var Je, pt = Cu(Ne.treeAdapter.getTagName(Fe));
            Ne._isElementCausesFosterParenting(pt) ? Ne._fosterParentElement(ut) : (Je = Ne.treeAdapter.getNamespaceURI(Fe), pt === re.TEMPLATE && Je === Tt.HTML && (Fe = Ne.treeAdapter.getTemplateContent(Fe)), Ne.treeAdapter.appendChild(Fe, ut));
          }(M, me, ue), function(Ne, Fe, ut) {
            var pt = Ne.treeAdapter.getNamespaceURI(ut.element), Je = ut.token, pt = Ne.treeAdapter.createElement(Je.tagName, pt, Je.attrs);
            Ne._adoptNodes(Fe, pt), Ne.treeAdapter.appendChild(Fe, pt), Ne.activeFormattingElements.insertElementAfterBookmark(pt, Je), Ne.activeFormattingElements.removeEntry(ut), Ne.openElements.remove(ut.element), Ne.openElements.insertAfter(Fe, pt, Je.tagID);
          }(M, W, R);
        }
      }
      function Nc(M, O) {
        M._appendCommentNode(O, M.openElements.currentTmplContentOrNode);
      }
      function Vf(M, O) {
        if (M.stopped = !0, O.location) {
          for (var w, R, W = M.fragmentContext ? 0 : 2, ue = M.openElements.stackTop; W <= ue; ue--) M._setEndLocation(M.openElements.items[ue], O);
          !M.fragmentContext && 0 <= M.openElements.stackTop && (R = M.openElements.items[0], (w = M.treeAdapter.getNodeSourceCodeLocation(R)) && !w.endTag && (M._setEndLocation(R, O), 1 <= M.openElements.stackTop && (w = M.openElements.items[1], (R = M.treeAdapter.getNodeSourceCodeLocation(w)) && !R.endTag && M._setEndLocation(w, O))));
        }
      }
      function co(M, O) {
        M._err(O, xt.missingDoctype, !0), M.treeAdapter.setDocumentMode(M.document, bo.QUIRKS), M.insertionMode = Xe.BEFORE_HTML, M._processToken(O);
      }
      function Ei(M, O) {
        M._insertFakeRootElement(), M.insertionMode = Xe.BEFORE_HEAD, M._processToken(O);
      }
      function fl(M, O) {
        M._insertFakeElement(ht.HEAD, re.HEAD), M.headElement = M.openElements.current, M.insertionMode = Xe.IN_HEAD, M._processToken(O);
      }
      function ya(M, O) {
        switch (O.tagID) {
          case re.HTML:
            Hr(M, O);
            break;
          case re.BASE:
          case re.BASEFONT:
          case re.BGSOUND:
          case re.LINK:
          case re.META:
            M._appendElement(O, Tt.HTML), O.ackSelfClosing = !0;
            break;
          case re.TITLE:
            M._switchToTextParsing(O, Uo.RCDATA);
            break;
          case re.NOSCRIPT:
            M.options.scriptingEnabled ? M._switchToTextParsing(O, Uo.RAWTEXT) : (M._insertElement(O, Tt.HTML), M.insertionMode = Xe.IN_HEAD_NO_SCRIPT);
            break;
          case re.NOFRAMES:
          case re.STYLE:
            M._switchToTextParsing(O, Uo.RAWTEXT);
            break;
          case re.SCRIPT:
            M._switchToTextParsing(O, Uo.SCRIPT_DATA);
            break;
          case re.TEMPLATE:
            M._insertTemplate(O), M.activeFormattingElements.insertMarker(), M.framesetOk = !1, M.insertionMode = Xe.IN_TEMPLATE, M.tmplInsertionModeStack.unshift(Xe.IN_TEMPLATE);
            break;
          case re.HEAD:
            M._err(O, xt.misplacedStartTagForHeadElement);
            break;
          default:
            Ji(M, O);
        }
      }
      function hl(M, O) {
        0 < M.openElements.tmplCount ? (M.openElements.generateImpliedEndTagsThoroughly(), M.openElements.currentTagId !== re.TEMPLATE && M._err(O, xt.closingOfElementWithOpenChildElements), M.openElements.popUntilTagNamePopped(re.TEMPLATE), M.activeFormattingElements.clearToLastMarker(), M.tmplInsertionModeStack.shift(), M._resetInsertionMode()) : M._err(O, xt.endTagWithoutMatchingOpenElement);
      }
      function Ji(M, O) {
        M.openElements.pop(), M.insertionMode = Xe.AFTER_HEAD, M._processToken(O);
      }
      function za(M, O) {
        var w = O.type === Cr.EOF ? xt.openElementsLeftAfterEof : xt.disallowedContentInNoscriptInHead;
        M._err(O, w), M.openElements.pop(), M.insertionMode = Xe.IN_HEAD, M._processToken(O);
      }
      function eo(M, O) {
        M._insertFakeElement(ht.BODY, re.BODY), M.insertionMode = Xe.IN_BODY, Os(M, O);
      }
      function Os(M, O) {
        switch (O.type) {
          case Cr.CHARACTER:
            Ho(M, O);
            break;
          case Cr.WHITESPACE_CHARACTER:
            Du(M, O);
            break;
          case Cr.COMMENT:
            Nc(M, O);
            break;
          case Cr.START_TAG:
            Hr(M, O);
            break;
          case Cr.END_TAG:
            Ru(M, O);
            break;
          case Cr.EOF:
            Gf(M, O);
        }
      }
      function Du(M, O) {
        M._reconstructActiveFormattingElements(), M._insertCharacters(O);
      }
      function Ho(M, O) {
        M._reconstructActiveFormattingElements(), M._insertCharacters(O), M.framesetOk = !1;
      }
      function fo(M, O) {
        M._reconstructActiveFormattingElements(), M._appendElement(O, Tt.HTML), M.framesetOk = !1, O.ackSelfClosing = !0;
      }
      function va(M) {
        return (M = ap(M, sl.TYPE)) != null && M.toLowerCase() === Gn;
      }
      function to(M, O) {
        M._switchToTextParsing(O, Uo.RAWTEXT);
      }
      function Ds(M, O) {
        M._reconstructActiveFormattingElements(), M._insertElement(O, Tt.HTML);
      }
      function Hr(M, O) {
        switch (O.tagID) {
          case re.I:
          case re.S:
          case re.B:
          case re.U:
          case re.EM:
          case re.TT:
          case re.BIG:
          case re.CODE:
          case re.FONT:
          case re.SMALL:
          case re.STRIKE:
          case re.STRONG:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), R._insertElement(W, Tt.HTML), R.activeFormattingElements.pushElement(R.openElements.current, W);
            })(M, O);
            break;
          case re.A:
            (function(R, W) {
              var ue = R.activeFormattingElements.getElementEntryInScopeWithTagName(ht.A);
              ue && (Ou(R, W), R.openElements.remove(ue.element), R.activeFormattingElements.removeEntry(ue)), R._reconstructActiveFormattingElements(), R._insertElement(W, Tt.HTML), R.activeFormattingElements.pushElement(R.openElements.current, W);
            })(M, O);
            break;
          case re.H1:
          case re.H2:
          case re.H3:
          case re.H4:
          case re.H5:
          case re.H6:
            (function(R, W) {
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), ll(R.openElements.currentTagId) && R.openElements.pop(), R._insertElement(W, Tt.HTML);
            })(M, O);
            break;
          case re.P:
          case re.DL:
          case re.OL:
          case re.UL:
          case re.DIV:
          case re.DIR:
          case re.NAV:
          case re.MAIN:
          case re.MENU:
          case re.ASIDE:
          case re.CENTER:
          case re.FIGURE:
          case re.FOOTER:
          case re.HEADER:
          case re.HGROUP:
          case re.DIALOG:
          case re.DETAILS:
          case re.ADDRESS:
          case re.ARTICLE:
          case re.SECTION:
          case re.SUMMARY:
          case re.FIELDSET:
          case re.BLOCKQUOTE:
          case re.FIGCAPTION:
            (function(R, W) {
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._insertElement(W, Tt.HTML);
            })(M, O);
            break;
          case re.LI:
          case re.DD:
          case re.DT:
            (function(R, W) {
              R.framesetOk = !1;
              for (var ue = W.tagID, me = R.openElements.stackTop; 0 <= me; me--) {
                var Ae = R.openElements.tagIDs[me];
                if (ue === re.LI && Ae === re.LI || (ue === re.DD || ue === re.DT) && (Ae === re.DD || Ae === re.DT)) {
                  R.openElements.generateImpliedEndTagsWithExclusion(Ae), R.openElements.popUntilTagNamePopped(Ae);
                  break;
                }
                if (Ae !== re.ADDRESS && Ae !== re.DIV && Ae !== re.P && R._isSpecialElement(R.openElements.items[me], Ae)) break;
              }
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._insertElement(W, Tt.HTML);
            })(M, O);
            break;
          case re.BR:
          case re.IMG:
          case re.WBR:
          case re.AREA:
          case re.EMBED:
          case re.KEYGEN:
            fo(M, O);
            break;
          case re.HR:
            (function(R, W) {
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._appendElement(W, Tt.HTML), R.framesetOk = !1, W.ackSelfClosing = !0;
            })(M, O);
            break;
          case re.RB:
          case re.RTC:
            (function(R, W) {
              R.openElements.hasInScope(re.RUBY) && R.openElements.generateImpliedEndTags(), R._insertElement(W, Tt.HTML);
            })(M, O);
            break;
          case re.RT:
          case re.RP:
            (function(R, W) {
              R.openElements.hasInScope(re.RUBY) && R.openElements.generateImpliedEndTagsWithExclusion(re.RTC), R._insertElement(W, Tt.HTML);
            })(M, O);
            break;
          case re.PRE:
          case re.LISTING:
            (function(R, W) {
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._insertElement(W, Tt.HTML), R.skipNextNewLine = !0, R.framesetOk = !1;
            })(M, O);
            break;
          case re.XMP:
            (function(R, W) {
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._reconstructActiveFormattingElements(), R.framesetOk = !1, R._switchToTextParsing(W, Uo.RAWTEXT);
            })(M, O);
            break;
          case re.SVG:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), ku(W), xn(W), W.selfClosing ? R._appendElement(W, Tt.SVG) : R._insertElement(W, Tt.SVG), W.ackSelfClosing = !0;
            })(M, O);
            break;
          case re.HTML:
            (function(R, W) {
              R.openElements.tmplCount === 0 && R.treeAdapter.adoptAttributes(R.openElements.items[0], W.attrs);
            })(M, O);
            break;
          case re.BASE:
          case re.LINK:
          case re.META:
          case re.STYLE:
          case re.TITLE:
          case re.SCRIPT:
          case re.BGSOUND:
          case re.BASEFONT:
          case re.TEMPLATE:
            ya(M, O);
            break;
          case re.BODY:
            (function(R, W) {
              var ue = R.openElements.tryPeekProperlyNestedBodyElement();
              ue && R.openElements.tmplCount === 0 && (R.framesetOk = !1, R.treeAdapter.adoptAttributes(ue, W.attrs));
            })(M, O);
            break;
          case re.FORM:
            (function(R, W) {
              var ue = 0 < R.openElements.tmplCount;
              R.formElement && !ue || (R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._insertElement(W, Tt.HTML), ue || (R.formElement = R.openElements.current));
            })(M, O);
            break;
          case re.NOBR:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), R.openElements.hasInScope(re.NOBR) && (Ou(R, W), R._reconstructActiveFormattingElements()), R._insertElement(W, Tt.HTML), R.activeFormattingElements.pushElement(R.openElements.current, W);
            })(M, O);
            break;
          case re.MATH:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), Rc(W), xn(W), W.selfClosing ? R._appendElement(W, Tt.MATHML) : R._insertElement(W, Tt.MATHML), W.ackSelfClosing = !0;
            })(M, O);
            break;
          case re.TABLE:
            (function(R, W) {
              R.treeAdapter.getDocumentMode(R.document) !== bo.QUIRKS && R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._insertElement(W, Tt.HTML), R.framesetOk = !1, R.insertionMode = Xe.IN_TABLE;
            })(M, O);
            break;
          case re.INPUT:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), R._appendElement(W, Tt.HTML), va(W) || (R.framesetOk = !1), W.ackSelfClosing = !0;
            })(M, O);
            break;
          case re.PARAM:
          case re.TRACK:
          case re.SOURCE:
            (function(R, W) {
              R._appendElement(W, Tt.HTML), W.ackSelfClosing = !0;
            })(M, O);
            break;
          case re.IMAGE:
            (function(R, W) {
              W.tagName = ht.IMG, W.tagID = re.IMG, fo(R, W);
            })(M, O);
            break;
          case re.BUTTON:
            (function(R, W) {
              R.openElements.hasInScope(re.BUTTON) && (R.openElements.generateImpliedEndTags(), R.openElements.popUntilTagNamePopped(re.BUTTON)), R._reconstructActiveFormattingElements(), R._insertElement(W, Tt.HTML), R.framesetOk = !1;
            })(M, O);
            break;
          case re.APPLET:
          case re.OBJECT:
          case re.MARQUEE:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), R._insertElement(W, Tt.HTML), R.activeFormattingElements.insertMarker(), R.framesetOk = !1;
            })(M, O);
            break;
          case re.IFRAME:
            (function(R, W) {
              R.framesetOk = !1, R._switchToTextParsing(W, Uo.RAWTEXT);
            })(M, O);
            break;
          case re.SELECT:
            (function(R, W) {
              R._reconstructActiveFormattingElements(), R._insertElement(W, Tt.HTML), R.framesetOk = !1, R.insertionMode = R.insertionMode === Xe.IN_TABLE || R.insertionMode === Xe.IN_CAPTION || R.insertionMode === Xe.IN_TABLE_BODY || R.insertionMode === Xe.IN_ROW || R.insertionMode === Xe.IN_CELL ? Xe.IN_SELECT_IN_TABLE : Xe.IN_SELECT;
            })(M, O);
            break;
          case re.OPTION:
          case re.OPTGROUP:
            (function(R, W) {
              R.openElements.currentTagId === re.OPTION && R.openElements.pop(), R._reconstructActiveFormattingElements(), R._insertElement(W, Tt.HTML);
            })(M, O);
            break;
          case re.NOEMBED:
            to(M, O);
            break;
          case re.FRAMESET:
            (function(R, W) {
              var ue = R.openElements.tryPeekProperlyNestedBodyElement();
              R.framesetOk && ue && (R.treeAdapter.detachNode(ue), R.openElements.popAllUpToHtmlElement(), R._insertElement(W, Tt.HTML), R.insertionMode = Xe.IN_FRAMESET);
            })(M, O);
            break;
          case re.TEXTAREA:
            (function(R, W) {
              R._insertElement(W, Tt.HTML), R.skipNextNewLine = !0, R.tokenizer.state = Uo.RCDATA, R.originalInsertionMode = R.insertionMode, R.framesetOk = !1, R.insertionMode = Xe.TEXT;
            })(M, O);
            break;
          case re.NOSCRIPT:
            (M.options.scriptingEnabled ? to : Ds)(M, O);
            break;
          case re.PLAINTEXT:
            (function(R, W) {
              R.openElements.hasInButtonScope(re.P) && R._closePElement(), R._insertElement(W, Tt.HTML), R.tokenizer.state = Uo.PLAINTEXT;
            })(M, O);
            break;
          case re.COL:
          case re.TH:
          case re.TD:
          case re.TR:
          case re.HEAD:
          case re.FRAME:
          case re.TBODY:
          case re.TFOOT:
          case re.THEAD:
          case re.CAPTION:
          case re.COLGROUP:
            break;
          default:
            Ds(M, O);
        }
      }
      function qf(M, O) {
        for (var w = O.tagName, R = O.tagID, W = M.openElements.stackTop; 0 < W; W--) {
          var ue = M.openElements.items[W], me = M.openElements.tagIDs[W];
          if (R === me && (R !== re.UNKNOWN || M.treeAdapter.getTagName(ue) === w)) {
            M.openElements.generateImpliedEndTagsWithExclusion(R), M.openElements.stackTop >= W && M.openElements.shortenToLength(W);
            break;
          }
          if (M._isSpecialElement(ue, me)) break;
        }
      }
      function Ru(M, O) {
        switch (O.tagID) {
          case re.A:
          case re.B:
          case re.I:
          case re.S:
          case re.U:
          case re.EM:
          case re.TT:
          case re.BIG:
          case re.CODE:
          case re.FONT:
          case re.NOBR:
          case re.SMALL:
          case re.STRIKE:
          case re.STRONG:
            Ou(M, O);
            break;
          case re.P:
            (function(R) {
              R.openElements.hasInButtonScope(re.P) || R._insertFakeElement(ht.P, re.P), R._closePElement();
            })(M);
            break;
          case re.DL:
          case re.UL:
          case re.OL:
          case re.DIR:
          case re.DIV:
          case re.NAV:
          case re.PRE:
          case re.MAIN:
          case re.MENU:
          case re.ASIDE:
          case re.BUTTON:
          case re.CENTER:
          case re.FIGURE:
          case re.FOOTER:
          case re.HEADER:
          case re.HGROUP:
          case re.DIALOG:
          case re.ADDRESS:
          case re.ARTICLE:
          case re.DETAILS:
          case re.SECTION:
          case re.SUMMARY:
          case re.LISTING:
          case re.FIELDSET:
          case re.BLOCKQUOTE:
          case re.FIGCAPTION:
            (function(R, W) {
              W = W.tagID, R.openElements.hasInScope(W) && (R.openElements.generateImpliedEndTags(), R.openElements.popUntilTagNamePopped(W));
            })(M, O);
            break;
          case re.LI:
            (function(R) {
              R.openElements.hasInListItemScope(re.LI) && (R.openElements.generateImpliedEndTagsWithExclusion(re.LI), R.openElements.popUntilTagNamePopped(re.LI));
            })(M);
            break;
          case re.DD:
          case re.DT:
            (function(R, W) {
              W = W.tagID, R.openElements.hasInScope(W) && (R.openElements.generateImpliedEndTagsWithExclusion(W), R.openElements.popUntilTagNamePopped(W));
            })(M, O);
            break;
          case re.H1:
          case re.H2:
          case re.H3:
          case re.H4:
          case re.H5:
          case re.H6:
            (function(R) {
              R.openElements.hasNumberedHeaderInScope() && (R.openElements.generateImpliedEndTags(), R.openElements.popUntilNumberedHeaderPopped());
            })(M);
            break;
          case re.BR:
            (function(R) {
              R._reconstructActiveFormattingElements(), R._insertFakeElement(ht.BR, re.BR), R.openElements.pop(), R.framesetOk = !1;
            })(M);
            break;
          case re.BODY:
            (function(R, W) {
              var ue;
              R.openElements.hasInScope(re.BODY) && (R.insertionMode = Xe.AFTER_BODY, !R.options.sourceCodeLocationInfo || (ue = R.openElements.tryPeekProperlyNestedBodyElement()) && R._setEndLocation(ue, W));
            })(M, O);
            break;
          case re.HTML:
            (function(R, W) {
              R.openElements.hasInScope(re.BODY) && (R.insertionMode = Xe.AFTER_BODY, Md(R, W));
            })(M, O);
            break;
          case re.FORM:
            (function(R) {
              var W = 0 < R.openElements.tmplCount, ue = R.formElement;
              W || (R.formElement = null), (ue || W) && R.openElements.hasInScope(re.FORM) && (R.openElements.generateImpliedEndTags(), W ? R.openElements.popUntilTagNamePopped(re.FORM) : ue && R.openElements.remove(ue));
            })(M);
            break;
          case re.APPLET:
          case re.OBJECT:
          case re.MARQUEE:
            (function(R, W) {
              W = W.tagID, R.openElements.hasInScope(W) && (R.openElements.generateImpliedEndTags(), R.openElements.popUntilTagNamePopped(W), R.activeFormattingElements.clearToLastMarker());
            })(M, O);
            break;
          case re.TEMPLATE:
            hl(M, O);
            break;
          default:
            qf(M, O);
        }
      }
      function Gf(M, O) {
        (0 < M.tmplInsertionModeStack.length ? gp : Vf)(M, O);
      }
      function zo(M, O) {
        if (ii.has(M.openElements.currentTagId)) switch (M.pendingCharacterTokens.length = 0, M.hasNonWhitespacePendingCharacterToken = !1, M.originalInsertionMode = M.insertionMode, M.insertionMode = Xe.IN_TABLE_TEXT, O.type) {
          case Cr.CHARACTER:
            mp(M, O);
            break;
          case Cr.WHITESPACE_CHARACTER:
            Wf(M, O);
        }
        else Co(M, O);
      }
      function qi(M, O) {
        switch (O.tagID) {
          case re.TD:
          case re.TH:
          case re.TR:
            (function(R, W) {
              R.openElements.clearBackToTableContext(), R._insertFakeElement(ht.TBODY, re.TBODY), R.insertionMode = Xe.IN_TABLE_BODY, Id(R, W);
            })(M, O);
            break;
          case re.STYLE:
          case re.SCRIPT:
          case re.TEMPLATE:
            ya(M, O);
            break;
          case re.COL:
            (function(R, W) {
              R.openElements.clearBackToTableContext(), R._insertFakeElement(ht.COLGROUP, re.COLGROUP), R.insertionMode = Xe.IN_COLUMN_GROUP, $f(R, W);
            })(M, O);
            break;
          case re.FORM:
            (function(R, W) {
              R.formElement || R.openElements.tmplCount !== 0 || (R._insertElement(W, Tt.HTML), R.formElement = R.openElements.current, R.openElements.pop());
            })(M, O);
            break;
          case re.TABLE:
            (function(R, W) {
              R.openElements.hasInTableScope(re.TABLE) && (R.openElements.popUntilTagNamePopped(re.TABLE), R._resetInsertionMode(), R._processStartTag(W));
            })(M, O);
            break;
          case re.TBODY:
          case re.TFOOT:
          case re.THEAD:
            (function(R, W) {
              R.openElements.clearBackToTableContext(), R._insertElement(W, Tt.HTML), R.insertionMode = Xe.IN_TABLE_BODY;
            })(M, O);
            break;
          case re.INPUT:
            (function(R, W) {
              va(W) ? R._appendElement(W, Tt.HTML) : Co(R, W), W.ackSelfClosing = !0;
            })(M, O);
            break;
          case re.CAPTION:
            (function(R, W) {
              R.openElements.clearBackToTableContext(), R.activeFormattingElements.insertMarker(), R._insertElement(W, Tt.HTML), R.insertionMode = Xe.IN_CAPTION;
            })(M, O);
            break;
          case re.COLGROUP:
            (function(R, W) {
              R.openElements.clearBackToTableContext(), R._insertElement(W, Tt.HTML), R.insertionMode = Xe.IN_COLUMN_GROUP;
            })(M, O);
            break;
          default:
            Co(M, O);
        }
      }
      function Pr(M, O) {
        switch (O.tagID) {
          case re.TABLE:
            M.openElements.hasInTableScope(re.TABLE) && (M.openElements.popUntilTagNamePopped(re.TABLE), M._resetInsertionMode());
            break;
          case re.TEMPLATE:
            hl(M, O);
            break;
          case re.BODY:
          case re.CAPTION:
          case re.COL:
          case re.COLGROUP:
          case re.HTML:
          case re.TBODY:
          case re.TD:
          case re.TFOOT:
          case re.TH:
          case re.THEAD:
          case re.TR:
            break;
          default:
            Co(M, O);
        }
      }
      function Co(M, O) {
        var w = M.fosterParentingEnabled;
        M.fosterParentingEnabled = !0, Os(M, O), M.fosterParentingEnabled = w;
      }
      function Wf(M, O) {
        M.pendingCharacterTokens.push(O);
      }
      function mp(M, O) {
        M.pendingCharacterTokens.push(O), M.hasNonWhitespacePendingCharacterToken = !0;
      }
      function Ul(M, O) {
        var w = 0;
        if (M.hasNonWhitespacePendingCharacterToken) for (; w < M.pendingCharacterTokens.length; w++) Co(M, M.pendingCharacterTokens[w]);
        else for (; w < M.pendingCharacterTokens.length; w++) M._insertCharacters(M.pendingCharacterTokens[w]);
        M.insertionMode = M.originalInsertionMode, M._processToken(O);
      }
      var Nd = /* @__PURE__ */ new Set([re.CAPTION, re.COL, re.COLGROUP, re.TBODY, re.TD, re.TFOOT, re.TH, re.THEAD, re.TR]);
      function $f(M, O) {
        switch (O.tagID) {
          case re.HTML:
            Hr(M, O);
            break;
          case re.COL:
            M._appendElement(O, Tt.HTML), O.ackSelfClosing = !0;
            break;
          case re.TEMPLATE:
            ya(M, O);
            break;
          default:
            Nu(M, O);
        }
      }
      function Nu(M, O) {
        M.openElements.currentTagId === re.COLGROUP && (M.openElements.pop(), M.insertionMode = Xe.IN_TABLE, M._processToken(O));
      }
      function Id(M, O) {
        switch (O.tagID) {
          case re.TR:
            M.openElements.clearBackToTableBodyContext(), M._insertElement(O, Tt.HTML), M.insertionMode = Xe.IN_ROW;
            break;
          case re.TH:
          case re.TD:
            M.openElements.clearBackToTableBodyContext(), M._insertFakeElement(ht.TR, re.TR), M.insertionMode = Xe.IN_ROW, Ic(M, O);
            break;
          case re.CAPTION:
          case re.COL:
          case re.COLGROUP:
          case re.TBODY:
          case re.TFOOT:
          case re.THEAD:
            M.openElements.hasTableBodyContextInTableScope() && (M.openElements.clearBackToTableBodyContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE, qi(M, O));
            break;
          default:
            qi(M, O);
        }
      }
      function oi(M, O) {
        var w = O.tagID;
        switch (O.tagID) {
          case re.TBODY:
          case re.TFOOT:
          case re.THEAD:
            M.openElements.hasInTableScope(w) && (M.openElements.clearBackToTableBodyContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE);
            break;
          case re.TABLE:
            M.openElements.hasTableBodyContextInTableScope() && (M.openElements.clearBackToTableBodyContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE, Pr(M, O));
            break;
          case re.BODY:
          case re.CAPTION:
          case re.COL:
          case re.COLGROUP:
          case re.HTML:
          case re.TD:
          case re.TH:
          case re.TR:
            break;
          default:
            Pr(M, O);
        }
      }
      function Ic(M, O) {
        switch (O.tagID) {
          case re.TH:
          case re.TD:
            M.openElements.clearBackToTableRowContext(), M._insertElement(O, Tt.HTML), M.insertionMode = Xe.IN_CELL, M.activeFormattingElements.insertMarker();
            break;
          case re.CAPTION:
          case re.COL:
          case re.COLGROUP:
          case re.TBODY:
          case re.TFOOT:
          case re.THEAD:
          case re.TR:
            M.openElements.hasInTableScope(re.TR) && (M.openElements.clearBackToTableRowContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE_BODY, Id(M, O));
            break;
          default:
            qi(M, O);
        }
      }
      function Ld(M, O) {
        switch (O.tagID) {
          case re.TR:
            M.openElements.hasInTableScope(re.TR) && (M.openElements.clearBackToTableRowContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE_BODY);
            break;
          case re.TABLE:
            M.openElements.hasInTableScope(re.TR) && (M.openElements.clearBackToTableRowContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE_BODY, oi(M, O));
            break;
          case re.TBODY:
          case re.TFOOT:
          case re.THEAD:
            (M.openElements.hasInTableScope(O.tagID) || M.openElements.hasInTableScope(re.TR)) && (M.openElements.clearBackToTableRowContext(), M.openElements.pop(), M.insertionMode = Xe.IN_TABLE_BODY, oi(M, O));
            break;
          case re.BODY:
          case re.CAPTION:
          case re.COL:
          case re.COLGROUP:
          case re.HTML:
          case re.TD:
          case re.TH:
            break;
          default:
            Pr(M, O);
        }
      }
      function Hl(M, O) {
        switch (O.tagID) {
          case re.HTML:
            Hr(M, O);
            break;
          case re.OPTION:
            M.openElements.currentTagId === re.OPTION && M.openElements.pop(), M._insertElement(O, Tt.HTML);
            break;
          case re.OPTGROUP:
            M.openElements.currentTagId === re.OPTION && M.openElements.pop(), M.openElements.currentTagId === re.OPTGROUP && M.openElements.pop(), M._insertElement(O, Tt.HTML);
            break;
          case re.INPUT:
          case re.KEYGEN:
          case re.TEXTAREA:
          case re.SELECT:
            M.openElements.hasInSelectScope(re.SELECT) && (M.openElements.popUntilTagNamePopped(re.SELECT), M._resetInsertionMode(), O.tagID !== re.SELECT && M._processStartTag(O));
            break;
          case re.SCRIPT:
          case re.TEMPLATE:
            ya(M, O);
        }
      }
      function ls(M, O) {
        switch (O.tagID) {
          case re.OPTGROUP:
            0 < M.openElements.stackTop && M.openElements.currentTagId === re.OPTION && M.openElements.tagIDs[M.openElements.stackTop - 1] === re.OPTGROUP && M.openElements.pop(), M.openElements.currentTagId === re.OPTGROUP && M.openElements.pop();
            break;
          case re.OPTION:
            M.openElements.currentTagId === re.OPTION && M.openElements.pop();
            break;
          case re.SELECT:
            M.openElements.hasInSelectScope(re.SELECT) && (M.openElements.popUntilTagNamePopped(re.SELECT), M._resetInsertionMode());
            break;
          case re.TEMPLATE:
            hl(M, O);
        }
      }
      function gp(M, O) {
        0 < M.openElements.tmplCount ? (M.openElements.popUntilTagNamePopped(re.TEMPLATE), M.activeFormattingElements.clearToLastMarker(), M.tmplInsertionModeStack.shift(), M._resetInsertionMode(), M.onEof(O)) : Vf(M, O);
      }
      function Md(M, O) {
        var w, R;
        O.tagID === re.HTML ? (M.fragmentContext || (M.insertionMode = Xe.AFTER_AFTER_BODY), M.options.sourceCodeLocationInfo && M.openElements.tagIDs[0] === re.HTML && (M._setEndLocation(M.openElements.items[0], O), !(R = M.openElements.items[1]) || (w = M.treeAdapter.getNodeSourceCodeLocation(R)) !== null && w !== void 0 && w.endTag || M._setEndLocation(R, O))) : pl(M, O);
      }
      function pl(M, O) {
        M.insertionMode = Xe.IN_BODY, Os(M, O);
      }
      function Pd(M, O) {
        M.insertionMode = Xe.IN_BODY, Os(M, O);
      }
      function Rs(M) {
        for (; M.treeAdapter.getNamespaceURI(M.openElements.current) !== Tt.HTML && !M._isIntegrationPoint(M.openElements.currentTagId, M.openElements.current); ) M.openElements.pop();
      }
      var Bi = r(148);
      function Xt(M) {
        return (Xt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function ba(M, O) {
        var w = typeof Symbol < "u" && M[Symbol.iterator] || M["@@iterator"];
        if (!w) {
          if (Array.isArray(M) || (w = function(Ne, Fe) {
            if (Ne) {
              if (typeof Ne == "string") return aa(Ne, Fe);
              var ut = Object.prototype.toString.call(Ne).slice(8, -1);
              return (ut = ut === "Object" && Ne.constructor ? Ne.constructor.name : ut) === "Map" || ut === "Set" ? Array.from(Ne) : ut === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ut) ? aa(Ne, Fe) : void 0;
            }
          }(M)) || O && M && typeof M.length == "number") {
            w && (M = w);
            var R = 0;
            return { s: O = function() {
            }, n: function() {
              return R >= M.length ? { done: !0 } : { done: !1, value: M[R++] };
            }, e: function(Ne) {
              throw Ne;
            }, f: O };
          }
          throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var W, ue = !0, me = !1;
        return { s: function() {
          w = w.call(M);
        }, n: function() {
          var Ne = w.next();
          return ue = Ne.done, Ne;
        }, e: function(Ne) {
          me = !0, W = Ne;
        }, f: function() {
          try {
            ue || w.return == null || w.return();
          } finally {
            if (me) throw W;
          }
        } };
      }
      function aa(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      function Yf(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function Xf(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? Yf(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = function(Fe) {
                return Fe = function(Je, pt) {
                  if (Xt(Je) != "object" || !Je) return Je;
                  var Nt = Je[Symbol.toPrimitive];
                  if (Nt === void 0) return (pt === "string" ? String : Number)(Je);
                  if (Xt(pt = Nt.call(Je, pt || "default")) != "object") return pt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(Fe, "string"), Xt(Fe) == "symbol" ? Fe : String(Fe);
              }(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : Yf(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      var Lc = /* @__PURE__ */ new Set([ht.AREA, ht.BASE, ht.BASEFONT, ht.BGSOUND, ht.BR, ht.COL, ht.EMBED, ht.FRAME, ht.HR, ht.IMG, ht.INPUT, ht.KEYGEN, ht.LINK, ht.META, ht.PARAM, ht.SOURCE, ht.TRACK, ht.WBR]), Va = { treeAdapter: Bl, scriptingEnabled: !0 };
      function zl(M, O) {
        return O.treeAdapter.isElementNode(M) ? function(R, W) {
          var ue = W.treeAdapter.getTagName(R);
          return "<".concat(ue).concat(function(Ae, Ne) {
            var Fe, ut = "", Je = ba((Ne = Ne.treeAdapter).getAttrList(Ae));
            try {
              for (Je.s(); !(Fe = Je.n()).done; ) {
                var pt = Fe.value;
                if (ut += " ", pt.namespace) switch (pt.namespace) {
                  case Tt.XML:
                    ut += "xml:".concat(pt.name);
                    break;
                  case Tt.XMLNS:
                    pt.name !== "xmlns" && (ut += "xmlns:"), ut += pt.name;
                    break;
                  case Tt.XLINK:
                    ut += "xlink:".concat(pt.name);
                    break;
                  default:
                    ut += "".concat(pt.prefix, ":").concat(pt.name);
                }
                else ut += pt.name;
                ut += '="'.concat(Object(Bi.escapeAttribute)(pt.value), '"');
              }
            } catch (Nt) {
              Je.e(Nt);
            } finally {
              Je.f();
            }
            return ut;
          }(R, W), ">").concat(function(Ae, Ne) {
            return Ne.treeAdapter.isElementNode(Ae) && Ne.treeAdapter.getNamespaceURI(Ae) === Tt.HTML && Lc.has(Ne.treeAdapter.getTagName(Ae));
          }(R, W) ? "" : "".concat(function(ut, Ne) {
            var Fe = "", ut = Ne.treeAdapter.isElementNode(ut) && Ne.treeAdapter.getTagName(ut) === ht.TEMPLATE && Ne.treeAdapter.getNamespaceURI(ut) === Tt.HTML ? Ne.treeAdapter.getTemplateContent(ut) : ut;
            if (ut = Ne.treeAdapter.getChildNodes(ut)) {
              var Je, pt = ba(ut);
              try {
                for (pt.s(); !(Je = pt.n()).done; ) Fe += zl(Je.value, Ne);
              } catch (Nt) {
                pt.e(Nt);
              } finally {
                pt.f();
              }
            }
            return Fe;
          }(R, W), "</").concat(ue, ">"));
        }(M, O) : O.treeAdapter.isTextNode(M) ? function(R, W) {
          var ue = W.treeAdapter, me = ue.getTextNodeContent(R), Ae = ue.getParentNode(R);
          return (R = Ae && ue.isElementNode(Ae) && ue.getTagName(Ae)) && ue.getNamespaceURI(Ae) === Tt.HTML && jf(R, W.scriptingEnabled) ? me : Object(Bi.escapeText)(me);
        }(M, O) : O.treeAdapter.isCommentNode(M) ? function(R, W) {
          return W = W.treeAdapter, "<!--".concat(W.getCommentNodeContent(R), "-->");
        }(M, O) : O.treeAdapter.isDocumentTypeNode(M) ? function(R, W) {
          return W = W.treeAdapter, "<!DOCTYPE ".concat(W.getDocumentTypeNodeName(R), ">");
        }(M, O) : "";
      }
      function mi(M) {
        return (mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function _p(M, O) {
        var w, R = Object.keys(M);
        return Object.getOwnPropertySymbols && (w = Object.getOwnPropertySymbols(M), O && (w = w.filter(function(W) {
          return Object.getOwnPropertyDescriptor(M, W).enumerable;
        })), R.push.apply(R, w)), R;
      }
      function Ns(M) {
        for (var O = 1; O < arguments.length; O++) {
          var w = arguments[O] != null ? arguments[O] : {};
          O % 2 ? _p(Object(w), !0).forEach(function(R) {
            (function(ue, me, Ae) {
              (me = function(Fe) {
                return Fe = function(Je, pt) {
                  if (mi(Je) != "object" || !Je) return Je;
                  var Nt = Je[Symbol.toPrimitive];
                  if (Nt === void 0) return (pt === "string" ? String : Number)(Je);
                  if (mi(pt = Nt.call(Je, pt || "default")) != "object") return pt;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(Fe, "string"), mi(Fe) == "symbol" ? Fe : String(Fe);
              }(me)) in ue ? Object.defineProperty(ue, me, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : ue[me] = Ae;
            })(M, R, w[R]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(w)) : _p(Object(w)).forEach(function(R) {
            Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(w, R));
          });
        }
        return M;
      }
      function ml(M) {
        return new Y.f(M);
      }
      function jd(M) {
        var O = M.includes('"') ? "'" : '"';
        return O + M + O;
      }
      var us = { isCommentNode: Y.j, isElementNode: Y.m, isTextNode: Y.n, createDocument: function() {
        var O = new Y.b([]);
        return O["x-mode"] = d.DOCUMENT_MODE.NO_QUIRKS, O;
      }, createDocumentFragment: function() {
        return new Y.b([]);
      }, createElement: function(O, w, R) {
        for (var W = /* @__PURE__ */ Object.create(null), ue = /* @__PURE__ */ Object.create(null), me = /* @__PURE__ */ Object.create(null), Ae = 0; Ae < R.length; Ae++) {
          var Ne = R[Ae].name;
          W[Ne] = R[Ae].value, ue[Ne] = R[Ae].namespace, me[Ne] = R[Ae].prefix;
        }
        return (O = new Y.d(O, W, [])).namespace = w, O["x-attribsNamespace"] = ue, O["x-attribsPrefix"] = me, O;
      }, createCommentNode: function(O) {
        return new Y.a(O);
      }, appendChild: function(O, w) {
        var R = O.children[O.children.length - 1];
        R && ((R.next = w).prev = R), O.children.push(w), w.parent = O;
      }, insertBefore: function(O, w, R) {
        var W = O.children.indexOf(R), ue = R.prev;
        ue && ((ue.next = w).prev = ue), (R.prev = w).next = R, O.children.splice(W, 0, w), w.parent = O;
      }, setTemplateContent: function(O, w) {
        us.appendChild(O, w);
      }, getTemplateContent: function(O) {
        return O.children[0];
      }, setDocumentType: function(O, w, R, W) {
        var ue = function(Ne, Fe, ut) {
          var Je = "!DOCTYPE ";
          return Ne && (Je += Ne), Fe ? Je += " PUBLIC ".concat(jd(Fe)) : ut && (Je += " SYSTEM"), ut && (Je += " ".concat(jd(ut))), Je;
        }(w, R, W), me = O.children.find(function(Ae) {
          return Object(Y.k)(Ae) && Ae.name === "!doctype";
        });
        me ? me.data = ue ?? null : (me = new Y.e("!doctype", ue), us.appendChild(O, me)), me["x-name"] = w ?? void 0, me["x-publicId"] = R ?? void 0, me["x-systemId"] = W ?? void 0;
      }, setDocumentMode: function(O, w) {
        O["x-mode"] = w;
      }, getDocumentMode: function(O) {
        return O["x-mode"];
      }, detachNode: function(O) {
        var w, R, W;
        O.parent && (w = O.parent.children.indexOf(O), R = O.prev, W = O.next, O.prev = null, O.next = null, R && (R.next = W), W && (W.prev = R), O.parent.children.splice(w, 1), O.parent = null);
      }, insertText: function(O, w) {
        var R = O.children[O.children.length - 1];
        R && Object(Y.n)(R) ? R.data += w : us.appendChild(O, ml(w));
      }, insertTextBefore: function(O, w, R) {
        var W = O.children[O.children.indexOf(R) - 1];
        W && Object(Y.n)(W) ? W.data += w : us.insertBefore(O, ml(w), R);
      }, adoptAttributes: function(O, w) {
        for (var R = 0; R < w.length; R++) {
          var W = w[R].name;
          O.attribs[W] === void 0 && (O.attribs[W] = w[R].value, O["x-attribsNamespace"][W] = w[R].namespace, O["x-attribsPrefix"][W] = w[R].prefix);
        }
      }, getFirstChild: function(O) {
        return O.children[0];
      }, getChildNodes: function(O) {
        return O.children;
      }, getParentNode: function(O) {
        return O.parent;
      }, getAttrList: function(O) {
        return O.attributes;
      }, getTagName: function(O) {
        return O.name;
      }, getNamespaceURI: function(O) {
        return O.namespace;
      }, getTextNodeContent: function(O) {
        return O.data;
      }, getCommentNodeContent: function(O) {
        return O.data;
      }, getDocumentTypeNodeName: function(O) {
        return (O = O["x-name"]) !== null && O !== void 0 ? O : "";
      }, getDocumentTypeNodePublicId: function(O) {
        return (O = O["x-publicId"]) !== null && O !== void 0 ? O : "";
      }, getDocumentTypeNodeSystemId: function(O) {
        return (O = O["x-systemId"]) !== null && O !== void 0 ? O : "";
      }, isDocumentTypeNode: function(O) {
        return Object(Y.k)(O) && O.name === "!doctype";
      }, setNodeSourceCodeLocation: function(O, w) {
        w && (O.startIndex = w.startOffset, O.endIndex = w.endOffset), O.sourceCodeLocation = w;
      }, getNodeSourceCodeLocation: function(O) {
        return O.sourceCodeLocation;
      }, updateNodeSourceCodeLocation: function(O, w) {
        w.endOffset != null && (O.endIndex = w.endOffset), O.sourceCodeLocation = Ns(Ns({}, O.sourceCodeLocation), w);
      } };
      function wo(M, O) {
        (O == null || O > M.length) && (O = M.length);
        for (var w = 0, R = new Array(O); w < O; w++) R[w] = M[w];
        return R;
      }
      var Vl = { treeAdapter: us };
      function Kf(M) {
        for (var O = ("length" in M) ? M : [M], w = 0; w < O.length; w += 1) {
          var R, W = O[w];
          Object(Y.l)(W) && (R = Array.prototype.splice).call.apply(R, [O, w, 1].concat(function(Ne) {
            return function(ut) {
              if (Array.isArray(ut)) return wo(ut);
            }(Ne) || function(ut) {
              if (typeof Symbol < "u" && ut[Symbol.iterator] != null || ut["@@iterator"] != null) return Array.from(ut);
            }(Ne) || function(ut, Je) {
              if (ut) {
                if (typeof ut == "string") return wo(ut, Je);
                var pt = Object.prototype.toString.call(ut).slice(8, -1);
                return (pt = pt === "Object" && ut.constructor ? ut.constructor.name : pt) === "Map" || pt === "Set" ? Array.from(ut) : pt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(pt) ? wo(ut, Je) : void 0;
              }
            }(Ne) || function() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }(W.children)));
        }
        for (var ue = "", me = 0; me < O.length; me += 1) ue += function(Ne, Fe) {
          return zl(Ne, Xf(Xf({}, Va), Fe));
        }(O[me], Vl);
        return ue;
      }
      var an, Lt, Is, Bd = r(96);
      function sa(M) {
        return (sa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function Mc(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, function(ue) {
            return ue = function(Ae, Ne) {
              if (sa(Ae) != "object" || !Ae) return Ae;
              var Fe = Ae[Symbol.toPrimitive];
              if (Fe === void 0) return (Ne === "string" ? String : Number)(Ae);
              if (sa(Ne = Fe.call(Ae, Ne || "default")) != "object") return Ne;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ue, "string"), sa(ue) == "symbol" ? ue : String(ue);
          }(R.key), R);
        }
      }
      function Ea(M) {
        return M === an.Space || M === an.NewLine || M === an.Tab || M === an.FormFeed || M === an.CarriageReturn;
      }
      function Ls(M) {
        return M === an.Slash || M === an.Gt || Ea(M);
      }
      function Qf(M) {
        return M >= an.Zero && M <= an.Nine;
      }
      (Ve = an = an || {})[Ve.Tab = 9] = "Tab", Ve[Ve.NewLine = 10] = "NewLine", Ve[Ve.FormFeed = 12] = "FormFeed", Ve[Ve.CarriageReturn = 13] = "CarriageReturn", Ve[Ve.Space = 32] = "Space", Ve[Ve.ExclamationMark = 33] = "ExclamationMark", Ve[Ve.Number = 35] = "Number", Ve[Ve.Amp = 38] = "Amp", Ve[Ve.SingleQuote = 39] = "SingleQuote", Ve[Ve.DoubleQuote = 34] = "DoubleQuote", Ve[Ve.Dash = 45] = "Dash", Ve[Ve.Slash = 47] = "Slash", Ve[Ve.Zero = 48] = "Zero", Ve[Ve.Nine = 57] = "Nine", Ve[Ve.Semi = 59] = "Semi", Ve[Ve.Lt = 60] = "Lt", Ve[Ve.Eq = 61] = "Eq", Ve[Ve.Gt = 62] = "Gt", Ve[Ve.Questionmark = 63] = "Questionmark", Ve[Ve.UpperA = 65] = "UpperA", Ve[Ve.LowerA = 97] = "LowerA", Ve[Ve.UpperF = 70] = "UpperF", Ve[Ve.LowerF = 102] = "LowerF", Ve[Ve.UpperZ = 90] = "UpperZ", Ve[Ve.LowerZ = 122] = "LowerZ", Ve[Ve.LowerX = 120] = "LowerX", Ve[Ve.OpeningSquareBracket = 91] = "OpeningSquareBracket", (De = Lt = Lt || {})[De.Text = 1] = "Text", De[De.BeforeTagName = 2] = "BeforeTagName", De[De.InTagName = 3] = "InTagName", De[De.InSelfClosingTag = 4] = "InSelfClosingTag", De[De.BeforeClosingTagName = 5] = "BeforeClosingTagName", De[De.InClosingTagName = 6] = "InClosingTagName", De[De.AfterClosingTagName = 7] = "AfterClosingTagName", De[De.BeforeAttributeName = 8] = "BeforeAttributeName", De[De.InAttributeName = 9] = "InAttributeName", De[De.AfterAttributeName = 10] = "AfterAttributeName", De[De.BeforeAttributeValue = 11] = "BeforeAttributeValue", De[De.InAttributeValueDq = 12] = "InAttributeValueDq", De[De.InAttributeValueSq = 13] = "InAttributeValueSq", De[De.InAttributeValueNq = 14] = "InAttributeValueNq", De[De.BeforeDeclaration = 15] = "BeforeDeclaration", De[De.InDeclaration = 16] = "InDeclaration", De[De.InProcessingInstruction = 17] = "InProcessingInstruction", De[De.BeforeComment = 18] = "BeforeComment", De[De.CDATASequence = 19] = "CDATASequence", De[De.InSpecialComment = 20] = "InSpecialComment", De[De.InCommentLike = 21] = "InCommentLike", De[De.BeforeSpecialS = 22] = "BeforeSpecialS", De[De.SpecialStartSequence = 23] = "SpecialStartSequence", De[De.InSpecialTag = 24] = "InSpecialTag", De[De.BeforeEntity = 25] = "BeforeEntity", De[De.BeforeNumericEntity = 26] = "BeforeNumericEntity", De[De.InNamedEntity = 27] = "InNamedEntity", De[De.InNumericEntity = 28] = "InNumericEntity", De[De.InHexEntity = 29] = "InHexEntity", (ct = Is = {})[ct.NoValue = 0] = "NoValue", ct[ct.Unquoted = 1] = "Unquoted", ct[ct.Single = 2] = "Single", ct[ct.Double = 3] = "Double";
      var Gi = { Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]), CdataEnd: new Uint8Array([93, 93, 62]), CommentEnd: new Uint8Array([45, 45, 62]), ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]), StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]), TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]) }, zm = function() {
        function M(W, w) {
          var R = (R = W.xmlMode) !== void 0 && R, W = (W = W.decodeEntities) === void 0 || W;
          (function(me, Ae) {
            if (!(me instanceof Ae)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.cbs = w, this.state = Lt.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = Lt.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = R, this.decodeEntities = W, this.entityTrie = R ? ji.xmlDecodeTree : ji.htmlDecodeTree;
        }
        return function(w, R, W) {
          R && Mc(w.prototype, R), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "reset", value: function() {
          this.state = Lt.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = Lt.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        } }, { key: "write", value: function(w) {
          this.offset += this.buffer.length, this.buffer = w, this.parse();
        } }, { key: "end", value: function() {
          this.running && this.finish();
        } }, { key: "pause", value: function() {
          this.running = !1;
        } }, { key: "resume", value: function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        } }, { key: "getIndex", value: function() {
          return this.index;
        } }, { key: "getSectionStart", value: function() {
          return this.sectionStart;
        } }, { key: "stateText", value: function(w) {
          w === an.Lt || !this.decodeEntities && this.fastForwardTo(an.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = Lt.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && w === an.Amp && (this.state = Lt.BeforeEntity);
        } }, { key: "stateSpecialStartSequence", value: function(w) {
          var R = this.sequenceIndex === this.currentSequence.length;
          if (R ? Ls(w) : (32 | w) === this.currentSequence[this.sequenceIndex]) {
            if (!R) return void this.sequenceIndex++;
          } else this.isSpecial = !1;
          this.sequenceIndex = 0, this.state = Lt.InTagName, this.stateInTagName(w);
        } }, { key: "stateInSpecialTag", value: function(w) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (w === an.Gt || Ea(w)) {
              var R, W = this.index - this.currentSequence.length;
              return this.sectionStart < W && (R = this.index, this.index = W, this.cbs.ontext(this.sectionStart, W), this.index = R), this.isSpecial = !1, this.sectionStart = 2 + W, void this.stateInClosingTagName(w);
            }
            this.sequenceIndex = 0;
          }
          (32 | w) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === Gi.TitleEnd ? this.decodeEntities && w === an.Amp && (this.state = Lt.BeforeEntity) : this.fastForwardTo(an.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(w === an.Lt);
        } }, { key: "stateCDATASequence", value: function(w) {
          w === Gi.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === Gi.Cdata.length && (this.state = Lt.InCommentLike, this.currentSequence = Gi.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = Lt.InDeclaration, this.stateInDeclaration(w));
        } }, { key: "fastForwardTo", value: function(w) {
          for (; ++this.index < this.buffer.length + this.offset; ) if (this.buffer.charCodeAt(this.index - this.offset) === w) return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        } }, { key: "stateInCommentLike", value: function(w) {
          w === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === Gi.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = Lt.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : w !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        } }, { key: "isTagStartChar", value: function(w) {
          return this.xmlMode ? !Ls(w) : function(W) {
            return W >= an.LowerA && W <= an.LowerZ || W >= an.UpperA && W <= an.UpperZ;
          }(w);
        } }, { key: "startSpecial", value: function(w, R) {
          this.isSpecial = !0, this.currentSequence = w, this.sequenceIndex = R, this.state = Lt.SpecialStartSequence;
        } }, { key: "stateBeforeTagName", value: function(w) {
          var R;
          w === an.ExclamationMark ? (this.state = Lt.BeforeDeclaration, this.sectionStart = this.index + 1) : w === an.Questionmark ? (this.state = Lt.InProcessingInstruction, this.sectionStart = this.index + 1) : this.isTagStartChar(w) ? (R = 32 | w, this.sectionStart = this.index, this.xmlMode || R !== Gi.TitleEnd[2] ? this.state = this.xmlMode || R !== Gi.ScriptEnd[2] ? Lt.InTagName : Lt.BeforeSpecialS : this.startSpecial(Gi.TitleEnd, 3)) : w === an.Slash ? this.state = Lt.BeforeClosingTagName : (this.state = Lt.Text, this.stateText(w));
        } }, { key: "stateInTagName", value: function(w) {
          Ls(w) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = Lt.BeforeAttributeName, this.stateBeforeAttributeName(w));
        } }, { key: "stateBeforeClosingTagName", value: function(w) {
          Ea(w) || (w === an.Gt ? this.state = Lt.Text : (this.state = this.isTagStartChar(w) ? Lt.InClosingTagName : Lt.InSpecialComment, this.sectionStart = this.index));
        } }, { key: "stateInClosingTagName", value: function(w) {
          w !== an.Gt && !Ea(w) || (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = Lt.AfterClosingTagName, this.stateAfterClosingTagName(w));
        } }, { key: "stateAfterClosingTagName", value: function(w) {
          w !== an.Gt && !this.fastForwardTo(an.Gt) || (this.state = Lt.Text, this.baseState = Lt.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateBeforeAttributeName", value: function(w) {
          w === an.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = Lt.InSpecialTag, this.sequenceIndex = 0) : this.state = Lt.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : w === an.Slash ? this.state = Lt.InSelfClosingTag : Ea(w) || (this.state = Lt.InAttributeName, this.sectionStart = this.index);
        } }, { key: "stateInSelfClosingTag", value: function(w) {
          w === an.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = Lt.Text, this.baseState = Lt.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : Ea(w) || (this.state = Lt.BeforeAttributeName, this.stateBeforeAttributeName(w));
        } }, { key: "stateInAttributeName", value: function(w) {
          w !== an.Eq && !Ls(w) || (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = Lt.AfterAttributeName, this.stateAfterAttributeName(w));
        } }, { key: "stateAfterAttributeName", value: function(w) {
          w === an.Eq ? this.state = Lt.BeforeAttributeValue : w === an.Slash || w === an.Gt ? (this.cbs.onattribend(Is.NoValue, this.index), this.state = Lt.BeforeAttributeName, this.stateBeforeAttributeName(w)) : Ea(w) || (this.cbs.onattribend(Is.NoValue, this.index), this.state = Lt.InAttributeName, this.sectionStart = this.index);
        } }, { key: "stateBeforeAttributeValue", value: function(w) {
          w === an.DoubleQuote ? (this.state = Lt.InAttributeValueDq, this.sectionStart = this.index + 1) : w === an.SingleQuote ? (this.state = Lt.InAttributeValueSq, this.sectionStart = this.index + 1) : Ea(w) || (this.sectionStart = this.index, this.state = Lt.InAttributeValueNq, this.stateInAttributeValueNoQuotes(w));
        } }, { key: "handleInAttributeValue", value: function(w, R) {
          w === R || !this.decodeEntities && this.fastForwardTo(R) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(R === an.DoubleQuote ? Is.Double : Is.Single, this.index), this.state = Lt.BeforeAttributeName) : this.decodeEntities && w === an.Amp && (this.baseState = this.state, this.state = Lt.BeforeEntity);
        } }, { key: "stateInAttributeValueDoubleQuotes", value: function(w) {
          this.handleInAttributeValue(w, an.DoubleQuote);
        } }, { key: "stateInAttributeValueSingleQuotes", value: function(w) {
          this.handleInAttributeValue(w, an.SingleQuote);
        } }, { key: "stateInAttributeValueNoQuotes", value: function(w) {
          Ea(w) || w === an.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(Is.Unquoted, this.index), this.state = Lt.BeforeAttributeName, this.stateBeforeAttributeName(w)) : this.decodeEntities && w === an.Amp && (this.baseState = this.state, this.state = Lt.BeforeEntity);
        } }, { key: "stateBeforeDeclaration", value: function(w) {
          w === an.OpeningSquareBracket ? (this.state = Lt.CDATASequence, this.sequenceIndex = 0) : this.state = w === an.Dash ? Lt.BeforeComment : Lt.InDeclaration;
        } }, { key: "stateInDeclaration", value: function(w) {
          w !== an.Gt && !this.fastForwardTo(an.Gt) || (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = Lt.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateInProcessingInstruction", value: function(w) {
          w !== an.Gt && !this.fastForwardTo(an.Gt) || (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = Lt.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateBeforeComment", value: function(w) {
          w === an.Dash ? (this.state = Lt.InCommentLike, this.currentSequence = Gi.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = Lt.InDeclaration;
        } }, { key: "stateInSpecialComment", value: function(w) {
          w !== an.Gt && !this.fastForwardTo(an.Gt) || (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = Lt.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateBeforeSpecialS", value: function(w) {
          var R = 32 | w;
          R === Gi.ScriptEnd[3] ? this.startSpecial(Gi.ScriptEnd, 4) : R === Gi.StyleEnd[3] ? this.startSpecial(Gi.StyleEnd, 4) : (this.state = Lt.InTagName, this.stateInTagName(w));
        } }, { key: "stateBeforeEntity", value: function(w) {
          this.entityExcess = 1, this.entityResult = 0, w === an.Number ? this.state = Lt.BeforeNumericEntity : w === an.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = Lt.InNamedEntity, this.stateInNamedEntity(w));
        } }, { key: "stateInNamedEntity", value: function(w) {
          if (this.entityExcess += 1, this.trieIndex = Object(ji.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, w), this.trieIndex < 0) return this.emitNamedEntity(), void this.index--;
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var R = this.trieCurrent & ji.BinTrieFlags.VALUE_LENGTH;
          R && (R = (R >> 14) - 1, this.allowLegacyEntity() || w === an.Semi ? ((w = this.index - this.entityExcess + 1) > this.sectionStart && this.emitPartial(this.sectionStart, w), this.entityResult = this.trieIndex, this.trieIndex += R, this.entityExcess = 0, this.sectionStart = this.index + 1, R == 0 && this.emitNamedEntity()) : this.trieIndex += R);
        } }, { key: "emitNamedEntity", value: function() {
          if (this.state = this.baseState, this.entityResult !== 0) switch ((this.entityTrie[this.entityResult] & ji.BinTrieFlags.VALUE_LENGTH) >> 14) {
            case 1:
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~ji.BinTrieFlags.VALUE_LENGTH);
              break;
            case 2:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        } }, { key: "stateBeforeNumericEntity", value: function(w) {
          (32 | w) === an.LowerX ? (this.entityExcess++, this.state = Lt.InHexEntity) : (this.state = Lt.InNumericEntity, this.stateInNumericEntity(w));
        } }, { key: "emitNumericEntity", value: function(w) {
          var R = this.index - this.entityExcess - 1;
          2 + R + +(this.state === Lt.InHexEntity) !== this.index && (R > this.sectionStart && this.emitPartial(this.sectionStart, R), this.sectionStart = this.index + Number(w), this.emitCodePoint(Object(ji.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        } }, { key: "stateInNumericEntity", value: function(w) {
          w === an.Semi ? this.emitNumericEntity(!0) : Qf(w) ? (this.entityResult = 10 * this.entityResult + (w - an.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        } }, { key: "stateInHexEntity", value: function(w) {
          w === an.Semi ? this.emitNumericEntity(!0) : Qf(w) ? (this.entityResult = 16 * this.entityResult + (w - an.Zero), this.entityExcess++) : function(W) {
            return W >= an.UpperA && W <= an.UpperF || W >= an.LowerA && W <= an.LowerF;
          }(w) ? (this.entityResult = 16 * this.entityResult + ((32 | w) - an.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        } }, { key: "allowLegacyEntity", value: function() {
          return !this.xmlMode && (this.baseState === Lt.Text || this.baseState === Lt.InSpecialTag);
        } }, { key: "cleanup", value: function() {
          this.running && this.sectionStart !== this.index && (this.state === Lt.Text || this.state === Lt.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : this.state !== Lt.InAttributeValueDq && this.state !== Lt.InAttributeValueSq && this.state !== Lt.InAttributeValueNq || (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        } }, { key: "shouldContinue", value: function() {
          return this.index < this.buffer.length + this.offset && this.running;
        } }, { key: "parse", value: function() {
          for (; this.shouldContinue(); ) {
            var w = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case Lt.Text:
                this.stateText(w);
                break;
              case Lt.SpecialStartSequence:
                this.stateSpecialStartSequence(w);
                break;
              case Lt.InSpecialTag:
                this.stateInSpecialTag(w);
                break;
              case Lt.CDATASequence:
                this.stateCDATASequence(w);
                break;
              case Lt.InAttributeValueDq:
                this.stateInAttributeValueDoubleQuotes(w);
                break;
              case Lt.InAttributeName:
                this.stateInAttributeName(w);
                break;
              case Lt.InCommentLike:
                this.stateInCommentLike(w);
                break;
              case Lt.InSpecialComment:
                this.stateInSpecialComment(w);
                break;
              case Lt.BeforeAttributeName:
                this.stateBeforeAttributeName(w);
                break;
              case Lt.InTagName:
                this.stateInTagName(w);
                break;
              case Lt.InClosingTagName:
                this.stateInClosingTagName(w);
                break;
              case Lt.BeforeTagName:
                this.stateBeforeTagName(w);
                break;
              case Lt.AfterAttributeName:
                this.stateAfterAttributeName(w);
                break;
              case Lt.InAttributeValueSq:
                this.stateInAttributeValueSingleQuotes(w);
                break;
              case Lt.BeforeAttributeValue:
                this.stateBeforeAttributeValue(w);
                break;
              case Lt.BeforeClosingTagName:
                this.stateBeforeClosingTagName(w);
                break;
              case Lt.AfterClosingTagName:
                this.stateAfterClosingTagName(w);
                break;
              case Lt.BeforeSpecialS:
                this.stateBeforeSpecialS(w);
                break;
              case Lt.InAttributeValueNq:
                this.stateInAttributeValueNoQuotes(w);
                break;
              case Lt.InSelfClosingTag:
                this.stateInSelfClosingTag(w);
                break;
              case Lt.InDeclaration:
                this.stateInDeclaration(w);
                break;
              case Lt.BeforeDeclaration:
                this.stateBeforeDeclaration(w);
                break;
              case Lt.BeforeComment:
                this.stateBeforeComment(w);
                break;
              case Lt.InProcessingInstruction:
                this.stateInProcessingInstruction(w);
                break;
              case Lt.InNamedEntity:
                this.stateInNamedEntity(w);
                break;
              case Lt.BeforeEntity:
                this.stateBeforeEntity(w);
                break;
              case Lt.InHexEntity:
                this.stateInHexEntity(w);
                break;
              case Lt.InNumericEntity:
                this.stateInNumericEntity(w);
                break;
              default:
                this.stateBeforeNumericEntity(w);
            }
            this.index++;
          }
          this.cleanup();
        } }, { key: "finish", value: function() {
          this.state === Lt.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        } }, { key: "handleTrailingData", value: function() {
          var w = this.buffer.length + this.offset;
          this.state === Lt.InCommentLike ? this.currentSequence === Gi.CdataEnd ? this.cbs.oncdata(this.sectionStart, w, 0) : this.cbs.oncomment(this.sectionStart, w, 0) : this.state === Lt.InNumericEntity && this.allowLegacyEntity() || this.state === Lt.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === Lt.InTagName || this.state === Lt.BeforeAttributeName || this.state === Lt.BeforeAttributeValue || this.state === Lt.AfterAttributeName || this.state === Lt.InAttributeName || this.state === Lt.InAttributeValueSq || this.state === Lt.InAttributeValueDq || this.state === Lt.InAttributeValueNq || this.state === Lt.InClosingTagName || this.cbs.ontext(this.sectionStart, w);
        } }, { key: "emitPartial", value: function(w, R) {
          this.baseState !== Lt.Text && this.baseState !== Lt.InSpecialTag ? this.cbs.onattribdata(w, R) : this.cbs.ontext(w, R);
        } }, { key: "emitCodePoint", value: function(w) {
          this.baseState !== Lt.Text && this.baseState !== Lt.InSpecialTag ? this.cbs.onattribentity(w) : this.cbs.ontextentity(w);
        } }]), M;
      }();
      function Pc(M) {
        return (Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
          return typeof O;
        } : function(O) {
          return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
        })(M);
      }
      function ci(M, O) {
        for (var w = 0; w < O.length; w++) {
          var R = O[w];
          R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, function(ue) {
            return ue = function(Ae, Ne) {
              if (Pc(Ae) != "object" || !Ae) return Ae;
              var Fe = Ae[Symbol.toPrimitive];
              if (Fe === void 0) return (Ne === "string" ? String : Number)(Ae);
              if (Pc(Ne = Fe.call(Ae, Ne || "default")) != "object") return Ne;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ue, "string"), Pc(ue) == "symbol" ? ue : String(ue);
          }(R.key), R);
        }
      }
      var Xr = /* @__PURE__ */ new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]), yt = /* @__PURE__ */ new Set(["p"]), Ve = /* @__PURE__ */ new Set(["thead", "tbody"]), De = /* @__PURE__ */ new Set(["dd", "dt"]), ct = /* @__PURE__ */ new Set(["rt", "rp"]), vn = /* @__PURE__ */ new Map([["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])], ["th", /* @__PURE__ */ new Set(["th"])], ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])], ["body", /* @__PURE__ */ new Set(["head", "link", "script"])], ["li", /* @__PURE__ */ new Set(["li"])], ["p", yt], ["h1", yt], ["h2", yt], ["h3", yt], ["h4", yt], ["h5", yt], ["h6", yt], ["select", Xr], ["input", Xr], ["output", Xr], ["button", Xr], ["datalist", Xr], ["textarea", Xr], ["option", /* @__PURE__ */ new Set(["option"])], ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])], ["dd", De], ["dt", De], ["address", yt], ["article", yt], ["aside", yt], ["blockquote", yt], ["details", yt], ["div", yt], ["dl", yt], ["fieldset", yt], ["figcaption", yt], ["figure", yt], ["footer", yt], ["form", yt], ["header", yt], ["hr", yt], ["main", yt], ["nav", yt], ["ol", yt], ["pre", yt], ["section", yt], ["table", yt], ["ul", yt], ["rt", ct], ["rp", ct], ["tbody", Ve], ["tfoot", Ve]]), Sn = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]), Un = /* @__PURE__ */ new Set(["math", "svg"]), lr = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]), Sa = /\s|\//, jc = function() {
        function M(O) {
          var w = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
          (function(W, ue) {
            if (!(W instanceof ue)) throw new TypeError("Cannot call a class as a function");
          })(this, M), this.options = w, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = O ?? {}, this.lowerCaseTagNames = (O = w.lowerCaseTags) !== null && O !== void 0 ? O : !w.xmlMode, this.lowerCaseAttributeNames = (O = w.lowerCaseAttributeNames) !== null && O !== void 0 ? O : !w.xmlMode, this.tokenizer = new ((O = w.Tokenizer) !== null && O !== void 0 ? O : zm)(this.options, this), (O = (w = this.cbs).onparserinit) !== null && O !== void 0 && O.call(w, this);
        }
        return function(w, R, W) {
          R && ci(w.prototype, R), Object.defineProperty(w, "prototype", { writable: !1 });
        }(M, [{ key: "ontext", value: function(w, R) {
          var W, ue = this.getSlice(w, R);
          this.endIndex = R - 1, (w = (W = this.cbs).ontext) !== null && w !== void 0 && w.call(W, ue), this.startIndex = R;
        } }, { key: "ontextentity", value: function(w) {
          var R, W, ue = this.tokenizer.getSectionStart();
          this.endIndex = ue - 1, (W = (R = this.cbs).ontext) !== null && W !== void 0 && W.call(R, Object(ji.fromCodePoint)(w)), this.startIndex = ue;
        } }, { key: "isVoidElement", value: function(w) {
          return !this.options.xmlMode && Sn.has(w);
        } }, { key: "onopentagname", value: function(w, R) {
          this.endIndex = R, R = this.getSlice(w, R), this.lowerCaseTagNames && (R = R.toLowerCase()), this.emitOpenTag(R);
        } }, { key: "emitOpenTag", value: function(w) {
          var R, W, ue, me;
          this.openTagStart = this.startIndex, this.tagname = w;
          var Ae = !this.options.xmlMode && vn.get(w);
          if (Ae) for (; 0 < this.stack.length && Ae.has(this.stack[this.stack.length - 1]); ) {
            var Ne = this.stack.pop();
            (W = (R = this.cbs).onclosetag) !== null && W !== void 0 && W.call(R, Ne, !0);
          }
          this.isVoidElement(w) || (this.stack.push(w), Un.has(w) ? this.foreignContext.push(!0) : lr.has(w) && this.foreignContext.push(!1)), (me = (ue = this.cbs).onopentagname) !== null && me !== void 0 && me.call(ue, w), this.cbs.onopentag && (this.attribs = {});
        } }, { key: "endOpenTag", value: function(w) {
          var R, W;
          this.startIndex = this.openTagStart, this.attribs && ((W = (R = this.cbs).onopentag) !== null && W !== void 0 && W.call(R, this.tagname, this.attribs, w), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
        } }, { key: "onopentagend", value: function(w) {
          this.endIndex = w, this.endOpenTag(!1), this.startIndex = w + 1;
        } }, { key: "onclosetag", value: function(w, R) {
          this.endIndex = R;
          var W = this.getSlice(w, R);
          if (this.lowerCaseTagNames && (W = W.toLowerCase()), (Un.has(W) || lr.has(W)) && this.foreignContext.pop(), this.isVoidElement(W)) this.options.xmlMode || W !== "br" || ((w = (ue = this.cbs).onopentagname) !== null && w !== void 0 && w.call(ue, "br"), (ue = (w = this.cbs).onopentag) !== null && ue !== void 0 && ue.call(w, "br", {}, !0), (w = (ue = this.cbs).onclosetag) !== null && w !== void 0 && w.call(ue, "br", !1));
          else {
            var ue = this.stack.lastIndexOf(W);
            if (ue !== -1) if (this.cbs.onclosetag) for (var me = this.stack.length - ue; me--; ) this.cbs.onclosetag(this.stack.pop(), me !== 0);
            else this.stack.length = ue;
            else this.options.xmlMode || W !== "p" || (this.emitOpenTag("p"), this.closeCurrentTag(!0));
          }
          this.startIndex = R + 1;
        } }, { key: "onselfclosingtag", value: function(w) {
          this.endIndex = w, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = w + 1) : this.onopentagend(w);
        } }, { key: "closeCurrentTag", value: function(w) {
          var R, W, ue = this.tagname;
          this.endOpenTag(w), this.stack[this.stack.length - 1] === ue && ((W = (R = this.cbs).onclosetag) !== null && W !== void 0 && W.call(R, ue, !w), this.stack.pop());
        } }, { key: "onattribname", value: function(w, R) {
          this.startIndex = w, R = this.getSlice(w, R), this.attribname = this.lowerCaseAttributeNames ? R.toLowerCase() : R;
        } }, { key: "onattribdata", value: function(w, R) {
          this.attribvalue += this.getSlice(w, R);
        } }, { key: "onattribentity", value: function(w) {
          this.attribvalue += Object(ji.fromCodePoint)(w);
        } }, { key: "onattribend", value: function(w, R) {
          var W;
          this.endIndex = R, (R = (W = this.cbs).onattribute) !== null && R !== void 0 && R.call(W, this.attribname, this.attribvalue, w === Is.Double ? '"' : w === Is.Single ? "'" : w === Is.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
        } }, { key: "getInstructionName", value: function(w) {
          var R = (R = w.search(Sa)) < 0 ? w : w.substr(0, R);
          return this.lowerCaseTagNames ? R.toLowerCase() : R;
        } }, { key: "ondeclaration", value: function(w, R) {
          this.endIndex = R;
          var W = this.getSlice(w, R);
          this.cbs.onprocessinginstruction && (w = this.getInstructionName(W), this.cbs.onprocessinginstruction("!".concat(w), "!".concat(W))), this.startIndex = R + 1;
        } }, { key: "onprocessinginstruction", value: function(w, R) {
          this.endIndex = R;
          var W = this.getSlice(w, R);
          this.cbs.onprocessinginstruction && (w = this.getInstructionName(W), this.cbs.onprocessinginstruction("?".concat(w), "?".concat(W))), this.startIndex = R + 1;
        } }, { key: "oncomment", value: function(w, R, W) {
          var ue, me;
          this.endIndex = R, (me = (ue = this.cbs).oncomment) !== null && me !== void 0 && me.call(ue, this.getSlice(w, R - W)), (W = (w = this.cbs).oncommentend) !== null && W !== void 0 && W.call(w), this.startIndex = R + 1;
        } }, { key: "oncdata", value: function(w, R, W) {
          var ue, me;
          this.endIndex = R, W = this.getSlice(w, R - W), this.options.xmlMode || this.options.recognizeCDATA ? ((me = (ue = this.cbs).oncdatastart) !== null && me !== void 0 && me.call(ue), (ue = (me = this.cbs).ontext) !== null && ue !== void 0 && ue.call(me, W), (me = (ue = this.cbs).oncdataend) !== null && me !== void 0 && me.call(ue)) : ((ue = (me = this.cbs).oncomment) !== null && ue !== void 0 && ue.call(me, "[CDATA[".concat(W, "]]")), (W = (me = this.cbs).oncommentend) !== null && W !== void 0 && W.call(me)), this.startIndex = R + 1;
        } }, { key: "onend", value: function() {
          var w, R;
          if (this.cbs.onclosetag) {
            this.endIndex = this.startIndex;
            for (var W = this.stack.length; 0 < W; this.cbs.onclosetag(this.stack[--W], !0)) ;
          }
          (R = (w = this.cbs).onend) !== null && R !== void 0 && R.call(w);
        } }, { key: "reset", value: function() {
          var w, R;
          (w = (R = this.cbs).onreset) !== null && w !== void 0 && w.call(R), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (R = (w = this.cbs).onparserinit) !== null && R !== void 0 && R.call(w, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
        } }, { key: "parseComplete", value: function(w) {
          this.reset(), this.end(w);
        } }, { key: "getSlice", value: function(w, R) {
          for (; w - this.bufferOffset >= this.buffers[0].length; ) this.shiftBuffer();
          for (var W = this.buffers[0].slice(w - this.bufferOffset, R - this.bufferOffset); R - this.bufferOffset > this.buffers[0].length; ) this.shiftBuffer(), W += this.buffers[0].slice(0, R - this.bufferOffset);
          return W;
        } }, { key: "shiftBuffer", value: function() {
          this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
        } }, { key: "write", value: function(w) {
          var R, W;
          this.ended ? (W = (R = this.cbs).onerror) !== null && W !== void 0 && W.call(R, new Error(".write() after done!")) : (this.buffers.push(w), this.tokenizer.running && (this.tokenizer.write(w), this.writeIndex++));
        } }, { key: "end", value: function(w) {
          var R, W;
          this.ended ? (W = (R = this.cbs).onerror) !== null && W !== void 0 && W.call(R, new Error(".end() after done!")) : (w && this.write(w), this.ended = !0, this.tokenizer.end());
        } }, { key: "pause", value: function() {
          this.tokenizer.pause();
        } }, { key: "resume", value: function() {
          for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; ) this.tokenizer.write(this.buffers[this.writeIndex++]);
          this.ended && this.tokenizer.end();
        } }, { key: "parseChunk", value: function(w) {
          this.write(w);
        } }, { key: "done", value: function(w) {
          this.end(w);
        } }]), M;
      }();
      r(8);
      var Bc = /* @__PURE__ */ function(O, w) {
        return function R(W, ue) {
          var me = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2];
          if (W == null) throw new Error("cheerio.load() expects a string");
          var Ae = Cc(Cc({}, g), b(ue)), Ne = O(W, Ae, me, null), Fe = function() {
            function Je() {
              return function(Nt, Bt) {
                if (!(Nt instanceof Bt)) throw new TypeError("Cannot call a class as a function");
              }(this, Je), function(Nt, Bt, Qt) {
                return Bt = Il(Bt), function(mn, kn) {
                  if (kn && (Sc(kn) === "object" || typeof kn == "function")) return kn;
                  if (kn !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                  return function(Dr) {
                    if (Dr !== void 0) return Dr;
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  }(mn);
                }(Nt, Eu() ? Reflect.construct(Bt, Qt || [], Il(Nt).constructor) : Bt.apply(Nt, Qt));
              }(this, Je, arguments);
            }
            return function(Nt, Bt) {
              if (typeof Bt != "function" && Bt !== null) throw new TypeError("Super expression must either be null or a function");
              Nt.prototype = Object.create(Bt && Bt.prototype, { constructor: { value: Nt, writable: !0, configurable: !0 } }), Object.defineProperty(Nt, "prototype", { writable: !1 }), Bt && Su(Nt, Bt);
            }(Je, al), function(Nt, Bt, Qt) {
              Bt && Cd(Nt.prototype, Bt), Object.defineProperty(Nt, "prototype", { writable: !1 });
            }(Je, [{ key: "_make", value: function(Nt, Bt) {
              return (Bt = ut(Nt, Bt)).prevObject = this, Bt;
            } }, { key: "_parse", value: function(Nt, Bt, Qt, Cn) {
              return O(Nt, Bt, Qt, Cn);
            } }, { key: "_render", value: function(Nt) {
              return w(Nt, this.options);
            } }]), Je;
          }();
          function ut(Je, pt) {
            var Nt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : Ne, Bt = 3 < arguments.length ? arguments[3] : void 0;
            if (Je && ie(Je)) return Je;
            var Qt = Cc(Cc({}, Ae), b(Bt)), Cn = typeof Nt == "string" ? [O(Nt, Qt, !1, null)] : "length" in Nt ? Nt : [Nt];
            if ((Bt = ie(Cn) ? Cn : new Fe(Cn, null, Qt))._root = Bt, !Je) return new Fe(void 0, Bt, Qt);
            if (Nt = typeof Je == "string" && te(Je) ? O(Je, Qt, !1, null).children : function(kn) {
              return kn.name || kn.type === "root" || kn.type === "text" || kn.type === "comment";
            }(Je) ? [Je] : Array.isArray(Je) ? Je : void 0, Cn = new Fe(Nt, Bt, Qt), Nt) return Cn;
            if (typeof Je != "string") throw new Error("Unexpected type of selector");
            return (Bt = pt ? typeof pt == "string" ? te(pt) ? new Fe([O(pt, Qt, !1, null)], Bt, Qt) : (Je = "".concat(pt, " ").concat(Je), Bt) : ie(pt) ? pt : new Fe(Array.isArray(pt) ? pt : [pt], Bt, Qt) : Bt) ? Bt.find(Je) : Cn;
          }
          return Object.assign(ut, l, { load: R, _root: Ne, _options: Ae, fn: Fe.prototype, prototype: Fe.prototype }), ut;
        };
      }(Object(Ts.a)(function(M, O, w, R) {
        return O.xmlMode || O._useHtmlParser2 ? function(ue, me) {
          var Ae = new Y.c(void 0, me);
          return new jc(Ae, me).end(ue), Ae.root;
        }(M, O) : function(ue, me, Ae, Ne) {
          return me = { scriptingEnabled: typeof me.scriptingEnabled != "boolean" || me.scriptingEnabled, treeAdapter: us, sourceCodeLocationInfo: me.sourceCodeLocationInfo }, Ae ? function(ut, Je) {
            return dl.parse(ut, Je);
          }(ue, me) : function(ut, Je, pt) {
            return typeof ut == "string" && (pt = Je, Je = ut, ut = null), (pt = dl.getFragmentParser(ut, pt)).tokenizer.write(Je, !0), pt.getFragment();
          }(Ne, ue, me);
        }(M, O, w, R);
      }), function(M, O) {
        return O.xmlMode || O._useHtmlParser2 ? Object(Bd.a)(M, O) : Kf(M);
      }), A0 = (s.default = Bc([]), B), xo = U, Fd = j, jt = I;
    }, function(a, s, r) {
      a.exports = r(242);
    }, function(a, s, h) {
      var l = h(1).default, f = h(38).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = f(h(10)), f = h(93), h = l(h(556));
      (0, d.assignComponents)(d.components, h.default.components), (0, f.assignDependencies)(f.dependencies, h.default.dependencies), s.default = d.default, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(69).default;
      a.exports = function(f, h) {
        if (l(f) != "object" || !f) return f;
        var p = f[Symbol.toPrimitive];
        if (p === void 0) return (h === "string" ? String : Number)(f);
        if (h = p.call(f, h || "default"), l(h) != "object") return h;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(69).default, d = r(39);
      a.exports = function(h, p) {
        if (p && (l(p) === "object" || typeof p == "function")) return p;
        if (p !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return d(h);
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(150), d = r(97), f = r(246), h = r(247);
      function p(g) {
        var _ = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
        return a.exports = p = function(v) {
          if (v === null || !f(v)) return v;
          if (typeof v != "function") throw new TypeError("Super expression must either be null or a function");
          if (_ !== void 0) {
            if (_.has(v)) return _.get(v);
            _.set(v, E);
          }
          function E() {
            return h(v, arguments, l(this).constructor);
          }
          return E.prototype = Object.create(v.prototype, { constructor: { value: E, enumerable: !1, writable: !0, configurable: !0 } }), d(E, v);
        }, a.exports.__esModule = !0, a.exports.default = a.exports, p(g);
      }
      a.exports = p, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s) {
      a.exports = function(l) {
        try {
          return Function.toString.call(l).indexOf("[native code]") !== -1;
        } catch {
          return typeof l == "function";
        }
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      var l = r(97), d = r(151);
      a.exports = function(h, p, g) {
        if (d()) return Reflect.construct.apply(null, arguments);
        var _ = [null];
        return _.push.apply(_, p), _ = new (h.bind.apply(h, _))(), g && l(_, g.prototype), _;
      }, a.exports.__esModule = !0, a.exports.default = a.exports;
    }, function(a, s, r) {
      r = r(153)(Object.keys, Object), a.exports = r;
    }, function(a, s, r) {
      r = r(29)(r(17), "DataView"), a.exports = r;
    }, function(a, s, _) {
      var l = _(71), d = _(253), f = _(19), h = _(155), p = /^\[object .+?Constructor\]$/, g = Function.prototype, _ = Object.prototype, g = g.toString, _ = _.hasOwnProperty, b = RegExp("^" + g.call(_).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      a.exports = function(E) {
        return !(!f(E) || d(E)) && (l(E) ? b : p).test(h(E));
      };
    }, function(a, s, r) {
      var l = r(41), d = (r = Object.prototype).hasOwnProperty, f = r.toString, h = l ? l.toStringTag : void 0;
      a.exports = function(g) {
        var _ = d.call(g, h), b = g[h];
        try {
          var v = !(g[h] = void 0);
        } catch {
        }
        var E = f.call(g);
        return v && (_ ? g[h] = b : delete g[h]), E;
      };
    }, function(a, s) {
      var r = Object.prototype.toString;
      a.exports = function(d) {
        return r.call(d);
      };
    }, function(a, s, l) {
      var l = l(254), d = (l = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "")) ? "Symbol(src)_1." + l : "";
      a.exports = function(h) {
        return !!d && d in h;
      };
    }, function(a, s, r) {
      r = r(17)["__core-js_shared__"], a.exports = r;
    }, function(a, s) {
      a.exports = function(l, d) {
        return l == null ? void 0 : l[d];
      };
    }, function(a, s, r) {
      r = r(29)(r(17), "Promise"), a.exports = r;
    }, function(a, s, r) {
      r = r(29)(r(17), "Set"), a.exports = r;
    }, function(a, s, r) {
      var l = r(30), d = r(20);
      a.exports = function(h) {
        return d(h) && l(h) == "[object Arguments]";
      };
    }, function(a, s) {
      a.exports = function() {
        return !1;
      };
    }, function(a, s, r) {
      var l = r(30), d = r(100), f = r(20), h = {};
      h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h["[object Arguments]"] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h["[object Function]"] = h["[object Map]"] = h["[object Number]"] = h["[object Object]"] = h["[object RegExp]"] = h["[object Set]"] = h["[object String]"] = h["[object WeakMap]"] = !1, a.exports = function(g) {
        return f(g) && d(g.length) && !!h[l(g)];
      };
    }, function(a, s, r) {
      r = r(262)(), a.exports = r;
    }, function(a, s) {
      a.exports = function(l) {
        return function(d, f, h) {
          for (var p = -1, g = Object(d), _ = h(d), b = _.length; b--; ) {
            var v = _[l ? b : ++p];
            if (f(g[v], v, g) === !1) break;
          }
          return d;
        };
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = -1, h = Array(l); ++f < l; ) h[f] = d(f);
        return h;
      };
    }, function(a, s, r) {
      var l = r(31);
      a.exports = function(f, h) {
        return function(p, g) {
          if (p == null) return p;
          if (!l(p)) return f(p, g);
          for (var _ = p.length, b = h ? _ : -1, v = Object(p); (h ? b-- : ++b < _) && g(v[b], b, v) !== !1; ) ;
          return p;
        };
      };
    }, function(a, s, r) {
      var l = r(25);
      a.exports = function(f) {
        return typeof f == "function" ? f : l;
      };
    }, function(a, s, r) {
      var l = r(267), d = r(299), f = r(170);
      a.exports = function(p) {
        var g = d(p);
        return g.length == 1 && g[0][2] ? f(g[0][0], g[0][1]) : function(_) {
          return _ === p || l(_, p, g);
        };
      };
    }, function(a, s, r) {
      var l = r(104), d = r(161);
      a.exports = function(h, p, g, _) {
        var b = g.length, v = b, E = !_;
        if (h == null) return !v;
        for (h = Object(h); b--; ) {
          var C = g[b];
          if (E && C[2] ? C[1] !== h[C[0]] : !(C[0] in h)) return !1;
        }
        for (; ++b < v; ) {
          var y = (C = g[b])[0], T = h[y], A = C[1];
          if (E && C[2]) {
            if (T === void 0 && !(y in h)) return !1;
          } else {
            var k, N = new l();
            if (!((k = _ ? _(T, A, y, h, p, N) : k) === void 0 ? d(A, T, 3, _, N) : k)) return !1;
          }
        }
        return !0;
      };
    }, function(a, s) {
      a.exports = function() {
        this.__data__ = [], this.size = 0;
      };
    }, function(a, s, r) {
      var l = r(76), d = Array.prototype.splice;
      a.exports = function(h) {
        var p = this.__data__;
        return !((h = l(p, h)) < 0 || (h == p.length - 1 ? p.pop() : d.call(p, h, 1), --this.size, 0));
      };
    }, function(a, s, r) {
      var l = r(76);
      a.exports = function(f) {
        var h = this.__data__;
        return (f = l(h, f)) < 0 ? void 0 : h[f][1];
      };
    }, function(a, s, r) {
      var l = r(76);
      a.exports = function(f) {
        return -1 < l(this.__data__, f);
      };
    }, function(a, s, r) {
      var l = r(76);
      a.exports = function(f, h) {
        var p = this.__data__, g = l(p, f);
        return g < 0 ? (++this.size, p.push([f, h])) : p[g][1] = h, this;
      };
    }, function(a, s, r) {
      var l = r(75);
      a.exports = function() {
        this.__data__ = new l(), this.size = 0;
      };
    }, function(a, s) {
      a.exports = function(f) {
        var d = this.__data__, f = d.delete(f);
        return this.size = d.size, f;
      };
    }, function(a, s) {
      a.exports = function(l) {
        return this.__data__.get(l);
      };
    }, function(a, s) {
      a.exports = function(l) {
        return this.__data__.has(l);
      };
    }, function(a, s, r) {
      var l = r(75), d = r(99), f = r(105);
      a.exports = function(p, g) {
        var _ = this.__data__;
        if (_ instanceof l) {
          var b = _.__data__;
          if (!d || b.length < 199) return b.push([p, g]), this.size = ++_.size, this;
          _ = this.__data__ = new f(b);
        }
        return _.set(p, g), this.size = _.size, this;
      };
    }, function(a, s, r) {
      var l = r(279), d = r(75), f = r(99);
      a.exports = function() {
        this.size = 0, this.__data__ = { hash: new l(), map: new (f || d)(), string: new l() };
      };
    }, function(a, s, p) {
      var l = p(280), d = p(281), f = p(282), h = p(283), p = p(284);
      function g(_) {
        var b = -1, v = _ == null ? 0 : _.length;
        for (this.clear(); ++b < v; ) {
          var E = _[b];
          this.set(E[0], E[1]);
        }
      }
      g.prototype.clear = l, g.prototype.delete = d, g.prototype.get = f, g.prototype.has = h, g.prototype.set = p, a.exports = g;
    }, function(a, s, r) {
      var l = r(78);
      a.exports = function() {
        this.__data__ = l ? l(null) : {}, this.size = 0;
      };
    }, function(a, s) {
      a.exports = function(l) {
        return l = this.has(l) && delete this.__data__[l], this.size -= l ? 1 : 0, l;
      };
    }, function(a, s, r) {
      var l = r(78), d = Object.prototype.hasOwnProperty;
      a.exports = function(h) {
        var p = this.__data__;
        if (l) {
          var g = p[h];
          return g === "__lodash_hash_undefined__" ? void 0 : g;
        }
        return d.call(p, h) ? p[h] : void 0;
      };
    }, function(a, s, r) {
      var l = r(78), d = Object.prototype.hasOwnProperty;
      a.exports = function(h) {
        var p = this.__data__;
        return l ? p[h] !== void 0 : d.call(p, h);
      };
    }, function(a, s, r) {
      var l = r(78);
      a.exports = function(f, h) {
        var p = this.__data__;
        return this.size += this.has(f) ? 0 : 1, p[f] = l && h === void 0 ? "__lodash_hash_undefined__" : h, this;
      };
    }, function(a, s, r) {
      var l = r(79);
      a.exports = function(f) {
        return f = l(this, f).delete(f), this.size -= f ? 1 : 0, f;
      };
    }, function(a, s) {
      function r(l) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        })(l);
      }
      a.exports = function(d) {
        var f = r(d);
        return f == "string" || f == "number" || f == "symbol" || f == "boolean" ? d !== "__proto__" : d === null;
      };
    }, function(a, s, r) {
      var l = r(79);
      a.exports = function(f) {
        return l(this, f).get(f);
      };
    }, function(a, s, r) {
      var l = r(79);
      a.exports = function(f) {
        return l(this, f).has(f);
      };
    }, function(a, s, r) {
      var l = r(79);
      a.exports = function(f, h) {
        var p = l(this, f), g = p.size;
        return p.set(f, h), this.size += p.size == g ? 0 : 1, this;
      };
    }, function(a, s, r) {
      var l = r(104), d = r(162), f = r(295), h = r(298), p = r(40), g = r(13), _ = r(73), b = r(101), v = "[object Arguments]", E = "[object Array]", C = "[object Object]", y = Object.prototype.hasOwnProperty;
      a.exports = function(A, k, N, j, I, B) {
        var U = g(A), ie = g(k), H = U ? E : p(A), Q = ie ? E : p(k), Y = (H = H == v ? C : H) == C, ie = (Q = Q == v ? C : Q) == C;
        if ((Q = H == Q) && _(A)) {
          if (!_(k)) return !1;
          Y = !(U = !0);
        }
        return Q && !Y ? (B = B || new l(), U || b(A) ? d(A, k, N, j, I, B) : f(A, k, H, N, j, I, B)) : 1 & N || (Y = Y && y.call(A, "__wrapped__"), ie = ie && y.call(k, "__wrapped__"), !Y && !ie) ? !!Q && (B = B || new l(), h(A, k, N, j, I, B)) : I(Y ? A.value() : A, ie ? k.value() : k, N, j, B = B || new l());
      };
    }, function(a, s, f) {
      var l = f(105), d = f(292), f = f(293);
      function h(p) {
        var g = -1, _ = p == null ? 0 : p.length;
        for (this.__data__ = new l(); ++g < _; ) this.add(p[g]);
      }
      h.prototype.add = h.prototype.push = d, h.prototype.has = f, a.exports = h;
    }, function(a, s) {
      a.exports = function(l) {
        return this.__data__.set(l, "__lodash_hash_undefined__"), this;
      };
    }, function(a, s) {
      a.exports = function(l) {
        return this.__data__.has(l);
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return l.has(d);
      };
    }, function(a, s, r) {
      var l = r(41), d = r(164), f = r(77), h = r(162), p = r(296), g = r(297), _ = (l = l ? l.prototype : void 0) ? l.valueOf : void 0;
      a.exports = function(v, E, C, y, T, A, k) {
        switch (C) {
          case "[object DataView]":
            if (v.byteLength != E.byteLength || v.byteOffset != E.byteOffset) return !1;
            v = v.buffer, E = E.buffer;
          case "[object ArrayBuffer]":
            return !(v.byteLength != E.byteLength || !A(new d(v), new d(E)));
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return f(+v, +E);
          case "[object Error]":
            return v.name == E.name && v.message == E.message;
          case "[object RegExp]":
          case "[object String]":
            return v == E + "";
          case "[object Map]":
            var N = p;
          case "[object Set]":
            if (N = N || g, v.size != E.size && !(1 & y)) return !1;
            var j = k.get(v);
            return j ? j == E : (y |= 2, k.set(v, E), N = h(N(v), N(E), y, T, A, k), k.delete(v), N);
          case "[object Symbol]":
            if (_) return _.call(v) == _.call(E);
        }
        return !1;
      };
    }, function(a, s) {
      a.exports = function(l) {
        var d = -1, f = Array(l.size);
        return l.forEach(function(h, p) {
          f[++d] = [p, h];
        }), f;
      };
    }, function(a, s) {
      a.exports = function(l) {
        var d = -1, f = Array(l.size);
        return l.forEach(function(h) {
          f[++d] = h;
        }), f;
      };
    }, function(a, s, r) {
      var l = r(165), d = Object.prototype.hasOwnProperty;
      a.exports = function(h, p, g, _, b, v) {
        var E = 1 & g, C = l(h), y = C.length;
        if (y != l(p).length && !E) return !1;
        for (var T = y; T--; ) {
          var A = C[T];
          if (!(E ? A in p : d.call(p, A))) return !1;
        }
        var k = v.get(h), N = v.get(p);
        if (k && N) return k == p && N == h;
        var j = !0;
        v.set(h, p), v.set(p, h);
        for (var I = E; ++T < y; ) {
          var B, U = h[A = C[T]], H = p[A];
          if (!((B = _ ? E ? _(H, U, A, p, h, v) : _(U, H, A, h, p, v) : B) === void 0 ? U === H || b(U, H, g, _, v) : B)) {
            j = !1;
            break;
          }
          I = I || A == "constructor";
        }
        return !j || I || (k = h.constructor) != (N = p.constructor) && "constructor" in h && "constructor" in p && !(typeof k == "function" && k instanceof k && typeof N == "function" && N instanceof N) && (j = !1), v.delete(h), v.delete(p), j;
      };
    }, function(a, s, r) {
      var l = r(169), d = r(32);
      a.exports = function(h) {
        for (var p = d(h), g = p.length; g--; ) {
          var _ = p[g], b = h[_];
          p[g] = [_, b, l(b)];
        }
        return p;
      };
    }, function(a, s, r) {
      var l = r(161), d = r(43), f = r(304), h = r(108), p = r(169), g = r(170), _ = r(33);
      a.exports = function(v, E) {
        return h(v) && p(E) ? g(_(v), E) : function(C) {
          var y = d(C, v);
          return y === void 0 && y === E ? f(C, v) : l(E, y, 3);
        };
      };
    }, function(a, s, r) {
      var l = r(302);
      a.exports = function(f) {
        var h = (f = l(f, function(p) {
          return h.size === 500 && h.clear(), p;
        })).cache;
        return f;
      };
    }, function(a, s, r) {
      var l = r(105), d = "Expected a function";
      function f(h, p) {
        if (typeof h != "function" || p != null && typeof p != "function") throw new TypeError(d);
        function g() {
          var _ = arguments, b = p ? p.apply(this, _) : _[0], v = g.cache;
          return v.has(b) ? v.get(b) : (_ = h.apply(this, _), g.cache = v.set(b, _) || v, _);
        }
        return g.cache = new (f.Cache || l)(), g;
      }
      f.Cache = l, a.exports = f;
    }, function(a, s, r) {
      var l = r(41), d = r(58), f = r(13), h = r(45), p = (l = l ? l.prototype : void 0) ? l.toString : void 0;
      a.exports = function g(_) {
        if (typeof _ == "string") return _;
        if (f(_)) return d(_, g) + "";
        if (h(_)) return p ? p.call(_) : "";
        var b = _ + "";
        return b == "0" && 1 / _ == -1 / 0 ? "-0" : b;
      };
    }, function(a, s, r) {
      var l = r(305), d = r(306);
      a.exports = function(h, p) {
        return h != null && d(h, p, l);
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return l != null && d in Object(l);
      };
    }, function(a, s, r) {
      var l = r(44), d = r(72), f = r(13), h = r(56), p = r(100), g = r(33);
      a.exports = function(b, v, E) {
        for (var C = -1, y = (v = l(v, b)).length, T = !1; ++C < y; ) {
          var A = g(v[C]);
          if (!(T = b != null && E(b, A))) break;
          b = b[A];
        }
        return T || ++C != y ? T : !!(y = b == null ? 0 : b.length) && p(y) && h(A, y) && (f(b) || d(b));
      };
    }, function(a, s, r) {
      var l = r(308), d = r(309), f = r(108), h = r(33);
      a.exports = function(g) {
        return f(g) ? l(h(g)) : d(g);
      };
    }, function(a, s) {
      a.exports = function(l) {
        return function(d) {
          return d == null ? void 0 : d[l];
        };
      };
    }, function(a, s, r) {
      var l = r(80);
      a.exports = function(f) {
        return function(h) {
          return l(h, f);
        };
      };
    }, function(a, s) {
      a.exports = function(l, d, f, h, p) {
        return p(l, function(g, _, b) {
          f = h ? (h = !1, g) : d(f, g, _, b);
        }), f;
      };
    }, function(a, s, r) {
      var l = r(59), d = r(112);
      a.exports = function(h, p) {
        return h && l(p, d(p), h);
      };
    }, function(a, s, r) {
      var l = r(19), d = r(70), f = r(313), h = Object.prototype.hasOwnProperty;
      a.exports = function(g) {
        if (!l(g)) return f(g);
        var _, b = d(g), v = [];
        for (_ in g) (_ != "constructor" || !b && h.call(g, _)) && v.push(_);
        return v;
      };
    }, function(a, s) {
      a.exports = function(l) {
        var d = [];
        if (l != null) for (var f in Object(l)) d.push(f);
        return d;
      };
    }, function(a, s, r) {
      (function(l) {
        function d(_) {
          return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
            return typeof b;
          } : function(b) {
            return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
          })(_);
        }
        var f = r(17), h = d(s) == "object" && s && !s.nodeType && s, p = h && d(l) == "object" && l && !l.nodeType && l, g = (f = p && p.exports === h ? f.Buffer : void 0) ? f.allocUnsafe : void 0;
        l.exports = function(b, v) {
          return v ? b.slice() : (v = b.length, v = g ? g(v) : new b.constructor(v), b.copy(v), v);
        };
      }).call(this, r(54)(a));
    }, function(a, s, r) {
      var l = r(59), d = r(107);
      a.exports = function(h, p) {
        return l(h, d(h), p);
      };
    }, function(a, s, r) {
      var l = r(59), d = r(175);
      a.exports = function(h, p) {
        return l(h, d(h), p);
      };
    }, function(a, s) {
      var r = Object.prototype.hasOwnProperty;
      a.exports = function(d) {
        var f = d.length, h = new d.constructor(f);
        return f && typeof d[0] == "string" && r.call(d, "index") && (h.index = d.index, h.input = d.input), h;
      };
    }, function(a, s, r) {
      var l = r(115), d = r(319), f = r(320), h = r(321), p = r(322);
      a.exports = function(_, b, v) {
        var E = _.constructor;
        switch (b) {
          case "[object ArrayBuffer]":
            return l(_);
          case "[object Boolean]":
          case "[object Date]":
            return new E(+_);
          case "[object DataView]":
            return d(_, v);
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return p(_, v);
          case "[object Map]":
            return new E();
          case "[object Number]":
          case "[object String]":
            return new E(_);
          case "[object RegExp]":
            return f(_);
          case "[object Set]":
            return new E();
          case "[object Symbol]":
            return h(_);
        }
      };
    }, function(a, s, r) {
      var l = r(115);
      a.exports = function(f, h) {
        return h = h ? l(f.buffer) : f.buffer, new f.constructor(h, f.byteOffset, f.byteLength);
      };
    }, function(a, s) {
      var r = /\w*$/;
      a.exports = function(d) {
        var f = new d.constructor(d.source, r.exec(d));
        return f.lastIndex = d.lastIndex, f;
      };
    }, function(a, s, r) {
      var l = (r = (r = r(41)) ? r.prototype : void 0) ? r.valueOf : void 0;
      a.exports = function(f) {
        return l ? Object(l.call(f)) : {};
      };
    }, function(a, s, r) {
      var l = r(115);
      a.exports = function(f, h) {
        return h = h ? l(f.buffer) : f.buffer, new f.constructor(h, f.byteOffset, f.length);
      };
    }, function(a, s, r) {
      var l = r(82), d = r(113), f = r(70);
      a.exports = function(p) {
        return typeof p.constructor != "function" || f(p) ? {} : l(d(p));
      };
    }, function(a, s, r) {
      var d = r(325), l = r(102), d = (r = (r = r(103)) && r.isMap) ? l(r) : d;
      a.exports = d;
    }, function(a, s, r) {
      var l = r(40), d = r(20);
      a.exports = function(h) {
        return d(h) && l(h) == "[object Map]";
      };
    }, function(a, s, r) {
      var d = r(327), l = r(102), d = (r = (r = r(103)) && r.isSet) ? l(r) : d;
      a.exports = d;
    }, function(a, s, r) {
      var l = r(40), d = r(20);
      a.exports = function(h) {
        return d(h) && l(h) == "[object Set]";
      };
    }, function(a, s, r) {
      var l = r(44), d = r(329), f = r(330), h = r(33);
      a.exports = function(g, _) {
        return _ = l(_, g), (g = f(g, _)) == null || delete g[h(d(_))];
      };
    }, function(a, s) {
      a.exports = function(l) {
        var d = l == null ? 0 : l.length;
        return d ? l[d - 1] : void 0;
      };
    }, function(a, s, r) {
      var l = r(80), d = r(331);
      a.exports = function(h, p) {
        return p.length < 2 ? h : l(h, d(p, 0, -1));
      };
    }, function(a, s) {
      a.exports = function(l, d, f) {
        var h = -1, p = l.length;
        (f = p < f ? p : f) < 0 && (f += p), p = f < (d = d < 0 ? p < -d ? 0 : p + d : d) ? 0 : f - d >>> 0, d >>>= 0;
        for (var g = Array(p); ++h < p; ) g[h] = l[h + d];
        return g;
      };
    }, function(a, s, r) {
      var l = r(176);
      a.exports = function(f) {
        return l(f) ? void 0 : f;
      };
    }, function(a, s, r) {
      var l = r(334);
      a.exports = function(f) {
        return f != null && f.length ? l(f, 1) : [];
      };
    }, function(a, s, r) {
      var l = r(106), d = r(335);
      a.exports = function f(h, p, g, _, b) {
        var v = -1, E = h.length;
        for (g = g || d, b = b || []; ++v < E; ) {
          var C = h[v];
          0 < p && g(C) ? 1 < p ? f(C, p - 1, g, _, b) : l(b, C) : _ || (b[b.length] = C);
        }
        return b;
      };
    }, function(a, s, r) {
      var l = r(41), d = r(72), f = r(13), h = l ? l.isConcatSpreadable : void 0;
      a.exports = function(g) {
        return f(g) || d(g) || !!(h && g && g[h]);
      };
    }, function(a, s, r) {
      var l = r(117), d = Math.max;
      a.exports = function(h, p, g) {
        return p = d(p === void 0 ? h.length - 1 : p, 0), function() {
          for (var _ = arguments, b = -1, v = d(_.length - p, 0), E = Array(v); ++b < v; ) E[b] = _[p + b];
          for (var b = -1, C = Array(p + 1); ++b < p; ) C[b] = _[b];
          return C[p] = g(E), l(h, this, C);
        };
      };
    }, function(a, s, f) {
      var l = f(338), d = f(173), f = f(25);
      a.exports = d ? function(h, p) {
        return d(h, "toString", { configurable: !0, enumerable: !1, value: l(p), writable: !0 });
      } : f;
    }, function(a, s) {
      a.exports = function(l) {
        return function() {
          return l;
        };
      };
    }, function(a, s, r) {
      var l = r(55), d = r(31);
      a.exports = function(h, p) {
        var g = -1, _ = d(h) ? Array(h.length) : [];
        return l(h, function(b, v, E) {
          _[++g] = p(b, v, E);
        }), _;
      };
    }, function(a, s, r) {
      var l = r(55);
      a.exports = function(f, h) {
        var p = [];
        return l(f, function(g, _, b) {
          h(g, _, b) && p.push(g);
        }), p;
      };
    }, function(a, s, r) {
      var l = r(21), d = r(31), f = r(32);
      a.exports = function(p) {
        return function(g, _, b) {
          var v, E = Object(g);
          return d(g) || (v = l(_, 3), g = f(g), _ = function(y) {
            return v(E[y], y, E);
          }), -1 < (b = p(g, _, b)) ? E[v ? g[b] : b] : void 0;
        };
      };
    }, function(a, s, r) {
      var l = r(119), d = r(21), f = r(61), h = Math.max;
      a.exports = function(g, _, b) {
        var v = g == null ? 0 : g.length;
        return v ? ((b = b == null ? 0 : f(b)) < 0 && (b = h(v + b, 0)), l(g, d(_, 3), b)) : -1;
      };
    }, function(a, s, r) {
      var l = r(344), d = r(19), f = r(45), h = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, g = /^0o[0-7]+$/i, _ = parseInt;
      a.exports = function(v) {
        if (typeof v == "number") return v;
        if (f(v)) return NaN;
        if (d(v) && (E = typeof v.valueOf == "function" ? v.valueOf() : v, v = d(E) ? E + "" : E), typeof v != "string") return v === 0 ? v : +v;
        v = l(v);
        var E = p.test(v);
        return E || g.test(v) ? _(v.slice(2), E ? 2 : 8) : h.test(v) ? NaN : +v;
      };
    }, function(a, s, r) {
      var l = r(345), d = /^\s+/;
      a.exports = function(h) {
        return h && h.slice(0, l(h) + 1).replace(d, "");
      };
    }, function(a, s) {
      var r = /\s/;
      a.exports = function(d) {
        for (var f = d.length; f-- && r.test(d.charAt(f)); ) ;
        return f;
      };
    }, function(a, s, r) {
      var l = r(347), d = r(358)(function(h, p) {
        return l(h, { xmlMode: p && p.xmlMode }, f, [p]);
      }), f = function(p, g) {
        return d.juiceDocument(p, g);
      };
      d.inlineContent = function(h, p, g) {
        return l(h, { xmlMode: g && g.xmlMode }, d.inlineDocument, [p, g]);
      }, d.codeBlocks = l.codeBlocks, a.exports = d;
    }, function(a, s, r) {
      var l = r(240);
      r(120), a.exports = function(d, f, h, p) {
        var g = /* @__PURE__ */ function() {
          var v = [];
          return { encodeEntities: function(C) {
            var y = a.exports.codeBlocks;
            return Object.keys(y).forEach(function(T) {
              T = new RegExp(y[T].start + "([\\S\\s]*?)" + y[T].end, "g"), C = C.replace(T, function(A, k) {
                return v.push(A), "JUICE_CODE_BLOCK_" + (v.length - 1) + "_";
              });
            }), C;
          }, decodeEntities: function(C) {
            for (var y = 0; y < v.length; y++) {
              var T = new RegExp("JUICE_CODE_BLOCK_" + y + '_(="")?', "gi");
              C = C.replace(T, function() {
                return v[y];
              });
            }
            return C;
          } };
        }(), _ = function(v, E, C) {
          return E = Object.assign({ decodeEntities: !1, _useHtmlParser2: !0 }, E), v = C(v), l.load(v, E);
        }(d, f, g.encodeEntities);
        return (d = [_]).push.apply(d, p), _ = h.apply(void 0, d) || _, f && f.xmlMode ? g.decodeEntities(_.xml()) : g.decodeEntities(_.html());
      }, a.exports.codeBlocks = { EJS: { start: "<%", end: "%>" }, HBS: { start: "{{", end: "}}" } };
    }, function(a, s, r) {
      s.byteLength = function(v) {
        var E = _(v);
        return 3 * ((v = E[0]) + (E = E[1])) / 4 - E;
      }, s.toByteArray = function(v) {
        for (var E, C = (y = _(v))[0], y = y[1], T = new f(function(I, B, U) {
          return 3 * (B + U) / 4 - U;
        }(0, C, y)), A = 0, k = 0 < y ? C - 4 : C, N = 0; N < k; N += 4) E = d[v.charCodeAt(N)] << 18 | d[v.charCodeAt(N + 1)] << 12 | d[v.charCodeAt(N + 2)] << 6 | d[v.charCodeAt(N + 3)], T[A++] = E >> 16 & 255, T[A++] = E >> 8 & 255, T[A++] = 255 & E;
        return y === 2 && (E = d[v.charCodeAt(N)] << 2 | d[v.charCodeAt(N + 1)] >> 4, T[A++] = 255 & E), y === 1 && (E = d[v.charCodeAt(N)] << 10 | d[v.charCodeAt(N + 1)] << 4 | d[v.charCodeAt(N + 2)] >> 2, T[A++] = E >> 8 & 255, T[A++] = 255 & E), T;
      }, s.fromByteArray = function(v) {
        for (var E, C = v.length, y = C % 3, T = [], A = 0, k = C - y; A < k; A += 16383) T.push(function(j, I, B) {
          for (var U, H = [], Q = I; Q < B; Q += 3) U = (j[Q] << 16 & 16711680) + (j[Q + 1] << 8 & 65280) + (255 & j[Q + 2]), H.push(function(ie) {
            return l[ie >> 18 & 63] + l[ie >> 12 & 63] + l[ie >> 6 & 63] + l[63 & ie];
          }(U));
          return H.join("");
        }(v, A, k < A + 16383 ? k : A + 16383));
        return y == 1 ? (E = v[C - 1], T.push(l[E >> 2] + l[E << 4 & 63] + "==")) : y == 2 && (E = (v[C - 2] << 8) + v[C - 1], T.push(l[E >> 10] + l[E >> 4 & 63] + l[E << 2 & 63] + "=")), T.join("");
      };
      for (var l = [], d = [], f = typeof Uint8Array < "u" ? Uint8Array : Array, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0, g = h.length; p < g; ++p) l[p] = h[p], d[h.charCodeAt(p)] = p;
      function _(b) {
        var v = b.length;
        if (0 < v % 4) throw new Error("Invalid string. Length must be a multiple of 4");
        return [b = (b = b.indexOf("=")) === -1 ? v : b, b === v ? 0 : 4 - b % 4];
      }
      d[45] = 62, d[95] = 63;
    }, function(a, s) {
      s.read = function(r, l, T, f, h) {
        var p, g, _ = 8 * h - f - 1, b = (1 << _) - 1, v = b >> 1, E = -7, C = T ? h - 1 : 0, y = T ? -1 : 1, T = r[l + C];
        for (C += y, p = T & (1 << -E) - 1, T >>= -E, E += _; 0 < E; p = 256 * p + r[l + C], C += y, E -= 8) ;
        for (g = p & (1 << -E) - 1, p >>= -E, E += f; 0 < E; g = 256 * g + r[l + C], C += y, E -= 8) ;
        if (p === 0) p = 1 - v;
        else {
          if (p === b) return g ? NaN : 1 / 0 * (T ? -1 : 1);
          g += Math.pow(2, f), p -= v;
        }
        return (T ? -1 : 1) * g * Math.pow(2, p - f);
      }, s.write = function(r, l, d, f, h, A) {
        var g, _, b = 8 * A - h - 1, v = (1 << b) - 1, E = v >> 1, C = h === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = f ? 0 : A - 1, T = f ? 1 : -1, A = l < 0 || l === 0 && 1 / l < 0 ? 1 : 0;
        for (l = Math.abs(l), isNaN(l) || l === 1 / 0 ? (_ = isNaN(l) ? 1 : 0, g = v) : (g = Math.floor(Math.log(l) / Math.LN2), l * (f = Math.pow(2, -g)) < 1 && (g--, f *= 2), 2 <= (l += 1 <= g + E ? C / f : C * Math.pow(2, 1 - E)) * f && (g++, f /= 2), v <= g + E ? (_ = 0, g = v) : 1 <= g + E ? (_ = (l * f - 1) * Math.pow(2, h), g += E) : (_ = l * Math.pow(2, E - 1) * Math.pow(2, h), g = 0)); 8 <= h; r[d + y] = 255 & _, y += T, _ /= 256, h -= 8) ;
        for (g = g << h | _, b += h; 0 < b; r[d + y] = 255 & g, y += T, g /= 256, b -= 8) ;
        r[d + y - T] |= 128 * A;
      };
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(l) {
        return l.charCodeAt(0);
      }));
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = new Uint16Array("Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(l) {
        return l.charCodeAt(0);
      }));
    }, function(a, s, r) {
      a.exports = { lex: r(182), parse: r(353), stringify: r(354) };
    }, function(a, s, r) {
      var l, d, f, h;
      r(121)("parse");
      var p = r(182);
      function g(y, T) {
        var A;
        T = T || {};
        for (var k = ["type", "name", "value"], N = {}, j = 0; j < k.length; ++j) y[A = k[j]] && (N[A] = T[A] || y[A]);
        for (k = Object.keys(T), j = 0; j < k.length; ++j) N[A = k[j]] || (N[A] = T[A]);
        return f && (N.position = { start: y.start, end: y.end }), N;
      }
      function _() {
        var y = h.shift();
        return y;
      }
      function b(y) {
        d += 1;
        var T = {};
        switch (y.type) {
          case "font-face":
          case "viewport":
            T.declarations = C();
            break;
          case "page":
            T.prefix = y.prefix, T.declarations = C();
            break;
          default:
            T.prefix = y.prefix, T.rules = function() {
              return E(function() {
                return d;
              });
            }();
        }
        return g(y, T);
      }
      function v(y) {
        switch (y.type) {
          case "property":
            return function(A) {
              return g(A);
            }(y);
          case "selector":
            return function(A) {
              return g(A, { type: "rule", selectors: A.text.split(",").map(function(N) {
                return N.trim();
              }), declarations: C() });
            }(y);
          case "at-group-end":
            return void --d;
          case "media":
          case "keyframes":
            return b(y);
          case "comment":
            if (l) return function(A) {
              return g(A, { text: A.text });
            }(y);
            break;
          case "charset":
            return function(A) {
              return g(A);
            }(y);
          case "import":
            return function(A) {
              return g(A);
            }(y);
          case "namespace":
            return function(A) {
              return g(A);
            }(y);
          case "font-face":
          case "supports":
          case "viewport":
          case "document":
          case "page":
            return b(y);
        }
      }
      function E(y) {
        for (var T, A, k = []; (A = _()) && y && y(A); ) (T = v(A)) && k.push(T);
        return A && A.type !== "end" && h.unshift(A), k;
      }
      function C() {
        return E(function(y) {
          return y.type === "property" || y.type === "comment";
        });
      }
      a.exports = function(T, A) {
        l = !!(A = A || {}).comments, f = !!A.position, d = 0, h = Array.isArray(T) ? T.slice() : p(T);
        for (var k, N = []; k = _(); ) (k = v(k)) && N.push(k);
        return { type: "stylesheet", stylesheet: { rules: N } };
      };
    }, function(a, s, r) {
      var l, d, f, h, p, g;
      r(121)("stringify");
      function _(k) {
        if (!k) return d ? "" : Array(h).join(f || "");
        h += k;
      }
      function b(k) {
        var N = "", j = k.prefix || "";
        k.name && (N = " " + k.name);
        var I = k.type !== "page";
        return "@" + j + k.type + N + g + y(k, I) + p;
      }
      function v(k) {
        return l ? "/*" + (k.text || "") + "*/" + p : "";
      }
      function E(k) {
        var N;
        return k.selectors ? N = k.selectors.join("," + p) : (N = "@" + k.type, N += k.name ? " " + k.name : ""), _() + N + g + y(k) + p;
      }
      function C(k, N) {
        return k.reduce(function(j, I) {
          return (I = (I.type === "comment" ? v : N)(I)) && j.push(I), j;
        }, []);
      }
      function y(k, N) {
        var j = k.declarations, I = T;
        return k.rules && (j = k.rules, I = E), "{" + (j = (j = function(U, H) {
          return U ? (_(1), H = C(U, H), _(-1), H.length ? H.join(p) : "") : "";
        }(j, I)) && p + j + (N ? "" : p)) + _() + "}";
      }
      function T(k) {
        if (k.type === "property") return function(j) {
          var I = j.name ? j.name + ":" + g : "";
          return _() + I + j.value + ";";
        }(k);
      }
      function A(k) {
        switch (k.type) {
          case "rule":
            return E(k);
          case "media":
          case "keyframes":
            return b(k);
          case "comment":
            return v(k);
          case "import":
          case "charset":
          case "namespace":
            return function(j) {
              return "@" + j.type + " " + j.value + ";" + p;
            }(k);
          case "font-face":
          case "supports":
          case "viewport":
          case "document":
          case "page":
            return b(k);
        }
      }
      a.exports = function(N, j) {
        return f = (j = j || {}).indentation || "", d = !!j.compress, l = !!j.comments, h = 1, d ? p = g = "" : (p = `
`, g = " "), N = C(N.stylesheet.rules, A).join(`
`).trim();
      };
    }, function(a, s, r) {
      var l = r(356);
      function d(h, p) {
        this.text = h, this.spec = void 0, this.styleAttribute = p || !1;
      }
      function f(h) {
        try {
          return l(h)[0];
        } catch {
          return [];
        }
      }
      (a.exports = d).prototype.parsed = function() {
        return this.tokens || (this.tokens = f(this.text)), this.tokens;
      }, d.prototype.specificity = function() {
        var h = this.styleAttribute;
        return this.spec || (this.spec = function p(g, _) {
          for (var b = _ || f(g), v = [h ? 1 : 0, 0, 0, 0], E = [], C = 0; C < b.length; C++) {
            var y = b[C], T = y.pseudos;
            if (y.id && v[1]++, y.attributes && (v[2] += y.attributes.length), y.classList && (v[2] += y.classList.length), y.tag && y.tag !== "*" && v[3]++, T) {
              v[3] += T.length;
              for (var A = 0; A < T.length; A++) T[A].name === "not" && (E.push(T[A].value), v[3]--);
            }
          }
          for (var k = E.length; k--; ) for (var N = p(E[k]), j = 4; j--; ) v[j] += N[j];
          return v;
        }(this.text, this.parsed())), this.spec;
      };
    }, function(a, s, r) {
      function l(C) {
        return (C + "").replace(h, "\\$1");
      }
      function d(C) {
        return (C + "").replace(p, "");
      }
      function f(C) {
        this.combinator = C || " ", this.tag = "*";
      }
      var h = /([-.*+?^${}()|[\]\/\\])/g, p = /\\/g, g = RegExp(`^(?:\\s*(,)\\s*|\\s*(<combinator>+)\\s*|(\\s+)|(<unicode>+|\\*)|\\#(<unicode>+)|\\.(<unicode>+)|\\[\\s*(<unicode1>+)(?:\\s*([*^$!~|]?=)(?:\\s*(?:(["']?)(.*?)\\9)))?\\s*\\](?!\\])|(:+)(<unicode>+)(?:\\((?:(?:(["'])([^\\13]*)\\13)|((?:\\([^)]+\\)|[^()]*)+))\\))?)`.replace(/<combinator>/, "[" + l(">+~`!@$%^&={}\\;</") + "]").replace(/<unicode>/g, "(?:[\\w\\u00a1-\\uFFFF-]|\\\\[^\\s0-9a-f])").replace(/<unicode1>/g, "(?:[:\\w\\u00a1-\\uFFFF-]|\\\\[^\\s0-9a-f])"));
      function _() {
        this.length = 0;
      }
      function b(C, y, T, A, k, N, j, I, B, U, H, Q, Y, ie, ce, $) {
        var te, V;
        return (y || !this.length) && (te = this[this.length++] = new _(), y) || (te = te || this[this.length - 1], V = (V = T || A || !te.length ? te[te.length++] = new f(T) : V) || te[te.length - 1], k ? V.tag = d(k) : N ? V.id = d(N) : j ? (k = d(j), (N = V.classes || (V.classes = {}))[k] || (N[k] = l(j), (j = V.classList || (V.classList = [])).push(k), j.sort())) : Y ? ($ = $ || ce, (V.pseudos || (V.pseudos = [])).push({ type: Q.length == 1 ? "class" : "element", name: d(Y), escapedName: l(Y), value: $ ? d($) : null, escapedValue: $ ? l($) : null })) : I && (H = H ? l(H) : null, (V.attributes || (V.attributes = [])).push({ operator: B, name: d(I), escapedName: l(I), value: H ? d(H) : null, escapedValue: H ? l(H) : null }))), "";
      }
      function v(C) {
        this.length = 0;
        for (var y, T = this, A = C; C; ) {
          if ((y = C.replace(g, function() {
            return b.apply(T, arguments);
          })) === C) throw new Error(A + " is an invalid expression");
          C = y;
        }
      }
      f.prototype.toString = function() {
        if (!this.raw) {
          var C, y, T = "";
          if (T += this.tag || "*", this.id && (T += "#" + this.id), this.classes && (T += "." + this.classList.join(".")), this.attributes) for (C = 0; y = this.attributes[C++]; ) T += "[" + y.name + (y.operator ? y.operator + '"' + y.value + '"' : "") + "]";
          if (this.pseudos) for (C = 0; y = this.pseudos[C++]; ) T += ":" + y.name, y.value && (T += "(" + y.value + ")");
          this.raw = T;
        }
        return this.raw;
      }, _.prototype.toString = function() {
        if (!this.raw) {
          for (var C, y = "", T = 0; C = this[T++]; ) T !== 1 && (y += " "), C.combinator !== " " && (y += C.combinator + " "), y += C;
          this.raw = y;
        }
        return this.raw;
      }, v.prototype.toString = function() {
        if (!this.raw) {
          for (var C, y = [], T = 0; C = this[T++]; ) y.push(C);
          this.raw = y.join(", ");
        }
        return this.raw;
      };
      var E = {};
      a.exports = function(y) {
        return y == null ? null : (y = ("" + y).replace(/^\s+|\s+$/g, ""), E[y] || (E[y] = new v(y)));
      };
    }, function(a, s, r) {
      a.exports = d;
      var l = r(120);
      function d(f, h, p, g, _) {
        this.prop = f, this.value = h, this.selector = p, this.priority = g || 0, this.additionalPriority = _ || [];
      }
      d.prototype.compareFunc = function(f) {
        var h = [];
        h.push.apply(h, this.selector.specificity()), h.push.apply(h, this.additionalPriority), h[0] += this.priority;
        var p = [];
        return p.push.apply(p, f.selector.specificity()), p.push.apply(p, f.additionalPriority), p[0] += f.priority, l.compareFunc(h, p);
      }, d.prototype.compare = function(f) {
        return this.compareFunc(f) === 1 ? this : f;
      }, d.prototype.toString = function() {
        return this.prop + ": " + this.value.replace(/['"]+/g, "") + ";";
      };
    }, function(a, s, r) {
      var l = r(120), d = r(359), f = r(360);
      a.exports = function(p) {
        function g(v, E, C) {
          C = C || {};
          var y = l.parseCSS(E), T = [], A = "style", k = {};
          function N(j, I) {
            if (j.name) {
              var B = j.name.toUpperCase();
              if (-1 < p[I + "Elements"].indexOf(B)) {
                for (var U in j.styleProps) if (j.styleProps[U].prop === I) {
                  var H = j.styleProps[U].value;
                  if ((H = C.preserveImportant ? _(H) : H).match(/(px|auto)/)) return U = H.replace("px", ""), v(j).attr(I, U), 0;
                  if (-1 < p.tableElements.indexOf(B) && H.match(/\%/)) return v(j).attr(I, H), 0;
                }
              }
            }
          }
          C.styleAttributeName && (A = C.styleAttributeName), y.forEach(function(I) {
            var B = I[0], U = I[1], H = new l.Selector(B), Q = H.parsed();
            if (Q) {
              for (var Y, ie, ce = function(J) {
                if (J.length !== 0) {
                  var L = J[J.length - 1].pseudos;
                  if (L) {
                    for (var z = 0; z < L.length; z++) if (b(L[z])) return L[z].name;
                  }
                }
              }(Q), $ = 0; $ < Q.length; ++$) {
                var te = Q[$];
                if (te.pseudos) for (var V = 0; V < te.pseudos.length; ++V) {
                  var K = te.pseudos[V];
                  if (0 <= p.ignoredPseudos.indexOf(K.name)) return;
                }
              }
              ce && (I = (Y = Q[Q.length - 1]).pseudos, Y.pseudos = function(J) {
                return J.filter(function(L) {
                  return !b(L);
                });
              }(Y.pseudos), B = Q.toString(), Y.pseudos = I);
              try {
                ie = v(B);
              } catch {
                return;
              }
              ie.each(function() {
                var ne, J, L = this;
                function z(ee, q) {
                  for (var X, oe, ae, _e, ve = 0, Ee = ee.length; ve < Ee; ve++) ee[ve].type == "property" && (X = ee[ve].name, oe = ee[ve].value, X === "counter-reset" && function(ze, Ie) {
                    for (var je = Ie.split(/\s+/), qe = 0; qe < je.length; qe++) {
                      var Ge = je[qe], Ze = parseInt(je[qe + 1], 10);
                      isNaN(Ze) ? ze.counterProps[Ge] = k[Ge] = 0 : ze.counterProps[Ge] = k[je[qe++]] = Ze;
                    }
                  }(L, oe), X === "counter-increment" && function(ze, Ie) {
                    for (var je = Ie.split(/\s+/), qe = 0; qe < je.length; qe++) {
                      var Ge, Ze = je[qe];
                      ze.counterProps[Ze] !== void 0 && (Ge = parseInt(je[qe + 1], 10), isNaN(Ge) ? ze.counterProps[Ze] = k[Ze] += 1 : ze.counterProps[Ze] = k[je[qe++]] += Ge);
                    }
                  }(L, oe), (ae = oe.match(/!important$/) !== null) && !C.preserveImportant && (oe = _(oe)), _e = [ee[ve].position.start.line, ee[ve].position.start.col], ae = new l.Property(X, oe, q, ae ? 2 : 0, _e), _e = L.styleProps[X], p.excludedProperties.indexOf(X) < 0 && (_e && _e.compare(ae) === ae || !_e) && (_e && _e.selector !== q ? delete L.styleProps[X] : _e && (ae.nextProp = _e), L.styleProps[X] = ae));
                }
                L.name && 0 <= p.nonVisualElements.indexOf(L.name.toUpperCase()) || (L.counterProps || (L.counterProps = L.parent && L.parent.counterProps ? Object.create(L.parent.counterProps) : {}), ce && ((J = L[ne = "pseudo" + ce]) || ((J = L[ne] = v("<span />").get(0)).pseudoElementType = ce, J.pseudoElementParent = L, J.counterProps = L.counterProps, L[ne] = J), L = J), L.styleProps || (L.styleProps = {}, v(L).attr(A) && (J = "* { " + v(L).attr(A) + " } ", z(l.parseCSS(J)[0][1], new l.Selector("<style>", !0))), T.push(L)), z(U, H));
              });
            }
          }), T.forEach(function(I) {
            Object.keys(I.styleProps).length;
            var B = [];
            Object.keys(I.styleProps).forEach(function(H) {
              for (var Q = I.styleProps[H]; Q !== void 0; ) B.push(Q), Q = Q.nextProp;
            }), B.sort(function(H, Q) {
              return H.compareFunc(Q);
            });
            var U = B.filter(function(H) {
              return (!C.resolveCSSVariables || H.prop.indexOf("--") !== 0) && H.prop !== "content";
            }).map(function(H) {
              return C.resolveCSSVariables && (H.value = f.replaceVariables(I, H.value)), H.prop + ": " + H.value.replace(/["]/g, "'") + ";";
            }).join(" ");
            U && v(I).attr(A, U);
          }), C.inlinePseudoElements && T.forEach(function(I) {
            var B;
            I.pseudoElementType && I.styleProps.content && ((B = function(H) {
              var Q = H.styleProps.content.value;
              if (Q === "none" || Q === "normal") return "";
              var Y = Q.match(/^\s*url\s*\(\s*(.*?)\s*\)\s*$/i);
              if (Y) return { img: Y[1].replace(/^['"]|['"]$/g, "") };
              for (var ie, ce, $ = [], te = Q.split(/['"]/), V = 0; V < te.length; V++) te[V] !== "" && ((ce = te[V].match(/var\s*\(\s*(.*?)\s*(,\s*(.*?)\s*)?\s*\)/i)) ? (ie = f.findVariableValue(H, ce[1]) || ce[2], $.push(ie.replace(/^['"]|['"]$/g, ""))) : (ce = te[V].match(/counter\s*\(\s*(.*?)\s*(,\s*(.*?)\s*)?\s*\)/i)) && ce[1] in H.counterProps ? (ie = H.counterProps[ce[1]], $.push(function(ne, J) {
                switch (J) {
                  case "lower-roman":
                    return d.romanize(ne).toLowerCase();
                  case "upper-roman":
                    return d.romanize(ne);
                  case "lower-latin":
                  case "lower-alpha":
                    return d.alphanumeric(ne).toLowerCase();
                  case "upper-latin":
                  case "upper-alpha":
                    return d.alphanumeric(ne);
                  default:
                    return ne.toString();
                }
              }(ie, ce[3]))) : (ce = te[V].match(/attr\s*\(\s*(.*?)\s*\)/i)) ? (ce = ce[1], $.push((H.pseudoElementParent || H).attribs[ce])) : $.push(te[V]));
              return (Q = $.join("")).replace(/\\/g, "");
            }(I)).img ? (I.name = "img", v(I).attr("src", B.img)) : v(I).text(B), B = I.pseudoElementParent, I.pseudoElementType === "before" ? v(B).prepend(I) : v(B).append(I));
          }), C.applyWidthAttributes && T.forEach(function(j) {
            N(j, "width");
          }), C.applyHeightAttributes && T.forEach(function(j) {
            N(j, "height");
          }), C.applyAttributesTableElements && T.forEach(function(I) {
            if (I.name) {
              var B, U = I.name.toUpperCase(), H = Object.keys(p.styleToAttribute);
              if (-1 < p.tableElements.indexOf(U)) for (var Q in I.styleProps) -1 < H.indexOf(I.styleProps[Q].prop) && (B = p.styleToAttribute[I.styleProps[Q].prop], Q = I.styleProps[Q].value, C.preserveImportant && (Q = _(Q)), B === "background" && (Q = function(ie) {
                return ie.indexOf("url(") !== 0 ? ie : ie.replace(/^url\((["'])?([^"']+)\1\)$/, "$2");
              }(Q)), /(linear|radial)-gradient\(/i.test(Q) || v(I).attr(B, Q));
            }
          }), C.insertPreservedExtraCss && C.extraCss && (E = l.getPreservedText(C.extraCss, { mediaQueries: C.preserveMediaQueries, fontFaces: C.preserveFontFaces, keyFrames: C.preserveKeyFrames })) && (!(y = null) !== C.insertPreservedExtraCss ? y = v(C.insertPreservedExtraCss) : (y = (y = v("head")).length ? y : v("body")).length || (y = v.root()), y.first().append("<style>" + E + "</style>"));
        }
        function _(v) {
          return v.replace(/\s*!important$/, "");
        }
        function b(v) {
          return v.name === "before" || v.name === "after";
        }
        return p.ignoredPseudos = ["hover", "active", "focus", "visited", "link"], p.widthElements = ["TABLE", "TD", "TH", "IMG"], p.heightElements = ["TABLE", "TD", "TH", "IMG"], p.tableElements = ["TABLE", "TH", "TR", "TD", "CAPTION", "COLGROUP", "COL", "THEAD", "TBODY", "TFOOT"], p.nonVisualElements = ["HEAD", "TITLE", "BASE", "LINK", "STYLE", "META", "SCRIPT", "NOSCRIPT"], p.styleToAttribute = { "background-color": "bgcolor", "background-image": "background", "text-align": "align", "vertical-align": "valign" }, p.excludedProperties = [], p.juiceDocument = function(E, C) {
          var y = function(A, k) {
            return function(j, I) {
              var B, U, H = [];
              return j("style").each(function() {
                var Q, Y = !!(U = this).childNodes;
                (B = Y ? U.childNodes : U.children).length === 1 ? (B = B[0].data, I.applyStyleTags && j(U).attr("data-embed") === void 0 && H.push(B), I.removeStyleTags && j(U).attr("data-embed") === void 0 && (Q = Y ? U.childNodes[0].nodeValue : U.children[0].data, (Q = l.getPreservedText(Q, { mediaQueries: I.preserveMediaQueries, fontFaces: I.preserveFontFaces, keyFrames: I.preserveKeyFrames, pseudos: I.preservePseudos }, p.ignoredPseudos)) ? Y ? U.childNodes[0].nodeValue = Q : U.children[0].data = Q : j(U).remove()), j(U).removeAttr("data-embed")) : I.removeStyleTags && j(U).remove();
              }), H;
            }(A, k).join(`
`);
          }(E, C = l.getDefaultOptions(C));
          return g(E, y += `
` + C.extraCss, C), E;
        }, p.inlineDocument = g, p;
      };
    }, function(a, s, r) {
      s.romanize = function(l) {
        if (isNaN(l)) return NaN;
        for (var d = String(+l).split(""), f = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"], h = "", p = 3; p--; ) h = (f[+d.pop() + 10 * p] || "") + h;
        return Array(+d.join("") + 1).join("M") + h;
      }, s.alphanumeric = function(l) {
        for (var d, f = ""; 0 < l; ) d = (l - 1) % 26, f = String.fromCharCode(65 + d) + f, l = (l - d) / 26 | 0;
        return f || void 0;
      };
    }, function(a, s, r) {
      function l(d, f) {
        for (; d; ) {
          if (d.styleProps && f in d.styleProps) return d.styleProps[f].value;
          d = d.pseudoElementParent || d.parent;
        }
      }
      a.exports = { replaceVariables: function(f, h) {
        for (var p, g = /([a-z\-]+)\s*\(\s*([^\(\)]*?)\s*(?:,\s*([^\(\)]*?)\s*)?\s*\)/i, _ = [], b = function(A) {
          for (var k = ""; k = (Math.random() + 1).toString(36).substring(2), A.indexOf(k) !== -1; ) ;
          return k;
        }(h); (p = g.exec(h)) !== null; ) {
          var v = "".concat(_.length);
          if (p[1].toLowerCase() == "var") {
            var E = l(f, p[2]);
            if (E) {
              h = h.replace(p[0], E);
              continue;
            }
            if (p[3]) {
              h = h.replace(p[0], p[3]);
              continue;
            }
          }
          v = "".concat(b).concat(v.padStart(5, "-")), h = h.replace(p[0], v), _.push({ placeholder: v, replace: p[0] });
        }
        for (var C = _.length - 1; 0 <= C; C--) {
          var y = _[C];
          h = h.replace(y.placeholder, y.replace);
        }
        return h;
      }, findVariableValue: l };
    }, function(a, s, r) {
      var l;
      function d(f) {
        return (d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
          return typeof h;
        } : function(h) {
          return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
        })(f);
      }
      (function() {
        var f;
        (function() {
          var p = [, , function(b) {
            function v(y) {
              this.__parent = y, this.__character_count = 0, this.__indent_count = -1, this.__alignment_count = 0, this.__wrap_point_index = 0, this.__wrap_point_character_count = 0, this.__wrap_point_indent_count = -1, this.__wrap_point_alignment_count = 0, this.__items = [];
            }
            function E(y, T) {
              this.__cache = [""], this.__indent_size = y.indent_size, this.__indent_string = y.indent_char, y.indent_with_tabs || (this.__indent_string = new Array(y.indent_size + 1).join(y.indent_char)), T = T || "", 0 < y.indent_level && (T = new Array(y.indent_level + 1).join(this.__indent_string)), this.__base_string = T, this.__base_string_length = T.length;
            }
            function C(y, T) {
              this.__indent_cache = new E(y, T), this.raw = !1, this._end_with_newline = y.end_with_newline, this.indent_size = y.indent_size, this.wrap_line_length = y.wrap_line_length, this.indent_empty_lines = y.indent_empty_lines, this.__lines = [], this.previous_line = null, this.current_line = null, this.next_line = new v(this), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1, this.__add_outputline();
            }
            v.prototype.clone_empty = function() {
              var y = new v(this.__parent);
              return y.set_indent(this.__indent_count, this.__alignment_count), y;
            }, v.prototype.item = function(y) {
              return y < 0 ? this.__items[this.__items.length + y] : this.__items[y];
            }, v.prototype.has_match = function(y) {
              for (var T = this.__items.length - 1; 0 <= T; T--) if (this.__items[T].match(y)) return !0;
              return !1;
            }, v.prototype.set_indent = function(y, T) {
              this.is_empty() && (this.__indent_count = y || 0, this.__alignment_count = T || 0, this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count));
            }, v.prototype._set_wrap_point = function() {
              this.__parent.wrap_line_length && (this.__wrap_point_index = this.__items.length, this.__wrap_point_character_count = this.__character_count, this.__wrap_point_indent_count = this.__parent.next_line.__indent_count, this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count);
            }, v.prototype._should_wrap = function() {
              return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
            }, v.prototype._allow_wrap = function() {
              if (this._should_wrap()) {
                this.__parent.add_new_line();
                var y = this.__parent.current_line;
                return y.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count), y.__items = this.__items.slice(this.__wrap_point_index), this.__items = this.__items.slice(0, this.__wrap_point_index), y.__character_count += this.__character_count - this.__wrap_point_character_count, this.__character_count = this.__wrap_point_character_count, y.__items[0] === " " && (y.__items.splice(0, 1), --y.__character_count), !0;
              }
              return !1;
            }, v.prototype.is_empty = function() {
              return this.__items.length === 0;
            }, v.prototype.last = function() {
              return this.is_empty() ? null : this.__items[this.__items.length - 1];
            }, v.prototype.push = function(y) {
              this.__items.push(y);
              var T = y.lastIndexOf(`
`);
              T !== -1 ? this.__character_count = y.length - T : this.__character_count += y.length;
            }, v.prototype.pop = function() {
              var y = null;
              return this.is_empty() || (y = this.__items.pop(), this.__character_count -= y.length), y;
            }, v.prototype._remove_indent = function() {
              0 < this.__indent_count && (--this.__indent_count, this.__character_count -= this.__parent.indent_size);
            }, v.prototype._remove_wrap_indent = function() {
              0 < this.__wrap_point_indent_count && --this.__wrap_point_indent_count;
            }, v.prototype.trim = function() {
              for (; this.last() === " "; ) this.__items.pop(), --this.__character_count;
            }, v.prototype.toString = function() {
              var y = "";
              return this.is_empty() ? this.__parent.indent_empty_lines && (y = this.__parent.get_indent_string(this.__indent_count)) : (y = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count), y += this.__items.join("")), y;
            }, E.prototype.get_indent_size = function(y, T) {
              var A = this.__base_string_length;
              return y < 0 && (A = 0), (A += y * this.__indent_size) + (T || 0);
            }, E.prototype.get_indent_string = function(y, T) {
              var A = this.__base_string;
              return T = T || 0, y < 0 && (y = 0, A = ""), T += y * this.__indent_size, this.__ensure_cache(T), A + this.__cache[T];
            }, E.prototype.__ensure_cache = function(y) {
              for (; y >= this.__cache.length; ) this.__add_column();
            }, E.prototype.__add_column = function() {
              var y, T = this.__cache.length, A = "";
              this.__indent_size && T >= this.__indent_size && (T -= (y = Math.floor(T / this.__indent_size)) * this.__indent_size, A = new Array(y + 1).join(this.__indent_string)), T && (A += new Array(T + 1).join(" ")), this.__cache.push(A);
            }, C.prototype.__add_outputline = function() {
              this.previous_line = this.current_line, this.current_line = this.next_line.clone_empty(), this.__lines.push(this.current_line);
            }, C.prototype.get_line_number = function() {
              return this.__lines.length;
            }, C.prototype.get_indent_string = function(y, T) {
              return this.__indent_cache.get_indent_string(y, T);
            }, C.prototype.get_indent_size = function(y, T) {
              return this.__indent_cache.get_indent_size(y, T);
            }, C.prototype.is_empty = function() {
              return !this.previous_line && this.current_line.is_empty();
            }, C.prototype.add_new_line = function(y) {
              return !(this.is_empty() || !y && this.just_added_newline() || (this.raw || this.__add_outputline(), 0));
            }, C.prototype.get_code = function(y) {
              this.trim(!0);
              var T = this.current_line.pop();
              return T && (T[T.length - 1] === `
` && (T = T.replace(/\n+$/g, "")), this.current_line.push(T)), this._end_with_newline && this.__add_outputline(), T = this.__lines.join(`
`), y !== `
` ? T.replace(/[\n]/g, y) : T;
            }, C.prototype.set_wrap_point = function() {
              this.current_line._set_wrap_point();
            }, C.prototype.set_indent = function(y, T) {
              return this.next_line.set_indent(y = y || 0, T = T || 0), 1 < this.__lines.length ? (this.current_line.set_indent(y, T), !0) : (this.current_line.set_indent(), !1);
            }, C.prototype.add_raw_token = function(y) {
              for (var T = 0; T < y.newlines; T++) this.__add_outputline();
              this.current_line.set_indent(-1), this.current_line.push(y.whitespace_before), this.current_line.push(y.text), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1;
            }, C.prototype.add_token = function(y) {
              this.__add_space_before_token(), this.current_line.push(y), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = this.current_line._allow_wrap();
            }, C.prototype.__add_space_before_token = function() {
              this.space_before_token && !this.just_added_newline() && (this.non_breaking_space || this.set_wrap_point(), this.current_line.push(" "));
            }, C.prototype.remove_indent = function(y) {
              for (var T = this.__lines.length; y < T; ) this.__lines[y]._remove_indent(), y++;
              this.current_line._remove_wrap_indent();
            }, C.prototype.trim = function(y) {
              for (y = y !== void 0 && y, this.current_line.trim(); y && 1 < this.__lines.length && this.current_line.is_empty(); ) this.__lines.pop(), this.current_line = this.__lines[this.__lines.length - 1], this.current_line.trim();
              this.previous_line = 1 < this.__lines.length ? this.__lines[this.__lines.length - 2] : null;
            }, C.prototype.just_added_newline = function() {
              return this.current_line.is_empty();
            }, C.prototype.just_added_blankline = function() {
              return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
            }, C.prototype.ensure_empty_line_above = function(y, T) {
              for (var A = this.__lines.length - 2; 0 <= A; ) {
                var k = this.__lines[A];
                if (k.is_empty()) break;
                if (k.item(0).indexOf(y) !== 0 && k.item(-1) !== T) {
                  this.__lines.splice(A + 1, 0, new v(this)), this.previous_line = this.__lines[this.__lines.length - 2];
                  break;
                }
                A--;
              }
            }, b.exports.Output = C;
          }, function(b) {
            b.exports.Token = function(E, C, y, T) {
              this.type = E, this.text = C, this.comments_before = null, this.newlines = y || 0, this.whitespace_before = T || "", this.parent = null, this.next = null, this.previous = null, this.opened = null, this.closed = null, this.directives = null;
            };
          }, , , function(b) {
            function v(y, T) {
              this.raw_options = E(y, T), this.disabled = this._get_boolean("disabled"), this.eol = this._get_characters("eol", "auto"), this.end_with_newline = this._get_boolean("end_with_newline"), this.indent_size = this._get_number("indent_size", 4), this.indent_char = this._get_characters("indent_char", " "), this.indent_level = this._get_number("indent_level"), this.preserve_newlines = this._get_boolean("preserve_newlines", !0), this.max_preserve_newlines = this._get_number("max_preserve_newlines", 32786), this.preserve_newlines || (this.max_preserve_newlines = 0), this.indent_with_tabs = this._get_boolean("indent_with_tabs", this.indent_char === "	"), this.indent_with_tabs && (this.indent_char = "	", this.indent_size === 1 && (this.indent_size = 4)), this.wrap_line_length = this._get_number("wrap_line_length", this._get_number("max_char")), this.indent_empty_lines = this._get_boolean("indent_empty_lines"), this.templating = this._get_selection_list("templating", ["auto", "none", "django", "erb", "handlebars", "php", "smarty"], ["auto"]);
            }
            function E(y, T) {
              var A, k = {};
              for (A in y = C(y)) A !== T && (k[A] = y[A]);
              if (T && y[T]) for (A in y[T]) k[A] = y[T][A];
              return k;
            }
            function C(y) {
              var T, A = {};
              for (T in y) A[T.replace(/-/g, "_")] = y[T];
              return A;
            }
            v.prototype._get_array = function(y, T) {
              return T = T || [], d(y = this.raw_options[y]) === "object" ? y !== null && typeof y.concat == "function" && (T = y.concat()) : typeof y == "string" && (T = y.split(/[^a-zA-Z0-9_\/\-]+/)), T;
            }, v.prototype._get_boolean = function(y, T) {
              return (y = this.raw_options[y]) === void 0 ? !!T : !!y;
            }, v.prototype._get_characters = function(y, T) {
              return T = T || "", typeof (y = this.raw_options[y]) == "string" ? y.replace(/\\r/, "\r").replace(/\\n/, `
`).replace(/\\t/, "	") : T;
            }, v.prototype._get_number = function(y, T) {
              return y = this.raw_options[y], T = parseInt(T, 10), isNaN(T) && (T = 0), y = parseInt(y, 10), isNaN(y) ? T : y;
            }, v.prototype._get_selection = function(y, T, A) {
              if ((A = this._get_selection_list(y, T, A)).length !== 1) throw new Error("Invalid Option Value: The option '" + y + `' can only be one of the following values:
` + T + `
You passed in: '` + this.raw_options[y] + "'");
              return A[0];
            }, v.prototype._get_selection_list = function(y, T, A) {
              if (!T || T.length === 0) throw new Error("Selection list cannot be empty.");
              if (A = A || [T[0]], !this._is_valid_selection(A, T)) throw new Error("Invalid Default Value!");
              if (A = this._get_array(y, A), !this._is_valid_selection(A, T)) throw new Error("Invalid Option Value: The option '" + y + `' can contain only the following values:
` + T + `
You passed in: '` + this.raw_options[y] + "'");
              return A;
            }, v.prototype._is_valid_selection = function(y, T) {
              return y.length && T.length && !y.some(function(A) {
                return T.indexOf(A) === -1;
              });
            }, b.exports.Options = v, b.exports.normalizeOpts = C, b.exports.mergeOpts = E;
          }, , function(b) {
            var v = RegExp.prototype.hasOwnProperty("sticky");
            function E(C) {
              this.__input = C || "", this.__input_length = this.__input.length, this.__position = 0;
            }
            E.prototype.restart = function() {
              this.__position = 0;
            }, E.prototype.back = function() {
              0 < this.__position && --this.__position;
            }, E.prototype.hasNext = function() {
              return this.__position < this.__input_length;
            }, E.prototype.next = function() {
              var C = null;
              return this.hasNext() && (C = this.__input.charAt(this.__position), this.__position += 1), C;
            }, E.prototype.peek = function(C) {
              var y = null;
              return C = C || 0, 0 <= (C += this.__position) && C < this.__input_length ? this.__input.charAt(C) : y;
            }, E.prototype.__match = function(C, y) {
              C.lastIndex = y;
              var T = C.exec(this.__input);
              return !T || v && C.sticky || T.index !== y && (T = null), T;
            }, E.prototype.test = function(C, y) {
              return y = y || 0, 0 <= (y += this.__position) && y < this.__input_length && !!this.__match(C, y);
            }, E.prototype.testChar = function(C, y) {
              return y = this.peek(y), C.lastIndex = 0, y !== null && C.test(y);
            }, E.prototype.match = function(C) {
              return (C = this.__match(C, this.__position)) ? this.__position += C[0].length : C = null, C;
            }, E.prototype.read = function(C, y, T) {
              var A, k = "";
              return C && (A = this.match(C)) && (k += A[0]), !y || !A && C || (k += this.readUntil(y, T)), k;
            }, E.prototype.readUntil = function(C, y) {
              var T = this.__position;
              return C.lastIndex = this.__position, (C = C.exec(this.__input)) ? (T = C.index, y && (T += C[0].length)) : T = this.__input_length, C = this.__input.substring(this.__position, T), this.__position = T, C;
            }, E.prototype.readUntilAfter = function(C) {
              return this.readUntil(C, !0);
            }, E.prototype.get_regexp = function(C, A) {
              var T = null, A = A && v ? "y" : "g";
              return typeof C == "string" && C !== "" ? T = new RegExp(C, A) : C && (T = new RegExp(C.source, A)), T;
            }, E.prototype.get_literal_regexp = function(C) {
              return RegExp(C.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
            }, E.prototype.peekUntilAfter = function(T) {
              var y = this.__position, T = this.readUntilAfter(T);
              return this.__position = y, T;
            }, E.prototype.lookBack = function(C) {
              var y = this.__position - 1;
              return y >= C.length && this.__input.substring(y - C.length, y).toLowerCase() === C;
            }, b.exports.InputScanner = E;
          }, function(b, v, E) {
            var C = E(8).InputScanner, y = E(3).Token, T = E(10).TokenStream, A = E(11).WhitespacePattern, k = { START: "TK_START", RAW: "TK_RAW", EOF: "TK_EOF" };
            (E = function(j, I) {
              this._input = new C(j), this._options = I || {}, this.__tokens = null, this._patterns = {}, this._patterns.whitespace = new A(this._input);
            }).prototype.tokenize = function() {
              var N;
              this._input.restart(), this.__tokens = new T(), this._reset();
              for (var j = new y(k.START, ""), I = null, B = [], U = new T(); j.type !== k.EOF; ) {
                for (N = this._get_next_token(j, I); this._is_comment(N); ) U.add(N), N = this._get_next_token(j, I);
                U.isEmpty() || (N.comments_before = U, U = new T()), N.parent = I, this._is_opening(N) ? (B.push(I), I = N) : I && this._is_closing(N, I) && ((N.opened = I).closed = N, I = B.pop(), N.parent = I), (N.previous = j).next = N, this.__tokens.add(N), j = N;
              }
              return this.__tokens;
            }, E.prototype._is_first_token = function() {
              return this.__tokens.isEmpty();
            }, E.prototype._reset = function() {
            }, E.prototype._get_next_token = function(N, j) {
              this._readWhitespace();
              var I = this._input.read(/.+/g);
              return I ? this._create_token(k.RAW, I) : this._create_token(k.EOF, "");
            }, E.prototype._is_comment = function(N) {
              return !1;
            }, E.prototype._is_opening = function(N) {
              return !1;
            }, E.prototype._is_closing = function(N, j) {
              return !1;
            }, E.prototype._create_token = function(N, j) {
              return new y(N, j, this._patterns.whitespace.newline_count, this._patterns.whitespace.whitespace_before_token);
            }, E.prototype._readWhitespace = function() {
              return this._patterns.whitespace.read();
            }, b.exports.Tokenizer = E, b.exports.TOKEN = k;
          }, function(b) {
            function v(E) {
              this.__tokens = [], this.__tokens_length = this.__tokens.length, this.__position = 0, this.__parent_token = E;
            }
            v.prototype.restart = function() {
              this.__position = 0;
            }, v.prototype.isEmpty = function() {
              return this.__tokens_length === 0;
            }, v.prototype.hasNext = function() {
              return this.__position < this.__tokens_length;
            }, v.prototype.next = function() {
              var E = null;
              return this.hasNext() && (E = this.__tokens[this.__position], this.__position += 1), E;
            }, v.prototype.peek = function(E) {
              var C = null;
              return E = E || 0, 0 <= (E += this.__position) && E < this.__tokens_length ? this.__tokens[E] : C;
            }, v.prototype.add = function(E) {
              this.__parent_token && (E.parent = this.__parent_token), this.__tokens.push(E), this.__tokens_length += 1;
            }, b.exports.TokenStream = v;
          }, function(b, v, E) {
            var C = E(12).Pattern;
            function y(T, A) {
              C.call(this, T, A), A ? this._line_regexp = this._input.get_regexp(A._line_regexp) : this.__set_whitespace_patterns("", ""), this.newline_count = 0, this.whitespace_before_token = "";
            }
            (y.prototype = new C()).__set_whitespace_patterns = function(T, A) {
              this._match_pattern = this._input.get_regexp("[" + (T += "\\t ") + (A += "\\n\\r") + "]+", !0), this._newline_regexp = this._input.get_regexp("\\r\\n|[" + A + "]");
            }, y.prototype.read = function() {
              this.newline_count = 0, this.whitespace_before_token = "";
              var T, A = this._input.read(this._match_pattern);
              return A === " " ? this.whitespace_before_token = " " : A && (T = this.__split(this._newline_regexp, A), this.newline_count = T.length - 1, this.whitespace_before_token = T[this.newline_count]), A;
            }, y.prototype.matching = function(T, A) {
              var k = this._create();
              return k.__set_whitespace_patterns(T, A), k._update(), k;
            }, y.prototype._create = function() {
              return new y(this._input, this);
            }, y.prototype.__split = function(T, A) {
              for (var k = T.lastIndex = 0, N = [], j = T.exec(A); j; ) N.push(A.substring(k, j.index)), k = j.index + j[0].length, j = T.exec(A);
              return k < A.length ? N.push(A.substring(k, A.length)) : N.push(""), N;
            }, b.exports.WhitespacePattern = y;
          }, function(b) {
            function v(E, C) {
              this._input = E, this._starting_pattern = null, this._match_pattern = null, this._until_pattern = null, this._until_after = !1, C && (this._starting_pattern = this._input.get_regexp(C._starting_pattern, !0), this._match_pattern = this._input.get_regexp(C._match_pattern, !0), this._until_pattern = this._input.get_regexp(C._until_pattern), this._until_after = C._until_after);
            }
            v.prototype.read = function() {
              var E = this._input.read(this._starting_pattern);
              return this._starting_pattern && !E || (E += this._input.read(this._match_pattern, this._until_pattern, this._until_after)), E;
            }, v.prototype.read_match = function() {
              return this._input.match(this._match_pattern);
            }, v.prototype.until_after = function(E) {
              var C = this._create();
              return C._until_after = !0, C._until_pattern = this._input.get_regexp(E), C._update(), C;
            }, v.prototype.until = function(E) {
              var C = this._create();
              return C._until_after = !1, C._until_pattern = this._input.get_regexp(E), C._update(), C;
            }, v.prototype.starting_with = function(E) {
              var C = this._create();
              return C._starting_pattern = this._input.get_regexp(E, !0), C._update(), C;
            }, v.prototype.matching = function(E) {
              var C = this._create();
              return C._match_pattern = this._input.get_regexp(E, !0), C._update(), C;
            }, v.prototype._create = function() {
              return new v(this._input, this);
            }, v.prototype._update = function() {
            }, b.exports.Pattern = v;
          }, function(b) {
            function v(E, C) {
              E = typeof E == "string" ? E : E.source, C = typeof C == "string" ? C : C.source, this.__directives_block_pattern = new RegExp(E + / beautify( \w+[:]\w+)+ /.source + C, "g"), this.__directive_pattern = / (\w+)[:](\w+)/g, this.__directives_end_ignore_pattern = new RegExp(E + /\sbeautify\signore:end\s/.source + C, "g");
            }
            v.prototype.get_directives = function(E) {
              if (!E.match(this.__directives_block_pattern)) return null;
              var C = {};
              this.__directive_pattern.lastIndex = 0;
              for (var y = this.__directive_pattern.exec(E); y; ) C[y[1]] = y[2], y = this.__directive_pattern.exec(E);
              return C;
            }, v.prototype.readIgnored = function(E) {
              return E.readUntilAfter(this.__directives_end_ignore_pattern);
            }, b.exports.Directives = v;
          }, function(b, v, E) {
            var C = E(12).Pattern, y = { django: !1, erb: !1, handlebars: !1, php: !1, smarty: !1 };
            function T(A, k) {
              C.call(this, A, k), this.__template_pattern = null, this._disabled = Object.assign({}, y), this._excluded = Object.assign({}, y), k && (this.__template_pattern = this._input.get_regexp(k.__template_pattern), this._excluded = Object.assign(this._excluded, k._excluded), this._disabled = Object.assign(this._disabled, k._disabled)), A = new C(A), this.__patterns = { handlebars_comment: A.starting_with(/{{!--/).until_after(/--}}/), handlebars_unescaped: A.starting_with(/{{{/).until_after(/}}}/), handlebars: A.starting_with(/{{/).until_after(/}}/), php: A.starting_with(/<\?(?:[= ]|php)/).until_after(/\?>/), erb: A.starting_with(/<%[^%]/).until_after(/[^%]%>/), django: A.starting_with(/{%/).until_after(/%}/), django_value: A.starting_with(/{{/).until_after(/}}/), django_comment: A.starting_with(/{#/).until_after(/#}/), smarty: A.starting_with(/{(?=[^}{\s\n])/).until_after(/[^\s\n]}/), smarty_comment: A.starting_with(/{\*/).until_after(/\*}/), smarty_literal: A.starting_with(/{literal}/).until_after(/{\/literal}/) };
            }
            (T.prototype = new C())._create = function() {
              return new T(this._input, this);
            }, T.prototype._update = function() {
              this.__set_templated_pattern();
            }, T.prototype.disable = function(A) {
              var k = this._create();
              return k._disabled[A] = !0, k._update(), k;
            }, T.prototype.read_options = function(A) {
              var k, N = this._create();
              for (k in y) N._disabled[k] = A.templating.indexOf(k) === -1;
              return N._update(), N;
            }, T.prototype.exclude = function(A) {
              var k = this._create();
              return k._excluded[A] = !0, k._update(), k;
            }, T.prototype.read = function() {
              for (var A = "", A = this._match_pattern ? this._input.read(this._starting_pattern) : this._input.read(this._starting_pattern, this.__template_pattern), k = this._read_template(); k; ) this._match_pattern ? k += this._input.read(this._match_pattern) : k += this._input.readUntil(this.__template_pattern), A += k, k = this._read_template();
              return this._until_after && (A += this._input.readUntilAfter(this._until_pattern)), A;
            }, T.prototype.__set_templated_pattern = function() {
              var A = [];
              this._disabled.php || A.push(this.__patterns.php._starting_pattern.source), this._disabled.handlebars || A.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.erb || A.push(this.__patterns.erb._starting_pattern.source), this._disabled.django || (A.push(this.__patterns.django._starting_pattern.source), A.push(this.__patterns.django_value._starting_pattern.source), A.push(this.__patterns.django_comment._starting_pattern.source)), this._disabled.smarty || A.push(this.__patterns.smarty._starting_pattern.source), this._until_pattern && A.push(this._until_pattern.source), this.__template_pattern = this._input.get_regexp("(?:" + A.join("|") + ")");
            }, T.prototype._read_template = function() {
              var A, k = "", N = this._input.peek();
              return N === "<" ? (A = this._input.peek(1), this._disabled.php || this._excluded.php || A !== "?" || (k = k || this.__patterns.php.read()), this._disabled.erb || this._excluded.erb || A !== "%" || (k = k || this.__patterns.erb.read())) : N === "{" && (this._disabled.handlebars || this._excluded.handlebars || (k = (k = (k = k || this.__patterns.handlebars_comment.read()) || this.__patterns.handlebars_unescaped.read()) || this.__patterns.handlebars.read()), this._disabled.django || (this._excluded.django || this._excluded.handlebars || (k = k || this.__patterns.django_value.read()), this._excluded.django || (k = (k = k || this.__patterns.django_comment.read()) || this.__patterns.django.read())), this._disabled.smarty || this._disabled.django && this._disabled.handlebars && (k = (k = (k = k || this.__patterns.smarty_comment.read()) || this.__patterns.smarty_literal.read()) || this.__patterns.smarty.read())), k;
            }, b.exports.TemplatablePattern = T;
          }, , , , function(b, v, E) {
            var C = E(19).Beautifier, y = E(20).Options;
            b.exports = function(A, k, N, j) {
              return new C(A, k, N, j).beautify();
            }, b.exports.defaultOptions = function() {
              return new y();
            };
          }, function(b, v, E) {
            function C($, te) {
              this.indent_level = 0, this.alignment_size = 0, this.max_preserve_newlines = $.max_preserve_newlines, this.preserve_newlines = $.preserve_newlines, this._output = new T($, te);
            }
            var y = E(20).Options, T = E(2).Output, A = E(21).Tokenizer, k = E(21).TOKEN, N = /\r\n|[\r\n]/, j = /\r\n|[\r\n]/g;
            function I($, te) {
              var V = null, K = null;
              return te.closed ? ($ === "script" ? V = "text/javascript" : $ === "style" && (V = "text/css"), -1 < (V = function(J) {
                for (var L = null, z = J.next; z.type !== k.EOF && J.closed !== z; ) {
                  if (z.type === k.ATTRIBUTE && z.text === "type") {
                    z.next && z.next.type === k.EQUALS && z.next.next && z.next.next.type === k.VALUE && (L = z.next.next.text);
                    break;
                  }
                  z = z.next;
                }
                return L;
              }(te) || V).search("text/css") ? K = "css" : -1 < V.search(/module|((text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect))/) ? K = "javascript" : -1 < V.search(/(text|application|dojo)\/(x-)?(html)/) ? K = "html" : -1 < V.search(/test\/null/) && (K = "null"), K) : null;
            }
            function B($, te) {
              return te.indexOf($) !== -1;
            }
            function U($, te, V) {
              this.parent = $ || null, this.tag = te ? te.tag_name : "", this.indent_level = V || 0, this.parser_token = te || null;
            }
            function H($) {
              this._printer = $, this._current_frame = null;
            }
            function Q($, te, V, K) {
              this._source_text = $ || "", te = te || {}, this._js_beautify = V, this._css_beautify = K, this._tag_stack = null, te = new y(te, "html"), this._options = te, this._is_wrap_attributes_force = this._options.wrap_attributes.substr(0, 5) === "force", this._is_wrap_attributes_force_expand_multiline = this._options.wrap_attributes === "force-expand-multiline", this._is_wrap_attributes_force_aligned = this._options.wrap_attributes === "force-aligned", this._is_wrap_attributes_aligned_multiple = this._options.wrap_attributes === "aligned-multiple", this._is_wrap_attributes_preserve = this._options.wrap_attributes.substr(0, 8) === "preserve", this._is_wrap_attributes_preserve_aligned = this._options.wrap_attributes === "preserve-aligned";
            }
            C.prototype.current_line_has_match = function($) {
              return this._output.current_line.has_match($);
            }, C.prototype.set_space_before_token = function($, te) {
              this._output.space_before_token = $, this._output.non_breaking_space = te;
            }, C.prototype.set_wrap_point = function() {
              this._output.set_indent(this.indent_level, this.alignment_size), this._output.set_wrap_point();
            }, C.prototype.add_raw_token = function($) {
              this._output.add_raw_token($);
            }, C.prototype.print_preserved_newlines = function($) {
              var te = 0;
              $.type !== k.TEXT && $.previous.type !== k.TEXT && (te = $.newlines ? 1 : 0), this.preserve_newlines && (te = $.newlines < this.max_preserve_newlines + 1 ? $.newlines : this.max_preserve_newlines + 1);
              for (var V = 0; V < te; V++) this.print_newline(0 < V);
              return te !== 0;
            }, C.prototype.traverse_whitespace = function($) {
              return !(!$.whitespace_before && !$.newlines || (this.print_preserved_newlines($) || (this._output.space_before_token = !0), 0));
            }, C.prototype.previous_token_wrapped = function() {
              return this._output.previous_token_wrapped;
            }, C.prototype.print_newline = function($) {
              this._output.add_new_line($);
            }, C.prototype.print_token = function($) {
              $.text && (this._output.set_indent(this.indent_level, this.alignment_size), this._output.add_token($.text));
            }, C.prototype.indent = function() {
              this.indent_level++;
            }, C.prototype.get_full_indent = function($) {
              return ($ = this.indent_level + ($ || 0)) < 1 ? "" : this._output.get_indent_string($);
            }, H.prototype.get_parser_token = function() {
              return this._current_frame ? this._current_frame.parser_token : null;
            }, H.prototype.record_tag = function($) {
              $ = new U(this._current_frame, $, this._printer.indent_level), this._current_frame = $;
            }, H.prototype._try_pop_frame = function($) {
              var te = null;
              return $ && (te = $.parser_token, this._printer.indent_level = $.indent_level, this._current_frame = $.parent), te;
            }, H.prototype._get_frame = function($, te) {
              for (var V = this._current_frame; V && $.indexOf(V.tag) === -1; ) {
                if (te && te.indexOf(V.tag) !== -1) {
                  V = null;
                  break;
                }
                V = V.parent;
              }
              return V;
            }, H.prototype.try_pop = function($, te) {
              return te = this._get_frame([$], te), this._try_pop_frame(te);
            }, H.prototype.indent_to_tag = function($) {
              ($ = this._get_frame($)) && (this._printer.indent_level = $.indent_level);
            }, Q.prototype.beautify = function() {
              if (this._options.disabled) return this._source_text;
              var $ = this._source_text, te = this._options.eol;
              this._options.eol === "auto" && (te = `
`, $ && N.test($) && (te = $.match(N)[0]));
              var V = ($ = $.replace(j, `
`)).match(/^[\t ]*/)[0], K = { text: "", type: "" }, ne = new Y(), J = new C(this._options, V), L = new A($, this._options).tokenize();
              this._tag_stack = new H(J);
              for (var z = null, ee = L.next(); ee.type !== k.EOF; ) ee.type === k.TAG_OPEN || ee.type === k.COMMENT ? ne = z = this._handle_tag_open(J, ee, ne, K, L) : ee.type === k.ATTRIBUTE || ee.type === k.EQUALS || ee.type === k.VALUE || ee.type === k.TEXT && !ne.tag_complete ? z = this._handle_inside_tag(J, ee, ne, K) : ee.type === k.TAG_CLOSE ? z = this._handle_tag_close(J, ee, ne) : ee.type === k.TEXT ? z = this._handle_text(J, ee, ne) : J.add_raw_token(ee), K = z, ee = L.next();
              return J._output.get_code(te);
            }, Q.prototype._handle_tag_close = function($, te, V) {
              var K = { text: te.text, type: te.type };
              return $.alignment_size = 0, V.tag_complete = !0, $.set_space_before_token(te.newlines || te.whitespace_before !== "", !0), V.is_unformatted ? $.add_raw_token(te) : (V.tag_start_char === "<" && ($.set_space_before_token(te.text[0] === "/", !0), this._is_wrap_attributes_force_expand_multiline && V.has_wrapped_attrs && $.print_newline(!1)), $.print_token(te)), !V.indent_content || V.is_unformatted || V.is_content_unformatted || ($.indent(), V.indent_content = !1), V.is_inline_element || V.is_unformatted || V.is_content_unformatted || $.set_wrap_point(), K;
            }, Q.prototype._handle_inside_tag = function($, te, V, K) {
              var ne = V.has_wrapped_attrs, J = { text: te.text, type: te.type };
              return $.set_space_before_token(te.newlines || te.whitespace_before !== "", !0), V.is_unformatted ? $.add_raw_token(te) : V.tag_start_char === "{" && te.type === k.TEXT ? $.print_preserved_newlines(te) ? (te.newlines = 0, $.add_raw_token(te)) : $.print_token(te) : (te.type === k.ATTRIBUTE ? $.set_space_before_token(!0) : (te.type === k.EQUALS || te.type === k.VALUE && te.previous.type === k.EQUALS) && $.set_space_before_token(!1), te.type === k.ATTRIBUTE && V.tag_start_char === "<" && ((this._is_wrap_attributes_preserve || this._is_wrap_attributes_preserve_aligned) && ($.traverse_whitespace(te), ne = ne || te.newlines !== 0), this._is_wrap_attributes_force && V.attr_count >= this._options.wrap_attributes_min_attrs && (K.type !== k.TAG_OPEN || this._is_wrap_attributes_force_expand_multiline) && ($.print_newline(!1), ne = !0)), $.print_token(te), ne = ne || $.previous_token_wrapped(), V.has_wrapped_attrs = ne), J;
            }, Q.prototype._handle_text = function($, te, V) {
              var K = { text: te.text, type: "TK_CONTENT" };
              return V.custom_beautifier_name ? this._print_custom_beatifier_text($, te, V) : V.is_unformatted || V.is_content_unformatted ? $.add_raw_token(te) : ($.traverse_whitespace(te), $.print_token(te)), K;
            }, Q.prototype._print_custom_beatifier_text = function($, te, V) {
              var K = this;
              if (te.text !== "") {
                var ne, q = te.text, ee = 1, J = "", L = "";
                V.custom_beautifier_name === "javascript" && typeof this._js_beautify == "function" ? ne = this._js_beautify : V.custom_beautifier_name === "css" && typeof this._css_beautify == "function" ? ne = this._css_beautify : V.custom_beautifier_name === "html" && (ne = function(oe, ae) {
                  return new Q(oe, ae, K._js_beautify, K._css_beautify).beautify();
                }), this._options.indent_scripts === "keep" ? ee = 0 : this._options.indent_scripts === "separate" && (ee = -$.indent_level);
                var z, ee = $.get_full_indent(ee), q = q.replace(/\n[ \t]*$/, "");
                if (V.custom_beautifier_name !== "html" && q[0] === "<" && q.match(/^(<!--|<!\[CDATA\[)/)) {
                  if (!(V = /^(<!--[^\n]*|<!\[CDATA\[)(\n?)([ \t\n]*)([\s\S]*)(-->|]]>)$/.exec(q))) return void $.add_raw_token(te);
                  J = ee + V[1] + `
`, q = V[4], V[5] && (L = ee + V[5]), q = q.replace(/\n[ \t]*$/, ""), (V[2] || V[3].indexOf(`
`) !== -1) && (V = V[3].match(/[ \t]+$/)) && (te.whitespace_before = V[0]);
                }
                q = q && (ne ? ((z = function() {
                  this.eol = `
`;
                }).prototype = this._options.raw_options, ne(ee + q, new z())) : ee + (q = (z = te.whitespace_before) ? q.replace(new RegExp(`
(` + z + ")?", "g"), `
`) : q).replace(/\n/g, `
` + ee)), J && (q = q ? J + q + `
` + L : J + L), $.print_newline(!1), q && (te.text = q, te.whitespace_before = "", te.newlines = 0, $.add_raw_token(te), $.print_newline(!0));
              }
            }, Q.prototype._handle_tag_open = function($, te, V, K, ne) {
              var J = this._get_tag_open_token(te);
              if (!V.is_unformatted && !V.is_content_unformatted || V.is_empty_element || te.type !== k.TAG_OPEN || J.is_start_tag ? ($.traverse_whitespace(te), this._set_tag_position($, te, J, V, K), J.is_inline_element || $.set_wrap_point(), $.print_token(te)) : ($.add_raw_token(te), J.start_tag_token = this._tag_stack.try_pop(J.tag_name)), J.is_start_tag && this._is_wrap_attributes_force) for (var L, z = 0; (L = ne.peek(z)).type === k.ATTRIBUTE && (J.attr_count += 1), z += 1, L.type !== k.EOF && L.type !== k.TAG_CLOSE; ) ;
              return (this._is_wrap_attributes_force_aligned || this._is_wrap_attributes_aligned_multiple || this._is_wrap_attributes_preserve_aligned) && (J.alignment_size = te.text.length + 1), J.tag_complete || J.is_unformatted || ($.alignment_size = J.alignment_size), J;
            };
            var Y = function(te, V) {
              var K;
              this.parent = te || null, this.text = "", this.type = "TK_TAG_OPEN", this.tag_name = "", this.is_inline_element = !1, this.is_unformatted = !1, this.is_content_unformatted = !1, this.is_empty_element = !1, this.is_start_tag = !1, this.is_end_tag = !1, this.indent_content = !1, this.multiline_content = !1, this.custom_beautifier_name = null, this.start_tag_token = null, this.attr_count = 0, this.has_wrapped_attrs = !1, this.alignment_size = 0, this.tag_complete = !1, this.tag_start_char = "", this.tag_check = "", V ? (this.tag_start_char = V.text[0], this.text = V.text, this.tag_start_char === "<" ? (K = V.text.match(/^<([^\s>]*)/), this.tag_check = K ? K[1] : "") : (K = V.text.match(/^{{~?(?:[\^]|#\*?)?([^\s}]+)/), this.tag_check = K ? K[1] : "", (V.text.startsWith("{{#>") || V.text.startsWith("{{~#>")) && this.tag_check[0] === ">" && (this.tag_check === ">" && V.next !== null ? this.tag_check = V.next.text.split(" ")[0] : this.tag_check = V.text.split(">")[1])), this.tag_check = this.tag_check.toLowerCase(), V.type === k.COMMENT && (this.tag_complete = !0), this.is_start_tag = this.tag_check.charAt(0) !== "/", this.tag_name = this.is_start_tag ? this.tag_check : this.tag_check.substr(1), this.is_end_tag = !this.is_start_tag || V.closed && V.closed.text === "/>", V = 2, this.tag_start_char === "{" && 3 <= this.text.length && this.text.charAt(2) === "~" && (V = 3), this.is_end_tag = this.is_end_tag || this.tag_start_char === "{" && (this.text.length < 3 || /[^#\^]/.test(this.text.charAt(V)))) : this.tag_complete = !0;
            };
            Q.prototype._get_tag_open_token = function($) {
              return ($ = new Y(this._tag_stack.get_parser_token(), $)).alignment_size = this._options.wrap_attributes_indent_size, $.is_end_tag = $.is_end_tag || B($.tag_check, this._options.void_elements), $.is_empty_element = $.tag_complete || $.is_start_tag && $.is_end_tag, $.is_unformatted = !$.tag_complete && B($.tag_check, this._options.unformatted), $.is_content_unformatted = !$.is_empty_element && B($.tag_check, this._options.content_unformatted), $.is_inline_element = B($.tag_name, this._options.inline) || this._options.inline_custom_elements && $.tag_name.includes("-") || $.tag_start_char === "{", $;
            }, Q.prototype._set_tag_position = function($, te, V, K, ne) {
              V.is_empty_element || (V.is_end_tag ? V.start_tag_token = this._tag_stack.try_pop(V.tag_name) : (this._do_optional_end_element(V) && (V.is_inline_element || $.print_newline(!1)), this._tag_stack.record_tag(V), V.tag_name !== "script" && V.tag_name !== "style" || V.is_unformatted || V.is_content_unformatted || (V.custom_beautifier_name = I(V.tag_check, te)))), B(V.tag_check, this._options.extra_liners) && ($.print_newline(!1), $._output.just_added_blankline() || $.print_newline(!0)), V.is_empty_element ? (V.tag_start_char === "{" && V.tag_check === "else" && (this._tag_stack.indent_to_tag(["if", "unless", "each"]), V.indent_content = !0, $.current_line_has_match(/{{#if/) || $.print_newline(!1)), V.tag_name === "!--" && ne.type === k.TAG_CLOSE && K.is_end_tag && V.text.indexOf(`
`) === -1 || (V.is_inline_element || V.is_unformatted || $.print_newline(!1), this._calcluate_parent_multiline($, V))) : V.is_end_tag ? (te = !1, te = (te = V.start_tag_token && V.start_tag_token.multiline_content) || !V.is_inline_element && !(K.is_inline_element || K.is_unformatted) && !(ne.type === k.TAG_CLOSE && V.start_tag_token === K) && ne.type !== "TK_CONTENT", (te = !V.is_content_unformatted && !V.is_unformatted && te) && $.print_newline(!1)) : (V.indent_content = !V.custom_beautifier_name, V.tag_start_char === "<" && (V.tag_name === "html" ? V.indent_content = this._options.indent_inner_html : V.tag_name === "head" ? V.indent_content = this._options.indent_head_inner_html : V.tag_name === "body" && (V.indent_content = this._options.indent_body_inner_html)), V.is_inline_element || V.is_unformatted || ne.type === "TK_CONTENT" && !V.is_content_unformatted || $.print_newline(!1), this._calcluate_parent_multiline($, V));
            }, Q.prototype._calcluate_parent_multiline = function($, te) {
              !te.parent || !$._output.just_added_newline() || (te.is_inline_element || te.is_unformatted) && te.parent.is_inline_element || (te.parent.multiline_content = !0);
            };
            var ie = ["address", "article", "aside", "blockquote", "details", "div", "dl", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hr", "main", "menu", "nav", "ol", "p", "pre", "section", "table", "ul"], ce = ["a", "audio", "del", "ins", "map", "noscript", "video"];
            Q.prototype._do_optional_end_element = function($) {
              var te, V = null;
              if (!$.is_empty_element && $.is_start_tag && $.parent) return $.tag_name === "body" ? V = V || this._tag_stack.try_pop("head") : $.tag_name === "li" ? V = V || this._tag_stack.try_pop("li", ["ol", "ul", "menu"]) : $.tag_name === "dd" || $.tag_name === "dt" ? V = (V = V || this._tag_stack.try_pop("dt", ["dl"])) || this._tag_stack.try_pop("dd", ["dl"]) : $.parent.tag_name === "p" && ie.indexOf($.tag_name) !== -1 ? (te = $.parent.parent) && ce.indexOf(te.tag_name) !== -1 || (V = V || this._tag_stack.try_pop("p")) : $.tag_name === "rp" || $.tag_name === "rt" ? V = (V = V || this._tag_stack.try_pop("rt", ["ruby", "rtc"])) || this._tag_stack.try_pop("rp", ["ruby", "rtc"]) : $.tag_name === "optgroup" ? V = V || this._tag_stack.try_pop("optgroup", ["select"]) : $.tag_name === "option" ? V = V || this._tag_stack.try_pop("option", ["select", "datalist", "optgroup"]) : $.tag_name === "colgroup" ? V = V || this._tag_stack.try_pop("caption", ["table"]) : $.tag_name === "thead" ? V = (V = V || this._tag_stack.try_pop("caption", ["table"])) || this._tag_stack.try_pop("colgroup", ["table"]) : $.tag_name === "tbody" || $.tag_name === "tfoot" ? V = (V = (V = (V = V || this._tag_stack.try_pop("caption", ["table"])) || this._tag_stack.try_pop("colgroup", ["table"])) || this._tag_stack.try_pop("thead", ["table"])) || this._tag_stack.try_pop("tbody", ["table"]) : $.tag_name === "tr" ? V = (V = (V = V || this._tag_stack.try_pop("caption", ["table"])) || this._tag_stack.try_pop("colgroup", ["table"])) || this._tag_stack.try_pop("tr", ["table", "thead", "tbody", "tfoot"]) : $.tag_name !== "th" && $.tag_name !== "td" || (V = (V = V || this._tag_stack.try_pop("td", ["table", "thead", "tbody", "tfoot", "tr"])) || this._tag_stack.try_pop("th", ["table", "thead", "tbody", "tfoot", "tr"])), $.parent = this._tag_stack.get_parser_token(), V;
            }, b.exports.Beautifier = Q;
          }, function(b, v, E) {
            var C = E(6).Options;
            function y(T) {
              C.call(this, T, "html"), this.templating.length === 1 && this.templating[0] === "auto" && (this.templating = ["django", "erb", "handlebars", "php"]), this.indent_inner_html = this._get_boolean("indent_inner_html"), this.indent_body_inner_html = this._get_boolean("indent_body_inner_html", !0), this.indent_head_inner_html = this._get_boolean("indent_head_inner_html", !0), this.indent_handlebars = this._get_boolean("indent_handlebars", !0), this.wrap_attributes = this._get_selection("wrap_attributes", ["auto", "force", "force-aligned", "force-expand-multiline", "aligned-multiple", "preserve", "preserve-aligned"]), this.wrap_attributes_min_attrs = this._get_number("wrap_attributes_min_attrs", 2), this.wrap_attributes_indent_size = this._get_number("wrap_attributes_indent_size", this.indent_size), this.extra_liners = this._get_array("extra_liners", ["head", "body", "/html"]), this.inline = this._get_array("inline", ["a", "abbr", "area", "audio", "b", "bdi", "bdo", "br", "button", "canvas", "cite", "code", "data", "datalist", "del", "dfn", "em", "embed", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "map", "mark", "math", "meter", "noscript", "object", "output", "progress", "q", "ruby", "s", "samp", "select", "small", "span", "strong", "sub", "sup", "svg", "template", "textarea", "time", "u", "var", "video", "wbr", "text", "acronym", "big", "strike", "tt"]), this.inline_custom_elements = this._get_boolean("inline_custom_elements", !0), this.void_elements = this._get_array("void_elements", ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr", "!doctype", "?xml", "basefont", "isindex"]), this.unformatted = this._get_array("unformatted", []), this.content_unformatted = this._get_array("content_unformatted", ["pre", "textarea"]), this.unformatted_content_delimiter = this._get_characters("unformatted_content_delimiter"), this.indent_scripts = this._get_selection("indent_scripts", ["normal", "keep", "separate"]);
            }
            y.prototype = new C(), b.exports.Options = y;
          }, function(b, v, E) {
            var C = E(9).Tokenizer, y = E(9).TOKEN, T = E(13).Directives, A = E(14).TemplatablePattern, k = E(12).Pattern, N = { TAG_OPEN: "TK_TAG_OPEN", TAG_CLOSE: "TK_TAG_CLOSE", ATTRIBUTE: "TK_ATTRIBUTE", EQUALS: "TK_EQUALS", VALUE: "TK_VALUE", COMMENT: "TK_COMMENT", TEXT: "TK_TEXT", UNKNOWN: "TK_UNKNOWN", START: y.START, RAW: y.RAW, EOF: y.EOF }, j = new T(/<\!--/, /-->/);
            ((T = function(B, U) {
              C.call(this, B, U), this._current_tag_name = "", B = new A(this._input).read_options(this._options), U = new k(this._input), this.__patterns = { word: B.until(/[\n\r\t <]/), single_quote: B.until_after(/'/), double_quote: B.until_after(/"/), attribute: B.until(/[\n\r\t =>]|\/>/), element_name: B.until(/[\n\r\t >\/]/), handlebars_comment: U.starting_with(/{{!--/).until_after(/--}}/), handlebars: U.starting_with(/{{/).until_after(/}}/), handlebars_open: U.until(/[\n\r\t }]/), handlebars_raw_close: U.until(/}}/), comment: U.starting_with(/<!--/).until_after(/-->/), cdata: U.starting_with(/<!\[CDATA\[/).until_after(/]]>/), conditional_comment: U.starting_with(/<!\[/).until_after(/]>/), processing: U.starting_with(/<\?/).until_after(/\?>/) }, this._options.indent_handlebars && (this.__patterns.word = this.__patterns.word.exclude("handlebars")), this._unformatted_content_delimiter = null, this._options.unformatted_content_delimiter && (B = this._input.get_literal_regexp(this._options.unformatted_content_delimiter), this.__patterns.unformatted_content_delimiter = U.matching(B).until_after(B));
            }).prototype = new C())._is_comment = function(I) {
              return !1;
            }, T.prototype._is_opening = function(I) {
              return I.type === N.TAG_OPEN;
            }, T.prototype._is_closing = function(I, B) {
              return I.type === N.TAG_CLOSE && B && ((I.text === ">" || I.text === "/>") && B.text[0] === "<" || I.text === "}}" && B.text[0] === "{" && B.text[1] === "{");
            }, T.prototype._reset = function() {
              this._current_tag_name = "";
            }, T.prototype._get_next_token = function(I, B) {
              this._readWhitespace();
              var U = this._input.peek();
              return U === null ? this._create_token(N.EOF, "") : this._read_open_handlebars(U, B) || this._read_attribute(U, I, B) || this._read_close(U, B) || this._read_raw_content(U, I, B) || this._read_content_word(U) || this._read_comment_or_cdata(U) || this._read_processing(U) || this._read_open(U, B) || this._create_token(N.UNKNOWN, this._input.next());
            }, T.prototype._read_comment_or_cdata = function(I) {
              var B = null, U = null, H = null;
              return I === "<" && (this._input.peek(1) === "!" && ((U = this.__patterns.comment.read()) ? (H = j.get_directives(U)) && H.ignore === "start" && (U += j.readIgnored(this._input)) : U = this.__patterns.cdata.read()), U && ((B = this._create_token(N.COMMENT, U)).directives = H)), B;
            }, T.prototype._read_processing = function(I) {
              var B = null, U = null;
              return I !== "<" || (U = (I = this._input.peek(1)) === "!" || I === "?" ? (U = this.__patterns.conditional_comment.read()) || this.__patterns.processing.read() : U) && ((B = this._create_token(N.COMMENT, U)).directives = null), B;
            }, T.prototype._read_open = function(I, B) {
              var U = null, H = null;
              return B || I === "<" && (U = this._input.next(), this._input.peek() === "/" && (U += this._input.next()), U += this.__patterns.element_name.read(), H = this._create_token(N.TAG_OPEN, U)), H;
            }, T.prototype._read_open_handlebars = function(I, B) {
              var U = null, H = null;
              return B || this._options.indent_handlebars && I === "{" && this._input.peek(1) === "{" && (H = this._input.peek(2) === "!" ? (U = (U = this.__patterns.handlebars_comment.read()) || this.__patterns.handlebars.read(), this._create_token(N.COMMENT, U)) : (U = this.__patterns.handlebars_open.read(), this._create_token(N.TAG_OPEN, U))), H;
            }, T.prototype._read_close = function(I, B) {
              var U = null, H = null;
              return B && (B.text[0] === "<" && (I === ">" || I === "/" && this._input.peek(1) === ">") ? (U = this._input.next(), I === "/" && (U += this._input.next()), H = this._create_token(N.TAG_CLOSE, U)) : B.text[0] === "{" && I === "}" && this._input.peek(1) === "}" && (this._input.next(), this._input.next(), H = this._create_token(N.TAG_CLOSE, "}}"))), H;
            }, T.prototype._read_attribute = function(I, B, U) {
              var H = null;
              return U && U.text[0] === "<" && (I === "=" ? H = this._create_token(N.EQUALS, this._input.next()) : I === '"' || I === "'" ? (U = this._input.next(), U += (I === '"' ? this.__patterns.double_quote : this.__patterns.single_quote).read(), H = this._create_token(N.VALUE, U)) : (U = this.__patterns.attribute.read()) && (H = B.type === N.EQUALS ? this._create_token(N.VALUE, U) : this._create_token(N.ATTRIBUTE, U))), H;
            }, T.prototype._is_content_unformatted = function(I) {
              return this._options.void_elements.indexOf(I) === -1 && (this._options.content_unformatted.indexOf(I) !== -1 || this._options.unformatted.indexOf(I) !== -1);
            }, T.prototype._read_raw_content = function(I, B, U) {
              var H = "";
              if (U && U.text[0] === "{") H = this.__patterns.handlebars_raw_close.read();
              else if (B.type === N.TAG_CLOSE && B.opened.text[0] === "<" && B.text[0] !== "/") if ((B = B.opened.text.substr(1).toLowerCase()) === "script" || B === "style") {
                if (I = this._read_comment_or_cdata(I)) return I.type = N.TEXT, I;
                H = this._input.readUntil(new RegExp("</" + B + "[\\n\\r\\t ]*?>", "ig"));
              } else this._is_content_unformatted(B) && (H = this._input.readUntil(new RegExp("</" + B + "[\\n\\r\\t ]*?>", "ig")));
              return H ? this._create_token(N.TEXT, H) : null;
            }, T.prototype._read_content_word = function(I) {
              var B = "";
              if (B = (B = this._options.unformatted_content_delimiter && I === this._options.unformatted_content_delimiter[0] ? this.__patterns.unformatted_content_delimiter.read() : B) || this.__patterns.word.read()) return this._create_token(N.TEXT, B);
            }, b.exports.Tokenizer = T, b.exports.TOKEN = N;
          }], g = {}, _ = function b(v) {
            var E = g[v];
            return E !== void 0 || (E = g[v] = { exports: {} }, p[v](E, E.exports, b)), E.exports;
          }(18);
          f = _;
        })();
        var h = f;
        l = [r, r(122), r(123)], (l = (function(p) {
          var g = r(122), _ = r(123);
          return { html_beautify: function(v, E) {
            return h(v, E, g.js_beautify, _.css_beautify);
          } };
        }).apply(s, l)) === void 0 || (a.exports = l);
      })();
    }, function(a, s, r) {
      function l(Se) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(he) {
          return typeof he;
        } : function(he) {
          return he && typeof Symbol == "function" && he.constructor === Symbol && he !== Symbol.prototype ? "symbol" : typeof he;
        })(Se);
      }
      var d = r(363), f = r(456).decode, h = r(457).HTMLParser, p = r(458), g = r(472), _ = r(473), b = r(215);
      function v(Se) {
        return Se && Se.replace(/^[ \n\r\t\f]+/, "").replace(/[ \n\r\t\f]+$/, "");
      }
      function E(Se) {
        return Se && Se.replace(/[ \n\r\t\f\xA0]+/g, function(he) {
          return he === "	" ? "	" : he.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
        });
      }
      function C(Se, he, Te, Me, Ye) {
        var et = "", dt = "";
        return he.preserveLineBreaks && (Se = Se.replace(/^[ \n\r\t\f]*?[\n\r][ \n\r\t\f]*/, function() {
          return et = `
`, "";
        }).replace(/[ \n\r\t\f]*?[\n\r][ \n\r\t\f]*$/, function() {
          return dt = `
`, "";
        })), Te && (Se = Se.replace(/^[ \n\r\t\f\xA0]+/, function(We) {
          var nt = !et && he.conservativeCollapse;
          return nt && We === "	" ? "	" : We.replace(/^[^\xA0]+/, "").replace(/(\xA0+)[^\xA0]+/g, "$1 ") || (nt ? " " : "");
        })), Me && (Se = Se.replace(/[ \n\r\t\f\xA0]+$/, function(We) {
          var nt = !dt && he.conservativeCollapse;
          return nt && We === "	" ? "	" : We.replace(/[^\xA0]+(\xA0+)/g, " $1").replace(/[^\xA0]+$/, "") || (nt ? " " : "");
        })), Ye && (Se = E(Se)), et + Se + dt;
      }
      var y = (r = b.createMapFromString)("a,abbr,acronym,b,bdi,bdo,big,button,cite,code,del,dfn,em,font,i,ins,kbd,label,mark,math,nobr,object,q,rp,rt,rtc,ruby,s,samp,select,small,span,strike,strong,sub,sup,svg,textarea,time,tt,u,var"), T = r("a,abbr,acronym,b,big,del,em,font,i,ins,kbd,mark,nobr,rp,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var"), A = r("comment,img,input,wbr");
      function k(Se, he, Te, Me) {
        var Ye = he && !A(he);
        Ye && !Me.collapseInlineTagWhitespace && (Ye = he.charAt(0) === "/" ? !y(he.slice(1)) : !T(he));
        var et = Te && !A(Te);
        return C(Se, Me, Ye, et = et && !Me.collapseInlineTagWhitespace ? Te.charAt(0) === "/" ? !T(Te.slice(1)) : !y(Te) : et, he && Te);
      }
      function N(Se, he) {
        for (var Te = Se.length; Te--; ) if (Se[Te].name.toLowerCase() === he) return 1;
      }
      var j = b.createMap(["text/javascript", "text/ecmascript", "text/jscript", "application/javascript", "application/x-javascript", "application/ecmascript"]);
      function I(Se) {
        return (Se = v(Se.split(/;/, 2)[0]).toLowerCase()) === "" || j(Se);
      }
      function B(Se) {
        return (Se = v(Se).toLowerCase()) === "" || Se === "text/css";
      }
      function U(Se, he) {
        if (Se === "style") {
          for (var Te = 0, Me = he.length; Te < Me; Te++) if (he[Te].name.toLowerCase() === "type") return B(he[Te].value);
          return 1;
        }
      }
      var H = r("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"), Q = r("true,false");
      function Y(Se, he, Te) {
        if (Se === "link") {
          for (var Me = 0, Ye = he.length; Me < Ye; Me++) if (he[Me].name === "rel" && he[Me].value === Te) return 1;
        }
      }
      var ie = r("img,source");
      function ce(Se) {
        return "/* clean-css ignore:start */" + Se + "/* clean-css ignore:end */";
      }
      function $(Se, he) {
        switch (he) {
          case "inline":
            return "*{" + Se + "}";
          case "media":
            return "@media " + Se + "{a{top:0}}";
          default:
            return Se;
        }
      }
      var te = r("html,head,body,colgroup,tbody"), V = r("html,head,body,li,dt,dd,p,rb,rt,rtc,rp,optgroup,option,colgroup,caption,thead,tbody,tfoot,tr,td,th"), K = r("meta,link,script,style,template,noscript"), ne = r("dt,dd"), J = r("address,article,aside,blockquote,details,div,dl,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,main,menu,nav,ol,p,pre,section,table,ul"), L = r("a,audio,del,ins,map,noscript,video"), z = r("rb,rt,rtc,rp"), ee = r("rb,rtc,rp"), q = r("option,optgroup"), X = r("tbody,tfoot"), oe = r("thead,tbody,tfoot"), ae = r("td,th"), _e = r("html,head,body"), ve = r("html,body"), Ee = r("head,colgroup,caption"), we = r("dt,thead"), ze = r("a,abbr,acronym,address,applet,area,article,aside,audio,b,base,basefont,bdi,bdo,bgsound,big,blink,blockquote,body,br,button,canvas,caption,center,cite,code,col,colgroup,command,content,data,datalist,dd,del,details,dfn,dialog,dir,div,dl,dt,element,em,embed,fieldset,figcaption,figure,font,footer,form,frame,frameset,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,i,iframe,image,img,input,ins,isindex,kbd,keygen,label,legend,li,link,listing,main,map,mark,marquee,menu,menuitem,meta,meter,multicol,nav,nobr,noembed,noframes,noscript,object,ol,optgroup,option,output,p,param,picture,plaintext,pre,progress,q,rb,rp,rt,rtc,ruby,s,samp,script,section,select,shadow,small,source,spacer,span,strike,strong,style,sub,summary,sup,table,tbody,td,template,textarea,tfoot,th,thead,time,title,tr,track,tt,u,ul,var,video,wbr,xmp"), Ie = new RegExp("^(?:class|id|style|title|lang|dir|on(?:focus|blur|change|click|dblclick|mouse(?:down|up|over|move|out)|key(?:press|down|up)))$");
      function je(Se, he) {
        for (var Te = he.length - 1; 0 <= Te; Te--) if (he[Te].name === Se) return 1;
      }
      function qe(Se) {
        return !/^(?:script|style|pre|textarea)$/.test(Se);
      }
      function Ge(Se) {
        return !/^(?:pre|textarea)$/.test(Se);
      }
      function Ze(Se, he, Te, Me) {
        var Ye = Me.name(Se.name), et = Se.value;
        if (Me.decodeEntities && et && (et = f(et, { isAttributeValue: !0 })), !(Me.removeRedundantAttributes && function(We, nt, ft, At) {
          return ft = ft ? v(ft.toLowerCase()) : "", We === "script" && nt === "language" && ft === "javascript" || We === "form" && nt === "method" && ft === "get" || We === "input" && nt === "type" && ft === "text" || We === "script" && nt === "charset" && !N(At, "src") || We === "a" && nt === "name" && N(At, "id") || We === "area" && nt === "shape" && ft === "rect";
        }(Te, Ye, et, he) || Me.removeScriptTypeAttributes && Te === "script" && Ye === "type" && I(et) || Me.removeStyleLinkTypeAttributes && (Te === "style" || Te === "link") && Ye === "type" && B(et) || (et = et && function(We, nt, ft, At, ln) {
          if (function(zt, kt) {
            var Ft = kt.customEventAttributes;
            if (!Ft) return /^on[a-z]{3,}$/.test(zt);
            for (var ar = Ft.length; ar--; ) if (Ft[ar].test(zt)) return 1;
          }(nt, At)) return ft = v(ft).replace(/^javascript:\s*/i, ""), At.minifyJS(ft, !0);
          if (nt === "class") return ft = v(ft), At.sortClassName ? At.sortClassName(ft) : E(ft);
          if (function(zt, kt) {
            return /^(?:a|area|link|base)$/.test(kt) && zt === "href" || kt === "img" && /^(?:src|longdesc|usemap)$/.test(zt) || kt === "object" && /^(?:classid|codebase|data|usemap)$/.test(zt) || kt === "q" && zt === "cite" || kt === "blockquote" && zt === "cite" || (kt === "ins" || kt === "del") && zt === "cite" || kt === "form" && zt === "action" || kt === "input" && (zt === "src" || zt === "usemap") || kt === "head" && zt === "profile" || kt === "script" && (zt === "src" || zt === "for");
          }(nt, We)) return ft = v(ft), Y(We, ln, "canonical") ? ft : At.minifyURLs(ft);
          if (function(zt, kt) {
            return /^(?:a|area|object|button)$/.test(kt) && zt === "tabindex" || kt === "input" && (zt === "maxlength" || zt === "tabindex") || kt === "select" && (zt === "size" || zt === "tabindex") || kt === "textarea" && /^(?:rows|cols|tabindex)$/.test(zt) || kt === "colgroup" && zt === "span" || kt === "col" && zt === "span" || (kt === "th" || kt === "td") && (zt === "rowspan" || zt === "colspan");
          }(nt, We)) return v(ft);
          if (nt === "style") return (ft = v(ft)) && (/;$/.test(ft) && !/&#?[0-9a-zA-Z]+;$/.test(ft) && (ft = ft.replace(/\s*;$/, ";")), ft = At.minifyCSS(ft, "inline")), ft;
          if (function(zt, kt) {
            return zt === "srcset" && ie(kt);
          }(nt, We)) ft = v(ft).split(/\s+,\s*|\s*,\s+/).map(function(Jt) {
            var zt = Jt, kt = "", Ft = Jt.match(/\s+([1-9][0-9]*w|[0-9]+(?:\.[0-9]+)?x)$/);
            return Ft && (zt = zt.slice(0, -Ft[0].length), Jt = +Ft[1].slice(0, -1), Ft = Ft[1].slice(-1), Jt == 1 && Ft === "x" || (kt = " " + Jt + Ft)), At.minifyURLs(zt) + kt;
          }).join(", ");
          else if (function(zt, kt) {
            if (zt === "meta") {
              for (var Ft = 0, ar = kt.length; Ft < ar; Ft++) if (kt[Ft].name === "name" && kt[Ft].value === "viewport") return 1;
            }
          }(We, ln) && nt === "content") ft = ft.replace(/\s+/g, "").replace(/[0-9]+\.[0-9]+/g, function(Jt) {
            return (+Jt).toString();
          });
          else {
            if (function(zt, kt) {
              if (zt === "meta") {
                for (var Ft = 0, ar = kt.length; Ft < ar; Ft++) if (kt[Ft].name.toLowerCase() === "http-equiv" && kt[Ft].value.toLowerCase() === "content-security-policy") return 1;
              }
            }(We, ln) && nt.toLowerCase() === "content") return E(ft);
            if (At.customAttrCollapse && At.customAttrCollapse.test(nt)) ft = ft.replace(/\n+|\r+|\s{2,}/g, "");
            else if (We === "script" && nt === "type") ft = v(ft.replace(/\s*;\s*/g, ";"));
            else if (function(zt, kt, Ft) {
              return Ft === "media" && (Y(zt, kt, "stylesheet") || U(zt, kt));
            }(We, ln, nt)) return ft = v(ft), At.minifyCSS(ft, "media");
          }
          return ft;
        }(Te, Ye, et, Me, he), Me.removeEmptyAttributes && function(We, nt, ft, At) {
          return (!ft || /^\s*$/.test(ft)) && (typeof At.removeEmptyAttributes == "function" ? At.removeEmptyAttributes(nt, We) : We === "input" && nt === "value" || Ie.test(nt));
        }(Te, Ye, et, Me)))) return { attr: Se, name: Ye, value: et = Me.decodeEntities && et ? et.replace(/&(#?[0-9a-zA-Z]+;)/g, "&amp;$1") : et };
      }
      function tt(Se) {
        return Se;
      }
      function Qe(Se) {
        for (var he; he = Math.random().toString(36).replace(/^0\.[0-9]*/, ""), ~Se.indexOf(he); ) ;
        return he;
      }
      var ke = r("script,style");
      function pe(Se, he, Te) {
        he.collapseWhitespace && (Se = C(Se, he, !0, !0));
        var Me, Ye, et, dt, We, nt = [], ft = "", At = "", ln = [], Jt = [], zt = [], kt = "", Ft = "", ar = [], In = [];
        Se = Se.replace(/<!-- htmlmin:ignore -->([\s\S]*?)<!-- htmlmin:ignore -->/g, function(en, bt) {
          et || (et = Qe(Se), Pt = new RegExp("^" + et + "([0-9]+)$"), he.ignoreCustomComments ? he.ignoreCustomComments = he.ignoreCustomComments.slice() : he.ignoreCustomComments = [], he.ignoreCustomComments.push(Pt));
          var Pt = "<!--" + et + ar.length + "-->";
          return ar.push(bt), Pt;
        });
        var On = he.ignoreCustomFragments.map(function(en) {
          return en.source;
        });
        function ui(en, bt) {
          return he.canTrimWhitespace(en, bt, Ge);
        }
        function Fr() {
          for (var en = nt.length - 1; 0 < en && !/^<[^/!]/.test(nt[en]); ) en--;
          nt.length = Math.max(0, en);
        }
        function er() {
          for (var en = nt.length - 1; 0 < en && !/^<\//.test(nt[en]); ) en--;
          nt.length = Math.max(0, en);
        }
        function $n(en, bt) {
          for (var Pt = null; 0 <= en && ui(Pt); en--) {
            var fn = nt[en], cn = fn.match(/^<\/([\w:-]+)>$/);
            if (cn) Pt = cn[1];
            else if (/>$/.test(fn) || (nt[en] = k(fn, null, bt, he))) break;
          }
        }
        function un(en) {
          var bt, Pt = nt.length - 1;
          1 < nt.length && (bt = nt[nt.length - 1], /^(?:<!|$)/.test(bt) && bt.indexOf(et) === -1 && Pt--), $n(Pt, en);
        }
        return On.length && (On = new RegExp("\\s*(?:" + On.join("|") + ")+\\s*", "g"), Se = Se.replace(On, function(en) {
          var bt, Pt;
          dt || (dt = Qe(Se), We = new RegExp("(\\s*)" + dt + "([0-9]+)" + dt + "(\\s*)", "g"), he.minifyCSS && (he.minifyCSS = (Pt = he.minifyCSS, function(cn, Vn) {
            cn = cn.replace(We, function(Kt, Dn, Kn) {
              var vr = In[+Kn];
              return vr[1] + dt + Kn + dt + vr[2];
            });
            var En = [];
            return new d().minify($(cn, Vn)).warnings.forEach(function(Kt) {
              (Kt = We.exec(Kt)) && (Kt = dt + Kt[2] + dt, cn = cn.replace(Kt, ce(Kt)), En.push(Kt));
            }), cn = Pt(cn, Vn), En.forEach(function(Kt) {
              cn = cn.replace(ce(Kt), Kt);
            }), cn;
          })), he.minifyJS && (he.minifyJS = (bt = he.minifyJS, function(cn, Vn) {
            return bt(cn.replace(We, function(En, Kt, Dn) {
              var Kn = In[+Dn];
              return Kn[1] + dt + Dn + dt + Kn[2];
            }), Vn);
          })));
          var fn = dt + In.length + dt;
          return In.push(/^(\s*)[\s\S]*?(\s*)$/.exec(en)), "	" + fn + "	";
        })), (he.sortAttributes && typeof he.sortAttributes != "function" || he.sortClassName && typeof he.sortClassName != "function") && function(bt, Pt, fn, cn) {
          var Vn = Pt.sortAttributes && /* @__PURE__ */ Object.create(null), En = Pt.sortClassName && new g();
          function Kt(_r) {
            return _r.map(function(sr) {
              return Pt.name(sr.name);
            });
          }
          function Dn(_r, sr) {
            return !sr || _r.indexOf(sr) === -1;
          }
          function Kn(_r) {
            return Dn(_r, fn) && Dn(_r, cn);
          }
          var vr, Ii = Pt.log;
          if (Pt.log = tt, Pt.sortAttributes = !1, Pt.sortClassName = !1, function _r(sr) {
            var br, ao;
            new h(sr, { start: function(di, Lo) {
              Vn && (Vn[di] || (Vn[di] = new g()), Vn[di].add(Kt(Lo).filter(Kn)));
              for (var La = 0, Ai = Lo.length; La < Ai; La++) {
                var fr = Lo[La];
                En && fr.value && Pt.name(fr.name) === "class" ? En.add(v(fr.value).split(/[ \t\n\f\r]+/).filter(Kn)) : Pt.processScripts && fr.name.toLowerCase() === "type" && (br = di, ao = fr.value);
              }
            }, end: function() {
              br = "";
            }, chars: function(di) {
              Pt.processScripts && ke(br) && -1 < Pt.processScripts.indexOf(ao) && _r(di);
            } });
          }(pe(bt, Pt)), Pt.log = Ii, Vn) {
            var vo, qr = /* @__PURE__ */ Object.create(null);
            for (vo in Vn) qr[vo] = Vn[vo].createSorter();
            Pt.sortAttributes = function(_r, sr) {
              var br, ao = qr[_r];
              ao && (br = /* @__PURE__ */ Object.create(null), (_r = Kt(sr)).forEach(function(Zi, di) {
                (br[Zi] || (br[Zi] = [])).push(sr[di]);
              }), ao.sort(_r).forEach(function(Zi, di) {
                sr[di] = br[Zi].shift();
              }));
            };
          }
          En && (vr = En.createSorter(), Pt.sortClassName = function(_r) {
            return vr.sort(_r.split(/[ \n\f\r]+/)).join(" ");
          });
        }(Se, he, et, dt), new h(Se, { partialMarkup: Te, continueOnParseError: he.continueOnParseError, customAttrAssign: he.customAttrAssign, customAttrSurround: he.customAttrSurround, html5: he.html5, start: function(bt, Pt, fn, cn, Vn) {
          bt.toLowerCase() === "svg" && ((he = Object.create(he)).caseSensitive = !0, he.keepClosingSlash = !0, he.name = tt), bt = he.name(bt), T(Me = At = bt) || (ft = ""), Ye = !1, ln = Pt;
          var En, Kt = he.removeOptionalTags;
          Kt && ((En = ze(bt)) && function(_r, sr) {
            switch (_r) {
              case "html":
              case "head":
                return 1;
              case "body":
                return !K(sr);
              case "colgroup":
                return sr === "col";
              case "tbody":
                return sr === "tr";
            }
          }(kt, bt) && Fr(), kt = "", En && function(_r, sr) {
            switch (_r) {
              case "html":
              case "head":
              case "body":
              case "colgroup":
              case "caption":
                return 1;
              case "li":
              case "optgroup":
              case "tr":
                return sr === _r;
              case "dt":
              case "dd":
                return ne(sr);
              case "p":
                return J(sr);
              case "rb":
              case "rt":
              case "rp":
                return z(sr);
              case "rtc":
                return ee(sr);
              case "option":
                return q(sr);
              case "thead":
              case "tbody":
                return X(sr);
              case "tfoot":
                return sr === "tbody";
              case "td":
              case "th":
                return ae(sr);
            }
          }(Ft, bt) && (er(), Kt = !function(_r, sr) {
            switch (sr) {
              case "colgroup":
                return _r === "colgroup";
              case "tbody":
                return oe(_r);
            }
          }(Ft, bt)), Ft = ""), he.collapseWhitespace && (Jt.length || un(bt), fn || (ui(bt, Pt) && !Jt.length || Jt.push(bt), function(_r, sr) {
            return he.canCollapseWhitespace(_r, sr, qe);
          }(bt, Pt) && !zt.length || zt.push(bt)));
          var Dn = cn && he.keepClosingSlash;
          nt.push("<" + bt), he.sortAttributes && he.sortAttributes(bt, Pt);
          for (var Kn = [], vr = Pt.length, Ii = !0; 0 <= --vr; ) {
            var vo = Ze(Pt[vr], Pt, bt, he);
            vo && (Kn.unshift(function(Ma, sr, br, ao, Zi) {
              var di, Lo, La = Ma.name, Ai = Ma.value, fr = Ma.attr, Ma = fr.quote;
              return Ai === void 0 || br.removeAttributeQuotes && !~Ai.indexOf(Zi) && function(Qn) {
                return /^[^ \t\n\f\r"'`=<>]+$/.test(Qn);
              }(Ai) ? Lo = !ao || sr || /\/$/.test(Ai) ? Ai + " " : Ai : (br.preventAttributesEscaping || (Ai = (Ma = br.quoteCharacter === void 0 ? (Ai.match(/'/g) || []).length < (Ai.match(/"/g) || []).length ? "'" : '"' : br.quoteCharacter === "'" ? "'" : '"') == '"' ? Ai.replace(/"/g, "&#34;") : Ai.replace(/'/g, "&#39;")), Lo = Ma + Ai + Ma, ao || br.removeTagWhitespace || (Lo += " ")), Ai === void 0 || br.collapseBooleanAttributes && function(Qn, Pa) {
                return H(Qn) || Qn === "draggable" && !Q(Pa);
              }(La.toLowerCase(), Ai.toLowerCase()) ? (di = La, ao || (di += " ")) : di = La + fr.customAssign + Lo, fr.customOpen + di + fr.customClose;
            }(vo, Dn, he, Ii, dt)), Ii = !1);
          }
          0 < Kn.length ? (nt.push(" "), nt.push.apply(nt, Kn)) : Kt && te(bt) && (kt = bt), nt.push(nt.pop() + (Dn ? "/" : "") + ">"), Vn && !he.includeAutoGeneratedTags && (Fr(), kt = "");
        }, end: function(bt, Pt, fn) {
          bt = (he = bt.toLowerCase() === "svg" ? Object.getPrototypeOf(he) : he).name(bt), he.collapseWhitespace && (Jt.length ? bt === Jt[Jt.length - 1] && Jt.pop() : un("/" + bt), zt.length && bt === zt[zt.length - 1] && zt.pop());
          var cn = !1;
          bt === At && (At = "", cn = !Ye), he.removeOptionalTags && (cn && _e(kt) && Fr(), kt = "", !ze(bt) || !Ft || we(Ft) || Ft === "p" && L(bt) || er(), Ft = V(bt) ? bt : ""), he.removeEmptyElements && cn && function(En, Kt) {
            switch (En) {
              case "textarea":
                return;
              case "audio":
              case "script":
              case "video":
                if (je("src", Kt)) return;
                break;
              case "iframe":
                if (je("src", Kt) || je("srcdoc", Kt)) return;
                break;
              case "object":
                if (je("data", Kt)) return;
                break;
              case "applet":
                if (je("code", Kt)) return;
            }
            return 1;
          }(bt, Pt) ? (Fr(), Ft = kt = "") : (fn && !he.includeAutoGeneratedTags ? Ft = "" : nt.push("</" + bt + ">"), Me = "/" + bt, y(bt) ? cn && (ft += "|") : ft = "");
        }, chars: function(bt, Pt, fn) {
          if (Pt = Pt === "" ? "comment" : Pt, fn = fn === "" ? "comment" : fn, he.decodeEntities && bt && !ke(At) && (bt = f(bt)), he.collapseWhitespace) {
            if (!Jt.length) {
              var cn;
              if (Pt !== "comment" || (cn = nt[nt.length - 1]).indexOf(et) === -1 && (cn || (Pt = Me), 1 < nt.length && (!cn || !he.conservativeCollapse && / $/.test(ft)) && (cn = nt.length - 2, nt[cn] = nt[cn].replace(/\s+$/, function(En) {
                return bt = En + bt, "";
              }))), Pt) if (Pt === "/nobr" || Pt === "wbr") {
                if (/^\s/.test(bt)) {
                  for (var Vn = nt.length - 1; 0 < Vn && nt[Vn].lastIndexOf("<" + Pt) !== 0; ) Vn--;
                  $n(Vn - 1, "br");
                }
              } else T(Pt.charAt(0) === "/" ? Pt.slice(1) : Pt) && (bt = C(bt, he, /(?:^|\s)$/.test(ft)));
              !(bt = Pt || fn ? k(bt, Pt, fn, he) : C(bt, he, !0, !0)) && /\s$/.test(ft) && Pt && Pt.charAt(0) === "/" && $n(nt.length - 1, fn);
            }
            zt.length || fn === "html" || Pt && fn || (bt = C(bt, he, !1, !1, !0));
          }
          he.processScripts && ke(At) && (bt = function(Kt, Dn, Kn) {
            for (var vr = 0, Ii = Kn.length; vr < Ii; vr++) if (Kn[vr].name.toLowerCase() === "type" && -1 < Dn.processScripts.indexOf(Kn[vr].value)) return pe(Kt, Dn);
            return Kt;
          }(bt, he, ln)), function(Kt, Dn) {
            if (Kt === "script") {
              for (var Kn = 0, vr = Dn.length; Kn < vr; Kn++) if (Dn[Kn].name.toLowerCase() === "type") return I(Dn[Kn].value);
              return 1;
            }
          }(At, ln) && (bt = he.minifyJS(bt)), U(At, ln) && (bt = he.minifyCSS(bt)), he.removeOptionalTags && bt && (kt !== "html" && (kt !== "body" || /^\s/.test(bt)) || Fr(), kt = "", (ve(Ft) || Ee(Ft) && !/^\s/.test(bt)) && er(), Ft = ""), Me = /^\s*$/.test(bt) ? Pt : "comment", he.decodeEntities && bt && !ke(At) && (bt = bt.replace(/&((?:Iacute|aacute|uacute|plusmn|Otilde|otilde|agrave|Agrave|Yacute|yacute|Oslash|oslash|atilde|Atilde|brvbar|ccedil|Ccedil|Ograve|curren|divide|eacute|Eacute|ograve|Oacute|egrave|Egrave|Ugrave|frac12|frac14|frac34|ugrave|oacute|iacute|Ntilde|ntilde|Uacute|middot|igrave|Igrave|iquest|Aacute|cedil|laquo|micro|iexcl|Icirc|icirc|acirc|Ucirc|Ecirc|ocirc|Ocirc|ecirc|ucirc|Aring|aring|AElig|aelig|acute|pound|raquo|Acirc|times|THORN|szlig|thorn|COPY|auml|ordf|ordm|Uuml|macr|uuml|Auml|ouml|Ouml|para|nbsp|euml|quot|QUOT|Euml|yuml|cent|sect|copy|sup1|sup2|sup3|iuml|Iuml|ETH|shy|reg|not|yen|amp|AMP|REG|uml|eth|deg|gt|GT|LT|lt)(?!;)|(?:#?[0-9a-zA-Z]+;))/g, "&amp$1").replace(/</g, "&lt;")), We && he.collapseWhitespace && Jt.length && (bt = bt.replace(We, function(En, Kt, Dn) {
            return In[+Dn][0];
          })), ft += bt, bt && (Ye = !0), nt.push(bt);
        }, comment: function(bt, cn) {
          var fn = cn ? "<!" : "<!--", cn = cn ? ">" : "-->";
          bt = function(En) {
            return /^\[if\s[^\]]+]|\[endif]$/.test(En);
          }(bt) ? fn + function(En, Kt) {
            return Kt.processConditionalComments ? En.replace(/^(\[if\s[^\]]+]>)([\s\S]*?)(<!\[endif])$/, function(Dn, Kn, vr, Ii) {
              return Kn + pe(vr, Kt, !0) + Ii;
            }) : En;
          }(bt, he) + cn : he.removeComments ? function(En, Kt) {
            for (var Dn = 0, Kn = Kt.ignoreCustomComments.length; Dn < Kn; Dn++) if (Kt.ignoreCustomComments[Dn].test(En)) return 1;
          }(bt, he) ? "<!--" + bt + "-->" : "" : fn + bt + cn, he.removeOptionalTags && bt && (Ft = kt = ""), nt.push(bt);
        }, doctype: function(bt) {
          nt.push(he.useShortDoctype ? "<!doctype" + (he.removeTagWhitespace ? "" : " ") + "html>" : E(bt));
        } }), he.removeOptionalTags && (_e(kt) && Fr(), Ft && !we(Ft) && er()), he.collapseWhitespace && un("br"), function(bt, Pt, fn, cn) {
          var Vn, En = Pt.maxLineLength;
          if (En) {
            for (var Kt = "", Dn = []; bt.length; ) {
              var Kn = Kt.length, vr = bt[0].indexOf(`
`);
              vr < 0 ? Kt += cn(fn(bt.shift())) : (Kt += cn(fn(bt[0].slice(0, vr))), bt[0] = bt[0].slice(vr + 1)), 0 < Kn && Kt.length > En ? (Dn.push(Kt.slice(0, Kn)), Kt = Kt.slice(Kn)) : 0 <= vr && (Dn.push(Kt), Kt = "");
            }
            Kt && Dn.push(Kt), Vn = Dn.join(`
`);
          } else Vn = cn(fn(bt.join("")));
          return Pt.collapseWhitespace ? C(Vn, Pt, !0, !0) : Vn;
        }(nt, he, We ? function(en) {
          return en.replace(We, function(bt, Pt, fn, cn) {
            return fn = In[+fn][0], he.collapseWhitespace ? (Pt !== "	" && (fn = Pt + fn), cn !== "	" && (fn += cn), C(fn, { preserveLineBreaks: he.preserveLineBreaks, conservativeCollapse: !he.trimCustomFragments }, /^[ \n\r\t\f]/.test(fn), /[ \n\r\t\f]$/.test(fn))) : fn;
          });
        } : tt, et ? function(en) {
          return en.replace(new RegExp("<!--" + et + "([0-9]+)-->", "g"), function(bt, Pt) {
            return ar[+Pt];
          });
        } : tt);
      }
      s.minify = function(Me, he) {
        var Te = Date.now(), Me = pe(Me, he = function(et) {
          var dt = { name: function(nt) {
            return nt.toLowerCase();
          }, canCollapseWhitespace: qe, canTrimWhitespace: Ge, html5: !0, ignoreCustomComments: [/^!/], ignoreCustomFragments: [/<%[\s\S]*?%>/, /<\?[\s\S]*?\?>/], includeAutoGeneratedTags: !0, log: tt, minifyCSS: tt, minifyJS: tt, minifyURLs: tt };
          return Object.keys(et).forEach(function(We) {
            var nt = et[We];
            We === "caseSensitive" ? nt && (dt.name = tt) : We === "log" ? typeof nt == "function" && (dt.log = nt) : We === "minifyCSS" && typeof nt != "function" ? nt && (l(nt) !== "object" && (nt = {}), dt.minifyCSS = function(ft, At) {
              ft = ft.replace(/(url\s*\(\s*)("|'|)(.*?)\2(\s*\))/gi, function(Jt, zt, kt, Ft, ar) {
                return zt + kt + dt.minifyURLs(Ft) + kt + ar;
              });
              var ln = new d(nt).minify($(ft, At));
              return 0 < ln.errors.length ? (ln.errors.forEach(dt.log), ft) : function(zt, kt) {
                var Ft;
                switch (kt) {
                  case "inline":
                    Ft = zt.match(/^\*\{([\s\S]*)\}$/);
                    break;
                  case "media":
                    Ft = zt.match(/^@media ([\s\S]*?)\s*{[\s\S]*}$/);
                }
                return Ft ? Ft[1] : zt;
              }(ln.styles, At);
            }) : We === "minifyJS" && typeof nt != "function" ? nt && (((nt = l(nt) !== "object" ? {} : nt).parse || (nt.parse = {})).bare_returns = !1, dt.minifyJS = function(ft, At) {
              var ln = (ln = ft.match(/^\s*<!--.*/)) ? ft.slice(ln[0].length).replace(/\n\s*-->\s*$/, "") : ft;
              return nt.parse.bare_returns = At, (ln = _.minify(ln, nt)).error ? (dt.log(ln.error), ft) : ln.code.replace(/;$/, "");
            }) : We === "minifyURLs" && typeof nt != "function" ? nt && (typeof nt == "string" ? nt = { site: nt } : l(nt) !== "object" && (nt = {}), dt.minifyURLs = function(ft) {
              try {
                return p.relate(ft, nt);
              } catch (At) {
                return dt.log(At), ft;
              }
            }) : dt[We] = nt;
          }), dt;
        }(he || {}));
        return he.log("minified in: " + (Date.now() - Te) + "ms"), Me;
      };
    }, function(a, s, r) {
      a.exports = r(364);
    }, function(a, s, r) {
      (function(l) {
        var d = r(365), f = r(366), h = r(374), p = r(398), g = r(399), _ = r(400), b = r(83).formatFrom, v = r(433), E = r(434), C = r(435), y = r(26).OptimizationLevel, T = r(26).optimizationLevelFrom, A = r(436), k = r(437), N = r(438), j = r(445), I = r(454), B = r(455), U = a.exports = function(Y) {
          this.options = { compatibility: g((Y = Y || {}).compatibility), fetch: _(Y.fetch), format: b(Y.format), inline: v(Y.inline), inlineRequest: E(Y.inlineRequest), inlineTimeout: C(Y.inlineTimeout), level: T(Y.level), rebase: A(Y.rebase), rebaseTo: k(Y.rebaseTo), returnPromise: !!Y.returnPromise, sourceMap: !!Y.sourceMap, sourceMapInlineSources: !!Y.sourceMapInlineSources };
        };
        function H(Q, Y, ie, ce) {
          var $ = typeof ie != "function" ? ie : null, te = typeof ce == "function" ? ce : typeof ie == "function" ? ie : null, V = { stats: { efficiency: 0, minifiedSize: 0, originalSize: 0, startedAt: Date.now(), timeSpent: 0 }, cache: { specificity: {} }, errors: [], inlinedStylesheets: [], inputSourceMapTracker: N(), localOnly: !te, options: Y, source: null, sourcesContent: {}, validator: p(Y.compatibility), warnings: [] };
          return $ && V.inputSourceMapTracker.track(void 0, $), function(ne) {
            return ne ? function(J) {
              return J();
            } : l.nextTick;
          }(V.localOnly)(function() {
            return j(Q, V, function(K) {
              return K = function(J, L) {
                return J.stats = function(ee, q) {
                  var X = Date.now() - q.stats.startedAt;
                  return delete q.stats.startedAt, q.stats.timeSpent = X, q.stats.efficiency = 1 - ee.length / q.stats.originalSize, q.stats.minifiedSize = ee.length, q.stats;
                }(J.styles, L), J.errors = L.errors, J.inlinedStylesheets = L.inlinedStylesheets, J.warnings = L.warnings, J;
              }((V.options.sourceMap ? B : I)(function(J, L) {
                var z = d(J, L);
                return z = y.One in L.options.level ? f(J, L) : J, y.Two in L.options.level ? h(J, L, !0) : z;
              }(K, V), V), V), te ? te(0 < V.errors.length ? V.errors : null, K) : K;
            });
          });
        }
        U.process = function(Q, Y) {
          var ie = Y.to;
          return delete Y.to, new U(Object.assign({ returnPromise: !0, rebaseTo: ie }, Y)).minify(Q).then(function(ce) {
            return { css: ce.styles };
          });
        }, U.prototype.minify = function(Q, Y, ie) {
          var ce = this.options;
          return ce.returnPromise ? new Promise(function($, te) {
            H(Q, ce, Y, function(V, K) {
              return V ? te(V) : $(K);
            });
          }) : H(Q, ce, Y, ie);
        };
      }).call(this, r(15));
    }, function(a, s) {
      a.exports = function(l) {
        return l;
      };
    }, function(a, s, r) {
      var l = r(367), d = r(368), f = r(369), h = r(124), p = r(125), g = r(372), _ = r(373), b = r(126), v = r(184), E = r(62), C = r(49).all, y = r(26).OptimizationLevel, T = r(12), A = r(16), k = r(84), N = r(127), j = r(14).rules, I = "ignore-property", B = "@charset", U = new RegExp("^" + B, "i"), H = r(185).DEFAULT, Q = /(?:^|\s|\()(-?\d+)px/, Y = /^(\-?[\d\.]+)(m?s)$/, ie = /[0-9a-f]/i, ce = /^(?:\-chrome\-|\-[\w\-]+\w|\w[\w\-]+\w|\-\-\S+)$/, $ = /^@import/i, te = /^('.*'|".*")$/, V = /^['"][a-zA-Z][a-zA-Z\d\-_]+['"]$/, K = /^url\(/i, ne = /^local\(/i, J = /^--\S+$/;
      function L(q) {
        return q && q[1][0] == "-" && parseFloat(q[1]) < 0;
      }
      function z(q, X, oe) {
        var ae, _e, ve, Ee, we, ze, Ie = oe.options, je = Ie.level[y.One], qe = C(X, !0);
        e: for (var Ge = 0, Ze = qe.length; Ge < Ze; Ge++) if (_e = (ae = qe[Ge]).name, ce.test(_e) || (ze = ae.all[ae.position], oe.warnings.push("Invalid property name '" + _e + "' at " + k(ze[1][2][0]) + ". Ignoring."), ae.unused = !0), ae.value.length === 0 && (ze = ae.all[ae.position], oe.warnings.push("Empty property '" + _e + "' at " + k(ze[1][2][0]) + ". Ignoring."), ae.unused = !0), ae.hack && ((ae.hack[0] == b.ASTERISK || ae.hack[0] == b.UNDERSCORE) && !Ie.compatibility.properties.iePrefixHack || ae.hack[0] == b.BACKSLASH && !Ie.compatibility.properties.ieSuffixHack || ae.hack[0] == b.BANG && !Ie.compatibility.properties.ieBangHack) && (ae.unused = !0), je.removeNegativePaddings && _e.indexOf("padding") === 0 && (L(ae.value[0]) || L(ae.value[1]) || L(ae.value[2]) || L(ae.value[3])) && (ae.unused = !0), !Ie.compatibility.properties.ieFilters && function(pe) {
          return (pe.name == "filter" || pe.name == "-ms-filter") && (-1 < (pe = pe.value[0][1]).indexOf("progid") || pe.indexOf("alpha") === 0 || pe.indexOf("chroma") === 0);
        }(ae) && (ae.unused = !0), !ae.unused) {
          if (ae.block) z(q, ae.value[0][1], oe);
          else if (!J.test(_e)) {
            for (var tt = 0, Qe = ae.value.length; tt < Qe; tt++) {
              if (ve = ae.value[tt][0], we = function(pe) {
                return K.test(pe);
              }(Ee = ae.value[tt][1]), ve == T.PROPERTY_BLOCK) {
                ae.unused = !0, oe.warnings.push("Invalid value token at " + k(Ee[0][1][2][0]) + ". Ignoring.");
                break;
              }
              if (we && !oe.validator.isUrl(Ee)) {
                ae.unused = !0, oe.warnings.push("Broken URL '" + Ee + "' at " + k(ae.value[tt][2][0]) + ". Ignoring.");
                break;
              }
              if (we ? (Ee = je.normalizeUrls ? function(pe) {
                return pe.replace(K, "url(").replace(/\\?\n|\\?\r\n/g, "");
              }(Ee) : Ee, Ee = Ie.compatibility.properties.urlQuotes ? Ee : function(pe) {
                return !/^url\(['"].+['"]\)$/.test(pe) || /^url\(['"].*[\*\s\(\)'"].*['"]\)$/.test(pe) || /^url\(['"]data:[^;]+;charset/.test(pe) ? pe : pe.replace(/["']/g, "");
              }(Ee)) : function(pe) {
                return te.test(pe);
              }(Ee) || function(pe) {
                return ne.test(pe);
              }(Ee) ? Ee = je.removeQuotes ? function(pe, Se) {
                return pe == "content" || -1 < pe.indexOf("font-variation-settings") || -1 < pe.indexOf("font-feature-settings") || pe == "grid" || -1 < pe.indexOf("grid-") || !V.test(Se) ? Se : Se.substring(1, Se.length - 1);
              }(_e, Ee) : Ee : (Ee = function(pe, Se, he) {
                return Q.test(Se) ? Se.replace(Q, function(Te, Me) {
                  var Ye, et = parseInt(Me);
                  return et === 0 ? Te : (he.properties.shorterLengthUnits && he.units.pt && 3 * et % 4 == 0 && (Ye = 3 * et / 4 + "pt"), he.properties.shorterLengthUnits && he.units.pc && et % 16 == 0 && (Ye = et / 16 + "pc"), (Ye = (Ye = he.properties.shorterLengthUnits && he.units.in && et % 96 == 0 ? et / 96 + "in" : Ye) && Te.substring(0, Te.indexOf(Me)) + Ye) && Ye.length < Te.length ? Ye : Te);
                }) : Se;
              }(0, Ee = function(pe, Se, he) {
                return he.enabled && Se.indexOf(".") !== -1 ? Se.replace(he.decimalPointMatcher, "$1$2$3").replace(he.zeroMatcher, function(Te, We, nt, et) {
                  var dt = he.units[et].multiplier, We = parseInt(We), We = isNaN(We) ? 0 : We, nt = parseFloat(nt);
                  return Math.round((We + nt) * dt) / dt + et;
                }) : Se;
              }(0, Ee = je.removeWhitespace ? function(pe, Se) {
                return -1 < pe.indexOf("filter") || Se.indexOf(" ") == -1 || Se.indexOf("expression") === 0 || -1 < Se.indexOf(A.SINGLE_QUOTE) || -1 < Se.indexOf(A.DOUBLE_QUOTE) ? Se : (Se = -1 < (Se = Se.replace(/\s+/g, " ")).indexOf("calc") ? Se.replace(/\) ?\/ ?/g, ")/ ") : Se).replace(/(\(;?)\s+/g, "$1").replace(/\s+(;?\))/g, "$1").replace(/, /g, ",");
              }(_e, Ee) : Ee, Ie.precision), Ie.compatibility), Ee = je.replaceTimeUnits ? function(pe, Se) {
                return Y.test(Se) ? Se.replace(Y, function(he, Te, Me) {
                  var Ye;
                  return Me == "ms" ? Ye = parseInt(Te) / 1e3 + "s" : Me == "s" && (Ye = 1e3 * parseFloat(Te) + "ms"), Ye.length < he.length ? Ye : he;
                }) : Se;
              }(0, Ee) : Ee, Ee = je.replaceZeroUnits ? function(pe, Se) {
                return Se.indexOf("0") == -1 ? Se : (Se = -1 < Se.indexOf("-") ? Se.replace(/([^\w\d\-]|^)\-0([^\.]|$)/g, "$10$2").replace(/([^\w\d\-]|^)\-0([^\.]|$)/g, "$10$2") : Se).replace(/(^|\s)0+([1-9])/g, "$1$2").replace(/(^|\D)\.0+(\D|$)/g, "$10$2").replace(/(^|\D)\.0+(\D|$)/g, "$10$2").replace(/\.([1-9]*)0+(\D|$)/g, function(he, Te, Me) {
                  return (0 < Te.length ? "." : "") + Te + Me;
                }).replace(/(^|\D)0\.(\d)/g, "$1.$2");
              }(0, Ee) : Ee, Ie.compatibility.properties.zeroUnits && (Ee = function(pe, Se, he) {
                return /^(?:\-moz\-calc|\-webkit\-calc|calc|rgb|hsl|rgba|hsla)\(/.test(Se) || pe == "flex" || pe == "-ms-flex" || pe == "-webkit-flex" || pe == "flex-basis" || pe == "-webkit-flex-basis" || 0 < Se.indexOf("%") && (pe == "height" || pe == "max-height" || pe == "width" || pe == "max-width") ? Se : Se.replace(he, "$10$2").replace(he, "$10$2");
              }(_e, Ee = function(pe, Se) {
                return Se.indexOf("0deg") == -1 ? Se : Se.replace(/\(0deg\)/g, "(0)");
              }(0, Ee), Ie.unitsRegexp)), Ie.compatibility.properties.colors && (Ee = function(pe, Se, he) {
                return Se.match(/#|rgb|hsl/gi) && (Se = Se.replace(/(rgb|hsl)a?\((\-?\d+),(\-?\d+\%?),(\-?\d+\%?),(0*[1-9]+[0-9]*(\.?\d*)?)\)/gi, function(Te, Me, Ye, et, dt, We) {
                  return 1 <= parseInt(We, 10) ? Me + "(" + [Ye, et, dt].join(",") + ")" : Te;
                }).replace(/rgb\((\-?\d+),(\-?\d+),(\-?\d+)\)/gi, function(Te, Me, Ye, et) {
                  return f(Me, Ye, et);
                }).replace(/hsl\((-?\d+),(-?\d+)%?,(-?\d+)%?\)/gi, function(Te, Me, Ye, et) {
                  return d(Me, Ye, et);
                }).replace(/(^|[^='"])#([0-9a-f]{6})/gi, function(Te, Me, Ye, et, dt) {
                  return (et = dt[et + Te.length]) && ie.test(et) ? Te : (Ye[0] == Ye[1] && Ye[2] == Ye[3] && Ye[4] == Ye[5] ? Me + "#" + Ye[0] + Ye[2] + Ye[4] : Me + "#" + Ye).toLowerCase();
                }).replace(/(^|[^='"])#([0-9a-f]{3})/gi, function(Te, Me, Ye) {
                  return Me + "#" + Ye.toLowerCase();
                }).replace(/(rgb|rgba|hsl|hsla)\(([^\)]+)\)/gi, function(Te, Me, Ye) {
                  var et = Ye.split(","), dt = Me && Me.toLowerCase();
                  return dt == "hsl" && et.length == 3 || dt == "hsla" && et.length == 4 || dt == "rgb" && et.length === 3 && 0 < Ye.indexOf("%") || dt == "rgba" && et.length == 4 && 0 < Ye.indexOf("%") ? (et[1].indexOf("%") == -1 && (et[1] += "%"), et[2].indexOf("%") == -1 && (et[2] += "%"), Me + "(" + et.join(",") + ")") : Te;
                }), he.colors.opacity && pe.indexOf("background") == -1 && (Se = Se.replace(/(?:rgba|hsla)\(0,0%?,0%?,0\)/g, function(Te) {
                  return -1 < N(Se, ",").pop().indexOf("gradient(") ? Te : "transparent";
                }))), l(Se);
              }(_e, Ee, Ie.compatibility))), (Ee = function(pe, Se, he, Te) {
                return (he = Te(pe, Se, j(he))) === void 0 ? Se : he === !1 ? I : he;
              }(_e, Ee, q, je.transform)) === I) {
                ae.unused = !0;
                continue e;
              }
              ae.value[tt][1] = Ee;
            }
            je.replaceMultipleZeros && function(pe) {
              var Se, he = pe.value;
              (Se = he.length == 4 && he[0][1] === "0" && he[1][1] === "0" && he[2][1] === "0" && he[3][1] === "0" ? -1 < pe.name.indexOf("box-shadow") ? 2 : 1 : Se) && (pe.value.splice(Se), pe.dirty = !0);
            }(ae), _e == "background" && je.optimizeBackground ? function(pe) {
              (pe = pe.value).length == 1 && pe[0][1] == "none" && (pe[0][1] = "0 0"), pe.length == 1 && pe[0][1] == "transparent" && (pe[0][1] = "0 0");
            }(ae) : _e.indexOf("border") === 0 && 0 < _e.indexOf("radius") && je.optimizeBorderRadius ? function(pe) {
              var Se, he = pe.value;
              he.length == 3 && he[1][1] == "/" && he[0][1] == he[2][1] ? Se = 1 : he.length == 5 && he[2][1] == "/" && he[0][1] == he[3][1] && he[1][1] == he[4][1] ? Se = 2 : he.length == 7 && he[3][1] == "/" && he[0][1] == he[4][1] && he[1][1] == he[5][1] && he[2][1] == he[6][1] ? Se = 3 : he.length == 9 && he[4][1] == "/" && he[0][1] == he[5][1] && he[1][1] == he[6][1] && he[2][1] == he[7][1] && he[3][1] == he[8][1] && (Se = 4), Se && (pe.value.splice(Se), pe.dirty = !0);
            }(ae) : _e == "filter" && je.optimizeFilter && Ie.compatibility.properties.ieFilters ? function(pe) {
              pe.value.length == 1 && (pe.value[0][1] = pe.value[0][1].replace(/progid:DXImageTransform\.Microsoft\.(Alpha|Chroma)(\W)/, function(Se, he, Te) {
                return he.toLowerCase() + Te;
              })), pe.value[0][1] = pe.value[0][1].replace(/,(\S)/g, ", $1").replace(/ ?= ?/g, "=");
            }(ae) : _e == "font-weight" && je.optimizeFontWeight ? function(pe, Se) {
              var he = pe.value[Se][1];
              he == "normal" ? he = "400" : he == "bold" && (he = "700"), pe.value[Se][1] = he;
            }(ae, 0) : _e == "outline" && je.optimizeOutline && function(pe) {
              (pe = pe.value).length == 1 && pe[0][1] == "none" && (pe[0][1] = "0");
            }(ae);
          }
        }
        E(qe), v(qe), function(pe, Se) {
          for (var he, Te = 0; Te < pe.length; Te++) (he = pe[Te])[0] == T.COMMENT && (ee(he, Se), he[1].length === 0 && (pe.splice(Te, 1), Te--));
        }(X, Ie);
      }
      function ee(q, X) {
        q[1][2] == A.EXCLAMATION && (X.level[y.One].specialComments == "all" || X.commentsKept < X.level[y.One].specialComments) ? X.commentsKept++ : q[1] = [];
      }
      a.exports = function q(X, oe) {
        var ae = oe.options, _e = ae.level[y.One], ve = ae.compatibility.selectors.ie7Hack, Ee = ae.compatibility.selectors.adjacentSpace, we = ae.compatibility.properties.spaceAfterClosingBrace, ze = ae.format, Ie = !1, je = !1;
        ae.unitsRegexp = ae.unitsRegexp || function(Qe) {
          var ke = ["px", "em", "ex", "cm", "mm", "in", "pt", "pc", "%"];
          return ["ch", "rem", "vh", "vm", "vmax", "vmin", "vw"].forEach(function(pe) {
            Qe.compatibility.units[pe] && ke.push(pe);
          }), new RegExp("(^|\\s|\\(|,)0(?:" + ke.join("|") + ")(\\W|$)", "g");
        }(ae), ae.precision = ae.precision || function(Qe) {
          var ke, pe, Se = { matcher: null, units: {} }, he = [];
          for (ke in Qe) (pe = Qe[ke]) != H && (Se.units[ke] = {}, Se.units[ke].value = pe, Se.units[ke].multiplier = Math.pow(10, pe), he.push(ke));
          return 0 < he.length && (Se.enabled = !0, Se.decimalPointMatcher = new RegExp("(\\d)\\.($|" + he.join("|") + ")($|W)", "g"), Se.zeroMatcher = new RegExp("(\\d*)(\\.\\d+)(" + he.join("|") + ")", "g")), Se;
        }(_e.roundingPrecision), ae.commentsKept = ae.commentsKept || 0;
        for (var qe = 0, Ge = X.length; qe < Ge; qe++) {
          var Ze = X[qe];
          switch (Ze[0]) {
            case T.AT_RULE:
              Ze[1] = function(Qe) {
                return $.test(Qe[1]);
              }(Ze) && je ? "" : Ze[1], Ze[1] = _e.tidyAtRules ? _(Ze[1]) : Ze[1], Ie = !0;
              break;
            case T.AT_RULE_BLOCK:
              z(Ze[1], Ze[2], oe), je = !0;
              break;
            case T.NESTED_BLOCK:
              Ze[1] = _e.tidyBlockScopes ? g(Ze[1], we) : Ze[1], q(Ze[2], oe), je = !0;
              break;
            case T.COMMENT:
              ee(Ze, ae);
              break;
            case T.RULE:
              Ze[1] = _e.tidySelectors ? p(Ze[1], !ve, Ee, ze, oe.warnings) : Ze[1], Ze[1] = 1 < Ze[1].length ? h(Ze[1], _e.selectorsSortingMethod) : Ze[1], z(Ze[1], Ze[2], oe), je = !0;
          }
          (Ze[0] == T.COMMENT && Ze[1].length === 0 || _e.removeEmpty && (Ze[1].length === 0 || Ze[2] && Ze[2].length === 0)) && (X.splice(qe, 1), qe--, Ge--);
        }
        return _e.cleanupCharsets && Ie && function(Qe) {
          for (var ke = !1, pe = 0, Se = Qe.length; pe < Se; pe++) {
            var he = Qe[pe];
            he[0] == T.AT_RULE && U.test(he[1]) && (ke || he[1].indexOf(B) == -1 ? (Qe.splice(pe, 1), pe--, Se--) : (ke = !0, Qe.splice(pe, 1), Qe.unshift([T.AT_RULE, he[1].replace(U, B)])));
          }
        }(X), X;
      };
    }, function(a, s) {
      var r, l = { aliceblue: "#f0f8ff", antiquewhite: "#faebd7", aqua: "#0ff", aquamarine: "#7fffd4", azure: "#f0ffff", beige: "#f5f5dc", bisque: "#ffe4c4", black: "#000", blanchedalmond: "#ffebcd", blue: "#00f", blueviolet: "#8a2be2", brown: "#a52a2a", burlywood: "#deb887", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", cornflowerblue: "#6495ed", cornsilk: "#fff8dc", crimson: "#dc143c", cyan: "#0ff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", darkkhaki: "#bdb76b", darkmagenta: "#8b008b", darkolivegreen: "#556b2f", darkorange: "#ff8c00", darkorchid: "#9932cc", darkred: "#8b0000", darksalmon: "#e9967a", darkseagreen: "#8fbc8f", darkslateblue: "#483d8b", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", darkturquoise: "#00ced1", darkviolet: "#9400d3", deeppink: "#ff1493", deepskyblue: "#00bfff", dimgray: "#696969", dimgrey: "#696969", dodgerblue: "#1e90ff", firebrick: "#b22222", floralwhite: "#fffaf0", forestgreen: "#228b22", fuchsia: "#f0f", gainsboro: "#dcdcdc", ghostwhite: "#f8f8ff", gold: "#ffd700", goldenrod: "#daa520", gray: "#808080", green: "#008000", greenyellow: "#adff2f", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", indianred: "#cd5c5c", indigo: "#4b0082", ivory: "#fffff0", khaki: "#f0e68c", lavender: "#e6e6fa", lavenderblush: "#fff0f5", lawngreen: "#7cfc00", lemonchiffon: "#fffacd", lightblue: "#add8e6", lightcoral: "#f08080", lightcyan: "#e0ffff", lightgoldenrodyellow: "#fafad2", lightgray: "#d3d3d3", lightgreen: "#90ee90", lightgrey: "#d3d3d3", lightpink: "#ffb6c1", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", lightskyblue: "#87cefa", lightslategray: "#778899", lightslategrey: "#778899", lightsteelblue: "#b0c4de", lightyellow: "#ffffe0", lime: "#0f0", limegreen: "#32cd32", linen: "#faf0e6", magenta: "#ff00ff", maroon: "#800000", mediumaquamarine: "#66cdaa", mediumblue: "#0000cd", mediumorchid: "#ba55d3", mediumpurple: "#9370db", mediumseagreen: "#3cb371", mediumslateblue: "#7b68ee", mediumspringgreen: "#00fa9a", mediumturquoise: "#48d1cc", mediumvioletred: "#c71585", midnightblue: "#191970", mintcream: "#f5fffa", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", navajowhite: "#ffdead", navy: "#000080", oldlace: "#fdf5e6", olive: "#808000", olivedrab: "#6b8e23", orange: "#ffa500", orangered: "#ff4500", orchid: "#da70d6", palegoldenrod: "#eee8aa", palegreen: "#98fb98", paleturquoise: "#afeeee", palevioletred: "#db7093", papayawhip: "#ffefd5", peachpuff: "#ffdab9", peru: "#cd853f", pink: "#ffc0cb", plum: "#dda0dd", powderblue: "#b0e0e6", purple: "#800080", rebeccapurple: "#663399", red: "#f00", rosybrown: "#bc8f8f", royalblue: "#4169e1", saddlebrown: "#8b4513", salmon: "#fa8072", sandybrown: "#f4a460", seagreen: "#2e8b57", seashell: "#fff5ee", sienna: "#a0522d", silver: "#c0c0c0", skyblue: "#87ceeb", slateblue: "#6a5acd", slategray: "#708090", slategrey: "#708090", snow: "#fffafa", springgreen: "#00ff7f", steelblue: "#4682b4", tan: "#d2b48c", teal: "#008080", thistle: "#d8bfd8", tomato: "#ff6347", turquoise: "#40e0d0", violet: "#ee82ee", wheat: "#f5deb3", white: "#fff", whitesmoke: "#f5f5f5", yellow: "#ff0", yellowgreen: "#9acd32" }, d = {}, f = {};
      for (r in l) {
        var h = l[r];
        r.length < h.length ? f[h] = r : d[r] = h;
      }
      var p = new RegExp("(^| |,|\\))(" + Object.keys(d).join("|") + ")( |,|\\)|$)", "ig"), g = new RegExp("(" + Object.keys(f).join("|") + ")([^a-f0-9]|$)", "ig");
      function _(v, E, C, y) {
        return E + d[C.toLowerCase()] + y;
      }
      function b(v, E, C) {
        return f[E.toLowerCase()] + C;
      }
      a.exports = function(E) {
        var C = -1 < E.indexOf("#"), y = E.replace(p, _);
        return y != E && (y = y.replace(p, _)), C ? y.replace(g, b) : y;
      };
    }, function(a, s) {
      function r(l, d, f) {
        return f < 0 && (f += 1), 1 < f && --f, f < 1 / 6 ? l + 6 * (d - l) * f : f < 0.5 ? d : f < 2 / 3 ? l + (d - l) * (2 / 3 - f) * 6 : l;
      }
      a.exports = function(d, f, h) {
        return f = (d = function(g, _, b) {
          var v, E, C;
          return (g %= 360) < 0 && (g += 360), g = ~~g / 360, _ < 0 ? _ = 0 : 100 < _ && (_ = 100), b < 0 ? b = 0 : 100 < b && (b = 100), b = ~~b / 100, (_ = ~~_ / 100) == 0 ? v = E = C = b : (v = r(_ = 2 * b - (b = b < 0.5 ? b * (1 + _) : b + _ - b * _), b, g + 1 / 3), E = r(_, b, g), C = r(_, b, g - 1 / 3)), [~~(255 * v), ~~(255 * E), ~~(255 * C)];
        }(d, f, h))[0].toString(16), h = d[1].toString(16), d = d[2].toString(16), "#" + (f.length == 1 ? "0" : "") + f + (h.length == 1 ? "0" : "") + h + (d.length == 1 ? "0" : "") + d;
      };
    }, function(a, s) {
      a.exports = function(l, d, f) {
        return "#" + ("00000" + (Math.max(0, Math.min(parseInt(l), 255)) << 16 | Math.max(0, Math.min(parseInt(d), 255)) << 8 | Math.max(0, Math.min(parseInt(f), 255))).toString(16)).slice(-6);
      };
    }, function(a, s) {
      var r = /([0-9]+)/;
      function l(d) {
        return "" + parseInt(d) == d ? parseInt(d) : d;
      }
      a.exports = function(f, h) {
        for (var p, g, _ = ("" + f).split(r).map(l), b = ("" + h).split(r).map(l), v = 0, E = Math.min(_.length, b.length); v < E; v++) if ((p = _[v]) != (g = b[v])) return g < p ? 1 : -1;
        return _.length > b.length ? 1 : _.length == b.length ? 0 : -1;
      };
    }, function(a, s) {
      s.endianness = function() {
        return "LE";
      }, s.hostname = function() {
        return typeof location < "u" ? location.hostname : "";
      }, s.loadavg = function() {
        return [];
      }, s.uptime = function() {
        return 0;
      }, s.freemem = function() {
        return Number.MAX_VALUE;
      }, s.totalmem = function() {
        return Number.MAX_VALUE;
      }, s.cpus = function() {
        return [];
      }, s.type = function() {
        return "Browser";
      }, s.release = function() {
        return typeof navigator < "u" ? navigator.appVersion : "";
      }, s.networkInterfaces = s.getNetworkInterfaces = function() {
        return {};
      }, s.arch = function() {
        return "javascript";
      }, s.platform = function() {
        return "browser";
      }, s.tmpdir = s.tmpDir = function() {
        return "/tmp";
      }, s.EOL = `
`, s.homedir = function() {
        return "/";
      };
    }, function(a, s) {
      var r = /^@media\W/;
      a.exports = function(d, f) {
        for (var h, p = d.length - 1; 0 <= p; p--) h = !f && r.test(d[p][1]), d[p][1] = d[p][1].replace(/\n|\r\n/g, " ").replace(/\s+/g, " ").replace(/(,|:|\() /g, "$1").replace(/ \)/g, ")").replace(/'([a-zA-Z][a-zA-Z\d\-_]+)'/, "$1").replace(/"([a-zA-Z][a-zA-Z\d\-_]+)"/, "$1").replace(h ? /\) /g : null, ")");
        return d;
      };
    }, function(a, s) {
      a.exports = function(l) {
        return l.replace(/\s+/g, " ").replace(/url\(\s+/g, "url(").replace(/\s+\)/g, ")").trim();
      };
    }, function(a, s, r) {
      var l = r(375), d = r(386), f = r(389), h = r(390), p = r(391), g = r(392), _ = r(393), b = r(394), v = r(395), E = r(396), C = r(86), y = r(26).OptimizationLevel, T = r(12);
      a.exports = function A(k, N, j) {
        var I, B, U = N.options.level[y.Two];
        if (function(Q, Y) {
          for (var ie = 0, ce = Q.length; ie < ce; ie++) {
            var $, te = Q[ie];
            te[0] == T.NESTED_BLOCK && ($ = /@(-moz-|-o-|-webkit-)?keyframes/.test(te[1][0][1]), A(te[2], Y, !$));
          }
        }(k, N), function H(Q, Y) {
          for (var ie = 0, ce = Q.length; ie < ce; ie++) {
            var $ = Q[ie];
            switch ($[0]) {
              case T.RULE:
                C($[2], !0, !0, Y);
                break;
              case T.NESTED_BLOCK:
                H($[2], Y);
            }
          }
        }(k, N), U.removeDuplicateRules && b(k, N), U.mergeAdjacentRules && l(k, N), U.reduceNonAdjacentRules && p(k, N), U.mergeNonAdjacentRules && U.mergeNonAdjacentRules != "body" && h(k, N), U.mergeNonAdjacentRules && U.mergeNonAdjacentRules != "selector" && f(k, N), U.restructureRules && U.mergeAdjacentRules && j && (E(k, N), l(k, N)), U.restructureRules && !U.mergeAdjacentRules && j && E(k, N), U.removeDuplicateFontRules && g(k, N), U.removeDuplicateMediaBlocks && _(k, N), U.removeUnusedAtRules && v(k, N), U.mergeMedia) for (B = (I = d(k, N)).length - 1; 0 <= B; B--) A(I[B][2], N, !1);
        return U.removeEmpty && function H(Q) {
          for (var Y = 0, ie = Q.length; Y < ie; Y++) {
            var ce = Q[Y], $ = !1;
            switch (ce[0]) {
              case T.RULE:
                $ = ce[1].length === 0 || ce[2].length === 0;
                break;
              case T.NESTED_BLOCK:
                H(ce[2]), $ = ce[2].length === 0;
                break;
              case T.AT_RULE:
                $ = ce[1].length === 0;
                break;
              case T.AT_RULE_BLOCK:
                $ = ce[2].length === 0;
            }
            $ && (Q.splice(Y, 1), Y--, ie--);
          }
        }(k), k;
      };
    }, function(a, s, r) {
      var l = r(85), d = r(86), f = r(124), h = r(125), p = r(26).OptimizationLevel, g = r(14).body, _ = r(14).rules, b = r(12);
      a.exports = function(E, C) {
        for (var y = [null, [], []], T = C.options, A = T.compatibility.selectors.adjacentSpace, k = T.level[p.One].selectorsSortingMethod, N = T.compatibility.selectors.mergeablePseudoClasses, j = T.compatibility.selectors.mergeablePseudoElements, I = T.compatibility.selectors.mergeLimit, B = T.compatibility.selectors.multiplePseudoMerging, U = 0, H = E.length; U < H; U++) {
          var Q = E[U];
          Q[0] == b.RULE ? y[0] == b.RULE && _(Q[1]) == _(y[1]) ? (Array.prototype.push.apply(y[2], Q[2]), d(y[2], !0, !0, C), Q[2] = []) : y[0] == b.RULE && g(Q[2]) == g(y[2]) && l(_(Q[1]), N, j, B) && l(_(y[1]), N, j, B) && y[1].length < I ? (y[1] = h(y[1].concat(Q[1]), !1, A, !1, C.warnings), y[1] = 1 < y.length ? f(y[1], k) : y[1], Q[2] = []) : y = Q : y = [null, [], []];
        }
      };
    }, function(a, s, r) {
      var l = r(186), d = r(187), f = r(129), h = r(34), p = r(87).deep, g = r(130), _ = r(62), b = r(49).single, v = r(14).body, E = r(12);
      function C(A, k, N, j) {
        var I, B, U, H = A[k];
        for (I in N) H !== void 0 && I == H.name || (B = h[I], U = N[I], H && function(Y, ie, ce) {
          var $, te = h[ie], V = h[ce.name];
          if ("overridesShorthands" in te && -1 < te.overridesShorthands.indexOf(ce.name)) return 1;
          if (V && "componentOf" in V) {
            for ($ in Y[ie]) if (-1 < V.componentOf.indexOf($)) return 1;
          }
        }(N, I, H) ? delete N[I] : B.components.length > Object.keys(U).length || !function(Y) {
          var ie, ce;
          for (ce in Y) {
            if (ie !== void 0 && Y[ce].important != ie) return 1;
            ie = Y[ce].important;
          }
        }(U) && function(Y, J, ce) {
          var $, te, V, K, ne = h[J], J = [E.PROPERTY, [E.PROPERTY_NAME, J], [E.PROPERTY_VALUE, ne.defaultValue]], L = b(J);
          for (f([L], ce, []), V = 0, K = ne.components.length; V < K; V++) if ($ = Y[ne.components[V]], te = h[$.name].canOverride, !l(te.bind(null, ce), L.components[V], $)) return;
          return 1;
        }(U, I, j) && function(Y) {
          var ie, ce, $, te = null;
          for (ie in Y) if ($ = Y[ie], "restore" in (ce = h[ie])) {
            if (_([$.all[$.position]], g), $ = ce.restore($, h).length, te !== null && $ !== te) return;
            te = $;
          }
          return 1;
        }(U) && (function(Y) {
          var ie, ce, $ = null;
          for (ie in Y) {
            if (ce = d(Y[ie]), $ !== null && $ !== ce) return 1;
            $ = ce;
          }
        }(U) ? function(Y, ie, ee, $) {
          var te, V, K, ne = function(ae, tt, ve) {
            var Ee, we, ze, Ie, je = [], qe = {}, Ge = {}, Ze = h[tt], tt = [E.PROPERTY, [E.PROPERTY_NAME, tt], [E.PROPERTY_VALUE, Ze.defaultValue]], Qe = b(tt);
            for (f([Qe], ve, []), ze = 0, Ie = Ze.components.length; ze < Ie; ze++) Ee = ae[Ze.components[ze]], d(Ee) ? (we = Ee.all[Ee.position].slice(0, 2), Array.prototype.push.apply(we, Ee.value), je.push(we), (we = p(Ee)).value = function(pe, Se) {
              return "oppositeTo" in (Se = h[Se]) ? pe[Se.oppositeTo].value : [[E.PROPERTY_VALUE, Se.defaultValue]];
            }(ae, we.name), Qe.components[ze] = we, qe[Ee.name] = p(Ee)) : ((we = p(Ee)).all = Ee.all, Qe.components[ze] = we, Ge[Ee.name] = Ee);
            return ve = y(Ge, 1), tt[1].push(ve), _([Qe], g), tt = tt.slice(0, 2), Array.prototype.push.apply(tt, Qe.value), je.unshift(tt), [je, Qe, qe];
          }(ie, ee, $), J = function(ae, Qe, ve) {
            var Ee, we, ze, Ie, je = [], qe = {}, Ge = {}, Ze = h[Qe], tt = [E.PROPERTY, [E.PROPERTY_NAME, Qe], [E.PROPERTY_VALUE, "inherit"]], Qe = b(tt);
            for (f([Qe], ve, []), ze = 0, Ie = Ze.components.length; ze < Ie; ze++) Ee = ae[Ze.components[ze]], d(Ee) ? qe[Ee.name] = Ee : (we = Ee.all[Ee.position].slice(0, 2), Array.prototype.push.apply(we, Ee.value), je.push(we), Ge[Ee.name] = p(Ee));
            return ve = y(qe, 1), tt[1].push(ve), ve = y(qe, 2), tt[2].push(ve), je.unshift(tt), [je, Qe, Ge];
          }(ie, ee, $), L = ne[0], ee = J[0], z = ($ = v(L).length < v(ee).length) ? L : ee, ee = ($ ? ne : J)[1], q = ($ ? ne : J)[2], X = ie[Object.keys(ie)[0]].all;
          for (te in ee.position = X.length, ee.shorthand = !0, ee.dirty = !0, ee.all = X, ee.all.push(z[0]), Y.push(ee), ie) (K = ie[te]).unused = !0, K.name in q && (V = q[K.name], K = function(ae, _e) {
            for (var ve = 0, Ee = ae.length; ve < Ee; ve++) if (ae[ve][1][1] == _e) return ae[ve];
          }(z, te), V.position = X.length, V.all = X, V.all.push(K), Y.push(V));
        } : function(Y, ie, K, $) {
          var te, V = h[K], K = [E.PROPERTY, [E.PROPERTY_NAME, K], [E.PROPERTY_VALUE, V.defaultValue]], ne = b(K);
          ne.shorthand = !0, ne.dirty = !0, f([ne], $, []);
          for (var J, L = 0, z = V.components.length; L < z; L++) {
            var ee = ie[V.components[L]];
            ne.components[L] = p(ee), ne.important = ee.important, te = ee.all;
          }
          for (J in ie) ie[J].unused = !0;
          $ = y(ie, 1), K[1].push($), $ = y(ie, 2), K[2].push($), ne.position = te.length, ne.all = te, ne.all.push(K), Y.push(ne);
        })(A, U, I, j));
      }
      function y(A, k) {
        var N, j, I = [];
        for (j in A) N = (N = (N = A[j]).all[N.position])[k][N[k].length - 1], Array.prototype.push.apply(I, N);
        return I.sort(T);
      }
      function T(I, B) {
        var N = I[0], j = B[0], I = I[1], B = B[1];
        return N < j || N === j && I < B ? -1 : 1;
      }
      a.exports = function(k, N) {
        var j, I, B, U, H, Q, Y, ie = {};
        if (!(k.length < 3)) {
          for (U = 0, H = k.length; U < H; U++) if (B = k[U], j = h[B.name], !B.unused && !B.hack && !B.block && (C(k, U, ie, N), j && j.componentOf)) for (Q = 0, Y = j.componentOf.length; Q < Y; Q++) ie[I = j.componentOf[Q]] = ie[I] || {}, ie[I][B.name] = B;
          C(k, U, ie, N);
        }
      };
    }, function(a, s, r) {
      var l = r(188), d = r(49).single, f = r(12), h = r(16), p = r(84);
      function g(E) {
        for (var C = 0, y = E.length; C < y; C++) if (E[C][1] == "inherit") return 1;
      }
      function _(E, C, y) {
        return (y = y[E]).doubleValues && y.defaultValue.length == 2 ? d([f.PROPERTY, [f.PROPERTY_NAME, E], [f.PROPERTY_VALUE, y.defaultValue[0]], [f.PROPERTY_VALUE, y.defaultValue[1]]]) : y.doubleValues && y.defaultValue.length == 1 ? d([f.PROPERTY, [f.PROPERTY_NAME, E], [f.PROPERTY_VALUE, y.defaultValue[0]]]) : d([f.PROPERTY, [f.PROPERTY_NAME, E], [f.PROPERTY_VALUE, y.defaultValue]]);
      }
      function b(E, C) {
        var y = C[E.name].components, T = [], A = E.value;
        if (A.length < 1) return [];
        A.length < 2 && (A[1] = A[0].slice(0)), A.length < 3 && (A[2] = A[0].slice(0)), A.length < 4 && (A[3] = A[1].slice(0));
        for (var k = y.length - 1; 0 <= k; k--) {
          var N = d([f.PROPERTY, [f.PROPERTY_NAME, y[k]]]);
          N.value = [A[k]], T.unshift(N);
        }
        return T;
      }
      function v(E, C, y) {
        for (var T, A, k, N, j = C[E.name], I = [_(j.components[0], 0, C), _(j.components[1], 0, C), _(j.components[2], 0, C)], B = 0; B < 3; B++) {
          var U = I[B];
          0 < U.name.indexOf("color") ? T = U : 0 < U.name.indexOf("style") ? A = U : k = U;
        }
        return E.value.length == 1 && E.value[0][1] == "inherit" || E.value.length == 3 && E.value[0][1] == "inherit" && E.value[1][1] == "inherit" && E.value[2][1] == "inherit" ? T.value = A.value = k.value = [E.value[0]] : (0 < (E = E.value.slice(0)).length && (N = 1 < (N = E.filter(/* @__PURE__ */ function(Q) {
          return function(Y) {
            return Y[1] != "inherit" && (Q.isWidth(Y[1]) || Q.isUnit(Y[1]) && !Q.isDynamicUnit(Y[1])) && !Q.isStyleKeyword(Y[1]) && !Q.isColorFunction(Y[1]);
          };
        }(y))).length && (N[0][1] == "none" || N[0][1] == "auto") ? N[1] : N[0]) && (k.value = [N], E.splice(E.indexOf(N), 1)), 0 < E.length && (N = E.filter(/* @__PURE__ */ function(Q) {
          return function(Y) {
            return Y[1] != "inherit" && Q.isStyleKeyword(Y[1]) && !Q.isColorFunction(Y[1]);
          };
        }(y))[0]) && (A.value = [N], E.splice(E.indexOf(N), 1)), 0 < E.length && (N = E.filter(/* @__PURE__ */ function(Q) {
          return function(Y) {
            return Y[1] == "invert" || Q.isColor(Y[1]) || Q.isPrefixed(Y[1]);
          };
        }(y))[0]) && (T.value = [N], E.splice(E.indexOf(N), 1))), I;
      }
      a.exports = { animation: function(C, ce, T) {
        var A, k, N, j = _(C.name + "-duration", 0, ce), I = _(C.name + "-timing-function", 0, ce), B = _(C.name + "-delay", 0, ce), U = _(C.name + "-iteration-count", 0, ce), H = _(C.name + "-direction", 0, ce), Q = _(C.name + "-fill-mode", 0, ce), Y = _(C.name + "-play-state", 0, ce), ie = _(C.name + "-name", 0, ce), ce = [j, I, B, U, H, Q, Y, ie], $ = C.value, te = !1, V = !1, K = !1, ne = !1, J = !1, L = !1, z = !1, ee = !1;
        if (C.value.length == 1 && C.value[0][1] == "inherit") return j.value = I.value = B.value = U.value = H.value = Q.value = Y.value = ie.value = C.value, ce;
        if (1 < $.length && g($)) throw new l("Invalid animation values at " + p($[0][2][0]) + ". Ignoring.");
        for (k = 0, N = $.length; k < N; k++) if (A = $[k], T.isTime(A[1]) && !te) j.value = [A], te = !0;
        else if (T.isTime(A[1]) && !K) B.value = [A], K = !0;
        else if (!T.isGlobal(A[1]) && !T.isTimingFunction(A[1]) || V) if (!T.isAnimationIterationCountKeyword(A[1]) && !T.isPositiveNumber(A[1]) || ne) if (T.isAnimationDirectionKeyword(A[1]) && !J) H.value = [A], J = !0;
        else if (T.isAnimationFillModeKeyword(A[1]) && !L) Q.value = [A], L = !0;
        else if (T.isAnimationPlayStateKeyword(A[1]) && !z) Y.value = [A], z = !0;
        else {
          if (!T.isAnimationNameKeyword(A[1]) && !T.isIdentifier(A[1]) || ee) throw new l("Invalid animation value at " + p(A[2][0]) + ". Ignoring.");
          ie.value = [A], ee = !0;
        }
        else U.value = [A], ne = !0;
        else I.value = [A], V = !0;
        return ce;
      }, background: function(C, y, T) {
        var A = _("background-image", 0, y), k = _("background-position", 0, y), N = _("background-size", 0, y), j = _("background-repeat", 0, y), I = _("background-attachment", 0, y), B = _("background-origin", 0, y), U = _("background-clip", 0, y), H = _("background-color", 0, y), Q = [A, k, N, j, I, B, U, H], Y = C.value, ie = !1, ce = !1, $ = !1, te = !1, V = !1;
        if (C.value.length == 1 && C.value[0][1] == "inherit") return H.value = A.value = j.value = k.value = N.value = B.value = U.value = C.value, Q;
        if (C.value.length == 1 && C.value[0][1] == "0 0") return Q;
        for (var K = Y.length - 1; 0 <= K; K--) {
          var ne, J = Y[K];
          T.isBackgroundAttachmentKeyword(J[1]) ? (I.value = [J], V = !0) : T.isBackgroundClipKeyword(J[1]) || T.isBackgroundOriginKeyword(J[1]) ? (ce ? (B.value = [J], $ = !0) : (U.value = [J], ce = !0), V = !0) : T.isBackgroundRepeatKeyword(J[1]) ? (te ? j.value.unshift(J) : (j.value = [J], te = !0), V = !0) : T.isBackgroundPositionKeyword(J[1]) || T.isBackgroundSizeKeyword(J[1]) || T.isUnit(J[1]) || T.isDynamicUnit(J[1]) ? (0 < K ? (ne = Y[K - 1])[1] == h.FORWARD_SLASH ? N.value = [J] : 1 < K && Y[K - 2][1] == h.FORWARD_SLASH ? (N.value = [ne, J], K -= 2) : (ie || (k.value = []), k.value.unshift(J), ie = !0) : (ie || (k.value = []), k.value.unshift(J), ie = !0), V = !0) : H.value[0][1] != y[H.name].defaultValue && H.value[0][1] != "none" || !T.isColor(J[1]) && !T.isPrefixed(J[1]) ? (T.isUrl(J[1]) || T.isFunction(J[1])) && (A.value = [J], V = !0) : (H.value = [J], V = !0);
        }
        if (ce && !$ && (B.value = U.value.slice(0)), !V) throw new l("Invalid background value at " + p(Y[0][2][0]) + ". Ignoring.");
        return Q;
      }, border: v, borderRadius: function(C, y) {
        for (var T = C.value, A = -1, k = 0, N = T.length; k < N; k++) if (T[k][1] == h.FORWARD_SLASH) {
          A = k;
          break;
        }
        if (A === 0 || A === T.length - 1) throw new l("Invalid border-radius value at " + p(T[0][2][0]) + ". Ignoring.");
        var j = _(C.name, 0, y);
        j.value = -1 < A ? T.slice(0, A) : T.slice(0), j.components = b(j, y);
        var I = _(C.name, 0, y);
        I.value = -1 < A ? T.slice(A + 1) : T.slice(0), I.components = b(I, y);
        for (var B = 0; B < 4; B++) j.components[B].multiplex = !0, j.components[B].value = j.components[B].value.concat(I.components[B].value);
        return j.components;
      }, font: function(C, L, T) {
        var A, k, N, j, I = _("font-style", 0, L), B = _("font-variant", 0, L), U = _("font-weight", 0, L), H = _("font-stretch", 0, L), Q = _("font-size", 0, L), Y = _("line-height", 0, L), ie = _("font-family", 0, L), ce = [I, B, U, H, Q, Y, ie], $ = C.value, te = 0, V = !1, K = !1, ne = !1, J = !1, L = !1, z = !1;
        if (!$[te]) throw new l("Missing font values at " + p(C.all[C.position][1][2][0]) + ". Ignoring.");
        if ($.length == 1 && $[0][1] == "inherit") return I.value = B.value = U.value = H.value = Q.value = Y.value = ie.value = $, ce;
        if ($.length == 1 && (T.isFontKeyword($[0][1]) || T.isGlobal($[0][1]) || T.isPrefixed($[0][1]))) return $[0][1] = h.INTERNAL + $[0][1], I.value = B.value = U.value = H.value = Q.value = Y.value = ie.value = $, ce;
        if ($.length < 2 || !function(q, X) {
          for (var oe, ae = 0, _e = q.length; ae < _e; ae++) if (oe = q[ae], X.isFontSizeKeyword(oe[1]) || X.isUnit(oe[1]) && !X.isDynamicUnit(oe[1]) || X.isFunction(oe[1])) return 1;
        }($, T) || !function(q, X) {
          for (var oe, ae = 0, _e = q.length; ae < _e; ae++) if (oe = q[ae], X.isIdentifier(oe[1])) return 1;
        }($, T)) throw new l("Invalid font values at " + p(C.all[C.position][1][2][0]) + ". Ignoring.");
        if (1 < $.length && g($)) throw new l("Invalid font values at " + p($[0][2][0]) + ". Ignoring.");
        for (; te < 4; ) {
          if (A = T.isFontStretchKeyword($[te][1]) || T.isGlobal($[te][1]), k = T.isFontStyleKeyword($[te][1]) || T.isGlobal($[te][1]), N = T.isFontVariantKeyword($[te][1]) || T.isGlobal($[te][1]), j = T.isFontWeightKeyword($[te][1]) || T.isGlobal($[te][1]), k && !K) I.value = [$[te]], K = !0;
          else if (N && !ne) B.value = [$[te]], ne = !0;
          else if (j && !J) U.value = [$[te]], J = !0;
          else {
            if (!A || V) {
              if (k && K || N && ne || j && J || A && V) throw new l("Invalid font style / variant / weight / stretch value at " + p($[0][2][0]) + ". Ignoring.");
              break;
            }
            H.value = [$[te]], V = !0;
          }
          te++;
        }
        if (!(T.isFontSizeKeyword($[te][1]) || T.isUnit($[te][1]) && !T.isDynamicUnit($[te][1]))) throw new l("Missing font size at " + p($[0][2][0]) + ". Ignoring.");
        if (Q.value = [$[te]], L = !0, !$[++te]) throw new l("Missing font family at " + p($[0][2][0]) + ". Ignoring.");
        for (L && $[te] && $[te][1] == h.FORWARD_SLASH && $[te + 1] && (T.isLineHeightKeyword($[te + 1][1]) || T.isUnit($[te + 1][1]) || T.isNumber($[te + 1][1])) && (Y.value = [$[te + 1]], te++, te++), ie.value = []; $[te]; ) z = $[te][1] != h.COMMA && (z ? ie.value[ie.value.length - 1][1] += h.SPACE + $[te][1] : ie.value.push($[te]), !0), te++;
        if (ie.value.length === 0) throw new l("Missing font family at " + p($[0][2][0]) + ". Ignoring.");
        return ce;
      }, fourValues: b, listStyle: function(C, j, T) {
        var A = _("list-style-type", 0, j), k = _("list-style-position", 0, j), N = _("list-style-image", 0, j), j = [A, k, N];
        if (C.value.length == 1 && C.value[0][1] == "inherit") return A.value = k.value = N.value = [C.value[0]], j;
        for (var I = C.value.slice(0), U = I.length, B = 0, B = 0, U = I.length; B < U; B++) if (T.isUrl(I[B][1]) || I[B][1] == "0") {
          N.value = [I[B]], I.splice(B, 1);
          break;
        }
        for (B = 0, U = I.length; B < U; B++) if (T.isListStylePositionKeyword(I[B][1])) {
          k.value = [I[B]], I.splice(B, 1);
          break;
        }
        return 0 < I.length && (T.isListStyleTypeKeyword(I[0][1]) || T.isIdentifier(I[0][1])) && (A.value = [I[0]]), j;
      }, multiplex: function(C) {
        return function(y, T, A) {
          for (var k, N, j = [], I = y.value, B = 0, U = I.length; B < U; B++) I[B][1] == "," && j.push(B);
          if (j.length === 0) return C(y, T, A);
          for (var H = [], B = 0, U = j.length; B <= U; B++) {
            var Q = B === 0 ? 0 : j[B - 1] + 1, Y = B < U ? j[B] : I.length, ie = _(y.name, 0, T);
            ie.value = I.slice(Q, Y), H.push(C(ie, T, A));
          }
          var ce = H[0];
          for (B = 0, U = ce.length; B < U; B++) for (ce[B].multiplex = !0, k = 1, N = H.length; k < N; k++) ce[B].value.push([f.PROPERTY_VALUE, h.COMMA]), Array.prototype.push.apply(ce[B].value, H[k][B].value);
          return ce;
        };
      }, outline: v, transition: function(C, H, T) {
        var A, k, N, j = _(C.name + "-property", 0, H), I = _(C.name + "-duration", 0, H), B = _(C.name + "-timing-function", 0, H), U = _(C.name + "-delay", 0, H), H = [j, I, B, U], Q = C.value, Y = !1, ie = !1, ce = !1, $ = !1;
        if (C.value.length == 1 && C.value[0][1] == "inherit") return j.value = I.value = B.value = U.value = C.value, H;
        if (1 < Q.length && g(Q)) throw new l("Invalid animation values at " + p(Q[0][2][0]) + ". Ignoring.");
        for (k = 0, N = Q.length; k < N; k++) if (A = Q[k], T.isTime(A[1]) && !Y) I.value = [A], Y = !0;
        else if (T.isTime(A[1]) && !ie) U.value = [A], ie = !0;
        else if (!T.isGlobal(A[1]) && !T.isTimingFunction(A[1]) || $) {
          if (!T.isIdentifier(A[1]) || ce) throw new l("Invalid animation value at " + p(A[2][0]) + ". Ignoring.");
          j.value = [A], ce = !0;
        } else B.value = [A], $ = !0;
        return H;
      } };
    }, function(a, s, r) {
      var l = r(379);
      function d(_) {
        return function(b, v, E) {
          return !(!l(b, v, E, 0, !0) && !b.isKeyword(_)(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isKeyword(_)(E));
        };
      }
      function f(_) {
        return function(b, v, E) {
          return !!(l(b, v, E, 0, !0) || b.isKeyword(_)(E) || b.isGlobal(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isKeyword(_)(E) || b.isGlobal(E));
        };
      }
      function h(_, b, v) {
        return !!function(C, y, T) {
          return C.isFunction(y) && C.isFunction(T) && y.substring(0, y.indexOf("(")) === T.substring(0, T.indexOf("("));
        }(_, b, v) || b === v;
      }
      function p(_, b, v) {
        return !(!l(_, b, v, 0, !0) && !_.isUnit(v)) && (!(!_.isVariable(b) || !_.isVariable(v)) || !(_.isUnit(b) && !_.isUnit(v)) && (!!_.isUnit(v) || !_.isUnit(b) && (!(!_.isFunction(b) || _.isPrefixed(b) || !_.isFunction(v) || _.isPrefixed(v)) || h(_, b, v))));
      }
      function g(_) {
        var b = f(_);
        return function(v, E, C) {
          return p(v, E, C) || b(v, E, C);
        };
      }
      a.exports = { generic: { color: function(b, v, E) {
        return !(!l(b, v, E, 0, !0) && !b.isColor(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || !(!b.colorOpacity && (b.isRgbColor(v) || b.isHslColor(v))) && !(!b.colorOpacity && (b.isRgbColor(E) || b.isHslColor(E))) && (!(!b.isColor(v) || !b.isColor(E)) || h(b, v, E)));
      }, components: function(b) {
        return function(v, E, C, y) {
          return b[y](v, E, C);
        };
      }, image: function(b, v, E) {
        return !(!l(b, v, E, 0, !0) && !b.isImage(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || !!b.isImage(E) || !b.isImage(v) && h(b, v, E));
      }, propertyName: function(b, v, E) {
        return !(!l(b, v, E, 0, !0) && !b.isIdentifier(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isIdentifier(E));
      }, time: function(b, v, E) {
        return !(!l(b, v, E, 0, !0) && !b.isTime(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || !(b.isTime(v) && !b.isTime(E)) && (!!b.isTime(E) || !b.isTime(v) && (!(!b.isFunction(v) || b.isPrefixed(v) || !b.isFunction(E) || b.isPrefixed(E)) || h(b, v, E))));
      }, timingFunction: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isTimingFunction(E) || b.isGlobal(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isTimingFunction(E) || b.isGlobal(E));
      }, unit: p, unitOrNumber: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isUnit(E) || b.isNumber(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || !((b.isUnit(v) || b.isNumber(v)) && !b.isUnit(E) && !b.isNumber(E)) && (!(!b.isUnit(E) && !b.isNumber(E)) || !b.isUnit(v) && !b.isNumber(v) && (!(!b.isFunction(v) || b.isPrefixed(v) || !b.isFunction(E) || b.isPrefixed(E)) || h(b, v, E))));
      } }, property: { animationDirection: f("animation-direction"), animationFillMode: d("animation-fill-mode"), animationIterationCount: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isAnimationIterationCountKeyword(E) || b.isPositiveNumber(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isAnimationIterationCountKeyword(E) || b.isPositiveNumber(E));
      }, animationName: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isAnimationNameKeyword(E) || b.isIdentifier(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isAnimationNameKeyword(E) || b.isIdentifier(E));
      }, animationPlayState: f("animation-play-state"), backgroundAttachment: d("background-attachment"), backgroundClip: f("background-clip"), backgroundOrigin: d("background-origin"), backgroundPosition: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isBackgroundPositionKeyword(E) || b.isGlobal(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || !(!b.isBackgroundPositionKeyword(E) && !b.isGlobal(E)) || p(b, v, E));
      }, backgroundRepeat: d("background-repeat"), backgroundSize: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isBackgroundSizeKeyword(E) || b.isGlobal(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || !(!b.isBackgroundSizeKeyword(E) && !b.isGlobal(E)) || p(b, v, E));
      }, bottom: g("bottom"), borderCollapse: d("border-collapse"), borderStyle: f("*-style"), clear: f("clear"), cursor: f("cursor"), display: f("display"), float: f("float"), left: g("left"), fontFamily: function(b, v, E) {
        return l(b, v, E, 0, !0);
      }, fontStretch: f("font-stretch"), fontStyle: f("font-style"), fontVariant: f("font-variant"), fontWeight: f("font-weight"), listStyleType: f("list-style-type"), listStylePosition: f("list-style-position"), outlineStyle: f("*-style"), overflow: f("overflow"), position: f("position"), right: g("right"), textAlign: f("text-align"), textDecoration: f("text-decoration"), textOverflow: f("text-overflow"), textShadow: function(b, v, E) {
        return !!(l(b, v, E, 0, !0) || b.isUnit(E) || b.isColor(E) || b.isGlobal(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isUnit(E) || b.isColor(E) || b.isGlobal(E));
      }, top: g("top"), transform: h, verticalAlign: g("vertical-align"), visibility: f("visibility"), whiteSpace: f("white-space"), zIndex: function(b, v, E) {
        return !(!l(b, v, E, 0, !0) && !b.isZIndex(E)) && (!(!b.isVariable(v) || !b.isVariable(E)) || b.isZIndex(E));
      } } };
    }, function(a, s, r) {
      var l = r(189).same;
      a.exports = function(f, h, p, g, _) {
        return !(!l(h, p) || _ && f.isVariable(h) !== f.isVariable(p));
      };
    }, function(a, s, r) {
      var l = r(87).shallow, d = r(12), f = r(16);
      function h(g) {
        for (var _ = 0, b = g.length; _ < b; _++) {
          var v = g[_][1];
          if (v != "inherit" && v != f.COMMA && v != f.FORWARD_SLASH) return;
        }
        return 1;
      }
      function p(v) {
        var _ = (E = v.components)[0].value[0], b = E[1].value[0], v = E[2].value[0], E = E[3].value[0];
        return _[1] == b[1] && _[1] == v[1] && _[1] == E[1] ? [_] : _[1] == v[1] && b[1] == E[1] ? [_, b] : b[1] == E[1] ? [_, b, v] : [_, b, v, E];
      }
      a.exports = { background: function(_, b, v) {
        var E = _.components, C = [];
        function y(H) {
          Array.prototype.unshift.apply(C, H.value);
        }
        function T(H) {
          var Q = b[H.name];
          return Q.doubleValues && Q.defaultValue.length == 1 ? H.value[0][1] == Q.defaultValue[0] && (!H.value[1] || H.value[1][1] == Q.defaultValue[0]) : Q.doubleValues && Q.defaultValue.length != 1 ? H.value[0][1] == Q.defaultValue[0] && (H.value[1] || H.value[0])[1] == Q.defaultValue[1] : H.value[0][1] == Q.defaultValue;
        }
        for (var A = E.length - 1; 0 <= A; A--) {
          var k, N, j, I, B = E[A], U = T(B);
          B.name == "background-clip" ? (j = T(I = E[A - 1]), N = !(k = B.value[0][1] == I.value[0][1]) && (j && !U || !j && !U || !j && U && B.value[0][1] != I.value[0][1]), k ? y(I) : N && (y(B), y(I)), A--) : B.name == "background-size" ? (N = !(k = !(I = T(j = E[A - 1])) && U) && (I && !U || !I && !U), k ? y(j) : N ? (y(B), C.unshift([d.PROPERTY_VALUE, f.FORWARD_SLASH]), y(j)) : j.value.length == 1 && y(j), A--) : U || b[B.name].multiplexLastOnly && !v || y(B);
        }
        return C.length === 0 && _.value.length == 1 && _.value[0][1] == "0" && C.push(_.value[0]), C.length === 0 && C.push([d.PROPERTY_VALUE, b[_.name].defaultValue]), h(C) ? [C[0]] : C;
      }, borderRadius: function(_, b) {
        if (_.multiplex) {
          for (var v = l(_), E = l(_), C = 0; C < 4; C++) {
            var y = _.components[C], T = l(_);
            T.value = [y.value[0]], v.components.push(T), (T = l(_)).value = [y.value[1] || y.value[0]], E.components.push(T);
          }
          var A = p(v), k = p(E);
          return A.length != k.length || A[0][1] != k[0][1] || 1 < A.length && A[1][1] != k[1][1] || 2 < A.length && A[2][1] != k[2][1] || 3 < A.length && A[3][1] != k[3][1] ? A.concat([[d.PROPERTY_VALUE, f.FORWARD_SLASH]]).concat(k) : A;
        }
        return p(_);
      }, font: function(_, b) {
        var v, E = _.components, C = [], y = 0, T = 0;
        if (_.value[0][1].indexOf(f.INTERNAL) === 0) return _.value[0][1] = _.value[0][1].substring(f.INTERNAL.length), _.value;
        for (; y < 4; ) (v = E[y]).value[0][1] != b[v.name].defaultValue && Array.prototype.push.apply(C, v.value), y++;
        for (Array.prototype.push.apply(C, E[y].value), E[++y].value[0][1] != b[E[y].name].defaultValue && (Array.prototype.push.apply(C, [[d.PROPERTY_VALUE, f.FORWARD_SLASH]]), Array.prototype.push.apply(C, E[y].value)), y++; E[y].value[T]; ) C.push(E[y].value[T]), E[y].value[T + 1] && C.push([d.PROPERTY_VALUE, f.COMMA]), T++;
        return h(C) ? [C[0]] : C;
      }, fourValues: p, multiplex: function(_) {
        return function(b, v) {
          if (!b.multiplex) return _(b, v, !0);
          for (var E = 0, C = [], y = {}, T = 0, A = b.components[0].value.length; T < A; T++) b.components[0].value[T][1] == f.COMMA && E++;
          for (T = 0; T <= E; T++) {
            for (var k = l(b), N = 0, j = b.components.length; N < j; N++) {
              var I = b.components[N], B = l(I);
              k.components.push(B);
              for (var U = y[B.name] || 0, H = I.value.length; U < H; U++) {
                if (I.value[U][1] == f.COMMA) {
                  y[B.name] = U + 1;
                  break;
                }
                B.value.push(I.value[U]);
              }
            }
            var Q = _(k, v, T == E);
            Array.prototype.push.apply(C, Q), T < E && C.push([d.PROPERTY_VALUE, f.COMMA]);
          }
          return C;
        };
      }, withoutDefaults: function(_, b) {
        for (var v = _.components, E = [], C = v.length - 1; 0 <= C; C--) {
          var y = v[C], T = b[y.name];
          (y.value[0][1] != T.defaultValue || "keepUnlessDefault" in T && !function(k, N, j) {
            for (var I, B = 0, U = k.length; B < U; B++) if ((I = k[B]).name == j && I.value[0][1] == N[j].defaultValue) return 1;
          }(v, b, T.keepUnlessDefault)) && E.unshift(y.value[0]);
        }
        return E.length === 0 && E.push([d.PROPERTY_VALUE, b[_.name].defaultValue]), h(E) ? [E[0]] : E;
      } };
    }, function(a, s, r) {
      var l = r(187), d = r(186), f = r(382), h = r(383), p = r(384), g = r(385), _ = r(189).same, b = r(34), v = r(87).deep, E = r(130), C = r(87).shallow, y = r(62), T = r(12), A = r(16), k = r(14).property;
      function N($, te) {
        te.unused = !0, B(te, H($)), $.value = te.value;
      }
      function j($, te) {
        te.unused = !0, $.multiplex = !0, $.value = te.value;
      }
      function I($, te) {
        (te.multiplex ? j : $.multiplex ? N : function(K, ne) {
          ne.unused = !0, K.value = ne.value;
        })($, te);
      }
      function B($, te) {
        $.multiplex = !0, (b[$.name].shorthand ? function(K, ne) {
          for (var J, L = 0, z = K.components.length; L < z; L++) (J = K.components[L]).multiplex || U(J, ne);
        } : U)($, te);
      }
      function U($, te) {
        for (var V, K = b[$.name], ne = K.intoMultiplexMode == "real", J = K.intoMultiplexMode == "real" ? $.value.slice(0) : K.intoMultiplexMode == "placeholder" ? K.placeholderValue : K.defaultValue, L = H($), z = J.length; L < te; L++) if ($.value.push([T.PROPERTY_VALUE, A.COMMA]), Array.isArray(J)) for (V = 0; V < z; V++) $.value.push(ne ? J[V] : [T.PROPERTY_VALUE, J[V]]);
        else $.value.push(ne ? J : [T.PROPERTY_VALUE, J]);
      }
      function H($) {
        for (var te = 0, V = 0, K = $.value.length; V < K; V++) $.value[V][1] == A.COMMA && te++;
        return te + 1;
      }
      function Q($) {
        return $ = [T.PROPERTY, [T.PROPERTY_NAME, $.name]].concat($.value), k([$], 0).length;
      }
      function Y($, te) {
        for (var V = 0, K = $.components.length; V < K; V++) if (!ie(te.isUrl, $.components[V]) && ie(te.isFunction, $.components[V])) return 1;
      }
      function ie($, te) {
        for (var V = 0, K = te.value.length; V < K; V++) if (te.value[V][1] != A.COMMA && $(te.value[V][1])) return 1;
      }
      function ce($) {
        return $.name in b;
      }
      a.exports = function(te, V, K, ne) {
        var J, L, z, ee, q, X, oe, ae, _e, ve, Ee, we;
        e: for (oe = te.length - 1; 0 <= oe; oe--) if (ce(J = te[oe]) && !J.block) {
          je = b[J.name].canOverride;
          t: for (ae = oe - 1; 0 <= ae; ae--) if (ce(L = te[ae]) && !L.block && !L.unused && !J.unused && (!L.hack || J.hack || J.important) && (L.hack || L.important || !J.hack) && (L.important != J.important || L.hack[0] == J.hack[0]) && !(L.important == J.important && (L.hack[0] != J.hack[0] || L.hack[1] && L.hack[1] != J.hack[1]) || l(J) || function(Ge, Ze) {
            return !Ge.multiplex && (Ge.name == "background" || Ge.name == "background-image") && Ze.multiplex && (Ze.name == "background" || Ze.name == "background-image") && function(Qe) {
              for (var ke = function(Te) {
                for (var Me = [], Ye = 0, et = [], dt = Te.length; Ye < dt; Ye++) {
                  var We = Te[Ye];
                  We[1] == A.COMMA ? (Me.push(et), et = []) : et.push(We);
                }
                return Me.push(et), Me;
              }(Qe), pe = 0, Se = ke.length; pe < Se; pe++) if (ke[pe].length == 1 && ke[pe][0][1] == "none") return 1;
            }(Ze.value);
          }(L, J))) {
            if (J.shorthand && h(J, L)) !J.important && L.important || _([L], J.components) && (!ie(ne.isFunction, L) && Y(J, ne) || (p(J) ? (we = f(J, L), je = b[L.name].canOverride, d(je.bind(null, ne), L, we) && (L.unused = !0)) : L.unused = !0));
            else if (J.shorthand && g(J, L)) {
              if ((J.important || !L.important) && _([L], J.components) && (ie(ne.isFunction, L) || !Y(J, ne))) {
                for (_e = (z = L.shorthand ? L.components : [L]).length - 1; 0 <= _e; _e--) if (ee = z[_e], q = f(J, ee), je = b[ee.name].canOverride, !d(je.bind(null, ne), L, q)) continue t;
                L.unused = !0;
              }
            } else if (V && L.shorthand && !J.shorthand && h(L, J, !0)) J.important && !L.important || (J.important || !L.important ? function(Ge, Ze, tt) {
              for (var Qe = 0, ke = Ze; 0 <= ke && (Ge[ke].name != tt || Ge[ke].unused || Qe++, !(1 < Qe)); ke--) ;
              return 1 < Qe;
            }(te, oe - 1, L.name) || Y(L, ne) || p(L) && (we = f(L, J), d(je.bind(null, ne), we, J) && (ve = !K.properties.backgroundClipMerging && -1 < we.name.indexOf("background-clip") || !K.properties.backgroundOriginMerging && -1 < we.name.indexOf("background-origin") || !K.properties.backgroundSizeMerging && -1 < we.name.indexOf("background-size"), Ee = b[J.name].nonMergeableValue === J.value[0][1], ve || Ee || !K.properties.merging && function(Ge, Ze) {
              for (var tt = 0; tt < Ge.components.length; tt++) {
                var Qe = Ge.components[tt], ke = b[Qe.name], pe = ke && ke.canOverride || pe.sameValue, Se = C(Qe);
                if (Se.value = [[T.PROPERTY_VALUE, ke.defaultValue]], !d(pe.bind(null, Ze), Se, Qe)) return 1;
              }
            }(L, ne) || we.value[0][1] != J.value[0][1] && (l(L) || l(J)) || function(Ge, Ze) {
              if (!(!Ge.multiplex && !Ze.multiplex || Ge.multiplex && Ze.multiplex)) {
                var tt, Qe = Ge.multiplex ? Ge : Ze, ke = Ge.multiplex ? Ze : Ge, Ze = v(Qe);
                return y([Ze], E), Qe = v(ke), y([Qe], E), ke = Q(Ze) + 1 + Q(Qe), Ge.multiplex ? N(tt = f(Ze, Qe), Qe) : (tt = f(Qe, Ze), B(Qe, H(Ze)), j(tt, Ze)), y([Qe], E), ke <= Q(Qe);
              }
            }(L, J) || (!L.multiplex && J.multiplex && B(L, H(J)), I(we, J), L.dirty = !0))) : J.unused = !0);
            else if (V && L.shorthand && J.shorthand && L.name == J.name) {
              if (L.multiplex || !J.multiplex) {
                if (!J.important && L.important) {
                  J.unused = !0;
                  continue e;
                }
                if (!J.important || L.important) if (p(J)) {
                  for (_e = L.components.length - 1; 0 <= _e; _e--) {
                    var ze = L.components[_e], Ie = J.components[_e], je = b[ze.name].canOverride;
                    if (!d(je.bind(null, ne), ze, Ie)) continue e;
                  }
                  (function(Ge, Ze) {
                    Ze.unused = !0;
                    for (var tt = 0, Qe = Ge.components.length; tt < Qe; tt++) I(Ge.components[tt], Ze.components[tt], Ge.multiplex);
                  })(L, J), L.dirty = !0;
                } else L.unused = !0;
                else L.unused = !0;
              }
            } else if (V && L.shorthand && J.shorthand && h(L, J)) !L.important && J.important || (we = f(L, J), je = b[J.name].canOverride, d(je.bind(null, ne), we, J) && (!L.important || J.important ? 1 < b[J.name].restore(J, b).length || (I(we = f(L, J), J), J.dirty = !0) : J.unused = !0));
            else if (L.name == J.name) {
              if (X = !0, J.shorthand) for (_e = J.components.length - 1; 0 <= _e && X; _e--) ee = L.components[_e], q = J.components[_e], je = b[q.name].canOverride, X = X && d(je.bind(null, ne), ee, q);
              else je = b[J.name].canOverride, X = d(je.bind(null, ne), L, J);
              L.important && !J.important && X ? J.unused = !0 : (!L.important && J.important && X || X) && (L.unused = !0);
            }
          }
        }
      };
    }, function(a, s, r) {
      var l = r(34);
      function d(f, h) {
        return f.components.filter(h)[0];
      }
      a.exports = function(h, p) {
        return d(h, p = /* @__PURE__ */ function(_) {
          return function(b) {
            return _.name === b.name;
          };
        }(p)) || function(_, b) {
          var v, E, C;
          if (l[_.name].shorthandComponents) {
            for (E = 0, C = _.components.length; E < C; E++) if (v = d(_.components[E], b)) return v;
          }
        }(h, p);
      };
    }, function(a, s, r) {
      var l = r(34);
      function d(f, h) {
        return "components" in (f = l[f.name]) && -1 < f.components.indexOf(h.name);
      }
      a.exports = function(h, p, g) {
        return d(h, p) || !g && !!l[h.name].shorthandComponents && function(b, v) {
          return b.components.some(function(E) {
            return d(E, v);
          });
        }(h, p);
      };
    }, function(a, s, r) {
      var l = r(16);
      a.exports = function(f) {
        return f.name != "font" || f.value[0][1].indexOf(l.INTERNAL) == -1;
      };
    }, function(a, s, r) {
      var l = r(34);
      a.exports = function(f, h) {
        return f.name in l && "overridesShorthands" in l[f.name] && -1 < l[f.name].overridesShorthands.indexOf(h.name);
      };
    }, function(a, s, r) {
      var l = r(88).canReorder, d = r(88).canReorderSingle, f = r(131), h = r(190), p = r(14).rules, g = r(26).OptimizationLevel, _ = r(12);
      a.exports = function(v, E) {
        for (var C, y = E.options.level[g.Two].mergeSemantically, T = E.cache.specificity, A = {}, k = [], N = v.length - 1; 0 <= N; N--) {
          var j, I = v[N];
          I[0] == _.NESTED_BLOCK && ((I = A[j = p(I[1])]) || (A[j] = I = []), I.push(N));
        }
        for (C in A) {
          var B = A[C];
          e: for (var U = B.length - 1; 0 < U; U--) {
            var H = B[U], Q = v[H], Y = B[U - 1], ie = v[Y];
            t: for (var ce = 1; -1 <= ce; ce -= 2) {
              for (var $ = ce == 1, te = $ ? H + 1 : Y - 1, V = $ ? Y : H, K = $ ? 1 : -1, ne = $ ? Q : ie, J = $ ? ie : Q, L = f(ne); te != V; ) {
                var z = f(v[te]);
                if (te += K, !(y && function(q, X, oe) {
                  for (var ae, _e, ve, Ee, we, ze, Ie = 0, je = q.length; Ie < je; Ie++) for (_e = (ae = q[Ie])[5], we = 0, ze = X.length; we < ze; we++) if (Ee = (ve = X[we])[5], h(_e, Ee, !0) && !d(ae, ve, oe)) return;
                  return 1;
                }(L, z, T) || l(L, z, T))) continue t;
              }
              J[2] = $ ? ne[2].concat(J[2]) : J[2].concat(ne[2]), ne[2] = [], k.push(J);
              continue e;
            }
          }
        }
        return k;
      };
    }, function(a, s, r) {
      var l = r(388);
      function d(f, h) {
        var p;
        return f in h || (h[f] = p = l(f)), p || h[f];
      }
      a.exports = function(h, p, g) {
        for (var _, b, v, E, C = 0, y = h.length; C < y; C++) for (_ = d(h[C][1], g), v = 0, E = p.length; v < E; v++) if (b = d(p[v][1], g), _[0] === b[0] && _[1] === b[1] && _[2] === b[2]) return !0;
        return !1;
      };
    }, function(a, s, r) {
      var l = r(16), d = /[a-zA-Z]/, f = /[\s,\(>~\+]/;
      a.exports = function(p) {
        for (var g, _, b, v, E, C = [0, 0, 0], y = 0, T = !1, A = !1, k = 0, N = p.length; k < N; k++) {
          if (g = p[k], !_) if (g != l.SINGLE_QUOTE || v || b) if (g == l.SINGLE_QUOTE && !v && b) b = !1;
          else if (g != l.DOUBLE_QUOTE || v || b) if (g == l.DOUBLE_QUOTE && v && !b) v = !1;
          else {
            if (b || v) continue;
            0 < y && !T || (g == l.OPEN_ROUND_BRACKET ? y++ : g == l.CLOSE_ROUND_BRACKET && y == 1 ? (y--, T = !1) : g == l.CLOSE_ROUND_BRACKET ? y-- : g == "#" ? C[0]++ : g == "." || g == l.OPEN_SQUARE_BRACKET ? C[1]++ : g != ":" || A || function(I, B) {
              return I.indexOf(":not(", B) === B;
            }(p, k) ? g == ":" ? T = !0 : (k === 0 || E) && d.test(g) && C[2]++ : (C[1]++, T = !1));
          }
          else v = !0;
          else b = !0;
          A = g == ":", E = !(_ = g == l.BACK_SLASH) && f.test(g);
        }
        return C;
      };
    }, function(a, s, r) {
      var l = r(85), d = r(124), f = r(125), h = r(26).OptimizationLevel, p = r(14).body, g = r(14).rules, _ = r(12);
      function b(v) {
        return v.replace(/--[^ ,>\+~:]+/g, "");
      }
      a.exports = function(E, C) {
        for (var y = C.options, T = y.level[h.Two].mergeSemantically, A = y.compatibility.selectors.adjacentSpace, k = y.level[h.One].selectorsSortingMethod, N = y.compatibility.selectors.mergeablePseudoClasses, j = y.compatibility.selectors.mergeablePseudoElements, I = y.compatibility.selectors.multiplePseudoMerging, B = {}, U = E.length - 1; 0 <= U; U--) {
          var H, Q, Y = E[U];
          Y[0] == _.RULE && (0 < Y[2].length && !T && function(ce) {
            return /\.|\*| :/.test(ce);
          }(g(Y[1])) && (B = {}), 0 < Y[2].length && T && function(ce) {
            return -1 < (ce = g(ce[1])).indexOf("__") || -1 < ce.indexOf("--");
          }(Y) && function(ce, $) {
            var te, V = b(g(ce[1]));
            for (te in $) {
              var K = $[te];
              (-1 < (K = b(g(K[1]))).indexOf(V) || -1 < V.indexOf(K)) && delete $[te];
            }
          }(Y, B), (Q = B[H = p(Y[2])]) && l(g(Y[1]), N, j, I) && l(g(Q[1]), N, j, I) && (0 < Y[2].length ? (Y[1] = f(Q[1].concat(Y[1]), !1, A, !1, C.warnings), Y[1] = 1 < Y[1].length ? d(Y[1], k) : Y[1]) : Y[1] = Q[1].concat(Y[1]), Q[2] = [], B[H] = null), B[p(Y[2])] = Y);
        }
      };
    }, function(a, s, r) {
      var l = r(88).canReorder, d = r(131), f = r(86), h = r(14).rules, p = r(12);
      a.exports = function(_, b) {
        for (var v, E = b.cache.specificity, C = {}, y = [], T = _.length - 1; 0 <= T; T--) _[T][0] == p.RULE && _[T][2].length !== 0 && (C[v = h(_[T][1])] = [T].concat(C[v] || []), C[v].length == 2 && y.push(v));
        for (T = y.length - 1; 0 <= T; T--) {
          var A = C[y[T]];
          e: for (var k = A.length - 1; 0 < k; k--) {
            var N = A[k - 1], j = _[N], I = A[k], B = _[I];
            t: for (var U = 1; -1 <= U; U -= 2) {
              for (var H = U == 1, Q = H ? N + 1 : I - 1, Y = H ? I : N, ie = H ? 1 : -1, ce = H ? j : B, $ = H ? B : j, te = d(ce); Q != Y; ) {
                var V = d(_[Q]);
                if (Q += ie, !(V = H ? l(te, V, E) : l(V, te, E)) && !H) continue e;
                if (!V && H) continue t;
              }
              H ? (Array.prototype.push.apply(ce[2], $[2]), $[2] = ce[2]) : Array.prototype.push.apply($[2], ce[2]), f($[2], !0, !0, b), ce[2] = [];
            }
          }
        }
      };
    }, function(a, s, r) {
      var l = r(85), d = r(86), f = r(191), h = r(12), p = r(14).body, g = r(14).rules;
      function _(b, v, E, C, y) {
        for (var T, A, k = [], N = [], j = [], I = v.length - 1; 0 <= I; I--) E.filterOut(I, k) || (A = b[T = v[I].where], A = f(A[2]), k = k.concat(A), N.push(A), j.push(T));
        d(k, !0, !1, y);
        for (var B, U = j.length, H = k.length - 1, Q = U - 1; 0 <= Q; ) (Q === 0 || k[H] && -1 < N[Q].indexOf(k[H])) && -1 < H ? H-- : (B = k.splice(H + 1), E.callback(b[j[Q]], B, U, Q), Q--);
      }
      a.exports = function(v, E) {
        for (var C = E.options, y = C.compatibility.selectors.mergeablePseudoClasses, T = C.compatibility.selectors.mergeablePseudoElements, A = C.compatibility.selectors.multiplePseudoMerging, k = {}, N = [], j = v.length - 1; 0 <= j; j--) {
          var I = v[j];
          if (I[0] == h.RULE && I[2].length !== 0) for (var B = g(I[1]), U = 1 < I[1].length && l(B, y, T, A), H = function(te) {
            for (var V = [], K = 0; K < te.length; K++) V.push([te[K][1]]);
            return V;
          }(I[1]), Q = U ? [B].concat(H) : [B], Y = 0, ie = Q.length; Y < ie; Y++) {
            var ce = Q[Y];
            k[ce] ? N.push(ce) : k[ce] = [], k[ce].push({ where: j, list: H, isPartial: U && 0 < Y, isComplex: U && Y === 0 });
          }
        }
        (function(te, V, K, ne, J) {
          function L(oe, ae) {
            return X[oe].isPartial && ae.length === 0;
          }
          function z(oe, ae, _e, ve) {
            X[_e - ve - 1].isPartial || (oe[2] = ae);
          }
          for (var ee = 0, q = V.length; ee < q; ee++) {
            var X = K[V[ee]];
            _(te, X, { filterOut: L, callback: z }, 0, J);
          }
        })(v, N, k, 0, E), function(te, V, K, ne) {
          var J = K.compatibility.selectors.mergeablePseudoClasses, L = K.compatibility.selectors.mergeablePseudoElements, z = K.compatibility.selectors.multiplePseudoMerging, ee = {};
          function q(qe) {
            return ee.data[qe].where < ee.intoPosition;
          }
          function X(qe, Ge, Ze, tt) {
            tt === 0 && ee.reducedBodies.push(Ge);
          }
          e: for (var oe in V) {
            var ae = V[oe];
            if (ae[0].isComplex) {
              var _e = ae[ae.length - 1].where, ve = te[_e], Ee = [], we = l(oe, J, L, z) ? ae[0].list : [oe];
              ee.intoPosition = _e, ee.reducedBodies = Ee;
              for (var ze, Ie = 0, je = we.length; Ie < je; Ie++)
                if ((ze = V[ze = we[Ie]]).length < 2 || (_(te, ee.data = ze, { filterOut: q, callback: X }, 0, ne), p(Ee[Ee.length - 1]) != p(Ee[0]))) continue e;
              ve[2] = Ee[0];
            }
          }
        }(v, k, C, E);
      };
    }, function(a, s, r) {
      var l = r(12), d = r(14).all;
      a.exports = function(h) {
        for (var p, g, _ = [], b = 0, v = h.length; b < v; b++) (p = h[b])[0] != l.AT_RULE_BLOCK && p[1][0][1] != "@font-face" || (g = d([p]), -1 < _.indexOf(g) ? p[2] = [] : _.push(g));
      };
    }, function(a, s, r) {
      var l = r(12), d = r(14).all, f = r(14).rules;
      a.exports = function(p) {
        for (var g, _, b, v = {}, E = 0, C = p.length; E < C; E++) (_ = p[E])[0] == l.NESTED_BLOCK && ((g = v[b = f(_[1]) + "%" + d(_[2])]) && (g[2] = []), v[b] = _);
      };
    }, function(a, s, r) {
      var l = r(12), d = r(14).body, f = r(14).rules;
      a.exports = function(p) {
        for (var g, _, b = {}, v = [], E = 0, C = p.length; E < C; E++) (g = p[E])[0] == l.RULE && (b[y = f(g[1])] && b[y].length == 1 ? v.push(y) : b[y] = b[y] || [], b[y].push(E));
        for (E = 0, C = v.length; E < C; E++) for (var y, T = [], A = b[y = v[E]].length - 1; 0 <= A; A--) g = p[b[y][A]], _ = d(g[2]), -1 < T.indexOf(_) ? g[2] = [] : T.push(_);
      };
    }, function(a, s, r) {
      var l = r(129), d = r(49).single, f = r(62), h = r(12), p = /^(\-moz\-|\-o\-|\-webkit\-)?animation-name$/, g = /^(\-moz\-|\-o\-|\-webkit\-)?animation$/, _ = /^@(\-moz\-|\-o\-|\-webkit\-)?keyframes /, b = /\s{0,31}!important$/, v = /^(['"]?)(.*)\1$/;
      function E(U) {
        return U.replace(v, "$2").replace(b, "");
      }
      function C(U, H, Q, Y) {
        for (var ie, ce, $, te = {}, V = 0, K = U.length; V < K; V++) H(U[V], te);
        if (Object.keys(te).length !== 0) for (ie in function ne(J, L, z, ee) {
          for (var q = L(z), X = 0, oe = J.length; X < oe; X++) switch (J[X][0]) {
            case h.RULE:
              q(J[X], ee);
              break;
            case h.NESTED_BLOCK:
              ne(J[X][2], L, z, ee);
          }
        }(U, Q, te, Y), te) for (V = 0, K = (ce = te[ie]).length; V < K; V++) ($ = ce[V])[$[0] == h.AT_RULE ? 1 : 2] = [];
      }
      function y(U, H) {
        var Q;
        U[0] == h.AT_RULE_BLOCK && U[1][0][1].indexOf("@counter-style") === 0 && (H[Q = U[1][0][1].split(" ")[1]] = H[Q] || [], H[Q].push(U));
      }
      function T(U) {
        return function(H, Q) {
          for (var Y, ie, ce = 0, $ = H[2].length; ce < $; ce++) (Y = H[2][ce])[1][1] == "list-style" && (ie = d(Y), l([ie], Q.validator, Q.warnings), ie.components[0].value[0][1] in U && delete U[Y[2][1]], f([ie])), Y[1][1] == "list-style-type" && Y[2][1] in U && delete U[Y[2][1]];
        };
      }
      function A(U, H) {
        var Q, Y, ie;
        if (U[0] == h.AT_RULE_BLOCK && U[1][0][1] == "@font-face") {
          for (Y = 0, ie = U[2].length; Y < ie; Y++) if ((Q = U[2][Y])[1][1] == "font-family") {
            H[Q = E(Q[2][1].toLowerCase())] = H[Q] || [], H[Q].push(U);
            break;
          }
        }
      }
      function k(U) {
        return function(H, Q) {
          for (var Y, ie, ce, $, te, V, K = 0, ne = H[2].length; K < ne; K++) {
            if ((Y = H[2][K])[1][1] == "font") {
              for (ie = d(Y), l([ie], Q.validator, Q.warnings), te = 0, V = (ce = ie.components[6]).value.length; te < V; te++) ($ = E(ce.value[te][1].toLowerCase())) in U && delete U[$];
              f([ie]);
            }
            if (Y[1][1] == "font-family") for (te = 2, V = Y.length; te < V; te++) ($ = E(Y[te][1].toLowerCase())) in U && delete U[$];
          }
        };
      }
      function N(U, H) {
        var Q;
        U[0] == h.NESTED_BLOCK && _.test(U[1][0][1]) && (H[Q = U[1][0][1].split(" ")[1]] = H[Q] || [], H[Q].push(U));
      }
      function j(U) {
        return function(H, Q) {
          for (var Y, ie, ce, $, te, V = 0, K = H[2].length; V < K; V++) {
            if (Y = H[2][V], g.test(Y[1][1])) {
              for (ie = d(Y), l([ie], Q.validator, Q.warnings), $ = 0, te = (ce = ie.components[7]).value.length; $ < te; $++) ce.value[$][1] in U && delete U[ce.value[$][1]];
              f([ie]);
            }
            if (p.test(Y[1][1])) for ($ = 2, te = Y.length; $ < te; $++) Y[$][1] in U && delete U[Y[$][1]];
          }
        };
      }
      function I(U, H) {
        var Q;
        U[0] == h.AT_RULE && U[1].indexOf("@namespace") === 0 && (H[Q = U[1].split(" ")[1]] = H[Q] || [], H[Q].push(U));
      }
      function B(U) {
        var H = new RegExp(Object.keys(U).join("\\||") + "\\|", "g");
        return function(Q) {
          for (var Y, ie, ce, $, te = 0, V = Q[1].length; te < V; te++) for (ce = 0, $ = (Y = Q[1][te][1].match(H)).length; ce < $; ce++) (ie = Y[ce].substring(0, Y[ce].length - 1)) in U && delete U[ie];
        };
      }
      a.exports = function(H, Q) {
        C(H, y, T, Q), C(H, A, k, Q), C(H, N, j, Q), C(H, I, B, Q);
      };
    }, function(a, s, r) {
      var l = r(88).canReorderSingle, d = r(131), f = r(85), h = r(397), p = r(12), g = r(191), _ = r(14).body, b = r(14).rules;
      function v(E, C) {
        return C < E ? 1 : -1;
      }
      a.exports = function(C, y) {
        var T = y.options, A = T.compatibility.selectors.mergeablePseudoClasses, k = T.compatibility.selectors.mergeablePseudoElements, N = T.compatibility.selectors.mergeLimit, j = T.compatibility.selectors.multiplePseudoMerging, I = y.cache.specificity, B = {}, U = [], H = {}, Q = [], Y = 2, ie = "%";
        function ce(Qe, ke, pe) {
          for (var Se = pe.length - 1; 0 <= Se; Se--) {
            var he = function(Me, Ye) {
              var et = function(We) {
                for (var nt = [], ft = 0, At = We.length; ft < At; ft++) nt.push(b(We[ft][1]));
                return nt.join(ie);
              }(Ye);
              return H[et] = H[et] || [], H[et].push([Me, Ye]), et;
            }(ke, pe[Se][0]);
            if (1 < H[he].length && J(Qe, H[he])) {
              (function(Me) {
                var Ye, et = Me.split(ie), dt = [];
                for (Ye in H) for (var We = Ye.split(ie), nt = We.length - 1; 0 <= nt; nt--) if (-1 < et.indexOf(We[nt])) {
                  dt.push(Ye);
                  break;
                }
                for (nt = dt.length - 1; 0 <= nt; nt--) delete H[dt[nt]];
              })(he);
              break;
            }
          }
        }
        function $(Qe) {
          for (var ke = [], pe = [], Se = Qe.length - 1; 0 <= Se; Se--) f(b(Qe[Se][1]), A, k, j) && (pe.unshift(Qe[Se]), 0 < Qe[Se][2].length && ke.indexOf(Qe[Se]) == -1 && ke.push(Qe[Se]));
          return 1 < ke.length ? pe : [];
        }
        function te(Qe, ke) {
          return Qe[1] > ke[1] ? 1 : Qe[1] == ke[1] ? 0 : -1;
        }
        function V(Qe, ke, pe) {
          return function Se(he, Te, Me, Ye) {
            var et = [[he, function(ft, At, ln) {
              for (var Jt = 0, zt = ft.length - 1; 0 <= zt; zt--) Jt += ft[zt][2].length > ln ? b(ft[zt][1]).length : -1;
              return Jt - (ft.length - 1) * At + 1;
            }(he, Te, Me)]];
            if (2 < he.length && 0 < Ye) for (var dt = he.length - 1; 0 <= dt; dt--) {
              var We = Array.prototype.slice.call(he, 0);
              We.splice(dt, 1), et = et.concat(Se(We, Te, Me, Ye - 1));
            }
            return et;
          }(Qe, ke, pe, Y - 1).sort(te);
        }
        function K(Qe, ke, pe, Se) {
          for (var he = [], Te = Se.length - 1; 0 <= Te; Te--) for (var Me = Se[Te], Ye = Me[2].length - 1; 0 <= Ye; Ye--) for (var et = Me[2][Ye], dt = 0, We = ke.length; dt < We; dt++) {
            var At = ke[dt], nt = et[1][1], ft = At[0], At = At[4];
            if (nt == ft && _([et]) == At) {
              Me[2].splice(Ye, 1);
              break;
            }
          }
          for (Te = ke.length - 1; 0 <= Te; Te--) he.unshift(ke[Te][3]);
          pe = [p.RULE, pe, he], C.splice(Qe, 0, pe);
        }
        function ne(Qe, ke) {
          var pe = ke[4];
          (pe = B[pe]) && 1 < pe.length && !function(he, dt) {
            var Me, Ye = [], et = [], dt = dt[4], We = $(B[dt]);
            if (!(We.length < 2)) {
              e: for (var nt in B) {
                for (var ft = B[nt], At = We.length - 1; 0 <= At; At--) if (ft.indexOf(We[At]) == -1) continue e;
                Ye.push(nt);
              }
              if (!(Ye.length < 2)) {
                for (At = Ye.length - 1; 0 <= At; At--) for (Me = U.length - 1; 0 <= Me; Me--) if (U[Me][4] == Ye[At]) {
                  et.unshift([U[Me], We]);
                  break;
                }
                return J(he, et);
              }
            }
          }(Qe, ke) && function(he, Te) {
            var Me = Te[0], et = Te[1], Ye = Te[4], et = Me.length + et.length + 1, dt = [], We = [];
            if (!((Ye = $(B[Ye])).length < 2)) {
              var nt = (et = V(Ye, et, 1))[0];
              if (0 < nt[1]) return ce(he, Te, et);
              for (var ft = nt[0].length - 1; 0 <= ft; ft--) dt = nt[0][ft][1].concat(dt), We.unshift(nt[0][ft]);
              K(he, [Te], dt = h(dt), We);
            }
          }(Qe, ke);
        }
        function J(Qe, ke) {
          for (var pe = 0, Se = [], he = ke.length - 1; 0 <= he; he--) pe += (et = ke[he][0])[4].length + (0 < he ? 1 : 0), Se.push(et);
          var Te = V(ke[0][1], pe, Se.length)[0];
          if (0 < Te[1]) return !1;
          for (var Me = [], Ye = [], he = Te[0].length - 1; 0 <= he; he--) Me = Te[0][he][1].concat(Me), Ye.unshift(Te[0][he]);
          for (K(Qe, Se, Me = h(Me), Ye), he = Se.length - 1; 0 <= he; he--) {
            var et = Se[he], dt = U.indexOf(et);
            delete B[et[4]], -1 < dt && Q.indexOf(dt) == -1 && Q.push(dt);
          }
          return !0;
        }
        for (var L = C.length - 1; 0 <= L; L--) {
          var z, ee, q, X = C[L];
          if (X[0] == p.RULE) z = !0;
          else {
            if (X[0] != p.NESTED_BLOCK) continue;
            z = !1;
          }
          for (var oe = U.length, ae = d(X), Q = [], _e = [], ve = ae.length - 1; 0 <= ve; ve--) for (Ie = ve - 1; 0 <= Ie; Ie--) if (!l(ae[ve], ae[Ie], I)) {
            _e.push(ve);
            break;
          }
          for (ve = ae.length - 1; 0 <= ve; ve--) {
            for (var Ee, we = ae[ve], ze = !1, Ie = 0; Ie < oe; Ie++) {
              var je = U[Ie];
              Q.indexOf(Ie) == -1 && (!l(we, je, I) && !function(ke, pe, Se) {
                return ke[0] == pe[0] && (pe = pe[4], (pe = B[pe]) && -1 < pe.indexOf(Se));
              }(we, je, X) || B[je[4]] && B[je[4]].length === N) && (ne(L + 1, je), Q.indexOf(Ie) == -1 && (Q.push(Ie), delete B[je[4]])), ze || (ze = we[0] == je[0] && we[1] == je[1]) && (q = Ie);
            }
            !z || -1 < _e.indexOf(ve) || (Ee = we[4], ze && U[q][5].length + we[5].length > N ? (ne(L + 1, U[q]), U.splice(q, 1), ze = !(B[Ee] = [X])) : (B[Ee] = B[Ee] || [], B[Ee].push(X)), ze ? U[q] = function(ke, pe) {
              return (ke = g(ke))[5] = ke[5].concat(pe[5]), ke;
            }(U[q], we) : U.push(we));
          }
          for (ve = 0, ee = (Q = Q.sort(v)).length; ve < ee; ve++) {
            var qe = Q[ve] - ve;
            U.splice(qe, 1);
          }
        }
        for (var Ge = C[0] && C[0][0] == p.AT_RULE && C[0][1].indexOf("@charset") === 0 ? 1 : 0; Ge < C.length - 1; Ge++) {
          var Ze = C[Ge][0] === p.AT_RULE && C[Ge][1].indexOf("@import") === 0, tt = C[Ge][0] === p.COMMENT;
          if (!Ze && !tt) break;
        }
        for (L = 0; L < U.length; L++) ne(Ge, U[L]);
      };
    }, function(a, s) {
      function r(l, d) {
        return l[1] > d[1] ? 1 : -1;
      }
      a.exports = function(d) {
        for (var f = [], h = [], p = 0, g = d.length; p < g; p++) {
          var _ = d[p];
          h.indexOf(_[1]) == -1 && (h.push(_[1]), f.push(_));
        }
        return f.sort(r);
      };
    }, function(a, s) {
      var r = new RegExp("^(\\-moz\\-|\\-webkit\\-)?calc\\([^\\)]+\\)$", "i"), l = /[0-9]/, d = new RegExp("^(var\\(\\-\\-[^\\)]+\\)|[A-Z]+(\\-|[A-Z]|[0-9])+\\(.*?\\)|\\-(\\-|[A-Z]|[0-9])+\\(.*?\\))$", "i"), f = /^hsl\(\s{0,31}[\-\.]?\d+\s{0,31},\s{0,31}\.?\d+%\s{0,31},\s{0,31}\.?\d+%\s{0,31}\)|hsla\(\s{0,31}[\-\.]?\d+\s{0,31},\s{0,31}\.?\d+%\s{0,31},\s{0,31}\.?\d+%\s{0,31},\s{0,31}\.?\d+\s{0,31}\)$/i, h = /^(\-[a-z0-9_][a-z0-9\-_]*|[a-z][a-z0-9\-_]*)$/i, p = /^[a-z]+$/i, g = /^-([a-z0-9]|-)*$/i, _ = /^rgb\(\s{0,31}[\d]{1,3}\s{0,31},\s{0,31}[\d]{1,3}\s{0,31},\s{0,31}[\d]{1,3}\s{0,31}\)|rgba\(\s{0,31}[\d]{1,3}\s{0,31},\s{0,31}[\d]{1,3}\s{0,31},\s{0,31}[\d]{1,3}\s{0,31},\s{0,31}[\.\d]+\s{0,31}\)$/i, b = /^(cubic\-bezier|steps)\([^\)]+\)$/, v = ["ms", "s"], E = /^url\([\s\S]+\)$/i, C = new RegExp("^var\\(\\-\\-[^\\)]+\\)$", "i"), y = /^#[0-9a-f]{8}$/i, T = /^#[0-9a-f]{4}$/i, A = /^#[0-9a-f]{6}$/i, k = /^#[0-9a-f]{3}$/i, N = ".", j = "-", I = "+", B = { "^": ["inherit", "initial", "unset"], "*-style": ["auto", "dashed", "dotted", "double", "groove", "hidden", "inset", "none", "outset", "ridge", "solid"], "*-timing-function": ["ease", "ease-in", "ease-in-out", "ease-out", "linear", "step-end", "step-start"], "animation-direction": ["alternate", "alternate-reverse", "normal", "reverse"], "animation-fill-mode": ["backwards", "both", "forwards", "none"], "animation-iteration-count": ["infinite"], "animation-name": ["none"], "animation-play-state": ["paused", "running"], "background-attachment": ["fixed", "inherit", "local", "scroll"], "background-clip": ["border-box", "content-box", "inherit", "padding-box", "text"], "background-origin": ["border-box", "content-box", "inherit", "padding-box"], "background-position": ["bottom", "center", "left", "right", "top"], "background-repeat": ["no-repeat", "inherit", "repeat", "repeat-x", "repeat-y", "round", "space"], "background-size": ["auto", "cover", "contain"], "border-collapse": ["collapse", "inherit", "separate"], bottom: ["auto"], clear: ["both", "left", "none", "right"], color: ["transparent"], cursor: ["all-scroll", "auto", "col-resize", "crosshair", "default", "e-resize", "help", "move", "n-resize", "ne-resize", "no-drop", "not-allowed", "nw-resize", "pointer", "progress", "row-resize", "s-resize", "se-resize", "sw-resize", "text", "vertical-text", "w-resize", "wait"], display: ["block", "inline", "inline-block", "inline-table", "list-item", "none", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group"], float: ["left", "none", "right"], left: ["auto"], font: ["caption", "icon", "menu", "message-box", "small-caption", "status-bar", "unset"], "font-size": ["large", "larger", "medium", "small", "smaller", "x-large", "x-small", "xx-large", "xx-small"], "font-stretch": ["condensed", "expanded", "extra-condensed", "extra-expanded", "normal", "semi-condensed", "semi-expanded", "ultra-condensed", "ultra-expanded"], "font-style": ["italic", "normal", "oblique"], "font-variant": ["normal", "small-caps"], "font-weight": ["100", "200", "300", "400", "500", "600", "700", "800", "900", "bold", "bolder", "lighter", "normal"], "line-height": ["normal"], "list-style-position": ["inside", "outside"], "list-style-type": ["armenian", "circle", "decimal", "decimal-leading-zero", "disc", "decimal|disc", "georgian", "lower-alpha", "lower-greek", "lower-latin", "lower-roman", "none", "square", "upper-alpha", "upper-latin", "upper-roman"], overflow: ["auto", "hidden", "scroll", "visible"], position: ["absolute", "fixed", "relative", "static"], right: ["auto"], "text-align": ["center", "justify", "left", "left|right", "right"], "text-decoration": ["line-through", "none", "overline", "underline"], "text-overflow": ["clip", "ellipsis"], top: ["auto"], "vertical-align": ["baseline", "bottom", "middle", "sub", "super", "text-bottom", "text-top", "top"], visibility: ["collapse", "hidden", "visible"], "white-space": ["normal", "nowrap", "pre"], width: ["inherit", "initial", "medium", "thick", "thin"] }, U = ["%", "ch", "cm", "em", "ex", "in", "mm", "pc", "pt", "px", "rem", "vh", "vm", "vmax", "vmin", "vw"];
      function H(ae) {
        return ae != "auto" && (V("color")(ae) || function(ve) {
          return k.test(ve) || T.test(ve) || A.test(ve) || y.test(ve);
        }(ae) || Q(ae) || function(ve) {
          return p.test(ve);
        }(ae));
      }
      function Q(ae) {
        return ne(ae) || ce(ae);
      }
      function Y(ae) {
        return r.test(ae);
      }
      function ie(ae) {
        return d.test(ae);
      }
      function ce(ae) {
        return f.test(ae);
      }
      function $(ae) {
        return h.test(ae);
      }
      function te(ae) {
        return ae == "none" || ae == "inherit" || q(ae);
      }
      function V(ae) {
        return function(_e) {
          return -1 < B[ae].indexOf(_e);
        };
      }
      function K(ae) {
        return oe(ae) == ae.length;
      }
      function ne(ae) {
        return _.test(ae);
      }
      function J(ae) {
        return g.test(ae);
      }
      function L(ae) {
        return K(ae) && 0 <= parseFloat(ae);
      }
      function z(ae) {
        return C.test(ae);
      }
      function ee(ae) {
        var _e = oe(ae);
        return _e == ae.length && parseInt(ae) === 0 || -1 < _e && -1 < v.indexOf(ae.slice(_e + 1));
      }
      function q(ae) {
        return E.test(ae);
      }
      function X(ae) {
        return ae == "auto" || K(ae) || V("^")(ae);
      }
      function oe(ae) {
        for (var _e, ve = !1, Ee = !1, we = 0, ze = ae.length; we < ze; we++) if (_e = ae[we], we !== 0 || _e != I && _e != j) {
          if (0 < we && Ee && (_e == I || _e == j)) return we - 1;
          if (_e != N || ve) {
            if (_e == N && ve || !l.test(_e)) return we - 1;
          } else ve = !0;
        } else Ee = !0;
        return we;
      }
      a.exports = function(_e) {
        var ve = U.slice(0).filter(function(Ee) {
          return !(Ee in _e.units) || _e.units[Ee] === !0;
        });
        return { colorOpacity: _e.colors.opacity, isAnimationDirectionKeyword: V("animation-direction"), isAnimationFillModeKeyword: V("animation-fill-mode"), isAnimationIterationCountKeyword: V("animation-iteration-count"), isAnimationNameKeyword: V("animation-name"), isAnimationPlayStateKeyword: V("animation-play-state"), isTimingFunction: function() {
          var we = V("*-timing-function");
          return function(ze) {
            return we(ze) || b.test(ze);
          };
        }(), isBackgroundAttachmentKeyword: V("background-attachment"), isBackgroundClipKeyword: V("background-clip"), isBackgroundOriginKeyword: V("background-origin"), isBackgroundPositionKeyword: V("background-position"), isBackgroundRepeatKeyword: V("background-repeat"), isBackgroundSizeKeyword: V("background-size"), isColor: H, isColorFunction: Q, isDynamicUnit: Y, isFontKeyword: V("font"), isFontSizeKeyword: V("font-size"), isFontStretchKeyword: V("font-stretch"), isFontStyleKeyword: V("font-style"), isFontVariantKeyword: V("font-variant"), isFontWeightKeyword: V("font-weight"), isFunction: ie, isGlobal: V("^"), isHslColor: ce, isIdentifier: $, isImage: te, isKeyword: V, isLineHeightKeyword: V("line-height"), isListStylePositionKeyword: V("list-style-position"), isListStyleTypeKeyword: V("list-style-type"), isNumber: K, isPrefixed: J, isPositiveNumber: L, isRgbColor: ne, isStyleKeyword: V("*-style"), isTime: ee, isUnit: (function(we, ze) {
          var Ie = oe(ze);
          return Ie == ze.length && parseInt(ze) === 0 || -1 < Ie && -1 < we.indexOf(ze.slice(Ie + 1)) || ze == "auto" || ze == "inherit";
        }).bind(null, ve), isUrl: q, isVariable: z, isWidth: V("width"), isZIndex: X };
      };
    }, function(a, s) {
      function r(f) {
        return (r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
          return typeof h;
        } : function(h) {
          return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
        })(f);
      }
      var l = { "*": { colors: { opacity: !0 }, properties: { backgroundClipMerging: !0, backgroundOriginMerging: !0, backgroundSizeMerging: !0, colors: !0, ieBangHack: !1, ieFilters: !1, iePrefixHack: !1, ieSuffixHack: !1, merging: !0, shorterLengthUnits: !1, spaceAfterClosingBrace: !0, urlQuotes: !1, zeroUnits: !0 }, selectors: { adjacentSpace: !1, ie7Hack: !1, mergeablePseudoClasses: [":active", ":after", ":before", ":empty", ":checked", ":disabled", ":empty", ":enabled", ":first-child", ":first-letter", ":first-line", ":first-of-type", ":focus", ":hover", ":lang", ":last-child", ":last-of-type", ":link", ":not", ":nth-child", ":nth-last-child", ":nth-last-of-type", ":nth-of-type", ":only-child", ":only-of-type", ":root", ":target", ":visited"], mergeablePseudoElements: ["::after", "::before", "::first-letter", "::first-line"], mergeLimit: 8191, multiplePseudoMerging: !0 }, units: { ch: !0, in: !0, pc: !0, pt: !0, rem: !0, vh: !0, vm: !0, vmax: !0, vmin: !0, vw: !0 } } };
      function d(f, h) {
        for (var p in f) {
          var g = f[p];
          r(g) !== "object" || Array.isArray(g) ? h[p] = p in h ? h[p] : g : h[p] = d(g, h[p] || {});
        }
        return h;
      }
      l.ie11 = l["*"], l.ie10 = l["*"], l.ie9 = d(l["*"], { properties: { ieFilters: !0, ieSuffixHack: !0 } }), l.ie8 = d(l.ie9, { colors: { opacity: !1 }, properties: { backgroundClipMerging: !1, backgroundOriginMerging: !1, backgroundSizeMerging: !1, iePrefixHack: !0, merging: !1 }, selectors: { mergeablePseudoClasses: [":after", ":before", ":first-child", ":first-letter", ":focus", ":hover", ":visited"], mergeablePseudoElements: [] }, units: { ch: !1, rem: !1, vh: !1, vm: !1, vmax: !1, vmin: !1, vw: !1 } }), l.ie7 = d(l.ie8, { properties: { ieBangHack: !0 }, selectors: { ie7Hack: !0, mergeablePseudoClasses: [":first-child", ":first-letter", ":hover", ":visited"] } }), a.exports = function(h) {
        return d(l["*"], function(g) {
          if (r(g) == "object") return g;
          if (!/[,\+\-]/.test(g)) return l[g] || l["*"];
          var _ = g.split(","), b = _[0] in l ? l[_.shift()] : l["*"];
          return g = {}, _.forEach(function(C) {
            var E = C[0] == "+", C = (y = C.substring(1).split("."))[0], y = y[1];
            g[C] = g[C] || {}, g[C][y] = E;
          }), d(b, g);
        }(h));
      };
    }, function(a, s, r) {
      var l = r(401);
      a.exports = function(f) {
        return f || l;
      };
    }, function(a, s, r) {
      var l = r(192), d = r(430), f = r(27), h = r(431), p = r(432), g = r(48);
      a.exports = function _(b, v, E, C) {
        var y = v.protocol || v.hostname, T = !1, A = g(f.parse(b), v || {});
        v.hostname !== void 0 && (A.protocol = v.protocol || "http:", A.path = A.href), (0, (y && !p(y) || h(b) ? l : d).get)(A, function(k) {
          var N = [];
          if (!T) return k.statusCode < 200 || 399 < k.statusCode ? C(k.statusCode, null) : 299 < k.statusCode ? _(f.resolve(b, k.headers.location), v, E, C) : (k.on("data", function(j) {
            N.push(j.toString());
          }), void k.on("end", function() {
            var j = N.join("");
            C(null, j);
          }));
        }).on("error", function(k) {
          T || (T = !0, C(k.message, null));
        }).on("timeout", function() {
          T || (T = !0, C("timeout", null));
        }).setTimeout(E);
      };
    }, function(a, s, r) {
      (function(l, d, f) {
        var h = r(193), p = r(35), g = r(194), _ = r(195), b = r(411), v = g.IncomingMessage, E = g.readyStates;
        p(g = a.exports = function(y) {
          var T, A = this;
          _.Writable.call(A), A._opts = y, A._body = [], A._headers = {}, y.auth && A.setHeader("Authorization", "Basic " + new l(y.auth).toString("base64")), Object.keys(y.headers).forEach(function(N) {
            A.setHeader(N, y.headers[N]);
          });
          var k = !0;
          if (y.mode === "disable-fetch" || "requestTimeout" in y && !h.abortController) T = !(k = !1);
          else if (y.mode === "prefer-streaming") T = !1;
          else if (y.mode === "allow-wrong-content-type") T = !h.overrideMimeType;
          else {
            if (y.mode && y.mode !== "default" && y.mode !== "prefer-fast") throw new Error("Invalid value for opts.mode");
            T = !0;
          }
          A._mode = function(j, I) {
            return h.fetch && I ? "fetch" : h.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : h.msstream ? "ms-stream" : h.arraybuffer && j ? "arraybuffer" : h.vbArray && j ? "text:vbarray" : "text";
          }(T, k), A._fetchTimer = null, A.on("finish", function() {
            A._onFinish();
          });
        }, _.Writable), g.prototype.setHeader = function(y, T) {
          var A = y.toLowerCase();
          C.indexOf(A) === -1 && (this._headers[A] = { name: y, value: T });
        }, g.prototype.getHeader = function(y) {
          return (y = this._headers[y.toLowerCase()]) ? y.value : null;
        }, g.prototype.removeHeader = function(y) {
          delete this._headers[y.toLowerCase()];
        }, g.prototype._onFinish = function() {
          var y = this;
          if (!y._destroyed) {
            var T = y._opts, A = y._headers, k = null;
            T.method !== "GET" && T.method !== "HEAD" && (k = h.arraybuffer ? b(l.concat(y._body)) : h.blobConstructor ? new d.Blob(y._body.map(function(U) {
              return b(U);
            }), { type: (A["content-type"] || {}).value || "" }) : l.concat(y._body).toString());
            var N = [];
            if (Object.keys(A).forEach(function(Q) {
              var H = A[Q].name, Q = A[Q].value;
              Array.isArray(Q) ? Q.forEach(function(Y) {
                N.push([H, Y]);
              }) : N.push([H, Q]);
            }), y._mode === "fetch") {
              var j, I = null;
              h.abortController && (I = (j = new AbortController()).signal, y._fetchAbortController = j, "requestTimeout" in T && T.requestTimeout !== 0 && (y._fetchTimer = d.setTimeout(function() {
                y.emit("requestTimeout"), y._fetchAbortController && y._fetchAbortController.abort();
              }, T.requestTimeout))), d.fetch(y._opts.url, { method: y._opts.method, headers: N, body: k || void 0, mode: "cors", credentials: T.withCredentials ? "include" : "same-origin", signal: I }).then(function(U) {
                y._fetchResponse = U, y._connect();
              }, function(U) {
                d.clearTimeout(y._fetchTimer), y._destroyed || y.emit("error", U);
              });
            } else {
              var B = y._xhr = new d.XMLHttpRequest();
              try {
                B.open(y._opts.method, y._opts.url, !0);
              } catch (U) {
                return void f.nextTick(function() {
                  y.emit("error", U);
                });
              }
              "responseType" in B && (B.responseType = y._mode.split(":")[0]), "withCredentials" in B && (B.withCredentials = !!T.withCredentials), y._mode === "text" && "overrideMimeType" in B && B.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in T && (B.timeout = T.requestTimeout, B.ontimeout = function() {
                y.emit("requestTimeout");
              }), N.forEach(function(U) {
                B.setRequestHeader(U[0], U[1]);
              }), y._response = null, B.onreadystatechange = function() {
                switch (B.readyState) {
                  case E.LOADING:
                  case E.DONE:
                    y._onXHRProgress();
                }
              }, y._mode === "moz-chunked-arraybuffer" && (B.onprogress = function() {
                y._onXHRProgress();
              }), B.onerror = function() {
                y._destroyed || y.emit("error", new Error("XHR error"));
              };
              try {
                B.send(k);
              } catch (U) {
                return void f.nextTick(function() {
                  y.emit("error", U);
                });
              }
            }
          }
        }, g.prototype._onXHRProgress = function() {
          !function(T) {
            try {
              var A = T.status;
              return A !== null && A !== 0;
            } catch {
              return;
            }
          }(this._xhr) || this._destroyed || (this._response || this._connect(), this._response._onXHRProgress());
        }, g.prototype._connect = function() {
          var y = this;
          y._destroyed || (y._response = new v(y._xhr, y._fetchResponse, y._mode, y._fetchTimer), y._response.on("error", function(T) {
            y.emit("error", T);
          }), y.emit("response", y._response));
        }, g.prototype._write = function(y, T, A) {
          this._body.push(y), A();
        }, g.prototype.abort = g.prototype.destroy = function() {
          this._destroyed = !0, d.clearTimeout(this._fetchTimer), this._response && (this._response._destroyed = !0), this._xhr ? this._xhr.abort() : this._fetchAbortController && this._fetchAbortController.abort();
        }, g.prototype.end = function(y, T, A) {
          typeof y == "function" && (A = y, y = void 0), _.Writable.prototype.end.call(this, y, T, A);
        }, g.prototype.flushHeaders = function() {
        }, g.prototype.setTimeout = function() {
        }, g.prototype.setNoDelay = function() {
        }, g.prototype.setSocketKeepAlive = function() {
        };
        var C = ["accept-charset", "accept-encoding", "access-control-request-headers", "access-control-request-method", "connection", "content-length", "cookie", "cookie2", "date", "dnt", "expect", "host", "keep-alive", "origin", "referer", "te", "trailer", "transfer-encoding", "upgrade", "via"];
      }).call(this, r(23).Buffer, r(18), r(15));
    }, function(a, s) {
    }, function(a, s, r) {
      var l = r(132).Buffer, d = r(405);
      function f() {
        (function(p, g) {
          if (!(p instanceof g)) throw new TypeError("Cannot call a class as a function");
        })(this, f), this.head = null, this.tail = null, this.length = 0;
      }
      a.exports = (f.prototype.push = function(p) {
        p = { data: p, next: null }, 0 < this.length ? this.tail.next = p : this.head = p, this.tail = p, ++this.length;
      }, f.prototype.unshift = function(p) {
        p = { data: p, next: this.head }, this.length === 0 && (this.tail = p), this.head = p, ++this.length;
      }, f.prototype.shift = function() {
        if (this.length !== 0) {
          var p = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, p;
        }
      }, f.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, f.prototype.join = function(p) {
        if (this.length === 0) return "";
        for (var g = this.head, _ = "" + g.data; g = g.next; ) _ += p + g.data;
        return _;
      }, f.prototype.concat = function(p) {
        if (this.length === 0) return l.alloc(0);
        for (var g = l.allocUnsafe(p >>> 0), _ = this.head, b = 0; _; ) (function(E, C, y) {
          E.copy(C, y);
        })(_.data, g, b), b += _.data.length, _ = _.next;
        return g;
      }, f), d && d.inspect && d.inspect.custom && (a.exports.prototype[d.inspect.custom] = function() {
        var h = d.inspect({ length: this.length });
        return this.constructor.name + " " + h;
      });
    }, function(a, s) {
    }, function(a, s, r) {
      (function(l) {
        var d = l !== void 0 && l || typeof self < "u" && self || window, f = Function.prototype.apply;
        function h(p, g) {
          this._id = p, this._clearFn = g;
        }
        s.setTimeout = function() {
          return new h(f.call(setTimeout, d, arguments), clearTimeout);
        }, s.setInterval = function() {
          return new h(f.call(setInterval, d, arguments), clearInterval);
        }, s.clearTimeout = s.clearInterval = function(p) {
          p && p.close();
        }, h.prototype.unref = h.prototype.ref = function() {
        }, h.prototype.close = function() {
          this._clearFn.call(d, this._id);
        }, s.enroll = function(p, g) {
          clearTimeout(p._idleTimeoutId), p._idleTimeout = g;
        }, s.unenroll = function(p) {
          clearTimeout(p._idleTimeoutId), p._idleTimeout = -1;
        }, s._unrefActive = s.active = function(p) {
          clearTimeout(p._idleTimeoutId);
          var g = p._idleTimeout;
          0 <= g && (p._idleTimeoutId = setTimeout(function() {
            p._onTimeout && p._onTimeout();
          }, g));
        }, r(407), s.setImmediate = typeof self < "u" && self.setImmediate || l !== void 0 && l.setImmediate || this && this.setImmediate, s.clearImmediate = typeof self < "u" && self.clearImmediate || l !== void 0 && l.clearImmediate || this && this.clearImmediate;
      }).call(this, r(18));
    }, function(a, s, r) {
      (function(l, d) {
        (function(f, h) {
          var p, g, _, b, v, E;
          function C(T) {
            delete g[T];
          }
          function y(T) {
            if (_) setTimeout(y, 0, T);
            else {
              var A = g[T];
              if (A) {
                _ = !0;
                try {
                  (function(N) {
                    var j = N.callback, I = N.args;
                    switch (I.length) {
                      case 0:
                        j();
                        break;
                      case 1:
                        j(I[0]);
                        break;
                      case 2:
                        j(I[0], I[1]);
                        break;
                      case 3:
                        j(I[0], I[1], I[2]);
                        break;
                      default:
                        j.apply(h, I);
                    }
                  })(A);
                } finally {
                  C(T), _ = !1;
                }
              }
            }
          }
          f.setImmediate || (p = 1, _ = !(g = {}), b = f.document, E = (E = Object.getPrototypeOf && Object.getPrototypeOf(f)) && E.setTimeout ? E : f, ({}.toString.call(f.process) === "[object process]" ? function() {
            v = function(k) {
              d.nextTick(function() {
                y(k);
              });
            };
          } : function() {
            if (f.postMessage && !f.importScripts) {
              var A = !0, k = f.onmessage;
              return f.onmessage = function() {
                A = !1;
              }, f.postMessage("", "*"), f.onmessage = k, A;
            }
          }() ? function() {
            function A(N) {
              N.source === f && typeof N.data == "string" && N.data.indexOf(k) === 0 && y(+N.data.slice(k.length));
            }
            var k = "setImmediate$" + Math.random() + "$";
            f.addEventListener ? f.addEventListener("message", A, !1) : f.attachEvent("onmessage", A), v = function(j) {
              f.postMessage(k + j, "*");
            };
          } : f.MessageChannel ? function() {
            var A = new MessageChannel();
            A.port1.onmessage = function(k) {
              y(k.data);
            }, v = function(N) {
              A.port2.postMessage(N);
            };
          } : b && "onreadystatechange" in b.createElement("script") ? function() {
            var A = b.documentElement;
            v = function(N) {
              var j = b.createElement("script");
              j.onreadystatechange = function() {
                y(N), j.onreadystatechange = null, A.removeChild(j), j = null;
              }, A.appendChild(j);
            };
          } : function() {
            v = function(k) {
              setTimeout(y, 0, k);
            };
          })(), E.setImmediate = function(A) {
            typeof A != "function" && (A = new Function("" + A));
            for (var k = new Array(arguments.length - 1), N = 0; N < k.length; N++) k[N] = arguments[N + 1];
            return g[p] = { callback: A, args: k }, v(p), p++;
          }, E.clearImmediate = C);
        })(typeof self > "u" ? l === void 0 ? this : l : self);
      }).call(this, r(18), r(15));
    }, function(a, s, r) {
      (function(l) {
        function d(f) {
          try {
            if (!l.localStorage) return;
          } catch {
            return;
          }
          return (f = l.localStorage[f]) != null && String(f).toLowerCase() === "true";
        }
        a.exports = function(h, p) {
          if (d("noDeprecation")) return h;
          var g = !1;
          return function() {
            if (!g) {
              if (d("throwDeprecation")) throw new Error(p);
              d("traceDeprecation") ? console.trace(p) : console.warn(p), g = !0;
            }
            return h.apply(this, arguments);
          };
        };
      }).call(this, r(18));
    }, function(a, s, r) {
      var l = r(23), d = l.Buffer;
      function f(p, g) {
        for (var _ in p) g[_] = p[_];
      }
      function h(p, g, _) {
        return d(p, g, _);
      }
      d.from && d.alloc && d.allocUnsafe && d.allocUnsafeSlow ? a.exports = l : (f(l, s), s.Buffer = h), h.prototype = Object.create(d.prototype), f(d, h), h.from = function(p, g, _) {
        if (typeof p == "number") throw new TypeError("Argument must not be a number");
        return d(p, g, _);
      }, h.alloc = function(p, g, _) {
        if (typeof p != "number") throw new TypeError("Argument must be a number");
        return p = d(p), g !== void 0 ? typeof _ == "string" ? p.fill(g, _) : p.fill(g) : p.fill(0), p;
      }, h.allocUnsafe = function(p) {
        if (typeof p != "number") throw new TypeError("Argument must be a number");
        return d(p);
      }, h.allocUnsafeSlow = function(p) {
        if (typeof p != "number") throw new TypeError("Argument must be a number");
        return l.SlowBuffer(p);
      };
    }, function(a, s, r) {
      a.exports = d;
      var l = r(202);
      function d(f) {
        if (!(this instanceof d)) return new d(f);
        l.call(this, f);
      }
      (a = Object.create(r(63))).inherits = r(35), a.inherits(d, l), d.prototype._transform = function(f, h, p) {
        p(null, f);
      };
    }, function(a, s, r) {
      var l = r(23).Buffer;
      a.exports = function(d) {
        if (d instanceof Uint8Array) {
          if (d.byteOffset === 0 && d.byteLength === d.buffer.byteLength) return d.buffer;
          if (typeof d.buffer.slice == "function") return d.buffer.slice(d.byteOffset, d.byteOffset + d.byteLength);
        }
        if (l.isBuffer(d)) {
          for (var f = new Uint8Array(d.length), h = d.length, p = 0; p < h; p++) f[p] = d[p];
          return f.buffer;
        }
        throw new Error("Argument must be a Buffer");
      };
    }, function(a, s) {
      a.exports = function() {
        for (var d = {}, f = 0; f < arguments.length; f++) {
          var h, p = arguments[f];
          for (h in p) r.call(p, h) && (d[h] = p[h]);
        }
        return d;
      };
      var r = Object.prototype.hasOwnProperty;
    }, function(a, s) {
      a.exports = { 100: "Continue", 101: "Switching Protocols", 102: "Processing", 200: "OK", 201: "Created", 202: "Accepted", 203: "Non-Authoritative Information", 204: "No Content", 205: "Reset Content", 206: "Partial Content", 207: "Multi-Status", 208: "Already Reported", 226: "IM Used", 300: "Multiple Choices", 301: "Moved Permanently", 302: "Found", 303: "See Other", 304: "Not Modified", 305: "Use Proxy", 307: "Temporary Redirect", 308: "Permanent Redirect", 400: "Bad Request", 401: "Unauthorized", 402: "Payment Required", 403: "Forbidden", 404: "Not Found", 405: "Method Not Allowed", 406: "Not Acceptable", 407: "Proxy Authentication Required", 408: "Request Timeout", 409: "Conflict", 410: "Gone", 411: "Length Required", 412: "Precondition Failed", 413: "Payload Too Large", 414: "URI Too Long", 415: "Unsupported Media Type", 416: "Range Not Satisfiable", 417: "Expectation Failed", 418: "I'm a teapot", 421: "Misdirected Request", 422: "Unprocessable Entity", 423: "Locked", 424: "Failed Dependency", 425: "Unordered Collection", 426: "Upgrade Required", 428: "Precondition Required", 429: "Too Many Requests", 431: "Request Header Fields Too Large", 451: "Unavailable For Legal Reasons", 500: "Internal Server Error", 501: "Not Implemented", 502: "Bad Gateway", 503: "Service Unavailable", 504: "Gateway Timeout", 505: "HTTP Version Not Supported", 506: "Variant Also Negotiates", 507: "Insufficient Storage", 508: "Loop Detected", 509: "Bandwidth Limit Exceeded", 510: "Not Extended", 511: "Network Authentication Required" };
    }, function(a, s, r) {
      (function(l, d) {
        var f;
        function h(p) {
          return (h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
            return typeof g;
          } : function(g) {
            return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
          })(p);
        }
        (function(p) {
          var g = h(s) == "object" && s && !s.nodeType && s, _ = h(l) == "object" && l && !l.nodeType && l, b = (d === void 0 ? "undefined" : h(d)) == "object" && d;
          b.global !== b && b.window !== b && b.self !== b || (p = b);
          var v, E, C = 2147483647, y = 36, T = 26, A = 38, k = 700, N = /^xn--/, j = /[^\x20-\x7E]/, I = /[\x2E\u3002\uFF0E\uFF61]/g, B = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, U = y - 1, H = Math.floor, Q = String.fromCharCode;
          function Y(L) {
            throw new RangeError(B[L]);
          }
          function ie(L, z) {
            for (var ee = L.length, q = []; ee--; ) q[ee] = z(L[ee]);
            return q;
          }
          function ce(L, z) {
            var ee = L.split("@"), q = "";
            return 1 < ee.length && (q = ee[0] + "@", L = ee[1]), q + ie((L = L.replace(I, ".")).split("."), z).join(".");
          }
          function $(L) {
            for (var z, ee, q = [], X = 0, oe = L.length; X < oe; ) 55296 <= (z = L.charCodeAt(X++)) && z <= 56319 && X < oe ? (64512 & (ee = L.charCodeAt(X++))) == 56320 ? q.push(((1023 & z) << 10) + (1023 & ee) + 65536) : (q.push(z), X--) : q.push(z);
            return q;
          }
          function te(L) {
            return ie(L, function(z) {
              var ee = "";
              return 65535 < z && (ee += Q((z -= 65536) >>> 10 & 1023 | 55296), z = 56320 | 1023 & z), ee + Q(z);
            }).join("");
          }
          function V(L, z) {
            return L + 22 + 75 * (L < 26) - ((z != 0) << 5);
          }
          function K(L, z, ee) {
            var q = 0;
            for (L = ee ? H(L / k) : L >> 1, L += H(L / z); U * T >> 1 < L; q += y) L = H(L / U);
            return H(q + (U + 1) * L / (L + A));
          }
          function ne(L) {
            var z, ee, q, X, oe, ae, _e, ve = [], Ee = L.length, we = 0, ze = 128, Ie = 72, je = L.lastIndexOf("-");
            for (je < 0 && (je = 0), ee = 0; ee < je; ++ee) 128 <= L.charCodeAt(ee) && Y("not-basic"), ve.push(L.charCodeAt(ee));
            for (q = 0 < je ? je + 1 : 0; q < Ee; ) {
              for (X = we, oe = 1, ae = y; Ee <= q && Y("invalid-input"), _e = function(Ge) {
                return Ge - 48 < 10 ? Ge - 22 : Ge - 65 < 26 ? Ge - 65 : Ge - 97 < 26 ? Ge - 97 : y;
              }(L.charCodeAt(q++)), (y <= _e || _e > H((C - we) / oe)) && Y("overflow"), we += _e * oe, !(_e < (_e = ae <= Ie ? 1 : Ie + T <= ae ? T : ae - Ie)); ae += y) oe > H(C / (_e = y - _e)) && Y("overflow"), oe *= _e;
              Ie = K(we - X, z = ve.length + 1, X == 0), H(we / z) > C - ze && Y("overflow"), ze += H(we / z), we %= z, ve.splice(we++, 0, ze);
            }
            return te(ve);
          }
          function J(L) {
            for (var z, ee, q, X, oe, ae, _e, ve, Ee, we, ze = [], Ie = (L = $(L)).length, je = 128, qe = 72, Ge = z = 0; Ge < Ie; ++Ge) (_e = L[Ge]) < 128 && ze.push(Q(_e));
            for (ee = q = ze.length, q && ze.push("-"); ee < Ie; ) {
              for (X = C, Ge = 0; Ge < Ie; ++Ge) je <= (_e = L[Ge]) && _e < X && (X = _e);
              for (X - je > H((C - z) / (ve = ee + 1)) && Y("overflow"), z += (X - je) * ve, je = X, Ge = 0; Ge < Ie; ++Ge) if ((_e = L[Ge]) < je && ++z > C && Y("overflow"), _e == je) {
                for (oe = z, ae = y; !(oe < (Ee = ae <= qe ? 1 : qe + T <= ae ? T : ae - qe)); ae += y) ze.push(Q(V(Ee + (we = oe - Ee) % (Ee = y - Ee), 0))), oe = H(we / Ee);
                ze.push(Q(V(oe, 0))), qe = K(z, ve, ee == q), z = 0, ++ee;
              }
              ++z, ++je;
            }
            return ze.join("");
          }
          if (v = { version: "1.4.1", ucs2: { decode: $, encode: te }, decode: ne, encode: J, toASCII: function(z) {
            return ce(z, function(ee) {
              return j.test(ee) ? "xn--" + J(ee) : ee;
            });
          }, toUnicode: function(z) {
            return ce(z, function(ee) {
              return N.test(ee) ? ne(ee.slice(4).toLowerCase()) : ee;
            });
          } }, h(r(90)) == "object" && r(90)) (f = (function() {
            return v;
          }).call(s, r, s, l)) === void 0 || (l.exports = f);
          else if (g && _) if (l.exports == g) _.exports = v;
          else for (E in v) v.hasOwnProperty(E) && (g[E] = v[E]);
          else p.punycode = v;
        })(this);
      }).call(this, r(54)(a), r(18));
    }, function(a, s, f) {
      var l = f(416), d = f(429), f = f(134);
      a.exports = { formats: f, parse: d, stringify: l };
    }, function(a, s, y) {
      function l(k) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
          return typeof N;
        } : function(N) {
          return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
        })(k);
      }
      function d(k, N) {
        E.apply(k, v(N) ? N : [N]);
      }
      function f(k, N, j, I, B, U, H, Q, Y, ie, ce, $, te, V, K, ne) {
        for (var J = k, L = ne, z = 0, ee = !1; (L = L.get(A)) !== void 0 && !ee; ) {
          var q = L.get(k);
          if (z += 1, q !== void 0) {
            if (q === z) throw new RangeError("Cyclic object value");
            ee = !0;
          }
          L.get(A) === void 0 && (z = 0);
        }
        if (typeof Q == "function" ? J = Q(N, J) : J instanceof Date ? J = ce(J) : j === "comma" && v(J) && (J = p.maybeMap(J, function(Ie) {
          return Ie instanceof Date ? ce(Ie) : Ie;
        })), J === null) {
          if (B) return H && !V ? H(N, T.encoder, K, "key", $) : N;
          J = "";
        }
        if (function(je) {
          return typeof je == "string" || typeof je == "number" || typeof je == "boolean" || l(je) === "symbol" || typeof je == "bigint";
        }(J) || p.isBuffer(J)) return H ? [te(V ? N : H(N, T.encoder, K, "key", $)) + "=" + te(H(J, T.encoder, K, "value", $))] : [te(N) + "=" + te(String(J))];
        var X, oe = [];
        if (J === void 0) return oe;
        for (var ae = j === "comma" && v(J) ? [{ value: 0 < (J = V && H ? p.maybeMap(J, H) : J).length ? J.join(",") || null : void 0 }] : v(Q) ? Q : (X = Object.keys(J), Y ? X.sort(Y) : X), _e = I && v(J) && J.length === 1 ? N + "[]" : N, ve = 0; ve < ae.length; ++ve) {
          var Ee, we = ae[ve], ze = l(we) === "object" && we.value !== void 0 ? we.value : J[we];
          U && ze === null || (Ee = v(J) ? typeof j == "function" ? j(_e, we) : _e : _e + (ie ? "." + we : "[" + we + "]"), ne.set(k, z), (we = h()).set(A, ne), d(oe, f(ze, Ee, j, I, B, U, j === "comma" && V && v(J) ? null : H, Q, Y, ie, ce, $, te, V, K, we)));
        }
        return oe;
      }
      var h = y(417), p = y(205), g = y(134), _ = Object.prototype.hasOwnProperty, b = { brackets: function(N) {
        return N + "[]";
      }, comma: "comma", indices: function(N, j) {
        return N + "[" + j + "]";
      }, repeat: function(N) {
        return N;
      } }, v = Array.isArray, E = Array.prototype.push, C = Date.prototype.toISOString, y = g.default, T = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: p.encode, encodeValuesOnly: !1, format: y, formatter: g.formatters[y], indices: !1, serializeDate: function(N) {
        return C.call(N);
      }, skipNulls: !1, strictNullHandling: !1 }, A = {};
      a.exports = function(U, N) {
        var j = U, I = function(V) {
          if (!V) return T;
          if (V.encoder !== null && V.encoder !== void 0 && typeof V.encoder != "function") throw new TypeError("Encoder has to be a function.");
          var K = V.charset || T.charset;
          if (V.charset !== void 0 && V.charset !== "utf-8" && V.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
          var ne = g.default;
          if (V.format !== void 0) {
            if (!_.call(g.formatters, V.format)) throw new TypeError("Unknown format option provided.");
            ne = V.format;
          }
          var J = g.formatters[ne], L = T.filter;
          return typeof V.filter != "function" && !v(V.filter) || (L = V.filter), { addQueryPrefix: (typeof V.addQueryPrefix == "boolean" ? V : T).addQueryPrefix, allowDots: V.allowDots === void 0 ? T.allowDots : !!V.allowDots, charset: K, charsetSentinel: (typeof V.charsetSentinel == "boolean" ? V : T).charsetSentinel, delimiter: (V.delimiter === void 0 ? T : V).delimiter, encode: (typeof V.encode == "boolean" ? V : T).encode, encoder: (typeof V.encoder == "function" ? V : T).encoder, encodeValuesOnly: (typeof V.encodeValuesOnly == "boolean" ? V : T).encodeValuesOnly, filter: L, format: ne, formatter: J, serializeDate: (typeof V.serializeDate == "function" ? V : T).serializeDate, skipNulls: (typeof V.skipNulls == "boolean" ? V : T).skipNulls, sort: typeof V.sort == "function" ? V.sort : null, strictNullHandling: (typeof V.strictNullHandling == "boolean" ? V : T).strictNullHandling };
        }(N);
        typeof I.filter == "function" ? j = (0, I.filter)("", j) : v(I.filter) && (Y = I.filter);
        var B = [];
        if (l(j) !== "object" || j === null) return "";
        var U = N && N.arrayFormat in b ? N.arrayFormat : N && "indices" in N && !N.indices ? "repeat" : "indices", H = b[U];
        if (N && "commaRoundTrip" in N && typeof N.commaRoundTrip != "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
        var Q = H === "comma" && N && N.commaRoundTrip, Y = Y || Object.keys(j);
        I.sort && Y.sort(I.sort);
        for (var ie = h(), ce = 0; ce < Y.length; ++ce) {
          var $ = Y[ce];
          I.skipNulls && j[$] === null || d(B, f(j[$], $, H, Q, I.strictNullHandling, I.skipNulls, I.encode ? I.encoder : null, I.filter, I.sort, I.allowDots, I.serializeDate, I.format, I.formatter, I.encodeValuesOnly, I.charset, ie));
        }
        return U = B.join(I.delimiter), N = I.addQueryPrefix === !0 ? "?" : "", I.charsetSentinel && (I.charset === "iso-8859-1" ? N += "utf8=%26%2310003%3B&" : N += "utf8=%E2%9C%93&"), 0 < U.length ? N + U : "";
      };
    }, function(a, s, r) {
      function l(k) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
          return typeof N;
        } : function(N) {
          return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
        })(k);
      }
      function d(k, N) {
        for (var j, I = k; (j = I.next) !== null; I = j) if (j.key === N) return I.next = j.next, j.next = k.next, k.next = j;
      }
      var f = r(36), h = r(423), p = r(427), g = f("%TypeError%"), _ = f("%WeakMap%", !0), b = f("%Map%", !0), v = h("WeakMap.prototype.get", !0), E = h("WeakMap.prototype.set", !0), C = h("WeakMap.prototype.has", !0), y = h("Map.prototype.get", !0), T = h("Map.prototype.set", !0), A = h("Map.prototype.has", !0);
      a.exports = function() {
        var N, j, I, B = { assert: function(H) {
          if (!B.has(H)) throw new g("Side channel does not contain " + p(H));
        }, get: function(H) {
          if (_ && H && (l(H) === "object" || typeof H == "function")) {
            if (N) return v(N, H);
          } else if (b) {
            if (j) return y(j, H);
          } else if (I) return function(Y, ie) {
            return (ie = d(Y, ie)) && ie.value;
          }(I, H);
        }, has: function(H) {
          if (_ && H && (l(H) === "object" || typeof H == "function")) {
            if (N) return C(N, H);
          } else if (b) {
            if (j) return A(j, H);
          } else if (I) return function(Y, ie) {
            return !!d(Y, ie);
          }(I, H);
          return !1;
        }, set: function(H, Q) {
          _ && H && (l(H) === "object" || typeof H == "function") ? (N = N || new _(), E(N, H, Q)) : b ? (j = j || new b(), T(j, H, Q)) : function(ie, ce, $) {
            var te = d(ie, ce);
            te ? te.value = $ : ie.next = { key: ce, next: ie.next, value: $ };
          }(I = I || { key: {}, next: null }, H, Q);
        } };
        return B;
      };
    }, function(a, s, r) {
      function l(h) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
          return typeof p;
        } : function(p) {
          return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
        })(h);
      }
      var d = typeof Symbol < "u" && Symbol, f = r(419);
      a.exports = function() {
        return typeof d == "function" && typeof Symbol == "function" && l(d("foo")) === "symbol" && l(Symbol("bar")) === "symbol" && f();
      };
    }, function(a, s, r) {
      function l(d) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        })(d);
      }
      a.exports = function() {
        if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
        if (l(Symbol.iterator) === "symbol") return !0;
        var f = {}, h = Symbol("test"), p = Object(h);
        if (typeof h == "string" || Object.prototype.toString.call(h) !== "[object Symbol]" || Object.prototype.toString.call(p) !== "[object Symbol]") return !1;
        for (h in f[h] = 42, f) return !1;
        return (typeof Object.keys != "function" || Object.keys(f).length === 0) && (typeof Object.getOwnPropertyNames != "function" || Object.getOwnPropertyNames(f).length === 0) && (p = Object.getOwnPropertySymbols(f)).length === 1 && p[0] === h && !!Object.prototype.propertyIsEnumerable.call(f, h) && (typeof Object.getOwnPropertyDescriptor != "function" || (f = Object.getOwnPropertyDescriptor(f, h)).value === 42 && f.enumerable === !0);
      };
    }, function(a, s, r) {
      var l = { foo: {} }, d = Object;
      a.exports = function() {
        return { __proto__: l }.foo === l.foo && !({ __proto__: null } instanceof d);
      };
    }, function(a, s, r) {
      function l(h, p) {
        for (var g = [], _ = 0; _ < h.length; _ += 1) g[_] = h[_];
        for (var b = 0; b < p.length; b += 1) g[b + h.length] = p[b];
        return g;
      }
      var d = Object.prototype.toString, f = Math.max;
      a.exports = function(p) {
        var g = this;
        if (typeof g != "function" || d.apply(g) !== "[object Function]") throw new TypeError("Function.prototype.bind called on incompatible " + g);
        for (var _, b = function(A, k) {
          for (var N = [], j = k, I = 0; j < A.length; j += 1, I += 1) N[I] = A[j];
          return N;
        }(arguments, 1), v = function() {
          if (this instanceof _) {
            var A = g.apply(this, l(b, arguments));
            return Object(A) === A ? A : this;
          }
          return g.apply(p, l(b, arguments));
        }, E = f(0, g.length - b.length), C = [], y = 0; y < E; y++) C[y] = "$" + y;
        return _ = Function("binder", "return function (" + function(A, k) {
          for (var N = "", j = 0; j < A.length; j += 1) N += A[j], j + 1 < A.length && (N += k);
          return N;
        }(C, ",") + "){ return binder.apply(this,arguments); }")(v), g.prototype && ((v = function() {
        }).prototype = g.prototype, _.prototype = new v(), v.prototype = null), _;
      };
    }, function(a, s, f) {
      var l = Function.prototype.call, d = Object.prototype.hasOwnProperty, f = f(133);
      a.exports = f.call(l, d);
    }, function(a, s, r) {
      var l = r(36), d = r(424), f = d(l("String.prototype.indexOf"));
      a.exports = function(p, g) {
        return typeof (g = l(p, !!g)) == "function" && -1 < f(p, ".prototype.") ? d(g) : g;
      };
    }, function(a, s, b) {
      var l = b(133), d = b(36), f = b(425), h = d("%TypeError%"), p = d("%Function.prototype.apply%"), g = d("%Function.prototype.call%"), _ = d("%Reflect.apply%", !0) || l.call(g, p), b = d("%Object.defineProperty%", !0), v = d("%Math.max%");
      if (b) try {
        b({}, "a", { value: 1 });
      } catch {
        b = null;
      }
      a.exports = function(C) {
        if (typeof C != "function") throw new h("a function is required");
        var y = _(l, g, arguments);
        return f(y, 1 + v(0, C.length - (arguments.length - 1)), !0);
      }, d = function() {
        return _(l, p, arguments);
      }, b ? b(a.exports, "apply", { value: d }) : a.exports.apply = d;
    }, function(a, s, r) {
      var l = r(36), d = r(426), f = r(203)(), h = r(204), p = l("%TypeError%"), g = l("%Math.floor%");
      a.exports = function(b, v) {
        if (typeof b != "function") throw new p("`fn` is not a function");
        if (typeof v != "number" || v < 0 || 4294967295 < v || g(v) !== v) throw new p("`length` must be a positive 32-bit integer");
        var E, C = 2 < arguments.length && !!arguments[2], y = !0, T = !0;
        return "length" in b && h && ((E = h(b, "length")) && !E.configurable && (y = !1), E && !E.writable && (T = !1)), !y && !T && C || (f ? d(b, "length", v, !0, !0) : d(b, "length", v)), b;
      };
    }, function(a, s, r) {
      function l(b) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
          return typeof v;
        } : function(v) {
          return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
        })(b);
      }
      var d = r(203)(), f = r(36), h = d && f("%Object.defineProperty%", !0);
      if (h) try {
        h({}, "a", { value: 1 });
      } catch {
        h = !1;
      }
      var p = f("%SyntaxError%"), g = f("%TypeError%"), _ = r(204);
      a.exports = function(v, E, C) {
        if (!v || l(v) !== "object" && typeof v != "function") throw new g("`obj` must be an object or a function`");
        if (typeof E != "string" && l(E) !== "symbol") throw new g("`property` must be a string or a symbol`");
        if (3 < arguments.length && typeof arguments[3] != "boolean" && arguments[3] !== null) throw new g("`nonEnumerable`, if provided, must be a boolean or null");
        if (4 < arguments.length && typeof arguments[4] != "boolean" && arguments[4] !== null) throw new g("`nonWritable`, if provided, must be a boolean or null");
        if (5 < arguments.length && typeof arguments[5] != "boolean" && arguments[5] !== null) throw new g("`nonConfigurable`, if provided, must be a boolean or null");
        if (6 < arguments.length && typeof arguments[6] != "boolean") throw new g("`loose`, if provided, must be a boolean");
        var y = 3 < arguments.length ? arguments[3] : null, T = 4 < arguments.length ? arguments[4] : null, A = 5 < arguments.length ? arguments[5] : null, k = 6 < arguments.length && arguments[6], N = !!_ && _(v, E);
        if (h) h(v, E, { configurable: A === null && N ? N.configurable : !A, enumerable: y === null && N ? N.enumerable : !y, value: C, writable: T === null && N ? N.writable : !T });
        else {
          if (!k && (y || T || A)) throw new p("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
          v[E] = C;
        }
      };
    }, function(a, s, r) {
      function l(q) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(X) {
          return typeof X;
        } : function(X) {
          return X && typeof Symbol == "function" && X.constructor === Symbol && X !== Symbol.prototype ? "symbol" : typeof X;
        })(q);
      }
      var p = typeof Map == "function" && Map.prototype, h = Object.getOwnPropertyDescriptor && p ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, d = p && h && typeof h.get == "function" ? h.get : null, f = p && Map.prototype.forEach, h = typeof Set == "function" && Set.prototype, p = Object.getOwnPropertyDescriptor && h ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, g = h && p && typeof p.get == "function" ? p.get : null, _ = h && Set.prototype.forEach, b = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap.prototype.has : null, v = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet.prototype.has : null, E = typeof WeakRef == "function" && WeakRef.prototype ? WeakRef.prototype.deref : null, C = Boolean.prototype.valueOf, y = Object.prototype.toString, T = Function.prototype.toString, A = String.prototype.match, k = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, N = Object.getOwnPropertySymbols, j = typeof Symbol == "function" && l(Symbol.iterator) === "symbol" ? Symbol.prototype.toString : null, I = typeof Symbol == "function" && l(Symbol.iterator) === "object", B = Object.prototype.propertyIsEnumerable, U = (typeof Reflect == "function" ? Reflect : Object).getPrototypeOf || ([].__proto__ === Array.prototype ? function(q) {
        return q.__proto__;
      } : null), H = (r = r(428).custom) && ce(r) ? r : null, Q = typeof Symbol == "function" && Symbol.toStringTag !== void 0 ? Symbol.toStringTag : null;
      function Y(q, X, oe) {
        return (X = (oe.quoteStyle || X) === "double" ? '"' : "'") + q + X;
      }
      function ie(q) {
        return !(V(q) !== "[object Array]" || Q && l(q) === "object" && Q in q);
      }
      function ce(q) {
        if (I) return q && l(q) === "object" && q instanceof Symbol;
        if (l(q) === "symbol") return 1;
        if (q && l(q) === "object" && j) try {
          return j.call(q), 1;
        } catch {
        }
      }
      a.exports = function q(X, oe, ae, _e) {
        var ve = oe || {};
        if (te(ve, "quoteStyle") && ve.quoteStyle !== "single" && ve.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
        if (te(ve, "maxStringLength") && (typeof ve.maxStringLength == "number" ? ve.maxStringLength < 0 && ve.maxStringLength !== 1 / 0 : ve.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
        var Ee = !te(ve, "customInspect") || ve.customInspect;
        if (typeof Ee != "boolean") throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
        if (te(ve, "indent") && ve.indent !== null && ve.indent !== "	" && !(parseInt(ve.indent, 10) === ve.indent && 0 < ve.indent)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
        if (X === void 0) return "undefined";
        if (X === null) return "null";
        if (typeof X == "boolean") return X ? "true" : "false";
        if (typeof X == "string") return function Se(he, Te) {
          if (he.length > Te.maxStringLength) {
            var Me = "... " + (Me = he.length - Te.maxStringLength) + " more character" + (1 < Me ? "s" : "");
            return Se(he.slice(0, Te.maxStringLength), Te) + Me;
          }
          return Y(he = he.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, ne), "single", Te);
        }(X, ve);
        if (typeof X == "number") return X === 0 ? 0 < 1 / 0 / X ? "0" : "-0" : String(X);
        if (typeof X == "bigint") return String(X) + "n";
        var we = ve.depth === void 0 ? 5 : ve.depth;
        if (we <= (ae = ae === void 0 ? 0 : ae) && 0 < we && l(X) === "object") return ie(X) ? "[Array]" : "[Object]";
        var ze = function(he, Te) {
          var Me;
          if (he.indent === "	") Me = "	";
          else {
            if (!(typeof he.indent == "number" && 0 < he.indent)) return null;
            Me = Array(he.indent + 1).join(" ");
          }
          return { base: Me, prev: Array(Te + 1).join(Me) };
        }(ve, ae);
        if (_e === void 0) _e = [];
        else if (0 <= K(_e, X)) return "[Circular]";
        function Ie(Se, he, Te) {
          return he && (_e = _e.slice()).push(he), Te ? (Te = { depth: ve.depth }, te(ve, "quoteStyle") && (Te.quoteStyle = ve.quoteStyle), q(Se, Te, ae + 1, _e)) : q(Se, ve, ae + 1, _e);
        }
        if (typeof X == "function") return "[Function" + ((oe = function(he) {
          return he.name || ((he = A.call(T.call(he), /^function\s*([\w$]+)/)) ? he[1] : null);
        }(X)) ? ": " + oe : " (anonymous)") + "]" + (0 < (we = ee(X, Ie)).length ? " { " + we.join(", ") + " }" : "");
        if (ce(X)) {
          var je = I ? String(X).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : j.call(X);
          return l(X) !== "object" || I ? je : J(je);
        }
        if (function(he) {
          return he && l(he) === "object" && (typeof HTMLElement < "u" && he instanceof HTMLElement || typeof he.nodeName == "string" && typeof he.getAttribute == "function");
        }(X)) {
          for (var qe = "<" + String(X.nodeName).toLowerCase(), Ge = X.attributes || [], Ze = 0; Ze < Ge.length; Ze++) qe += " " + Ge[Ze].name + "=" + Y(function(he) {
            return String(he).replace(/"/g, "&quot;");
          }(Ge[Ze].value), "double", ve);
          return qe += ">", X.childNodes && X.childNodes.length && (qe += "..."), qe + ("</" + String(X.nodeName).toLowerCase()) + ">";
        }
        if (ie(X)) {
          if (X.length === 0) return "[]";
          var tt = ee(X, Ie);
          return ze && !function(he) {
            for (var Te = 0; Te < he.length; Te++) if (0 <= K(he[Te], `
`)) return;
            return 1;
          }(tt) ? "[" + z(tt, ze) + "]" : "[ " + tt.join(", ") + " ]";
        }
        if (function(he) {
          return !(V(he) !== "[object Error]" || Q && l(he) === "object" && Q in he);
        }(X)) {
          var Qe = ee(X, Ie);
          return Qe.length === 0 ? "[" + String(X) + "]" : "{ [" + String(X) + "] " + Qe.join(", ") + " }";
        }
        if (l(X) === "object" && Ee) {
          if (H && typeof X[H] == "function") return X[H]();
          if (typeof X.inspect == "function") return X.inspect();
        }
        if (function(he) {
          if (d && he && l(he) === "object") try {
            d.call(he);
            try {
              g.call(he);
            } catch {
              return 1;
            }
            return he instanceof Map;
          } catch {
          }
        }(X)) {
          var ke = [];
          return f.call(X, function(Se, he) {
            ke.push(Ie(he, X, !0) + " => " + Ie(Se, X));
          }), L("Map", d.call(X), ke, ze);
        }
        if (function(he) {
          if (g && he && l(he) === "object") try {
            g.call(he);
            try {
              d.call(he);
            } catch {
              return 1;
            }
            return he instanceof Set;
          } catch {
          }
        }(X)) {
          var pe = [];
          return _.call(X, function(Se) {
            pe.push(Ie(Se, X));
          }), L("Set", g.call(X), pe, ze);
        }
        return function(he) {
          if (b && he && l(he) === "object") try {
            b.call(he, b);
            try {
              v.call(he, v);
            } catch {
              return 1;
            }
            return he instanceof WeakMap;
          } catch {
          }
        }(X) ? "WeakMap { ? }" : function(he) {
          if (v && he && l(he) === "object") try {
            v.call(he, v);
            try {
              b.call(he, b);
            } catch {
              return 1;
            }
            return he instanceof WeakSet;
          } catch {
          }
        }(X) ? "WeakSet { ? }" : function(he) {
          if (E && he && l(he) === "object") try {
            return E.call(he), 1;
          } catch {
          }
        }(X) ? "WeakRef { ? }" : function(he) {
          return !(V(he) !== "[object Number]" || Q && l(he) === "object" && Q in he);
        }(X) ? J(Ie(Number(X))) : function(he) {
          if (he && l(he) === "object" && k) try {
            return k.call(he), 1;
          } catch {
          }
        }(X) ? J(Ie(k.call(X))) : function(he) {
          return !(V(he) !== "[object Boolean]" || Q && l(he) === "object" && Q in he);
        }(X) ? J(C.call(X)) : function(he) {
          return !(V(he) !== "[object String]" || Q && l(he) === "object" && Q in he);
        }(X) ? J(Ie(String(X))) : function(he) {
          return !(V(he) !== "[object Date]" || Q && l(he) === "object" && Q in he);
        }(X) || function(he) {
          return !(V(he) !== "[object RegExp]" || Q && l(he) === "object" && Q in he);
        }(X) ? String(X) : (je = ee(X, Ie), tt = U ? U(X) === Object.prototype : X instanceof Object || X.constructor === Object, Qe = X instanceof Object ? "" : "null prototype", Ee = !tt && Q && Object(X) === X && Q in X ? V(X).slice(8, -1) : Qe ? "Object" : "", Qe = (!tt && typeof X.constructor == "function" && X.constructor.name ? X.constructor.name + " " : "") + (Ee || Qe ? "[" + [].concat(Ee || [], Qe || []).join(": ") + "] " : ""), je.length === 0 ? Qe + "{}" : ze ? Qe + "{" + z(je, ze) + "}" : Qe + "{ " + je.join(", ") + " }");
      };
      var $ = Object.prototype.hasOwnProperty || function(q) {
        return q in this;
      };
      function te(q, X) {
        return $.call(q, X);
      }
      function V(q) {
        return y.call(q);
      }
      function K(q, X) {
        if (q.indexOf) return q.indexOf(X);
        for (var oe = 0, ae = q.length; oe < ae; oe++) if (q[oe] === X) return oe;
        return -1;
      }
      function ne(q) {
        var X = q.charCodeAt(0);
        return (q = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[X]) ? "\\" + q : "\\x" + (X < 16 ? "0" : "") + X.toString(16).toUpperCase();
      }
      function J(q) {
        return "Object(" + q + ")";
      }
      function L(q, X, oe, ae) {
        return q + " (" + X + ") {" + (ae ? z(oe, ae) : oe.join(", ")) + "}";
      }
      function z(q, X) {
        if (q.length === 0) return "";
        var oe = `
` + X.prev + X.base;
        return oe + q.join("," + oe) + `
` + X.prev;
      }
      function ee(q, X) {
        var oe = ie(q), ae = [];
        if (oe) {
          ae.length = q.length;
          for (var _e = 0; _e < q.length; _e++) ae[_e] = te(q, _e) ? X(q[_e], q) : "";
        }
        var ve, Ee = typeof N == "function" ? N(q) : [];
        if (I) for (var we = {}, ze = 0; ze < Ee.length; ze++) we["$" + Ee[ze]] = Ee[ze];
        for (ve in q) te(q, ve) && (oe && String(Number(ve)) === ve && ve < q.length || I && we["$" + ve] instanceof Symbol || (/[^\w$]/.test(ve) ? ae.push(X(ve, q) + ": " + X(q[ve], q)) : ae.push(ve + ": " + X(q[ve], q))));
        if (typeof N == "function") for (var Ie = 0; Ie < Ee.length; Ie++) B.call(q, Ee[Ie]) && ae.push("[" + X(Ee[Ie]) + "]: " + X(q[Ee[Ie]], q));
        return ae;
      }
    }, function(a, s) {
    }, function(a, s, r) {
      function l(b, v) {
        return b && typeof b == "string" && v.comma && -1 < b.indexOf(",") ? b.split(",") : b;
      }
      function d(N, v) {
        var E, C, y, T, A = { __proto__: null }, k = v.ignoreQueryPrefix ? N.replace(/^\?/, "") : N, N = v.parameterLimit === 1 / 0 ? void 0 : v.parameterLimit, j = k.split(v.delimiter, N), I = -1, B = v.charset;
        if (v.charsetSentinel) for (E = 0; E < j.length; ++E) j[E].indexOf("utf8=") === 0 && (j[E] === "utf8=%E2%9C%93" ? B = "utf-8" : j[E] === "utf8=%26%2310003%3B" && (B = "iso-8859-1"), I = E, E = j.length);
        for (E = 0; E < j.length; ++E) E !== I && ((T = (T = (T = (C = j[E]).indexOf("]=")) === -1 ? C.indexOf("=") : T + 1) === -1 ? (y = v.decoder(C, _.decoder, B, "key"), v.strictNullHandling ? null : "") : (y = v.decoder(C.slice(0, T), _.decoder, B, "key"), h.maybeMap(l(C.slice(T + 1), v), function(U) {
          return v.decoder(U, _.decoder, B, "value");
        }))) && v.interpretNumericEntities && B === "iso-8859-1" && (T = function(H) {
          return H.replace(/&#(\d+);/g, function(Q, Y) {
            return String.fromCharCode(parseInt(Y, 10));
          });
        }(T)), -1 < C.indexOf("[]=") && (T = g(T) ? [T] : T), p.call(A, y) ? A[y] = h.combine(A[y], T) : A[y] = T);
        return A;
      }
      function f(b, v, E, C) {
        if (b) {
          var y = E.allowDots ? b.replace(/\.([^.[]+)/g, "[$1]") : b, T = /(\[[^[\]]*])/g, A = 0 < E.depth && /(\[[^[\]]*])/.exec(y), k = [];
          if (b = A ? y.slice(0, A.index) : y) {
            if (!E.plainObjects && p.call(Object.prototype, b) && !E.allowPrototypes) return;
            k.push(b);
          }
          for (var N = 0; 0 < E.depth && (A = T.exec(y)) !== null && N < E.depth; ) {
            if (N += 1, !E.plainObjects && p.call(Object.prototype, A[1].slice(1, -1)) && !E.allowPrototypes) return;
            k.push(A[1]);
          }
          return A && k.push("[" + y.slice(A.index) + "]"), function(I, B, U, H) {
            for (var Q = H ? B : l(B, U), Y = I.length - 1; 0 <= Y; --Y) {
              var ie, ce, $, te = I[Y];
              te === "[]" && U.parseArrays ? ie = [].concat(Q) : (ie = U.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, ce = te.charAt(0) === "[" && te.charAt(te.length - 1) === "]" ? te.slice(1, -1) : te, $ = parseInt(ce, 10), U.parseArrays || ce !== "" ? !isNaN($) && te !== ce && String($) === ce && 0 <= $ && U.parseArrays && $ <= U.arrayLimit ? (ie = [])[$] = Q : ce !== "__proto__" && (ie[ce] = Q) : ie = { 0: Q }), Q = ie;
            }
            return Q;
          }(k, v, E, C);
        }
      }
      var h = r(205), p = Object.prototype.hasOwnProperty, g = Array.isArray, _ = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: h.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 };
      a.exports = function(b, v) {
        var E = function(j) {
          if (!j) return _;
          if (j.decoder !== null && j.decoder !== void 0 && typeof j.decoder != "function") throw new TypeError("Decoder has to be a function.");
          if (j.charset !== void 0 && j.charset !== "utf-8" && j.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
          var I = (j.charset === void 0 ? _ : j).charset;
          return { allowDots: j.allowDots === void 0 ? _.allowDots : !!j.allowDots, allowPrototypes: (typeof j.allowPrototypes == "boolean" ? j : _).allowPrototypes, allowSparse: (typeof j.allowSparse == "boolean" ? j : _).allowSparse, arrayLimit: (typeof j.arrayLimit == "number" ? j : _).arrayLimit, charset: I, charsetSentinel: (typeof j.charsetSentinel == "boolean" ? j : _).charsetSentinel, comma: (typeof j.comma == "boolean" ? j : _).comma, decoder: (typeof j.decoder == "function" ? j : _).decoder, delimiter: (typeof j.delimiter == "string" || h.isRegExp(j.delimiter) ? j : _).delimiter, depth: typeof j.depth == "number" || j.depth === !1 ? +j.depth : _.depth, ignoreQueryPrefix: j.ignoreQueryPrefix === !0, interpretNumericEntities: (typeof j.interpretNumericEntities == "boolean" ? j : _).interpretNumericEntities, parameterLimit: (typeof j.parameterLimit == "number" ? j : _).parameterLimit, parseArrays: j.parseArrays !== !1, plainObjects: (typeof j.plainObjects == "boolean" ? j : _).plainObjects, strictNullHandling: (typeof j.strictNullHandling == "boolean" ? j : _).strictNullHandling };
        }(v);
        if (b === "" || b == null) return E.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        for (var C = typeof b == "string" ? d(b, E) : b, k = E.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, y = Object.keys(C), T = 0; T < y.length; ++T) var A = f(A = y[T], C[A], E, typeof b == "string"), k = h.merge(k, A, E);
        return E.allowSparse === !0 ? k : h.compact(k);
      };
    }, function(a, s, r) {
      var l, d = r(192), f = r(27), h = a.exports;
      for (l in d) d.hasOwnProperty(l) && (h[l] = d[l]);
      function p(g) {
        if ((g = typeof g == "string" ? f.parse(g) : g).protocol || (g.protocol = "https:"), g.protocol !== "https:") throw new Error('Protocol "' + g.protocol + '" not supported. Expected "https:"');
        return g;
      }
      h.request = function(g, _) {
        return g = p(g), d.request.call(this, g, _);
      }, h.get = function(g, _) {
        return g = p(g), d.get.call(this, g, _);
      };
    }, function(a, s) {
      var r = /^http:\/\//;
      a.exports = function(d) {
        return r.test(d);
      };
    }, function(a, s) {
      var r = /^https:\/\//;
      a.exports = function(d) {
        return r.test(d);
      };
    }, function(a, s) {
      a.exports = function(l) {
        return Array.isArray(l) ? l : l === !1 ? ["none"] : l === void 0 ? ["local"] : l.split(",");
      };
    }, function(a, s, r) {
      (function(l) {
        var d = r(27), f = r(48);
        a.exports = function(p) {
          return f(function(_) {
            return _ ? { hostname: d.parse(_).hostname, port: parseInt(d.parse(_).port) } : {};
          }(l.env.HTTP_PROXY || l.env.http_proxy), p || {});
        };
      }).call(this, r(15));
    }, function(a, s) {
      a.exports = function(l) {
        return l || 5e3;
      };
    }, function(a, s) {
      a.exports = function(l) {
        return l === void 0 || !!l;
      };
    }, function(a, s, r) {
      (function(l) {
        var d = r(22);
        a.exports = function(h) {
          return h ? d.resolve(h) : l.cwd();
        };
      }).call(this, r(15));
    }, function(a, s, r) {
      var l = r(206).SourceMapConsumer;
      a.exports = function() {
        var f = {};
        return { all: (function(p) {
          return p;
        }).bind(null, f), isTracking: (function(p, g) {
          return g in p;
        }).bind(null, f), originalPositionFor: (function h(p, g, _, b) {
          for (var v, E = g[0], C = g[1], y = g[2], T = { line: E, column: C + _ }; !v && T.column > C; ) T.column--, v = p[y].originalPositionFor(T);
          return !v || v.column < 0 ? g : v.line === null && 1 < E && 0 < b ? h(p, [E - 1, C, y], _, b - 1) : v.line !== null ? function(k) {
            return [k.line, k.column, k.source];
          }(v) : g;
        }).bind(null, f), track: (function(p, g, _) {
          p[g] = new l(_);
        }).bind(null, f) };
      };
    }, function(a, s) {
      var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
      s.encode = function(l) {
        if (0 <= l && l < r.length) return r[l];
        throw new TypeError("Must be between 0 and 63: " + l);
      }, s.decode = function(l) {
        return 65 <= l && l <= 90 ? l - 65 : 97 <= l && l <= 122 ? l - 97 + 26 : 48 <= l && l <= 57 ? l - 48 + 52 : l == 43 ? 62 : l == 47 ? 63 : -1;
      };
    }, function(a, s, r) {
      var l = r(64);
      function d() {
        this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
      }
      d.prototype.unsortedForEach = function(h, p) {
        this._array.forEach(h, p);
      }, d.prototype.add = function(h) {
        (function(g, _) {
          var b = g.generatedLine, v = _.generatedLine, E = g.generatedColumn, C = _.generatedColumn;
          return b < v || v == b && E <= C || l.compareByGeneratedPositionsInflated(g, _) <= 0;
        })(this._last, h) ? this._last = h : this._sorted = !1, this._array.push(h);
      }, d.prototype.toArray = function() {
        return this._sorted || (this._array.sort(l.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
      }, s.MappingList = d;
    }, function(a, s, r) {
      var l = r(64), d = r(442), f = r(209).ArraySet, h = r(208), p = r(443).quickSort;
      function g(E, C) {
        var y = E;
        return new ((y = typeof E == "string" ? l.parseSourceMapInput(E) : y).sections != null ? v : _)(y, C);
      }
      function _(j, C) {
        var I = j;
        typeof j == "string" && (I = l.parseSourceMapInput(j));
        var y = l.getArg(I, "version"), T = l.getArg(I, "sources"), A = l.getArg(I, "names", []), k = l.getArg(I, "sourceRoot", null), N = l.getArg(I, "sourcesContent", null), j = l.getArg(I, "mappings"), I = l.getArg(I, "file", null);
        if (y != this._version) throw new Error("Unsupported version: " + y);
        k = k && l.normalize(k), T = T.map(String).map(l.normalize).map(function(B) {
          return k && l.isAbsolute(k) && l.isAbsolute(B) ? l.relative(k, B) : B;
        }), this._names = f.fromArray(A.map(String), !0), this._sources = f.fromArray(T, !0), this._absoluteSources = this._sources.toArray().map(function(B) {
          return l.computeSourceURL(k, B, C);
        }), this.sourceRoot = k, this.sourcesContent = N, this._mappings = j, this._sourceMapURL = C, this.file = I;
      }
      function b() {
        this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
      }
      function v(E, C) {
        var y = E;
        if (typeof E == "string" && (y = l.parseSourceMapInput(E)), E = l.getArg(y, "version"), y = l.getArg(y, "sections"), E != this._version) throw new Error("Unsupported version: " + E);
        this._sources = new f(), this._names = new f();
        var T = { line: -1, column: 0 };
        this._sections = y.map(function(A) {
          if (A.url) throw new Error("Support for url field in sections not implemented.");
          var k = l.getArg(A, "offset"), N = l.getArg(k, "line"), j = l.getArg(k, "column");
          if (N < T.line || N === T.line && j < T.column) throw new Error("Section offsets must be ordered and non-overlapping.");
          return T = k, { generatedOffset: { generatedLine: N + 1, generatedColumn: j + 1 }, consumer: new g(l.getArg(A, "map"), C) };
        });
      }
      g.fromSourceMap = function(E, C) {
        return _.fromSourceMap(E, C);
      }, g.prototype._version = 3, g.prototype.__generatedMappings = null, Object.defineProperty(g.prototype, "_generatedMappings", { configurable: !0, enumerable: !0, get: function() {
        return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
      } }), g.prototype.__originalMappings = null, Object.defineProperty(g.prototype, "_originalMappings", { configurable: !0, enumerable: !0, get: function() {
        return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
      } }), g.prototype._charIsMappingSeparator = function(C, y) {
        return (y = C.charAt(y)) === ";" || y === ",";
      }, g.prototype._parseMappings = function(C, y) {
        throw new Error("Subclasses must implement _parseMappings");
      }, g.GENERATED_ORDER = 1, g.ORIGINAL_ORDER = 2, g.GREATEST_LOWER_BOUND = 1, g.LEAST_UPPER_BOUND = 2, g.prototype.eachMapping = function(C, k, T) {
        var A, k = k || null;
        switch (T || g.GENERATED_ORDER) {
          case g.GENERATED_ORDER:
            A = this._generatedMappings;
            break;
          case g.ORIGINAL_ORDER:
            A = this._originalMappings;
            break;
          default:
            throw new Error("Unknown order of iteration.");
        }
        var N = this.sourceRoot;
        A.map(function(j) {
          var I = j.source === null ? null : this._sources.at(j.source);
          return { source: l.computeSourceURL(N, I, this._sourceMapURL), generatedLine: j.generatedLine, generatedColumn: j.generatedColumn, originalLine: j.originalLine, originalColumn: j.originalColumn, name: j.name === null ? null : this._names.at(j.name) };
        }, this).forEach(C, k);
      }, g.prototype.allGeneratedPositionsFor = function(C) {
        var y = l.getArg(C, "line"), T = { source: l.getArg(C, "source"), originalLine: y, originalColumn: l.getArg(C, "column", 0) };
        if (T.source = this._findSourceIndex(T.source), T.source < 0) return [];
        var A = [], k = this._findMapping(T, this._originalMappings, "originalLine", "originalColumn", l.compareByOriginalPositions, d.LEAST_UPPER_BOUND);
        if (0 <= k) {
          var N = this._originalMappings[k];
          if (C.column === void 0) for (var j = N.originalLine; N && N.originalLine === j; ) A.push({ line: l.getArg(N, "generatedLine", null), column: l.getArg(N, "generatedColumn", null), lastColumn: l.getArg(N, "lastGeneratedColumn", null) }), N = this._originalMappings[++k];
          else for (var I = N.originalColumn; N && N.originalLine === y && N.originalColumn == I; ) A.push({ line: l.getArg(N, "generatedLine", null), column: l.getArg(N, "generatedColumn", null), lastColumn: l.getArg(N, "lastGeneratedColumn", null) }), N = this._originalMappings[++k];
        }
        return A;
      }, s.SourceMapConsumer = g, (_.prototype = Object.create(g.prototype)).consumer = g, _.prototype._findSourceIndex = function(E) {
        var C, y = E;
        if (this.sourceRoot != null && (y = l.relative(this.sourceRoot, y)), this._sources.has(y)) return this._sources.indexOf(y);
        for (C = 0; C < this._absoluteSources.length; ++C) if (this._absoluteSources[C] == E) return C;
        return -1;
      }, _.fromSourceMap = function(C, y) {
        var T = Object.create(_.prototype), A = T._names = f.fromArray(C._names.toArray(), !0), k = T._sources = f.fromArray(C._sources.toArray(), !0);
        T.sourceRoot = C._sourceRoot, T.sourcesContent = C._generateSourcesContent(T._sources.toArray(), T.sourceRoot), T.file = C._file, T._sourceMapURL = y, T._absoluteSources = T._sources.toArray().map(function(Y) {
          return l.computeSourceURL(T.sourceRoot, Y, y);
        });
        for (var N = C._mappings.toArray().slice(), j = T.__generatedMappings = [], I = T.__originalMappings = [], B = 0, U = N.length; B < U; B++) {
          var H = N[B], Q = new b();
          Q.generatedLine = H.generatedLine, Q.generatedColumn = H.generatedColumn, H.source && (Q.source = k.indexOf(H.source), Q.originalLine = H.originalLine, Q.originalColumn = H.originalColumn, H.name && (Q.name = A.indexOf(H.name)), I.push(Q)), j.push(Q);
        }
        return p(T.__originalMappings, l.compareByOriginalPositions), T;
      }, _.prototype._version = 3, Object.defineProperty(_.prototype, "sources", { get: function() {
        return this._absoluteSources.slice();
      } }), _.prototype._parseMappings = function(C, y) {
        for (var T, A, k, N, j = 1, I = 0, B = 0, U = 0, H = 0, Q = 0, Y = C.length, ie = 0, ce = {}, $ = {}, te = [], V = []; ie < Y; ) if (C.charAt(ie) === ";") j++, ie++, I = 0;
        else if (C.charAt(ie) === ",") ie++;
        else {
          for ((T = new b()).generatedLine = j, N = ie; N < Y && !this._charIsMappingSeparator(C, N); N++) ;
          if (k = ce[A = C.slice(ie, N)]) ie += A.length;
          else {
            for (k = []; ie < N; ) h.decode(C, ie, $), ie = $.rest, k.push($.value);
            if (k.length === 2) throw new Error("Found a source, but no line and column");
            if (k.length === 3) throw new Error("Found a source and line, but no column");
            ce[A] = k;
          }
          T.generatedColumn = I + k[0], I = T.generatedColumn, 1 < k.length && (T.source = H + k[1], H += k[1], T.originalLine = B + k[2], B = T.originalLine, T.originalLine += 1, T.originalColumn = U + k[3], U = T.originalColumn, 4 < k.length && (T.name = Q + k[4], Q += k[4])), V.push(T), typeof T.originalLine == "number" && te.push(T);
        }
        p(V, l.compareByGeneratedPositionsDeflated), this.__generatedMappings = V, p(te, l.compareByOriginalPositions), this.__originalMappings = te;
      }, _.prototype._findMapping = function(C, y, T, A, k, N) {
        if (C[T] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + C[T]);
        if (C[A] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + C[A]);
        return d.search(C, y, k, N);
      }, _.prototype.computeColumnSpans = function() {
        for (var C = 0; C < this._generatedMappings.length; ++C) {
          var y = this._generatedMappings[C];
          if (C + 1 < this._generatedMappings.length) {
            var T = this._generatedMappings[C + 1];
            if (y.generatedLine === T.generatedLine) {
              y.lastGeneratedColumn = T.generatedColumn - 1;
              continue;
            }
          }
          y.lastGeneratedColumn = 1 / 0;
        }
      }, _.prototype.originalPositionFor = function(C) {
        var y = { generatedLine: l.getArg(C, "line"), generatedColumn: l.getArg(C, "column") }, T = this._findMapping(y, this._generatedMappings, "generatedLine", "generatedColumn", l.compareByGeneratedPositionsDeflated, l.getArg(C, "bias", g.GREATEST_LOWER_BOUND));
        return 0 <= T && (C = this._generatedMappings[T]).generatedLine === y.generatedLine ? ((T = l.getArg(C, "source", null)) !== null && (T = this._sources.at(T), T = l.computeSourceURL(this.sourceRoot, T, this._sourceMapURL)), (y = l.getArg(C, "name", null)) !== null && (y = this._names.at(y)), { source: T, line: l.getArg(C, "originalLine", null), column: l.getArg(C, "originalColumn", null), name: y }) : { source: null, line: null, column: null, name: null };
      }, _.prototype.hasContentsOfAllSources = function() {
        return !!this.sourcesContent && this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(C) {
          return C == null;
        });
      }, _.prototype.sourceContentFor = function(C, y) {
        if (!this.sourcesContent) return null;
        if (0 <= (A = this._findSourceIndex(C))) return this.sourcesContent[A];
        var T, A = C;
        if (this.sourceRoot != null && (A = l.relative(this.sourceRoot, A)), this.sourceRoot != null && (T = l.urlParse(this.sourceRoot))) {
          if (C = A.replace(/^file:\/\//, ""), T.scheme == "file" && this._sources.has(C)) return this.sourcesContent[this._sources.indexOf(C)];
          if ((!T.path || T.path == "/") && this._sources.has("/" + A)) return this.sourcesContent[this._sources.indexOf("/" + A)];
        }
        if (y) return null;
        throw new Error('"' + A + '" is not in the SourceMap.');
      }, _.prototype.generatedPositionFor = function(C) {
        var y = l.getArg(C, "source");
        return (y = this._findSourceIndex(y)) < 0 ? { line: null, column: null, lastColumn: null } : (y = { source: y, originalLine: l.getArg(C, "line"), originalColumn: l.getArg(C, "column") }, 0 <= (C = this._findMapping(y, this._originalMappings, "originalLine", "originalColumn", l.compareByOriginalPositions, l.getArg(C, "bias", g.GREATEST_LOWER_BOUND))) && (C = this._originalMappings[C]).source === y.source ? { line: l.getArg(C, "generatedLine", null), column: l.getArg(C, "generatedColumn", null), lastColumn: l.getArg(C, "lastGeneratedColumn", null) } : { line: null, column: null, lastColumn: null });
      }, s.BasicSourceMapConsumer = _, (v.prototype = Object.create(g.prototype)).constructor = g, v.prototype._version = 3, Object.defineProperty(v.prototype, "sources", { get: function() {
        for (var C = [], y = 0; y < this._sections.length; y++) for (var T = 0; T < this._sections[y].consumer.sources.length; T++) C.push(this._sections[y].consumer.sources[T]);
        return C;
      } }), v.prototype.originalPositionFor = function(C) {
        var y = { generatedLine: l.getArg(C, "line"), generatedColumn: l.getArg(C, "column") }, T = d.search(y, this._sections, function(A, k) {
          return A.generatedLine - k.generatedOffset.generatedLine || A.generatedColumn - k.generatedOffset.generatedColumn;
        });
        return (T = this._sections[T]) ? T.consumer.originalPositionFor({ line: y.generatedLine - (T.generatedOffset.generatedLine - 1), column: y.generatedColumn - (T.generatedOffset.generatedLine === y.generatedLine ? T.generatedOffset.generatedColumn - 1 : 0), bias: C.bias }) : { source: null, line: null, column: null, name: null };
      }, v.prototype.hasContentsOfAllSources = function() {
        return this._sections.every(function(C) {
          return C.consumer.hasContentsOfAllSources();
        });
      }, v.prototype.sourceContentFor = function(C, y) {
        for (var T = 0; T < this._sections.length; T++) {
          var A = this._sections[T].consumer.sourceContentFor(C, !0);
          if (A) return A;
        }
        if (y) return null;
        throw new Error('"' + C + '" is not in the SourceMap.');
      }, v.prototype.generatedPositionFor = function(C) {
        for (var y = 0; y < this._sections.length; y++) {
          var T = this._sections[y];
          if (T.consumer._findSourceIndex(l.getArg(C, "source")) !== -1) {
            var A = T.consumer.generatedPositionFor(C);
            if (A) return { line: A.line + (T.generatedOffset.generatedLine - 1), column: A.column + (T.generatedOffset.generatedLine === A.line ? T.generatedOffset.generatedColumn - 1 : 0) };
          }
        }
        return { line: null, column: null };
      }, v.prototype._parseMappings = function(C, y) {
        this.__generatedMappings = [], this.__originalMappings = [];
        for (var T = 0; T < this._sections.length; T++) for (var A = this._sections[T], k = A.consumer._generatedMappings, N = 0; N < k.length; N++) {
          var j = k[N], I = A.consumer._sources.at(j.source), I = l.computeSourceURL(A.consumer.sourceRoot, I, this._sourceMapURL);
          this._sources.add(I), I = this._sources.indexOf(I);
          var B = null;
          j.name && (B = A.consumer._names.at(j.name), this._names.add(B), B = this._names.indexOf(B)), B = { source: I, generatedLine: j.generatedLine + (A.generatedOffset.generatedLine - 1), generatedColumn: j.generatedColumn + (A.generatedOffset.generatedLine === j.generatedLine ? A.generatedOffset.generatedColumn - 1 : 0), originalLine: j.originalLine, originalColumn: j.originalColumn, name: B }, this.__generatedMappings.push(B), typeof B.originalLine == "number" && this.__originalMappings.push(B);
        }
        p(this.__generatedMappings, l.compareByGeneratedPositionsDeflated), p(this.__originalMappings, l.compareByOriginalPositions);
      }, s.IndexedSourceMapConsumer = v;
    }, function(a, s) {
      s.GREATEST_LOWER_BOUND = 1, s.LEAST_UPPER_BOUND = 2, s.search = function(l, d, f, h) {
        if (d.length === 0) return -1;
        var p = function g(_, b, v, E, C, y) {
          var T = Math.floor((b - _) / 2) + _, A = C(v, E[T], !0);
          return A === 0 ? T : 0 < A ? 1 < b - T ? g(T, b, v, E, C, y) : y == s.LEAST_UPPER_BOUND ? b < E.length ? b : -1 : T : 1 < T - _ ? g(_, T, v, E, C, y) : y == s.LEAST_UPPER_BOUND ? T : _ < 0 ? -1 : _;
        }(-1, d.length, l, d, f, h || s.GREATEST_LOWER_BOUND);
        if (p < 0) return -1;
        for (; 0 <= p - 1 && f(d[p], d[p - 1], !0) === 0; ) --p;
        return p;
      };
    }, function(a, s) {
      function r(l, d, f) {
        var h = l[d];
        l[d] = l[f], l[f] = h;
      }
      s.quickSort = function(l, d) {
        (function f(h, p, g, _) {
          if (g < _) {
            var b = g - 1;
            r(h, function(T, A) {
              return Math.round(T + Math.random() * (A - T));
            }(g, _), _);
            for (var v = h[_], E = g; E < _; E++) p(h[E], v) <= 0 && r(h, b += 1, E);
            r(h, b + 1, E);
            var C = b + 1;
            f(h, p, g, C - 1), f(h, p, C + 1, _);
          }
        })(l, d, 0, l.length - 1);
      };
    }, function(a, s, r) {
      var l = r(207).SourceMapGenerator, d = r(64), f = /(\r?\n)/, h = "$$$isSourceNode$$$";
      function p(g, _, b, v, E) {
        this.children = [], this.sourceContents = {}, this.line = g ?? null, this.column = _ ?? null, this.source = b ?? null, this.name = E ?? null, this[h] = !0, v != null && this.add(v);
      }
      p.fromStringWithSourceMap = function(_, b, v) {
        function E() {
          return I() + (I() || "");
          function I() {
            return T < y.length ? y[T++] : void 0;
          }
        }
        var C = new p(), y = _.split(f), T = 0, A = 1, k = 0, N = null;
        return b.eachMapping(function(I) {
          if (N !== null) {
            if (!(A < I.generatedLine)) {
              var B = (U = y[T] || "").substr(0, I.generatedColumn - k);
              return y[T] = U.substr(I.generatedColumn - k), k = I.generatedColumn, j(N, B), void (N = I);
            }
            j(N, E()), A++, k = 0;
          }
          for (; A < I.generatedLine; ) C.add(E()), A++;
          var U;
          k < I.generatedColumn && (U = y[T] || "", C.add(U.substr(0, I.generatedColumn)), y[T] = U.substr(I.generatedColumn), k = I.generatedColumn), N = I;
        }, this), T < y.length && (N && j(N, E()), C.add(y.splice(T).join(""))), b.sources.forEach(function(I) {
          var B = b.sourceContentFor(I);
          B != null && (v != null && (I = d.join(v, I)), C.setSourceContent(I, B));
        }), C;
        function j(I, B) {
          var U;
          I === null || I.source === void 0 ? C.add(B) : (U = v ? d.join(v, I.source) : I.source, C.add(new p(I.originalLine, I.originalColumn, U, B, I.name)));
        }
      }, p.prototype.add = function(_) {
        if (Array.isArray(_)) _.forEach(function(b) {
          this.add(b);
        }, this);
        else {
          if (!_[h] && typeof _ != "string") throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + _);
          _ && this.children.push(_);
        }
        return this;
      }, p.prototype.prepend = function(_) {
        if (Array.isArray(_)) for (var b = _.length - 1; 0 <= b; b--) this.prepend(_[b]);
        else {
          if (!_[h] && typeof _ != "string") throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + _);
          this.children.unshift(_);
        }
        return this;
      }, p.prototype.walk = function(_) {
        for (var b, v = 0, E = this.children.length; v < E; v++) (b = this.children[v])[h] ? b.walk(_) : b !== "" && _(b, { source: this.source, line: this.line, column: this.column, name: this.name });
      }, p.prototype.join = function(_) {
        var b, v, E = this.children.length;
        if (0 < E) {
          for (b = [], v = 0; v < E - 1; v++) b.push(this.children[v]), b.push(_);
          b.push(this.children[v]), this.children = b;
        }
        return this;
      }, p.prototype.replaceRight = function(_, b) {
        var v = this.children[this.children.length - 1];
        return v[h] ? v.replaceRight(_, b) : typeof v == "string" ? this.children[this.children.length - 1] = v.replace(_, b) : this.children.push("".replace(_, b)), this;
      }, p.prototype.setSourceContent = function(_, b) {
        this.sourceContents[d.toSetString(_)] = b;
      }, p.prototype.walkSourceContents = function(_) {
        for (var b = 0, v = this.children.length; b < v; b++) this.children[b][h] && this.children[b].walkSourceContents(_);
        for (var E = Object.keys(this.sourceContents), b = 0, v = E.length; b < v; b++) _(d.fromSetString(E[b]), this.sourceContents[E[b]]);
      }, p.prototype.toString = function() {
        var _ = "";
        return this.walk(function(b) {
          _ += b;
        }), _;
      }, p.prototype.toStringWithSourceMap = function(_) {
        var b = { code: "", line: 1, column: 0 }, v = new l(_), E = !1, C = null, y = null, T = null, A = null;
        return this.walk(function(k, N) {
          b.code += k, N.source !== null && N.line !== null && N.column !== null ? (C === N.source && y === N.line && T === N.column && A === N.name || v.addMapping({ source: N.source, original: { line: N.line, column: N.column }, generated: { line: b.line, column: b.column }, name: N.name }), C = N.source, y = N.line, T = N.column, A = N.name, E = !0) : E && (v.addMapping({ generated: { line: b.line, column: b.column } }), C = null, E = !1);
          for (var j = 0, I = k.length; j < I; j++) k.charCodeAt(j) === 10 ? (b.line++, b.column = 0, j + 1 === I ? (C = null, E = !1) : E && v.addMapping({ source: N.source, original: { line: N.line, column: N.column }, generated: { line: b.line, column: b.column }, name: N.name })) : b.column++;
        }), this.walkSourceContents(function(k, N) {
          v.setSourceContent(k, N);
        }), { code: b.code, map: v };
      }, s.SourceNode = p;
    }, function(a, s, r) {
      (function(l, d) {
        function f(te) {
          return (f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(V) {
            return typeof V;
          } : function(V) {
            return V && typeof Symbol == "function" && V.constructor === Symbol && V !== Symbol.prototype ? "symbol" : typeof V;
          })(te);
        }
        var h = r(65), p = r(22), g = r(446), _ = r(212), b = r(135), v = r(449), E = r(450), C = r(451), y = r(210), T = r(211), A = r(213), k = r(453), N = r(12), j = r(16), I = r(91), B = r(214), U = r(66);
        function H(te, V, K) {
          return V.source = void 0, V.sourcesContent[void 0] = te, V.stats.originalSize += te.length, ce(te, V, { inline: V.options.inline }, K);
        }
        function Q(te, V, K) {
          var ne, J, L;
          for (ne in te) L = te[ne], J = Y(ne), K.push(ie(J)), V.sourcesContent[J] = L.styles, L.sourceMap && function(ee, q, X) {
            ee = typeof ee == "string" ? JSON.parse(ee) : ee, ee = U(q) ? T(ee, q) : y(ee, q || "uri:unknown", X.options.rebaseTo), X.inputSourceMapTracker.track(q, ee);
          }(L.sourceMap, J, V);
          return K;
        }
        function Y(te) {
          var V = p.resolve("");
          return U(te) ? te : (te = p.isAbsolute(te) ? te : p.resolve(te), te = p.relative(V, te), E(te));
        }
        function ie(te) {
          return A("url(" + te + ")", "") + j.SEMICOLON;
        }
        function ce(te, V, K, ne) {
          var J = {};
          return V.source ? U(V.source) ? (J.fromBase = V.source, J.toBase = V.source) : (p.isAbsolute(V.source) ? J.fromBase = p.dirname(V.source) : J.fromBase = p.dirname(p.resolve(V.source)), J.toBase = V.options.rebaseTo) : (J.fromBase = p.resolve(""), J.toBase = V.options.rebaseTo), te = k(te, V), te = C(te, V.options.rebase, V.validator, J), function(z) {
            return z.length != 1 || z[0] != "none";
          }(K.inline) ? function(z, ee, q, X) {
            return function oe(ae) {
              for (var _e, ve = 0, Ee = ae.sourceTokens.length; ve < Ee; ve++) {
                if ((_e = ae.sourceTokens[ve])[0] == N.AT_RULE && B(_e[1])) return ae.sourceTokens.splice(0, ve), function(Ge, Ie) {
                  var je = (qe = _(Ge[1]))[0], qe = qe[1], Ge = Ge[2];
                  return (U(je) ? function(tt, Qe, ke, pe) {
                    var Se = b(tt, !0, pe.inline), he = tt, Te = tt in pe.externalContext.sourcesContent, Me = !I(tt);
                    return -1 < pe.inlinedStylesheets.indexOf(tt) ? (pe.warnings.push('Ignoring remote @import of "' + tt + '" as it has already been imported.'), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe)) : pe.localOnly && pe.afterContent ? (pe.warnings.push('Ignoring remote @import of "' + tt + '" as no callback given and after other content.'), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe)) : Me ? (pe.warnings.push('Skipping remote @import of "' + tt + '" as no protocol given.'), pe.outputTokens = pe.outputTokens.concat(pe.sourceTokens.slice(0, 1)), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe)) : pe.localOnly && !Te ? (pe.warnings.push('Skipping remote @import of "' + tt + '" as no callback given.'), pe.outputTokens = pe.outputTokens.concat(pe.sourceTokens.slice(0, 1)), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe)) : !Se && pe.afterContent ? (pe.warnings.push('Ignoring remote @import of "' + tt + '" as resource is not allowed and after other content.'), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe)) : Se ? (pe.inlinedStylesheets.push(tt), Te ? Ye(null, pe.externalContext.sourcesContent[tt]) : pe.fetch(tt, pe.inlineRequest, pe.inlineTimeout, Ye)) : (pe.warnings.push('Skipping remote @import of "' + tt + '" as resource is not allowed.'), pe.outputTokens = pe.outputTokens.concat(pe.sourceTokens.slice(0, 1)), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe));
                    function Ye(et, dt) {
                      return et ? (pe.errors.push('Broken @import declaration of "' + tt + '" - ' + et), d.nextTick(function() {
                        pe.outputTokens = pe.outputTokens.concat(pe.sourceTokens.slice(0, 1)), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe);
                      })) : (pe.inline = pe.externalContext.options.inline, pe.isRemote = !0, pe.externalContext.source = he, pe.externalContext.sourcesContent[tt] = dt, pe.externalContext.stats.originalSize += dt.length, ce(dt, pe.externalContext, pe, function(We) {
                        return We = $(We, Qe, ke), pe.outputTokens = pe.outputTokens.concat(We), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe);
                      }));
                    }
                  } : function(tt, Qe, ke, pe) {
                    var Se = p.resolve(""), he = p.isAbsolute(tt) ? p.resolve(Se, tt[0] == "/" ? tt.substring(1) : tt) : p.resolve(pe.rebaseTo, tt), Me = p.relative(Se, he), Te = b(tt, !1, pe.inline), Me = (Se = E(Me)) in pe.externalContext.sourcesContent;
                    if (-1 < pe.inlinedStylesheets.indexOf(he)) pe.warnings.push('Ignoring local @import of "' + tt + '" as it has already been imported.');
                    else if (Me || h.existsSync(he) && h.statSync(he).isFile()) if (!Te && pe.afterContent) pe.warnings.push('Ignoring local @import of "' + tt + '" as resource is not allowed and after other content.');
                    else if (pe.afterContent) pe.warnings.push('Ignoring local @import of "' + tt + '" as after other content.');
                    else {
                      if (Te) return Me = Me ? pe.externalContext.sourcesContent[Se] : h.readFileSync(he, "utf-8"), pe.inlinedStylesheets.push(he), pe.inline = pe.externalContext.options.inline, pe.externalContext.source = Se, pe.externalContext.sourcesContent[Se] = Me, pe.externalContext.stats.originalSize += Me.length, ce(Me, pe.externalContext, pe, function(Ye) {
                        return Ye = $(Ye, Qe, ke), pe.outputTokens = pe.outputTokens.concat(Ye), pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe);
                      });
                      pe.warnings.push('Skipping local @import of "' + tt + '" as resource is not allowed.'), pe.outputTokens = pe.outputTokens.concat(pe.sourceTokens.slice(0, 1));
                    }
                    else pe.errors.push('Ignoring local @import of "' + tt + '" as resource is missing.');
                    return pe.sourceTokens = pe.sourceTokens.slice(1), oe(pe);
                  })(je, qe, Ge, Ie);
                }(_e, ae);
                _e[0] == N.AT_RULE || _e[0] == N.COMMENT ? ae.outputTokens.push(_e) : (ae.outputTokens.push(_e), ae.afterContent = !0);
              }
              return ae.sourceTokens = [], ae.callback(ae.outputTokens);
            }({ afterContent: !1, callback: X, errors: ee.errors, externalContext: ee, fetch: ee.options.fetch, inlinedStylesheets: q.inlinedStylesheets || ee.inlinedStylesheets, inline: q.inline, inlineRequest: ee.options.inlineRequest, inlineTimeout: ee.options.inlineTimeout, isRemote: q.isRemote || !1, localOnly: ee.localOnly, outputTokens: [], rebaseTo: ee.options.rebaseTo, sourceTokens: z, warnings: ee.warnings });
          }(te, V, K, ne) : ne(te);
        }
        function $(te, V, K) {
          return V ? [[N.NESTED_BLOCK, [[N.NESTED_BLOCK_SCOPE, "@media " + V, K]], te]] : te;
        }
        a.exports = function(V, K, ne) {
          return function(L, z, ee) {
            return typeof L == "string" ? H(L, z, ee) : l.isBuffer(L) ? H(L.toString(), z, ee) : Array.isArray(L) ? function(X, oe, ae) {
              return ce(X.reduce(function(_e, ve) {
                return typeof ve == "string" ? function(we, ze) {
                  return ze.push(ie(Y(we))), ze;
                }(ve, _e) : Q(ve, oe, _e);
              }, []).join(""), oe, { inline: ["all"] }, ae);
            }(L, z, ee) : f(L) == "object" ? function(X, oe, ae) {
              return ce(Q(X, oe, []).join(""), oe, { inline: ["all"] }, ae);
            }(L, z, ee) : void 0;
          }(V, K, function(J) {
            return g(J, K, function() {
              return v(K, function() {
                return ne(J);
              });
            });
          });
        };
      }).call(this, r(23).Buffer, r(15));
    }, function(a, s, r) {
      (function(l, d) {
        var f = r(65), h = r(22), p = r(135), g = r(447), _ = r(210), b = r(211), v = r(12), E = r(91), C = r(448), y = r(66), T = /^\/\*# sourceMappingURL=(\S+) \*\/$/;
        function A(N) {
          return (N = (N[0] == v.AT_RULE || N[0] == v.COMMENT ? N : N[1][0])[2][0])[2];
        }
        function k(N, j) {
          for (var I = N[1], B = N[2], U = [], H = 0, Q = B.length; H < Q; H++) U.push(j.originalPositionFor(B[H], I.length));
          N[2] = U;
        }
        a.exports = function(j, I, B) {
          var U = { callback: B, fetch: I.options.fetch, index: 0, inline: I.options.inline, inlineRequest: I.options.inlineRequest, inlineTimeout: I.options.inlineTimeout, inputSourceMapTracker: I.inputSourceMapTracker, localOnly: I.localOnly, processedTokens: [], rebaseTo: I.options.rebaseTo, sourceTokens: j, warnings: I.warnings };
          return I.options.sourceMap && 0 < j.length ? function H(Q) {
            for (var Y, ie, ce = [], $ = A(Q.sourceTokens[0]), te = Q.sourceTokens.length; Q.index < te; Q.index++) if ((Y = A(ie = Q.sourceTokens[Q.index])) != $ && (ce = [], $ = Y), ce.push(ie), Q.processedTokens.push(ie), ie[0] == v.COMMENT && T.test(ie[1])) return function(K, ne, J, L) {
              return function(ee, q, X) {
                var oe, ae, _e = T.exec(ee)[1];
                return C(_e) ? (oe = function(Ee) {
                  var we = (ze = g(Ee))[2] ? ze[2].split(/[=;]/)[2] : "us-ascii", ze = (Ee = ze[3] ? ze[3].split(";")[1] : "utf8") == "utf8" ? l.unescape(ze[4]) : ze[4];
                  return (Ee = new d(ze, Ee)).charset = we, JSON.parse(Ee.toString());
                }(_e), X(oe)) : y(_e) ? function(Ee, we, ze) {
                  var Ie = p(Ee, !0, we.inline), je = !E(Ee);
                  return we.localOnly ? (we.warnings.push('Cannot fetch remote resource from "' + Ee + '" as no callback given.'), ze(null)) : je ? (we.warnings.push('Cannot fetch "' + Ee + '" as no protocol given.'), ze(null)) : Ie ? void we.fetch(Ee, we.inlineRequest, we.inlineTimeout, function(qe, Ge) {
                    return qe ? (we.warnings.push('Missing source map at "' + Ee + '" - ' + qe), ze(null)) : void ze(Ge);
                  }) : (we.warnings.push('Cannot fetch "' + Ee + '" as resource is not allowed.'), ze(null));
                }(_e, q, function(ve) {
                  ve ? (ve = JSON.parse(ve), ae = b(ve, _e), X(ae)) : X(null);
                }) : (oe = function(Ee, we) {
                  var ze = p(Ee, !1, we.inline);
                  return f.existsSync(Ee) && f.statSync(Ee).isFile() ? ze ? (Ee = f.readFileSync(Ee, "utf-8"), JSON.parse(Ee)) : (we.warnings.push('Cannot fetch "' + Ee + '" as resource is not allowed.'), null) : (we.warnings.push('Ignoring local source map at "' + Ee + '" as resource is missing.'), null);
                }(ee = h.resolve(q.rebaseTo, _e), q)) ? (ae = _(oe, ee, q.rebaseTo), X(ae)) : X(null);
              }(K, L, function(z) {
                return z && (L.inputSourceMapTracker.track(ne, z), function ee(q, X) {
                  for (var oe, ae = 0, _e = q.length; ae < _e; ae++) switch ((oe = q[ae])[0]) {
                    case v.AT_RULE:
                      k(oe, X);
                      break;
                    case v.AT_RULE_BLOCK:
                      ee(oe[1], X), ee(oe[2], X);
                      break;
                    case v.AT_RULE_BLOCK_SCOPE:
                      k(oe, X);
                      break;
                    case v.NESTED_BLOCK:
                      ee(oe[1], X), ee(oe[2], X);
                      break;
                    case v.NESTED_BLOCK_SCOPE:
                    case v.COMMENT:
                      k(oe, X);
                      break;
                    case v.PROPERTY:
                      ee(oe, X);
                      break;
                    case v.PROPERTY_BLOCK:
                      ee(oe[1], X);
                      break;
                    case v.PROPERTY_NAME:
                    case v.PROPERTY_VALUE:
                      k(oe, X);
                      break;
                    case v.RULE:
                      ee(oe[1], X), ee(oe[2], X);
                      break;
                    case v.RULE_SCOPE:
                      k(oe, X);
                  }
                  return q;
                }(J, L.inputSourceMapTracker)), L.index++, H(L);
              });
            }(ie[1], Y, ce, Q);
            return Q.callback(Q.processedTokens);
          }(U) : B(j);
        };
      }).call(this, r(18), r(23).Buffer);
    }, function(a, s) {
      var r = /^data:(\S*?)?(;charset=[^;]+)?(;[^,]+?)?,(.+)/;
      a.exports = function(d) {
        return r.exec(d);
      };
    }, function(a, s) {
      var r = /^data:(\S*?)?(;charset=[^;]+)?(;[^,]+?)?,(.+)/;
      a.exports = function(d) {
        return r.test(d);
      };
    }, function(a, s, r) {
      var l = r(65), d = r(22), f = r(135), h = r(91), p = r(66);
      a.exports = function(_, b) {
        var v = { callback: b, fetch: _.options.fetch, index: 0, inline: _.options.inline, inlineRequest: _.options.inlineRequest, inlineTimeout: _.options.inlineTimeout, localOnly: _.localOnly, rebaseTo: _.options.rebaseTo, sourcesContent: _.sourcesContent, uriToSource: function(C) {
          var y, T, A, k, N, j = {};
          for (A in C) for (y = C[A], k = 0, N = y.sources.length; k < N; k++) T = y.sources[k], A = y.sourceContentFor(T, !0), j[T] = A;
          return j;
        }(_.inputSourceMapTracker.all()), warnings: _.warnings };
        return _.options.sourceMap && _.options.sourceMapInlineSources ? function E(C) {
          for (var y, T, A = Object.keys(C.uriToSource), k = A.length; C.index < k; C.index++) {
            if (y = A[C.index], !(T = C.uriToSource[y])) return function(j, I) {
              var B;
              return p(j) ? function(H, Q, Y) {
                var ie = f(H, !0, Q.inline), ce = !h(H);
                return Q.localOnly ? (Q.warnings.push('Cannot fetch remote resource from "' + H + '" as no callback given.'), Y(null)) : ce ? (Q.warnings.push('Cannot fetch "' + H + '" as no protocol given.'), Y(null)) : ie ? void Q.fetch(H, Q.inlineRequest, Q.inlineTimeout, function($, te) {
                  $ && Q.warnings.push('Missing original source at "' + H + '" - ' + $), Y(te);
                }) : (Q.warnings.push('Cannot fetch "' + H + '" as resource is not allowed.'), Y(null));
              }(j, I, function(U) {
                return I.index++, I.sourcesContent[j] = U, E(I);
              }) : (B = function(ie, Q) {
                var Y = f(ie, !1, Q.inline), ie = d.resolve(Q.rebaseTo, ie);
                return l.existsSync(ie) && l.statSync(ie).isFile() ? Y ? l.readFileSync(ie, "utf8") : (Q.warnings.push('Cannot fetch "' + ie + '" as resource is not allowed.'), null) : (Q.warnings.push('Ignoring local source map at "' + ie + '" as resource is missing.'), null);
              }(j, I), I.index++, I.sourcesContent[j] = B, E(I));
            }(y, C);
            C.sourcesContent[y] = T;
          }
          return C.callback();
        }(v) : b();
      };
    }, function(a, s) {
      var r = /\\/g;
      a.exports = function(d) {
        return d.replace(r, "/");
      };
    }, function(a, s, r) {
      var l = r(212), d = r(213), f = r(452), h = r(12), p = r(214), g = /^\/\*# sourceMappingURL=(\S+) \*\/$/;
      function _(v, E, C) {
        var y;
        p(v[1]) && (y = l(v[1]), C = f(y[0], C), y = y[1], v[1] = d(C, y));
      }
      function b(v, E, C) {
        for (var y, T, A, k, N = 0, j = v.length; N < j; N++) for (A = 2, k = (y = v[N]).length; A < k; A++) T = y[A][1], E.isUrl(T) && (y[A][1] = f(T, C));
      }
      a.exports = function(E, C, y, T) {
        return (C ? function A(k, N, j) {
          for (var I, B = 0, U = k.length; B < U; B++) switch ((I = k[B])[0]) {
            case h.AT_RULE:
              _(I, 0, j);
              break;
            case h.AT_RULE_BLOCK:
              b(I[2], N, j);
              break;
            case h.COMMENT:
              (function(Q, Y) {
                var ie = g.exec(Q[1]);
                ie && ie[1].indexOf("data:") === -1 && (Q[1] = Q[1].replace(ie[1], f(ie[1], Y, !0)));
              })(I, j);
              break;
            case h.NESTED_BLOCK:
              A(I[2], N, j);
              break;
            case h.RULE:
              b(I[2], N, j);
          }
          return k;
        } : function(k, N, j) {
          for (var I, B = 0, U = k.length; B < U; B++) (I = k[B])[0] === h.AT_RULE && _(I, 0, j);
          return k;
        })(E, y, T);
      };
    }, function(a, s, r) {
      (function(l) {
        var d = r(22), f = r(27), h = /^["']/, p = /["']$/, g = /[\(\)]/, _ = /^url\(/i, b = /\)$/, v = /\s/, E = l.platform == "win32";
        function C(A, k) {
          return !k || function(j) {
            return d.isAbsolute(j);
          }(A) && !y(k.toBase) || y(A) || function(j) {
            return j[0] == "#";
          }(A) || function(j) {
            return /^\w+:\w+/.test(j);
          }(A) ? A : function(j) {
            return j.indexOf("data:") === 0;
          }(A) ? "'" + A + "'" : y(k.toBase) ? f.resolve(k.toBase, A) : k.absolute ? T(function(j, I) {
            return d.resolve(d.join(I.fromBase || "", j)).replace(I.toBase, "");
          }(A, k)) : T(function(j, I) {
            return d.relative(I.toBase, d.join(I.fromBase || "", j));
          }(A, k));
        }
        function y(A) {
          return /^[^:]+?:\/\//.test(A) || A.indexOf("//") === 0;
        }
        function T(A) {
          return E ? A.replace(/\\/g, "/") : A;
        }
        a.exports = function(I, N, j) {
          var I = (B = I.replace(_, "").replace(b, "").trim()).replace(h, "").replace(p, "").trim(), B = B[0] == "'" || B[0] == '"' ? B[0] : function(H) {
            return -1 < H.indexOf("'") ? '"' : -1 < H.indexOf('"') || function(Y) {
              return v.test(Y);
            }(H) || function(Y) {
              return g.test(Y);
            }(H) ? "'" : "";
          }(I);
          return j ? C(I, N) : "url(" + B + C(I, N) + B + ")";
        };
      }).call(this, r(15));
    }, function(a, s, r) {
      var l = r(16), d = r(12), f = r(84), h = "block", p = "comment", g = "double-quote", _ = "rule", b = "single-quote", v = ["@charset", "@import"], E = ["@-moz-document", "@document", "@-moz-keyframes", "@-ms-keyframes", "@-o-keyframes", "@-webkit-keyframes", "@keyframes", "@media", "@supports"], C = /\/\* clean\-css ignore:end \*\/$/, y = /^\/\* clean\-css ignore:start \*\//, T = ["@bottom-center", "@bottom-left", "@bottom-left-corner", "@bottom-right", "@bottom-right-corner", "@left-bottom", "@left-middle", "@left-top", "@right-bottom", "@right-middle", "@right-top", "@top-center", "@top-left", "@top-left-corner", "@top-right", "@top-right-corner"], A = ["@footnote", "@footnotes", "@left", "@page-float-bottom", "@page-float-top", "@right"], k = /^\[\s{0,31}\d+\s{0,31}\]$/, N = /[\s\(]/, j = /[\s|\}]*$/;
      function I(H, Q, Y, ie) {
        var ce = H[2];
        return Y.inputSourceMapTracker.isTracking(ce) ? Y.inputSourceMapTracker.originalPositionFor(H, Q.length, ie) : H;
      }
      function B(Y) {
        var Q = Y[0] == l.AT || Y[0] == l.UNDERSCORE, Y = Y.join("").split(N)[0];
        return Q && -1 < E.indexOf(Y) ? d.NESTED_BLOCK : Q && -1 < v.indexOf(Y) ? d.AT_RULE : Q ? d.AT_RULE_BLOCK : d.RULE;
      }
      function U(H) {
        return H == d.RULE ? d.RULE_SCOPE : H == d.NESTED_BLOCK ? d.NESTED_BLOCK_SCOPE : H == d.AT_RULE_BLOCK ? d.AT_RULE_BLOCK_SCOPE : void 0;
      }
      a.exports = function(Q, Y) {
        return function ie(ce, $, te, V) {
          for (var K, ne, J, L, z, ee, q, X = [], oe = X, ae = [], _e = [], ve = te.level, Ee = [], we = [], ze = [], Ie = 0, je = !1, qe = !1, Ge = !1, Ze = !1, tt = !1, Qe = te.position; Qe.index < ce.length; Qe.index++) {
            var ke = ce[Qe.index], pe = ve == b || ve == g, Se = ke == l.SPACE || ke == l.TAB, he = ke == l.NEW_LINE_NIX, Te = ke == l.NEW_LINE_NIX && ce[Qe.index - 1] == l.CARRIAGE_RETURN, Me = ke == l.CARRIAGE_RETURN && ce[Qe.index + 1] && ce[Qe.index + 1] != l.NEW_LINE_NIX, Ye = !qe && ve != p && !pe && ke == l.ASTERISK && ce[Qe.index - 1] == l.FORWARD_SLASH, et = !je && !pe && ke == l.FORWARD_SLASH && ce[Qe.index - 1] == l.ASTERISK, dt = ve == p && et, Ie = Math.max(Ie, 0), We = we.length === 0 ? [Qe.line, Qe.column, Qe.source] : We;
            if (ee) we.push(ke);
            else if (dt || ve != p) if (Ye || dt || !Ge) if (Ye && (ve == h || ve == _) && 1 < we.length) _e.push(We), we.push(ke), ze.push(we.slice(0, we.length - 2)), we = we.slice(we.length - 2), We = [Qe.line, Qe.column - 1, Qe.source], Ee.push(ve), ve = p;
            else if (Ye) Ee.push(ve), ve = p, we.push(ke);
            else if (dt && function(At) {
              return y.test(At.join("") + l.FORWARD_SLASH);
            }(we)) L = we.join("").trim() + ke, K = [d.COMMENT, L, [I(We, L, $)]], oe.push(K), Ge = !0, We = _e.pop() || null, we = ze.pop() || [];
            else if (dt && function(At) {
              return C.test(At.join("") + l.FORWARD_SLASH);
            }(we)) q = (L = we.join("") + ke).lastIndexOf(l.FORWARD_SLASH + l.ASTERISK), z = L.substring(0, q), K = [d.RAW, z, [I(We, z, $)]], oe.push(K), z = L.substring(q), We = [Qe.line, Qe.column - z.length + 1, Qe.source], K = [d.COMMENT, z, [I(We, z, $)]], oe.push(K), Ge = !1, ve = Ee.pop(), We = _e.pop() || null, we = ze.pop() || [];
            else if (dt) L = we.join("").trim() + ke, K = [d.COMMENT, L, [I(We, L, $)]], oe.push(K), ve = Ee.pop(), We = _e.pop() || null, we = ze.pop() || [];
            else if (et && ce[Qe.index + 1] != l.ASTERISK) $.warnings.push("Unexpected '*/' at " + f([Qe.line, Qe.column, Qe.source]) + "."), we = [];
            else if (ke != l.SINGLE_QUOTE || pe) if (ke == l.SINGLE_QUOTE && ve == b) ve = Ee.pop(), we.push(ke);
            else if (ke != l.DOUBLE_QUOTE || pe) if (ke == l.DOUBLE_QUOTE && ve == g) ve = Ee.pop(), we.push(ke);
            else if (!Ye && !dt && ke != l.CLOSE_ROUND_BRACKET && ke != l.OPEN_ROUND_BRACKET && ve != p && !pe && 0 < Ie) we.push(ke);
            else if (ke != l.OPEN_ROUND_BRACKET || pe || ve == p || Ze) if (ke != l.CLOSE_ROUND_BRACKET || pe || ve == p || Ze) if (ke == l.SEMICOLON && ve == h && we[0] == l.AT) L = we.join("").trim(), X.push([d.AT_RULE, L, [I(We, L, $)]]), we = [];
            else if (ke == l.COMMA && ve == h && ne) L = we.join("").trim(), ne[1].push([U(ne[0]), L, [I(We, L, $, ne[1].length)]]), we = [];
            else if (ke == l.COMMA && ve == h && B(we) == d.AT_RULE) we.push(ke);
            else if (ke == l.COMMA && ve == h) ne = [B(we), [], []], L = we.join("").trim(), ne[1].push([U(ne[0]), L, [I(We, L, $, 0)]]), we = [];
            else if (ke == l.OPEN_CURLY_BRACKET && ve == h && ne && ne[0] == d.NESTED_BLOCK) L = we.join("").trim(), ne[1].push([d.NESTED_BLOCK_SCOPE, L, [I(We, L, $)]]), X.push(ne), Ee.push(ve), Qe.column++, Qe.index++, we = [], ne[2] = ie(ce, $, te, !0), ne = null;
            else if (ke == l.OPEN_CURLY_BRACKET && ve == h && B(we) == d.NESTED_BLOCK) L = we.join("").trim(), (ne = ne || [d.NESTED_BLOCK, [], []])[1].push([d.NESTED_BLOCK_SCOPE, L, [I(We, L, $)]]), X.push(ne), Ee.push(ve), Qe.column++, Qe.index++, we = [], ne[2] = ie(ce, $, te, !0), ne = null;
            else if (ke == l.OPEN_CURLY_BRACKET && ve == h) L = we.join("").trim(), (ne = ne || [B(we), [], []])[1].push([U(ne[0]), L, [I(We, L, $, ne[1].length)]]), oe = ne[2], X.push(ne), Ee.push(ve), ve = _, we = [];
            else if (ke == l.OPEN_CURLY_BRACKET && ve == _ && Ze) ae.push(ne), ne = [d.PROPERTY_BLOCK, []], J.push(ne), oe = ne[1], Ee.push(ve), ve = _, Ze = !1;
            else if (ke == l.OPEN_CURLY_BRACKET && ve == _ && function(At) {
              return At = At.join("").trim(), -1 < T.indexOf(At) || -1 < A.indexOf(At);
            }(we)) L = we.join("").trim(), ae.push(ne), (ne = [d.AT_RULE_BLOCK, [], []])[1].push([d.AT_RULE_BLOCK_SCOPE, L, [I(We, L, $)]]), oe.push(ne), oe = ne[2], Ee.push(ve), ve = _, we = [];
            else if (ke != l.COLON || ve != _ || Ze) {
              if (ke == l.SEMICOLON && ve == _ && J && 0 < ae.length && 0 < we.length && we[0] == l.AT) L = we.join("").trim(), ne[1].push([d.AT_RULE, L, [I(We, L, $)]]), we = [];
              else if (ke == l.SEMICOLON && ve == _ && J && 0 < we.length) L = we.join("").trim(), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), J = null, Ze = !1, we = [];
              else if (ke == l.SEMICOLON && ve == _ && J && we.length === 0) J = null, Ze = !1;
              else if (ke == l.SEMICOLON && ve == _ && 0 < we.length && we[0] == l.AT) L = we.join(""), oe.push([d.AT_RULE, L, [I(We, L, $)]]), Ze = !1, we = [];
              else if (ke == l.SEMICOLON && ve == _ && tt) tt = !1, we = [];
              else if (ke != l.SEMICOLON || ve != _ || we.length !== 0) if (ke == l.CLOSE_CURLY_BRACKET && ve == _ && J && Ze && 0 < we.length && 0 < ae.length) L = we.join(""), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), J = null, oe = (ne = ae.pop())[2], ve = Ee.pop(), Ze = !1, we = [];
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == _ && J && 0 < we.length && we[0] == l.AT && 0 < ae.length) L = we.join(""), ne[1].push([d.AT_RULE, L, [I(We, L, $)]]), J = null, oe = (ne = ae.pop())[2], ve = Ee.pop(), Ze = !1, we = [];
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == _ && J && 0 < ae.length) J = null, oe = (ne = ae.pop())[2], ve = Ee.pop(), Ze = !1;
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == _ && J && 0 < we.length) L = we.join(""), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), J = null, ne = ae.pop(), oe = X, ve = Ee.pop(), Ze = !1, we = [];
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == _ && 0 < we.length && we[0] == l.AT) ne = J = null, L = we.join("").trim(), oe.push([d.AT_RULE, L, [I(We, L, $)]]), oe = X, ve = Ee.pop(), Ze = !1, we = [];
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == _ && Ee[Ee.length - 1] == _) J = null, oe = (ne = ae.pop())[2], ve = Ee.pop(), tt = !(Ze = !1), we = [];
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == _) ne = J = null, oe = X, ve = Ee.pop(), Ze = !1;
              else if (ke == l.CLOSE_CURLY_BRACKET && ve == h && !V && Qe.index <= ce.length - 1) $.warnings.push("Unexpected '}' at " + f([Qe.line, Qe.column, Qe.source]) + "."), we.push(ke);
              else {
                if (ke == l.CLOSE_CURLY_BRACKET && ve == h) break;
                ke == l.OPEN_ROUND_BRACKET && ve == _ && Ze ? (we.push(ke), Ie++) : ke == l.CLOSE_ROUND_BRACKET && ve == _ && Ze && Ie == 1 ? (we.push(ke), L = we.join("").trim(), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), Ie--, we = []) : ke == l.CLOSE_ROUND_BRACKET && ve == _ && Ze ? (we.push(ke), Ie--) : ke == l.FORWARD_SLASH && ce[Qe.index + 1] != l.ASTERISK && ve == _ && Ze && 0 < we.length ? (L = we.join("").trim(), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), J.push([d.PROPERTY_VALUE, ke, [[Qe.line, Qe.column, Qe.source]]]), we = []) : ke == l.FORWARD_SLASH && ce[Qe.index + 1] != l.ASTERISK && ve == _ && Ze ? (J.push([d.PROPERTY_VALUE, ke, [[Qe.line, Qe.column, Qe.source]]]), we = []) : ke == l.COMMA && ve == _ && Ze && 0 < we.length ? (L = we.join("").trim(), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), J.push([d.PROPERTY_VALUE, ke, [[Qe.line, Qe.column, Qe.source]]]), we = []) : ke == l.COMMA && ve == _ && Ze ? (J.push([d.PROPERTY_VALUE, ke, [[Qe.line, Qe.column, Qe.source]]]), we = []) : ke == l.CLOSE_SQUARE_BRACKET && J && 1 < J.length && 0 < we.length && function(At) {
                  return k.test(At.join("") + l.CLOSE_SQUARE_BRACKET);
                }(we) ? (we.push(ke), L = we.join("").trim(), J[J.length - 1][1] += L, we = []) : (Se || he && !Te) && ve == _ && Ze && J && 0 < we.length || Te && ve == _ && Ze && J && 1 < we.length ? (L = we.join("").trim(), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), we = []) : Te && ve == _ && Ze ? we = [] : we.length == 1 && Te ? we.pop() : !(0 < we.length) && (Se || he || Te || Me) || we.push(ke);
              }
            } else L = we.join("").trim(), J = [d.PROPERTY, [d.PROPERTY_NAME, L, [I(We, L, $)]]], oe.push(J), Ze = !0, we = [];
            else we.push(ke), Ie--;
            else we.push(ke), Ie++;
            else Ee.push(ve), ve = g, we.push(ke);
            else Ee.push(ve), ve = b, we.push(ke);
            else we.push(ke);
            else we.push(ke);
            ee = !ee && ke == l.BACK_SLASH, je = Ye, qe = dt, Qe.line = Te || he || Me ? Qe.line + 1 : Qe.line, Qe.column = Te || he || Me ? 0 : Qe.column + 1;
          }
          return Ze && $.warnings.push("Missing '}' at " + f([Qe.line, Qe.column, Qe.source]) + "."), Ze && 0 < we.length && (L = we.join("").replace(j, ""), J.push([d.PROPERTY_VALUE, L, [I(We, L, $)]]), we = []), 0 < we.length && $.warnings.push("Invalid character(s) '" + we.join("") + "' at " + f(We) + ". Ignoring."), X;
        }(Q, Y, { level: h, position: { source: Y.source || void 0, line: 1, column: 0, index: 0 } }, !1);
      };
    }, function(a, s, r) {
      var l = r(128).all;
      function d(p, g) {
        g = typeof g == "string" ? g : g[1], (0, p.wrap)(p, g), h(p, g), p.output.push(g);
      }
      function f(p, g) {
        p.column + g.length > p.format.wrapAt && (h(p, p.format.breakWith), p.output.push(p.format.breakWith));
      }
      function h(p, g) {
        g = g.split(`
`), p.line += g.length - 1, p.column = 1 < g.length ? 0 : p.column + g.pop().length;
      }
      a.exports = function(g, _) {
        return _ = { column: 0, format: _.options.format, indentBy: 0, indentWith: "", line: 1, output: [], spaceAfterClosingBrace: _.options.compatibility.properties.spaceAfterClosingBrace, store: d, wrap: _.options.format.wrapAt ? f : function() {
        } }, l(_, g), { styles: _.output.join("") };
      };
    }, function(a, s, r) {
      (function(l) {
        var d = r(206).SourceMapGenerator, f = r(128).all, h = r(66), p = l.platform == "win32", g = /\//g, _ = "$stdin", b = "\\";
        function v(y, N) {
          var A = typeof N == "string", k = A ? N : N[1], N = A ? null : N[2];
          (0, y.wrap)(y, k), C(y, k, N), y.output.push(k);
        }
        function E(y, T) {
          y.column + T.length > y.format.wrapAt && (C(y, y.format.breakWith, !1), y.output.push(y.format.breakWith));
        }
        function C(y, T, A) {
          T = T.split(`
`), A && function(N, j) {
            for (var I = 0, B = j.length; I < B; I++) (function(H, te) {
              var Y = te[0], ie = te[1], ce = te[2], $ = ce, te = $ || _;
              p && $ && !h($) && (te = $.replace(g, b)), H.outputMap.addMapping({ generated: { line: H.line, column: H.column }, source: te, original: { line: Y, column: ie } }), H.inlineSources && ce in H.sourcesContent && H.outputMap.setSourceContent(te, H.sourcesContent[ce]);
            })(N, j[I]);
          }(y, A), y.line += T.length - 1, y.column = 1 < T.length ? 0 : y.column + T.pop().length;
        }
        a.exports = function(T, A) {
          return A = { column: 0, format: A.options.format, indentBy: 0, indentWith: "", inlineSources: A.options.sourceMapInlineSources, line: 1, output: [], outputMap: new d(), sourcesContent: A.sourcesContent, spaceAfterClosingBrace: A.options.compatibility.properties.spaceAfterClosingBrace, store: v, wrap: A.options.format.wrapAt ? E : function() {
          } }, f(A, T), { sourceMap: A.outputMap, styles: A.output.join("") };
        };
      }).call(this, r(15));
    }, function(a, s, r) {
      (function(l, d) {
        var f;
        function h(p) {
          return (h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
            return typeof g;
          } : function(g) {
            return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
          })(p);
        }
        (function(p) {
          var g = h(s) == "object" && s, _ = h(l) == "object" && l && l.exports == g && l, b = (d === void 0 ? "undefined" : h(d)) == "object" && d;
          function v(ee, q) {
            return ne.call(ee, q);
          }
          function E(ee, q) {
            if (!ee) return q;
            var X, oe = {};
            for (X in q) oe[X] = (v(ee, X) ? ee : q)[X];
            return oe;
          }
          function C(ee, q) {
            var X = "";
            return 55296 <= ee && ee <= 57343 || 1114111 < ee ? (q && J("character reference outside the permissible Unicode range"), "�") : v(te, ee) ? (q && J("disallowed character reference"), te[ee]) : (q && function(ae, _e) {
              for (var ve = -1, Ee = ae.length; ++ve < Ee; ) if (ae[ve] == _e) return 1;
            }(V, ee) && J("disallowed character reference"), 65535 < ee && (X += K((ee -= 65536) >>> 10 & 1023 | 55296), ee = 56320 | 1023 & ee), X + K(ee));
          }
          function y(ee) {
            return "&#x" + ee.toString(16).toUpperCase() + ";";
          }
          function T(ee) {
            return "&#" + ee + ";";
          }
          function A(ee, q) {
            function X(Ee) {
              return ve(Ee.charCodeAt(0));
            }
            (q = E(q, A.options)).strict && Y.test(ee) && J("forbidden code point");
            var oe = q.encodeEverything, ae = q.useNamedReferences, _e = q.allowUnsafeSymbols, ve = q.decimal ? T : y;
            return oe ? (ee = ee.replace(N, function(Ee) {
              return ae && v(B, Ee) ? "&" + B[Ee] + ";" : X(Ee);
            }), ae && (ee = ee.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;")), ae && (ee = ee.replace(I, function(Ee) {
              return "&" + B[Ee] + ";";
            }))) : ae ? ee = (ee = (ee = _e ? ee : ee.replace(U, function(Ee) {
              return "&" + B[Ee] + ";";
            })).replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;")).replace(I, function(Ee) {
              return "&" + B[Ee] + ";";
            }) : _e || (ee = ee.replace(U, X)), ee.replace(k, function(ze) {
              var we = ze.charCodeAt(0), ze = ze.charCodeAt(1);
              return ve(1024 * (we - 55296) + ze - 56320 + 65536);
            }).replace(j, X);
          }
          b.global !== b && b.window !== b || (p = b);
          var k = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, N = /[\x01-\x7F]/g, j = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g, I = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g, B = { "­": "shy", "‌": "zwnj", "‍": "zwj", "‎": "lrm", "⁣": "ic", "⁢": "it", "⁡": "af", "‏": "rlm", "​": "ZeroWidthSpace", "⁠": "NoBreak", "̑": "DownBreve", "⃛": "tdot", "⃜": "DotDot", "	": "Tab", "\n": "NewLine", " ": "puncsp", " ": "MediumSpace", " ": "thinsp", " ": "hairsp", " ": "emsp13", " ": "ensp", " ": "emsp14", " ": "emsp", " ": "numsp", " ": "nbsp", "  ": "ThickSpace", "‾": "oline", _: "lowbar", "‐": "dash", "–": "ndash", "—": "mdash", "―": "horbar", ",": "comma", ";": "semi", "⁏": "bsemi", ":": "colon", "⩴": "Colone", "!": "excl", "¡": "iexcl", "?": "quest", "¿": "iquest", ".": "period", "‥": "nldr", "…": "mldr", "·": "middot", "'": "apos", "‘": "lsquo", "’": "rsquo", "‚": "sbquo", "‹": "lsaquo", "›": "rsaquo", '"': "quot", "“": "ldquo", "”": "rdquo", "„": "bdquo", "«": "laquo", "»": "raquo", "(": "lpar", ")": "rpar", "[": "lsqb", "]": "rsqb", "{": "lcub", "}": "rcub", "⌈": "lceil", "⌉": "rceil", "⌊": "lfloor", "⌋": "rfloor", "⦅": "lopar", "⦆": "ropar", "⦋": "lbrke", "⦌": "rbrke", "⦍": "lbrkslu", "⦎": "rbrksld", "⦏": "lbrksld", "⦐": "rbrkslu", "⦑": "langd", "⦒": "rangd", "⦓": "lparlt", "⦔": "rpargt", "⦕": "gtlPar", "⦖": "ltrPar", "⟦": "lobrk", "⟧": "robrk", "⟨": "lang", "⟩": "rang", "⟪": "Lang", "⟫": "Rang", "⟬": "loang", "⟭": "roang", "❲": "lbbrk", "❳": "rbbrk", "‖": "Vert", "§": "sect", "¶": "para", "@": "commat", "*": "ast", "/": "sol", undefined: null, "&": "amp", "#": "num", "%": "percnt", "‰": "permil", "‱": "pertenk", "†": "dagger", "‡": "Dagger", "•": "bull", "⁃": "hybull", "′": "prime", "″": "Prime", "‴": "tprime", "⁗": "qprime", "‵": "bprime", "⁁": "caret", "`": "grave", "´": "acute", "˜": "tilde", "^": "Hat", "¯": "macr", "˘": "breve", "˙": "dot", "¨": "die", "˚": "ring", "˝": "dblac", "¸": "cedil", "˛": "ogon", "ˆ": "circ", "ˇ": "caron", "°": "deg", "©": "copy", "®": "reg", "℗": "copysr", "℘": "wp", "℞": "rx", "℧": "mho", "℩": "iiota", "←": "larr", "↚": "nlarr", "→": "rarr", "↛": "nrarr", "↑": "uarr", "↓": "darr", "↔": "harr", "↮": "nharr", "↕": "varr", "↖": "nwarr", "↗": "nearr", "↘": "searr", "↙": "swarr", "↝": "rarrw", "↝̸": "nrarrw", "↞": "Larr", "↟": "Uarr", "↠": "Rarr", "↡": "Darr", "↢": "larrtl", "↣": "rarrtl", "↤": "mapstoleft", "↥": "mapstoup", "↦": "map", "↧": "mapstodown", "↩": "larrhk", "↪": "rarrhk", "↫": "larrlp", "↬": "rarrlp", "↭": "harrw", "↰": "lsh", "↱": "rsh", "↲": "ldsh", "↳": "rdsh", "↵": "crarr", "↶": "cularr", "↷": "curarr", "↺": "olarr", "↻": "orarr", "↼": "lharu", "↽": "lhard", "↾": "uharr", "↿": "uharl", "⇀": "rharu", "⇁": "rhard", "⇂": "dharr", "⇃": "dharl", "⇄": "rlarr", "⇅": "udarr", "⇆": "lrarr", "⇇": "llarr", "⇈": "uuarr", "⇉": "rrarr", "⇊": "ddarr", "⇋": "lrhar", "⇌": "rlhar", "⇐": "lArr", "⇍": "nlArr", "⇑": "uArr", "⇒": "rArr", "⇏": "nrArr", "⇓": "dArr", "⇔": "iff", "⇎": "nhArr", "⇕": "vArr", "⇖": "nwArr", "⇗": "neArr", "⇘": "seArr", "⇙": "swArr", "⇚": "lAarr", "⇛": "rAarr", "⇝": "zigrarr", "⇤": "larrb", "⇥": "rarrb", "⇵": "duarr", "⇽": "loarr", "⇾": "roarr", "⇿": "hoarr", "∀": "forall", "∁": "comp", "∂": "part", "∂̸": "npart", "∃": "exist", "∄": "nexist", "∅": "empty", "∇": "Del", "∈": "in", "∉": "notin", "∋": "ni", "∌": "notni", "϶": "bepsi", "∏": "prod", "∐": "coprod", "∑": "sum", "+": "plus", "±": "pm", "÷": "div", "×": "times", "<": "lt", "≮": "nlt", "<⃒": "nvlt", "=": "equals", "≠": "ne", "=⃥": "bne", "⩵": "Equal", ">": "gt", "≯": "ngt", ">⃒": "nvgt", "¬": "not", "|": "vert", "¦": "brvbar", "−": "minus", "∓": "mp", "∔": "plusdo", "⁄": "frasl", "∖": "setmn", "∗": "lowast", "∘": "compfn", "√": "Sqrt", "∝": "prop", "∞": "infin", "∟": "angrt", "∠": "ang", "∠⃒": "nang", "∡": "angmsd", "∢": "angsph", "∣": "mid", "∤": "nmid", "∥": "par", "∦": "npar", "∧": "and", "∨": "or", "∩": "cap", "∩︀": "caps", "∪": "cup", "∪︀": "cups", "∫": "int", "∬": "Int", "∭": "tint", "⨌": "qint", "∮": "oint", "∯": "Conint", "∰": "Cconint", "∱": "cwint", "∲": "cwconint", "∳": "awconint", "∴": "there4", "∵": "becaus", "∶": "ratio", "∷": "Colon", "∸": "minusd", "∺": "mDDot", "∻": "homtht", "∼": "sim", "≁": "nsim", "∼⃒": "nvsim", "∽": "bsim", "∽̱": "race", "∾": "ac", "∾̳": "acE", "∿": "acd", "≀": "wr", "≂": "esim", "≂̸": "nesim", "≃": "sime", "≄": "nsime", "≅": "cong", "≇": "ncong", "≆": "simne", "≈": "ap", "≉": "nap", "≊": "ape", "≋": "apid", "≋̸": "napid", "≌": "bcong", "≍": "CupCap", "≭": "NotCupCap", "≍⃒": "nvap", "≎": "bump", "≎̸": "nbump", "≏": "bumpe", "≏̸": "nbumpe", "≐": "doteq", "≐̸": "nedot", "≑": "eDot", "≒": "efDot", "≓": "erDot", "≔": "colone", "≕": "ecolon", "≖": "ecir", "≗": "cire", "≙": "wedgeq", "≚": "veeeq", "≜": "trie", "≟": "equest", "≡": "equiv", "≢": "nequiv", "≡⃥": "bnequiv", "≤": "le", "≰": "nle", "≤⃒": "nvle", "≥": "ge", "≱": "nge", "≥⃒": "nvge", "≦": "lE", "≦̸": "nlE", "≧": "gE", "≧̸": "ngE", "≨︀": "lvnE", "≨": "lnE", "≩": "gnE", "≩︀": "gvnE", "≪": "ll", "≪̸": "nLtv", "≪⃒": "nLt", "≫": "gg", "≫̸": "nGtv", "≫⃒": "nGt", "≬": "twixt", "≲": "lsim", "≴": "nlsim", "≳": "gsim", "≵": "ngsim", "≶": "lg", "≸": "ntlg", "≷": "gl", "≹": "ntgl", "≺": "pr", "⊀": "npr", "≻": "sc", "⊁": "nsc", "≼": "prcue", "⋠": "nprcue", "≽": "sccue", "⋡": "nsccue", "≾": "prsim", "≿": "scsim", "≿̸": "NotSucceedsTilde", "⊂": "sub", "⊄": "nsub", "⊂⃒": "vnsub", "⊃": "sup", "⊅": "nsup", "⊃⃒": "vnsup", "⊆": "sube", "⊈": "nsube", "⊇": "supe", "⊉": "nsupe", "⊊︀": "vsubne", "⊊": "subne", "⊋︀": "vsupne", "⊋": "supne", "⊍": "cupdot", "⊎": "uplus", "⊏": "sqsub", "⊏̸": "NotSquareSubset", "⊐": "sqsup", "⊐̸": "NotSquareSuperset", "⊑": "sqsube", "⋢": "nsqsube", "⊒": "sqsupe", "⋣": "nsqsupe", "⊓": "sqcap", "⊓︀": "sqcaps", "⊔": "sqcup", "⊔︀": "sqcups", "⊕": "oplus", "⊖": "ominus", "⊗": "otimes", "⊘": "osol", "⊙": "odot", "⊚": "ocir", "⊛": "oast", "⊝": "odash", "⊞": "plusb", "⊟": "minusb", "⊠": "timesb", "⊡": "sdotb", "⊢": "vdash", "⊬": "nvdash", "⊣": "dashv", "⊤": "top", "⊥": "bot", "⊧": "models", "⊨": "vDash", "⊭": "nvDash", "⊩": "Vdash", "⊮": "nVdash", "⊪": "Vvdash", "⊫": "VDash", "⊯": "nVDash", "⊰": "prurel", "⊲": "vltri", "⋪": "nltri", "⊳": "vrtri", "⋫": "nrtri", "⊴": "ltrie", "⋬": "nltrie", "⊴⃒": "nvltrie", "⊵": "rtrie", "⋭": "nrtrie", "⊵⃒": "nvrtrie", "⊶": "origof", "⊷": "imof", "⊸": "mumap", "⊹": "hercon", "⊺": "intcal", "⊻": "veebar", "⊽": "barvee", "⊾": "angrtvb", "⊿": "lrtri", "⋀": "Wedge", "⋁": "Vee", "⋂": "xcap", "⋃": "xcup", "⋄": "diam", "⋅": "sdot", "⋆": "Star", "⋇": "divonx", "⋈": "bowtie", "⋉": "ltimes", "⋊": "rtimes", "⋋": "lthree", "⋌": "rthree", "⋍": "bsime", "⋎": "cuvee", "⋏": "cuwed", "⋐": "Sub", "⋑": "Sup", "⋒": "Cap", "⋓": "Cup", "⋔": "fork", "⋕": "epar", "⋖": "ltdot", "⋗": "gtdot", "⋘": "Ll", "⋘̸": "nLl", "⋙": "Gg", "⋙̸": "nGg", "⋚︀": "lesg", "⋚": "leg", "⋛": "gel", "⋛︀": "gesl", "⋞": "cuepr", "⋟": "cuesc", "⋦": "lnsim", "⋧": "gnsim", "⋨": "prnsim", "⋩": "scnsim", "⋮": "vellip", "⋯": "ctdot", "⋰": "utdot", "⋱": "dtdot", "⋲": "disin", "⋳": "isinsv", "⋴": "isins", "⋵": "isindot", "⋵̸": "notindot", "⋶": "notinvc", "⋷": "notinvb", "⋹": "isinE", "⋹̸": "notinE", "⋺": "nisd", "⋻": "xnis", "⋼": "nis", "⋽": "notnivc", "⋾": "notnivb", "⌅": "barwed", "⌆": "Barwed", "⌌": "drcrop", "⌍": "dlcrop", "⌎": "urcrop", "⌏": "ulcrop", "⌐": "bnot", "⌒": "profline", "⌓": "profsurf", "⌕": "telrec", "⌖": "target", "⌜": "ulcorn", "⌝": "urcorn", "⌞": "dlcorn", "⌟": "drcorn", "⌢": "frown", "⌣": "smile", "⌭": "cylcty", "⌮": "profalar", "⌶": "topbot", "⌽": "ovbar", "⌿": "solbar", "⍼": "angzarr", "⎰": "lmoust", "⎱": "rmoust", "⎴": "tbrk", "⎵": "bbrk", "⎶": "bbrktbrk", "⏜": "OverParenthesis", "⏝": "UnderParenthesis", "⏞": "OverBrace", "⏟": "UnderBrace", "⏢": "trpezium", "⏧": "elinters", "␣": "blank", "─": "boxh", "│": "boxv", "┌": "boxdr", "┐": "boxdl", "└": "boxur", "┘": "boxul", "├": "boxvr", "┤": "boxvl", "┬": "boxhd", "┴": "boxhu", "┼": "boxvh", "═": "boxH", "║": "boxV", "╒": "boxdR", "╓": "boxDr", "╔": "boxDR", "╕": "boxdL", "╖": "boxDl", "╗": "boxDL", "╘": "boxuR", "╙": "boxUr", "╚": "boxUR", "╛": "boxuL", "╜": "boxUl", "╝": "boxUL", "╞": "boxvR", "╟": "boxVr", "╠": "boxVR", "╡": "boxvL", "╢": "boxVl", "╣": "boxVL", "╤": "boxHd", "╥": "boxhD", "╦": "boxHD", "╧": "boxHu", "╨": "boxhU", "╩": "boxHU", "╪": "boxvH", "╫": "boxVh", "╬": "boxVH", "▀": "uhblk", "▄": "lhblk", "█": "block", "░": "blk14", "▒": "blk12", "▓": "blk34", "□": "squ", "▪": "squf", "▫": "EmptyVerySmallSquare", "▭": "rect", "▮": "marker", "▱": "fltns", "△": "xutri", "▴": "utrif", "▵": "utri", "▸": "rtrif", "▹": "rtri", "▽": "xdtri", "▾": "dtrif", "▿": "dtri", "◂": "ltrif", "◃": "ltri", "◊": "loz", "○": "cir", "◬": "tridot", "◯": "xcirc", "◸": "ultri", "◹": "urtri", "◺": "lltri", "◻": "EmptySmallSquare", "◼": "FilledSmallSquare", "★": "starf", "☆": "star", "☎": "phone", "♀": "female", "♂": "male", "♠": "spades", "♣": "clubs", "♥": "hearts", "♦": "diams", "♪": "sung", "✓": "check", "✗": "cross", "✠": "malt", "✶": "sext", "❘": "VerticalSeparator", "⟈": "bsolhsub", "⟉": "suphsol", "⟵": "xlarr", "⟶": "xrarr", "⟷": "xharr", "⟸": "xlArr", "⟹": "xrArr", "⟺": "xhArr", "⟼": "xmap", "⟿": "dzigrarr", "⤂": "nvlArr", "⤃": "nvrArr", "⤄": "nvHarr", "⤅": "Map", "⤌": "lbarr", "⤍": "rbarr", "⤎": "lBarr", "⤏": "rBarr", "⤐": "RBarr", "⤑": "DDotrahd", "⤒": "UpArrowBar", "⤓": "DownArrowBar", "⤖": "Rarrtl", "⤙": "latail", "⤚": "ratail", "⤛": "lAtail", "⤜": "rAtail", "⤝": "larrfs", "⤞": "rarrfs", "⤟": "larrbfs", "⤠": "rarrbfs", "⤣": "nwarhk", "⤤": "nearhk", "⤥": "searhk", "⤦": "swarhk", "⤧": "nwnear", "⤨": "toea", "⤩": "tosa", "⤪": "swnwar", "⤳": "rarrc", "⤳̸": "nrarrc", "⤵": "cudarrr", "⤶": "ldca", "⤷": "rdca", "⤸": "cudarrl", "⤹": "larrpl", "⤼": "curarrm", "⤽": "cularrp", "⥅": "rarrpl", "⥈": "harrcir", "⥉": "Uarrocir", "⥊": "lurdshar", "⥋": "ldrushar", "⥎": "LeftRightVector", "⥏": "RightUpDownVector", "⥐": "DownLeftRightVector", "⥑": "LeftUpDownVector", "⥒": "LeftVectorBar", "⥓": "RightVectorBar", "⥔": "RightUpVectorBar", "⥕": "RightDownVectorBar", "⥖": "DownLeftVectorBar", "⥗": "DownRightVectorBar", "⥘": "LeftUpVectorBar", "⥙": "LeftDownVectorBar", "⥚": "LeftTeeVector", "⥛": "RightTeeVector", "⥜": "RightUpTeeVector", "⥝": "RightDownTeeVector", "⥞": "DownLeftTeeVector", "⥟": "DownRightTeeVector", "⥠": "LeftUpTeeVector", "⥡": "LeftDownTeeVector", "⥢": "lHar", "⥣": "uHar", "⥤": "rHar", "⥥": "dHar", "⥦": "luruhar", "⥧": "ldrdhar", "⥨": "ruluhar", "⥩": "rdldhar", "⥪": "lharul", "⥫": "llhard", "⥬": "rharul", "⥭": "lrhard", "⥮": "udhar", "⥯": "duhar", "⥰": "RoundImplies", "⥱": "erarr", "⥲": "simrarr", "⥳": "larrsim", "⥴": "rarrsim", "⥵": "rarrap", "⥶": "ltlarr", "⥸": "gtrarr", "⥹": "subrarr", "⥻": "suplarr", "⥼": "lfisht", "⥽": "rfisht", "⥾": "ufisht", "⥿": "dfisht", "⦚": "vzigzag", "⦜": "vangrt", "⦝": "angrtvbd", "⦤": "ange", "⦥": "range", "⦦": "dwangle", "⦧": "uwangle", "⦨": "angmsdaa", "⦩": "angmsdab", "⦪": "angmsdac", "⦫": "angmsdad", "⦬": "angmsdae", "⦭": "angmsdaf", "⦮": "angmsdag", "⦯": "angmsdah", "⦰": "bemptyv", "⦱": "demptyv", "⦲": "cemptyv", "⦳": "raemptyv", "⦴": "laemptyv", "⦵": "ohbar", "⦶": "omid", "⦷": "opar", "⦹": "operp", "⦻": "olcross", "⦼": "odsold", "⦾": "olcir", "⦿": "ofcir", "⧀": "olt", "⧁": "ogt", "⧂": "cirscir", "⧃": "cirE", "⧄": "solb", "⧅": "bsolb", "⧉": "boxbox", "⧍": "trisb", "⧎": "rtriltri", "⧏": "LeftTriangleBar", "⧏̸": "NotLeftTriangleBar", "⧐": "RightTriangleBar", "⧐̸": "NotRightTriangleBar", "⧜": "iinfin", "⧝": "infintie", "⧞": "nvinfin", "⧣": "eparsl", "⧤": "smeparsl", "⧥": "eqvparsl", "⧫": "lozf", "⧴": "RuleDelayed", "⧶": "dsol", "⨀": "xodot", "⨁": "xoplus", "⨂": "xotime", "⨄": "xuplus", "⨆": "xsqcup", "⨍": "fpartint", "⨐": "cirfnint", "⨑": "awint", "⨒": "rppolint", "⨓": "scpolint", "⨔": "npolint", "⨕": "pointint", "⨖": "quatint", "⨗": "intlarhk", "⨢": "pluscir", "⨣": "plusacir", "⨤": "simplus", "⨥": "plusdu", "⨦": "plussim", "⨧": "plustwo", "⨩": "mcomma", "⨪": "minusdu", "⨭": "loplus", "⨮": "roplus", "⨯": "Cross", "⨰": "timesd", "⨱": "timesbar", "⨳": "smashp", "⨴": "lotimes", "⨵": "rotimes", "⨶": "otimesas", "⨷": "Otimes", "⨸": "odiv", "⨹": "triplus", "⨺": "triminus", "⨻": "tritime", "⨼": "iprod", "⨿": "amalg", "⩀": "capdot", "⩂": "ncup", "⩃": "ncap", "⩄": "capand", "⩅": "cupor", "⩆": "cupcap", "⩇": "capcup", "⩈": "cupbrcap", "⩉": "capbrcup", "⩊": "cupcup", "⩋": "capcap", "⩌": "ccups", "⩍": "ccaps", "⩐": "ccupssm", "⩓": "And", "⩔": "Or", "⩕": "andand", "⩖": "oror", "⩗": "orslope", "⩘": "andslope", "⩚": "andv", "⩛": "orv", "⩜": "andd", "⩝": "ord", "⩟": "wedbar", "⩦": "sdote", "⩪": "simdot", "⩭": "congdot", "⩭̸": "ncongdot", "⩮": "easter", "⩯": "apacir", "⩰": "apE", "⩰̸": "napE", "⩱": "eplus", "⩲": "pluse", "⩳": "Esim", "⩷": "eDDot", "⩸": "equivDD", "⩹": "ltcir", "⩺": "gtcir", "⩻": "ltquest", "⩼": "gtquest", "⩽": "les", "⩽̸": "nles", "⩾": "ges", "⩾̸": "nges", "⩿": "lesdot", "⪀": "gesdot", "⪁": "lesdoto", "⪂": "gesdoto", "⪃": "lesdotor", "⪄": "gesdotol", "⪅": "lap", "⪆": "gap", "⪇": "lne", "⪈": "gne", "⪉": "lnap", "⪊": "gnap", "⪋": "lEg", "⪌": "gEl", "⪍": "lsime", "⪎": "gsime", "⪏": "lsimg", "⪐": "gsiml", "⪑": "lgE", "⪒": "glE", "⪓": "lesges", "⪔": "gesles", "⪕": "els", "⪖": "egs", "⪗": "elsdot", "⪘": "egsdot", "⪙": "el", "⪚": "eg", "⪝": "siml", "⪞": "simg", "⪟": "simlE", "⪠": "simgE", "⪡": "LessLess", "⪡̸": "NotNestedLessLess", "⪢": "GreaterGreater", "⪢̸": "NotNestedGreaterGreater", "⪤": "glj", "⪥": "gla", "⪦": "ltcc", "⪧": "gtcc", "⪨": "lescc", "⪩": "gescc", "⪪": "smt", "⪫": "lat", "⪬": "smte", "⪬︀": "smtes", "⪭": "late", "⪭︀": "lates", "⪮": "bumpE", "⪯": "pre", "⪯̸": "npre", "⪰": "sce", "⪰̸": "nsce", "⪳": "prE", "⪴": "scE", "⪵": "prnE", "⪶": "scnE", "⪷": "prap", "⪸": "scap", "⪹": "prnap", "⪺": "scnap", "⪻": "Pr", "⪼": "Sc", "⪽": "subdot", "⪾": "supdot", "⪿": "subplus", "⫀": "supplus", "⫁": "submult", "⫂": "supmult", "⫃": "subedot", "⫄": "supedot", "⫅": "subE", "⫅̸": "nsubE", "⫆": "supE", "⫆̸": "nsupE", "⫇": "subsim", "⫈": "supsim", "⫋︀": "vsubnE", "⫋": "subnE", "⫌︀": "vsupnE", "⫌": "supnE", "⫏": "csub", "⫐": "csup", "⫑": "csube", "⫒": "csupe", "⫓": "subsup", "⫔": "supsub", "⫕": "subsub", "⫖": "supsup", "⫗": "suphsub", "⫘": "supdsub", "⫙": "forkv", "⫚": "topfork", "⫛": "mlcp", "⫤": "Dashv", "⫦": "Vdashl", "⫧": "Barv", "⫨": "vBar", "⫩": "vBarv", "⫫": "Vbar", "⫬": "Not", "⫭": "bNot", "⫮": "rnmid", "⫯": "cirmid", "⫰": "midcir", "⫱": "topcir", "⫲": "nhpar", "⫳": "parsim", "⫽": "parsl", "⫽⃥": "nparsl", "♭": "flat", "♮": "natur", "♯": "sharp", "¤": "curren", "¢": "cent", $: "dollar", "£": "pound", "¥": "yen", "€": "euro", "¹": "sup1", "½": "half", "⅓": "frac13", "¼": "frac14", "⅕": "frac15", "⅙": "frac16", "⅛": "frac18", "²": "sup2", "⅔": "frac23", "⅖": "frac25", "³": "sup3", "¾": "frac34", "⅗": "frac35", "⅜": "frac38", "⅘": "frac45", "⅚": "frac56", "⅝": "frac58", "⅞": "frac78", "𝒶": "ascr", "𝕒": "aopf", "𝔞": "afr", "𝔸": "Aopf", "𝔄": "Afr", "𝒜": "Ascr", ª: "ordf", á: "aacute", Á: "Aacute", à: "agrave", À: "Agrave", ă: "abreve", Ă: "Abreve", â: "acirc", Â: "Acirc", å: "aring", Å: "angst", ä: "auml", Ä: "Auml", ã: "atilde", Ã: "Atilde", ą: "aogon", Ą: "Aogon", ā: "amacr", Ā: "Amacr", æ: "aelig", Æ: "AElig", "𝒷": "bscr", "𝕓": "bopf", "𝔟": "bfr", "𝔹": "Bopf", ℬ: "Bscr", "𝔅": "Bfr", "𝔠": "cfr", "𝒸": "cscr", "𝕔": "copf", ℭ: "Cfr", "𝒞": "Cscr", ℂ: "Copf", ć: "cacute", Ć: "Cacute", ĉ: "ccirc", Ĉ: "Ccirc", č: "ccaron", Č: "Ccaron", ċ: "cdot", Ċ: "Cdot", ç: "ccedil", Ç: "Ccedil", "℅": "incare", "𝔡": "dfr", "ⅆ": "dd", "𝕕": "dopf", "𝒹": "dscr", "𝒟": "Dscr", "𝔇": "Dfr", "ⅅ": "DD", "𝔻": "Dopf", ď: "dcaron", Ď: "Dcaron", đ: "dstrok", Đ: "Dstrok", ð: "eth", Ð: "ETH", "ⅇ": "ee", ℯ: "escr", "𝔢": "efr", "𝕖": "eopf", ℰ: "Escr", "𝔈": "Efr", "𝔼": "Eopf", é: "eacute", É: "Eacute", è: "egrave", È: "Egrave", ê: "ecirc", Ê: "Ecirc", ě: "ecaron", Ě: "Ecaron", ë: "euml", Ë: "Euml", ė: "edot", Ė: "Edot", ę: "eogon", Ę: "Eogon", ē: "emacr", Ē: "Emacr", "𝔣": "ffr", "𝕗": "fopf", "𝒻": "fscr", "𝔉": "Ffr", "𝔽": "Fopf", ℱ: "Fscr", ﬀ: "fflig", ﬃ: "ffilig", ﬄ: "ffllig", ﬁ: "filig", fj: "fjlig", ﬂ: "fllig", ƒ: "fnof", ℊ: "gscr", "𝕘": "gopf", "𝔤": "gfr", "𝒢": "Gscr", "𝔾": "Gopf", "𝔊": "Gfr", ǵ: "gacute", ğ: "gbreve", Ğ: "Gbreve", ĝ: "gcirc", Ĝ: "Gcirc", ġ: "gdot", Ġ: "Gdot", Ģ: "Gcedil", "𝔥": "hfr", ℎ: "planckh", "𝒽": "hscr", "𝕙": "hopf", ℋ: "Hscr", ℌ: "Hfr", ℍ: "Hopf", ĥ: "hcirc", Ĥ: "Hcirc", ℏ: "hbar", ħ: "hstrok", Ħ: "Hstrok", "𝕚": "iopf", "𝔦": "ifr", "𝒾": "iscr", "ⅈ": "ii", "𝕀": "Iopf", ℐ: "Iscr", ℑ: "Im", í: "iacute", Í: "Iacute", ì: "igrave", Ì: "Igrave", î: "icirc", Î: "Icirc", ï: "iuml", Ï: "Iuml", ĩ: "itilde", Ĩ: "Itilde", İ: "Idot", į: "iogon", Į: "Iogon", ī: "imacr", Ī: "Imacr", ĳ: "ijlig", Ĳ: "IJlig", ı: "imath", "𝒿": "jscr", "𝕛": "jopf", "𝔧": "jfr", "𝒥": "Jscr", "𝔍": "Jfr", "𝕁": "Jopf", ĵ: "jcirc", Ĵ: "Jcirc", "ȷ": "jmath", "𝕜": "kopf", "𝓀": "kscr", "𝔨": "kfr", "𝒦": "Kscr", "𝕂": "Kopf", "𝔎": "Kfr", ķ: "kcedil", Ķ: "Kcedil", "𝔩": "lfr", "𝓁": "lscr", ℓ: "ell", "𝕝": "lopf", ℒ: "Lscr", "𝔏": "Lfr", "𝕃": "Lopf", ĺ: "lacute", Ĺ: "Lacute", ľ: "lcaron", Ľ: "Lcaron", ļ: "lcedil", Ļ: "Lcedil", ł: "lstrok", Ł: "Lstrok", ŀ: "lmidot", Ŀ: "Lmidot", "𝔪": "mfr", "𝕞": "mopf", "𝓂": "mscr", "𝔐": "Mfr", "𝕄": "Mopf", ℳ: "Mscr", "𝔫": "nfr", "𝕟": "nopf", "𝓃": "nscr", ℕ: "Nopf", "𝒩": "Nscr", "𝔑": "Nfr", ń: "nacute", Ń: "Nacute", ň: "ncaron", Ň: "Ncaron", ñ: "ntilde", Ñ: "Ntilde", ņ: "ncedil", Ņ: "Ncedil", "№": "numero", ŋ: "eng", Ŋ: "ENG", "𝕠": "oopf", "𝔬": "ofr", ℴ: "oscr", "𝒪": "Oscr", "𝔒": "Ofr", "𝕆": "Oopf", º: "ordm", ó: "oacute", Ó: "Oacute", ò: "ograve", Ò: "Ograve", ô: "ocirc", Ô: "Ocirc", ö: "ouml", Ö: "Ouml", ő: "odblac", Ő: "Odblac", õ: "otilde", Õ: "Otilde", ø: "oslash", Ø: "Oslash", ō: "omacr", Ō: "Omacr", œ: "oelig", Œ: "OElig", "𝔭": "pfr", "𝓅": "pscr", "𝕡": "popf", ℙ: "Popf", "𝔓": "Pfr", "𝒫": "Pscr", "𝕢": "qopf", "𝔮": "qfr", "𝓆": "qscr", "𝒬": "Qscr", "𝔔": "Qfr", ℚ: "Qopf", ĸ: "kgreen", "𝔯": "rfr", "𝕣": "ropf", "𝓇": "rscr", ℛ: "Rscr", ℜ: "Re", ℝ: "Ropf", ŕ: "racute", Ŕ: "Racute", ř: "rcaron", Ř: "Rcaron", ŗ: "rcedil", Ŗ: "Rcedil", "𝕤": "sopf", "𝓈": "sscr", "𝔰": "sfr", "𝕊": "Sopf", "𝔖": "Sfr", "𝒮": "Sscr", "Ⓢ": "oS", ś: "sacute", Ś: "Sacute", ŝ: "scirc", Ŝ: "Scirc", š: "scaron", Š: "Scaron", ş: "scedil", Ş: "Scedil", ß: "szlig", "𝔱": "tfr", "𝓉": "tscr", "𝕥": "topf", "𝒯": "Tscr", "𝔗": "Tfr", "𝕋": "Topf", ť: "tcaron", Ť: "Tcaron", ţ: "tcedil", Ţ: "Tcedil", "™": "trade", ŧ: "tstrok", Ŧ: "Tstrok", "𝓊": "uscr", "𝕦": "uopf", "𝔲": "ufr", "𝕌": "Uopf", "𝔘": "Ufr", "𝒰": "Uscr", ú: "uacute", Ú: "Uacute", ù: "ugrave", Ù: "Ugrave", ŭ: "ubreve", Ŭ: "Ubreve", û: "ucirc", Û: "Ucirc", ů: "uring", Ů: "Uring", ü: "uuml", Ü: "Uuml", ű: "udblac", Ű: "Udblac", ũ: "utilde", Ũ: "Utilde", ų: "uogon", Ų: "Uogon", ū: "umacr", Ū: "Umacr", "𝔳": "vfr", "𝕧": "vopf", "𝓋": "vscr", "𝔙": "Vfr", "𝕍": "Vopf", "𝒱": "Vscr", "𝕨": "wopf", "𝓌": "wscr", "𝔴": "wfr", "𝒲": "Wscr", "𝕎": "Wopf", "𝔚": "Wfr", ŵ: "wcirc", Ŵ: "Wcirc", "𝔵": "xfr", "𝓍": "xscr", "𝕩": "xopf", "𝕏": "Xopf", "𝔛": "Xfr", "𝒳": "Xscr", "𝔶": "yfr", "𝓎": "yscr", "𝕪": "yopf", "𝒴": "Yscr", "𝔜": "Yfr", "𝕐": "Yopf", ý: "yacute", Ý: "Yacute", ŷ: "ycirc", Ŷ: "Ycirc", ÿ: "yuml", Ÿ: "Yuml", "𝓏": "zscr", "𝔷": "zfr", "𝕫": "zopf", ℨ: "Zfr", ℤ: "Zopf", "𝒵": "Zscr", ź: "zacute", Ź: "Zacute", ž: "zcaron", Ž: "Zcaron", ż: "zdot", Ż: "Zdot", Ƶ: "imped", þ: "thorn", Þ: "THORN", ŉ: "napos", α: "alpha", Α: "Alpha", β: "beta", Β: "Beta", γ: "gamma", Γ: "Gamma", δ: "delta", Δ: "Delta", ε: "epsi", "ϵ": "epsiv", Ε: "Epsilon", ϝ: "gammad", Ϝ: "Gammad", ζ: "zeta", Ζ: "Zeta", η: "eta", Η: "Eta", θ: "theta", ϑ: "thetav", Θ: "Theta", ι: "iota", Ι: "Iota", κ: "kappa", ϰ: "kappav", Κ: "Kappa", λ: "lambda", Λ: "Lambda", μ: "mu", µ: "micro", Μ: "Mu", ν: "nu", Ν: "Nu", ξ: "xi", Ξ: "Xi", ο: "omicron", Ο: "Omicron", π: "pi", ϖ: "piv", Π: "Pi", ρ: "rho", ϱ: "rhov", Ρ: "Rho", σ: "sigma", Σ: "Sigma", ς: "sigmaf", τ: "tau", Τ: "Tau", υ: "upsi", Υ: "Upsilon", ϒ: "Upsi", φ: "phi", ϕ: "phiv", Φ: "Phi", χ: "chi", Χ: "Chi", ψ: "psi", Ψ: "Psi", ω: "omega", Ω: "ohm", а: "acy", А: "Acy", б: "bcy", Б: "Bcy", в: "vcy", В: "Vcy", г: "gcy", Г: "Gcy", ѓ: "gjcy", Ѓ: "GJcy", д: "dcy", Д: "Dcy", ђ: "djcy", Ђ: "DJcy", е: "iecy", Е: "IEcy", ё: "iocy", Ё: "IOcy", є: "jukcy", Є: "Jukcy", ж: "zhcy", Ж: "ZHcy", з: "zcy", З: "Zcy", ѕ: "dscy", Ѕ: "DScy", и: "icy", И: "Icy", і: "iukcy", І: "Iukcy", ї: "yicy", Ї: "YIcy", й: "jcy", Й: "Jcy", ј: "jsercy", Ј: "Jsercy", к: "kcy", К: "Kcy", ќ: "kjcy", Ќ: "KJcy", л: "lcy", Л: "Lcy", љ: "ljcy", Љ: "LJcy", м: "mcy", М: "Mcy", н: "ncy", Н: "Ncy", њ: "njcy", Њ: "NJcy", о: "ocy", О: "Ocy", п: "pcy", П: "Pcy", р: "rcy", Р: "Rcy", с: "scy", С: "Scy", т: "tcy", Т: "Tcy", ћ: "tshcy", Ћ: "TSHcy", у: "ucy", У: "Ucy", ў: "ubrcy", Ў: "Ubrcy", ф: "fcy", Ф: "Fcy", х: "khcy", Х: "KHcy", ц: "tscy", Ц: "TScy", ч: "chcy", Ч: "CHcy", џ: "dzcy", Џ: "DZcy", ш: "shcy", Ш: "SHcy", щ: "shchcy", Щ: "SHCHcy", ъ: "hardcy", Ъ: "HARDcy", ы: "ycy", Ы: "Ycy", ь: "softcy", Ь: "SOFTcy", э: "ecy", Э: "Ecy", ю: "yucy", Ю: "YUcy", я: "yacy", Я: "YAcy", ℵ: "aleph", ℶ: "beth", ℷ: "gimel", ℸ: "daleth" }, U = /["&'<>`]/g, H = { '"': "&quot;", "&": "&amp;", "'": "&#x27;", "<": "&lt;", ">": "&gt;", "`": "&#x60;" }, Q = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/, Y = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, ie = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g, ce = { aacute: "á", Aacute: "Á", abreve: "ă", Abreve: "Ă", ac: "∾", acd: "∿", acE: "∾̳", acirc: "â", Acirc: "Â", acute: "´", acy: "а", Acy: "А", aelig: "æ", AElig: "Æ", af: "⁡", afr: "𝔞", Afr: "𝔄", agrave: "à", Agrave: "À", alefsym: "ℵ", aleph: "ℵ", alpha: "α", Alpha: "Α", amacr: "ā", Amacr: "Ā", amalg: "⨿", amp: "&", AMP: "&", and: "∧", And: "⩓", andand: "⩕", andd: "⩜", andslope: "⩘", andv: "⩚", ang: "∠", ange: "⦤", angle: "∠", angmsd: "∡", angmsdaa: "⦨", angmsdab: "⦩", angmsdac: "⦪", angmsdad: "⦫", angmsdae: "⦬", angmsdaf: "⦭", angmsdag: "⦮", angmsdah: "⦯", angrt: "∟", angrtvb: "⊾", angrtvbd: "⦝", angsph: "∢", angst: "Å", angzarr: "⍼", aogon: "ą", Aogon: "Ą", aopf: "𝕒", Aopf: "𝔸", ap: "≈", apacir: "⩯", ape: "≊", apE: "⩰", apid: "≋", apos: "'", ApplyFunction: "⁡", approx: "≈", approxeq: "≊", aring: "å", Aring: "Å", ascr: "𝒶", Ascr: "𝒜", Assign: "≔", ast: "*", asymp: "≈", asympeq: "≍", atilde: "ã", Atilde: "Ã", auml: "ä", Auml: "Ä", awconint: "∳", awint: "⨑", backcong: "≌", backepsilon: "϶", backprime: "‵", backsim: "∽", backsimeq: "⋍", Backslash: "∖", Barv: "⫧", barvee: "⊽", barwed: "⌅", Barwed: "⌆", barwedge: "⌅", bbrk: "⎵", bbrktbrk: "⎶", bcong: "≌", bcy: "б", Bcy: "Б", bdquo: "„", becaus: "∵", because: "∵", Because: "∵", bemptyv: "⦰", bepsi: "϶", bernou: "ℬ", Bernoullis: "ℬ", beta: "β", Beta: "Β", beth: "ℶ", between: "≬", bfr: "𝔟", Bfr: "𝔅", bigcap: "⋂", bigcirc: "◯", bigcup: "⋃", bigodot: "⨀", bigoplus: "⨁", bigotimes: "⨂", bigsqcup: "⨆", bigstar: "★", bigtriangledown: "▽", bigtriangleup: "△", biguplus: "⨄", bigvee: "⋁", bigwedge: "⋀", bkarow: "⤍", blacklozenge: "⧫", blacksquare: "▪", blacktriangle: "▴", blacktriangledown: "▾", blacktriangleleft: "◂", blacktriangleright: "▸", blank: "␣", blk12: "▒", blk14: "░", blk34: "▓", block: "█", bne: "=⃥", bnequiv: "≡⃥", bnot: "⌐", bNot: "⫭", bopf: "𝕓", Bopf: "𝔹", bot: "⊥", bottom: "⊥", bowtie: "⋈", boxbox: "⧉", boxdl: "┐", boxdL: "╕", boxDl: "╖", boxDL: "╗", boxdr: "┌", boxdR: "╒", boxDr: "╓", boxDR: "╔", boxh: "─", boxH: "═", boxhd: "┬", boxhD: "╥", boxHd: "╤", boxHD: "╦", boxhu: "┴", boxhU: "╨", boxHu: "╧", boxHU: "╩", boxminus: "⊟", boxplus: "⊞", boxtimes: "⊠", boxul: "┘", boxuL: "╛", boxUl: "╜", boxUL: "╝", boxur: "└", boxuR: "╘", boxUr: "╙", boxUR: "╚", boxv: "│", boxV: "║", boxvh: "┼", boxvH: "╪", boxVh: "╫", boxVH: "╬", boxvl: "┤", boxvL: "╡", boxVl: "╢", boxVL: "╣", boxvr: "├", boxvR: "╞", boxVr: "╟", boxVR: "╠", bprime: "‵", breve: "˘", Breve: "˘", brvbar: "¦", bscr: "𝒷", Bscr: "ℬ", bsemi: "⁏", bsim: "∽", bsime: "⋍", bsol: "\\", bsolb: "⧅", bsolhsub: "⟈", bull: "•", bullet: "•", bump: "≎", bumpe: "≏", bumpE: "⪮", bumpeq: "≏", Bumpeq: "≎", cacute: "ć", Cacute: "Ć", cap: "∩", Cap: "⋒", capand: "⩄", capbrcup: "⩉", capcap: "⩋", capcup: "⩇", capdot: "⩀", CapitalDifferentialD: "ⅅ", caps: "∩︀", caret: "⁁", caron: "ˇ", Cayleys: "ℭ", ccaps: "⩍", ccaron: "č", Ccaron: "Č", ccedil: "ç", Ccedil: "Ç", ccirc: "ĉ", Ccirc: "Ĉ", Cconint: "∰", ccups: "⩌", ccupssm: "⩐", cdot: "ċ", Cdot: "Ċ", cedil: "¸", Cedilla: "¸", cemptyv: "⦲", cent: "¢", centerdot: "·", CenterDot: "·", cfr: "𝔠", Cfr: "ℭ", chcy: "ч", CHcy: "Ч", check: "✓", checkmark: "✓", chi: "χ", Chi: "Χ", cir: "○", circ: "ˆ", circeq: "≗", circlearrowleft: "↺", circlearrowright: "↻", circledast: "⊛", circledcirc: "⊚", circleddash: "⊝", CircleDot: "⊙", circledR: "®", circledS: "Ⓢ", CircleMinus: "⊖", CirclePlus: "⊕", CircleTimes: "⊗", cire: "≗", cirE: "⧃", cirfnint: "⨐", cirmid: "⫯", cirscir: "⧂", ClockwiseContourIntegral: "∲", CloseCurlyDoubleQuote: "”", CloseCurlyQuote: "’", clubs: "♣", clubsuit: "♣", colon: ":", Colon: "∷", colone: "≔", Colone: "⩴", coloneq: "≔", comma: ",", commat: "@", comp: "∁", compfn: "∘", complement: "∁", complexes: "ℂ", cong: "≅", congdot: "⩭", Congruent: "≡", conint: "∮", Conint: "∯", ContourIntegral: "∮", copf: "𝕔", Copf: "ℂ", coprod: "∐", Coproduct: "∐", copy: "©", COPY: "©", copysr: "℗", CounterClockwiseContourIntegral: "∳", crarr: "↵", cross: "✗", Cross: "⨯", cscr: "𝒸", Cscr: "𝒞", csub: "⫏", csube: "⫑", csup: "⫐", csupe: "⫒", ctdot: "⋯", cudarrl: "⤸", cudarrr: "⤵", cuepr: "⋞", cuesc: "⋟", cularr: "↶", cularrp: "⤽", cup: "∪", Cup: "⋓", cupbrcap: "⩈", cupcap: "⩆", CupCap: "≍", cupcup: "⩊", cupdot: "⊍", cupor: "⩅", cups: "∪︀", curarr: "↷", curarrm: "⤼", curlyeqprec: "⋞", curlyeqsucc: "⋟", curlyvee: "⋎", curlywedge: "⋏", curren: "¤", curvearrowleft: "↶", curvearrowright: "↷", cuvee: "⋎", cuwed: "⋏", cwconint: "∲", cwint: "∱", cylcty: "⌭", dagger: "†", Dagger: "‡", daleth: "ℸ", darr: "↓", dArr: "⇓", Darr: "↡", dash: "‐", dashv: "⊣", Dashv: "⫤", dbkarow: "⤏", dblac: "˝", dcaron: "ď", Dcaron: "Ď", dcy: "д", Dcy: "Д", dd: "ⅆ", DD: "ⅅ", ddagger: "‡", ddarr: "⇊", DDotrahd: "⤑", ddotseq: "⩷", deg: "°", Del: "∇", delta: "δ", Delta: "Δ", demptyv: "⦱", dfisht: "⥿", dfr: "𝔡", Dfr: "𝔇", dHar: "⥥", dharl: "⇃", dharr: "⇂", DiacriticalAcute: "´", DiacriticalDot: "˙", DiacriticalDoubleAcute: "˝", DiacriticalGrave: "`", DiacriticalTilde: "˜", diam: "⋄", diamond: "⋄", Diamond: "⋄", diamondsuit: "♦", diams: "♦", die: "¨", DifferentialD: "ⅆ", digamma: "ϝ", disin: "⋲", div: "÷", divide: "÷", divideontimes: "⋇", divonx: "⋇", djcy: "ђ", DJcy: "Ђ", dlcorn: "⌞", dlcrop: "⌍", dollar: "$", dopf: "𝕕", Dopf: "𝔻", dot: "˙", Dot: "¨", DotDot: "⃜", doteq: "≐", doteqdot: "≑", DotEqual: "≐", dotminus: "∸", dotplus: "∔", dotsquare: "⊡", doublebarwedge: "⌆", DoubleContourIntegral: "∯", DoubleDot: "¨", DoubleDownArrow: "⇓", DoubleLeftArrow: "⇐", DoubleLeftRightArrow: "⇔", DoubleLeftTee: "⫤", DoubleLongLeftArrow: "⟸", DoubleLongLeftRightArrow: "⟺", DoubleLongRightArrow: "⟹", DoubleRightArrow: "⇒", DoubleRightTee: "⊨", DoubleUpArrow: "⇑", DoubleUpDownArrow: "⇕", DoubleVerticalBar: "∥", downarrow: "↓", Downarrow: "⇓", DownArrow: "↓", DownArrowBar: "⤓", DownArrowUpArrow: "⇵", DownBreve: "̑", downdownarrows: "⇊", downharpoonleft: "⇃", downharpoonright: "⇂", DownLeftRightVector: "⥐", DownLeftTeeVector: "⥞", DownLeftVector: "↽", DownLeftVectorBar: "⥖", DownRightTeeVector: "⥟", DownRightVector: "⇁", DownRightVectorBar: "⥗", DownTee: "⊤", DownTeeArrow: "↧", drbkarow: "⤐", drcorn: "⌟", drcrop: "⌌", dscr: "𝒹", Dscr: "𝒟", dscy: "ѕ", DScy: "Ѕ", dsol: "⧶", dstrok: "đ", Dstrok: "Đ", dtdot: "⋱", dtri: "▿", dtrif: "▾", duarr: "⇵", duhar: "⥯", dwangle: "⦦", dzcy: "џ", DZcy: "Џ", dzigrarr: "⟿", eacute: "é", Eacute: "É", easter: "⩮", ecaron: "ě", Ecaron: "Ě", ecir: "≖", ecirc: "ê", Ecirc: "Ê", ecolon: "≕", ecy: "э", Ecy: "Э", eDDot: "⩷", edot: "ė", eDot: "≑", Edot: "Ė", ee: "ⅇ", efDot: "≒", efr: "𝔢", Efr: "𝔈", eg: "⪚", egrave: "è", Egrave: "È", egs: "⪖", egsdot: "⪘", el: "⪙", Element: "∈", elinters: "⏧", ell: "ℓ", els: "⪕", elsdot: "⪗", emacr: "ē", Emacr: "Ē", empty: "∅", emptyset: "∅", EmptySmallSquare: "◻", emptyv: "∅", EmptyVerySmallSquare: "▫", emsp: " ", emsp13: " ", emsp14: " ", eng: "ŋ", ENG: "Ŋ", ensp: " ", eogon: "ę", Eogon: "Ę", eopf: "𝕖", Eopf: "𝔼", epar: "⋕", eparsl: "⧣", eplus: "⩱", epsi: "ε", epsilon: "ε", Epsilon: "Ε", epsiv: "ϵ", eqcirc: "≖", eqcolon: "≕", eqsim: "≂", eqslantgtr: "⪖", eqslantless: "⪕", Equal: "⩵", equals: "=", EqualTilde: "≂", equest: "≟", Equilibrium: "⇌", equiv: "≡", equivDD: "⩸", eqvparsl: "⧥", erarr: "⥱", erDot: "≓", escr: "ℯ", Escr: "ℰ", esdot: "≐", esim: "≂", Esim: "⩳", eta: "η", Eta: "Η", eth: "ð", ETH: "Ð", euml: "ë", Euml: "Ë", euro: "€", excl: "!", exist: "∃", Exists: "∃", expectation: "ℰ", exponentiale: "ⅇ", ExponentialE: "ⅇ", fallingdotseq: "≒", fcy: "ф", Fcy: "Ф", female: "♀", ffilig: "ﬃ", fflig: "ﬀ", ffllig: "ﬄ", ffr: "𝔣", Ffr: "𝔉", filig: "ﬁ", FilledSmallSquare: "◼", FilledVerySmallSquare: "▪", fjlig: "fj", flat: "♭", fllig: "ﬂ", fltns: "▱", fnof: "ƒ", fopf: "𝕗", Fopf: "𝔽", forall: "∀", ForAll: "∀", fork: "⋔", forkv: "⫙", Fouriertrf: "ℱ", fpartint: "⨍", frac12: "½", frac13: "⅓", frac14: "¼", frac15: "⅕", frac16: "⅙", frac18: "⅛", frac23: "⅔", frac25: "⅖", frac34: "¾", frac35: "⅗", frac38: "⅜", frac45: "⅘", frac56: "⅚", frac58: "⅝", frac78: "⅞", frasl: "⁄", frown: "⌢", fscr: "𝒻", Fscr: "ℱ", gacute: "ǵ", gamma: "γ", Gamma: "Γ", gammad: "ϝ", Gammad: "Ϝ", gap: "⪆", gbreve: "ğ", Gbreve: "Ğ", Gcedil: "Ģ", gcirc: "ĝ", Gcirc: "Ĝ", gcy: "г", Gcy: "Г", gdot: "ġ", Gdot: "Ġ", ge: "≥", gE: "≧", gel: "⋛", gEl: "⪌", geq: "≥", geqq: "≧", geqslant: "⩾", ges: "⩾", gescc: "⪩", gesdot: "⪀", gesdoto: "⪂", gesdotol: "⪄", gesl: "⋛︀", gesles: "⪔", gfr: "𝔤", Gfr: "𝔊", gg: "≫", Gg: "⋙", ggg: "⋙", gimel: "ℷ", gjcy: "ѓ", GJcy: "Ѓ", gl: "≷", gla: "⪥", glE: "⪒", glj: "⪤", gnap: "⪊", gnapprox: "⪊", gne: "⪈", gnE: "≩", gneq: "⪈", gneqq: "≩", gnsim: "⋧", gopf: "𝕘", Gopf: "𝔾", grave: "`", GreaterEqual: "≥", GreaterEqualLess: "⋛", GreaterFullEqual: "≧", GreaterGreater: "⪢", GreaterLess: "≷", GreaterSlantEqual: "⩾", GreaterTilde: "≳", gscr: "ℊ", Gscr: "𝒢", gsim: "≳", gsime: "⪎", gsiml: "⪐", gt: ">", Gt: "≫", GT: ">", gtcc: "⪧", gtcir: "⩺", gtdot: "⋗", gtlPar: "⦕", gtquest: "⩼", gtrapprox: "⪆", gtrarr: "⥸", gtrdot: "⋗", gtreqless: "⋛", gtreqqless: "⪌", gtrless: "≷", gtrsim: "≳", gvertneqq: "≩︀", gvnE: "≩︀", Hacek: "ˇ", hairsp: " ", half: "½", hamilt: "ℋ", hardcy: "ъ", HARDcy: "Ъ", harr: "↔", hArr: "⇔", harrcir: "⥈", harrw: "↭", Hat: "^", hbar: "ℏ", hcirc: "ĥ", Hcirc: "Ĥ", hearts: "♥", heartsuit: "♥", hellip: "…", hercon: "⊹", hfr: "𝔥", Hfr: "ℌ", HilbertSpace: "ℋ", hksearow: "⤥", hkswarow: "⤦", hoarr: "⇿", homtht: "∻", hookleftarrow: "↩", hookrightarrow: "↪", hopf: "𝕙", Hopf: "ℍ", horbar: "―", HorizontalLine: "─", hscr: "𝒽", Hscr: "ℋ", hslash: "ℏ", hstrok: "ħ", Hstrok: "Ħ", HumpDownHump: "≎", HumpEqual: "≏", hybull: "⁃", hyphen: "‐", iacute: "í", Iacute: "Í", ic: "⁣", icirc: "î", Icirc: "Î", icy: "и", Icy: "И", Idot: "İ", iecy: "е", IEcy: "Е", iexcl: "¡", iff: "⇔", ifr: "𝔦", Ifr: "ℑ", igrave: "ì", Igrave: "Ì", ii: "ⅈ", iiiint: "⨌", iiint: "∭", iinfin: "⧜", iiota: "℩", ijlig: "ĳ", IJlig: "Ĳ", Im: "ℑ", imacr: "ī", Imacr: "Ī", image: "ℑ", ImaginaryI: "ⅈ", imagline: "ℐ", imagpart: "ℑ", imath: "ı", imof: "⊷", imped: "Ƶ", Implies: "⇒", in: "∈", incare: "℅", infin: "∞", infintie: "⧝", inodot: "ı", int: "∫", Int: "∬", intcal: "⊺", integers: "ℤ", Integral: "∫", intercal: "⊺", Intersection: "⋂", intlarhk: "⨗", intprod: "⨼", InvisibleComma: "⁣", InvisibleTimes: "⁢", iocy: "ё", IOcy: "Ё", iogon: "į", Iogon: "Į", iopf: "𝕚", Iopf: "𝕀", iota: "ι", Iota: "Ι", iprod: "⨼", iquest: "¿", iscr: "𝒾", Iscr: "ℐ", isin: "∈", isindot: "⋵", isinE: "⋹", isins: "⋴", isinsv: "⋳", isinv: "∈", it: "⁢", itilde: "ĩ", Itilde: "Ĩ", iukcy: "і", Iukcy: "І", iuml: "ï", Iuml: "Ï", jcirc: "ĵ", Jcirc: "Ĵ", jcy: "й", Jcy: "Й", jfr: "𝔧", Jfr: "𝔍", jmath: "ȷ", jopf: "𝕛", Jopf: "𝕁", jscr: "𝒿", Jscr: "𝒥", jsercy: "ј", Jsercy: "Ј", jukcy: "є", Jukcy: "Є", kappa: "κ", Kappa: "Κ", kappav: "ϰ", kcedil: "ķ", Kcedil: "Ķ", kcy: "к", Kcy: "К", kfr: "𝔨", Kfr: "𝔎", kgreen: "ĸ", khcy: "х", KHcy: "Х", kjcy: "ќ", KJcy: "Ќ", kopf: "𝕜", Kopf: "𝕂", kscr: "𝓀", Kscr: "𝒦", lAarr: "⇚", lacute: "ĺ", Lacute: "Ĺ", laemptyv: "⦴", lagran: "ℒ", lambda: "λ", Lambda: "Λ", lang: "⟨", Lang: "⟪", langd: "⦑", langle: "⟨", lap: "⪅", Laplacetrf: "ℒ", laquo: "«", larr: "←", lArr: "⇐", Larr: "↞", larrb: "⇤", larrbfs: "⤟", larrfs: "⤝", larrhk: "↩", larrlp: "↫", larrpl: "⤹", larrsim: "⥳", larrtl: "↢", lat: "⪫", latail: "⤙", lAtail: "⤛", late: "⪭", lates: "⪭︀", lbarr: "⤌", lBarr: "⤎", lbbrk: "❲", lbrace: "{", lbrack: "[", lbrke: "⦋", lbrksld: "⦏", lbrkslu: "⦍", lcaron: "ľ", Lcaron: "Ľ", lcedil: "ļ", Lcedil: "Ļ", lceil: "⌈", lcub: "{", lcy: "л", Lcy: "Л", ldca: "⤶", ldquo: "“", ldquor: "„", ldrdhar: "⥧", ldrushar: "⥋", ldsh: "↲", le: "≤", lE: "≦", LeftAngleBracket: "⟨", leftarrow: "←", Leftarrow: "⇐", LeftArrow: "←", LeftArrowBar: "⇤", LeftArrowRightArrow: "⇆", leftarrowtail: "↢", LeftCeiling: "⌈", LeftDoubleBracket: "⟦", LeftDownTeeVector: "⥡", LeftDownVector: "⇃", LeftDownVectorBar: "⥙", LeftFloor: "⌊", leftharpoondown: "↽", leftharpoonup: "↼", leftleftarrows: "⇇", leftrightarrow: "↔", Leftrightarrow: "⇔", LeftRightArrow: "↔", leftrightarrows: "⇆", leftrightharpoons: "⇋", leftrightsquigarrow: "↭", LeftRightVector: "⥎", LeftTee: "⊣", LeftTeeArrow: "↤", LeftTeeVector: "⥚", leftthreetimes: "⋋", LeftTriangle: "⊲", LeftTriangleBar: "⧏", LeftTriangleEqual: "⊴", LeftUpDownVector: "⥑", LeftUpTeeVector: "⥠", LeftUpVector: "↿", LeftUpVectorBar: "⥘", LeftVector: "↼", LeftVectorBar: "⥒", leg: "⋚", lEg: "⪋", leq: "≤", leqq: "≦", leqslant: "⩽", les: "⩽", lescc: "⪨", lesdot: "⩿", lesdoto: "⪁", lesdotor: "⪃", lesg: "⋚︀", lesges: "⪓", lessapprox: "⪅", lessdot: "⋖", lesseqgtr: "⋚", lesseqqgtr: "⪋", LessEqualGreater: "⋚", LessFullEqual: "≦", LessGreater: "≶", lessgtr: "≶", LessLess: "⪡", lesssim: "≲", LessSlantEqual: "⩽", LessTilde: "≲", lfisht: "⥼", lfloor: "⌊", lfr: "𝔩", Lfr: "𝔏", lg: "≶", lgE: "⪑", lHar: "⥢", lhard: "↽", lharu: "↼", lharul: "⥪", lhblk: "▄", ljcy: "љ", LJcy: "Љ", ll: "≪", Ll: "⋘", llarr: "⇇", llcorner: "⌞", Lleftarrow: "⇚", llhard: "⥫", lltri: "◺", lmidot: "ŀ", Lmidot: "Ŀ", lmoust: "⎰", lmoustache: "⎰", lnap: "⪉", lnapprox: "⪉", lne: "⪇", lnE: "≨", lneq: "⪇", lneqq: "≨", lnsim: "⋦", loang: "⟬", loarr: "⇽", lobrk: "⟦", longleftarrow: "⟵", Longleftarrow: "⟸", LongLeftArrow: "⟵", longleftrightarrow: "⟷", Longleftrightarrow: "⟺", LongLeftRightArrow: "⟷", longmapsto: "⟼", longrightarrow: "⟶", Longrightarrow: "⟹", LongRightArrow: "⟶", looparrowleft: "↫", looparrowright: "↬", lopar: "⦅", lopf: "𝕝", Lopf: "𝕃", loplus: "⨭", lotimes: "⨴", lowast: "∗", lowbar: "_", LowerLeftArrow: "↙", LowerRightArrow: "↘", loz: "◊", lozenge: "◊", lozf: "⧫", lpar: "(", lparlt: "⦓", lrarr: "⇆", lrcorner: "⌟", lrhar: "⇋", lrhard: "⥭", lrm: "‎", lrtri: "⊿", lsaquo: "‹", lscr: "𝓁", Lscr: "ℒ", lsh: "↰", Lsh: "↰", lsim: "≲", lsime: "⪍", lsimg: "⪏", lsqb: "[", lsquo: "‘", lsquor: "‚", lstrok: "ł", Lstrok: "Ł", lt: "<", Lt: "≪", LT: "<", ltcc: "⪦", ltcir: "⩹", ltdot: "⋖", lthree: "⋋", ltimes: "⋉", ltlarr: "⥶", ltquest: "⩻", ltri: "◃", ltrie: "⊴", ltrif: "◂", ltrPar: "⦖", lurdshar: "⥊", luruhar: "⥦", lvertneqq: "≨︀", lvnE: "≨︀", macr: "¯", male: "♂", malt: "✠", maltese: "✠", map: "↦", Map: "⤅", mapsto: "↦", mapstodown: "↧", mapstoleft: "↤", mapstoup: "↥", marker: "▮", mcomma: "⨩", mcy: "м", Mcy: "М", mdash: "—", mDDot: "∺", measuredangle: "∡", MediumSpace: " ", Mellintrf: "ℳ", mfr: "𝔪", Mfr: "𝔐", mho: "℧", micro: "µ", mid: "∣", midast: "*", midcir: "⫰", middot: "·", minus: "−", minusb: "⊟", minusd: "∸", minusdu: "⨪", MinusPlus: "∓", mlcp: "⫛", mldr: "…", mnplus: "∓", models: "⊧", mopf: "𝕞", Mopf: "𝕄", mp: "∓", mscr: "𝓂", Mscr: "ℳ", mstpos: "∾", mu: "μ", Mu: "Μ", multimap: "⊸", mumap: "⊸", nabla: "∇", nacute: "ń", Nacute: "Ń", nang: "∠⃒", nap: "≉", napE: "⩰̸", napid: "≋̸", napos: "ŉ", napprox: "≉", natur: "♮", natural: "♮", naturals: "ℕ", nbsp: " ", nbump: "≎̸", nbumpe: "≏̸", ncap: "⩃", ncaron: "ň", Ncaron: "Ň", ncedil: "ņ", Ncedil: "Ņ", ncong: "≇", ncongdot: "⩭̸", ncup: "⩂", ncy: "н", Ncy: "Н", ndash: "–", ne: "≠", nearhk: "⤤", nearr: "↗", neArr: "⇗", nearrow: "↗", nedot: "≐̸", NegativeMediumSpace: "​", NegativeThickSpace: "​", NegativeThinSpace: "​", NegativeVeryThinSpace: "​", nequiv: "≢", nesear: "⤨", nesim: "≂̸", NestedGreaterGreater: "≫", NestedLessLess: "≪", NewLine: `
`, nexist: "∄", nexists: "∄", nfr: "𝔫", Nfr: "𝔑", nge: "≱", ngE: "≧̸", ngeq: "≱", ngeqq: "≧̸", ngeqslant: "⩾̸", nges: "⩾̸", nGg: "⋙̸", ngsim: "≵", ngt: "≯", nGt: "≫⃒", ngtr: "≯", nGtv: "≫̸", nharr: "↮", nhArr: "⇎", nhpar: "⫲", ni: "∋", nis: "⋼", nisd: "⋺", niv: "∋", njcy: "њ", NJcy: "Њ", nlarr: "↚", nlArr: "⇍", nldr: "‥", nle: "≰", nlE: "≦̸", nleftarrow: "↚", nLeftarrow: "⇍", nleftrightarrow: "↮", nLeftrightarrow: "⇎", nleq: "≰", nleqq: "≦̸", nleqslant: "⩽̸", nles: "⩽̸", nless: "≮", nLl: "⋘̸", nlsim: "≴", nlt: "≮", nLt: "≪⃒", nltri: "⋪", nltrie: "⋬", nLtv: "≪̸", nmid: "∤", NoBreak: "⁠", NonBreakingSpace: " ", nopf: "𝕟", Nopf: "ℕ", not: "¬", Not: "⫬", NotCongruent: "≢", NotCupCap: "≭", NotDoubleVerticalBar: "∦", NotElement: "∉", NotEqual: "≠", NotEqualTilde: "≂̸", NotExists: "∄", NotGreater: "≯", NotGreaterEqual: "≱", NotGreaterFullEqual: "≧̸", NotGreaterGreater: "≫̸", NotGreaterLess: "≹", NotGreaterSlantEqual: "⩾̸", NotGreaterTilde: "≵", NotHumpDownHump: "≎̸", NotHumpEqual: "≏̸", notin: "∉", notindot: "⋵̸", notinE: "⋹̸", notinva: "∉", notinvb: "⋷", notinvc: "⋶", NotLeftTriangle: "⋪", NotLeftTriangleBar: "⧏̸", NotLeftTriangleEqual: "⋬", NotLess: "≮", NotLessEqual: "≰", NotLessGreater: "≸", NotLessLess: "≪̸", NotLessSlantEqual: "⩽̸", NotLessTilde: "≴", NotNestedGreaterGreater: "⪢̸", NotNestedLessLess: "⪡̸", notni: "∌", notniva: "∌", notnivb: "⋾", notnivc: "⋽", NotPrecedes: "⊀", NotPrecedesEqual: "⪯̸", NotPrecedesSlantEqual: "⋠", NotReverseElement: "∌", NotRightTriangle: "⋫", NotRightTriangleBar: "⧐̸", NotRightTriangleEqual: "⋭", NotSquareSubset: "⊏̸", NotSquareSubsetEqual: "⋢", NotSquareSuperset: "⊐̸", NotSquareSupersetEqual: "⋣", NotSubset: "⊂⃒", NotSubsetEqual: "⊈", NotSucceeds: "⊁", NotSucceedsEqual: "⪰̸", NotSucceedsSlantEqual: "⋡", NotSucceedsTilde: "≿̸", NotSuperset: "⊃⃒", NotSupersetEqual: "⊉", NotTilde: "≁", NotTildeEqual: "≄", NotTildeFullEqual: "≇", NotTildeTilde: "≉", NotVerticalBar: "∤", npar: "∦", nparallel: "∦", nparsl: "⫽⃥", npart: "∂̸", npolint: "⨔", npr: "⊀", nprcue: "⋠", npre: "⪯̸", nprec: "⊀", npreceq: "⪯̸", nrarr: "↛", nrArr: "⇏", nrarrc: "⤳̸", nrarrw: "↝̸", nrightarrow: "↛", nRightarrow: "⇏", nrtri: "⋫", nrtrie: "⋭", nsc: "⊁", nsccue: "⋡", nsce: "⪰̸", nscr: "𝓃", Nscr: "𝒩", nshortmid: "∤", nshortparallel: "∦", nsim: "≁", nsime: "≄", nsimeq: "≄", nsmid: "∤", nspar: "∦", nsqsube: "⋢", nsqsupe: "⋣", nsub: "⊄", nsube: "⊈", nsubE: "⫅̸", nsubset: "⊂⃒", nsubseteq: "⊈", nsubseteqq: "⫅̸", nsucc: "⊁", nsucceq: "⪰̸", nsup: "⊅", nsupe: "⊉", nsupE: "⫆̸", nsupset: "⊃⃒", nsupseteq: "⊉", nsupseteqq: "⫆̸", ntgl: "≹", ntilde: "ñ", Ntilde: "Ñ", ntlg: "≸", ntriangleleft: "⋪", ntrianglelefteq: "⋬", ntriangleright: "⋫", ntrianglerighteq: "⋭", nu: "ν", Nu: "Ν", num: "#", numero: "№", numsp: " ", nvap: "≍⃒", nvdash: "⊬", nvDash: "⊭", nVdash: "⊮", nVDash: "⊯", nvge: "≥⃒", nvgt: ">⃒", nvHarr: "⤄", nvinfin: "⧞", nvlArr: "⤂", nvle: "≤⃒", nvlt: "<⃒", nvltrie: "⊴⃒", nvrArr: "⤃", nvrtrie: "⊵⃒", nvsim: "∼⃒", nwarhk: "⤣", nwarr: "↖", nwArr: "⇖", nwarrow: "↖", nwnear: "⤧", oacute: "ó", Oacute: "Ó", oast: "⊛", ocir: "⊚", ocirc: "ô", Ocirc: "Ô", ocy: "о", Ocy: "О", odash: "⊝", odblac: "ő", Odblac: "Ő", odiv: "⨸", odot: "⊙", odsold: "⦼", oelig: "œ", OElig: "Œ", ofcir: "⦿", ofr: "𝔬", Ofr: "𝔒", ogon: "˛", ograve: "ò", Ograve: "Ò", ogt: "⧁", ohbar: "⦵", ohm: "Ω", oint: "∮", olarr: "↺", olcir: "⦾", olcross: "⦻", oline: "‾", olt: "⧀", omacr: "ō", Omacr: "Ō", omega: "ω", Omega: "Ω", omicron: "ο", Omicron: "Ο", omid: "⦶", ominus: "⊖", oopf: "𝕠", Oopf: "𝕆", opar: "⦷", OpenCurlyDoubleQuote: "“", OpenCurlyQuote: "‘", operp: "⦹", oplus: "⊕", or: "∨", Or: "⩔", orarr: "↻", ord: "⩝", order: "ℴ", orderof: "ℴ", ordf: "ª", ordm: "º", origof: "⊶", oror: "⩖", orslope: "⩗", orv: "⩛", oS: "Ⓢ", oscr: "ℴ", Oscr: "𝒪", oslash: "ø", Oslash: "Ø", osol: "⊘", otilde: "õ", Otilde: "Õ", otimes: "⊗", Otimes: "⨷", otimesas: "⨶", ouml: "ö", Ouml: "Ö", ovbar: "⌽", OverBar: "‾", OverBrace: "⏞", OverBracket: "⎴", OverParenthesis: "⏜", par: "∥", para: "¶", parallel: "∥", parsim: "⫳", parsl: "⫽", part: "∂", PartialD: "∂", pcy: "п", Pcy: "П", percnt: "%", period: ".", permil: "‰", perp: "⊥", pertenk: "‱", pfr: "𝔭", Pfr: "𝔓", phi: "φ", Phi: "Φ", phiv: "ϕ", phmmat: "ℳ", phone: "☎", pi: "π", Pi: "Π", pitchfork: "⋔", piv: "ϖ", planck: "ℏ", planckh: "ℎ", plankv: "ℏ", plus: "+", plusacir: "⨣", plusb: "⊞", pluscir: "⨢", plusdo: "∔", plusdu: "⨥", pluse: "⩲", PlusMinus: "±", plusmn: "±", plussim: "⨦", plustwo: "⨧", pm: "±", Poincareplane: "ℌ", pointint: "⨕", popf: "𝕡", Popf: "ℙ", pound: "£", pr: "≺", Pr: "⪻", prap: "⪷", prcue: "≼", pre: "⪯", prE: "⪳", prec: "≺", precapprox: "⪷", preccurlyeq: "≼", Precedes: "≺", PrecedesEqual: "⪯", PrecedesSlantEqual: "≼", PrecedesTilde: "≾", preceq: "⪯", precnapprox: "⪹", precneqq: "⪵", precnsim: "⋨", precsim: "≾", prime: "′", Prime: "″", primes: "ℙ", prnap: "⪹", prnE: "⪵", prnsim: "⋨", prod: "∏", Product: "∏", profalar: "⌮", profline: "⌒", profsurf: "⌓", prop: "∝", Proportion: "∷", Proportional: "∝", propto: "∝", prsim: "≾", prurel: "⊰", pscr: "𝓅", Pscr: "𝒫", psi: "ψ", Psi: "Ψ", puncsp: " ", qfr: "𝔮", Qfr: "𝔔", qint: "⨌", qopf: "𝕢", Qopf: "ℚ", qprime: "⁗", qscr: "𝓆", Qscr: "𝒬", quaternions: "ℍ", quatint: "⨖", quest: "?", questeq: "≟", quot: '"', QUOT: '"', rAarr: "⇛", race: "∽̱", racute: "ŕ", Racute: "Ŕ", radic: "√", raemptyv: "⦳", rang: "⟩", Rang: "⟫", rangd: "⦒", range: "⦥", rangle: "⟩", raquo: "»", rarr: "→", rArr: "⇒", Rarr: "↠", rarrap: "⥵", rarrb: "⇥", rarrbfs: "⤠", rarrc: "⤳", rarrfs: "⤞", rarrhk: "↪", rarrlp: "↬", rarrpl: "⥅", rarrsim: "⥴", rarrtl: "↣", Rarrtl: "⤖", rarrw: "↝", ratail: "⤚", rAtail: "⤜", ratio: "∶", rationals: "ℚ", rbarr: "⤍", rBarr: "⤏", RBarr: "⤐", rbbrk: "❳", rbrace: "}", rbrack: "]", rbrke: "⦌", rbrksld: "⦎", rbrkslu: "⦐", rcaron: "ř", Rcaron: "Ř", rcedil: "ŗ", Rcedil: "Ŗ", rceil: "⌉", rcub: "}", rcy: "р", Rcy: "Р", rdca: "⤷", rdldhar: "⥩", rdquo: "”", rdquor: "”", rdsh: "↳", Re: "ℜ", real: "ℜ", realine: "ℛ", realpart: "ℜ", reals: "ℝ", rect: "▭", reg: "®", REG: "®", ReverseElement: "∋", ReverseEquilibrium: "⇋", ReverseUpEquilibrium: "⥯", rfisht: "⥽", rfloor: "⌋", rfr: "𝔯", Rfr: "ℜ", rHar: "⥤", rhard: "⇁", rharu: "⇀", rharul: "⥬", rho: "ρ", Rho: "Ρ", rhov: "ϱ", RightAngleBracket: "⟩", rightarrow: "→", Rightarrow: "⇒", RightArrow: "→", RightArrowBar: "⇥", RightArrowLeftArrow: "⇄", rightarrowtail: "↣", RightCeiling: "⌉", RightDoubleBracket: "⟧", RightDownTeeVector: "⥝", RightDownVector: "⇂", RightDownVectorBar: "⥕", RightFloor: "⌋", rightharpoondown: "⇁", rightharpoonup: "⇀", rightleftarrows: "⇄", rightleftharpoons: "⇌", rightrightarrows: "⇉", rightsquigarrow: "↝", RightTee: "⊢", RightTeeArrow: "↦", RightTeeVector: "⥛", rightthreetimes: "⋌", RightTriangle: "⊳", RightTriangleBar: "⧐", RightTriangleEqual: "⊵", RightUpDownVector: "⥏", RightUpTeeVector: "⥜", RightUpVector: "↾", RightUpVectorBar: "⥔", RightVector: "⇀", RightVectorBar: "⥓", ring: "˚", risingdotseq: "≓", rlarr: "⇄", rlhar: "⇌", rlm: "‏", rmoust: "⎱", rmoustache: "⎱", rnmid: "⫮", roang: "⟭", roarr: "⇾", robrk: "⟧", ropar: "⦆", ropf: "𝕣", Ropf: "ℝ", roplus: "⨮", rotimes: "⨵", RoundImplies: "⥰", rpar: ")", rpargt: "⦔", rppolint: "⨒", rrarr: "⇉", Rrightarrow: "⇛", rsaquo: "›", rscr: "𝓇", Rscr: "ℛ", rsh: "↱", Rsh: "↱", rsqb: "]", rsquo: "’", rsquor: "’", rthree: "⋌", rtimes: "⋊", rtri: "▹", rtrie: "⊵", rtrif: "▸", rtriltri: "⧎", RuleDelayed: "⧴", ruluhar: "⥨", rx: "℞", sacute: "ś", Sacute: "Ś", sbquo: "‚", sc: "≻", Sc: "⪼", scap: "⪸", scaron: "š", Scaron: "Š", sccue: "≽", sce: "⪰", scE: "⪴", scedil: "ş", Scedil: "Ş", scirc: "ŝ", Scirc: "Ŝ", scnap: "⪺", scnE: "⪶", scnsim: "⋩", scpolint: "⨓", scsim: "≿", scy: "с", Scy: "С", sdot: "⋅", sdotb: "⊡", sdote: "⩦", searhk: "⤥", searr: "↘", seArr: "⇘", searrow: "↘", sect: "§", semi: ";", seswar: "⤩", setminus: "∖", setmn: "∖", sext: "✶", sfr: "𝔰", Sfr: "𝔖", sfrown: "⌢", sharp: "♯", shchcy: "щ", SHCHcy: "Щ", shcy: "ш", SHcy: "Ш", ShortDownArrow: "↓", ShortLeftArrow: "←", shortmid: "∣", shortparallel: "∥", ShortRightArrow: "→", ShortUpArrow: "↑", shy: "­", sigma: "σ", Sigma: "Σ", sigmaf: "ς", sigmav: "ς", sim: "∼", simdot: "⩪", sime: "≃", simeq: "≃", simg: "⪞", simgE: "⪠", siml: "⪝", simlE: "⪟", simne: "≆", simplus: "⨤", simrarr: "⥲", slarr: "←", SmallCircle: "∘", smallsetminus: "∖", smashp: "⨳", smeparsl: "⧤", smid: "∣", smile: "⌣", smt: "⪪", smte: "⪬", smtes: "⪬︀", softcy: "ь", SOFTcy: "Ь", sol: "/", solb: "⧄", solbar: "⌿", sopf: "𝕤", Sopf: "𝕊", spades: "♠", spadesuit: "♠", spar: "∥", sqcap: "⊓", sqcaps: "⊓︀", sqcup: "⊔", sqcups: "⊔︀", Sqrt: "√", sqsub: "⊏", sqsube: "⊑", sqsubset: "⊏", sqsubseteq: "⊑", sqsup: "⊐", sqsupe: "⊒", sqsupset: "⊐", sqsupseteq: "⊒", squ: "□", square: "□", Square: "□", SquareIntersection: "⊓", SquareSubset: "⊏", SquareSubsetEqual: "⊑", SquareSuperset: "⊐", SquareSupersetEqual: "⊒", SquareUnion: "⊔", squarf: "▪", squf: "▪", srarr: "→", sscr: "𝓈", Sscr: "𝒮", ssetmn: "∖", ssmile: "⌣", sstarf: "⋆", star: "☆", Star: "⋆", starf: "★", straightepsilon: "ϵ", straightphi: "ϕ", strns: "¯", sub: "⊂", Sub: "⋐", subdot: "⪽", sube: "⊆", subE: "⫅", subedot: "⫃", submult: "⫁", subne: "⊊", subnE: "⫋", subplus: "⪿", subrarr: "⥹", subset: "⊂", Subset: "⋐", subseteq: "⊆", subseteqq: "⫅", SubsetEqual: "⊆", subsetneq: "⊊", subsetneqq: "⫋", subsim: "⫇", subsub: "⫕", subsup: "⫓", succ: "≻", succapprox: "⪸", succcurlyeq: "≽", Succeeds: "≻", SucceedsEqual: "⪰", SucceedsSlantEqual: "≽", SucceedsTilde: "≿", succeq: "⪰", succnapprox: "⪺", succneqq: "⪶", succnsim: "⋩", succsim: "≿", SuchThat: "∋", sum: "∑", Sum: "∑", sung: "♪", sup: "⊃", Sup: "⋑", sup1: "¹", sup2: "²", sup3: "³", supdot: "⪾", supdsub: "⫘", supe: "⊇", supE: "⫆", supedot: "⫄", Superset: "⊃", SupersetEqual: "⊇", suphsol: "⟉", suphsub: "⫗", suplarr: "⥻", supmult: "⫂", supne: "⊋", supnE: "⫌", supplus: "⫀", supset: "⊃", Supset: "⋑", supseteq: "⊇", supseteqq: "⫆", supsetneq: "⊋", supsetneqq: "⫌", supsim: "⫈", supsub: "⫔", supsup: "⫖", swarhk: "⤦", swarr: "↙", swArr: "⇙", swarrow: "↙", swnwar: "⤪", szlig: "ß", Tab: "	", target: "⌖", tau: "τ", Tau: "Τ", tbrk: "⎴", tcaron: "ť", Tcaron: "Ť", tcedil: "ţ", Tcedil: "Ţ", tcy: "т", Tcy: "Т", tdot: "⃛", telrec: "⌕", tfr: "𝔱", Tfr: "𝔗", there4: "∴", therefore: "∴", Therefore: "∴", theta: "θ", Theta: "Θ", thetasym: "ϑ", thetav: "ϑ", thickapprox: "≈", thicksim: "∼", ThickSpace: "  ", thinsp: " ", ThinSpace: " ", thkap: "≈", thksim: "∼", thorn: "þ", THORN: "Þ", tilde: "˜", Tilde: "∼", TildeEqual: "≃", TildeFullEqual: "≅", TildeTilde: "≈", times: "×", timesb: "⊠", timesbar: "⨱", timesd: "⨰", tint: "∭", toea: "⤨", top: "⊤", topbot: "⌶", topcir: "⫱", topf: "𝕥", Topf: "𝕋", topfork: "⫚", tosa: "⤩", tprime: "‴", trade: "™", TRADE: "™", triangle: "▵", triangledown: "▿", triangleleft: "◃", trianglelefteq: "⊴", triangleq: "≜", triangleright: "▹", trianglerighteq: "⊵", tridot: "◬", trie: "≜", triminus: "⨺", TripleDot: "⃛", triplus: "⨹", trisb: "⧍", tritime: "⨻", trpezium: "⏢", tscr: "𝓉", Tscr: "𝒯", tscy: "ц", TScy: "Ц", tshcy: "ћ", TSHcy: "Ћ", tstrok: "ŧ", Tstrok: "Ŧ", twixt: "≬", twoheadleftarrow: "↞", twoheadrightarrow: "↠", uacute: "ú", Uacute: "Ú", uarr: "↑", uArr: "⇑", Uarr: "↟", Uarrocir: "⥉", ubrcy: "ў", Ubrcy: "Ў", ubreve: "ŭ", Ubreve: "Ŭ", ucirc: "û", Ucirc: "Û", ucy: "у", Ucy: "У", udarr: "⇅", udblac: "ű", Udblac: "Ű", udhar: "⥮", ufisht: "⥾", ufr: "𝔲", Ufr: "𝔘", ugrave: "ù", Ugrave: "Ù", uHar: "⥣", uharl: "↿", uharr: "↾", uhblk: "▀", ulcorn: "⌜", ulcorner: "⌜", ulcrop: "⌏", ultri: "◸", umacr: "ū", Umacr: "Ū", uml: "¨", UnderBar: "_", UnderBrace: "⏟", UnderBracket: "⎵", UnderParenthesis: "⏝", Union: "⋃", UnionPlus: "⊎", uogon: "ų", Uogon: "Ų", uopf: "𝕦", Uopf: "𝕌", uparrow: "↑", Uparrow: "⇑", UpArrow: "↑", UpArrowBar: "⤒", UpArrowDownArrow: "⇅", updownarrow: "↕", Updownarrow: "⇕", UpDownArrow: "↕", UpEquilibrium: "⥮", upharpoonleft: "↿", upharpoonright: "↾", uplus: "⊎", UpperLeftArrow: "↖", UpperRightArrow: "↗", upsi: "υ", Upsi: "ϒ", upsih: "ϒ", upsilon: "υ", Upsilon: "Υ", UpTee: "⊥", UpTeeArrow: "↥", upuparrows: "⇈", urcorn: "⌝", urcorner: "⌝", urcrop: "⌎", uring: "ů", Uring: "Ů", urtri: "◹", uscr: "𝓊", Uscr: "𝒰", utdot: "⋰", utilde: "ũ", Utilde: "Ũ", utri: "▵", utrif: "▴", uuarr: "⇈", uuml: "ü", Uuml: "Ü", uwangle: "⦧", vangrt: "⦜", varepsilon: "ϵ", varkappa: "ϰ", varnothing: "∅", varphi: "ϕ", varpi: "ϖ", varpropto: "∝", varr: "↕", vArr: "⇕", varrho: "ϱ", varsigma: "ς", varsubsetneq: "⊊︀", varsubsetneqq: "⫋︀", varsupsetneq: "⊋︀", varsupsetneqq: "⫌︀", vartheta: "ϑ", vartriangleleft: "⊲", vartriangleright: "⊳", vBar: "⫨", Vbar: "⫫", vBarv: "⫩", vcy: "в", Vcy: "В", vdash: "⊢", vDash: "⊨", Vdash: "⊩", VDash: "⊫", Vdashl: "⫦", vee: "∨", Vee: "⋁", veebar: "⊻", veeeq: "≚", vellip: "⋮", verbar: "|", Verbar: "‖", vert: "|", Vert: "‖", VerticalBar: "∣", VerticalLine: "|", VerticalSeparator: "❘", VerticalTilde: "≀", VeryThinSpace: " ", vfr: "𝔳", Vfr: "𝔙", vltri: "⊲", vnsub: "⊂⃒", vnsup: "⊃⃒", vopf: "𝕧", Vopf: "𝕍", vprop: "∝", vrtri: "⊳", vscr: "𝓋", Vscr: "𝒱", vsubne: "⊊︀", vsubnE: "⫋︀", vsupne: "⊋︀", vsupnE: "⫌︀", Vvdash: "⊪", vzigzag: "⦚", wcirc: "ŵ", Wcirc: "Ŵ", wedbar: "⩟", wedge: "∧", Wedge: "⋀", wedgeq: "≙", weierp: "℘", wfr: "𝔴", Wfr: "𝔚", wopf: "𝕨", Wopf: "𝕎", wp: "℘", wr: "≀", wreath: "≀", wscr: "𝓌", Wscr: "𝒲", xcap: "⋂", xcirc: "◯", xcup: "⋃", xdtri: "▽", xfr: "𝔵", Xfr: "𝔛", xharr: "⟷", xhArr: "⟺", xi: "ξ", Xi: "Ξ", xlarr: "⟵", xlArr: "⟸", xmap: "⟼", xnis: "⋻", xodot: "⨀", xopf: "𝕩", Xopf: "𝕏", xoplus: "⨁", xotime: "⨂", xrarr: "⟶", xrArr: "⟹", xscr: "𝓍", Xscr: "𝒳", xsqcup: "⨆", xuplus: "⨄", xutri: "△", xvee: "⋁", xwedge: "⋀", yacute: "ý", Yacute: "Ý", yacy: "я", YAcy: "Я", ycirc: "ŷ", Ycirc: "Ŷ", ycy: "ы", Ycy: "Ы", yen: "¥", yfr: "𝔶", Yfr: "𝔜", yicy: "ї", YIcy: "Ї", yopf: "𝕪", Yopf: "𝕐", yscr: "𝓎", Yscr: "𝒴", yucy: "ю", YUcy: "Ю", yuml: "ÿ", Yuml: "Ÿ", zacute: "ź", Zacute: "Ź", zcaron: "ž", Zcaron: "Ž", zcy: "з", Zcy: "З", zdot: "ż", Zdot: "Ż", zeetrf: "ℨ", ZeroWidthSpace: "​", zeta: "ζ", Zeta: "Ζ", zfr: "𝔷", Zfr: "ℨ", zhcy: "ж", ZHcy: "Ж", zigrarr: "⇝", zopf: "𝕫", Zopf: "ℤ", zscr: "𝓏", Zscr: "𝒵", zwj: "‍", zwnj: "‌" }, $ = { aacute: "á", Aacute: "Á", acirc: "â", Acirc: "Â", acute: "´", aelig: "æ", AElig: "Æ", agrave: "à", Agrave: "À", amp: "&", AMP: "&", aring: "å", Aring: "Å", atilde: "ã", Atilde: "Ã", auml: "ä", Auml: "Ä", brvbar: "¦", ccedil: "ç", Ccedil: "Ç", cedil: "¸", cent: "¢", copy: "©", COPY: "©", curren: "¤", deg: "°", divide: "÷", eacute: "é", Eacute: "É", ecirc: "ê", Ecirc: "Ê", egrave: "è", Egrave: "È", eth: "ð", ETH: "Ð", euml: "ë", Euml: "Ë", frac12: "½", frac14: "¼", frac34: "¾", gt: ">", GT: ">", iacute: "í", Iacute: "Í", icirc: "î", Icirc: "Î", iexcl: "¡", igrave: "ì", Igrave: "Ì", iquest: "¿", iuml: "ï", Iuml: "Ï", laquo: "«", lt: "<", LT: "<", macr: "¯", micro: "µ", middot: "·", nbsp: " ", not: "¬", ntilde: "ñ", Ntilde: "Ñ", oacute: "ó", Oacute: "Ó", ocirc: "ô", Ocirc: "Ô", ograve: "ò", Ograve: "Ò", ordf: "ª", ordm: "º", oslash: "ø", Oslash: "Ø", otilde: "õ", Otilde: "Õ", ouml: "ö", Ouml: "Ö", para: "¶", plusmn: "±", pound: "£", quot: '"', QUOT: '"', raquo: "»", reg: "®", REG: "®", sect: "§", shy: "­", sup1: "¹", sup2: "²", sup3: "³", szlig: "ß", thorn: "þ", THORN: "Þ", times: "×", uacute: "ú", Uacute: "Ú", ucirc: "û", Ucirc: "Û", ugrave: "ù", Ugrave: "Ù", uml: "¨", uuml: "ü", Uuml: "Ü", yacute: "ý", Yacute: "Ý", yen: "¥", yuml: "ÿ" }, te = { 0: "�", 128: "€", 130: "‚", 131: "ƒ", 132: "„", 133: "…", 134: "†", 135: "‡", 136: "ˆ", 137: "‰", 138: "Š", 139: "‹", 140: "Œ", 142: "Ž", 145: "‘", 146: "’", 147: "“", 148: "”", 149: "•", 150: "–", 151: "—", 152: "˜", 153: "™", 154: "š", 155: "›", 156: "œ", 158: "ž", 159: "Ÿ" }, V = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65e3, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111], K = String.fromCharCode, ne = {}.hasOwnProperty, J = function(q) {
            throw Error("Parse error: " + q);
          };
          (b = function ee(q, X) {
            var oe = (X = E(X, ee.options)).strict;
            return oe && Q.test(q) && J("malformed character reference"), q.replace(ie, function(ae, _e, ve, Ee, we, ze, Ie, je, qe) {
              var Ge, Ze, tt;
              return _e ? ce[tt = _e] : ve ? (tt = ve, Ee && X.isAttributeValue ? (oe && Ee == "=" && J("`&` did not start a character reference"), ae) : (oe && J("named character reference was not terminated by a semicolon"), $[tt] + (Ee || ""))) : we ? (Ze = we, Ge = ze, oe && !Ge && J("character reference was not terminated by a semicolon"), C(Ze = parseInt(Ze, 10), oe)) : Ie ? (Ge = je, oe && !Ge && J("character reference was not terminated by a semicolon"), C(Ze = parseInt(Ie, 16), oe)) : (oe && J("named character reference was not terminated by a semicolon"), ae);
            });
          }).options = { isAttributeValue: !(A.options = { allowUnsafeSymbols: !1, encodeEverything: !1, strict: !1, useNamedReferences: !1, decimal: !1 }), strict: !1 };
          var L = { version: "1.2.0", encode: A, decode: b, escape: function(q) {
            return q.replace(U, function(X) {
              return H[X];
            });
          }, unescape: b };
          if (h(r(90)) == "object" && r(90)) (f = (function() {
            return L;
          }).call(s, r, s, l)) === void 0 || (l.exports = f);
          else if (g && !g.nodeType) if (_) _.exports = L;
          else for (var z in L) v(L, z) && (g[z] = L[z]);
          else p.he = L;
        })(this);
      }).call(this, r(54)(a), r(18));
    }, function(a, s, p) {
      var l = p(215).createMapFromString, d = /([^\s"'<>/=]+)/, f = [/=/], h = [/"([^"]*)"+/.source, /'([^']*)'+/.source, /([^ \t\n\f\r"'`=<>]+)/.source], p = "((?:" + (p = "[" + (p = "A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u0131\\u0134-\\u013E\\u0141-\\u0148\\u014A-\\u017E\\u0180-\\u01C3\\u01CD-\\u01F0\\u01F4\\u01F5\\u01FA-\\u0217\\u0250-\\u02A8\\u02BB-\\u02C1\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03CE\\u03D0-\\u03D6\\u03DA\\u03DC\\u03DE\\u03E0\\u03E2-\\u03F3\\u0401-\\u040C\\u040E-\\u044F\\u0451-\\u045C\\u045E-\\u0481\\u0490-\\u04C4\\u04C7\\u04C8\\u04CB\\u04CC\\u04D0-\\u04EB\\u04EE-\\u04F5\\u04F8\\u04F9\\u0531-\\u0556\\u0559\\u0561-\\u0586\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0621-\\u063A\\u0641-\\u064A\\u0671-\\u06B7\\u06BA-\\u06BE\\u06C0-\\u06CE\\u06D0-\\u06D3\\u06D5\\u06E5\\u06E6\\u0905-\\u0939\\u093D\\u0958-\\u0961\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8B\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AE0\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B36-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB5\\u0BB7-\\u0BB9\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CDE\\u0CE0\\u0CE1\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D28\\u0D2A-\\u0D39\\u0D60\\u0D61\\u0E01-\\u0E2E\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E45\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD\\u0EAE\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0F40-\\u0F47\\u0F49-\\u0F69\\u10A0-\\u10C5\\u10D0-\\u10F6\\u1100\\u1102\\u1103\\u1105-\\u1107\\u1109\\u110B\\u110C\\u110E-\\u1112\\u113C\\u113E\\u1140\\u114C\\u114E\\u1150\\u1154\\u1155\\u1159\\u115F-\\u1161\\u1163\\u1165\\u1167\\u1169\\u116D\\u116E\\u1172\\u1173\\u1175\\u119E\\u11A8\\u11AB\\u11AE\\u11AF\\u11B7\\u11B8\\u11BA\\u11BC-\\u11C2\\u11EB\\u11F0\\u11F9\\u1E00-\\u1E9B\\u1EA0-\\u1EF9\\u1F00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2126\\u212A\\u212B\\u212E\\u2180-\\u2182\\u3007\\u3021-\\u3029\\u3041-\\u3094\\u30A1-\\u30FA\\u3105-\\u312C\\u4E00-\\u9FA5\\uAC00-\\uD7A3") + "_][" + p + "0-9\\u0660-\\u0669\\u06F0-\\u06F9\\u0966-\\u096F\\u09E6-\\u09EF\\u0A66-\\u0A6F\\u0AE6-\\u0AEF\\u0B66-\\u0B6F\\u0BE7-\\u0BEF\\u0C66-\\u0C6F\\u0CE6-\\u0CEF\\u0D66-\\u0D6F\\u0E50-\\u0E59\\u0ED0-\\u0ED9\\u0F20-\\u0F29\\.\\-_\\u0300-\\u0345\\u0360\\u0361\\u0483-\\u0486\\u0591-\\u05A1\\u05A3-\\u05B9\\u05BB-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u064B-\\u0652\\u0670\\u06D6-\\u06E4\\u06E7\\u06E8\\u06EA-\\u06ED\\u0901-\\u0903\\u093C\\u093E-\\u094D\\u0951-\\u0954\\u0962\\u0963\\u0981-\\u0983\\u09BC\\u09BE-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CD\\u09D7\\u09E2\\u09E3\\u0A02\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A70\\u0A71\\u0A81-\\u0A83\\u0ABC\\u0ABE-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0B01-\\u0B03\\u0B3C\\u0B3E-\\u0B43\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B82\\u0B83\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD7\\u0C01-\\u0C03\\u0C3E-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C82\\u0C83\\u0CBE-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0D02\\u0D03\\u0D3E-\\u0D43\\u0D46-\\u0D48\\u0D4A-\\u0D4D\\u0D57\\u0E31\\u0E34-\\u0E3A\\u0E47-\\u0E4E\\u0EB1\\u0EB4-\\u0EB9\\u0EBB\\u0EBC\\u0EC8-\\u0ECD\\u0F18\\u0F19\\u0F35\\u0F37\\u0F39\\u0F3E\\u0F3F\\u0F71-\\u0F84\\u0F86-\\u0F8B\\u0F90-\\u0F95\\u0F97\\u0F99-\\u0FAD\\u0FB1-\\u0FB7\\u0FB9\\u20D0-\\u20DC\\u20E1\\u302A-\\u302F\\u3099\\u309A\\xB7\\u02D0\\u02D1\\u0387\\u0640\\u0E46\\u0EC6\\u3005\\u3031-\\u3035\\u309D\\u309E\\u30FC-\\u30FE]*") + "\\:)?" + p + ")", g = new RegExp("^<" + p), _ = /^\s*(\/?)>/, b = new RegExp("^<\\/" + p + "[^>]*>"), v = /^<!DOCTYPE\s?[^>]+>/i, E = !1;
      "x".replace(/x(.)?/g, function(B, U) {
        E = U === "";
      });
      var C = l("area,base,basefont,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr", !0), y = l("a,abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,code,del,dfn,em,font,i,iframe,img,input,ins,kbd,label,map,noscript,object,q,s,samp,script,select,small,span,strike,strong,sub,sup,svg,textarea,tt,u,var", !0), T = l("colgroup,dd,dt,li,option,p,td,tfoot,th,thead,tr,source", !0), A = l("checked,compact,declare,defer,disabled,ismap,multiple,nohref,noresize,noshade,nowrap,readonly,selected", !0), k = l("script,style", !0), N = l("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,ol,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track,ul", !0), j = {};
      function I(B, U) {
        for (var H, Q, Y, ie, ce = [], $ = function(X) {
          var oe = d.source + "(?:\\s*(" + function(Ee) {
            return f.concat(Ee.customAttrAssign || []).map(function(we) {
              return "(?:" + we.source + ")";
            }).join("|");
          }(X) + ")[ \\t\\n\\f\\r]*(?:" + h.join("|") + "))?";
          if (X.customAttrSurround) {
            for (var ae = [], _e = X.customAttrSurround.length - 1; 0 <= _e; _e--) ae[_e] = "(?:(" + X.customAttrSurround[_e][0].source + ")\\s*" + oe + "\\s*(" + X.customAttrSurround[_e][1].source + "))";
            ae.push("(?:" + oe + ")"), oe = "(?:" + ae.join("|") + ")";
          }
          return new RegExp("^\\s*" + oe);
        }(U); B; ) {
          if (Q = B, H && k(H)) {
            var te = H.toLowerCase(), V = j[te] || (j[te] = new RegExp("([\\s\\S]*?)</" + te + "[^>]*>", "i"));
            B = B.replace(V, function(q, X) {
              return te !== "script" && te !== "style" && te !== "noscript" && (X = X.replace(/<!--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), U.chars && U.chars(X), "";
            }), ee("</" + te + ">", te);
          } else {
            if ((ne = B.indexOf("<")) === 0) {
              if (/^<!--/.test(B) && 0 <= (V = B.indexOf("-->"))) {
                U.comment && U.comment(B.substring(4, V)), B = B.substring(V + 3), Y = "";
                continue;
              }
              if (/^<!\[/.test(B)) {
                var K = B.indexOf("]>");
                if (0 <= K) {
                  U.comment && U.comment(B.substring(2, K + 1), !0), B = B.substring(K + 2), Y = "";
                  continue;
                }
              }
              if (K = B.match(v)) {
                U.doctype && U.doctype(K[0]), B = B.substring(K[0].length), Y = "";
                continue;
              }
              if (K = B.match(b)) {
                B = B.substring(K[0].length), K[0].replace(b, ee), Y = "/" + K[1].toLowerCase();
                continue;
              }
              if (K = J(B)) {
                B = K.rest, function(ve) {
                  var oe = ve.tagName, ae = ve.unarySlash;
                  if (U.html5 && (H === "p" && N(oe) ? ee("", H) : oe === "tbody" ? L("thead") : oe === "tfoot" && (L("tbody") || L("thead")), oe === "col" && z("colgroup") < 0 && (H = "colgroup", ce.push({ tag: H, attrs: [] }), U.start && U.start(H, [], !1, ""))), !U.html5 && !y(oe)) for (; H && y(H); ) ee("", H);
                  T(oe) && H === oe && ee("", oe);
                  var _e = C(oe) || oe === "html" && H === "head" || !!ae, ve = ve.attrs.map(function(Ee) {
                    var we, ze, Ie, je, qe, Ge;
                    function Ze(pe) {
                      return qe = Ee[pe], (ze = Ee[pe + 1]) !== void 0 ? '"' : (ze = Ee[pe + 2]) !== void 0 ? "'" : ((ze = Ee[pe + 3]) === void 0 && A(we) && (ze = we), "");
                    }
                    E && Ee[0].indexOf('""') === -1 && (Ee[3] === "" && delete Ee[3], Ee[4] === "" && delete Ee[4], Ee[5] === "" && delete Ee[5]);
                    var tt = 1;
                    if (U.customAttrSurround) {
                      for (var Qe = 0, ke = U.customAttrSurround.length; Qe < ke; Qe++, tt += 7) if (we = Ee[tt + 1]) {
                        Ge = Ze(tt + 2), Ie = Ee[tt], je = Ee[tt + 6];
                        break;
                      }
                    }
                    return !we && (we = Ee[tt]) && (Ge = Ze(tt + 1)), { name: we, value: ze, customAssign: qe || "=", customOpen: Ie || "", customClose: je || "", quote: Ge || "" };
                  });
                  _e || (ce.push({ tag: oe, attrs: ve }), H = oe, ae = ""), U.start && U.start(oe, ve, _e, ae);
                }(K), Y = K.tagName.toLowerCase();
                continue;
              }
              U.continueOnParseError && (ne = B.indexOf("<", 1));
            }
            var ne = (ne = J(B = 0 <= ne ? (ie = B.substring(0, ne), B.substring(ne)) : (ie = B, ""))) ? ne.tagName : (ne = B.match(b)) ? "/" + ne[1] : "";
            U.chars && U.chars(ie, Y, ne), Y = "";
          }
          if (B === Q) throw new Error("Parse Error: " + B);
        }
        function J(q) {
          var X = q.match(g);
          if (X) {
            var oe, ae, _e = { tagName: X[1], attrs: [] };
            for (q = q.slice(X[0].length); !(oe = q.match(_)) && (ae = q.match($)); ) q = q.slice(ae[0].length), _e.attrs.push(ae);
            if (oe) return _e.unarySlash = oe[1], _e.rest = q.slice(oe[0].length), _e;
          }
        }
        function L(q) {
          return 0 <= z(q) && (ee("", q), 1);
        }
        function z(q) {
          for (var X = q.toLowerCase(), oe = ce.length - 1; 0 <= oe && ce[oe].tag.toLowerCase() !== X; oe--) ;
          return oe;
        }
        function ee(q, X) {
          var oe = X ? z(X) : 0;
          if (0 <= oe) {
            for (var ae = ce.length - 1; oe <= ae; ae--) U.end && U.end(ce[ae].tag, ce[ae].attrs, oe < ae || !q);
            ce.length = oe, H = oe && ce[oe - 1].tag;
          } else X.toLowerCase() === "br" ? U.start && U.start(X, [], !0, "") : X.toLowerCase() === "p" && (U.start && U.start(X, [], !1, "", !0), U.end && U.end(X, []));
        }
        U.partialMarkup || ee();
      }
      s.HTMLParser = I, s.HTMLtoXML = function(B) {
        var U = "";
        return I(B, { start: function(Q, Y, ie) {
          U += "<" + Q;
          for (var ce = 0, $ = Y.length; ce < $; ce++) U += " " + Y[ce].name + '="' + (Y[ce].value || "").replace(/"/g, "&#34;") + '"';
          U += (ie ? "/" : "") + ">";
        }, end: function(Q) {
          U += "</" + Q + ">";
        }, chars: function(Q) {
          U += Q;
        }, comment: function(Q) {
          U += "<!--" + Q + "-->";
        }, ignore: function(Q) {
          U += Q;
        } }), U;
      }, s.HTMLtoDOM = function(B, U) {
        var H = { html: !0, head: !0, body: !0, title: !0 }, Q = { link: "head", base: "head" };
        U ? U = U.ownerDocument || U.getOwnerDocument && U.getOwnerDocument() || U : typeof DOMDocument < "u" ? U = new DOMDocument() : typeof document < "u" && document.implementation && document.implementation.createDocument ? U = document.implementation.createDocument("", "", null) : typeof ActiveX < "u" && (U = new ActiveXObject("Msxml.DOMDocument"));
        var Y, ie, ce = [];
        if (U.documentElement || U.getDocumentElement && U.getDocumentElement() || !U.createElement || (Y = U.createElement("html"), (ie = U.createElement("head")).appendChild(U.createElement("title")), Y.appendChild(ie), Y.appendChild(U.createElement("body")), U.appendChild(Y)), U.getElementsByTagName) for (var $ in H) H[$] = U.getElementsByTagName($)[0];
        var te = H.body;
        return I(B, { start: function(K, ne, J) {
          if (H[K]) te = H[K];
          else {
            var L, z = U.createElement(K);
            for (L in ne) z.setAttribute(ne[L].name, ne[L].value);
            Q[K] && typeof H[Q[K]] != "boolean" ? H[Q[K]].appendChild(z) : te && te.appendChild && te.appendChild(z), J || (ce.push(z), te = z);
          }
        }, end: function() {
          --ce.length, te = ce[ce.length - 1];
        }, chars: function(K) {
          te.appendChild(U.createTextNode(K));
        }, comment: function() {
        }, ignore: function() {
        } }), U;
      };
    }, function(a, s, r) {
      var l = r(216), d = r(459), f = r(460), h = r(136), p = r(461), g = r(468);
      function _(b, v) {
        this.options = f(v, { defaultPorts: { ftp: 21, http: 80, https: 443 }, directoryIndexes: ["index.html"], ignore_www: !1, output: _.SHORTEST, rejectedSchemes: ["data", "javascript", "mailto"], removeAuth: !1, removeDirectoryIndexes: !0, removeEmptyQueries: !1, removeRootTrailingSlash: !0, schemeRelative: !0, site: void 0, slashesDenoteHost: !0 }), this.from = p.from(b, this.options, null);
      }
      _.prototype.relate = function(b, v, E) {
        if (h.isPlainObject(v) ? (E = v, v = b, b = null) : v || (v = b, b = null), E = f(E, this.options), b = b || E.site, !(b = p.from(b, E, this.from)) || !b.href) throw new Error("from value not defined.");
        if (b.extra.hrefInfo.minimumPathOnly) throw new Error("from value supplied is not absolute: " + b.href);
        return (v = p.to(v, E)).valid === !1 ? v.href : (v = g(b, v, E), d(v, E));
      }, _.relate = function(b, v, E) {
        return new _().relate(b, v, E);
      }, h.shallowMerge(_, l), a.exports = _;
    }, function(a, s, r) {
      var l = r(216);
      function d(p, g) {
        return g = g.removeEmptyQueries && p.extra.relation.minimumPort, p.query.string[g ? "stripped" : "full"];
      }
      function f(p, g) {
        return !p.extra.relation.minimumQuery || g.output === l.ABSOLUTE || g.output === l.ROOT_RELATIVE;
      }
      function h(p, b) {
        var _ = b.removeDirectoryIndexes && p.extra.resourceIsIndex, b = p.extra.relation.minimumResource && b.output !== l.ABSOLUTE && b.output !== l.ROOT_RELATIVE;
        return !!p.resource && !b && !_;
      }
      a.exports = function(g, _) {
        var b = "";
        return b += function(E, C) {
          var y = "";
          return !E.extra.relation.maximumHost && C.output !== l.ABSOLUTE || (E.extra.relation.minimumScheme && C.schemeRelative && C.output !== l.ABSOLUTE ? y += "//" : y += E.scheme + "://"), y;
        }(g, _), b += function(E, C) {
          return !E.auth || C.removeAuth || !E.extra.relation.maximumHost && C.output !== l.ABSOLUTE ? "" : E.auth + "@";
        }(g, _), b += function(E, C) {
          return E.host.full && (E.extra.relation.maximumAuth || C.output === l.ABSOLUTE) ? E.host.full : "";
        }(g, _), b += function(E) {
          return E.port && !E.extra.portIsDefault && E.extra.relation.maximumHost ? ":" + E.port : "";
        }(g), b += function(E, C) {
          var y = "", T = E.path.absolute.string, A = E.path.relative.string, k = h(E, C);
          return !E.extra.relation.maximumHost && C.output !== l.ABSOLUTE && C.output !== l.ROOT_RELATIVE && (A.length <= T.length && C.output === l.SHORTEST || C.output === l.PATH_RELATIVE) ? (y = A) === "" && (A = f(E, C) && !!d(E, C), (E.extra.relation.maximumPath && !k || E.extra.relation.overridesQuery && !k && !A) && (y = "./")) : y = T, y !== "/" || k || !C.removeRootTrailingSlash || E.extra.relation.minimumPort && C.output !== l.ABSOLUTE ? y : "";
        }(g, _), b += function(E, C) {
          return h(E, C) ? E.resource : "";
        }(g, _), (b += function(E, C) {
          return f(E, C) ? d(E, C) : "";
        }(g, _)) + function(E) {
          return E.hash || "";
        }(g);
      };
    }, function(a, s, r) {
      var l = r(136);
      a.exports = function(f, h) {
        if (l.isPlainObject(f)) {
          var p, g = {};
          for (p in h) h.hasOwnProperty(p) && (f[p] !== void 0 ? g[p] = function(b, v) {
            return v instanceof Object && b instanceof Object ? v instanceof Array && b instanceof Array ? v.concat(b) : l.shallowMerge(b, v) : b;
          }(f[p], h[p]) : g[p] = h[p]);
          return g;
        }
        return h;
      };
    }, function(a, s, r) {
      var l = r(462), d = r(463), f = r(464), h = r(465), p = r(466), g = r(467), _ = r(137);
      function b(v, E) {
        return (v = g(v, E)).valid === !1 || (d(v, E), h(v, E), f(v, E), p(v, E), l(v)), v;
      }
      a.exports = { from: function(E, C, y) {
        return E ? (E = b(E, C), C = _.resolveDotSegments(E.path.absolute.array), E.path.absolute.array = C, E.path.absolute.string = "/" + _.join(C), E) : y;
      }, to: b };
    }, function(a, s, r) {
      a.exports = function(d) {
        var f = !(d.scheme || d.auth || d.host.full || d.port), h = f && !d.path.absolute.string, p = h && !d.resource, g = p && !d.query.string.full.length, _ = g && !d.hash;
        d.extra.hrefInfo.minimumPathOnly = f, d.extra.hrefInfo.minimumResourceOnly = h, d.extra.hrefInfo.minimumQueryOnly = p, d.extra.hrefInfo.minimumHashOnly = g, d.extra.hrefInfo.empty = _;
      };
    }, function(a, s, r) {
      a.exports = function(d, f) {
        var h;
        !f.ignore_www || (h = d.host.full) && ((f = h).indexOf("www.") === 0 && (f = h.substr(4)), d.host.stripped = f);
      };
    }, function(a, s, r) {
      function l(d) {
        if (d === "/") return [];
        var f = [];
        return d.split("/").forEach(function(h) {
          h !== "" && f.push(h);
        }), f;
      }
      a.exports = function(f, h) {
        var p, g, _ = f.path.absolute.string;
        _ && (-1 < (p = _.lastIndexOf("/")) ? (++p < _.length && ((g = _.substr(p)) !== "." && g !== ".." ? (f.resource = g, _ = _.substr(0, p)) : _ += "/"), f.path.absolute.string = _, f.path.absolute.array = l(_)) : _ === "." || _ === ".." ? (f.path.absolute.string = _ += "/", f.path.absolute.array = l(_)) : (f.resource = _, f.path.absolute.string = null), f.extra.resourceIsIndex = function(v, E) {
          var C = !1;
          return E.directoryIndexes.every(function(y) {
            return y !== v || !(C = !0);
          }), C;
        }(f.resource, h));
      };
    }, function(a, s, r) {
      a.exports = function(d, f) {
        var h, p = -1;
        for (h in f.defaultPorts) if (h === d.scheme && f.defaultPorts.hasOwnProperty(h)) {
          p = f.defaultPorts[h];
          break;
        }
        -1 < p && (p = p.toString(), d.port === null && (d.port = p), d.extra.portIsDefault = d.port === p);
      };
    }, function(a, s, r) {
      var l = Object.prototype.hasOwnProperty;
      function d(f, h) {
        var p, g, _ = 0, b = "";
        for (p in f) p !== "" && l.call(f, p) === !0 && ((g = f[p]) === "" && h || (b += ++_ == 1 ? "?" : "&", p = encodeURIComponent(p), b += g !== "" ? p + "=" + encodeURIComponent(g).replace(/%20/g, "+") : p));
        return b;
      }
      a.exports = function(h, p) {
        h.query.string.full = d(h.query.object, !1), p.removeEmptyQueries && (h.query.string.stripped = d(h.query.object, !0));
      };
    }, function(a, s, r) {
      var l = r(27).parse;
      a.exports = function(f, h) {
        return function(g, _) {
          var b = !0;
          return _.rejectedSchemes.every(function(v) {
            return b = g.indexOf(v + ":") !== 0;
          }), b;
        }(f, h) ? function(g) {
          var _ = g.protocol;
          return _ && _.indexOf(":") === _.length - 1 && (_ = _.substr(0, _.length - 1)), g.host = { full: g.hostname, stripped: null }, g.path = { absolute: { array: null, string: g.pathname }, relative: { array: null, string: null } }, g.query = { object: g.query, string: { full: null, stripped: null } }, g.extra = { hrefInfo: { minimumPathOnly: null, minimumResourceOnly: null, minimumQueryOnly: null, minimumHashOnly: null, empty: null, separatorOnlyQuery: g.search === "?" }, portIsDefault: null, relation: { maximumScheme: null, maximumAuth: null, maximumHost: null, maximumPort: null, maximumPath: null, maximumResource: null, maximumQuery: null, maximumHash: null, minimumScheme: null, minimumAuth: null, minimumHost: null, minimumPort: null, minimumPath: null, minimumResource: null, minimumQuery: null, minimumHash: null, overridesQuery: null }, resourceIsIndex: null, slashes: g.slashes }, g.resource = null, g.scheme = _, delete g.hostname, delete g.pathname, delete g.protocol, delete g.search, delete g.slashes, g;
        }(l(f, !0, h.slashesDenoteHost)) : { href: f, valid: !1 };
      };
    }, function(a, s, r) {
      var l = r(469), d = r(471);
      a.exports = function(h, p, g) {
        return l(p, h, g), d(p, h, g), p;
      };
    }, function(a, s, r) {
      var l = r(470), d = r(136), f = r(137);
      a.exports = function(p, g, _) {
        l.upToPath(p, g, _), p.extra.relation.minimumScheme && (p.scheme = g.scheme), p.extra.relation.minimumAuth && (p.auth = g.auth), p.extra.relation.minimumHost && (p.host = d.clone(g.host)), p.extra.relation.minimumPort && function(v, E) {
          v.port = E.port, v.extra.portIsDefault = E.extra.portIsDefault;
        }(p, g), p.extra.relation.minimumScheme && function(v, E) {
          var C, y;
          v.extra.relation.maximumHost || !v.extra.hrefInfo.minimumResourceOnly ? (y = "/", (C = v.path.absolute.array) ? (v.extra.hrefInfo.minimumPathOnly && v.path.absolute.string.indexOf("/") !== 0 && (C = E.path.absolute.array.concat(C)), C = f.resolveDotSegments(C), y += f.join(C)) : C = [], v.path.absolute.array = C, v.path.absolute.string = y) : v.path = d.clone(E.path);
        }(p, g), l.pathOn(p, g, _), p.extra.relation.minimumResource && function(v, E) {
          v.resource = E.resource, v.extra.resourceIsIndex = E.extra.resourceIsIndex;
        }(p, g), p.extra.relation.minimumQuery && (p.query = d.clone(g.query)), p.extra.relation.minimumHash && (p.hash = g.hash);
      };
    }, function(a, s, r) {
      a.exports = { pathOn: function(d, y, E) {
        var C = d.extra.hrefInfo.minimumQueryOnly, p = d.extra.hrefInfo.minimumHashOnly, g = d.extra.hrefInfo.empty, v = d.extra.relation.minimumPort, _ = d.extra.relation.minimumScheme, b = v && d.path.absolute.string === y.path.absolute.string, v = d.resource === y.resource || !d.resource && y.extra.resourceIsIndex || E.removeDirectoryIndexes && d.extra.resourceIsIndex && !y.resource, v = b && (v || C || p || g), C = E.removeEmptyQueries ? "stripped" : "full", E = d.query.string[C], C = y.query.string[C], y = (g = v && !!E && E === C || (p || g) && !d.extra.hrefInfo.separatorOnlyQuery) && d.hash === y.hash;
        d.extra.relation.minimumPath = b, d.extra.relation.minimumResource = v, d.extra.relation.minimumQuery = g, d.extra.relation.minimumHash = y, d.extra.relation.maximumPort = !_ || _ && !b, d.extra.relation.maximumPath = !_ || _ && !v, d.extra.relation.maximumResource = !_ || _ && !g, d.extra.relation.maximumQuery = !_ || _ && !y, d.extra.relation.maximumHash = !_ || _ && !y, d.extra.relation.overridesQuery = b && d.extra.relation.maximumResource && !g && !!C;
      }, upToPath: function(d, f, _) {
        var b = d.extra.hrefInfo.minimumPathOnly, p = d.scheme === f.scheme || !d.scheme, g = p && (d.auth === f.auth || _.removeAuth || b), _ = _.ignore_www ? "stripped" : "full", b = (_ = g && (d.host[_] === f.host[_] || b)) && (d.port === f.port || b);
        d.extra.relation.minimumScheme = p, d.extra.relation.minimumAuth = g, d.extra.relation.minimumHost = _, d.extra.relation.minimumPort = b, d.extra.relation.maximumScheme = !p || p && !g, d.extra.relation.maximumAuth = !p || p && !_, d.extra.relation.maximumHost = !p || p && !b;
      } };
    }, function(a, s, r) {
      var l = r(137);
      a.exports = function(f, h, p) {
        f.extra.relation.minimumScheme && (h = function(_, b) {
          var v = [], E = !0, C = -1;
          return b.forEach(function(y, T) {
            E && (_[T] !== y ? E = !1 : C = T), E || v.push("..");
          }), _.forEach(function(y, T) {
            C < T && v.push(y);
          }), v;
        }(f.path.absolute.array, h.path.absolute.array), f.path.relative.array = h, f.path.relative.string = l.join(h));
      };
    }, function(a, s, r) {
      function l() {
      }
      function d() {
      }
      l.prototype.sort = function(f, h) {
        h = h || 0;
        for (var p = 0, g = this.keys.length; p < g; p++) {
          var _ = this.keys[p], b = _.slice(1), v = f.indexOf(b, h);
          if (v !== -1) {
            for (; v !== h && (f.splice(v, 1), f.splice(h, 0, b)), h++, (v = f.indexOf(b, h)) !== -1; ) ;
            return this[_].sort(f, h);
          }
        }
        return f;
      }, d.prototype = { add: function(h) {
        var p = this;
        h.forEach(function(g) {
          p[g = "$" + g] || (p[g] = [], p[g].processed = 0), p[g].push(h);
        });
      }, createSorter: function() {
        var h = this, p = new l();
        return p.keys = Object.keys(h).sort(function(g, _) {
          var b = h[g].length, v = h[_].length;
          return b < v ? 1 : v < b || g < _ ? -1 : _ < g ? 1 : 0;
        }).filter(function(g) {
          if (h[g].processed < h[g].length) {
            var _ = g.slice(1), b = new d();
            return h[g].forEach(function(v) {
              for (var E; (E = v.indexOf(_)) !== -1; ) v.splice(E, 1);
              v.forEach(function(C) {
                h["$" + C].processed++;
              }), b.add(v.slice(0));
            }), p[g] = b.createSorter(), !0;
          }
          return !1;
        }), p;
      } }, a.exports = d;
    }, function(a, s) {
      a.exports = {};
    }, function(a, s, r) {
      var l = r(475), d = r(51), f = Array.prototype.push;
      function h(_, b) {
        return b == 2 ? function(v, E) {
          return _(v, E);
        } : function(v) {
          return _(v);
        };
      }
      function p(_) {
        for (var b = _ ? _.length : 0, v = Array(b); b--; ) v[b] = _[b];
        return v;
      }
      function g(_, b) {
        return function() {
          var v = arguments.length;
          if (v) {
            for (var E = Array(v); v--; ) E[v] = arguments[v];
            var C = E[0] = b.apply(void 0, E);
            return _.apply(void 0, E), C;
          }
        };
      }
      a.exports = function _(b, v, E, C) {
        var y = typeof v == "function", T = v === Object(v);
        if (T && (C = E, E = v, v = void 0), E == null) throw new TypeError();
        var A = { cap: !("cap" in (C = C || {})) || C.cap, curry: !("curry" in C) || C.curry, fixed: !("fixed" in C) || C.fixed, immutable: !("immutable" in C) || C.immutable, rearg: !("rearg" in C) || C.rearg }, k = y ? E : d, N = "curry" in C && C.curry, j = "fixed" in C && C.fixed, I = "rearg" in C && C.rearg, B = y ? E.runInContext() : void 0, U = y ? E : { ary: b.ary, assign: b.assign, clone: b.clone, curry: b.curry, forEach: b.forEach, isArray: b.isArray, isError: b.isError, isFunction: b.isFunction, isWeakMap: b.isWeakMap, iteratee: b.iteratee, keys: b.keys, rearg: b.rearg, toInteger: b.toInteger, toPath: b.toPath }, H = U.ary, Q = U.assign, Y = U.clone, ie = U.curry, ce = U.forEach, $ = U.isArray, te = U.isError, V = U.isFunction, K = U.isWeakMap, ne = U.keys, J = U.rearg, L = U.toInteger, z = U.toPath, ee = ne(l.aryMethod), q = { castArray: function(je) {
          return function() {
            var qe = arguments[0];
            return $(qe) ? je(p(qe)) : je.apply(void 0, arguments);
          };
        }, iteratee: function(je) {
          return function() {
            var Ze = arguments[0], qe = arguments[1], Ge = je(Ze, qe), Ze = Ge.length;
            return A.cap && typeof qe == "number" ? (qe = 2 < qe ? qe - 2 : 1, Ze && Ze <= qe ? Ge : h(Ge, qe)) : Ge;
          };
        }, mixin: function(je) {
          return function(qe) {
            var Ge = this;
            if (!V(Ge)) return je(Ge, Object(qe));
            var Ze = [];
            return ce(ne(qe), function(tt) {
              V(qe[tt]) && Ze.push([tt, Ge.prototype[tt]]);
            }), je(Ge, Object(qe)), ce(Ze, function(tt) {
              var Qe = tt[1];
              V(Qe) ? Ge.prototype[tt[0]] = Qe : delete Ge.prototype[tt[0]];
            }), Ge;
          };
        }, nthArg: function(je) {
          return function(qe) {
            var Ge = qe < 0 ? 1 : L(qe) + 1;
            return ie(je(qe), Ge);
          };
        }, rearg: function(je) {
          return function(qe, Ge) {
            var Ze = Ge ? Ge.length : 0;
            return ie(je(qe, Ge), Ze);
          };
        }, runInContext: function(je) {
          return function(qe) {
            return _(b, je(qe), C);
          };
        } };
        function X(Ie, je, qe) {
          return !A.fixed || !j && l.skipFixed[Ie] ? je : (Ie = (Ie = l.methodSpread[Ie]) && Ie.start) === void 0 ? H(je, qe) : /* @__PURE__ */ function(Ze, tt) {
            return function() {
              for (var Qe = arguments.length, ke = Qe - 1, pe = Array(Qe); Qe--; ) pe[Qe] = arguments[Qe];
              var Se = pe[tt], he = pe.slice(0, tt);
              return Se && f.apply(he, Se), tt != ke && f.apply(he, pe.slice(tt + 1)), Ze.apply(this, he);
            };
          }(je, Ie);
        }
        function oe(Ie, je, qe) {
          return A.rearg && 1 < qe && (I || !l.skipRearg[Ie]) ? J(je, l.methodRearg[Ie] || l.aryRearg[qe]) : je;
        }
        function ae(Ie, je) {
          for (var qe = -1, Ge = (je = z(je)).length, Ze = Ge - 1, tt = Ie = Y(Object(Ie)); tt != null && ++qe < Ge; ) {
            var Qe = je[qe], ke = tt[Qe];
            ke == null || V(ke) || te(ke) || K(ke) || (tt[Qe] = Y(qe == Ze ? ke : Object(ke))), tt = tt[Qe];
          }
          return Ie;
        }
        function _e(Ie, je) {
          var qe = l.aliasToReal[Ie] || Ie, Ge = l.remap[qe] || qe, Ze = C;
          return function(pe) {
            var Qe = y ? B : U, ke = y ? B[Ge] : je, pe = Q(Q({}, Ze), pe);
            return _(Qe, qe, ke, pe);
          };
        }
        function ve(Ie, je) {
          return function() {
            var qe = arguments.length;
            if (!qe) return Ie();
            for (var Ge = Array(qe); qe--; ) Ge[qe] = arguments[qe];
            var Ze = A.rearg ? 0 : qe - 1;
            return Ge[Ze] = je(Ge[Ze]), Ie.apply(void 0, Ge);
          };
        }
        function Ee(Ie, je, qe) {
          var Ge, Ze = l.aliasToReal[Ie] || Ie, tt = je;
          return (Ie = q[Ze]) ? tt = Ie(je) : A.immutable && (l.mutate.array[Ze] ? tt = g(je, p) : l.mutate.object[Ze] ? tt = g(je, /* @__PURE__ */ function(ke) {
            return function(pe) {
              return ke({}, pe);
            };
          }(je)) : l.mutate.set[Ze] && (tt = g(je, ae))), ce(ee, function(Qe) {
            return ce(l.aryMethod[Qe], function(ke) {
              if (Ze == ke) return ke = (ke = l.methodSpread[Ze]) && ke.afterRearg, Ge = ke ? X(Ze, oe(Ze, tt, Qe), Qe) : oe(Ze, X(Ze, tt, Qe), Qe), Ge = function(Se, he, Te) {
                return N || A.curry && 1 < Te ? ie(he, Te) : he;
              }(0, Ge = function(Se, he) {
                if (A.cap) {
                  var Te = l.iterateeRearg[Se];
                  if (Te) return function(Ye, et) {
                    return ve(Ye, function(dt) {
                      var We = et.length;
                      return function(ft, At) {
                        return At == 2 ? function(ln, Jt) {
                          return ft.apply(void 0, arguments);
                        } : function(ln) {
                          return ft.apply(void 0, arguments);
                        };
                      }(J(h(dt, We), et), We);
                    });
                  }(he, Te);
                  if (Se = !y && l.iterateeAry[Se]) return function(Ye, et) {
                    return ve(Ye, function(dt) {
                      return typeof dt == "function" ? h(dt, et) : dt;
                    });
                  }(he, Se);
                }
                return he;
              }(Ze, Ge), Qe), !1;
            }), !Ge;
          }), (Ge = (Ge = Ge || tt) == je ? N ? ie(Ge, 1) : function() {
            return je.apply(this, arguments);
          } : Ge).convert = _e(Ze, je), Ge.placeholder = je.placeholder = qe, Ge;
        }
        if (!T) return Ee(v, E, k);
        var we = E, ze = [];
        return ce(ee, function(Ie) {
          ce(l.aryMethod[Ie], function(je) {
            var qe = we[l.remap[je] || je];
            qe && ze.push([je, Ee(je, qe, we)]);
          });
        }), ce(ne(we), function(Ie) {
          var je = we[Ie];
          if (typeof je == "function") {
            for (var qe = ze.length; qe--; ) if (ze[qe][0] == Ie) return;
            je.convert = _e(Ie, je), ze.push([Ie, je]);
          }
        }), ce(ze, function(Ie) {
          we[Ie[0]] = Ie[1];
        }), we.convert = function(je) {
          return we.runInContext.convert(je)(void 0);
        }, we.placeholder = we, ce(ne(we), function(Ie) {
          ce(l.realToAlias[Ie] || [], function(je) {
            we[je] = we[Ie];
          });
        }), we;
      };
    }, function(a, s) {
      s.aliasToReal = { each: "forEach", eachRight: "forEachRight", entries: "toPairs", entriesIn: "toPairsIn", extend: "assignIn", extendAll: "assignInAll", extendAllWith: "assignInAllWith", extendWith: "assignInWith", first: "head", conforms: "conformsTo", matches: "isMatch", property: "get", __: "placeholder", F: "stubFalse", T: "stubTrue", all: "every", allPass: "overEvery", always: "constant", any: "some", anyPass: "overSome", apply: "spread", assoc: "set", assocPath: "set", complement: "negate", compose: "flowRight", contains: "includes", dissoc: "unset", dissocPath: "unset", dropLast: "dropRight", dropLastWhile: "dropRightWhile", equals: "isEqual", identical: "eq", indexBy: "keyBy", init: "initial", invertObj: "invert", juxt: "over", omitAll: "omit", nAry: "ary", path: "get", pathEq: "matchesProperty", pathOr: "getOr", paths: "at", pickAll: "pick", pipe: "flow", pluck: "map", prop: "get", propEq: "matchesProperty", propOr: "getOr", props: "at", symmetricDifference: "xor", symmetricDifferenceBy: "xorBy", symmetricDifferenceWith: "xorWith", takeLast: "takeRight", takeLastWhile: "takeRightWhile", unapply: "rest", unnest: "flatten", useWith: "overArgs", where: "conformsTo", whereEq: "isMatch", zipObj: "zipObject" }, s.aryMethod = { 1: ["assignAll", "assignInAll", "attempt", "castArray", "ceil", "create", "curry", "curryRight", "defaultsAll", "defaultsDeepAll", "floor", "flow", "flowRight", "fromPairs", "invert", "iteratee", "memoize", "method", "mergeAll", "methodOf", "mixin", "nthArg", "over", "overEvery", "overSome", "rest", "reverse", "round", "runInContext", "spread", "template", "trim", "trimEnd", "trimStart", "uniqueId", "words", "zipAll"], 2: ["add", "after", "ary", "assign", "assignAllWith", "assignIn", "assignInAllWith", "at", "before", "bind", "bindAll", "bindKey", "chunk", "cloneDeepWith", "cloneWith", "concat", "conformsTo", "countBy", "curryN", "curryRightN", "debounce", "defaults", "defaultsDeep", "defaultTo", "delay", "difference", "divide", "drop", "dropRight", "dropRightWhile", "dropWhile", "endsWith", "eq", "every", "filter", "find", "findIndex", "findKey", "findLast", "findLastIndex", "findLastKey", "flatMap", "flatMapDeep", "flattenDepth", "forEach", "forEachRight", "forIn", "forInRight", "forOwn", "forOwnRight", "get", "groupBy", "gt", "gte", "has", "hasIn", "includes", "indexOf", "intersection", "invertBy", "invoke", "invokeMap", "isEqual", "isMatch", "join", "keyBy", "lastIndexOf", "lt", "lte", "map", "mapKeys", "mapValues", "matchesProperty", "maxBy", "meanBy", "merge", "mergeAllWith", "minBy", "multiply", "nth", "omit", "omitBy", "overArgs", "pad", "padEnd", "padStart", "parseInt", "partial", "partialRight", "partition", "pick", "pickBy", "propertyOf", "pull", "pullAll", "pullAt", "random", "range", "rangeRight", "rearg", "reject", "remove", "repeat", "restFrom", "result", "sampleSize", "some", "sortBy", "sortedIndex", "sortedIndexOf", "sortedLastIndex", "sortedLastIndexOf", "sortedUniqBy", "split", "spreadFrom", "startsWith", "subtract", "sumBy", "take", "takeRight", "takeRightWhile", "takeWhile", "tap", "throttle", "thru", "times", "trimChars", "trimCharsEnd", "trimCharsStart", "truncate", "union", "uniqBy", "uniqWith", "unset", "unzipWith", "without", "wrap", "xor", "zip", "zipObject", "zipObjectDeep"], 3: ["assignInWith", "assignWith", "clamp", "differenceBy", "differenceWith", "findFrom", "findIndexFrom", "findLastFrom", "findLastIndexFrom", "getOr", "includesFrom", "indexOfFrom", "inRange", "intersectionBy", "intersectionWith", "invokeArgs", "invokeArgsMap", "isEqualWith", "isMatchWith", "flatMapDepth", "lastIndexOfFrom", "mergeWith", "orderBy", "padChars", "padCharsEnd", "padCharsStart", "pullAllBy", "pullAllWith", "rangeStep", "rangeStepRight", "reduce", "reduceRight", "replace", "set", "slice", "sortedIndexBy", "sortedLastIndexBy", "transform", "unionBy", "unionWith", "update", "xorBy", "xorWith", "zipWith"], 4: ["fill", "setWith", "updateWith"] }, s.aryRearg = { 2: [1, 0], 3: [2, 0, 1], 4: [3, 2, 0, 1] }, s.iterateeAry = { dropRightWhile: 1, dropWhile: 1, every: 1, filter: 1, find: 1, findFrom: 1, findIndex: 1, findIndexFrom: 1, findKey: 1, findLast: 1, findLastFrom: 1, findLastIndex: 1, findLastIndexFrom: 1, findLastKey: 1, flatMap: 1, flatMapDeep: 1, flatMapDepth: 1, forEach: 1, forEachRight: 1, forIn: 1, forInRight: 1, forOwn: 1, forOwnRight: 1, map: 1, mapKeys: 1, mapValues: 1, partition: 1, reduce: 2, reduceRight: 2, reject: 1, remove: 1, some: 1, takeRightWhile: 1, takeWhile: 1, times: 1, transform: 2 }, s.iterateeRearg = { mapKeys: [1], reduceRight: [1, 0] }, s.methodRearg = { assignInAllWith: [1, 0], assignInWith: [1, 2, 0], assignAllWith: [1, 0], assignWith: [1, 2, 0], differenceBy: [1, 2, 0], differenceWith: [1, 2, 0], getOr: [2, 1, 0], intersectionBy: [1, 2, 0], intersectionWith: [1, 2, 0], isEqualWith: [1, 2, 0], isMatchWith: [2, 1, 0], mergeAllWith: [1, 0], mergeWith: [1, 2, 0], padChars: [2, 1, 0], padCharsEnd: [2, 1, 0], padCharsStart: [2, 1, 0], pullAllBy: [2, 1, 0], pullAllWith: [2, 1, 0], rangeStep: [1, 2, 0], rangeStepRight: [1, 2, 0], setWith: [3, 1, 2, 0], sortedIndexBy: [2, 1, 0], sortedLastIndexBy: [2, 1, 0], unionBy: [1, 2, 0], unionWith: [1, 2, 0], updateWith: [3, 1, 2, 0], xorBy: [1, 2, 0], xorWith: [1, 2, 0], zipWith: [1, 2, 0] }, s.methodSpread = { assignAll: { start: 0 }, assignAllWith: { start: 0 }, assignInAll: { start: 0 }, assignInAllWith: { start: 0 }, defaultsAll: { start: 0 }, defaultsDeepAll: { start: 0 }, invokeArgs: { start: 2 }, invokeArgsMap: { start: 2 }, mergeAll: { start: 0 }, mergeAllWith: { start: 0 }, partial: { start: 1 }, partialRight: { start: 1 }, without: { start: 1 }, zipAll: { start: 0 } }, s.mutate = { array: { fill: !0, pull: !0, pullAll: !0, pullAllBy: !0, pullAllWith: !0, pullAt: !0, remove: !0, reverse: !0 }, object: { assign: !0, assignAll: !0, assignAllWith: !0, assignIn: !0, assignInAll: !0, assignInAllWith: !0, assignInWith: !0, assignWith: !0, defaults: !0, defaultsAll: !0, defaultsDeep: !0, defaultsDeepAll: !0, merge: !0, mergeAll: !0, mergeAllWith: !0, mergeWith: !0 }, set: { set: !0, setWith: !0, unset: !0, update: !0, updateWith: !0 } }, s.realToAlias = function() {
        var r, l = Object.prototype.hasOwnProperty, d = s.aliasToReal, f = {};
        for (r in d) {
          var h = d[r];
          l.call(f, h) ? f[h].push(r) : f[h] = [r];
        }
        return f;
      }(), s.remap = { assignAll: "assign", assignAllWith: "assignWith", assignInAll: "assignIn", assignInAllWith: "assignInWith", curryN: "curry", curryRightN: "curryRight", defaultsAll: "defaults", defaultsDeepAll: "defaultsDeep", findFrom: "find", findIndexFrom: "findIndex", findLastFrom: "findLast", findLastIndexFrom: "findLastIndex", getOr: "get", includesFrom: "includes", indexOfFrom: "indexOf", invokeArgs: "invoke", invokeArgsMap: "invokeMap", lastIndexOfFrom: "lastIndexOf", mergeAll: "merge", mergeAllWith: "mergeWith", padChars: "pad", padCharsEnd: "padEnd", padCharsStart: "padStart", propertyOf: "get", rangeStep: "range", rangeStepRight: "rangeRight", restFrom: "rest", spreadFrom: "spread", trimChars: "trim", trimCharsEnd: "trimEnd", trimCharsStart: "trimStart", zipAll: "zip" }, s.skipFixed = { castArray: !0, flow: !0, flowRight: !0, iteratee: !0, mixin: !0, rearg: !0, runInContext: !0 }, s.skipRearg = { add: !0, assign: !0, assignIn: !0, bind: !0, bindKey: !0, concat: !0, difference: !0, divide: !0, eq: !0, gt: !0, gte: !0, isEqual: !0, lt: !0, lte: !0, matchesProperty: !0, merge: !0, multiply: !0, overArgs: !0, partial: !0, partialRight: !0, propertyOf: !0, random: !0, range: !0, rangeRight: !0, subtract: !0, zip: !0, zipObject: !0, zipObjectDeep: !0 };
    }, function(a, s, r) {
      a.exports = { ary: r(477), assign: r(174), clone: r(495), curry: r(496), forEach: r(74), isArray: r(13), isError: r(497), isFunction: r(71), isWeakMap: r(498), iteratee: r(499), keys: r(98), rearg: r(500), toInteger: r(61), toPath: r(501) };
    }, function(a, s, r) {
      var l = r(140);
      a.exports = function(f, h, p) {
        return h = p ? void 0 : h, h = f && h == null ? f.length : h, l(f, 128, void 0, void 0, void 0, void 0, h);
      };
    }, function(a, s, r) {
      var l = r(92), d = r(17);
      a.exports = function(h, p, g) {
        var _ = 1 & p, b = l(h);
        return function v() {
          return (this && this !== d && this instanceof v ? b : h).apply(_ ? g : this, arguments);
        };
      };
    }, function(a, s, r) {
      var l = r(117), d = r(92), f = r(219), h = r(222), p = r(227), g = r(145), _ = r(17);
      a.exports = function(v, E, C) {
        var y = d(v);
        return function T() {
          for (var A = arguments.length, k = Array(A), N = A, j = p(T); N--; ) k[N] = arguments[N];
          return (A -= (j = A < 3 && k[0] !== j && k[A - 1] !== j ? [] : g(k, j)).length) < C ? h(v, E, f, T.placeholder, void 0, k, j, void 0, void 0, C - A) : l(this && this !== _ && this instanceof T ? y : v, this, k);
        };
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        for (var f = l.length, h = 0; f--; ) l[f] === d && ++h;
        return h;
      };
    }, function(a, s) {
      a.exports = function() {
      };
    }, function(a, s) {
      a.exports = {};
    }, function(a, s, r) {
      var l = r(141), d = r(144), f = r(142), h = r(13), p = r(20), g = r(484), _ = Object.prototype.hasOwnProperty;
      function b(v) {
        if (p(v) && !h(v) && !(v instanceof l)) {
          if (v instanceof d) return v;
          if (_.call(v, "__wrapped__")) return g(v);
        }
        return new d(v);
      }
      b.prototype = f.prototype, a.exports = b.prototype.constructor = b;
    }, function(a, s, r) {
      var l = r(141), d = r(144), f = r(81);
      a.exports = function(p) {
        if (p instanceof l) return p.clone();
        var g = new d(p.__wrapped__, p.__chain__);
        return g.__actions__ = f(p.__actions__), g.__index__ = p.__index__, g.__values__ = p.__values__, g;
      };
    }, function(a, s) {
      var r = /\{\n\/\* \[wrapped with (.+)\] \*/, l = /,? & /;
      a.exports = function(f) {
        return (f = f.match(r)) ? f[1].split(l) : [];
      };
    }, function(a, s) {
      var r = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
      a.exports = function(d, f) {
        var h = f.length;
        if (!h) return d;
        var p = h - 1;
        return f[p] = (1 < h ? "& " : "") + f[p], f = f.join(2 < h ? ", " : " "), d.replace(r, `{
/* [wrapped with ` + f + `] */
`);
      };
    }, function(a, s, r) {
      var l = r(74), d = r(488), f = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];
      a.exports = function(p, g) {
        return l(f, function(_) {
          var b = "_." + _[0];
          g & _[1] && !d(p, b) && p.push(b);
        }), p.sort();
      };
    }, function(a, s, r) {
      var l = r(489);
      a.exports = function(f, h) {
        return !(f == null || !f.length) && -1 < l(f, h, 0);
      };
    }, function(a, s, r) {
      var l = r(119), d = r(490), f = r(491);
      a.exports = function(p, g, _) {
        return g == g ? f(p, g, _) : l(p, d, _);
      };
    }, function(a, s) {
      a.exports = function(l) {
        return l != l;
      };
    }, function(a, s) {
      a.exports = function(l, d, f) {
        for (var h = f - 1, p = l.length; ++h < p; ) if (l[h] === d) return h;
        return -1;
      };
    }, function(a, s, r) {
      var l = r(81), d = r(56), f = Math.min;
      a.exports = function(p, g) {
        for (var _ = p.length, b = f(g.length, _), v = l(p); b--; ) {
          var E = g[b];
          p[b] = d(E, _) ? v[E] : void 0;
        }
        return p;
      };
    }, function(a, s, r) {
      var l = r(117), d = r(92), f = r(17);
      a.exports = function(p, g, _, b) {
        var v = 1 & g, E = d(p);
        return function C() {
          for (var y = -1, T = arguments.length, A = -1, k = b.length, N = Array(k + T), j = this && this !== f && this instanceof C ? E : p; ++A < k; ) N[A] = b[A];
          for (; T--; ) N[A++] = arguments[++y];
          return l(j, v ? _ : this, N);
        };
      };
    }, function(a, s, r) {
      var l = r(220), d = r(221), f = r(145), h = "__lodash_placeholder__", p = Math.min;
      a.exports = function(_, b) {
        var v, E = _[1], C = b[1], y = E | C, T = C == 128 && E == 8 || C == 128 && E == 256 && _[7].length <= b[8] || C == 384 && b[7].length <= b[8] && E == 8;
        return (y < 131 || T) && (1 & C && (_[2] = b[2], y |= 1 & E ? 0 : 4), (E = b[3]) && (v = _[3], _[3] = v ? l(v, E, b[4]) : E, _[4] = v ? f(_[3], h) : b[4]), (E = b[5]) && (v = _[5], _[5] = v ? d(v, E, b[6]) : E, _[6] = v ? f(_[5], h) : b[6]), (E = b[7]) && (_[7] = E), 128 & C && (_[8] = _[8] == null ? b[8] : p(_[8], b[8])), _[9] == null && (_[9] = b[9]), _[0] = b[0], _[1] = y), _;
      };
    }, function(a, s, r) {
      var l = r(109);
      a.exports = function(f) {
        return l(f, 4);
      };
    }, function(a, s, r) {
      var l = r(140), d = 8;
      function f(h, p, g) {
        return (p = l(h, d, void 0, void 0, void 0, void 0, void 0, p = g ? void 0 : p)).placeholder = f.placeholder, p;
      }
      f.placeholder = {}, a.exports = f;
    }, function(a, s, r) {
      var l = r(30), d = r(20), f = r(176);
      a.exports = function(p) {
        if (!d(p)) return !1;
        var g = l(p);
        return g == "[object Error]" || g == "[object DOMException]" || typeof p.message == "string" && typeof p.name == "string" && !f(p);
      };
    }, function(a, s, r) {
      var l = r(40), d = r(20);
      a.exports = function(h) {
        return d(h) && l(h) == "[object WeakMap]";
      };
    }, function(a, s, r) {
      var l = r(109), d = r(21);
      a.exports = function(h) {
        return d(typeof h == "function" ? h : l(h, 1));
      };
    }, function(a, s, d) {
      var l = d(140), d = (d = d(116))(function(f, h) {
        return l(f, 256, void 0, void 0, void 0, h);
      });
      a.exports = d;
    }, function(a, s, r) {
      var l = r(58), d = r(81), f = r(13), h = r(45), p = r(171), g = r(33), _ = r(46);
      a.exports = function(v) {
        return f(v) ? l(v, g) : h(v) ? [v] : d(p(_(v)));
      };
    }, function(a, s, r) {
      r = r(503)(), a.exports = r;
    }, function(a, s, r) {
      var l = r(144), d = r(116), f = r(143), h = r(224), p = r(13), g = r(223);
      a.exports = function(b) {
        return d(function(v) {
          var E = v.length, C = E, y = l.prototype.thru;
          for (b && v.reverse(); C--; ) {
            if (typeof (T = v[C]) != "function") throw new TypeError("Expected a function");
            y && !N && h(T) == "wrapper" && (N = new l([], !0));
          }
          for (C = N ? C : E; ++C < E; ) var T = v[C], A = h(T), k = A == "wrapper" ? f(T) : void 0, N = k && g(k[0]) && k[1] == 424 && !k[4].length && k[9] == 1 ? N[h(k[0])].apply(N, k[3]) : T.length == 1 && g(T) ? N[A]() : N.thru(T);
          return function() {
            var j = arguments, I = j[0];
            if (N && j.length == 1 && p(I)) return N.plant(I).value();
            for (var B = 0, U = E ? v[B].apply(this, j) : I; ++B < E; ) U = v[B].call(this, U);
            return U;
          };
        });
      };
    }, function(a, s, r) {
      var l = r(67)("map", r(60));
      l.placeholder = r(51), a.exports = l;
    }, function(a, s, r) {
      var l = r(119), d = r(21), f = r(61), h = Math.max, p = Math.min;
      a.exports = function(_, b, v) {
        var E = _ == null ? 0 : _.length;
        if (!E) return -1;
        var C = E - 1;
        return v !== void 0 && (C = f(v), C = v < 0 ? h(E + C, 0) : p(C, E - 1)), l(_, d(b, 3), C, !0);
      };
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function f(h) {
        delete h.parent, h.children && h.children.length ? (0, d.default)(h.children, f) : delete h.children, h.attributes && Object.keys(h.attributes).length === 0 && delete h.attributes;
      };
      var d = l(r(42));
      a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(h) {
        return (0, d.default)(h, function(p) {
          return p === "true" || p !== "false" && p;
        });
      };
      var d = l(r(508));
      a.exports = s.default;
    }, function(a, s, r) {
      var l = r(111), d = r(158), f = r(21);
      a.exports = function(p, g) {
        var _ = {};
        return g = f(g, 3), d(p, function(b, v, E) {
          l(_, v, g(b, v, E));
        }), _;
      };
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function f(h) {
        h.attributes || (h.attributes = {}), h.children && (0, d.default)(h.children, f);
      };
      var d = l(r(42));
      a.exports = s.default;
    }, function(a, s, g) {
      var l = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.registerRule = function(v, E) {
        return typeof v != "function" ? console.error("Your rule must be a function") : (E ? _[E] = v : _[v.name] = v, !0);
      };
      var d = l(g(511)), f = l(g(512)), h = l(g(513)), p = l(g(514)), g = l(g(515)), _ = { validAttributes: d.default, validChildren: f.default, validTag: h.default, validTypes: p.default, errorAttr: g.default };
      s.default = _;
    }, function(a, s, r) {
      function l(p, g) {
        (g == null || g > p.length) && (g = p.length);
        for (var _ = 0, b = new Array(g); _ < g; _++) b[_] = p[_];
        return b;
      }
      var d = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(g, _) {
        var b = _.components, v = g.attributes;
        if (!(b = b[_ = g.tagName])) return null;
        var E = [].concat(function(y) {
          return function(A) {
            if (Array.isArray(A)) return l(A);
          }(y) || function(A) {
            if (typeof Symbol < "u" && A[Symbol.iterator] != null || A["@@iterator"] != null) return Array.from(A);
          }(y) || function(A, k) {
            if (A) {
              if (typeof A == "string") return l(A, k);
              var N = Object.prototype.toString.call(A).slice(8, -1);
              return (N = N === "Object" && A.constructor ? A.constructor.name : N) === "Map" || N === "Set" ? Array.from(A) : N === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(N) ? l(A, k) : void 0;
            }
          }(y) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }(Object.keys(b.allowedAttributes || {})), h);
        return (_ = Object.keys(v || {}).filter(function(C) {
          return !E.includes(C);
        })).length === 0 ? null : (v = (b = { attribute: 1 < _.length ? "Attributes" : "Attribute", illegal: 1 < _.length ? "are illegal" : "is illegal" }).attribute, b = b.illegal, (0, f.default)("".concat(v, " ").concat(_.join(", "), " ").concat(b), g));
      };
      var f = d(r(52)), h = ["mj-class", "css-class"];
      a.exports = s.default;
    }, function(a, s, r) {
      function l(h, p) {
        (p == null || p > h.length) && (p = h.length);
        for (var g = 0, _ = new Array(p); g < p; g++) _[g] = h[g];
        return _;
      }
      var d = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(p, E) {
        var _ = E.components, b = E.dependencies, v = E.skipElements, E = p.children, C = p.tagName;
        if (!_[C] || !E || !E.length) return null;
        var y, T = [], A = function(j, I) {
          var B = typeof Symbol < "u" && j[Symbol.iterator] || j["@@iterator"];
          if (!B) {
            if (Array.isArray(j) || (B = function(ce, $) {
              if (ce) {
                if (typeof ce == "string") return l(ce, $);
                var te = Object.prototype.toString.call(ce).slice(8, -1);
                return (te = te === "Object" && ce.constructor ? ce.constructor.name : te) === "Map" || te === "Set" ? Array.from(ce) : te === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(te) ? l(ce, $) : void 0;
              }
            }(j)) || I && j && typeof j.length == "number") {
              B && (j = B);
              var U = 0;
              return { s: I = function() {
              }, n: function() {
                return U >= j.length ? { done: !0 } : { done: !1, value: j[U++] };
              }, e: function(ce) {
                throw ce;
              }, f: I };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var H, Q = !0, Y = !1;
          return { s: function() {
            B = B.call(j);
          }, n: function() {
            var ce = B.next();
            return Q = ce.done, ce;
          }, e: function(ce) {
            Y = !0, H = ce;
          }, f: function() {
            try {
              Q || B.return == null || B.return();
            } finally {
              if (Y) throw H;
            }
          } };
        }(E);
        try {
          var k = function() {
            var j = y.value, I = j.tagName, B = _[I], U = b[C] || [];
            (!B || v.includes(I) || U.includes(I) || U.some(function(H) {
              return H instanceof RegExp && H.test(I);
            })) === !1 && (U = Object.keys(b).filter(function(H) {
              return b[H].includes(I) || b[H].some(function(Q) {
                return Q instanceof RegExp && Q.test(I);
              });
            }), T.push((0, f.default)("".concat(I, " cannot be used inside ").concat(C, ", only inside: ").concat(U.join(", ")), j)));
          };
          for (A.s(); !(y = A.n()).done; ) k();
        } catch (N) {
          A.e(N);
        } finally {
          A.f();
        }
        return T;
      };
      var f = d(r(52));
      a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(p, b) {
        var _ = b.components, b = p.tagName;
        return f.includes(b) || _[b] ? null : (0, d.default)("Element ".concat(b, " doesn't exist or is not registered"), p);
      };
      var d = l(r(52)), f = ["mj-all", "mj-class", "mj-selector", "mj-html-attribute"];
      a.exports = s.default;
    }, function(a, s, r) {
      function l(h, p) {
        (p == null || p > h.length) && (p = h.length);
        for (var g = 0, _ = new Array(p); g < p; g++) _[g] = h[g];
        return _;
      }
      var d = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(p, g) {
        var _ = g.components, b = g.initializeType, v = p.attributes, E = _[g = p.tagName];
        if (!E) return null;
        for (var C = [], y = 0, T = Object.entries(v || {}); y < T.length; y++) {
          var A = function(I, B) {
            return function(H) {
              if (Array.isArray(H)) return H;
            }(I) || function(H, Q) {
              var Y = H == null ? null : typeof Symbol < "u" && H[Symbol.iterator] || H["@@iterator"];
              if (Y != null) {
                var ie, ce, $, te, V = [], K = !0, ne = !1;
                try {
                  if ($ = (Y = Y.call(H)).next, Q !== 0) for (; !(K = (ie = $.call(Y)).done) && (V.push(ie.value), V.length !== Q); K = !0) ;
                } catch (J) {
                  ne = !0, ce = J;
                } finally {
                  try {
                    if (!K && Y.return != null && (te = Y.return(), Object(te) !== te)) return;
                  } finally {
                    if (ne) throw ce;
                  }
                }
                return V;
              }
            }(I, B) || function(H, Q) {
              if (H) {
                if (typeof H == "string") return l(H, Q);
                var Y = Object.prototype.toString.call(H).slice(8, -1);
                return (Y = Y === "Object" && H.constructor ? H.constructor.name : Y) === "Map" || Y === "Set" ? Array.from(H) : Y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Y) ? l(H, Q) : void 0;
              }
            }(I, B) || function() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }(T[y], 2), k = A[0], N = A[1];
          !(A = E.allowedAttributes && E.allowedAttributes[k]) || (N = new (b(A))(N)).isValid() === !1 && C.push((0, f.default)("Attribute ".concat(k, " ").concat(N.getErrorMessage()), p));
        }
        return C;
      };
      var f = d(r(52));
      a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(h) {
        var p = h.errors;
        return p ? p.map(function(_) {
          if (_.type !== "include") return null;
          var _ = (b = _.params).file, b = b.partialPath;
          return (0, d.default)("mj-include fails to read file : ".concat(_, " at ").concat(b), h);
        }) : null;
      };
      var d = l(r(52));
      a.exports = s.default;
    }, function(a, s, r) {
      function l(g) {
        return function(b) {
          if (Array.isArray(b)) return d(b);
        }(g) || function(b) {
          if (typeof Symbol < "u" && b[Symbol.iterator] != null || b["@@iterator"] != null) return Array.from(b);
        }(g) || function(b, v) {
          if (b) {
            if (typeof b == "string") return d(b, v);
            var E = Object.prototype.toString.call(b).slice(8, -1);
            return (E = E === "Object" && b.constructor ? b.constructor.name : E) === "Map" || E === "Set" ? Array.from(b) : E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E) ? d(b, v) : void 0;
          }
        }(g) || function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function d(g, _) {
        (_ == null || _ > g.length) && (_ = g.length);
        for (var b = 0, v = new Array(_); b < _; b++) v[b] = g[b];
        return v;
      }
      function f(g) {
        return (f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
          return typeof _;
        } : function(_) {
          return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
        })(g);
      }
      function h(g) {
        for (var _ = arguments.length, b = new Array(1 < _ ? _ - 1 : 0), v = 1; v < _; v++) b[v - 1] = arguments[v];
        if (b.length === 0) return g;
        for (var E = 0, C = b; E < C.length; E++) {
          var y = C[E];
          if (f(y) === "object" && y !== null) for (var T = 0, A = Object.keys(y); T < A.length; T++) {
            var k, N = A[T];
            typeof N == "string" ? (k = [], g[N] && k.push.apply(k, l(g[N])), y[N] && k.push.apply(k, l(y[N])), g[N] = Array.from(new Set(k))) : console.warn('dependency "tag" must be of type string');
          }
          else console.warn('"dependencies" must be an object.');
        }
        return g;
      }
      Object.defineProperty(s, "__esModule", { value: !0 }), s.registerDependencies = s.default = s.assignDependencies = void 0, s.assignDependencies = h;
      var p = {};
      s.registerDependencies = function(_) {
        h(p, _);
      }, s.default = p;
    }, function(a, s, r) {
      function l(U) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        })(U);
      }
      function d(U, H) {
        var Q, Y = Object.keys(U);
        return Object.getOwnPropertySymbols && (Q = Object.getOwnPropertySymbols(U), H && (Q = Q.filter(function(ie) {
          return Object.getOwnPropertyDescriptor(U, ie).enumerable;
        })), Y.push.apply(Y, Q)), Y;
      }
      function f(U) {
        for (var H = 1; H < arguments.length; H++) {
          var Q = arguments[H] != null ? arguments[H] : {};
          H % 2 ? d(Object(Q), !0).forEach(function(Y) {
            (function(ce, $, te) {
              ($ = function(K) {
                return K = function(J, L) {
                  if (l(J) != "object" || !J) return J;
                  var z = J[Symbol.toPrimitive];
                  if (z === void 0) return (L === "string" ? String : Number)(J);
                  if (l(L = z.call(J, L || "default")) != "object") return L;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(K, "string"), l(K) == "symbol" ? K : String(K);
              }($)) in ce ? Object.defineProperty(ce, $, { value: te, enumerable: !0, configurable: !0, writable: !0 }) : ce[$] = te;
            })(U, Y, Q[Y]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(U, Object.getOwnPropertyDescriptors(Q)) : d(Object(Q)).forEach(function(Y) {
            Object.defineProperty(U, Y, Object.getOwnPropertyDescriptor(Q, Y));
          });
        }
        return U;
      }
      var h = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = B, s.handleMjml3 = function(H) {
        var Q = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        return j(H) ? (Q.noMigrateWarn || console.log("MJML v3 syntax detected, migrating to MJML v4 syntax. Use mjml -m to get the migrated MJML."), B(H)) : H;
      };
      var p = h(r(94)), g = h(r(47)), _ = h(r(32)), b = h(r(138)), v = r(10), E = r(183), C = r(518), y = { indent_size: 2, wrap_attributes_indent_size: 2, max_preserve_newline: 0, preserve_newlines: !1 }, T = function(H) {
        return H.attributes;
      }, A = "facebook twitter google";
      function k(U) {
        var H = T(U), Q = function(ie) {
          var ce = (ie.attributes.display || A).split(" ");
          return delete ie.attributes.display, ce;
        }(U);
        return U.children = [], (0, _.default)(Q).forEach(function(Y) {
          var ie = Q[Y].replace(":url", "-noshare").replace(":share", ""), ce = ie.replace("-noshare", "");
          U.children.push({ tagName: "mj-social-element", attributes: { name: ie }, content: H["".concat(ce, "-content")] || "" }), (0, _.default)(H).forEach(function($) {
            $.match(ce) && !$.match("content") && (U.children[Y].attributes[$.replace("".concat(ce, "-"), "")] = U.attributes[$], delete U.attributes[$]);
          });
        }), (0, _.default)(H).forEach(function(Y) {
          Y.match("content") && delete H[Y];
        }), U;
      }
      function N(U) {
        return (0, _.default)(U).forEach(function(H) {
          if (H === "children") for (var Q = 0; Q < U.children.length; Q += 1) if (function(ie) {
            return C.unavailableTags.indexOf(ie) === -1;
          }(U.children[Q].tagName)) {
            switch (U.children[Q].tagName) {
              case "mj-body":
                U.children[Q] = function(ie) {
                  return ie.children[0].tagName === "mj-container" && (ie.attributes = ie.children[0].attributes, ie.children = ie.children[0].children), ie;
                }(U.children[Q]);
                break;
              case "mj-social":
                U.children[Q] = k(U.children[Q]);
                break;
              case "mj-navbar":
                U.children[Q] = function(ie) {
                  return ie.tagName = "mj-section", ie.attributes["full-width"] = "full-width", ie;
                }(U.children[Q]);
                break;
              case "mj-inline-links":
                U.children[Q].tagName = "mj-navbar";
                break;
              case "mj-link":
                U.children[Q].tagName = "mj-navbar-link";
                break;
              case "mj-hero":
                U.children[Q] = function(ie) {
                  var ce = (0, g.default)(ie.children, { tagName: "mj-hero-content" });
                  return f(f({}, ie), {}, { children: ce.children, attributes: f(f({}, ie.attributes), ce.attributes) });
                }(U.children[Q]);
            }
            U.children[Q].attributes = function(ie) {
              return (0, _.default)(ie).forEach(function(ce) {
                ie[ce] = function(te, V) {
                  for (var K = C.attributesWithUnit.length, ne = 0; ne < K; ne += 1) if (C.attributesWithUnit[ne] === te) return function(L) {
                    return isNaN(L) || (0, p.default)(L) ? L : "".concat(L, "px");
                  }(V);
                  return V;
                }(ce, ie[ce]);
              }), ie;
            }(U.children[Q].attributes), N(U.children[Q]);
          } else console.error("Ignoring unsupported tag : ".concat(U.children[Q].tagName, " on line ").concat(U.children[Q].line)), delete U.children[Q];
        }), U;
      }
      function j(U) {
        return U.tagName === "mj-container" || !(!U.children || !U.children.length) && U.children.some(j);
      }
      var I = function U(ce) {
        var Q = ce.tagName, Y = ce.attributes, ie = ce.children, ce = ce.content, ie = ie && 0 < ie.length ? ie.map(U).join(`
`) : ce || "", ce = Object.keys(Y).map(function($) {
          return "".concat($, '="').concat(Y[$], '"');
        }).join(" ");
        return "<".concat(Q).concat(ce === "" ? ">" : " ".concat(ce, ">")).concat(ie, "</").concat(Q, ">");
      };
      function B(U) {
        var H = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        return console.warn("mjml-migrate is deprecated and will be removed in mjml 5"), H = H.beautify, l(U) === "object" ? N(U) : (N(U = (0, b.default)(U, { components: v.components, ignoreIncludes: !0 })), H ? (0, E.html)(I(U), y) : I(U));
      }
    }, function(a, s, r) {
      a.exports = { unavailableTags: ["mj-html", "mj-invoice", "mj-list", "mj-location"], attributesWithUnit: ["background-size", "border-radius", "border-width", "cellpadding", "cellspacing", "font-size", "height", "icon-height", "ico-padding", "ico-padding-bottom", "ico-font-size", "ico-line-height", "ico-padding-left", "ico-padding-right", "ico-padding-top", "icon-size", "icon-width", "inner-padding", "letter-spacing", "padding", "padding-bottom", "padding-left", "padding-right", "padding-left", "tb-border-radius", "tb-width", "width"] };
    }, function(a, s, r) {
      function l($) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(te) {
          return typeof te;
        } : function(te) {
          return te && typeof Symbol == "function" && te.constructor === Symbol && te !== Symbol.prototype ? "symbol" : typeof te;
        })($);
      }
      function d($, te) {
        var V, K = Object.keys($);
        return Object.getOwnPropertySymbols && (V = Object.getOwnPropertySymbols($), te && (V = V.filter(function(ne) {
          return Object.getOwnPropertyDescriptor($, ne).enumerable;
        })), K.push.apply(K, V)), K;
      }
      function f($) {
        for (var te = 1; te < arguments.length; te++) {
          var V = arguments[te] != null ? arguments[te] : {};
          te % 2 ? d(Object(V), !0).forEach(function(K) {
            (function(J, L, z) {
              (L = function(q) {
                return q = function(oe, ae) {
                  if (l(oe) != "object" || !oe) return oe;
                  var _e = oe[Symbol.toPrimitive];
                  if (_e === void 0) return (ae === "string" ? String : Number)(oe);
                  if (l(ae = _e.call(oe, ae || "default")) != "object") return ae;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(q, "string"), l(q) == "symbol" ? q : String(q);
              }(L)) in J ? Object.defineProperty(J, L, { value: z, enumerable: !0, configurable: !0, writable: !0 }) : J[L] = z;
            })($, K, V[K]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties($, Object.getOwnPropertyDescriptors(V)) : d(Object(V)).forEach(function(K) {
            Object.defineProperty($, K, Object.getOwnPropertyDescriptor(V, K));
          });
        }
        return $;
      }
      var h = r(38).default, p = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.HeadComponent = s.BodyComponent = void 0, s.initComponent = ie;
      var g = p(r(6)), _ = p(r(7)), b = p(r(5)), v = p(r(4)), E = p(r(9)), C = p(r(520)), y = p(r(94)), T = p(r(118)), A = p(r(47)), k = p(r(230)), N = p(r(57)), j = p(r(25)), I = p(r(42)), B = p(r(43)), U = p(r(138)), H = h(r(532)), Q = p(r(533)), Y = p(r(544));
      function ie($) {
        var te = $.initialDatas, V = $.name;
        return ($ = te.context.components[V]) ? ((te = new $(te)).headStyle && te.context.addHeadStyle(V, te.headStyle), te.componentHeadStyle && te.context.addComponentHeadSyle(te.componentHeadStyle), te) : null;
      }
      var ce = function() {
        function $() {
          var z = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
          (0, b.default)(this, $);
          var te = (L = z.attributes) === void 0 ? {} : L, V = (ne = z.children) === void 0 ? [] : ne, K = (J = z.content) === void 0 ? "" : J, ne = (L = z.context) === void 0 ? {} : L, J = z.props, L = (L = z.globalAttributes) === void 0 ? {} : L, z = z.absoluteFilePath;
          return this.props = f(f({ absoluteFilePath: z === void 0 ? null : z }, J === void 0 ? {} : J), {}, { children: V, content: K }), this.attributes = (0, Q.default)(f(f(f({}, this.constructor.defaultAttributes), L), te), this.constructor.allowedAttributes), this.context = ne, this;
        }
        return (0, v.default)($, [{ key: "getChildContext", value: function() {
          return this.context;
        } }, { key: "getAttribute", value: function(V) {
          return this.attributes[V];
        } }, { key: "getContent", value: function() {
          return this.props.content.trim();
        } }, { key: "renderMJML", value: function(V) {
          var K = this, ne = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
          return typeof V != "string" ? this.context.processing(V, this.context) : (0, U.default)("<fragment>".concat(V, "</fragment>"), f(f({}, ne), {}, { components: this.context.components, ignoreIncludes: !0 })).children.map(function(J) {
            return K.context.processing(J, K.context);
          }).join("");
        } }], [{ key: "getTagName", value: function() {
          return this.componentName || (0, k.default)(this.name);
        } }, { key: "isRawElement", value: function() {
          return !!this.rawElement;
        } }]), $;
      }();
      (0, E.default)(ce, "defaultAttributes", {}), s.BodyComponent = function() {
        function $() {
          return (0, b.default)(this, $), (0, g.default)(this, $, arguments);
        }
        return (0, _.default)($, ce), (0, v.default)($, [{ key: "getStyles", value: function() {
          return {};
        } }, { key: "getShorthandAttrValue", value: function(J, K) {
          var ne = this.getAttribute("".concat(J, "-").concat(K)), J = this.getAttribute(J);
          return ne ? parseInt(ne, 10) : J ? (0, H.default)(J, K) : 0;
        } }, { key: "getShorthandBorderValue", value: function(K) {
          var ne = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "border", K = K && this.getAttribute("".concat(ne, "-").concat(K)), ne = this.getAttribute(ne);
          return (0, H.borderParser)(K || ne || "0");
        } }, { key: "getBoxWidths", value: function() {
          var V = this.context.containerWidth, K = parseInt(V, 10), ne = this.getShorthandAttrValue("padding", "right") + this.getShorthandAttrValue("padding", "left");
          return { totalWidth: K, borders: V = this.getShorthandBorderValue("right") + this.getShorthandBorderValue("left"), paddings: ne, box: K - ne - V };
        } }, { key: "htmlAttributes", value: function(V) {
          var K = this, ne = { style: function(L) {
            return K.styles(L);
          }, default: j.default };
          return (0, N.default)((0, C.default)(V, y.default), function(J, L, z) {
            return L = (ne[z] || ne.default)(L), "".concat(J, " ").concat(z, '="').concat(L, '"');
          }, "");
        } }, { key: "styles", value: function(V) {
          var K;
          return V && (K = typeof V == "string" ? (0, B.default)(this.getStyles(), V) : V), (0, N.default)(K, function(ne, J, L) {
            return (0, y.default)(J) ? ne : "".concat(ne).concat(L, ":").concat(J, ";");
          }, "");
        } }, { key: "renderChildren", value: function(V) {
          var K = this, ne = (ee = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}).props, J = ne === void 0 ? {} : ne, L = (ne = ee.renderer) === void 0 ? function(ve) {
            return ve.render();
          } : ne, z = (ne = ee.attributes) === void 0 ? {} : ne, ee = ee.rawXML;
          if (V = V || this.props.children, ee !== void 0 && ee) return V.map(function(ve) {
            return (0, Y.default)(ve);
          }).join(`
`);
          var q = V.length, X = (0, T.default)(this.context.components, function(ve) {
            return ve.isRawElement();
          }), oe = V.filter(function(ve) {
            return !(0, A.default)(X, function(Ee) {
              return Ee.getTagName() === ve.tagName;
            });
          }).length, ae = "", _e = 0;
          return (0, I.default)(V, function(ve) {
            (ve = ie({ name: ve.tagName, initialDatas: f(f({}, ve), {}, { attributes: f(f({}, z), ve.attributes), context: K.getChildContext(), props: f(f({}, J), {}, { first: _e === 0, index: _e, last: _e + 1 === q, sibling: q, nonRawSiblings: oe }) }) })) !== null && (ae += L(ve)), _e++;
          }), ae;
        } }]), $;
      }(), s.HeadComponent = function() {
        function $() {
          return (0, b.default)(this, $), (0, g.default)(this, $, arguments);
        }
        return (0, _.default)($, ce), (0, v.default)($, [{ key: "handlerChildren", value: function() {
          var V = this;
          return this.props.children.map(function(K) {
            var ne = ie({ name: K.tagName, initialDatas: f(f({}, K), {}, { context: V.getChildContext() }) });
            return ne ? (ne.handler && ne.handler(), ne.render ? ne.render() : null) : (console.error("No matching component for tag : ".concat(K.tagName)), null);
          });
        } }], [{ key: "getTagName", value: function() {
          return this.componentName || (0, k.default)(this.name);
        } }]), $;
      }();
    }, function(a, s, r) {
      var l = r(21), d = r(229), f = r(521);
      a.exports = function(p, g) {
        return f(p, d(l(g)));
      };
    }, function(a, s, r) {
      var l = r(58), d = r(21), f = r(522), h = r(114);
      a.exports = function(g, _) {
        if (g == null) return {};
        var b = l(h(g), function(v) {
          return [v];
        });
        return _ = d(_), f(g, b, function(v, E) {
          return _(v, E[0]);
        });
      };
    }, function(a, s, r) {
      var l = r(80), d = r(523), f = r(44);
      a.exports = function(p, g, _) {
        for (var b = -1, v = g.length, E = {}; ++b < v; ) {
          var C = g[b], y = l(p, C);
          _(y, C) && d(E, f(C, p), y);
        }
        return E;
      };
    }, function(a, s, r) {
      var l = r(110), d = r(44), f = r(56), h = r(19), p = r(33);
      a.exports = function(_, b, v, E) {
        if (!h(_)) return _;
        for (var C = -1, y = (b = d(b, _)).length, T = y - 1, A = _; A != null && ++C < y; ) {
          var k, N = p(b[C]), j = v;
          if (N === "__proto__" || N === "constructor" || N === "prototype") return _;
          C != T && (k = A[N], (j = E ? E(k, N, A) : void 0) === void 0 && (j = h(k) ? k : f(b[C + 1]) ? [] : {})), l(A, N, j), A = A[N];
        }
        return _;
      };
    }, function(a, s, r) {
      var l = r(160), d = r(525), f = r(528), h = RegExp("['’]", "g");
      a.exports = function(g) {
        return function(_) {
          return l(f(d(_).replace(h, "")), g, "");
        };
      };
    }, function(a, s, r) {
      var l = r(526), d = r(46), f = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, h = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
      a.exports = function(g) {
        return (g = d(g)) && g.replace(f, l).replace(h, "");
      };
    }, function(a, s, r) {
      r = r(527)({ À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", Ç: "C", ç: "c", Ð: "D", ð: "d", È: "E", É: "E", Ê: "E", Ë: "E", è: "e", é: "e", ê: "e", ë: "e", Ì: "I", Í: "I", Î: "I", Ï: "I", ì: "i", í: "i", î: "i", ï: "i", Ñ: "N", ñ: "n", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", Ù: "U", Ú: "U", Û: "U", Ü: "U", ù: "u", ú: "u", û: "u", ü: "u", Ý: "Y", ý: "y", ÿ: "y", Æ: "Ae", æ: "ae", Þ: "Th", þ: "th", ß: "ss", Ā: "A", Ă: "A", Ą: "A", ā: "a", ă: "a", ą: "a", Ć: "C", Ĉ: "C", Ċ: "C", Č: "C", ć: "c", ĉ: "c", ċ: "c", č: "c", Ď: "D", Đ: "D", ď: "d", đ: "d", Ē: "E", Ĕ: "E", Ė: "E", Ę: "E", Ě: "E", ē: "e", ĕ: "e", ė: "e", ę: "e", ě: "e", Ĝ: "G", Ğ: "G", Ġ: "G", Ģ: "G", ĝ: "g", ğ: "g", ġ: "g", ģ: "g", Ĥ: "H", Ħ: "H", ĥ: "h", ħ: "h", Ĩ: "I", Ī: "I", Ĭ: "I", Į: "I", İ: "I", ĩ: "i", ī: "i", ĭ: "i", į: "i", ı: "i", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", ĸ: "k", Ĺ: "L", Ļ: "L", Ľ: "L", Ŀ: "L", Ł: "L", ĺ: "l", ļ: "l", ľ: "l", ŀ: "l", ł: "l", Ń: "N", Ņ: "N", Ň: "N", Ŋ: "N", ń: "n", ņ: "n", ň: "n", ŋ: "n", Ō: "O", Ŏ: "O", Ő: "O", ō: "o", ŏ: "o", ő: "o", Ŕ: "R", Ŗ: "R", Ř: "R", ŕ: "r", ŗ: "r", ř: "r", Ś: "S", Ŝ: "S", Ş: "S", Š: "S", ś: "s", ŝ: "s", ş: "s", š: "s", Ţ: "T", Ť: "T", Ŧ: "T", ţ: "t", ť: "t", ŧ: "t", Ũ: "U", Ū: "U", Ŭ: "U", Ů: "U", Ű: "U", Ų: "U", ũ: "u", ū: "u", ŭ: "u", ů: "u", ű: "u", ų: "u", Ŵ: "W", ŵ: "w", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Ź: "Z", Ż: "Z", Ž: "Z", ź: "z", ż: "z", ž: "z", Ĳ: "IJ", ĳ: "ij", Œ: "Oe", œ: "oe", ŉ: "'n", ſ: "s" }), a.exports = r;
    }, function(a, s) {
      a.exports = function(l) {
        return function(d) {
          return l == null ? void 0 : l[d];
        };
      };
    }, function(a, s, r) {
      var l = r(529), d = r(530), f = r(46), h = r(531);
      a.exports = function(g, _, b) {
        return g = f(g), (_ = b ? void 0 : _) === void 0 ? (d(g) ? h : l)(g) : g.match(_) || [];
      };
    }, function(a, s) {
      var r = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      a.exports = function(d) {
        return d.match(r) || [];
      };
    }, function(a, s) {
      var r = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      a.exports = function(d) {
        return r.test(d);
      };
    }, function(a, s) {
      var r = "\\ud800-\\udfff", l = "[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]", d = "\\d+", f = "[\\u2700-\\u27bf]", h = "[a-z\\xdf-\\xf6\\xf8-\\xff]", p = "[^" + r + "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000" + d + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xff" + (T = "A-Z\\xc0-\\xd6\\xd8-\\xde") + "]", g = "(?:\\ud83c[\\udde6-\\uddff]){2}", _ = "[\\ud800-\\udbff][\\udc00-\\udfff]", b = "[" + T + "]", v = "(?:" + h + "|" + p + ")", E = "(?:" + b + "|" + p + ")", C = "(?:['’](?:d|ll|m|re|s|t|ve))?", y = "(?:['’](?:D|LL|M|RE|S|T|VE))?", T = (p = "[\\ufe0e\\ufe0f]?") + (T = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?") + "(?:\\u200d(?:" + ["[^" + r + "]", g, _].join("|") + ")" + p + T + ")*", T = "(?:" + [f, g, _].join("|") + ")" + T, A = RegExp([b + "?" + h + "+" + C + "(?=" + [l, b, "$"].join("|") + ")", E + "+" + y + "(?=" + [l, b + v, "$"].join("|") + ")", b + "?" + v + "+" + C, b + "+" + y, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", d, T].join("|"), "g");
      a.exports = function(N) {
        return N.match(A) || [];
      };
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.borderParser = function(h) {
        return parseInt((0, d.default)(h.match(/(?:(?:^| )(\d+))/), 1), 10) || 0;
      }, s.default = function(h, p) {
        var g = h.trim().replace(/\s+/g, " ").split(" ", 4), _ = {};
        switch (g.length) {
          case 2:
            _ = { top: 0, bottom: 0, left: 1, right: 1 };
            break;
          case 3:
            _ = { top: 0, left: 1, right: 1, bottom: 2 };
            break;
          case 4:
            _ = { top: 0, right: 1, bottom: 2, left: 3 };
            break;
          case 1:
          default:
            return parseInt(h, 10);
        }
        return parseInt(g[_[p]] || 0, 10);
      };
      var d = l(r(43));
    }, function(a, s, r) {
      function l(b) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
          return typeof v;
        } : function(v) {
          return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
        })(b);
      }
      function d(b, v) {
        var E, C = Object.keys(b);
        return Object.getOwnPropertySymbols && (E = Object.getOwnPropertySymbols(b), v && (E = E.filter(function(y) {
          return Object.getOwnPropertyDescriptor(b, y).enumerable;
        })), C.push.apply(C, E)), C;
      }
      function f(b) {
        for (var v = 1; v < arguments.length; v++) {
          var E = arguments[v] != null ? arguments[v] : {};
          v % 2 ? d(Object(E), !0).forEach(function(C) {
            h(b, C, E[C]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(E)) : d(Object(E)).forEach(function(C) {
            Object.defineProperty(b, C, Object.getOwnPropertyDescriptor(E, C));
          });
        }
        return b;
      }
      function h(b, v, E) {
        return (v = function(y) {
          return y = function(A, k) {
            if (l(A) != "object" || !A) return A;
            var N = A[Symbol.toPrimitive];
            if (N === void 0) return (k === "string" ? String : Number)(A);
            if (l(k = N.call(A, k || "default")) != "object") return k;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(y, "string"), l(y) == "symbol" ? y : String(y);
        }(v)) in b ? Object.defineProperty(b, v, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : b[v] = E, b;
      }
      var p = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(r(57)), _ = r(28);
      s.default = function(v, E) {
        return (0, g.default)(v, function(C, y, T) {
          if (E && E[T]) {
            var A = (0, _.initializeType)(E[T]);
            if (A) return A = new A(y), f(f({}, C), {}, h({}, T, A.getValue()));
          }
          return f(f({}, C), {}, h({}, T, y));
        }, {});
      }, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(163), d = r(21), f = r(535), h = r(13), p = r(147);
      a.exports = function(_, b, v) {
        var E = h(_) ? l : f;
        return v && p(_, b, v) && (b = void 0), E(_, d(b, 3));
      };
    }, function(a, s, r) {
      var l = r(55);
      a.exports = function(f, h) {
        var p;
        return l(f, function(g, _, b) {
          return !(p = h(g, _, b));
        }), !!p;
      };
    }, function(a, s, _) {
      var l = _(38).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(_(537)), f = l(_(538)), h = l(_(540)), p = l(_(541)), g = l(_(542)), _ = l(_(543));
      s.default = { boolean: { matcher: d.matcher, typeConstructor: d.default }, enum: { matcher: h.matcher, typeConstructor: h.default }, color: { matcher: f.matcher, typeConstructor: f.default }, unit: { matcher: p.matcher, typeConstructor: p.default }, string: { matcher: g.matcher, typeConstructor: g.default }, integer: { matcher: _.matcher, typeConstructor: _.default } }, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.matcher = s.default = void 0;
      var d = l(r(5)), f = l(r(4)), h = l(r(6)), p = l(r(7)), g = l(r(28));
      s.matcher = /^boolean/gim, s.default = function() {
        return function(b) {
          function v(E) {
            return (0, d.default)(this, v), (E = (0, h.default)(this, v, [E])).matchers = [/^true$/i, /^false$/i], E;
          }
          return (0, p.default)(v, b), (0, f.default)(v, [{ key: "isValid", value: function() {
            return this.value === !0 || this.value === !1;
          } }]), v;
        }(g.default);
      };
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.matcher = s.default = void 0;
      var d = l(r(5)), f = l(r(4)), h = l(r(6)), p = l(r(7)), g = l(r(28)), _ = l(r(539)), b = (s.matcher = /^color/gim, /^#\w{3}$/), v = /^#(\w)(\w)(\w)$/;
      s.default = function() {
        return function(C) {
          function y(T) {
            return (0, d.default)(this, y), (T = (0, h.default)(this, y, [T])).matchers = [/rgba\(\d{1,3},\s?\d{1,3},\s?\d{1,3},\s?\d(\.\d{1,3})?\)/gi, /rgb\(\d{1,3},\s?\d{1,3},\s?\d{1,3}\)/gi, /^#([0-9a-f]{3}){1,2}$/gi, new RegExp("^(".concat(_.default.join("|"), ")$"))], T;
          }
          return (0, p.default)(y, C), (0, f.default)(y, [{ key: "getValue", value: function() {
            return typeof this.value == "string" && this.value.match(b) ? this.value.replace(v, "#$1$1$2$2$3$3") : this.value;
          } }]), y;
        }(g.default);
      };
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.default = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "green", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "inherit", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "transparent", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"], a.exports = s.default;
    }, function(a, s, v) {
      var l = v(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.matcher = s.default = void 0;
      var d = l(v(4)), f = l(v(5)), h = l(v(6)), p = l(v(7)), g = l(v(9)), _ = l(v(231)), b = l(v(28)), v = (s.matcher = /^enum/gim, function(T) {
        var y = T.match(/\(([^)]+)\)/)[1].split(","), T = function(A) {
          function k(N) {
            return (0, f.default)(this, k), (N = (0, h.default)(this, k, [N])).matchers = y.map(function(j) {
              return new RegExp("^".concat((0, _.default)(j), "$"));
            }), N;
          }
          return (0, p.default)(k, A), (0, d.default)(k);
        }(b.default);
        return (0, g.default)(T, "errorMessage", "has invalid value: $value for type Enum, only accepts ".concat(y.join(", "))), T;
      });
      s.default = v;
    }, function(a, s, v) {
      var l = v(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.matcher = s.default = void 0;
      var d = l(v(4)), f = l(v(5)), h = l(v(6)), p = l(v(7)), g = l(v(9)), _ = l(v(231)), b = l(v(28)), v = (s.matcher = /^(unit|unitWithNegative)\(.*\)/gim, function(j) {
        var y = j.match(/^unitWithNegative/) ? "-|" : "", T = j.match(/\(([^)]+)\)/)[1].split(","), A = (j = j.match(/\{([^}]+)\}/)) && j[1] && j[1].split(",") || ["1"], k = T.includes("auto") ? "|auto" : "", N = T.filter(function(I) {
          return I !== "auto";
        }), j = function(I) {
          function B(U) {
            return (0, f.default)(this, B), (U = (0, h.default)(this, B, [U])).matchers = [new RegExp("^(((".concat(y, "\\d|,|\\.){1,}(").concat(N.map(_.default).join("|"), ")|0").concat(k, ")( )?){").concat(A.join(","), "}$"))], U;
          }
          return (0, p.default)(B, I), (0, d.default)(B);
        }(b.default);
        return (0, g.default)(j, "errorMessage", "has invalid value: $value for type Unit, only accepts (".concat(T.join(", "), ") units and ").concat(A.join(" to "), " value(s)")), j;
      });
      s.default = v;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.matcher = s.default = void 0;
      var d = l(r(4)), f = l(r(5)), h = l(r(6)), p = l(r(7)), g = l(r(28));
      s.matcher = /^string/gim, s.default = function() {
        return function(b) {
          function v(E) {
            return (0, f.default)(this, v), (E = (0, h.default)(this, v, [E])).matchers = [/.*/], E;
          }
          return (0, p.default)(v, b), (0, d.default)(v);
        }(g.default);
      };
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.matcher = s.default = void 0;
      var d = l(r(4)), f = l(r(5)), h = l(r(6)), p = l(r(7)), g = l(r(28));
      s.matcher = /^integer/gim, s.default = function() {
        return function(b) {
          function v(E) {
            return (0, f.default)(this, v), (E = (0, h.default)(this, v, [E])).matchers = [/\d+/], E;
          }
          return (0, p.default)(v, b), (0, d.default)(v);
        }(g.default);
      };
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.default = function l(g) {
        var f = g.tagName, h = g.attributes, p = g.children, g = g.content, p = p && 0 < p.length ? p.map(l).join(`
`) : g || "", g = Object.keys(h).map(function(_) {
          return "".concat(_, '="').concat(h[_], '"');
        }).join(" ");
        return "<".concat(f).concat(g === "" ? ">" : " ".concat(g, ">")).concat(p, "</").concat(f, ">");
      }, a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(d) {
        try {
          var f = Number.parseInt(d.match("[0-9]+")[0], 10);
          return "".concat(f - 1, "px");
        } catch {
          return d;
        }
      }, a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.default = function(d, f) {
        return d ? d.split(" ").map(function(h) {
          return "".concat(h, "-").concat(f);
        }).join(" ") : "";
      }, a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.default = function(d) {
        return d.replace(/(<!\[endif]-->\s*?<!--\[if mso \| IE]>)/gm, "");
      }, a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.default = function(d) {
        return d.replace(/(<!--\[if\s[^\]]+]>)([\s\S]*?)(<!\[endif]-->)/gm, function(f, h, p, g) {
          return p = p.replace(/(^|>)(\s+)(<|$)/gm, function(_, b, v, E) {
            return "".concat(b).concat(E);
          }).replace(/\s{2,}/gm, " "), "".concat(h).concat(p).concat(g);
        });
      }, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function($) {
        var E = (Y = $.backgroundColor) === void 0 ? "" : Y, C = (I = $.beforeDoctype) === void 0 ? "" : I, y = (B = $.breakpoint) === void 0 ? "480px" : B, T = (ie = $.content) === void 0 ? "" : ie, A = (U = $.fonts) === void 0 ? {} : U, k = (ce = $.mediaQueries) === void 0 ? {} : ce, N = (H = $.headStyle) === void 0 ? {} : H, j = (Q = $.componentsHeadStyle) === void 0 ? [] : Q, I = (Y = $.headRaw) === void 0 ? [] : Y, B = $.preview, U = (ie = $.title) === void 0 ? "" : ie, H = (ce = $.style) === void 0 ? [] : ce, Q = $.forceOWADesktop, Y = $.printerSupport, ie = $.inlineStyle, ce = $.lang, $ = $.dir;
        return "".concat(C ? "".concat(C, `
`) : "", `<!doctype html>
<html lang="`).concat(ce, '" dir="').concat($, `" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
  <head>
    <title>`).concat(U, `</title>
    <!--[if !mso]><!-->
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <!--<![endif]-->
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style type="text/css">
      #outlook a { padding:0; }
      body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
      table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
      img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
      p { display:block;margin:13px 0; }
    </style>
    <!--[if mso]>
    <noscript>
    <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
    </xml>
    </noscript>
    <![endif]-->
    <!--[if lte mso 11]>
    <style type="text/css">
      .mj-outlook-group-fix { width:100% !important; }
    </style>
    <![endif]-->
    `).concat((0, p.buildFontsTags)(T, ie, A), `
    `).concat((0, g.default)(y, k, { forceOWADesktop: Q, printerSupport: Y }), `
    `).concat((0, _.buildStyleFromComponents)(y, j, N), `
    `).concat((0, _.buildStyleFromTags)(y, H), `
    `).concat(I.filter((0, f.default)(d.default)).join(`
`), `
  </head>
  <body style="word-spacing:normal;`).concat(E ? "background-color:".concat(E, ";") : "", `">
    `).concat((0, h.default)(B), `
    `).concat(T, `
  </body>
</html>
  `);
      };
      var d = l(r(94)), f = l(r(229)), h = l(r(550)), p = r(551), g = l(r(552)), _ = r(553);
      a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(d) {
        return d !== "" ? `
    <div style="display:none;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">`.concat(d, `</div>
  `) : "";
      }, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.buildFontsTags = function(p, g) {
        var _ = [];
        return (0, f.default)(2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {}, function(b, v) {
          var E = new RegExp('"[^"]*font-family:[^"]*'.concat(v, '[^"]*"'), "gmi"), C = new RegExp("font-family:[^;}]*".concat(v), "gmi");
          (p.match(E) || g.some(function(y) {
            return y.match(C);
          })) && _.push(b);
        }), 0 < _.length ? `
      <!--[if !mso]><!-->
        `.concat((0, d.default)(_, function(b) {
          return '<link href="'.concat(b, '" rel="stylesheet" type="text/css">');
        }).join(`
`), `
        <style type="text/css">
          `).concat((0, d.default)(_, function(b) {
          return "@import url(".concat(b, ");");
        }).join(`
`), `
        </style>
      <!--<![endif]-->

    `) : "";
      };
      var d = l(r(60)), f = l(r(42));
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function(p) {
        var E = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}, b = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {};
        if ((0, d.default)(E)) return "";
        var g = (_ = b.forceOWADesktop) !== void 0 && _, _ = (v = b.printerSupport) !== void 0 && v, b = (0, f.default)(E, function(C, y) {
          return ".".concat(y, " ").concat(C);
        }), v = (0, f.default)(E, function(C, y) {
          return ".moz-text-html .".concat(y, " ").concat(C);
        }), E = (0, f.default)(b, function(C) {
          return "[owa] ".concat(C);
        });
        return `
    <style type="text/css">
      @media only screen and (min-width:`.concat(p, `) {
        `).concat(b.join(`
`), `
      }
    </style>
    <style media="screen and (min-width:`).concat(p, `)">
      `).concat(v.join(`
`), `
    </style>
    `).concat(_ ? `<style type="text/css">
            @media only print {
              `.concat(b.join(`
`), `
            }
          </style>`) : "", `
    `).concat(g ? `<style type="text/css">
`.concat(E.join(`
`), `
</style>`) : "", `
  `);
      };
      var d = l(r(152)), f = l(r(60));
      a.exports = s.default;
    }, function(a, s, r) {
      function l(h, p) {
        (p == null || p > h.length) && (p = h.length);
        for (var g = 0, _ = new Array(p); g < p; g++) _[g] = h[g];
        return _;
      }
      var d = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.buildStyleFromComponents = function(p, g, _) {
        return _ = Object.values(_), g.length !== 0 || _.length !== 0 ? `
    <style type="text/css">`.concat([].concat(function(v) {
          return function(C) {
            if (Array.isArray(C)) return l(C);
          }(v) || function(C) {
            if (typeof Symbol < "u" && C[Symbol.iterator] != null || C["@@iterator"] != null) return Array.from(C);
          }(v) || function(C, y) {
            if (C) {
              if (typeof C == "string") return l(C, y);
              var T = Object.prototype.toString.call(C).slice(8, -1);
              return (T = T === "Object" && C.constructor ? C.constructor.name : T) === "Map" || T === "Set" ? Array.from(C) : T === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(T) ? l(C, y) : void 0;
            }
          }(v) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }(g), _).reduce(function(b, v) {
          return "".concat(b, `
`).concat(v(p));
        }, ""), `
    </style>`) : "";
      }, s.buildStyleFromTags = function(p, g) {
        return g.length !== 0 ? ` 
    <style type="text/css">`.concat(g.reduce(function(_, b) {
          return "".concat(_, `
`).concat((0, f.default)(b) ? b(p) : b);
        }, ""), `
    </style>`) : "";
      };
      var f = d(r(71));
    }, function(a, s, r) {
      (function(l) {
        var d = r(1).default;
        Object.defineProperty(s, "__esModule", { value: !0 }), s.default = function() {
          var k = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : l.cwd(), y = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : g.registerComponent, T = _(k), A = T.mjmlConfig.packages, k = T.componentRootPath;
          return (T = T.error) ? { error: T } : E(A, k, y);
        }, s.handleMjmlConfigComponents = E, s.readMjmlConfig = _, s.registerCustomComponent = v, s.resolveComponentPath = b;
        var f = d(r(22)), h = d(r(65)), p = r(93), g = r(232);
        function _() {
          var C = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : l.cwd(), y = l.cwd(), T = C;
          try {
            var T = f.default.basename(C).match(/^\.mjmlconfig(\.js)?$/) ? f.default.resolve(C) : f.default.resolve(C, ".mjmlconfig"), y = f.default.dirname(T), A = f.default.resolve(T);
            return { mjmlConfig: f.default.extname(T) === ".js" ? (delete r.c[A], r(95)(A)) : JSON.parse(h.default.readFileSync(A, "utf8")), componentRootPath: y };
          } catch (k) {
            return k.code !== "ENOENT" && console.error("Error reading mjmlconfig : ", k), { mjmlConfig: { packages: [], options: {} }, mjmlConfigPath: T, componentRootPath: y, error: k };
          }
        }
        function b(C, y) {
          if (!C) return null;
          if (!C.startsWith(".") && !f.default.isAbsolute(C)) try {
            return r(95).resolve(C);
          } catch (T) {
            if (T.code !== "MODULE_NOT_FOUND") return console.error("Error resolving custom component path : ", T), null;
            try {
              return b("./node_modules/".concat(C), y);
            } catch {
              return b("./".concat(C), y);
            }
          }
          return r(95).resolve(f.default.resolve(y, C));
        }
        function v(C) {
          var y = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : g.registerComponent;
          C instanceof Function ? y(C) : Object.keys(C).forEach(function(T) {
            v(C[T], y);
          });
        }
        function E(C, y, T) {
          var A = { success: [], failures: [] };
          return C.forEach(function(k) {
            var N, j = k;
            try {
              (j = b(k, y)) && (v((N = r(95)(j)).default || N, T), (0, p.registerDependencies)((N.default || N).dependencies || {}), A.success.push(k));
            } catch (I) {
              A.failures.push({ error: I, compPath: k }), I.code === "ENOENT" || I.code === "MODULE_NOT_FOUND" ? console.error("Missing or unreadable custom component : ", j) : console.error("Error when registering custom component : ", j, I);
            }
          }), A;
        }
      }).call(this, r(15));
    }, function(a, s) {
      function r(l) {
        throw (l = new Error("Cannot find module '" + l + "'")).code = "MODULE_NOT_FOUND", l;
      }
      r.keys = function() {
        return [];
      }, (a.exports = r.resolve = r).id = 555;
    }, function(a, s, te) {
      var l = te(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = te(557), f = te(560), h = te(563), p = te(573), g = l(te(576)), _ = l(te(577)), b = l(te(578)), v = l(te(579)), E = l(te(580)), C = l(te(581)), y = l(te(582)), T = l(te(583)), A = l(te(584)), k = l(te(585)), N = l(te(588)), j = l(te(589)), I = l(te(590)), B = l(te(591)), U = l(te(592)), H = l(te(593)), Q = l(te(239)), Y = l(te(594)), ie = l(te(595)), ce = l(te(596)), $ = l(te(597)), te = l(te(598)), te = { components: [g.default, _.default, b.default, v.default, E.default, C.default, y.default, T.default, A.default, k.default, N.default, j.default, I.default, B.default, U.default, H.default, Q.default, Y.default, ie.default, ce.default, $.default, d.Social, d.SocialElement, f.Navbar, f.NavbarLink, p.Accordion, p.AccordionElement, p.AccordionText, p.AccordionTitle, h.Carousel, h.CarouselImage], dependencies: te.default };
      s.default = te, a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), Object.defineProperty(s, "Social", { enumerable: !0, get: function() {
        return d.default;
      } }), Object.defineProperty(s, "SocialElement", { enumerable: !0, get: function() {
        return f.default;
      } });
      var d = l(r(558)), f = l(r(559));
    }, function(a, s, b) {
      var l = b(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(b(5)), f = l(b(4)), h = l(b(6)), p = l(b(7)), g = l(b(9)), _ = l(b(94)), b = b(10), b = s.default = function(v) {
        function E() {
          return (0, d.default)(this, E), (0, h.default)(this, E, arguments);
        }
        return (0, p.default)(E, v), (0, f.default)(E, [{ key: "getStyles", value: function() {
          return { tableVertical: { margin: "0px" } };
        } }, { key: "getSocialElementAttributes", value: function() {
          var y = this, T = {};
          return this.getAttribute("inner-padding") && (T.padding = this.getAttribute("inner-padding")), ["border-radius", "color", "font-family", "font-size", "font-weight", "font-style", "icon-size", "icon-height", "icon-padding", "text-padding", "line-height", "text-decoration"].filter(function(A) {
            return !(0, _.default)(y.getAttribute(A));
          }).reduce(function(A, k) {
            return A[k] = y.getAttribute(k), A;
          }, T);
        } }, { key: "renderHorizontal", value: function() {
          var y = this, T = this.props.children;
          return `
     <!--[if mso | IE]>
      <table
        `.concat(this.htmlAttributes({ align: this.getAttribute("align"), border: "0", cellpadding: "0", cellspacing: "0", role: "presentation" }), `
      >
        <tr>
      <![endif]-->
      `).concat(this.renderChildren(T, { attributes: this.getSocialElementAttributes(), renderer: function(k) {
            return k.constructor.isRawElement() ? k.render() : `
            <!--[if mso | IE]>
              <td>
            <![endif]-->
              <table
                `.concat(k.htmlAttributes({ align: y.getAttribute("align"), border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: { float: "none", display: "inline-table" } }), `
              >
                <tbody>
                  `).concat(k.render(), `
                </tbody>
              </table>
            <!--[if mso | IE]>
              </td>
            <![endif]-->
          `);
          } }), `
      <!--[if mso | IE]>
          </tr>
        </table>
      <![endif]-->
    `);
        } }, { key: "renderVertical", value: function() {
          var y = this.props.children;
          return `
      <table
        `.concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "tableVertical" }), `
      >
        <tbody>
          `).concat(this.renderChildren(y, { attributes: this.getSocialElementAttributes() }), `
        </tbody>
      </table>
    `);
        } }, { key: "render", value: function() {
          return `
      `.concat(this.getAttribute("mode") === "horizontal" ? this.renderHorizontal() : this.renderVertical(), `
    `);
        } }]), E;
      }(b.BodyComponent);
      (0, g.default)(b, "componentName", "mj-social"), (0, g.default)(b, "allowedAttributes", { align: "enum(left,right,center)", "border-radius": "unit(px,%)", "container-background-color": "color", color: "color", "font-family": "string", "font-size": "unit(px)", "font-style": "string", "font-weight": "string", "icon-size": "unit(px,%)", "icon-height": "unit(px,%)", "icon-padding": "unit(px,%){1,4}", "inner-padding": "unit(px,%){1,4}", "line-height": "unit(px,%,)", mode: "enum(horizontal,vertical)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", "table-layout": "enum(auto,fixed)", "text-padding": "unit(px,%){1,4}", "text-decoration": "string", "vertical-align": "enum(top,bottom,middle)" }), (0, g.default)(b, "defaultAttributes", { align: "center", "border-radius": "3px", color: "#333333", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "font-size": "13px", "icon-size": "20px", "inner-padding": null, "line-height": "22px", mode: "horizontal", padding: "10px 25px", "text-decoration": "none" }), a.exports = s.default;
    }, function(a, s, T) {
      function l(k) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
          return typeof N;
        } : function(N) {
          return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
        })(k);
      }
      function d(k, N) {
        var j, I = Object.keys(k);
        return Object.getOwnPropertySymbols && (j = Object.getOwnPropertySymbols(k), N && (j = j.filter(function(B) {
          return Object.getOwnPropertyDescriptor(k, B).enumerable;
        })), I.push.apply(I, j)), I;
      }
      function f(k) {
        for (var N = 1; N < arguments.length; N++) {
          var j = arguments[N] != null ? arguments[N] : {};
          N % 2 ? d(Object(j), !0).forEach(function(I) {
            h(k, I, j[I]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(k, Object.getOwnPropertyDescriptors(j)) : d(Object(j)).forEach(function(I) {
            Object.defineProperty(k, I, Object.getOwnPropertyDescriptor(j, I));
          });
        }
        return k;
      }
      function h(k, N, j) {
        return (N = function(B) {
          return B = function(H, Q) {
            if (l(H) != "object" || !H) return H;
            var Y = H[Symbol.toPrimitive];
            if (Y === void 0) return (Q === "string" ? String : Number)(H);
            if (l(Q = Y.call(H, Q || "default")) != "object") return Q;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(B, "string"), l(B) == "symbol" ? B : String(B);
        }(N)) in k ? Object.defineProperty(k, N, { value: j, enumerable: !0, configurable: !0, writable: !0 }) : k[N] = j, k;
      }
      var y = T(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var p = y(T(5)), g = y(T(4)), _ = y(T(6)), b = y(T(7)), v = y(T(9)), E = y(T(157)), C = y(T(43)), y = T(10), T = "https://www.mailjet.com/images/theme/v1/icons/ico-social/", A = { facebook: { "share-url": "https://www.facebook.com/sharer/sharer.php?u=[[URL]]", "background-color": "#3b5998", src: "".concat(T, "facebook.png") }, twitter: { "share-url": "https://twitter.com/intent/tweet?url=[[URL]]", "background-color": "#55acee", src: "".concat(T, "twitter.png") }, x: { "share-url": "https://twitter.com/intent/tweet?url=[[URL]]", "background-color": "#000000", src: "".concat(T, "twitter-x.png") }, google: { "share-url": "https://plus.google.com/share?url=[[URL]]", "background-color": "#dc4e41", src: "".concat(T, "google-plus.png") }, pinterest: { "share-url": "https://pinterest.com/pin/create/button/?url=[[URL]]&media=&description=", "background-color": "#bd081c", src: "".concat(T, "pinterest.png") }, linkedin: { "share-url": "https://www.linkedin.com/shareArticle?mini=true&url=[[URL]]&title=&summary=&source=", "background-color": "#0077b5", src: "".concat(T, "linkedin.png") }, instagram: { "background-color": "#3f729b", src: "".concat(T, "instagram.png") }, web: { src: "".concat(T, "web.png"), "background-color": "#4BADE9" }, snapchat: { src: "".concat(T, "snapchat.png"), "background-color": "#FFFA54" }, youtube: { src: "".concat(T, "youtube.png"), "background-color": "#EB3323" }, tumblr: { src: "".concat(T, "tumblr.png"), "share-url": "https://www.tumblr.com/widgets/share/tool?canonicalUrl=[[URL]]", "background-color": "#344356" }, github: { src: "".concat(T, "github.png"), "background-color": "#000000" }, xing: { src: "".concat(T, "xing.png"), "share-url": "https://www.xing.com/app/user?op=share&url=[[URL]]", "background-color": "#296366" }, vimeo: { src: "".concat(T, "vimeo.png"), "background-color": "#53B4E7" }, medium: { src: "".concat(T, "medium.png"), "background-color": "#000000" }, soundcloud: { src: "".concat(T, "soundcloud.png"), "background-color": "#EF7F31" }, dribbble: { src: "".concat(T, "dribbble.png"), "background-color": "#D95988" } };
      (0, E.default)(A, function(k, N) {
        A["".concat(N, "-noshare")] = f(f({}, k), {}, { "share-url": "[[URL]]" });
      }), y = s.default = function(k) {
        function N() {
          return (0, p.default)(this, N), (0, _.default)(this, N, arguments);
        }
        return (0, b.default)(N, k), (0, g.default)(N, [{ key: "getStyles", value: function() {
          var I = (U = this.getSocialAttributes())["icon-size"], B = U["icon-height"], U = U["background-color"];
          return { td: { padding: this.getAttribute("padding"), "padding-top": this.getAttribute("padding-top"), "padding-right": this.getAttribute("padding-right"), "padding-bottom": this.getAttribute("padding-bottom"), "padding-left": this.getAttribute("padding-left"), "vertical-align": this.getAttribute("vertical-align") }, table: { background: U, "border-radius": this.getAttribute("border-radius"), width: I }, icon: { padding: this.getAttribute("icon-padding"), "font-size": "0", height: B || I, "vertical-align": "middle", width: I }, img: { "border-radius": this.getAttribute("border-radius"), display: "block" }, tdText: { "vertical-align": "middle", padding: this.getAttribute("text-padding") }, text: { color: this.getAttribute("color"), "font-size": this.getAttribute("font-size"), "font-weight": this.getAttribute("font-weight"), "font-style": this.getAttribute("font-style"), "font-family": this.getAttribute("font-family"), "line-height": this.getAttribute("line-height"), "text-decoration": this.getAttribute("text-decoration") } };
        } }, { key: "getSocialAttributes", value: function() {
          var I = this, B = A[this.getAttribute("name")] || {}, U = this.getAttribute("href");
          U && (0, C.default)(B, "share-url") && (U = B["share-url"].replace("[[URL]]", U));
          var H = ["icon-size", "icon-height", "srcset", "sizes", "src", "background-color"].reduce(function(Q, Y) {
            return f(f({}, Q), {}, h({}, Y, I.getAttribute(Y) || B[Y]));
          }, {});
          return f({ href: U }, H);
        } }, { key: "render", value: function() {
          var I = (ie = this.getSocialAttributes()).src, B = ie.srcset, U = ie.sizes, H = ie.href, Q = ie["icon-size"], Y = ie["icon-height"], ie = !!this.getAttribute("href");
          return `
      <tr
        `.concat(this.htmlAttributes({ class: this.getAttribute("css-class") }), `
      >
        <td `).concat(this.htmlAttributes({ style: "td" }), `>
          <table
            `).concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "table" }), `
          >
            <tbody>
              <tr>
                <td `).concat(this.htmlAttributes({ style: "icon" }), `>
                  `).concat(ie ? "<a ".concat(this.htmlAttributes({ href: H, rel: this.getAttribute("rel"), target: this.getAttribute("target") }), ">") : "", `
                    <img
                      `).concat(this.htmlAttributes({ alt: this.getAttribute("alt"), title: this.getAttribute("title"), height: parseInt(Y || Q, 10), src: I, style: "img", width: parseInt(Q, 10), sizes: U, srcset: B }), `
                    />
                  `).concat(ie ? "</a>" : "", `
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        `).concat(this.getContent() ? `
          <td `.concat(this.htmlAttributes({ style: "tdText" }), `>
            `).concat(ie ? `<a
                `.concat(this.htmlAttributes({ href: H, style: "text", rel: this.getAttribute("rel"), target: this.getAttribute("target") }), ">") : `<span
                    `.concat(this.htmlAttributes({ style: "text" }), ">"), `
              `).concat(this.getContent(), `
            `).concat(ie ? "</a>" : "</span>", `
          </td>
          `) : "", `
      </tr>
    `);
        } }]), N;
      }(y.BodyComponent), (0, v.default)(y, "componentName", "mj-social-element"), (0, v.default)(y, "endingTag", !0), (0, v.default)(y, "allowedAttributes", { align: "enum(left,center,right)", "background-color": "color", color: "color", "border-radius": "unit(px)", "font-family": "string", "font-size": "unit(px)", "font-style": "string", "font-weight": "string", href: "string", "icon-size": "unit(px,%)", "icon-height": "unit(px,%)", "icon-padding": "unit(px,%){1,4}", "line-height": "unit(px,%,)", name: "string", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", "text-padding": "unit(px,%){1,4}", rel: "string", src: "string", srcset: "string", sizes: "string", alt: "string", title: "string", target: "string", "text-decoration": "string", "vertical-align": "enum(top,middle,bottom)" }), (0, v.default)(y, "defaultAttributes", { alt: "", align: "left", color: "#000", "border-radius": "3px", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "font-size": "13px", "line-height": "1", padding: "4px", "text-padding": "4px 4px 4px 0", target: "_blank", "text-decoration": "none", "vertical-align": "middle" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), Object.defineProperty(s, "Navbar", { enumerable: !0, get: function() {
        return d.default;
      } }), Object.defineProperty(s, "NavbarLink", { enumerable: !0, get: function() {
        return f.default;
      } });
      var d = l(r(561)), f = l(r(562));
    }, function(a, s, y) {
      var l = y(38).default, d = y(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var f = d(y(5)), h = d(y(4)), p = d(y(6)), g = d(y(39)), _ = d(y(7)), b = d(y(9)), v = y(10), E = l(y(53)), C = d(y(233)), y = s.default = function(T) {
        function A() {
          var k;
          (0, f.default)(this, A);
          for (var N = arguments.length, j = new Array(N), I = 0; I < N; I++) j[I] = arguments[I];
          return k = (0, p.default)(this, A, [].concat(j)), (0, b.default)((0, g.default)(k), "headStyle", function(B) {
            return `
      noinput.mj-menu-checkbox { display:block!important; max-height:none!important; visibility:visible!important; }

      @media only screen and (max-width:`.concat((0, v.makeLowerBreakpoint)(B), `) {
        .mj-menu-checkbox[type="checkbox"] ~ .mj-inline-links { display:none!important; }
        .mj-menu-checkbox[type="checkbox"]:checked ~ .mj-inline-links,
        .mj-menu-checkbox[type="checkbox"] ~ .mj-menu-trigger { display:block!important; max-width:none!important; max-height:none!important; font-size:inherit!important; }
        .mj-menu-checkbox[type="checkbox"] ~ .mj-inline-links > a { display:block!important; }
        .mj-menu-checkbox[type="checkbox"]:checked ~ .mj-menu-trigger .mj-menu-icon-close { display:block!important; }
        .mj-menu-checkbox[type="checkbox"]:checked ~ .mj-menu-trigger .mj-menu-icon-open { display:none!important; }
      }
    `);
          }), k;
        }
        return (0, _.default)(A, T), (0, h.default)(A, [{ key: "getStyles", value: function() {
          return { div: { align: this.getAttribute("align"), width: "100%" }, label: { display: "block", cursor: "pointer", "mso-hide": "all", "-moz-user-select": "none", "user-select": "none", color: this.getAttribute("ico-color"), "font-size": this.getAttribute("ico-font-size"), "font-family": this.getAttribute("ico-font-family"), "text-transform": this.getAttribute("ico-text-transform"), "text-decoration": this.getAttribute("ico-text-decoration"), "line-height": this.getAttribute("ico-line-height"), "padding-top": this.getAttribute("ico-padding-top"), "padding-right": this.getAttribute("ico-padding-right"), "padding-bottom": this.getAttribute("ico-padding-bottom"), "padding-left": this.getAttribute("ico-padding-left"), padding: this.getAttribute("ico-padding") }, trigger: { display: "none", "max-height": "0px", "max-width": "0px", "font-size": "0px", overflow: "hidden" }, icoOpen: { "mso-hide": "all" }, icoClose: { display: "none", "mso-hide": "all" } };
        } }, { key: "renderHamburger", value: function() {
          var N = (0, C.default)(16);
          return `
      `.concat((0, E.msoConditionalTag)(`
        <input type="checkbox" id="`.concat(N, `" class="mj-menu-checkbox" style="display:none !important; max-height:0; visibility:hidden;" />
      `), !0), `
      <div
        `).concat(this.htmlAttributes({ class: "mj-menu-trigger", style: "trigger" }), `
      >
        <label
          `).concat(this.htmlAttributes({ for: N, class: "mj-menu-label", style: "label", align: this.getAttribute("ico-align") }), `
        >
          <span
            `).concat(this.htmlAttributes({ class: "mj-menu-icon-open", style: "icoOpen" }), `
          >
            `).concat(this.getAttribute("ico-open"), `
          </span>
          <span
            `).concat(this.htmlAttributes({ class: "mj-menu-icon-close", style: "icoClose" }), `
          >
            `).concat(this.getAttribute("ico-close"), `
          </span>
        </label>
      </div>
    `);
        } }, { key: "render", value: function() {
          return `
        `.concat(this.getAttribute("hamburger") === "hamburger" ? this.renderHamburger() : "", `
        <div
          `).concat(this.htmlAttributes({ class: "mj-inline-links", style: this.htmlAttributes("div") }), `
        >
        `).concat((0, E.default)(`
          <table role="presentation" border="0" cellpadding="0" cellspacing="0" align="`.concat(this.getAttribute("align"), `">
            <tr>
        `)), `
          `).concat(this.renderChildren(this.props.children, { attributes: { navbarBaseUrl: this.getAttribute("base-url") } }), `
          `).concat((0, E.default)(`
            </tr></table>
          `), `
        </div>
    `);
        } }]), A;
      }(v.BodyComponent);
      (0, b.default)(y, "componentName", "mj-navbar"), (0, b.default)(y, "allowedAttributes", { align: "enum(left,center,right)", "base-url": "string", hamburger: "string", "ico-align": "enum(left,center,right)", "ico-open": "string", "ico-close": "string", "ico-color": "color", "ico-font-size": "unit(px,%)", "ico-font-family": "string", "ico-text-transform": "string", "ico-padding": "unit(px,%){1,4}", "ico-padding-left": "unit(px,%)", "ico-padding-top": "unit(px,%)", "ico-padding-right": "unit(px,%)", "ico-padding-bottom": "unit(px,%)", padding: "unit(px,%){1,4}", "padding-left": "unit(px,%)", "padding-top": "unit(px,%)", "padding-right": "unit(px,%)", "padding-bottom": "unit(px,%)", "ico-text-decoration": "string", "ico-line-height": "unit(px,%,)" }), (0, b.default)(y, "defaultAttributes", { align: "center", "base-url": null, hamburger: null, "ico-align": "center", "ico-open": "&#9776;", "ico-close": "&#8855;", "ico-color": "#000000", "ico-font-size": "30px", "ico-font-family": "Ubuntu, Helvetica, Arial, sans-serif", "ico-text-transform": "uppercase", "ico-padding": "10px", "ico-text-decoration": "none", "ico-line-height": "30px" }), a.exports = s.default;
    }, function(a, s, v) {
      var l = v(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(v(5)), f = l(v(4)), h = l(v(6)), p = l(v(7)), g = l(v(9)), _ = v(10), b = l(v(53)), v = s.default = function(E) {
        function C() {
          return (0, d.default)(this, C), (0, h.default)(this, C, arguments);
        }
        return (0, p.default)(C, E), (0, f.default)(C, [{ key: "getStyles", value: function() {
          return { a: { display: "inline-block", color: this.getAttribute("color"), "font-family": this.getAttribute("font-family"), "font-size": this.getAttribute("font-size"), "font-style": this.getAttribute("font-style"), "font-weight": this.getAttribute("font-weight"), "letter-spacing": this.getAttribute("letter-spacing"), "line-height": this.getAttribute("line-height"), "text-decoration": this.getAttribute("text-decoration"), "text-transform": this.getAttribute("text-transform"), padding: this.getAttribute("padding"), "padding-top": this.getAttribute("padding-top"), "padding-left": this.getAttribute("padding-left"), "padding-right": this.getAttribute("padding-right"), "padding-bottom": this.getAttribute("padding-bottom") }, td: { padding: this.getAttribute("padding"), "padding-top": this.getAttribute("padding-top"), "padding-left": this.getAttribute("padding-left"), "padding-right": this.getAttribute("padding-right"), "padding-bottom": this.getAttribute("padding-bottom") } };
        } }, { key: "renderContent", value: function() {
          var A = this.getAttribute("href"), T = (T = this.getAttribute("navbarBaseUrl")) ? "".concat(T).concat(A) : A, A = this.getAttribute("css-class") ? " ".concat(this.getAttribute("css-class")) : "";
          return `
      <a
        `.concat(this.htmlAttributes({ class: "mj-link".concat(A), href: T, rel: this.getAttribute("rel"), target: this.getAttribute("target"), name: this.getAttribute("name"), style: "a" }), `
      >
        `).concat(this.getContent(), `
      </a>
    `);
        } }, { key: "render", value: function() {
          return `
        `.concat((0, b.default)(`
          <td
            `.concat(this.htmlAttributes({ style: "td", class: (0, _.suffixCssClasses)(this.getAttribute("css-class"), "outlook") }), `
          >
        `)), `
        `).concat(this.renderContent(), `
        `).concat((0, b.default)(`
          </td>
        `), `
      `);
        } }]), C;
      }(_.BodyComponent);
      (0, g.default)(v, "componentName", "mj-navbar-link"), (0, g.default)(v, "endingTag", !0), (0, g.default)(v, "allowedAttributes", { color: "color", "font-family": "string", "font-size": "unit(px)", "font-style": "string", "font-weight": "string", href: "string", name: "string", target: "string", rel: "string", "letter-spacing": "unitWithNegative(px,em)", "line-height": "unit(px,%,)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", "text-decoration": "string", "text-transform": "string" }), (0, g.default)(v, "defaultAttributes", { color: "#000000", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "font-size": "13px", "font-weight": "normal", "line-height": "22px", padding: "15px 10px", target: "_blank", "text-decoration": "none", "text-transform": "uppercase" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), Object.defineProperty(s, "Carousel", { enumerable: !0, get: function() {
        return d.default;
      } }), Object.defineProperty(s, "CarouselImage", { enumerable: !0, get: function() {
        return f.default;
      } });
      var d = l(r(564)), f = l(r(572));
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(r(5)), f = l(r(4)), h = l(r(6)), p = l(r(39)), g = l(r(7)), _ = l(r(9)), b = l(r(60)), v = l(r(234)), E = l(r(567)), C = l(r(569)), A = r(10), y = r(53), T = l(r(233)), A = s.default = function(k) {
        function N() {
          var j, I = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
          return (0, d.default)(this, N), j = (0, h.default)(this, N, [I]), (0, _.default)((0, p.default)(j), "componentHeadStyle", function() {
            var B = j.props.children.length, U = (0, p.default)(j).carouselId;
            if (!B) return "";
            var H = `
    .mj-carousel {
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
    }

    .mj-carousel-`.concat(U, `-icons-cell {
      display: table-cell !important;
      width: `).concat(j.getAttribute("icon-width"), ` !important;
    }

    .mj-carousel-radio,
    .mj-carousel-next,
    .mj-carousel-previous {
      display: none !important;
    }

    .mj-carousel-thumbnail,
    .mj-carousel-next,
    .mj-carousel-previous {
      touch-action: manipulation;
    }

    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-radio:checked ").concat((0, E.default)("+ * ", Y), "+ .mj-carousel-content .mj-carousel-image");
            }).join(","), ` {
      display: none !important;
    }

    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-radio-").concat(Y + 1, ":checked ").concat((0, E.default)("+ * ", B - Y - 1), "+ .mj-carousel-content .mj-carousel-image-").concat(Y + 1);
            }).join(","), ` {
      display: block !important;
    }

    .mj-carousel-previous-icons,
    .mj-carousel-next-icons,
    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-radio-").concat(Y + 1, ":checked ").concat((0, E.default)("+ * ", B - Y - 1), "+ .mj-carousel-content .mj-carousel-next-").concat((Y + 1 % B + B) % B + 1);
            }), `,
    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-radio-").concat(Y + 1, ":checked ").concat((0, E.default)("+ * ", B - Y - 1), "+ .mj-carousel-content .mj-carousel-previous-").concat((Y - 1 % B + B) % B + 1);
            }), ` {
      display: block !important;
    }

    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-radio-").concat(Y + 1, ":checked ").concat((0, E.default)("+ * ", B - Y - 1), "+ .mj-carousel-content .mj-carousel-").concat(U, "-thumbnail-").concat(Y + 1);
            }).join(","), ` {
      border-color: `).concat(j.getAttribute("tb-selected-border-color"), ` !important;
    }

    .mj-carousel-image img + div,
    .mj-carousel-thumbnail img + div {
      display: none !important;
    }

    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-thumbnail:hover ").concat((0, E.default)("+ * ", B - Y - 1), "+ .mj-carousel-main .mj-carousel-image");
            }).join(","), ` {
      display: none !important;
    }

    .mj-carousel-thumbnail:hover {
      border-color: `).concat(j.getAttribute("tb-hover-border-color"), ` !important;
    }

    `).concat((0, C.default)(0, B).map(function(Y) {
              return ".mj-carousel-".concat(U, "-thumbnail-").concat(Y + 1, ":hover ").concat((0, E.default)("+ * ", B - Y - 1), "+ .mj-carousel-main .mj-carousel-image-").concat(Y + 1);
            }).join(","), ` {
      display: block !important;
    }
    `), Q = `
      .mj-carousel noinput { display:block !important; }
      .mj-carousel noinput .mj-carousel-image-1 { display: block !important;  }
      .mj-carousel noinput .mj-carousel-arrows,
      .mj-carousel noinput .mj-carousel-thumbnails { display: none !important; }

      [owa] .mj-carousel-thumbnail { display: none !important; }
      
      @media screen yahoo {
          .mj-carousel-`.concat(j.carouselId, `-icons-cell,
          .mj-carousel-previous-icons,
          .mj-carousel-next-icons {
              display: none !important;
          }

          .mj-carousel-`).concat(U, "-radio-1:checked ").concat((0, E.default)("+ *", B - 1), "+ .mj-carousel-content .mj-carousel-").concat(U, `-thumbnail-1 {
              border-color: transparent;
          }
      }
    `);
            return "".concat(H, `
`).concat(Q);
          }), j.carouselId = (0, T.default)(16), j;
        }
        return (0, g.default)(N, k), (0, f.default)(N, [{ key: "getStyles", value: function() {
          return { carousel: { div: { display: "table", width: "100%", "table-layout": "fixed", "text-align": "center", "font-size": "0px" }, table: { "caption-side": "top", display: "table-caption", "table-layout": "fixed", width: "100%" } }, images: { td: { padding: "0px" } }, controls: { div: { display: "none", "mso-hide": "all" }, img: { display: "block", width: this.getAttribute("icon-width"), height: "auto" }, td: { "font-size": "0px", display: "none", "mso-hide": "all", padding: "0px" } } };
        } }, { key: "thumbnailsWidth", value: function() {
          return this.props.children.length ? this.getAttribute("tb-width") || "".concat((0, v.default)([this.context.parentWidth / this.props.children.length, 110]), "px") : 0;
        } }, { key: "imagesAttributes", value: function() {
          return (0, b.default)(this.children, "attributes");
        } }, { key: "generateRadios", value: function() {
          return this.renderChildren(this.props.children, { renderer: function(B) {
            return B.renderRadio();
          }, attributes: { carouselId: this.carouselId } });
        } }, { key: "generateThumbnails", value: function() {
          return this.getAttribute("thumbnails") !== "visible" ? "" : this.renderChildren(this.props.children, { attributes: { "tb-border": this.getAttribute("tb-border"), "tb-border-radius": this.getAttribute("tb-border-radius"), "tb-width": this.thumbnailsWidth(), carouselId: this.carouselId }, renderer: function(B) {
            return B.renderThumbnail();
          } });
        } }, { key: "generateControls", value: function(I, B) {
          var U = this, H = parseInt(this.getAttribute("icon-width"), 10);
          return `
      <td
        `.concat(this.htmlAttributes({ class: "mj-carousel-".concat(this.carouselId, "-icons-cell"), style: "controls.td" }), `
      >
        <div
          `).concat(this.htmlAttributes({ class: "mj-carousel-".concat(I, "-icons"), style: "controls.div" }), `
        >
          `).concat((0, C.default)(1, this.props.children.length + 1).map(function(Q) {
            return `
              <label
                `.concat(U.htmlAttributes({ for: "mj-carousel-".concat(U.carouselId, "-radio-").concat(Q), class: "mj-carousel-".concat(I, " mj-carousel-").concat(I, "-").concat(Q) }), `
              >
                <img
                  `).concat(U.htmlAttributes({ src: B, alt: I, style: "controls.img", width: H }), `
                />
              </label>
            `);
          }).join(""), `
        </div>
      </td>
    `);
        } }, { key: "generateImages", value: function() {
          return `
      <td
        `.concat(this.htmlAttributes({ style: "images.td" }), `
      >
        <div
          `).concat(this.htmlAttributes({ class: "mj-carousel-images" }), `
        >
          `).concat(this.renderChildren(this.props.children, { attributes: { "border-radius": this.getAttribute("border-radius") } }), `
        </div>
      </td>
    `);
        } }, { key: "generateCarousel", value: function() {
          return `
      <table
        `.concat(this.htmlAttributes({ style: "carousel.table", border: "0", cellpadding: "0", cellspacing: "0", width: "100%", role: "presentation", class: "mj-carousel-main" }), `
      >
        <tbody>
          <tr>
            `).concat(this.generateControls("previous", this.getAttribute("left-icon")), `
            `).concat(this.generateImages(), `
            `).concat(this.generateControls("next", this.getAttribute("right-icon")), `
          </tr>
        </tbody>
      </table>
    `);
        } }, { key: "renderFallback", value: function() {
          var I = this.props.children;
          return I.length === 0 ? "" : (0, y.msoConditionalTag)(this.renderChildren([I[0]], { attributes: { "border-radius": this.getAttribute("border-radius") } }));
        } }, { key: "render", value: function() {
          return `
      `.concat((0, y.msoConditionalTag)(`
        <div
          `.concat(this.htmlAttributes({ class: "mj-carousel" }), `
        >
          `).concat(this.generateRadios(), `
          <div
            `).concat(this.htmlAttributes({ class: "mj-carousel-content mj-carousel-".concat(this.carouselId, "-content"), style: "carousel.div" }), `
          >
            `).concat(this.generateThumbnails(), `
            `).concat(this.generateCarousel(), `
          </div>
        </div>
      `), !0), `
      `).concat(this.renderFallback(), `
    `);
        } }]), N;
      }(A.BodyComponent);
      (0, _.default)(A, "componentName", "mj-carousel"), (0, _.default)(A, "allowedAttributes", { align: "enum(left,center,right)", "border-radius": "unit(px,%){1,4}", "container-background-color": "color", "icon-width": "unit(px,%)", "left-icon": "string", padding: "unit(px,%){1,4}", "padding-top": "unit(px,%)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "right-icon": "string", thumbnails: "enum(visible,hidden)", "tb-border": "string", "tb-border-radius": "unit(px,%)", "tb-hover-border-color": "color", "tb-selected-border-color": "color", "tb-width": "unit(px,%)" }), (0, _.default)(A, "defaultAttributes", { align: "center", "border-radius": "6px", "icon-width": "44px", "left-icon": "https://i.imgur.com/xTh3hln.png", "right-icon": "https://i.imgur.com/os7o9kz.png", thumbnails: "visible", "tb-border": "2px solid transparent", "tb-border-radius": "6px", "tb-hover-border-color": "#fead0d", "tb-selected-border-color": "#ccc" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(45);
      a.exports = function(f, h, p) {
        for (var g = -1, _ = f.length; ++g < _; ) {
          var b, v, E = f[g], C = h(E);
          C != null && (b === void 0 ? C == C && !l(C) : p(C, b)) && (b = C, v = E);
        }
        return v;
      };
    }, function(a, s) {
      a.exports = function(l, d) {
        return l < d;
      };
    }, function(a, s, r) {
      var l = r(568), d = r(147), f = r(61), h = r(46);
      a.exports = function(g, _, b) {
        return _ = (b ? d(g, _, b) : _ === void 0) ? 1 : f(_), l(h(g), _);
      };
    }, function(a, s) {
      var r = Math.floor;
      a.exports = function(d, f) {
        var h = "";
        if (!d || f < 1 || 9007199254740991 < f) return h;
        for (; f % 2 && (h += d), (f = r(f / 2)) && (d += d), f; ) ;
        return h;
      };
    }, function(a, s, r) {
      r = r(570)(), a.exports = r;
    }, function(a, s, r) {
      var l = r(571), d = r(147), f = r(179);
      a.exports = function(p) {
        return function(g, _, b) {
          return b && typeof b != "number" && d(g, _, b) && (_ = b = void 0), g = f(g), _ === void 0 ? (_ = g, g = 0) : _ = f(_), b = b === void 0 ? g < _ ? 1 : -1 : f(b), l(g, _, b, p);
        };
      };
    }, function(a, s) {
      var r = Math.ceil, l = Math.max;
      a.exports = function(f, h, p, g) {
        for (var _ = -1, b = l(r((h - f) / (p || 1)), 0), v = Array(b); b--; ) v[g ? b : ++_] = f, f += p;
        return v;
      };
    }, function(a, s, _) {
      var p = _(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(_(5)), d = p(_(4)), f = p(_(6)), h = p(_(7)), p = p(_(9)), g = _(10), _ = s.default = function(b) {
        function v() {
          return (0, l.default)(this, v), (0, f.default)(this, v, arguments);
        }
        return (0, h.default)(v, b), (0, d.default)(v, [{ key: "getStyles", value: function() {
          return { images: { img: { "border-radius": this.getAttribute("border-radius"), display: "block", width: this.context.containerWidth, "max-width": "100%", height: "auto" }, firstImageDiv: {}, otherImageDiv: { display: "none", "mso-hide": "all" } }, radio: { input: { display: "none", "mso-hide": "all" } }, thumbnails: { a: { border: this.getAttribute("tb-border"), "border-radius": this.getAttribute("tb-border-radius"), display: "inline-block", overflow: "hidden", width: this.getAttribute("tb-width") }, img: { display: "block", width: "100%", height: "auto" } } };
        } }, { key: "renderThumbnail", value: function() {
          var C = (j = this.attributes).carouselId, y = j.src, T = j.alt, A = j["tb-width"], k = j.target, N = this.props.index + 1, j = (0, g.suffixCssClasses)(this.getAttribute("css-class"), "thumbnail");
          return `
      <a
        `.concat(this.htmlAttributes({ style: "thumbnails.a", href: "#".concat(N), target: k, class: "mj-carousel-thumbnail mj-carousel-".concat(C, "-thumbnail mj-carousel-").concat(C, "-thumbnail-").concat(N, " ").concat(j) }), `
      >
        <label `).concat(this.htmlAttributes({ for: "mj-carousel-".concat(C, "-radio-").concat(N) }), `>
          <img
            `).concat(this.htmlAttributes({ style: "thumbnails.img", src: this.getAttribute("thumbnails-src") || y, alt: T, width: parseInt(A, 10) }), `
          />
        </label>
      </a>
    `);
        } }, { key: "renderRadio", value: function() {
          var C = this.props.index, y = this.getAttribute("carouselId");
          return `
      <input
        `.concat(this.htmlAttributes({ class: "mj-carousel-radio mj-carousel-".concat(y, "-radio mj-carousel-").concat(y, "-radio-").concat(C + 1), checked: C === 0 ? "checked" : null, type: "radio", name: "mj-carousel-radio-".concat(y), id: "mj-carousel-".concat(y, "-radio-").concat(C + 1), style: "radio.input" }), `
      />
    `);
        } }, { key: "render", value: function() {
          var k = (A = this.attributes).src, N = A.alt, C = A.href, y = A.rel, T = A.title, A = this.props.index, k = `
      <img
        `.concat(this.htmlAttributes({ title: T, src: k, alt: N, style: "images.img", width: parseInt(this.context.containerWidth, 10), border: "0" }), ` />
    `), N = this.getAttribute("css-class") || "";
          return `
      <div
        `.concat(this.htmlAttributes({ class: "mj-carousel-image mj-carousel-image-".concat(A + 1, " ").concat(N), style: A === 0 ? "images.firstImageDiv" : "images.otherImageDiv" }), `
      >
        `).concat(C ? "<a ".concat(this.htmlAttributes({ href: C, rel: y, target: "_blank" }), ">").concat(k, "</a>") : k, `
      </div>
    `);
        } }]), v;
      }(g.BodyComponent);
      (0, p.default)(_, "componentName", "mj-carousel-image"), (0, p.default)(_, "endingTag", !0), (0, p.default)(_, "allowedAttributes", { alt: "string", href: "string", rel: "string", target: "string", title: "string", src: "string", "thumbnails-src": "string", "border-radius": "unit(px,%){1,4}", "tb-border": "string", "tb-border-radius": "unit(px,%){1,4}" }), (0, p.default)(_, "defaultAttributes", { alt: "", target: "_blank" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), Object.defineProperty(s, "Accordion", { enumerable: !0, get: function() {
        return d.default;
      } }), Object.defineProperty(s, "AccordionElement", { enumerable: !0, get: function() {
        return f.default;
      } }), Object.defineProperty(s, "AccordionText", { enumerable: !0, get: function() {
        return h.default;
      } }), Object.defineProperty(s, "AccordionTitle", { enumerable: !0, get: function() {
        return p.default;
      } });
      var d = l(r(574)), f = l(r(575)), h = l(r(235)), p = l(r(236));
    }, function(a, s, y) {
      function l(T) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
          return typeof A;
        } : function(A) {
          return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
        })(T);
      }
      function d(T, A) {
        var k, N = Object.keys(T);
        return Object.getOwnPropertySymbols && (k = Object.getOwnPropertySymbols(T), A && (k = k.filter(function(j) {
          return Object.getOwnPropertyDescriptor(T, j).enumerable;
        })), N.push.apply(N, k)), N;
      }
      function f(T) {
        for (var A = 1; A < arguments.length; A++) {
          var k = arguments[A] != null ? arguments[A] : {};
          A % 2 ? d(Object(k), !0).forEach(function(N) {
            h(T, N, k[N]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(k)) : d(Object(k)).forEach(function(N) {
            Object.defineProperty(T, N, Object.getOwnPropertyDescriptor(k, N));
          });
        }
        return T;
      }
      function h(T, A, k) {
        return (A = function(j) {
          return j = function(B, U) {
            if (l(B) != "object" || !B) return B;
            var H = B[Symbol.toPrimitive];
            if (H === void 0) return (U === "string" ? String : Number)(B);
            if (l(U = H.call(B, U || "default")) != "object") return U;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(j, "string"), l(j) == "symbol" ? j : String(j);
        }(A)) in T ? Object.defineProperty(T, A, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : T[A] = k, T;
      }
      var p = y(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(y(5)), _ = p(y(4)), b = p(y(6)), v = p(y(39)), E = p(y(7)), C = p(y(9)), y = y(10), y = s.default = function(T) {
        function A() {
          var k;
          (0, g.default)(this, A);
          for (var N = arguments.length, j = new Array(N), I = 0; I < N; I++) j[I] = arguments[I];
          return k = (0, b.default)(this, A, [].concat(j)), (0, C.default)((0, v.default)(k), "headStyle", function() {
            return `
      noinput.mj-accordion-checkbox { display:block!important; }

      @media yahoo, only screen and (min-width:0) {
        .mj-accordion-element { display:block; }
        input.mj-accordion-checkbox, .mj-accordion-less { display:none!important; }
        input.mj-accordion-checkbox + * .mj-accordion-title { cursor:pointer; touch-action:manipulation; -webkit-user-select:none; -moz-user-select:none; user-select:none; }
        input.mj-accordion-checkbox + * .mj-accordion-content { overflow:hidden; display:none; }
        input.mj-accordion-checkbox + * .mj-accordion-more { display:block!important; }
        input.mj-accordion-checkbox:checked + * .mj-accordion-content { display:block; }
        input.mj-accordion-checkbox:checked + * .mj-accordion-more { display:none!important; }
        input.mj-accordion-checkbox:checked + * .mj-accordion-less { display:block!important; }
      }

      .moz-text-html input.mj-accordion-checkbox + * .mj-accordion-title { cursor: auto; touch-action: auto; -webkit-user-select: auto; -moz-user-select: auto; user-select: auto; }
      .moz-text-html input.mj-accordion-checkbox + * .mj-accordion-content { overflow: hidden; display: block; }
      .moz-text-html input.mj-accordion-checkbox + * .mj-accordion-ico { display: none; }

      @goodbye { @gmail }
    `;
          }), k;
        }
        return (0, E.default)(A, T), (0, _.default)(A, [{ key: "getStyles", value: function() {
          return { table: { width: "100%", "border-collapse": "collapse", border: this.getAttribute("border"), "border-bottom": "none", "font-family": this.getAttribute("font-family") } };
        } }, { key: "render", value: function() {
          var N = this, j = ["border", "icon-align", "icon-width", "icon-height", "icon-position", "icon-wrapped-url", "icon-wrapped-alt", "icon-unwrapped-url", "icon-unwrapped-alt"].reduce(function(I, B) {
            return f(f({}, I), {}, h({}, B, N.getAttribute(B)));
          }, {});
          return `
      <table
        `.concat(this.htmlAttributes({ cellspacing: "0", cellpadding: "0", class: "mj-accordion", style: "table" }), `
      >
        <tbody>
          `).concat(this.renderChildren(this.props.children, { attributes: j }), `
        </tbody>
      </table>
    `);
        } }]), A;
      }(y.BodyComponent);
      (0, C.default)(y, "componentName", "mj-accordion"), (0, C.default)(y, "allowedAttributes", { "container-background-color": "color", border: "string", "font-family": "string", "icon-align": "enum(top,middle,bottom)", "icon-width": "unit(px,%)", "icon-height": "unit(px,%)", "icon-wrapped-url": "string", "icon-wrapped-alt": "string", "icon-unwrapped-url": "string", "icon-unwrapped-alt": "string", "icon-position": "enum(left,right)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}" }), (0, C.default)(y, "defaultAttributes", { border: "2px solid black", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "icon-align": "middle", "icon-wrapped-url": "https://i.imgur.com/bIXv1bk.png", "icon-wrapped-alt": "+", "icon-unwrapped-url": "https://i.imgur.com/w4uTygT.png", "icon-unwrapped-alt": "-", "icon-position": "right", "icon-height": "32px", "icon-width": "32px", padding: "10px 25px" }), a.exports = s.default;
    }, function(a, s, r) {
      function l(N) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
          return typeof j;
        } : function(j) {
          return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
        })(N);
      }
      function d(N, j) {
        var I, B = Object.keys(N);
        return Object.getOwnPropertySymbols && (I = Object.getOwnPropertySymbols(N), j && (I = I.filter(function(U) {
          return Object.getOwnPropertyDescriptor(N, U).enumerable;
        })), B.push.apply(B, I)), B;
      }
      function f(N) {
        for (var j = 1; j < arguments.length; j++) {
          var I = arguments[j] != null ? arguments[j] : {};
          j % 2 ? d(Object(I), !0).forEach(function(B) {
            h(N, B, I[B]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(I)) : d(Object(I)).forEach(function(B) {
            Object.defineProperty(N, B, Object.getOwnPropertyDescriptor(I, B));
          });
        }
        return N;
      }
      function h(N, j, I) {
        return (j = function(U) {
          return U = function(Q, Y) {
            if (l(Q) != "object" || !Q) return Q;
            var ie = Q[Symbol.toPrimitive];
            if (ie === void 0) return (Y === "string" ? String : Number)(Q);
            if (l(Y = ie.call(Q, Y || "default")) != "object") return Y;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(U, "string"), l(U) == "symbol" ? U : String(U);
        }(j)) in N ? Object.defineProperty(N, j, { value: I, enumerable: !0, configurable: !0, writable: !0 }) : N[j] = I, N;
      }
      var p = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(r(5)), _ = p(r(4)), b = p(r(6)), v = p(r(7)), E = p(r(9)), C = p(r(47)), k = r(10), y = p(r(53)), T = p(r(235)), A = p(r(236)), k = s.default = function(N) {
        function j() {
          return (0, g.default)(this, j), (0, b.default)(this, j, arguments);
        }
        return (0, v.default)(j, N), (0, _.default)(j, [{ key: "getStyles", value: function() {
          return { td: { padding: "0px", "background-color": this.getAttribute("background-color") }, label: { "font-size": "13px", "font-family": this.getAttribute("font-family") }, input: { display: "none" } };
        } }, { key: "handleMissingChildren", value: function() {
          var B = this, U = this.props.children, H = ["border", "icon-align", "icon-width", "icon-height", "icon-position", "icon-wrapped-url", "icon-wrapped-alt", "icon-unwrapped-url", "icon-unwrapped-alt"].reduce(function(Y, ie) {
            return f(f({}, Y), {}, h({}, ie, B.getAttribute(ie)));
          }, {}), Q = [];
          return (0, C.default)(U, { tagName: "mj-accordion-title" }) || Q.push(new A.default({ attributes: H, context: this.getChildContext() }).render()), Q.push(this.renderChildren(U, { attributes: H })), (0, C.default)(U, { tagName: "mj-accordion-text" }) || Q.push(new T.default({ attributes: H, context: this.getChildContext() }).render()), Q.join(`
`);
        } }, { key: "render", value: function() {
          return `
      <tr
        `.concat(this.htmlAttributes({ class: this.getAttribute("css-class") }), `
      >
        <td `).concat(this.htmlAttributes({ style: "td" }), `>
          <label
            `).concat(this.htmlAttributes({ class: "mj-accordion-element", style: "label" }), `
          >
            `).concat((0, y.default)(`
              <input
                `.concat(this.htmlAttributes({ class: "mj-accordion-checkbox", type: "checkbox", style: "input" }), `
              />
            `), !0), `
            <div>
              `).concat(this.handleMissingChildren(), `
            </div>
          </label>
        </td>
      </tr>
    `);
        } }]), j;
      }(k.BodyComponent);
      (0, E.default)(k, "componentName", "mj-accordion-element"), (0, E.default)(k, "allowedAttributes", { "background-color": "color", border: "string", "font-family": "string", "icon-align": "enum(top,middle,bottom)", "icon-width": "unit(px,%)", "icon-height": "unit(px,%)", "icon-wrapped-url": "string", "icon-wrapped-alt": "string", "icon-unwrapped-url": "string", "icon-unwrapped-alt": "string", "icon-position": "enum(left,right)" }), (0, E.default)(k, "defaultAttributes", { title: { img: { width: "32px", height: "32px" } } }), a.exports = s.default;
    }, function(a, s, v) {
      function l(E) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
          return typeof C;
        } : function(C) {
          return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
        })(E);
      }
      function d(E, C) {
        var y, T = Object.keys(E);
        return Object.getOwnPropertySymbols && (y = Object.getOwnPropertySymbols(E), C && (y = y.filter(function(A) {
          return Object.getOwnPropertyDescriptor(E, A).enumerable;
        })), T.push.apply(T, y)), T;
      }
      function f(E) {
        for (var C = 1; C < arguments.length; C++) {
          var y = arguments[C] != null ? arguments[C] : {};
          C % 2 ? d(Object(y), !0).forEach(function(T) {
            (function(k, N, j) {
              (N = function(B) {
                return B = function(H, Q) {
                  if (l(H) != "object" || !H) return H;
                  var Y = H[Symbol.toPrimitive];
                  if (Y === void 0) return (Q === "string" ? String : Number)(H);
                  if (l(Q = Y.call(H, Q || "default")) != "object") return Q;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(B, "string"), l(B) == "symbol" ? B : String(B);
              }(N)) in k ? Object.defineProperty(k, N, { value: j, enumerable: !0, configurable: !0, writable: !0 }) : k[N] = j;
            })(E, T, y[T]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(y)) : d(Object(y)).forEach(function(T) {
            Object.defineProperty(E, T, Object.getOwnPropertyDescriptor(y, T));
          });
        }
        return E;
      }
      var b = v(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var h = b(v(5)), p = b(v(4)), g = b(v(6)), _ = b(v(7)), b = b(v(9)), v = v(10), v = s.default = function(E) {
        function C() {
          return (0, h.default)(this, C), (0, g.default)(this, C, arguments);
        }
        return (0, _.default)(C, E), (0, p.default)(C, [{ key: "getChildContext", value: function() {
          return f(f({}, this.context), {}, { containerWidth: this.getAttribute("width") });
        } }, { key: "getStyles", value: function() {
          return { div: { "background-color": this.getAttribute("background-color") } };
        } }, { key: "render", value: function() {
          var T = (A = this.context).setBackgroundColor, A = (k = A.globalData).lang, k = k.dir;
          return T(this.getAttribute("background-color")), `
      <div
        `.concat(this.htmlAttributes({ class: this.getAttribute("css-class"), style: "div", lang: A, dir: k }), `
      >
        `).concat(this.renderChildren(), `
      </div>
    `);
        } }]), C;
      }(v.BodyComponent);
      (0, b.default)(v, "componentName", "mj-body"), (0, b.default)(v, "allowedAttributes", { width: "unit(px)", "background-color": "color" }), (0, b.default)(v, "defaultAttributes", { width: "600px" }), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "handler", value: function() {
          return this.handlerChildren();
        } }]), b;
      }(g.HeadComponent);
      (0, p.default)(g, "componentName", "mj-head"), a.exports = s.default;
    }, function(a, s, A) {
      function l(k) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
          return typeof N;
        } : function(N) {
          return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
        })(k);
      }
      function d(k, N) {
        var j, I = Object.keys(k);
        return Object.getOwnPropertySymbols && (j = Object.getOwnPropertySymbols(k), N && (j = j.filter(function(B) {
          return Object.getOwnPropertyDescriptor(k, B).enumerable;
        })), I.push.apply(I, j)), I;
      }
      function f(k) {
        for (var N = 1; N < arguments.length; N++) {
          var j = arguments[N] != null ? arguments[N] : {};
          N % 2 ? d(Object(j), !0).forEach(function(I) {
            h(k, I, j[I]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(k, Object.getOwnPropertyDescriptors(j)) : d(Object(j)).forEach(function(I) {
            Object.defineProperty(k, I, Object.getOwnPropertyDescriptor(j, I));
          });
        }
        return k;
      }
      function h(k, N, j) {
        return (N = function(B) {
          return B = function(H, Q) {
            if (l(H) != "object" || !H) return H;
            var Y = H[Symbol.toPrimitive];
            if (Y === void 0) return (Q === "string" ? String : Number)(H);
            if (l(Q = Y.call(H, Q || "default")) != "object") return Q;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(B, "string"), l(B) == "symbol" ? B : String(B);
        }(N)) in k ? Object.defineProperty(k, N, { value: j, enumerable: !0, configurable: !0, writable: !0 }) : k[N] = j, k;
      }
      var p = A(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(A(5)), _ = p(A(4)), b = p(A(6)), v = p(A(7)), E = p(A(9)), C = p(A(57)), y = p(A(172)), T = p(A(42)), A = A(10), A = s.default = function(k) {
        function N() {
          return (0, g.default)(this, N), (0, b.default)(this, N, arguments);
        }
        return (0, v.default)(N, k), (0, _.default)(N, [{ key: "handler", value: function() {
          var I = this.context.add, B = this.props.children;
          (0, T.default)(B, function(Y) {
            var H = Y.tagName, Q = Y.attributes, Y = Y.children;
            H === "mj-class" ? (I("classes", Q.name, (0, y.default)(Q, ["name"])), I("classesDefault", Q.name, (0, C.default)(Y, function(ie, te) {
              var $ = te.tagName, te = te.attributes;
              return f(f({}, ie), {}, h({}, $, te));
            }, {}))) : I("defaultAttributes", H, Q);
          });
        } }]), N;
      }(A.HeadComponent);
      (0, E.default)(A, "componentName", "mj-attributes"), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "handler", value: function() {
          (0, this.context.add)("breakpoint", this.getAttribute("width"));
        } }]), b;
      }(g.HeadComponent);
      (0, p.default)(g, "componentName", "mj-breakpoint"), (0, p.default)(g, "endingTag", !0), (0, p.default)(g, "allowedAttributes", { width: "unit(px)" }), a.exports = s.default;
    }, function(a, s, y) {
      function l(T) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
          return typeof A;
        } : function(A) {
          return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
        })(T);
      }
      function d(T, A) {
        var k, N = Object.keys(T);
        return Object.getOwnPropertySymbols && (k = Object.getOwnPropertySymbols(T), A && (k = k.filter(function(j) {
          return Object.getOwnPropertyDescriptor(T, j).enumerable;
        })), N.push.apply(N, k)), N;
      }
      function f(T) {
        for (var A = 1; A < arguments.length; A++) {
          var k = arguments[A] != null ? arguments[A] : {};
          A % 2 ? d(Object(k), !0).forEach(function(N) {
            h(T, N, k[N]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(k)) : d(Object(k)).forEach(function(N) {
            Object.defineProperty(T, N, Object.getOwnPropertyDescriptor(k, N));
          });
        }
        return T;
      }
      function h(T, A, k) {
        return (A = function(j) {
          return j = function(B, U) {
            if (l(B) != "object" || !B) return B;
            var H = B[Symbol.toPrimitive];
            if (H === void 0) return (U === "string" ? String : Number)(B);
            if (l(U = H.call(B, U || "default")) != "object") return U;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(j, "string"), l(j) == "symbol" ? j : String(j);
        }(A)) in T ? Object.defineProperty(T, A, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : T[A] = k, T;
      }
      var p = y(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(y(5)), _ = p(y(4)), b = p(y(6)), v = p(y(7)), E = p(y(9)), C = p(y(43)), y = y(10), y = s.default = function(T) {
        function A() {
          return (0, g.default)(this, A), (0, b.default)(this, A, arguments);
        }
        return (0, v.default)(A, T), (0, _.default)(A, [{ key: "handler", value: function() {
          var N = this.context.add;
          this.props.children.filter(function(j) {
            return j.tagName === "mj-selector";
          }).forEach(function(B) {
            var I = B.attributes, B = B.children, I = I.path, B = B.filter(function(U) {
              return U.tagName === "mj-html-attribute" && !!(0, C.default)(U, "attributes.name");
            }).reduce(function(U, H) {
              return f(f({}, U), {}, h({}, H.attributes.name, H.content));
            }, {});
            N("htmlAttributes", I, B);
          });
        } }]), A;
      }(y.HeadComponent);
      (0, E.default)(y, "componentName", "mj-html-attributes"), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "handler", value: function() {
          (0, this.context.add)("fonts", this.getAttribute("name"), this.getAttribute("href"));
        } }]), b;
      }(g.HeadComponent);
      (0, p.default)(g, "componentName", "mj-font"), (0, p.default)(g, "allowedAttributes", { name: "string", href: "string" }), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "handler", value: function() {
          (0, this.context.add)("preview", this.getContent());
        } }]), b;
      }(g.HeadComponent);
      (0, p.default)(g, "componentName", "mj-preview"), (0, p.default)(g, "endingTag", !0), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "handler", value: function() {
          (0, this.context.add)(this.getAttribute("inline") === "inline" ? "inlineStyle" : "style", this.getContent());
        } }]), b;
      }(g.HeadComponent);
      (0, p.default)(g, "componentName", "mj-style"), (0, p.default)(g, "endingTag", !0), (0, p.default)(g, "allowedAttributes", { inline: "string" }), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "handler", value: function() {
          (0, this.context.add)("title", this.getContent());
        } }]), b;
      }(g.HeadComponent);
      (0, p.default)(g, "componentName", "mj-title"), (0, p.default)(g, "endingTag", !0), a.exports = s.default;
    }, function(a, s, r) {
      function l(B) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(U) {
          return typeof U;
        } : function(U) {
          return U && typeof Symbol == "function" && U.constructor === Symbol && U !== Symbol.prototype ? "symbol" : typeof U;
        })(B);
      }
      function d(B, U) {
        var H, Q = Object.keys(B);
        return Object.getOwnPropertySymbols && (H = Object.getOwnPropertySymbols(B), U && (H = H.filter(function(Y) {
          return Object.getOwnPropertyDescriptor(B, Y).enumerable;
        })), Q.push.apply(Q, H)), Q;
      }
      function f(B) {
        for (var U = 1; U < arguments.length; U++) {
          var H = arguments[U] != null ? arguments[U] : {};
          U % 2 ? d(Object(H), !0).forEach(function(Q) {
            (function(ie, ce, $) {
              (ce = function(V) {
                return V = function(ne, J) {
                  if (l(ne) != "object" || !ne) return ne;
                  var L = ne[Symbol.toPrimitive];
                  if (L === void 0) return (J === "string" ? String : Number)(ne);
                  if (l(J = L.call(ne, J || "default")) != "object") return J;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(V, "string"), l(V) == "symbol" ? V : String(V);
              }(ce)) in ie ? Object.defineProperty(ie, ce, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : ie[ce] = $;
            })(B, Q, H[Q]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(B, Object.getOwnPropertyDescriptors(H)) : d(Object(H)).forEach(function(Q) {
            Object.defineProperty(B, Q, Object.getOwnPropertyDescriptor(H, Q));
          });
        }
        return B;
      }
      function h(B, U) {
        (U == null || U > B.length) && (U = B.length);
        for (var H = 0, Q = new Array(U); H < U; H++) Q[H] = B[H];
        return Q;
      }
      var p = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(r(5)), _ = p(r(4)), b = p(r(6)), v = p(r(39)), E = p(r(7)), C = p(r(9)), y = p(r(146)), T = p(r(237)), A = p(r(238)), k = p(r(139)), I = r(10), N = p(r(37)), j = (0, k.default)((0, y.default)(A.default), (0, T.default)(" ")), I = s.default = function(B) {
        function U() {
          var H;
          (0, g.default)(this, U);
          for (var Q = arguments.length, Y = new Array(Q), ie = 0; ie < Q; ie++) Y[ie] = arguments[ie];
          return H = (0, b.default)(this, U, [].concat(Y)), (0, C.default)((0, v.default)(H), "getBackground", function() {
            return j([H.getAttribute("background-color")].concat(function($) {
              return function(V) {
                if (Array.isArray(V)) return h(V);
              }($) || function(V) {
                if (typeof Symbol < "u" && V[Symbol.iterator] != null || V["@@iterator"] != null) return Array.from(V);
              }($) || function(V, K) {
                if (V) {
                  if (typeof V == "string") return h(V, K);
                  var ne = Object.prototype.toString.call(V).slice(8, -1);
                  return (ne = ne === "Object" && V.constructor ? V.constructor.name : ne) === "Map" || ne === "Set" ? Array.from(V) : ne === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ne) ? h(V, K) : void 0;
                }
              }($) || function() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }(H.getAttribute("background-url") ? ["url('".concat(H.getAttribute("background-url"), "')"), "no-repeat", "".concat(H.getAttribute("background-position"), " / cover")] : [])));
          }), H;
        }
        return (0, E.default)(U, B), (0, _.default)(U, [{ key: "getChildContext", value: function() {
          var Q = this.context.containerWidth, Y = this.getShorthandAttrValue("padding", "left") + this.getShorthandAttrValue("padding", "right"), $ = "".concat(parseFloat(Q), "px"), ie = (ce = (0, N.default)($, { parseFloatToInt: !1 })).unit, ce = ce.parsedWidth, $ = "".concat(ie === "%" ? parseFloat(Q) * ce / 100 - Y : ce - Y, "px");
          return f(f({}, this.context), {}, { containerWidth: $ });
        } }, { key: "getStyles", value: function() {
          var Q = this.context.containerWidth, Y = Math.round(parseInt(this.getAttribute("background-height"), 10) / parseInt(this.getAttribute("background-width"), 10) * 100), ie = this.getAttribute("background-width") || Q;
          return { div: { margin: "0 auto", "max-width": Q }, table: { width: "100%" }, tr: { "vertical-align": "top" }, "td-fluid": { width: "0.01%", "padding-bottom": "".concat(Y, "%"), "mso-padding-bottom-alt": "0" }, "outlook-table": { width: Q }, "outlook-td": { "line-height": 0, "font-size": 0, "mso-line-height-rule": "exactly" }, "outlook-inner-table": { width: Q }, "outlook-image": { border: "0", height: this.getAttribute("background-height"), "mso-position-horizontal": "center", position: "absolute", top: 0, width: ie, "z-index": "-3" }, "outlook-inner-td": { "background-color": this.getAttribute("inner-background-color"), padding: this.getAttribute("inner-padding"), "padding-top": this.getAttribute("inner-padding-top"), "padding-left": this.getAttribute("inner-padding-left"), "padding-right": this.getAttribute("inner-padding-right"), "padding-bottom": this.getAttribute("inner-padding-bottom") }, "inner-table": { width: "100%", margin: "0px" }, "inner-div": { "background-color": this.getAttribute("inner-background-color"), float: this.getAttribute("align"), margin: "0px auto", width: this.getAttribute("width") } };
        } }, { key: "renderContent", value: function() {
          var Q = this.context.containerWidth, Y = this.props.children;
          return `
      <!--[if mso | IE]>
        <table
          `.concat(this.htmlAttributes({ align: this.getAttribute("align"), border: "0", cellpadding: "0", cellspacing: "0", style: "outlook-inner-table", width: Q.replace("px", "") }), `
        >
          <tr>
            <td `).concat(this.htmlAttributes({ style: "outlook-inner-td" }), `>
      <![endif]-->
      <div
        `).concat(this.htmlAttributes({ align: this.getAttribute("align"), class: "mj-hero-content", style: "inner-div" }), `
      >
        <table
          `).concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "inner-table" }), `
        >
          <tbody>
            <tr>
              <td `).concat(this.htmlAttributes({ style: "inner-td" }), ` >
                <table
                  `).concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "inner-table" }), `
                >
                  <tbody>
                    `).concat(this.renderChildren(Y, { renderer: function(ce) {
            return ce.constructor.isRawElement() ? ce.render() : `
                        <tr>
                          <td
                            `.concat(ce.htmlAttributes({ align: ce.getAttribute("align"), background: ce.getAttribute("container-background-color"), class: ce.getAttribute("css-class"), style: { background: ce.getAttribute("container-background-color"), "font-size": "0px", padding: ce.getAttribute("padding"), "padding-top": ce.getAttribute("padding-top"), "padding-right": ce.getAttribute("padding-right"), "padding-bottom": ce.getAttribute("padding-bottom"), "padding-left": ce.getAttribute("padding-left"), "word-break": "break-word" } }), `
                          >
                            `).concat(ce.render(), `
                          </td>
                        </tr>
                      `);
          } }), `
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]>
            </td>
          </tr>
        </table>
      <![endif]-->
    `);
        } }, { key: "renderMode", value: function() {
          var Q = { background: this.getAttribute("background-url"), style: { background: this.getBackground(), "background-position": this.getAttribute("background-position"), "background-repeat": "no-repeat", "border-radius": this.getAttribute("border-radius"), padding: this.getAttribute("padding"), "padding-top": this.getAttribute("padding-top"), "padding-left": this.getAttribute("padding-left"), "padding-right": this.getAttribute("padding-right"), "padding-bottom": this.getAttribute("padding-bottom"), "vertical-align": this.getAttribute("vertical-align") } };
          switch (this.getAttribute("mode")) {
            case "fluid-height":
              var Y = this.htmlAttributes({ style: "td-fluid" });
              return `
          <td `.concat(Y, ` />
          <td `).concat(this.htmlAttributes(f({}, Q)), `>
            `).concat(this.renderContent(), `
          </td>
          <td `).concat(Y, ` />
        `);
            case "fixed-height":
            default:
              return Y = parseInt(this.getAttribute("height"), 10) - this.getShorthandAttrValue("padding", "top") - this.getShorthandAttrValue("padding", "bottom"), `
          <td
            `.concat(this.htmlAttributes(f(f({}, Q), {}, { height: Y, style: f(f({}, Q.style), {}, { height: "".concat(Y, "px") }) })), `
          >
            `).concat(this.renderContent(), `
          </td>
        `);
          }
        } }, { key: "render", value: function() {
          var Q = this.context.containerWidth;
          return `
      <!--[if mso | IE]>
        <table
          `.concat(this.htmlAttributes({ align: "center", border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "outlook-table", width: parseInt(Q, 10) }), `
        >
          <tr>
            <td `).concat(this.htmlAttributes({ style: "outlook-td" }), `>
              <v:image
                `).concat(this.htmlAttributes({ style: "outlook-image", src: this.getAttribute("background-url"), "xmlns:v": "urn:schemas-microsoft-com:vml" }), `
              />
      <![endif]-->
      <div
        `).concat(this.htmlAttributes({ align: this.getAttribute("align"), class: this.getAttribute("css-class"), style: "div" }), `
      >
        <table
          `).concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "table" }), `
        >
          <tbody>
            <tr
              `).concat(this.htmlAttributes({ style: "tr" }), `
            >
              `).concat(this.renderMode(), `
            </tr>
          </tbody>
      </table>
    </div>
    <!--[if mso | IE]>
          </td>
        </tr>
      </table>
    <![endif]-->
    `);
        } }]), U;
      }(I.BodyComponent);
      (0, C.default)(I, "componentName", "mj-hero"), (0, C.default)(I, "allowedAttributes", { mode: "string", height: "unit(px,%)", "background-url": "string", "background-width": "unit(px,%)", "background-height": "unit(px,%)", "background-position": "string", "border-radius": "string", "container-background-color": "color", "inner-background-color": "color", "inner-padding": "unit(px,%){1,4}", "inner-padding-top": "unit(px,%)", "inner-padding-left": "unit(px,%)", "inner-padding-right": "unit(px,%)", "inner-padding-bottom": "unit(px,%)", padding: "unit(px,%){1,4}", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", "background-color": "color", "vertical-align": "enum(top,bottom,middle)" }), (0, C.default)(I, "defaultAttributes", { mode: "fixed-height", height: "0px", "background-url": null, "background-position": "center center", padding: "0px", "padding-bottom": null, "padding-left": null, "padding-right": null, "padding-top": null, "background-color": "#ffffff", "vertical-align": "top" }), a.exports = s.default;
    }, function(a, s) {
      var r = Array.prototype.join;
      a.exports = function(d, f) {
        return d == null ? "" : r.call(d, f);
      };
    }, function(a, s) {
      a.exports = { cap: !1, curry: !1, fixed: !1, immutable: !1, rearg: !1 };
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(r(5)), f = l(r(4)), h = l(r(6)), p = l(r(7)), g = l(r(9)), b = r(10), _ = l(r(37)), b = s.default = function(v) {
        function E() {
          return (0, d.default)(this, E), (0, h.default)(this, E, arguments);
        }
        return (0, p.default)(E, v), (0, f.default)(E, [{ key: "getStyles", value: function() {
          return { table: { "border-collapse": "separate", width: this.getAttribute("width"), "line-height": "100%" }, td: { border: this.getAttribute("border"), "border-bottom": this.getAttribute("border-bottom"), "border-left": this.getAttribute("border-left"), "border-radius": this.getAttribute("border-radius"), "border-right": this.getAttribute("border-right"), "border-top": this.getAttribute("border-top"), cursor: "auto", "font-style": this.getAttribute("font-style"), height: this.getAttribute("height"), "mso-padding-alt": this.getAttribute("inner-padding"), "text-align": this.getAttribute("text-align"), background: this.getAttribute("background-color") }, content: { display: "inline-block", width: this.calculateAWidth(this.getAttribute("width")), background: this.getAttribute("background-color"), color: this.getAttribute("color"), "font-family": this.getAttribute("font-family"), "font-size": this.getAttribute("font-size"), "font-style": this.getAttribute("font-style"), "font-weight": this.getAttribute("font-weight"), "line-height": this.getAttribute("line-height"), "letter-spacing": this.getAttribute("letter-spacing"), margin: "0", "text-decoration": this.getAttribute("text-decoration"), "text-transform": this.getAttribute("text-transform"), padding: this.getAttribute("inner-padding"), "mso-padding-alt": "0px", "border-radius": this.getAttribute("border-radius") } };
        } }, { key: "calculateAWidth", value: function(y) {
          if (!y) return null;
          var T = (0, _.default)(y), A = T.parsedWidth;
          return T.unit !== "px" ? null : (y = this.getBoxWidths().borders, T = this.getShorthandAttrValue("inner-padding", "left") + this.getShorthandAttrValue("inner-padding", "right"), "".concat(A - T - y, "px"));
        } }, { key: "render", value: function() {
          var y = this.getAttribute("href") ? "a" : "p";
          return `
      <table
        `.concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "table" }), `
      >
        <tbody>
          <tr>
            <td
              `).concat(this.htmlAttributes({ align: "center", bgcolor: this.getAttribute("background-color") === "none" ? void 0 : this.getAttribute("background-color"), role: "presentation", style: "td", valign: this.getAttribute("vertical-align") }), `
            >
              <`).concat(y, `
                `).concat(this.htmlAttributes({ href: this.getAttribute("href"), name: this.getAttribute("name"), rel: this.getAttribute("rel"), title: this.getAttribute("title"), style: "content", target: y == "a" ? this.getAttribute("target") : void 0 }), `
              >
                `).concat(this.getContent(), `
              </`).concat(y, `>
            </td>
          </tr>
        </tbody>
      </table>
    `);
        } }]), E;
      }(b.BodyComponent);
      (0, g.default)(b, "componentName", "mj-button"), (0, g.default)(b, "endingTag", !0), (0, g.default)(b, "allowedAttributes", { align: "enum(left,center,right)", "background-color": "color", "border-bottom": "string", "border-left": "string", "border-radius": "string", "border-right": "string", "border-top": "string", border: "string", color: "color", "container-background-color": "color", "font-family": "string", "font-size": "unit(px)", "font-style": "string", "font-weight": "string", height: "unit(px,%)", href: "string", name: "string", title: "string", "inner-padding": "unit(px,%){1,4}", "letter-spacing": "unitWithNegative(px,em)", "line-height": "unit(px,%,)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", rel: "string", target: "string", "text-decoration": "string", "text-transform": "string", "vertical-align": "enum(top,bottom,middle)", "text-align": "enum(left,right,center)", width: "unit(px,%)" }), (0, g.default)(b, "defaultAttributes", { align: "center", "background-color": "#414141", border: "none", "border-radius": "3px", color: "#ffffff", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "font-size": "13px", "font-weight": "normal", "inner-padding": "10px 25px", "line-height": "120%", padding: "10px 25px", target: "_blank", "text-decoration": "none", "text-transform": "none", "vertical-align": "middle" }), a.exports = s.default;
    }, function(a, s, r) {
      function l(y) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
          return typeof T;
        } : function(T) {
          return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
        })(y);
      }
      function d(y, T) {
        var A, k = Object.keys(y);
        return Object.getOwnPropertySymbols && (A = Object.getOwnPropertySymbols(y), T && (A = A.filter(function(N) {
          return Object.getOwnPropertyDescriptor(y, N).enumerable;
        })), k.push.apply(k, A)), k;
      }
      function f(y) {
        for (var T = 1; T < arguments.length; T++) {
          var A = arguments[T] != null ? arguments[T] : {};
          T % 2 ? d(Object(A), !0).forEach(function(k) {
            (function(j, I, B) {
              (I = function(H) {
                return H = function(Y, ie) {
                  if (l(Y) != "object" || !Y) return Y;
                  var ce = Y[Symbol.toPrimitive];
                  if (ce === void 0) return (ie === "string" ? String : Number)(Y);
                  if (l(ie = ce.call(Y, ie || "default")) != "object") return ie;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(H, "string"), l(H) == "symbol" ? H : String(H);
              }(I)) in j ? Object.defineProperty(j, I, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : j[I] = B;
            })(y, k, A[k]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(A)) : d(Object(A)).forEach(function(k) {
            Object.defineProperty(y, k, Object.getOwnPropertyDescriptor(A, k));
          });
        }
        return y;
      }
      var h = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var p = h(r(5)), g = h(r(4)), _ = h(r(6)), b = h(r(7)), v = h(r(9)), C = r(10), E = h(r(37)), C = s.default = function(y) {
        function T() {
          return (0, p.default)(this, T), (0, _.default)(this, T, arguments);
        }
        return (0, b.default)(T, y), (0, g.default)(T, [{ key: "getChildContext", value: function() {
          var k = this.context.containerWidth, j = this.props.nonRawSiblings, I = (B = this.getBoxWidths()).borders, N = B.paddings + I + (this.getShorthandBorderValue("left", "inner-border") + this.getShorthandBorderValue("right", "inner-border")), B = this.getAttribute("width") || "".concat(parseFloat(k) / j, "px"), j = (I = (0, E.default)(B, { parseFloatToInt: !1 })).unit, I = I.parsedWidth, B = "".concat(j === "%" ? parseFloat(k) * I / 100 - N : I - N, "px");
          return f(f({}, this.context), {}, { containerWidth: B });
        } }, { key: "getStyles", value: function() {
          var k = { "background-color": this.getAttribute("background-color"), border: this.getAttribute("border"), "border-bottom": this.getAttribute("border-bottom"), "border-left": this.getAttribute("border-left"), "border-radius": this.getAttribute("border-radius"), "border-right": this.getAttribute("border-right"), "border-top": this.getAttribute("border-top"), "vertical-align": this.getAttribute("vertical-align") };
          return { div: { "font-size": "0px", "text-align": "left", direction: this.getAttribute("direction"), display: "inline-block", "vertical-align": this.getAttribute("vertical-align"), width: this.getMobileWidth() }, table: f({}, this.hasGutter() ? { "background-color": this.getAttribute("inner-background-color"), border: this.getAttribute("inner-border"), "border-bottom": this.getAttribute("inner-border-bottom"), "border-left": this.getAttribute("inner-border-left"), "border-radius": this.getAttribute("inner-border-radius"), "border-right": this.getAttribute("inner-border-right"), "border-top": this.getAttribute("inner-border-top") } : k), tdOutlook: { "vertical-align": this.getAttribute("vertical-align"), width: this.getWidthAsPixel() }, gutter: f(f({}, k), {}, { padding: this.getAttribute("padding"), "padding-top": this.getAttribute("padding-top"), "padding-right": this.getAttribute("padding-right"), "padding-bottom": this.getAttribute("padding-bottom"), "padding-left": this.getAttribute("padding-left") }) };
        } }, { key: "getMobileWidth", value: function() {
          var k = this.context.containerWidth, I = this.props.nonRawSiblings, N = this.getAttribute("width");
          if (this.getAttribute("mobileWidth") !== "mobileWidth") return "100%";
          if (N === void 0) return "".concat(parseInt(100 / I, 10), "%");
          var j = (0, E.default)(N, { parseFloatToInt: !1 }), I = j.unit, B = j.parsedWidth;
          switch (I) {
            case "%":
              return N;
            case "px":
            default:
              return "".concat(B / parseInt(k, 10) * 100, "%");
          }
        } }, { key: "getWidthAsPixel", value: function() {
          var k = this.context.containerWidth, N = (j = (0, E.default)(this.getParsedWidth(!0), { parseFloatToInt: !1 })).unit, j = j.parsedWidth;
          return "".concat(N === "%" ? parseFloat(k) * j / 100 : j, "px");
        } }, { key: "getParsedWidth", value: function(k) {
          var j = this.props.nonRawSiblings, N = this.getAttribute("width") || "".concat(100 / j, "%"), N = (j = (0, E.default)(N, { parseFloatToInt: !1 })).unit, j = j.parsedWidth;
          return k ? "".concat(j).concat(N) : { unit: N, parsedWidth: j };
        } }, { key: "getColumnClass", value: function() {
          var k = this.context.addMediaQuery, N = "", j = (I = this.getParsedWidth()).parsedWidth, I = I.unit, B = j.toString().replace(".", "-");
          switch (I) {
            case "%":
              N = "mj-column-per-".concat(B);
              break;
            case "px":
            default:
              N = "mj-column-px-".concat(B);
          }
          return k(N, { parsedWidth: j, unit: I }), N;
        } }, { key: "hasGutter", value: function() {
          var k = this;
          return ["padding", "padding-bottom", "padding-left", "padding-right", "padding-top"].some(function(N) {
            return k.getAttribute(N) != null;
          });
        } }, { key: "renderGutter", value: function() {
          return `
      <table
        `.concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", width: "100%" }), `
      >
        <tbody>
          <tr>
            <td `).concat(this.htmlAttributes({ style: "gutter" }), `>
              `).concat(this.renderColumn(), `
            </td>
          </tr>
        </tbody>
      </table>
    `);
        } }, { key: "renderColumn", value: function() {
          var k = this.props.children;
          return `
      <table
        `.concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "table", width: "100%" }), `
      >
        <tbody>
          `).concat(this.renderChildren(k, { renderer: function(j) {
            return j.constructor.isRawElement() ? j.render() : `
              <tr>
                <td
                  `.concat(j.htmlAttributes({ align: j.getAttribute("align"), class: j.getAttribute("css-class"), style: { background: j.getAttribute("container-background-color"), "font-size": "0px", padding: j.getAttribute("padding"), "padding-top": j.getAttribute("padding-top"), "padding-right": j.getAttribute("padding-right"), "padding-bottom": j.getAttribute("padding-bottom"), "padding-left": j.getAttribute("padding-left"), "word-break": "break-word" } }), `
                >
                  `).concat(j.render(), `
                </td>
              </tr>
            `);
          } }), `
        </tbody>
      </table>
    `);
        } }, { key: "render", value: function() {
          var k = "".concat(this.getColumnClass(), " mj-outlook-group-fix");
          return this.getAttribute("css-class") && (k += " ".concat(this.getAttribute("css-class"))), `
      <div
        `.concat(this.htmlAttributes({ class: k, style: "div" }), `
      >
        `).concat(this.hasGutter() ? this.renderGutter() : this.renderColumn(), `
      </div>
    `);
        } }]), T;
      }(C.BodyComponent);
      (0, v.default)(C, "componentName", "mj-column"), (0, v.default)(C, "allowedAttributes", { "background-color": "color", border: "string", "border-bottom": "string", "border-left": "string", "border-radius": "unit(px,%){1,4}", "border-right": "string", "border-top": "string", direction: "enum(ltr,rtl)", "inner-background-color": "color", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", "inner-border": "string", "inner-border-bottom": "string", "inner-border-left": "string", "inner-border-radius": "unit(px,%){1,4}", "inner-border-right": "string", "inner-border-top": "string", padding: "unit(px,%){1,4}", "vertical-align": "enum(top,bottom,middle)", width: "unit(px,%)" }), (0, v.default)(C, "defaultAttributes", { direction: "ltr", "vertical-align": "top" }), a.exports = s.default;
    }, function(a, s, r) {
      function l(y) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
          return typeof T;
        } : function(T) {
          return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
        })(y);
      }
      function d(y, T) {
        var A, k = Object.keys(y);
        return Object.getOwnPropertySymbols && (A = Object.getOwnPropertySymbols(y), T && (A = A.filter(function(N) {
          return Object.getOwnPropertyDescriptor(y, N).enumerable;
        })), k.push.apply(k, A)), k;
      }
      function f(y) {
        for (var T = 1; T < arguments.length; T++) {
          var A = arguments[T] != null ? arguments[T] : {};
          T % 2 ? d(Object(A), !0).forEach(function(k) {
            (function(j, I, B) {
              (I = function(H) {
                return H = function(Y, ie) {
                  if (l(Y) != "object" || !Y) return Y;
                  var ce = Y[Symbol.toPrimitive];
                  if (ce === void 0) return (ie === "string" ? String : Number)(Y);
                  if (l(ie = ce.call(Y, ie || "default")) != "object") return ie;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(H, "string"), l(H) == "symbol" ? H : String(H);
              }(I)) in j ? Object.defineProperty(j, I, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : j[I] = B;
            })(y, k, A[k]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(A)) : d(Object(A)).forEach(function(k) {
            Object.defineProperty(y, k, Object.getOwnPropertyDescriptor(A, k));
          });
        }
        return y;
      }
      var h = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var p = h(r(5)), g = h(r(4)), _ = h(r(6)), b = h(r(7)), v = h(r(9)), C = r(10), E = h(r(37)), C = s.default = function(y) {
        function T() {
          return (0, p.default)(this, T), (0, _.default)(this, T, arguments);
        }
        return (0, b.default)(T, y), (0, g.default)(T, [{ key: "getStyles", value: function() {
          var k = this, N = "0px auto";
          return this.getAttribute("align") === "left" ? N = "0px" : this.getAttribute("align") === "right" && (N = "0px 0px 0px auto"), { p: N = { "border-top": ["style", "width", "color"].map(function(j) {
            return k.getAttribute("border-".concat(j));
          }).join(" "), "font-size": "1px", margin: N, width: this.getAttribute("width") }, outlook: f(f({}, N), {}, { width: this.getOutlookWidth() }) };
        } }, { key: "getOutlookWidth", value: function() {
          var k = this.context.containerWidth, N = this.getShorthandAttrValue("padding", "left") + this.getShorthandAttrValue("padding", "right"), j = this.getAttribute("width"), I = (0, E.default)(j), B = I.parsedWidth;
          switch (I.unit) {
            case "%":
              var U = parseInt(k, 10) - N, H = parseInt(B, 10) / 100;
              return "".concat(U * H, "px");
            case "px":
              return j;
            default:
              return "".concat(parseInt(k, 10) - N, "px");
          }
        } }, { key: "renderAfter", value: function() {
          return `
      <!--[if mso | IE]>
        <table
          `.concat(this.htmlAttributes({ align: this.getAttribute("align"), border: "0", cellpadding: "0", cellspacing: "0", style: "outlook", role: "presentation", width: this.getOutlookWidth() }), `
        >
          <tr>
            <td style="height:0;line-height:0;">
              &nbsp;
            </td>
          </tr>
        </table>
      <![endif]-->
    `);
        } }, { key: "render", value: function() {
          return `
      <p
        `.concat(this.htmlAttributes({ style: "p" }), `
      >
      </p>
      `).concat(this.renderAfter(), `
    `);
        } }]), T;
      }(C.BodyComponent);
      (0, v.default)(C, "componentName", "mj-divider"), (0, v.default)(C, "allowedAttributes", { "border-color": "color", "border-style": "string", "border-width": "unit(px)", "container-background-color": "color", padding: "unit(px,%){1,4}", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", width: "unit(px,%)", align: "enum(left,center,right)" }), (0, v.default)(C, "defaultAttributes", { "border-color": "#000000", "border-style": "solid", "border-width": "4px", padding: "10px 25px", width: "100%", align: "center" }), a.exports = s.default;
    }, function(a, s, r) {
      function l(y) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
          return typeof T;
        } : function(T) {
          return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
        })(y);
      }
      function d(y, T) {
        var A, k = Object.keys(y);
        return Object.getOwnPropertySymbols && (A = Object.getOwnPropertySymbols(y), T && (A = A.filter(function(N) {
          return Object.getOwnPropertyDescriptor(y, N).enumerable;
        })), k.push.apply(k, A)), k;
      }
      function f(y) {
        for (var T = 1; T < arguments.length; T++) {
          var A = arguments[T] != null ? arguments[T] : {};
          T % 2 ? d(Object(A), !0).forEach(function(k) {
            (function(j, I, B) {
              (I = function(H) {
                return H = function(Y, ie) {
                  if (l(Y) != "object" || !Y) return Y;
                  var ce = Y[Symbol.toPrimitive];
                  if (ce === void 0) return (ie === "string" ? String : Number)(Y);
                  if (l(ie = ce.call(Y, ie || "default")) != "object") return ie;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(H, "string"), l(H) == "symbol" ? H : String(H);
              }(I)) in j ? Object.defineProperty(j, I, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : j[I] = B;
            })(y, k, A[k]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(A)) : d(Object(A)).forEach(function(k) {
            Object.defineProperty(y, k, Object.getOwnPropertyDescriptor(A, k));
          });
        }
        return y;
      }
      var h = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var p = h(r(5)), g = h(r(4)), _ = h(r(6)), b = h(r(7)), v = h(r(9)), C = r(10), E = h(r(37)), C = s.default = function(y) {
        function T() {
          return (0, p.default)(this, T), (0, _.default)(this, T, arguments);
        }
        return (0, b.default)(T, y), (0, g.default)(T, [{ key: "getChildContext", value: function() {
          var k = this.context.containerWidth, I = (B = this.props).nonRawSiblings, N = B.children, j = this.getShorthandAttrValue("padding", "left") + this.getShorthandAttrValue("padding", "right"), U = this.getAttribute("width") || "".concat(parseFloat(k) / I, "px"), I = (B = (0, E.default)(U, { parseFloatToInt: !1 })).unit, B = B.parsedWidth, U = "".concat(I === "%" ? parseFloat(k) * B / 100 - j : B - j, "px");
          return f(f({}, this.context), {}, { containerWidth: U, nonRawSiblings: N.length });
        } }, { key: "getStyles", value: function() {
          return { div: { "font-size": "0", "line-height": "0", "text-align": "left", display: "inline-block", width: "100%", direction: this.getAttribute("direction"), "vertical-align": this.getAttribute("vertical-align"), "background-color": this.getAttribute("background-color") }, tdOutlook: { "vertical-align": this.getAttribute("vertical-align"), width: this.getWidthAsPixel() } };
        } }, { key: "getParsedWidth", value: function(k) {
          var j = this.props.nonRawSiblings, N = this.getAttribute("width") || "".concat(100 / j, "%"), N = (j = (0, E.default)(N, { parseFloatToInt: !1 })).unit, j = j.parsedWidth;
          return k ? "".concat(j).concat(N) : { unit: N, parsedWidth: j };
        } }, { key: "getWidthAsPixel", value: function() {
          var k = this.context.containerWidth, N = (j = (0, E.default)(this.getParsedWidth(!0), { parseFloatToInt: !1 })).unit, j = j.parsedWidth;
          return "".concat(N === "%" ? parseFloat(k) * j / 100 : j, "px");
        } }, { key: "getColumnClass", value: function() {
          var k = this.context.addMediaQuery, N = "", j = this.getParsedWidth(), I = j.parsedWidth;
          switch (j = j.unit) {
            case "%":
              N = "mj-column-per-".concat(parseInt(I, 10));
              break;
            case "px":
            default:
              N = "mj-column-px-".concat(parseInt(I, 10));
          }
          return k(N, { parsedWidth: I, unit: j }), N;
        } }, { key: "render", value: function() {
          var k = (B = this.props).children, N = B.nonRawSiblings, j = this.getChildContext().containerWidth, I = this.context.containerWidth, B = "".concat(this.getColumnClass(), " mj-outlook-group-fix");
          return this.getAttribute("css-class") && (B += " ".concat(this.getAttribute("css-class"))), `
      <div
        `.concat(this.htmlAttributes({ class: B, style: "div" }), `
      >
        <!--[if mso | IE]>
        <table
          `).concat(this.htmlAttributes({ bgcolor: this.getAttribute("background-color") === "none" ? void 0 : this.getAttribute("background-color"), border: "0", cellpadding: "0", cellspacing: "0", role: "presentation" }), `
        >
          <tr>
        <![endif]-->
          `).concat(this.renderChildren(k, { attributes: { mobileWidth: "mobileWidth" }, renderer: function(H) {
            return H.constructor.isRawElement() ? H.render() : `
              <!--[if mso | IE]>
              <td
                `.concat(H.htmlAttributes({ style: { align: H.getAttribute("align"), "vertical-align": H.getAttribute("vertical-align"), width: function(ie) {
              if (!ie) return "".concat(parseInt(I, 10) / parseInt(N, 10), "px");
              var ie = (ce = (0, E.default)(ie, { parseFloatToInt: !1 })).unit, ce = ce.parsedWidth;
              return ie === "%" ? "".concat(100 * ce / j, "px") : "".concat(ce).concat(ie);
            }(H.getWidthAsPixel ? H.getWidthAsPixel() : H.getAttribute("width")) } }), `
              >
              <![endif]-->
                `).concat(H.render(), `
              <!--[if mso | IE]>
              </td>
              <![endif]-->
          `);
          } }), `
        <!--[if mso | IE]>
          </tr>
          </table>
        <![endif]-->
      </div>
    `);
        } }]), T;
      }(C.BodyComponent);
      (0, v.default)(C, "componentName", "mj-group"), (0, v.default)(C, "allowedAttributes", { "background-color": "color", direction: "enum(ltr,rtl)", "vertical-align": "enum(top,bottom,middle)", width: "unit(px,%)" }), (0, v.default)(C, "defaultAttributes", { direction: "ltr" }), a.exports = s.default;
    }, function(a, s, A) {
      function l(k) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
          return typeof N;
        } : function(N) {
          return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
        })(k);
      }
      function d(k, N) {
        var j, I = Object.keys(k);
        return Object.getOwnPropertySymbols && (j = Object.getOwnPropertySymbols(k), N && (j = j.filter(function(B) {
          return Object.getOwnPropertyDescriptor(k, B).enumerable;
        })), I.push.apply(I, j)), I;
      }
      function f(k) {
        for (var N = 1; N < arguments.length; N++) {
          var j = arguments[N] != null ? arguments[N] : {};
          N % 2 ? d(Object(j), !0).forEach(function(I) {
            (function(U, H, Q) {
              (H = function(ie) {
                return ie = function($, te) {
                  if (l($) != "object" || !$) return $;
                  var V = $[Symbol.toPrimitive];
                  if (V === void 0) return (te === "string" ? String : Number)($);
                  if (l(te = V.call($, te || "default")) != "object") return te;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }(ie, "string"), l(ie) == "symbol" ? ie : String(ie);
              }(H)) in U ? Object.defineProperty(U, H, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : U[H] = Q;
            })(k, I, j[I]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(k, Object.getOwnPropertyDescriptors(j)) : d(Object(j)).forEach(function(I) {
            Object.defineProperty(k, I, Object.getOwnPropertyDescriptor(j, I));
          });
        }
        return k;
      }
      var h = A(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var p = h(A(5)), g = h(A(4)), _ = h(A(6)), b = h(A(39)), v = h(A(7)), E = h(A(9)), C = h(A(234)), y = A(10), T = h(A(37)), A = s.default = function(k) {
        function N() {
          var j;
          (0, p.default)(this, N);
          for (var I = arguments.length, B = new Array(I), U = 0; U < I; U++) B[U] = arguments[U];
          return j = (0, _.default)(this, N, [].concat(B)), (0, E.default)((0, b.default)(j), "headStyle", function(H) {
            return `
    @media only screen and (max-width:`.concat((0, y.makeLowerBreakpoint)(H), `) {
      table.mj-full-width-mobile { width: 100% !important; }
      td.mj-full-width-mobile { width: auto !important; }
    }
  `);
          }), j;
        }
        return (0, v.default)(N, k), (0, g.default)(N, [{ key: "getStyles", value: function() {
          var B = this.getContentWidth(), I = this.getAttribute("full-width") === "full-width", B = (U = (0, T.default)(B)).parsedWidth, U = U.unit;
          return { img: { border: this.getAttribute("border"), "border-left": this.getAttribute("border-left"), "border-right": this.getAttribute("border-right"), "border-top": this.getAttribute("border-top"), "border-bottom": this.getAttribute("border-bottom"), "border-radius": this.getAttribute("border-radius"), display: "block", outline: "none", "text-decoration": "none", height: this.getAttribute("height"), "max-height": this.getAttribute("max-height"), "min-width": I ? "100%" : null, width: "100%", "max-width": I ? "100%" : null, "font-size": this.getAttribute("font-size") }, td: { width: I ? null : "".concat(B).concat(U) }, table: { "min-width": I ? "100%" : null, "max-width": I ? "100%" : null, width: I ? "".concat(B).concat(U) : null, "border-collapse": "collapse", "border-spacing": "0px" } };
        } }, { key: "getContentWidth", value: function() {
          var I = this.getAttribute("width") ? parseInt(this.getAttribute("width"), 10) : 1 / 0, B = this.getBoxWidths().box;
          return (0, C.default)([B, I]);
        } }, { key: "renderImage", value: function() {
          var I = this.getAttribute("height"), I = `
      <img
        `.concat(this.htmlAttributes(f({ alt: this.getAttribute("alt"), src: this.getAttribute("src"), srcset: this.getAttribute("srcset"), sizes: this.getAttribute("sizes"), style: "img", title: this.getAttribute("title"), width: this.getContentWidth(), usemap: this.getAttribute("usemap") }, I ? { height: I === "auto" ? I : parseInt(I, 10) } : {})), `
      />
    `);
          return this.getAttribute("href") ? `
        <a
          `.concat(this.htmlAttributes({ href: this.getAttribute("href"), target: this.getAttribute("target"), rel: this.getAttribute("rel"), name: this.getAttribute("name"), title: this.getAttribute("title") }), `
        >
          `).concat(I, `
        </a>
      `) : I;
        } }, { key: "render", value: function() {
          return `
      <table
        `.concat(this.htmlAttributes({ border: "0", cellpadding: "0", cellspacing: "0", role: "presentation", style: "table", class: this.getAttribute("fluid-on-mobile") ? "mj-full-width-mobile" : null }), `
      >
        <tbody>
          <tr>
            <td `).concat(this.htmlAttributes({ style: "td", class: this.getAttribute("fluid-on-mobile") ? "mj-full-width-mobile" : null }), `>
              `).concat(this.renderImage(), `
            </td>
          </tr>
        </tbody>
      </table>
    `);
        } }]), N;
      }(y.BodyComponent);
      (0, E.default)(A, "componentName", "mj-image"), (0, E.default)(A, "allowedAttributes", { alt: "string", href: "string", name: "string", src: "string", srcset: "string", sizes: "string", title: "string", rel: "string", align: "enum(left,center,right)", border: "string", "border-bottom": "string", "border-left": "string", "border-right": "string", "border-top": "string", "border-radius": "unit(px,%){1,4}", "container-background-color": "color", "fluid-on-mobile": "boolean", padding: "unit(px,%){1,4}", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", target: "string", width: "unit(px)", height: "unit(px,auto)", "max-height": "unit(px,%)", "font-size": "unit(px)", usemap: "string" }), (0, E.default)(A, "defaultAttributes", { alt: "", align: "center", border: "0", height: "auto", padding: "10px 25px", target: "_blank", "font-size": "13px" }), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "render", value: function() {
          return this.getContent();
        } }]), b;
      }(g.BodyComponent);
      (0, p.default)(g, "componentName", "mj-raw"), (0, p.default)(g, "endingTag", !0), (0, p.default)(g, "rawElement", !0), (0, p.default)(g, "allowedAttributes", { position: "enum(file-start)" }), a.exports = s.default;
    }, function(a, s, g) {
      var p = g(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = p(g(5)), d = p(g(4)), f = p(g(6)), h = p(g(7)), p = p(g(9)), g = g(10), g = s.default = function(_) {
        function b() {
          return (0, l.default)(this, b), (0, f.default)(this, b, arguments);
        }
        return (0, h.default)(b, _), (0, d.default)(b, [{ key: "getStyles", value: function() {
          return { div: { height: this.getAttribute("height"), "line-height": this.getAttribute("height") } };
        } }, { key: "render", value: function() {
          return `
      <div
        `.concat(this.htmlAttributes({ style: "div" }), `
      >&#8202;</div>
    `);
        } }]), b;
      }(g.BodyComponent);
      (0, p.default)(g, "componentName", "mj-spacer"), (0, p.default)(g, "allowedAttributes", { border: "string", "border-bottom": "string", "border-left": "string", "border-right": "string", "border-top": "string", "container-background-color": "color", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", height: "unit(px,%)" }), (0, p.default)(g, "defaultAttributes", { height: "20px" }), a.exports = s.default;
    }, function(a, s, r) {
      var l = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var d = l(r(5)), f = l(r(4)), h = l(r(6)), p = l(r(7)), g = l(r(9)), b = r(10), _ = l(r(53)), b = s.default = function(v) {
        function E() {
          return (0, d.default)(this, E), (0, h.default)(this, E, arguments);
        }
        return (0, p.default)(E, v), (0, f.default)(E, [{ key: "getStyles", value: function() {
          return { text: { "font-family": this.getAttribute("font-family"), "font-size": this.getAttribute("font-size"), "font-style": this.getAttribute("font-style"), "font-weight": this.getAttribute("font-weight"), "letter-spacing": this.getAttribute("letter-spacing"), "line-height": this.getAttribute("line-height"), "text-align": this.getAttribute("align"), "text-decoration": this.getAttribute("text-decoration"), "text-transform": this.getAttribute("text-transform"), color: this.getAttribute("color"), height: this.getAttribute("height") } };
        } }, { key: "renderContent", value: function() {
          return `
      <div
        `.concat(this.htmlAttributes({ style: "text" }), `
      >`).concat(this.getContent(), `</div>
    `);
        } }, { key: "render", value: function() {
          var y = this.getAttribute("height");
          return y ? `
        `.concat((0, _.default)(`
          <table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td height="`.concat(y, '" style="vertical-align:top;height:').concat(y, `;">
        `)), `
        `).concat(this.renderContent(), `
        `).concat((0, _.default)(`
          </td></tr></table>
        `), `
      `) : this.renderContent();
        } }]), E;
      }(b.BodyComponent);
      (0, g.default)(b, "componentName", "mj-text"), (0, g.default)(b, "endingTag", !0), (0, g.default)(b, "allowedAttributes", { align: "enum(left,right,center,justify)", "background-color": "color", color: "color", "container-background-color": "color", "font-family": "string", "font-size": "unit(px)", "font-style": "string", "font-weight": "string", height: "unit(px,%)", "letter-spacing": "unitWithNegative(px,em)", "line-height": "unit(px,%,)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", "text-decoration": "string", "text-transform": "string", "vertical-align": "enum(top,bottom,middle)" }), (0, g.default)(b, "defaultAttributes", { align: "left", color: "#000000", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "font-size": "13px", "line-height": "1", padding: "10px 25px" }), a.exports = s.default;
    }, function(a, s, T) {
      function l(A) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(k) {
          return typeof k;
        } : function(k) {
          return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
        })(A);
      }
      function d(A, k) {
        var N, j = Object.keys(A);
        return Object.getOwnPropertySymbols && (N = Object.getOwnPropertySymbols(A), k && (N = N.filter(function(I) {
          return Object.getOwnPropertyDescriptor(A, I).enumerable;
        })), j.push.apply(j, N)), j;
      }
      function f(A) {
        for (var k = 1; k < arguments.length; k++) {
          var N = arguments[k] != null ? arguments[k] : {};
          k % 2 ? d(Object(N), !0).forEach(function(j) {
            h(A, j, N[j]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(N)) : d(Object(N)).forEach(function(j) {
            Object.defineProperty(A, j, Object.getOwnPropertyDescriptor(N, j));
          });
        }
        return A;
      }
      function h(A, k, N) {
        return (k = function(I) {
          return I = function(U, H) {
            if (l(U) != "object" || !U) return U;
            var Q = U[Symbol.toPrimitive];
            if (Q === void 0) return (H === "string" ? String : Number)(U);
            if (l(H = Q.call(U, H || "default")) != "object") return H;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(I, "string"), l(I) == "symbol" ? I : String(I);
        }(k)) in A ? Object.defineProperty(A, k, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : A[k] = N, A;
      }
      var p = T(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var g = p(T(5)), _ = p(T(4)), b = p(T(6)), v = p(T(7)), E = p(T(9)), C = p(T(57)), y = p(T(37)), T = T(10), T = s.default = function(A) {
        function k() {
          return (0, g.default)(this, k), (0, b.default)(this, k, arguments);
        }
        return (0, v.default)(k, A), (0, _.default)(k, [{ key: "getStyles", value: function() {
          return { table: { color: this.getAttribute("color"), "font-family": this.getAttribute("font-family"), "font-size": this.getAttribute("font-size"), "line-height": this.getAttribute("line-height"), "table-layout": this.getAttribute("table-layout"), width: this.getAttribute("width"), border: this.getAttribute("border") } };
        } }, { key: "getWidth", value: function() {
          var j = this.getAttribute("width"), I = (0, y.default)(j), B = I.parsedWidth;
          return I.unit === "%" ? j : B;
        } }, { key: "render", value: function() {
          var j = this, I = (0, C.default)(["cellpadding", "cellspacing", "role"], function(B, U) {
            return f(f({}, B), {}, h({}, U, j.getAttribute(U)));
          }, {});
          return `
      <table
        `.concat(this.htmlAttributes(f(f({}, I), {}, { width: this.getWidth(), border: "0", style: "table" })), `
      >
        `).concat(this.getContent(), `
      </table>
    `);
        } }]), k;
      }(T.BodyComponent);
      (0, E.default)(T, "componentName", "mj-table"), (0, E.default)(T, "endingTag", !0), (0, E.default)(T, "allowedAttributes", { align: "enum(left,right,center)", border: "string", cellpadding: "integer", cellspacing: "integer", "container-background-color": "color", color: "color", "font-family": "string", "font-size": "unit(px)", "font-weight": "string", "line-height": "unit(px,%,)", "padding-bottom": "unit(px,%)", "padding-left": "unit(px,%)", "padding-right": "unit(px,%)", "padding-top": "unit(px,%)", padding: "unit(px,%){1,4}", role: "enum(none,presentation)", "table-layout": "enum(auto,fixed,initial,inherit)", "vertical-align": "enum(top,bottom,middle)", width: "unit(px,%)" }), (0, E.default)(T, "defaultAttributes", { align: "left", border: "none", cellpadding: "0", cellspacing: "0", color: "#000000", "font-family": "Ubuntu, Helvetica, Arial, sans-serif", "font-size": "13px", "line-height": "22px", padding: "10px 25px", "table-layout": "auto", width: "100%" }), a.exports = s.default;
    }, function(a, s, r) {
      var _ = r(1).default;
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0;
      var l = _(r(5)), d = _(r(4)), f = _(r(6)), h = _(r(7)), p = _(r(9)), _ = _(r(239)), g = r(10), _ = s.default = function(b) {
        function v() {
          return (0, l.default)(this, v), (0, f.default)(this, v, arguments);
        }
        return (0, h.default)(v, b), (0, d.default)(v, [{ key: "renderWrappedChildren", value: function() {
          var C = this.props.children, y = this.context.containerWidth;
          return `
      `.concat(this.renderChildren(C, { renderer: function(A) {
            return A.constructor.isRawElement() ? A.render() : `
          <!--[if mso | IE]>
            <tr>
              <td
                `.concat(A.htmlAttributes({ align: A.getAttribute("align"), class: (0, g.suffixCssClasses)(A.getAttribute("css-class"), "outlook"), width: y }), `
              >
          <![endif]-->
            `).concat(A.render(), `
          <!--[if mso | IE]>
              </td>
            </tr>
          <![endif]-->
        `);
          } }), `
    `);
        } }]), v;
      }(_.default);
      (0, p.default)(_, "componentName", "mj-wrapper"), a.exports = s.default;
    }, function(a, s, r) {
      Object.defineProperty(s, "__esModule", { value: !0 }), s.default = void 0, s.default = { mjml: ["mj-body", "mj-head", "mj-raw"], "mj-accordion": ["mj-accordion-element", "mj-raw"], "mj-accordion-element": ["mj-accordion-title", "mj-accordion-text", "mj-raw"], "mj-accordion-title": [], "mj-accordion-text": [], "mj-attributes": [/^.*^/], "mj-body": ["mj-raw", "mj-section", "mj-wrapper", "mj-hero"], "mj-button": [], "mj-carousel": ["mj-carousel-image"], "mj-carousel-image": [], "mj-column": ["mj-accordion", "mj-button", "mj-carousel", "mj-divider", "mj-image", "mj-raw", "mj-social", "mj-spacer", "mj-table", "mj-text", "mj-navbar"], "mj-html-attribute": [], "mj-html-attributes": ["mj-selector"], "mj-divider": [], "mj-group": ["mj-column", "mj-raw"], "mj-head": ["mj-attributes", "mj-breakpoint", "mj-html-attributes", "mj-font", "mj-preview", "mj-style", "mj-title", "mj-raw"], "mj-hero": ["mj-accordion", "mj-button", "mj-carousel", "mj-divider", "mj-image", "mj-social", "mj-spacer", "mj-table", "mj-text", "mj-navbar", "mj-raw"], "mj-image": [], "mj-navbar": ["mj-navbar-link", "mj-raw"], "mj-raw": [], "mj-section": ["mj-column", "mj-group", "mj-raw"], "mj-selector": ["mj-html-attribute"], "mj-social": ["mj-social-element", "mj-raw"], "mj-social-element": [], "mj-spacer": [], "mj-table": [], "mj-text": [], "mj-wrapper": ["mj-hero", "mj-raw", "mj-section"] }, a.exports = s.default;
    }, function(a, A, r) {
      r.r(A), r.d(A, "Parser", function() {
        return Y;
      }), r.d(A, "DomHandler", function() {
        return ie.c;
      }), r.d(A, "DefaultHandler", function() {
        return ie.c;
      }), r.d(A, "parseDocument", function() {
        return te;
      }), r.d(A, "parseDOM", function() {
        return V;
      }), r.d(A, "createDocumentStream", function() {
        return K;
      }), r.d(A, "createDomStream", function() {
        return ne;
      }), r.d(A, "Tokenizer", function() {
        return E;
      }), r.d(A, "QuoteType", function() {
        return f;
      }), r.d(A, "ElementType", function() {
        return ce;
      }), r.d(A, "getFeed", function() {
        return $.getFeed;
      }), r.d(A, "parseFeed", function() {
        return L;
      }), r.d(A, "DomUtils", function() {
        return $;
      });
      var l, d, f, h = r(11);
      function p(z) {
        return (p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ee) {
          return typeof ee;
        } : function(ee) {
          return ee && typeof Symbol == "function" && ee.constructor === Symbol && ee !== Symbol.prototype ? "symbol" : typeof ee;
        })(z);
      }
      function g(z, ee) {
        for (var q = 0; q < ee.length; q++) {
          var X = ee[q];
          X.enumerable = X.enumerable || !1, X.configurable = !0, "value" in X && (X.writable = !0), Object.defineProperty(z, function(ae) {
            return ae = function(ve, Ee) {
              if (p(ve) != "object" || !ve) return ve;
              var we = ve[Symbol.toPrimitive];
              if (we === void 0) return (Ee === "string" ? String : Number)(ve);
              if (p(Ee = we.call(ve, Ee || "default")) != "object") return Ee;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ae, "string"), p(ae) == "symbol" ? ae : String(ae);
          }(X.key), X);
        }
      }
      function _(z) {
        return z === l.Space || z === l.NewLine || z === l.Tab || z === l.FormFeed || z === l.CarriageReturn;
      }
      function b(z) {
        return z === l.Slash || z === l.Gt || _(z);
      }
      (k = l = l || {})[k.Tab = 9] = "Tab", k[k.NewLine = 10] = "NewLine", k[k.FormFeed = 12] = "FormFeed", k[k.CarriageReturn = 13] = "CarriageReturn", k[k.Space = 32] = "Space", k[k.ExclamationMark = 33] = "ExclamationMark", k[k.Number = 35] = "Number", k[k.Amp = 38] = "Amp", k[k.SingleQuote = 39] = "SingleQuote", k[k.DoubleQuote = 34] = "DoubleQuote", k[k.Dash = 45] = "Dash", k[k.Slash = 47] = "Slash", k[k.Zero = 48] = "Zero", k[k.Nine = 57] = "Nine", k[k.Semi = 59] = "Semi", k[k.Lt = 60] = "Lt", k[k.Eq = 61] = "Eq", k[k.Gt = 62] = "Gt", k[k.Questionmark = 63] = "Questionmark", k[k.UpperA = 65] = "UpperA", k[k.LowerA = 97] = "LowerA", k[k.UpperF = 70] = "UpperF", k[k.LowerF = 102] = "LowerF", k[k.UpperZ = 90] = "UpperZ", k[k.LowerZ = 122] = "LowerZ", k[k.LowerX = 120] = "LowerX", k[k.OpeningSquareBracket = 91] = "OpeningSquareBracket", (N = d = d || {})[N.Text = 1] = "Text", N[N.BeforeTagName = 2] = "BeforeTagName", N[N.InTagName = 3] = "InTagName", N[N.InSelfClosingTag = 4] = "InSelfClosingTag", N[N.BeforeClosingTagName = 5] = "BeforeClosingTagName", N[N.InClosingTagName = 6] = "InClosingTagName", N[N.AfterClosingTagName = 7] = "AfterClosingTagName", N[N.BeforeAttributeName = 8] = "BeforeAttributeName", N[N.InAttributeName = 9] = "InAttributeName", N[N.AfterAttributeName = 10] = "AfterAttributeName", N[N.BeforeAttributeValue = 11] = "BeforeAttributeValue", N[N.InAttributeValueDq = 12] = "InAttributeValueDq", N[N.InAttributeValueSq = 13] = "InAttributeValueSq", N[N.InAttributeValueNq = 14] = "InAttributeValueNq", N[N.BeforeDeclaration = 15] = "BeforeDeclaration", N[N.InDeclaration = 16] = "InDeclaration", N[N.InProcessingInstruction = 17] = "InProcessingInstruction", N[N.BeforeComment = 18] = "BeforeComment", N[N.CDATASequence = 19] = "CDATASequence", N[N.InSpecialComment = 20] = "InSpecialComment", N[N.InCommentLike = 21] = "InCommentLike", N[N.BeforeSpecialS = 22] = "BeforeSpecialS", N[N.BeforeSpecialT = 23] = "BeforeSpecialT", N[N.SpecialStartSequence = 24] = "SpecialStartSequence", N[N.InSpecialTag = 25] = "InSpecialTag", N[N.InEntity = 26] = "InEntity", (j = f = f || {})[j.NoValue = 0] = "NoValue", j[j.Unquoted = 1] = "Unquoted", j[j.Single = 2] = "Single", j[j.Double = 3] = "Double";
      var v = { Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]), CdataEnd: new Uint8Array([93, 93, 62]), CommentEnd: new Uint8Array([45, 45, 62]), ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]), StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]), TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]), TextareaEnd: new Uint8Array([60, 47, 116, 101, 120, 116, 97, 114, 101, 97]) }, E = function() {
        function z(ae, q) {
          var X = this, oe = (oe = ae.xmlMode) !== void 0 && oe, ae = (ae = ae.decodeEntities) === void 0 || ae;
          (function(ve, Ee) {
            if (!(ve instanceof Ee)) throw new TypeError("Cannot call a class as a function");
          })(this, z), this.cbs = q, this.state = d.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = d.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = oe, this.decodeEntities = ae, this.entityDecoder = new h.EntityDecoder(oe ? h.xmlDecodeTree : h.htmlDecodeTree, function(_e, ve) {
            return X.emitCodePoint(_e, ve);
          });
        }
        return function(q, X, oe) {
          X && g(q.prototype, X), Object.defineProperty(q, "prototype", { writable: !1 });
        }(z, [{ key: "reset", value: function() {
          this.state = d.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = d.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        } }, { key: "write", value: function(q) {
          this.offset += this.buffer.length, this.buffer = q, this.parse();
        } }, { key: "end", value: function() {
          this.running && this.finish();
        } }, { key: "pause", value: function() {
          this.running = !1;
        } }, { key: "resume", value: function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        } }, { key: "stateText", value: function(q) {
          q === l.Lt || !this.decodeEntities && this.fastForwardTo(l.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = d.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && q === l.Amp && this.startEntity();
        } }, { key: "stateSpecialStartSequence", value: function(q) {
          var X = this.sequenceIndex === this.currentSequence.length;
          if (X ? b(q) : (32 | q) === this.currentSequence[this.sequenceIndex]) {
            if (!X) return void this.sequenceIndex++;
          } else this.isSpecial = !1;
          this.sequenceIndex = 0, this.state = d.InTagName, this.stateInTagName(q);
        } }, { key: "stateInSpecialTag", value: function(q) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (q === l.Gt || _(q)) {
              var X, oe = this.index - this.currentSequence.length;
              return this.sectionStart < oe && (X = this.index, this.index = oe, this.cbs.ontext(this.sectionStart, oe), this.index = X), this.isSpecial = !1, this.sectionStart = 2 + oe, void this.stateInClosingTagName(q);
            }
            this.sequenceIndex = 0;
          }
          (32 | q) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === v.TitleEnd ? this.decodeEntities && q === l.Amp && this.startEntity() : this.fastForwardTo(l.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(q === l.Lt);
        } }, { key: "stateCDATASequence", value: function(q) {
          q === v.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === v.Cdata.length && (this.state = d.InCommentLike, this.currentSequence = v.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = d.InDeclaration, this.stateInDeclaration(q));
        } }, { key: "fastForwardTo", value: function(q) {
          for (; ++this.index < this.buffer.length + this.offset; ) if (this.buffer.charCodeAt(this.index - this.offset) === q) return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        } }, { key: "stateInCommentLike", value: function(q) {
          q === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === v.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = d.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : q !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        } }, { key: "isTagStartChar", value: function(q) {
          return this.xmlMode ? !b(q) : function(oe) {
            return oe >= l.LowerA && oe <= l.LowerZ || oe >= l.UpperA && oe <= l.UpperZ;
          }(q);
        } }, { key: "startSpecial", value: function(q, X) {
          this.isSpecial = !0, this.currentSequence = q, this.sequenceIndex = X, this.state = d.SpecialStartSequence;
        } }, { key: "stateBeforeTagName", value: function(q) {
          var X;
          q === l.ExclamationMark ? (this.state = d.BeforeDeclaration, this.sectionStart = this.index + 1) : q === l.Questionmark ? (this.state = d.InProcessingInstruction, this.sectionStart = this.index + 1) : this.isTagStartChar(q) ? (X = 32 | q, this.sectionStart = this.index, this.xmlMode ? this.state = d.InTagName : X === v.ScriptEnd[2] ? this.state = d.BeforeSpecialS : X === v.TitleEnd[2] ? this.state = d.BeforeSpecialT : this.state = d.InTagName) : q === l.Slash ? this.state = d.BeforeClosingTagName : (this.state = d.Text, this.stateText(q));
        } }, { key: "stateInTagName", value: function(q) {
          b(q) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = d.BeforeAttributeName, this.stateBeforeAttributeName(q));
        } }, { key: "stateBeforeClosingTagName", value: function(q) {
          _(q) || (q === l.Gt ? this.state = d.Text : (this.state = this.isTagStartChar(q) ? d.InClosingTagName : d.InSpecialComment, this.sectionStart = this.index));
        } }, { key: "stateInClosingTagName", value: function(q) {
          q !== l.Gt && !_(q) || (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = d.AfterClosingTagName, this.stateAfterClosingTagName(q));
        } }, { key: "stateAfterClosingTagName", value: function(q) {
          q !== l.Gt && !this.fastForwardTo(l.Gt) || (this.state = d.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateBeforeAttributeName", value: function(q) {
          q === l.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = d.InSpecialTag, this.sequenceIndex = 0) : this.state = d.Text, this.sectionStart = this.index + 1) : q === l.Slash ? this.state = d.InSelfClosingTag : _(q) || (this.state = d.InAttributeName, this.sectionStart = this.index);
        } }, { key: "stateInSelfClosingTag", value: function(q) {
          q === l.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = d.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : _(q) || (this.state = d.BeforeAttributeName, this.stateBeforeAttributeName(q));
        } }, { key: "stateInAttributeName", value: function(q) {
          q !== l.Eq && !b(q) || (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = d.AfterAttributeName, this.stateAfterAttributeName(q));
        } }, { key: "stateAfterAttributeName", value: function(q) {
          q === l.Eq ? this.state = d.BeforeAttributeValue : q === l.Slash || q === l.Gt ? (this.cbs.onattribend(f.NoValue, this.sectionStart), this.sectionStart = -1, this.state = d.BeforeAttributeName, this.stateBeforeAttributeName(q)) : _(q) || (this.cbs.onattribend(f.NoValue, this.sectionStart), this.state = d.InAttributeName, this.sectionStart = this.index);
        } }, { key: "stateBeforeAttributeValue", value: function(q) {
          q === l.DoubleQuote ? (this.state = d.InAttributeValueDq, this.sectionStart = this.index + 1) : q === l.SingleQuote ? (this.state = d.InAttributeValueSq, this.sectionStart = this.index + 1) : _(q) || (this.sectionStart = this.index, this.state = d.InAttributeValueNq, this.stateInAttributeValueNoQuotes(q));
        } }, { key: "handleInAttributeValue", value: function(q, X) {
          q === X || !this.decodeEntities && this.fastForwardTo(X) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(X === l.DoubleQuote ? f.Double : f.Single, this.index + 1), this.state = d.BeforeAttributeName) : this.decodeEntities && q === l.Amp && this.startEntity();
        } }, { key: "stateInAttributeValueDoubleQuotes", value: function(q) {
          this.handleInAttributeValue(q, l.DoubleQuote);
        } }, { key: "stateInAttributeValueSingleQuotes", value: function(q) {
          this.handleInAttributeValue(q, l.SingleQuote);
        } }, { key: "stateInAttributeValueNoQuotes", value: function(q) {
          _(q) || q === l.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(f.Unquoted, this.index), this.state = d.BeforeAttributeName, this.stateBeforeAttributeName(q)) : this.decodeEntities && q === l.Amp && this.startEntity();
        } }, { key: "stateBeforeDeclaration", value: function(q) {
          q === l.OpeningSquareBracket ? (this.state = d.CDATASequence, this.sequenceIndex = 0) : this.state = q === l.Dash ? d.BeforeComment : d.InDeclaration;
        } }, { key: "stateInDeclaration", value: function(q) {
          q !== l.Gt && !this.fastForwardTo(l.Gt) || (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = d.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateInProcessingInstruction", value: function(q) {
          q !== l.Gt && !this.fastForwardTo(l.Gt) || (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = d.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateBeforeComment", value: function(q) {
          q === l.Dash ? (this.state = d.InCommentLike, this.currentSequence = v.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = d.InDeclaration;
        } }, { key: "stateInSpecialComment", value: function(q) {
          q !== l.Gt && !this.fastForwardTo(l.Gt) || (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = d.Text, this.sectionStart = this.index + 1);
        } }, { key: "stateBeforeSpecialS", value: function(q) {
          var X = 32 | q;
          X === v.ScriptEnd[3] ? this.startSpecial(v.ScriptEnd, 4) : X === v.StyleEnd[3] ? this.startSpecial(v.StyleEnd, 4) : (this.state = d.InTagName, this.stateInTagName(q));
        } }, { key: "stateBeforeSpecialT", value: function(q) {
          var X = 32 | q;
          X === v.TitleEnd[3] ? this.startSpecial(v.TitleEnd, 4) : X === v.TextareaEnd[3] ? this.startSpecial(v.TextareaEnd, 4) : (this.state = d.InTagName, this.stateInTagName(q));
        } }, { key: "startEntity", value: function() {
          this.baseState = this.state, this.state = d.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? h.DecodingMode.Strict : this.baseState === d.Text || this.baseState === d.InSpecialTag ? h.DecodingMode.Legacy : h.DecodingMode.Attribute);
        } }, { key: "stateInEntity", value: function() {
          var q = this.entityDecoder.write(this.buffer, this.index - this.offset);
          0 <= q ? (this.state = this.baseState, q === 0 && (this.index = this.entityStart)) : this.index = this.offset + this.buffer.length - 1;
        } }, { key: "cleanup", value: function() {
          this.running && this.sectionStart !== this.index && (this.state === d.Text || this.state === d.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : this.state !== d.InAttributeValueDq && this.state !== d.InAttributeValueSq && this.state !== d.InAttributeValueNq || (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        } }, { key: "shouldContinue", value: function() {
          return this.index < this.buffer.length + this.offset && this.running;
        } }, { key: "parse", value: function() {
          for (; this.shouldContinue(); ) {
            var q = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case d.Text:
                this.stateText(q);
                break;
              case d.SpecialStartSequence:
                this.stateSpecialStartSequence(q);
                break;
              case d.InSpecialTag:
                this.stateInSpecialTag(q);
                break;
              case d.CDATASequence:
                this.stateCDATASequence(q);
                break;
              case d.InAttributeValueDq:
                this.stateInAttributeValueDoubleQuotes(q);
                break;
              case d.InAttributeName:
                this.stateInAttributeName(q);
                break;
              case d.InCommentLike:
                this.stateInCommentLike(q);
                break;
              case d.InSpecialComment:
                this.stateInSpecialComment(q);
                break;
              case d.BeforeAttributeName:
                this.stateBeforeAttributeName(q);
                break;
              case d.InTagName:
                this.stateInTagName(q);
                break;
              case d.InClosingTagName:
                this.stateInClosingTagName(q);
                break;
              case d.BeforeTagName:
                this.stateBeforeTagName(q);
                break;
              case d.AfterAttributeName:
                this.stateAfterAttributeName(q);
                break;
              case d.InAttributeValueSq:
                this.stateInAttributeValueSingleQuotes(q);
                break;
              case d.BeforeAttributeValue:
                this.stateBeforeAttributeValue(q);
                break;
              case d.BeforeClosingTagName:
                this.stateBeforeClosingTagName(q);
                break;
              case d.AfterClosingTagName:
                this.stateAfterClosingTagName(q);
                break;
              case d.BeforeSpecialS:
                this.stateBeforeSpecialS(q);
                break;
              case d.BeforeSpecialT:
                this.stateBeforeSpecialT(q);
                break;
              case d.InAttributeValueNq:
                this.stateInAttributeValueNoQuotes(q);
                break;
              case d.InSelfClosingTag:
                this.stateInSelfClosingTag(q);
                break;
              case d.InDeclaration:
                this.stateInDeclaration(q);
                break;
              case d.BeforeDeclaration:
                this.stateBeforeDeclaration(q);
                break;
              case d.BeforeComment:
                this.stateBeforeComment(q);
                break;
              case d.InProcessingInstruction:
                this.stateInProcessingInstruction(q);
                break;
              case d.InEntity:
                this.stateInEntity();
            }
            this.index++;
          }
          this.cleanup();
        } }, { key: "finish", value: function() {
          this.state === d.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
        } }, { key: "handleTrailingData", value: function() {
          var q = this.buffer.length + this.offset;
          this.sectionStart >= q || (this.state === d.InCommentLike ? this.currentSequence === v.CdataEnd ? this.cbs.oncdata(this.sectionStart, q, 0) : this.cbs.oncomment(this.sectionStart, q, 0) : this.state === d.InTagName || this.state === d.BeforeAttributeName || this.state === d.BeforeAttributeValue || this.state === d.AfterAttributeName || this.state === d.InAttributeName || this.state === d.InAttributeValueSq || this.state === d.InAttributeValueDq || this.state === d.InAttributeValueNq || this.state === d.InClosingTagName || this.cbs.ontext(this.sectionStart, q));
        } }, { key: "emitCodePoint", value: function(q, X) {
          this.baseState !== d.Text && this.baseState !== d.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + X, this.index = this.sectionStart - 1, this.cbs.onattribentity(q)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + X, this.index = this.sectionStart - 1, this.cbs.ontextentity(q, this.sectionStart));
        } }]), z;
      }();
      function C(z) {
        return (C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ee) {
          return typeof ee;
        } : function(ee) {
          return ee && typeof Symbol == "function" && ee.constructor === Symbol && ee !== Symbol.prototype ? "symbol" : typeof ee;
        })(z);
      }
      function y(z, ee) {
        for (var q = 0; q < ee.length; q++) {
          var X = ee[q];
          X.enumerable = X.enumerable || !1, X.configurable = !0, "value" in X && (X.writable = !0), Object.defineProperty(z, function(ae) {
            return ae = function(ve, Ee) {
              if (C(ve) != "object" || !ve) return ve;
              var we = ve[Symbol.toPrimitive];
              if (we === void 0) return (Ee === "string" ? String : Number)(ve);
              if (C(Ee = we.call(ve, Ee || "default")) != "object") return Ee;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }(ae, "string"), C(ae) == "symbol" ? ae : String(ae);
          }(X.key), X);
        }
      }
      var T = /* @__PURE__ */ new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]), A = /* @__PURE__ */ new Set(["p"]), k = /* @__PURE__ */ new Set(["thead", "tbody"]), N = /* @__PURE__ */ new Set(["dd", "dt"]), j = /* @__PURE__ */ new Set(["rt", "rp"]), I = /* @__PURE__ */ new Map([["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])], ["th", /* @__PURE__ */ new Set(["th"])], ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])], ["body", /* @__PURE__ */ new Set(["head", "link", "script"])], ["li", /* @__PURE__ */ new Set(["li"])], ["p", A], ["h1", A], ["h2", A], ["h3", A], ["h4", A], ["h5", A], ["h6", A], ["select", T], ["input", T], ["output", T], ["button", T], ["datalist", T], ["textarea", T], ["option", /* @__PURE__ */ new Set(["option"])], ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])], ["dd", N], ["dt", N], ["address", A], ["article", A], ["aside", A], ["blockquote", A], ["details", A], ["div", A], ["dl", A], ["fieldset", A], ["figcaption", A], ["figure", A], ["footer", A], ["form", A], ["header", A], ["hr", A], ["main", A], ["nav", A], ["ol", A], ["pre", A], ["section", A], ["table", A], ["ul", A], ["rt", j], ["rp", j], ["tbody", k], ["tfoot", k]]), B = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]), U = /* @__PURE__ */ new Set(["math", "svg"]), H = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]), Q = /\s|\//, Y = function() {
        function z(ee) {
          var q = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
          (function(oe, ae) {
            if (!(oe instanceof ae)) throw new TypeError("Cannot call a class as a function");
          })(this, z), this.options = q, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = ee ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (ee = q.lowerCaseTags) !== null && ee !== void 0 ? ee : this.htmlMode, this.lowerCaseAttributeNames = (ee = q.lowerCaseAttributeNames) !== null && ee !== void 0 ? ee : this.htmlMode, this.recognizeSelfClosing = (ee = q.recognizeSelfClosing) !== null && ee !== void 0 ? ee : !this.htmlMode, this.tokenizer = new ((ee = q.Tokenizer) !== null && ee !== void 0 ? ee : E)(this.options, this), this.foreignContext = [!this.htmlMode], (ee = (q = this.cbs).onparserinit) !== null && ee !== void 0 && ee.call(q, this);
        }
        return function(q, X, oe) {
          X && y(q.prototype, X), Object.defineProperty(q, "prototype", { writable: !1 });
        }(z, [{ key: "ontext", value: function(q, X) {
          var oe, ae = this.getSlice(q, X);
          this.endIndex = X - 1, (q = (oe = this.cbs).ontext) !== null && q !== void 0 && q.call(oe, ae), this.startIndex = X;
        } }, { key: "ontextentity", value: function(q, X) {
          var oe, ae;
          this.endIndex = X - 1, (ae = (oe = this.cbs).ontext) !== null && ae !== void 0 && ae.call(oe, Object(h.fromCodePoint)(q)), this.startIndex = X;
        } }, { key: "isVoidElement", value: function(q) {
          return this.htmlMode && B.has(q);
        } }, { key: "onopentagname", value: function(q, X) {
          this.endIndex = X, X = this.getSlice(q, X), this.lowerCaseTagNames && (X = X.toLowerCase()), this.emitOpenTag(X);
        } }, { key: "emitOpenTag", value: function(q) {
          var X, oe, ae, _e;
          this.openTagStart = this.startIndex, this.tagname = q;
          var ve = this.htmlMode && I.get(q);
          if (ve) for (; 0 < this.stack.length && ve.has(this.stack[0]); ) {
            var Ee = this.stack.shift();
            (oe = (X = this.cbs).onclosetag) !== null && oe !== void 0 && oe.call(X, Ee, !0);
          }
          this.isVoidElement(q) || (this.stack.unshift(q), this.htmlMode && (U.has(q) ? this.foreignContext.unshift(!0) : H.has(q) && this.foreignContext.unshift(!1))), (_e = (ae = this.cbs).onopentagname) !== null && _e !== void 0 && _e.call(ae, q), this.cbs.onopentag && (this.attribs = {});
        } }, { key: "endOpenTag", value: function(q) {
          var X, oe;
          this.startIndex = this.openTagStart, this.attribs && ((oe = (X = this.cbs).onopentag) !== null && oe !== void 0 && oe.call(X, this.tagname, this.attribs, q), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
        } }, { key: "onopentagend", value: function(q) {
          this.endIndex = q, this.endOpenTag(!1), this.startIndex = q + 1;
        } }, { key: "onclosetag", value: function(q, X) {
          var oe, ae, _e;
          this.endIndex = X;
          var ve = this.getSlice(q, X);
          if (this.lowerCaseTagNames && (ve = ve.toLowerCase()), this.htmlMode && (U.has(ve) || H.has(ve)) && this.foreignContext.shift(), this.isVoidElement(ve)) this.htmlMode && ve === "br" && ((q = (_e = this.cbs).onopentagname) !== null && q !== void 0 && q.call(_e, "br"), (_e = (q = this.cbs).onopentag) !== null && _e !== void 0 && _e.call(q, "br", {}, !0), (q = (_e = this.cbs).onclosetag) !== null && q !== void 0 && q.call(_e, "br", !1));
          else {
            var Ee = this.stack.indexOf(ve);
            if (Ee !== -1) for (var we = 0; we <= Ee; we++) {
              var ze = this.stack.shift();
              (ae = (oe = this.cbs).onclosetag) !== null && ae !== void 0 && ae.call(oe, ze, we !== Ee);
            }
            else this.htmlMode && ve === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
          }
          this.startIndex = X + 1;
        } }, { key: "onselfclosingtag", value: function(q) {
          this.endIndex = q, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = q + 1) : this.onopentagend(q);
        } }, { key: "closeCurrentTag", value: function(q) {
          var X, oe, ae = this.tagname;
          this.endOpenTag(q), this.stack[0] === ae && ((oe = (X = this.cbs).onclosetag) !== null && oe !== void 0 && oe.call(X, ae, !q), this.stack.shift());
        } }, { key: "onattribname", value: function(q, X) {
          this.startIndex = q, X = this.getSlice(q, X), this.attribname = this.lowerCaseAttributeNames ? X.toLowerCase() : X;
        } }, { key: "onattribdata", value: function(q, X) {
          this.attribvalue += this.getSlice(q, X);
        } }, { key: "onattribentity", value: function(q) {
          this.attribvalue += Object(h.fromCodePoint)(q);
        } }, { key: "onattribend", value: function(q, X) {
          var oe;
          this.endIndex = X, (X = (oe = this.cbs).onattribute) !== null && X !== void 0 && X.call(oe, this.attribname, this.attribvalue, q === f.Double ? '"' : q === f.Single ? "'" : q === f.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
        } }, { key: "getInstructionName", value: function(q) {
          var X = (X = q.search(Q)) < 0 ? q : q.substr(0, X);
          return this.lowerCaseTagNames ? X.toLowerCase() : X;
        } }, { key: "ondeclaration", value: function(q, X) {
          this.endIndex = X;
          var oe = this.getSlice(q, X);
          this.cbs.onprocessinginstruction && (q = this.getInstructionName(oe), this.cbs.onprocessinginstruction("!".concat(q), "!".concat(oe))), this.startIndex = X + 1;
        } }, { key: "onprocessinginstruction", value: function(q, X) {
          this.endIndex = X;
          var oe = this.getSlice(q, X);
          this.cbs.onprocessinginstruction && (q = this.getInstructionName(oe), this.cbs.onprocessinginstruction("?".concat(q), "?".concat(oe))), this.startIndex = X + 1;
        } }, { key: "oncomment", value: function(q, X, oe) {
          var ae, _e;
          this.endIndex = X, (_e = (ae = this.cbs).oncomment) !== null && _e !== void 0 && _e.call(ae, this.getSlice(q, X - oe)), (oe = (q = this.cbs).oncommentend) !== null && oe !== void 0 && oe.call(q), this.startIndex = X + 1;
        } }, { key: "oncdata", value: function(q, X, oe) {
          var ae, _e;
          this.endIndex = X, oe = this.getSlice(q, X - oe), !this.htmlMode || this.options.recognizeCDATA ? ((_e = (ae = this.cbs).oncdatastart) !== null && _e !== void 0 && _e.call(ae), (ae = (_e = this.cbs).ontext) !== null && ae !== void 0 && ae.call(_e, oe), (_e = (ae = this.cbs).oncdataend) !== null && _e !== void 0 && _e.call(ae)) : ((ae = (_e = this.cbs).oncomment) !== null && ae !== void 0 && ae.call(_e, "[CDATA[".concat(oe, "]]")), (oe = (_e = this.cbs).oncommentend) !== null && oe !== void 0 && oe.call(_e)), this.startIndex = X + 1;
        } }, { key: "onend", value: function() {
          var q, X;
          if (this.cbs.onclosetag) {
            this.endIndex = this.startIndex;
            for (var oe = 0; oe < this.stack.length; oe++) this.cbs.onclosetag(this.stack[oe], !0);
          }
          (X = (q = this.cbs).onend) !== null && X !== void 0 && X.call(q);
        } }, { key: "reset", value: function() {
          var q, X;
          (q = (X = this.cbs).onreset) !== null && q !== void 0 && q.call(X), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (X = (q = this.cbs).onparserinit) !== null && X !== void 0 && X.call(q, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
        } }, { key: "parseComplete", value: function(q) {
          this.reset(), this.end(q);
        } }, { key: "getSlice", value: function(q, X) {
          for (; q - this.bufferOffset >= this.buffers[0].length; ) this.shiftBuffer();
          for (var oe = this.buffers[0].slice(q - this.bufferOffset, X - this.bufferOffset); X - this.bufferOffset > this.buffers[0].length; ) this.shiftBuffer(), oe += this.buffers[0].slice(0, X - this.bufferOffset);
          return oe;
        } }, { key: "shiftBuffer", value: function() {
          this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
        } }, { key: "write", value: function(q) {
          var X, oe;
          this.ended ? (oe = (X = this.cbs).onerror) !== null && oe !== void 0 && oe.call(X, new Error(".write() after done!")) : (this.buffers.push(q), this.tokenizer.running && (this.tokenizer.write(q), this.writeIndex++));
        } }, { key: "end", value: function(q) {
          var X, oe;
          this.ended ? (oe = (X = this.cbs).onerror) !== null && oe !== void 0 && oe.call(X, new Error(".end() after done!")) : (q && this.write(q), this.ended = !0, this.tokenizer.end());
        } }, { key: "pause", value: function() {
          this.tokenizer.pause();
        } }, { key: "resume", value: function() {
          for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; ) this.tokenizer.write(this.buffers[this.writeIndex++]);
          this.ended && this.tokenizer.end();
        } }, { key: "parseChunk", value: function(q) {
          this.write(q);
        } }, { key: "done", value: function(q) {
          this.end(q);
        } }]), z;
      }(), ie = r(0), ce = r(8), $ = r(3);
      function te(z, ee) {
        var q = new ie.c(void 0, ee);
        return new Y(q, ee).end(z), q.root;
      }
      function V(z, ee) {
        return te(z, ee).children;
      }
      function K(z, ee, q) {
        var X = new ie.c(function(oe) {
          return z(oe, X.root);
        }, ee, q);
        return new Y(X, ee);
      }
      function ne(z, ee, q) {
        return q = new ie.c(z, ee, q), new Y(q, ee);
      }
      var J = { xmlMode: !0 };
      function L(z) {
        var ee = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : J;
        return Object($.getFeed)(V(z, ee));
      }
    }], c = {}, t.m = i, t.c = c, t.d = function(a, s, r) {
      t.o(a, s) || Object.defineProperty(a, s, { enumerable: !0, get: r });
    }, t.r = function(a) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
    }, t.t = function(a, s) {
      if (1 & s && (a = t(a)), 8 & s || 4 & s && typeof a == "object" && a && a.__esModule) return a;
      var r = /* @__PURE__ */ Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: a }), 2 & s && typeof a != "string") for (var l in a) t.d(r, l, (function(d) {
        return a[d];
      }).bind(null, l));
      return r;
    }, t.n = function(a) {
      var s = a && a.__esModule ? function() {
        return a.default;
      } : function() {
        return a;
      };
      return t.d(s, "a", s), s;
    }, t.o = function(a, s) {
      return Object.prototype.hasOwnProperty.call(a, s);
    }, t.p = "", t(t.s = 241);
    function t(a) {
      if (c[a]) return c[a].exports;
      var s = c[a] = { i: a, l: !1, exports: {} };
      return i[a].call(s.exports, s, s.exports, t), s.l = !0, s.exports;
    }
    var i, c;
  });
})(x7);
var cV = x7.exports;
const loe = /* @__PURE__ */ c0(cV);
var tx = { exports: {} }, Gs = {}, Zv = { exports: {} }, cw = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b4;
function dV() {
  return b4 || (b4 = 1, function(n) {
    function e(te, V) {
      var K = te.length;
      te.push(V);
      e: for (; 0 < K; ) {
        var ne = K - 1 >>> 1, J = te[ne];
        if (0 < c(J, V)) te[ne] = V, te[K] = J, K = ne;
        else break e;
      }
    }
    function t(te) {
      return te.length === 0 ? null : te[0];
    }
    function i(te) {
      if (te.length === 0) return null;
      var V = te[0], K = te.pop();
      if (K !== V) {
        te[0] = K;
        e: for (var ne = 0, J = te.length, L = J >>> 1; ne < L; ) {
          var z = 2 * (ne + 1) - 1, ee = te[z], q = z + 1, X = te[q];
          if (0 > c(ee, K)) q < J && 0 > c(X, ee) ? (te[ne] = X, te[q] = K, ne = q) : (te[ne] = ee, te[z] = K, ne = z);
          else if (q < J && 0 > c(X, K)) te[ne] = X, te[q] = K, ne = q;
          else break e;
        }
      }
      return V;
    }
    function c(te, V) {
      var K = te.sortIndex - V.sortIndex;
      return K !== 0 ? K : te.id - V.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var a = performance;
      n.unstable_now = function() {
        return a.now();
      };
    } else {
      var s = Date, r = s.now();
      n.unstable_now = function() {
        return s.now() - r;
      };
    }
    var l = [], d = [], f = 1, h = null, p = 3, g = !1, _ = !1, b = !1, v = typeof setTimeout == "function" ? setTimeout : null, E = typeof clearTimeout == "function" ? clearTimeout : null, C = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function y(te) {
      for (var V = t(d); V !== null; ) {
        if (V.callback === null) i(d);
        else if (V.startTime <= te) i(d), V.sortIndex = V.expirationTime, e(l, V);
        else break;
        V = t(d);
      }
    }
    function T(te) {
      if (b = !1, y(te), !_) if (t(l) !== null) _ = !0, ce(A);
      else {
        var V = t(d);
        V !== null && $(T, V.startTime - te);
      }
    }
    function A(te, V) {
      _ = !1, b && (b = !1, E(j), j = -1), g = !0;
      var K = p;
      try {
        for (y(V), h = t(l); h !== null && (!(h.expirationTime > V) || te && !U()); ) {
          var ne = h.callback;
          if (typeof ne == "function") {
            h.callback = null, p = h.priorityLevel;
            var J = ne(h.expirationTime <= V);
            V = n.unstable_now(), typeof J == "function" ? h.callback = J : h === t(l) && i(l), y(V);
          } else i(l);
          h = t(l);
        }
        if (h !== null) var L = !0;
        else {
          var z = t(d);
          z !== null && $(T, z.startTime - V), L = !1;
        }
        return L;
      } finally {
        h = null, p = K, g = !1;
      }
    }
    var k = !1, N = null, j = -1, I = 5, B = -1;
    function U() {
      return !(n.unstable_now() - B < I);
    }
    function H() {
      if (N !== null) {
        var te = n.unstable_now();
        B = te;
        var V = !0;
        try {
          V = N(!0, te);
        } finally {
          V ? Q() : (k = !1, N = null);
        }
      } else k = !1;
    }
    var Q;
    if (typeof C == "function") Q = function() {
      C(H);
    };
    else if (typeof MessageChannel < "u") {
      var Y = new MessageChannel(), ie = Y.port2;
      Y.port1.onmessage = H, Q = function() {
        ie.postMessage(null);
      };
    } else Q = function() {
      v(H, 0);
    };
    function ce(te) {
      N = te, k || (k = !0, Q());
    }
    function $(te, V) {
      j = v(function() {
        te(n.unstable_now());
      }, V);
    }
    n.unstable_IdlePriority = 5, n.unstable_ImmediatePriority = 1, n.unstable_LowPriority = 4, n.unstable_NormalPriority = 3, n.unstable_Profiling = null, n.unstable_UserBlockingPriority = 2, n.unstable_cancelCallback = function(te) {
      te.callback = null;
    }, n.unstable_continueExecution = function() {
      _ || g || (_ = !0, ce(A));
    }, n.unstable_forceFrameRate = function(te) {
      0 > te || 125 < te ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : I = 0 < te ? Math.floor(1e3 / te) : 5;
    }, n.unstable_getCurrentPriorityLevel = function() {
      return p;
    }, n.unstable_getFirstCallbackNode = function() {
      return t(l);
    }, n.unstable_next = function(te) {
      switch (p) {
        case 1:
        case 2:
        case 3:
          var V = 3;
          break;
        default:
          V = p;
      }
      var K = p;
      p = V;
      try {
        return te();
      } finally {
        p = K;
      }
    }, n.unstable_pauseExecution = function() {
    }, n.unstable_requestPaint = function() {
    }, n.unstable_runWithPriority = function(te, V) {
      switch (te) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          te = 3;
      }
      var K = p;
      p = te;
      try {
        return V();
      } finally {
        p = K;
      }
    }, n.unstable_scheduleCallback = function(te, V, K) {
      var ne = n.unstable_now();
      switch (typeof K == "object" && K !== null ? (K = K.delay, K = typeof K == "number" && 0 < K ? ne + K : ne) : K = ne, te) {
        case 1:
          var J = -1;
          break;
        case 2:
          J = 250;
          break;
        case 5:
          J = 1073741823;
          break;
        case 4:
          J = 1e4;
          break;
        default:
          J = 5e3;
      }
      return J = K + J, te = { id: f++, callback: V, priorityLevel: te, startTime: K, expirationTime: J, sortIndex: -1 }, K > ne ? (te.sortIndex = K, e(d, te), t(l) === null && te === t(d) && (b ? (E(j), j = -1) : b = !0, $(T, K - ne))) : (te.sortIndex = J, e(l, te), _ || g || (_ = !0, ce(A))), te;
    }, n.unstable_shouldYield = U, n.unstable_wrapCallback = function(te) {
      var V = p;
      return function() {
        var K = p;
        p = V;
        try {
          return te.apply(this, arguments);
        } finally {
          p = K;
        }
      };
    };
  }(cw)), cw;
}
var dw = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E4;
function fV() {
  return E4 || (E4 = 1, function(n) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1, t = !1, i = 5;
      function c(We, nt) {
        var ft = We.length;
        We.push(nt), r(We, nt, ft);
      }
      function a(We) {
        return We.length === 0 ? null : We[0];
      }
      function s(We) {
        if (We.length === 0)
          return null;
        var nt = We[0], ft = We.pop();
        return ft !== nt && (We[0] = ft, l(We, ft, 0)), nt;
      }
      function r(We, nt, ft) {
        for (var At = ft; At > 0; ) {
          var ln = At - 1 >>> 1, Jt = We[ln];
          if (d(Jt, nt) > 0)
            We[ln] = nt, We[At] = Jt, At = ln;
          else
            return;
        }
      }
      function l(We, nt, ft) {
        for (var At = ft, ln = We.length, Jt = ln >>> 1; At < Jt; ) {
          var zt = (At + 1) * 2 - 1, kt = We[zt], Ft = zt + 1, ar = We[Ft];
          if (d(kt, nt) < 0)
            Ft < ln && d(ar, kt) < 0 ? (We[At] = ar, We[Ft] = nt, At = Ft) : (We[At] = kt, We[zt] = nt, At = zt);
          else if (Ft < ln && d(ar, nt) < 0)
            We[At] = ar, We[Ft] = nt, At = Ft;
          else
            return;
        }
      }
      function d(We, nt) {
        var ft = We.sortIndex - nt.sortIndex;
        return ft !== 0 ? ft : We.id - nt.id;
      }
      var f = 1, h = 2, p = 3, g = 4, _ = 5;
      function b(We, nt) {
      }
      var v = typeof performance == "object" && typeof performance.now == "function";
      if (v) {
        var E = performance;
        n.unstable_now = function() {
          return E.now();
        };
      } else {
        var C = Date, y = C.now();
        n.unstable_now = function() {
          return C.now() - y;
        };
      }
      var T = 1073741823, A = -1, k = 250, N = 5e3, j = 1e4, I = T, B = [], U = [], H = 1, Q = null, Y = p, ie = !1, ce = !1, $ = !1, te = typeof setTimeout == "function" ? setTimeout : null, V = typeof clearTimeout == "function" ? clearTimeout : null, K = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ne(We) {
        for (var nt = a(U); nt !== null; ) {
          if (nt.callback === null)
            s(U);
          else if (nt.startTime <= We)
            s(U), nt.sortIndex = nt.expirationTime, c(B, nt);
          else
            return;
          nt = a(U);
        }
      }
      function J(We) {
        if ($ = !1, ne(We), !ce)
          if (a(B) !== null)
            ce = !0, Te(L);
          else {
            var nt = a(U);
            nt !== null && Me(J, nt.startTime - We);
          }
      }
      function L(We, nt) {
        ce = !1, $ && ($ = !1, Ye()), ie = !0;
        var ft = Y;
        try {
          var At;
          if (!t) return z(We, nt);
        } finally {
          Q = null, Y = ft, ie = !1;
        }
      }
      function z(We, nt) {
        var ft = nt;
        for (ne(ft), Q = a(B); Q !== null && !e && !(Q.expirationTime > ft && (!We || Ze())); ) {
          var At = Q.callback;
          if (typeof At == "function") {
            Q.callback = null, Y = Q.priorityLevel;
            var ln = Q.expirationTime <= ft, Jt = At(ln);
            ft = n.unstable_now(), typeof Jt == "function" ? Q.callback = Jt : Q === a(B) && s(B), ne(ft);
          } else
            s(B);
          Q = a(B);
        }
        if (Q !== null)
          return !0;
        var zt = a(U);
        return zt !== null && Me(J, zt.startTime - ft), !1;
      }
      function ee(We, nt) {
        switch (We) {
          case f:
          case h:
          case p:
          case g:
          case _:
            break;
          default:
            We = p;
        }
        var ft = Y;
        Y = We;
        try {
          return nt();
        } finally {
          Y = ft;
        }
      }
      function q(We) {
        var nt;
        switch (Y) {
          case f:
          case h:
          case p:
            nt = p;
            break;
          default:
            nt = Y;
            break;
        }
        var ft = Y;
        Y = nt;
        try {
          return We();
        } finally {
          Y = ft;
        }
      }
      function X(We) {
        var nt = Y;
        return function() {
          var ft = Y;
          Y = nt;
          try {
            return We.apply(this, arguments);
          } finally {
            Y = ft;
          }
        };
      }
      function oe(We, nt, ft) {
        var At = n.unstable_now(), ln;
        if (typeof ft == "object" && ft !== null) {
          var Jt = ft.delay;
          typeof Jt == "number" && Jt > 0 ? ln = At + Jt : ln = At;
        } else
          ln = At;
        var zt;
        switch (We) {
          case f:
            zt = A;
            break;
          case h:
            zt = k;
            break;
          case _:
            zt = I;
            break;
          case g:
            zt = j;
            break;
          case p:
          default:
            zt = N;
            break;
        }
        var kt = ln + zt, Ft = {
          id: H++,
          callback: nt,
          priorityLevel: We,
          startTime: ln,
          expirationTime: kt,
          sortIndex: -1
        };
        return ln > At ? (Ft.sortIndex = ln, c(U, Ft), a(B) === null && Ft === a(U) && ($ ? Ye() : $ = !0, Me(J, ln - At))) : (Ft.sortIndex = kt, c(B, Ft), !ce && !ie && (ce = !0, Te(L))), Ft;
      }
      function ae() {
      }
      function _e() {
        !ce && !ie && (ce = !0, Te(L));
      }
      function ve() {
        return a(B);
      }
      function Ee(We) {
        We.callback = null;
      }
      function we() {
        return Y;
      }
      var ze = !1, Ie = null, je = -1, qe = i, Ge = -1;
      function Ze() {
        var We = n.unstable_now() - Ge;
        return !(We < qe);
      }
      function tt() {
      }
      function Qe(We) {
        if (We < 0 || We > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        We > 0 ? qe = Math.floor(1e3 / We) : qe = i;
      }
      var ke = function() {
        if (Ie !== null) {
          var We = n.unstable_now();
          Ge = We;
          var nt = !0, ft = !0;
          try {
            ft = Ie(nt, We);
          } finally {
            ft ? pe() : (ze = !1, Ie = null);
          }
        } else
          ze = !1;
      }, pe;
      if (typeof K == "function")
        pe = function() {
          K(ke);
        };
      else if (typeof MessageChannel < "u") {
        var Se = new MessageChannel(), he = Se.port2;
        Se.port1.onmessage = ke, pe = function() {
          he.postMessage(null);
        };
      } else
        pe = function() {
          te(ke, 0);
        };
      function Te(We) {
        Ie = We, ze || (ze = !0, pe());
      }
      function Me(We, nt) {
        je = te(function() {
          We(n.unstable_now());
        }, nt);
      }
      function Ye() {
        V(je), je = -1;
      }
      var et = tt, dt = null;
      n.unstable_IdlePriority = _, n.unstable_ImmediatePriority = f, n.unstable_LowPriority = g, n.unstable_NormalPriority = p, n.unstable_Profiling = dt, n.unstable_UserBlockingPriority = h, n.unstable_cancelCallback = Ee, n.unstable_continueExecution = _e, n.unstable_forceFrameRate = Qe, n.unstable_getCurrentPriorityLevel = we, n.unstable_getFirstCallbackNode = ve, n.unstable_next = q, n.unstable_pauseExecution = ae, n.unstable_requestPaint = et, n.unstable_runWithPriority = ee, n.unstable_scheduleCallback = oe, n.unstable_shouldYield = Ze, n.unstable_wrapCallback = X, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(dw)), dw;
}
var S4;
function T7() {
  return S4 || (S4 = 1, process.env.NODE_ENV === "production" ? Zv.exports = dV() : Zv.exports = fV()), Zv.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C4;
function hV() {
  if (C4) return Gs;
  C4 = 1;
  var n = si, e = T7();
  function t(m) {
    for (var S = "https://reactjs.org/docs/error-decoder.html?invariant=" + m, P = 1; P < arguments.length; P++) S += "&args[]=" + encodeURIComponent(arguments[P]);
    return "Minified React error #" + m + "; visit " + S + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var i = /* @__PURE__ */ new Set(), c = {};
  function a(m, S) {
    s(m, S), s(m + "Capture", S);
  }
  function s(m, S) {
    for (c[m] = S, m = 0; m < S.length; m++) i.add(S[m]);
  }
  var r = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), l = Object.prototype.hasOwnProperty, d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, f = {}, h = {};
  function p(m) {
    return l.call(h, m) ? !0 : l.call(f, m) ? !1 : d.test(m) ? h[m] = !0 : (f[m] = !0, !1);
  }
  function g(m, S, P, G) {
    if (P !== null && P.type === 0) return !1;
    switch (typeof S) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return G ? !1 : P !== null ? !P.acceptsBooleans : (m = m.toLowerCase().slice(0, 5), m !== "data-" && m !== "aria-");
      default:
        return !1;
    }
  }
  function _(m, S, P, G) {
    if (S === null || typeof S > "u" || g(m, S, P, G)) return !0;
    if (G) return !1;
    if (P !== null) switch (P.type) {
      case 3:
        return !S;
      case 4:
        return S === !1;
      case 5:
        return isNaN(S);
      case 6:
        return isNaN(S) || 1 > S;
    }
    return !1;
  }
  function b(m, S, P, G, se, fe, Oe) {
    this.acceptsBooleans = S === 2 || S === 3 || S === 4, this.attributeName = G, this.attributeNamespace = se, this.mustUseProperty = P, this.propertyName = m, this.type = S, this.sanitizeURL = fe, this.removeEmptyString = Oe;
  }
  var v = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(m) {
    v[m] = new b(m, 0, !1, m, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(m) {
    var S = m[0];
    v[S] = new b(S, 1, !1, m[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(m) {
    v[m] = new b(m, 2, !1, m.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(m) {
    v[m] = new b(m, 2, !1, m, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(m) {
    v[m] = new b(m, 3, !1, m.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(m) {
    v[m] = new b(m, 3, !0, m, null, !1, !1);
  }), ["capture", "download"].forEach(function(m) {
    v[m] = new b(m, 4, !1, m, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(m) {
    v[m] = new b(m, 6, !1, m, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(m) {
    v[m] = new b(m, 5, !1, m.toLowerCase(), null, !1, !1);
  });
  var E = /[\-:]([a-z])/g;
  function C(m) {
    return m[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(m) {
    var S = m.replace(
      E,
      C
    );
    v[S] = new b(S, 1, !1, m, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(m) {
    var S = m.replace(E, C);
    v[S] = new b(S, 1, !1, m, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(m) {
    var S = m.replace(E, C);
    v[S] = new b(S, 1, !1, m, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(m) {
    v[m] = new b(m, 1, !1, m.toLowerCase(), null, !1, !1);
  }), v.xlinkHref = new b("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(m) {
    v[m] = new b(m, 1, !1, m.toLowerCase(), null, !0, !0);
  });
  function y(m, S, P, G) {
    var se = v.hasOwnProperty(S) ? v[S] : null;
    (se !== null ? se.type !== 0 : G || !(2 < S.length) || S[0] !== "o" && S[0] !== "O" || S[1] !== "n" && S[1] !== "N") && (_(S, P, se, G) && (P = null), G || se === null ? p(S) && (P === null ? m.removeAttribute(S) : m.setAttribute(S, "" + P)) : se.mustUseProperty ? m[se.propertyName] = P === null ? se.type === 3 ? !1 : "" : P : (S = se.attributeName, G = se.attributeNamespace, P === null ? m.removeAttribute(S) : (se = se.type, P = se === 3 || se === 4 && P === !0 ? "" : "" + P, G ? m.setAttributeNS(G, S, P) : m.setAttribute(S, P))));
  }
  var T = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, A = Symbol.for("react.element"), k = Symbol.for("react.portal"), N = Symbol.for("react.fragment"), j = Symbol.for("react.strict_mode"), I = Symbol.for("react.profiler"), B = Symbol.for("react.provider"), U = Symbol.for("react.context"), H = Symbol.for("react.forward_ref"), Q = Symbol.for("react.suspense"), Y = Symbol.for("react.suspense_list"), ie = Symbol.for("react.memo"), ce = Symbol.for("react.lazy"), $ = Symbol.for("react.offscreen"), te = Symbol.iterator;
  function V(m) {
    return m === null || typeof m != "object" ? null : (m = te && m[te] || m["@@iterator"], typeof m == "function" ? m : null);
  }
  var K = Object.assign, ne;
  function J(m) {
    if (ne === void 0) try {
      throw Error();
    } catch (P) {
      var S = P.stack.trim().match(/\n( *(at )?)/);
      ne = S && S[1] || "";
    }
    return `
` + ne + m;
  }
  var L = !1;
  function z(m, S) {
    if (!m || L) return "";
    L = !0;
    var P = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (S) if (S = function() {
        throw Error();
      }, Object.defineProperty(S.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(S, []);
        } catch (Ct) {
          var G = Ct;
        }
        Reflect.construct(m, [], S);
      } else {
        try {
          S.call();
        } catch (Ct) {
          G = Ct;
        }
        m.call(S.prototype);
      }
      else {
        try {
          throw Error();
        } catch (Ct) {
          G = Ct;
        }
        m();
      }
    } catch (Ct) {
      if (Ct && G && typeof Ct.stack == "string") {
        for (var se = Ct.stack.split(`
`), fe = G.stack.split(`
`), Oe = se.length - 1, $e = fe.length - 1; 1 <= Oe && 0 <= $e && se[Oe] !== fe[$e]; ) $e--;
        for (; 1 <= Oe && 0 <= $e; Oe--, $e--) if (se[Oe] !== fe[$e]) {
          if (Oe !== 1 || $e !== 1)
            do
              if (Oe--, $e--, 0 > $e || se[Oe] !== fe[$e]) {
                var rt = `
` + se[Oe].replace(" at new ", " at ");
                return m.displayName && rt.includes("<anonymous>") && (rt = rt.replace("<anonymous>", m.displayName)), rt;
              }
            while (1 <= Oe && 0 <= $e);
          break;
        }
      }
    } finally {
      L = !1, Error.prepareStackTrace = P;
    }
    return (m = m ? m.displayName || m.name : "") ? J(m) : "";
  }
  function ee(m) {
    switch (m.tag) {
      case 5:
        return J(m.type);
      case 16:
        return J("Lazy");
      case 13:
        return J("Suspense");
      case 19:
        return J("SuspenseList");
      case 0:
      case 2:
      case 15:
        return m = z(m.type, !1), m;
      case 11:
        return m = z(m.type.render, !1), m;
      case 1:
        return m = z(m.type, !0), m;
      default:
        return "";
    }
  }
  function q(m) {
    if (m == null) return null;
    if (typeof m == "function") return m.displayName || m.name || null;
    if (typeof m == "string") return m;
    switch (m) {
      case N:
        return "Fragment";
      case k:
        return "Portal";
      case I:
        return "Profiler";
      case j:
        return "StrictMode";
      case Q:
        return "Suspense";
      case Y:
        return "SuspenseList";
    }
    if (typeof m == "object") switch (m.$$typeof) {
      case U:
        return (m.displayName || "Context") + ".Consumer";
      case B:
        return (m._context.displayName || "Context") + ".Provider";
      case H:
        var S = m.render;
        return m = m.displayName, m || (m = S.displayName || S.name || "", m = m !== "" ? "ForwardRef(" + m + ")" : "ForwardRef"), m;
      case ie:
        return S = m.displayName || null, S !== null ? S : q(m.type) || "Memo";
      case ce:
        S = m._payload, m = m._init;
        try {
          return q(m(S));
        } catch {
        }
    }
    return null;
  }
  function X(m) {
    var S = m.type;
    switch (m.tag) {
      case 24:
        return "Cache";
      case 9:
        return (S.displayName || "Context") + ".Consumer";
      case 10:
        return (S._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return m = S.render, m = m.displayName || m.name || "", S.displayName || (m !== "" ? "ForwardRef(" + m + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return S;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return q(S);
      case 8:
        return S === j ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof S == "function") return S.displayName || S.name || null;
        if (typeof S == "string") return S;
    }
    return null;
  }
  function oe(m) {
    switch (typeof m) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return m;
      case "object":
        return m;
      default:
        return "";
    }
  }
  function ae(m) {
    var S = m.type;
    return (m = m.nodeName) && m.toLowerCase() === "input" && (S === "checkbox" || S === "radio");
  }
  function _e(m) {
    var S = ae(m) ? "checked" : "value", P = Object.getOwnPropertyDescriptor(m.constructor.prototype, S), G = "" + m[S];
    if (!m.hasOwnProperty(S) && typeof P < "u" && typeof P.get == "function" && typeof P.set == "function") {
      var se = P.get, fe = P.set;
      return Object.defineProperty(m, S, { configurable: !0, get: function() {
        return se.call(this);
      }, set: function(Oe) {
        G = "" + Oe, fe.call(this, Oe);
      } }), Object.defineProperty(m, S, { enumerable: P.enumerable }), { getValue: function() {
        return G;
      }, setValue: function(Oe) {
        G = "" + Oe;
      }, stopTracking: function() {
        m._valueTracker = null, delete m[S];
      } };
    }
  }
  function ve(m) {
    m._valueTracker || (m._valueTracker = _e(m));
  }
  function Ee(m) {
    if (!m) return !1;
    var S = m._valueTracker;
    if (!S) return !0;
    var P = S.getValue(), G = "";
    return m && (G = ae(m) ? m.checked ? "true" : "false" : m.value), m = G, m !== P ? (S.setValue(m), !0) : !1;
  }
  function we(m) {
    if (m = m || (typeof document < "u" ? document : void 0), typeof m > "u") return null;
    try {
      return m.activeElement || m.body;
    } catch {
      return m.body;
    }
  }
  function ze(m, S) {
    var P = S.checked;
    return K({}, S, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: P ?? m._wrapperState.initialChecked });
  }
  function Ie(m, S) {
    var P = S.defaultValue == null ? "" : S.defaultValue, G = S.checked != null ? S.checked : S.defaultChecked;
    P = oe(S.value != null ? S.value : P), m._wrapperState = { initialChecked: G, initialValue: P, controlled: S.type === "checkbox" || S.type === "radio" ? S.checked != null : S.value != null };
  }
  function je(m, S) {
    S = S.checked, S != null && y(m, "checked", S, !1);
  }
  function qe(m, S) {
    je(m, S);
    var P = oe(S.value), G = S.type;
    if (P != null) G === "number" ? (P === 0 && m.value === "" || m.value != P) && (m.value = "" + P) : m.value !== "" + P && (m.value = "" + P);
    else if (G === "submit" || G === "reset") {
      m.removeAttribute("value");
      return;
    }
    S.hasOwnProperty("value") ? Ze(m, S.type, P) : S.hasOwnProperty("defaultValue") && Ze(m, S.type, oe(S.defaultValue)), S.checked == null && S.defaultChecked != null && (m.defaultChecked = !!S.defaultChecked);
  }
  function Ge(m, S, P) {
    if (S.hasOwnProperty("value") || S.hasOwnProperty("defaultValue")) {
      var G = S.type;
      if (!(G !== "submit" && G !== "reset" || S.value !== void 0 && S.value !== null)) return;
      S = "" + m._wrapperState.initialValue, P || S === m.value || (m.value = S), m.defaultValue = S;
    }
    P = m.name, P !== "" && (m.name = ""), m.defaultChecked = !!m._wrapperState.initialChecked, P !== "" && (m.name = P);
  }
  function Ze(m, S, P) {
    (S !== "number" || we(m.ownerDocument) !== m) && (P == null ? m.defaultValue = "" + m._wrapperState.initialValue : m.defaultValue !== "" + P && (m.defaultValue = "" + P));
  }
  var tt = Array.isArray;
  function Qe(m, S, P, G) {
    if (m = m.options, S) {
      S = {};
      for (var se = 0; se < P.length; se++) S["$" + P[se]] = !0;
      for (P = 0; P < m.length; P++) se = S.hasOwnProperty("$" + m[P].value), m[P].selected !== se && (m[P].selected = se), se && G && (m[P].defaultSelected = !0);
    } else {
      for (P = "" + oe(P), S = null, se = 0; se < m.length; se++) {
        if (m[se].value === P) {
          m[se].selected = !0, G && (m[se].defaultSelected = !0);
          return;
        }
        S !== null || m[se].disabled || (S = m[se]);
      }
      S !== null && (S.selected = !0);
    }
  }
  function ke(m, S) {
    if (S.dangerouslySetInnerHTML != null) throw Error(t(91));
    return K({}, S, { value: void 0, defaultValue: void 0, children: "" + m._wrapperState.initialValue });
  }
  function pe(m, S) {
    var P = S.value;
    if (P == null) {
      if (P = S.children, S = S.defaultValue, P != null) {
        if (S != null) throw Error(t(92));
        if (tt(P)) {
          if (1 < P.length) throw Error(t(93));
          P = P[0];
        }
        S = P;
      }
      S == null && (S = ""), P = S;
    }
    m._wrapperState = { initialValue: oe(P) };
  }
  function Se(m, S) {
    var P = oe(S.value), G = oe(S.defaultValue);
    P != null && (P = "" + P, P !== m.value && (m.value = P), S.defaultValue == null && m.defaultValue !== P && (m.defaultValue = P)), G != null && (m.defaultValue = "" + G);
  }
  function he(m) {
    var S = m.textContent;
    S === m._wrapperState.initialValue && S !== "" && S !== null && (m.value = S);
  }
  function Te(m) {
    switch (m) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Me(m, S) {
    return m == null || m === "http://www.w3.org/1999/xhtml" ? Te(S) : m === "http://www.w3.org/2000/svg" && S === "foreignObject" ? "http://www.w3.org/1999/xhtml" : m;
  }
  var Ye, et = function(m) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(S, P, G, se) {
      MSApp.execUnsafeLocalFunction(function() {
        return m(S, P, G, se);
      });
    } : m;
  }(function(m, S) {
    if (m.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in m) m.innerHTML = S;
    else {
      for (Ye = Ye || document.createElement("div"), Ye.innerHTML = "<svg>" + S.valueOf().toString() + "</svg>", S = Ye.firstChild; m.firstChild; ) m.removeChild(m.firstChild);
      for (; S.firstChild; ) m.appendChild(S.firstChild);
    }
  });
  function dt(m, S) {
    if (S) {
      var P = m.firstChild;
      if (P && P === m.lastChild && P.nodeType === 3) {
        P.nodeValue = S;
        return;
      }
    }
    m.textContent = S;
  }
  var We = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, nt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(We).forEach(function(m) {
    nt.forEach(function(S) {
      S = S + m.charAt(0).toUpperCase() + m.substring(1), We[S] = We[m];
    });
  });
  function ft(m, S, P) {
    return S == null || typeof S == "boolean" || S === "" ? "" : P || typeof S != "number" || S === 0 || We.hasOwnProperty(m) && We[m] ? ("" + S).trim() : S + "px";
  }
  function At(m, S) {
    m = m.style;
    for (var P in S) if (S.hasOwnProperty(P)) {
      var G = P.indexOf("--") === 0, se = ft(P, S[P], G);
      P === "float" && (P = "cssFloat"), G ? m.setProperty(P, se) : m[P] = se;
    }
  }
  var ln = K({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Jt(m, S) {
    if (S) {
      if (ln[m] && (S.children != null || S.dangerouslySetInnerHTML != null)) throw Error(t(137, m));
      if (S.dangerouslySetInnerHTML != null) {
        if (S.children != null) throw Error(t(60));
        if (typeof S.dangerouslySetInnerHTML != "object" || !("__html" in S.dangerouslySetInnerHTML)) throw Error(t(61));
      }
      if (S.style != null && typeof S.style != "object") throw Error(t(62));
    }
  }
  function zt(m, S) {
    if (m.indexOf("-") === -1) return typeof S.is == "string";
    switch (m) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var kt = null;
  function Ft(m) {
    return m = m.target || m.srcElement || window, m.correspondingUseElement && (m = m.correspondingUseElement), m.nodeType === 3 ? m.parentNode : m;
  }
  var ar = null, In = null, On = null;
  function ui(m) {
    if (m = Rc(m)) {
      if (typeof ar != "function") throw Error(t(280));
      var S = m.stateNode;
      S && (S = xn(S), ar(m.stateNode, m.type, S));
    }
  }
  function Fr(m) {
    In ? On ? On.push(m) : On = [m] : In = m;
  }
  function er() {
    if (In) {
      var m = In, S = On;
      if (On = In = null, ui(m), S) for (m = 0; m < S.length; m++) ui(S[m]);
    }
  }
  function $n(m, S) {
    return m(S);
  }
  function un() {
  }
  var en = !1;
  function bt(m, S, P) {
    if (en) return m(S, P);
    en = !0;
    try {
      return $n(m, S, P);
    } finally {
      en = !1, (In !== null || On !== null) && (un(), er());
    }
  }
  function Pt(m, S) {
    var P = m.stateNode;
    if (P === null) return null;
    var G = xn(P);
    if (G === null) return null;
    P = G[S];
    e: switch (S) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (G = !G.disabled) || (m = m.type, G = !(m === "button" || m === "input" || m === "select" || m === "textarea")), m = !G;
        break e;
      default:
        m = !1;
    }
    if (m) return null;
    if (P && typeof P != "function") throw Error(t(231, S, typeof P));
    return P;
  }
  var fn = !1;
  if (r) try {
    var cn = {};
    Object.defineProperty(cn, "passive", { get: function() {
      fn = !0;
    } }), window.addEventListener("test", cn, cn), window.removeEventListener("test", cn, cn);
  } catch {
    fn = !1;
  }
  function Vn(m, S, P, G, se, fe, Oe, $e, rt) {
    var Ct = Array.prototype.slice.call(arguments, 3);
    try {
      S.apply(P, Ct);
    } catch (Ht) {
      this.onError(Ht);
    }
  }
  var En = !1, Kt = null, Dn = !1, Kn = null, vr = { onError: function(m) {
    En = !0, Kt = m;
  } };
  function Ii(m, S, P, G, se, fe, Oe, $e, rt) {
    En = !1, Kt = null, Vn.apply(vr, arguments);
  }
  function vo(m, S, P, G, se, fe, Oe, $e, rt) {
    if (Ii.apply(this, arguments), En) {
      if (En) {
        var Ct = Kt;
        En = !1, Kt = null;
      } else throw Error(t(198));
      Dn || (Dn = !0, Kn = Ct);
    }
  }
  function qr(m) {
    var S = m, P = m;
    if (m.alternate) for (; S.return; ) S = S.return;
    else {
      m = S;
      do
        S = m, S.flags & 4098 && (P = S.return), m = S.return;
      while (m);
    }
    return S.tag === 3 ? P : null;
  }
  function _r(m) {
    if (m.tag === 13) {
      var S = m.memoizedState;
      if (S === null && (m = m.alternate, m !== null && (S = m.memoizedState)), S !== null) return S.dehydrated;
    }
    return null;
  }
  function sr(m) {
    if (qr(m) !== m) throw Error(t(188));
  }
  function br(m) {
    var S = m.alternate;
    if (!S) {
      if (S = qr(m), S === null) throw Error(t(188));
      return S !== m ? null : m;
    }
    for (var P = m, G = S; ; ) {
      var se = P.return;
      if (se === null) break;
      var fe = se.alternate;
      if (fe === null) {
        if (G = se.return, G !== null) {
          P = G;
          continue;
        }
        break;
      }
      if (se.child === fe.child) {
        for (fe = se.child; fe; ) {
          if (fe === P) return sr(se), m;
          if (fe === G) return sr(se), S;
          fe = fe.sibling;
        }
        throw Error(t(188));
      }
      if (P.return !== G.return) P = se, G = fe;
      else {
        for (var Oe = !1, $e = se.child; $e; ) {
          if ($e === P) {
            Oe = !0, P = se, G = fe;
            break;
          }
          if ($e === G) {
            Oe = !0, G = se, P = fe;
            break;
          }
          $e = $e.sibling;
        }
        if (!Oe) {
          for ($e = fe.child; $e; ) {
            if ($e === P) {
              Oe = !0, P = fe, G = se;
              break;
            }
            if ($e === G) {
              Oe = !0, G = fe, P = se;
              break;
            }
            $e = $e.sibling;
          }
          if (!Oe) throw Error(t(189));
        }
      }
      if (P.alternate !== G) throw Error(t(190));
    }
    if (P.tag !== 3) throw Error(t(188));
    return P.stateNode.current === P ? m : S;
  }
  function ao(m) {
    return m = br(m), m !== null ? Zi(m) : null;
  }
  function Zi(m) {
    if (m.tag === 5 || m.tag === 6) return m;
    for (m = m.child; m !== null; ) {
      var S = Zi(m);
      if (S !== null) return S;
      m = m.sibling;
    }
    return null;
  }
  var di = e.unstable_scheduleCallback, Lo = e.unstable_cancelCallback, La = e.unstable_shouldYield, Ai = e.unstable_requestPaint, fr = e.unstable_now, Ma = e.unstable_getCurrentPriorityLevel, pa = e.unstable_ImmediatePriority, Qn = e.unstable_UserBlockingPriority, Pa = e.unstable_NormalPriority, lc = e.unstable_LowPriority, ma = e.unstable_IdlePriority, vs = null, Li = null;
  function uc(m) {
    if (Li && typeof Li.onCommitFiberRoot == "function") try {
      Li.onCommitFiberRoot(vs, m, void 0, (m.current.flags & 128) === 128);
    } catch {
    }
  }
  var Mo = Math.clz32 ? Math.clz32 : Jh, xf = Math.log, cc = Math.LN2;
  function Jh(m) {
    return m >>>= 0, m === 0 ? 32 : 31 - (xf(m) / cc | 0) | 0;
  }
  var bs = 64, Ur = 4194304;
  function el(m) {
    switch (m & -m) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return m & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return m & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return m;
    }
  }
  function so(m, S) {
    var P = m.pendingLanes;
    if (P === 0) return 0;
    var G = 0, se = m.suspendedLanes, fe = m.pingedLanes, Oe = P & 268435455;
    if (Oe !== 0) {
      var $e = Oe & ~se;
      $e !== 0 ? G = el($e) : (fe &= Oe, fe !== 0 && (G = el(fe)));
    } else Oe = P & ~se, Oe !== 0 ? G = el(Oe) : fe !== 0 && (G = el(fe));
    if (G === 0) return 0;
    if (S !== 0 && S !== G && !(S & se) && (se = G & -G, fe = S & -S, se >= fe || se === 16 && (fe & 4194240) !== 0)) return S;
    if (G & 4 && (G |= P & 16), S = m.entangledLanes, S !== 0) for (m = m.entanglements, S &= G; 0 < S; ) P = 31 - Mo(S), se = 1 << P, G |= m[P], S &= ~se;
    return G;
  }
  function tl(m, S) {
    switch (m) {
      case 1:
      case 2:
      case 4:
        return S + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return S + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ja(m, S) {
    for (var P = m.suspendedLanes, G = m.pingedLanes, se = m.expirationTimes, fe = m.pendingLanes; 0 < fe; ) {
      var Oe = 31 - Mo(fe), $e = 1 << Oe, rt = se[Oe];
      rt === -1 ? (!($e & P) || $e & G) && (se[Oe] = tl($e, S)) : rt <= S && (m.expiredLanes |= $e), fe &= ~$e;
    }
  }
  function Tl(m) {
    return m = m.pendingLanes & -1073741825, m !== 0 ? m : m & 1073741824 ? 1073741824 : 0;
  }
  function ns() {
    var m = bs;
    return bs <<= 1, !(bs & 4194240) && (bs = 64), m;
  }
  function dc(m) {
    for (var S = [], P = 0; 31 > P; P++) S.push(m);
    return S;
  }
  function ra(m, S, P) {
    m.pendingLanes |= S, S !== 536870912 && (m.suspendedLanes = 0, m.pingedLanes = 0), m = m.eventTimes, S = 31 - Mo(S), m[S] = P;
  }
  function _d(m, S) {
    var P = m.pendingLanes & ~S;
    m.pendingLanes = S, m.suspendedLanes = 0, m.pingedLanes = 0, m.expiredLanes &= S, m.mutableReadLanes &= S, m.entangledLanes &= S, S = m.entanglements;
    var G = m.eventTimes;
    for (m = m.expirationTimes; 0 < P; ) {
      var se = 31 - Mo(P), fe = 1 << se;
      S[se] = 0, G[se] = -1, m[se] = -1, P &= ~fe;
    }
  }
  function Al(m, S) {
    var P = m.entangledLanes |= S;
    for (m = m.entanglements; P; ) {
      var G = 31 - Mo(P), se = 1 << G;
      se & S | m[G] & S && (m[G] |= S), P &= ~se;
    }
  }
  var Er = 0;
  function yd(m) {
    return m &= -m, 1 < m ? 4 < m ? m & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Tf, nl, ur, vd, fc, Yn = !1, Es = [], ni = null, Po = null, lo = null, kl = /* @__PURE__ */ new Map(), fi = /* @__PURE__ */ new Map(), Or = [], ep = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function jo(m, S) {
    switch (m) {
      case "focusin":
      case "focusout":
        ni = null;
        break;
      case "dragenter":
      case "dragleave":
        Po = null;
        break;
      case "mouseover":
      case "mouseout":
        lo = null;
        break;
      case "pointerover":
      case "pointerout":
        kl.delete(S.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        fi.delete(S.pointerId);
    }
  }
  function Mi(m, S, P, G, se, fe) {
    return m === null || m.nativeEvent !== fe ? (m = { blockedOn: S, domEventName: P, eventSystemFlags: G, nativeEvent: fe, targetContainers: [se] }, S !== null && (S = Rc(S), S !== null && nl(S)), m) : (m.eventSystemFlags |= G, S = m.targetContainers, se !== null && S.indexOf(se) === -1 && S.push(se), m);
  }
  function Bo(m, S, P, G, se) {
    switch (S) {
      case "focusin":
        return ni = Mi(ni, m, S, P, G, se), !0;
      case "dragenter":
        return Po = Mi(Po, m, S, P, G, se), !0;
      case "mouseover":
        return lo = Mi(lo, m, S, P, G, se), !0;
      case "pointerover":
        var fe = se.pointerId;
        return kl.set(fe, Mi(kl.get(fe) || null, m, S, P, G, se)), !0;
      case "gotpointercapture":
        return fe = se.pointerId, fi.set(fe, Mi(fi.get(fe) || null, m, S, P, G, se)), !0;
    }
    return !1;
  }
  function vi(m) {
    var S = Ua(m.target);
    if (S !== null) {
      var P = qr(S);
      if (P !== null) {
        if (S = P.tag, S === 13) {
          if (S = _r(P), S !== null) {
            m.blockedOn = S, fc(m.priority, function() {
              ur(P);
            });
            return;
          }
        } else if (S === 3 && P.stateNode.current.memoizedState.isDehydrated) {
          m.blockedOn = P.tag === 3 ? P.stateNode.containerInfo : null;
          return;
        }
      }
    }
    m.blockedOn = null;
  }
  function Ol(m) {
    if (m.blockedOn !== null) return !1;
    for (var S = m.targetContainers; 0 < S.length; ) {
      var P = mc(m.domEventName, m.eventSystemFlags, S[0], m.nativeEvent);
      if (P === null) {
        P = m.nativeEvent;
        var G = new P.constructor(P.type, P);
        kt = G, P.target.dispatchEvent(G), kt = null;
      } else return S = Rc(P), S !== null && nl(S), m.blockedOn = P, !1;
      S.shift();
    }
    return !0;
  }
  function hc(m, S, P) {
    Ol(m) && P.delete(S);
  }
  function Af() {
    Yn = !1, ni !== null && Ol(ni) && (ni = null), Po !== null && Ol(Po) && (Po = null), lo !== null && Ol(lo) && (lo = null), kl.forEach(hc), fi.forEach(hc);
  }
  function du(m, S) {
    m.blockedOn === S && (m.blockedOn = null, Yn || (Yn = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, Af)));
  }
  function qn(m) {
    function S(se) {
      return du(se, m);
    }
    if (0 < Es.length) {
      du(Es[0], m);
      for (var P = 1; P < Es.length; P++) {
        var G = Es[P];
        G.blockedOn === m && (G.blockedOn = null);
      }
    }
    for (ni !== null && du(ni, m), Po !== null && du(Po, m), lo !== null && du(lo, m), kl.forEach(S), fi.forEach(S), P = 0; P < Or.length; P++) G = Or[P], G.blockedOn === m && (G.blockedOn = null);
    for (; 0 < Or.length && (P = Or[0], P.blockedOn === null); ) vi(P), P.blockedOn === null && Or.shift();
  }
  var Ss = T.ReactCurrentBatchConfig, Ba = !0;
  function kf(m, S, P, G) {
    var se = Er, fe = Ss.transition;
    Ss.transition = null;
    try {
      Er = 1, fu(m, S, P, G);
    } finally {
      Er = se, Ss.transition = fe;
    }
  }
  function pc(m, S, P, G) {
    var se = Er, fe = Ss.transition;
    Ss.transition = null;
    try {
      Er = 4, fu(m, S, P, G);
    } finally {
      Er = se, Ss.transition = fe;
    }
  }
  function fu(m, S, P, G) {
    if (Ba) {
      var se = mc(m, S, P, G);
      if (se === null) Ff(m, S, G, hu, P), jo(m, G);
      else if (Bo(se, m, S, P, G)) G.stopPropagation();
      else if (jo(m, G), S & 4 && -1 < ep.indexOf(m)) {
        for (; se !== null; ) {
          var fe = Rc(se);
          if (fe !== null && Tf(fe), fe = mc(m, S, P, G), fe === null && Ff(m, S, G, hu, P), fe === se) break;
          se = fe;
        }
        se !== null && G.stopPropagation();
      } else Ff(m, S, G, null, P);
    }
  }
  var hu = null;
  function mc(m, S, P, G) {
    if (hu = null, m = Ft(G), m = Ua(m), m !== null) if (S = qr(m), S === null) m = null;
    else if (P = S.tag, P === 13) {
      if (m = _r(S), m !== null) return m;
      m = null;
    } else if (P === 3) {
      if (S.stateNode.current.memoizedState.isDehydrated) return S.tag === 3 ? S.stateNode.containerInfo : null;
      m = null;
    } else S !== m && (m = null);
    return hu = m, null;
  }
  function bd(m) {
    switch (m) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Ma()) {
          case pa:
            return 1;
          case Qn:
            return 4;
          case Pa:
          case lc:
            return 16;
          case ma:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var rs = null, pu = null, Cs = null;
  function Ed() {
    if (Cs) return Cs;
    var m, S = pu, P = S.length, G, se = "value" in rs ? rs.value : rs.textContent, fe = se.length;
    for (m = 0; m < P && S[m] === se[m]; m++) ;
    var Oe = P - m;
    for (G = 1; G <= Oe && S[P - G] === se[fe - G]; G++) ;
    return Cs = se.slice(m, 1 < G ? 1 - G : void 0);
  }
  function ws(m) {
    var S = m.keyCode;
    return "charCode" in m ? (m = m.charCode, m === 0 && S === 13 && (m = 13)) : m = S, m === 10 && (m = 13), 32 <= m || m === 13 ? m : 0;
  }
  function gc() {
    return !0;
  }
  function Of() {
    return !1;
  }
  function Fo(m) {
    function S(P, G, se, fe, Oe) {
      this._reactName = P, this._targetInst = se, this.type = G, this.nativeEvent = fe, this.target = Oe, this.currentTarget = null;
      for (var $e in m) m.hasOwnProperty($e) && (P = m[$e], this[$e] = P ? P(fe) : fe[$e]);
      return this.isDefaultPrevented = (fe.defaultPrevented != null ? fe.defaultPrevented : fe.returnValue === !1) ? gc : Of, this.isPropagationStopped = Of, this;
    }
    return K(S.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var P = this.nativeEvent;
      P && (P.preventDefault ? P.preventDefault() : typeof P.returnValue != "unknown" && (P.returnValue = !1), this.isDefaultPrevented = gc);
    }, stopPropagation: function() {
      var P = this.nativeEvent;
      P && (P.stopPropagation ? P.stopPropagation() : typeof P.cancelBubble != "unknown" && (P.cancelBubble = !0), this.isPropagationStopped = gc);
    }, persist: function() {
    }, isPersistent: gc }), S;
  }
  var xs = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(m) {
    return m.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, _c = Fo(xs), Dl = K({}, xs, { view: 0, detail: 0 }), Df = Fo(Dl), yc, Sd, mu, Pi = K({}, Dl, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: hn, button: 0, buttons: 0, relatedTarget: function(m) {
    return m.relatedTarget === void 0 ? m.fromElement === m.srcElement ? m.toElement : m.fromElement : m.relatedTarget;
  }, movementX: function(m) {
    return "movementX" in m ? m.movementX : (m !== mu && (mu && m.type === "mousemove" ? (yc = m.screenX - mu.screenX, Sd = m.screenY - mu.screenY) : Sd = yc = 0, mu = m), yc);
  }, movementY: function(m) {
    return "movementY" in m ? m.movementY : Sd;
  } }), vc = Fo(Pi), Rf = K({}, Pi, { dataTransfer: 0 }), Ts = Fo(Rf), bc = K({}, Dl, { relatedTarget: 0 }), is = Fo(bc), hi = K({}, xs, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Ec = Fo(hi), Nf = K({}, xs, { clipboardData: function(m) {
    return "clipboardData" in m ? m.clipboardData : window.clipboardData;
  } }), be = Fo(Nf), le = K({}, xs, { data: 0 }), ye = Fo(le), Be = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Ke = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Ot = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Wt(m) {
    var S = this.nativeEvent;
    return S.getModifierState ? S.getModifierState(m) : (m = Ot[m]) ? !!S[m] : !1;
  }
  function hn() {
    return Wt;
  }
  var Rn = K({}, Dl, { key: function(m) {
    if (m.key) {
      var S = Be[m.key] || m.key;
      if (S !== "Unidentified") return S;
    }
    return m.type === "keypress" ? (m = ws(m), m === 13 ? "Enter" : String.fromCharCode(m)) : m.type === "keydown" || m.type === "keyup" ? Ke[m.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: hn, charCode: function(m) {
    return m.type === "keypress" ? ws(m) : 0;
  }, keyCode: function(m) {
    return m.type === "keydown" || m.type === "keyup" ? m.keyCode : 0;
  }, which: function(m) {
    return m.type === "keypress" ? ws(m) : m.type === "keydown" || m.type === "keyup" ? m.keyCode : 0;
  } }), yr = Fo(Rn), Sr = K({}, Pi, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), ri = Fo(Sr), Rl = K({}, Dl, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: hn }), tp = Fo(Rl), gu = K({}, xs, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), If = Fo(gu), uo = K({}, Pi, {
    deltaX: function(m) {
      return "deltaX" in m ? m.deltaX : "wheelDeltaX" in m ? -m.wheelDeltaX : 0;
    },
    deltaY: function(m) {
      return "deltaY" in m ? m.deltaY : "wheelDeltaY" in m ? -m.wheelDeltaY : "wheelDelta" in m ? -m.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), os = Fo(uo), pi = [9, 13, 27, 32], ga = r && "CompositionEvent" in window, rl = null;
  r && "documentMode" in document && (rl = document.documentMode);
  var Nl = r && "TextEvent" in window && !rl, _u = r && (!ga || rl && 8 < rl && 11 >= rl), il = " ", yu = !1;
  function vu(m, S) {
    switch (m) {
      case "keyup":
        return pi.indexOf(S.keyCode) !== -1;
      case "keydown":
        return S.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function bu(m) {
    return m = m.detail, typeof m == "object" && "data" in m ? m.data : null;
  }
  var ol = !1;
  function np(m, S) {
    switch (m) {
      case "compositionend":
        return bu(S);
      case "keypress":
        return S.which !== 32 ? null : (yu = !0, il);
      case "textInput":
        return m = S.data, m === il && yu ? null : m;
      default:
        return null;
    }
  }
  function rp(m, S) {
    if (ol) return m === "compositionend" || !ga && vu(m, S) ? (m = Ed(), Cs = pu = rs = null, ol = !1, m) : null;
    switch (m) {
      case "paste":
        return null;
      case "keypress":
        if (!(S.ctrlKey || S.altKey || S.metaKey) || S.ctrlKey && S.altKey) {
          if (S.char && 1 < S.char.length) return S.char;
          if (S.which) return String.fromCharCode(S.which);
        }
        return null;
      case "compositionend":
        return _u && S.locale !== "ko" ? null : S.data;
      default:
        return null;
    }
  }
  var Lf = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function al(m) {
    var S = m && m.nodeName && m.nodeName.toLowerCase();
    return S === "input" ? !!Lf[m.type] : S === "textarea";
  }
  function Sc(m, S, P, G) {
    Fr(G), S = Dd(S, "onChange"), 0 < S.length && (P = new _c("onChange", "change", null, P, G), m.push({ event: P, listeners: S }));
  }
  var Cd = null, Eu = null;
  function Il(m) {
    Bf(m, 0);
  }
  function Su(m) {
    var S = ku(m);
    if (Ee(S)) return m;
  }
  function ip(m, S) {
    if (m === "change") return S;
  }
  var Cc = !1;
  if (r) {
    var Mf;
    if (r) {
      var Pe = "oninput" in document;
      if (!Pe) {
        var Pm = document.createElement("div");
        Pm.setAttribute("oninput", "return;"), Pe = typeof Pm.oninput == "function";
      }
      Mf = Pe;
    } else Mf = !1;
    Cc = Mf && (!document.documentMode || 9 < document.documentMode);
  }
  function xt() {
    Cd && (Cd.detachEvent("onpropertychange", op), Eu = Cd = null);
  }
  function op(m) {
    if (m.propertyName === "value" && Su(Eu)) {
      var S = [];
      Sc(S, Eu, m, Ft(m)), bt(Il, S);
    }
  }
  function jm(m, S, P) {
    m === "focusin" ? (xt(), Cd = S, Eu = P, Cd.attachEvent("onpropertychange", op)) : m === "focusout" && xt();
  }
  function Bm(m) {
    if (m === "selectionchange" || m === "keyup" || m === "keydown") return Su(Eu);
  }
  function Pf(m, S) {
    if (m === "click") return Su(S);
  }
  function Fm(m, S) {
    if (m === "input" || m === "change") return Su(S);
  }
  function Cr(m, S) {
    return m === S && (m !== 0 || 1 / m === 1 / S) || m !== m && S !== S;
  }
  var Fa = typeof Object.is == "function" ? Object.is : Cr;
  function wd(m, S) {
    if (Fa(m, S)) return !0;
    if (typeof m != "object" || m === null || typeof S != "object" || S === null) return !1;
    var P = Object.keys(m), G = Object.keys(S);
    if (P.length !== G.length) return !1;
    for (G = 0; G < P.length; G++) {
      var se = P[G];
      if (!l.call(S, se) || !Fa(m[se], S[se])) return !1;
    }
    return !0;
  }
  function ap(m) {
    for (; m && m.firstChild; ) m = m.firstChild;
    return m;
  }
  function Tt(m, S) {
    var P = ap(m);
    m = 0;
    for (var G; P; ) {
      if (P.nodeType === 3) {
        if (G = m + P.textContent.length, m <= S && G >= S) return { node: P, offset: S - m };
        m = G;
      }
      e: {
        for (; P; ) {
          if (P.nextSibling) {
            P = P.nextSibling;
            break e;
          }
          P = P.parentNode;
        }
        P = void 0;
      }
      P = ap(P);
    }
  }
  function sl(m, S) {
    return m && S ? m === S ? !0 : m && m.nodeType === 3 ? !1 : S && S.nodeType === 3 ? sl(m, S.parentNode) : "contains" in m ? m.contains(S) : m.compareDocumentPosition ? !!(m.compareDocumentPosition(S) & 16) : !1 : !1;
  }
  function bo() {
    for (var m = window, S = we(); S instanceof m.HTMLIFrameElement; ) {
      try {
        var P = typeof S.contentWindow.location.href == "string";
      } catch {
        P = !1;
      }
      if (P) m = S.contentWindow;
      else break;
      S = we(m.document);
    }
    return S;
  }
  function ht(m) {
    var S = m && m.nodeName && m.nodeName.toLowerCase();
    return S && (S === "input" && (m.type === "text" || m.type === "search" || m.type === "tel" || m.type === "url" || m.type === "password") || S === "textarea" || m.contentEditable === "true");
  }
  function re(m) {
    var S = bo(), P = m.focusedElem, G = m.selectionRange;
    if (S !== P && P && P.ownerDocument && sl(P.ownerDocument.documentElement, P)) {
      if (G !== null && ht(P)) {
        if (S = G.start, m = G.end, m === void 0 && (m = S), "selectionStart" in P) P.selectionStart = S, P.selectionEnd = Math.min(m, P.value.length);
        else if (m = (S = P.ownerDocument || document) && S.defaultView || window, m.getSelection) {
          m = m.getSelection();
          var se = P.textContent.length, fe = Math.min(G.start, se);
          G = G.end === void 0 ? fe : Math.min(G.end, se), !m.extend && fe > G && (se = G, G = fe, fe = se), se = Tt(P, fe);
          var Oe = Tt(
            P,
            G
          );
          se && Oe && (m.rangeCount !== 1 || m.anchorNode !== se.node || m.anchorOffset !== se.offset || m.focusNode !== Oe.node || m.focusOffset !== Oe.offset) && (S = S.createRange(), S.setStart(se.node, se.offset), m.removeAllRanges(), fe > G ? (m.addRange(S), m.extend(Oe.node, Oe.offset)) : (S.setEnd(Oe.node, Oe.offset), m.addRange(S)));
        }
      }
      for (S = [], m = P; m = m.parentNode; ) m.nodeType === 1 && S.push({ element: m, left: m.scrollLeft, top: m.scrollTop });
      for (typeof P.focus == "function" && P.focus(), P = 0; P < S.length; P++) m = S[P], m.element.scrollLeft = m.left, m.element.scrollTop = m.top;
    }
  }
  var ji = r && "documentMode" in document && 11 >= document.documentMode, ia = null, Ll = null, xd = null, Cu = !1;
  function Vt(m, S, P) {
    var G = P.window === P ? P.document : P.nodeType === 9 ? P : P.ownerDocument;
    Cu || ia == null || ia !== we(G) || (G = ia, "selectionStart" in G && ht(G) ? G = { start: G.selectionStart, end: G.selectionEnd } : (G = (G.ownerDocument && G.ownerDocument.defaultView || window).getSelection(), G = { anchorNode: G.anchorNode, anchorOffset: G.anchorOffset, focusNode: G.focusNode, focusOffset: G.focusOffset }), xd && wd(xd, G) || (xd = G, G = Dd(Ll, "onSelect"), 0 < G.length && (S = new _c("onSelect", "select", null, S, P), m.push({ event: S, listeners: G }), S.target = ia)));
  }
  function Td(m, S) {
    var P = {};
    return P[m.toLowerCase()] = S.toLowerCase(), P["Webkit" + m] = "webkit" + S, P["Moz" + m] = "moz" + S, P;
  }
  var ll = { animationend: Td("Animation", "AnimationEnd"), animationiteration: Td("Animation", "AnimationIteration"), animationstart: Td("Animation", "AnimationStart"), transitionend: Td("Transition", "TransitionEnd") }, sp = {}, jf = {};
  r && (jf = document.createElement("div").style, "AnimationEvent" in window || (delete ll.animationend.animation, delete ll.animationiteration.animation, delete ll.animationstart.animation), "TransitionEvent" in window || delete ll.transitionend.transition);
  function ki(m) {
    if (sp[m]) return sp[m];
    if (!ll[m]) return m;
    var S = ll[m], P;
    for (P in S) if (S.hasOwnProperty(P) && P in jf) return sp[m] = S[P];
    return m;
  }
  var lp = ki("animationend"), He = ki("animationiteration"), Um = ki("animationstart"), Uo = ki("transitionend"), wc = /* @__PURE__ */ new Map(), xc = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Eo(m, S) {
    wc.set(m, S), a(S, [m]);
  }
  for (var wu = 0; wu < xc.length; wu++) {
    var Ml = xc[wu], Hm = Ml.toLowerCase(), Tc = Ml[0].toUpperCase() + Ml.slice(1);
    Eo(Hm, "on" + Tc);
  }
  Eo(lp, "onAnimationEnd"), Eo(He, "onAnimationIteration"), Eo(Um, "onAnimationStart"), Eo("dblclick", "onDoubleClick"), Eo("focusin", "onFocus"), Eo("focusout", "onBlur"), Eo(Uo, "onTransitionEnd"), s("onMouseEnter", ["mouseout", "mouseover"]), s("onMouseLeave", ["mouseout", "mouseover"]), s("onPointerEnter", ["pointerout", "pointerover"]), s("onPointerLeave", ["pointerout", "pointerover"]), a("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), a("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), a("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), a("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), a("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), a("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), w0 = new Set("cancel close invalid load scroll toggle".split(" ").concat(Ac));
  function Ad(m, S, P) {
    var G = m.type || "unknown-event";
    m.currentTarget = P, vo(G, S, void 0, m), m.currentTarget = null;
  }
  function Bf(m, S) {
    S = (S & 4) !== 0;
    for (var P = 0; P < m.length; P++) {
      var G = m[P], se = G.event;
      G = G.listeners;
      e: {
        var fe = void 0;
        if (S) for (var Oe = G.length - 1; 0 <= Oe; Oe--) {
          var $e = G[Oe], rt = $e.instance, Ct = $e.currentTarget;
          if ($e = $e.listener, rt !== fe && se.isPropagationStopped()) break e;
          Ad(se, $e, Ct), fe = rt;
        }
        else for (Oe = 0; Oe < G.length; Oe++) {
          if ($e = G[Oe], rt = $e.instance, Ct = $e.currentTarget, $e = $e.listener, rt !== fe && se.isPropagationStopped()) break e;
          Ad(se, $e, Ct), fe = rt;
        }
      }
    }
    if (Dn) throw m = Kn, Dn = !1, Kn = null, m;
  }
  function Mr(m, S) {
    var P = S[hp];
    P === void 0 && (P = S[hp] = /* @__PURE__ */ new Set());
    var G = m + "__bubble";
    P.has(G) || (kd(S, m, 2, !1), P.add(G));
  }
  function So(m, S, P) {
    var G = 0;
    S && (G |= 4), kd(P, m, G, S);
  }
  var As = "_reactListening" + Math.random().toString(36).slice(2);
  function xu(m) {
    if (!m[As]) {
      m[As] = !0, i.forEach(function(P) {
        P !== "selectionchange" && (w0.has(P) || So(P, !1, m), So(P, !0, m));
      });
      var S = m.nodeType === 9 ? m : m.ownerDocument;
      S === null || S[As] || (S[As] = !0, So("selectionchange", !1, S));
    }
  }
  function kd(m, S, P, G) {
    switch (bd(S)) {
      case 1:
        var se = kf;
        break;
      case 4:
        se = pc;
        break;
      default:
        se = fu;
    }
    P = se.bind(null, S, P, m), se = void 0, !fn || S !== "touchstart" && S !== "touchmove" && S !== "wheel" || (se = !0), G ? se !== void 0 ? m.addEventListener(S, P, { capture: !0, passive: se }) : m.addEventListener(S, P, !0) : se !== void 0 ? m.addEventListener(S, P, { passive: se }) : m.addEventListener(S, P, !1);
  }
  function Ff(m, S, P, G, se) {
    var fe = G;
    if (!(S & 1) && !(S & 2) && G !== null) e: for (; ; ) {
      if (G === null) return;
      var Oe = G.tag;
      if (Oe === 3 || Oe === 4) {
        var $e = G.stateNode.containerInfo;
        if ($e === se || $e.nodeType === 8 && $e.parentNode === se) break;
        if (Oe === 4) for (Oe = G.return; Oe !== null; ) {
          var rt = Oe.tag;
          if ((rt === 3 || rt === 4) && (rt = Oe.stateNode.containerInfo, rt === se || rt.nodeType === 8 && rt.parentNode === se)) return;
          Oe = Oe.return;
        }
        for (; $e !== null; ) {
          if (Oe = Ua($e), Oe === null) return;
          if (rt = Oe.tag, rt === 5 || rt === 6) {
            G = fe = Oe;
            continue e;
          }
          $e = $e.parentNode;
        }
      }
      G = G.return;
    }
    bt(function() {
      var Ct = fe, Ht = Ft(P), qt = [];
      e: {
        var Ut = wc.get(m);
        if (Ut !== void 0) {
          var rn = _c, gn = m;
          switch (m) {
            case "keypress":
              if (ws(P) === 0) break e;
            case "keydown":
            case "keyup":
              rn = yr;
              break;
            case "focusin":
              gn = "focus", rn = is;
              break;
            case "focusout":
              gn = "blur", rn = is;
              break;
            case "beforeblur":
            case "afterblur":
              rn = is;
              break;
            case "click":
              if (P.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              rn = vc;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              rn = Ts;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              rn = tp;
              break;
            case lp:
            case He:
            case Um:
              rn = Ec;
              break;
            case Uo:
              rn = If;
              break;
            case "scroll":
              rn = Df;
              break;
            case "wheel":
              rn = os;
              break;
            case "copy":
            case "cut":
            case "paste":
              rn = be;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              rn = ri;
          }
          var bn = (S & 4) !== 0, Xi = !bn && m === "scroll", mt = bn ? Ut !== null ? Ut + "Capture" : null : Ut;
          bn = [];
          for (var at = Ct, vt; at !== null; ) {
            vt = at;
            var $t = vt.stateNode;
            if (vt.tag === 5 && $t !== null && (vt = $t, mt !== null && ($t = Pt(at, mt), $t != null && bn.push(Od(at, $t, vt)))), Xi) break;
            at = at.return;
          }
          0 < bn.length && (Ut = new rn(Ut, gn, null, P, Ht), qt.push({ event: Ut, listeners: bn }));
        }
      }
      if (!(S & 7)) {
        e: {
          if (Ut = m === "mouseover" || m === "pointerover", rn = m === "mouseout" || m === "pointerout", Ut && P !== kt && (gn = P.relatedTarget || P.fromElement) && (Ua(gn) || gn[cl])) break e;
          if ((rn || Ut) && (Ut = Ht.window === Ht ? Ht : (Ut = Ht.ownerDocument) ? Ut.defaultView || Ut.parentWindow : window, rn ? (gn = P.relatedTarget || P.toElement, rn = Ct, gn = gn ? Ua(gn) : null, gn !== null && (Xi = qr(gn), gn !== Xi || gn.tag !== 5 && gn.tag !== 6) && (gn = null)) : (rn = null, gn = Ct), rn !== gn)) {
            if (bn = vc, $t = "onMouseLeave", mt = "onMouseEnter", at = "mouse", (m === "pointerout" || m === "pointerover") && (bn = ri, $t = "onPointerLeave", mt = "onPointerEnter", at = "pointer"), Xi = rn == null ? Ut : ku(rn), vt = gn == null ? Ut : ku(gn), Ut = new bn($t, at + "leave", rn, P, Ht), Ut.target = Xi, Ut.relatedTarget = vt, $t = null, Ua(Ht) === Ct && (bn = new bn(mt, at + "enter", gn, P, Ht), bn.target = vt, bn.relatedTarget = Xi, $t = bn), Xi = $t, rn && gn) t: {
              for (bn = rn, mt = gn, at = 0, vt = bn; vt; vt = Tu(vt)) at++;
              for (vt = 0, $t = mt; $t; $t = Tu($t)) vt++;
              for (; 0 < at - vt; ) bn = Tu(bn), at--;
              for (; 0 < vt - at; ) mt = Tu(mt), vt--;
              for (; at--; ) {
                if (bn === mt || mt !== null && bn === mt.alternate) break t;
                bn = Tu(bn), mt = Tu(mt);
              }
              bn = null;
            }
            else bn = null;
            rn !== null && up(qt, Ut, rn, bn, !1), gn !== null && Xi !== null && up(qt, Xi, gn, bn, !0);
          }
        }
        e: {
          if (Ut = Ct ? ku(Ct) : window, rn = Ut.nodeName && Ut.nodeName.toLowerCase(), rn === "select" || rn === "input" && Ut.type === "file") var wn = ip;
          else if (al(Ut)) if (Cc) wn = Fm;
          else {
            wn = Bm;
            var jn = jm;
          }
          else (rn = Ut.nodeName) && rn.toLowerCase() === "input" && (Ut.type === "checkbox" || Ut.type === "radio") && (wn = Pf);
          if (wn && (wn = wn(m, Ct))) {
            Sc(qt, wn, P, Ht);
            break e;
          }
          jn && jn(m, Ut, Ct), m === "focusout" && (jn = Ut._wrapperState) && jn.controlled && Ut.type === "number" && Ze(Ut, "number", Ut.value);
        }
        switch (jn = Ct ? ku(Ct) : window, m) {
          case "focusin":
            (al(jn) || jn.contentEditable === "true") && (ia = jn, Ll = Ct, xd = null);
            break;
          case "focusout":
            xd = Ll = ia = null;
            break;
          case "mousedown":
            Cu = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Cu = !1, Vt(qt, P, Ht);
            break;
          case "selectionchange":
            if (ji) break;
          case "keydown":
          case "keyup":
            Vt(qt, P, Ht);
        }
        var _n;
        if (ga) e: {
          switch (m) {
            case "compositionstart":
              var Hn = "onCompositionStart";
              break e;
            case "compositionend":
              Hn = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Hn = "onCompositionUpdate";
              break e;
          }
          Hn = void 0;
        }
        else ol ? vu(m, P) && (Hn = "onCompositionEnd") : m === "keydown" && P.keyCode === 229 && (Hn = "onCompositionStart");
        Hn && (_u && P.locale !== "ko" && (ol || Hn !== "onCompositionStart" ? Hn === "onCompositionEnd" && ol && (_n = Ed()) : (rs = Ht, pu = "value" in rs ? rs.value : rs.textContent, ol = !0)), jn = Dd(Ct, Hn), 0 < jn.length && (Hn = new ye(Hn, m, null, P, Ht), qt.push({ event: Hn, listeners: jn }), _n ? Hn.data = _n : (_n = bu(P), _n !== null && (Hn.data = _n)))), (_n = Nl ? np(m, P) : rp(m, P)) && (Ct = Dd(Ct, "onBeforeInput"), 0 < Ct.length && (Ht = new ye("onBeforeInput", "beforeinput", null, P, Ht), qt.push({ event: Ht, listeners: Ct }), Ht.data = _n));
      }
      Bf(qt, S);
    });
  }
  function Od(m, S, P) {
    return { instance: m, listener: S, currentTarget: P };
  }
  function Dd(m, S) {
    for (var P = S + "Capture", G = []; m !== null; ) {
      var se = m, fe = se.stateNode;
      se.tag === 5 && fe !== null && (se = fe, fe = Pt(m, P), fe != null && G.unshift(Od(m, fe, se)), fe = Pt(m, S), fe != null && G.push(Od(m, fe, se))), m = m.return;
    }
    return G;
  }
  function Tu(m) {
    if (m === null) return null;
    do
      m = m.return;
    while (m && m.tag !== 5);
    return m || null;
  }
  function up(m, S, P, G, se) {
    for (var fe = S._reactName, Oe = []; P !== null && P !== G; ) {
      var $e = P, rt = $e.alternate, Ct = $e.stateNode;
      if (rt !== null && rt === G) break;
      $e.tag === 5 && Ct !== null && ($e = Ct, se ? (rt = Pt(P, fe), rt != null && Oe.unshift(Od(P, rt, $e))) : se || (rt = Pt(P, fe), rt != null && Oe.push(Od(P, rt, $e)))), P = P.return;
    }
    Oe.length !== 0 && m.push({ event: S, listeners: Oe });
  }
  var cp = /\r\n?/g, Uf = /\u0000|\uFFFD/g;
  function dp(m) {
    return (typeof m == "string" ? m : "" + m).replace(cp, `
`).replace(Uf, "");
  }
  function Rd(m, S, P) {
    if (S = dp(S), dp(m) !== S && P) throw Error(t(425));
  }
  function Hf() {
  }
  var kc = null, Pl = null;
  function Oc(m, S) {
    return m === "textarea" || m === "noscript" || typeof S.children == "string" || typeof S.children == "number" || typeof S.dangerouslySetInnerHTML == "object" && S.dangerouslySetInnerHTML !== null && S.dangerouslySetInnerHTML.__html != null;
  }
  var jl = typeof setTimeout == "function" ? setTimeout : void 0, Bl = typeof clearTimeout == "function" ? clearTimeout : void 0, zf = typeof Promise == "function" ? Promise : void 0, fp = typeof queueMicrotask == "function" ? queueMicrotask : typeof zf < "u" ? function(m) {
    return zf.resolve(null).then(m).catch(x0);
  } : jl;
  function x0(m) {
    setTimeout(function() {
      throw m;
    });
  }
  function ul(m, S) {
    var P = S, G = 0;
    do {
      var se = P.nextSibling;
      if (m.removeChild(P), se && se.nodeType === 8) if (P = se.data, P === "/$") {
        if (G === 0) {
          m.removeChild(se), qn(S);
          return;
        }
        G--;
      } else P !== "$" && P !== "$?" && P !== "$!" || G++;
      P = se;
    } while (P);
    qn(S);
  }
  function as(m) {
    for (; m != null; m = m.nextSibling) {
      var S = m.nodeType;
      if (S === 1 || S === 3) break;
      if (S === 8) {
        if (S = m.data, S === "$" || S === "$!" || S === "$?") break;
        if (S === "/$") return null;
      }
    }
    return m;
  }
  function Dc(m) {
    m = m.previousSibling;
    for (var S = 0; m; ) {
      if (m.nodeType === 8) {
        var P = m.data;
        if (P === "$" || P === "$!" || P === "$?") {
          if (S === 0) return m;
          S--;
        } else P === "/$" && S++;
      }
      m = m.previousSibling;
    }
    return null;
  }
  var Fl = Math.random().toString(36).slice(2), ks = "__reactFiber$" + Fl, Au = "__reactProps$" + Fl, cl = "__reactContainer$" + Fl, hp = "__reactEvents$" + Fl, T0 = "__reactListeners$" + Fl, pp = "__reactHandles$" + Fl;
  function Ua(m) {
    var S = m[ks];
    if (S) return S;
    for (var P = m.parentNode; P; ) {
      if (S = P[cl] || P[ks]) {
        if (P = S.alternate, S.child !== null || P !== null && P.child !== null) for (m = Dc(m); m !== null; ) {
          if (P = m[ks]) return P;
          m = Dc(m);
        }
        return S;
      }
      m = P, P = m.parentNode;
    }
    return null;
  }
  function Rc(m) {
    return m = m[ks] || m[cl], !m || m.tag !== 5 && m.tag !== 6 && m.tag !== 13 && m.tag !== 3 ? null : m;
  }
  function ku(m) {
    if (m.tag === 5 || m.tag === 6) return m.stateNode;
    throw Error(t(33));
  }
  function xn(m) {
    return m[Au] || null;
  }
  var ss = [], Yr = -1;
  function Fn(m) {
    return { current: m };
  }
  function Tr(m) {
    0 > Yr || (m.current = ss[Yr], ss[Yr] = null, Yr--);
  }
  function Ar(m, S) {
    Yr++, ss[Yr] = m.current, m.current = S;
  }
  var Xe = {}, Gn = Fn(Xe), bi = Fn(!1), oa = Xe;
  function Ha(m, S) {
    var P = m.type.contextTypes;
    if (!P) return Xe;
    var G = m.stateNode;
    if (G && G.__reactInternalMemoizedUnmaskedChildContext === S) return G.__reactInternalMemoizedMaskedChildContext;
    var se = {}, fe;
    for (fe in P) se[fe] = S[fe];
    return G && (m = m.stateNode, m.__reactInternalMemoizedUnmaskedChildContext = S, m.__reactInternalMemoizedMaskedChildContext = se), se;
  }
  function ii(m) {
    return m = m.childContextTypes, m != null;
  }
  function _a() {
    Tr(bi), Tr(Gn);
  }
  function dl(m, S, P) {
    if (Gn.current !== Xe) throw Error(t(168));
    Ar(Gn, S), Ar(bi, P);
  }
  function Ou(m, S, P) {
    var G = m.stateNode;
    if (S = S.childContextTypes, typeof G.getChildContext != "function") return P;
    G = G.getChildContext();
    for (var se in G) if (!(se in S)) throw Error(t(108, X(m) || "Unknown", se));
    return K({}, P, G);
  }
  function Nc(m) {
    return m = (m = m.stateNode) && m.__reactInternalMemoizedMergedChildContext || Xe, oa = Gn.current, Ar(Gn, m), Ar(bi, bi.current), !0;
  }
  function Vf(m, S, P) {
    var G = m.stateNode;
    if (!G) throw Error(t(169));
    P ? (m = Ou(m, S, oa), G.__reactInternalMemoizedMergedChildContext = m, Tr(bi), Tr(Gn), Ar(Gn, m)) : Tr(bi), Ar(bi, P);
  }
  var co = null, Ei = !1, fl = !1;
  function ya(m) {
    co === null ? co = [m] : co.push(m);
  }
  function hl(m) {
    Ei = !0, ya(m);
  }
  function Ji() {
    if (!fl && co !== null) {
      fl = !0;
      var m = 0, S = Er;
      try {
        var P = co;
        for (Er = 1; m < P.length; m++) {
          var G = P[m];
          do
            G = G(!0);
          while (G !== null);
        }
        co = null, Ei = !1;
      } catch (se) {
        throw co !== null && (co = co.slice(m + 1)), di(pa, Ji), se;
      } finally {
        Er = S, fl = !1;
      }
    }
    return null;
  }
  var za = [], eo = 0, Os = null, Du = 0, Ho = [], fo = 0, va = null, to = 1, Ds = "";
  function Hr(m, S) {
    za[eo++] = Du, za[eo++] = Os, Os = m, Du = S;
  }
  function qf(m, S, P) {
    Ho[fo++] = to, Ho[fo++] = Ds, Ho[fo++] = va, va = m;
    var G = to;
    m = Ds;
    var se = 32 - Mo(G) - 1;
    G &= ~(1 << se), P += 1;
    var fe = 32 - Mo(S) + se;
    if (30 < fe) {
      var Oe = se - se % 5;
      fe = (G & (1 << Oe) - 1).toString(32), G >>= Oe, se -= Oe, to = 1 << 32 - Mo(S) + se | P << se | G, Ds = fe + m;
    } else to = 1 << fe | P << se | G, Ds = m;
  }
  function Ru(m) {
    m.return !== null && (Hr(m, 1), qf(m, 1, 0));
  }
  function Gf(m) {
    for (; m === Os; ) Os = za[--eo], za[eo] = null, Du = za[--eo], za[eo] = null;
    for (; m === va; ) va = Ho[--fo], Ho[fo] = null, Ds = Ho[--fo], Ho[fo] = null, to = Ho[--fo], Ho[fo] = null;
  }
  var zo = null, qi = null, Pr = !1, Co = null;
  function Wf(m, S) {
    var P = Fs(5, null, null, 0);
    P.elementType = "DELETED", P.stateNode = S, P.return = m, S = m.deletions, S === null ? (m.deletions = [P], m.flags |= 16) : S.push(P);
  }
  function mp(m, S) {
    switch (m.tag) {
      case 5:
        var P = m.type;
        return S = S.nodeType !== 1 || P.toLowerCase() !== S.nodeName.toLowerCase() ? null : S, S !== null ? (m.stateNode = S, zo = m, qi = as(S.firstChild), !0) : !1;
      case 6:
        return S = m.pendingProps === "" || S.nodeType !== 3 ? null : S, S !== null ? (m.stateNode = S, zo = m, qi = null, !0) : !1;
      case 13:
        return S = S.nodeType !== 8 ? null : S, S !== null ? (P = va !== null ? { id: to, overflow: Ds } : null, m.memoizedState = { dehydrated: S, treeContext: P, retryLane: 1073741824 }, P = Fs(18, null, null, 0), P.stateNode = S, P.return = m, m.child = P, zo = m, qi = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Ul(m) {
    return (m.mode & 1) !== 0 && (m.flags & 128) === 0;
  }
  function Nd(m) {
    if (Pr) {
      var S = qi;
      if (S) {
        var P = S;
        if (!mp(m, S)) {
          if (Ul(m)) throw Error(t(418));
          S = as(P.nextSibling);
          var G = zo;
          S && mp(m, S) ? Wf(G, P) : (m.flags = m.flags & -4097 | 2, Pr = !1, zo = m);
        }
      } else {
        if (Ul(m)) throw Error(t(418));
        m.flags = m.flags & -4097 | 2, Pr = !1, zo = m;
      }
    }
  }
  function $f(m) {
    for (m = m.return; m !== null && m.tag !== 5 && m.tag !== 3 && m.tag !== 13; ) m = m.return;
    zo = m;
  }
  function Nu(m) {
    if (m !== zo) return !1;
    if (!Pr) return $f(m), Pr = !0, !1;
    var S;
    if ((S = m.tag !== 3) && !(S = m.tag !== 5) && (S = m.type, S = S !== "head" && S !== "body" && !Oc(m.type, m.memoizedProps)), S && (S = qi)) {
      if (Ul(m)) throw Id(), Error(t(418));
      for (; S; ) Wf(m, S), S = as(S.nextSibling);
    }
    if ($f(m), m.tag === 13) {
      if (m = m.memoizedState, m = m !== null ? m.dehydrated : null, !m) throw Error(t(317));
      e: {
        for (m = m.nextSibling, S = 0; m; ) {
          if (m.nodeType === 8) {
            var P = m.data;
            if (P === "/$") {
              if (S === 0) {
                qi = as(m.nextSibling);
                break e;
              }
              S--;
            } else P !== "$" && P !== "$!" && P !== "$?" || S++;
          }
          m = m.nextSibling;
        }
        qi = null;
      }
    } else qi = zo ? as(m.stateNode.nextSibling) : null;
    return !0;
  }
  function Id() {
    for (var m = qi; m; ) m = as(m.nextSibling);
  }
  function oi() {
    qi = zo = null, Pr = !1;
  }
  function Ic(m) {
    Co === null ? Co = [m] : Co.push(m);
  }
  var Ld = T.ReactCurrentBatchConfig;
  function Hl(m, S, P) {
    if (m = P.ref, m !== null && typeof m != "function" && typeof m != "object") {
      if (P._owner) {
        if (P = P._owner, P) {
          if (P.tag !== 1) throw Error(t(309));
          var G = P.stateNode;
        }
        if (!G) throw Error(t(147, m));
        var se = G, fe = "" + m;
        return S !== null && S.ref !== null && typeof S.ref == "function" && S.ref._stringRef === fe ? S.ref : (S = function(Oe) {
          var $e = se.refs;
          Oe === null ? delete $e[fe] : $e[fe] = Oe;
        }, S._stringRef = fe, S);
      }
      if (typeof m != "string") throw Error(t(284));
      if (!P._owner) throw Error(t(290, m));
    }
    return m;
  }
  function ls(m, S) {
    throw m = Object.prototype.toString.call(S), Error(t(31, m === "[object Object]" ? "object with keys {" + Object.keys(S).join(", ") + "}" : m));
  }
  function gp(m) {
    var S = m._init;
    return S(m._payload);
  }
  function Md(m) {
    function S(mt, at) {
      if (m) {
        var vt = mt.deletions;
        vt === null ? (mt.deletions = [at], mt.flags |= 16) : vt.push(at);
      }
    }
    function P(mt, at) {
      if (!m) return null;
      for (; at !== null; ) S(mt, at), at = at.sibling;
      return null;
    }
    function G(mt, at) {
      for (mt = /* @__PURE__ */ new Map(); at !== null; ) at.key !== null ? mt.set(at.key, at) : mt.set(at.index, at), at = at.sibling;
      return mt;
    }
    function se(mt, at) {
      return mt = Vc(mt, at), mt.index = 0, mt.sibling = null, mt;
    }
    function fe(mt, at, vt) {
      return mt.index = vt, m ? (vt = mt.alternate, vt !== null ? (vt = vt.index, vt < at ? (mt.flags |= 2, at) : vt) : (mt.flags |= 2, at)) : (mt.flags |= 1048576, at);
    }
    function Oe(mt) {
      return m && mt.alternate === null && (mt.flags |= 2), mt;
    }
    function $e(mt, at, vt, $t) {
      return at === null || at.tag !== 6 ? (at = ug(vt, mt.mode, $t), at.return = mt, at) : (at = se(at, vt), at.return = mt, at);
    }
    function rt(mt, at, vt, $t) {
      var wn = vt.type;
      return wn === N ? Ht(mt, at, vt.props.children, $t, vt.key) : at !== null && (at.elementType === wn || typeof wn == "object" && wn !== null && wn.$$typeof === ce && gp(wn) === at.type) ? ($t = se(at, vt.props), $t.ref = Hl(mt, at, vt), $t.return = mt, $t) : ($t = sg(vt.type, vt.key, vt.props, null, mt.mode, $t), $t.ref = Hl(mt, at, vt), $t.return = mt, $t);
    }
    function Ct(mt, at, vt, $t) {
      return at === null || at.tag !== 4 || at.stateNode.containerInfo !== vt.containerInfo || at.stateNode.implementation !== vt.implementation ? (at = Op(vt, mt.mode, $t), at.return = mt, at) : (at = se(at, vt.children || []), at.return = mt, at);
    }
    function Ht(mt, at, vt, $t, wn) {
      return at === null || at.tag !== 7 ? (at = Yd(vt, mt.mode, $t, wn), at.return = mt, at) : (at = se(at, vt), at.return = mt, at);
    }
    function qt(mt, at, vt) {
      if (typeof at == "string" && at !== "" || typeof at == "number") return at = ug("" + at, mt.mode, vt), at.return = mt, at;
      if (typeof at == "object" && at !== null) {
        switch (at.$$typeof) {
          case A:
            return vt = sg(at.type, at.key, at.props, null, mt.mode, vt), vt.ref = Hl(mt, null, at), vt.return = mt, vt;
          case k:
            return at = Op(at, mt.mode, vt), at.return = mt, at;
          case ce:
            var $t = at._init;
            return qt(mt, $t(at._payload), vt);
        }
        if (tt(at) || V(at)) return at = Yd(at, mt.mode, vt, null), at.return = mt, at;
        ls(mt, at);
      }
      return null;
    }
    function Ut(mt, at, vt, $t) {
      var wn = at !== null ? at.key : null;
      if (typeof vt == "string" && vt !== "" || typeof vt == "number") return wn !== null ? null : $e(mt, at, "" + vt, $t);
      if (typeof vt == "object" && vt !== null) {
        switch (vt.$$typeof) {
          case A:
            return vt.key === wn ? rt(mt, at, vt, $t) : null;
          case k:
            return vt.key === wn ? Ct(mt, at, vt, $t) : null;
          case ce:
            return wn = vt._init, Ut(
              mt,
              at,
              wn(vt._payload),
              $t
            );
        }
        if (tt(vt) || V(vt)) return wn !== null ? null : Ht(mt, at, vt, $t, null);
        ls(mt, vt);
      }
      return null;
    }
    function rn(mt, at, vt, $t, wn) {
      if (typeof $t == "string" && $t !== "" || typeof $t == "number") return mt = mt.get(vt) || null, $e(at, mt, "" + $t, wn);
      if (typeof $t == "object" && $t !== null) {
        switch ($t.$$typeof) {
          case A:
            return mt = mt.get($t.key === null ? vt : $t.key) || null, rt(at, mt, $t, wn);
          case k:
            return mt = mt.get($t.key === null ? vt : $t.key) || null, Ct(at, mt, $t, wn);
          case ce:
            var jn = $t._init;
            return rn(mt, at, vt, jn($t._payload), wn);
        }
        if (tt($t) || V($t)) return mt = mt.get(vt) || null, Ht(at, mt, $t, wn, null);
        ls(at, $t);
      }
      return null;
    }
    function gn(mt, at, vt, $t) {
      for (var wn = null, jn = null, _n = at, Hn = at = 0, go = null; _n !== null && Hn < vt.length; Hn++) {
        _n.index > Hn ? (go = _n, _n = null) : go = _n.sibling;
        var Rr = Ut(mt, _n, vt[Hn], $t);
        if (Rr === null) {
          _n === null && (_n = go);
          break;
        }
        m && _n && Rr.alternate === null && S(mt, _n), at = fe(Rr, at, Hn), jn === null ? wn = Rr : jn.sibling = Rr, jn = Rr, _n = go;
      }
      if (Hn === vt.length) return P(mt, _n), Pr && Hr(mt, Hn), wn;
      if (_n === null) {
        for (; Hn < vt.length; Hn++) _n = qt(mt, vt[Hn], $t), _n !== null && (at = fe(_n, at, Hn), jn === null ? wn = _n : jn.sibling = _n, jn = _n);
        return Pr && Hr(mt, Hn), wn;
      }
      for (_n = G(mt, _n); Hn < vt.length; Hn++) go = rn(_n, mt, Hn, vt[Hn], $t), go !== null && (m && go.alternate !== null && _n.delete(go.key === null ? Hn : go.key), at = fe(go, at, Hn), jn === null ? wn = go : jn.sibling = go, jn = go);
      return m && _n.forEach(function(Pu) {
        return S(mt, Pu);
      }), Pr && Hr(mt, Hn), wn;
    }
    function bn(mt, at, vt, $t) {
      var wn = V(vt);
      if (typeof wn != "function") throw Error(t(150));
      if (vt = wn.call(vt), vt == null) throw Error(t(151));
      for (var jn = wn = null, _n = at, Hn = at = 0, go = null, Rr = vt.next(); _n !== null && !Rr.done; Hn++, Rr = vt.next()) {
        _n.index > Hn ? (go = _n, _n = null) : go = _n.sibling;
        var Pu = Ut(mt, _n, Rr.value, $t);
        if (Pu === null) {
          _n === null && (_n = go);
          break;
        }
        m && _n && Pu.alternate === null && S(mt, _n), at = fe(Pu, at, Hn), jn === null ? wn = Pu : jn.sibling = Pu, jn = Pu, _n = go;
      }
      if (Rr.done) return P(
        mt,
        _n
      ), Pr && Hr(mt, Hn), wn;
      if (_n === null) {
        for (; !Rr.done; Hn++, Rr = vt.next()) Rr = qt(mt, Rr.value, $t), Rr !== null && (at = fe(Rr, at, Hn), jn === null ? wn = Rr : jn.sibling = Rr, jn = Rr);
        return Pr && Hr(mt, Hn), wn;
      }
      for (_n = G(mt, _n); !Rr.done; Hn++, Rr = vt.next()) Rr = rn(_n, mt, Hn, Rr.value, $t), Rr !== null && (m && Rr.alternate !== null && _n.delete(Rr.key === null ? Hn : Rr.key), at = fe(Rr, at, Hn), jn === null ? wn = Rr : jn.sibling = Rr, jn = Rr);
      return m && _n.forEach(function(pE) {
        return S(mt, pE);
      }), Pr && Hr(mt, Hn), wn;
    }
    function Xi(mt, at, vt, $t) {
      if (typeof vt == "object" && vt !== null && vt.type === N && vt.key === null && (vt = vt.props.children), typeof vt == "object" && vt !== null) {
        switch (vt.$$typeof) {
          case A:
            e: {
              for (var wn = vt.key, jn = at; jn !== null; ) {
                if (jn.key === wn) {
                  if (wn = vt.type, wn === N) {
                    if (jn.tag === 7) {
                      P(mt, jn.sibling), at = se(jn, vt.props.children), at.return = mt, mt = at;
                      break e;
                    }
                  } else if (jn.elementType === wn || typeof wn == "object" && wn !== null && wn.$$typeof === ce && gp(wn) === jn.type) {
                    P(mt, jn.sibling), at = se(jn, vt.props), at.ref = Hl(mt, jn, vt), at.return = mt, mt = at;
                    break e;
                  }
                  P(mt, jn);
                  break;
                } else S(mt, jn);
                jn = jn.sibling;
              }
              vt.type === N ? (at = Yd(vt.props.children, mt.mode, $t, vt.key), at.return = mt, mt = at) : ($t = sg(vt.type, vt.key, vt.props, null, mt.mode, $t), $t.ref = Hl(mt, at, vt), $t.return = mt, mt = $t);
            }
            return Oe(mt);
          case k:
            e: {
              for (jn = vt.key; at !== null; ) {
                if (at.key === jn) if (at.tag === 4 && at.stateNode.containerInfo === vt.containerInfo && at.stateNode.implementation === vt.implementation) {
                  P(mt, at.sibling), at = se(at, vt.children || []), at.return = mt, mt = at;
                  break e;
                } else {
                  P(mt, at);
                  break;
                }
                else S(mt, at);
                at = at.sibling;
              }
              at = Op(vt, mt.mode, $t), at.return = mt, mt = at;
            }
            return Oe(mt);
          case ce:
            return jn = vt._init, Xi(mt, at, jn(vt._payload), $t);
        }
        if (tt(vt)) return gn(mt, at, vt, $t);
        if (V(vt)) return bn(mt, at, vt, $t);
        ls(mt, vt);
      }
      return typeof vt == "string" && vt !== "" || typeof vt == "number" ? (vt = "" + vt, at !== null && at.tag === 6 ? (P(mt, at.sibling), at = se(at, vt), at.return = mt, mt = at) : (P(mt, at), at = ug(vt, mt.mode, $t), at.return = mt, mt = at), Oe(mt)) : P(mt, at);
    }
    return Xi;
  }
  var pl = Md(!0), Pd = Md(!1), Rs = Fn(null), Bi = null, Xt = null, ba = null;
  function aa() {
    ba = Xt = Bi = null;
  }
  function Yf(m) {
    var S = Rs.current;
    Tr(Rs), m._currentValue = S;
  }
  function Xf(m, S, P) {
    for (; m !== null; ) {
      var G = m.alternate;
      if ((m.childLanes & S) !== S ? (m.childLanes |= S, G !== null && (G.childLanes |= S)) : G !== null && (G.childLanes & S) !== S && (G.childLanes |= S), m === P) break;
      m = m.return;
    }
  }
  function Lc(m, S) {
    Bi = m, ba = Xt = null, m = m.dependencies, m !== null && m.firstContext !== null && (m.lanes & S && (qa = !0), m.firstContext = null);
  }
  function Va(m) {
    var S = m._currentValue;
    if (ba !== m) if (m = { context: m, memoizedValue: S, next: null }, Xt === null) {
      if (Bi === null) throw Error(t(308));
      Xt = m, Bi.dependencies = { lanes: 0, firstContext: m };
    } else Xt = Xt.next = m;
    return S;
  }
  var zl = null;
  function mi(m) {
    zl === null ? zl = [m] : zl.push(m);
  }
  function _p(m, S, P, G) {
    var se = S.interleaved;
    return se === null ? (P.next = P, mi(S)) : (P.next = se.next, se.next = P), S.interleaved = P, Ns(m, G);
  }
  function Ns(m, S) {
    m.lanes |= S;
    var P = m.alternate;
    for (P !== null && (P.lanes |= S), P = m, m = m.return; m !== null; ) m.childLanes |= S, P = m.alternate, P !== null && (P.childLanes |= S), P = m, m = m.return;
    return P.tag === 3 ? P.stateNode : null;
  }
  var ml = !1;
  function jd(m) {
    m.updateQueue = { baseState: m.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function us(m, S) {
    m = m.updateQueue, S.updateQueue === m && (S.updateQueue = { baseState: m.baseState, firstBaseUpdate: m.firstBaseUpdate, lastBaseUpdate: m.lastBaseUpdate, shared: m.shared, effects: m.effects });
  }
  function wo(m, S) {
    return { eventTime: m, lane: S, tag: 0, payload: null, callback: null, next: null };
  }
  function Vl(m, S, P) {
    var G = m.updateQueue;
    if (G === null) return null;
    if (G = G.shared, mr & 2) {
      var se = G.pending;
      return se === null ? S.next = S : (S.next = se.next, se.next = S), G.pending = S, Ns(m, P);
    }
    return se = G.interleaved, se === null ? (S.next = S, mi(G)) : (S.next = se.next, se.next = S), G.interleaved = S, Ns(m, P);
  }
  function Kf(m, S, P) {
    if (S = S.updateQueue, S !== null && (S = S.shared, (P & 4194240) !== 0)) {
      var G = S.lanes;
      G &= m.pendingLanes, P |= G, S.lanes = P, Al(m, P);
    }
  }
  function an(m, S) {
    var P = m.updateQueue, G = m.alternate;
    if (G !== null && (G = G.updateQueue, P === G)) {
      var se = null, fe = null;
      if (P = P.firstBaseUpdate, P !== null) {
        do {
          var Oe = { eventTime: P.eventTime, lane: P.lane, tag: P.tag, payload: P.payload, callback: P.callback, next: null };
          fe === null ? se = fe = Oe : fe = fe.next = Oe, P = P.next;
        } while (P !== null);
        fe === null ? se = fe = S : fe = fe.next = S;
      } else se = fe = S;
      P = { baseState: G.baseState, firstBaseUpdate: se, lastBaseUpdate: fe, shared: G.shared, effects: G.effects }, m.updateQueue = P;
      return;
    }
    m = P.lastBaseUpdate, m === null ? P.firstBaseUpdate = S : m.next = S, P.lastBaseUpdate = S;
  }
  function Lt(m, S, P, G) {
    var se = m.updateQueue;
    ml = !1;
    var fe = se.firstBaseUpdate, Oe = se.lastBaseUpdate, $e = se.shared.pending;
    if ($e !== null) {
      se.shared.pending = null;
      var rt = $e, Ct = rt.next;
      rt.next = null, Oe === null ? fe = Ct : Oe.next = Ct, Oe = rt;
      var Ht = m.alternate;
      Ht !== null && (Ht = Ht.updateQueue, $e = Ht.lastBaseUpdate, $e !== Oe && ($e === null ? Ht.firstBaseUpdate = Ct : $e.next = Ct, Ht.lastBaseUpdate = rt));
    }
    if (fe !== null) {
      var qt = se.baseState;
      Oe = 0, Ht = Ct = rt = null, $e = fe;
      do {
        var Ut = $e.lane, rn = $e.eventTime;
        if ((G & Ut) === Ut) {
          Ht !== null && (Ht = Ht.next = {
            eventTime: rn,
            lane: 0,
            tag: $e.tag,
            payload: $e.payload,
            callback: $e.callback,
            next: null
          });
          e: {
            var gn = m, bn = $e;
            switch (Ut = S, rn = P, bn.tag) {
              case 1:
                if (gn = bn.payload, typeof gn == "function") {
                  qt = gn.call(rn, qt, Ut);
                  break e;
                }
                qt = gn;
                break e;
              case 3:
                gn.flags = gn.flags & -65537 | 128;
              case 0:
                if (gn = bn.payload, Ut = typeof gn == "function" ? gn.call(rn, qt, Ut) : gn, Ut == null) break e;
                qt = K({}, qt, Ut);
                break e;
              case 2:
                ml = !0;
            }
          }
          $e.callback !== null && $e.lane !== 0 && (m.flags |= 64, Ut = se.effects, Ut === null ? se.effects = [$e] : Ut.push($e));
        } else rn = { eventTime: rn, lane: Ut, tag: $e.tag, payload: $e.payload, callback: $e.callback, next: null }, Ht === null ? (Ct = Ht = rn, rt = qt) : Ht = Ht.next = rn, Oe |= Ut;
        if ($e = $e.next, $e === null) {
          if ($e = se.shared.pending, $e === null) break;
          Ut = $e, $e = Ut.next, Ut.next = null, se.lastBaseUpdate = Ut, se.shared.pending = null;
        }
      } while (!0);
      if (Ht === null && (rt = qt), se.baseState = rt, se.firstBaseUpdate = Ct, se.lastBaseUpdate = Ht, S = se.shared.interleaved, S !== null) {
        se = S;
        do
          Oe |= se.lane, se = se.next;
        while (se !== S);
      } else fe === null && (se.shared.lanes = 0);
      qd |= Oe, m.lanes = Oe, m.memoizedState = qt;
    }
  }
  function Is(m, S, P) {
    if (m = S.effects, S.effects = null, m !== null) for (S = 0; S < m.length; S++) {
      var G = m[S], se = G.callback;
      if (se !== null) {
        if (G.callback = null, G = P, typeof se != "function") throw Error(t(191, se));
        se.call(G);
      }
    }
  }
  var Bd = {}, sa = Fn(Bd), Mc = Fn(Bd), Ea = Fn(Bd);
  function Ls(m) {
    if (m === Bd) throw Error(t(174));
    return m;
  }
  function Qf(m, S) {
    switch (Ar(Ea, S), Ar(Mc, m), Ar(sa, Bd), m = S.nodeType, m) {
      case 9:
      case 11:
        S = (S = S.documentElement) ? S.namespaceURI : Me(null, "");
        break;
      default:
        m = m === 8 ? S.parentNode : S, S = m.namespaceURI || null, m = m.tagName, S = Me(S, m);
    }
    Tr(sa), Ar(sa, S);
  }
  function Gi() {
    Tr(sa), Tr(Mc), Tr(Ea);
  }
  function zm(m) {
    Ls(Ea.current);
    var S = Ls(sa.current), P = Me(S, m.type);
    S !== P && (Ar(Mc, m), Ar(sa, P));
  }
  function Pc(m) {
    Mc.current === m && (Tr(sa), Tr(Mc));
  }
  var ci = Fn(0);
  function Xr(m) {
    for (var S = m; S !== null; ) {
      if (S.tag === 13) {
        var P = S.memoizedState;
        if (P !== null && (P = P.dehydrated, P === null || P.data === "$?" || P.data === "$!")) return S;
      } else if (S.tag === 19 && S.memoizedProps.revealOrder !== void 0) {
        if (S.flags & 128) return S;
      } else if (S.child !== null) {
        S.child.return = S, S = S.child;
        continue;
      }
      if (S === m) break;
      for (; S.sibling === null; ) {
        if (S.return === null || S.return === m) return null;
        S = S.return;
      }
      S.sibling.return = S.return, S = S.sibling;
    }
    return null;
  }
  var yt = [];
  function Ve() {
    for (var m = 0; m < yt.length; m++) yt[m]._workInProgressVersionPrimary = null;
    yt.length = 0;
  }
  var De = T.ReactCurrentDispatcher, ct = T.ReactCurrentBatchConfig, vn = 0, Sn = null, Un = null, lr = null, Sa = !1, jc = !1, Bc = 0, A0 = 0;
  function xo() {
    throw Error(t(321));
  }
  function Fd(m, S) {
    if (S === null) return !1;
    for (var P = 0; P < S.length && P < m.length; P++) if (!Fa(m[P], S[P])) return !1;
    return !0;
  }
  function jt(m, S, P, G, se, fe) {
    if (vn = fe, Sn = S, S.memoizedState = null, S.updateQueue = null, S.lanes = 0, De.current = m === null || m.memoizedState === null ? Wi : Gr, m = P(G, se), jc) {
      fe = 0;
      do {
        if (jc = !1, Bc = 0, 25 <= fe) throw Error(t(301));
        fe += 1, lr = Un = null, S.updateQueue = null, De.current = Ud, m = P(G, se);
      } while (jc);
    }
    if (De.current = gi, S = Un !== null && Un.next !== null, vn = 0, lr = Un = Sn = null, Sa = !1, S) throw Error(t(300));
    return m;
  }
  function M() {
    var m = Bc !== 0;
    return Bc = 0, m;
  }
  function O() {
    var m = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return lr === null ? Sn.memoizedState = lr = m : lr = lr.next = m, lr;
  }
  function w() {
    if (Un === null) {
      var m = Sn.alternate;
      m = m !== null ? m.memoizedState : null;
    } else m = Un.next;
    var S = lr === null ? Sn.memoizedState : lr.next;
    if (S !== null) lr = S, Un = m;
    else {
      if (m === null) throw Error(t(310));
      Un = m, m = { memoizedState: Un.memoizedState, baseState: Un.baseState, baseQueue: Un.baseQueue, queue: Un.queue, next: null }, lr === null ? Sn.memoizedState = lr = m : lr = lr.next = m;
    }
    return lr;
  }
  function R(m, S) {
    return typeof S == "function" ? S(m) : S;
  }
  function W(m) {
    var S = w(), P = S.queue;
    if (P === null) throw Error(t(311));
    P.lastRenderedReducer = m;
    var G = Un, se = G.baseQueue, fe = P.pending;
    if (fe !== null) {
      if (se !== null) {
        var Oe = se.next;
        se.next = fe.next, fe.next = Oe;
      }
      G.baseQueue = se = fe, P.pending = null;
    }
    if (se !== null) {
      fe = se.next, G = G.baseState;
      var $e = Oe = null, rt = null, Ct = fe;
      do {
        var Ht = Ct.lane;
        if ((vn & Ht) === Ht) rt !== null && (rt = rt.next = { lane: 0, action: Ct.action, hasEagerState: Ct.hasEagerState, eagerState: Ct.eagerState, next: null }), G = Ct.hasEagerState ? Ct.eagerState : m(G, Ct.action);
        else {
          var qt = {
            lane: Ht,
            action: Ct.action,
            hasEagerState: Ct.hasEagerState,
            eagerState: Ct.eagerState,
            next: null
          };
          rt === null ? ($e = rt = qt, Oe = G) : rt = rt.next = qt, Sn.lanes |= Ht, qd |= Ht;
        }
        Ct = Ct.next;
      } while (Ct !== null && Ct !== fe);
      rt === null ? Oe = G : rt.next = $e, Fa(G, S.memoizedState) || (qa = !0), S.memoizedState = G, S.baseState = Oe, S.baseQueue = rt, P.lastRenderedState = G;
    }
    if (m = P.interleaved, m !== null) {
      se = m;
      do
        fe = se.lane, Sn.lanes |= fe, qd |= fe, se = se.next;
      while (se !== m);
    } else se === null && (P.lanes = 0);
    return [S.memoizedState, P.dispatch];
  }
  function ue(m) {
    var S = w(), P = S.queue;
    if (P === null) throw Error(t(311));
    P.lastRenderedReducer = m;
    var G = P.dispatch, se = P.pending, fe = S.memoizedState;
    if (se !== null) {
      P.pending = null;
      var Oe = se = se.next;
      do
        fe = m(fe, Oe.action), Oe = Oe.next;
      while (Oe !== se);
      Fa(fe, S.memoizedState) || (qa = !0), S.memoizedState = fe, S.baseQueue === null && (S.baseState = fe), P.lastRenderedState = fe;
    }
    return [fe, G];
  }
  function me() {
  }
  function Ae(m, S) {
    var P = Sn, G = w(), se = S(), fe = !Fa(G.memoizedState, se);
    if (fe && (G.memoizedState = se, qa = !0), G = G.queue, Zn(ut.bind(null, P, G, m), [m]), G.getSnapshot !== S || fe || lr !== null && lr.memoizedState.tag & 1) {
      if (P.flags |= 2048, Bt(9, Fe.bind(null, P, G, se, S), void 0, null), Ui === null) throw Error(t(349));
      vn & 30 || Ne(P, S, se);
    }
    return se;
  }
  function Ne(m, S, P) {
    m.flags |= 16384, m = { getSnapshot: S, value: P }, S = Sn.updateQueue, S === null ? (S = { lastEffect: null, stores: null }, Sn.updateQueue = S, S.stores = [m]) : (P = S.stores, P === null ? S.stores = [m] : P.push(m));
  }
  function Fe(m, S, P, G) {
    S.value = P, S.getSnapshot = G, Je(S) && pt(m);
  }
  function ut(m, S, P) {
    return P(function() {
      Je(S) && pt(m);
    });
  }
  function Je(m) {
    var S = m.getSnapshot;
    m = m.value;
    try {
      var P = S();
      return !Fa(m, P);
    } catch {
      return !0;
    }
  }
  function pt(m) {
    var S = Ns(m, 1);
    S !== null && Di(S, m, 1, -1);
  }
  function Nt(m) {
    var S = O();
    return typeof m == "function" && (m = m()), S.memoizedState = S.baseState = m, m = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: R, lastRenderedState: m }, S.queue = m, m = m.dispatch = la.bind(null, Sn, m), [S.memoizedState, m];
  }
  function Bt(m, S, P, G) {
    return m = { tag: m, create: S, destroy: P, deps: G, next: null }, S = Sn.updateQueue, S === null ? (S = { lastEffect: null, stores: null }, Sn.updateQueue = S, S.lastEffect = m.next = m) : (P = S.lastEffect, P === null ? S.lastEffect = m.next = m : (G = P.next, P.next = m, m.next = G, S.lastEffect = m)), m;
  }
  function Qt() {
    return w().memoizedState;
  }
  function Cn(m, S, P, G) {
    var se = O();
    Sn.flags |= m, se.memoizedState = Bt(1 | S, P, void 0, G === void 0 ? null : G);
  }
  function mn(m, S, P, G) {
    var se = w();
    G = G === void 0 ? null : G;
    var fe = void 0;
    if (Un !== null) {
      var Oe = Un.memoizedState;
      if (fe = Oe.destroy, G !== null && Fd(G, Oe.deps)) {
        se.memoizedState = Bt(S, P, fe, G);
        return;
      }
    }
    Sn.flags |= m, se.memoizedState = Bt(1 | S, P, fe, G);
  }
  function kn(m, S) {
    return Cn(8390656, 8, m, S);
  }
  function Zn(m, S) {
    return mn(2048, 8, m, S);
  }
  function Dr(m, S) {
    return mn(4, 2, m, S);
  }
  function Kr(m, S) {
    return mn(4, 4, m, S);
  }
  function Nn(m, S) {
    if (typeof S == "function") return m = m(), S(m), function() {
      S(null);
    };
    if (S != null) return m = m(), S.current = m, function() {
      S.current = null;
    };
  }
  function Oi(m, S, P) {
    return P = P != null ? P.concat([m]) : null, mn(4, 4, Nn.bind(null, S, m), P);
  }
  function cr() {
  }
  function zr(m, S) {
    var P = w();
    S = S === void 0 ? null : S;
    var G = P.memoizedState;
    return G !== null && S !== null && Fd(S, G[1]) ? G[0] : (P.memoizedState = [m, S], m);
  }
  function To(m, S) {
    var P = w();
    S = S === void 0 ? null : S;
    var G = P.memoizedState;
    return G !== null && S !== null && Fd(S, G[1]) ? G[0] : (m = m(), P.memoizedState = [m, S], m);
  }
  function tr(m, S, P) {
    return vn & 21 ? (Fa(P, S) || (P = ns(), Sn.lanes |= P, qd |= P, m.baseState = !0), S) : (m.baseState && (m.baseState = !1, qa = !0), m.memoizedState = P);
  }
  function Pn(m, S) {
    var P = Er;
    Er = P !== 0 && 4 > P ? P : 4, m(!0);
    var G = ct.transition;
    ct.transition = {};
    try {
      m(!1), S();
    } finally {
      Er = P, ct.transition = G;
    }
  }
  function kr() {
    return w().memoizedState;
  }
  function Ca(m, S, P) {
    var G = Mu(m);
    if (P = { lane: G, action: P, hasEagerState: !1, eagerState: null, next: null }, no(m)) ro(S, P);
    else if (P = _p(m, S, P, G), P !== null) {
      var se = Oo();
      Di(P, m, G, se), jr(P, S, G);
    }
  }
  function la(m, S, P) {
    var G = Mu(m), se = { lane: G, action: P, hasEagerState: !1, eagerState: null, next: null };
    if (no(m)) ro(S, se);
    else {
      var fe = m.alternate;
      if (m.lanes === 0 && (fe === null || fe.lanes === 0) && (fe = S.lastRenderedReducer, fe !== null)) try {
        var Oe = S.lastRenderedState, $e = fe(Oe, P);
        if (se.hasEagerState = !0, se.eagerState = $e, Fa($e, Oe)) {
          var rt = S.interleaved;
          rt === null ? (se.next = se, mi(S)) : (se.next = rt.next, rt.next = se), S.interleaved = se;
          return;
        }
      } catch {
      } finally {
      }
      P = _p(m, S, se, G), P !== null && (se = Oo(), Di(P, m, G, se), jr(P, S, G));
    }
  }
  function no(m) {
    var S = m.alternate;
    return m === Sn || S !== null && S === Sn;
  }
  function ro(m, S) {
    jc = Sa = !0;
    var P = m.pending;
    P === null ? S.next = S : (S.next = P.next, P.next = S), m.pending = S;
  }
  function jr(m, S, P) {
    if (P & 4194240) {
      var G = S.lanes;
      G &= m.pendingLanes, P |= G, S.lanes = P, Al(m, P);
    }
  }
  var gi = { readContext: Va, useCallback: xo, useContext: xo, useEffect: xo, useImperativeHandle: xo, useInsertionEffect: xo, useLayoutEffect: xo, useMemo: xo, useReducer: xo, useRef: xo, useState: xo, useDebugValue: xo, useDeferredValue: xo, useTransition: xo, useMutableSource: xo, useSyncExternalStore: xo, useId: xo, unstable_isNewReconciler: !1 }, Wi = { readContext: Va, useCallback: function(m, S) {
    return O().memoizedState = [m, S === void 0 ? null : S], m;
  }, useContext: Va, useEffect: kn, useImperativeHandle: function(m, S, P) {
    return P = P != null ? P.concat([m]) : null, Cn(
      4194308,
      4,
      Nn.bind(null, S, m),
      P
    );
  }, useLayoutEffect: function(m, S) {
    return Cn(4194308, 4, m, S);
  }, useInsertionEffect: function(m, S) {
    return Cn(4, 2, m, S);
  }, useMemo: function(m, S) {
    var P = O();
    return S = S === void 0 ? null : S, m = m(), P.memoizedState = [m, S], m;
  }, useReducer: function(m, S, P) {
    var G = O();
    return S = P !== void 0 ? P(S) : S, G.memoizedState = G.baseState = S, m = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: m, lastRenderedState: S }, G.queue = m, m = m.dispatch = Ca.bind(null, Sn, m), [G.memoizedState, m];
  }, useRef: function(m) {
    var S = O();
    return m = { current: m }, S.memoizedState = m;
  }, useState: Nt, useDebugValue: cr, useDeferredValue: function(m) {
    return O().memoizedState = m;
  }, useTransition: function() {
    var m = Nt(!1), S = m[0];
    return m = Pn.bind(null, m[1]), O().memoizedState = m, [S, m];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(m, S, P) {
    var G = Sn, se = O();
    if (Pr) {
      if (P === void 0) throw Error(t(407));
      P = P();
    } else {
      if (P = S(), Ui === null) throw Error(t(349));
      vn & 30 || Ne(G, S, P);
    }
    se.memoizedState = P;
    var fe = { value: P, getSnapshot: S };
    return se.queue = fe, kn(ut.bind(
      null,
      G,
      fe,
      m
    ), [m]), G.flags |= 2048, Bt(9, Fe.bind(null, G, fe, P, S), void 0, null), P;
  }, useId: function() {
    var m = O(), S = Ui.identifierPrefix;
    if (Pr) {
      var P = Ds, G = to;
      P = (G & ~(1 << 32 - Mo(G) - 1)).toString(32) + P, S = ":" + S + "R" + P, P = Bc++, 0 < P && (S += "H" + P.toString(32)), S += ":";
    } else P = A0++, S = ":" + S + "r" + P.toString(32) + ":";
    return m.memoizedState = S;
  }, unstable_isNewReconciler: !1 }, Gr = {
    readContext: Va,
    useCallback: zr,
    useContext: Va,
    useEffect: Zn,
    useImperativeHandle: Oi,
    useInsertionEffect: Dr,
    useLayoutEffect: Kr,
    useMemo: To,
    useReducer: W,
    useRef: Qt,
    useState: function() {
      return W(R);
    },
    useDebugValue: cr,
    useDeferredValue: function(m) {
      var S = w();
      return tr(S, Un.memoizedState, m);
    },
    useTransition: function() {
      var m = W(R)[0], S = w().memoizedState;
      return [m, S];
    },
    useMutableSource: me,
    useSyncExternalStore: Ae,
    useId: kr,
    unstable_isNewReconciler: !1
  }, Ud = { readContext: Va, useCallback: zr, useContext: Va, useEffect: Zn, useImperativeHandle: Oi, useInsertionEffect: Dr, useLayoutEffect: Kr, useMemo: To, useReducer: ue, useRef: Qt, useState: function() {
    return ue(R);
  }, useDebugValue: cr, useDeferredValue: function(m) {
    var S = w();
    return Un === null ? S.memoizedState = m : tr(S, Un.memoizedState, m);
  }, useTransition: function() {
    var m = ue(R)[0], S = w().memoizedState;
    return [m, S];
  }, useMutableSource: me, useSyncExternalStore: Ae, useId: kr, unstable_isNewReconciler: !1 };
  function Vo(m, S) {
    if (m && m.defaultProps) {
      S = K({}, S), m = m.defaultProps;
      for (var P in m) S[P] === void 0 && (S[P] = m[P]);
      return S;
    }
    return S;
  }
  function gl(m, S, P, G) {
    S = m.memoizedState, P = P(G, S), P = P == null ? S : K({}, S, P), m.memoizedState = P, m.lanes === 0 && (m.updateQueue.baseState = P);
  }
  var _l = { isMounted: function(m) {
    return (m = m._reactInternals) ? qr(m) === m : !1;
  }, enqueueSetState: function(m, S, P) {
    m = m._reactInternals;
    var G = Oo(), se = Mu(m), fe = wo(G, se);
    fe.payload = S, P != null && (fe.callback = P), S = Vl(m, fe, se), S !== null && (Di(S, m, se, G), Kf(S, m, se));
  }, enqueueReplaceState: function(m, S, P) {
    m = m._reactInternals;
    var G = Oo(), se = Mu(m), fe = wo(G, se);
    fe.tag = 1, fe.payload = S, P != null && (fe.callback = P), S = Vl(m, fe, se), S !== null && (Di(S, m, se, G), Kf(S, m, se));
  }, enqueueForceUpdate: function(m, S) {
    m = m._reactInternals;
    var P = Oo(), G = Mu(m), se = wo(P, G);
    se.tag = 2, S != null && (se.callback = S), S = Vl(m, se, G), S !== null && (Di(S, m, G, P), Kf(S, m, G));
  } };
  function Zf(m, S, P, G, se, fe, Oe) {
    return m = m.stateNode, typeof m.shouldComponentUpdate == "function" ? m.shouldComponentUpdate(G, fe, Oe) : S.prototype && S.prototype.isPureReactComponent ? !wd(P, G) || !wd(se, fe) : !0;
  }
  function yp(m, S, P) {
    var G = !1, se = Xe, fe = S.contextType;
    return typeof fe == "object" && fe !== null ? fe = Va(fe) : (se = ii(S) ? oa : Gn.current, G = S.contextTypes, fe = (G = G != null) ? Ha(m, se) : Xe), S = new S(P, fe), m.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, S.updater = _l, m.stateNode = S, S._reactInternals = m, G && (m = m.stateNode, m.__reactInternalMemoizedUnmaskedChildContext = se, m.__reactInternalMemoizedMaskedChildContext = fe), S;
  }
  function Vm(m, S, P, G) {
    m = S.state, typeof S.componentWillReceiveProps == "function" && S.componentWillReceiveProps(P, G), typeof S.UNSAFE_componentWillReceiveProps == "function" && S.UNSAFE_componentWillReceiveProps(P, G), S.state !== m && _l.enqueueReplaceState(S, S.state, null);
  }
  function k0(m, S, P, G) {
    var se = m.stateNode;
    se.props = P, se.state = m.memoizedState, se.refs = {}, jd(m);
    var fe = S.contextType;
    typeof fe == "object" && fe !== null ? se.context = Va(fe) : (fe = ii(S) ? oa : Gn.current, se.context = Ha(m, fe)), se.state = m.memoizedState, fe = S.getDerivedStateFromProps, typeof fe == "function" && (gl(m, S, fe, P), se.state = m.memoizedState), typeof S.getDerivedStateFromProps == "function" || typeof se.getSnapshotBeforeUpdate == "function" || typeof se.UNSAFE_componentWillMount != "function" && typeof se.componentWillMount != "function" || (S = se.state, typeof se.componentWillMount == "function" && se.componentWillMount(), typeof se.UNSAFE_componentWillMount == "function" && se.UNSAFE_componentWillMount(), S !== se.state && _l.enqueueReplaceState(se, se.state, null), Lt(m, P, se, G), se.state = m.memoizedState), typeof se.componentDidMount == "function" && (m.flags |= 4194308);
  }
  function Fc(m, S) {
    try {
      var P = "", G = S;
      do
        P += ee(G), G = G.return;
      while (G);
      var se = P;
    } catch (fe) {
      se = `
Error generating stack: ` + fe.message + `
` + fe.stack;
    }
    return { value: m, source: S, stack: se, digest: null };
  }
  function O0(m, S, P) {
    return { value: m, source: null, stack: P ?? null, digest: S ?? null };
  }
  function vp(m, S) {
    try {
      console.error(S.value);
    } catch (P) {
      setTimeout(function() {
        throw P;
      });
    }
  }
  var Y1 = typeof WeakMap == "function" ? WeakMap : Map;
  function X1(m, S, P) {
    P = wo(-1, P), P.tag = 3, P.payload = { element: null };
    var G = S.value;
    return P.callback = function() {
      tg || (tg = !0, B0 = G), vp(m, S);
    }, P;
  }
  function K1(m, S, P) {
    P = wo(-1, P), P.tag = 3;
    var G = m.type.getDerivedStateFromError;
    if (typeof G == "function") {
      var se = S.value;
      P.payload = function() {
        return G(se);
      }, P.callback = function() {
        vp(m, S);
      };
    }
    var fe = m.stateNode;
    return fe !== null && typeof fe.componentDidCatch == "function" && (P.callback = function() {
      vp(m, S), typeof G != "function" && (js === null ? js = /* @__PURE__ */ new Set([this]) : js.add(this));
      var Oe = S.stack;
      this.componentDidCatch(S.value, { componentStack: Oe !== null ? Oe : "" });
    }), P;
  }
  function bp(m, S, P) {
    var G = m.pingCache;
    if (G === null) {
      G = m.pingCache = new Y1();
      var se = /* @__PURE__ */ new Set();
      G.set(S, se);
    } else se = G.get(S), se === void 0 && (se = /* @__PURE__ */ new Set(), G.set(S, se));
    se.has(P) || (se.add(P), m = lE.bind(null, m, S, P), S.then(m, m));
  }
  function Q1(m) {
    do {
      var S;
      if ((S = m.tag === 13) && (S = m.memoizedState, S = S !== null ? S.dehydrated !== null : !0), S) return m;
      m = m.return;
    } while (m !== null);
    return null;
  }
  function D0(m, S, P, G, se) {
    return m.mode & 1 ? (m.flags |= 65536, m.lanes = se, m) : (m === S ? m.flags |= 65536 : (m.flags |= 128, P.flags |= 131072, P.flags &= -52805, P.tag === 1 && (P.alternate === null ? P.tag = 17 : (S = wo(-1, 1), S.tag = 2, Vl(P, S, 1))), P.lanes |= 1), m);
  }
  var Z1 = T.ReactCurrentOwner, qa = !1;
  function $i(m, S, P, G) {
    S.child = m === null ? Pd(S, null, P, G) : pl(S, m.child, P, G);
  }
  function Jf(m, S, P, G, se) {
    P = P.render;
    var fe = S.ref;
    return Lc(S, se), G = jt(m, S, P, G, fe, se), P = M(), m !== null && !qa ? (S.updateQueue = m.updateQueue, S.flags &= -2053, m.lanes &= ~se, Yi(m, S, se)) : (Pr && P && Ru(S), S.flags |= 1, $i(m, S, G, se), S.child);
  }
  function Uc(m, S, P, G, se) {
    if (m === null) {
      var fe = P.type;
      return typeof fe == "function" && !V0(fe) && fe.defaultProps === void 0 && P.compare === null && P.defaultProps === void 0 ? (S.tag = 15, S.type = fe, qm(m, S, fe, G, se)) : (m = sg(P.type, null, G, S, S.mode, se), m.ref = S.ref, m.return = S, S.child = m);
    }
    if (fe = m.child, !(m.lanes & se)) {
      var Oe = fe.memoizedProps;
      if (P = P.compare, P = P !== null ? P : wd, P(Oe, G) && m.ref === S.ref) return Yi(m, S, se);
    }
    return S.flags |= 1, m = Vc(fe, G), m.ref = S.ref, m.return = S, S.child = m;
  }
  function qm(m, S, P, G, se) {
    if (m !== null) {
      var fe = m.memoizedProps;
      if (wd(fe, G) && m.ref === S.ref) if (qa = !1, S.pendingProps = G = fe, (m.lanes & se) !== 0) m.flags & 131072 && (qa = !0);
      else return S.lanes = m.lanes, Yi(m, S, se);
    }
    return or(m, S, P, G, se);
  }
  function Ga(m, S, P) {
    var G = S.pendingProps, se = G.children, fe = m !== null ? m.memoizedState : null;
    if (G.mode === "hidden") if (!(S.mode & 1)) S.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Ar(uh, Wa), Wa |= P;
    else {
      if (!(P & 1073741824)) return m = fe !== null ? fe.baseLanes | P : P, S.lanes = S.childLanes = 1073741824, S.memoizedState = { baseLanes: m, cachePool: null, transitions: null }, S.updateQueue = null, Ar(uh, Wa), Wa |= m, null;
      S.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G = fe !== null ? fe.baseLanes : P, Ar(uh, Wa), Wa |= G;
    }
    else fe !== null ? (G = fe.baseLanes | P, S.memoizedState = null) : G = P, Ar(uh, Wa), Wa |= G;
    return $i(m, S, se, P), S.child;
  }
  function Hd(m, S) {
    var P = S.ref;
    (m === null && P !== null || m !== null && m.ref !== P) && (S.flags |= 512, S.flags |= 2097152);
  }
  function or(m, S, P, G, se) {
    var fe = ii(P) ? oa : Gn.current;
    return fe = Ha(S, fe), Lc(S, se), P = jt(m, S, P, G, fe, se), G = M(), m !== null && !qa ? (S.updateQueue = m.updateQueue, S.flags &= -2053, m.lanes &= ~se, Yi(m, S, se)) : (Pr && G && Ru(S), S.flags |= 1, $i(m, S, P, se), S.child);
  }
  function Ep(m, S, P, G, se) {
    if (ii(P)) {
      var fe = !0;
      Nc(S);
    } else fe = !1;
    if (Lc(S, se), S.stateNode === null) Cp(m, S), yp(S, P, G), k0(S, P, G, se), G = !0;
    else if (m === null) {
      var Oe = S.stateNode, $e = S.memoizedProps;
      Oe.props = $e;
      var rt = Oe.context, Ct = P.contextType;
      typeof Ct == "object" && Ct !== null ? Ct = Va(Ct) : (Ct = ii(P) ? oa : Gn.current, Ct = Ha(S, Ct));
      var Ht = P.getDerivedStateFromProps, qt = typeof Ht == "function" || typeof Oe.getSnapshotBeforeUpdate == "function";
      qt || typeof Oe.UNSAFE_componentWillReceiveProps != "function" && typeof Oe.componentWillReceiveProps != "function" || ($e !== G || rt !== Ct) && Vm(S, Oe, G, Ct), ml = !1;
      var Ut = S.memoizedState;
      Oe.state = Ut, Lt(S, G, Oe, se), rt = S.memoizedState, $e !== G || Ut !== rt || bi.current || ml ? (typeof Ht == "function" && (gl(S, P, Ht, G), rt = S.memoizedState), ($e = ml || Zf(S, P, $e, G, Ut, rt, Ct)) ? (qt || typeof Oe.UNSAFE_componentWillMount != "function" && typeof Oe.componentWillMount != "function" || (typeof Oe.componentWillMount == "function" && Oe.componentWillMount(), typeof Oe.UNSAFE_componentWillMount == "function" && Oe.UNSAFE_componentWillMount()), typeof Oe.componentDidMount == "function" && (S.flags |= 4194308)) : (typeof Oe.componentDidMount == "function" && (S.flags |= 4194308), S.memoizedProps = G, S.memoizedState = rt), Oe.props = G, Oe.state = rt, Oe.context = Ct, G = $e) : (typeof Oe.componentDidMount == "function" && (S.flags |= 4194308), G = !1);
    } else {
      Oe = S.stateNode, us(m, S), $e = S.memoizedProps, Ct = S.type === S.elementType ? $e : Vo(S.type, $e), Oe.props = Ct, qt = S.pendingProps, Ut = Oe.context, rt = P.contextType, typeof rt == "object" && rt !== null ? rt = Va(rt) : (rt = ii(P) ? oa : Gn.current, rt = Ha(S, rt));
      var rn = P.getDerivedStateFromProps;
      (Ht = typeof rn == "function" || typeof Oe.getSnapshotBeforeUpdate == "function") || typeof Oe.UNSAFE_componentWillReceiveProps != "function" && typeof Oe.componentWillReceiveProps != "function" || ($e !== qt || Ut !== rt) && Vm(S, Oe, G, rt), ml = !1, Ut = S.memoizedState, Oe.state = Ut, Lt(S, G, Oe, se);
      var gn = S.memoizedState;
      $e !== qt || Ut !== gn || bi.current || ml ? (typeof rn == "function" && (gl(S, P, rn, G), gn = S.memoizedState), (Ct = ml || Zf(S, P, Ct, G, Ut, gn, rt) || !1) ? (Ht || typeof Oe.UNSAFE_componentWillUpdate != "function" && typeof Oe.componentWillUpdate != "function" || (typeof Oe.componentWillUpdate == "function" && Oe.componentWillUpdate(G, gn, rt), typeof Oe.UNSAFE_componentWillUpdate == "function" && Oe.UNSAFE_componentWillUpdate(G, gn, rt)), typeof Oe.componentDidUpdate == "function" && (S.flags |= 4), typeof Oe.getSnapshotBeforeUpdate == "function" && (S.flags |= 1024)) : (typeof Oe.componentDidUpdate != "function" || $e === m.memoizedProps && Ut === m.memoizedState || (S.flags |= 4), typeof Oe.getSnapshotBeforeUpdate != "function" || $e === m.memoizedProps && Ut === m.memoizedState || (S.flags |= 1024), S.memoizedProps = G, S.memoizedState = gn), Oe.props = G, Oe.state = gn, Oe.context = rt, G = Ct) : (typeof Oe.componentDidUpdate != "function" || $e === m.memoizedProps && Ut === m.memoizedState || (S.flags |= 4), typeof Oe.getSnapshotBeforeUpdate != "function" || $e === m.memoizedProps && Ut === m.memoizedState || (S.flags |= 1024), G = !1);
    }
    return Gm(m, S, P, G, fe, se);
  }
  function Gm(m, S, P, G, se, fe) {
    Hd(m, S);
    var Oe = (S.flags & 128) !== 0;
    if (!G && !Oe) return se && Vf(S, P, !1), Yi(m, S, fe);
    G = S.stateNode, Z1.current = S;
    var $e = Oe && typeof P.getDerivedStateFromError != "function" ? null : G.render();
    return S.flags |= 1, m !== null && Oe ? (S.child = pl(S, m.child, null, fe), S.child = pl(S, null, $e, fe)) : $i(m, S, $e, fe), S.memoizedState = G.state, se && Vf(S, P, !0), S.child;
  }
  function J2(m) {
    var S = m.stateNode;
    S.pendingContext ? dl(m, S.pendingContext, S.pendingContext !== S.context) : S.context && dl(m, S.context, !1), Qf(m, S.containerInfo);
  }
  function J1(m, S, P, G, se) {
    return oi(), Ic(se), S.flags |= 256, $i(m, S, P, G), S.child;
  }
  var Sp = { dehydrated: null, treeContext: null, retryLane: 0 };
  function zd(m) {
    return { baseLanes: m, cachePool: null, transitions: null };
  }
  function ey(m, S, P) {
    var G = S.pendingProps, se = ci.current, fe = !1, Oe = (S.flags & 128) !== 0, $e;
    if (($e = Oe) || ($e = m !== null && m.memoizedState === null ? !1 : (se & 2) !== 0), $e ? (fe = !0, S.flags &= -129) : (m === null || m.memoizedState !== null) && (se |= 1), Ar(ci, se & 1), m === null)
      return Nd(S), m = S.memoizedState, m !== null && (m = m.dehydrated, m !== null) ? (S.mode & 1 ? m.data === "$!" ? S.lanes = 8 : S.lanes = 1073741824 : S.lanes = 1, null) : (Oe = G.children, m = G.fallback, fe ? (G = S.mode, fe = S.child, Oe = { mode: "hidden", children: Oe }, !(G & 1) && fe !== null ? (fe.childLanes = 0, fe.pendingProps = Oe) : fe = lg(Oe, G, 0, null), m = Yd(m, G, P, null), fe.return = S, m.return = S, fe.sibling = m, S.child = fe, S.child.memoizedState = zd(P), S.memoizedState = Sp, m) : Wm(S, Oe));
    if (se = m.memoizedState, se !== null && ($e = se.dehydrated, $e !== null)) return R0(m, S, Oe, G, $e, se, P);
    if (fe) {
      fe = G.fallback, Oe = S.mode, se = m.child, $e = se.sibling;
      var rt = { mode: "hidden", children: G.children };
      return !(Oe & 1) && S.child !== se ? (G = S.child, G.childLanes = 0, G.pendingProps = rt, S.deletions = null) : (G = Vc(se, rt), G.subtreeFlags = se.subtreeFlags & 14680064), $e !== null ? fe = Vc($e, fe) : (fe = Yd(fe, Oe, P, null), fe.flags |= 2), fe.return = S, G.return = S, G.sibling = fe, S.child = G, G = fe, fe = S.child, Oe = m.child.memoizedState, Oe = Oe === null ? zd(P) : { baseLanes: Oe.baseLanes | P, cachePool: null, transitions: Oe.transitions }, fe.memoizedState = Oe, fe.childLanes = m.childLanes & ~P, S.memoizedState = Sp, G;
    }
    return fe = m.child, m = fe.sibling, G = Vc(fe, { mode: "visible", children: G.children }), !(S.mode & 1) && (G.lanes = P), G.return = S, G.sibling = null, m !== null && (P = S.deletions, P === null ? (S.deletions = [m], S.flags |= 16) : P.push(m)), S.child = G, S.memoizedState = null, G;
  }
  function Wm(m, S) {
    return S = lg({ mode: "visible", children: S }, m.mode, 0, null), S.return = m, m.child = S;
  }
  function $m(m, S, P, G) {
    return G !== null && Ic(G), pl(S, m.child, null, P), m = Wm(S, S.pendingProps.children), m.flags |= 2, S.memoizedState = null, m;
  }
  function R0(m, S, P, G, se, fe, Oe) {
    if (P)
      return S.flags & 256 ? (S.flags &= -257, G = O0(Error(t(422))), $m(m, S, Oe, G)) : S.memoizedState !== null ? (S.child = m.child, S.flags |= 128, null) : (fe = G.fallback, se = S.mode, G = lg({ mode: "visible", children: G.children }, se, 0, null), fe = Yd(fe, se, Oe, null), fe.flags |= 2, G.return = S, fe.return = S, G.sibling = fe, S.child = G, S.mode & 1 && pl(S, m.child, null, Oe), S.child.memoizedState = zd(Oe), S.memoizedState = Sp, fe);
    if (!(S.mode & 1)) return $m(m, S, Oe, null);
    if (se.data === "$!") {
      if (G = se.nextSibling && se.nextSibling.dataset, G) var $e = G.dgst;
      return G = $e, fe = Error(t(419)), G = O0(fe, G, void 0), $m(m, S, Oe, G);
    }
    if ($e = (Oe & m.childLanes) !== 0, qa || $e) {
      if (G = Ui, G !== null) {
        switch (Oe & -Oe) {
          case 4:
            se = 2;
            break;
          case 16:
            se = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            se = 32;
            break;
          case 536870912:
            se = 268435456;
            break;
          default:
            se = 0;
        }
        se = se & (G.suspendedLanes | Oe) ? 0 : se, se !== 0 && se !== fe.retryLane && (fe.retryLane = se, Ns(m, se), Di(G, m, se, -1));
      }
      return kp(), G = O0(Error(t(421))), $m(m, S, Oe, G);
    }
    return se.data === "$?" ? (S.flags |= 128, S.child = m.child, S = z0.bind(null, m), se._reactRetry = S, null) : (m = fe.treeContext, qi = as(se.nextSibling), zo = S, Pr = !0, Co = null, m !== null && (Ho[fo++] = to, Ho[fo++] = Ds, Ho[fo++] = va, to = m.id, Ds = m.overflow, va = S), S = Wm(S, G.children), S.flags |= 4096, S);
  }
  function ty(m, S, P) {
    m.lanes |= S;
    var G = m.alternate;
    G !== null && (G.lanes |= S), Xf(m.return, S, P);
  }
  function Ym(m, S, P, G, se) {
    var fe = m.memoizedState;
    fe === null ? m.memoizedState = { isBackwards: S, rendering: null, renderingStartTime: 0, last: G, tail: P, tailMode: se } : (fe.isBackwards = S, fe.rendering = null, fe.renderingStartTime = 0, fe.last = G, fe.tail = P, fe.tailMode = se);
  }
  function N0(m, S, P) {
    var G = S.pendingProps, se = G.revealOrder, fe = G.tail;
    if ($i(m, S, G.children, P), G = ci.current, G & 2) G = G & 1 | 2, S.flags |= 128;
    else {
      if (m !== null && m.flags & 128) e: for (m = S.child; m !== null; ) {
        if (m.tag === 13) m.memoizedState !== null && ty(m, P, S);
        else if (m.tag === 19) ty(m, P, S);
        else if (m.child !== null) {
          m.child.return = m, m = m.child;
          continue;
        }
        if (m === S) break e;
        for (; m.sibling === null; ) {
          if (m.return === null || m.return === S) break e;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      }
      G &= 1;
    }
    if (Ar(ci, G), !(S.mode & 1)) S.memoizedState = null;
    else switch (se) {
      case "forwards":
        for (P = S.child, se = null; P !== null; ) m = P.alternate, m !== null && Xr(m) === null && (se = P), P = P.sibling;
        P = se, P === null ? (se = S.child, S.child = null) : (se = P.sibling, P.sibling = null), Ym(S, !1, se, P, fe);
        break;
      case "backwards":
        for (P = null, se = S.child, S.child = null; se !== null; ) {
          if (m = se.alternate, m !== null && Xr(m) === null) {
            S.child = se;
            break;
          }
          m = se.sibling, se.sibling = P, P = se, se = m;
        }
        Ym(S, !0, P, null, fe);
        break;
      case "together":
        Ym(S, !1, null, null, void 0);
        break;
      default:
        S.memoizedState = null;
    }
    return S.child;
  }
  function Cp(m, S) {
    !(S.mode & 1) && m !== null && (m.alternate = null, S.alternate = null, S.flags |= 2);
  }
  function Yi(m, S, P) {
    if (m !== null && (S.dependencies = m.dependencies), qd |= S.lanes, !(P & S.childLanes)) return null;
    if (m !== null && S.child !== m.child) throw Error(t(153));
    if (S.child !== null) {
      for (m = S.child, P = Vc(m, m.pendingProps), S.child = P, P.return = S; m.sibling !== null; ) m = m.sibling, P = P.sibling = Vc(m, m.pendingProps), P.return = S;
      P.sibling = null;
    }
    return S.child;
  }
  function Iu(m, S, P) {
    switch (S.tag) {
      case 3:
        J2(S), oi();
        break;
      case 5:
        zm(S);
        break;
      case 1:
        ii(S.type) && Nc(S);
        break;
      case 4:
        Qf(S, S.stateNode.containerInfo);
        break;
      case 10:
        var G = S.type._context, se = S.memoizedProps.value;
        Ar(Rs, G._currentValue), G._currentValue = se;
        break;
      case 13:
        if (G = S.memoizedState, G !== null)
          return G.dehydrated !== null ? (Ar(ci, ci.current & 1), S.flags |= 128, null) : P & S.child.childLanes ? ey(m, S, P) : (Ar(ci, ci.current & 1), m = Yi(m, S, P), m !== null ? m.sibling : null);
        Ar(ci, ci.current & 1);
        break;
      case 19:
        if (G = (P & S.childLanes) !== 0, m.flags & 128) {
          if (G) return N0(m, S, P);
          S.flags |= 128;
        }
        if (se = S.memoizedState, se !== null && (se.rendering = null, se.tail = null, se.lastEffect = null), Ar(ci, ci.current), G) break;
        return null;
      case 22:
      case 23:
        return S.lanes = 0, Ga(m, S, P);
    }
    return Yi(m, S, P);
  }
  var ql, eh, th, Ms;
  ql = function(m, S) {
    for (var P = S.child; P !== null; ) {
      if (P.tag === 5 || P.tag === 6) m.appendChild(P.stateNode);
      else if (P.tag !== 4 && P.child !== null) {
        P.child.return = P, P = P.child;
        continue;
      }
      if (P === S) break;
      for (; P.sibling === null; ) {
        if (P.return === null || P.return === S) return;
        P = P.return;
      }
      P.sibling.return = P.return, P = P.sibling;
    }
  }, eh = function() {
  }, th = function(m, S, P, G) {
    var se = m.memoizedProps;
    if (se !== G) {
      m = S.stateNode, Ls(sa.current);
      var fe = null;
      switch (P) {
        case "input":
          se = ze(m, se), G = ze(m, G), fe = [];
          break;
        case "select":
          se = K({}, se, { value: void 0 }), G = K({}, G, { value: void 0 }), fe = [];
          break;
        case "textarea":
          se = ke(m, se), G = ke(m, G), fe = [];
          break;
        default:
          typeof se.onClick != "function" && typeof G.onClick == "function" && (m.onclick = Hf);
      }
      Jt(P, G);
      var Oe;
      P = null;
      for (Ct in se) if (!G.hasOwnProperty(Ct) && se.hasOwnProperty(Ct) && se[Ct] != null) if (Ct === "style") {
        var $e = se[Ct];
        for (Oe in $e) $e.hasOwnProperty(Oe) && (P || (P = {}), P[Oe] = "");
      } else Ct !== "dangerouslySetInnerHTML" && Ct !== "children" && Ct !== "suppressContentEditableWarning" && Ct !== "suppressHydrationWarning" && Ct !== "autoFocus" && (c.hasOwnProperty(Ct) ? fe || (fe = []) : (fe = fe || []).push(Ct, null));
      for (Ct in G) {
        var rt = G[Ct];
        if ($e = se != null ? se[Ct] : void 0, G.hasOwnProperty(Ct) && rt !== $e && (rt != null || $e != null)) if (Ct === "style") if ($e) {
          for (Oe in $e) !$e.hasOwnProperty(Oe) || rt && rt.hasOwnProperty(Oe) || (P || (P = {}), P[Oe] = "");
          for (Oe in rt) rt.hasOwnProperty(Oe) && $e[Oe] !== rt[Oe] && (P || (P = {}), P[Oe] = rt[Oe]);
        } else P || (fe || (fe = []), fe.push(
          Ct,
          P
        )), P = rt;
        else Ct === "dangerouslySetInnerHTML" ? (rt = rt ? rt.__html : void 0, $e = $e ? $e.__html : void 0, rt != null && $e !== rt && (fe = fe || []).push(Ct, rt)) : Ct === "children" ? typeof rt != "string" && typeof rt != "number" || (fe = fe || []).push(Ct, "" + rt) : Ct !== "suppressContentEditableWarning" && Ct !== "suppressHydrationWarning" && (c.hasOwnProperty(Ct) ? (rt != null && Ct === "onScroll" && Mr("scroll", m), fe || $e === rt || (fe = [])) : (fe = fe || []).push(Ct, rt));
      }
      P && (fe = fe || []).push("style", P);
      var Ct = fe;
      (S.updateQueue = Ct) && (S.flags |= 4);
    }
  }, Ms = function(m, S, P, G) {
    P !== G && (S.flags |= 4);
  };
  function Fi(m, S) {
    if (!Pr) switch (m.tailMode) {
      case "hidden":
        S = m.tail;
        for (var P = null; S !== null; ) S.alternate !== null && (P = S), S = S.sibling;
        P === null ? m.tail = null : P.sibling = null;
        break;
      case "collapsed":
        P = m.tail;
        for (var G = null; P !== null; ) P.alternate !== null && (G = P), P = P.sibling;
        G === null ? S || m.tail === null ? m.tail = null : m.tail.sibling = null : G.sibling = null;
    }
  }
  function ua(m) {
    var S = m.alternate !== null && m.alternate.child === m.child, P = 0, G = 0;
    if (S) for (var se = m.child; se !== null; ) P |= se.lanes | se.childLanes, G |= se.subtreeFlags & 14680064, G |= se.flags & 14680064, se.return = m, se = se.sibling;
    else for (se = m.child; se !== null; ) P |= se.lanes | se.childLanes, G |= se.subtreeFlags, G |= se.flags, se.return = m, se = se.sibling;
    return m.subtreeFlags |= G, m.childLanes = P, S;
  }
  function eE(m, S, P) {
    var G = S.pendingProps;
    switch (Gf(S), S.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ua(S), null;
      case 1:
        return ii(S.type) && _a(), ua(S), null;
      case 3:
        return G = S.stateNode, Gi(), Tr(bi), Tr(Gn), Ve(), G.pendingContext && (G.context = G.pendingContext, G.pendingContext = null), (m === null || m.child === null) && (Nu(S) ? S.flags |= 4 : m === null || m.memoizedState.isDehydrated && !(S.flags & 256) || (S.flags |= 1024, Co !== null && (F0(Co), Co = null))), eh(m, S), ua(S), null;
      case 5:
        Pc(S);
        var se = Ls(Ea.current);
        if (P = S.type, m !== null && S.stateNode != null) th(m, S, P, G, se), m.ref !== S.ref && (S.flags |= 512, S.flags |= 2097152);
        else {
          if (!G) {
            if (S.stateNode === null) throw Error(t(166));
            return ua(S), null;
          }
          if (m = Ls(sa.current), Nu(S)) {
            G = S.stateNode, P = S.type;
            var fe = S.memoizedProps;
            switch (G[ks] = S, G[Au] = fe, m = (S.mode & 1) !== 0, P) {
              case "dialog":
                Mr("cancel", G), Mr("close", G);
                break;
              case "iframe":
              case "object":
              case "embed":
                Mr("load", G);
                break;
              case "video":
              case "audio":
                for (se = 0; se < Ac.length; se++) Mr(Ac[se], G);
                break;
              case "source":
                Mr("error", G);
                break;
              case "img":
              case "image":
              case "link":
                Mr(
                  "error",
                  G
                ), Mr("load", G);
                break;
              case "details":
                Mr("toggle", G);
                break;
              case "input":
                Ie(G, fe), Mr("invalid", G);
                break;
              case "select":
                G._wrapperState = { wasMultiple: !!fe.multiple }, Mr("invalid", G);
                break;
              case "textarea":
                pe(G, fe), Mr("invalid", G);
            }
            Jt(P, fe), se = null;
            for (var Oe in fe) if (fe.hasOwnProperty(Oe)) {
              var $e = fe[Oe];
              Oe === "children" ? typeof $e == "string" ? G.textContent !== $e && (fe.suppressHydrationWarning !== !0 && Rd(G.textContent, $e, m), se = ["children", $e]) : typeof $e == "number" && G.textContent !== "" + $e && (fe.suppressHydrationWarning !== !0 && Rd(
                G.textContent,
                $e,
                m
              ), se = ["children", "" + $e]) : c.hasOwnProperty(Oe) && $e != null && Oe === "onScroll" && Mr("scroll", G);
            }
            switch (P) {
              case "input":
                ve(G), Ge(G, fe, !0);
                break;
              case "textarea":
                ve(G), he(G);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof fe.onClick == "function" && (G.onclick = Hf);
            }
            G = se, S.updateQueue = G, G !== null && (S.flags |= 4);
          } else {
            Oe = se.nodeType === 9 ? se : se.ownerDocument, m === "http://www.w3.org/1999/xhtml" && (m = Te(P)), m === "http://www.w3.org/1999/xhtml" ? P === "script" ? (m = Oe.createElement("div"), m.innerHTML = "<script><\/script>", m = m.removeChild(m.firstChild)) : typeof G.is == "string" ? m = Oe.createElement(P, { is: G.is }) : (m = Oe.createElement(P), P === "select" && (Oe = m, G.multiple ? Oe.multiple = !0 : G.size && (Oe.size = G.size))) : m = Oe.createElementNS(m, P), m[ks] = S, m[Au] = G, ql(m, S, !1, !1), S.stateNode = m;
            e: {
              switch (Oe = zt(P, G), P) {
                case "dialog":
                  Mr("cancel", m), Mr("close", m), se = G;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Mr("load", m), se = G;
                  break;
                case "video":
                case "audio":
                  for (se = 0; se < Ac.length; se++) Mr(Ac[se], m);
                  se = G;
                  break;
                case "source":
                  Mr("error", m), se = G;
                  break;
                case "img":
                case "image":
                case "link":
                  Mr(
                    "error",
                    m
                  ), Mr("load", m), se = G;
                  break;
                case "details":
                  Mr("toggle", m), se = G;
                  break;
                case "input":
                  Ie(m, G), se = ze(m, G), Mr("invalid", m);
                  break;
                case "option":
                  se = G;
                  break;
                case "select":
                  m._wrapperState = { wasMultiple: !!G.multiple }, se = K({}, G, { value: void 0 }), Mr("invalid", m);
                  break;
                case "textarea":
                  pe(m, G), se = ke(m, G), Mr("invalid", m);
                  break;
                default:
                  se = G;
              }
              Jt(P, se), $e = se;
              for (fe in $e) if ($e.hasOwnProperty(fe)) {
                var rt = $e[fe];
                fe === "style" ? At(m, rt) : fe === "dangerouslySetInnerHTML" ? (rt = rt ? rt.__html : void 0, rt != null && et(m, rt)) : fe === "children" ? typeof rt == "string" ? (P !== "textarea" || rt !== "") && dt(m, rt) : typeof rt == "number" && dt(m, "" + rt) : fe !== "suppressContentEditableWarning" && fe !== "suppressHydrationWarning" && fe !== "autoFocus" && (c.hasOwnProperty(fe) ? rt != null && fe === "onScroll" && Mr("scroll", m) : rt != null && y(m, fe, rt, Oe));
              }
              switch (P) {
                case "input":
                  ve(m), Ge(m, G, !1);
                  break;
                case "textarea":
                  ve(m), he(m);
                  break;
                case "option":
                  G.value != null && m.setAttribute("value", "" + oe(G.value));
                  break;
                case "select":
                  m.multiple = !!G.multiple, fe = G.value, fe != null ? Qe(m, !!G.multiple, fe, !1) : G.defaultValue != null && Qe(
                    m,
                    !!G.multiple,
                    G.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof se.onClick == "function" && (m.onclick = Hf);
              }
              switch (P) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  G = !!G.autoFocus;
                  break e;
                case "img":
                  G = !0;
                  break e;
                default:
                  G = !1;
              }
            }
            G && (S.flags |= 4);
          }
          S.ref !== null && (S.flags |= 512, S.flags |= 2097152);
        }
        return ua(S), null;
      case 6:
        if (m && S.stateNode != null) Ms(m, S, m.memoizedProps, G);
        else {
          if (typeof G != "string" && S.stateNode === null) throw Error(t(166));
          if (P = Ls(Ea.current), Ls(sa.current), Nu(S)) {
            if (G = S.stateNode, P = S.memoizedProps, G[ks] = S, (fe = G.nodeValue !== P) && (m = zo, m !== null)) switch (m.tag) {
              case 3:
                Rd(G.nodeValue, P, (m.mode & 1) !== 0);
                break;
              case 5:
                m.memoizedProps.suppressHydrationWarning !== !0 && Rd(G.nodeValue, P, (m.mode & 1) !== 0);
            }
            fe && (S.flags |= 4);
          } else G = (P.nodeType === 9 ? P : P.ownerDocument).createTextNode(G), G[ks] = S, S.stateNode = G;
        }
        return ua(S), null;
      case 13:
        if (Tr(ci), G = S.memoizedState, m === null || m.memoizedState !== null && m.memoizedState.dehydrated !== null) {
          if (Pr && qi !== null && S.mode & 1 && !(S.flags & 128)) Id(), oi(), S.flags |= 98560, fe = !1;
          else if (fe = Nu(S), G !== null && G.dehydrated !== null) {
            if (m === null) {
              if (!fe) throw Error(t(318));
              if (fe = S.memoizedState, fe = fe !== null ? fe.dehydrated : null, !fe) throw Error(t(317));
              fe[ks] = S;
            } else oi(), !(S.flags & 128) && (S.memoizedState = null), S.flags |= 4;
            ua(S), fe = !1;
          } else Co !== null && (F0(Co), Co = null), fe = !0;
          if (!fe) return S.flags & 65536 ? S : null;
        }
        return S.flags & 128 ? (S.lanes = P, S) : (G = G !== null, G !== (m !== null && m.memoizedState !== null) && G && (S.child.flags |= 8192, S.mode & 1 && (m === null || ci.current & 1 ? po === 0 && (po = 3) : kp())), S.updateQueue !== null && (S.flags |= 4), ua(S), null);
      case 4:
        return Gi(), eh(m, S), m === null && xu(S.stateNode.containerInfo), ua(S), null;
      case 10:
        return Yf(S.type._context), ua(S), null;
      case 17:
        return ii(S.type) && _a(), ua(S), null;
      case 19:
        if (Tr(ci), fe = S.memoizedState, fe === null) return ua(S), null;
        if (G = (S.flags & 128) !== 0, Oe = fe.rendering, Oe === null) if (G) Fi(fe, !1);
        else {
          if (po !== 0 || m !== null && m.flags & 128) for (m = S.child; m !== null; ) {
            if (Oe = Xr(m), Oe !== null) {
              for (S.flags |= 128, Fi(fe, !1), G = Oe.updateQueue, G !== null && (S.updateQueue = G, S.flags |= 4), S.subtreeFlags = 0, G = P, P = S.child; P !== null; ) fe = P, m = G, fe.flags &= 14680066, Oe = fe.alternate, Oe === null ? (fe.childLanes = 0, fe.lanes = m, fe.child = null, fe.subtreeFlags = 0, fe.memoizedProps = null, fe.memoizedState = null, fe.updateQueue = null, fe.dependencies = null, fe.stateNode = null) : (fe.childLanes = Oe.childLanes, fe.lanes = Oe.lanes, fe.child = Oe.child, fe.subtreeFlags = 0, fe.deletions = null, fe.memoizedProps = Oe.memoizedProps, fe.memoizedState = Oe.memoizedState, fe.updateQueue = Oe.updateQueue, fe.type = Oe.type, m = Oe.dependencies, fe.dependencies = m === null ? null : { lanes: m.lanes, firstContext: m.firstContext }), P = P.sibling;
              return Ar(ci, ci.current & 1 | 2), S.child;
            }
            m = m.sibling;
          }
          fe.tail !== null && fr() > dh && (S.flags |= 128, G = !0, Fi(fe, !1), S.lanes = 4194304);
        }
        else {
          if (!G) if (m = Xr(Oe), m !== null) {
            if (S.flags |= 128, G = !0, P = m.updateQueue, P !== null && (S.updateQueue = P, S.flags |= 4), Fi(fe, !0), fe.tail === null && fe.tailMode === "hidden" && !Oe.alternate && !Pr) return ua(S), null;
          } else 2 * fr() - fe.renderingStartTime > dh && P !== 1073741824 && (S.flags |= 128, G = !0, Fi(fe, !1), S.lanes = 4194304);
          fe.isBackwards ? (Oe.sibling = S.child, S.child = Oe) : (P = fe.last, P !== null ? P.sibling = Oe : S.child = Oe, fe.last = Oe);
        }
        return fe.tail !== null ? (S = fe.tail, fe.rendering = S, fe.tail = S.sibling, fe.renderingStartTime = fr(), S.sibling = null, P = ci.current, Ar(ci, G ? P & 1 | 2 : P & 1), S) : (ua(S), null);
      case 22:
      case 23:
        return og(), G = S.memoizedState !== null, m !== null && m.memoizedState !== null !== G && (S.flags |= 8192), G && S.mode & 1 ? Wa & 1073741824 && (ua(S), S.subtreeFlags & 6 && (S.flags |= 8192)) : ua(S), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(t(156, S.tag));
  }
  function tE(m, S) {
    switch (Gf(S), S.tag) {
      case 1:
        return ii(S.type) && _a(), m = S.flags, m & 65536 ? (S.flags = m & -65537 | 128, S) : null;
      case 3:
        return Gi(), Tr(bi), Tr(Gn), Ve(), m = S.flags, m & 65536 && !(m & 128) ? (S.flags = m & -65537 | 128, S) : null;
      case 5:
        return Pc(S), null;
      case 13:
        if (Tr(ci), m = S.memoizedState, m !== null && m.dehydrated !== null) {
          if (S.alternate === null) throw Error(t(340));
          oi();
        }
        return m = S.flags, m & 65536 ? (S.flags = m & -65537 | 128, S) : null;
      case 19:
        return Tr(ci), null;
      case 4:
        return Gi(), null;
      case 10:
        return Yf(S.type._context), null;
      case 22:
      case 23:
        return og(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var nh = !1, qo = !1, Xm = typeof WeakSet == "function" ? WeakSet : Set, dn = null;
  function rh(m, S) {
    var P = m.ref;
    if (P !== null) if (typeof P == "function") try {
      P(null);
    } catch (G) {
      Hi(m, S, G);
    }
    else P.current = null;
  }
  function I0(m, S, P) {
    try {
      P();
    } catch (G) {
      Hi(m, S, G);
    }
  }
  var Km = !1;
  function nE(m, S) {
    if (kc = Ba, m = bo(), ht(m)) {
      if ("selectionStart" in m) var P = { start: m.selectionStart, end: m.selectionEnd };
      else e: {
        P = (P = m.ownerDocument) && P.defaultView || window;
        var G = P.getSelection && P.getSelection();
        if (G && G.rangeCount !== 0) {
          P = G.anchorNode;
          var se = G.anchorOffset, fe = G.focusNode;
          G = G.focusOffset;
          try {
            P.nodeType, fe.nodeType;
          } catch {
            P = null;
            break e;
          }
          var Oe = 0, $e = -1, rt = -1, Ct = 0, Ht = 0, qt = m, Ut = null;
          t: for (; ; ) {
            for (var rn; qt !== P || se !== 0 && qt.nodeType !== 3 || ($e = Oe + se), qt !== fe || G !== 0 && qt.nodeType !== 3 || (rt = Oe + G), qt.nodeType === 3 && (Oe += qt.nodeValue.length), (rn = qt.firstChild) !== null; )
              Ut = qt, qt = rn;
            for (; ; ) {
              if (qt === m) break t;
              if (Ut === P && ++Ct === se && ($e = Oe), Ut === fe && ++Ht === G && (rt = Oe), (rn = qt.nextSibling) !== null) break;
              qt = Ut, Ut = qt.parentNode;
            }
            qt = rn;
          }
          P = $e === -1 || rt === -1 ? null : { start: $e, end: rt };
        } else P = null;
      }
      P = P || { start: 0, end: 0 };
    } else P = null;
    for (Pl = { focusedElem: m, selectionRange: P }, Ba = !1, dn = S; dn !== null; ) if (S = dn, m = S.child, (S.subtreeFlags & 1028) !== 0 && m !== null) m.return = S, dn = m;
    else for (; dn !== null; ) {
      S = dn;
      try {
        var gn = S.alternate;
        if (S.flags & 1024) switch (S.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (gn !== null) {
              var bn = gn.memoizedProps, Xi = gn.memoizedState, mt = S.stateNode, at = mt.getSnapshotBeforeUpdate(S.elementType === S.type ? bn : Vo(S.type, bn), Xi);
              mt.__reactInternalSnapshotBeforeUpdate = at;
            }
            break;
          case 3:
            var vt = S.stateNode.containerInfo;
            vt.nodeType === 1 ? vt.textContent = "" : vt.nodeType === 9 && vt.documentElement && vt.removeChild(vt.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(t(163));
        }
      } catch ($t) {
        Hi(S, S.return, $t);
      }
      if (m = S.sibling, m !== null) {
        m.return = S.return, dn = m;
        break;
      }
      dn = S.return;
    }
    return gn = Km, Km = !1, gn;
  }
  function ih(m, S, P) {
    var G = S.updateQueue;
    if (G = G !== null ? G.lastEffect : null, G !== null) {
      var se = G = G.next;
      do {
        if ((se.tag & m) === m) {
          var fe = se.destroy;
          se.destroy = void 0, fe !== void 0 && I0(S, P, fe);
        }
        se = se.next;
      } while (se !== G);
    }
  }
  function Qm(m, S) {
    if (S = S.updateQueue, S = S !== null ? S.lastEffect : null, S !== null) {
      var P = S = S.next;
      do {
        if ((P.tag & m) === m) {
          var G = P.create;
          P.destroy = G();
        }
        P = P.next;
      } while (P !== S);
    }
  }
  function Zm(m) {
    var S = m.ref;
    if (S !== null) {
      var P = m.stateNode;
      switch (m.tag) {
        case 5:
          m = P;
          break;
        default:
          m = P;
      }
      typeof S == "function" ? S(m) : S.current = m;
    }
  }
  function ny(m) {
    var S = m.alternate;
    S !== null && (m.alternate = null, ny(S)), m.child = null, m.deletions = null, m.sibling = null, m.tag === 5 && (S = m.stateNode, S !== null && (delete S[ks], delete S[Au], delete S[hp], delete S[T0], delete S[pp])), m.stateNode = null, m.return = null, m.dependencies = null, m.memoizedProps = null, m.memoizedState = null, m.pendingProps = null, m.stateNode = null, m.updateQueue = null;
  }
  function L0(m) {
    return m.tag === 5 || m.tag === 3 || m.tag === 4;
  }
  function ry(m) {
    e: for (; ; ) {
      for (; m.sibling === null; ) {
        if (m.return === null || L0(m.return)) return null;
        m = m.return;
      }
      for (m.sibling.return = m.return, m = m.sibling; m.tag !== 5 && m.tag !== 6 && m.tag !== 18; ) {
        if (m.flags & 2 || m.child === null || m.tag === 4) continue e;
        m.child.return = m, m = m.child;
      }
      if (!(m.flags & 2)) return m.stateNode;
    }
  }
  function wp(m, S, P) {
    var G = m.tag;
    if (G === 5 || G === 6) m = m.stateNode, S ? P.nodeType === 8 ? P.parentNode.insertBefore(m, S) : P.insertBefore(m, S) : (P.nodeType === 8 ? (S = P.parentNode, S.insertBefore(m, P)) : (S = P, S.appendChild(m)), P = P._reactRootContainer, P != null || S.onclick !== null || (S.onclick = Hf));
    else if (G !== 4 && (m = m.child, m !== null)) for (wp(m, S, P), m = m.sibling; m !== null; ) wp(m, S, P), m = m.sibling;
  }
  function oh(m, S, P) {
    var G = m.tag;
    if (G === 5 || G === 6) m = m.stateNode, S ? P.insertBefore(m, S) : P.appendChild(m);
    else if (G !== 4 && (m = m.child, m !== null)) for (oh(m, S, P), m = m.sibling; m !== null; ) oh(m, S, P), m = m.sibling;
  }
  var Si = null, Ao = !1;
  function wa(m, S, P) {
    for (P = P.child; P !== null; ) ah(m, S, P), P = P.sibling;
  }
  function ah(m, S, P) {
    if (Li && typeof Li.onCommitFiberUnmount == "function") try {
      Li.onCommitFiberUnmount(vs, P);
    } catch {
    }
    switch (P.tag) {
      case 5:
        qo || rh(P, S);
      case 6:
        var G = Si, se = Ao;
        Si = null, wa(m, S, P), Si = G, Ao = se, Si !== null && (Ao ? (m = Si, P = P.stateNode, m.nodeType === 8 ? m.parentNode.removeChild(P) : m.removeChild(P)) : Si.removeChild(P.stateNode));
        break;
      case 18:
        Si !== null && (Ao ? (m = Si, P = P.stateNode, m.nodeType === 8 ? ul(m.parentNode, P) : m.nodeType === 1 && ul(m, P), qn(m)) : ul(Si, P.stateNode));
        break;
      case 4:
        G = Si, se = Ao, Si = P.stateNode.containerInfo, Ao = !0, wa(m, S, P), Si = G, Ao = se;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!qo && (G = P.updateQueue, G !== null && (G = G.lastEffect, G !== null))) {
          se = G = G.next;
          do {
            var fe = se, Oe = fe.destroy;
            fe = fe.tag, Oe !== void 0 && (fe & 2 || fe & 4) && I0(P, S, Oe), se = se.next;
          } while (se !== G);
        }
        wa(m, S, P);
        break;
      case 1:
        if (!qo && (rh(P, S), G = P.stateNode, typeof G.componentWillUnmount == "function")) try {
          G.props = P.memoizedProps, G.state = P.memoizedState, G.componentWillUnmount();
        } catch ($e) {
          Hi(P, S, $e);
        }
        wa(m, S, P);
        break;
      case 21:
        wa(m, S, P);
        break;
      case 22:
        P.mode & 1 ? (qo = (G = qo) || P.memoizedState !== null, wa(m, S, P), qo = G) : wa(m, S, P);
        break;
      default:
        wa(m, S, P);
    }
  }
  function sh(m) {
    var S = m.updateQueue;
    if (S !== null) {
      m.updateQueue = null;
      var P = m.stateNode;
      P === null && (P = m.stateNode = new Xm()), S.forEach(function(G) {
        var se = uE.bind(null, m, G);
        P.has(G) || (P.add(G), G.then(se, se));
      });
    }
  }
  function ko(m, S) {
    var P = S.deletions;
    if (P !== null) for (var G = 0; G < P.length; G++) {
      var se = P[G];
      try {
        var fe = m, Oe = S, $e = Oe;
        e: for (; $e !== null; ) {
          switch ($e.tag) {
            case 5:
              Si = $e.stateNode, Ao = !1;
              break e;
            case 3:
              Si = $e.stateNode.containerInfo, Ao = !0;
              break e;
            case 4:
              Si = $e.stateNode.containerInfo, Ao = !0;
              break e;
          }
          $e = $e.return;
        }
        if (Si === null) throw Error(t(160));
        ah(fe, Oe, se), Si = null, Ao = !1;
        var rt = se.alternate;
        rt !== null && (rt.return = null), se.return = null;
      } catch (Ct) {
        Hi(se, S, Ct);
      }
    }
    if (S.subtreeFlags & 12854) for (S = S.child; S !== null; ) iy(S, m), S = S.sibling;
  }
  function iy(m, S) {
    var P = m.alternate, G = m.flags;
    switch (m.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ko(S, m), Gl(m), G & 4) {
          try {
            ih(3, m, m.return), Qm(3, m);
          } catch (bn) {
            Hi(m, m.return, bn);
          }
          try {
            ih(5, m, m.return);
          } catch (bn) {
            Hi(m, m.return, bn);
          }
        }
        break;
      case 1:
        ko(S, m), Gl(m), G & 512 && P !== null && rh(P, P.return);
        break;
      case 5:
        if (ko(S, m), Gl(m), G & 512 && P !== null && rh(P, P.return), m.flags & 32) {
          var se = m.stateNode;
          try {
            dt(se, "");
          } catch (bn) {
            Hi(m, m.return, bn);
          }
        }
        if (G & 4 && (se = m.stateNode, se != null)) {
          var fe = m.memoizedProps, Oe = P !== null ? P.memoizedProps : fe, $e = m.type, rt = m.updateQueue;
          if (m.updateQueue = null, rt !== null) try {
            $e === "input" && fe.type === "radio" && fe.name != null && je(se, fe), zt($e, Oe);
            var Ct = zt($e, fe);
            for (Oe = 0; Oe < rt.length; Oe += 2) {
              var Ht = rt[Oe], qt = rt[Oe + 1];
              Ht === "style" ? At(se, qt) : Ht === "dangerouslySetInnerHTML" ? et(se, qt) : Ht === "children" ? dt(se, qt) : y(se, Ht, qt, Ct);
            }
            switch ($e) {
              case "input":
                qe(se, fe);
                break;
              case "textarea":
                Se(se, fe);
                break;
              case "select":
                var Ut = se._wrapperState.wasMultiple;
                se._wrapperState.wasMultiple = !!fe.multiple;
                var rn = fe.value;
                rn != null ? Qe(se, !!fe.multiple, rn, !1) : Ut !== !!fe.multiple && (fe.defaultValue != null ? Qe(
                  se,
                  !!fe.multiple,
                  fe.defaultValue,
                  !0
                ) : Qe(se, !!fe.multiple, fe.multiple ? [] : "", !1));
            }
            se[Au] = fe;
          } catch (bn) {
            Hi(m, m.return, bn);
          }
        }
        break;
      case 6:
        if (ko(S, m), Gl(m), G & 4) {
          if (m.stateNode === null) throw Error(t(162));
          se = m.stateNode, fe = m.memoizedProps;
          try {
            se.nodeValue = fe;
          } catch (bn) {
            Hi(m, m.return, bn);
          }
        }
        break;
      case 3:
        if (ko(S, m), Gl(m), G & 4 && P !== null && P.memoizedState.isDehydrated) try {
          qn(S.containerInfo);
        } catch (bn) {
          Hi(m, m.return, bn);
        }
        break;
      case 4:
        ko(S, m), Gl(m);
        break;
      case 13:
        ko(S, m), Gl(m), se = m.child, se.flags & 8192 && (fe = se.memoizedState !== null, se.stateNode.isHidden = fe, !fe || se.alternate !== null && se.alternate.memoizedState !== null || (eg = fr())), G & 4 && sh(m);
        break;
      case 22:
        if (Ht = P !== null && P.memoizedState !== null, m.mode & 1 ? (qo = (Ct = qo) || Ht, ko(S, m), qo = Ct) : ko(S, m), Gl(m), G & 8192) {
          if (Ct = m.memoizedState !== null, (m.stateNode.isHidden = Ct) && !Ht && m.mode & 1) for (dn = m, Ht = m.child; Ht !== null; ) {
            for (qt = dn = Ht; dn !== null; ) {
              switch (Ut = dn, rn = Ut.child, Ut.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  ih(4, Ut, Ut.return);
                  break;
                case 1:
                  rh(Ut, Ut.return);
                  var gn = Ut.stateNode;
                  if (typeof gn.componentWillUnmount == "function") {
                    G = Ut, P = Ut.return;
                    try {
                      S = G, gn.props = S.memoizedProps, gn.state = S.memoizedState, gn.componentWillUnmount();
                    } catch (bn) {
                      Hi(G, P, bn);
                    }
                  }
                  break;
                case 5:
                  rh(Ut, Ut.return);
                  break;
                case 22:
                  if (Ut.memoizedState !== null) {
                    oy(qt);
                    continue;
                  }
              }
              rn !== null ? (rn.return = Ut, dn = rn) : oy(qt);
            }
            Ht = Ht.sibling;
          }
          e: for (Ht = null, qt = m; ; ) {
            if (qt.tag === 5) {
              if (Ht === null) {
                Ht = qt;
                try {
                  se = qt.stateNode, Ct ? (fe = se.style, typeof fe.setProperty == "function" ? fe.setProperty("display", "none", "important") : fe.display = "none") : ($e = qt.stateNode, rt = qt.memoizedProps.style, Oe = rt != null && rt.hasOwnProperty("display") ? rt.display : null, $e.style.display = ft("display", Oe));
                } catch (bn) {
                  Hi(m, m.return, bn);
                }
              }
            } else if (qt.tag === 6) {
              if (Ht === null) try {
                qt.stateNode.nodeValue = Ct ? "" : qt.memoizedProps;
              } catch (bn) {
                Hi(m, m.return, bn);
              }
            } else if ((qt.tag !== 22 && qt.tag !== 23 || qt.memoizedState === null || qt === m) && qt.child !== null) {
              qt.child.return = qt, qt = qt.child;
              continue;
            }
            if (qt === m) break e;
            for (; qt.sibling === null; ) {
              if (qt.return === null || qt.return === m) break e;
              Ht === qt && (Ht = null), qt = qt.return;
            }
            Ht === qt && (Ht = null), qt.sibling.return = qt.return, qt = qt.sibling;
          }
        }
        break;
      case 19:
        ko(S, m), Gl(m), G & 4 && sh(m);
        break;
      case 21:
        break;
      default:
        ko(
          S,
          m
        ), Gl(m);
    }
  }
  function Gl(m) {
    var S = m.flags;
    if (S & 2) {
      try {
        e: {
          for (var P = m.return; P !== null; ) {
            if (L0(P)) {
              var G = P;
              break e;
            }
            P = P.return;
          }
          throw Error(t(160));
        }
        switch (G.tag) {
          case 5:
            var se = G.stateNode;
            G.flags & 32 && (dt(se, ""), G.flags &= -33);
            var fe = ry(m);
            oh(m, fe, se);
            break;
          case 3:
          case 4:
            var Oe = G.stateNode.containerInfo, $e = ry(m);
            wp(m, $e, Oe);
            break;
          default:
            throw Error(t(161));
        }
      } catch (rt) {
        Hi(m, m.return, rt);
      }
      m.flags &= -3;
    }
    S & 4096 && (m.flags &= -4097);
  }
  function rE(m, S, P) {
    dn = m, M0(m);
  }
  function M0(m, S, P) {
    for (var G = (m.mode & 1) !== 0; dn !== null; ) {
      var se = dn, fe = se.child;
      if (se.tag === 22 && G) {
        var Oe = se.memoizedState !== null || nh;
        if (!Oe) {
          var $e = se.alternate, rt = $e !== null && $e.memoizedState !== null || qo;
          $e = nh;
          var Ct = qo;
          if (nh = Oe, (qo = rt) && !Ct) for (dn = se; dn !== null; ) Oe = dn, rt = Oe.child, Oe.tag === 22 && Oe.memoizedState !== null ? P0(se) : rt !== null ? (rt.return = Oe, dn = rt) : P0(se);
          for (; fe !== null; ) dn = fe, M0(fe), fe = fe.sibling;
          dn = se, nh = $e, qo = Ct;
        }
        lh(m);
      } else se.subtreeFlags & 8772 && fe !== null ? (fe.return = se, dn = fe) : lh(m);
    }
  }
  function lh(m) {
    for (; dn !== null; ) {
      var S = dn;
      if (S.flags & 8772) {
        var P = S.alternate;
        try {
          if (S.flags & 8772) switch (S.tag) {
            case 0:
            case 11:
            case 15:
              qo || Qm(5, S);
              break;
            case 1:
              var G = S.stateNode;
              if (S.flags & 4 && !qo) if (P === null) G.componentDidMount();
              else {
                var se = S.elementType === S.type ? P.memoizedProps : Vo(S.type, P.memoizedProps);
                G.componentDidUpdate(se, P.memoizedState, G.__reactInternalSnapshotBeforeUpdate);
              }
              var fe = S.updateQueue;
              fe !== null && Is(S, fe, G);
              break;
            case 3:
              var Oe = S.updateQueue;
              if (Oe !== null) {
                if (P = null, S.child !== null) switch (S.child.tag) {
                  case 5:
                    P = S.child.stateNode;
                    break;
                  case 1:
                    P = S.child.stateNode;
                }
                Is(S, Oe, P);
              }
              break;
            case 5:
              var $e = S.stateNode;
              if (P === null && S.flags & 4) {
                P = $e;
                var rt = S.memoizedProps;
                switch (S.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    rt.autoFocus && P.focus();
                    break;
                  case "img":
                    rt.src && (P.src = rt.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (S.memoizedState === null) {
                var Ct = S.alternate;
                if (Ct !== null) {
                  var Ht = Ct.memoizedState;
                  if (Ht !== null) {
                    var qt = Ht.dehydrated;
                    qt !== null && qn(qt);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(t(163));
          }
          qo || S.flags & 512 && Zm(S);
        } catch (Ut) {
          Hi(S, S.return, Ut);
        }
      }
      if (S === m) {
        dn = null;
        break;
      }
      if (P = S.sibling, P !== null) {
        P.return = S.return, dn = P;
        break;
      }
      dn = S.return;
    }
  }
  function oy(m) {
    for (; dn !== null; ) {
      var S = dn;
      if (S === m) {
        dn = null;
        break;
      }
      var P = S.sibling;
      if (P !== null) {
        P.return = S.return, dn = P;
        break;
      }
      dn = S.return;
    }
  }
  function P0(m) {
    for (; dn !== null; ) {
      var S = dn;
      try {
        switch (S.tag) {
          case 0:
          case 11:
          case 15:
            var P = S.return;
            try {
              Qm(4, S);
            } catch (rt) {
              Hi(S, P, rt);
            }
            break;
          case 1:
            var G = S.stateNode;
            if (typeof G.componentDidMount == "function") {
              var se = S.return;
              try {
                G.componentDidMount();
              } catch (rt) {
                Hi(S, se, rt);
              }
            }
            var fe = S.return;
            try {
              Zm(S);
            } catch (rt) {
              Hi(S, fe, rt);
            }
            break;
          case 5:
            var Oe = S.return;
            try {
              Zm(S);
            } catch (rt) {
              Hi(S, Oe, rt);
            }
        }
      } catch (rt) {
        Hi(S, S.return, rt);
      }
      if (S === m) {
        dn = null;
        break;
      }
      var $e = S.sibling;
      if ($e !== null) {
        $e.return = S.return, dn = $e;
        break;
      }
      dn = S.return;
    }
  }
  var iE = Math.ceil, Vd = T.ReactCurrentDispatcher, Jm = T.ReactCurrentOwner, Ps = T.ReactCurrentBatchConfig, mr = 0, Ui = null, _i = null, ho = 0, Wa = 0, uh = Fn(0), po = 0, xp = null, qd = 0, ch = 0, j0 = 0, Hc = null, ca = null, eg = 0, dh = 1 / 0, Lu = null, tg = !1, B0 = null, js = null, fh = !1, Bs = null, ng = 0, Tp = 0, rg = null, Ap = -1, Gd = 0;
  function Oo() {
    return mr & 6 ? fr() : Ap !== -1 ? Ap : Ap = fr();
  }
  function Mu(m) {
    return m.mode & 1 ? mr & 2 && ho !== 0 ? ho & -ho : Ld.transition !== null ? (Gd === 0 && (Gd = ns()), Gd) : (m = Er, m !== 0 || (m = window.event, m = m === void 0 ? 16 : bd(m.type)), m) : 1;
  }
  function Di(m, S, P, G) {
    if (50 < Tp) throw Tp = 0, rg = null, Error(t(185));
    ra(m, P, G), (!(mr & 2) || m !== Ui) && (m === Ui && (!(mr & 2) && (ch |= P), po === 4 && Wl(m, ho)), mo(m, G), P === 1 && mr === 0 && !(S.mode & 1) && (dh = fr() + 500, Ei && Ji()));
  }
  function mo(m, S) {
    var P = m.callbackNode;
    ja(m, S);
    var G = so(m, m === Ui ? ho : 0);
    if (G === 0) P !== null && Lo(P), m.callbackNode = null, m.callbackPriority = 0;
    else if (S = G & -G, m.callbackPriority !== S) {
      if (P != null && Lo(P), S === 1) m.tag === 0 ? hl(hh.bind(null, m)) : ya(hh.bind(null, m)), fp(function() {
        !(mr & 6) && Ji();
      }), P = null;
      else {
        switch (yd(G)) {
          case 1:
            P = pa;
            break;
          case 4:
            P = Qn;
            break;
          case 16:
            P = Pa;
            break;
          case 536870912:
            P = ma;
            break;
          default:
            P = Pa;
        }
        P = hy(P, ig.bind(null, m));
      }
      m.callbackPriority = S, m.callbackNode = P;
    }
  }
  function ig(m, S) {
    if (Ap = -1, Gd = 0, mr & 6) throw Error(t(327));
    var P = m.callbackNode;
    if (ph() && m.callbackNode !== P) return null;
    var G = so(m, m === Ui ? ho : 0);
    if (G === 0) return null;
    if (G & 30 || G & m.expiredLanes || S) S = ag(m, G);
    else {
      S = G;
      var se = mr;
      mr |= 2;
      var fe = sy();
      (Ui !== m || ho !== S) && (Lu = null, dh = fr() + 500, $d(m, S));
      do
        try {
          aE();
          break;
        } catch ($e) {
          ay(m, $e);
        }
      while (!0);
      aa(), Vd.current = fe, mr = se, _i !== null ? S = 0 : (Ui = null, ho = 0, S = po);
    }
    if (S !== 0) {
      if (S === 2 && (se = Tl(m), se !== 0 && (G = se, S = Wd(m, se))), S === 1) throw P = xp, $d(m, 0), Wl(m, G), mo(m, fr()), P;
      if (S === 6) Wl(m, G);
      else {
        if (se = m.current.alternate, !(G & 30) && !U0(se) && (S = ag(m, G), S === 2 && (fe = Tl(m), fe !== 0 && (G = fe, S = Wd(m, fe))), S === 1)) throw P = xp, $d(m, 0), Wl(m, G), mo(m, fr()), P;
        switch (m.finishedWork = se, m.finishedLanes = G, S) {
          case 0:
          case 1:
            throw Error(t(345));
          case 2:
            zc(m, ca, Lu);
            break;
          case 3:
            if (Wl(m, G), (G & 130023424) === G && (S = eg + 500 - fr(), 10 < S)) {
              if (so(m, 0) !== 0) break;
              if (se = m.suspendedLanes, (se & G) !== G) {
                Oo(), m.pingedLanes |= m.suspendedLanes & se;
                break;
              }
              m.timeoutHandle = jl(zc.bind(null, m, ca, Lu), S);
              break;
            }
            zc(m, ca, Lu);
            break;
          case 4:
            if (Wl(m, G), (G & 4194240) === G) break;
            for (S = m.eventTimes, se = -1; 0 < G; ) {
              var Oe = 31 - Mo(G);
              fe = 1 << Oe, Oe = S[Oe], Oe > se && (se = Oe), G &= ~fe;
            }
            if (G = se, G = fr() - G, G = (120 > G ? 120 : 480 > G ? 480 : 1080 > G ? 1080 : 1920 > G ? 1920 : 3e3 > G ? 3e3 : 4320 > G ? 4320 : 1960 * iE(G / 1960)) - G, 10 < G) {
              m.timeoutHandle = jl(zc.bind(null, m, ca, Lu), G);
              break;
            }
            zc(m, ca, Lu);
            break;
          case 5:
            zc(m, ca, Lu);
            break;
          default:
            throw Error(t(329));
        }
      }
    }
    return mo(m, fr()), m.callbackNode === P ? ig.bind(null, m) : null;
  }
  function Wd(m, S) {
    var P = Hc;
    return m.current.memoizedState.isDehydrated && ($d(m, S).flags |= 256), m = ag(m, S), m !== 2 && (S = ca, ca = P, S !== null && F0(S)), m;
  }
  function F0(m) {
    ca === null ? ca = m : ca.push.apply(ca, m);
  }
  function U0(m) {
    for (var S = m; ; ) {
      if (S.flags & 16384) {
        var P = S.updateQueue;
        if (P !== null && (P = P.stores, P !== null)) for (var G = 0; G < P.length; G++) {
          var se = P[G], fe = se.getSnapshot;
          se = se.value;
          try {
            if (!Fa(fe(), se)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (P = S.child, S.subtreeFlags & 16384 && P !== null) P.return = S, S = P;
      else {
        if (S === m) break;
        for (; S.sibling === null; ) {
          if (S.return === null || S.return === m) return !0;
          S = S.return;
        }
        S.sibling.return = S.return, S = S.sibling;
      }
    }
    return !0;
  }
  function Wl(m, S) {
    for (S &= ~j0, S &= ~ch, m.suspendedLanes |= S, m.pingedLanes &= ~S, m = m.expirationTimes; 0 < S; ) {
      var P = 31 - Mo(S), G = 1 << P;
      m[P] = -1, S &= ~G;
    }
  }
  function hh(m) {
    if (mr & 6) throw Error(t(327));
    ph();
    var S = so(m, 0);
    if (!(S & 1)) return mo(m, fr()), null;
    var P = ag(m, S);
    if (m.tag !== 0 && P === 2) {
      var G = Tl(m);
      G !== 0 && (S = G, P = Wd(m, G));
    }
    if (P === 1) throw P = xp, $d(m, 0), Wl(m, S), mo(m, fr()), P;
    if (P === 6) throw Error(t(345));
    return m.finishedWork = m.current.alternate, m.finishedLanes = S, zc(m, ca, Lu), mo(m, fr()), null;
  }
  function H0(m, S) {
    var P = mr;
    mr |= 1;
    try {
      return m(S);
    } finally {
      mr = P, mr === 0 && (dh = fr() + 500, Ei && Ji());
    }
  }
  function $l(m) {
    Bs !== null && Bs.tag === 0 && !(mr & 6) && ph();
    var S = mr;
    mr |= 1;
    var P = Ps.transition, G = Er;
    try {
      if (Ps.transition = null, Er = 1, m) return m();
    } finally {
      Er = G, Ps.transition = P, mr = S, !(mr & 6) && Ji();
    }
  }
  function og() {
    Wa = uh.current, Tr(uh);
  }
  function $d(m, S) {
    m.finishedWork = null, m.finishedLanes = 0;
    var P = m.timeoutHandle;
    if (P !== -1 && (m.timeoutHandle = -1, Bl(P)), _i !== null) for (P = _i.return; P !== null; ) {
      var G = P;
      switch (Gf(G), G.tag) {
        case 1:
          G = G.type.childContextTypes, G != null && _a();
          break;
        case 3:
          Gi(), Tr(bi), Tr(Gn), Ve();
          break;
        case 5:
          Pc(G);
          break;
        case 4:
          Gi();
          break;
        case 13:
          Tr(ci);
          break;
        case 19:
          Tr(ci);
          break;
        case 10:
          Yf(G.type._context);
          break;
        case 22:
        case 23:
          og();
      }
      P = P.return;
    }
    if (Ui = m, _i = m = Vc(m.current, null), ho = Wa = S, po = 0, xp = null, j0 = ch = qd = 0, ca = Hc = null, zl !== null) {
      for (S = 0; S < zl.length; S++) if (P = zl[S], G = P.interleaved, G !== null) {
        P.interleaved = null;
        var se = G.next, fe = P.pending;
        if (fe !== null) {
          var Oe = fe.next;
          fe.next = se, G.next = Oe;
        }
        P.pending = G;
      }
      zl = null;
    }
    return m;
  }
  function ay(m, S) {
    do {
      var P = _i;
      try {
        if (aa(), De.current = gi, Sa) {
          for (var G = Sn.memoizedState; G !== null; ) {
            var se = G.queue;
            se !== null && (se.pending = null), G = G.next;
          }
          Sa = !1;
        }
        if (vn = 0, lr = Un = Sn = null, jc = !1, Bc = 0, Jm.current = null, P === null || P.return === null) {
          po = 1, xp = S, _i = null;
          break;
        }
        e: {
          var fe = m, Oe = P.return, $e = P, rt = S;
          if (S = ho, $e.flags |= 32768, rt !== null && typeof rt == "object" && typeof rt.then == "function") {
            var Ct = rt, Ht = $e, qt = Ht.tag;
            if (!(Ht.mode & 1) && (qt === 0 || qt === 11 || qt === 15)) {
              var Ut = Ht.alternate;
              Ut ? (Ht.updateQueue = Ut.updateQueue, Ht.memoizedState = Ut.memoizedState, Ht.lanes = Ut.lanes) : (Ht.updateQueue = null, Ht.memoizedState = null);
            }
            var rn = Q1(Oe);
            if (rn !== null) {
              rn.flags &= -257, D0(rn, Oe, $e, fe, S), rn.mode & 1 && bp(fe, Ct, S), S = rn, rt = Ct;
              var gn = S.updateQueue;
              if (gn === null) {
                var bn = /* @__PURE__ */ new Set();
                bn.add(rt), S.updateQueue = bn;
              } else gn.add(rt);
              break e;
            } else {
              if (!(S & 1)) {
                bp(fe, Ct, S), kp();
                break e;
              }
              rt = Error(t(426));
            }
          } else if (Pr && $e.mode & 1) {
            var Xi = Q1(Oe);
            if (Xi !== null) {
              !(Xi.flags & 65536) && (Xi.flags |= 256), D0(Xi, Oe, $e, fe, S), Ic(Fc(rt, $e));
              break e;
            }
          }
          fe = rt = Fc(rt, $e), po !== 4 && (po = 2), Hc === null ? Hc = [fe] : Hc.push(fe), fe = Oe;
          do {
            switch (fe.tag) {
              case 3:
                fe.flags |= 65536, S &= -S, fe.lanes |= S;
                var mt = X1(fe, rt, S);
                an(fe, mt);
                break e;
              case 1:
                $e = rt;
                var at = fe.type, vt = fe.stateNode;
                if (!(fe.flags & 128) && (typeof at.getDerivedStateFromError == "function" || vt !== null && typeof vt.componentDidCatch == "function" && (js === null || !js.has(vt)))) {
                  fe.flags |= 65536, S &= -S, fe.lanes |= S;
                  var $t = K1(fe, $e, S);
                  an(fe, $t);
                  break e;
                }
            }
            fe = fe.return;
          } while (fe !== null);
        }
        uy(P);
      } catch (wn) {
        S = wn, _i === P && P !== null && (_i = P = P.return);
        continue;
      }
      break;
    } while (!0);
  }
  function sy() {
    var m = Vd.current;
    return Vd.current = gi, m === null ? gi : m;
  }
  function kp() {
    (po === 0 || po === 3 || po === 2) && (po = 4), Ui === null || !(qd & 268435455) && !(ch & 268435455) || Wl(Ui, ho);
  }
  function ag(m, S) {
    var P = mr;
    mr |= 2;
    var G = sy();
    (Ui !== m || ho !== S) && (Lu = null, $d(m, S));
    do
      try {
        oE();
        break;
      } catch (se) {
        ay(m, se);
      }
    while (!0);
    if (aa(), mr = P, Vd.current = G, _i !== null) throw Error(t(261));
    return Ui = null, ho = 0, po;
  }
  function oE() {
    for (; _i !== null; ) ly(_i);
  }
  function aE() {
    for (; _i !== null && !La(); ) ly(_i);
  }
  function ly(m) {
    var S = fy(m.alternate, m, Wa);
    m.memoizedProps = m.pendingProps, S === null ? uy(m) : _i = S, Jm.current = null;
  }
  function uy(m) {
    var S = m;
    do {
      var P = S.alternate;
      if (m = S.return, S.flags & 32768) {
        if (P = tE(P, S), P !== null) {
          P.flags &= 32767, _i = P;
          return;
        }
        if (m !== null) m.flags |= 32768, m.subtreeFlags = 0, m.deletions = null;
        else {
          po = 6, _i = null;
          return;
        }
      } else if (P = eE(P, S, Wa), P !== null) {
        _i = P;
        return;
      }
      if (S = S.sibling, S !== null) {
        _i = S;
        return;
      }
      _i = S = m;
    } while (S !== null);
    po === 0 && (po = 5);
  }
  function zc(m, S, P) {
    var G = Er, se = Ps.transition;
    try {
      Ps.transition = null, Er = 1, sE(m, S, P, G);
    } finally {
      Ps.transition = se, Er = G;
    }
    return null;
  }
  function sE(m, S, P, G) {
    do
      ph();
    while (Bs !== null);
    if (mr & 6) throw Error(t(327));
    P = m.finishedWork;
    var se = m.finishedLanes;
    if (P === null) return null;
    if (m.finishedWork = null, m.finishedLanes = 0, P === m.current) throw Error(t(177));
    m.callbackNode = null, m.callbackPriority = 0;
    var fe = P.lanes | P.childLanes;
    if (_d(m, fe), m === Ui && (_i = Ui = null, ho = 0), !(P.subtreeFlags & 2064) && !(P.flags & 2064) || fh || (fh = !0, hy(Pa, function() {
      return ph(), null;
    })), fe = (P.flags & 15990) !== 0, P.subtreeFlags & 15990 || fe) {
      fe = Ps.transition, Ps.transition = null;
      var Oe = Er;
      Er = 1;
      var $e = mr;
      mr |= 4, Jm.current = null, nE(m, P), iy(P, m), re(Pl), Ba = !!kc, Pl = kc = null, m.current = P, rE(P), Ai(), mr = $e, Er = Oe, Ps.transition = fe;
    } else m.current = P;
    if (fh && (fh = !1, Bs = m, ng = se), fe = m.pendingLanes, fe === 0 && (js = null), uc(P.stateNode), mo(m, fr()), S !== null) for (G = m.onRecoverableError, P = 0; P < S.length; P++) se = S[P], G(se.value, { componentStack: se.stack, digest: se.digest });
    if (tg) throw tg = !1, m = B0, B0 = null, m;
    return ng & 1 && m.tag !== 0 && ph(), fe = m.pendingLanes, fe & 1 ? m === rg ? Tp++ : (Tp = 0, rg = m) : Tp = 0, Ji(), null;
  }
  function ph() {
    if (Bs !== null) {
      var m = yd(ng), S = Ps.transition, P = Er;
      try {
        if (Ps.transition = null, Er = 16 > m ? 16 : m, Bs === null) var G = !1;
        else {
          if (m = Bs, Bs = null, ng = 0, mr & 6) throw Error(t(331));
          var se = mr;
          for (mr |= 4, dn = m.current; dn !== null; ) {
            var fe = dn, Oe = fe.child;
            if (dn.flags & 16) {
              var $e = fe.deletions;
              if ($e !== null) {
                for (var rt = 0; rt < $e.length; rt++) {
                  var Ct = $e[rt];
                  for (dn = Ct; dn !== null; ) {
                    var Ht = dn;
                    switch (Ht.tag) {
                      case 0:
                      case 11:
                      case 15:
                        ih(8, Ht, fe);
                    }
                    var qt = Ht.child;
                    if (qt !== null) qt.return = Ht, dn = qt;
                    else for (; dn !== null; ) {
                      Ht = dn;
                      var Ut = Ht.sibling, rn = Ht.return;
                      if (ny(Ht), Ht === Ct) {
                        dn = null;
                        break;
                      }
                      if (Ut !== null) {
                        Ut.return = rn, dn = Ut;
                        break;
                      }
                      dn = rn;
                    }
                  }
                }
                var gn = fe.alternate;
                if (gn !== null) {
                  var bn = gn.child;
                  if (bn !== null) {
                    gn.child = null;
                    do {
                      var Xi = bn.sibling;
                      bn.sibling = null, bn = Xi;
                    } while (bn !== null);
                  }
                }
                dn = fe;
              }
            }
            if (fe.subtreeFlags & 2064 && Oe !== null) Oe.return = fe, dn = Oe;
            else e: for (; dn !== null; ) {
              if (fe = dn, fe.flags & 2048) switch (fe.tag) {
                case 0:
                case 11:
                case 15:
                  ih(9, fe, fe.return);
              }
              var mt = fe.sibling;
              if (mt !== null) {
                mt.return = fe.return, dn = mt;
                break e;
              }
              dn = fe.return;
            }
          }
          var at = m.current;
          for (dn = at; dn !== null; ) {
            Oe = dn;
            var vt = Oe.child;
            if (Oe.subtreeFlags & 2064 && vt !== null) vt.return = Oe, dn = vt;
            else e: for (Oe = at; dn !== null; ) {
              if ($e = dn, $e.flags & 2048) try {
                switch ($e.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Qm(9, $e);
                }
              } catch (wn) {
                Hi($e, $e.return, wn);
              }
              if ($e === Oe) {
                dn = null;
                break e;
              }
              var $t = $e.sibling;
              if ($t !== null) {
                $t.return = $e.return, dn = $t;
                break e;
              }
              dn = $e.return;
            }
          }
          if (mr = se, Ji(), Li && typeof Li.onPostCommitFiberRoot == "function") try {
            Li.onPostCommitFiberRoot(vs, m);
          } catch {
          }
          G = !0;
        }
        return G;
      } finally {
        Er = P, Ps.transition = S;
      }
    }
    return !1;
  }
  function cy(m, S, P) {
    S = Fc(P, S), S = X1(m, S, 1), m = Vl(m, S, 1), S = Oo(), m !== null && (ra(m, 1, S), mo(m, S));
  }
  function Hi(m, S, P) {
    if (m.tag === 3) cy(m, m, P);
    else for (; S !== null; ) {
      if (S.tag === 3) {
        cy(S, m, P);
        break;
      } else if (S.tag === 1) {
        var G = S.stateNode;
        if (typeof S.type.getDerivedStateFromError == "function" || typeof G.componentDidCatch == "function" && (js === null || !js.has(G))) {
          m = Fc(P, m), m = K1(S, m, 1), S = Vl(S, m, 1), m = Oo(), S !== null && (ra(S, 1, m), mo(S, m));
          break;
        }
      }
      S = S.return;
    }
  }
  function lE(m, S, P) {
    var G = m.pingCache;
    G !== null && G.delete(S), S = Oo(), m.pingedLanes |= m.suspendedLanes & P, Ui === m && (ho & P) === P && (po === 4 || po === 3 && (ho & 130023424) === ho && 500 > fr() - eg ? $d(m, 0) : j0 |= P), mo(m, S);
  }
  function dy(m, S) {
    S === 0 && (m.mode & 1 ? (S = Ur, Ur <<= 1, !(Ur & 130023424) && (Ur = 4194304)) : S = 1);
    var P = Oo();
    m = Ns(m, S), m !== null && (ra(m, S, P), mo(m, P));
  }
  function z0(m) {
    var S = m.memoizedState, P = 0;
    S !== null && (P = S.retryLane), dy(m, P);
  }
  function uE(m, S) {
    var P = 0;
    switch (m.tag) {
      case 13:
        var G = m.stateNode, se = m.memoizedState;
        se !== null && (P = se.retryLane);
        break;
      case 19:
        G = m.stateNode;
        break;
      default:
        throw Error(t(314));
    }
    G !== null && G.delete(S), dy(m, P);
  }
  var fy;
  fy = function(m, S, P) {
    if (m !== null) if (m.memoizedProps !== S.pendingProps || bi.current) qa = !0;
    else {
      if (!(m.lanes & P) && !(S.flags & 128)) return qa = !1, Iu(m, S, P);
      qa = !!(m.flags & 131072);
    }
    else qa = !1, Pr && S.flags & 1048576 && qf(S, Du, S.index);
    switch (S.lanes = 0, S.tag) {
      case 2:
        var G = S.type;
        Cp(m, S), m = S.pendingProps;
        var se = Ha(S, Gn.current);
        Lc(S, P), se = jt(null, S, G, m, se, P);
        var fe = M();
        return S.flags |= 1, typeof se == "object" && se !== null && typeof se.render == "function" && se.$$typeof === void 0 ? (S.tag = 1, S.memoizedState = null, S.updateQueue = null, ii(G) ? (fe = !0, Nc(S)) : fe = !1, S.memoizedState = se.state !== null && se.state !== void 0 ? se.state : null, jd(S), se.updater = _l, S.stateNode = se, se._reactInternals = S, k0(S, G, m, P), S = Gm(null, S, G, !0, fe, P)) : (S.tag = 0, Pr && fe && Ru(S), $i(null, S, se, P), S = S.child), S;
      case 16:
        G = S.elementType;
        e: {
          switch (Cp(m, S), m = S.pendingProps, se = G._init, G = se(G._payload), S.type = G, se = S.tag = cE(G), m = Vo(G, m), se) {
            case 0:
              S = or(null, S, G, m, P);
              break e;
            case 1:
              S = Ep(null, S, G, m, P);
              break e;
            case 11:
              S = Jf(null, S, G, m, P);
              break e;
            case 14:
              S = Uc(null, S, G, Vo(G.type, m), P);
              break e;
          }
          throw Error(t(
            306,
            G,
            ""
          ));
        }
        return S;
      case 0:
        return G = S.type, se = S.pendingProps, se = S.elementType === G ? se : Vo(G, se), or(m, S, G, se, P);
      case 1:
        return G = S.type, se = S.pendingProps, se = S.elementType === G ? se : Vo(G, se), Ep(m, S, G, se, P);
      case 3:
        e: {
          if (J2(S), m === null) throw Error(t(387));
          G = S.pendingProps, fe = S.memoizedState, se = fe.element, us(m, S), Lt(S, G, null, P);
          var Oe = S.memoizedState;
          if (G = Oe.element, fe.isDehydrated) if (fe = { element: G, isDehydrated: !1, cache: Oe.cache, pendingSuspenseBoundaries: Oe.pendingSuspenseBoundaries, transitions: Oe.transitions }, S.updateQueue.baseState = fe, S.memoizedState = fe, S.flags & 256) {
            se = Fc(Error(t(423)), S), S = J1(m, S, G, P, se);
            break e;
          } else if (G !== se) {
            se = Fc(Error(t(424)), S), S = J1(m, S, G, P, se);
            break e;
          } else for (qi = as(S.stateNode.containerInfo.firstChild), zo = S, Pr = !0, Co = null, P = Pd(S, null, G, P), S.child = P; P; ) P.flags = P.flags & -3 | 4096, P = P.sibling;
          else {
            if (oi(), G === se) {
              S = Yi(m, S, P);
              break e;
            }
            $i(m, S, G, P);
          }
          S = S.child;
        }
        return S;
      case 5:
        return zm(S), m === null && Nd(S), G = S.type, se = S.pendingProps, fe = m !== null ? m.memoizedProps : null, Oe = se.children, Oc(G, se) ? Oe = null : fe !== null && Oc(G, fe) && (S.flags |= 32), Hd(m, S), $i(m, S, Oe, P), S.child;
      case 6:
        return m === null && Nd(S), null;
      case 13:
        return ey(m, S, P);
      case 4:
        return Qf(S, S.stateNode.containerInfo), G = S.pendingProps, m === null ? S.child = pl(S, null, G, P) : $i(m, S, G, P), S.child;
      case 11:
        return G = S.type, se = S.pendingProps, se = S.elementType === G ? se : Vo(G, se), Jf(m, S, G, se, P);
      case 7:
        return $i(m, S, S.pendingProps, P), S.child;
      case 8:
        return $i(m, S, S.pendingProps.children, P), S.child;
      case 12:
        return $i(m, S, S.pendingProps.children, P), S.child;
      case 10:
        e: {
          if (G = S.type._context, se = S.pendingProps, fe = S.memoizedProps, Oe = se.value, Ar(Rs, G._currentValue), G._currentValue = Oe, fe !== null) if (Fa(fe.value, Oe)) {
            if (fe.children === se.children && !bi.current) {
              S = Yi(m, S, P);
              break e;
            }
          } else for (fe = S.child, fe !== null && (fe.return = S); fe !== null; ) {
            var $e = fe.dependencies;
            if ($e !== null) {
              Oe = fe.child;
              for (var rt = $e.firstContext; rt !== null; ) {
                if (rt.context === G) {
                  if (fe.tag === 1) {
                    rt = wo(-1, P & -P), rt.tag = 2;
                    var Ct = fe.updateQueue;
                    if (Ct !== null) {
                      Ct = Ct.shared;
                      var Ht = Ct.pending;
                      Ht === null ? rt.next = rt : (rt.next = Ht.next, Ht.next = rt), Ct.pending = rt;
                    }
                  }
                  fe.lanes |= P, rt = fe.alternate, rt !== null && (rt.lanes |= P), Xf(
                    fe.return,
                    P,
                    S
                  ), $e.lanes |= P;
                  break;
                }
                rt = rt.next;
              }
            } else if (fe.tag === 10) Oe = fe.type === S.type ? null : fe.child;
            else if (fe.tag === 18) {
              if (Oe = fe.return, Oe === null) throw Error(t(341));
              Oe.lanes |= P, $e = Oe.alternate, $e !== null && ($e.lanes |= P), Xf(Oe, P, S), Oe = fe.sibling;
            } else Oe = fe.child;
            if (Oe !== null) Oe.return = fe;
            else for (Oe = fe; Oe !== null; ) {
              if (Oe === S) {
                Oe = null;
                break;
              }
              if (fe = Oe.sibling, fe !== null) {
                fe.return = Oe.return, Oe = fe;
                break;
              }
              Oe = Oe.return;
            }
            fe = Oe;
          }
          $i(m, S, se.children, P), S = S.child;
        }
        return S;
      case 9:
        return se = S.type, G = S.pendingProps.children, Lc(S, P), se = Va(se), G = G(se), S.flags |= 1, $i(m, S, G, P), S.child;
      case 14:
        return G = S.type, se = Vo(G, S.pendingProps), se = Vo(G.type, se), Uc(m, S, G, se, P);
      case 15:
        return qm(m, S, S.type, S.pendingProps, P);
      case 17:
        return G = S.type, se = S.pendingProps, se = S.elementType === G ? se : Vo(G, se), Cp(m, S), S.tag = 1, ii(G) ? (m = !0, Nc(S)) : m = !1, Lc(S, P), yp(S, G, se), k0(S, G, se, P), Gm(null, S, G, !0, m, P);
      case 19:
        return N0(m, S, P);
      case 22:
        return Ga(m, S, P);
    }
    throw Error(t(156, S.tag));
  };
  function hy(m, S) {
    return di(m, S);
  }
  function py(m, S, P, G) {
    this.tag = m, this.key = P, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = S, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = G, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Fs(m, S, P, G) {
    return new py(m, S, P, G);
  }
  function V0(m) {
    return m = m.prototype, !(!m || !m.isReactComponent);
  }
  function cE(m) {
    if (typeof m == "function") return V0(m) ? 1 : 0;
    if (m != null) {
      if (m = m.$$typeof, m === H) return 11;
      if (m === ie) return 14;
    }
    return 2;
  }
  function Vc(m, S) {
    var P = m.alternate;
    return P === null ? (P = Fs(m.tag, S, m.key, m.mode), P.elementType = m.elementType, P.type = m.type, P.stateNode = m.stateNode, P.alternate = m, m.alternate = P) : (P.pendingProps = S, P.type = m.type, P.flags = 0, P.subtreeFlags = 0, P.deletions = null), P.flags = m.flags & 14680064, P.childLanes = m.childLanes, P.lanes = m.lanes, P.child = m.child, P.memoizedProps = m.memoizedProps, P.memoizedState = m.memoizedState, P.updateQueue = m.updateQueue, S = m.dependencies, P.dependencies = S === null ? null : { lanes: S.lanes, firstContext: S.firstContext }, P.sibling = m.sibling, P.index = m.index, P.ref = m.ref, P;
  }
  function sg(m, S, P, G, se, fe) {
    var Oe = 2;
    if (G = m, typeof m == "function") V0(m) && (Oe = 1);
    else if (typeof m == "string") Oe = 5;
    else e: switch (m) {
      case N:
        return Yd(P.children, se, fe, S);
      case j:
        Oe = 8, se |= 8;
        break;
      case I:
        return m = Fs(12, P, S, se | 2), m.elementType = I, m.lanes = fe, m;
      case Q:
        return m = Fs(13, P, S, se), m.elementType = Q, m.lanes = fe, m;
      case Y:
        return m = Fs(19, P, S, se), m.elementType = Y, m.lanes = fe, m;
      case $:
        return lg(P, se, fe, S);
      default:
        if (typeof m == "object" && m !== null) switch (m.$$typeof) {
          case B:
            Oe = 10;
            break e;
          case U:
            Oe = 9;
            break e;
          case H:
            Oe = 11;
            break e;
          case ie:
            Oe = 14;
            break e;
          case ce:
            Oe = 16, G = null;
            break e;
        }
        throw Error(t(130, m == null ? m : typeof m, ""));
    }
    return S = Fs(Oe, P, S, se), S.elementType = m, S.type = G, S.lanes = fe, S;
  }
  function Yd(m, S, P, G) {
    return m = Fs(7, m, G, S), m.lanes = P, m;
  }
  function lg(m, S, P, G) {
    return m = Fs(22, m, G, S), m.elementType = $, m.lanes = P, m.stateNode = { isHidden: !1 }, m;
  }
  function ug(m, S, P) {
    return m = Fs(6, m, null, S), m.lanes = P, m;
  }
  function Op(m, S, P) {
    return S = Fs(4, m.children !== null ? m.children : [], m.key, S), S.lanes = P, S.stateNode = { containerInfo: m.containerInfo, pendingChildren: null, implementation: m.implementation }, S;
  }
  function Dp(m, S, P, G, se) {
    this.tag = S, this.containerInfo = m, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = dc(0), this.expirationTimes = dc(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = dc(0), this.identifierPrefix = G, this.onRecoverableError = se, this.mutableSourceEagerHydrationData = null;
  }
  function q0(m, S, P, G, se, fe, Oe, $e, rt) {
    return m = new Dp(m, S, P, $e, rt), S === 1 ? (S = 1, fe === !0 && (S |= 8)) : S = 0, fe = Fs(3, null, null, S), m.current = fe, fe.stateNode = m, fe.memoizedState = { element: G, isDehydrated: P, cache: null, transitions: null, pendingSuspenseBoundaries: null }, jd(fe), m;
  }
  function my(m, S, P) {
    var G = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: k, key: G == null ? null : "" + G, children: m, containerInfo: S, implementation: P };
  }
  function G0(m) {
    if (!m) return Xe;
    m = m._reactInternals;
    e: {
      if (qr(m) !== m || m.tag !== 1) throw Error(t(170));
      var S = m;
      do {
        switch (S.tag) {
          case 3:
            S = S.stateNode.context;
            break e;
          case 1:
            if (ii(S.type)) {
              S = S.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        S = S.return;
      } while (S !== null);
      throw Error(t(171));
    }
    if (m.tag === 1) {
      var P = m.type;
      if (ii(P)) return Ou(m, P, S);
    }
    return S;
  }
  function W0(m, S, P, G, se, fe, Oe, $e, rt) {
    return m = q0(P, G, !0, m, se, fe, Oe, $e, rt), m.context = G0(null), P = m.current, G = Oo(), se = Mu(P), fe = wo(G, se), fe.callback = S ?? null, Vl(P, fe, se), m.current.lanes = se, ra(m, se, G), mo(m, G), m;
  }
  function cg(m, S, P, G) {
    var se = S.current, fe = Oo(), Oe = Mu(se);
    return P = G0(P), S.context === null ? S.context = P : S.pendingContext = P, S = wo(fe, Oe), S.payload = { element: m }, G = G === void 0 ? null : G, G !== null && (S.callback = G), m = Vl(se, S, Oe), m !== null && (Di(m, se, Oe, fe), Kf(m, se, Oe)), Oe;
  }
  function Rp(m) {
    if (m = m.current, !m.child) return null;
    switch (m.child.tag) {
      case 5:
        return m.child.stateNode;
      default:
        return m.child.stateNode;
    }
  }
  function gy(m, S) {
    if (m = m.memoizedState, m !== null && m.dehydrated !== null) {
      var P = m.retryLane;
      m.retryLane = P !== 0 && P < S ? P : S;
    }
  }
  function $0(m, S) {
    gy(m, S), (m = m.alternate) && gy(m, S);
  }
  function dE() {
    return null;
  }
  var Y0 = typeof reportError == "function" ? reportError : function(m) {
    console.error(m);
  };
  function dg(m) {
    this._internalRoot = m;
  }
  Np.prototype.render = dg.prototype.render = function(m) {
    var S = this._internalRoot;
    if (S === null) throw Error(t(409));
    cg(m, S, null, null);
  }, Np.prototype.unmount = dg.prototype.unmount = function() {
    var m = this._internalRoot;
    if (m !== null) {
      this._internalRoot = null;
      var S = m.containerInfo;
      $l(function() {
        cg(null, m, null, null);
      }), S[cl] = null;
    }
  };
  function Np(m) {
    this._internalRoot = m;
  }
  Np.prototype.unstable_scheduleHydration = function(m) {
    if (m) {
      var S = vd();
      m = { blockedOn: null, target: m, priority: S };
      for (var P = 0; P < Or.length && S !== 0 && S < Or[P].priority; P++) ;
      Or.splice(P, 0, m), P === 0 && vi(m);
    }
  };
  function qc(m) {
    return !(!m || m.nodeType !== 1 && m.nodeType !== 9 && m.nodeType !== 11);
  }
  function fg(m) {
    return !(!m || m.nodeType !== 1 && m.nodeType !== 9 && m.nodeType !== 11 && (m.nodeType !== 8 || m.nodeValue !== " react-mount-point-unstable "));
  }
  function _y() {
  }
  function fE(m, S, P, G, se) {
    if (se) {
      if (typeof G == "function") {
        var fe = G;
        G = function() {
          var Ct = Rp(Oe);
          fe.call(Ct);
        };
      }
      var Oe = W0(S, G, m, 0, null, !1, !1, "", _y);
      return m._reactRootContainer = Oe, m[cl] = Oe.current, xu(m.nodeType === 8 ? m.parentNode : m), $l(), Oe;
    }
    for (; se = m.lastChild; ) m.removeChild(se);
    if (typeof G == "function") {
      var $e = G;
      G = function() {
        var Ct = Rp(rt);
        $e.call(Ct);
      };
    }
    var rt = q0(m, 0, !1, null, null, !1, !1, "", _y);
    return m._reactRootContainer = rt, m[cl] = rt.current, xu(m.nodeType === 8 ? m.parentNode : m), $l(function() {
      cg(S, rt, P, G);
    }), rt;
  }
  function hg(m, S, P, G, se) {
    var fe = P._reactRootContainer;
    if (fe) {
      var Oe = fe;
      if (typeof se == "function") {
        var $e = se;
        se = function() {
          var rt = Rp(Oe);
          $e.call(rt);
        };
      }
      cg(S, Oe, m, se);
    } else Oe = fE(P, S, m, se, G);
    return Rp(Oe);
  }
  Tf = function(m) {
    switch (m.tag) {
      case 3:
        var S = m.stateNode;
        if (S.current.memoizedState.isDehydrated) {
          var P = el(S.pendingLanes);
          P !== 0 && (Al(S, P | 1), mo(S, fr()), !(mr & 6) && (dh = fr() + 500, Ji()));
        }
        break;
      case 13:
        $l(function() {
          var G = Ns(m, 1);
          if (G !== null) {
            var se = Oo();
            Di(G, m, 1, se);
          }
        }), $0(m, 1);
    }
  }, nl = function(m) {
    if (m.tag === 13) {
      var S = Ns(m, 134217728);
      if (S !== null) {
        var P = Oo();
        Di(S, m, 134217728, P);
      }
      $0(m, 134217728);
    }
  }, ur = function(m) {
    if (m.tag === 13) {
      var S = Mu(m), P = Ns(m, S);
      if (P !== null) {
        var G = Oo();
        Di(P, m, S, G);
      }
      $0(m, S);
    }
  }, vd = function() {
    return Er;
  }, fc = function(m, S) {
    var P = Er;
    try {
      return Er = m, S();
    } finally {
      Er = P;
    }
  }, ar = function(m, S, P) {
    switch (S) {
      case "input":
        if (qe(m, P), S = P.name, P.type === "radio" && S != null) {
          for (P = m; P.parentNode; ) P = P.parentNode;
          for (P = P.querySelectorAll("input[name=" + JSON.stringify("" + S) + '][type="radio"]'), S = 0; S < P.length; S++) {
            var G = P[S];
            if (G !== m && G.form === m.form) {
              var se = xn(G);
              if (!se) throw Error(t(90));
              Ee(G), qe(G, se);
            }
          }
        }
        break;
      case "textarea":
        Se(m, P);
        break;
      case "select":
        S = P.value, S != null && Qe(m, !!P.multiple, S, !1);
    }
  }, $n = H0, un = $l;
  var hE = { usingClientEntryPoint: !1, Events: [Rc, ku, xn, Fr, er, H0] }, Ip = { findFiberByHostInstance: Ua, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, yy = { bundleType: Ip.bundleType, version: Ip.version, rendererPackageName: Ip.rendererPackageName, rendererConfig: Ip.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: T.ReactCurrentDispatcher, findHostInstanceByFiber: function(m) {
    return m = ao(m), m === null ? null : m.stateNode;
  }, findFiberByHostInstance: Ip.findFiberByHostInstance || dE, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var pg = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!pg.isDisabled && pg.supportsFiber) try {
      vs = pg.inject(yy), Li = pg;
    } catch {
    }
  }
  return Gs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = hE, Gs.createPortal = function(m, S) {
    var P = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!qc(S)) throw Error(t(200));
    return my(m, S, null, P);
  }, Gs.createRoot = function(m, S) {
    if (!qc(m)) throw Error(t(299));
    var P = !1, G = "", se = Y0;
    return S != null && (S.unstable_strictMode === !0 && (P = !0), S.identifierPrefix !== void 0 && (G = S.identifierPrefix), S.onRecoverableError !== void 0 && (se = S.onRecoverableError)), S = q0(m, 1, !1, null, null, P, !1, G, se), m[cl] = S.current, xu(m.nodeType === 8 ? m.parentNode : m), new dg(S);
  }, Gs.findDOMNode = function(m) {
    if (m == null) return null;
    if (m.nodeType === 1) return m;
    var S = m._reactInternals;
    if (S === void 0)
      throw typeof m.render == "function" ? Error(t(188)) : (m = Object.keys(m).join(","), Error(t(268, m)));
    return m = ao(S), m = m === null ? null : m.stateNode, m;
  }, Gs.flushSync = function(m) {
    return $l(m);
  }, Gs.hydrate = function(m, S, P) {
    if (!fg(S)) throw Error(t(200));
    return hg(null, m, S, !0, P);
  }, Gs.hydrateRoot = function(m, S, P) {
    if (!qc(m)) throw Error(t(405));
    var G = P != null && P.hydratedSources || null, se = !1, fe = "", Oe = Y0;
    if (P != null && (P.unstable_strictMode === !0 && (se = !0), P.identifierPrefix !== void 0 && (fe = P.identifierPrefix), P.onRecoverableError !== void 0 && (Oe = P.onRecoverableError)), S = W0(S, null, m, 1, P ?? null, se, !1, fe, Oe), m[cl] = S.current, xu(m), G) for (m = 0; m < G.length; m++) P = G[m], se = P._getVersion, se = se(P._source), S.mutableSourceEagerHydrationData == null ? S.mutableSourceEagerHydrationData = [P, se] : S.mutableSourceEagerHydrationData.push(
      P,
      se
    );
    return new Np(S);
  }, Gs.render = function(m, S, P) {
    if (!fg(S)) throw Error(t(200));
    return hg(null, m, S, !1, P);
  }, Gs.unmountComponentAtNode = function(m) {
    if (!fg(m)) throw Error(t(40));
    return m._reactRootContainer ? ($l(function() {
      hg(null, null, m, !1, function() {
        m._reactRootContainer = null, m[cl] = null;
      });
    }), !0) : !1;
  }, Gs.unstable_batchedUpdates = H0, Gs.unstable_renderSubtreeIntoContainer = function(m, S, P, G) {
    if (!fg(P)) throw Error(t(200));
    if (m == null || m._reactInternals === void 0) throw Error(t(38));
    return hg(m, S, P, !1, G);
  }, Gs.version = "18.3.1-next-f1338f8080-20240426", Gs;
}
var Ws = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w4;
function pV() {
  return w4 || (w4 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = si, e = T7(), t = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, i = !1;
    function c(o) {
      i = o;
    }
    function a(o) {
      if (!i) {
        for (var u = arguments.length, x = new Array(u > 1 ? u - 1 : 0), D = 1; D < u; D++)
          x[D - 1] = arguments[D];
        r("warn", o, x);
      }
    }
    function s(o) {
      if (!i) {
        for (var u = arguments.length, x = new Array(u > 1 ? u - 1 : 0), D = 1; D < u; D++)
          x[D - 1] = arguments[D];
        r("error", o, x);
      }
    }
    function r(o, u, x) {
      {
        var D = t.ReactDebugCurrentFrame, F = D.getStackAddendum();
        F !== "" && (u += "%s", x = x.concat([F]));
        var Z = x.map(function(de) {
          return String(de);
        });
        Z.unshift("Warning: " + u), Function.prototype.apply.call(console[o], console, Z);
      }
    }
    var l = 0, d = 1, f = 2, h = 3, p = 4, g = 5, _ = 6, b = 7, v = 8, E = 9, C = 10, y = 11, T = 12, A = 13, k = 14, N = 15, j = 16, I = 17, B = 18, U = 19, H = 21, Q = 22, Y = 23, ie = 24, ce = 25, $ = !0, te = !1, V = !1, K = !1, ne = !1, J = !0, L = !1, z = !0, ee = !0, q = !0, X = !0, oe = /* @__PURE__ */ new Set(), ae = {}, _e = {};
    function ve(o, u) {
      Ee(o, u), Ee(o + "Capture", u);
    }
    function Ee(o, u) {
      ae[o] && s("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", o), ae[o] = u;
      {
        var x = o.toLowerCase();
        _e[x] = o, o === "onDoubleClick" && (_e.ondblclick = o);
      }
      for (var D = 0; D < u.length; D++)
        oe.add(u[D]);
    }
    var we = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ze = Object.prototype.hasOwnProperty;
    function Ie(o) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, x = u && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return x;
      }
    }
    function je(o) {
      try {
        return qe(o), !1;
      } catch {
        return !0;
      }
    }
    function qe(o) {
      return "" + o;
    }
    function Ge(o, u) {
      if (je(o))
        return s("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", u, Ie(o)), qe(o);
    }
    function Ze(o) {
      if (je(o))
        return s("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ie(o)), qe(o);
    }
    function tt(o, u) {
      if (je(o))
        return s("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", u, Ie(o)), qe(o);
    }
    function Qe(o, u) {
      if (je(o))
        return s("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", u, Ie(o)), qe(o);
    }
    function ke(o) {
      if (je(o))
        return s("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Ie(o)), qe(o);
    }
    function pe(o) {
      if (je(o))
        return s("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Ie(o)), qe(o);
    }
    var Se = 0, he = 1, Te = 2, Me = 3, Ye = 4, et = 5, dt = 6, We = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", nt = We + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ft = new RegExp("^[" + We + "][" + nt + "]*$"), At = {}, ln = {};
    function Jt(o) {
      return ze.call(ln, o) ? !0 : ze.call(At, o) ? !1 : ft.test(o) ? (ln[o] = !0, !0) : (At[o] = !0, s("Invalid attribute name: `%s`", o), !1);
    }
    function zt(o, u, x) {
      return u !== null ? u.type === Se : x ? !1 : o.length > 2 && (o[0] === "o" || o[0] === "O") && (o[1] === "n" || o[1] === "N");
    }
    function kt(o, u, x, D) {
      if (x !== null && x.type === Se)
        return !1;
      switch (typeof u) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (D)
            return !1;
          if (x !== null)
            return !x.acceptsBooleans;
          var F = o.toLowerCase().slice(0, 5);
          return F !== "data-" && F !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Ft(o, u, x, D) {
      if (u === null || typeof u > "u" || kt(o, u, x, D))
        return !0;
      if (D)
        return !1;
      if (x !== null)
        switch (x.type) {
          case Me:
            return !u;
          case Ye:
            return u === !1;
          case et:
            return isNaN(u);
          case dt:
            return isNaN(u) || u < 1;
        }
      return !1;
    }
    function ar(o) {
      return On.hasOwnProperty(o) ? On[o] : null;
    }
    function In(o, u, x, D, F, Z, de) {
      this.acceptsBooleans = u === Te || u === Me || u === Ye, this.attributeName = D, this.attributeNamespace = F, this.mustUseProperty = x, this.propertyName = o, this.type = u, this.sanitizeURL = Z, this.removeEmptyString = de;
    }
    var On = {}, ui = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    ui.forEach(function(o) {
      On[o] = new In(
        o,
        Se,
        !1,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
      var u = o[0], x = o[1];
      On[u] = new In(
        u,
        he,
        !1,
        // mustUseProperty
        x,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
      On[o] = new In(
        o,
        Te,
        !1,
        // mustUseProperty
        o.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
      On[o] = new In(
        o,
        Te,
        !1,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(o) {
      On[o] = new In(
        o,
        Me,
        !1,
        // mustUseProperty
        o.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(o) {
      On[o] = new In(
        o,
        Me,
        !0,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(o) {
      On[o] = new In(
        o,
        Ye,
        !1,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(o) {
      On[o] = new In(
        o,
        dt,
        !1,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(o) {
      On[o] = new In(
        o,
        et,
        !1,
        // mustUseProperty
        o.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Fr = /[\-\:]([a-z])/g, er = function(o) {
      return o[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(o) {
      var u = o.replace(Fr, er);
      On[u] = new In(
        u,
        he,
        !1,
        // mustUseProperty
        o,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(o) {
      var u = o.replace(Fr, er);
      On[u] = new In(
        u,
        he,
        !1,
        // mustUseProperty
        o,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(o) {
      var u = o.replace(Fr, er);
      On[u] = new In(
        u,
        he,
        !1,
        // mustUseProperty
        o,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(o) {
      On[o] = new In(
        o,
        he,
        !1,
        // mustUseProperty
        o.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var $n = "xlinkHref";
    On[$n] = new In(
      "xlinkHref",
      he,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(o) {
      On[o] = new In(
        o,
        he,
        !1,
        // mustUseProperty
        o.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var un = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, en = !1;
    function bt(o) {
      !en && un.test(o) && (en = !0, s("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(o)));
    }
    function Pt(o, u, x, D) {
      if (D.mustUseProperty) {
        var F = D.propertyName;
        return o[F];
      } else {
        Ge(x, u), D.sanitizeURL && bt("" + x);
        var Z = D.attributeName, de = null;
        if (D.type === Ye) {
          if (o.hasAttribute(Z)) {
            var ge = o.getAttribute(Z);
            return ge === "" ? !0 : Ft(u, x, D, !1) ? ge : ge === "" + x ? x : ge;
          }
        } else if (o.hasAttribute(Z)) {
          if (Ft(u, x, D, !1))
            return o.getAttribute(Z);
          if (D.type === Me)
            return x;
          de = o.getAttribute(Z);
        }
        return Ft(u, x, D, !1) ? de === null ? x : de : de === "" + x ? x : de;
      }
    }
    function fn(o, u, x, D) {
      {
        if (!Jt(u))
          return;
        if (!o.hasAttribute(u))
          return x === void 0 ? void 0 : null;
        var F = o.getAttribute(u);
        return Ge(x, u), F === "" + x ? x : F;
      }
    }
    function cn(o, u, x, D) {
      var F = ar(u);
      if (!zt(u, F, D)) {
        if (Ft(u, x, F, D) && (x = null), D || F === null) {
          if (Jt(u)) {
            var Z = u;
            x === null ? o.removeAttribute(Z) : (Ge(x, u), o.setAttribute(Z, "" + x));
          }
          return;
        }
        var de = F.mustUseProperty;
        if (de) {
          var ge = F.propertyName;
          if (x === null) {
            var xe = F.type;
            o[ge] = xe === Me ? !1 : "";
          } else
            o[ge] = x;
          return;
        }
        var Le = F.attributeName, Ue = F.attributeNamespace;
        if (x === null)
          o.removeAttribute(Le);
        else {
          var st = F.type, ot;
          st === Me || st === Ye && x === !0 ? ot = "" : (Ge(x, Le), ot = "" + x, F.sanitizeURL && bt(ot.toString())), Ue ? o.setAttributeNS(Ue, Le, ot) : o.setAttribute(Le, ot);
        }
      }
    }
    var Vn = Symbol.for("react.element"), En = Symbol.for("react.portal"), Kt = Symbol.for("react.fragment"), Dn = Symbol.for("react.strict_mode"), Kn = Symbol.for("react.profiler"), vr = Symbol.for("react.provider"), Ii = Symbol.for("react.context"), vo = Symbol.for("react.forward_ref"), qr = Symbol.for("react.suspense"), _r = Symbol.for("react.suspense_list"), sr = Symbol.for("react.memo"), br = Symbol.for("react.lazy"), ao = Symbol.for("react.scope"), Zi = Symbol.for("react.debug_trace_mode"), di = Symbol.for("react.offscreen"), Lo = Symbol.for("react.legacy_hidden"), La = Symbol.for("react.cache"), Ai = Symbol.for("react.tracing_marker"), fr = Symbol.iterator, Ma = "@@iterator";
    function pa(o) {
      if (o === null || typeof o != "object")
        return null;
      var u = fr && o[fr] || o[Ma];
      return typeof u == "function" ? u : null;
    }
    var Qn = Object.assign, Pa = 0, lc, ma, vs, Li, uc, Mo, xf;
    function cc() {
    }
    cc.__reactDisabledLog = !0;
    function Jh() {
      {
        if (Pa === 0) {
          lc = console.log, ma = console.info, vs = console.warn, Li = console.error, uc = console.group, Mo = console.groupCollapsed, xf = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: cc,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        Pa++;
      }
    }
    function bs() {
      {
        if (Pa--, Pa === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Qn({}, o, {
              value: lc
            }),
            info: Qn({}, o, {
              value: ma
            }),
            warn: Qn({}, o, {
              value: vs
            }),
            error: Qn({}, o, {
              value: Li
            }),
            group: Qn({}, o, {
              value: uc
            }),
            groupCollapsed: Qn({}, o, {
              value: Mo
            }),
            groupEnd: Qn({}, o, {
              value: xf
            })
          });
        }
        Pa < 0 && s("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ur = t.ReactCurrentDispatcher, el;
    function so(o, u, x) {
      {
        if (el === void 0)
          try {
            throw Error();
          } catch (F) {
            var D = F.stack.trim().match(/\n( *(at )?)/);
            el = D && D[1] || "";
          }
        return `
` + el + o;
      }
    }
    var tl = !1, ja;
    {
      var Tl = typeof WeakMap == "function" ? WeakMap : Map;
      ja = new Tl();
    }
    function ns(o, u) {
      if (!o || tl)
        return "";
      {
        var x = ja.get(o);
        if (x !== void 0)
          return x;
      }
      var D;
      tl = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Z;
      Z = Ur.current, Ur.current = null, Jh();
      try {
        if (u) {
          var de = function() {
            throw Error();
          };
          if (Object.defineProperty(de.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(de, []);
            } catch (wt) {
              D = wt;
            }
            Reflect.construct(o, [], de);
          } else {
            try {
              de.call();
            } catch (wt) {
              D = wt;
            }
            o.call(de.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (wt) {
            D = wt;
          }
          o();
        }
      } catch (wt) {
        if (wt && D && typeof wt.stack == "string") {
          for (var ge = wt.stack.split(`
`), xe = D.stack.split(`
`), Le = ge.length - 1, Ue = xe.length - 1; Le >= 1 && Ue >= 0 && ge[Le] !== xe[Ue]; )
            Ue--;
          for (; Le >= 1 && Ue >= 0; Le--, Ue--)
            if (ge[Le] !== xe[Ue]) {
              if (Le !== 1 || Ue !== 1)
                do
                  if (Le--, Ue--, Ue < 0 || ge[Le] !== xe[Ue]) {
                    var st = `
` + ge[Le].replace(" at new ", " at ");
                    return o.displayName && st.includes("<anonymous>") && (st = st.replace("<anonymous>", o.displayName)), typeof o == "function" && ja.set(o, st), st;
                  }
                while (Le >= 1 && Ue >= 0);
              break;
            }
        }
      } finally {
        tl = !1, Ur.current = Z, bs(), Error.prepareStackTrace = F;
      }
      var ot = o ? o.displayName || o.name : "", Et = ot ? so(ot) : "";
      return typeof o == "function" && ja.set(o, Et), Et;
    }
    function dc(o, u, x) {
      return ns(o, !0);
    }
    function ra(o, u, x) {
      return ns(o, !1);
    }
    function _d(o) {
      var u = o.prototype;
      return !!(u && u.isReactComponent);
    }
    function Al(o, u, x) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return ns(o, _d(o));
      if (typeof o == "string")
        return so(o);
      switch (o) {
        case qr:
          return so("Suspense");
        case _r:
          return so("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case vo:
            return ra(o.render);
          case sr:
            return Al(o.type, u, x);
          case br: {
            var D = o, F = D._payload, Z = D._init;
            try {
              return Al(Z(F), u, x);
            } catch {
            }
          }
        }
      return "";
    }
    function Er(o) {
      switch (o._debugOwner && o._debugOwner.type, o._debugSource, o.tag) {
        case g:
          return so(o.type);
        case j:
          return so("Lazy");
        case A:
          return so("Suspense");
        case U:
          return so("SuspenseList");
        case l:
        case f:
        case N:
          return ra(o.type);
        case y:
          return ra(o.type.render);
        case d:
          return dc(o.type);
        default:
          return "";
      }
    }
    function yd(o) {
      try {
        var u = "", x = o;
        do
          u += Er(x), x = x.return;
        while (x);
        return u;
      } catch (D) {
        return `
Error generating stack: ` + D.message + `
` + D.stack;
      }
    }
    function Tf(o, u, x) {
      var D = o.displayName;
      if (D)
        return D;
      var F = u.displayName || u.name || "";
      return F !== "" ? x + "(" + F + ")" : x;
    }
    function nl(o) {
      return o.displayName || "Context";
    }
    function ur(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && s("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case Kt:
          return "Fragment";
        case En:
          return "Portal";
        case Kn:
          return "Profiler";
        case Dn:
          return "StrictMode";
        case qr:
          return "Suspense";
        case _r:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case Ii:
            var u = o;
            return nl(u) + ".Consumer";
          case vr:
            var x = o;
            return nl(x._context) + ".Provider";
          case vo:
            return Tf(o, o.render, "ForwardRef");
          case sr:
            var D = o.displayName || null;
            return D !== null ? D : ur(o.type) || "Memo";
          case br: {
            var F = o, Z = F._payload, de = F._init;
            try {
              return ur(de(Z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function vd(o, u, x) {
      var D = u.displayName || u.name || "";
      return o.displayName || (D !== "" ? x + "(" + D + ")" : x);
    }
    function fc(o) {
      return o.displayName || "Context";
    }
    function Yn(o) {
      var u = o.tag, x = o.type;
      switch (u) {
        case ie:
          return "Cache";
        case E:
          var D = x;
          return fc(D) + ".Consumer";
        case C:
          var F = x;
          return fc(F._context) + ".Provider";
        case B:
          return "DehydratedFragment";
        case y:
          return vd(x, x.render, "ForwardRef");
        case b:
          return "Fragment";
        case g:
          return x;
        case p:
          return "Portal";
        case h:
          return "Root";
        case _:
          return "Text";
        case j:
          return ur(x);
        case v:
          return x === Dn ? "StrictMode" : "Mode";
        case Q:
          return "Offscreen";
        case T:
          return "Profiler";
        case H:
          return "Scope";
        case A:
          return "Suspense";
        case U:
          return "SuspenseList";
        case ce:
          return "TracingMarker";
        case d:
        case l:
        case I:
        case f:
        case k:
        case N:
          if (typeof x == "function")
            return x.displayName || x.name || null;
          if (typeof x == "string")
            return x;
          break;
      }
      return null;
    }
    var Es = t.ReactDebugCurrentFrame, ni = null, Po = !1;
    function lo() {
      {
        if (ni === null)
          return null;
        var o = ni._debugOwner;
        if (o !== null && typeof o < "u")
          return Yn(o);
      }
      return null;
    }
    function kl() {
      return ni === null ? "" : yd(ni);
    }
    function fi() {
      Es.getCurrentStack = null, ni = null, Po = !1;
    }
    function Or(o) {
      Es.getCurrentStack = o === null ? null : kl, ni = o, Po = !1;
    }
    function ep() {
      return ni;
    }
    function jo(o) {
      Po = o;
    }
    function Mi(o) {
      return "" + o;
    }
    function Bo(o) {
      switch (typeof o) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return o;
        case "object":
          return pe(o), o;
        default:
          return "";
      }
    }
    var vi = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ol(o, u) {
      vi[u.type] || u.onChange || u.onInput || u.readOnly || u.disabled || u.value == null || s("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), u.onChange || u.readOnly || u.disabled || u.checked == null || s("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function hc(o) {
      var u = o.type, x = o.nodeName;
      return x && x.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
    }
    function Af(o) {
      return o._valueTracker;
    }
    function du(o) {
      o._valueTracker = null;
    }
    function qn(o) {
      var u = "";
      return o && (hc(o) ? u = o.checked ? "true" : "false" : u = o.value), u;
    }
    function Ss(o) {
      var u = hc(o) ? "checked" : "value", x = Object.getOwnPropertyDescriptor(o.constructor.prototype, u);
      pe(o[u]);
      var D = "" + o[u];
      if (!(o.hasOwnProperty(u) || typeof x > "u" || typeof x.get != "function" || typeof x.set != "function")) {
        var F = x.get, Z = x.set;
        Object.defineProperty(o, u, {
          configurable: !0,
          get: function() {
            return F.call(this);
          },
          set: function(ge) {
            pe(ge), D = "" + ge, Z.call(this, ge);
          }
        }), Object.defineProperty(o, u, {
          enumerable: x.enumerable
        });
        var de = {
          getValue: function() {
            return D;
          },
          setValue: function(ge) {
            pe(ge), D = "" + ge;
          },
          stopTracking: function() {
            du(o), delete o[u];
          }
        };
        return de;
      }
    }
    function Ba(o) {
      Af(o) || (o._valueTracker = Ss(o));
    }
    function kf(o) {
      if (!o)
        return !1;
      var u = Af(o);
      if (!u)
        return !0;
      var x = u.getValue(), D = qn(o);
      return D !== x ? (u.setValue(D), !0) : !1;
    }
    function pc(o) {
      if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u")
        return null;
      try {
        return o.activeElement || o.body;
      } catch {
        return o.body;
      }
    }
    var fu = !1, hu = !1, mc = !1, bd = !1;
    function rs(o) {
      var u = o.type === "checkbox" || o.type === "radio";
      return u ? o.checked != null : o.value != null;
    }
    function pu(o, u) {
      var x = o, D = u.checked, F = Qn({}, u, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: D ?? x._wrapperState.initialChecked
      });
      return F;
    }
    function Cs(o, u) {
      Ol("input", u), u.checked !== void 0 && u.defaultChecked !== void 0 && !hu && (s("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", lo() || "A component", u.type), hu = !0), u.value !== void 0 && u.defaultValue !== void 0 && !fu && (s("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", lo() || "A component", u.type), fu = !0);
      var x = o, D = u.defaultValue == null ? "" : u.defaultValue;
      x._wrapperState = {
        initialChecked: u.checked != null ? u.checked : u.defaultChecked,
        initialValue: Bo(u.value != null ? u.value : D),
        controlled: rs(u)
      };
    }
    function Ed(o, u) {
      var x = o, D = u.checked;
      D != null && cn(x, "checked", D, !1);
    }
    function ws(o, u) {
      var x = o;
      {
        var D = rs(u);
        !x._wrapperState.controlled && D && !bd && (s("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), bd = !0), x._wrapperState.controlled && !D && !mc && (s("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), mc = !0);
      }
      Ed(o, u);
      var F = Bo(u.value), Z = u.type;
      if (F != null)
        Z === "number" ? (F === 0 && x.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        x.value != F) && (x.value = Mi(F)) : x.value !== Mi(F) && (x.value = Mi(F));
      else if (Z === "submit" || Z === "reset") {
        x.removeAttribute("value");
        return;
      }
      u.hasOwnProperty("value") ? xs(x, u.type, F) : u.hasOwnProperty("defaultValue") && xs(x, u.type, Bo(u.defaultValue)), u.checked == null && u.defaultChecked != null && (x.defaultChecked = !!u.defaultChecked);
    }
    function gc(o, u, x) {
      var D = o;
      if (u.hasOwnProperty("value") || u.hasOwnProperty("defaultValue")) {
        var F = u.type, Z = F === "submit" || F === "reset";
        if (Z && (u.value === void 0 || u.value === null))
          return;
        var de = Mi(D._wrapperState.initialValue);
        x || de !== D.value && (D.value = de), D.defaultValue = de;
      }
      var ge = D.name;
      ge !== "" && (D.name = ""), D.defaultChecked = !D.defaultChecked, D.defaultChecked = !!D._wrapperState.initialChecked, ge !== "" && (D.name = ge);
    }
    function Of(o, u) {
      var x = o;
      ws(x, u), Fo(x, u);
    }
    function Fo(o, u) {
      var x = u.name;
      if (u.type === "radio" && x != null) {
        for (var D = o; D.parentNode; )
          D = D.parentNode;
        Ge(x, "name");
        for (var F = D.querySelectorAll("input[name=" + JSON.stringify("" + x) + '][type="radio"]'), Z = 0; Z < F.length; Z++) {
          var de = F[Z];
          if (!(de === o || de.form !== o.form)) {
            var ge = My(de);
            if (!ge)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            kf(de), ws(de, ge);
          }
        }
      }
    }
    function xs(o, u, x) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (u !== "number" || pc(o.ownerDocument) !== o) && (x == null ? o.defaultValue = Mi(o._wrapperState.initialValue) : o.defaultValue !== Mi(x) && (o.defaultValue = Mi(x)));
    }
    var _c = !1, Dl = !1, Df = !1;
    function yc(o, u) {
      u.value == null && (typeof u.children == "object" && u.children !== null ? n.Children.forEach(u.children, function(x) {
        x != null && (typeof x == "string" || typeof x == "number" || Dl || (Dl = !0, s("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : u.dangerouslySetInnerHTML != null && (Df || (Df = !0, s("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), u.selected != null && !_c && (s("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), _c = !0);
    }
    function Sd(o, u) {
      u.value != null && o.setAttribute("value", Mi(Bo(u.value)));
    }
    var mu = Array.isArray;
    function Pi(o) {
      return mu(o);
    }
    var vc;
    vc = !1;
    function Rf() {
      var o = lo();
      return o ? `

Check the render method of \`` + o + "`." : "";
    }
    var Ts = ["value", "defaultValue"];
    function bc(o) {
      {
        Ol("select", o);
        for (var u = 0; u < Ts.length; u++) {
          var x = Ts[u];
          if (o[x] != null) {
            var D = Pi(o[x]);
            o.multiple && !D ? s("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", x, Rf()) : !o.multiple && D && s("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", x, Rf());
          }
        }
      }
    }
    function is(o, u, x, D) {
      var F = o.options;
      if (u) {
        for (var Z = x, de = {}, ge = 0; ge < Z.length; ge++)
          de["$" + Z[ge]] = !0;
        for (var xe = 0; xe < F.length; xe++) {
          var Le = de.hasOwnProperty("$" + F[xe].value);
          F[xe].selected !== Le && (F[xe].selected = Le), Le && D && (F[xe].defaultSelected = !0);
        }
      } else {
        for (var Ue = Mi(Bo(x)), st = null, ot = 0; ot < F.length; ot++) {
          if (F[ot].value === Ue) {
            F[ot].selected = !0, D && (F[ot].defaultSelected = !0);
            return;
          }
          st === null && !F[ot].disabled && (st = F[ot]);
        }
        st !== null && (st.selected = !0);
      }
    }
    function hi(o, u) {
      return Qn({}, u, {
        value: void 0
      });
    }
    function Ec(o, u) {
      var x = o;
      bc(u), x._wrapperState = {
        wasMultiple: !!u.multiple
      }, u.value !== void 0 && u.defaultValue !== void 0 && !vc && (s("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), vc = !0);
    }
    function Nf(o, u) {
      var x = o;
      x.multiple = !!u.multiple;
      var D = u.value;
      D != null ? is(x, !!u.multiple, D, !1) : u.defaultValue != null && is(x, !!u.multiple, u.defaultValue, !0);
    }
    function be(o, u) {
      var x = o, D = x._wrapperState.wasMultiple;
      x._wrapperState.wasMultiple = !!u.multiple;
      var F = u.value;
      F != null ? is(x, !!u.multiple, F, !1) : D !== !!u.multiple && (u.defaultValue != null ? is(x, !!u.multiple, u.defaultValue, !0) : is(x, !!u.multiple, u.multiple ? [] : "", !1));
    }
    function le(o, u) {
      var x = o, D = u.value;
      D != null && is(x, !!u.multiple, D, !1);
    }
    var ye = !1;
    function Be(o, u) {
      var x = o;
      if (u.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var D = Qn({}, u, {
        value: void 0,
        defaultValue: void 0,
        children: Mi(x._wrapperState.initialValue)
      });
      return D;
    }
    function Ke(o, u) {
      var x = o;
      Ol("textarea", u), u.value !== void 0 && u.defaultValue !== void 0 && !ye && (s("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", lo() || "A component"), ye = !0);
      var D = u.value;
      if (D == null) {
        var F = u.children, Z = u.defaultValue;
        if (F != null) {
          s("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (Z != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Pi(F)) {
              if (F.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              F = F[0];
            }
            Z = F;
          }
        }
        Z == null && (Z = ""), D = Z;
      }
      x._wrapperState = {
        initialValue: Bo(D)
      };
    }
    function Ot(o, u) {
      var x = o, D = Bo(u.value), F = Bo(u.defaultValue);
      if (D != null) {
        var Z = Mi(D);
        Z !== x.value && (x.value = Z), u.defaultValue == null && x.defaultValue !== Z && (x.defaultValue = Z);
      }
      F != null && (x.defaultValue = Mi(F));
    }
    function Wt(o, u) {
      var x = o, D = x.textContent;
      D === x._wrapperState.initialValue && D !== "" && D !== null && (x.value = D);
    }
    function hn(o, u) {
      Ot(o, u);
    }
    var Rn = "http://www.w3.org/1999/xhtml", yr = "http://www.w3.org/1998/Math/MathML", Sr = "http://www.w3.org/2000/svg";
    function ri(o) {
      switch (o) {
        case "svg":
          return Sr;
        case "math":
          return yr;
        default:
          return Rn;
      }
    }
    function Rl(o, u) {
      return o == null || o === Rn ? ri(u) : o === Sr && u === "foreignObject" ? Rn : o;
    }
    var tp = function(o) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(u, x, D, F) {
        MSApp.execUnsafeLocalFunction(function() {
          return o(u, x, D, F);
        });
      } : o;
    }, gu, If = tp(function(o, u) {
      if (o.namespaceURI === Sr && !("innerHTML" in o)) {
        gu = gu || document.createElement("div"), gu.innerHTML = "<svg>" + u.valueOf().toString() + "</svg>";
        for (var x = gu.firstChild; o.firstChild; )
          o.removeChild(o.firstChild);
        for (; x.firstChild; )
          o.appendChild(x.firstChild);
        return;
      }
      o.innerHTML = u;
    }), uo = 1, os = 3, pi = 8, ga = 9, rl = 11, Nl = function(o, u) {
      if (u) {
        var x = o.firstChild;
        if (x && x === o.lastChild && x.nodeType === os) {
          x.nodeValue = u;
          return;
        }
      }
      o.textContent = u;
    }, _u = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, il = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function yu(o, u) {
      return o + u.charAt(0).toUpperCase() + u.substring(1);
    }
    var vu = ["Webkit", "ms", "Moz", "O"];
    Object.keys(il).forEach(function(o) {
      vu.forEach(function(u) {
        il[yu(u, o)] = il[o];
      });
    });
    function bu(o, u, x) {
      var D = u == null || typeof u == "boolean" || u === "";
      return D ? "" : !x && typeof u == "number" && u !== 0 && !(il.hasOwnProperty(o) && il[o]) ? u + "px" : (Qe(u, o), ("" + u).trim());
    }
    var ol = /([A-Z])/g, np = /^ms-/;
    function rp(o) {
      return o.replace(ol, "-$1").toLowerCase().replace(np, "-ms-");
    }
    var Lf = function() {
    };
    {
      var al = /^(?:webkit|moz|o)[A-Z]/, Sc = /^-ms-/, Cd = /-(.)/g, Eu = /;\s*$/, Il = {}, Su = {}, ip = !1, Cc = !1, Mf = function(o) {
        return o.replace(Cd, function(u, x) {
          return x.toUpperCase();
        });
      }, Pe = function(o) {
        Il.hasOwnProperty(o) && Il[o] || (Il[o] = !0, s(
          "Unsupported style property %s. Did you mean %s?",
          o,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Mf(o.replace(Sc, "ms-"))
        ));
      }, Pm = function(o) {
        Il.hasOwnProperty(o) && Il[o] || (Il[o] = !0, s("Unsupported vendor-prefixed style property %s. Did you mean %s?", o, o.charAt(0).toUpperCase() + o.slice(1)));
      }, xt = function(o, u) {
        Su.hasOwnProperty(u) && Su[u] || (Su[u] = !0, s(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, o, u.replace(Eu, "")));
      }, op = function(o, u) {
        ip || (ip = !0, s("`NaN` is an invalid value for the `%s` css style property.", o));
      }, jm = function(o, u) {
        Cc || (Cc = !0, s("`Infinity` is an invalid value for the `%s` css style property.", o));
      };
      Lf = function(o, u) {
        o.indexOf("-") > -1 ? Pe(o) : al.test(o) ? Pm(o) : Eu.test(u) && xt(o, u), typeof u == "number" && (isNaN(u) ? op(o, u) : isFinite(u) || jm(o, u));
      };
    }
    var Bm = Lf;
    function Pf(o) {
      {
        var u = "", x = "";
        for (var D in o)
          if (o.hasOwnProperty(D)) {
            var F = o[D];
            if (F != null) {
              var Z = D.indexOf("--") === 0;
              u += x + (Z ? D : rp(D)) + ":", u += bu(D, F, Z), x = ";";
            }
          }
        return u || null;
      }
    }
    function Fm(o, u) {
      var x = o.style;
      for (var D in u)
        if (u.hasOwnProperty(D)) {
          var F = D.indexOf("--") === 0;
          F || Bm(D, u[D]);
          var Z = bu(D, u[D], F);
          D === "float" && (D = "cssFloat"), F ? x.setProperty(D, Z) : x[D] = Z;
        }
    }
    function Cr(o) {
      return o == null || typeof o == "boolean" || o === "";
    }
    function Fa(o) {
      var u = {};
      for (var x in o)
        for (var D = _u[x] || [x], F = 0; F < D.length; F++)
          u[D[F]] = x;
      return u;
    }
    function wd(o, u) {
      {
        if (!u)
          return;
        var x = Fa(o), D = Fa(u), F = {};
        for (var Z in x) {
          var de = x[Z], ge = D[Z];
          if (ge && de !== ge) {
            var xe = de + "," + ge;
            if (F[xe])
              continue;
            F[xe] = !0, s("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Cr(o[de]) ? "Removing" : "Updating", de, ge);
          }
        }
      }
    }
    var ap = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Tt = Qn({
      menuitem: !0
    }, ap), sl = "__html";
    function bo(o, u) {
      if (u) {
        if (Tt[o] && (u.children != null || u.dangerouslySetInnerHTML != null))
          throw new Error(o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (u.dangerouslySetInnerHTML != null) {
          if (u.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof u.dangerouslySetInnerHTML != "object" || !(sl in u.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!u.suppressContentEditableWarning && u.contentEditable && u.children != null && s("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), u.style != null && typeof u.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function ht(o, u) {
      if (o.indexOf("-") === -1)
        return typeof u.is == "string";
      switch (o) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var re = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ji = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, ia = {}, Ll = new RegExp("^(aria)-[" + nt + "]*$"), xd = new RegExp("^(aria)[A-Z][" + nt + "]*$");
    function Cu(o, u) {
      {
        if (ze.call(ia, u) && ia[u])
          return !0;
        if (xd.test(u)) {
          var x = "aria-" + u.slice(4).toLowerCase(), D = ji.hasOwnProperty(x) ? x : null;
          if (D == null)
            return s("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", u), ia[u] = !0, !0;
          if (u !== D)
            return s("Invalid ARIA attribute `%s`. Did you mean `%s`?", u, D), ia[u] = !0, !0;
        }
        if (Ll.test(u)) {
          var F = u.toLowerCase(), Z = ji.hasOwnProperty(F) ? F : null;
          if (Z == null)
            return ia[u] = !0, !1;
          if (u !== Z)
            return s("Unknown ARIA attribute `%s`. Did you mean `%s`?", u, Z), ia[u] = !0, !0;
        }
      }
      return !0;
    }
    function Vt(o, u) {
      {
        var x = [];
        for (var D in u) {
          var F = Cu(o, D);
          F || x.push(D);
        }
        var Z = x.map(function(de) {
          return "`" + de + "`";
        }).join(", ");
        x.length === 1 ? s("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Z, o) : x.length > 1 && s("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Z, o);
      }
    }
    function Td(o, u) {
      ht(o, u) || Vt(o, u);
    }
    var ll = !1;
    function sp(o, u) {
      {
        if (o !== "input" && o !== "textarea" && o !== "select")
          return;
        u != null && u.value === null && !ll && (ll = !0, o === "select" && u.multiple ? s("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", o) : s("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", o));
      }
    }
    var jf = function() {
    };
    {
      var ki = {}, lp = /^on./, He = /^on[^A-Z]/, Um = new RegExp("^(aria)-[" + nt + "]*$"), Uo = new RegExp("^(aria)[A-Z][" + nt + "]*$");
      jf = function(o, u, x, D) {
        if (ze.call(ki, u) && ki[u])
          return !0;
        var F = u.toLowerCase();
        if (F === "onfocusin" || F === "onfocusout")
          return s("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ki[u] = !0, !0;
        if (D != null) {
          var Z = D.registrationNameDependencies, de = D.possibleRegistrationNames;
          if (Z.hasOwnProperty(u))
            return !0;
          var ge = de.hasOwnProperty(F) ? de[F] : null;
          if (ge != null)
            return s("Invalid event handler property `%s`. Did you mean `%s`?", u, ge), ki[u] = !0, !0;
          if (lp.test(u))
            return s("Unknown event handler property `%s`. It will be ignored.", u), ki[u] = !0, !0;
        } else if (lp.test(u))
          return He.test(u) && s("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", u), ki[u] = !0, !0;
        if (Um.test(u) || Uo.test(u))
          return !0;
        if (F === "innerhtml")
          return s("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ki[u] = !0, !0;
        if (F === "aria")
          return s("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ki[u] = !0, !0;
        if (F === "is" && x !== null && x !== void 0 && typeof x != "string")
          return s("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof x), ki[u] = !0, !0;
        if (typeof x == "number" && isNaN(x))
          return s("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", u), ki[u] = !0, !0;
        var xe = ar(u), Le = xe !== null && xe.type === Se;
        if (re.hasOwnProperty(F)) {
          var Ue = re[F];
          if (Ue !== u)
            return s("Invalid DOM property `%s`. Did you mean `%s`?", u, Ue), ki[u] = !0, !0;
        } else if (!Le && u !== F)
          return s("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", u, F), ki[u] = !0, !0;
        return typeof x == "boolean" && kt(u, x, xe, !1) ? (x ? s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', x, u, u, x, u) : s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', x, u, u, x, u, u, u), ki[u] = !0, !0) : Le ? !0 : kt(u, x, xe, !1) ? (ki[u] = !0, !1) : ((x === "false" || x === "true") && xe !== null && xe.type === Me && (s("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", x, u, x === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', u, x), ki[u] = !0), !0);
      };
    }
    var wc = function(o, u, x) {
      {
        var D = [];
        for (var F in u) {
          var Z = jf(o, F, u[F], x);
          Z || D.push(F);
        }
        var de = D.map(function(ge) {
          return "`" + ge + "`";
        }).join(", ");
        D.length === 1 ? s("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", de, o) : D.length > 1 && s("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", de, o);
      }
    };
    function xc(o, u, x) {
      ht(o, u) || wc(o, u, x);
    }
    var Eo = 1, wu = 2, Ml = 4, Hm = Eo | wu | Ml, Tc = null;
    function Ac(o) {
      Tc !== null && s("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Tc = o;
    }
    function w0() {
      Tc === null && s("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Tc = null;
    }
    function Ad(o) {
      return o === Tc;
    }
    function Bf(o) {
      var u = o.target || o.srcElement || window;
      return u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === os ? u.parentNode : u;
    }
    var Mr = null, So = null, As = null;
    function xu(o) {
      var u = _h(o);
      if (u) {
        if (typeof Mr != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var x = u.stateNode;
        if (x) {
          var D = My(x);
          Mr(u.stateNode, u.type, D);
        }
      }
    }
    function kd(o) {
      Mr = o;
    }
    function Ff(o) {
      So ? As ? As.push(o) : As = [o] : So = o;
    }
    function Od() {
      return So !== null || As !== null;
    }
    function Dd() {
      if (So) {
        var o = So, u = As;
        if (So = null, As = null, xu(o), u)
          for (var x = 0; x < u.length; x++)
            xu(u[x]);
      }
    }
    var Tu = function(o, u) {
      return o(u);
    }, up = function() {
    }, cp = !1;
    function Uf() {
      var o = Od();
      o && (up(), Dd());
    }
    function dp(o, u, x) {
      if (cp)
        return o(u, x);
      cp = !0;
      try {
        return Tu(o, u, x);
      } finally {
        cp = !1, Uf();
      }
    }
    function Rd(o, u, x) {
      Tu = o, up = x;
    }
    function Hf(o) {
      return o === "button" || o === "input" || o === "select" || o === "textarea";
    }
    function kc(o, u, x) {
      switch (o) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(x.disabled && Hf(u));
        default:
          return !1;
      }
    }
    function Pl(o, u) {
      var x = o.stateNode;
      if (x === null)
        return null;
      var D = My(x);
      if (D === null)
        return null;
      var F = D[u];
      if (kc(u, o.type, D))
        return null;
      if (F && typeof F != "function")
        throw new Error("Expected `" + u + "` listener to be a function, instead got a value of `" + typeof F + "` type.");
      return F;
    }
    var Oc = !1;
    if (we)
      try {
        var jl = {};
        Object.defineProperty(jl, "passive", {
          get: function() {
            Oc = !0;
          }
        }), window.addEventListener("test", jl, jl), window.removeEventListener("test", jl, jl);
      } catch {
        Oc = !1;
      }
    function Bl(o, u, x, D, F, Z, de, ge, xe) {
      var Le = Array.prototype.slice.call(arguments, 3);
      try {
        u.apply(x, Le);
      } catch (Ue) {
        this.onError(Ue);
      }
    }
    var zf = Bl;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var fp = document.createElement("react");
      zf = function(u, x, D, F, Z, de, ge, xe, Le) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var Ue = document.createEvent("Event"), st = !1, ot = !0, Et = window.event, wt = Object.getOwnPropertyDescriptor(window, "event");
        function Dt() {
          fp.removeEventListener(Rt, Ln, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Et);
        }
        var tn = Array.prototype.slice.call(arguments, 3);
        function Ln() {
          st = !0, Dt(), x.apply(D, tn), ot = !1;
        }
        var Tn, xr = !1, gr = !1;
        function gt(_t) {
          if (Tn = _t.error, xr = !0, Tn === null && _t.colno === 0 && _t.lineno === 0 && (gr = !0), _t.defaultPrevented && Tn != null && typeof Tn == "object")
            try {
              Tn._suppressLogging = !0;
            } catch {
            }
        }
        var Rt = "react-" + (u || "invokeguardedcallback");
        if (window.addEventListener("error", gt), fp.addEventListener(Rt, Ln, !1), Ue.initEvent(Rt, !1, !1), fp.dispatchEvent(Ue), wt && Object.defineProperty(window, "event", wt), st && ot && (xr ? gr && (Tn = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Tn = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Tn)), window.removeEventListener("error", gt), !st)
          return Dt(), Bl.apply(this, arguments);
      };
    }
    var x0 = zf, ul = !1, as = null, Dc = !1, Fl = null, ks = {
      onError: function(o) {
        ul = !0, as = o;
      }
    };
    function Au(o, u, x, D, F, Z, de, ge, xe) {
      ul = !1, as = null, x0.apply(ks, arguments);
    }
    function cl(o, u, x, D, F, Z, de, ge, xe) {
      if (Au.apply(this, arguments), ul) {
        var Le = pp();
        Dc || (Dc = !0, Fl = Le);
      }
    }
    function hp() {
      if (Dc) {
        var o = Fl;
        throw Dc = !1, Fl = null, o;
      }
    }
    function T0() {
      return ul;
    }
    function pp() {
      if (ul) {
        var o = as;
        return ul = !1, as = null, o;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ua(o) {
      return o._reactInternals;
    }
    function Rc(o) {
      return o._reactInternals !== void 0;
    }
    function ku(o, u) {
      o._reactInternals = u;
    }
    var xn = (
      /*                      */
      0
    ), ss = (
      /*                */
      1
    ), Yr = (
      /*                    */
      2
    ), Fn = (
      /*                       */
      4
    ), Tr = (
      /*                */
      16
    ), Ar = (
      /*                 */
      32
    ), Xe = (
      /*                     */
      64
    ), Gn = (
      /*                   */
      128
    ), bi = (
      /*            */
      256
    ), oa = (
      /*                          */
      512
    ), Ha = (
      /*                     */
      1024
    ), ii = (
      /*                      */
      2048
    ), _a = (
      /*                    */
      4096
    ), dl = (
      /*                   */
      8192
    ), Ou = (
      /*             */
      16384
    ), Nc = ii | Fn | Xe | oa | Ha | Ou, Vf = (
      /*               */
      32767
    ), co = (
      /*                   */
      32768
    ), Ei = (
      /*                */
      65536
    ), fl = (
      /* */
      131072
    ), ya = (
      /*                       */
      1048576
    ), hl = (
      /*                    */
      2097152
    ), Ji = (
      /*                 */
      4194304
    ), za = (
      /*                */
      8388608
    ), eo = (
      /*               */
      16777216
    ), Os = (
      /*              */
      33554432
    ), Du = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Fn | Ha | 0
    ), Ho = Yr | Fn | Tr | Ar | oa | _a | dl, fo = Fn | Xe | oa | dl, va = ii | Tr, to = Ji | za | hl, Ds = t.ReactCurrentOwner;
    function Hr(o) {
      var u = o, x = o;
      if (o.alternate)
        for (; u.return; )
          u = u.return;
      else {
        var D = u;
        do
          u = D, (u.flags & (Yr | _a)) !== xn && (x = u.return), D = u.return;
        while (D);
      }
      return u.tag === h ? x : null;
    }
    function qf(o) {
      if (o.tag === A) {
        var u = o.memoizedState;
        if (u === null) {
          var x = o.alternate;
          x !== null && (u = x.memoizedState);
        }
        if (u !== null)
          return u.dehydrated;
      }
      return null;
    }
    function Ru(o) {
      return o.tag === h ? o.stateNode.containerInfo : null;
    }
    function Gf(o) {
      return Hr(o) === o;
    }
    function zo(o) {
      {
        var u = Ds.current;
        if (u !== null && u.tag === d) {
          var x = u, D = x.stateNode;
          D._warnedAboutRefsInRender || s("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Yn(x) || "A component"), D._warnedAboutRefsInRender = !0;
        }
      }
      var F = Ua(o);
      return F ? Hr(F) === F : !1;
    }
    function qi(o) {
      if (Hr(o) !== o)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Pr(o) {
      var u = o.alternate;
      if (!u) {
        var x = Hr(o);
        if (x === null)
          throw new Error("Unable to find node on an unmounted component.");
        return x !== o ? null : o;
      }
      for (var D = o, F = u; ; ) {
        var Z = D.return;
        if (Z === null)
          break;
        var de = Z.alternate;
        if (de === null) {
          var ge = Z.return;
          if (ge !== null) {
            D = F = ge;
            continue;
          }
          break;
        }
        if (Z.child === de.child) {
          for (var xe = Z.child; xe; ) {
            if (xe === D)
              return qi(Z), o;
            if (xe === F)
              return qi(Z), u;
            xe = xe.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (D.return !== F.return)
          D = Z, F = de;
        else {
          for (var Le = !1, Ue = Z.child; Ue; ) {
            if (Ue === D) {
              Le = !0, D = Z, F = de;
              break;
            }
            if (Ue === F) {
              Le = !0, F = Z, D = de;
              break;
            }
            Ue = Ue.sibling;
          }
          if (!Le) {
            for (Ue = de.child; Ue; ) {
              if (Ue === D) {
                Le = !0, D = de, F = Z;
                break;
              }
              if (Ue === F) {
                Le = !0, F = de, D = Z;
                break;
              }
              Ue = Ue.sibling;
            }
            if (!Le)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (D.alternate !== F)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (D.tag !== h)
        throw new Error("Unable to find node on an unmounted component.");
      return D.stateNode.current === D ? o : u;
    }
    function Co(o) {
      var u = Pr(o);
      return u !== null ? Wf(u) : null;
    }
    function Wf(o) {
      if (o.tag === g || o.tag === _)
        return o;
      for (var u = o.child; u !== null; ) {
        var x = Wf(u);
        if (x !== null)
          return x;
        u = u.sibling;
      }
      return null;
    }
    function mp(o) {
      var u = Pr(o);
      return u !== null ? Ul(u) : null;
    }
    function Ul(o) {
      if (o.tag === g || o.tag === _)
        return o;
      for (var u = o.child; u !== null; ) {
        if (u.tag !== p) {
          var x = Ul(u);
          if (x !== null)
            return x;
        }
        u = u.sibling;
      }
      return null;
    }
    var Nd = e.unstable_scheduleCallback, $f = e.unstable_cancelCallback, Nu = e.unstable_shouldYield, Id = e.unstable_requestPaint, oi = e.unstable_now, Ic = e.unstable_getCurrentPriorityLevel, Ld = e.unstable_ImmediatePriority, Hl = e.unstable_UserBlockingPriority, ls = e.unstable_NormalPriority, gp = e.unstable_LowPriority, Md = e.unstable_IdlePriority, pl = e.unstable_yieldValue, Pd = e.unstable_setDisableYieldValue, Rs = null, Bi = null, Xt = null, ba = !1, aa = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Yf(o) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var u = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (u.isDisabled)
        return !0;
      if (!u.supportsFiber)
        return s("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        ee && (o = Qn({}, o, {
          getLaneLabelMap: Ns,
          injectProfilingHooks: _p
        })), Rs = u.inject(o), Bi = u;
      } catch (x) {
        s("React instrumentation encountered an error: %s.", x);
      }
      return !!u.checkDCE;
    }
    function Xf(o, u) {
      if (Bi && typeof Bi.onScheduleFiberRoot == "function")
        try {
          Bi.onScheduleFiberRoot(Rs, o, u);
        } catch (x) {
          ba || (ba = !0, s("React instrumentation encountered an error: %s", x));
        }
    }
    function Lc(o, u) {
      if (Bi && typeof Bi.onCommitFiberRoot == "function")
        try {
          var x = (o.current.flags & Gn) === Gn;
          if (q) {
            var D;
            switch (u) {
              case Yi:
                D = Ld;
                break;
              case Iu:
                D = Hl;
                break;
              case ql:
                D = ls;
                break;
              case eh:
                D = Md;
                break;
              default:
                D = ls;
                break;
            }
            Bi.onCommitFiberRoot(Rs, o, D, x);
          }
        } catch (F) {
          ba || (ba = !0, s("React instrumentation encountered an error: %s", F));
        }
    }
    function Va(o) {
      if (Bi && typeof Bi.onPostCommitFiberRoot == "function")
        try {
          Bi.onPostCommitFiberRoot(Rs, o);
        } catch (u) {
          ba || (ba = !0, s("React instrumentation encountered an error: %s", u));
        }
    }
    function zl(o) {
      if (Bi && typeof Bi.onCommitFiberUnmount == "function")
        try {
          Bi.onCommitFiberUnmount(Rs, o);
        } catch (u) {
          ba || (ba = !0, s("React instrumentation encountered an error: %s", u));
        }
    }
    function mi(o) {
      if (typeof pl == "function" && (Pd(o), c(o)), Bi && typeof Bi.setStrictMode == "function")
        try {
          Bi.setStrictMode(Rs, o);
        } catch (u) {
          ba || (ba = !0, s("React instrumentation encountered an error: %s", u));
        }
    }
    function _p(o) {
      Xt = o;
    }
    function Ns() {
      {
        for (var o = /* @__PURE__ */ new Map(), u = 1, x = 0; x < Fd; x++) {
          var D = Wi(u);
          o.set(u, D), u *= 2;
        }
        return o;
      }
    }
    function ml(o) {
      Xt !== null && typeof Xt.markCommitStarted == "function" && Xt.markCommitStarted(o);
    }
    function jd() {
      Xt !== null && typeof Xt.markCommitStopped == "function" && Xt.markCommitStopped();
    }
    function us(o) {
      Xt !== null && typeof Xt.markComponentRenderStarted == "function" && Xt.markComponentRenderStarted(o);
    }
    function wo() {
      Xt !== null && typeof Xt.markComponentRenderStopped == "function" && Xt.markComponentRenderStopped();
    }
    function Vl(o) {
      Xt !== null && typeof Xt.markComponentPassiveEffectMountStarted == "function" && Xt.markComponentPassiveEffectMountStarted(o);
    }
    function Kf() {
      Xt !== null && typeof Xt.markComponentPassiveEffectMountStopped == "function" && Xt.markComponentPassiveEffectMountStopped();
    }
    function an(o) {
      Xt !== null && typeof Xt.markComponentPassiveEffectUnmountStarted == "function" && Xt.markComponentPassiveEffectUnmountStarted(o);
    }
    function Lt() {
      Xt !== null && typeof Xt.markComponentPassiveEffectUnmountStopped == "function" && Xt.markComponentPassiveEffectUnmountStopped();
    }
    function Is(o) {
      Xt !== null && typeof Xt.markComponentLayoutEffectMountStarted == "function" && Xt.markComponentLayoutEffectMountStarted(o);
    }
    function Bd() {
      Xt !== null && typeof Xt.markComponentLayoutEffectMountStopped == "function" && Xt.markComponentLayoutEffectMountStopped();
    }
    function sa(o) {
      Xt !== null && typeof Xt.markComponentLayoutEffectUnmountStarted == "function" && Xt.markComponentLayoutEffectUnmountStarted(o);
    }
    function Mc() {
      Xt !== null && typeof Xt.markComponentLayoutEffectUnmountStopped == "function" && Xt.markComponentLayoutEffectUnmountStopped();
    }
    function Ea(o, u, x) {
      Xt !== null && typeof Xt.markComponentErrored == "function" && Xt.markComponentErrored(o, u, x);
    }
    function Ls(o, u, x) {
      Xt !== null && typeof Xt.markComponentSuspended == "function" && Xt.markComponentSuspended(o, u, x);
    }
    function Qf(o) {
      Xt !== null && typeof Xt.markLayoutEffectsStarted == "function" && Xt.markLayoutEffectsStarted(o);
    }
    function Gi() {
      Xt !== null && typeof Xt.markLayoutEffectsStopped == "function" && Xt.markLayoutEffectsStopped();
    }
    function zm(o) {
      Xt !== null && typeof Xt.markPassiveEffectsStarted == "function" && Xt.markPassiveEffectsStarted(o);
    }
    function Pc() {
      Xt !== null && typeof Xt.markPassiveEffectsStopped == "function" && Xt.markPassiveEffectsStopped();
    }
    function ci(o) {
      Xt !== null && typeof Xt.markRenderStarted == "function" && Xt.markRenderStarted(o);
    }
    function Xr() {
      Xt !== null && typeof Xt.markRenderYielded == "function" && Xt.markRenderYielded();
    }
    function yt() {
      Xt !== null && typeof Xt.markRenderStopped == "function" && Xt.markRenderStopped();
    }
    function Ve(o) {
      Xt !== null && typeof Xt.markRenderScheduled == "function" && Xt.markRenderScheduled(o);
    }
    function De(o, u) {
      Xt !== null && typeof Xt.markForceUpdateScheduled == "function" && Xt.markForceUpdateScheduled(o, u);
    }
    function ct(o, u) {
      Xt !== null && typeof Xt.markStateUpdateScheduled == "function" && Xt.markStateUpdateScheduled(o, u);
    }
    var vn = (
      /*                         */
      0
    ), Sn = (
      /*                 */
      1
    ), Un = (
      /*                    */
      2
    ), lr = (
      /*               */
      8
    ), Sa = (
      /*              */
      16
    ), jc = Math.clz32 ? Math.clz32 : xo, Bc = Math.log, A0 = Math.LN2;
    function xo(o) {
      var u = o >>> 0;
      return u === 0 ? 32 : 31 - (Bc(u) / A0 | 0) | 0;
    }
    var Fd = 31, jt = (
      /*                        */
      0
    ), M = (
      /*                          */
      0
    ), O = (
      /*                        */
      1
    ), w = (
      /*    */
      2
    ), R = (
      /*             */
      4
    ), W = (
      /*            */
      8
    ), ue = (
      /*                     */
      16
    ), me = (
      /*                */
      32
    ), Ae = (
      /*                       */
      4194240
    ), Ne = (
      /*                        */
      64
    ), Fe = (
      /*                        */
      128
    ), ut = (
      /*                        */
      256
    ), Je = (
      /*                        */
      512
    ), pt = (
      /*                        */
      1024
    ), Nt = (
      /*                        */
      2048
    ), Bt = (
      /*                        */
      4096
    ), Qt = (
      /*                        */
      8192
    ), Cn = (
      /*                        */
      16384
    ), mn = (
      /*                       */
      32768
    ), kn = (
      /*                       */
      65536
    ), Zn = (
      /*                       */
      131072
    ), Dr = (
      /*                       */
      262144
    ), Kr = (
      /*                       */
      524288
    ), Nn = (
      /*                       */
      1048576
    ), Oi = (
      /*                       */
      2097152
    ), cr = (
      /*                            */
      130023424
    ), zr = (
      /*                             */
      4194304
    ), To = (
      /*                             */
      8388608
    ), tr = (
      /*                             */
      16777216
    ), Pn = (
      /*                             */
      33554432
    ), kr = (
      /*                             */
      67108864
    ), Ca = zr, la = (
      /*          */
      134217728
    ), no = (
      /*                          */
      268435455
    ), ro = (
      /*               */
      268435456
    ), jr = (
      /*                        */
      536870912
    ), gi = (
      /*                   */
      1073741824
    );
    function Wi(o) {
      {
        if (o & O)
          return "Sync";
        if (o & w)
          return "InputContinuousHydration";
        if (o & R)
          return "InputContinuous";
        if (o & W)
          return "DefaultHydration";
        if (o & ue)
          return "Default";
        if (o & me)
          return "TransitionHydration";
        if (o & Ae)
          return "Transition";
        if (o & cr)
          return "Retry";
        if (o & la)
          return "SelectiveHydration";
        if (o & ro)
          return "IdleHydration";
        if (o & jr)
          return "Idle";
        if (o & gi)
          return "Offscreen";
      }
    }
    var Gr = -1, Ud = Ne, Vo = zr;
    function gl(o) {
      switch ($i(o)) {
        case O:
          return O;
        case w:
          return w;
        case R:
          return R;
        case W:
          return W;
        case ue:
          return ue;
        case me:
          return me;
        case Ne:
        case Fe:
        case ut:
        case Je:
        case pt:
        case Nt:
        case Bt:
        case Qt:
        case Cn:
        case mn:
        case kn:
        case Zn:
        case Dr:
        case Kr:
        case Nn:
        case Oi:
          return o & Ae;
        case zr:
        case To:
        case tr:
        case Pn:
        case kr:
          return o & cr;
        case la:
          return la;
        case ro:
          return ro;
        case jr:
          return jr;
        case gi:
          return gi;
        default:
          return s("Should have found matching lanes. This is a bug in React."), o;
      }
    }
    function _l(o, u) {
      var x = o.pendingLanes;
      if (x === jt)
        return jt;
      var D = jt, F = o.suspendedLanes, Z = o.pingedLanes, de = x & no;
      if (de !== jt) {
        var ge = de & ~F;
        if (ge !== jt)
          D = gl(ge);
        else {
          var xe = de & Z;
          xe !== jt && (D = gl(xe));
        }
      } else {
        var Le = x & ~F;
        Le !== jt ? D = gl(Le) : Z !== jt && (D = gl(Z));
      }
      if (D === jt)
        return jt;
      if (u !== jt && u !== D && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (u & F) === jt) {
        var Ue = $i(D), st = $i(u);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          Ue >= st || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          Ue === ue && (st & Ae) !== jt
        )
          return u;
      }
      (D & R) !== jt && (D |= x & ue);
      var ot = o.entangledLanes;
      if (ot !== jt)
        for (var Et = o.entanglements, wt = D & ot; wt > 0; ) {
          var Dt = Uc(wt), tn = 1 << Dt;
          D |= Et[Dt], wt &= ~tn;
        }
      return D;
    }
    function Zf(o, u) {
      for (var x = o.eventTimes, D = Gr; u > 0; ) {
        var F = Uc(u), Z = 1 << F, de = x[F];
        de > D && (D = de), u &= ~Z;
      }
      return D;
    }
    function yp(o, u) {
      switch (o) {
        case O:
        case w:
        case R:
          return u + 250;
        case W:
        case ue:
        case me:
        case Ne:
        case Fe:
        case ut:
        case Je:
        case pt:
        case Nt:
        case Bt:
        case Qt:
        case Cn:
        case mn:
        case kn:
        case Zn:
        case Dr:
        case Kr:
        case Nn:
        case Oi:
          return u + 5e3;
        case zr:
        case To:
        case tr:
        case Pn:
        case kr:
          return Gr;
        case la:
        case ro:
        case jr:
        case gi:
          return Gr;
        default:
          return s("Should have found matching lanes. This is a bug in React."), Gr;
      }
    }
    function Vm(o, u) {
      for (var x = o.pendingLanes, D = o.suspendedLanes, F = o.pingedLanes, Z = o.expirationTimes, de = x; de > 0; ) {
        var ge = Uc(de), xe = 1 << ge, Le = Z[ge];
        Le === Gr ? ((xe & D) === jt || (xe & F) !== jt) && (Z[ge] = yp(xe, u)) : Le <= u && (o.expiredLanes |= xe), de &= ~xe;
      }
    }
    function k0(o) {
      return gl(o.pendingLanes);
    }
    function Fc(o) {
      var u = o.pendingLanes & ~gi;
      return u !== jt ? u : u & gi ? gi : jt;
    }
    function O0(o) {
      return (o & O) !== jt;
    }
    function vp(o) {
      return (o & no) !== jt;
    }
    function Y1(o) {
      return (o & cr) === o;
    }
    function X1(o) {
      var u = O | R | ue;
      return (o & u) === jt;
    }
    function K1(o) {
      return (o & Ae) === o;
    }
    function bp(o, u) {
      var x = w | R | W | ue;
      return (u & x) !== jt;
    }
    function Q1(o, u) {
      return (u & o.expiredLanes) !== jt;
    }
    function D0(o) {
      return (o & Ae) !== jt;
    }
    function Z1() {
      var o = Ud;
      return Ud <<= 1, (Ud & Ae) === jt && (Ud = Ne), o;
    }
    function qa() {
      var o = Vo;
      return Vo <<= 1, (Vo & cr) === jt && (Vo = zr), o;
    }
    function $i(o) {
      return o & -o;
    }
    function Jf(o) {
      return $i(o);
    }
    function Uc(o) {
      return 31 - jc(o);
    }
    function qm(o) {
      return Uc(o);
    }
    function Ga(o, u) {
      return (o & u) !== jt;
    }
    function Hd(o, u) {
      return (o & u) === u;
    }
    function or(o, u) {
      return o | u;
    }
    function Ep(o, u) {
      return o & ~u;
    }
    function Gm(o, u) {
      return o & u;
    }
    function J2(o) {
      return o;
    }
    function J1(o, u) {
      return o !== M && o < u ? o : u;
    }
    function Sp(o) {
      for (var u = [], x = 0; x < Fd; x++)
        u.push(o);
      return u;
    }
    function zd(o, u, x) {
      o.pendingLanes |= u, u !== jr && (o.suspendedLanes = jt, o.pingedLanes = jt);
      var D = o.eventTimes, F = qm(u);
      D[F] = x;
    }
    function ey(o, u) {
      o.suspendedLanes |= u, o.pingedLanes &= ~u;
      for (var x = o.expirationTimes, D = u; D > 0; ) {
        var F = Uc(D), Z = 1 << F;
        x[F] = Gr, D &= ~Z;
      }
    }
    function Wm(o, u, x) {
      o.pingedLanes |= o.suspendedLanes & u;
    }
    function $m(o, u) {
      var x = o.pendingLanes & ~u;
      o.pendingLanes = u, o.suspendedLanes = jt, o.pingedLanes = jt, o.expiredLanes &= u, o.mutableReadLanes &= u, o.entangledLanes &= u;
      for (var D = o.entanglements, F = o.eventTimes, Z = o.expirationTimes, de = x; de > 0; ) {
        var ge = Uc(de), xe = 1 << ge;
        D[ge] = jt, F[ge] = Gr, Z[ge] = Gr, de &= ~xe;
      }
    }
    function R0(o, u) {
      for (var x = o.entangledLanes |= u, D = o.entanglements, F = x; F; ) {
        var Z = Uc(F), de = 1 << Z;
        // Is this one of the newly entangled lanes?
        de & u | // Is this lane transitively entangled with the newly entangled lanes?
        D[Z] & u && (D[Z] |= u), F &= ~de;
      }
    }
    function ty(o, u) {
      var x = $i(u), D;
      switch (x) {
        case R:
          D = w;
          break;
        case ue:
          D = W;
          break;
        case Ne:
        case Fe:
        case ut:
        case Je:
        case pt:
        case Nt:
        case Bt:
        case Qt:
        case Cn:
        case mn:
        case kn:
        case Zn:
        case Dr:
        case Kr:
        case Nn:
        case Oi:
        case zr:
        case To:
        case tr:
        case Pn:
        case kr:
          D = me;
          break;
        case jr:
          D = ro;
          break;
        default:
          D = M;
          break;
      }
      return (D & (o.suspendedLanes | u)) !== M ? M : D;
    }
    function Ym(o, u, x) {
      if (aa)
        for (var D = o.pendingUpdatersLaneMap; x > 0; ) {
          var F = qm(x), Z = 1 << F, de = D[F];
          de.add(u), x &= ~Z;
        }
    }
    function N0(o, u) {
      if (aa)
        for (var x = o.pendingUpdatersLaneMap, D = o.memoizedUpdaters; u > 0; ) {
          var F = qm(u), Z = 1 << F, de = x[F];
          de.size > 0 && (de.forEach(function(ge) {
            var xe = ge.alternate;
            (xe === null || !D.has(xe)) && D.add(ge);
          }), de.clear()), u &= ~Z;
        }
    }
    function Cp(o, u) {
      return null;
    }
    var Yi = O, Iu = R, ql = ue, eh = jr, th = M;
    function Ms() {
      return th;
    }
    function Fi(o) {
      th = o;
    }
    function ua(o, u) {
      var x = th;
      try {
        return th = o, u();
      } finally {
        th = x;
      }
    }
    function eE(o, u) {
      return o !== 0 && o < u ? o : u;
    }
    function tE(o, u) {
      return o > u ? o : u;
    }
    function nh(o, u) {
      return o !== 0 && o < u;
    }
    function qo(o) {
      var u = $i(o);
      return nh(Yi, u) ? nh(Iu, u) ? vp(u) ? ql : eh : Iu : Yi;
    }
    function Xm(o) {
      var u = o.current.memoizedState;
      return u.isDehydrated;
    }
    var dn;
    function rh(o) {
      dn = o;
    }
    function I0(o) {
      dn(o);
    }
    var Km;
    function nE(o) {
      Km = o;
    }
    var ih;
    function Qm(o) {
      ih = o;
    }
    var Zm;
    function ny(o) {
      Zm = o;
    }
    var L0;
    function ry(o) {
      L0 = o;
    }
    var wp = !1, oh = [], Si = null, Ao = null, wa = null, ah = /* @__PURE__ */ new Map(), sh = /* @__PURE__ */ new Map(), ko = [], iy = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Gl(o) {
      return iy.indexOf(o) > -1;
    }
    function rE(o, u, x, D, F) {
      return {
        blockedOn: o,
        domEventName: u,
        eventSystemFlags: x,
        nativeEvent: F,
        targetContainers: [D]
      };
    }
    function M0(o, u) {
      switch (o) {
        case "focusin":
        case "focusout":
          Si = null;
          break;
        case "dragenter":
        case "dragleave":
          Ao = null;
          break;
        case "mouseover":
        case "mouseout":
          wa = null;
          break;
        case "pointerover":
        case "pointerout": {
          var x = u.pointerId;
          ah.delete(x);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var D = u.pointerId;
          sh.delete(D);
          break;
        }
      }
    }
    function lh(o, u, x, D, F, Z) {
      if (o === null || o.nativeEvent !== Z) {
        var de = rE(u, x, D, F, Z);
        if (u !== null) {
          var ge = _h(u);
          ge !== null && Km(ge);
        }
        return de;
      }
      o.eventSystemFlags |= D;
      var xe = o.targetContainers;
      return F !== null && xe.indexOf(F) === -1 && xe.push(F), o;
    }
    function oy(o, u, x, D, F) {
      switch (u) {
        case "focusin": {
          var Z = F;
          return Si = lh(Si, o, u, x, D, Z), !0;
        }
        case "dragenter": {
          var de = F;
          return Ao = lh(Ao, o, u, x, D, de), !0;
        }
        case "mouseover": {
          var ge = F;
          return wa = lh(wa, o, u, x, D, ge), !0;
        }
        case "pointerover": {
          var xe = F, Le = xe.pointerId;
          return ah.set(Le, lh(ah.get(Le) || null, o, u, x, D, xe)), !0;
        }
        case "gotpointercapture": {
          var Ue = F, st = Ue.pointerId;
          return sh.set(st, lh(sh.get(st) || null, o, u, x, D, Ue)), !0;
        }
      }
      return !1;
    }
    function P0(o) {
      var u = Pp(o.target);
      if (u !== null) {
        var x = Hr(u);
        if (x !== null) {
          var D = x.tag;
          if (D === A) {
            var F = qf(x);
            if (F !== null) {
              o.blockedOn = F, L0(o.priority, function() {
                ih(x);
              });
              return;
            }
          } else if (D === h) {
            var Z = x.stateNode;
            if (Xm(Z)) {
              o.blockedOn = Ru(x);
              return;
            }
          }
        }
      }
      o.blockedOn = null;
    }
    function iE(o) {
      for (var u = Zm(), x = {
        blockedOn: null,
        target: o,
        priority: u
      }, D = 0; D < ko.length && nh(u, ko[D].priority); D++)
        ;
      ko.splice(D, 0, x), D === 0 && P0(x);
    }
    function Vd(o) {
      if (o.blockedOn !== null)
        return !1;
      for (var u = o.targetContainers; u.length > 0; ) {
        var x = u[0], D = ca(o.domEventName, o.eventSystemFlags, x, o.nativeEvent);
        if (D === null) {
          var F = o.nativeEvent, Z = new F.constructor(F.type, F);
          Ac(Z), F.target.dispatchEvent(Z), w0();
        } else {
          var de = _h(D);
          return de !== null && Km(de), o.blockedOn = D, !1;
        }
        u.shift();
      }
      return !0;
    }
    function Jm(o, u, x) {
      Vd(o) && x.delete(u);
    }
    function Ps() {
      wp = !1, Si !== null && Vd(Si) && (Si = null), Ao !== null && Vd(Ao) && (Ao = null), wa !== null && Vd(wa) && (wa = null), ah.forEach(Jm), sh.forEach(Jm);
    }
    function mr(o, u) {
      o.blockedOn === u && (o.blockedOn = null, wp || (wp = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, Ps)));
    }
    function Ui(o) {
      if (oh.length > 0) {
        mr(oh[0], o);
        for (var u = 1; u < oh.length; u++) {
          var x = oh[u];
          x.blockedOn === o && (x.blockedOn = null);
        }
      }
      Si !== null && mr(Si, o), Ao !== null && mr(Ao, o), wa !== null && mr(wa, o);
      var D = function(ge) {
        return mr(ge, o);
      };
      ah.forEach(D), sh.forEach(D);
      for (var F = 0; F < ko.length; F++) {
        var Z = ko[F];
        Z.blockedOn === o && (Z.blockedOn = null);
      }
      for (; ko.length > 0; ) {
        var de = ko[0];
        if (de.blockedOn !== null)
          break;
        P0(de), de.blockedOn === null && ko.shift();
      }
    }
    var _i = t.ReactCurrentBatchConfig, ho = !0;
    function Wa(o) {
      ho = !!o;
    }
    function uh() {
      return ho;
    }
    function po(o, u, x) {
      var D = eg(u), F;
      switch (D) {
        case Yi:
          F = xp;
          break;
        case Iu:
          F = qd;
          break;
        case ql:
        default:
          F = ch;
          break;
      }
      return F.bind(null, u, x, o);
    }
    function xp(o, u, x, D) {
      var F = Ms(), Z = _i.transition;
      _i.transition = null;
      try {
        Fi(Yi), ch(o, u, x, D);
      } finally {
        Fi(F), _i.transition = Z;
      }
    }
    function qd(o, u, x, D) {
      var F = Ms(), Z = _i.transition;
      _i.transition = null;
      try {
        Fi(Iu), ch(o, u, x, D);
      } finally {
        Fi(F), _i.transition = Z;
      }
    }
    function ch(o, u, x, D) {
      ho && j0(o, u, x, D);
    }
    function j0(o, u, x, D) {
      var F = ca(o, u, x, D);
      if (F === null) {
        EE(o, u, D, Hc, x), M0(o, D);
        return;
      }
      if (oy(F, o, u, x, D)) {
        D.stopPropagation();
        return;
      }
      if (M0(o, D), u & Ml && Gl(o)) {
        for (; F !== null; ) {
          var Z = _h(F);
          Z !== null && I0(Z);
          var de = ca(o, u, x, D);
          if (de === null && EE(o, u, D, Hc, x), de === F)
            break;
          F = de;
        }
        F !== null && D.stopPropagation();
        return;
      }
      EE(o, u, D, null, x);
    }
    var Hc = null;
    function ca(o, u, x, D) {
      Hc = null;
      var F = Bf(D), Z = Pp(F);
      if (Z !== null) {
        var de = Hr(Z);
        if (de === null)
          Z = null;
        else {
          var ge = de.tag;
          if (ge === A) {
            var xe = qf(de);
            if (xe !== null)
              return xe;
            Z = null;
          } else if (ge === h) {
            var Le = de.stateNode;
            if (Xm(Le))
              return Ru(de);
            Z = null;
          } else de !== Z && (Z = null);
        }
      }
      return Hc = Z, null;
    }
    function eg(o) {
      switch (o) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Yi;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Iu;
        case "message": {
          var u = Ic();
          switch (u) {
            case Ld:
              return Yi;
            case Hl:
              return Iu;
            case ls:
            case gp:
              return ql;
            case Md:
              return eh;
            default:
              return ql;
          }
        }
        default:
          return ql;
      }
    }
    function dh(o, u, x) {
      return o.addEventListener(u, x, !1), x;
    }
    function Lu(o, u, x) {
      return o.addEventListener(u, x, !0), x;
    }
    function tg(o, u, x, D) {
      return o.addEventListener(u, x, {
        capture: !0,
        passive: D
      }), x;
    }
    function B0(o, u, x, D) {
      return o.addEventListener(u, x, {
        passive: D
      }), x;
    }
    var js = null, fh = null, Bs = null;
    function ng(o) {
      return js = o, fh = Ap(), !0;
    }
    function Tp() {
      js = null, fh = null, Bs = null;
    }
    function rg() {
      if (Bs)
        return Bs;
      var o, u = fh, x = u.length, D, F = Ap(), Z = F.length;
      for (o = 0; o < x && u[o] === F[o]; o++)
        ;
      var de = x - o;
      for (D = 1; D <= de && u[x - D] === F[Z - D]; D++)
        ;
      var ge = D > 1 ? 1 - D : void 0;
      return Bs = F.slice(o, ge), Bs;
    }
    function Ap() {
      return "value" in js ? js.value : js.textContent;
    }
    function Gd(o) {
      var u, x = o.keyCode;
      return "charCode" in o ? (u = o.charCode, u === 0 && x === 13 && (u = 13)) : u = x, u === 10 && (u = 13), u >= 32 || u === 13 ? u : 0;
    }
    function Oo() {
      return !0;
    }
    function Mu() {
      return !1;
    }
    function Di(o) {
      function u(x, D, F, Z, de) {
        this._reactName = x, this._targetInst = F, this.type = D, this.nativeEvent = Z, this.target = de, this.currentTarget = null;
        for (var ge in o)
          if (o.hasOwnProperty(ge)) {
            var xe = o[ge];
            xe ? this[ge] = xe(Z) : this[ge] = Z[ge];
          }
        var Le = Z.defaultPrevented != null ? Z.defaultPrevented : Z.returnValue === !1;
        return Le ? this.isDefaultPrevented = Oo : this.isDefaultPrevented = Mu, this.isPropagationStopped = Mu, this;
      }
      return Qn(u.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var x = this.nativeEvent;
          x && (x.preventDefault ? x.preventDefault() : typeof x.returnValue != "unknown" && (x.returnValue = !1), this.isDefaultPrevented = Oo);
        },
        stopPropagation: function() {
          var x = this.nativeEvent;
          x && (x.stopPropagation ? x.stopPropagation() : typeof x.cancelBubble != "unknown" && (x.cancelBubble = !0), this.isPropagationStopped = Oo);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Oo
      }), u;
    }
    var mo = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(o) {
        return o.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, ig = Di(mo), Wd = Qn({}, mo, {
      view: 0,
      detail: 0
    }), F0 = Di(Wd), U0, Wl, hh;
    function H0(o) {
      o !== hh && (hh && o.type === "mousemove" ? (U0 = o.screenX - hh.screenX, Wl = o.screenY - hh.screenY) : (U0 = 0, Wl = 0), hh = o);
    }
    var $l = Qn({}, Wd, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: z0,
      button: 0,
      buttons: 0,
      relatedTarget: function(o) {
        return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
      },
      movementX: function(o) {
        return "movementX" in o ? o.movementX : (H0(o), U0);
      },
      movementY: function(o) {
        return "movementY" in o ? o.movementY : Wl;
      }
    }), og = Di($l), $d = Qn({}, $l, {
      dataTransfer: 0
    }), ay = Di($d), sy = Qn({}, Wd, {
      relatedTarget: 0
    }), kp = Di(sy), ag = Qn({}, mo, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), oE = Di(ag), aE = Qn({}, mo, {
      clipboardData: function(o) {
        return "clipboardData" in o ? o.clipboardData : window.clipboardData;
      }
    }), ly = Di(aE), uy = Qn({}, mo, {
      data: 0
    }), zc = Di(uy), sE = zc, ph = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, cy = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Hi(o) {
      if (o.key) {
        var u = ph[o.key] || o.key;
        if (u !== "Unidentified")
          return u;
      }
      if (o.type === "keypress") {
        var x = Gd(o);
        return x === 13 ? "Enter" : String.fromCharCode(x);
      }
      return o.type === "keydown" || o.type === "keyup" ? cy[o.keyCode] || "Unidentified" : "";
    }
    var lE = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function dy(o) {
      var u = this, x = u.nativeEvent;
      if (x.getModifierState)
        return x.getModifierState(o);
      var D = lE[o];
      return D ? !!x[D] : !1;
    }
    function z0(o) {
      return dy;
    }
    var uE = Qn({}, Wd, {
      key: Hi,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: z0,
      // Legacy Interface
      charCode: function(o) {
        return o.type === "keypress" ? Gd(o) : 0;
      },
      keyCode: function(o) {
        return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
      },
      which: function(o) {
        return o.type === "keypress" ? Gd(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
      }
    }), fy = Di(uE), hy = Qn({}, $l, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), py = Di(hy), Fs = Qn({}, Wd, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: z0
    }), V0 = Di(Fs), cE = Qn({}, mo, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Vc = Di(cE), sg = Qn({}, $l, {
      deltaX: function(o) {
        return "deltaX" in o ? o.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in o ? -o.wheelDeltaX : 0
        );
      },
      deltaY: function(o) {
        return "deltaY" in o ? o.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in o ? -o.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in o ? -o.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Yd = Di(sg), lg = [9, 13, 27, 32], ug = 229, Op = we && "CompositionEvent" in window, Dp = null;
    we && "documentMode" in document && (Dp = document.documentMode);
    var q0 = we && "TextEvent" in window && !Dp, my = we && (!Op || Dp && Dp > 8 && Dp <= 11), G0 = 32, W0 = String.fromCharCode(G0);
    function cg() {
      ve("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), ve("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), ve("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), ve("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Rp = !1;
    function gy(o) {
      return (o.ctrlKey || o.altKey || o.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(o.ctrlKey && o.altKey);
    }
    function $0(o) {
      switch (o) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function dE(o, u) {
      return o === "keydown" && u.keyCode === ug;
    }
    function Y0(o, u) {
      switch (o) {
        case "keyup":
          return lg.indexOf(u.keyCode) !== -1;
        case "keydown":
          return u.keyCode !== ug;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function dg(o) {
      var u = o.detail;
      return typeof u == "object" && "data" in u ? u.data : null;
    }
    function Np(o) {
      return o.locale === "ko";
    }
    var qc = !1;
    function fg(o, u, x, D, F) {
      var Z, de;
      if (Op ? Z = $0(u) : qc ? Y0(u, D) && (Z = "onCompositionEnd") : dE(u, D) && (Z = "onCompositionStart"), !Z)
        return null;
      my && !Np(D) && (!qc && Z === "onCompositionStart" ? qc = ng(F) : Z === "onCompositionEnd" && qc && (de = rg()));
      var ge = Sy(x, Z);
      if (ge.length > 0) {
        var xe = new zc(Z, u, null, D, F);
        if (o.push({
          event: xe,
          listeners: ge
        }), de)
          xe.data = de;
        else {
          var Le = dg(D);
          Le !== null && (xe.data = Le);
        }
      }
    }
    function _y(o, u) {
      switch (o) {
        case "compositionend":
          return dg(u);
        case "keypress":
          var x = u.which;
          return x !== G0 ? null : (Rp = !0, W0);
        case "textInput":
          var D = u.data;
          return D === W0 && Rp ? null : D;
        default:
          return null;
      }
    }
    function fE(o, u) {
      if (qc) {
        if (o === "compositionend" || !Op && Y0(o, u)) {
          var x = rg();
          return Tp(), qc = !1, x;
        }
        return null;
      }
      switch (o) {
        case "paste":
          return null;
        case "keypress":
          if (!gy(u)) {
            if (u.char && u.char.length > 1)
              return u.char;
            if (u.which)
              return String.fromCharCode(u.which);
          }
          return null;
        case "compositionend":
          return my && !Np(u) ? null : u.data;
        default:
          return null;
      }
    }
    function hg(o, u, x, D, F) {
      var Z;
      if (q0 ? Z = _y(u, D) : Z = fE(u, D), !Z)
        return null;
      var de = Sy(x, "onBeforeInput");
      if (de.length > 0) {
        var ge = new sE("onBeforeInput", "beforeinput", null, D, F);
        o.push({
          event: ge,
          listeners: de
        }), ge.data = Z;
      }
    }
    function hE(o, u, x, D, F, Z, de) {
      fg(o, u, x, D, F), hg(o, u, x, D, F);
    }
    var Ip = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function yy(o) {
      var u = o && o.nodeName && o.nodeName.toLowerCase();
      return u === "input" ? !!Ip[o.type] : u === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function pg(o) {
      if (!we)
        return !1;
      var u = "on" + o, x = u in document;
      if (!x) {
        var D = document.createElement("div");
        D.setAttribute(u, "return;"), x = typeof D[u] == "function";
      }
      return x;
    }
    function m() {
      ve("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function S(o, u, x, D) {
      Ff(D);
      var F = Sy(u, "onChange");
      if (F.length > 0) {
        var Z = new ig("onChange", "change", null, x, D);
        o.push({
          event: Z,
          listeners: F
        });
      }
    }
    var P = null, G = null;
    function se(o) {
      var u = o.nodeName && o.nodeName.toLowerCase();
      return u === "select" || u === "input" && o.type === "file";
    }
    function fe(o) {
      var u = [];
      S(u, G, o, Bf(o)), dp(Oe, u);
    }
    function Oe(o) {
      r5(o, 0);
    }
    function $e(o) {
      var u = bg(o);
      if (kf(u))
        return o;
    }
    function rt(o, u) {
      if (o === "change")
        return u;
    }
    var Ct = !1;
    we && (Ct = pg("input") && (!document.documentMode || document.documentMode > 9));
    function Ht(o, u) {
      P = o, G = u, P.attachEvent("onpropertychange", Ut);
    }
    function qt() {
      P && (P.detachEvent("onpropertychange", Ut), P = null, G = null);
    }
    function Ut(o) {
      o.propertyName === "value" && $e(G) && fe(o);
    }
    function rn(o, u, x) {
      o === "focusin" ? (qt(), Ht(u, x)) : o === "focusout" && qt();
    }
    function gn(o, u) {
      if (o === "selectionchange" || o === "keyup" || o === "keydown")
        return $e(G);
    }
    function bn(o) {
      var u = o.nodeName;
      return u && u.toLowerCase() === "input" && (o.type === "checkbox" || o.type === "radio");
    }
    function Xi(o, u) {
      if (o === "click")
        return $e(u);
    }
    function mt(o, u) {
      if (o === "input" || o === "change")
        return $e(u);
    }
    function at(o) {
      var u = o._wrapperState;
      !u || !u.controlled || o.type !== "number" || xs(o, "number", o.value);
    }
    function vt(o, u, x, D, F, Z, de) {
      var ge = x ? bg(x) : window, xe, Le;
      if (se(ge) ? xe = rt : yy(ge) ? Ct ? xe = mt : (xe = gn, Le = rn) : bn(ge) && (xe = Xi), xe) {
        var Ue = xe(u, x);
        if (Ue) {
          S(o, Ue, D, F);
          return;
        }
      }
      Le && Le(u, ge, x), u === "focusout" && at(ge);
    }
    function $t() {
      Ee("onMouseEnter", ["mouseout", "mouseover"]), Ee("onMouseLeave", ["mouseout", "mouseover"]), Ee("onPointerEnter", ["pointerout", "pointerover"]), Ee("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function wn(o, u, x, D, F, Z, de) {
      var ge = u === "mouseover" || u === "pointerover", xe = u === "mouseout" || u === "pointerout";
      if (ge && !Ad(D)) {
        var Le = D.relatedTarget || D.fromElement;
        if (Le && (Pp(Le) || l_(Le)))
          return;
      }
      if (!(!xe && !ge)) {
        var Ue;
        if (F.window === F)
          Ue = F;
        else {
          var st = F.ownerDocument;
          st ? Ue = st.defaultView || st.parentWindow : Ue = window;
        }
        var ot, Et;
        if (xe) {
          var wt = D.relatedTarget || D.toElement;
          if (ot = x, Et = wt ? Pp(wt) : null, Et !== null) {
            var Dt = Hr(Et);
            (Et !== Dt || Et.tag !== g && Et.tag !== _) && (Et = null);
          }
        } else
          ot = null, Et = x;
        if (ot !== Et) {
          var tn = og, Ln = "onMouseLeave", Tn = "onMouseEnter", xr = "mouse";
          (u === "pointerout" || u === "pointerover") && (tn = py, Ln = "onPointerLeave", Tn = "onPointerEnter", xr = "pointer");
          var gr = ot == null ? Ue : bg(ot), gt = Et == null ? Ue : bg(Et), Rt = new tn(Ln, xr + "leave", ot, D, F);
          Rt.target = gr, Rt.relatedTarget = gt;
          var _t = null, Gt = Pp(F);
          if (Gt === x) {
            var sn = new tn(Tn, xr + "enter", Et, D, F);
            sn.target = gt, sn.relatedTarget = gr, _t = sn;
          }
          WD(o, Rt, _t, ot, Et);
        }
      }
    }
    function jn(o, u) {
      return o === u && (o !== 0 || 1 / o === 1 / u) || o !== o && u !== u;
    }
    var _n = typeof Object.is == "function" ? Object.is : jn;
    function Hn(o, u) {
      if (_n(o, u))
        return !0;
      if (typeof o != "object" || o === null || typeof u != "object" || u === null)
        return !1;
      var x = Object.keys(o), D = Object.keys(u);
      if (x.length !== D.length)
        return !1;
      for (var F = 0; F < x.length; F++) {
        var Z = x[F];
        if (!ze.call(u, Z) || !_n(o[Z], u[Z]))
          return !1;
      }
      return !0;
    }
    function go(o) {
      for (; o && o.firstChild; )
        o = o.firstChild;
      return o;
    }
    function Rr(o) {
      for (; o; ) {
        if (o.nextSibling)
          return o.nextSibling;
        o = o.parentNode;
      }
    }
    function Pu(o, u) {
      for (var x = go(o), D = 0, F = 0; x; ) {
        if (x.nodeType === os) {
          if (F = D + x.textContent.length, D <= u && F >= u)
            return {
              node: x,
              offset: u - D
            };
          D = F;
        }
        x = go(Rr(x));
      }
    }
    function pE(o) {
      var u = o.ownerDocument, x = u && u.defaultView || window, D = x.getSelection && x.getSelection();
      if (!D || D.rangeCount === 0)
        return null;
      var F = D.anchorNode, Z = D.anchorOffset, de = D.focusNode, ge = D.focusOffset;
      try {
        F.nodeType, de.nodeType;
      } catch {
        return null;
      }
      return TD(o, F, Z, de, ge);
    }
    function TD(o, u, x, D, F) {
      var Z = 0, de = -1, ge = -1, xe = 0, Le = 0, Ue = o, st = null;
      e: for (; ; ) {
        for (var ot = null; Ue === u && (x === 0 || Ue.nodeType === os) && (de = Z + x), Ue === D && (F === 0 || Ue.nodeType === os) && (ge = Z + F), Ue.nodeType === os && (Z += Ue.nodeValue.length), (ot = Ue.firstChild) !== null; )
          st = Ue, Ue = ot;
        for (; ; ) {
          if (Ue === o)
            break e;
          if (st === u && ++xe === x && (de = Z), st === D && ++Le === F && (ge = Z), (ot = Ue.nextSibling) !== null)
            break;
          Ue = st, st = Ue.parentNode;
        }
        Ue = ot;
      }
      return de === -1 || ge === -1 ? null : {
        start: de,
        end: ge
      };
    }
    function AD(o, u) {
      var x = o.ownerDocument || document, D = x && x.defaultView || window;
      if (D.getSelection) {
        var F = D.getSelection(), Z = o.textContent.length, de = Math.min(u.start, Z), ge = u.end === void 0 ? de : Math.min(u.end, Z);
        if (!F.extend && de > ge) {
          var xe = ge;
          ge = de, de = xe;
        }
        var Le = Pu(o, de), Ue = Pu(o, ge);
        if (Le && Ue) {
          if (F.rangeCount === 1 && F.anchorNode === Le.node && F.anchorOffset === Le.offset && F.focusNode === Ue.node && F.focusOffset === Ue.offset)
            return;
          var st = x.createRange();
          st.setStart(Le.node, Le.offset), F.removeAllRanges(), de > ge ? (F.addRange(st), F.extend(Ue.node, Ue.offset)) : (st.setEnd(Ue.node, Ue.offset), F.addRange(st));
        }
      }
    }
    function GT(o) {
      return o && o.nodeType === os;
    }
    function WT(o, u) {
      return !o || !u ? !1 : o === u ? !0 : GT(o) ? !1 : GT(u) ? WT(o, u.parentNode) : "contains" in o ? o.contains(u) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(u) & 16) : !1;
    }
    function kD(o) {
      return o && o.ownerDocument && WT(o.ownerDocument.documentElement, o);
    }
    function OD(o) {
      try {
        return typeof o.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function $T() {
      for (var o = window, u = pc(); u instanceof o.HTMLIFrameElement; ) {
        if (OD(u))
          o = u.contentWindow;
        else
          return u;
        u = pc(o.document);
      }
      return u;
    }
    function mE(o) {
      var u = o && o.nodeName && o.nodeName.toLowerCase();
      return u && (u === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || u === "textarea" || o.contentEditable === "true");
    }
    function DD() {
      var o = $T();
      return {
        focusedElem: o,
        selectionRange: mE(o) ? ND(o) : null
      };
    }
    function RD(o) {
      var u = $T(), x = o.focusedElem, D = o.selectionRange;
      if (u !== x && kD(x)) {
        D !== null && mE(x) && ID(x, D);
        for (var F = [], Z = x; Z = Z.parentNode; )
          Z.nodeType === uo && F.push({
            element: Z,
            left: Z.scrollLeft,
            top: Z.scrollTop
          });
        typeof x.focus == "function" && x.focus();
        for (var de = 0; de < F.length; de++) {
          var ge = F[de];
          ge.element.scrollLeft = ge.left, ge.element.scrollTop = ge.top;
        }
      }
    }
    function ND(o) {
      var u;
      return "selectionStart" in o ? u = {
        start: o.selectionStart,
        end: o.selectionEnd
      } : u = pE(o), u || {
        start: 0,
        end: 0
      };
    }
    function ID(o, u) {
      var x = u.start, D = u.end;
      D === void 0 && (D = x), "selectionStart" in o ? (o.selectionStart = x, o.selectionEnd = Math.min(D, o.value.length)) : AD(o, u);
    }
    var LD = we && "documentMode" in document && document.documentMode <= 11;
    function MD() {
      ve("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var mg = null, gE = null, X0 = null, _E = !1;
    function PD(o) {
      if ("selectionStart" in o && mE(o))
        return {
          start: o.selectionStart,
          end: o.selectionEnd
        };
      var u = o.ownerDocument && o.ownerDocument.defaultView || window, x = u.getSelection();
      return {
        anchorNode: x.anchorNode,
        anchorOffset: x.anchorOffset,
        focusNode: x.focusNode,
        focusOffset: x.focusOffset
      };
    }
    function jD(o) {
      return o.window === o ? o.document : o.nodeType === ga ? o : o.ownerDocument;
    }
    function YT(o, u, x) {
      var D = jD(x);
      if (!(_E || mg == null || mg !== pc(D))) {
        var F = PD(mg);
        if (!X0 || !Hn(X0, F)) {
          X0 = F;
          var Z = Sy(gE, "onSelect");
          if (Z.length > 0) {
            var de = new ig("onSelect", "select", null, u, x);
            o.push({
              event: de,
              listeners: Z
            }), de.target = mg;
          }
        }
      }
    }
    function BD(o, u, x, D, F, Z, de) {
      var ge = x ? bg(x) : window;
      switch (u) {
        case "focusin":
          (yy(ge) || ge.contentEditable === "true") && (mg = ge, gE = x, X0 = null);
          break;
        case "focusout":
          mg = null, gE = null, X0 = null;
          break;
        case "mousedown":
          _E = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          _E = !1, YT(o, D, F);
          break;
        case "selectionchange":
          if (LD)
            break;
        case "keydown":
        case "keyup":
          YT(o, D, F);
      }
    }
    function vy(o, u) {
      var x = {};
      return x[o.toLowerCase()] = u.toLowerCase(), x["Webkit" + o] = "webkit" + u, x["Moz" + o] = "moz" + u, x;
    }
    var gg = {
      animationend: vy("Animation", "AnimationEnd"),
      animationiteration: vy("Animation", "AnimationIteration"),
      animationstart: vy("Animation", "AnimationStart"),
      transitionend: vy("Transition", "TransitionEnd")
    }, yE = {}, XT = {};
    we && (XT = document.createElement("div").style, "AnimationEvent" in window || (delete gg.animationend.animation, delete gg.animationiteration.animation, delete gg.animationstart.animation), "TransitionEvent" in window || delete gg.transitionend.transition);
    function by(o) {
      if (yE[o])
        return yE[o];
      if (!gg[o])
        return o;
      var u = gg[o];
      for (var x in u)
        if (u.hasOwnProperty(x) && x in XT)
          return yE[o] = u[x];
      return o;
    }
    var KT = by("animationend"), QT = by("animationiteration"), ZT = by("animationstart"), JT = by("transitionend"), e5 = /* @__PURE__ */ new Map(), t5 = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function mh(o, u) {
      e5.set(o, u), ve(u, [o]);
    }
    function FD() {
      for (var o = 0; o < t5.length; o++) {
        var u = t5[o], x = u.toLowerCase(), D = u[0].toUpperCase() + u.slice(1);
        mh(x, "on" + D);
      }
      mh(KT, "onAnimationEnd"), mh(QT, "onAnimationIteration"), mh(ZT, "onAnimationStart"), mh("dblclick", "onDoubleClick"), mh("focusin", "onFocus"), mh("focusout", "onBlur"), mh(JT, "onTransitionEnd");
    }
    function UD(o, u, x, D, F, Z, de) {
      var ge = e5.get(u);
      if (ge !== void 0) {
        var xe = ig, Le = u;
        switch (u) {
          case "keypress":
            if (Gd(D) === 0)
              return;
          case "keydown":
          case "keyup":
            xe = fy;
            break;
          case "focusin":
            Le = "focus", xe = kp;
            break;
          case "focusout":
            Le = "blur", xe = kp;
            break;
          case "beforeblur":
          case "afterblur":
            xe = kp;
            break;
          case "click":
            if (D.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            xe = og;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            xe = ay;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            xe = V0;
            break;
          case KT:
          case QT:
          case ZT:
            xe = oE;
            break;
          case JT:
            xe = Vc;
            break;
          case "scroll":
            xe = F0;
            break;
          case "wheel":
            xe = Yd;
            break;
          case "copy":
          case "cut":
          case "paste":
            xe = ly;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            xe = py;
            break;
        }
        var Ue = (Z & Ml) !== 0;
        {
          var st = !Ue && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          u === "scroll", ot = qD(x, ge, D.type, Ue, st);
          if (ot.length > 0) {
            var Et = new xe(ge, Le, null, D, F);
            o.push({
              event: Et,
              listeners: ot
            });
          }
        }
      }
    }
    FD(), $t(), m(), MD(), cg();
    function HD(o, u, x, D, F, Z, de) {
      UD(o, u, x, D, F, Z);
      var ge = (Z & Hm) === 0;
      ge && (wn(o, u, x, D, F), vt(o, u, x, D, F), BD(o, u, x, D, F), hE(o, u, x, D, F));
    }
    var K0 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], vE = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(K0));
    function n5(o, u, x) {
      var D = o.type || "unknown-event";
      o.currentTarget = x, cl(D, u, void 0, o), o.currentTarget = null;
    }
    function zD(o, u, x) {
      var D;
      if (x)
        for (var F = u.length - 1; F >= 0; F--) {
          var Z = u[F], de = Z.instance, ge = Z.currentTarget, xe = Z.listener;
          if (de !== D && o.isPropagationStopped())
            return;
          n5(o, xe, ge), D = de;
        }
      else
        for (var Le = 0; Le < u.length; Le++) {
          var Ue = u[Le], st = Ue.instance, ot = Ue.currentTarget, Et = Ue.listener;
          if (st !== D && o.isPropagationStopped())
            return;
          n5(o, Et, ot), D = st;
        }
    }
    function r5(o, u) {
      for (var x = (u & Ml) !== 0, D = 0; D < o.length; D++) {
        var F = o[D], Z = F.event, de = F.listeners;
        zD(Z, de, x);
      }
      hp();
    }
    function VD(o, u, x, D, F) {
      var Z = Bf(x), de = [];
      HD(de, o, D, x, Z, u), r5(de, u);
    }
    function Ri(o, u) {
      vE.has(o) || s('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', o);
      var x = !1, D = vN(u), F = $D(o);
      D.has(F) || (i5(u, o, wu, x), D.add(F));
    }
    function bE(o, u, x) {
      vE.has(o) && !u && s('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', o);
      var D = 0;
      u && (D |= Ml), i5(x, o, D, u);
    }
    var Ey = "_reactListening" + Math.random().toString(36).slice(2);
    function Q0(o) {
      if (!o[Ey]) {
        o[Ey] = !0, oe.forEach(function(x) {
          x !== "selectionchange" && (vE.has(x) || bE(x, !1, o), bE(x, !0, o));
        });
        var u = o.nodeType === ga ? o : o.ownerDocument;
        u !== null && (u[Ey] || (u[Ey] = !0, bE("selectionchange", !1, u)));
      }
    }
    function i5(o, u, x, D, F) {
      var Z = po(o, u, x), de = void 0;
      Oc && (u === "touchstart" || u === "touchmove" || u === "wheel") && (de = !0), o = o, D ? de !== void 0 ? tg(o, u, Z, de) : Lu(o, u, Z) : de !== void 0 ? B0(o, u, Z, de) : dh(o, u, Z);
    }
    function o5(o, u) {
      return o === u || o.nodeType === pi && o.parentNode === u;
    }
    function EE(o, u, x, D, F) {
      var Z = D;
      if (!(u & Eo) && !(u & wu)) {
        var de = F;
        if (D !== null) {
          var ge = D;
          e: for (; ; ) {
            if (ge === null)
              return;
            var xe = ge.tag;
            if (xe === h || xe === p) {
              var Le = ge.stateNode.containerInfo;
              if (o5(Le, de))
                break;
              if (xe === p)
                for (var Ue = ge.return; Ue !== null; ) {
                  var st = Ue.tag;
                  if (st === h || st === p) {
                    var ot = Ue.stateNode.containerInfo;
                    if (o5(ot, de))
                      return;
                  }
                  Ue = Ue.return;
                }
              for (; Le !== null; ) {
                var Et = Pp(Le);
                if (Et === null)
                  return;
                var wt = Et.tag;
                if (wt === g || wt === _) {
                  ge = Z = Et;
                  continue e;
                }
                Le = Le.parentNode;
              }
            }
            ge = ge.return;
          }
        }
      }
      dp(function() {
        return VD(o, u, x, Z);
      });
    }
    function Z0(o, u, x) {
      return {
        instance: o,
        listener: u,
        currentTarget: x
      };
    }
    function qD(o, u, x, D, F, Z) {
      for (var de = u !== null ? u + "Capture" : null, ge = D ? de : u, xe = [], Le = o, Ue = null; Le !== null; ) {
        var st = Le, ot = st.stateNode, Et = st.tag;
        if (Et === g && ot !== null && (Ue = ot, ge !== null)) {
          var wt = Pl(Le, ge);
          wt != null && xe.push(Z0(Le, wt, Ue));
        }
        if (F)
          break;
        Le = Le.return;
      }
      return xe;
    }
    function Sy(o, u) {
      for (var x = u + "Capture", D = [], F = o; F !== null; ) {
        var Z = F, de = Z.stateNode, ge = Z.tag;
        if (ge === g && de !== null) {
          var xe = de, Le = Pl(F, x);
          Le != null && D.unshift(Z0(F, Le, xe));
          var Ue = Pl(F, u);
          Ue != null && D.push(Z0(F, Ue, xe));
        }
        F = F.return;
      }
      return D;
    }
    function _g(o) {
      if (o === null)
        return null;
      do
        o = o.return;
      while (o && o.tag !== g);
      return o || null;
    }
    function GD(o, u) {
      for (var x = o, D = u, F = 0, Z = x; Z; Z = _g(Z))
        F++;
      for (var de = 0, ge = D; ge; ge = _g(ge))
        de++;
      for (; F - de > 0; )
        x = _g(x), F--;
      for (; de - F > 0; )
        D = _g(D), de--;
      for (var xe = F; xe--; ) {
        if (x === D || D !== null && x === D.alternate)
          return x;
        x = _g(x), D = _g(D);
      }
      return null;
    }
    function a5(o, u, x, D, F) {
      for (var Z = u._reactName, de = [], ge = x; ge !== null && ge !== D; ) {
        var xe = ge, Le = xe.alternate, Ue = xe.stateNode, st = xe.tag;
        if (Le !== null && Le === D)
          break;
        if (st === g && Ue !== null) {
          var ot = Ue;
          if (F) {
            var Et = Pl(ge, Z);
            Et != null && de.unshift(Z0(ge, Et, ot));
          } else if (!F) {
            var wt = Pl(ge, Z);
            wt != null && de.push(Z0(ge, wt, ot));
          }
        }
        ge = ge.return;
      }
      de.length !== 0 && o.push({
        event: u,
        listeners: de
      });
    }
    function WD(o, u, x, D, F) {
      var Z = D && F ? GD(D, F) : null;
      D !== null && a5(o, u, D, Z, !1), F !== null && x !== null && a5(o, x, F, Z, !0);
    }
    function $D(o, u) {
      return o + "__bubble";
    }
    var Us = !1, J0 = "dangerouslySetInnerHTML", Cy = "suppressContentEditableWarning", gh = "suppressHydrationWarning", s5 = "autoFocus", Lp = "children", Mp = "style", wy = "__html", SE, xy, e_, l5, Ty, u5, c5;
    SE = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, xy = function(o, u) {
      Td(o, u), sp(o, u), xc(o, u, {
        registrationNameDependencies: ae,
        possibleRegistrationNames: _e
      });
    }, u5 = we && !document.documentMode, e_ = function(o, u, x) {
      if (!Us) {
        var D = Ay(x), F = Ay(u);
        F !== D && (Us = !0, s("Prop `%s` did not match. Server: %s Client: %s", o, JSON.stringify(F), JSON.stringify(D)));
      }
    }, l5 = function(o) {
      if (!Us) {
        Us = !0;
        var u = [];
        o.forEach(function(x) {
          u.push(x);
        }), s("Extra attributes from the server: %s", u);
      }
    }, Ty = function(o, u) {
      u === !1 ? s("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", o, o, o) : s("Expected `%s` listener to be a function, instead got a value of `%s` type.", o, typeof u);
    }, c5 = function(o, u) {
      var x = o.namespaceURI === Rn ? o.ownerDocument.createElement(o.tagName) : o.ownerDocument.createElementNS(o.namespaceURI, o.tagName);
      return x.innerHTML = u, x.innerHTML;
    };
    var YD = /\r\n?/g, XD = /\u0000|\uFFFD/g;
    function Ay(o) {
      ke(o);
      var u = typeof o == "string" ? o : "" + o;
      return u.replace(YD, `
`).replace(XD, "");
    }
    function ky(o, u, x, D) {
      var F = Ay(u), Z = Ay(o);
      if (Z !== F && (D && (Us || (Us = !0, s('Text content did not match. Server: "%s" Client: "%s"', Z, F))), x && $))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function d5(o) {
      return o.nodeType === ga ? o : o.ownerDocument;
    }
    function KD() {
    }
    function Oy(o) {
      o.onclick = KD;
    }
    function QD(o, u, x, D, F) {
      for (var Z in D)
        if (D.hasOwnProperty(Z)) {
          var de = D[Z];
          if (Z === Mp)
            de && Object.freeze(de), Fm(u, de);
          else if (Z === J0) {
            var ge = de ? de[wy] : void 0;
            ge != null && If(u, ge);
          } else if (Z === Lp)
            if (typeof de == "string") {
              var xe = o !== "textarea" || de !== "";
              xe && Nl(u, de);
            } else typeof de == "number" && Nl(u, "" + de);
          else Z === Cy || Z === gh || Z === s5 || (ae.hasOwnProperty(Z) ? de != null && (typeof de != "function" && Ty(Z, de), Z === "onScroll" && Ri("scroll", u)) : de != null && cn(u, Z, de, F));
        }
    }
    function ZD(o, u, x, D) {
      for (var F = 0; F < u.length; F += 2) {
        var Z = u[F], de = u[F + 1];
        Z === Mp ? Fm(o, de) : Z === J0 ? If(o, de) : Z === Lp ? Nl(o, de) : cn(o, Z, de, D);
      }
    }
    function JD(o, u, x, D) {
      var F, Z = d5(x), de, ge = D;
      if (ge === Rn && (ge = ri(o)), ge === Rn) {
        if (F = ht(o, u), !F && o !== o.toLowerCase() && s("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", o), o === "script") {
          var xe = Z.createElement("div");
          xe.innerHTML = "<script><\/script>";
          var Le = xe.firstChild;
          de = xe.removeChild(Le);
        } else if (typeof u.is == "string")
          de = Z.createElement(o, {
            is: u.is
          });
        else if (de = Z.createElement(o), o === "select") {
          var Ue = de;
          u.multiple ? Ue.multiple = !0 : u.size && (Ue.size = u.size);
        }
      } else
        de = Z.createElementNS(ge, o);
      return ge === Rn && !F && Object.prototype.toString.call(de) === "[object HTMLUnknownElement]" && !ze.call(SE, o) && (SE[o] = !0, s("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", o)), de;
    }
    function eR(o, u) {
      return d5(u).createTextNode(o);
    }
    function tR(o, u, x, D) {
      var F = ht(u, x);
      xy(u, x);
      var Z;
      switch (u) {
        case "dialog":
          Ri("cancel", o), Ri("close", o), Z = x;
          break;
        case "iframe":
        case "object":
        case "embed":
          Ri("load", o), Z = x;
          break;
        case "video":
        case "audio":
          for (var de = 0; de < K0.length; de++)
            Ri(K0[de], o);
          Z = x;
          break;
        case "source":
          Ri("error", o), Z = x;
          break;
        case "img":
        case "image":
        case "link":
          Ri("error", o), Ri("load", o), Z = x;
          break;
        case "details":
          Ri("toggle", o), Z = x;
          break;
        case "input":
          Cs(o, x), Z = pu(o, x), Ri("invalid", o);
          break;
        case "option":
          yc(o, x), Z = x;
          break;
        case "select":
          Ec(o, x), Z = hi(o, x), Ri("invalid", o);
          break;
        case "textarea":
          Ke(o, x), Z = Be(o, x), Ri("invalid", o);
          break;
        default:
          Z = x;
      }
      switch (bo(u, Z), QD(u, o, D, Z, F), u) {
        case "input":
          Ba(o), gc(o, x, !1);
          break;
        case "textarea":
          Ba(o), Wt(o);
          break;
        case "option":
          Sd(o, x);
          break;
        case "select":
          Nf(o, x);
          break;
        default:
          typeof Z.onClick == "function" && Oy(o);
          break;
      }
    }
    function nR(o, u, x, D, F) {
      xy(u, D);
      var Z = null, de, ge;
      switch (u) {
        case "input":
          de = pu(o, x), ge = pu(o, D), Z = [];
          break;
        case "select":
          de = hi(o, x), ge = hi(o, D), Z = [];
          break;
        case "textarea":
          de = Be(o, x), ge = Be(o, D), Z = [];
          break;
        default:
          de = x, ge = D, typeof de.onClick != "function" && typeof ge.onClick == "function" && Oy(o);
          break;
      }
      bo(u, ge);
      var xe, Le, Ue = null;
      for (xe in de)
        if (!(ge.hasOwnProperty(xe) || !de.hasOwnProperty(xe) || de[xe] == null))
          if (xe === Mp) {
            var st = de[xe];
            for (Le in st)
              st.hasOwnProperty(Le) && (Ue || (Ue = {}), Ue[Le] = "");
          } else xe === J0 || xe === Lp || xe === Cy || xe === gh || xe === s5 || (ae.hasOwnProperty(xe) ? Z || (Z = []) : (Z = Z || []).push(xe, null));
      for (xe in ge) {
        var ot = ge[xe], Et = de != null ? de[xe] : void 0;
        if (!(!ge.hasOwnProperty(xe) || ot === Et || ot == null && Et == null))
          if (xe === Mp)
            if (ot && Object.freeze(ot), Et) {
              for (Le in Et)
                Et.hasOwnProperty(Le) && (!ot || !ot.hasOwnProperty(Le)) && (Ue || (Ue = {}), Ue[Le] = "");
              for (Le in ot)
                ot.hasOwnProperty(Le) && Et[Le] !== ot[Le] && (Ue || (Ue = {}), Ue[Le] = ot[Le]);
            } else
              Ue || (Z || (Z = []), Z.push(xe, Ue)), Ue = ot;
          else if (xe === J0) {
            var wt = ot ? ot[wy] : void 0, Dt = Et ? Et[wy] : void 0;
            wt != null && Dt !== wt && (Z = Z || []).push(xe, wt);
          } else xe === Lp ? (typeof ot == "string" || typeof ot == "number") && (Z = Z || []).push(xe, "" + ot) : xe === Cy || xe === gh || (ae.hasOwnProperty(xe) ? (ot != null && (typeof ot != "function" && Ty(xe, ot), xe === "onScroll" && Ri("scroll", o)), !Z && Et !== ot && (Z = [])) : (Z = Z || []).push(xe, ot));
      }
      return Ue && (wd(Ue, ge[Mp]), (Z = Z || []).push(Mp, Ue)), Z;
    }
    function rR(o, u, x, D, F) {
      x === "input" && F.type === "radio" && F.name != null && Ed(o, F);
      var Z = ht(x, D), de = ht(x, F);
      switch (ZD(o, u, Z, de), x) {
        case "input":
          ws(o, F);
          break;
        case "textarea":
          Ot(o, F);
          break;
        case "select":
          be(o, F);
          break;
      }
    }
    function iR(o) {
      {
        var u = o.toLowerCase();
        return re.hasOwnProperty(u) && re[u] || null;
      }
    }
    function oR(o, u, x, D, F, Z, de) {
      var ge, xe;
      switch (ge = ht(u, x), xy(u, x), u) {
        case "dialog":
          Ri("cancel", o), Ri("close", o);
          break;
        case "iframe":
        case "object":
        case "embed":
          Ri("load", o);
          break;
        case "video":
        case "audio":
          for (var Le = 0; Le < K0.length; Le++)
            Ri(K0[Le], o);
          break;
        case "source":
          Ri("error", o);
          break;
        case "img":
        case "image":
        case "link":
          Ri("error", o), Ri("load", o);
          break;
        case "details":
          Ri("toggle", o);
          break;
        case "input":
          Cs(o, x), Ri("invalid", o);
          break;
        case "option":
          yc(o, x);
          break;
        case "select":
          Ec(o, x), Ri("invalid", o);
          break;
        case "textarea":
          Ke(o, x), Ri("invalid", o);
          break;
      }
      bo(u, x);
      {
        xe = /* @__PURE__ */ new Set();
        for (var Ue = o.attributes, st = 0; st < Ue.length; st++) {
          var ot = Ue[st].name.toLowerCase();
          switch (ot) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              xe.add(Ue[st].name);
          }
        }
      }
      var Et = null;
      for (var wt in x)
        if (x.hasOwnProperty(wt)) {
          var Dt = x[wt];
          if (wt === Lp)
            typeof Dt == "string" ? o.textContent !== Dt && (x[gh] !== !0 && ky(o.textContent, Dt, Z, de), Et = [Lp, Dt]) : typeof Dt == "number" && o.textContent !== "" + Dt && (x[gh] !== !0 && ky(o.textContent, Dt, Z, de), Et = [Lp, "" + Dt]);
          else if (ae.hasOwnProperty(wt))
            Dt != null && (typeof Dt != "function" && Ty(wt, Dt), wt === "onScroll" && Ri("scroll", o));
          else if (de && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof ge == "boolean") {
            var tn = void 0, Ln = ge && L ? null : ar(wt);
            if (x[gh] !== !0) {
              if (!(wt === Cy || wt === gh || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              wt === "value" || wt === "checked" || wt === "selected")) {
                if (wt === J0) {
                  var Tn = o.innerHTML, xr = Dt ? Dt[wy] : void 0;
                  if (xr != null) {
                    var gr = c5(o, xr);
                    gr !== Tn && e_(wt, Tn, gr);
                  }
                } else if (wt === Mp) {
                  if (xe.delete(wt), u5) {
                    var gt = Pf(Dt);
                    tn = o.getAttribute("style"), gt !== tn && e_(wt, tn, gt);
                  }
                } else if (ge && !L)
                  xe.delete(wt.toLowerCase()), tn = fn(o, wt, Dt), Dt !== tn && e_(wt, tn, Dt);
                else if (!zt(wt, Ln, ge) && !Ft(wt, Dt, Ln, ge)) {
                  var Rt = !1;
                  if (Ln !== null)
                    xe.delete(Ln.attributeName), tn = Pt(o, wt, Dt, Ln);
                  else {
                    var _t = D;
                    if (_t === Rn && (_t = ri(u)), _t === Rn)
                      xe.delete(wt.toLowerCase());
                    else {
                      var Gt = iR(wt);
                      Gt !== null && Gt !== wt && (Rt = !0, xe.delete(Gt)), xe.delete(wt);
                    }
                    tn = fn(o, wt, Dt);
                  }
                  var sn = L;
                  !sn && Dt !== tn && !Rt && e_(wt, tn, Dt);
                }
              }
            }
          }
        }
      switch (de && // $FlowFixMe - Should be inferred as not undefined.
      xe.size > 0 && x[gh] !== !0 && l5(xe), u) {
        case "input":
          Ba(o), gc(o, x, !0);
          break;
        case "textarea":
          Ba(o), Wt(o);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof x.onClick == "function" && Oy(o);
          break;
      }
      return Et;
    }
    function aR(o, u, x) {
      var D = o.nodeValue !== u;
      return D;
    }
    function CE(o, u) {
      {
        if (Us)
          return;
        Us = !0, s("Did not expect server HTML to contain a <%s> in <%s>.", u.nodeName.toLowerCase(), o.nodeName.toLowerCase());
      }
    }
    function wE(o, u) {
      {
        if (Us)
          return;
        Us = !0, s('Did not expect server HTML to contain the text node "%s" in <%s>.', u.nodeValue, o.nodeName.toLowerCase());
      }
    }
    function xE(o, u, x) {
      {
        if (Us)
          return;
        Us = !0, s("Expected server HTML to contain a matching <%s> in <%s>.", u, o.nodeName.toLowerCase());
      }
    }
    function TE(o, u) {
      {
        if (u === "" || Us)
          return;
        Us = !0, s('Expected server HTML to contain a matching text node for "%s" in <%s>.', u, o.nodeName.toLowerCase());
      }
    }
    function sR(o, u, x) {
      switch (u) {
        case "input":
          Of(o, x);
          return;
        case "textarea":
          hn(o, x);
          return;
        case "select":
          le(o, x);
          return;
      }
    }
    var t_ = function() {
    }, n_ = function() {
    };
    {
      var lR = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], f5 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], uR = f5.concat(["button"]), cR = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], h5 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      n_ = function(o, u) {
        var x = Qn({}, o || h5), D = {
          tag: u
        };
        return f5.indexOf(u) !== -1 && (x.aTagInScope = null, x.buttonTagInScope = null, x.nobrTagInScope = null), uR.indexOf(u) !== -1 && (x.pTagInButtonScope = null), lR.indexOf(u) !== -1 && u !== "address" && u !== "div" && u !== "p" && (x.listItemTagAutoclosing = null, x.dlItemTagAutoclosing = null), x.current = D, u === "form" && (x.formTag = D), u === "a" && (x.aTagInScope = D), u === "button" && (x.buttonTagInScope = D), u === "nobr" && (x.nobrTagInScope = D), u === "p" && (x.pTagInButtonScope = D), u === "li" && (x.listItemTagAutoclosing = D), (u === "dd" || u === "dt") && (x.dlItemTagAutoclosing = D), x;
      };
      var dR = function(o, u) {
        switch (u) {
          case "select":
            return o === "option" || o === "optgroup" || o === "#text";
          case "optgroup":
            return o === "option" || o === "#text";
          case "option":
            return o === "#text";
          case "tr":
            return o === "th" || o === "td" || o === "style" || o === "script" || o === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return o === "tr" || o === "style" || o === "script" || o === "template";
          case "colgroup":
            return o === "col" || o === "template";
          case "table":
            return o === "caption" || o === "colgroup" || o === "tbody" || o === "tfoot" || o === "thead" || o === "style" || o === "script" || o === "template";
          case "head":
            return o === "base" || o === "basefont" || o === "bgsound" || o === "link" || o === "meta" || o === "title" || o === "noscript" || o === "noframes" || o === "style" || o === "script" || o === "template";
          case "html":
            return o === "head" || o === "body" || o === "frameset";
          case "frameset":
            return o === "frame";
          case "#document":
            return o === "html";
        }
        switch (o) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return u !== "h1" && u !== "h2" && u !== "h3" && u !== "h4" && u !== "h5" && u !== "h6";
          case "rp":
          case "rt":
            return cR.indexOf(u) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return u == null;
        }
        return !0;
      }, fR = function(o, u) {
        switch (o) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return u.pTagInButtonScope;
          case "form":
            return u.formTag || u.pTagInButtonScope;
          case "li":
            return u.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return u.dlItemTagAutoclosing;
          case "button":
            return u.buttonTagInScope;
          case "a":
            return u.aTagInScope;
          case "nobr":
            return u.nobrTagInScope;
        }
        return null;
      }, p5 = {};
      t_ = function(o, u, x) {
        x = x || h5;
        var D = x.current, F = D && D.tag;
        u != null && (o != null && s("validateDOMNesting: when childText is passed, childTag should be null"), o = "#text");
        var Z = dR(o, F) ? null : D, de = Z ? null : fR(o, x), ge = Z || de;
        if (ge) {
          var xe = ge.tag, Le = !!Z + "|" + o + "|" + xe;
          if (!p5[Le]) {
            p5[Le] = !0;
            var Ue = o, st = "";
            if (o === "#text" ? /\S/.test(u) ? Ue = "Text nodes" : (Ue = "Whitespace text nodes", st = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : Ue = "<" + o + ">", Z) {
              var ot = "";
              xe === "table" && o === "tr" && (ot += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), s("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", Ue, xe, st, ot);
            } else
              s("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", Ue, xe);
          }
        }
      };
    }
    var Dy = "suppressHydrationWarning", Ry = "$", Ny = "/$", r_ = "$?", i_ = "$!", hR = "style", AE = null, kE = null;
    function pR(o) {
      var u, x, D = o.nodeType;
      switch (D) {
        case ga:
        case rl: {
          u = D === ga ? "#document" : "#fragment";
          var F = o.documentElement;
          x = F ? F.namespaceURI : Rl(null, "");
          break;
        }
        default: {
          var Z = D === pi ? o.parentNode : o, de = Z.namespaceURI || null;
          u = Z.tagName, x = Rl(de, u);
          break;
        }
      }
      {
        var ge = u.toLowerCase(), xe = n_(null, ge);
        return {
          namespace: x,
          ancestorInfo: xe
        };
      }
    }
    function mR(o, u, x) {
      {
        var D = o, F = Rl(D.namespace, u), Z = n_(D.ancestorInfo, u);
        return {
          namespace: F,
          ancestorInfo: Z
        };
      }
    }
    function zie(o) {
      return o;
    }
    function gR(o) {
      AE = uh(), kE = DD();
      var u = null;
      return Wa(!1), u;
    }
    function _R(o) {
      RD(kE), Wa(AE), AE = null, kE = null;
    }
    function yR(o, u, x, D, F) {
      var Z;
      {
        var de = D;
        if (t_(o, null, de.ancestorInfo), typeof u.children == "string" || typeof u.children == "number") {
          var ge = "" + u.children, xe = n_(de.ancestorInfo, o);
          t_(null, ge, xe);
        }
        Z = de.namespace;
      }
      var Le = JD(o, u, x, Z);
      return s_(F, Le), PE(Le, u), Le;
    }
    function vR(o, u) {
      o.appendChild(u);
    }
    function bR(o, u, x, D, F) {
      switch (tR(o, u, x, D), u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!x.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function ER(o, u, x, D, F, Z) {
      {
        var de = Z;
        if (typeof D.children != typeof x.children && (typeof D.children == "string" || typeof D.children == "number")) {
          var ge = "" + D.children, xe = n_(de.ancestorInfo, u);
          t_(null, ge, xe);
        }
      }
      return nR(o, u, x, D);
    }
    function OE(o, u) {
      return o === "textarea" || o === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
    }
    function SR(o, u, x, D) {
      {
        var F = x;
        t_(null, o, F.ancestorInfo);
      }
      var Z = eR(o, u);
      return s_(D, Z), Z;
    }
    function CR() {
      var o = window.event;
      return o === void 0 ? ql : eg(o.type);
    }
    var DE = typeof setTimeout == "function" ? setTimeout : void 0, wR = typeof clearTimeout == "function" ? clearTimeout : void 0, RE = -1, m5 = typeof Promise == "function" ? Promise : void 0, xR = typeof queueMicrotask == "function" ? queueMicrotask : typeof m5 < "u" ? function(o) {
      return m5.resolve(null).then(o).catch(TR);
    } : DE;
    function TR(o) {
      setTimeout(function() {
        throw o;
      });
    }
    function AR(o, u, x, D) {
      switch (u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          x.autoFocus && o.focus();
          return;
        case "img": {
          x.src && (o.src = x.src);
          return;
        }
      }
    }
    function kR(o, u, x, D, F, Z) {
      rR(o, u, x, D, F), PE(o, F);
    }
    function g5(o) {
      Nl(o, "");
    }
    function OR(o, u, x) {
      o.nodeValue = x;
    }
    function DR(o, u) {
      o.appendChild(u);
    }
    function RR(o, u) {
      var x;
      o.nodeType === pi ? (x = o.parentNode, x.insertBefore(u, o)) : (x = o, x.appendChild(u));
      var D = o._reactRootContainer;
      D == null && x.onclick === null && Oy(x);
    }
    function NR(o, u, x) {
      o.insertBefore(u, x);
    }
    function IR(o, u, x) {
      o.nodeType === pi ? o.parentNode.insertBefore(u, x) : o.insertBefore(u, x);
    }
    function LR(o, u) {
      o.removeChild(u);
    }
    function MR(o, u) {
      o.nodeType === pi ? o.parentNode.removeChild(u) : o.removeChild(u);
    }
    function NE(o, u) {
      var x = u, D = 0;
      do {
        var F = x.nextSibling;
        if (o.removeChild(x), F && F.nodeType === pi) {
          var Z = F.data;
          if (Z === Ny)
            if (D === 0) {
              o.removeChild(F), Ui(u);
              return;
            } else
              D--;
          else (Z === Ry || Z === r_ || Z === i_) && D++;
        }
        x = F;
      } while (x);
      Ui(u);
    }
    function PR(o, u) {
      o.nodeType === pi ? NE(o.parentNode, u) : o.nodeType === uo && NE(o, u), Ui(o);
    }
    function jR(o) {
      o = o;
      var u = o.style;
      typeof u.setProperty == "function" ? u.setProperty("display", "none", "important") : u.display = "none";
    }
    function BR(o) {
      o.nodeValue = "";
    }
    function FR(o, u) {
      o = o;
      var x = u[hR], D = x != null && x.hasOwnProperty("display") ? x.display : null;
      o.style.display = bu("display", D);
    }
    function UR(o, u) {
      o.nodeValue = u;
    }
    function HR(o) {
      o.nodeType === uo ? o.textContent = "" : o.nodeType === ga && o.documentElement && o.removeChild(o.documentElement);
    }
    function zR(o, u, x) {
      return o.nodeType !== uo || u.toLowerCase() !== o.nodeName.toLowerCase() ? null : o;
    }
    function VR(o, u) {
      return u === "" || o.nodeType !== os ? null : o;
    }
    function qR(o) {
      return o.nodeType !== pi ? null : o;
    }
    function _5(o) {
      return o.data === r_;
    }
    function IE(o) {
      return o.data === i_;
    }
    function GR(o) {
      var u = o.nextSibling && o.nextSibling.dataset, x, D, F;
      return u && (x = u.dgst, D = u.msg, F = u.stck), {
        message: D,
        digest: x,
        stack: F
      };
    }
    function WR(o, u) {
      o._reactRetry = u;
    }
    function Iy(o) {
      for (; o != null; o = o.nextSibling) {
        var u = o.nodeType;
        if (u === uo || u === os)
          break;
        if (u === pi) {
          var x = o.data;
          if (x === Ry || x === i_ || x === r_)
            break;
          if (x === Ny)
            return null;
        }
      }
      return o;
    }
    function o_(o) {
      return Iy(o.nextSibling);
    }
    function $R(o) {
      return Iy(o.firstChild);
    }
    function YR(o) {
      return Iy(o.firstChild);
    }
    function XR(o) {
      return Iy(o.nextSibling);
    }
    function KR(o, u, x, D, F, Z, de) {
      s_(Z, o), PE(o, x);
      var ge;
      {
        var xe = F;
        ge = xe.namespace;
      }
      var Le = (Z.mode & Sn) !== vn;
      return oR(o, u, x, ge, D, Le, de);
    }
    function QR(o, u, x, D) {
      return s_(x, o), x.mode & Sn, aR(o, u);
    }
    function ZR(o, u) {
      s_(u, o);
    }
    function JR(o) {
      for (var u = o.nextSibling, x = 0; u; ) {
        if (u.nodeType === pi) {
          var D = u.data;
          if (D === Ny) {
            if (x === 0)
              return o_(u);
            x--;
          } else (D === Ry || D === i_ || D === r_) && x++;
        }
        u = u.nextSibling;
      }
      return null;
    }
    function y5(o) {
      for (var u = o.previousSibling, x = 0; u; ) {
        if (u.nodeType === pi) {
          var D = u.data;
          if (D === Ry || D === i_ || D === r_) {
            if (x === 0)
              return u;
            x--;
          } else D === Ny && x++;
        }
        u = u.previousSibling;
      }
      return null;
    }
    function eN(o) {
      Ui(o);
    }
    function tN(o) {
      Ui(o);
    }
    function nN(o) {
      return o !== "head" && o !== "body";
    }
    function rN(o, u, x, D) {
      var F = !0;
      ky(u.nodeValue, x, D, F);
    }
    function iN(o, u, x, D, F, Z) {
      if (u[Dy] !== !0) {
        var de = !0;
        ky(D.nodeValue, F, Z, de);
      }
    }
    function oN(o, u) {
      u.nodeType === uo ? CE(o, u) : u.nodeType === pi || wE(o, u);
    }
    function aN(o, u) {
      {
        var x = o.parentNode;
        x !== null && (u.nodeType === uo ? CE(x, u) : u.nodeType === pi || wE(x, u));
      }
    }
    function sN(o, u, x, D, F) {
      (F || u[Dy] !== !0) && (D.nodeType === uo ? CE(x, D) : D.nodeType === pi || wE(x, D));
    }
    function lN(o, u, x) {
      xE(o, u);
    }
    function uN(o, u) {
      TE(o, u);
    }
    function cN(o, u, x) {
      {
        var D = o.parentNode;
        D !== null && xE(D, u);
      }
    }
    function dN(o, u) {
      {
        var x = o.parentNode;
        x !== null && TE(x, u);
      }
    }
    function fN(o, u, x, D, F, Z) {
      (Z || u[Dy] !== !0) && xE(x, D);
    }
    function hN(o, u, x, D, F) {
      (F || u[Dy] !== !0) && TE(x, D);
    }
    function pN(o) {
      s("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", o.nodeName.toLowerCase());
    }
    function mN(o) {
      Q0(o);
    }
    var yg = Math.random().toString(36).slice(2), vg = "__reactFiber$" + yg, LE = "__reactProps$" + yg, a_ = "__reactContainer$" + yg, ME = "__reactEvents$" + yg, gN = "__reactListeners$" + yg, _N = "__reactHandles$" + yg;
    function yN(o) {
      delete o[vg], delete o[LE], delete o[ME], delete o[gN], delete o[_N];
    }
    function s_(o, u) {
      u[vg] = o;
    }
    function Ly(o, u) {
      u[a_] = o;
    }
    function v5(o) {
      o[a_] = null;
    }
    function l_(o) {
      return !!o[a_];
    }
    function Pp(o) {
      var u = o[vg];
      if (u)
        return u;
      for (var x = o.parentNode; x; ) {
        if (u = x[a_] || x[vg], u) {
          var D = u.alternate;
          if (u.child !== null || D !== null && D.child !== null)
            for (var F = y5(o); F !== null; ) {
              var Z = F[vg];
              if (Z)
                return Z;
              F = y5(F);
            }
          return u;
        }
        o = x, x = o.parentNode;
      }
      return null;
    }
    function _h(o) {
      var u = o[vg] || o[a_];
      return u && (u.tag === g || u.tag === _ || u.tag === A || u.tag === h) ? u : null;
    }
    function bg(o) {
      if (o.tag === g || o.tag === _)
        return o.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function My(o) {
      return o[LE] || null;
    }
    function PE(o, u) {
      o[LE] = u;
    }
    function vN(o) {
      var u = o[ME];
      return u === void 0 && (u = o[ME] = /* @__PURE__ */ new Set()), u;
    }
    var b5 = {}, E5 = t.ReactDebugCurrentFrame;
    function Py(o) {
      if (o) {
        var u = o._owner, x = Al(o.type, o._source, u ? u.type : null);
        E5.setExtraStackFrame(x);
      } else
        E5.setExtraStackFrame(null);
    }
    function ju(o, u, x, D, F) {
      {
        var Z = Function.call.bind(ze);
        for (var de in o)
          if (Z(o, de)) {
            var ge = void 0;
            try {
              if (typeof o[de] != "function") {
                var xe = Error((D || "React class") + ": " + x + " type `" + de + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[de] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xe.name = "Invariant Violation", xe;
              }
              ge = o[de](u, de, D, x, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Le) {
              ge = Le;
            }
            ge && !(ge instanceof Error) && (Py(F), s("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", x, de, typeof ge), Py(null)), ge instanceof Error && !(ge.message in b5) && (b5[ge.message] = !0, Py(F), s("Failed %s type: %s", x, ge.message), Py(null));
          }
      }
    }
    var jE = [], jy;
    jy = [];
    var Xd = -1;
    function yh(o) {
      return {
        current: o
      };
    }
    function $a(o, u) {
      if (Xd < 0) {
        s("Unexpected pop.");
        return;
      }
      u !== jy[Xd] && s("Unexpected Fiber popped."), o.current = jE[Xd], jE[Xd] = null, jy[Xd] = null, Xd--;
    }
    function Ya(o, u, x) {
      Xd++, jE[Xd] = o.current, jy[Xd] = x, o.current = u;
    }
    var BE;
    BE = {};
    var yl = {};
    Object.freeze(yl);
    var Kd = yh(yl), Gc = yh(!1), FE = yl;
    function Eg(o, u, x) {
      return x && Wc(u) ? FE : Kd.current;
    }
    function S5(o, u, x) {
      {
        var D = o.stateNode;
        D.__reactInternalMemoizedUnmaskedChildContext = u, D.__reactInternalMemoizedMaskedChildContext = x;
      }
    }
    function Sg(o, u) {
      {
        var x = o.type, D = x.contextTypes;
        if (!D)
          return yl;
        var F = o.stateNode;
        if (F && F.__reactInternalMemoizedUnmaskedChildContext === u)
          return F.__reactInternalMemoizedMaskedChildContext;
        var Z = {};
        for (var de in D)
          Z[de] = u[de];
        {
          var ge = Yn(o) || "Unknown";
          ju(D, Z, "context", ge);
        }
        return F && S5(o, u, Z), Z;
      }
    }
    function By() {
      return Gc.current;
    }
    function Wc(o) {
      {
        var u = o.childContextTypes;
        return u != null;
      }
    }
    function Fy(o) {
      $a(Gc, o), $a(Kd, o);
    }
    function UE(o) {
      $a(Gc, o), $a(Kd, o);
    }
    function C5(o, u, x) {
      {
        if (Kd.current !== yl)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Ya(Kd, u, o), Ya(Gc, x, o);
      }
    }
    function w5(o, u, x) {
      {
        var D = o.stateNode, F = u.childContextTypes;
        if (typeof D.getChildContext != "function") {
          {
            var Z = Yn(o) || "Unknown";
            BE[Z] || (BE[Z] = !0, s("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", Z, Z));
          }
          return x;
        }
        var de = D.getChildContext();
        for (var ge in de)
          if (!(ge in F))
            throw new Error((Yn(o) || "Unknown") + '.getChildContext(): key "' + ge + '" is not defined in childContextTypes.');
        {
          var xe = Yn(o) || "Unknown";
          ju(F, de, "child context", xe);
        }
        return Qn({}, x, de);
      }
    }
    function Uy(o) {
      {
        var u = o.stateNode, x = u && u.__reactInternalMemoizedMergedChildContext || yl;
        return FE = Kd.current, Ya(Kd, x, o), Ya(Gc, Gc.current, o), !0;
      }
    }
    function x5(o, u, x) {
      {
        var D = o.stateNode;
        if (!D)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (x) {
          var F = w5(o, u, FE);
          D.__reactInternalMemoizedMergedChildContext = F, $a(Gc, o), $a(Kd, o), Ya(Kd, F, o), Ya(Gc, x, o);
        } else
          $a(Gc, o), Ya(Gc, x, o);
      }
    }
    function bN(o) {
      {
        if (!Gf(o) || o.tag !== d)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var u = o;
        do {
          switch (u.tag) {
            case h:
              return u.stateNode.context;
            case d: {
              var x = u.type;
              if (Wc(x))
                return u.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          u = u.return;
        } while (u !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var vh = 0, Hy = 1, Qd = null, HE = !1, zE = !1;
    function T5(o) {
      Qd === null ? Qd = [o] : Qd.push(o);
    }
    function EN(o) {
      HE = !0, T5(o);
    }
    function A5() {
      HE && bh();
    }
    function bh() {
      if (!zE && Qd !== null) {
        zE = !0;
        var o = 0, u = Ms();
        try {
          var x = !0, D = Qd;
          for (Fi(Yi); o < D.length; o++) {
            var F = D[o];
            do
              F = F(x);
            while (F !== null);
          }
          Qd = null, HE = !1;
        } catch (Z) {
          throw Qd !== null && (Qd = Qd.slice(o + 1)), Nd(Ld, bh), Z;
        } finally {
          Fi(u), zE = !1;
        }
      }
      return null;
    }
    var Cg = [], wg = 0, zy = null, Vy = 0, Yl = [], Xl = 0, jp = null, Zd = 1, Jd = "";
    function SN(o) {
      return Fp(), (o.flags & ya) !== xn;
    }
    function CN(o) {
      return Fp(), Vy;
    }
    function wN() {
      var o = Jd, u = Zd, x = u & ~xN(u);
      return x.toString(32) + o;
    }
    function Bp(o, u) {
      Fp(), Cg[wg++] = Vy, Cg[wg++] = zy, zy = o, Vy = u;
    }
    function k5(o, u, x) {
      Fp(), Yl[Xl++] = Zd, Yl[Xl++] = Jd, Yl[Xl++] = jp, jp = o;
      var D = Zd, F = Jd, Z = qy(D) - 1, de = D & ~(1 << Z), ge = x + 1, xe = qy(u) + Z;
      if (xe > 30) {
        var Le = Z - Z % 5, Ue = (1 << Le) - 1, st = (de & Ue).toString(32), ot = de >> Le, Et = Z - Le, wt = qy(u) + Et, Dt = ge << Et, tn = Dt | ot, Ln = st + F;
        Zd = 1 << wt | tn, Jd = Ln;
      } else {
        var Tn = ge << Z, xr = Tn | de, gr = F;
        Zd = 1 << xe | xr, Jd = gr;
      }
    }
    function VE(o) {
      Fp();
      var u = o.return;
      if (u !== null) {
        var x = 1, D = 0;
        Bp(o, x), k5(o, x, D);
      }
    }
    function qy(o) {
      return 32 - jc(o);
    }
    function xN(o) {
      return 1 << qy(o) - 1;
    }
    function qE(o) {
      for (; o === zy; )
        zy = Cg[--wg], Cg[wg] = null, Vy = Cg[--wg], Cg[wg] = null;
      for (; o === jp; )
        jp = Yl[--Xl], Yl[Xl] = null, Jd = Yl[--Xl], Yl[Xl] = null, Zd = Yl[--Xl], Yl[Xl] = null;
    }
    function TN() {
      return Fp(), jp !== null ? {
        id: Zd,
        overflow: Jd
      } : null;
    }
    function AN(o, u) {
      Fp(), Yl[Xl++] = Zd, Yl[Xl++] = Jd, Yl[Xl++] = jp, Zd = u.id, Jd = u.overflow, jp = o;
    }
    function Fp() {
      Ta() || s("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var xa = null, Kl = null, Bu = !1, Up = !1, Eh = null;
    function kN() {
      Bu && s("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function O5() {
      Up = !0;
    }
    function ON() {
      return Up;
    }
    function DN(o) {
      var u = o.stateNode.containerInfo;
      return Kl = YR(u), xa = o, Bu = !0, Eh = null, Up = !1, !0;
    }
    function RN(o, u, x) {
      return Kl = XR(u), xa = o, Bu = !0, Eh = null, Up = !1, x !== null && AN(o, x), !0;
    }
    function D5(o, u) {
      switch (o.tag) {
        case h: {
          oN(o.stateNode.containerInfo, u);
          break;
        }
        case g: {
          var x = (o.mode & Sn) !== vn;
          sN(
            o.type,
            o.memoizedProps,
            o.stateNode,
            u,
            // TODO: Delete this argument when we remove the legacy root API.
            x
          );
          break;
        }
        case A: {
          var D = o.memoizedState;
          D.dehydrated !== null && aN(D.dehydrated, u);
          break;
        }
      }
    }
    function R5(o, u) {
      D5(o, u);
      var x = MM();
      x.stateNode = u, x.return = o;
      var D = o.deletions;
      D === null ? (o.deletions = [x], o.flags |= Tr) : D.push(x);
    }
    function GE(o, u) {
      {
        if (Up)
          return;
        switch (o.tag) {
          case h: {
            var x = o.stateNode.containerInfo;
            switch (u.tag) {
              case g:
                var D = u.type;
                u.pendingProps, lN(x, D);
                break;
              case _:
                var F = u.pendingProps;
                uN(x, F);
                break;
            }
            break;
          }
          case g: {
            var Z = o.type, de = o.memoizedProps, ge = o.stateNode;
            switch (u.tag) {
              case g: {
                var xe = u.type, Le = u.pendingProps, Ue = (o.mode & Sn) !== vn;
                fN(
                  Z,
                  de,
                  ge,
                  xe,
                  Le,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Ue
                );
                break;
              }
              case _: {
                var st = u.pendingProps, ot = (o.mode & Sn) !== vn;
                hN(
                  Z,
                  de,
                  ge,
                  st,
                  // TODO: Delete this argument when we remove the legacy root API.
                  ot
                );
                break;
              }
            }
            break;
          }
          case A: {
            var Et = o.memoizedState, wt = Et.dehydrated;
            if (wt !== null) switch (u.tag) {
              case g:
                var Dt = u.type;
                u.pendingProps, cN(wt, Dt);
                break;
              case _:
                var tn = u.pendingProps;
                dN(wt, tn);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function N5(o, u) {
      u.flags = u.flags & ~_a | Yr, GE(o, u);
    }
    function I5(o, u) {
      switch (o.tag) {
        case g: {
          var x = o.type;
          o.pendingProps;
          var D = zR(u, x);
          return D !== null ? (o.stateNode = D, xa = o, Kl = $R(D), !0) : !1;
        }
        case _: {
          var F = o.pendingProps, Z = VR(u, F);
          return Z !== null ? (o.stateNode = Z, xa = o, Kl = null, !0) : !1;
        }
        case A: {
          var de = qR(u);
          if (de !== null) {
            var ge = {
              dehydrated: de,
              treeContext: TN(),
              retryLane: gi
            };
            o.memoizedState = ge;
            var xe = PM(de);
            return xe.return = o, o.child = xe, xa = o, Kl = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function WE(o) {
      return (o.mode & Sn) !== vn && (o.flags & Gn) === xn;
    }
    function $E(o) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function YE(o) {
      if (Bu) {
        var u = Kl;
        if (!u) {
          WE(o) && (GE(xa, o), $E()), N5(xa, o), Bu = !1, xa = o;
          return;
        }
        var x = u;
        if (!I5(o, u)) {
          WE(o) && (GE(xa, o), $E()), u = o_(x);
          var D = xa;
          if (!u || !I5(o, u)) {
            N5(xa, o), Bu = !1, xa = o;
            return;
          }
          R5(D, x);
        }
      }
    }
    function NN(o, u, x) {
      var D = o.stateNode, F = !Up, Z = KR(D, o.type, o.memoizedProps, u, x, o, F);
      return o.updateQueue = Z, Z !== null;
    }
    function IN(o) {
      var u = o.stateNode, x = o.memoizedProps, D = QR(u, x, o);
      if (D) {
        var F = xa;
        if (F !== null)
          switch (F.tag) {
            case h: {
              var Z = F.stateNode.containerInfo, de = (F.mode & Sn) !== vn;
              rN(
                Z,
                u,
                x,
                // TODO: Delete this argument when we remove the legacy root API.
                de
              );
              break;
            }
            case g: {
              var ge = F.type, xe = F.memoizedProps, Le = F.stateNode, Ue = (F.mode & Sn) !== vn;
              iN(
                ge,
                xe,
                Le,
                u,
                x,
                // TODO: Delete this argument when we remove the legacy root API.
                Ue
              );
              break;
            }
          }
      }
      return D;
    }
    function LN(o) {
      var u = o.memoizedState, x = u !== null ? u.dehydrated : null;
      if (!x)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      ZR(x, o);
    }
    function MN(o) {
      var u = o.memoizedState, x = u !== null ? u.dehydrated : null;
      if (!x)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return JR(x);
    }
    function L5(o) {
      for (var u = o.return; u !== null && u.tag !== g && u.tag !== h && u.tag !== A; )
        u = u.return;
      xa = u;
    }
    function Gy(o) {
      if (o !== xa)
        return !1;
      if (!Bu)
        return L5(o), Bu = !0, !1;
      if (o.tag !== h && (o.tag !== g || nN(o.type) && !OE(o.type, o.memoizedProps))) {
        var u = Kl;
        if (u)
          if (WE(o))
            M5(o), $E();
          else
            for (; u; )
              R5(o, u), u = o_(u);
      }
      return L5(o), o.tag === A ? Kl = MN(o) : Kl = xa ? o_(o.stateNode) : null, !0;
    }
    function PN() {
      return Bu && Kl !== null;
    }
    function M5(o) {
      for (var u = Kl; u; )
        D5(o, u), u = o_(u);
    }
    function xg() {
      xa = null, Kl = null, Bu = !1, Up = !1;
    }
    function P5() {
      Eh !== null && (Ok(Eh), Eh = null);
    }
    function Ta() {
      return Bu;
    }
    function XE(o) {
      Eh === null ? Eh = [o] : Eh.push(o);
    }
    var jN = t.ReactCurrentBatchConfig, BN = null;
    function FN() {
      return jN.transition;
    }
    var Fu = {
      recordUnsafeLifecycleWarnings: function(o, u) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(o, u) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var UN = function(o) {
        for (var u = null, x = o; x !== null; )
          x.mode & lr && (u = x), x = x.return;
        return u;
      }, Hp = function(o) {
        var u = [];
        return o.forEach(function(x) {
          u.push(x);
        }), u.sort().join(", ");
      }, u_ = [], c_ = [], d_ = [], f_ = [], h_ = [], p_ = [], zp = /* @__PURE__ */ new Set();
      Fu.recordUnsafeLifecycleWarnings = function(o, u) {
        zp.has(o.type) || (typeof u.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        u.componentWillMount.__suppressDeprecationWarning !== !0 && u_.push(o), o.mode & lr && typeof u.UNSAFE_componentWillMount == "function" && c_.push(o), typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && d_.push(o), o.mode & lr && typeof u.UNSAFE_componentWillReceiveProps == "function" && f_.push(o), typeof u.componentWillUpdate == "function" && u.componentWillUpdate.__suppressDeprecationWarning !== !0 && h_.push(o), o.mode & lr && typeof u.UNSAFE_componentWillUpdate == "function" && p_.push(o));
      }, Fu.flushPendingUnsafeLifecycleWarnings = function() {
        var o = /* @__PURE__ */ new Set();
        u_.length > 0 && (u_.forEach(function(ot) {
          o.add(Yn(ot) || "Component"), zp.add(ot.type);
        }), u_ = []);
        var u = /* @__PURE__ */ new Set();
        c_.length > 0 && (c_.forEach(function(ot) {
          u.add(Yn(ot) || "Component"), zp.add(ot.type);
        }), c_ = []);
        var x = /* @__PURE__ */ new Set();
        d_.length > 0 && (d_.forEach(function(ot) {
          x.add(Yn(ot) || "Component"), zp.add(ot.type);
        }), d_ = []);
        var D = /* @__PURE__ */ new Set();
        f_.length > 0 && (f_.forEach(function(ot) {
          D.add(Yn(ot) || "Component"), zp.add(ot.type);
        }), f_ = []);
        var F = /* @__PURE__ */ new Set();
        h_.length > 0 && (h_.forEach(function(ot) {
          F.add(Yn(ot) || "Component"), zp.add(ot.type);
        }), h_ = []);
        var Z = /* @__PURE__ */ new Set();
        if (p_.length > 0 && (p_.forEach(function(ot) {
          Z.add(Yn(ot) || "Component"), zp.add(ot.type);
        }), p_ = []), u.size > 0) {
          var de = Hp(u);
          s(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, de);
        }
        if (D.size > 0) {
          var ge = Hp(D);
          s(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, ge);
        }
        if (Z.size > 0) {
          var xe = Hp(Z);
          s(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, xe);
        }
        if (o.size > 0) {
          var Le = Hp(o);
          a(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Le);
        }
        if (x.size > 0) {
          var Ue = Hp(x);
          a(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ue);
        }
        if (F.size > 0) {
          var st = Hp(F);
          a(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, st);
        }
      };
      var Wy = /* @__PURE__ */ new Map(), j5 = /* @__PURE__ */ new Set();
      Fu.recordLegacyContextWarning = function(o, u) {
        var x = UN(o);
        if (x === null) {
          s("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!j5.has(o.type)) {
          var D = Wy.get(x);
          (o.type.contextTypes != null || o.type.childContextTypes != null || u !== null && typeof u.getChildContext == "function") && (D === void 0 && (D = [], Wy.set(x, D)), D.push(o));
        }
      }, Fu.flushLegacyContextWarning = function() {
        Wy.forEach(function(o, u) {
          if (o.length !== 0) {
            var x = o[0], D = /* @__PURE__ */ new Set();
            o.forEach(function(Z) {
              D.add(Yn(Z) || "Component"), j5.add(Z.type);
            });
            var F = Hp(D);
            try {
              Or(x), s(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, F);
            } finally {
              fi();
            }
          }
        });
      }, Fu.discardPendingWarnings = function() {
        u_ = [], c_ = [], d_ = [], f_ = [], h_ = [], p_ = [], Wy = /* @__PURE__ */ new Map();
      };
    }
    var KE, QE, ZE, JE, eS, B5 = function(o, u) {
    };
    KE = !1, QE = !1, ZE = {}, JE = {}, eS = {}, B5 = function(o, u) {
      if (!(o === null || typeof o != "object") && !(!o._store || o._store.validated || o.key != null)) {
        if (typeof o._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        o._store.validated = !0;
        var x = Yn(u) || "Component";
        JE[x] || (JE[x] = !0, s('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function HN(o) {
      return o.prototype && o.prototype.isReactComponent;
    }
    function m_(o, u, x) {
      var D = x.ref;
      if (D !== null && typeof D != "function" && typeof D != "object") {
        if ((o.mode & lr || z) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(x._owner && x._self && x._owner.stateNode !== x._self) && // Will already throw with "Function components cannot have string refs"
        !(x._owner && x._owner.tag !== d) && // Will already warn with "Function components cannot be given refs"
        !(typeof x.type == "function" && !HN(x.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        x._owner) {
          var F = Yn(o) || "Component";
          ZE[F] || (s('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F, D), ZE[F] = !0);
        }
        if (x._owner) {
          var Z = x._owner, de;
          if (Z) {
            var ge = Z;
            if (ge.tag !== d)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            de = ge.stateNode;
          }
          if (!de)
            throw new Error("Missing owner for string ref " + D + ". This error is likely caused by a bug in React. Please file an issue.");
          var xe = de;
          tt(D, "ref");
          var Le = "" + D;
          if (u !== null && u.ref !== null && typeof u.ref == "function" && u.ref._stringRef === Le)
            return u.ref;
          var Ue = function(st) {
            var ot = xe.refs;
            st === null ? delete ot[Le] : ot[Le] = st;
          };
          return Ue._stringRef = Le, Ue;
        } else {
          if (typeof D != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!x._owner)
            throw new Error("Element ref was specified as a string (" + D + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return D;
    }
    function $y(o, u) {
      var x = Object.prototype.toString.call(u);
      throw new Error("Objects are not valid as a React child (found: " + (x === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : x) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Yy(o) {
      {
        var u = Yn(o) || "Component";
        if (eS[u])
          return;
        eS[u] = !0, s("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function F5(o) {
      var u = o._payload, x = o._init;
      return x(u);
    }
    function U5(o) {
      function u(gt, Rt) {
        if (o) {
          var _t = gt.deletions;
          _t === null ? (gt.deletions = [Rt], gt.flags |= Tr) : _t.push(Rt);
        }
      }
      function x(gt, Rt) {
        if (!o)
          return null;
        for (var _t = Rt; _t !== null; )
          u(gt, _t), _t = _t.sibling;
        return null;
      }
      function D(gt, Rt) {
        for (var _t = /* @__PURE__ */ new Map(), Gt = Rt; Gt !== null; )
          Gt.key !== null ? _t.set(Gt.key, Gt) : _t.set(Gt.index, Gt), Gt = Gt.sibling;
        return _t;
      }
      function F(gt, Rt) {
        var _t = Qp(gt, Rt);
        return _t.index = 0, _t.sibling = null, _t;
      }
      function Z(gt, Rt, _t) {
        if (gt.index = _t, !o)
          return gt.flags |= ya, Rt;
        var Gt = gt.alternate;
        if (Gt !== null) {
          var sn = Gt.index;
          return sn < Rt ? (gt.flags |= Yr, Rt) : sn;
        } else
          return gt.flags |= Yr, Rt;
      }
      function de(gt) {
        return o && gt.alternate === null && (gt.flags |= Yr), gt;
      }
      function ge(gt, Rt, _t, Gt) {
        if (Rt === null || Rt.tag !== _) {
          var sn = XC(_t, gt.mode, Gt);
          return sn.return = gt, sn;
        } else {
          var nn = F(Rt, _t);
          return nn.return = gt, nn;
        }
      }
      function xe(gt, Rt, _t, Gt) {
        var sn = _t.type;
        if (sn === Kt)
          return Ue(gt, Rt, _t.props.children, Gt, _t.key);
        if (Rt !== null && (Rt.elementType === sn || // Keep this check inline so it only runs on the false path:
        Gk(Rt, _t) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof sn == "object" && sn !== null && sn.$$typeof === br && F5(sn) === Rt.type)) {
          var nn = F(Rt, _t.props);
          return nn.ref = m_(gt, Rt, _t), nn.return = gt, nn._debugSource = _t._source, nn._debugOwner = _t._owner, nn;
        }
        var Xn = YC(_t, gt.mode, Gt);
        return Xn.ref = m_(gt, Rt, _t), Xn.return = gt, Xn;
      }
      function Le(gt, Rt, _t, Gt) {
        if (Rt === null || Rt.tag !== p || Rt.stateNode.containerInfo !== _t.containerInfo || Rt.stateNode.implementation !== _t.implementation) {
          var sn = KC(_t, gt.mode, Gt);
          return sn.return = gt, sn;
        } else {
          var nn = F(Rt, _t.children || []);
          return nn.return = gt, nn;
        }
      }
      function Ue(gt, Rt, _t, Gt, sn) {
        if (Rt === null || Rt.tag !== b) {
          var nn = Nh(_t, gt.mode, Gt, sn);
          return nn.return = gt, nn;
        } else {
          var Xn = F(Rt, _t);
          return Xn.return = gt, Xn;
        }
      }
      function st(gt, Rt, _t) {
        if (typeof Rt == "string" && Rt !== "" || typeof Rt == "number") {
          var Gt = XC("" + Rt, gt.mode, _t);
          return Gt.return = gt, Gt;
        }
        if (typeof Rt == "object" && Rt !== null) {
          switch (Rt.$$typeof) {
            case Vn: {
              var sn = YC(Rt, gt.mode, _t);
              return sn.ref = m_(gt, null, Rt), sn.return = gt, sn;
            }
            case En: {
              var nn = KC(Rt, gt.mode, _t);
              return nn.return = gt, nn;
            }
            case br: {
              var Xn = Rt._payload, nr = Rt._init;
              return st(gt, nr(Xn), _t);
            }
          }
          if (Pi(Rt) || pa(Rt)) {
            var Zr = Nh(Rt, gt.mode, _t, null);
            return Zr.return = gt, Zr;
          }
          $y(gt, Rt);
        }
        return typeof Rt == "function" && Yy(gt), null;
      }
      function ot(gt, Rt, _t, Gt) {
        var sn = Rt !== null ? Rt.key : null;
        if (typeof _t == "string" && _t !== "" || typeof _t == "number")
          return sn !== null ? null : ge(gt, Rt, "" + _t, Gt);
        if (typeof _t == "object" && _t !== null) {
          switch (_t.$$typeof) {
            case Vn:
              return _t.key === sn ? xe(gt, Rt, _t, Gt) : null;
            case En:
              return _t.key === sn ? Le(gt, Rt, _t, Gt) : null;
            case br: {
              var nn = _t._payload, Xn = _t._init;
              return ot(gt, Rt, Xn(nn), Gt);
            }
          }
          if (Pi(_t) || pa(_t))
            return sn !== null ? null : Ue(gt, Rt, _t, Gt, null);
          $y(gt, _t);
        }
        return typeof _t == "function" && Yy(gt), null;
      }
      function Et(gt, Rt, _t, Gt, sn) {
        if (typeof Gt == "string" && Gt !== "" || typeof Gt == "number") {
          var nn = gt.get(_t) || null;
          return ge(Rt, nn, "" + Gt, sn);
        }
        if (typeof Gt == "object" && Gt !== null) {
          switch (Gt.$$typeof) {
            case Vn: {
              var Xn = gt.get(Gt.key === null ? _t : Gt.key) || null;
              return xe(Rt, Xn, Gt, sn);
            }
            case En: {
              var nr = gt.get(Gt.key === null ? _t : Gt.key) || null;
              return Le(Rt, nr, Gt, sn);
            }
            case br:
              var Zr = Gt._payload, Nr = Gt._init;
              return Et(gt, Rt, _t, Nr(Zr), sn);
          }
          if (Pi(Gt) || pa(Gt)) {
            var _o = gt.get(_t) || null;
            return Ue(Rt, _o, Gt, sn, null);
          }
          $y(Rt, Gt);
        }
        return typeof Gt == "function" && Yy(Rt), null;
      }
      function wt(gt, Rt, _t) {
        {
          if (typeof gt != "object" || gt === null)
            return Rt;
          switch (gt.$$typeof) {
            case Vn:
            case En:
              B5(gt, _t);
              var Gt = gt.key;
              if (typeof Gt != "string")
                break;
              if (Rt === null) {
                Rt = /* @__PURE__ */ new Set(), Rt.add(Gt);
                break;
              }
              if (!Rt.has(Gt)) {
                Rt.add(Gt);
                break;
              }
              s("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Gt);
              break;
            case br:
              var sn = gt._payload, nn = gt._init;
              wt(nn(sn), Rt, _t);
              break;
          }
        }
        return Rt;
      }
      function Dt(gt, Rt, _t, Gt) {
        for (var sn = null, nn = 0; nn < _t.length; nn++) {
          var Xn = _t[nn];
          sn = wt(Xn, sn, gt);
        }
        for (var nr = null, Zr = null, Nr = Rt, _o = 0, Ir = 0, io = null; Nr !== null && Ir < _t.length; Ir++) {
          Nr.index > Ir ? (io = Nr, Nr = null) : io = Nr.sibling;
          var Ka = ot(gt, Nr, _t[Ir], Gt);
          if (Ka === null) {
            Nr === null && (Nr = io);
            break;
          }
          o && Nr && Ka.alternate === null && u(gt, Nr), _o = Z(Ka, _o, Ir), Zr === null ? nr = Ka : Zr.sibling = Ka, Zr = Ka, Nr = io;
        }
        if (Ir === _t.length) {
          if (x(gt, Nr), Ta()) {
            var Ia = Ir;
            Bp(gt, Ia);
          }
          return nr;
        }
        if (Nr === null) {
          for (; Ir < _t.length; Ir++) {
            var bl = st(gt, _t[Ir], Gt);
            bl !== null && (_o = Z(bl, _o, Ir), Zr === null ? nr = bl : Zr.sibling = bl, Zr = bl);
          }
          if (Ta()) {
            var hs = Ir;
            Bp(gt, hs);
          }
          return nr;
        }
        for (var ps = D(gt, Nr); Ir < _t.length; Ir++) {
          var Qa = Et(ps, gt, Ir, _t[Ir], Gt);
          Qa !== null && (o && Qa.alternate !== null && ps.delete(Qa.key === null ? Ir : Qa.key), _o = Z(Qa, _o, Ir), Zr === null ? nr = Qa : Zr.sibling = Qa, Zr = Qa);
        }
        if (o && ps.forEach(function(qg) {
          return u(gt, qg);
        }), Ta()) {
          var sf = Ir;
          Bp(gt, sf);
        }
        return nr;
      }
      function tn(gt, Rt, _t, Gt) {
        var sn = pa(_t);
        if (typeof sn != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          _t[Symbol.toStringTag] === "Generator" && (QE || s("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), QE = !0), _t.entries === sn && (KE || s("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), KE = !0);
          var nn = sn.call(_t);
          if (nn)
            for (var Xn = null, nr = nn.next(); !nr.done; nr = nn.next()) {
              var Zr = nr.value;
              Xn = wt(Zr, Xn, gt);
            }
        }
        var Nr = sn.call(_t);
        if (Nr == null)
          throw new Error("An iterable object provided no iterator.");
        for (var _o = null, Ir = null, io = Rt, Ka = 0, Ia = 0, bl = null, hs = Nr.next(); io !== null && !hs.done; Ia++, hs = Nr.next()) {
          io.index > Ia ? (bl = io, io = null) : bl = io.sibling;
          var ps = ot(gt, io, hs.value, Gt);
          if (ps === null) {
            io === null && (io = bl);
            break;
          }
          o && io && ps.alternate === null && u(gt, io), Ka = Z(ps, Ka, Ia), Ir === null ? _o = ps : Ir.sibling = ps, Ir = ps, io = bl;
        }
        if (hs.done) {
          if (x(gt, io), Ta()) {
            var Qa = Ia;
            Bp(gt, Qa);
          }
          return _o;
        }
        if (io === null) {
          for (; !hs.done; Ia++, hs = Nr.next()) {
            var sf = st(gt, hs.value, Gt);
            sf !== null && (Ka = Z(sf, Ka, Ia), Ir === null ? _o = sf : Ir.sibling = sf, Ir = sf);
          }
          if (Ta()) {
            var qg = Ia;
            Bp(gt, qg);
          }
          return _o;
        }
        for (var $_ = D(gt, io); !hs.done; Ia++, hs = Nr.next()) {
          var ed = Et($_, gt, Ia, hs.value, Gt);
          ed !== null && (o && ed.alternate !== null && $_.delete(ed.key === null ? Ia : ed.key), Ka = Z(ed, Ka, Ia), Ir === null ? _o = ed : Ir.sibling = ed, Ir = ed);
        }
        if (o && $_.forEach(function(hP) {
          return u(gt, hP);
        }), Ta()) {
          var fP = Ia;
          Bp(gt, fP);
        }
        return _o;
      }
      function Ln(gt, Rt, _t, Gt) {
        if (Rt !== null && Rt.tag === _) {
          x(gt, Rt.sibling);
          var sn = F(Rt, _t);
          return sn.return = gt, sn;
        }
        x(gt, Rt);
        var nn = XC(_t, gt.mode, Gt);
        return nn.return = gt, nn;
      }
      function Tn(gt, Rt, _t, Gt) {
        for (var sn = _t.key, nn = Rt; nn !== null; ) {
          if (nn.key === sn) {
            var Xn = _t.type;
            if (Xn === Kt) {
              if (nn.tag === b) {
                x(gt, nn.sibling);
                var nr = F(nn, _t.props.children);
                return nr.return = gt, nr._debugSource = _t._source, nr._debugOwner = _t._owner, nr;
              }
            } else if (nn.elementType === Xn || // Keep this check inline so it only runs on the false path:
            Gk(nn, _t) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Xn == "object" && Xn !== null && Xn.$$typeof === br && F5(Xn) === nn.type) {
              x(gt, nn.sibling);
              var Zr = F(nn, _t.props);
              return Zr.ref = m_(gt, nn, _t), Zr.return = gt, Zr._debugSource = _t._source, Zr._debugOwner = _t._owner, Zr;
            }
            x(gt, nn);
            break;
          } else
            u(gt, nn);
          nn = nn.sibling;
        }
        if (_t.type === Kt) {
          var Nr = Nh(_t.props.children, gt.mode, Gt, _t.key);
          return Nr.return = gt, Nr;
        } else {
          var _o = YC(_t, gt.mode, Gt);
          return _o.ref = m_(gt, Rt, _t), _o.return = gt, _o;
        }
      }
      function xr(gt, Rt, _t, Gt) {
        for (var sn = _t.key, nn = Rt; nn !== null; ) {
          if (nn.key === sn)
            if (nn.tag === p && nn.stateNode.containerInfo === _t.containerInfo && nn.stateNode.implementation === _t.implementation) {
              x(gt, nn.sibling);
              var Xn = F(nn, _t.children || []);
              return Xn.return = gt, Xn;
            } else {
              x(gt, nn);
              break;
            }
          else
            u(gt, nn);
          nn = nn.sibling;
        }
        var nr = KC(_t, gt.mode, Gt);
        return nr.return = gt, nr;
      }
      function gr(gt, Rt, _t, Gt) {
        var sn = typeof _t == "object" && _t !== null && _t.type === Kt && _t.key === null;
        if (sn && (_t = _t.props.children), typeof _t == "object" && _t !== null) {
          switch (_t.$$typeof) {
            case Vn:
              return de(Tn(gt, Rt, _t, Gt));
            case En:
              return de(xr(gt, Rt, _t, Gt));
            case br:
              var nn = _t._payload, Xn = _t._init;
              return gr(gt, Rt, Xn(nn), Gt);
          }
          if (Pi(_t))
            return Dt(gt, Rt, _t, Gt);
          if (pa(_t))
            return tn(gt, Rt, _t, Gt);
          $y(gt, _t);
        }
        return typeof _t == "string" && _t !== "" || typeof _t == "number" ? de(Ln(gt, Rt, "" + _t, Gt)) : (typeof _t == "function" && Yy(gt), x(gt, Rt));
      }
      return gr;
    }
    var Tg = U5(!0), H5 = U5(!1);
    function zN(o, u) {
      if (o !== null && u.child !== o.child)
        throw new Error("Resuming work not yet implemented.");
      if (u.child !== null) {
        var x = u.child, D = Qp(x, x.pendingProps);
        for (u.child = D, D.return = u; x.sibling !== null; )
          x = x.sibling, D = D.sibling = Qp(x, x.pendingProps), D.return = u;
        D.sibling = null;
      }
    }
    function VN(o, u) {
      for (var x = o.child; x !== null; )
        DM(x, u), x = x.sibling;
    }
    var tS = yh(null), nS;
    nS = {};
    var Xy = null, Ag = null, rS = null, Ky = !1;
    function Qy() {
      Xy = null, Ag = null, rS = null, Ky = !1;
    }
    function z5() {
      Ky = !0;
    }
    function V5() {
      Ky = !1;
    }
    function q5(o, u, x) {
      Ya(tS, u._currentValue, o), u._currentValue = x, u._currentRenderer !== void 0 && u._currentRenderer !== null && u._currentRenderer !== nS && s("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), u._currentRenderer = nS;
    }
    function iS(o, u) {
      var x = tS.current;
      $a(tS, u), o._currentValue = x;
    }
    function oS(o, u, x) {
      for (var D = o; D !== null; ) {
        var F = D.alternate;
        if (Hd(D.childLanes, u) ? F !== null && !Hd(F.childLanes, u) && (F.childLanes = or(F.childLanes, u)) : (D.childLanes = or(D.childLanes, u), F !== null && (F.childLanes = or(F.childLanes, u))), D === x)
          break;
        D = D.return;
      }
      D !== x && s("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function qN(o, u, x) {
      GN(o, u, x);
    }
    function GN(o, u, x) {
      var D = o.child;
      for (D !== null && (D.return = o); D !== null; ) {
        var F = void 0, Z = D.dependencies;
        if (Z !== null) {
          F = D.child;
          for (var de = Z.firstContext; de !== null; ) {
            if (de.context === u) {
              if (D.tag === d) {
                var ge = Jf(x), xe = ef(Gr, ge);
                xe.tag = Jy;
                var Le = D.updateQueue;
                if (Le !== null) {
                  var Ue = Le.shared, st = Ue.pending;
                  st === null ? xe.next = xe : (xe.next = st.next, st.next = xe), Ue.pending = xe;
                }
              }
              D.lanes = or(D.lanes, x);
              var ot = D.alternate;
              ot !== null && (ot.lanes = or(ot.lanes, x)), oS(D.return, x, o), Z.lanes = or(Z.lanes, x);
              break;
            }
            de = de.next;
          }
        } else if (D.tag === C)
          F = D.type === o.type ? null : D.child;
        else if (D.tag === B) {
          var Et = D.return;
          if (Et === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Et.lanes = or(Et.lanes, x);
          var wt = Et.alternate;
          wt !== null && (wt.lanes = or(wt.lanes, x)), oS(Et, x, o), F = D.sibling;
        } else
          F = D.child;
        if (F !== null)
          F.return = D;
        else
          for (F = D; F !== null; ) {
            if (F === o) {
              F = null;
              break;
            }
            var Dt = F.sibling;
            if (Dt !== null) {
              Dt.return = F.return, F = Dt;
              break;
            }
            F = F.return;
          }
        D = F;
      }
    }
    function kg(o, u) {
      Xy = o, Ag = null, rS = null;
      var x = o.dependencies;
      if (x !== null) {
        var D = x.firstContext;
        D !== null && (Ga(x.lanes, u) && D_(), x.firstContext = null);
      }
    }
    function Do(o) {
      Ky && s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var u = o._currentValue;
      if (rS !== o) {
        var x = {
          context: o,
          memoizedValue: u,
          next: null
        };
        if (Ag === null) {
          if (Xy === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Ag = x, Xy.dependencies = {
            lanes: jt,
            firstContext: x
          };
        } else
          Ag = Ag.next = x;
      }
      return u;
    }
    var Vp = null;
    function aS(o) {
      Vp === null ? Vp = [o] : Vp.push(o);
    }
    function WN() {
      if (Vp !== null) {
        for (var o = 0; o < Vp.length; o++) {
          var u = Vp[o], x = u.interleaved;
          if (x !== null) {
            u.interleaved = null;
            var D = x.next, F = u.pending;
            if (F !== null) {
              var Z = F.next;
              F.next = D, x.next = Z;
            }
            u.pending = x;
          }
        }
        Vp = null;
      }
    }
    function G5(o, u, x, D) {
      var F = u.interleaved;
      return F === null ? (x.next = x, aS(u)) : (x.next = F.next, F.next = x), u.interleaved = x, Zy(o, D);
    }
    function $N(o, u, x, D) {
      var F = u.interleaved;
      F === null ? (x.next = x, aS(u)) : (x.next = F.next, F.next = x), u.interleaved = x;
    }
    function YN(o, u, x, D) {
      var F = u.interleaved;
      return F === null ? (x.next = x, aS(u)) : (x.next = F.next, F.next = x), u.interleaved = x, Zy(o, D);
    }
    function Hs(o, u) {
      return Zy(o, u);
    }
    var XN = Zy;
    function Zy(o, u) {
      o.lanes = or(o.lanes, u);
      var x = o.alternate;
      x !== null && (x.lanes = or(x.lanes, u)), x === null && (o.flags & (Yr | _a)) !== xn && Hk(o);
      for (var D = o, F = o.return; F !== null; )
        F.childLanes = or(F.childLanes, u), x = F.alternate, x !== null ? x.childLanes = or(x.childLanes, u) : (F.flags & (Yr | _a)) !== xn && Hk(o), D = F, F = F.return;
      if (D.tag === h) {
        var Z = D.stateNode;
        return Z;
      } else
        return null;
    }
    var W5 = 0, $5 = 1, Jy = 2, sS = 3, ev = !1, lS, tv;
    lS = !1, tv = null;
    function uS(o) {
      var u = {
        baseState: o.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: jt
        },
        effects: null
      };
      o.updateQueue = u;
    }
    function Y5(o, u) {
      var x = u.updateQueue, D = o.updateQueue;
      if (x === D) {
        var F = {
          baseState: D.baseState,
          firstBaseUpdate: D.firstBaseUpdate,
          lastBaseUpdate: D.lastBaseUpdate,
          shared: D.shared,
          effects: D.effects
        };
        u.updateQueue = F;
      }
    }
    function ef(o, u) {
      var x = {
        eventTime: o,
        lane: u,
        tag: W5,
        payload: null,
        callback: null,
        next: null
      };
      return x;
    }
    function Sh(o, u, x) {
      var D = o.updateQueue;
      if (D === null)
        return null;
      var F = D.shared;
      if (tv === F && !lS && (s("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), lS = !0), $L()) {
        var Z = F.pending;
        return Z === null ? u.next = u : (u.next = Z.next, Z.next = u), F.pending = u, XN(o, x);
      } else
        return YN(o, F, u, x);
    }
    function nv(o, u, x) {
      var D = u.updateQueue;
      if (D !== null) {
        var F = D.shared;
        if (D0(x)) {
          var Z = F.lanes;
          Z = Gm(Z, o.pendingLanes);
          var de = or(Z, x);
          F.lanes = de, R0(o, de);
        }
      }
    }
    function cS(o, u) {
      var x = o.updateQueue, D = o.alternate;
      if (D !== null) {
        var F = D.updateQueue;
        if (x === F) {
          var Z = null, de = null, ge = x.firstBaseUpdate;
          if (ge !== null) {
            var xe = ge;
            do {
              var Le = {
                eventTime: xe.eventTime,
                lane: xe.lane,
                tag: xe.tag,
                payload: xe.payload,
                callback: xe.callback,
                next: null
              };
              de === null ? Z = de = Le : (de.next = Le, de = Le), xe = xe.next;
            } while (xe !== null);
            de === null ? Z = de = u : (de.next = u, de = u);
          } else
            Z = de = u;
          x = {
            baseState: F.baseState,
            firstBaseUpdate: Z,
            lastBaseUpdate: de,
            shared: F.shared,
            effects: F.effects
          }, o.updateQueue = x;
          return;
        }
      }
      var Ue = x.lastBaseUpdate;
      Ue === null ? x.firstBaseUpdate = u : Ue.next = u, x.lastBaseUpdate = u;
    }
    function KN(o, u, x, D, F, Z) {
      switch (x.tag) {
        case $5: {
          var de = x.payload;
          if (typeof de == "function") {
            z5();
            var ge = de.call(Z, D, F);
            {
              if (o.mode & lr) {
                mi(!0);
                try {
                  de.call(Z, D, F);
                } finally {
                  mi(!1);
                }
              }
              V5();
            }
            return ge;
          }
          return de;
        }
        case sS:
          o.flags = o.flags & ~Ei | Gn;
        case W5: {
          var xe = x.payload, Le;
          if (typeof xe == "function") {
            z5(), Le = xe.call(Z, D, F);
            {
              if (o.mode & lr) {
                mi(!0);
                try {
                  xe.call(Z, D, F);
                } finally {
                  mi(!1);
                }
              }
              V5();
            }
          } else
            Le = xe;
          return Le == null ? D : Qn({}, D, Le);
        }
        case Jy:
          return ev = !0, D;
      }
      return D;
    }
    function rv(o, u, x, D) {
      var F = o.updateQueue;
      ev = !1, tv = F.shared;
      var Z = F.firstBaseUpdate, de = F.lastBaseUpdate, ge = F.shared.pending;
      if (ge !== null) {
        F.shared.pending = null;
        var xe = ge, Le = xe.next;
        xe.next = null, de === null ? Z = Le : de.next = Le, de = xe;
        var Ue = o.alternate;
        if (Ue !== null) {
          var st = Ue.updateQueue, ot = st.lastBaseUpdate;
          ot !== de && (ot === null ? st.firstBaseUpdate = Le : ot.next = Le, st.lastBaseUpdate = xe);
        }
      }
      if (Z !== null) {
        var Et = F.baseState, wt = jt, Dt = null, tn = null, Ln = null, Tn = Z;
        do {
          var xr = Tn.lane, gr = Tn.eventTime;
          if (Hd(D, xr)) {
            if (Ln !== null) {
              var Rt = {
                eventTime: gr,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: M,
                tag: Tn.tag,
                payload: Tn.payload,
                callback: Tn.callback,
                next: null
              };
              Ln = Ln.next = Rt;
            }
            Et = KN(o, F, Tn, Et, u, x);
            var _t = Tn.callback;
            if (_t !== null && // If the update was already committed, we should not queue its
            // callback again.
            Tn.lane !== M) {
              o.flags |= Xe;
              var Gt = F.effects;
              Gt === null ? F.effects = [Tn] : Gt.push(Tn);
            }
          } else {
            var gt = {
              eventTime: gr,
              lane: xr,
              tag: Tn.tag,
              payload: Tn.payload,
              callback: Tn.callback,
              next: null
            };
            Ln === null ? (tn = Ln = gt, Dt = Et) : Ln = Ln.next = gt, wt = or(wt, xr);
          }
          if (Tn = Tn.next, Tn === null) {
            if (ge = F.shared.pending, ge === null)
              break;
            var sn = ge, nn = sn.next;
            sn.next = null, Tn = nn, F.lastBaseUpdate = sn, F.shared.pending = null;
          }
        } while (!0);
        Ln === null && (Dt = Et), F.baseState = Dt, F.firstBaseUpdate = tn, F.lastBaseUpdate = Ln;
        var Xn = F.shared.interleaved;
        if (Xn !== null) {
          var nr = Xn;
          do
            wt = or(wt, nr.lane), nr = nr.next;
          while (nr !== Xn);
        } else Z === null && (F.shared.lanes = jt);
        z_(wt), o.lanes = wt, o.memoizedState = Et;
      }
      tv = null;
    }
    function QN(o, u) {
      if (typeof o != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + o));
      o.call(u);
    }
    function X5() {
      ev = !1;
    }
    function iv() {
      return ev;
    }
    function K5(o, u, x) {
      var D = u.effects;
      if (u.effects = null, D !== null)
        for (var F = 0; F < D.length; F++) {
          var Z = D[F], de = Z.callback;
          de !== null && (Z.callback = null, QN(de, x));
        }
    }
    var g_ = {}, Ch = yh(g_), __ = yh(g_), ov = yh(g_);
    function av(o) {
      if (o === g_)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return o;
    }
    function Q5() {
      var o = av(ov.current);
      return o;
    }
    function dS(o, u) {
      Ya(ov, u, o), Ya(__, o, o), Ya(Ch, g_, o);
      var x = pR(u);
      $a(Ch, o), Ya(Ch, x, o);
    }
    function Og(o) {
      $a(Ch, o), $a(__, o), $a(ov, o);
    }
    function fS() {
      var o = av(Ch.current);
      return o;
    }
    function Z5(o) {
      av(ov.current);
      var u = av(Ch.current), x = mR(u, o.type);
      u !== x && (Ya(__, o, o), Ya(Ch, x, o));
    }
    function hS(o) {
      __.current === o && ($a(Ch, o), $a(__, o));
    }
    var ZN = 0, J5 = 1, eA = 1, y_ = 2, Uu = yh(ZN);
    function pS(o, u) {
      return (o & u) !== 0;
    }
    function Dg(o) {
      return o & J5;
    }
    function mS(o, u) {
      return o & J5 | u;
    }
    function JN(o, u) {
      return o | u;
    }
    function wh(o, u) {
      Ya(Uu, u, o);
    }
    function Rg(o) {
      $a(Uu, o);
    }
    function eI(o, u) {
      var x = o.memoizedState;
      return x !== null ? x.dehydrated !== null : (o.memoizedProps, !0);
    }
    function sv(o) {
      for (var u = o; u !== null; ) {
        if (u.tag === A) {
          var x = u.memoizedState;
          if (x !== null) {
            var D = x.dehydrated;
            if (D === null || _5(D) || IE(D))
              return u;
          }
        } else if (u.tag === U && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        u.memoizedProps.revealOrder !== void 0) {
          var F = (u.flags & Gn) !== xn;
          if (F)
            return u;
        } else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === o)
          return null;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === o)
            return null;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return null;
    }
    var zs = (
      /*   */
      0
    ), Go = (
      /* */
      1
    ), $c = (
      /*  */
      2
    ), Wo = (
      /*    */
      4
    ), Aa = (
      /*   */
      8
    ), gS = [];
    function _S() {
      for (var o = 0; o < gS.length; o++) {
        var u = gS[o];
        u._workInProgressVersionPrimary = null;
      }
      gS.length = 0;
    }
    function tI(o, u) {
      var x = u._getVersion, D = x(u._source);
      o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [u, D] : o.mutableSourceEagerHydrationData.push(u, D);
    }
    var on = t.ReactCurrentDispatcher, v_ = t.ReactCurrentBatchConfig, yS, Ng;
    yS = /* @__PURE__ */ new Set();
    var qp = jt, Qr = null, $o = null, Yo = null, lv = !1, b_ = !1, E_ = 0, nI = 0, rI = 25, It = null, Ql = null, xh = -1, vS = !1;
    function Vr() {
      {
        var o = It;
        Ql === null ? Ql = [o] : Ql.push(o);
      }
    }
    function Zt() {
      {
        var o = It;
        Ql !== null && (xh++, Ql[xh] !== o && iI(o));
      }
    }
    function Ig(o) {
      o != null && !Pi(o) && s("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", It, typeof o);
    }
    function iI(o) {
      {
        var u = Yn(Qr);
        if (!yS.has(u) && (yS.add(u), Ql !== null)) {
          for (var x = "", D = 30, F = 0; F <= xh; F++) {
            for (var Z = Ql[F], de = F === xh ? o : Z, ge = F + 1 + ". " + Z; ge.length < D; )
              ge += " ";
            ge += de + `
`, x += ge;
          }
          s(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, u, x);
        }
      }
    }
    function Xa() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function bS(o, u) {
      if (vS)
        return !1;
      if (u === null)
        return s("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", It), !1;
      o.length !== u.length && s(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, It, "[" + u.join(", ") + "]", "[" + o.join(", ") + "]");
      for (var x = 0; x < u.length && x < o.length; x++)
        if (!_n(o[x], u[x]))
          return !1;
      return !0;
    }
    function Lg(o, u, x, D, F, Z) {
      qp = Z, Qr = u, Ql = o !== null ? o._debugHookTypes : null, xh = -1, vS = o !== null && o.type !== u.type, u.memoizedState = null, u.updateQueue = null, u.lanes = jt, o !== null && o.memoizedState !== null ? on.current = SA : Ql !== null ? on.current = EA : on.current = bA;
      var de = x(D, F);
      if (b_) {
        var ge = 0;
        do {
          if (b_ = !1, E_ = 0, ge >= rI)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          ge += 1, vS = !1, $o = null, Yo = null, u.updateQueue = null, xh = -1, on.current = CA, de = x(D, F);
        } while (b_);
      }
      on.current = Ev, u._debugHookTypes = Ql;
      var xe = $o !== null && $o.next !== null;
      if (qp = jt, Qr = null, $o = null, Yo = null, It = null, Ql = null, xh = -1, o !== null && (o.flags & to) !== (u.flags & to) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (o.mode & Sn) !== vn && s("Internal React error: Expected static flag was missing. Please notify the React team."), lv = !1, xe)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return de;
    }
    function Mg() {
      var o = E_ !== 0;
      return E_ = 0, o;
    }
    function tA(o, u, x) {
      u.updateQueue = o.updateQueue, (u.mode & Sa) !== vn ? u.flags &= ~(Os | eo | ii | Fn) : u.flags &= ~(ii | Fn), o.lanes = Ep(o.lanes, x);
    }
    function nA() {
      if (on.current = Ev, lv) {
        for (var o = Qr.memoizedState; o !== null; ) {
          var u = o.queue;
          u !== null && (u.pending = null), o = o.next;
        }
        lv = !1;
      }
      qp = jt, Qr = null, $o = null, Yo = null, Ql = null, xh = -1, It = null, mA = !1, b_ = !1, E_ = 0;
    }
    function Yc() {
      var o = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Yo === null ? Qr.memoizedState = Yo = o : Yo = Yo.next = o, Yo;
    }
    function Zl() {
      var o;
      if ($o === null) {
        var u = Qr.alternate;
        u !== null ? o = u.memoizedState : o = null;
      } else
        o = $o.next;
      var x;
      if (Yo === null ? x = Qr.memoizedState : x = Yo.next, x !== null)
        Yo = x, x = Yo.next, $o = o;
      else {
        if (o === null)
          throw new Error("Rendered more hooks than during the previous render.");
        $o = o;
        var D = {
          memoizedState: $o.memoizedState,
          baseState: $o.baseState,
          baseQueue: $o.baseQueue,
          queue: $o.queue,
          next: null
        };
        Yo === null ? Qr.memoizedState = Yo = D : Yo = Yo.next = D;
      }
      return Yo;
    }
    function rA() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function ES(o, u) {
      return typeof u == "function" ? u(o) : u;
    }
    function SS(o, u, x) {
      var D = Yc(), F;
      x !== void 0 ? F = x(u) : F = u, D.memoizedState = D.baseState = F;
      var Z = {
        pending: null,
        interleaved: null,
        lanes: jt,
        dispatch: null,
        lastRenderedReducer: o,
        lastRenderedState: F
      };
      D.queue = Z;
      var de = Z.dispatch = lI.bind(null, Qr, Z);
      return [D.memoizedState, de];
    }
    function CS(o, u, x) {
      var D = Zl(), F = D.queue;
      if (F === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      F.lastRenderedReducer = o;
      var Z = $o, de = Z.baseQueue, ge = F.pending;
      if (ge !== null) {
        if (de !== null) {
          var xe = de.next, Le = ge.next;
          de.next = Le, ge.next = xe;
        }
        Z.baseQueue !== de && s("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), Z.baseQueue = de = ge, F.pending = null;
      }
      if (de !== null) {
        var Ue = de.next, st = Z.baseState, ot = null, Et = null, wt = null, Dt = Ue;
        do {
          var tn = Dt.lane;
          if (Hd(qp, tn)) {
            if (wt !== null) {
              var Tn = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: M,
                action: Dt.action,
                hasEagerState: Dt.hasEagerState,
                eagerState: Dt.eagerState,
                next: null
              };
              wt = wt.next = Tn;
            }
            if (Dt.hasEagerState)
              st = Dt.eagerState;
            else {
              var xr = Dt.action;
              st = o(st, xr);
            }
          } else {
            var Ln = {
              lane: tn,
              action: Dt.action,
              hasEagerState: Dt.hasEagerState,
              eagerState: Dt.eagerState,
              next: null
            };
            wt === null ? (Et = wt = Ln, ot = st) : wt = wt.next = Ln, Qr.lanes = or(Qr.lanes, tn), z_(tn);
          }
          Dt = Dt.next;
        } while (Dt !== null && Dt !== Ue);
        wt === null ? ot = st : wt.next = Et, _n(st, D.memoizedState) || D_(), D.memoizedState = st, D.baseState = ot, D.baseQueue = wt, F.lastRenderedState = st;
      }
      var gr = F.interleaved;
      if (gr !== null) {
        var gt = gr;
        do {
          var Rt = gt.lane;
          Qr.lanes = or(Qr.lanes, Rt), z_(Rt), gt = gt.next;
        } while (gt !== gr);
      } else de === null && (F.lanes = jt);
      var _t = F.dispatch;
      return [D.memoizedState, _t];
    }
    function wS(o, u, x) {
      var D = Zl(), F = D.queue;
      if (F === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      F.lastRenderedReducer = o;
      var Z = F.dispatch, de = F.pending, ge = D.memoizedState;
      if (de !== null) {
        F.pending = null;
        var xe = de.next, Le = xe;
        do {
          var Ue = Le.action;
          ge = o(ge, Ue), Le = Le.next;
        } while (Le !== xe);
        _n(ge, D.memoizedState) || D_(), D.memoizedState = ge, D.baseQueue === null && (D.baseState = ge), F.lastRenderedState = ge;
      }
      return [ge, Z];
    }
    function Vie(o, u, x) {
    }
    function qie(o, u, x) {
    }
    function xS(o, u, x) {
      var D = Qr, F = Yc(), Z, de = Ta();
      if (de) {
        if (x === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        Z = x(), Ng || Z !== x() && (s("The result of getServerSnapshot should be cached to avoid an infinite loop"), Ng = !0);
      } else {
        if (Z = u(), !Ng) {
          var ge = u();
          _n(Z, ge) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), Ng = !0);
        }
        var xe = Uv();
        if (xe === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        bp(xe, qp) || iA(D, u, Z);
      }
      F.memoizedState = Z;
      var Le = {
        value: Z,
        getSnapshot: u
      };
      return F.queue = Le, hv(aA.bind(null, D, Le, o), [o]), D.flags |= ii, S_(Go | Aa, oA.bind(null, D, Le, Z, u), void 0, null), Z;
    }
    function uv(o, u, x) {
      var D = Qr, F = Zl(), Z = u();
      if (!Ng) {
        var de = u();
        _n(Z, de) || (s("The result of getSnapshot should be cached to avoid an infinite loop"), Ng = !0);
      }
      var ge = F.memoizedState, xe = !_n(ge, Z);
      xe && (F.memoizedState = Z, D_());
      var Le = F.queue;
      if (w_(aA.bind(null, D, Le, o), [o]), Le.getSnapshot !== u || xe || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Yo !== null && Yo.memoizedState.tag & Go) {
        D.flags |= ii, S_(Go | Aa, oA.bind(null, D, Le, Z, u), void 0, null);
        var Ue = Uv();
        if (Ue === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        bp(Ue, qp) || iA(D, u, Z);
      }
      return Z;
    }
    function iA(o, u, x) {
      o.flags |= Ou;
      var D = {
        getSnapshot: u,
        value: x
      }, F = Qr.updateQueue;
      if (F === null)
        F = rA(), Qr.updateQueue = F, F.stores = [D];
      else {
        var Z = F.stores;
        Z === null ? F.stores = [D] : Z.push(D);
      }
    }
    function oA(o, u, x, D) {
      u.value = x, u.getSnapshot = D, sA(u) && lA(o);
    }
    function aA(o, u, x) {
      var D = function() {
        sA(u) && lA(o);
      };
      return x(D);
    }
    function sA(o) {
      var u = o.getSnapshot, x = o.value;
      try {
        var D = u();
        return !_n(x, D);
      } catch {
        return !0;
      }
    }
    function lA(o) {
      var u = Hs(o, O);
      u !== null && Zo(u, o, O, Gr);
    }
    function cv(o) {
      var u = Yc();
      typeof o == "function" && (o = o()), u.memoizedState = u.baseState = o;
      var x = {
        pending: null,
        interleaved: null,
        lanes: jt,
        dispatch: null,
        lastRenderedReducer: ES,
        lastRenderedState: o
      };
      u.queue = x;
      var D = x.dispatch = uI.bind(null, Qr, x);
      return [u.memoizedState, D];
    }
    function TS(o) {
      return CS(ES);
    }
    function AS(o) {
      return wS(ES);
    }
    function S_(o, u, x, D) {
      var F = {
        tag: o,
        create: u,
        destroy: x,
        deps: D,
        // Circular
        next: null
      }, Z = Qr.updateQueue;
      if (Z === null)
        Z = rA(), Qr.updateQueue = Z, Z.lastEffect = F.next = F;
      else {
        var de = Z.lastEffect;
        if (de === null)
          Z.lastEffect = F.next = F;
        else {
          var ge = de.next;
          de.next = F, F.next = ge, Z.lastEffect = F;
        }
      }
      return F;
    }
    function kS(o) {
      var u = Yc();
      {
        var x = {
          current: o
        };
        return u.memoizedState = x, x;
      }
    }
    function dv(o) {
      var u = Zl();
      return u.memoizedState;
    }
    function C_(o, u, x, D) {
      var F = Yc(), Z = D === void 0 ? null : D;
      Qr.flags |= o, F.memoizedState = S_(Go | u, x, void 0, Z);
    }
    function fv(o, u, x, D) {
      var F = Zl(), Z = D === void 0 ? null : D, de = void 0;
      if ($o !== null) {
        var ge = $o.memoizedState;
        if (de = ge.destroy, Z !== null) {
          var xe = ge.deps;
          if (bS(Z, xe)) {
            F.memoizedState = S_(u, x, de, Z);
            return;
          }
        }
      }
      Qr.flags |= o, F.memoizedState = S_(Go | u, x, de, Z);
    }
    function hv(o, u) {
      return (Qr.mode & Sa) !== vn ? C_(Os | ii | za, Aa, o, u) : C_(ii | za, Aa, o, u);
    }
    function w_(o, u) {
      return fv(ii, Aa, o, u);
    }
    function OS(o, u) {
      return C_(Fn, $c, o, u);
    }
    function pv(o, u) {
      return fv(Fn, $c, o, u);
    }
    function DS(o, u) {
      var x = Fn;
      return x |= Ji, (Qr.mode & Sa) !== vn && (x |= eo), C_(x, Wo, o, u);
    }
    function mv(o, u) {
      return fv(Fn, Wo, o, u);
    }
    function uA(o, u) {
      if (typeof u == "function") {
        var x = u, D = o();
        return x(D), function() {
          x(null);
        };
      } else if (u != null) {
        var F = u;
        F.hasOwnProperty("current") || s("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(F).join(", ") + "}");
        var Z = o();
        return F.current = Z, function() {
          F.current = null;
        };
      }
    }
    function RS(o, u, x) {
      typeof u != "function" && s("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", u !== null ? typeof u : "null");
      var D = x != null ? x.concat([o]) : null, F = Fn;
      return F |= Ji, (Qr.mode & Sa) !== vn && (F |= eo), C_(F, Wo, uA.bind(null, u, o), D);
    }
    function gv(o, u, x) {
      typeof u != "function" && s("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", u !== null ? typeof u : "null");
      var D = x != null ? x.concat([o]) : null;
      return fv(Fn, Wo, uA.bind(null, u, o), D);
    }
    function oI(o, u) {
    }
    var _v = oI;
    function NS(o, u) {
      var x = Yc(), D = u === void 0 ? null : u;
      return x.memoizedState = [o, D], o;
    }
    function yv(o, u) {
      var x = Zl(), D = u === void 0 ? null : u, F = x.memoizedState;
      if (F !== null && D !== null) {
        var Z = F[1];
        if (bS(D, Z))
          return F[0];
      }
      return x.memoizedState = [o, D], o;
    }
    function IS(o, u) {
      var x = Yc(), D = u === void 0 ? null : u, F = o();
      return x.memoizedState = [F, D], F;
    }
    function vv(o, u) {
      var x = Zl(), D = u === void 0 ? null : u, F = x.memoizedState;
      if (F !== null && D !== null) {
        var Z = F[1];
        if (bS(D, Z))
          return F[0];
      }
      var de = o();
      return x.memoizedState = [de, D], de;
    }
    function LS(o) {
      var u = Yc();
      return u.memoizedState = o, o;
    }
    function cA(o) {
      var u = Zl(), x = $o, D = x.memoizedState;
      return fA(u, D, o);
    }
    function dA(o) {
      var u = Zl();
      if ($o === null)
        return u.memoizedState = o, o;
      var x = $o.memoizedState;
      return fA(u, x, o);
    }
    function fA(o, u, x) {
      var D = !X1(qp);
      if (D) {
        if (!_n(x, u)) {
          var F = Z1();
          Qr.lanes = or(Qr.lanes, F), z_(F), o.baseState = !0;
        }
        return u;
      } else
        return o.baseState && (o.baseState = !1, D_()), o.memoizedState = x, x;
    }
    function aI(o, u, x) {
      var D = Ms();
      Fi(eE(D, Iu)), o(!0);
      var F = v_.transition;
      v_.transition = {};
      var Z = v_.transition;
      v_.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        o(!1), u();
      } finally {
        if (Fi(D), v_.transition = F, F === null && Z._updatedFibers) {
          var de = Z._updatedFibers.size;
          de > 10 && a("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Z._updatedFibers.clear();
        }
      }
    }
    function MS() {
      var o = cv(!1), u = o[0], x = o[1], D = aI.bind(null, x), F = Yc();
      return F.memoizedState = D, [u, D];
    }
    function hA() {
      var o = TS(), u = o[0], x = Zl(), D = x.memoizedState;
      return [u, D];
    }
    function pA() {
      var o = AS(), u = o[0], x = Zl(), D = x.memoizedState;
      return [u, D];
    }
    var mA = !1;
    function sI() {
      return mA;
    }
    function PS() {
      var o = Yc(), u = Uv(), x = u.identifierPrefix, D;
      if (Ta()) {
        var F = wN();
        D = ":" + x + "R" + F;
        var Z = E_++;
        Z > 0 && (D += "H" + Z.toString(32)), D += ":";
      } else {
        var de = nI++;
        D = ":" + x + "r" + de.toString(32) + ":";
      }
      return o.memoizedState = D, D;
    }
    function bv() {
      var o = Zl(), u = o.memoizedState;
      return u;
    }
    function lI(o, u, x) {
      typeof arguments[3] == "function" && s("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var D = Dh(o), F = {
        lane: D,
        action: x,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (gA(o))
        _A(u, F);
      else {
        var Z = G5(o, u, F, D);
        if (Z !== null) {
          var de = fs();
          Zo(Z, o, D, de), yA(Z, u, D);
        }
      }
      vA(o, D);
    }
    function uI(o, u, x) {
      typeof arguments[3] == "function" && s("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var D = Dh(o), F = {
        lane: D,
        action: x,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (gA(o))
        _A(u, F);
      else {
        var Z = o.alternate;
        if (o.lanes === jt && (Z === null || Z.lanes === jt)) {
          var de = u.lastRenderedReducer;
          if (de !== null) {
            var ge;
            ge = on.current, on.current = Hu;
            try {
              var xe = u.lastRenderedState, Le = de(xe, x);
              if (F.hasEagerState = !0, F.eagerState = Le, _n(Le, xe)) {
                $N(o, u, F, D);
                return;
              }
            } catch {
            } finally {
              on.current = ge;
            }
          }
        }
        var Ue = G5(o, u, F, D);
        if (Ue !== null) {
          var st = fs();
          Zo(Ue, o, D, st), yA(Ue, u, D);
        }
      }
      vA(o, D);
    }
    function gA(o) {
      var u = o.alternate;
      return o === Qr || u !== null && u === Qr;
    }
    function _A(o, u) {
      b_ = lv = !0;
      var x = o.pending;
      x === null ? u.next = u : (u.next = x.next, x.next = u), o.pending = u;
    }
    function yA(o, u, x) {
      if (D0(x)) {
        var D = u.lanes;
        D = Gm(D, o.pendingLanes);
        var F = or(D, x);
        u.lanes = F, R0(o, F);
      }
    }
    function vA(o, u, x) {
      ct(o, u);
    }
    var Ev = {
      readContext: Do,
      useCallback: Xa,
      useContext: Xa,
      useEffect: Xa,
      useImperativeHandle: Xa,
      useInsertionEffect: Xa,
      useLayoutEffect: Xa,
      useMemo: Xa,
      useReducer: Xa,
      useRef: Xa,
      useState: Xa,
      useDebugValue: Xa,
      useDeferredValue: Xa,
      useTransition: Xa,
      useMutableSource: Xa,
      useSyncExternalStore: Xa,
      useId: Xa,
      unstable_isNewReconciler: te
    }, bA = null, EA = null, SA = null, CA = null, Xc = null, Hu = null, Sv = null;
    {
      var jS = function() {
        s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Jn = function() {
        s("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      bA = {
        readContext: function(o) {
          return Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Vr(), Ig(u), NS(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Vr(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Vr(), Ig(u), hv(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Vr(), Ig(x), RS(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Vr(), Ig(u), OS(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Vr(), Ig(u), DS(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Vr(), Ig(u);
          var x = on.current;
          on.current = Xc;
          try {
            return IS(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Vr();
          var D = on.current;
          on.current = Xc;
          try {
            return SS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Vr(), kS(o);
        },
        useState: function(o) {
          It = "useState", Vr();
          var u = on.current;
          on.current = Xc;
          try {
            return cv(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Vr(), void 0;
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Vr(), LS(o);
        },
        useTransition: function() {
          return It = "useTransition", Vr(), MS();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Vr(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Vr(), xS(o, u, x);
        },
        useId: function() {
          return It = "useId", Vr(), PS();
        },
        unstable_isNewReconciler: te
      }, EA = {
        readContext: function(o) {
          return Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Zt(), NS(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Zt(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Zt(), hv(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Zt(), RS(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Zt(), OS(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Zt(), DS(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Zt();
          var x = on.current;
          on.current = Xc;
          try {
            return IS(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Zt();
          var D = on.current;
          on.current = Xc;
          try {
            return SS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Zt(), kS(o);
        },
        useState: function(o) {
          It = "useState", Zt();
          var u = on.current;
          on.current = Xc;
          try {
            return cv(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Zt(), void 0;
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Zt(), LS(o);
        },
        useTransition: function() {
          return It = "useTransition", Zt(), MS();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Zt(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Zt(), xS(o, u, x);
        },
        useId: function() {
          return It = "useId", Zt(), PS();
        },
        unstable_isNewReconciler: te
      }, SA = {
        readContext: function(o) {
          return Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Zt(), yv(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Zt(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Zt(), w_(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Zt(), gv(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Zt(), pv(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Zt(), mv(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Zt();
          var x = on.current;
          on.current = Hu;
          try {
            return vv(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Zt();
          var D = on.current;
          on.current = Hu;
          try {
            return CS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Zt(), dv();
        },
        useState: function(o) {
          It = "useState", Zt();
          var u = on.current;
          on.current = Hu;
          try {
            return TS(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Zt(), _v();
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Zt(), cA(o);
        },
        useTransition: function() {
          return It = "useTransition", Zt(), hA();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Zt(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Zt(), uv(o, u);
        },
        useId: function() {
          return It = "useId", Zt(), bv();
        },
        unstable_isNewReconciler: te
      }, CA = {
        readContext: function(o) {
          return Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Zt(), yv(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Zt(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Zt(), w_(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Zt(), gv(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Zt(), pv(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Zt(), mv(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Zt();
          var x = on.current;
          on.current = Sv;
          try {
            return vv(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Zt();
          var D = on.current;
          on.current = Sv;
          try {
            return wS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Zt(), dv();
        },
        useState: function(o) {
          It = "useState", Zt();
          var u = on.current;
          on.current = Sv;
          try {
            return AS(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Zt(), _v();
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Zt(), dA(o);
        },
        useTransition: function() {
          return It = "useTransition", Zt(), pA();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Zt(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Zt(), uv(o, u);
        },
        useId: function() {
          return It = "useId", Zt(), bv();
        },
        unstable_isNewReconciler: te
      }, Xc = {
        readContext: function(o) {
          return jS(), Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Jn(), Vr(), NS(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Jn(), Vr(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Jn(), Vr(), hv(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Jn(), Vr(), RS(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Jn(), Vr(), OS(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Jn(), Vr(), DS(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Jn(), Vr();
          var x = on.current;
          on.current = Xc;
          try {
            return IS(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Jn(), Vr();
          var D = on.current;
          on.current = Xc;
          try {
            return SS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Jn(), Vr(), kS(o);
        },
        useState: function(o) {
          It = "useState", Jn(), Vr();
          var u = on.current;
          on.current = Xc;
          try {
            return cv(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Jn(), Vr(), void 0;
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Jn(), Vr(), LS(o);
        },
        useTransition: function() {
          return It = "useTransition", Jn(), Vr(), MS();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Jn(), Vr(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Jn(), Vr(), xS(o, u, x);
        },
        useId: function() {
          return It = "useId", Jn(), Vr(), PS();
        },
        unstable_isNewReconciler: te
      }, Hu = {
        readContext: function(o) {
          return jS(), Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Jn(), Zt(), yv(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Jn(), Zt(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Jn(), Zt(), w_(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Jn(), Zt(), gv(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Jn(), Zt(), pv(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Jn(), Zt(), mv(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Jn(), Zt();
          var x = on.current;
          on.current = Hu;
          try {
            return vv(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Jn(), Zt();
          var D = on.current;
          on.current = Hu;
          try {
            return CS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Jn(), Zt(), dv();
        },
        useState: function(o) {
          It = "useState", Jn(), Zt();
          var u = on.current;
          on.current = Hu;
          try {
            return TS(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Jn(), Zt(), _v();
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Jn(), Zt(), cA(o);
        },
        useTransition: function() {
          return It = "useTransition", Jn(), Zt(), hA();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Jn(), Zt(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Jn(), Zt(), uv(o, u);
        },
        useId: function() {
          return It = "useId", Jn(), Zt(), bv();
        },
        unstable_isNewReconciler: te
      }, Sv = {
        readContext: function(o) {
          return jS(), Do(o);
        },
        useCallback: function(o, u) {
          return It = "useCallback", Jn(), Zt(), yv(o, u);
        },
        useContext: function(o) {
          return It = "useContext", Jn(), Zt(), Do(o);
        },
        useEffect: function(o, u) {
          return It = "useEffect", Jn(), Zt(), w_(o, u);
        },
        useImperativeHandle: function(o, u, x) {
          return It = "useImperativeHandle", Jn(), Zt(), gv(o, u, x);
        },
        useInsertionEffect: function(o, u) {
          return It = "useInsertionEffect", Jn(), Zt(), pv(o, u);
        },
        useLayoutEffect: function(o, u) {
          return It = "useLayoutEffect", Jn(), Zt(), mv(o, u);
        },
        useMemo: function(o, u) {
          It = "useMemo", Jn(), Zt();
          var x = on.current;
          on.current = Hu;
          try {
            return vv(o, u);
          } finally {
            on.current = x;
          }
        },
        useReducer: function(o, u, x) {
          It = "useReducer", Jn(), Zt();
          var D = on.current;
          on.current = Hu;
          try {
            return wS(o, u, x);
          } finally {
            on.current = D;
          }
        },
        useRef: function(o) {
          return It = "useRef", Jn(), Zt(), dv();
        },
        useState: function(o) {
          It = "useState", Jn(), Zt();
          var u = on.current;
          on.current = Hu;
          try {
            return AS(o);
          } finally {
            on.current = u;
          }
        },
        useDebugValue: function(o, u) {
          return It = "useDebugValue", Jn(), Zt(), _v();
        },
        useDeferredValue: function(o) {
          return It = "useDeferredValue", Jn(), Zt(), dA(o);
        },
        useTransition: function() {
          return It = "useTransition", Jn(), Zt(), pA();
        },
        useMutableSource: function(o, u, x) {
          return It = "useMutableSource", Jn(), Zt(), void 0;
        },
        useSyncExternalStore: function(o, u, x) {
          return It = "useSyncExternalStore", Jn(), Zt(), uv(o, u);
        },
        useId: function() {
          return It = "useId", Jn(), Zt(), bv();
        },
        unstable_isNewReconciler: te
      };
    }
    var Th = e.unstable_now, wA = 0, Cv = -1, x_ = -1, wv = -1, BS = !1, xv = !1;
    function xA() {
      return BS;
    }
    function cI() {
      xv = !0;
    }
    function dI() {
      BS = !1, xv = !1;
    }
    function fI() {
      BS = xv, xv = !1;
    }
    function TA() {
      return wA;
    }
    function AA() {
      wA = Th();
    }
    function FS(o) {
      x_ = Th(), o.actualStartTime < 0 && (o.actualStartTime = Th());
    }
    function kA(o) {
      x_ = -1;
    }
    function Tv(o, u) {
      if (x_ >= 0) {
        var x = Th() - x_;
        o.actualDuration += x, u && (o.selfBaseDuration = x), x_ = -1;
      }
    }
    function Kc(o) {
      if (Cv >= 0) {
        var u = Th() - Cv;
        Cv = -1;
        for (var x = o.return; x !== null; ) {
          switch (x.tag) {
            case h:
              var D = x.stateNode;
              D.effectDuration += u;
              return;
            case T:
              var F = x.stateNode;
              F.effectDuration += u;
              return;
          }
          x = x.return;
        }
      }
    }
    function US(o) {
      if (wv >= 0) {
        var u = Th() - wv;
        wv = -1;
        for (var x = o.return; x !== null; ) {
          switch (x.tag) {
            case h:
              var D = x.stateNode;
              D !== null && (D.passiveEffectDuration += u);
              return;
            case T:
              var F = x.stateNode;
              F !== null && (F.passiveEffectDuration += u);
              return;
          }
          x = x.return;
        }
      }
    }
    function Qc() {
      Cv = Th();
    }
    function HS() {
      wv = Th();
    }
    function zS(o) {
      for (var u = o.child; u; )
        o.actualDuration += u.actualDuration, u = u.sibling;
    }
    function zu(o, u) {
      if (o && o.defaultProps) {
        var x = Qn({}, u), D = o.defaultProps;
        for (var F in D)
          x[F] === void 0 && (x[F] = D[F]);
        return x;
      }
      return u;
    }
    var VS = {}, qS, GS, WS, $S, YS, OA, Av, XS, KS, QS, T_;
    {
      qS = /* @__PURE__ */ new Set(), GS = /* @__PURE__ */ new Set(), WS = /* @__PURE__ */ new Set(), $S = /* @__PURE__ */ new Set(), XS = /* @__PURE__ */ new Set(), YS = /* @__PURE__ */ new Set(), KS = /* @__PURE__ */ new Set(), QS = /* @__PURE__ */ new Set(), T_ = /* @__PURE__ */ new Set();
      var DA = /* @__PURE__ */ new Set();
      Av = function(o, u) {
        if (!(o === null || typeof o == "function")) {
          var x = u + "_" + o;
          DA.has(x) || (DA.add(x), s("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u, o));
        }
      }, OA = function(o, u) {
        if (u === void 0) {
          var x = ur(o) || "Component";
          YS.has(x) || (YS.add(x), s("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", x));
        }
      }, Object.defineProperty(VS, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(VS);
    }
    function ZS(o, u, x, D) {
      var F = o.memoizedState, Z = x(D, F);
      {
        if (o.mode & lr) {
          mi(!0);
          try {
            Z = x(D, F);
          } finally {
            mi(!1);
          }
        }
        OA(u, Z);
      }
      var de = Z == null ? F : Qn({}, F, Z);
      if (o.memoizedState = de, o.lanes === jt) {
        var ge = o.updateQueue;
        ge.baseState = de;
      }
    }
    var JS = {
      isMounted: zo,
      enqueueSetState: function(o, u, x) {
        var D = Ua(o), F = fs(), Z = Dh(D), de = ef(F, Z);
        de.payload = u, x != null && (Av(x, "setState"), de.callback = x);
        var ge = Sh(D, de, Z);
        ge !== null && (Zo(ge, D, Z, F), nv(ge, D, Z)), ct(D, Z);
      },
      enqueueReplaceState: function(o, u, x) {
        var D = Ua(o), F = fs(), Z = Dh(D), de = ef(F, Z);
        de.tag = $5, de.payload = u, x != null && (Av(x, "replaceState"), de.callback = x);
        var ge = Sh(D, de, Z);
        ge !== null && (Zo(ge, D, Z, F), nv(ge, D, Z)), ct(D, Z);
      },
      enqueueForceUpdate: function(o, u) {
        var x = Ua(o), D = fs(), F = Dh(x), Z = ef(D, F);
        Z.tag = Jy, u != null && (Av(u, "forceUpdate"), Z.callback = u);
        var de = Sh(x, Z, F);
        de !== null && (Zo(de, x, F, D), nv(de, x, F)), De(x, F);
      }
    };
    function RA(o, u, x, D, F, Z, de) {
      var ge = o.stateNode;
      if (typeof ge.shouldComponentUpdate == "function") {
        var xe = ge.shouldComponentUpdate(D, Z, de);
        {
          if (o.mode & lr) {
            mi(!0);
            try {
              xe = ge.shouldComponentUpdate(D, Z, de);
            } finally {
              mi(!1);
            }
          }
          xe === void 0 && s("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", ur(u) || "Component");
        }
        return xe;
      }
      return u.prototype && u.prototype.isPureReactComponent ? !Hn(x, D) || !Hn(F, Z) : !0;
    }
    function hI(o, u, x) {
      var D = o.stateNode;
      {
        var F = ur(u) || "Component", Z = D.render;
        Z || (u.prototype && typeof u.prototype.render == "function" ? s("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", F) : s("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", F)), D.getInitialState && !D.getInitialState.isReactClassApproved && !D.state && s("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", F), D.getDefaultProps && !D.getDefaultProps.isReactClassApproved && s("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", F), D.propTypes && s("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", F), D.contextType && s("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", F), u.childContextTypes && !T_.has(u) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (o.mode & lr) === vn && (T_.add(u), s(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, F)), u.contextTypes && !T_.has(u) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (o.mode & lr) === vn && (T_.add(u), s(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, F)), D.contextTypes && s("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", F), u.contextType && u.contextTypes && !KS.has(u) && (KS.add(u), s("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", F)), typeof D.componentShouldUpdate == "function" && s("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", F), u.prototype && u.prototype.isPureReactComponent && typeof D.shouldComponentUpdate < "u" && s("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", ur(u) || "A pure component"), typeof D.componentDidUnmount == "function" && s("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", F), typeof D.componentDidReceiveProps == "function" && s("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", F), typeof D.componentWillRecieveProps == "function" && s("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", F), typeof D.UNSAFE_componentWillRecieveProps == "function" && s("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", F);
        var de = D.props !== x;
        D.props !== void 0 && de && s("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", F, F), D.defaultProps && s("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", F, F), typeof D.getSnapshotBeforeUpdate == "function" && typeof D.componentDidUpdate != "function" && !WS.has(u) && (WS.add(u), s("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", ur(u))), typeof D.getDerivedStateFromProps == "function" && s("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", F), typeof D.getDerivedStateFromError == "function" && s("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", F), typeof u.getSnapshotBeforeUpdate == "function" && s("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", F);
        var ge = D.state;
        ge && (typeof ge != "object" || Pi(ge)) && s("%s.state: must be set to an object or null", F), typeof D.getChildContext == "function" && typeof u.childContextTypes != "object" && s("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", F);
      }
    }
    function NA(o, u) {
      u.updater = JS, o.stateNode = u, ku(u, o), u._reactInternalInstance = VS;
    }
    function IA(o, u, x) {
      var D = !1, F = yl, Z = yl, de = u.contextType;
      if ("contextType" in u) {
        var ge = (
          // Allow null for conditional declaration
          de === null || de !== void 0 && de.$$typeof === Ii && de._context === void 0
        );
        if (!ge && !QS.has(u)) {
          QS.add(u);
          var xe = "";
          de === void 0 ? xe = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof de != "object" ? xe = " However, it is set to a " + typeof de + "." : de.$$typeof === vr ? xe = " Did you accidentally pass the Context.Provider instead?" : de._context !== void 0 ? xe = " Did you accidentally pass the Context.Consumer instead?" : xe = " However, it is set to an object with keys {" + Object.keys(de).join(", ") + "}.", s("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", ur(u) || "Component", xe);
        }
      }
      if (typeof de == "object" && de !== null)
        Z = Do(de);
      else {
        F = Eg(o, u, !0);
        var Le = u.contextTypes;
        D = Le != null, Z = D ? Sg(o, F) : yl;
      }
      var Ue = new u(x, Z);
      if (o.mode & lr) {
        mi(!0);
        try {
          Ue = new u(x, Z);
        } finally {
          mi(!1);
        }
      }
      var st = o.memoizedState = Ue.state !== null && Ue.state !== void 0 ? Ue.state : null;
      NA(o, Ue);
      {
        if (typeof u.getDerivedStateFromProps == "function" && st === null) {
          var ot = ur(u) || "Component";
          GS.has(ot) || (GS.add(ot), s("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ot, Ue.state === null ? "null" : "undefined", ot));
        }
        if (typeof u.getDerivedStateFromProps == "function" || typeof Ue.getSnapshotBeforeUpdate == "function") {
          var Et = null, wt = null, Dt = null;
          if (typeof Ue.componentWillMount == "function" && Ue.componentWillMount.__suppressDeprecationWarning !== !0 ? Et = "componentWillMount" : typeof Ue.UNSAFE_componentWillMount == "function" && (Et = "UNSAFE_componentWillMount"), typeof Ue.componentWillReceiveProps == "function" && Ue.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? wt = "componentWillReceiveProps" : typeof Ue.UNSAFE_componentWillReceiveProps == "function" && (wt = "UNSAFE_componentWillReceiveProps"), typeof Ue.componentWillUpdate == "function" && Ue.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Dt = "componentWillUpdate" : typeof Ue.UNSAFE_componentWillUpdate == "function" && (Dt = "UNSAFE_componentWillUpdate"), Et !== null || wt !== null || Dt !== null) {
            var tn = ur(u) || "Component", Ln = typeof u.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            $S.has(tn) || ($S.add(tn), s(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, tn, Ln, Et !== null ? `
  ` + Et : "", wt !== null ? `
  ` + wt : "", Dt !== null ? `
  ` + Dt : ""));
          }
        }
      }
      return D && S5(o, F, Z), Ue;
    }
    function pI(o, u) {
      var x = u.state;
      typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), x !== u.state && (s("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Yn(o) || "Component"), JS.enqueueReplaceState(u, u.state, null));
    }
    function LA(o, u, x, D) {
      var F = u.state;
      if (typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(x, D), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(x, D), u.state !== F) {
        {
          var Z = Yn(o) || "Component";
          qS.has(Z) || (qS.add(Z), s("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Z));
        }
        JS.enqueueReplaceState(u, u.state, null);
      }
    }
    function eC(o, u, x, D) {
      hI(o, u, x);
      var F = o.stateNode;
      F.props = x, F.state = o.memoizedState, F.refs = {}, uS(o);
      var Z = u.contextType;
      if (typeof Z == "object" && Z !== null)
        F.context = Do(Z);
      else {
        var de = Eg(o, u, !0);
        F.context = Sg(o, de);
      }
      {
        if (F.state === x) {
          var ge = ur(u) || "Component";
          XS.has(ge) || (XS.add(ge), s("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", ge));
        }
        o.mode & lr && Fu.recordLegacyContextWarning(o, F), Fu.recordUnsafeLifecycleWarnings(o, F);
      }
      F.state = o.memoizedState;
      var xe = u.getDerivedStateFromProps;
      if (typeof xe == "function" && (ZS(o, u, xe, x), F.state = o.memoizedState), typeof u.getDerivedStateFromProps != "function" && typeof F.getSnapshotBeforeUpdate != "function" && (typeof F.UNSAFE_componentWillMount == "function" || typeof F.componentWillMount == "function") && (pI(o, F), rv(o, x, F, D), F.state = o.memoizedState), typeof F.componentDidMount == "function") {
        var Le = Fn;
        Le |= Ji, (o.mode & Sa) !== vn && (Le |= eo), o.flags |= Le;
      }
    }
    function mI(o, u, x, D) {
      var F = o.stateNode, Z = o.memoizedProps;
      F.props = Z;
      var de = F.context, ge = u.contextType, xe = yl;
      if (typeof ge == "object" && ge !== null)
        xe = Do(ge);
      else {
        var Le = Eg(o, u, !0);
        xe = Sg(o, Le);
      }
      var Ue = u.getDerivedStateFromProps, st = typeof Ue == "function" || typeof F.getSnapshotBeforeUpdate == "function";
      !st && (typeof F.UNSAFE_componentWillReceiveProps == "function" || typeof F.componentWillReceiveProps == "function") && (Z !== x || de !== xe) && LA(o, F, x, xe), X5();
      var ot = o.memoizedState, Et = F.state = ot;
      if (rv(o, x, F, D), Et = o.memoizedState, Z === x && ot === Et && !By() && !iv()) {
        if (typeof F.componentDidMount == "function") {
          var wt = Fn;
          wt |= Ji, (o.mode & Sa) !== vn && (wt |= eo), o.flags |= wt;
        }
        return !1;
      }
      typeof Ue == "function" && (ZS(o, u, Ue, x), Et = o.memoizedState);
      var Dt = iv() || RA(o, u, Z, x, ot, Et, xe);
      if (Dt) {
        if (!st && (typeof F.UNSAFE_componentWillMount == "function" || typeof F.componentWillMount == "function") && (typeof F.componentWillMount == "function" && F.componentWillMount(), typeof F.UNSAFE_componentWillMount == "function" && F.UNSAFE_componentWillMount()), typeof F.componentDidMount == "function") {
          var tn = Fn;
          tn |= Ji, (o.mode & Sa) !== vn && (tn |= eo), o.flags |= tn;
        }
      } else {
        if (typeof F.componentDidMount == "function") {
          var Ln = Fn;
          Ln |= Ji, (o.mode & Sa) !== vn && (Ln |= eo), o.flags |= Ln;
        }
        o.memoizedProps = x, o.memoizedState = Et;
      }
      return F.props = x, F.state = Et, F.context = xe, Dt;
    }
    function gI(o, u, x, D, F) {
      var Z = u.stateNode;
      Y5(o, u);
      var de = u.memoizedProps, ge = u.type === u.elementType ? de : zu(u.type, de);
      Z.props = ge;
      var xe = u.pendingProps, Le = Z.context, Ue = x.contextType, st = yl;
      if (typeof Ue == "object" && Ue !== null)
        st = Do(Ue);
      else {
        var ot = Eg(u, x, !0);
        st = Sg(u, ot);
      }
      var Et = x.getDerivedStateFromProps, wt = typeof Et == "function" || typeof Z.getSnapshotBeforeUpdate == "function";
      !wt && (typeof Z.UNSAFE_componentWillReceiveProps == "function" || typeof Z.componentWillReceiveProps == "function") && (de !== xe || Le !== st) && LA(u, Z, D, st), X5();
      var Dt = u.memoizedState, tn = Z.state = Dt;
      if (rv(u, D, Z, F), tn = u.memoizedState, de === xe && Dt === tn && !By() && !iv() && !V)
        return typeof Z.componentDidUpdate == "function" && (de !== o.memoizedProps || Dt !== o.memoizedState) && (u.flags |= Fn), typeof Z.getSnapshotBeforeUpdate == "function" && (de !== o.memoizedProps || Dt !== o.memoizedState) && (u.flags |= Ha), !1;
      typeof Et == "function" && (ZS(u, x, Et, D), tn = u.memoizedState);
      var Ln = iv() || RA(u, x, ge, D, Dt, tn, st) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      V;
      return Ln ? (!wt && (typeof Z.UNSAFE_componentWillUpdate == "function" || typeof Z.componentWillUpdate == "function") && (typeof Z.componentWillUpdate == "function" && Z.componentWillUpdate(D, tn, st), typeof Z.UNSAFE_componentWillUpdate == "function" && Z.UNSAFE_componentWillUpdate(D, tn, st)), typeof Z.componentDidUpdate == "function" && (u.flags |= Fn), typeof Z.getSnapshotBeforeUpdate == "function" && (u.flags |= Ha)) : (typeof Z.componentDidUpdate == "function" && (de !== o.memoizedProps || Dt !== o.memoizedState) && (u.flags |= Fn), typeof Z.getSnapshotBeforeUpdate == "function" && (de !== o.memoizedProps || Dt !== o.memoizedState) && (u.flags |= Ha), u.memoizedProps = D, u.memoizedState = tn), Z.props = D, Z.state = tn, Z.context = st, Ln;
    }
    function Gp(o, u) {
      return {
        value: o,
        source: u,
        stack: yd(u),
        digest: null
      };
    }
    function tC(o, u, x) {
      return {
        value: o,
        source: null,
        stack: x ?? null,
        digest: u ?? null
      };
    }
    function _I(o, u) {
      return !0;
    }
    function nC(o, u) {
      try {
        var x = _I(o, u);
        if (x === !1)
          return;
        var D = u.value, F = u.source, Z = u.stack, de = Z !== null ? Z : "";
        if (D != null && D._suppressLogging) {
          if (o.tag === d)
            return;
          console.error(D);
        }
        var ge = F ? Yn(F) : null, xe = ge ? "The above error occurred in the <" + ge + "> component:" : "The above error occurred in one of your React components:", Le;
        if (o.tag === h)
          Le = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var Ue = Yn(o) || "Anonymous";
          Le = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + Ue + ".");
        }
        var st = xe + `
` + de + `

` + ("" + Le);
        console.error(st);
      } catch (ot) {
        setTimeout(function() {
          throw ot;
        });
      }
    }
    var yI = typeof WeakMap == "function" ? WeakMap : Map;
    function MA(o, u, x) {
      var D = ef(Gr, x);
      D.tag = sS, D.payload = {
        element: null
      };
      var F = u.value;
      return D.callback = function() {
        cM(F), nC(o, u);
      }, D;
    }
    function rC(o, u, x) {
      var D = ef(Gr, x);
      D.tag = sS;
      var F = o.type.getDerivedStateFromError;
      if (typeof F == "function") {
        var Z = u.value;
        D.payload = function() {
          return F(Z);
        }, D.callback = function() {
          Wk(o), nC(o, u);
        };
      }
      var de = o.stateNode;
      return de !== null && typeof de.componentDidCatch == "function" && (D.callback = function() {
        Wk(o), nC(o, u), typeof F != "function" && lM(this);
        var xe = u.value, Le = u.stack;
        this.componentDidCatch(xe, {
          componentStack: Le !== null ? Le : ""
        }), typeof F != "function" && (Ga(o.lanes, O) || s("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Yn(o) || "Unknown"));
      }), D;
    }
    function PA(o, u, x) {
      var D = o.pingCache, F;
      if (D === null ? (D = o.pingCache = new yI(), F = /* @__PURE__ */ new Set(), D.set(u, F)) : (F = D.get(u), F === void 0 && (F = /* @__PURE__ */ new Set(), D.set(u, F))), !F.has(x)) {
        F.add(x);
        var Z = dM.bind(null, o, u, x);
        aa && V_(o, x), u.then(Z, Z);
      }
    }
    function vI(o, u, x, D) {
      var F = o.updateQueue;
      if (F === null) {
        var Z = /* @__PURE__ */ new Set();
        Z.add(x), o.updateQueue = Z;
      } else
        F.add(x);
    }
    function bI(o, u) {
      var x = o.tag;
      if ((o.mode & Sn) === vn && (x === l || x === y || x === N)) {
        var D = o.alternate;
        D ? (o.updateQueue = D.updateQueue, o.memoizedState = D.memoizedState, o.lanes = D.lanes) : (o.updateQueue = null, o.memoizedState = null);
      }
    }
    function jA(o) {
      var u = o;
      do {
        if (u.tag === A && eI(u))
          return u;
        u = u.return;
      } while (u !== null);
      return null;
    }
    function BA(o, u, x, D, F) {
      if ((o.mode & Sn) === vn) {
        if (o === u)
          o.flags |= Ei;
        else {
          if (o.flags |= Gn, x.flags |= fl, x.flags &= ~(Nc | co), x.tag === d) {
            var Z = x.alternate;
            if (Z === null)
              x.tag = I;
            else {
              var de = ef(Gr, O);
              de.tag = Jy, Sh(x, de, O);
            }
          }
          x.lanes = or(x.lanes, O);
        }
        return o;
      }
      return o.flags |= Ei, o.lanes = F, o;
    }
    function EI(o, u, x, D, F) {
      if (x.flags |= co, aa && V_(o, F), D !== null && typeof D == "object" && typeof D.then == "function") {
        var Z = D;
        bI(x), Ta() && x.mode & Sn && O5();
        var de = jA(u);
        if (de !== null) {
          de.flags &= ~bi, BA(de, u, x, o, F), de.mode & Sn && PA(o, Z, F), vI(de, o, Z);
          return;
        } else {
          if (!O0(F)) {
            PA(o, Z, F), PC();
            return;
          }
          var ge = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          D = ge;
        }
      } else if (Ta() && x.mode & Sn) {
        O5();
        var xe = jA(u);
        if (xe !== null) {
          (xe.flags & Ei) === xn && (xe.flags |= bi), BA(xe, u, x, o, F), XE(Gp(D, x));
          return;
        }
      }
      D = Gp(D, x), eM(D);
      var Le = u;
      do {
        switch (Le.tag) {
          case h: {
            var Ue = D;
            Le.flags |= Ei;
            var st = Jf(F);
            Le.lanes = or(Le.lanes, st);
            var ot = MA(Le, Ue, st);
            cS(Le, ot);
            return;
          }
          case d:
            var Et = D, wt = Le.type, Dt = Le.stateNode;
            if ((Le.flags & Gn) === xn && (typeof wt.getDerivedStateFromError == "function" || Dt !== null && typeof Dt.componentDidCatch == "function" && !jk(Dt))) {
              Le.flags |= Ei;
              var tn = Jf(F);
              Le.lanes = or(Le.lanes, tn);
              var Ln = rC(Le, Et, tn);
              cS(Le, Ln);
              return;
            }
            break;
        }
        Le = Le.return;
      } while (Le !== null);
    }
    function SI() {
      return null;
    }
    var A_ = t.ReactCurrentOwner, Vu = !1, iC, k_, oC, aC, sC, Wp, lC, kv, O_;
    iC = {}, k_ = {}, oC = {}, aC = {}, sC = {}, Wp = !1, lC = {}, kv = {}, O_ = {};
    function cs(o, u, x, D) {
      o === null ? u.child = H5(u, null, x, D) : u.child = Tg(u, o.child, x, D);
    }
    function CI(o, u, x, D) {
      u.child = Tg(u, o.child, null, D), u.child = Tg(u, null, x, D);
    }
    function FA(o, u, x, D, F) {
      if (u.type !== u.elementType) {
        var Z = x.propTypes;
        Z && ju(
          Z,
          D,
          // Resolved props
          "prop",
          ur(x)
        );
      }
      var de = x.render, ge = u.ref, xe, Le;
      kg(u, F), us(u);
      {
        if (A_.current = u, jo(!0), xe = Lg(o, u, de, D, ge, F), Le = Mg(), u.mode & lr) {
          mi(!0);
          try {
            xe = Lg(o, u, de, D, ge, F), Le = Mg();
          } finally {
            mi(!1);
          }
        }
        jo(!1);
      }
      return wo(), o !== null && !Vu ? (tA(o, u, F), tf(o, u, F)) : (Ta() && Le && VE(u), u.flags |= ss, cs(o, u, xe, F), u.child);
    }
    function UA(o, u, x, D, F) {
      if (o === null) {
        var Z = x.type;
        if (kM(Z) && x.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        x.defaultProps === void 0) {
          var de = Z;
          return de = Vg(Z), u.tag = N, u.type = de, dC(u, Z), HA(o, u, de, D, F);
        }
        {
          var ge = Z.propTypes;
          if (ge && ju(
            ge,
            D,
            // Resolved props
            "prop",
            ur(Z)
          ), x.defaultProps !== void 0) {
            var xe = ur(Z) || "Unknown";
            O_[xe] || (s("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", xe), O_[xe] = !0);
          }
        }
        var Le = $C(x.type, null, D, u, u.mode, F);
        return Le.ref = u.ref, Le.return = u, u.child = Le, Le;
      }
      {
        var Ue = x.type, st = Ue.propTypes;
        st && ju(
          st,
          D,
          // Resolved props
          "prop",
          ur(Ue)
        );
      }
      var ot = o.child, Et = _C(o, F);
      if (!Et) {
        var wt = ot.memoizedProps, Dt = x.compare;
        if (Dt = Dt !== null ? Dt : Hn, Dt(wt, D) && o.ref === u.ref)
          return tf(o, u, F);
      }
      u.flags |= ss;
      var tn = Qp(ot, D);
      return tn.ref = u.ref, tn.return = u, u.child = tn, tn;
    }
    function HA(o, u, x, D, F) {
      if (u.type !== u.elementType) {
        var Z = u.elementType;
        if (Z.$$typeof === br) {
          var de = Z, ge = de._payload, xe = de._init;
          try {
            Z = xe(ge);
          } catch {
            Z = null;
          }
          var Le = Z && Z.propTypes;
          Le && ju(
            Le,
            D,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            ur(Z)
          );
        }
      }
      if (o !== null) {
        var Ue = o.memoizedProps;
        if (Hn(Ue, D) && o.ref === u.ref && // Prevent bailout if the implementation changed due to hot reload.
        u.type === o.type)
          if (Vu = !1, u.pendingProps = D = Ue, _C(o, F))
            (o.flags & fl) !== xn && (Vu = !0);
          else return u.lanes = o.lanes, tf(o, u, F);
      }
      return uC(o, u, x, D, F);
    }
    function zA(o, u, x) {
      var D = u.pendingProps, F = D.children, Z = o !== null ? o.memoizedState : null;
      if (D.mode === "hidden" || K)
        if ((u.mode & Sn) === vn) {
          var de = {
            baseLanes: jt,
            cachePool: null,
            transitions: null
          };
          u.memoizedState = de, Hv(u, x);
        } else if (Ga(x, gi)) {
          var st = {
            baseLanes: jt,
            cachePool: null,
            transitions: null
          };
          u.memoizedState = st;
          var ot = Z !== null ? Z.baseLanes : x;
          Hv(u, ot);
        } else {
          var ge = null, xe;
          if (Z !== null) {
            var Le = Z.baseLanes;
            xe = or(Le, x);
          } else
            xe = x;
          u.lanes = u.childLanes = gi;
          var Ue = {
            baseLanes: xe,
            cachePool: ge,
            transitions: null
          };
          return u.memoizedState = Ue, u.updateQueue = null, Hv(u, xe), null;
        }
      else {
        var Et;
        Z !== null ? (Et = or(Z.baseLanes, x), u.memoizedState = null) : Et = x, Hv(u, Et);
      }
      return cs(o, u, F, x), u.child;
    }
    function wI(o, u, x) {
      var D = u.pendingProps;
      return cs(o, u, D, x), u.child;
    }
    function xI(o, u, x) {
      var D = u.pendingProps.children;
      return cs(o, u, D, x), u.child;
    }
    function TI(o, u, x) {
      {
        u.flags |= Fn;
        {
          var D = u.stateNode;
          D.effectDuration = 0, D.passiveEffectDuration = 0;
        }
      }
      var F = u.pendingProps, Z = F.children;
      return cs(o, u, Z, x), u.child;
    }
    function VA(o, u) {
      var x = u.ref;
      (o === null && x !== null || o !== null && o.ref !== x) && (u.flags |= oa, u.flags |= hl);
    }
    function uC(o, u, x, D, F) {
      if (u.type !== u.elementType) {
        var Z = x.propTypes;
        Z && ju(
          Z,
          D,
          // Resolved props
          "prop",
          ur(x)
        );
      }
      var de;
      {
        var ge = Eg(u, x, !0);
        de = Sg(u, ge);
      }
      var xe, Le;
      kg(u, F), us(u);
      {
        if (A_.current = u, jo(!0), xe = Lg(o, u, x, D, de, F), Le = Mg(), u.mode & lr) {
          mi(!0);
          try {
            xe = Lg(o, u, x, D, de, F), Le = Mg();
          } finally {
            mi(!1);
          }
        }
        jo(!1);
      }
      return wo(), o !== null && !Vu ? (tA(o, u, F), tf(o, u, F)) : (Ta() && Le && VE(u), u.flags |= ss, cs(o, u, xe, F), u.child);
    }
    function qA(o, u, x, D, F) {
      {
        switch (VM(u)) {
          case !1: {
            var Z = u.stateNode, de = u.type, ge = new de(u.memoizedProps, Z.context), xe = ge.state;
            Z.updater.enqueueSetState(Z, xe, null);
            break;
          }
          case !0: {
            u.flags |= Gn, u.flags |= Ei;
            var Le = new Error("Simulated error coming from DevTools"), Ue = Jf(F);
            u.lanes = or(u.lanes, Ue);
            var st = rC(u, Gp(Le, u), Ue);
            cS(u, st);
            break;
          }
        }
        if (u.type !== u.elementType) {
          var ot = x.propTypes;
          ot && ju(
            ot,
            D,
            // Resolved props
            "prop",
            ur(x)
          );
        }
      }
      var Et;
      Wc(x) ? (Et = !0, Uy(u)) : Et = !1, kg(u, F);
      var wt = u.stateNode, Dt;
      wt === null ? (Dv(o, u), IA(u, x, D), eC(u, x, D, F), Dt = !0) : o === null ? Dt = mI(u, x, D, F) : Dt = gI(o, u, x, D, F);
      var tn = cC(o, u, x, Dt, Et, F);
      {
        var Ln = u.stateNode;
        Dt && Ln.props !== D && (Wp || s("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Yn(u) || "a component"), Wp = !0);
      }
      return tn;
    }
    function cC(o, u, x, D, F, Z) {
      VA(o, u);
      var de = (u.flags & Gn) !== xn;
      if (!D && !de)
        return F && x5(u, x, !1), tf(o, u, Z);
      var ge = u.stateNode;
      A_.current = u;
      var xe;
      if (de && typeof x.getDerivedStateFromError != "function")
        xe = null, kA();
      else {
        us(u);
        {
          if (jo(!0), xe = ge.render(), u.mode & lr) {
            mi(!0);
            try {
              ge.render();
            } finally {
              mi(!1);
            }
          }
          jo(!1);
        }
        wo();
      }
      return u.flags |= ss, o !== null && de ? CI(o, u, xe, Z) : cs(o, u, xe, Z), u.memoizedState = ge.state, F && x5(u, x, !0), u.child;
    }
    function GA(o) {
      var u = o.stateNode;
      u.pendingContext ? C5(o, u.pendingContext, u.pendingContext !== u.context) : u.context && C5(o, u.context, !1), dS(o, u.containerInfo);
    }
    function AI(o, u, x) {
      if (GA(u), o === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var D = u.pendingProps, F = u.memoizedState, Z = F.element;
      Y5(o, u), rv(u, D, null, x);
      var de = u.memoizedState;
      u.stateNode;
      var ge = de.element;
      if (F.isDehydrated) {
        var xe = {
          element: ge,
          isDehydrated: !1,
          cache: de.cache,
          pendingSuspenseBoundaries: de.pendingSuspenseBoundaries,
          transitions: de.transitions
        }, Le = u.updateQueue;
        if (Le.baseState = xe, u.memoizedState = xe, u.flags & bi) {
          var Ue = Gp(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), u);
          return WA(o, u, ge, x, Ue);
        } else if (ge !== Z) {
          var st = Gp(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), u);
          return WA(o, u, ge, x, st);
        } else {
          DN(u);
          var ot = H5(u, null, ge, x);
          u.child = ot;
          for (var Et = ot; Et; )
            Et.flags = Et.flags & ~Yr | _a, Et = Et.sibling;
        }
      } else {
        if (xg(), ge === Z)
          return tf(o, u, x);
        cs(o, u, ge, x);
      }
      return u.child;
    }
    function WA(o, u, x, D, F) {
      return xg(), XE(F), u.flags |= bi, cs(o, u, x, D), u.child;
    }
    function kI(o, u, x) {
      Z5(u), o === null && YE(u);
      var D = u.type, F = u.pendingProps, Z = o !== null ? o.memoizedProps : null, de = F.children, ge = OE(D, F);
      return ge ? de = null : Z !== null && OE(D, Z) && (u.flags |= Ar), VA(o, u), cs(o, u, de, x), u.child;
    }
    function OI(o, u) {
      return o === null && YE(u), null;
    }
    function DI(o, u, x, D) {
      Dv(o, u);
      var F = u.pendingProps, Z = x, de = Z._payload, ge = Z._init, xe = ge(de);
      u.type = xe;
      var Le = u.tag = OM(xe), Ue = zu(xe, F), st;
      switch (Le) {
        case l:
          return dC(u, xe), u.type = xe = Vg(xe), st = uC(null, u, xe, Ue, D), st;
        case d:
          return u.type = xe = HC(xe), st = qA(null, u, xe, Ue, D), st;
        case y:
          return u.type = xe = zC(xe), st = FA(null, u, xe, Ue, D), st;
        case k: {
          if (u.type !== u.elementType) {
            var ot = xe.propTypes;
            ot && ju(
              ot,
              Ue,
              // Resolved for outer only
              "prop",
              ur(xe)
            );
          }
          return st = UA(
            null,
            u,
            xe,
            zu(xe.type, Ue),
            // The inner type can have defaults too
            D
          ), st;
        }
      }
      var Et = "";
      throw xe !== null && typeof xe == "object" && xe.$$typeof === br && (Et = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + xe + ". " + ("Lazy element type must resolve to a class or function." + Et));
    }
    function RI(o, u, x, D, F) {
      Dv(o, u), u.tag = d;
      var Z;
      return Wc(x) ? (Z = !0, Uy(u)) : Z = !1, kg(u, F), IA(u, x, D), eC(u, x, D, F), cC(null, u, x, !0, Z, F);
    }
    function NI(o, u, x, D) {
      Dv(o, u);
      var F = u.pendingProps, Z;
      {
        var de = Eg(u, x, !1);
        Z = Sg(u, de);
      }
      kg(u, D);
      var ge, xe;
      us(u);
      {
        if (x.prototype && typeof x.prototype.render == "function") {
          var Le = ur(x) || "Unknown";
          iC[Le] || (s("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Le, Le), iC[Le] = !0);
        }
        u.mode & lr && Fu.recordLegacyContextWarning(u, null), jo(!0), A_.current = u, ge = Lg(null, u, x, F, Z, D), xe = Mg(), jo(!1);
      }
      if (wo(), u.flags |= ss, typeof ge == "object" && ge !== null && typeof ge.render == "function" && ge.$$typeof === void 0) {
        var Ue = ur(x) || "Unknown";
        k_[Ue] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ue, Ue, Ue), k_[Ue] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof ge == "object" && ge !== null && typeof ge.render == "function" && ge.$$typeof === void 0
      ) {
        {
          var st = ur(x) || "Unknown";
          k_[st] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", st, st, st), k_[st] = !0);
        }
        u.tag = d, u.memoizedState = null, u.updateQueue = null;
        var ot = !1;
        return Wc(x) ? (ot = !0, Uy(u)) : ot = !1, u.memoizedState = ge.state !== null && ge.state !== void 0 ? ge.state : null, uS(u), NA(u, ge), eC(u, x, F, D), cC(null, u, x, !0, ot, D);
      } else {
        if (u.tag = l, u.mode & lr) {
          mi(!0);
          try {
            ge = Lg(null, u, x, F, Z, D), xe = Mg();
          } finally {
            mi(!1);
          }
        }
        return Ta() && xe && VE(u), cs(null, u, ge, D), dC(u, x), u.child;
      }
    }
    function dC(o, u) {
      {
        if (u && u.childContextTypes && s("%s(...): childContextTypes cannot be defined on a function component.", u.displayName || u.name || "Component"), o.ref !== null) {
          var x = "", D = lo();
          D && (x += `

Check the render method of \`` + D + "`.");
          var F = D || "", Z = o._debugSource;
          Z && (F = Z.fileName + ":" + Z.lineNumber), sC[F] || (sC[F] = !0, s("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", x));
        }
        if (u.defaultProps !== void 0) {
          var de = ur(u) || "Unknown";
          O_[de] || (s("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", de), O_[de] = !0);
        }
        if (typeof u.getDerivedStateFromProps == "function") {
          var ge = ur(u) || "Unknown";
          aC[ge] || (s("%s: Function components do not support getDerivedStateFromProps.", ge), aC[ge] = !0);
        }
        if (typeof u.contextType == "object" && u.contextType !== null) {
          var xe = ur(u) || "Unknown";
          oC[xe] || (s("%s: Function components do not support contextType.", xe), oC[xe] = !0);
        }
      }
    }
    var fC = {
      dehydrated: null,
      treeContext: null,
      retryLane: M
    };
    function hC(o) {
      return {
        baseLanes: o,
        cachePool: SI(),
        transitions: null
      };
    }
    function II(o, u) {
      var x = null;
      return {
        baseLanes: or(o.baseLanes, u),
        cachePool: x,
        transitions: o.transitions
      };
    }
    function LI(o, u, x, D) {
      if (u !== null) {
        var F = u.memoizedState;
        if (F === null)
          return !1;
      }
      return pS(o, y_);
    }
    function MI(o, u) {
      return Ep(o.childLanes, u);
    }
    function $A(o, u, x) {
      var D = u.pendingProps;
      qM(u) && (u.flags |= Gn);
      var F = Uu.current, Z = !1, de = (u.flags & Gn) !== xn;
      if (de || LI(F, o) ? (Z = !0, u.flags &= ~Gn) : (o === null || o.memoizedState !== null) && (F = JN(F, eA)), F = Dg(F), wh(u, F), o === null) {
        YE(u);
        var ge = u.memoizedState;
        if (ge !== null) {
          var xe = ge.dehydrated;
          if (xe !== null)
            return UI(u, xe);
        }
        var Le = D.children, Ue = D.fallback;
        if (Z) {
          var st = PI(u, Le, Ue, x), ot = u.child;
          return ot.memoizedState = hC(x), u.memoizedState = fC, st;
        } else
          return pC(u, Le);
      } else {
        var Et = o.memoizedState;
        if (Et !== null) {
          var wt = Et.dehydrated;
          if (wt !== null)
            return HI(o, u, de, D, wt, Et, x);
        }
        if (Z) {
          var Dt = D.fallback, tn = D.children, Ln = BI(o, u, tn, Dt, x), Tn = u.child, xr = o.child.memoizedState;
          return Tn.memoizedState = xr === null ? hC(x) : II(xr, x), Tn.childLanes = MI(o, x), u.memoizedState = fC, Ln;
        } else {
          var gr = D.children, gt = jI(o, u, gr, x);
          return u.memoizedState = null, gt;
        }
      }
    }
    function pC(o, u, x) {
      var D = o.mode, F = {
        mode: "visible",
        children: u
      }, Z = mC(F, D);
      return Z.return = o, o.child = Z, Z;
    }
    function PI(o, u, x, D) {
      var F = o.mode, Z = o.child, de = {
        mode: "hidden",
        children: u
      }, ge, xe;
      return (F & Sn) === vn && Z !== null ? (ge = Z, ge.childLanes = jt, ge.pendingProps = de, o.mode & Un && (ge.actualDuration = 0, ge.actualStartTime = -1, ge.selfBaseDuration = 0, ge.treeBaseDuration = 0), xe = Nh(x, F, D, null)) : (ge = mC(de, F), xe = Nh(x, F, D, null)), ge.return = o, xe.return = o, ge.sibling = xe, o.child = ge, xe;
    }
    function mC(o, u, x) {
      return Yk(o, u, jt, null);
    }
    function YA(o, u) {
      return Qp(o, u);
    }
    function jI(o, u, x, D) {
      var F = o.child, Z = F.sibling, de = YA(F, {
        mode: "visible",
        children: x
      });
      if ((u.mode & Sn) === vn && (de.lanes = D), de.return = u, de.sibling = null, Z !== null) {
        var ge = u.deletions;
        ge === null ? (u.deletions = [Z], u.flags |= Tr) : ge.push(Z);
      }
      return u.child = de, de;
    }
    function BI(o, u, x, D, F) {
      var Z = u.mode, de = o.child, ge = de.sibling, xe = {
        mode: "hidden",
        children: x
      }, Le;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (Z & Sn) === vn && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        u.child !== de
      ) {
        var Ue = u.child;
        Le = Ue, Le.childLanes = jt, Le.pendingProps = xe, u.mode & Un && (Le.actualDuration = 0, Le.actualStartTime = -1, Le.selfBaseDuration = de.selfBaseDuration, Le.treeBaseDuration = de.treeBaseDuration), u.deletions = null;
      } else
        Le = YA(de, xe), Le.subtreeFlags = de.subtreeFlags & to;
      var st;
      return ge !== null ? st = Qp(ge, D) : (st = Nh(D, Z, F, null), st.flags |= Yr), st.return = u, Le.return = u, Le.sibling = st, u.child = Le, st;
    }
    function Ov(o, u, x, D) {
      D !== null && XE(D), Tg(u, o.child, null, x);
      var F = u.pendingProps, Z = F.children, de = pC(u, Z);
      return de.flags |= Yr, u.memoizedState = null, de;
    }
    function FI(o, u, x, D, F) {
      var Z = u.mode, de = {
        mode: "visible",
        children: x
      }, ge = mC(de, Z), xe = Nh(D, Z, F, null);
      return xe.flags |= Yr, ge.return = u, xe.return = u, ge.sibling = xe, u.child = ge, (u.mode & Sn) !== vn && Tg(u, o.child, null, F), xe;
    }
    function UI(o, u, x) {
      return (o.mode & Sn) === vn ? (s("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), o.lanes = O) : IE(u) ? o.lanes = W : o.lanes = gi, null;
    }
    function HI(o, u, x, D, F, Z, de) {
      if (x)
        if (u.flags & bi) {
          u.flags &= ~bi;
          var gt = tC(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Ov(o, u, de, gt);
        } else {
          if (u.memoizedState !== null)
            return u.child = o.child, u.flags |= Gn, null;
          var Rt = D.children, _t = D.fallback, Gt = FI(o, u, Rt, _t, de), sn = u.child;
          return sn.memoizedState = hC(de), u.memoizedState = fC, Gt;
        }
      else {
        if (kN(), (u.mode & Sn) === vn)
          return Ov(
            o,
            u,
            de,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (IE(F)) {
          var ge, xe, Le;
          {
            var Ue = GR(F);
            ge = Ue.digest, xe = Ue.message, Le = Ue.stack;
          }
          var st;
          xe ? st = new Error(xe) : st = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var ot = tC(st, ge, Le);
          return Ov(o, u, de, ot);
        }
        var Et = Ga(de, o.childLanes);
        if (Vu || Et) {
          var wt = Uv();
          if (wt !== null) {
            var Dt = ty(wt, de);
            if (Dt !== M && Dt !== Z.retryLane) {
              Z.retryLane = Dt;
              var tn = Gr;
              Hs(o, Dt), Zo(wt, o, Dt, tn);
            }
          }
          PC();
          var Ln = tC(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Ov(o, u, de, Ln);
        } else if (_5(F)) {
          u.flags |= Gn, u.child = o.child;
          var Tn = fM.bind(null, o);
          return WR(F, Tn), null;
        } else {
          RN(u, F, Z.treeContext);
          var xr = D.children, gr = pC(u, xr);
          return gr.flags |= _a, gr;
        }
      }
    }
    function XA(o, u, x) {
      o.lanes = or(o.lanes, u);
      var D = o.alternate;
      D !== null && (D.lanes = or(D.lanes, u)), oS(o.return, u, x);
    }
    function zI(o, u, x) {
      for (var D = u; D !== null; ) {
        if (D.tag === A) {
          var F = D.memoizedState;
          F !== null && XA(D, x, o);
        } else if (D.tag === U)
          XA(D, x, o);
        else if (D.child !== null) {
          D.child.return = D, D = D.child;
          continue;
        }
        if (D === o)
          return;
        for (; D.sibling === null; ) {
          if (D.return === null || D.return === o)
            return;
          D = D.return;
        }
        D.sibling.return = D.return, D = D.sibling;
      }
    }
    function VI(o) {
      for (var u = o, x = null; u !== null; ) {
        var D = u.alternate;
        D !== null && sv(D) === null && (x = u), u = u.sibling;
      }
      return x;
    }
    function qI(o) {
      if (o !== void 0 && o !== "forwards" && o !== "backwards" && o !== "together" && !lC[o])
        if (lC[o] = !0, typeof o == "string")
          switch (o.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              s('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', o, o.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              s('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', o, o.toLowerCase());
              break;
            }
            default:
              s('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', o);
              break;
          }
        else
          s('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', o);
    }
    function GI(o, u) {
      o !== void 0 && !kv[o] && (o !== "collapsed" && o !== "hidden" ? (kv[o] = !0, s('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', o)) : u !== "forwards" && u !== "backwards" && (kv[o] = !0, s('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', o)));
    }
    function KA(o, u) {
      {
        var x = Pi(o), D = !x && typeof pa(o) == "function";
        if (x || D) {
          var F = x ? "array" : "iterable";
          return s("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", F, u, F), !1;
        }
      }
      return !0;
    }
    function WI(o, u) {
      if ((u === "forwards" || u === "backwards") && o !== void 0 && o !== null && o !== !1)
        if (Pi(o)) {
          for (var x = 0; x < o.length; x++)
            if (!KA(o[x], x))
              return;
        } else {
          var D = pa(o);
          if (typeof D == "function") {
            var F = D.call(o);
            if (F)
              for (var Z = F.next(), de = 0; !Z.done; Z = F.next()) {
                if (!KA(Z.value, de))
                  return;
                de++;
              }
          } else
            s('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', u);
        }
    }
    function gC(o, u, x, D, F) {
      var Z = o.memoizedState;
      Z === null ? o.memoizedState = {
        isBackwards: u,
        rendering: null,
        renderingStartTime: 0,
        last: D,
        tail: x,
        tailMode: F
      } : (Z.isBackwards = u, Z.rendering = null, Z.renderingStartTime = 0, Z.last = D, Z.tail = x, Z.tailMode = F);
    }
    function QA(o, u, x) {
      var D = u.pendingProps, F = D.revealOrder, Z = D.tail, de = D.children;
      qI(F), GI(Z, F), WI(de, F), cs(o, u, de, x);
      var ge = Uu.current, xe = pS(ge, y_);
      if (xe)
        ge = mS(ge, y_), u.flags |= Gn;
      else {
        var Le = o !== null && (o.flags & Gn) !== xn;
        Le && zI(u, u.child, x), ge = Dg(ge);
      }
      if (wh(u, ge), (u.mode & Sn) === vn)
        u.memoizedState = null;
      else
        switch (F) {
          case "forwards": {
            var Ue = VI(u.child), st;
            Ue === null ? (st = u.child, u.child = null) : (st = Ue.sibling, Ue.sibling = null), gC(
              u,
              !1,
              // isBackwards
              st,
              Ue,
              Z
            );
            break;
          }
          case "backwards": {
            var ot = null, Et = u.child;
            for (u.child = null; Et !== null; ) {
              var wt = Et.alternate;
              if (wt !== null && sv(wt) === null) {
                u.child = Et;
                break;
              }
              var Dt = Et.sibling;
              Et.sibling = ot, ot = Et, Et = Dt;
            }
            gC(
              u,
              !0,
              // isBackwards
              ot,
              null,
              // last
              Z
            );
            break;
          }
          case "together": {
            gC(
              u,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            u.memoizedState = null;
        }
      return u.child;
    }
    function $I(o, u, x) {
      dS(u, u.stateNode.containerInfo);
      var D = u.pendingProps;
      return o === null ? u.child = Tg(u, null, D, x) : cs(o, u, D, x), u.child;
    }
    var ZA = !1;
    function YI(o, u, x) {
      var D = u.type, F = D._context, Z = u.pendingProps, de = u.memoizedProps, ge = Z.value;
      {
        "value" in Z || ZA || (ZA = !0, s("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var xe = u.type.propTypes;
        xe && ju(xe, Z, "prop", "Context.Provider");
      }
      if (q5(u, F, ge), de !== null) {
        var Le = de.value;
        if (_n(Le, ge)) {
          if (de.children === Z.children && !By())
            return tf(o, u, x);
        } else
          qN(u, F, x);
      }
      var Ue = Z.children;
      return cs(o, u, Ue, x), u.child;
    }
    var JA = !1;
    function XI(o, u, x) {
      var D = u.type;
      D._context === void 0 ? D !== D.Consumer && (JA || (JA = !0, s("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : D = D._context;
      var F = u.pendingProps, Z = F.children;
      typeof Z != "function" && s("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), kg(u, x);
      var de = Do(D);
      us(u);
      var ge;
      return A_.current = u, jo(!0), ge = Z(de), jo(!1), wo(), u.flags |= ss, cs(o, u, ge, x), u.child;
    }
    function D_() {
      Vu = !0;
    }
    function Dv(o, u) {
      (u.mode & Sn) === vn && o !== null && (o.alternate = null, u.alternate = null, u.flags |= Yr);
    }
    function tf(o, u, x) {
      return o !== null && (u.dependencies = o.dependencies), kA(), z_(u.lanes), Ga(x, u.childLanes) ? (zN(o, u), u.child) : null;
    }
    function KI(o, u, x) {
      {
        var D = u.return;
        if (D === null)
          throw new Error("Cannot swap the root fiber.");
        if (o.alternate = null, u.alternate = null, x.index = u.index, x.sibling = u.sibling, x.return = u.return, x.ref = u.ref, u === D.child)
          D.child = x;
        else {
          var F = D.child;
          if (F === null)
            throw new Error("Expected parent to have a child.");
          for (; F.sibling !== u; )
            if (F = F.sibling, F === null)
              throw new Error("Expected to find the previous sibling.");
          F.sibling = x;
        }
        var Z = D.deletions;
        return Z === null ? (D.deletions = [o], D.flags |= Tr) : Z.push(o), x.flags |= Yr, x;
      }
    }
    function _C(o, u) {
      var x = o.lanes;
      return !!Ga(x, u);
    }
    function QI(o, u, x) {
      switch (u.tag) {
        case h:
          GA(u), u.stateNode, xg();
          break;
        case g:
          Z5(u);
          break;
        case d: {
          var D = u.type;
          Wc(D) && Uy(u);
          break;
        }
        case p:
          dS(u, u.stateNode.containerInfo);
          break;
        case C: {
          var F = u.memoizedProps.value, Z = u.type._context;
          q5(u, Z, F);
          break;
        }
        case T:
          {
            var de = Ga(x, u.childLanes);
            de && (u.flags |= Fn);
            {
              var ge = u.stateNode;
              ge.effectDuration = 0, ge.passiveEffectDuration = 0;
            }
          }
          break;
        case A: {
          var xe = u.memoizedState;
          if (xe !== null) {
            if (xe.dehydrated !== null)
              return wh(u, Dg(Uu.current)), u.flags |= Gn, null;
            var Le = u.child, Ue = Le.childLanes;
            if (Ga(x, Ue))
              return $A(o, u, x);
            wh(u, Dg(Uu.current));
            var st = tf(o, u, x);
            return st !== null ? st.sibling : null;
          } else
            wh(u, Dg(Uu.current));
          break;
        }
        case U: {
          var ot = (o.flags & Gn) !== xn, Et = Ga(x, u.childLanes);
          if (ot) {
            if (Et)
              return QA(o, u, x);
            u.flags |= Gn;
          }
          var wt = u.memoizedState;
          if (wt !== null && (wt.rendering = null, wt.tail = null, wt.lastEffect = null), wh(u, Uu.current), Et)
            break;
          return null;
        }
        case Q:
        case Y:
          return u.lanes = jt, zA(o, u, x);
      }
      return tf(o, u, x);
    }
    function ek(o, u, x) {
      if (u._debugNeedsRemount && o !== null)
        return KI(o, u, $C(u.type, u.key, u.pendingProps, u._debugOwner || null, u.mode, u.lanes));
      if (o !== null) {
        var D = o.memoizedProps, F = u.pendingProps;
        if (D !== F || By() || // Force a re-render if the implementation changed due to hot reload:
        u.type !== o.type)
          Vu = !0;
        else {
          var Z = _C(o, x);
          if (!Z && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (u.flags & Gn) === xn)
            return Vu = !1, QI(o, u, x);
          (o.flags & fl) !== xn ? Vu = !0 : Vu = !1;
        }
      } else if (Vu = !1, Ta() && SN(u)) {
        var de = u.index, ge = CN();
        k5(u, ge, de);
      }
      switch (u.lanes = jt, u.tag) {
        case f:
          return NI(o, u, u.type, x);
        case j: {
          var xe = u.elementType;
          return DI(o, u, xe, x);
        }
        case l: {
          var Le = u.type, Ue = u.pendingProps, st = u.elementType === Le ? Ue : zu(Le, Ue);
          return uC(o, u, Le, st, x);
        }
        case d: {
          var ot = u.type, Et = u.pendingProps, wt = u.elementType === ot ? Et : zu(ot, Et);
          return qA(o, u, ot, wt, x);
        }
        case h:
          return AI(o, u, x);
        case g:
          return kI(o, u, x);
        case _:
          return OI(o, u);
        case A:
          return $A(o, u, x);
        case p:
          return $I(o, u, x);
        case y: {
          var Dt = u.type, tn = u.pendingProps, Ln = u.elementType === Dt ? tn : zu(Dt, tn);
          return FA(o, u, Dt, Ln, x);
        }
        case b:
          return wI(o, u, x);
        case v:
          return xI(o, u, x);
        case T:
          return TI(o, u, x);
        case C:
          return YI(o, u, x);
        case E:
          return XI(o, u, x);
        case k: {
          var Tn = u.type, xr = u.pendingProps, gr = zu(Tn, xr);
          if (u.type !== u.elementType) {
            var gt = Tn.propTypes;
            gt && ju(
              gt,
              gr,
              // Resolved for outer only
              "prop",
              ur(Tn)
            );
          }
          return gr = zu(Tn.type, gr), UA(o, u, Tn, gr, x);
        }
        case N:
          return HA(o, u, u.type, u.pendingProps, x);
        case I: {
          var Rt = u.type, _t = u.pendingProps, Gt = u.elementType === Rt ? _t : zu(Rt, _t);
          return RI(o, u, Rt, Gt, x);
        }
        case U:
          return QA(o, u, x);
        case H:
          break;
        case Q:
          return zA(o, u, x);
      }
      throw new Error("Unknown unit of work tag (" + u.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Pg(o) {
      o.flags |= Fn;
    }
    function tk(o) {
      o.flags |= oa, o.flags |= hl;
    }
    var nk, yC, rk, ik;
    nk = function(o, u, x, D) {
      for (var F = u.child; F !== null; ) {
        if (F.tag === g || F.tag === _)
          vR(o, F.stateNode);
        else if (F.tag !== p) {
          if (F.child !== null) {
            F.child.return = F, F = F.child;
            continue;
          }
        }
        if (F === u)
          return;
        for (; F.sibling === null; ) {
          if (F.return === null || F.return === u)
            return;
          F = F.return;
        }
        F.sibling.return = F.return, F = F.sibling;
      }
    }, yC = function(o, u) {
    }, rk = function(o, u, x, D, F) {
      var Z = o.memoizedProps;
      if (Z !== D) {
        var de = u.stateNode, ge = fS(), xe = ER(de, x, Z, D, F, ge);
        u.updateQueue = xe, xe && Pg(u);
      }
    }, ik = function(o, u, x, D) {
      x !== D && Pg(u);
    };
    function R_(o, u) {
      if (!Ta())
        switch (o.tailMode) {
          case "hidden": {
            for (var x = o.tail, D = null; x !== null; )
              x.alternate !== null && (D = x), x = x.sibling;
            D === null ? o.tail = null : D.sibling = null;
            break;
          }
          case "collapsed": {
            for (var F = o.tail, Z = null; F !== null; )
              F.alternate !== null && (Z = F), F = F.sibling;
            Z === null ? !u && o.tail !== null ? o.tail.sibling = null : o.tail = null : Z.sibling = null;
            break;
          }
        }
    }
    function ka(o) {
      var u = o.alternate !== null && o.alternate.child === o.child, x = jt, D = xn;
      if (u) {
        if ((o.mode & Un) !== vn) {
          for (var xe = o.selfBaseDuration, Le = o.child; Le !== null; )
            x = or(x, or(Le.lanes, Le.childLanes)), D |= Le.subtreeFlags & to, D |= Le.flags & to, xe += Le.treeBaseDuration, Le = Le.sibling;
          o.treeBaseDuration = xe;
        } else
          for (var Ue = o.child; Ue !== null; )
            x = or(x, or(Ue.lanes, Ue.childLanes)), D |= Ue.subtreeFlags & to, D |= Ue.flags & to, Ue.return = o, Ue = Ue.sibling;
        o.subtreeFlags |= D;
      } else {
        if ((o.mode & Un) !== vn) {
          for (var F = o.actualDuration, Z = o.selfBaseDuration, de = o.child; de !== null; )
            x = or(x, or(de.lanes, de.childLanes)), D |= de.subtreeFlags, D |= de.flags, F += de.actualDuration, Z += de.treeBaseDuration, de = de.sibling;
          o.actualDuration = F, o.treeBaseDuration = Z;
        } else
          for (var ge = o.child; ge !== null; )
            x = or(x, or(ge.lanes, ge.childLanes)), D |= ge.subtreeFlags, D |= ge.flags, ge.return = o, ge = ge.sibling;
        o.subtreeFlags |= D;
      }
      return o.childLanes = x, u;
    }
    function ZI(o, u, x) {
      if (PN() && (u.mode & Sn) !== vn && (u.flags & Gn) === xn)
        return M5(u), xg(), u.flags |= bi | co | Ei, !1;
      var D = Gy(u);
      if (x !== null && x.dehydrated !== null)
        if (o === null) {
          if (!D)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (LN(u), ka(u), (u.mode & Un) !== vn) {
            var F = x !== null;
            if (F) {
              var Z = u.child;
              Z !== null && (u.treeBaseDuration -= Z.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (xg(), (u.flags & Gn) === xn && (u.memoizedState = null), u.flags |= Fn, ka(u), (u.mode & Un) !== vn) {
            var de = x !== null;
            if (de) {
              var ge = u.child;
              ge !== null && (u.treeBaseDuration -= ge.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return P5(), !0;
    }
    function ok(o, u, x) {
      var D = u.pendingProps;
      switch (qE(u), u.tag) {
        case f:
        case j:
        case N:
        case l:
        case y:
        case b:
        case v:
        case T:
        case E:
        case k:
          return ka(u), null;
        case d: {
          var F = u.type;
          return Wc(F) && Fy(u), ka(u), null;
        }
        case h: {
          var Z = u.stateNode;
          if (Og(u), UE(u), _S(), Z.pendingContext && (Z.context = Z.pendingContext, Z.pendingContext = null), o === null || o.child === null) {
            var de = Gy(u);
            if (de)
              Pg(u);
            else if (o !== null) {
              var ge = o.memoizedState;
              // Check if this is a client root
              (!ge.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (u.flags & bi) !== xn) && (u.flags |= Ha, P5());
            }
          }
          return yC(o, u), ka(u), null;
        }
        case g: {
          hS(u);
          var xe = Q5(), Le = u.type;
          if (o !== null && u.stateNode != null)
            rk(o, u, Le, D, xe), o.ref !== u.ref && tk(u);
          else {
            if (!D) {
              if (u.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return ka(u), null;
            }
            var Ue = fS(), st = Gy(u);
            if (st)
              NN(u, xe, Ue) && Pg(u);
            else {
              var ot = yR(Le, D, xe, Ue, u);
              nk(ot, u, !1, !1), u.stateNode = ot, bR(ot, Le, D, xe) && Pg(u);
            }
            u.ref !== null && tk(u);
          }
          return ka(u), null;
        }
        case _: {
          var Et = D;
          if (o && u.stateNode != null) {
            var wt = o.memoizedProps;
            ik(o, u, wt, Et);
          } else {
            if (typeof Et != "string" && u.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Dt = Q5(), tn = fS(), Ln = Gy(u);
            Ln ? IN(u) && Pg(u) : u.stateNode = SR(Et, Dt, tn, u);
          }
          return ka(u), null;
        }
        case A: {
          Rg(u);
          var Tn = u.memoizedState;
          if (o === null || o.memoizedState !== null && o.memoizedState.dehydrated !== null) {
            var xr = ZI(o, u, Tn);
            if (!xr)
              return u.flags & Ei ? u : null;
          }
          if ((u.flags & Gn) !== xn)
            return u.lanes = x, (u.mode & Un) !== vn && zS(u), u;
          var gr = Tn !== null, gt = o !== null && o.memoizedState !== null;
          if (gr !== gt && gr) {
            var Rt = u.child;
            if (Rt.flags |= dl, (u.mode & Sn) !== vn) {
              var _t = o === null && (u.memoizedProps.unstable_avoidThisFallback !== !0 || !ne);
              _t || pS(Uu.current, eA) ? JL() : PC();
            }
          }
          var Gt = u.updateQueue;
          if (Gt !== null && (u.flags |= Fn), ka(u), (u.mode & Un) !== vn && gr) {
            var sn = u.child;
            sn !== null && (u.treeBaseDuration -= sn.treeBaseDuration);
          }
          return null;
        }
        case p:
          return Og(u), yC(o, u), o === null && mN(u.stateNode.containerInfo), ka(u), null;
        case C:
          var nn = u.type._context;
          return iS(nn, u), ka(u), null;
        case I: {
          var Xn = u.type;
          return Wc(Xn) && Fy(u), ka(u), null;
        }
        case U: {
          Rg(u);
          var nr = u.memoizedState;
          if (nr === null)
            return ka(u), null;
          var Zr = (u.flags & Gn) !== xn, Nr = nr.rendering;
          if (Nr === null)
            if (Zr)
              R_(nr, !1);
            else {
              var _o = tM() && (o === null || (o.flags & Gn) === xn);
              if (!_o)
                for (var Ir = u.child; Ir !== null; ) {
                  var io = sv(Ir);
                  if (io !== null) {
                    Zr = !0, u.flags |= Gn, R_(nr, !1);
                    var Ka = io.updateQueue;
                    return Ka !== null && (u.updateQueue = Ka, u.flags |= Fn), u.subtreeFlags = xn, VN(u, x), wh(u, mS(Uu.current, y_)), u.child;
                  }
                  Ir = Ir.sibling;
                }
              nr.tail !== null && oi() > Tk() && (u.flags |= Gn, Zr = !0, R_(nr, !1), u.lanes = Ca);
            }
          else {
            if (!Zr) {
              var Ia = sv(Nr);
              if (Ia !== null) {
                u.flags |= Gn, Zr = !0;
                var bl = Ia.updateQueue;
                if (bl !== null && (u.updateQueue = bl, u.flags |= Fn), R_(nr, !0), nr.tail === null && nr.tailMode === "hidden" && !Nr.alternate && !Ta())
                  return ka(u), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              oi() * 2 - nr.renderingStartTime > Tk() && x !== gi && (u.flags |= Gn, Zr = !0, R_(nr, !1), u.lanes = Ca);
            }
            if (nr.isBackwards)
              Nr.sibling = u.child, u.child = Nr;
            else {
              var hs = nr.last;
              hs !== null ? hs.sibling = Nr : u.child = Nr, nr.last = Nr;
            }
          }
          if (nr.tail !== null) {
            var ps = nr.tail;
            nr.rendering = ps, nr.tail = ps.sibling, nr.renderingStartTime = oi(), ps.sibling = null;
            var Qa = Uu.current;
            return Zr ? Qa = mS(Qa, y_) : Qa = Dg(Qa), wh(u, Qa), ps;
          }
          return ka(u), null;
        }
        case H:
          break;
        case Q:
        case Y: {
          MC(u);
          var sf = u.memoizedState, qg = sf !== null;
          if (o !== null) {
            var $_ = o.memoizedState, ed = $_ !== null;
            ed !== qg && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !K && (u.flags |= dl);
          }
          return !qg || (u.mode & Sn) === vn ? ka(u) : Ga(Jc, gi) && (ka(u), u.subtreeFlags & (Yr | Fn) && (u.flags |= dl)), null;
        }
        case ie:
          return null;
        case ce:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + u.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function JI(o, u, x) {
      switch (qE(u), u.tag) {
        case d: {
          var D = u.type;
          Wc(D) && Fy(u);
          var F = u.flags;
          return F & Ei ? (u.flags = F & ~Ei | Gn, (u.mode & Un) !== vn && zS(u), u) : null;
        }
        case h: {
          u.stateNode, Og(u), UE(u), _S();
          var Z = u.flags;
          return (Z & Ei) !== xn && (Z & Gn) === xn ? (u.flags = Z & ~Ei | Gn, u) : null;
        }
        case g:
          return hS(u), null;
        case A: {
          Rg(u);
          var de = u.memoizedState;
          if (de !== null && de.dehydrated !== null) {
            if (u.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            xg();
          }
          var ge = u.flags;
          return ge & Ei ? (u.flags = ge & ~Ei | Gn, (u.mode & Un) !== vn && zS(u), u) : null;
        }
        case U:
          return Rg(u), null;
        case p:
          return Og(u), null;
        case C:
          var xe = u.type._context;
          return iS(xe, u), null;
        case Q:
        case Y:
          return MC(u), null;
        case ie:
          return null;
        default:
          return null;
      }
    }
    function ak(o, u, x) {
      switch (qE(u), u.tag) {
        case d: {
          var D = u.type.childContextTypes;
          D != null && Fy(u);
          break;
        }
        case h: {
          u.stateNode, Og(u), UE(u), _S();
          break;
        }
        case g: {
          hS(u);
          break;
        }
        case p:
          Og(u);
          break;
        case A:
          Rg(u);
          break;
        case U:
          Rg(u);
          break;
        case C:
          var F = u.type._context;
          iS(F, u);
          break;
        case Q:
        case Y:
          MC(u);
          break;
      }
    }
    var sk = null;
    sk = /* @__PURE__ */ new Set();
    var Rv = !1, Oa = !1, eL = typeof WeakSet == "function" ? WeakSet : Set, yn = null, jg = null, Bg = null;
    function tL(o) {
      Au(null, function() {
        throw o;
      }), pp();
    }
    var nL = function(o, u) {
      if (u.props = o.memoizedProps, u.state = o.memoizedState, o.mode & Un)
        try {
          Qc(), u.componentWillUnmount();
        } finally {
          Kc(o);
        }
      else
        u.componentWillUnmount();
    };
    function lk(o, u) {
      try {
        Ah(Wo, o);
      } catch (x) {
        yi(o, u, x);
      }
    }
    function vC(o, u, x) {
      try {
        nL(o, x);
      } catch (D) {
        yi(o, u, D);
      }
    }
    function rL(o, u, x) {
      try {
        x.componentDidMount();
      } catch (D) {
        yi(o, u, D);
      }
    }
    function uk(o, u) {
      try {
        dk(o);
      } catch (x) {
        yi(o, u, x);
      }
    }
    function Fg(o, u) {
      var x = o.ref;
      if (x !== null)
        if (typeof x == "function") {
          var D;
          try {
            if (q && X && o.mode & Un)
              try {
                Qc(), D = x(null);
              } finally {
                Kc(o);
              }
            else
              D = x(null);
          } catch (F) {
            yi(o, u, F);
          }
          typeof D == "function" && s("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Yn(o));
        } else
          x.current = null;
    }
    function Nv(o, u, x) {
      try {
        x();
      } catch (D) {
        yi(o, u, D);
      }
    }
    var ck = !1;
    function iL(o, u) {
      gR(o.containerInfo), yn = u, oL();
      var x = ck;
      return ck = !1, x;
    }
    function oL() {
      for (; yn !== null; ) {
        var o = yn, u = o.child;
        (o.subtreeFlags & Du) !== xn && u !== null ? (u.return = o, yn = u) : aL();
      }
    }
    function aL() {
      for (; yn !== null; ) {
        var o = yn;
        Or(o);
        try {
          sL(o);
        } catch (x) {
          yi(o, o.return, x);
        }
        fi();
        var u = o.sibling;
        if (u !== null) {
          u.return = o.return, yn = u;
          return;
        }
        yn = o.return;
      }
    }
    function sL(o) {
      var u = o.alternate, x = o.flags;
      if ((x & Ha) !== xn) {
        switch (Or(o), o.tag) {
          case l:
          case y:
          case N:
            break;
          case d: {
            if (u !== null) {
              var D = u.memoizedProps, F = u.memoizedState, Z = o.stateNode;
              o.type === o.elementType && !Wp && (Z.props !== o.memoizedProps && s("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Yn(o) || "instance"), Z.state !== o.memoizedState && s("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Yn(o) || "instance"));
              var de = Z.getSnapshotBeforeUpdate(o.elementType === o.type ? D : zu(o.type, D), F);
              {
                var ge = sk;
                de === void 0 && !ge.has(o.type) && (ge.add(o.type), s("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Yn(o)));
              }
              Z.__reactInternalSnapshotBeforeUpdate = de;
            }
            break;
          }
          case h: {
            {
              var xe = o.stateNode;
              HR(xe.containerInfo);
            }
            break;
          }
          case g:
          case _:
          case p:
          case I:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        fi();
      }
    }
    function qu(o, u, x) {
      var D = u.updateQueue, F = D !== null ? D.lastEffect : null;
      if (F !== null) {
        var Z = F.next, de = Z;
        do {
          if ((de.tag & o) === o) {
            var ge = de.destroy;
            de.destroy = void 0, ge !== void 0 && ((o & Aa) !== zs ? an(u) : (o & Wo) !== zs && sa(u), (o & $c) !== zs && q_(!0), Nv(u, x, ge), (o & $c) !== zs && q_(!1), (o & Aa) !== zs ? Lt() : (o & Wo) !== zs && Mc());
          }
          de = de.next;
        } while (de !== Z);
      }
    }
    function Ah(o, u) {
      var x = u.updateQueue, D = x !== null ? x.lastEffect : null;
      if (D !== null) {
        var F = D.next, Z = F;
        do {
          if ((Z.tag & o) === o) {
            (o & Aa) !== zs ? Vl(u) : (o & Wo) !== zs && Is(u);
            var de = Z.create;
            (o & $c) !== zs && q_(!0), Z.destroy = de(), (o & $c) !== zs && q_(!1), (o & Aa) !== zs ? Kf() : (o & Wo) !== zs && Bd();
            {
              var ge = Z.destroy;
              if (ge !== void 0 && typeof ge != "function") {
                var xe = void 0;
                (Z.tag & Wo) !== xn ? xe = "useLayoutEffect" : (Z.tag & $c) !== xn ? xe = "useInsertionEffect" : xe = "useEffect";
                var Le = void 0;
                ge === null ? Le = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof ge.then == "function" ? Le = `

It looks like you wrote ` + xe + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + xe + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : Le = " You returned: " + ge, s("%s must not return anything besides a function, which is used for clean-up.%s", xe, Le);
              }
            }
          }
          Z = Z.next;
        } while (Z !== F);
      }
    }
    function lL(o, u) {
      if ((u.flags & Fn) !== xn)
        switch (u.tag) {
          case T: {
            var x = u.stateNode.passiveEffectDuration, D = u.memoizedProps, F = D.id, Z = D.onPostCommit, de = TA(), ge = u.alternate === null ? "mount" : "update";
            xA() && (ge = "nested-update"), typeof Z == "function" && Z(F, ge, x, de);
            var xe = u.return;
            e: for (; xe !== null; ) {
              switch (xe.tag) {
                case h:
                  var Le = xe.stateNode;
                  Le.passiveEffectDuration += x;
                  break e;
                case T:
                  var Ue = xe.stateNode;
                  Ue.passiveEffectDuration += x;
                  break e;
              }
              xe = xe.return;
            }
            break;
          }
        }
    }
    function uL(o, u, x, D) {
      if ((x.flags & fo) !== xn)
        switch (x.tag) {
          case l:
          case y:
          case N: {
            if (!Oa)
              if (x.mode & Un)
                try {
                  Qc(), Ah(Wo | Go, x);
                } finally {
                  Kc(x);
                }
              else
                Ah(Wo | Go, x);
            break;
          }
          case d: {
            var F = x.stateNode;
            if (x.flags & Fn && !Oa)
              if (u === null)
                if (x.type === x.elementType && !Wp && (F.props !== x.memoizedProps && s("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Yn(x) || "instance"), F.state !== x.memoizedState && s("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Yn(x) || "instance")), x.mode & Un)
                  try {
                    Qc(), F.componentDidMount();
                  } finally {
                    Kc(x);
                  }
                else
                  F.componentDidMount();
              else {
                var Z = x.elementType === x.type ? u.memoizedProps : zu(x.type, u.memoizedProps), de = u.memoizedState;
                if (x.type === x.elementType && !Wp && (F.props !== x.memoizedProps && s("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Yn(x) || "instance"), F.state !== x.memoizedState && s("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Yn(x) || "instance")), x.mode & Un)
                  try {
                    Qc(), F.componentDidUpdate(Z, de, F.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Kc(x);
                  }
                else
                  F.componentDidUpdate(Z, de, F.__reactInternalSnapshotBeforeUpdate);
              }
            var ge = x.updateQueue;
            ge !== null && (x.type === x.elementType && !Wp && (F.props !== x.memoizedProps && s("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Yn(x) || "instance"), F.state !== x.memoizedState && s("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Yn(x) || "instance")), K5(x, ge, F));
            break;
          }
          case h: {
            var xe = x.updateQueue;
            if (xe !== null) {
              var Le = null;
              if (x.child !== null)
                switch (x.child.tag) {
                  case g:
                    Le = x.child.stateNode;
                    break;
                  case d:
                    Le = x.child.stateNode;
                    break;
                }
              K5(x, xe, Le);
            }
            break;
          }
          case g: {
            var Ue = x.stateNode;
            if (u === null && x.flags & Fn) {
              var st = x.type, ot = x.memoizedProps;
              AR(Ue, st, ot);
            }
            break;
          }
          case _:
            break;
          case p:
            break;
          case T: {
            {
              var Et = x.memoizedProps, wt = Et.onCommit, Dt = Et.onRender, tn = x.stateNode.effectDuration, Ln = TA(), Tn = u === null ? "mount" : "update";
              xA() && (Tn = "nested-update"), typeof Dt == "function" && Dt(x.memoizedProps.id, Tn, x.actualDuration, x.treeBaseDuration, x.actualStartTime, Ln);
              {
                typeof wt == "function" && wt(x.memoizedProps.id, Tn, tn, Ln), aM(x);
                var xr = x.return;
                e: for (; xr !== null; ) {
                  switch (xr.tag) {
                    case h:
                      var gr = xr.stateNode;
                      gr.effectDuration += tn;
                      break e;
                    case T:
                      var gt = xr.stateNode;
                      gt.effectDuration += tn;
                      break e;
                  }
                  xr = xr.return;
                }
              }
            }
            break;
          }
          case A: {
            _L(o, x);
            break;
          }
          case U:
          case I:
          case H:
          case Q:
          case Y:
          case ce:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Oa || x.flags & oa && dk(x);
    }
    function cL(o) {
      switch (o.tag) {
        case l:
        case y:
        case N: {
          if (o.mode & Un)
            try {
              Qc(), lk(o, o.return);
            } finally {
              Kc(o);
            }
          else
            lk(o, o.return);
          break;
        }
        case d: {
          var u = o.stateNode;
          typeof u.componentDidMount == "function" && rL(o, o.return, u), uk(o, o.return);
          break;
        }
        case g: {
          uk(o, o.return);
          break;
        }
      }
    }
    function dL(o, u) {
      for (var x = null, D = o; ; ) {
        if (D.tag === g) {
          if (x === null) {
            x = D;
            try {
              var F = D.stateNode;
              u ? jR(F) : FR(D.stateNode, D.memoizedProps);
            } catch (de) {
              yi(o, o.return, de);
            }
          }
        } else if (D.tag === _) {
          if (x === null)
            try {
              var Z = D.stateNode;
              u ? BR(Z) : UR(Z, D.memoizedProps);
            } catch (de) {
              yi(o, o.return, de);
            }
        } else if (!((D.tag === Q || D.tag === Y) && D.memoizedState !== null && D !== o)) {
          if (D.child !== null) {
            D.child.return = D, D = D.child;
            continue;
          }
        }
        if (D === o)
          return;
        for (; D.sibling === null; ) {
          if (D.return === null || D.return === o)
            return;
          x === D && (x = null), D = D.return;
        }
        x === D && (x = null), D.sibling.return = D.return, D = D.sibling;
      }
    }
    function dk(o) {
      var u = o.ref;
      if (u !== null) {
        var x = o.stateNode, D;
        switch (o.tag) {
          case g:
            D = x;
            break;
          default:
            D = x;
        }
        if (typeof u == "function") {
          var F;
          if (o.mode & Un)
            try {
              Qc(), F = u(D);
            } finally {
              Kc(o);
            }
          else
            F = u(D);
          typeof F == "function" && s("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Yn(o));
        } else
          u.hasOwnProperty("current") || s("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Yn(o)), u.current = D;
      }
    }
    function fL(o) {
      var u = o.alternate;
      u !== null && (u.return = null), o.return = null;
    }
    function fk(o) {
      var u = o.alternate;
      u !== null && (o.alternate = null, fk(u));
      {
        if (o.child = null, o.deletions = null, o.sibling = null, o.tag === g) {
          var x = o.stateNode;
          x !== null && yN(x);
        }
        o.stateNode = null, o._debugOwner = null, o.return = null, o.dependencies = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.stateNode = null, o.updateQueue = null;
      }
    }
    function hL(o) {
      for (var u = o.return; u !== null; ) {
        if (hk(u))
          return u;
        u = u.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hk(o) {
      return o.tag === g || o.tag === h || o.tag === p;
    }
    function pk(o) {
      var u = o;
      e: for (; ; ) {
        for (; u.sibling === null; ) {
          if (u.return === null || hk(u.return))
            return null;
          u = u.return;
        }
        for (u.sibling.return = u.return, u = u.sibling; u.tag !== g && u.tag !== _ && u.tag !== B; ) {
          if (u.flags & Yr || u.child === null || u.tag === p)
            continue e;
          u.child.return = u, u = u.child;
        }
        if (!(u.flags & Yr))
          return u.stateNode;
      }
    }
    function pL(o) {
      var u = hL(o);
      switch (u.tag) {
        case g: {
          var x = u.stateNode;
          u.flags & Ar && (g5(x), u.flags &= ~Ar);
          var D = pk(o);
          EC(o, D, x);
          break;
        }
        case h:
        case p: {
          var F = u.stateNode.containerInfo, Z = pk(o);
          bC(o, Z, F);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function bC(o, u, x) {
      var D = o.tag, F = D === g || D === _;
      if (F) {
        var Z = o.stateNode;
        u ? IR(x, Z, u) : RR(x, Z);
      } else if (D !== p) {
        var de = o.child;
        if (de !== null) {
          bC(de, u, x);
          for (var ge = de.sibling; ge !== null; )
            bC(ge, u, x), ge = ge.sibling;
        }
      }
    }
    function EC(o, u, x) {
      var D = o.tag, F = D === g || D === _;
      if (F) {
        var Z = o.stateNode;
        u ? NR(x, Z, u) : DR(x, Z);
      } else if (D !== p) {
        var de = o.child;
        if (de !== null) {
          EC(de, u, x);
          for (var ge = de.sibling; ge !== null; )
            EC(ge, u, x), ge = ge.sibling;
        }
      }
    }
    var Da = null, Gu = !1;
    function mL(o, u, x) {
      {
        var D = u;
        e: for (; D !== null; ) {
          switch (D.tag) {
            case g: {
              Da = D.stateNode, Gu = !1;
              break e;
            }
            case h: {
              Da = D.stateNode.containerInfo, Gu = !0;
              break e;
            }
            case p: {
              Da = D.stateNode.containerInfo, Gu = !0;
              break e;
            }
          }
          D = D.return;
        }
        if (Da === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        mk(o, u, x), Da = null, Gu = !1;
      }
      fL(x);
    }
    function kh(o, u, x) {
      for (var D = x.child; D !== null; )
        mk(o, u, D), D = D.sibling;
    }
    function mk(o, u, x) {
      switch (zl(x), x.tag) {
        case g:
          Oa || Fg(x, u);
        case _: {
          {
            var D = Da, F = Gu;
            Da = null, kh(o, u, x), Da = D, Gu = F, Da !== null && (Gu ? MR(Da, x.stateNode) : LR(Da, x.stateNode));
          }
          return;
        }
        case B: {
          Da !== null && (Gu ? PR(Da, x.stateNode) : NE(Da, x.stateNode));
          return;
        }
        case p: {
          {
            var Z = Da, de = Gu;
            Da = x.stateNode.containerInfo, Gu = !0, kh(o, u, x), Da = Z, Gu = de;
          }
          return;
        }
        case l:
        case y:
        case k:
        case N: {
          if (!Oa) {
            var ge = x.updateQueue;
            if (ge !== null) {
              var xe = ge.lastEffect;
              if (xe !== null) {
                var Le = xe.next, Ue = Le;
                do {
                  var st = Ue, ot = st.destroy, Et = st.tag;
                  ot !== void 0 && ((Et & $c) !== zs ? Nv(x, u, ot) : (Et & Wo) !== zs && (sa(x), x.mode & Un ? (Qc(), Nv(x, u, ot), Kc(x)) : Nv(x, u, ot), Mc())), Ue = Ue.next;
                } while (Ue !== Le);
              }
            }
          }
          kh(o, u, x);
          return;
        }
        case d: {
          if (!Oa) {
            Fg(x, u);
            var wt = x.stateNode;
            typeof wt.componentWillUnmount == "function" && vC(x, u, wt);
          }
          kh(o, u, x);
          return;
        }
        case H: {
          kh(o, u, x);
          return;
        }
        case Q: {
          if (
            // TODO: Remove this dead flag
            x.mode & Sn
          ) {
            var Dt = Oa;
            Oa = Dt || x.memoizedState !== null, kh(o, u, x), Oa = Dt;
          } else
            kh(o, u, x);
          break;
        }
        default: {
          kh(o, u, x);
          return;
        }
      }
    }
    function gL(o) {
      o.memoizedState;
    }
    function _L(o, u) {
      var x = u.memoizedState;
      if (x === null) {
        var D = u.alternate;
        if (D !== null) {
          var F = D.memoizedState;
          if (F !== null) {
            var Z = F.dehydrated;
            Z !== null && tN(Z);
          }
        }
      }
    }
    function gk(o) {
      var u = o.updateQueue;
      if (u !== null) {
        o.updateQueue = null;
        var x = o.stateNode;
        x === null && (x = o.stateNode = new eL()), u.forEach(function(D) {
          var F = hM.bind(null, o, D);
          if (!x.has(D)) {
            if (x.add(D), aa)
              if (jg !== null && Bg !== null)
                V_(Bg, jg);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            D.then(F, F);
          }
        });
      }
    }
    function yL(o, u, x) {
      jg = x, Bg = o, Or(u), _k(u, o), Or(u), jg = null, Bg = null;
    }
    function Wu(o, u, x) {
      var D = u.deletions;
      if (D !== null)
        for (var F = 0; F < D.length; F++) {
          var Z = D[F];
          try {
            mL(o, u, Z);
          } catch (xe) {
            yi(Z, u, xe);
          }
        }
      var de = ep();
      if (u.subtreeFlags & Ho)
        for (var ge = u.child; ge !== null; )
          Or(ge), _k(ge, o), ge = ge.sibling;
      Or(de);
    }
    function _k(o, u, x) {
      var D = o.alternate, F = o.flags;
      switch (o.tag) {
        case l:
        case y:
        case k:
        case N: {
          if (Wu(u, o), Zc(o), F & Fn) {
            try {
              qu($c | Go, o, o.return), Ah($c | Go, o);
            } catch (Xn) {
              yi(o, o.return, Xn);
            }
            if (o.mode & Un) {
              try {
                Qc(), qu(Wo | Go, o, o.return);
              } catch (Xn) {
                yi(o, o.return, Xn);
              }
              Kc(o);
            } else
              try {
                qu(Wo | Go, o, o.return);
              } catch (Xn) {
                yi(o, o.return, Xn);
              }
          }
          return;
        }
        case d: {
          Wu(u, o), Zc(o), F & oa && D !== null && Fg(D, D.return);
          return;
        }
        case g: {
          Wu(u, o), Zc(o), F & oa && D !== null && Fg(D, D.return);
          {
            if (o.flags & Ar) {
              var Z = o.stateNode;
              try {
                g5(Z);
              } catch (Xn) {
                yi(o, o.return, Xn);
              }
            }
            if (F & Fn) {
              var de = o.stateNode;
              if (de != null) {
                var ge = o.memoizedProps, xe = D !== null ? D.memoizedProps : ge, Le = o.type, Ue = o.updateQueue;
                if (o.updateQueue = null, Ue !== null)
                  try {
                    kR(de, Ue, Le, xe, ge, o);
                  } catch (Xn) {
                    yi(o, o.return, Xn);
                  }
              }
            }
          }
          return;
        }
        case _: {
          if (Wu(u, o), Zc(o), F & Fn) {
            if (o.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var st = o.stateNode, ot = o.memoizedProps, Et = D !== null ? D.memoizedProps : ot;
            try {
              OR(st, Et, ot);
            } catch (Xn) {
              yi(o, o.return, Xn);
            }
          }
          return;
        }
        case h: {
          if (Wu(u, o), Zc(o), F & Fn && D !== null) {
            var wt = D.memoizedState;
            if (wt.isDehydrated)
              try {
                eN(u.containerInfo);
              } catch (Xn) {
                yi(o, o.return, Xn);
              }
          }
          return;
        }
        case p: {
          Wu(u, o), Zc(o);
          return;
        }
        case A: {
          Wu(u, o), Zc(o);
          var Dt = o.child;
          if (Dt.flags & dl) {
            var tn = Dt.stateNode, Ln = Dt.memoizedState, Tn = Ln !== null;
            if (tn.isHidden = Tn, Tn) {
              var xr = Dt.alternate !== null && Dt.alternate.memoizedState !== null;
              xr || ZL();
            }
          }
          if (F & Fn) {
            try {
              gL(o);
            } catch (Xn) {
              yi(o, o.return, Xn);
            }
            gk(o);
          }
          return;
        }
        case Q: {
          var gr = D !== null && D.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            o.mode & Sn
          ) {
            var gt = Oa;
            Oa = gt || gr, Wu(u, o), Oa = gt;
          } else
            Wu(u, o);
          if (Zc(o), F & dl) {
            var Rt = o.stateNode, _t = o.memoizedState, Gt = _t !== null, sn = o;
            if (Rt.isHidden = Gt, Gt && !gr && (sn.mode & Sn) !== vn) {
              yn = sn;
              for (var nn = sn.child; nn !== null; )
                yn = nn, bL(nn), nn = nn.sibling;
            }
            dL(sn, Gt);
          }
          return;
        }
        case U: {
          Wu(u, o), Zc(o), F & Fn && gk(o);
          return;
        }
        case H:
          return;
        default: {
          Wu(u, o), Zc(o);
          return;
        }
      }
    }
    function Zc(o) {
      var u = o.flags;
      if (u & Yr) {
        try {
          pL(o);
        } catch (x) {
          yi(o, o.return, x);
        }
        o.flags &= ~Yr;
      }
      u & _a && (o.flags &= ~_a);
    }
    function vL(o, u, x) {
      jg = x, Bg = u, yn = o, yk(o, u, x), jg = null, Bg = null;
    }
    function yk(o, u, x) {
      for (var D = (o.mode & Sn) !== vn; yn !== null; ) {
        var F = yn, Z = F.child;
        if (F.tag === Q && D) {
          var de = F.memoizedState !== null, ge = de || Rv;
          if (ge) {
            SC(o, u, x);
            continue;
          } else {
            var xe = F.alternate, Le = xe !== null && xe.memoizedState !== null, Ue = Le || Oa, st = Rv, ot = Oa;
            Rv = ge, Oa = Ue, Oa && !ot && (yn = F, EL(F));
            for (var Et = Z; Et !== null; )
              yn = Et, yk(
                Et,
                // New root; bubble back up to here and stop.
                u,
                x
              ), Et = Et.sibling;
            yn = F, Rv = st, Oa = ot, SC(o, u, x);
            continue;
          }
        }
        (F.subtreeFlags & fo) !== xn && Z !== null ? (Z.return = F, yn = Z) : SC(o, u, x);
      }
    }
    function SC(o, u, x) {
      for (; yn !== null; ) {
        var D = yn;
        if ((D.flags & fo) !== xn) {
          var F = D.alternate;
          Or(D);
          try {
            uL(u, F, D, x);
          } catch (de) {
            yi(D, D.return, de);
          }
          fi();
        }
        if (D === o) {
          yn = null;
          return;
        }
        var Z = D.sibling;
        if (Z !== null) {
          Z.return = D.return, yn = Z;
          return;
        }
        yn = D.return;
      }
    }
    function bL(o) {
      for (; yn !== null; ) {
        var u = yn, x = u.child;
        switch (u.tag) {
          case l:
          case y:
          case k:
          case N: {
            if (u.mode & Un)
              try {
                Qc(), qu(Wo, u, u.return);
              } finally {
                Kc(u);
              }
            else
              qu(Wo, u, u.return);
            break;
          }
          case d: {
            Fg(u, u.return);
            var D = u.stateNode;
            typeof D.componentWillUnmount == "function" && vC(u, u.return, D);
            break;
          }
          case g: {
            Fg(u, u.return);
            break;
          }
          case Q: {
            var F = u.memoizedState !== null;
            if (F) {
              vk(o);
              continue;
            }
            break;
          }
        }
        x !== null ? (x.return = u, yn = x) : vk(o);
      }
    }
    function vk(o) {
      for (; yn !== null; ) {
        var u = yn;
        if (u === o) {
          yn = null;
          return;
        }
        var x = u.sibling;
        if (x !== null) {
          x.return = u.return, yn = x;
          return;
        }
        yn = u.return;
      }
    }
    function EL(o) {
      for (; yn !== null; ) {
        var u = yn, x = u.child;
        if (u.tag === Q) {
          var D = u.memoizedState !== null;
          if (D) {
            bk(o);
            continue;
          }
        }
        x !== null ? (x.return = u, yn = x) : bk(o);
      }
    }
    function bk(o) {
      for (; yn !== null; ) {
        var u = yn;
        Or(u);
        try {
          cL(u);
        } catch (D) {
          yi(u, u.return, D);
        }
        if (fi(), u === o) {
          yn = null;
          return;
        }
        var x = u.sibling;
        if (x !== null) {
          x.return = u.return, yn = x;
          return;
        }
        yn = u.return;
      }
    }
    function SL(o, u, x, D) {
      yn = u, CL(u, o, x, D);
    }
    function CL(o, u, x, D) {
      for (; yn !== null; ) {
        var F = yn, Z = F.child;
        (F.subtreeFlags & va) !== xn && Z !== null ? (Z.return = F, yn = Z) : wL(o, u, x, D);
      }
    }
    function wL(o, u, x, D) {
      for (; yn !== null; ) {
        var F = yn;
        if ((F.flags & ii) !== xn) {
          Or(F);
          try {
            xL(u, F, x, D);
          } catch (de) {
            yi(F, F.return, de);
          }
          fi();
        }
        if (F === o) {
          yn = null;
          return;
        }
        var Z = F.sibling;
        if (Z !== null) {
          Z.return = F.return, yn = Z;
          return;
        }
        yn = F.return;
      }
    }
    function xL(o, u, x, D) {
      switch (u.tag) {
        case l:
        case y:
        case N: {
          if (u.mode & Un) {
            HS();
            try {
              Ah(Aa | Go, u);
            } finally {
              US(u);
            }
          } else
            Ah(Aa | Go, u);
          break;
        }
      }
    }
    function TL(o) {
      yn = o, AL();
    }
    function AL() {
      for (; yn !== null; ) {
        var o = yn, u = o.child;
        if ((yn.flags & Tr) !== xn) {
          var x = o.deletions;
          if (x !== null) {
            for (var D = 0; D < x.length; D++) {
              var F = x[D];
              yn = F, DL(F, o);
            }
            {
              var Z = o.alternate;
              if (Z !== null) {
                var de = Z.child;
                if (de !== null) {
                  Z.child = null;
                  do {
                    var ge = de.sibling;
                    de.sibling = null, de = ge;
                  } while (de !== null);
                }
              }
            }
            yn = o;
          }
        }
        (o.subtreeFlags & va) !== xn && u !== null ? (u.return = o, yn = u) : kL();
      }
    }
    function kL() {
      for (; yn !== null; ) {
        var o = yn;
        (o.flags & ii) !== xn && (Or(o), OL(o), fi());
        var u = o.sibling;
        if (u !== null) {
          u.return = o.return, yn = u;
          return;
        }
        yn = o.return;
      }
    }
    function OL(o) {
      switch (o.tag) {
        case l:
        case y:
        case N: {
          o.mode & Un ? (HS(), qu(Aa | Go, o, o.return), US(o)) : qu(Aa | Go, o, o.return);
          break;
        }
      }
    }
    function DL(o, u) {
      for (; yn !== null; ) {
        var x = yn;
        Or(x), NL(x, u), fi();
        var D = x.child;
        D !== null ? (D.return = x, yn = D) : RL(o);
      }
    }
    function RL(o) {
      for (; yn !== null; ) {
        var u = yn, x = u.sibling, D = u.return;
        if (fk(u), u === o) {
          yn = null;
          return;
        }
        if (x !== null) {
          x.return = D, yn = x;
          return;
        }
        yn = D;
      }
    }
    function NL(o, u) {
      switch (o.tag) {
        case l:
        case y:
        case N: {
          o.mode & Un ? (HS(), qu(Aa, o, u), US(o)) : qu(Aa, o, u);
          break;
        }
      }
    }
    function IL(o) {
      switch (o.tag) {
        case l:
        case y:
        case N: {
          try {
            Ah(Wo | Go, o);
          } catch (x) {
            yi(o, o.return, x);
          }
          break;
        }
        case d: {
          var u = o.stateNode;
          try {
            u.componentDidMount();
          } catch (x) {
            yi(o, o.return, x);
          }
          break;
        }
      }
    }
    function LL(o) {
      switch (o.tag) {
        case l:
        case y:
        case N: {
          try {
            Ah(Aa | Go, o);
          } catch (u) {
            yi(o, o.return, u);
          }
          break;
        }
      }
    }
    function ML(o) {
      switch (o.tag) {
        case l:
        case y:
        case N: {
          try {
            qu(Wo | Go, o, o.return);
          } catch (x) {
            yi(o, o.return, x);
          }
          break;
        }
        case d: {
          var u = o.stateNode;
          typeof u.componentWillUnmount == "function" && vC(o, o.return, u);
          break;
        }
      }
    }
    function PL(o) {
      switch (o.tag) {
        case l:
        case y:
        case N:
          try {
            qu(Aa | Go, o, o.return);
          } catch (u) {
            yi(o, o.return, u);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var N_ = Symbol.for;
      N_("selector.component"), N_("selector.has_pseudo_class"), N_("selector.role"), N_("selector.test_id"), N_("selector.text");
    }
    var jL = [];
    function BL() {
      jL.forEach(function(o) {
        return o();
      });
    }
    var FL = t.ReactCurrentActQueue;
    function UL(o) {
      {
        var u = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), x = typeof jest < "u";
        return x && u !== !1;
      }
    }
    function Ek() {
      {
        var o = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !o && FL.current !== null && s("The current testing environment is not configured to support act(...)"), o;
      }
    }
    var HL = Math.ceil, CC = t.ReactCurrentDispatcher, wC = t.ReactCurrentOwner, Ra = t.ReactCurrentBatchConfig, $u = t.ReactCurrentActQueue, Xo = (
      /*             */
      0
    ), Sk = (
      /*               */
      1
    ), Na = (
      /*                */
      2
    ), Jl = (
      /*                */
      4
    ), nf = 0, I_ = 1, $p = 2, Iv = 3, L_ = 4, Ck = 5, xC = 6, wr = Xo, ds = null, Ki = null, Ko = jt, Jc = jt, TC = yh(jt), Qo = nf, M_ = null, Lv = jt, P_ = jt, Mv = jt, j_ = null, Vs = null, AC = 0, wk = 500, xk = 1 / 0, zL = 500, rf = null;
    function B_() {
      xk = oi() + zL;
    }
    function Tk() {
      return xk;
    }
    var Pv = !1, kC = null, Ug = null, Yp = !1, Oh = null, F_ = jt, OC = [], DC = null, VL = 50, U_ = 0, RC = null, NC = !1, jv = !1, qL = 50, Hg = 0, Bv = null, H_ = Gr, Fv = jt, Ak = !1;
    function Uv() {
      return ds;
    }
    function fs() {
      return (wr & (Na | Jl)) !== Xo ? oi() : (H_ !== Gr || (H_ = oi()), H_);
    }
    function Dh(o) {
      var u = o.mode;
      if ((u & Sn) === vn)
        return O;
      if ((wr & Na) !== Xo && Ko !== jt)
        return Jf(Ko);
      var x = FN() !== BN;
      if (x) {
        if (Ra.transition !== null) {
          var D = Ra.transition;
          D._updatedFibers || (D._updatedFibers = /* @__PURE__ */ new Set()), D._updatedFibers.add(o);
        }
        return Fv === M && (Fv = Z1()), Fv;
      }
      var F = Ms();
      if (F !== M)
        return F;
      var Z = CR();
      return Z;
    }
    function GL(o) {
      var u = o.mode;
      return (u & Sn) === vn ? O : qa();
    }
    function Zo(o, u, x, D) {
      mM(), Ak && s("useInsertionEffect must not schedule updates."), NC && (jv = !0), zd(o, x, D), (wr & Na) !== jt && o === ds ? yM(u) : (aa && Ym(o, u, x), vM(u), o === ds && ((wr & Na) === Xo && (P_ = or(P_, x)), Qo === L_ && Rh(o, Ko)), qs(o, D), x === O && wr === Xo && (u.mode & Sn) === vn && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !$u.isBatchingLegacy && (B_(), A5()));
    }
    function WL(o, u, x) {
      var D = o.current;
      D.lanes = u, zd(o, u, x), qs(o, x);
    }
    function $L(o) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (wr & Na) !== Xo
      );
    }
    function qs(o, u) {
      var x = o.callbackNode;
      Vm(o, u);
      var D = _l(o, o === ds ? Ko : jt);
      if (D === jt) {
        x !== null && Vk(x), o.callbackNode = null, o.callbackPriority = M;
        return;
      }
      var F = $i(D), Z = o.callbackPriority;
      if (Z === F && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !($u.current !== null && x !== FC)) {
        x == null && Z !== O && s("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      x != null && Vk(x);
      var de;
      if (F === O)
        o.tag === vh ? ($u.isBatchingLegacy !== null && ($u.didScheduleLegacyUpdate = !0), EN(Dk.bind(null, o))) : T5(Dk.bind(null, o)), $u.current !== null ? $u.current.push(bh) : xR(function() {
          (wr & (Na | Jl)) === Xo && bh();
        }), de = null;
      else {
        var ge;
        switch (qo(D)) {
          case Yi:
            ge = Ld;
            break;
          case Iu:
            ge = Hl;
            break;
          case ql:
            ge = ls;
            break;
          case eh:
            ge = Md;
            break;
          default:
            ge = ls;
            break;
        }
        de = UC(ge, kk.bind(null, o));
      }
      o.callbackPriority = F, o.callbackNode = de;
    }
    function kk(o, u) {
      if (dI(), H_ = Gr, Fv = jt, (wr & (Na | Jl)) !== Xo)
        throw new Error("Should not already be working.");
      var x = o.callbackNode, D = af();
      if (D && o.callbackNode !== x)
        return null;
      var F = _l(o, o === ds ? Ko : jt);
      if (F === jt)
        return null;
      var Z = !bp(o, F) && !Q1(o, F) && !u, de = Z ? rM(o, F) : zv(o, F);
      if (de !== nf) {
        if (de === $p) {
          var ge = Fc(o);
          ge !== jt && (F = ge, de = IC(o, ge));
        }
        if (de === I_) {
          var xe = M_;
          throw Xp(o, jt), Rh(o, F), qs(o, oi()), xe;
        }
        if (de === xC)
          Rh(o, F);
        else {
          var Le = !bp(o, F), Ue = o.current.alternate;
          if (Le && !XL(Ue)) {
            if (de = zv(o, F), de === $p) {
              var st = Fc(o);
              st !== jt && (F = st, de = IC(o, st));
            }
            if (de === I_) {
              var ot = M_;
              throw Xp(o, jt), Rh(o, F), qs(o, oi()), ot;
            }
          }
          o.finishedWork = Ue, o.finishedLanes = F, YL(o, de, F);
        }
      }
      return qs(o, oi()), o.callbackNode === x ? kk.bind(null, o) : null;
    }
    function IC(o, u) {
      var x = j_;
      if (Xm(o)) {
        var D = Xp(o, u);
        D.flags |= bi, pN(o.containerInfo);
      }
      var F = zv(o, u);
      if (F !== $p) {
        var Z = Vs;
        Vs = x, Z !== null && Ok(Z);
      }
      return F;
    }
    function Ok(o) {
      Vs === null ? Vs = o : Vs.push.apply(Vs, o);
    }
    function YL(o, u, x) {
      switch (u) {
        case nf:
        case I_:
          throw new Error("Root did not complete. This is a bug in React.");
        case $p: {
          Kp(o, Vs, rf);
          break;
        }
        case Iv: {
          if (Rh(o, x), Y1(x) && // do not delay if we're inside an act() scope
          !qk()) {
            var D = AC + wk - oi();
            if (D > 10) {
              var F = _l(o, jt);
              if (F !== jt)
                break;
              var Z = o.suspendedLanes;
              if (!Hd(Z, x)) {
                fs(), Wm(o, Z);
                break;
              }
              o.timeoutHandle = DE(Kp.bind(null, o, Vs, rf), D);
              break;
            }
          }
          Kp(o, Vs, rf);
          break;
        }
        case L_: {
          if (Rh(o, x), K1(x))
            break;
          if (!qk()) {
            var de = Zf(o, x), ge = de, xe = oi() - ge, Le = pM(xe) - xe;
            if (Le > 10) {
              o.timeoutHandle = DE(Kp.bind(null, o, Vs, rf), Le);
              break;
            }
          }
          Kp(o, Vs, rf);
          break;
        }
        case Ck: {
          Kp(o, Vs, rf);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function XL(o) {
      for (var u = o; ; ) {
        if (u.flags & Ou) {
          var x = u.updateQueue;
          if (x !== null) {
            var D = x.stores;
            if (D !== null)
              for (var F = 0; F < D.length; F++) {
                var Z = D[F], de = Z.getSnapshot, ge = Z.value;
                try {
                  if (!_n(de(), ge))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var xe = u.child;
        if (u.subtreeFlags & Ou && xe !== null) {
          xe.return = u, u = xe;
          continue;
        }
        if (u === o)
          return !0;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === o)
            return !0;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !0;
    }
    function Rh(o, u) {
      u = Ep(u, Mv), u = Ep(u, P_), ey(o, u);
    }
    function Dk(o) {
      if (fI(), (wr & (Na | Jl)) !== Xo)
        throw new Error("Should not already be working.");
      af();
      var u = _l(o, jt);
      if (!Ga(u, O))
        return qs(o, oi()), null;
      var x = zv(o, u);
      if (o.tag !== vh && x === $p) {
        var D = Fc(o);
        D !== jt && (u = D, x = IC(o, D));
      }
      if (x === I_) {
        var F = M_;
        throw Xp(o, jt), Rh(o, u), qs(o, oi()), F;
      }
      if (x === xC)
        throw new Error("Root did not complete. This is a bug in React.");
      var Z = o.current.alternate;
      return o.finishedWork = Z, o.finishedLanes = u, Kp(o, Vs, rf), qs(o, oi()), null;
    }
    function KL(o, u) {
      u !== jt && (R0(o, or(u, O)), qs(o, oi()), (wr & (Na | Jl)) === Xo && (B_(), bh()));
    }
    function LC(o, u) {
      var x = wr;
      wr |= Sk;
      try {
        return o(u);
      } finally {
        wr = x, wr === Xo && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !$u.isBatchingLegacy && (B_(), A5());
      }
    }
    function QL(o, u, x, D, F) {
      var Z = Ms(), de = Ra.transition;
      try {
        return Ra.transition = null, Fi(Yi), o(u, x, D, F);
      } finally {
        Fi(Z), Ra.transition = de, wr === Xo && B_();
      }
    }
    function of(o) {
      Oh !== null && Oh.tag === vh && (wr & (Na | Jl)) === Xo && af();
      var u = wr;
      wr |= Sk;
      var x = Ra.transition, D = Ms();
      try {
        return Ra.transition = null, Fi(Yi), o ? o() : void 0;
      } finally {
        Fi(D), Ra.transition = x, wr = u, (wr & (Na | Jl)) === Xo && bh();
      }
    }
    function Rk() {
      return (wr & (Na | Jl)) !== Xo;
    }
    function Hv(o, u) {
      Ya(TC, Jc, o), Jc = or(Jc, u);
    }
    function MC(o) {
      Jc = TC.current, $a(TC, o);
    }
    function Xp(o, u) {
      o.finishedWork = null, o.finishedLanes = jt;
      var x = o.timeoutHandle;
      if (x !== RE && (o.timeoutHandle = RE, wR(x)), Ki !== null)
        for (var D = Ki.return; D !== null; ) {
          var F = D.alternate;
          ak(F, D), D = D.return;
        }
      ds = o;
      var Z = Qp(o.current, null);
      return Ki = Z, Ko = Jc = u, Qo = nf, M_ = null, Lv = jt, P_ = jt, Mv = jt, j_ = null, Vs = null, WN(), Fu.discardPendingWarnings(), Z;
    }
    function Nk(o, u) {
      do {
        var x = Ki;
        try {
          if (Qy(), nA(), fi(), wC.current = null, x === null || x.return === null) {
            Qo = I_, M_ = u, Ki = null;
            return;
          }
          if (q && x.mode & Un && Tv(x, !0), ee)
            if (wo(), u !== null && typeof u == "object" && typeof u.then == "function") {
              var D = u;
              Ls(x, D, Ko);
            } else
              Ea(x, u, Ko);
          EI(o, x.return, x, u, Ko), Pk(x);
        } catch (F) {
          u = F, Ki === x && x !== null ? (x = x.return, Ki = x) : x = Ki;
          continue;
        }
        return;
      } while (!0);
    }
    function Ik() {
      var o = CC.current;
      return CC.current = Ev, o === null ? Ev : o;
    }
    function Lk(o) {
      CC.current = o;
    }
    function ZL() {
      AC = oi();
    }
    function z_(o) {
      Lv = or(o, Lv);
    }
    function JL() {
      Qo === nf && (Qo = Iv);
    }
    function PC() {
      (Qo === nf || Qo === Iv || Qo === $p) && (Qo = L_), ds !== null && (vp(Lv) || vp(P_)) && Rh(ds, Ko);
    }
    function eM(o) {
      Qo !== L_ && (Qo = $p), j_ === null ? j_ = [o] : j_.push(o);
    }
    function tM() {
      return Qo === nf;
    }
    function zv(o, u) {
      var x = wr;
      wr |= Na;
      var D = Ik();
      if (ds !== o || Ko !== u) {
        if (aa) {
          var F = o.memoizedUpdaters;
          F.size > 0 && (V_(o, Ko), F.clear()), N0(o, u);
        }
        rf = Cp(), Xp(o, u);
      }
      ci(u);
      do
        try {
          nM();
          break;
        } catch (Z) {
          Nk(o, Z);
        }
      while (!0);
      if (Qy(), wr = x, Lk(D), Ki !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return yt(), ds = null, Ko = jt, Qo;
    }
    function nM() {
      for (; Ki !== null; )
        Mk(Ki);
    }
    function rM(o, u) {
      var x = wr;
      wr |= Na;
      var D = Ik();
      if (ds !== o || Ko !== u) {
        if (aa) {
          var F = o.memoizedUpdaters;
          F.size > 0 && (V_(o, Ko), F.clear()), N0(o, u);
        }
        rf = Cp(), B_(), Xp(o, u);
      }
      ci(u);
      do
        try {
          iM();
          break;
        } catch (Z) {
          Nk(o, Z);
        }
      while (!0);
      return Qy(), Lk(D), wr = x, Ki !== null ? (Xr(), nf) : (yt(), ds = null, Ko = jt, Qo);
    }
    function iM() {
      for (; Ki !== null && !Nu(); )
        Mk(Ki);
    }
    function Mk(o) {
      var u = o.alternate;
      Or(o);
      var x;
      (o.mode & Un) !== vn ? (FS(o), x = jC(u, o, Jc), Tv(o, !0)) : x = jC(u, o, Jc), fi(), o.memoizedProps = o.pendingProps, x === null ? Pk(o) : Ki = x, wC.current = null;
    }
    function Pk(o) {
      var u = o;
      do {
        var x = u.alternate, D = u.return;
        if ((u.flags & co) === xn) {
          Or(u);
          var F = void 0;
          if ((u.mode & Un) === vn ? F = ok(x, u, Jc) : (FS(u), F = ok(x, u, Jc), Tv(u, !1)), fi(), F !== null) {
            Ki = F;
            return;
          }
        } else {
          var Z = JI(x, u);
          if (Z !== null) {
            Z.flags &= Vf, Ki = Z;
            return;
          }
          if ((u.mode & Un) !== vn) {
            Tv(u, !1);
            for (var de = u.actualDuration, ge = u.child; ge !== null; )
              de += ge.actualDuration, ge = ge.sibling;
            u.actualDuration = de;
          }
          if (D !== null)
            D.flags |= co, D.subtreeFlags = xn, D.deletions = null;
          else {
            Qo = xC, Ki = null;
            return;
          }
        }
        var xe = u.sibling;
        if (xe !== null) {
          Ki = xe;
          return;
        }
        u = D, Ki = u;
      } while (u !== null);
      Qo === nf && (Qo = Ck);
    }
    function Kp(o, u, x) {
      var D = Ms(), F = Ra.transition;
      try {
        Ra.transition = null, Fi(Yi), oM(o, u, x, D);
      } finally {
        Ra.transition = F, Fi(D);
      }
      return null;
    }
    function oM(o, u, x, D) {
      do
        af();
      while (Oh !== null);
      if (gM(), (wr & (Na | Jl)) !== Xo)
        throw new Error("Should not already be working.");
      var F = o.finishedWork, Z = o.finishedLanes;
      if (ml(Z), F === null)
        return jd(), null;
      if (Z === jt && s("root.finishedLanes should not be empty during a commit. This is a bug in React."), o.finishedWork = null, o.finishedLanes = jt, F === o.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      o.callbackNode = null, o.callbackPriority = M;
      var de = or(F.lanes, F.childLanes);
      $m(o, de), o === ds && (ds = null, Ki = null, Ko = jt), ((F.subtreeFlags & va) !== xn || (F.flags & va) !== xn) && (Yp || (Yp = !0, DC = x, UC(ls, function() {
        return af(), null;
      })));
      var ge = (F.subtreeFlags & (Du | Ho | fo | va)) !== xn, xe = (F.flags & (Du | Ho | fo | va)) !== xn;
      if (ge || xe) {
        var Le = Ra.transition;
        Ra.transition = null;
        var Ue = Ms();
        Fi(Yi);
        var st = wr;
        wr |= Jl, wC.current = null, iL(o, F), AA(), yL(o, F, Z), _R(o.containerInfo), o.current = F, Qf(Z), vL(F, o, Z), Gi(), Id(), wr = st, Fi(Ue), Ra.transition = Le;
      } else
        o.current = F, AA();
      var ot = Yp;
      if (Yp ? (Yp = !1, Oh = o, F_ = Z) : (Hg = 0, Bv = null), de = o.pendingLanes, de === jt && (Ug = null), ot || Uk(o.current, !1), Lc(F.stateNode, D), aa && o.memoizedUpdaters.clear(), BL(), qs(o, oi()), u !== null)
        for (var Et = o.onRecoverableError, wt = 0; wt < u.length; wt++) {
          var Dt = u[wt], tn = Dt.stack, Ln = Dt.digest;
          Et(Dt.value, {
            componentStack: tn,
            digest: Ln
          });
        }
      if (Pv) {
        Pv = !1;
        var Tn = kC;
        throw kC = null, Tn;
      }
      return Ga(F_, O) && o.tag !== vh && af(), de = o.pendingLanes, Ga(de, O) ? (cI(), o === RC ? U_++ : (U_ = 0, RC = o)) : U_ = 0, bh(), jd(), null;
    }
    function af() {
      if (Oh !== null) {
        var o = qo(F_), u = tE(ql, o), x = Ra.transition, D = Ms();
        try {
          return Ra.transition = null, Fi(u), sM();
        } finally {
          Fi(D), Ra.transition = x;
        }
      }
      return !1;
    }
    function aM(o) {
      OC.push(o), Yp || (Yp = !0, UC(ls, function() {
        return af(), null;
      }));
    }
    function sM() {
      if (Oh === null)
        return !1;
      var o = DC;
      DC = null;
      var u = Oh, x = F_;
      if (Oh = null, F_ = jt, (wr & (Na | Jl)) !== Xo)
        throw new Error("Cannot flush passive effects while already rendering.");
      NC = !0, jv = !1, zm(x);
      var D = wr;
      wr |= Jl, TL(u.current), SL(u, u.current, x, o);
      {
        var F = OC;
        OC = [];
        for (var Z = 0; Z < F.length; Z++) {
          var de = F[Z];
          lL(u, de);
        }
      }
      Pc(), Uk(u.current, !0), wr = D, bh(), jv ? u === Bv ? Hg++ : (Hg = 0, Bv = u) : Hg = 0, NC = !1, jv = !1, Va(u);
      {
        var ge = u.current.stateNode;
        ge.effectDuration = 0, ge.passiveEffectDuration = 0;
      }
      return !0;
    }
    function jk(o) {
      return Ug !== null && Ug.has(o);
    }
    function lM(o) {
      Ug === null ? Ug = /* @__PURE__ */ new Set([o]) : Ug.add(o);
    }
    function uM(o) {
      Pv || (Pv = !0, kC = o);
    }
    var cM = uM;
    function Bk(o, u, x) {
      var D = Gp(x, u), F = MA(o, D, O), Z = Sh(o, F, O), de = fs();
      Z !== null && (zd(Z, O, de), qs(Z, de));
    }
    function yi(o, u, x) {
      if (tL(x), q_(!1), o.tag === h) {
        Bk(o, o, x);
        return;
      }
      var D = null;
      for (D = u; D !== null; ) {
        if (D.tag === h) {
          Bk(D, o, x);
          return;
        } else if (D.tag === d) {
          var F = D.type, Z = D.stateNode;
          if (typeof F.getDerivedStateFromError == "function" || typeof Z.componentDidCatch == "function" && !jk(Z)) {
            var de = Gp(x, o), ge = rC(D, de, O), xe = Sh(D, ge, O), Le = fs();
            xe !== null && (zd(xe, O, Le), qs(xe, Le));
            return;
          }
        }
        D = D.return;
      }
      s(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, x);
    }
    function dM(o, u, x) {
      var D = o.pingCache;
      D !== null && D.delete(u);
      var F = fs();
      Wm(o, x), bM(o), ds === o && Hd(Ko, x) && (Qo === L_ || Qo === Iv && Y1(Ko) && oi() - AC < wk ? Xp(o, jt) : Mv = or(Mv, x)), qs(o, F);
    }
    function Fk(o, u) {
      u === M && (u = GL(o));
      var x = fs(), D = Hs(o, u);
      D !== null && (zd(D, u, x), qs(D, x));
    }
    function fM(o) {
      var u = o.memoizedState, x = M;
      u !== null && (x = u.retryLane), Fk(o, x);
    }
    function hM(o, u) {
      var x = M, D;
      switch (o.tag) {
        case A:
          D = o.stateNode;
          var F = o.memoizedState;
          F !== null && (x = F.retryLane);
          break;
        case U:
          D = o.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      D !== null && D.delete(u), Fk(o, x);
    }
    function pM(o) {
      return o < 120 ? 120 : o < 480 ? 480 : o < 1080 ? 1080 : o < 1920 ? 1920 : o < 3e3 ? 3e3 : o < 4320 ? 4320 : HL(o / 1960) * 1960;
    }
    function mM() {
      if (U_ > VL)
        throw U_ = 0, RC = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Hg > qL && (Hg = 0, Bv = null, s("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function gM() {
      Fu.flushLegacyContextWarning(), Fu.flushPendingUnsafeLifecycleWarnings();
    }
    function Uk(o, u) {
      Or(o), Vv(o, eo, ML), u && Vv(o, Os, PL), Vv(o, eo, IL), u && Vv(o, Os, LL), fi();
    }
    function Vv(o, u, x) {
      for (var D = o, F = null; D !== null; ) {
        var Z = D.subtreeFlags & u;
        D !== F && D.child !== null && Z !== xn ? D = D.child : ((D.flags & u) !== xn && x(D), D.sibling !== null ? D = D.sibling : D = F = D.return);
      }
    }
    var qv = null;
    function Hk(o) {
      {
        if ((wr & Na) !== Xo || !(o.mode & Sn))
          return;
        var u = o.tag;
        if (u !== f && u !== h && u !== d && u !== l && u !== y && u !== k && u !== N)
          return;
        var x = Yn(o) || "ReactComponent";
        if (qv !== null) {
          if (qv.has(x))
            return;
          qv.add(x);
        } else
          qv = /* @__PURE__ */ new Set([x]);
        var D = ni;
        try {
          Or(o), s("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          D ? Or(o) : fi();
        }
      }
    }
    var jC;
    {
      var _M = null;
      jC = function(o, u, x) {
        var D = Xk(_M, u);
        try {
          return ek(o, u, x);
        } catch (Z) {
          if (ON() || Z !== null && typeof Z == "object" && typeof Z.then == "function")
            throw Z;
          if (Qy(), nA(), ak(o, u), Xk(u, D), u.mode & Un && FS(u), Au(null, ek, null, o, u, x), T0()) {
            var F = pp();
            typeof F == "object" && F !== null && F._suppressLogging && typeof Z == "object" && Z !== null && !Z._suppressLogging && (Z._suppressLogging = !0);
          }
          throw Z;
        }
      };
    }
    var zk = !1, BC;
    BC = /* @__PURE__ */ new Set();
    function yM(o) {
      if (Po && !sI())
        switch (o.tag) {
          case l:
          case y:
          case N: {
            var u = Ki && Yn(Ki) || "Unknown", x = u;
            if (!BC.has(x)) {
              BC.add(x);
              var D = Yn(o) || "Unknown";
              s("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", D, u, u);
            }
            break;
          }
          case d: {
            zk || (s("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), zk = !0);
            break;
          }
        }
    }
    function V_(o, u) {
      if (aa) {
        var x = o.memoizedUpdaters;
        x.forEach(function(D) {
          Ym(o, D, u);
        });
      }
    }
    var FC = {};
    function UC(o, u) {
      {
        var x = $u.current;
        return x !== null ? (x.push(u), FC) : Nd(o, u);
      }
    }
    function Vk(o) {
      if (o !== FC)
        return $f(o);
    }
    function qk() {
      return $u.current !== null;
    }
    function vM(o) {
      {
        if (o.mode & Sn) {
          if (!Ek())
            return;
        } else if (!UL() || wr !== Xo || o.tag !== l && o.tag !== y && o.tag !== N)
          return;
        if ($u.current === null) {
          var u = ni;
          try {
            Or(o), s(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Yn(o));
          } finally {
            u ? Or(o) : fi();
          }
        }
      }
    }
    function bM(o) {
      o.tag !== vh && Ek() && $u.current === null && s(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function q_(o) {
      Ak = o;
    }
    var eu = null, zg = null, EM = function(o) {
      eu = o;
    };
    function Vg(o) {
      {
        if (eu === null)
          return o;
        var u = eu(o);
        return u === void 0 ? o : u.current;
      }
    }
    function HC(o) {
      return Vg(o);
    }
    function zC(o) {
      {
        if (eu === null)
          return o;
        var u = eu(o);
        if (u === void 0) {
          if (o != null && typeof o.render == "function") {
            var x = Vg(o.render);
            if (o.render !== x) {
              var D = {
                $$typeof: vo,
                render: x
              };
              return o.displayName !== void 0 && (D.displayName = o.displayName), D;
            }
          }
          return o;
        }
        return u.current;
      }
    }
    function Gk(o, u) {
      {
        if (eu === null)
          return !1;
        var x = o.elementType, D = u.type, F = !1, Z = typeof D == "object" && D !== null ? D.$$typeof : null;
        switch (o.tag) {
          case d: {
            typeof D == "function" && (F = !0);
            break;
          }
          case l: {
            (typeof D == "function" || Z === br) && (F = !0);
            break;
          }
          case y: {
            (Z === vo || Z === br) && (F = !0);
            break;
          }
          case k:
          case N: {
            (Z === sr || Z === br) && (F = !0);
            break;
          }
          default:
            return !1;
        }
        if (F) {
          var de = eu(x);
          if (de !== void 0 && de === eu(D))
            return !0;
        }
        return !1;
      }
    }
    function Wk(o) {
      {
        if (eu === null || typeof WeakSet != "function")
          return;
        zg === null && (zg = /* @__PURE__ */ new WeakSet()), zg.add(o);
      }
    }
    var SM = function(o, u) {
      {
        if (eu === null)
          return;
        var x = u.staleFamilies, D = u.updatedFamilies;
        af(), of(function() {
          VC(o.current, D, x);
        });
      }
    }, CM = function(o, u) {
      {
        if (o.context !== yl)
          return;
        af(), of(function() {
          G_(u, o, null, null);
        });
      }
    };
    function VC(o, u, x) {
      {
        var D = o.alternate, F = o.child, Z = o.sibling, de = o.tag, ge = o.type, xe = null;
        switch (de) {
          case l:
          case N:
          case d:
            xe = ge;
            break;
          case y:
            xe = ge.render;
            break;
        }
        if (eu === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var Le = !1, Ue = !1;
        if (xe !== null) {
          var st = eu(xe);
          st !== void 0 && (x.has(st) ? Ue = !0 : u.has(st) && (de === d ? Ue = !0 : Le = !0));
        }
        if (zg !== null && (zg.has(o) || D !== null && zg.has(D)) && (Ue = !0), Ue && (o._debugNeedsRemount = !0), Ue || Le) {
          var ot = Hs(o, O);
          ot !== null && Zo(ot, o, O, Gr);
        }
        F !== null && !Ue && VC(F, u, x), Z !== null && VC(Z, u, x);
      }
    }
    var wM = function(o, u) {
      {
        var x = /* @__PURE__ */ new Set(), D = new Set(u.map(function(F) {
          return F.current;
        }));
        return qC(o.current, D, x), x;
      }
    };
    function qC(o, u, x) {
      {
        var D = o.child, F = o.sibling, Z = o.tag, de = o.type, ge = null;
        switch (Z) {
          case l:
          case N:
          case d:
            ge = de;
            break;
          case y:
            ge = de.render;
            break;
        }
        var xe = !1;
        ge !== null && u.has(ge) && (xe = !0), xe ? xM(o, x) : D !== null && qC(D, u, x), F !== null && qC(F, u, x);
      }
    }
    function xM(o, u) {
      {
        var x = TM(o, u);
        if (x)
          return;
        for (var D = o; ; ) {
          switch (D.tag) {
            case g:
              u.add(D.stateNode);
              return;
            case p:
              u.add(D.stateNode.containerInfo);
              return;
            case h:
              u.add(D.stateNode.containerInfo);
              return;
          }
          if (D.return === null)
            throw new Error("Expected to reach root first.");
          D = D.return;
        }
      }
    }
    function TM(o, u) {
      for (var x = o, D = !1; ; ) {
        if (x.tag === g)
          D = !0, u.add(x.stateNode);
        else if (x.child !== null) {
          x.child.return = x, x = x.child;
          continue;
        }
        if (x === o)
          return D;
        for (; x.sibling === null; ) {
          if (x.return === null || x.return === o)
            return D;
          x = x.return;
        }
        x.sibling.return = x.return, x = x.sibling;
      }
      return !1;
    }
    var GC;
    {
      GC = !1;
      try {
        var $k = Object.preventExtensions({});
      } catch {
        GC = !0;
      }
    }
    function AM(o, u, x, D) {
      this.tag = o, this.key = x, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = u, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = D, this.flags = xn, this.subtreeFlags = xn, this.deletions = null, this.lanes = jt, this.childLanes = jt, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !GC && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var vl = function(o, u, x, D) {
      return new AM(o, u, x, D);
    };
    function WC(o) {
      var u = o.prototype;
      return !!(u && u.isReactComponent);
    }
    function kM(o) {
      return typeof o == "function" && !WC(o) && o.defaultProps === void 0;
    }
    function OM(o) {
      if (typeof o == "function")
        return WC(o) ? d : l;
      if (o != null) {
        var u = o.$$typeof;
        if (u === vo)
          return y;
        if (u === sr)
          return k;
      }
      return f;
    }
    function Qp(o, u) {
      var x = o.alternate;
      x === null ? (x = vl(o.tag, u, o.key, o.mode), x.elementType = o.elementType, x.type = o.type, x.stateNode = o.stateNode, x._debugSource = o._debugSource, x._debugOwner = o._debugOwner, x._debugHookTypes = o._debugHookTypes, x.alternate = o, o.alternate = x) : (x.pendingProps = u, x.type = o.type, x.flags = xn, x.subtreeFlags = xn, x.deletions = null, x.actualDuration = 0, x.actualStartTime = -1), x.flags = o.flags & to, x.childLanes = o.childLanes, x.lanes = o.lanes, x.child = o.child, x.memoizedProps = o.memoizedProps, x.memoizedState = o.memoizedState, x.updateQueue = o.updateQueue;
      var D = o.dependencies;
      switch (x.dependencies = D === null ? null : {
        lanes: D.lanes,
        firstContext: D.firstContext
      }, x.sibling = o.sibling, x.index = o.index, x.ref = o.ref, x.selfBaseDuration = o.selfBaseDuration, x.treeBaseDuration = o.treeBaseDuration, x._debugNeedsRemount = o._debugNeedsRemount, x.tag) {
        case f:
        case l:
        case N:
          x.type = Vg(o.type);
          break;
        case d:
          x.type = HC(o.type);
          break;
        case y:
          x.type = zC(o.type);
          break;
      }
      return x;
    }
    function DM(o, u) {
      o.flags &= to | Yr;
      var x = o.alternate;
      if (x === null)
        o.childLanes = jt, o.lanes = u, o.child = null, o.subtreeFlags = xn, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null, o.selfBaseDuration = 0, o.treeBaseDuration = 0;
      else {
        o.childLanes = x.childLanes, o.lanes = x.lanes, o.child = x.child, o.subtreeFlags = xn, o.deletions = null, o.memoizedProps = x.memoizedProps, o.memoizedState = x.memoizedState, o.updateQueue = x.updateQueue, o.type = x.type;
        var D = x.dependencies;
        o.dependencies = D === null ? null : {
          lanes: D.lanes,
          firstContext: D.firstContext
        }, o.selfBaseDuration = x.selfBaseDuration, o.treeBaseDuration = x.treeBaseDuration;
      }
      return o;
    }
    function RM(o, u, x) {
      var D;
      return o === Hy ? (D = Sn, u === !0 && (D |= lr, D |= Sa)) : D = vn, aa && (D |= Un), vl(h, null, null, D);
    }
    function $C(o, u, x, D, F, Z) {
      var de = f, ge = o;
      if (typeof o == "function")
        WC(o) ? (de = d, ge = HC(ge)) : ge = Vg(ge);
      else if (typeof o == "string")
        de = g;
      else
        e: switch (o) {
          case Kt:
            return Nh(x.children, F, Z, u);
          case Dn:
            de = v, F |= lr, (F & Sn) !== vn && (F |= Sa);
            break;
          case Kn:
            return NM(x, F, Z, u);
          case qr:
            return IM(x, F, Z, u);
          case _r:
            return LM(x, F, Z, u);
          case di:
            return Yk(x, F, Z, u);
          case Lo:
          case ao:
          case La:
          case Ai:
          case Zi:
          default: {
            if (typeof o == "object" && o !== null)
              switch (o.$$typeof) {
                case vr:
                  de = C;
                  break e;
                case Ii:
                  de = E;
                  break e;
                case vo:
                  de = y, ge = zC(ge);
                  break e;
                case sr:
                  de = k;
                  break e;
                case br:
                  de = j, ge = null;
                  break e;
              }
            var xe = "";
            {
              (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var Le = D ? Yn(D) : null;
              Le && (xe += `

Check the render method of \`` + Le + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (o == null ? o : typeof o) + "." + xe));
          }
        }
      var Ue = vl(de, x, u, F);
      return Ue.elementType = o, Ue.type = ge, Ue.lanes = Z, Ue._debugOwner = D, Ue;
    }
    function YC(o, u, x) {
      var D = null;
      D = o._owner;
      var F = o.type, Z = o.key, de = o.props, ge = $C(F, Z, de, D, u, x);
      return ge._debugSource = o._source, ge._debugOwner = o._owner, ge;
    }
    function Nh(o, u, x, D) {
      var F = vl(b, o, D, u);
      return F.lanes = x, F;
    }
    function NM(o, u, x, D) {
      typeof o.id != "string" && s('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof o.id);
      var F = vl(T, o, D, u | Un);
      return F.elementType = Kn, F.lanes = x, F.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, F;
    }
    function IM(o, u, x, D) {
      var F = vl(A, o, D, u);
      return F.elementType = qr, F.lanes = x, F;
    }
    function LM(o, u, x, D) {
      var F = vl(U, o, D, u);
      return F.elementType = _r, F.lanes = x, F;
    }
    function Yk(o, u, x, D) {
      var F = vl(Q, o, D, u);
      F.elementType = di, F.lanes = x;
      var Z = {
        isHidden: !1
      };
      return F.stateNode = Z, F;
    }
    function XC(o, u, x) {
      var D = vl(_, o, null, u);
      return D.lanes = x, D;
    }
    function MM() {
      var o = vl(g, null, null, vn);
      return o.elementType = "DELETED", o;
    }
    function PM(o) {
      var u = vl(B, null, null, vn);
      return u.stateNode = o, u;
    }
    function KC(o, u, x) {
      var D = o.children !== null ? o.children : [], F = vl(p, D, o.key, u);
      return F.lanes = x, F.stateNode = {
        containerInfo: o.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: o.implementation
      }, F;
    }
    function Xk(o, u) {
      return o === null && (o = vl(f, null, null, vn)), o.tag = u.tag, o.key = u.key, o.elementType = u.elementType, o.type = u.type, o.stateNode = u.stateNode, o.return = u.return, o.child = u.child, o.sibling = u.sibling, o.index = u.index, o.ref = u.ref, o.pendingProps = u.pendingProps, o.memoizedProps = u.memoizedProps, o.updateQueue = u.updateQueue, o.memoizedState = u.memoizedState, o.dependencies = u.dependencies, o.mode = u.mode, o.flags = u.flags, o.subtreeFlags = u.subtreeFlags, o.deletions = u.deletions, o.lanes = u.lanes, o.childLanes = u.childLanes, o.alternate = u.alternate, o.actualDuration = u.actualDuration, o.actualStartTime = u.actualStartTime, o.selfBaseDuration = u.selfBaseDuration, o.treeBaseDuration = u.treeBaseDuration, o._debugSource = u._debugSource, o._debugOwner = u._debugOwner, o._debugNeedsRemount = u._debugNeedsRemount, o._debugHookTypes = u._debugHookTypes, o;
    }
    function jM(o, u, x, D, F) {
      this.tag = u, this.containerInfo = o, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = RE, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = M, this.eventTimes = Sp(jt), this.expirationTimes = Sp(Gr), this.pendingLanes = jt, this.suspendedLanes = jt, this.pingedLanes = jt, this.expiredLanes = jt, this.mutableReadLanes = jt, this.finishedLanes = jt, this.entangledLanes = jt, this.entanglements = Sp(jt), this.identifierPrefix = D, this.onRecoverableError = F, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var Z = this.pendingUpdatersLaneMap = [], de = 0; de < Fd; de++)
          Z.push(/* @__PURE__ */ new Set());
      }
      switch (u) {
        case Hy:
          this._debugRootType = x ? "hydrateRoot()" : "createRoot()";
          break;
        case vh:
          this._debugRootType = x ? "hydrate()" : "render()";
          break;
      }
    }
    function Kk(o, u, x, D, F, Z, de, ge, xe, Le) {
      var Ue = new jM(o, u, x, ge, xe), st = RM(u, Z);
      Ue.current = st, st.stateNode = Ue;
      {
        var ot = {
          element: D,
          isDehydrated: x,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        st.memoizedState = ot;
      }
      return uS(st), Ue;
    }
    var QC = "18.3.1";
    function BM(o, u, x) {
      var D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Ze(D), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: En,
        key: D == null ? null : "" + D,
        children: o,
        containerInfo: u,
        implementation: x
      };
    }
    var ZC, JC;
    ZC = !1, JC = {};
    function Qk(o) {
      if (!o)
        return yl;
      var u = Ua(o), x = bN(u);
      if (u.tag === d) {
        var D = u.type;
        if (Wc(D))
          return w5(u, D, x);
      }
      return x;
    }
    function FM(o, u) {
      {
        var x = Ua(o);
        if (x === void 0) {
          if (typeof o.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var D = Object.keys(o).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + D);
        }
        var F = Co(x);
        if (F === null)
          return null;
        if (F.mode & lr) {
          var Z = Yn(x) || "Component";
          if (!JC[Z]) {
            JC[Z] = !0;
            var de = ni;
            try {
              Or(F), x.mode & lr ? s("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", u, u, Z) : s("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", u, u, Z);
            } finally {
              de ? Or(de) : fi();
            }
          }
        }
        return F.stateNode;
      }
    }
    function Zk(o, u, x, D, F, Z, de, ge) {
      var xe = !1, Le = null;
      return Kk(o, u, xe, Le, x, D, F, Z, de);
    }
    function Jk(o, u, x, D, F, Z, de, ge, xe, Le) {
      var Ue = !0, st = Kk(x, D, Ue, o, F, Z, de, ge, xe);
      st.context = Qk(null);
      var ot = st.current, Et = fs(), wt = Dh(ot), Dt = ef(Et, wt);
      return Dt.callback = u ?? null, Sh(ot, Dt, wt), WL(st, wt, Et), st;
    }
    function G_(o, u, x, D) {
      Xf(u, o);
      var F = u.current, Z = fs(), de = Dh(F);
      Ve(de);
      var ge = Qk(x);
      u.context === null ? u.context = ge : u.pendingContext = ge, Po && ni !== null && !ZC && (ZC = !0, s(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Yn(ni) || "Unknown"));
      var xe = ef(Z, de);
      xe.payload = {
        element: o
      }, D = D === void 0 ? null : D, D !== null && (typeof D != "function" && s("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", D), xe.callback = D);
      var Le = Sh(F, xe, de);
      return Le !== null && (Zo(Le, F, de, Z), nv(Le, F, de)), de;
    }
    function Gv(o) {
      var u = o.current;
      if (!u.child)
        return null;
      switch (u.child.tag) {
        case g:
          return u.child.stateNode;
        default:
          return u.child.stateNode;
      }
    }
    function UM(o) {
      switch (o.tag) {
        case h: {
          var u = o.stateNode;
          if (Xm(u)) {
            var x = k0(u);
            KL(u, x);
          }
          break;
        }
        case A: {
          of(function() {
            var F = Hs(o, O);
            if (F !== null) {
              var Z = fs();
              Zo(F, o, O, Z);
            }
          });
          var D = O;
          ew(o, D);
          break;
        }
      }
    }
    function e3(o, u) {
      var x = o.memoizedState;
      x !== null && x.dehydrated !== null && (x.retryLane = J1(x.retryLane, u));
    }
    function ew(o, u) {
      e3(o, u);
      var x = o.alternate;
      x && e3(x, u);
    }
    function HM(o) {
      if (o.tag === A) {
        var u = la, x = Hs(o, u);
        if (x !== null) {
          var D = fs();
          Zo(x, o, u, D);
        }
        ew(o, u);
      }
    }
    function zM(o) {
      if (o.tag === A) {
        var u = Dh(o), x = Hs(o, u);
        if (x !== null) {
          var D = fs();
          Zo(x, o, u, D);
        }
        ew(o, u);
      }
    }
    function t3(o) {
      var u = mp(o);
      return u === null ? null : u.stateNode;
    }
    var n3 = function(o) {
      return null;
    };
    function VM(o) {
      return n3(o);
    }
    var r3 = function(o) {
      return !1;
    };
    function qM(o) {
      return r3(o);
    }
    var i3 = null, o3 = null, a3 = null, s3 = null, l3 = null, u3 = null, c3 = null, d3 = null, f3 = null;
    {
      var h3 = function(o, u, x) {
        var D = u[x], F = Pi(o) ? o.slice() : Qn({}, o);
        return x + 1 === u.length ? (Pi(F) ? F.splice(D, 1) : delete F[D], F) : (F[D] = h3(o[D], u, x + 1), F);
      }, p3 = function(o, u) {
        return h3(o, u, 0);
      }, m3 = function(o, u, x, D) {
        var F = u[D], Z = Pi(o) ? o.slice() : Qn({}, o);
        if (D + 1 === u.length) {
          var de = x[D];
          Z[de] = Z[F], Pi(Z) ? Z.splice(F, 1) : delete Z[F];
        } else
          Z[F] = m3(
            // $FlowFixMe number or string is fine here
            o[F],
            u,
            x,
            D + 1
          );
        return Z;
      }, g3 = function(o, u, x) {
        if (u.length !== x.length) {
          a("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var D = 0; D < x.length - 1; D++)
            if (u[D] !== x[D]) {
              a("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return m3(o, u, x, 0);
      }, _3 = function(o, u, x, D) {
        if (x >= u.length)
          return D;
        var F = u[x], Z = Pi(o) ? o.slice() : Qn({}, o);
        return Z[F] = _3(o[F], u, x + 1, D), Z;
      }, y3 = function(o, u, x) {
        return _3(o, u, 0, x);
      }, tw = function(o, u) {
        for (var x = o.memoizedState; x !== null && u > 0; )
          x = x.next, u--;
        return x;
      };
      i3 = function(o, u, x, D) {
        var F = tw(o, u);
        if (F !== null) {
          var Z = y3(F.memoizedState, x, D);
          F.memoizedState = Z, F.baseState = Z, o.memoizedProps = Qn({}, o.memoizedProps);
          var de = Hs(o, O);
          de !== null && Zo(de, o, O, Gr);
        }
      }, o3 = function(o, u, x) {
        var D = tw(o, u);
        if (D !== null) {
          var F = p3(D.memoizedState, x);
          D.memoizedState = F, D.baseState = F, o.memoizedProps = Qn({}, o.memoizedProps);
          var Z = Hs(o, O);
          Z !== null && Zo(Z, o, O, Gr);
        }
      }, a3 = function(o, u, x, D) {
        var F = tw(o, u);
        if (F !== null) {
          var Z = g3(F.memoizedState, x, D);
          F.memoizedState = Z, F.baseState = Z, o.memoizedProps = Qn({}, o.memoizedProps);
          var de = Hs(o, O);
          de !== null && Zo(de, o, O, Gr);
        }
      }, s3 = function(o, u, x) {
        o.pendingProps = y3(o.memoizedProps, u, x), o.alternate && (o.alternate.pendingProps = o.pendingProps);
        var D = Hs(o, O);
        D !== null && Zo(D, o, O, Gr);
      }, l3 = function(o, u) {
        o.pendingProps = p3(o.memoizedProps, u), o.alternate && (o.alternate.pendingProps = o.pendingProps);
        var x = Hs(o, O);
        x !== null && Zo(x, o, O, Gr);
      }, u3 = function(o, u, x) {
        o.pendingProps = g3(o.memoizedProps, u, x), o.alternate && (o.alternate.pendingProps = o.pendingProps);
        var D = Hs(o, O);
        D !== null && Zo(D, o, O, Gr);
      }, c3 = function(o) {
        var u = Hs(o, O);
        u !== null && Zo(u, o, O, Gr);
      }, d3 = function(o) {
        n3 = o;
      }, f3 = function(o) {
        r3 = o;
      };
    }
    function GM(o) {
      var u = Co(o);
      return u === null ? null : u.stateNode;
    }
    function WM(o) {
      return null;
    }
    function $M() {
      return ni;
    }
    function YM(o) {
      var u = o.findFiberByHostInstance, x = t.ReactCurrentDispatcher;
      return Yf({
        bundleType: o.bundleType,
        version: o.version,
        rendererPackageName: o.rendererPackageName,
        rendererConfig: o.rendererConfig,
        overrideHookState: i3,
        overrideHookStateDeletePath: o3,
        overrideHookStateRenamePath: a3,
        overrideProps: s3,
        overridePropsDeletePath: l3,
        overridePropsRenamePath: u3,
        setErrorHandler: d3,
        setSuspenseHandler: f3,
        scheduleUpdate: c3,
        currentDispatcherRef: x,
        findHostInstanceByFiber: GM,
        findFiberByHostInstance: u || WM,
        // React Refresh
        findHostInstancesForRefresh: wM,
        scheduleRefresh: SM,
        scheduleRoot: CM,
        setRefreshHandler: EM,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: $M,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: QC
      });
    }
    var v3 = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(o) {
      console.error(o);
    };
    function nw(o) {
      this._internalRoot = o;
    }
    Wv.prototype.render = nw.prototype.render = function(o) {
      var u = this._internalRoot;
      if (u === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? s("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : $v(arguments[1]) ? s("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && s("You passed a second argument to root.render(...) but it only accepts one argument.");
        var x = u.containerInfo;
        if (x.nodeType !== pi) {
          var D = t3(u.current);
          D && D.parentNode !== x && s("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      G_(o, u, null, null);
    }, Wv.prototype.unmount = nw.prototype.unmount = function() {
      typeof arguments[0] == "function" && s("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var o = this._internalRoot;
      if (o !== null) {
        this._internalRoot = null;
        var u = o.containerInfo;
        Rk() && s("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), of(function() {
          G_(null, o, null, null);
        }), v5(u);
      }
    };
    function XM(o, u) {
      if (!$v(o))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      b3(o);
      var x = !1, D = !1, F = "", Z = v3;
      u != null && (u.hydrate ? a("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof u == "object" && u !== null && u.$$typeof === Vn && s(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), u.unstable_strictMode === !0 && (x = !0), u.identifierPrefix !== void 0 && (F = u.identifierPrefix), u.onRecoverableError !== void 0 && (Z = u.onRecoverableError), u.transitionCallbacks !== void 0 && u.transitionCallbacks);
      var de = Zk(o, Hy, null, x, D, F, Z);
      Ly(de.current, o);
      var ge = o.nodeType === pi ? o.parentNode : o;
      return Q0(ge), new nw(de);
    }
    function Wv(o) {
      this._internalRoot = o;
    }
    function KM(o) {
      o && iE(o);
    }
    Wv.prototype.unstable_scheduleHydration = KM;
    function QM(o, u, x) {
      if (!$v(o))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      b3(o), u === void 0 && s("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var D = x ?? null, F = x != null && x.hydratedSources || null, Z = !1, de = !1, ge = "", xe = v3;
      x != null && (x.unstable_strictMode === !0 && (Z = !0), x.identifierPrefix !== void 0 && (ge = x.identifierPrefix), x.onRecoverableError !== void 0 && (xe = x.onRecoverableError));
      var Le = Jk(u, null, o, Hy, D, Z, de, ge, xe);
      if (Ly(Le.current, o), Q0(o), F)
        for (var Ue = 0; Ue < F.length; Ue++) {
          var st = F[Ue];
          tI(Le, st);
        }
      return new Wv(Le);
    }
    function $v(o) {
      return !!(o && (o.nodeType === uo || o.nodeType === ga || o.nodeType === rl || !J));
    }
    function W_(o) {
      return !!(o && (o.nodeType === uo || o.nodeType === ga || o.nodeType === rl || o.nodeType === pi && o.nodeValue === " react-mount-point-unstable "));
    }
    function b3(o) {
      o.nodeType === uo && o.tagName && o.tagName.toUpperCase() === "BODY" && s("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), l_(o) && (o._reactRootContainer ? s("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : s("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var ZM = t.ReactCurrentOwner, E3;
    E3 = function(o) {
      if (o._reactRootContainer && o.nodeType !== pi) {
        var u = t3(o._reactRootContainer.current);
        u && u.parentNode !== o && s("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var x = !!o._reactRootContainer, D = rw(o), F = !!(D && _h(D));
      F && !x && s("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), o.nodeType === uo && o.tagName && o.tagName.toUpperCase() === "BODY" && s("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function rw(o) {
      return o ? o.nodeType === ga ? o.documentElement : o.firstChild : null;
    }
    function S3() {
    }
    function JM(o, u, x, D, F) {
      if (F) {
        if (typeof D == "function") {
          var Z = D;
          D = function() {
            var ot = Gv(de);
            Z.call(ot);
          };
        }
        var de = Jk(
          u,
          D,
          o,
          vh,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          S3
        );
        o._reactRootContainer = de, Ly(de.current, o);
        var ge = o.nodeType === pi ? o.parentNode : o;
        return Q0(ge), of(), de;
      } else {
        for (var xe; xe = o.lastChild; )
          o.removeChild(xe);
        if (typeof D == "function") {
          var Le = D;
          D = function() {
            var ot = Gv(Ue);
            Le.call(ot);
          };
        }
        var Ue = Zk(
          o,
          vh,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          S3
        );
        o._reactRootContainer = Ue, Ly(Ue.current, o);
        var st = o.nodeType === pi ? o.parentNode : o;
        return Q0(st), of(function() {
          G_(u, Ue, x, D);
        }), Ue;
      }
    }
    function eP(o, u) {
      o !== null && typeof o != "function" && s("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u, o);
    }
    function Yv(o, u, x, D, F) {
      E3(x), eP(F === void 0 ? null : F, "render");
      var Z = x._reactRootContainer, de;
      if (!Z)
        de = JM(x, u, o, F, D);
      else {
        if (de = Z, typeof F == "function") {
          var ge = F;
          F = function() {
            var xe = Gv(de);
            ge.call(xe);
          };
        }
        G_(u, de, o, F);
      }
      return Gv(de);
    }
    var C3 = !1;
    function tP(o) {
      {
        C3 || (C3 = !0, s("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var u = ZM.current;
        if (u !== null && u.stateNode !== null) {
          var x = u.stateNode._warnedAboutRefsInRender;
          x || s("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", ur(u.type) || "A component"), u.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return o == null ? null : o.nodeType === uo ? o : FM(o, "findDOMNode");
    }
    function nP(o, u, x) {
      if (s("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !W_(u))
        throw new Error("Target container is not a DOM element.");
      {
        var D = l_(u) && u._reactRootContainer === void 0;
        D && s("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Yv(null, o, u, !0, x);
    }
    function rP(o, u, x) {
      if (s("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !W_(u))
        throw new Error("Target container is not a DOM element.");
      {
        var D = l_(u) && u._reactRootContainer === void 0;
        D && s("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Yv(null, o, u, !1, x);
    }
    function iP(o, u, x, D) {
      if (s("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !W_(x))
        throw new Error("Target container is not a DOM element.");
      if (o == null || !Rc(o))
        throw new Error("parentComponent must be a valid React Component");
      return Yv(o, u, x, !1, D);
    }
    var w3 = !1;
    function oP(o) {
      if (w3 || (w3 = !0, s("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !W_(o))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var u = l_(o) && o._reactRootContainer === void 0;
        u && s("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (o._reactRootContainer) {
        {
          var x = rw(o), D = x && !_h(x);
          D && s("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return of(function() {
          Yv(null, null, o, !1, function() {
            o._reactRootContainer = null, v5(o);
          });
        }), !0;
      } else {
        {
          var F = rw(o), Z = !!(F && _h(F)), de = o.nodeType === uo && W_(o.parentNode) && !!o.parentNode._reactRootContainer;
          Z && s("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", de ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    rh(UM), nE(HM), Qm(zM), ny(Ms), ry(ua), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && s("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), kd(sR), Rd(LC, QL, of);
    function aP(o, u) {
      var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!$v(u))
        throw new Error("Target container is not a DOM element.");
      return BM(o, u, null, x);
    }
    function sP(o, u, x, D) {
      return iP(o, u, x, D);
    }
    var iw = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [_h, bg, My, Ff, Dd, LC]
    };
    function lP(o, u) {
      return iw.usingClientEntryPoint || s('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), XM(o, u);
    }
    function uP(o, u, x) {
      return iw.usingClientEntryPoint || s('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), QM(o, u, x);
    }
    function cP(o) {
      return Rk() && s("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), of(o);
    }
    var dP = YM({
      findFiberByHostInstance: Pp,
      bundleType: 1,
      version: QC,
      rendererPackageName: "react-dom"
    });
    if (!dP && we && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var x3 = window.location.protocol;
      /^(https?|file):$/.test(x3) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (x3 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Ws.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = iw, Ws.createPortal = aP, Ws.createRoot = lP, Ws.findDOMNode = tP, Ws.flushSync = cP, Ws.hydrate = nP, Ws.hydrateRoot = uP, Ws.render = rP, Ws.unmountComponentAtNode = oP, Ws.unstable_batchedUpdates = LC, Ws.unstable_renderSubtreeIntoContainer = sP, Ws.version = QC, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ws;
}
function A7() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(A7);
    } catch (n) {
      console.error(n);
    }
  }
}
process.env.NODE_ENV === "production" ? (A7(), tx.exports = hV()) : tx.exports = pV();
var om = tx.exports;
const mV = "_h1_shyur_1", gV = "_h2_shyur_2", _V = "_h3_shyur_3", yV = "_h4_shyur_4", vV = "_h5_shyur_5", bV = "_h6_shyur_6", EV = "_lead_shyur_120", SV = "_p_shyur_121", CV = "_small_shyur_122", wV = "_xs_shyur_246", k7 = {
  h1: mV,
  h2: gV,
  h3: _V,
  h4: yV,
  h5: vV,
  h6: bV,
  "h1--noMargin": "_h1--noMargin_shyur_29",
  "h2--noMargin": "_h2--noMargin_shyur_30",
  "h3--noMargin": "_h3--noMargin_shyur_31",
  "h4--noMargin": "_h4--noMargin_shyur_32",
  "h5--noMargin": "_h5--noMargin_shyur_33",
  "h6--noMargin": "_h6--noMargin_shyur_34",
  "h1--color-primary": "_h1--color-primary_shyur_37",
  "h1--color-info": "_h1--color-info_shyur_37",
  "h2--color-primary": "_h2--color-primary_shyur_38",
  "h2--color-info": "_h2--color-info_shyur_39",
  "h3--color-primary": "_h3--color-primary_shyur_40",
  "h3--color-info": "_h3--color-info_shyur_41",
  "h4--color-primary": "_h4--color-primary_shyur_42",
  "h4--color-info": "_h4--color-info_shyur_43",
  "h5--color-primary": "_h5--color-primary_shyur_44",
  "h5--color-info": "_h5--color-info_shyur_45",
  "h6--color-primary": "_h6--color-primary_shyur_46",
  "h6--color-info": "_h6--color-info_shyur_47",
  "h1--color-secondary": "_h1--color-secondary_shyur_50",
  "h1--color-success": "_h1--color-success_shyur_50",
  "h2--color-secondary": "_h2--color-secondary_shyur_51",
  "h2--color-success": "_h2--color-success_shyur_52",
  "h3--color-secondary": "_h3--color-secondary_shyur_53",
  "h3--color-success": "_h3--color-success_shyur_54",
  "h4--color-secondary": "_h4--color-secondary_shyur_55",
  "h4--color-success": "_h4--color-success_shyur_56",
  "h5--color-secondary": "_h5--color-secondary_shyur_57",
  "h5--color-success": "_h5--color-success_shyur_58",
  "h6--color-secondary": "_h6--color-secondary_shyur_59",
  "h6--color-success": "_h6--color-success_shyur_60",
  "h1--color-warning": "_h1--color-warning_shyur_63",
  "h2--color-warning": "_h2--color-warning_shyur_64",
  "h3--color-warning": "_h3--color-warning_shyur_65",
  "h4--color-warning": "_h4--color-warning_shyur_66",
  "h5--color-warning": "_h5--color-warning_shyur_67",
  "h6--color-warning": "_h6--color-warning_shyur_68",
  "h1--color-error": "_h1--color-error_shyur_71",
  "h2--color-error": "_h2--color-error_shyur_72",
  "h3--color-error": "_h3--color-error_shyur_73",
  "h4--color-error": "_h4--color-error_shyur_74",
  "h5--color-error": "_h5--color-error_shyur_75",
  "h6--color-error": "_h6--color-error_shyur_76",
  "h1--color-subtle": "_h1--color-subtle_shyur_79",
  "h2--color-subtle": "_h2--color-subtle_shyur_80",
  "h3--color-subtle": "_h3--color-subtle_shyur_81",
  "h4--color-subtle": "_h4--color-subtle_shyur_82",
  "h5--color-subtle": "_h5--color-subtle_shyur_83",
  "h6--color-subtle": "_h6--color-subtle_shyur_84",
  "h1--align-center": "_h1--align-center_shyur_87",
  "h2--align-center": "_h2--align-center_shyur_88",
  "h3--align-center": "_h3--align-center_shyur_89",
  "h4--align-center": "_h4--align-center_shyur_90",
  "h5--align-center": "_h5--align-center_shyur_91",
  "h6--align-center": "_h6--align-center_shyur_92",
  "h1--align-right": "_h1--align-right_shyur_95",
  "h2--align-right": "_h2--align-right_shyur_96",
  "h3--align-right": "_h3--align-right_shyur_97",
  "h4--align-right": "_h4--align-right_shyur_98",
  "h5--align-right": "_h5--align-right_shyur_99",
  "h6--align-right": "_h6--align-right_shyur_100",
  "h1--align-left": "_h1--align-left_shyur_103",
  "h2--align-left": "_h2--align-left_shyur_104",
  "h3--align-left": "_h3--align-left_shyur_105",
  "h4--align-left": "_h4--align-left_shyur_106",
  "h5--align-left": "_h5--align-left_shyur_107",
  "h6--align-left": "_h6--align-left_shyur_108",
  "h1--mono": "_h1--mono_shyur_111",
  "h2--mono": "_h2--mono_shyur_112",
  "h3--mono": "_h3--mono_shyur_113",
  "h4--mono": "_h4--mono_shyur_114",
  "h5--mono": "_h5--mono_shyur_115",
  "h6--mono": "_h6--mono_shyur_116",
  lead: EV,
  p: SV,
  small: CV,
  "lead--noMargin": "_lead--noMargin_shyur_141",
  "p--noMargin": "_p--noMargin_shyur_142",
  "small--noMargin": "_small--noMargin_shyur_143",
  "lead--color-primary": "_lead--color-primary_shyur_146",
  "lead--color-info": "_lead--color-info_shyur_146",
  "p--color-primary": "_p--color-primary_shyur_147",
  "p--color-info": "_p--color-info_shyur_148",
  "small--color-primary": "_small--color-primary_shyur_149",
  "small--color-info": "_small--color-info_shyur_150",
  "lead--color-secondary": "_lead--color-secondary_shyur_153",
  "lead--color-success": "_lead--color-success_shyur_153",
  "p--color-secondary": "_p--color-secondary_shyur_154",
  "p--color-success": "_p--color-success_shyur_155",
  "small--color-secondary": "_small--color-secondary_shyur_156",
  "small--color-success": "_small--color-success_shyur_157",
  "lead--color-warning": "_lead--color-warning_shyur_160",
  "p--color-warning": "_p--color-warning_shyur_161",
  "small--color-warning": "_small--color-warning_shyur_162",
  "lead--color-error": "_lead--color-error_shyur_165",
  "p--color-error": "_p--color-error_shyur_166",
  "small--color-error": "_small--color-error_shyur_167",
  "lead--color-subtle": "_lead--color-subtle_shyur_170",
  "p--color-subtle": "_p--color-subtle_shyur_171",
  "small--color-subtle": "_small--color-subtle_shyur_172",
  "lead--align-center": "_lead--align-center_shyur_175",
  "p--align-center": "_p--align-center_shyur_176",
  "small--align-center": "_small--align-center_shyur_177",
  "lead--align-right": "_lead--align-right_shyur_180",
  "p--align-right": "_p--align-right_shyur_181",
  "small--align-right": "_small--align-right_shyur_182",
  "lead--align-left": "_lead--align-left_shyur_185",
  "p--align-left": "_p--align-left_shyur_186",
  "small--align-left": "_small--align-left_shyur_187",
  "lead--mono": "_lead--mono_shyur_190",
  "p--mono": "_p--mono_shyur_191",
  "small--mono": "_small--mono_shyur_192",
  "hero-xl": "_hero-xl_shyur_196",
  "hero-lg": "_hero-lg_shyur_200",
  xs: wV,
  "margin-0": "_margin-0_shyur_252",
  "margin-1": "_margin-1_shyur_257",
  "margin-2": "_margin-2_shyur_262",
  "margin-3": "_margin-3_shyur_267",
  "margin-4": "_margin-4_shyur_272",
  "margin-5": "_margin-5_shyur_277",
  "margin-6": "_margin-6_shyur_282",
  "margin-7": "_margin-7_shyur_287",
  "margin-8": "_margin-8_shyur_292",
  "margin-9": "_margin-9_shyur_297",
  "margin-10": "_margin-10_shyur_302"
}, a0 = (n) => {
  const {
    variant: e,
    children: t,
    component: i,
    badge: c,
    badgeColor: a,
    noMargin: s,
    color: r,
    textAlign: l,
    mono: d
  } = n;
  let f = "small", h = i ?? e;
  switch (e === "lead" && (h = "p"), e) {
    case "h1":
    case "h2":
      f = "normal";
      break;
    case "h3":
      f = "small";
      break;
  }
  return /* @__PURE__ */ Mt(
    TV,
    {
      htmlElement: h,
      className: k7[e],
      noMargin: s,
      variant: e,
      color: r,
      textAlign: l,
      mono: d,
      children: [
        t,
        c && /* @__PURE__ */ Re(
          vm,
          {
            size: f,
            marginLeft: !0,
            content: c,
            color: a
          }
        )
      ]
    }
  );
}, xV = Mn.bind(k7), TV = (n) => {
  const {
    htmlElement: e,
    children: t,
    className: i,
    noMargin: c,
    variant: a,
    textAlign: s,
    color: r,
    mono: l
  } = n, d = [
    i,
    {
      [`${a}--noMargin`]: c,
      [`${a}--color-${r}`]: !!r,
      [`${a}--align-${s}`]: !!s,
      [`${a}--mono`]: l
    }
  ];
  return su(e, { className: xV(d) }, t);
}, AV = "_eventCard_xftp8_11", kV = "_popIn_xftp8_1", OV = "_eventCard__image_xftp8_37", DV = "_eventCard__imageBanner_xftp8_47", RV = "_eventCard__imageLogoWrapper_xftp8_56", NV = "_eventCard__imageLogo_xftp8_56", IV = "_eventCard__imageIcon_xftp8_73", LV = "_eventCard__info_xftp8_92", MV = "_eventCard__infoText_xftp8_103", PV = "_eventCard__infoBadge_xftp8_126", nd = {
  eventCard: AV,
  "eventCard--clickable": "_eventCard--clickable_xftp8_21",
  "eventCard--popIn": "_eventCard--popIn_xftp8_24",
  popIn: kV,
  eventCard__image: OV,
  eventCard__imageBanner: DV,
  eventCard__imageLogoWrapper: RV,
  eventCard__imageLogo: NV,
  eventCard__imageIcon: IV,
  eventCard__info: LV,
  eventCard__infoText: MV,
  eventCard__infoBadge: PV
}, jV = "_eventIcon_1ohmm_1", Ci = {
  eventIcon: jV
}, BV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M14,19h-1.786l-0.021-0.022C11.589,18.336,10.331,17,8,17H5v-0.5C5,16.224,4.776,16,4.5,16h-4C0.224,16,0,16.224,0,16.5 v7C0,23.776,0.224,24,0.5,24h4C4.776,24,5,23.776,5,23.5V23h16.5c0.276,0,0.5-0.224,0.5-0.5C22,20.438,17.784,19,14,19z M4,23H1 v-6h3V23z M5,22v-4h3c1.289,0,2.165,0.498,2.77,1H7c-0.276,0-0.5,0.224-0.5,0.5S6.724,20,7,20h7c3.36,0,6.021,1.074,6.781,2H5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.708,15.906C17.795,15.969,17.897,16,18,16s0.205-0.031,0.292-0.094C18.525,15.738,24,11.76,24,8.607 c0-2.062-1.442-3.314-2.868-3.485C20.104,5.001,18.792,5.42,18,6.863c-0.792-1.442-2.101-1.861-3.132-1.741 C13.442,5.293,12,6.545,12,8.607C12,11.76,17.475,15.738,17.708,15.906z M14.987,6.115c0.076-0.01,0.153-0.014,0.232-0.014 c0.88,0,1.883,0.592,2.294,2.284c0.109,0.448,0.863,0.448,0.973,0c0.448-1.845,1.6-2.378,2.526-2.271C22,6.233,23,7.127,23,8.607 c0,2.061-3.371,5.038-5,6.271c-1.629-1.232-5-4.208-5-6.271C13,7.127,14,6.233,14.987,6.115z" })))), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), FV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("path", { d: "M13.5,0h-3C7.467,0,5,2.468,5,5.5v7c0,3.032,2.467,5.5,5.5,5.5H12v1.051c-2.244,0.252-4,2.139-4,4.449 C8,23.776,8.224,24,8.5,24h8c0.007,0,0.013,0,0.02,0c0.276,0,0.5-0.224,0.5-0.5c0-0.052-0.008-0.102-0.022-0.148 c-0.073-2.243-1.802-4.055-3.998-4.302V18h0.5c3.033,0,5.5-2.468,5.5-5.5v-7C19,2.468,16.533,0,13.5,0z M15.964,23H9.036 c0.243-1.694,1.704-3,3.464-3S15.721,21.306,15.964,23z M13.5,17H13v-1.051c1.14-0.232,2-1.242,2-2.449c0-1.379-1.122-2.5-2.5-2.5 S10,12.121,10,13.5c0,1.207,0.86,2.217,2,2.449V17h-1.5C8.019,17,6,14.981,6,12.5V10h5.5c0.276,0,0.5-0.224,0.5-0.5 S11.776,9,11.5,9H6V8h5.5C11.776,8,12,7.776,12,7.5S11.776,7,11.5,7H6V6h5.5C11.776,6,12,5.776,12,5.5S11.776,5,11.5,5H6.051 C6.303,2.756,8.189,1,10.5,1h3c2.311,0,4.197,1.756,4.449,4H16.5C16.224,5,16,5.224,16,5.5S16.224,6,16.5,6H18v1h-1.5 C16.224,7,16,7.224,16,7.5S16.224,8,16.5,8H18v1h-1.5C16.224,9,16,9.224,16,9.5s0.224,0.5,0.5,0.5H18v2.5 C18,14.981,15.981,17,13.5,17z M12.5,15c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S13.327,15,12.5,15z" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), UV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("path", { d: "M20.5,10c-0.276,0-0.5,0.224-0.5,0.5V12h-1V6.5c0-2.802-1.785-5.188-4.275-6.1c-0.026-0.014-0.054-0.021-0.083-0.03 C13.97,0.135,13.251,0,12.5,0c-0.752,0-1.471,0.135-2.144,0.371c-0.027,0.008-0.054,0.016-0.079,0.028C7.787,1.311,6,3.697,6,6.5 V12H5v-1.5C5,10.224,4.776,10,4.5,10S4,10.224,4,10.5v2c0,4.598,3.477,8.224,8,8.476V23.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5v-2.524c4.523-0.252,8-3.878,8-8.476v-2C21,10.224,20.776,10,20.5,10z M7,11h3.5c0.276,0,0.5-0.224,0.5-0.5 S10.776,10,10.5,10H7V9h3.5C10.776,9,11,8.776,11,8.5S10.776,8,10.5,8H7V7h3.5C10.776,7,11,6.776,11,6.5S10.776,6,10.5,6H7.025 C7.199,4.082,8.363,2.447,10,1.607V3.5C10,3.776,10.224,4,10.5,4S11,3.776,11,3.5V1.213c0.323-0.092,0.656-0.156,1-0.188V3.5 C12,3.776,12.224,4,12.5,4S13,3.776,13,3.5V1.025c0.344,0.031,0.678,0.096,1.001,0.188L14,3.5C14,3.776,14.224,4,14.5,4 C14.776,4,15,3.776,15,3.5l0.001-1.893c1.637,0.84,2.8,2.475,2.974,4.393H14.5C14.224,6,14,6.224,14,6.5S14.224,7,14.5,7H18v1h-3.5 C14.224,8,14,8.224,14,8.5S14.224,9,14.5,9H18v1h-3.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5H18v1H7V11z M17.975,13 c-0.254,2.799-2.611,5-5.475,5s-5.221-2.201-5.475-5H17.975z M12.5,20c-4.037,0-7.225-3.037-7.476-7h1.001 c0.257,3.351,3.06,6,6.475,6s6.218-2.649,6.475-6h1.001C19.725,16.963,16.537,20,12.5,20z" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), HV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,6h-7C16.224,6,16,6.224,16,6.5S16.224,7,16.5,7H23v3H1V7h6.5C7.776,7,8,6.776,8,6.5S7.776,6,7.5,6h-7 C0.224,6,0,6.224,0,6.5v16C0,22.776,0.224,23,0.5,23h23c0.276,0,0.5-0.224,0.5-0.5v-16C24,6.224,23.776,6,23.5,6z M1,22V11h22v11 H1z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,15h4c0.276,0,0.5-0.224,0.5-0.5S16.776,14,16.5,14h-4c-0.276,0-0.5,0.224-0.5,0.5S12.224,15,12.5,15z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.5,16h-6c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h6c0.276,0,0.5-0.224,0.5-0.5S18.776,16,18.5,16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,18h-5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h5c0.276,0,0.5-0.224,0.5-0.5S17.776,18,17.5,18z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9.5,9h5C14.776,9,15,8.776,15,8.5V4c0-1.654-1.346-3-3-3S9,2.346,9,4v4.5C9,8.776,9.224,9,9.5,9z M10,4 c0-1.104,0.897-2,2-2s2,0.896,2,2v4h-4V4z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.401,16.424C8.77,16.061,9,15.558,9,15c0-1.104-0.897-2-2-2s-2,0.896-2,2c0,0.558,0.23,1.061,0.599,1.424 C4.653,17.014,4,18.164,4,19.5C4,19.776,4.224,20,4.5,20h5c0.276,0,0.5-0.224,0.5-0.5C10,18.164,9.347,17.014,8.401,16.424z  M6,15c0-0.551,0.449-1,1-1s1,0.449,1,1c0,0.551-0.449,1-1,1S6,15.551,6,15z M5.04,19c0.186-1.14,0.994-2,1.96-2 s1.774,0.86,1.96,2H5.04z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), zV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,17h-1h-1.025c-0.233-4.455-3.542-8.102-7.844-8.85C13.861,7.824,14,7.429,14,7c0-1.103-0.897-2-2-2s-2,0.897-2,2 c0,0.429,0.139,0.824,0.369,1.15C6.067,8.898,2.759,12.545,2.525,17H1.5h-1C0.224,17,0,17.224,0,17.5S0.224,18,0.5,18h0.793 l1.854,1.854C3.24,19.947,3.367,20,3.5,20h17c0.133,0,0.26-0.053,0.354-0.146L22.707,18H23.5c0.276,0,0.5-0.224,0.5-0.5 S23.776,17,23.5,17z M11,7c0-0.552,0.448-1,1-1s1,0.448,1,1s-0.448,1-1,1S11,7.552,11,7z M12,9c4.518,0,8.214,3.547,8.475,8H3.525 C3.786,12.547,7.482,9,12,9z M20.293,19H3.707l-1-1h18.586L20.293,19z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12,10.5c-2.399,0-4.604,1.208-5.898,3.23c-0.149,0.232-0.081,0.542,0.151,0.69C6.337,14.475,6.43,14.5,6.522,14.5 c0.164,0,0.326-0.081,0.421-0.23c1.109-1.734,3-2.77,5.057-2.77c0.276,0,0.5-0.224,0.5-0.5S12.276,10.5,12,10.5z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisible_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), VV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("path", { d: "M20.779,0.585c-0.139-0.094-0.313-0.11-0.468-0.048l-11,4.5C9.123,5.114,9,5.297,9,5.5V17H6.5C4.57,17,3,18.57,3,20.5 S4.57,24,6.5,24c1.864,0,3.5-1.636,3.5-3.5v-3V9.336l10-4.091V13h-2.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5 c1.864,0,3.5-1.636,3.5-3.5v-3V1C21,0.833,20.917,0.678,20.779,0.585z M9,20.5C9,21.68,7.931,23,6.5,23C5.122,23,4,21.879,4,20.5 S5.122,18,6.5,18H9V20.5z M10,8.255V5.836l10-4.091v2.419L10,8.255z M20,16.5c0,1.18-1.069,2.5-2.5,2.5c-1.378,0-2.5-1.121-2.5-2.5 s1.122-2.5,2.5-2.5H20V16.5z" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), qV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M21.038,16.772l-3.581-0.988c-0.017-0.008-0.036-0.009-0.053-0.015l-1.771-0.488c0.95-0.854,1.714-1.995,1.847-3.359 c0.686-0.234,1.146-0.971,1.146-1.922c0-0.941-0.451-1.673-1.125-1.915V6V4.051l6.085-1.059C23.826,2.951,24,2.743,24,2.5 s-0.175-0.451-0.415-0.492l-11.5-2c-0.057-0.01-0.114-0.01-0.171,0l-11.5,2C0.175,2.049,0,2.257,0,2.5s0.175,0.451,0.415,0.492 L2.5,3.355v3.093l-1.489,6.947c-0.032,0.147,0.005,0.302,0.1,0.419C1.207,13.932,1.35,14,1.5,14h3 c0.151,0,0.294-0.068,0.389-0.186c0.095-0.117,0.132-0.271,0.1-0.419L3.5,6.448V3.529l3,0.521V6v2.085 C5.827,8.327,5.375,9.059,5.375,10c0,0.951,0.46,1.688,1.146,1.922c0.132,1.363,0.896,2.504,1.844,3.356l-5.444,1.509 C1.174,17.441,0,19.134,0,21v2.5C0,23.776,0.224,24,0.5,24h23c0.276,0,0.5-0.224,0.5-0.5V21 C24,19.134,22.827,17.441,21.038,16.772z M2.119,13L3,8.887L3.882,13H2.119z M12,1.008L20.583,2.5L12,3.992L3.418,2.5L12,1.008z  M11.915,4.992C11.943,4.997,11.972,5,12,5s0.057-0.003,0.085-0.008L16.5,4.225v1.542C16.061,6.101,14.633,7,12,7 C9.365,7,7.937,6.099,7.5,5.768V4.225L11.915,4.992z M7.5,11.5C7.5,11.224,7.277,11,7,11c-0.494,0-0.625-0.654-0.625-1 c0-0.291,0.072-0.565,0.197-0.754C6.72,9.025,6.887,9,7,9c0.276,0,0.5-0.224,0.5-0.5V6.955C8.331,7.426,9.787,8,12,8 s3.669-0.574,4.5-1.045V8.5C16.5,8.776,16.724,9,17,9c0.494,0,0.625,0.654,0.625,1c0,0.291-0.072,0.565-0.197,0.754 C17.281,10.975,17.114,11,17,11c-0.276,0-0.5,0.224-0.5,0.5c0,1.499-1.05,2.763-2.197,3.566 c-0.002,0.002-0.004,0.003-0.007,0.004C13.457,15.658,12.567,16,12,16C10.658,16,7.5,14.1,7.5,11.5z M12,17 c0.649,0,1.651-0.342,2.624-0.96l1.669,0.46L12,20.793l-4.295-4.295l1.666-0.462C10.345,16.656,11.35,17,12,17z M23,23H1v-2 c0-1.451,0.913-2.768,2.229-3.264l3.368-0.932l5.05,5.049C11.745,21.951,11.873,22,12,22s0.256-0.049,0.354-0.146l5.048-5.048 l3.328,0.917C22.088,18.232,23,19.549,23,21V23z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9.501,9.511c0.095-0.013,0.251-0.01,0.362-0.01L10,9.502l0.137-0.001c0.114,0.001,0.269-0.002,0.363,0.01 c0.004,0.271,0.227,0.491,0.5,0.491c0.276,0,0.5-0.224,0.5-0.5c0-0.298-0.089-0.538-0.266-0.713 c-0.296-0.294-0.703-0.287-1.105-0.288L10,8.502L9.872,8.501C9.477,8.503,9.062,8.495,8.766,8.789 C8.59,8.964,8.5,9.204,8.5,9.502c0,0.276,0.226,0.473,0.502,0.473C9.257,9.975,9.47,9.761,9.501,9.511z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M13.003,9.975c0.254,0,0.467-0.214,0.498-0.464c0.095-0.013,0.25-0.01,0.362-0.01L14,9.502l0.137-0.001 c0.113,0.001,0.269-0.002,0.363,0.01c0.004,0.271,0.227,0.491,0.5,0.491c0.276,0,0.5-0.224,0.5-0.5 c0-0.298-0.089-0.538-0.266-0.713c-0.296-0.294-0.705-0.287-1.105-0.288L14,8.502l-0.129-0.001 c-0.396,0.002-0.809-0.006-1.105,0.288C12.59,8.964,12.5,9.204,12.5,9.502C12.5,9.778,12.727,9.975,13.003,9.975z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), GV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("path", { d: "M23,15.093V3.5C23,3.224,22.776,3,22.5,3H15V2.5C15,2.224,14.776,2,14.5,2H12V0.5C12,0.224,11.776,0,11.5,0 S11,0.224,11,0.5V2H9.5C9.224,2,9,2.224,9,2.5V3H1.5C1.224,3,1,3.224,1,3.5v11.593c-0.581,0.207-1,0.756-1,1.407 C0,17.327,0.673,18,1.5,18h4.691l-2.638,5.276c-0.124,0.247-0.023,0.547,0.224,0.671C3.848,23.983,3.924,24,4,24 c0.184,0,0.36-0.101,0.448-0.276L7.309,18H11v5.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V18h4.691l2.862,5.724 C19.641,23.899,19.817,24,20,24c0.075,0,0.151-0.017,0.223-0.053c0.247-0.124,0.347-0.424,0.224-0.671L17.809,18H22.5 c0.827,0,1.5-0.673,1.5-1.5C24,15.849,23.581,15.299,23,15.093z M10,3h4v1h-4V3z M2,4h7v0.5C9,4.776,9.224,5,9.5,5h5 C14.776,5,15,4.776,15,4.5V4h7v11H2V4z M22.5,17h-21C1.224,17,1,16.776,1,16.5C1,16.224,1.224,16,1.5,16h21 c0.276,0,0.5,0.224,0.5,0.5C23,16.776,22.776,17,22.5,17z" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { x: 0, fill: "none", width: 24, height: 24 }))), WV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M0.361,2.654l0.517,0.149L1.88,9.556c0.028,0.192,0.166,0.351,0.353,0.406c0.047,0.014,0.095,0.021,0.142,0.021 c0.142,0,0.278-0.06,0.375-0.169l4.546-5.155l1.243,0.359l0.944,6.77c0.026,0.192,0.163,0.352,0.349,0.409 c0.049,0.015,0.098,0.021,0.146,0.021c0.14,0,0.275-0.059,0.372-0.166l4.641-5.169l1.201,0.347l0.944,6.771 c0.026,0.192,0.163,0.352,0.349,0.409c0.049,0.015,0.098,0.021,0.146,0.021c0.14,0,0.275-0.059,0.372-0.166l4.642-5.171 l0.658,0.19c0.046,0.014,0.093,0.02,0.139,0.02c0.217,0,0.417-0.143,0.48-0.361c0.076-0.265-0.076-0.542-0.342-0.619L9.135,4.148 H9.133l0,0L4.178,2.717L1.464,1.921C1.449,1.916,1.435,1.922,1.421,1.92L0.639,1.693C0.376,1.613,0.097,1.77,0.02,2.035 C-0.057,2.3,0.096,2.577,0.361,2.654z M10.324,10.583L9.592,5.332l4.282,1.296L10.324,10.583z M17.978,12.797l-0.732-5.25 l4.282,1.296L17.978,12.797z M6.227,4.358L2.711,8.345L1.934,3.109l2.146,0.619L6.227,4.358z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M23.412,14.292l-4.816,0.542l-1.72,0.165c-0.04,0.004-0.073,0.027-0.111,0.04L1.226,16.786L0.87,16.82 c-0.009,0-0.015,0.007-0.022,0.008l-0.37,0.042c-0.274,0.031-0.472,0.278-0.441,0.553c0.029,0.256,0.245,0.444,0.496,0.444 c0.019,0,0.038-0.001,0.057-0.003l0.064-0.007l3.443,5.895C4.187,23.906,4.352,24,4.528,24c0.016,0,0.031-0.001,0.047-0.002 c0.193-0.019,0.359-0.147,0.424-0.331l2.332-6.561l1.528-0.172l3.468,5.94c0.09,0.154,0.255,0.248,0.432,0.248 c0.016,0,0.031-0.001,0.047-0.002c0.193-0.019,0.359-0.147,0.424-0.33l2.352-6.612l1.091-0.122l3.43,5.875 c0.09,0.154,0.255,0.248,0.432,0.248c0.016,0,0.031-0.001,0.047-0.002c0.193-0.019,0.359-0.147,0.424-0.33l2.325-6.539 l0.194-0.022c0.274-0.031,0.472-0.278,0.441-0.553C23.933,14.458,23.678,14.267,23.412,14.292z M4.418,22.318l-2.674-4.577 l4.453-0.43L4.418,22.318z M12.648,21.441l-2.673-4.578l4.453-0.428L12.648,21.441z M22.203,15.491l-1.78,5.007l-2.664-4.564 l0.934-0.104L22.203,15.491z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), $V = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M22.5,2h-2C20.224,2,20,2.224,20,2.5V3H3V2.5C3,2.224,2.776,2,2.5,2h-2C0.224,2,0,2.224,0,2.5v19 C0,21.776,0.224,22,0.5,22h2C2.776,22,3,21.776,3,21.5V21h17v0.5c0,0.276,0.224,0.5,0.5,0.5h2c0.276,0,0.5-0.224,0.5-0.5v-19 C23,2.224,22.776,2,22.5,2z M2,21H1V3h1V21z M3,20V4h17v16H3z M22,21h-1V3h1V21z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M4.5,8h5C9.776,8,10,7.776,10,7.5v-2C10,5.224,9.776,5,9.5,5h-5C4.224,5,4,5.224,4,5.5v2C4,7.776,4.224,8,4.5,8z M5,6h4v1 H5V6z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.5,14H7v-4c0-0.276-0.224-0.5-0.5-0.5S6,9.724,6,10v4H4.5C4.224,14,4,14.224,4,14.5v2C4,16.776,4.224,17,4.5,17H6v1 c0,0.276,0.224,0.5,0.5,0.5S7,18.276,7,18v-1h1.5C8.776,17,9,16.776,9,16.5v-2C9,14.224,8.776,14,8.5,14z M8,16H5v-1h3V16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M14,11.5c0-0.276-0.224-0.5-0.5-0.5H12v-1c0-0.276-0.224-0.5-0.5-0.5S11,9.724,11,10v1H9.5C9.224,11,9,11.224,9,11.5v2 C9,13.776,9.224,14,9.5,14H11v4c0,0.276,0.224,0.5,0.5,0.5S12,18.276,12,18v-4h1.5c0.276,0,0.5-0.224,0.5-0.5V11.5z M13,13h-3v-1 h3V13z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.5,14H17v-4c0-0.276-0.224-0.5-0.5-0.5S16,9.724,16,10v4h-1.5c-0.276,0-0.5,0.224-0.5,0.5v2c0,0.276,0.224,0.5,0.5,0.5 H16v1c0,0.276,0.224,0.5,0.5,0.5S17,18.276,17,18v-1h1.5c0.276,0,0.5-0.224,0.5-0.5v-2C19,14.224,18.776,14,18.5,14z M18,16h-3v-1 h3V16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M11.5,7h1C12.776,7,13,6.776,13,6.5S12.776,6,12.5,6h-1C11.224,6,11,6.224,11,6.5S11.224,7,11.5,7z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M14.5,7h1C15.776,7,16,6.776,16,6.5S15.776,6,15.5,6h-1C14.224,6,14,6.224,14,6.5S14.224,7,14.5,7z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,7h1C18.776,7,19,6.776,19,6.5S18.776,6,18.5,6h-1C17.224,6,17,6.224,17,6.5S17.224,7,17.5,7z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), YV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M20.5,0h-17C3.224,0,3,0.224,3,0.5v23C3,23.776,3.224,24,3.5,24h17c0.276,0,0.5-0.224,0.5-0.5v-23 C21,0.224,20.776,0,20.5,0z M20,23H4V1h16V23z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.5,8h7C15.776,8,16,7.776,16,7.5v-5C16,2.224,15.776,2,15.5,2h-7C8.224,2,8,2.224,8,2.5v5C8,7.776,8.224,8,8.5,8z M9,3 h6v4H9V3z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.5,15h7c0.276,0,0.5-0.224,0.5-0.5v-5C16,9.224,15.776,9,15.5,9h-7C8.224,9,8,9.224,8,9.5v5C8,14.776,8.224,15,8.5,15z  M9,10h6v4H9V10z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.5,22h7c0.276,0,0.5-0.224,0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-7C8.224,16,8,16.224,8,16.5v5 C8,21.776,8.224,22,8.5,22z M9,17h6v4H9V17z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M5.5,4h1C6.776,4,7,3.776,7,3.5v-1C7,2.224,6.776,2,6.5,2h-1C5.224,2,5,2.224,5,2.5v1C5,3.776,5.224,4,5.5,4z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M5.5,8h1C6.776,8,7,7.776,7,7.5v-1C7,6.224,6.776,6,6.5,6h-1C5.224,6,5,6.224,5,6.5v1C5,7.776,5.224,8,5.5,8z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M5.5,11h1C6.776,11,7,10.776,7,10.5v-1C7,9.224,6.776,9,6.5,9h-1C5.224,9,5,9.224,5,9.5v1C5,10.776,5.224,11,5.5,11z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M5.5,15h1C6.776,15,7,14.776,7,14.5v-1C7,13.224,6.776,13,6.5,13h-1C5.224,13,5,13.224,5,13.5v1C5,14.776,5.224,15,5.5,15 z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M5.5,18h1C6.776,18,7,17.776,7,17.5v-1C7,16.224,6.776,16,6.5,16h-1C5.224,16,5,16.224,5,16.5v1C5,17.776,5.224,18,5.5,18 z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M5.5,22h1C6.776,22,7,21.776,7,21.5v-1C7,20.224,6.776,20,6.5,20h-1C5.224,20,5,20.224,5,20.5v1C5,21.776,5.224,22,5.5,22 z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,4h1C18.776,4,19,3.776,19,3.5v-1C19,2.224,18.776,2,18.5,2h-1C17.224,2,17,2.224,17,2.5v1C17,3.776,17.224,4,17.5,4 z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,8h1C18.776,8,19,7.776,19,7.5v-1C19,6.224,18.776,6,18.5,6h-1C17.224,6,17,6.224,17,6.5v1C17,7.776,17.224,8,17.5,8 z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,11h1c0.276,0,0.5-0.224,0.5-0.5v-1C19,9.224,18.776,9,18.5,9h-1C17.224,9,17,9.224,17,9.5v1 C17,10.776,17.224,11,17.5,11z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,15h1c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-1c-0.276,0-0.5,0.224-0.5,0.5v1 C17,14.776,17.224,15,17.5,15z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,18h1c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-1c-0.276,0-0.5,0.224-0.5,0.5v1 C17,17.776,17.224,18,17.5,18z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,22h1c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-1c-0.276,0-0.5,0.224-0.5,0.5v1 C17,21.776,17.224,22,17.5,22z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), XV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M12.576,15.61c0.075,0,0.15-0.017,0.22-0.051c0.148-0.073,3.646-1.811,3.707-4.276c0-1.816-1.264-2.767-2.513-2.767 c-0.534,0-1.031,0.177-1.414,0.492c-0.383-0.315-0.88-0.492-1.414-0.492c-1.249,0-2.513,0.95-2.513,2.779 c0.061,2.453,3.559,4.19,3.707,4.264C12.426,15.594,12.501,15.61,12.576,15.61z M9.649,11.283c0-1.214,0.784-1.767,1.513-1.767 c0.426,0,0.788,0.184,0.993,0.505c0.092,0.144,0.25,0.23,0.421,0.23s0.329-0.087,0.421-0.23c0.559-0.871,2.506-0.654,2.506,1.249 c-0.035,1.416-1.955,2.748-2.927,3.277C11.604,14.021,9.685,12.692,9.649,11.283z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M20.343,17.088l-4.104,1.361C15.954,18.181,15.541,18,15,18h-2.798c-0.743-0.7-2.429-2-4.702-2H5v-0.5 C5,15.224,4.776,15,4.5,15h-4C0.224,15,0,15.224,0,15.5v7C0,22.776,0.224,23,0.5,23h4C4.776,23,5,22.776,5,22.5v-0.741 c0.841,0.284,1.59,0.543,2.256,0.774c2.624,0.911,4.088,1.409,5.419,1.409c1.623,0,3.048-0.742,6.138-2.386 c1.281-0.682,2.876-1.529,4.911-2.547c0.144-0.072,0.244-0.209,0.27-0.367c0.026-0.159-0.026-0.32-0.14-0.434 C22.679,17.035,21.667,16.712,20.343,17.088z M4,22H1v-6h3V22z M18.343,20.674c-5.289,2.812-5.287,2.813-10.759,0.915 C6.833,21.328,5.976,21.031,5,20.703V17h2.5c2.069,0,3.589,1.296,4.146,1.854C11.74,18.947,11.867,19,12,19h3 c0.514,0,0.695,0.27,0.695,0.5S15.514,20,15,20H9.5C9.224,20,9,20.224,9,20.5S9.224,21,9.5,21H15c1.113,0,1.695-0.755,1.695-1.5 c0-0.048-0.009-0.096-0.014-0.145l3.956-1.312c0.658-0.187,1.229-0.177,1.98,0.403C20.883,19.323,19.488,20.064,18.343,20.674z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,1h-4C19.224,1,19,1.224,19,1.5v0.68c-0.841-0.285-1.59-0.544-2.256-0.775C10.92-0.618,10.812-0.61,5.188,2.381 C3.906,3.062,2.312,3.91,0.276,4.928C0.133,5,0.032,5.137,0.007,5.295c-0.026,0.159,0.026,0.32,0.14,0.434 C1.014,6.595,1.792,7,2.673,7c0.312,0,0.638-0.052,0.984-0.15l4.056-1.347C7.997,5.799,8.427,6,9,6h2.798 c0.743,0.7,2.429,2,4.702,2H19v0.5C19,8.776,19.224,9,19.5,9h4C23.776,9,24,8.776,24,8.5v-7C24,1.224,23.776,1,23.5,1z M16.5,7 c-2.069,0-3.589-1.296-4.146-1.854C12.26,5.053,12.133,5,12,5H9C8.486,5,8.305,4.73,8.305,4.5S8.486,4,9,4h5.5 C14.776,4,15,3.776,15,3.5S14.776,3,14.5,3H9C7.887,3,7.305,3.755,7.305,4.5c0,0.027,0.007,0.055,0.008,0.082l-3.95,1.312 c-0.658,0.187-1.228,0.177-1.98-0.403c1.735-0.877,3.13-1.618,4.275-2.228c5.29-2.812,5.289-2.812,10.759-0.915 C17.167,2.61,18.024,2.907,19,3.234V7H16.5z M23,8h-3V2h3V8z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisible_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), KV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M8.776,5.947c0.248,0.125,0.548,0.024,0.671-0.224l1.138-2.276L11.6,4.8c0.189,0.252,0.611,0.252,0.801,0l1.015-1.353 l1.138,2.276C14.641,5.898,14.817,6,15,6c0.075,0,0.151-0.017,0.224-0.053c0.247-0.124,0.347-0.424,0.224-0.671l-1.5-3 c-0.077-0.155-0.229-0.259-0.402-0.274C13.376,1.984,13.204,2.062,13.1,2.2L12,3.667L10.9,2.2 c-0.105-0.139-0.276-0.216-0.445-0.198c-0.173,0.016-0.325,0.119-0.402,0.274l-1.5,3C8.43,5.523,8.529,5.823,8.776,5.947z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M21,11v-0.287c1.287-1.193,2-2.767,2-4.463C23,2.804,20.196,0,16.75,0h-9.5C3.804,0,1,2.804,1,6.25 c0,1.726,0.695,3.262,2,4.464V11c-1.654,0-3,1.346-3,3s1.346,3,3,3c0.079,0,0.151-0.021,0.218-0.055C4.11,20.976,7.706,24,12,24 c4.295,0,7.891-3.024,8.782-7.055C20.849,16.979,20.921,17,21,17c1.654,0,3-1.346,3-3S22.654,11,21,11z M2,6.25 C2,3.355,4.355,1,7.25,1h9.5C19.645,1,22,3.355,22,6.25c0,1.191-0.42,2.271-1.183,3.187C20.363,8.028,19.057,7,17.5,7h-11 C4.943,7,3.636,8.029,3.183,9.438C2.42,8.524,2,7.444,2,6.25z M19.949,10H4.051C4.283,8.86,5.292,8,6.5,8h11 C18.708,8,19.717,8.86,19.949,10z M3,16c-1.103,0-2-0.897-2-2s0.897-2,2-2v3c0,0.343,0.023,0.68,0.061,1.012 C3.04,16.01,3.021,16,3,16z M12,23c-4.411,0-8-3.589-8-8v-4h16v4C20,19.411,16.411,23,12,23z M21,16 c-0.021,0-0.04,0.01-0.061,0.012C20.977,15.68,21,15.343,21,15v-3c1.103,0,2,0.897,2,2S22.103,16,21,16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.5,14.5C8.776,14.5,9,14.276,9,14v-1c0-0.276-0.224-0.5-0.5-0.5S8,12.724,8,13v1C8,14.276,8.224,14.5,8.5,14.5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M15.5,14.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5S15,12.724,15,13v1C15,14.276,15.224,14.5,15.5,14.5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.788,15.987l-4.484-0.484c-0.14-0.019-0.282,0.03-0.388,0.125S13.75,15.858,13.75,16c0,0.925-0.765,2-1.75,2 s-1.75-1.075-1.75-2c0-0.142-0.061-0.277-0.166-0.372s-0.248-0.144-0.388-0.125l-4.5,0.484c-0.153,0.017-0.291,0.104-0.372,0.234 c-0.081,0.132-0.097,0.294-0.042,0.438l0.575,1.531C5.646,18.975,6.4,19.5,7.234,19.5c0.339,0,0.67-0.087,0.961-0.246l0.253,0.454 C8.817,20.493,9.617,21,10.484,21c0.562,0,1.099-0.214,1.508-0.581C12.401,20.786,12.938,21,13.5,21 c0.867,0,1.667-0.507,2.021-1.263l0.268-0.483c0.292,0.159,0.622,0.246,0.961,0.246c0.834,0,1.589-0.525,1.876-1.306l0.576-1.534 c0.055-0.145,0.039-0.307-0.042-0.438C19.079,16.091,18.941,16.004,18.788,15.987z M17.689,17.846 c-0.243,0.657-1.216,0.844-1.684,0.322c-0.108-0.121-0.264-0.184-0.429-0.163c-0.16,0.019-0.303,0.113-0.381,0.255l-0.564,1.022 C14.426,19.718,13.982,20,13.5,20c-0.444,0-0.846-0.228-1.074-0.608c-0.094-0.156-0.259-0.243-0.429-0.243 c-0.002,0-0.003,0-0.005,0c-0.14,0.009-0.339,0.085-0.434,0.243C11.33,19.772,10.929,20,10.484,20 c-0.482,0-0.926-0.282-1.146-0.747l-0.55-0.993c-0.078-0.142-0.221-0.236-0.381-0.255c-0.167-0.02-0.32,0.042-0.429,0.163 c-0.469,0.521-1.44,0.337-1.685-0.325l-0.349-0.931l3.355-0.361C9.554,17.907,10.706,19,12,19c1.293,0,2.446-1.093,2.699-2.448 l3.341,0.36L17.689,17.846z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisible_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), QV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M22.691,0.038c-0.185-0.076-0.401-0.035-0.545,0.108c-1.018,1.018-5.191,1.728-10.149,1.728 c-4.955,0-9.126-0.71-10.144-1.728C1.711,0.004,1.495-0.037,1.309,0.038C1.122,0.115,1,0.298,1,0.5V12c0,6.753,8.773,12,11,12 s11-5.247,11-12V0.5C23,0.298,22.878,0.115,22.691,0.038z M22,12c0,5.925-8.101,11-10,11S2,17.925,2,12V1.438 c2.085,1.047,6.343,1.436,9.997,1.436c3.657,0,7.918-0.389,10.003-1.436V12z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M14.5,9.498c0.276,0,0.5-0.224,0.5-0.5c0-0.827,0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5c0-1.379-1.121-2.5-2.5-2.5S14,7.619,14,8.998C14,9.274,14.224,9.498,14.5,9.498z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9,8.998c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5c0-1.379-1.121-2.5-2.5-2.5S5,7.619,5,8.998 c0,0.276,0.224,0.5,0.5,0.5S6,9.274,6,8.998c0-0.827,0.673-1.5,1.5-1.5S9,8.171,9,8.998z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.5,13.998c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,2.481,2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5 c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,1.93-1.57,3.5-3.5,3.5S8.5,15.928,8.5,13.998z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), ZV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,4H19V2.5C19,1.122,17.879,0,16.5,0h-3C12.121,0,11,1.122,11,2.5V4H8V2.5C8,1.673,8.673,1,9.5,1h1 C10.776,1,11,0.776,11,0.5S10.776,0,10.5,0h-1C8.121,0,7,1.122,7,2.5V4H0.5C0.224,4,0,4.224,0,4.5v19C0,23.776,0.224,24,0.5,24h7 h16c0.276,0,0.5-0.224,0.5-0.5v-19C24,4.224,23.776,4,23.5,4z M12,2.5C12,1.673,12.673,1,13.5,1h3C17.327,1,18,1.673,18,2.5V4h-6 V2.5z M1,5h2v14.835l-1.312,1.312c-0.195,0.195-0.195,0.512,0,0.707c0.195,0.195,0.512,0.195,0.707,0l1.146-1.147l1.146,1.147 C4.786,21.951,4.914,22,5.042,22s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L4,19.751V5h3v18H1V5z M23,23H8V5h15V23z " })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), JV = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M10.5,11c0.276,0,0.5-0.224,0.5-0.5V10c0-0.772-0.582-1.543-1.325-1.755L7.5,7.623V6.858C8.404,6.176,9,5.049,9,3.771 C9,1.692,7.43,0,5.5,0S2,1.692,2,3.771c0,1.277,0.596,2.404,1.5,3.087v0.765L1.323,8.245C0.581,8.458,0,9.229,0,10v0.5 C0,10.776,0.224,11,0.5,11H10.5z M5.5,1c1.123,0,2.064,0.831,2.379,1.963c-0.153,0.046-0.35,0.07-0.567,0.039 C7.082,2.969,6.664,2.85,6.44,2.434c-0.075-0.14-0.211-0.235-0.368-0.258c-0.157-0.022-0.314,0.03-0.426,0.141 C4.917,3.046,3.826,3.105,3.154,2.844C3.5,1.773,4.416,1,5.5,1z M3.007,3.851c0.885,0.266,2.017,0.157,2.912-0.464 c0.324,0.319,0.756,0.532,1.247,0.604c0.122,0.018,0.243,0.027,0.362,0.027c0.158,0,0.308-0.02,0.454-0.05 C7.889,5.403,6.818,6.543,5.5,6.543C4.146,6.543,3.046,5.341,3.007,3.851z M1,10c0-0.325,0.285-0.704,0.598-0.793l2.539-0.726 C4.352,8.419,4.5,8.224,4.5,8V7.367c0.319,0.104,0.65,0.176,1,0.176s0.681-0.072,1-0.176V8c0,0.224,0.148,0.419,0.363,0.481 L9.4,9.207C9.714,9.296,10,9.675,10,10H1z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M22.675,8.245L20.5,7.623V6.858c0.904-0.683,1.5-1.81,1.5-3.087C22,1.692,20.43,0,18.5,0S15,1.692,15,3.771 c0,1.277,0.596,2.404,1.5,3.087v0.765l-2.177,0.622C13.581,8.458,13,9.229,13,10v0.5c0,0.276,0.224,0.5,0.5,0.5h10 c0.276,0,0.5-0.224,0.5-0.5V10C24,9.228,23.418,8.457,22.675,8.245z M18.5,1c1.121,0,2.061,0.828,2.377,1.957 C20.725,3.007,20.525,3.034,20.303,3c-0.227-0.034-0.64-0.151-0.863-0.567c-0.075-0.14-0.211-0.235-0.368-0.258 c-0.157-0.022-0.314,0.03-0.426,0.141c-0.729,0.729-1.821,0.789-2.492,0.528C16.5,1.773,17.416,1,18.5,1z M16.007,3.851 c0.885,0.266,2.016,0.157,2.911-0.464c0.322,0.319,0.752,0.531,1.239,0.603c0.12,0.018,0.24,0.026,0.357,0.026 c0.163,0,0.318-0.022,0.468-0.054C20.893,5.4,19.819,6.543,18.5,6.543C17.146,6.543,16.046,5.341,16.007,3.851z M14,10 c0-0.325,0.285-0.704,0.598-0.793l2.539-0.726C17.352,8.419,17.5,8.224,17.5,8V7.367c0.319,0.104,0.65,0.176,1,0.176 s0.681-0.072,1-0.176V8c0,0.224,0.148,0.419,0.363,0.481L22.4,9.207C22.714,9.296,23,9.675,23,10H14z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M16.175,21.245L14,20.623v-0.765c0.904-0.683,1.5-1.81,1.5-3.087C15.5,14.692,13.93,13,12,13s-3.5,1.692-3.5,3.771 c0,1.277,0.596,2.404,1.5,3.087v0.765l-2.177,0.622C7.081,21.458,6.5,22.229,6.5,23v0.5C6.5,23.776,6.724,24,7,24h10 c0.276,0,0.5-0.224,0.5-0.5V23C17.5,22.228,16.918,21.457,16.175,21.245z M12,14c1.114,0,2.049,0.817,2.371,1.937 c-0.158,0.053-0.365,0.082-0.592,0.048c-0.22-0.032-0.622-0.147-0.838-0.551c-0.075-0.14-0.211-0.235-0.368-0.258 c-0.157-0.022-0.314,0.03-0.426,0.141c-0.729,0.729-1.82,0.788-2.492,0.527C10.001,14.773,10.917,14,12,14z M9.507,16.851 c0.886,0.267,2.018,0.158,2.912-0.464c0.317,0.311,0.737,0.517,1.213,0.587c0.117,0.018,0.234,0.025,0.349,0.025 c0.174,0,0.341-0.025,0.503-0.062c-0.079,1.45-1.158,2.605-2.485,2.605C10.646,19.543,9.546,18.342,9.507,16.851z M7.5,23 c0-0.325,0.285-0.704,0.598-0.793l2.539-0.726C10.852,21.419,11,21.224,11,21v-0.633c0.319,0.104,0.65,0.176,1,0.176 s0.681-0.072,1-0.176V21c0,0.224,0.148,0.419,0.363,0.481l2.538,0.726c0.314,0.089,0.6,0.468,0.6,0.793H7.5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M6.854,15.354c0.195-0.195,0.195-0.512,0-0.707l-2.5-2.5c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l2.5,2.5 C6.244,15.451,6.372,15.5,6.5,15.5S6.756,15.451,6.854,15.354z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M19.646,12.146l-2.5,2.5c-0.195,0.195-0.195,0.512,0,0.707c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146 l2.5-2.5c0.195-0.195,0.195-0.512,0-0.707S19.842,11.951,19.646,12.146z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), eq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.978,2.259c-0.014-0.192-0.137-0.359-0.316-0.431c-0.179-0.066-0.383-0.031-0.523,0.101 c-1.477,1.377-2.682,2.047-3.686,2.047c-0.776,0-1.418-0.376-2.16-0.811c-0.862-0.505-1.839-1.076-3.174-1.076 c-0.672,0-1.367,0.142-2.118,0.433c-0.751-0.291-1.446-0.433-2.118-0.433c-1.336,0-2.312,0.571-3.174,1.076 C5.966,3.6,5.324,3.976,4.548,3.976c-1.017,0-2.188-0.65-3.685-2.047C0.724,1.797,0.521,1.762,0.34,1.828 C0.16,1.899,0.037,2.066,0.023,2.259C0.006,2.515-0.39,8.579,2.69,11.887c1.275,1.37,2.959,2.064,5.004,2.064 c1.891,0,3.357-0.432,4.306-0.829c0.948,0.397,2.415,0.829,4.306,0.829c2.046,0,3.729-0.694,5.005-2.064 c0.753-0.809,1.296-1.782,1.689-2.795V24h1V3.459C24.011,2.774,23.982,2.324,23.978,2.259z M20.579,11.205 c-1.079,1.159-2.517,1.746-4.273,1.746c-1.855,0-3.255-0.451-4.102-0.83c-0.064-0.029-0.135-0.044-0.204-0.044 s-0.14,0.015-0.204,0.044c-0.847,0.379-2.246,0.83-4.102,0.83c-1.756,0-3.192-0.587-4.271-1.743 C1.359,8.992,1.033,5.21,1.004,3.381c1.331,1.084,2.473,1.595,3.543,1.595c0.001,0,0.001,0,0.001,0 c1.048,0,1.87-0.481,2.665-0.947c0.825-0.483,1.604-0.939,2.669-0.939c0.595,0,1.225,0.142,1.926,0.434 c0.123,0.051,0.262,0.051,0.385,0c0.701-0.292,1.331-0.434,1.926-0.434c1.063,0,1.843,0.456,2.668,0.939 c0.796,0.466,1.618,0.947,2.666,0.947c1.072,0,2.215-0.511,3.545-1.596C22.97,5.207,22.646,8.985,20.579,11.205z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M16.579,5.645c-1.947,0.348-3.288,1.654-3.053,2.976c0.195,1.088,1.39,1.818,2.974,1.818c0.303,0,0.613-0.028,0.921-0.083 c0.888-0.158,1.689-0.529,2.258-1.044c0.633-0.572,0.915-1.259,0.795-1.932c-0.194-1.088-1.389-1.818-2.974-1.818 C17.197,5.562,16.887,5.59,16.579,5.645z M19.489,7.556c0.077,0.434-0.269,0.822-0.481,1.015 c-0.425,0.385-1.067,0.677-1.763,0.801c-1.324,0.238-2.606-0.217-2.734-0.927c-0.115-0.648,0.777-1.554,2.244-1.815 c0.25-0.045,0.501-0.067,0.745-0.067C18.55,6.562,19.387,6.979,19.489,7.556z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M7.421,5.645C7.113,5.59,6.803,5.562,6.5,5.562c-1.584,0-2.778,0.73-2.974,1.818c-0.12,0.673,0.162,1.359,0.795,1.932 c0.568,0.515,1.37,0.886,2.258,1.044c0.308,0.055,0.618,0.083,0.921,0.083c1.585,0,2.779-0.73,2.974-1.818 C10.709,7.299,9.368,5.992,7.421,5.645z M6.755,9.371C6.06,9.247,5.417,8.955,4.992,8.57C4.779,8.378,4.434,7.989,4.511,7.556 C4.614,6.979,5.45,6.562,6.5,6.562c0.244,0,0.495,0.022,0.745,0.067c1.467,0.262,2.359,1.167,2.244,1.815 C9.362,9.154,8.078,9.608,6.755,9.371z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), tq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,9.5C23.776,9.5,24,9.276,24,9V4.5C24,4.224,23.776,4,23.5,4h-23C0.224,4,0,4.224,0,4.5V9c0,0.276,0.224,0.5,0.5,0.5 C1.879,9.5,3,10.621,3,12s-1.121,2.5-2.5,2.5C0.224,14.5,0,14.724,0,15v4.5C0,19.776,0.224,20,0.5,20h23 c0.276,0,0.5-0.224,0.5-0.5V15c0-0.276-0.224-0.5-0.5-0.5c-1.379,0-2.5-1.121-2.5-2.5S22.121,9.5,23.5,9.5z M23,15.465V19h-4v-1 h-1v1H1v-3.535C2.694,15.221,4,13.76,4,12S2.694,8.779,1,8.535V5h22v3.535C21.306,8.779,20,10.24,20,12S21.306,15.221,23,15.465z" }), /* @__PURE__ */ Ce.createElement("rect", { x: 18, y: 6, width: 1, height: 1 }), /* @__PURE__ */ Ce.createElement("rect", { x: 18, y: 8, width: 1, height: 1 }), /* @__PURE__ */ Ce.createElement("rect", { x: 18, y: 10, width: 1, height: 1 }), /* @__PURE__ */ Ce.createElement("rect", { x: 18, y: 12, width: 1, height: 1 }), /* @__PURE__ */ Ce.createElement("rect", { x: 18, y: 14, width: 1, height: 1 }), /* @__PURE__ */ Ce.createElement("rect", { x: 18, y: 16, width: 1, height: 1 }), /* @__PURE__ */ Ce.createElement("path", { d: "M15.5,7h-9C6.224,7,6,7.224,6,7.5v9C6,16.776,6.224,17,6.5,17h9c0.276,0,0.5-0.224,0.5-0.5v-9C16,7.224,15.776,7,15.5,7z  M15,16H7V8h8V16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9.5,11h3c0.276,0,0.5-0.224,0.5-0.5S12.776,10,12.5,10h-3C9.224,10,9,10.224,9,10.5S9.224,11,9.5,11z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9.5,14h3c0.276,0,0.5-0.224,0.5-0.5S12.776,13,12.5,13h-3C9.224,13,9,13.224,9,13.5S9.224,14,9.5,14z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), nq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M5.979,0.355c-0.128-0.422-0.829-0.422-0.957,0L1.07,13.396v0.001l-1.048,3.459C0.007,16.902,0,16.951,0,17 c0,1.103,0.897,2,2,2h3v4.5C5,23.776,5.224,24,5.5,24S6,23.776,6,23.5V19h3c1.103,0,2-0.897,2-2c0-0.049-0.007-0.098-0.021-0.145 L5.979,0.355z M2.989,10.51c0.48-0.001,0.945,0.156,1.312,0.472C4.746,11.362,5,11.916,5,12.5v1.887 c-0.117-0.134-0.226-0.273-0.361-0.393c-0.676-0.594-1.525-0.927-2.409-0.978L2.989,10.51z M6,12.5 c0-0.583,0.254-1.136,0.696-1.517c0.368-0.317,0.836-0.476,1.314-0.474l0.76,2.508c-0.888,0.052-1.738,0.386-2.414,0.98 C6.223,14.115,6.115,14.254,6,14.387V12.5z M5.5,2.224l2.211,7.298c-0.609,0.06-1.193,0.297-1.667,0.704 C6.028,10.24,6.017,10.258,6,10.273V7.5C6,7.224,5.776,7,5.5,7S5,7.224,5,7.5v2.772c-0.017-0.015-0.029-0.034-0.047-0.05 C4.48,9.816,3.897,9.582,3.288,9.523L5.5,2.224z M2,18c-0.529,0-0.963-0.413-0.998-0.934l0.924-3.049 c0.749-0.021,1.483,0.228,2.053,0.728C4.628,15.315,5,16.137,5,17v1H2z M9,18H6v-1c0-0.861,0.371-1.683,1.018-2.252 c0.569-0.5,1.305-0.748,2.056-0.73l0.924,3.049C9.963,17.587,9.529,18,9,18z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,10.5c0-3.859-3.14-7-7-7s-7,3.141-7,7c0,3.69,2.874,6.717,6.5,6.975V23.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5v-6.025C20.626,17.217,23.5,14.19,23.5,10.5z M17,16.475V15.5c0-1.342,0.924-2.642,2.148-3.022 c0.264-0.082,0.411-0.362,0.329-0.626c-0.082-0.263-0.36-0.411-0.626-0.329c-0.73,0.228-1.363,0.688-1.852,1.278V8.5 C17,8.224,16.776,8,16.5,8S16,8.224,16,8.5v2.28C15.468,10.301,14.771,10,14,10c-0.276,0-0.5,0.224-0.5,0.5S13.724,11,14,11 c1.103,0,2,0.897,2,2v3.475c-3.075-0.256-5.5-2.835-5.5-5.975c0-3.309,2.691-6,6-6s6,2.691,6,6 C22.5,13.64,20.075,16.219,17,16.475z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisible_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), rq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M7.203,8.492c-0.22,0.22-0.347,0.503-0.431,0.811l-0.01-0.005L0.191,21.606c-0.339,0.636-0.225,1.406,0.285,1.917 c0.314,0.314,0.729,0.479,1.148,0.479c0.262-0.001,0.525-0.064,0.77-0.194l12.296-6.557c0.321-0.085,0.604-0.23,0.822-0.449 c1.201-1.201,0.321-3.895-2.047-6.264C11.194,8.271,8.37,7.323,7.203,8.492z M1.924,22.926c-0.244,0.132-0.541,0.089-0.739-0.109 c-0.197-0.197-0.241-0.494-0.11-0.739l5.814-10.892c0.366,1.12,1.178,2.386,2.361,3.57c1.15,1.15,2.434,1.979,3.581,2.354 L1.924,22.926z M14.806,16.096c-0.159,0.159-0.404,0.24-0.729,0.24c-1.114,0-2.73-0.898-4.12-2.287 c-2.03-2.032-2.708-4.188-2.047-4.85C8.069,9.04,8.314,8.96,8.638,8.96c1.113,0,2.73,0.897,4.121,2.286 C14.79,13.278,15.468,15.434,14.806,16.096z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M23.818,11.863c-2.128-2.127-5.593-2.127-7.725,0c-0.195,0.194-0.195,0.512,0,0.707s0.512,0.195,0.707,0 c1.74-1.738,4.572-1.736,6.311,0c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146 C24.014,12.375,24.014,12.059,23.818,11.863z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M11.415,7.893c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146c1.032-1.031,1.601-2.402,1.601-3.861 S13.154,1.2,12.122,0.168c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707c0.843,0.844,1.308,1.965,1.308,3.156 s-0.465,2.312-1.308,3.154C11.22,7.381,11.22,7.697,11.415,7.893z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.075,8.75c0.053,0,0.105-0.008,0.158-0.025l3.509-1.168c0.262-0.088,0.403-0.37,0.316-0.633 c-0.088-0.262-0.371-0.403-0.633-0.316l-3.509,1.168c-0.262,0.088-0.403,0.37-0.316,0.633C17.671,8.617,17.865,8.75,18.075,8.75z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M15.578,6.387c0.053,0.018,0.105,0.025,0.158,0.025c0.209,0,0.404-0.133,0.475-0.342l1.17-3.51 c0.087-0.262-0.055-0.545-0.316-0.633c-0.26-0.085-0.544,0.055-0.633,0.316l-1.17,3.51C15.175,6.016,15.316,6.299,15.578,6.387z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M15.566,9.252c0.267,0,0.519-0.104,0.707-0.293c0.39-0.39,0.39-1.024,0-1.416c-0.377-0.377-1.036-0.378-1.415,0.001 c-0.389,0.391-0.389,1.025,0.001,1.415C15.048,9.147,15.3,9.252,15.566,9.252z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.134,6.327c0.268,0,0.519-0.104,0.707-0.294c0.39-0.39,0.39-1.024,0-1.414c-0.377-0.377-1.037-0.377-1.414,0 c-0.39,0.39-0.39,1.024-0.001,1.413C7.615,6.223,7.866,6.327,8.134,6.327z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M19.908,5.095c0.267,0,0.518-0.104,0.707-0.292c0.39-0.39,0.39-1.024,0-1.414c-0.377-0.377-1.037-0.377-1.414,0 c-0.39,0.39-0.39,1.024,0.001,1.415C19.391,4.991,19.642,5.095,19.908,5.095z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.538,13.393c-0.39,0.39-0.39,1.024,0,1.414c0.188,0.188,0.44,0.293,0.707,0.293s0.519-0.104,0.707-0.293 c0.39-0.39,0.39-1.024,0-1.414C19.575,13.016,18.915,13.016,18.538,13.393z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), iq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,6h-7C16.224,6,16,6.224,16,6.5S16.224,7,16.5,7H23v3H1V7h6.5C7.776,7,8,6.776,8,6.5S7.776,6,7.5,6h-7 C0.224,6,0,6.224,0,6.5v16C0,22.776,0.224,23,0.5,23h23c0.276,0,0.5-0.224,0.5-0.5v-16C24,6.224,23.776,6,23.5,6z M1,22V11h22v11 H1z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,15h4c0.276,0,0.5-0.224,0.5-0.5S16.776,14,16.5,14h-4c-0.276,0-0.5,0.224-0.5,0.5S12.224,15,12.5,15z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.5,16h-6c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h6c0.276,0,0.5-0.224,0.5-0.5S18.776,16,18.5,16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,18h-5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h5c0.276,0,0.5-0.224,0.5-0.5S17.776,18,17.5,18z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9.5,9h5C14.776,9,15,8.776,15,8.5V4c0-1.654-1.346-3-3-3S9,2.346,9,4v4.5C9,8.776,9.224,9,9.5,9z M10,4 c0-1.104,0.897-2,2-2s2,0.896,2,2v4h-4V4z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.401,16.424C8.77,16.061,9,15.558,9,15c0-1.104-0.897-2-2-2s-2,0.896-2,2c0,0.558,0.23,1.061,0.599,1.424 C4.653,17.014,4,18.164,4,19.5C4,19.776,4.224,20,4.5,20h5c0.276,0,0.5-0.224,0.5-0.5C10,18.164,9.347,17.014,8.401,16.424z  M6,15c0-0.551,0.449-1,1-1s1,0.449,1,1c0,0.551-0.449,1-1,1S6,15.551,6,15z M5.04,19c0.186-1.14,0.994-2,1.96-2 s1.774,0.86,1.96,2H5.04z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), oq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.691,4.536c-0.186-0.076-0.401-0.034-0.545,0.108c-1.034,1.034-4.309,1.729-8.148,1.729 c-3.838,0-7.11-0.695-8.145-1.729C6.711,4.502,6.495,4.46,6.309,4.536C6.122,4.613,6,4.796,6,4.998V13.5C6,19.275,12.795,24,15,24 s9-4.725,9-10.5V4.998C24,4.796,23.878,4.613,23.691,4.536z M23,13.5c0,5.346-6.381,9.5-8,9.5s-8-4.154-8-9.5V5.971 c1.862,1.022,5.201,1.403,7.998,1.403c2.798,0,6.139-0.381,8.002-1.403V13.5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M1,9V1.473c1.862,1.022,5.201,1.403,7.998,1.403c0.001,0,0.001,0,0.002,0c2.797,0,6.138-0.382,8-1.403V4 c0,0.276,0.224,0.5,0.5,0.5S18,4.276,18,4V0.5c0-0.202-0.122-0.385-0.309-0.462c-0.186-0.076-0.402-0.035-0.545,0.108 C16.112,1.181,12.839,1.875,9,1.876c-0.001,0-0.001,0-0.002,0c-3.838,0-7.11-0.695-8.145-1.729 C0.711,0.004,0.495-0.037,0.309,0.038C0.122,0.115,0,0.298,0,0.5V9c0,2.919,1.676,5.332,3.082,6.843 c0.099,0.105,0.232,0.159,0.366,0.159c0.122,0,0.244-0.044,0.341-0.134c0.202-0.188,0.213-0.505,0.025-0.707 C2.53,13.782,1,11.594,1,9z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,16.498c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5 c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,1.379-1.121,2.5-2.5,2.5S12.5,17.877,12.5,16.498z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17,12.498c0.276,0,0.5-0.224,0.5-0.5c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 c0-1.103-0.897-2-2-2s-2,0.897-2,2C16.5,12.274,16.724,12.498,17,12.498z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,11.998c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5c0-1.103-0.897-2-2-2s-2,0.897-2,2c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5c0-0.552,0.448-1,1-1S12.5,11.446,12.5,11.998z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), aq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.691,4.536c-0.186-0.076-0.401-0.034-0.545,0.108c-1.034,1.034-4.309,1.729-8.148,1.729 c-3.838,0-7.11-0.695-8.145-1.729C6.711,4.502,6.495,4.46,6.309,4.536C6.122,4.613,6,4.796,6,4.998V13.5C6,19.275,12.795,24,15,24 s9-4.725,9-10.5V4.998C24,4.796,23.878,4.613,23.691,4.536z M23,13.5c0,5.346-6.381,9.5-8,9.5s-8-4.154-8-9.5V5.971 c1.862,1.022,5.201,1.403,7.998,1.403c2.798,0,6.139-0.381,8.002-1.403V13.5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M1,9V1.473c1.862,1.022,5.201,1.403,7.998,1.403c0.001,0,0.001,0,0.002,0c2.797,0,6.138-0.382,8-1.403V4 c0,0.276,0.224,0.5,0.5,0.5S18,4.276,18,4V0.5c0-0.202-0.122-0.385-0.309-0.462c-0.186-0.076-0.402-0.035-0.545,0.108 C16.112,1.181,12.839,1.875,9,1.876c-0.001,0-0.001,0-0.002,0c-3.838,0-7.11-0.695-8.145-1.729 C0.711,0.004,0.495-0.037,0.309,0.038C0.122,0.115,0,0.298,0,0.5V9c0,2.919,1.676,5.332,3.082,6.843 c0.099,0.105,0.232,0.159,0.366,0.159c0.122,0,0.244-0.044,0.341-0.134c0.202-0.188,0.213-0.505,0.025-0.707 C2.53,13.782,1,11.594,1,9z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,16.498c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5 c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,1.379-1.121,2.5-2.5,2.5S12.5,17.877,12.5,16.498z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17,12.498c0.276,0,0.5-0.224,0.5-0.5c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5 c0-1.103-0.897-2-2-2s-2,0.897-2,2C16.5,12.274,16.724,12.498,17,12.498z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,11.998c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5c0-1.103-0.897-2-2-2s-2,0.897-2,2c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5c0-0.552,0.448-1,1-1S12.5,11.446,12.5,11.998z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisble_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), sq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M14.972,5H13.28l-0.861-1.724c-0.17-0.339-0.725-0.339-0.895,0L10.663,5H8.972C8.753,5,8.56,5.143,8.494,5.352 C8.43,5.561,8.508,5.788,8.688,5.912l1.479,1.019L9.5,8.834C9.427,9.042,9.498,9.273,9.676,9.403s0.42,0.129,0.596-0.003 l1.7-1.275l1.7,1.275c0.089,0.066,0.194,0.1,0.3,0.1c0.098,0,0.196-0.029,0.281-0.086c0.177-0.12,0.257-0.339,0.201-0.545 l-0.528-1.941l1.35-1.03c0.17-0.13,0.238-0.354,0.17-0.558S15.187,5,14.972,5z M13.106,7.726L12.271,7.1 c-0.089-0.067-0.194-0.1-0.3-0.1s-0.211,0.033-0.3,0.1l-0.684,0.512l0.25-0.711c0.075-0.213-0.002-0.449-0.188-0.578L10.58,6 h0.392c0.189,0,0.362-0.106,0.447-0.276l0.553-1.105l0.553,1.105C12.609,5.894,12.782,6,12.972,6h0.521l-0.442,0.338 c-0.161,0.124-0.232,0.333-0.179,0.529L13.106,7.726z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M24.004,2.752L24.002,2.5c0-0.276-0.224-0.5-0.5-0.5h-2.027c0.019-0.482,0.032-0.975,0.032-1.5 c0-0.276-0.224-0.5-0.5-0.5h-18c-0.276,0-0.5,0.224-0.5,0.5c0,0.526,0.014,1.018,0.032,1.5H0.507c-0.276,0-0.5,0.224-0.5,0.5 L0.004,2.771C-0.013,4.139-0.059,7.771,1.87,9.726c0.771,0.78,1.773,1.189,2.966,1.25c1.058,1.52,2.309,2.278,3.384,2.924 c1.356,0.815,2.252,1.354,2.252,3.092C10.412,20.33,8.91,21,6.507,21c-0.276,0-0.5,0.224-0.5,0.5v2c0,0.276,0.224,0.5,0.5,0.5h11 c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5c-2.866,0-4.035-1.159-4.035-4c0-1.753,0.907-2.298,2.281-3.124 c1.075-0.646,2.324-1.402,3.385-2.9c1.197-0.06,2.204-0.47,2.979-1.254C24.06,7.759,24.02,4.122,24.004,2.752z M2.582,9.022 C1.033,7.455,0.989,4.386,1.002,3h1.592c0.208,3.163,0.809,5.342,1.602,6.892C3.563,9.752,3.026,9.472,2.582,9.022z  M15.237,13.019c-1.422,0.855-2.766,1.663-2.766,3.981c0,3.241,1.444,4.837,4.535,4.988V23h-10v-1.012 c3.023-0.15,4.406-1.703,4.465-4.988c0-2.312-1.329-3.111-2.736-3.958c-1.038-0.624-2.188-1.325-3.145-2.732 c-0.014-0.032-0.036-0.056-0.055-0.084C4.411,8.525,3.564,5.815,3.51,1h16.994c-0.006,0.49-0.023,0.949-0.045,1.396 c-0.007,0.035-0.021,0.067-0.021,0.104c0,0.026,0.011,0.05,0.015,0.075C20.049,10.125,17.4,11.719,15.237,13.019z M19.789,9.891 c0.806-1.549,1.418-3.726,1.63-6.891h1.587c0.011,1.396-0.046,4.448-1.6,6.019C20.96,9.47,20.421,9.75,19.789,9.891z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), lq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M16.5,6H14V1h1c0.276,0,0.5-0.224,0.5-0.5S15.276,0,15,0H9C8.724,0,8.5,0.224,8.5,0.5S8.724,1,9,1h1v5H7.5 C6.122,6,5,7.122,5,8.5v12C5,21.878,6.122,23,7.5,23H8v0.5C8,23.776,8.224,24,8.5,24S9,23.776,9,23.5V23h6v0.5 c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V23h0.5c1.378,0,2.5-1.122,2.5-2.5v-12C19,7.122,17.878,6,16.5,6z M11,1h2v5h-2V1z  M18,20.5c0,0.827-0.673,1.5-1.5,1.5h-9C6.673,22,6,21.327,6,20.5v-12C6,7.673,6.673,7,7.5,7h9C17.327,7,18,7.673,18,8.5V20.5z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M15.5,9h-7C8.224,9,8,9.224,8,9.5S8.224,10,8.5,10H9v0.5C9,10.776,9.224,11,9.5,11s0.5-0.224,0.5-0.5V10h5.5 c0.276,0,0.5-0.224,0.5-0.5S15.776,9,15.5,9z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M15.5,15h-7C8.224,15,8,15.224,8,15.5v3C8,19.327,8.673,20,9.5,20h5c0.827,0,1.5-0.673,1.5-1.5v-3 C16,15.224,15.776,15,15.5,15z M15,18.5c0,0.276-0.224,0.5-0.5,0.5h-5C9.224,19,9,18.776,9,18.5V16h6V18.5z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "invisible_shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), uq = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "24px", height: "24px", viewBox: "0 0 24 24", enableBackground: "new 0 0 24 24", xmlSpace: "preserve", ...n }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons_1_" }, /* @__PURE__ */ Ce.createElement("g", { id: "Outline_Icons" }, /* @__PURE__ */ Ce.createElement("g", null, /* @__PURE__ */ Ce.createElement("path", { d: "M23.5,6h-7C16.224,6,16,6.224,16,6.5S16.224,7,16.5,7H23v3H1V7h6.5C7.776,7,8,6.776,8,6.5S7.776,6,7.5,6h-7 C0.224,6,0,6.224,0,6.5v16C0,22.776,0.224,23,0.5,23h23c0.276,0,0.5-0.224,0.5-0.5v-16C24,6.224,23.776,6,23.5,6z M1,22V11h22v11 H1z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M12.5,15h4c0.276,0,0.5-0.224,0.5-0.5S16.776,14,16.5,14h-4c-0.276,0-0.5,0.224-0.5,0.5S12.224,15,12.5,15z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M18.5,16h-6c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h6c0.276,0,0.5-0.224,0.5-0.5S18.776,16,18.5,16z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M17.5,18h-5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h5c0.276,0,0.5-0.224,0.5-0.5S17.776,18,17.5,18z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M9.5,9h5C14.776,9,15,8.776,15,8.5V4c0-1.654-1.346-3-3-3S9,2.346,9,4v4.5C9,8.776,9.224,9,9.5,9z M10,4 c0-1.104,0.897-2,2-2s2,0.896,2,2v4h-4V4z" }), /* @__PURE__ */ Ce.createElement("path", { d: "M8.401,16.424C8.77,16.061,9,15.558,9,15c0-1.104-0.897-2-2-2s-2,0.896-2,2c0,0.558,0.23,1.061,0.599,1.424 C4.653,17.014,4,18.164,4,19.5C4,19.776,4.224,20,4.5,20h5c0.276,0,0.5-0.224,0.5-0.5C10,18.164,9.347,17.014,8.401,16.424z  M6,15c0-0.551,0.449-1,1-1s1,0.449,1,1c0,0.551-0.449,1-1,1S6,15.551,6,15z M5.04,19c0.186-1.14,0.994-2,1.96-2 s1.774,0.86,1.96,2H5.04z" }))), /* @__PURE__ */ Ce.createElement("g", { id: "New_icons_1_" })), /* @__PURE__ */ Ce.createElement("g", { id: "Invisible_Shape" }, /* @__PURE__ */ Ce.createElement("rect", { fill: "none", width: 24, height: 24 }))), cq = (n) => {
  const { type: e } = n;
  return e ? e === "charity" ? /* @__PURE__ */ Re(BV, { className: Ci.eventIcon }) : e === "comedy" ? /* @__PURE__ */ Re(FV, { className: Ci.eventIcon }) : e === "concert" ? /* @__PURE__ */ Re(UV, { className: Ci.eventIcon }) : e === "conference" ? /* @__PURE__ */ Re(HV, { className: Ci.eventIcon }) : e === "culinary" ? /* @__PURE__ */ Re(zV, { className: Ci.eventIcon }) : e === "dance" ? /* @__PURE__ */ Re(VV, { className: Ci.eventIcon }) : e === "education" ? /* @__PURE__ */ Re(qV, { className: Ci.eventIcon }) : e === "exhibition" ? /* @__PURE__ */ Re(GV, { className: Ci.eventIcon }) : e === "fair" ? /* @__PURE__ */ Re(WV, { className: Ci.eventIcon }) : e === "festival" ? /* @__PURE__ */ Re($V, { className: Ci.eventIcon }) : e === "film" ? /* @__PURE__ */ Re(YV, { className: Ci.eventIcon }) : e === "health" ? /* @__PURE__ */ Re(XV, { className: Ci.eventIcon }) : e === "lan-party" ? /* @__PURE__ */ Re(KV, { className: Ci.eventIcon }) : e === "leisure" ? /* @__PURE__ */ Re(QV, { className: Ci.eventIcon }) : e === "market" ? /* @__PURE__ */ Re(ZV, { className: Ci.eventIcon }) : e === "meeting" ? /* @__PURE__ */ Re(JV, { className: Ci.eventIcon }) : e === "musical" ? /* @__PURE__ */ Re(eq, { className: Ci.eventIcon }) : e === "other" ? /* @__PURE__ */ Re(tq, { className: Ci.eventIcon }) : e === "outdoor" ? /* @__PURE__ */ Re(nq, { className: Ci.eventIcon }) : e === "party" ? /* @__PURE__ */ Re(rq, { className: Ci.eventIcon }) : e === "seminar" ? /* @__PURE__ */ Re(iq, { className: Ci.eventIcon }) : e === "show" ? /* @__PURE__ */ Re(oq, { className: Ci.eventIcon }) : e === "theater" ? /* @__PURE__ */ Re(aq, { className: Ci.eventIcon }) : e === "tournament" ? /* @__PURE__ */ Re(sq, { className: Ci.eventIcon }) : e === "travelling" ? /* @__PURE__ */ Re(lq, { className: Ci.eventIcon }) : e === "workshop" ? /* @__PURE__ */ Re(uq, { className: Ci.eventIcon }) : null : null;
}, dq = Mn.bind(nd), uoe = (n) => {
  const {
    title: e,
    subtitle: t,
    banner: i,
    logo: c,
    color: a,
    backgroundColor: s,
    type: r,
    status: l,
    popIn: d,
    index: f,
    onClick: h
  } = n, p = dq("eventCard", {
    "eventCard--popIn": d,
    "eventCard--clickable": h
  }), g = {
    backgroundColor: c || i ? s : a,
    animationDelay: f ? `${f * 20}ms` : "0"
  };
  return /* @__PURE__ */ Mt("div", { className: p, style: g, onClick: h, children: [
    /* @__PURE__ */ Mt("div", { className: nd.eventCard__image, children: [
      i && /* @__PURE__ */ Re(
        "div",
        {
          className: nd.eventCard__imageBanner,
          style: { backgroundImage: `url("${i}")` }
        }
      ),
      c && /* @__PURE__ */ Re("div", { className: nd.eventCard__imageLogoWrapper, children: /* @__PURE__ */ Re(
        "img",
        {
          className: nd.eventCard__imageLogo,
          src: c,
          alt: e
        }
      ) }),
      !i && !c && /* @__PURE__ */ Re("div", { className: nd.eventCard__imageIcon, children: /* @__PURE__ */ Re(cq, { type: r }) })
    ] }),
    /* @__PURE__ */ Mt(
      "div",
      {
        className: nd.eventCard__info,
        style: { backgroundColor: a },
        children: [
          /* @__PURE__ */ Mt("div", { className: nd.eventCard__infoText, children: [
            /* @__PURE__ */ Re("h5", { children: e }),
            t && /* @__PURE__ */ Re("h6", { children: t })
          ] }),
          l === "live" && /* @__PURE__ */ Re("div", { className: nd.eventCard__infoBadge, children: /* @__PURE__ */ Re(vm, { content: l, color: "live", pulse: !0 }) }),
          l === "open" && /* @__PURE__ */ Re("div", { className: nd.eventCard__infoBadge, children: /* @__PURE__ */ Re(vm, { content: l, color: "success" }) })
        ]
      }
    )
  ] });
}, fq = "_flexbox_wq94n_1", hq = {
  flexbox: fq
}, pq = Mn.bind(hq), coe = (n) => {
  const { children: e, flexDirection: t, gap: i } = n, c = {
    flexDirection: t ?? "column",
    gap: i ?? "1.5rem"
  }, a = pq("flexbox", {});
  return /* @__PURE__ */ Re("div", { className: a, style: c, children: e });
}, mq = "_prefix_1yooj_1", gq = "_suffix_1yooj_2", _q = "_wrapper_1yooj_22", yq = "_input_1yooj_53", vq = "_password_1yooj_72", bq = "_clear_1yooj_72", Eq = "_eye_1yooj_113", Sq = "_clearButton_1yooj_134", Cq = "_clearButtonIcon_1yooj_152", ec = {
  prefix: mq,
  suffix: gq,
  wrapper: _q,
  "wrapper--error": "_wrapper--error_1yooj_32",
  "wrapper--size-small": "_wrapper--size-small_1yooj_46",
  input: yq,
  password: vq,
  clear: bq,
  "input--size-small": "_input--size-small_1yooj_103",
  eye: Eq,
  clearButton: Sq,
  clearButtonIcon: Cq
}, wq = "_error_8i8ub_1", xq = {
  error: wq
}, Xh = (n) => {
  const { name: e } = n;
  return /* @__PURE__ */ Re(xz, { name: e, component: "div", className: xq.error });
}, Kb = Mn.bind(ec), doe = (n) => {
  const {
    autoComplete: e,
    name: t,
    password: i,
    placeholder: c = "",
    autoFocus: a,
    type: s,
    disabled: r,
    prefix: l,
    suffix: d,
    min: f = 0,
    max: h = "any",
    step: p = "any",
    onPaste: g,
    onBlur: _,
    clearButton: b = !1,
    size: v = "medium"
  } = n, { errors: E, touched: C, values: y, setFieldValue: T } = gd(), [A, k] = Wn(!!i), N = Kb("wrapper", {
    "wrapper--error": t in E && t in C && !r,
    [`wrapper--size-${v}`]: !!v
  }), j = Kb("input", {
    password: i,
    clear: b,
    "input--error": t in E && t in C && !r,
    [`input--size-${v}`]: !!v
  }), I = () => i ? A ? "password" : "text" : s ?? "text", B = () => {
    k(!A);
  }, U = () => {
    T(t, "");
  }, H = (Q, Y) => {
    const ie = rr(Q, Y), ce = Y.split(".");
    if (ce.length >= 2) {
      const $ = ce[0];
      if (typeof (Q == null ? void 0 : Q[$]) == "string")
        return !1;
    }
    return typeof ie == "string";
  };
  return /* @__PURE__ */ Mt(pd, { children: [
    /* @__PURE__ */ Mt("div", { className: N, children: [
      l && /* @__PURE__ */ Re("span", { className: ec.prefix, children: l }),
      /* @__PURE__ */ Re(
        Dm,
        {
          className: j,
          id: t,
          type: I(),
          name: t,
          placeholder: c,
          autoComplete: e,
          autoFocus: a,
          disabled: r,
          ...s === "number" ? {
            min: f,
            max: h,
            step: p
          } : {},
          ..._ && { onBlur: _ },
          ...g && { onPaste: g }
        }
      ),
      i && /* @__PURE__ */ Re(
        "button",
        {
          className: ec.eye,
          onClick: B,
          tabIndex: -1,
          type: "button",
          children: A ? /* @__PURE__ */ Re(Ix, {}) : /* @__PURE__ */ Re(N6, {})
        }
      ),
      b && rr(y, t) && /* @__PURE__ */ Re(
        "button",
        {
          className: ec.clearButton,
          type: "button",
          onClick: U,
          children: /* @__PURE__ */ Re(S2, { className: ec.clearButtonIcon })
        }
      ),
      d && /* @__PURE__ */ Re("span", { className: ec.suffix, children: d })
    ] }),
    H(E, t) && rr(C, t) && /* @__PURE__ */ Re(Xh, { name: t })
  ] });
}, Tq = Ef((n, e) => {
  const {
    autoComplete: t,
    autoFocus: i,
    clearButton: c = !1,
    disabled: a,
    error: s,
    max: r = "any",
    min: l = 0,
    name: d,
    onBlur: f,
    onChange: h,
    onKeyDown: p,
    onPaste: g,
    password: _,
    placeholder: b = "",
    prefix: v,
    size: E = "medium",
    step: C = "any",
    suffix: y,
    type: T,
    value: A
  } = n, [k, N] = Wn(!0), j = () => {
    N(!k);
  }, I = () => {
    h("");
  }, B = (Q) => {
    h(Q.target.value);
  }, U = Kb("wrapper", {
    "wrapper--error": s && !a,
    [`wrapper--size-${E}`]: !!E
  }), H = Kb("input", {
    password: _,
    clear: c,
    "input--error": s && !a,
    [`input--size-${E}`]: !!E
  });
  return /* @__PURE__ */ Re(pd, { children: /* @__PURE__ */ Mt("div", { className: U, children: [
    v && /* @__PURE__ */ Re("span", { className: ec.prefix, children: v }),
    /* @__PURE__ */ Re(
      "input",
      {
        ref: e,
        className: H,
        name: d,
        type: _ ? k ? "password" : "text" : T || "text",
        placeholder: b,
        autoComplete: t,
        autoFocus: i,
        disabled: a,
        value: A,
        onChange: B,
        ...T === "number" ? {
          min: l,
          max: r,
          step: C
        } : {},
        ...f && { onBlur: f },
        ...p && { onKeyDown: p },
        ...g && { onPaste: g }
      }
    ),
    _ && /* @__PURE__ */ Re(
      "button",
      {
        className: ec.eye,
        onClick: j,
        tabIndex: -1,
        type: "button",
        children: k ? /* @__PURE__ */ Re(Ix, {}) : /* @__PURE__ */ Re(N6, {})
      }
    ),
    c && A && /* @__PURE__ */ Re(
      "button",
      {
        className: ec.clearButton,
        type: "button",
        onClick: I,
        children: /* @__PURE__ */ Re(S2, { className: ec.clearButtonIcon })
      }
    ),
    y && /* @__PURE__ */ Re("span", { className: ec.suffix, children: y })
  ] }) });
});
Tq.displayName = "Input";
const Aq = "_formgrid_d5sm5_1", kq = {
  formgrid: Aq
}, Oq = Mn.bind(kq), foe = (n) => {
  const { children: e } = n, t = {}, i = Oq("formgrid", {});
  return /* @__PURE__ */ Re("div", { className: i, style: t, children: e });
}, Dq = "_mediaupload_nrinr_1", Rq = "_mediaupload__preview_nrinr_1", Nq = "_mediaupload__actions_nrinr_19", Iq = "_preview__content_nrinr_22", Lq = "_preview__icon_nrinr_30", Mq = "_preview__title_nrinr_39", Pq = "_title__browse_nrinr_46", jq = "_mediaupload__image_nrinr_51", Bq = "_mediaupload__drop_nrinr_58", Fq = "_mediaupload__loading_nrinr_67", Uq = "_mediaupload__modal_nrinr_78", Hq = "_modal__icon_nrinr_93", zq = "_modal__title_nrinr_102", Vq = "_modal__info_nrinr_108", qq = "_modal__actions_nrinr_115", Gq = "_modal__button_nrinr_121", Wq = "_actionbutton_nrinr_168", rd = {
  mediaupload: Dq,
  mediaupload__preview: Rq,
  "mediaupload__preview--hasimage": "_mediaupload__preview--hasimage_nrinr_13",
  mediaupload__actions: Nq,
  preview__content: Iq,
  preview__icon: Lq,
  preview__title: Mq,
  title__browse: Pq,
  mediaupload__image: jq,
  mediaupload__drop: Bq,
  mediaupload__loading: Fq,
  mediaupload__modal: Uq,
  modal__icon: Hq,
  modal__title: zq,
  modal__info: Vq,
  modal__actions: qq,
  modal__button: Gq,
  "modal__button--danger": "_modal__button--danger_nrinr_142",
  "modal__button--link": "_modal__button--link_nrinr_148",
  actionbutton: Wq,
  "actionbutton--danger": "_actionbutton--danger_nrinr_192"
}, $q = "_modal_aun4i_1", Yq = "_modal__overlay_aun4i_20", Xq = "_modal__box_aun4i_25", Kq = "_modal__close_aun4i_34", Qq = "_modal__content_aun4i_58", Zq = "_modal__contentIcon_aun4i_61", Jq = "_modal__contentInner_aun4i_93", nm = {
  modal: $q,
  "modal--align-center": "_modal--align-center_aun4i_11",
  "modal--align-start": "_modal--align-start_aun4i_14",
  "modal--align-end": "_modal--align-end_aun4i_17",
  modal__overlay: Yq,
  modal__box: Xq,
  modal__close: Kq,
  modal__content: Qq,
  modal__contentIcon: Zq,
  "modal__contentIcon-info": "_modal__contentIcon-info_aun4i_75",
  "modal__contentIcon-success": "_modal__contentIcon-success_aun4i_78",
  "modal__contentIcon-warning": "_modal__contentIcon-warning_aun4i_81",
  "modal__contentIcon-error": "_modal__contentIcon-error_aun4i_84",
  "modal__contentIcon-subtle": "_modal__contentIcon-subtle_aun4i_87",
  "modal__contentIcon-disabled": "_modal__contentIcon-disabled_aun4i_90",
  modal__contentInner: Jq
}, x4 = Mn.bind(nm), eG = (n) => {
  const {
    isVisible: e,
    closeModal: t,
    children: i,
    iconColor: c,
    align: a = "center",
    maxWidth: s = "25rem"
  } = n, r = zn(null), l = (p) => {
    if (r.current && !r.current.contains(p.target)) {
      if (!t) return;
      t();
    }
  }, d = hr(
    (p) => {
      t && p.key === "Escape" && t();
    },
    [t]
  );
  An(() => {
    e ? (document.body.style.overflow = "hidden", document.addEventListener("keydown", d)) : (document.body.style.overflow = "auto", document.removeEventListener("keydown", d));
  }, [e, d]);
  const f = x4("modal__contentIcon", {
    [`modal__contentIcon-${c}`]: !!c
  }), h = x4("modal", {
    [`modal--align-${a}`]: !!a
  });
  return e ? /* @__PURE__ */ Mt("div", { className: h, onClick: l, children: [
    /* @__PURE__ */ Re("div", { className: nm.modal__overlay }),
    /* @__PURE__ */ Mt(
      "div",
      {
        ref: r,
        className: nm.modal__box,
        style: {
          maxWidth: typeof s == "number" ? `${s}px` : s
        },
        children: [
          t && /* @__PURE__ */ Re(
            "button",
            {
              className: nm.modal__close,
              onClick: t,
              children: /* @__PURE__ */ Re(k6, {})
            }
          ),
          /* @__PURE__ */ Mt("div", { className: nm.modal__content, children: [
            n.icon && /* @__PURE__ */ Re("div", { className: f, children: /* @__PURE__ */ Re(n.icon, { className: nm.icon }) }),
            /* @__PURE__ */ Re("div", { className: nm.modal__contentInner, children: i })
          ] })
        ]
      }
    )
  ] }) : null;
}, tG = "_modalButtons_n8fjk_1", nG = {
  modalButtons: tG
}, rG = (n) => {
  const { children: e } = n;
  return /* @__PURE__ */ Re("div", { className: nG.modalButtons, children: e });
}, iG = "_message_qkdib_1", oG = "_popIn_qkdib_1", aG = "_message__title_qkdib_32", sG = "_message__icon_qkdib_86", lG = "_message__content_qkdib_99", uG = "_message__message_qkdib_112", cG = "_message__children_qkdib_118", n1 = {
  message: iG,
  "message--animate": "_message--animate_qkdib_21",
  popIn: oG,
  "message--clickable": "_message--clickable_qkdib_25",
  "message--default": "_message--default_qkdib_28",
  message__title: aG,
  "message--info": "_message--info_qkdib_35",
  "message--success": "_message--success_qkdib_38",
  "message--error": "_message--error_qkdib_41",
  "message--warning": "_message--warning_qkdib_44",
  "message--noMargin": "_message--noMargin_qkdib_47",
  "message--variant-outline": "_message--variant-outline_qkdib_50",
  message__icon: sG,
  message__content: lG,
  "message__title--noMarginTop": "_message__title--noMarginTop_qkdib_106",
  "message__title--noMarginBottom": "_message__title--noMarginBottom_qkdib_109",
  message__message: uG,
  message__children: cG,
  "message--alert": "_message--alert_qkdib_132"
}, T4 = Mn.bind(n1), fw = (n) => {
  const {
    alert: e,
    animate: t = !0,
    autoClose: i,
    autoCloseTime: c = 5e3,
    children: a,
    icon: s,
    message: r,
    noMargin: l,
    onClick: d,
    title: f,
    type: h = "default",
    variant: p = "fill"
  } = n, [g, _] = Wn(!1);
  An(() => {
    if (i) {
      const E = setTimeout(() => {
        _(!0);
      }, c);
      return () => clearTimeout(E);
    } else
      return;
  }, []);
  const b = T4("message", {
    [`message--${h}`]: !0,
    "message--alert": !!e,
    "message--noMargin": !!l,
    "message--clickable": !!d,
    "message--animate": !!t,
    [`message--variant-${p}`]: !!p
  }), v = T4("message__title", {
    "message__title--noMarginTop": !!s,
    "message__title--noMarginBottom": !!r
  });
  return g ? null : /* @__PURE__ */ Mt("div", { className: b, onClick: d, children: [
    s && /* @__PURE__ */ Re("div", { className: n1.message__icon, children: s }),
    /* @__PURE__ */ Mt("div", { className: n1.message__content, children: [
      f && /* @__PURE__ */ Re("h4", { className: v, children: f }),
      r && typeof r == "string" ? /* @__PURE__ */ Re("p", { className: n1.message__message, children: r }) : Array.isArray(r) && r.map((E, C) => /* @__PURE__ */ Re("p", { children: E }, C))
    ] }),
    a && /* @__PURE__ */ Re("div", { className: n1.message__children, children: a })
  ] });
}, dG = Mn.bind(rd), hoe = (n) => {
  const {
    image: e,
    aspectRatio: t,
    type: i,
    maxFileSize: c = 10,
    onChange: a,
    onRemove: s,
    translations: r
    //onColors,
  } = n, { accountId: l, apiClient: d } = U6(), f = ["image/png", "image/jpg", "image/jpeg"], h = zn(null), p = zn(0), [g, _] = Wn(!1), [b, v] = Wn(!1), [E, C] = Wn(null), [y, T] = Wn(!1), [A, k] = Wn(!1), N = dG("mediaupload__preview", {
    "mediaupload__preview--hasimage": !!e
  });
  An(() => {
  }, []);
  const j = () => {
    _(!1);
  }, I = () => {
    var te;
    (te = h.current) == null || te.click();
  }, B = (te) => {
    te.stopPropagation(), te.preventDefault(), T(!0), te.dataTransfer.dropEffect = "copy", p.current && clearTimeout(p.current);
  }, U = (te) => {
    te.stopPropagation(), te.preventDefault(), p.current = setTimeout(() => {
      T(!1);
    }, 100);
  }, H = (te) => {
    te.stopPropagation(), te.preventDefault(), T(!1);
    const K = te.dataTransfer.files;
    K.length && Y(K[0]);
  }, Q = function(te) {
    const V = te.target.files;
    !V || !V.length || Y(V[0]);
  }, Y = async (te) => {
    if (C(null), v(!0), T(!1), !d || !l) {
      C("upload_error"), v(!1);
      return;
    }
    if (!f.includes(te.type)) {
      C("invalid_file_type"), v(!1);
      return;
    }
    if (te.size > c * 1e6) {
      C("max_file_size"), v(!1);
      return;
    }
    try {
      const V = await (d == null ? void 0 : d.uploadMedia(l, i, te));
      a(V.media);
    } catch (V) {
      C("upload_error"), d != null && d.isApiError(V) && console.log(V.response.body);
    } finally {
      v(!1);
    }
  }, ie = () => {
    k(!0);
  }, ce = () => {
    k(!1), s && s();
  }, $ = () => {
    k(!1);
  };
  return /* @__PURE__ */ Mt("div", { className: rd.mediaupload, children: [
    E == "upload_error" && /* @__PURE__ */ Re(
      fw,
      {
        type: "error",
        message: r.errors.upload_error,
        alert: !0
      }
    ),
    E == "max_file_size" && /* @__PURE__ */ Re(
      fw,
      {
        type: "error",
        message: r.errors.max_file_size,
        alert: !0
      }
    ),
    E == "invalid_file_type" && /* @__PURE__ */ Re(
      fw,
      {
        type: "error",
        message: r.errors.invalid_file_type,
        alert: !0
      }
    ),
    /* @__PURE__ */ Mt(
      "div",
      {
        className: N,
        onDragOver: B,
        onDragLeave: U,
        onDrop: H,
        style: { aspectRatio: t },
        children: [
          !e && !b && /* @__PURE__ */ Mt("div", { className: rd.preview__content, children: [
            /* @__PURE__ */ Re("div", { className: rd.preview__icon, children: /* @__PURE__ */ Re(T3, {}) }),
            /* @__PURE__ */ Mt("div", { className: rd.preview__title, children: [
              /* @__PURE__ */ Mt("span", { children: [
                r.title,
                /* @__PURE__ */ Re("br", {})
              ] }),
              /* @__PURE__ */ Mt("span", { children: [
                /* @__PURE__ */ Mt("span", { children: [
                  " ",
                  r.title_or,
                  " "
                ] }),
                /* @__PURE__ */ Re(
                  "span",
                  {
                    className: rd.title__browse,
                    onClick: I,
                    children: r.title_browse
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ Re(a0, { variant: "small", noMargin: !0, children: r.supported_files })
          ] }),
          !!e && /* @__PURE__ */ Re(
            "img",
            {
              onLoad: j,
              src: e,
              className: rd.mediaupload__image
            }
          ),
          y && /* @__PURE__ */ Re("div", { className: rd.mediaupload__drop }),
          (g || b) && /* @__PURE__ */ Re("div", { className: rd.mediaupload__loading, children: /* @__PURE__ */ Re(Ux, { size: "small", rotate: !0 }) }),
          !!e && !b && !E && !A && /* @__PURE__ */ Re("div", { className: rd.mediaupload__actions, children: /* @__PURE__ */ Mt(Mj, { children: [
            /* @__PURE__ */ Mt(
              Fh,
              {
                onClick: I,
                color: "primary",
                size: "tiny",
                children: [
                  /* @__PURE__ */ Re(T3, {}),
                  r.actions.replace
                ]
              }
            ),
            /* @__PURE__ */ Mt(
              Fh,
              {
                onClick: ie,
                color: "error",
                size: "tiny",
                children: [
                  /* @__PURE__ */ Re(A3, {}),
                  r.actions.remove
                ]
              }
            )
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ Re(
      "input",
      {
        ref: h,
        onChange: Q,
        type: "file",
        hidden: !0
      }
    ),
    /* @__PURE__ */ Re(
      eG,
      {
        isVisible: A,
        closeModal: $,
        icon: A3,
        iconColor: "error",
        maxWidth: "25rem",
        children: /* @__PURE__ */ Mt("div", { children: [
          /* @__PURE__ */ Re(a0, { variant: "h3", color: "error", children: r.remove.title }),
          /* @__PURE__ */ Mt(rG, { children: [
            /* @__PURE__ */ Re(Fh, { onClick: ce, color: "error", children: r.remove.confirm }),
            /* @__PURE__ */ Re(
              Fh,
              {
                onClick: $,
                color: "subtle",
                variant: "link",
                children: r.remove.cancel
              }
            )
          ] })
        ] })
      }
    )
  ] });
}, fG = "_bottomNavbarItem_1y2vj_1", hG = "_bottomNavbarItem__icon_1y2vj_15", pG = "_bottomNavbarItem__label_1y2vj_27", rm = {
  bottomNavbarItem: fG,
  "bottomNavbarItem--active": "_bottomNavbarItem--active_1y2vj_12",
  bottomNavbarItem__icon: hG,
  bottomNavbarItem__label: pG
}, mG = Mn.bind(rm), poe = (n) => {
  const { label: e, onClick: t, active: i } = n, c = mG([
    "bottomNavbarItem",
    {
      "bottomNavbarItem--active": !!i
    }
  ]);
  return t ? /* @__PURE__ */ Mt("button", { className: c, onClick: t, children: [
    /* @__PURE__ */ Re("span", { className: rm.bottomNavbarItem__icon, children: /* @__PURE__ */ Re(n.icon, { className: rm.bottomNavbarItem__icon }) }),
    e && /* @__PURE__ */ Re("span", { className: rm.bottomNavbarItem__label, children: e })
  ] }) : /* @__PURE__ */ Mt("div", { className: c, children: [
    /* @__PURE__ */ Re("span", { className: rm.bottomNavbarItem__icon, children: /* @__PURE__ */ Re(n.icon, { className: rm.bottomNavbarItem__icon }) }),
    e && /* @__PURE__ */ Re("span", { className: rm.bottomNavbarItem__label, children: e })
  ] });
}, gG = "_topNavbar_1rvpd_1", _G = "_topNavbar__inner_1rvpd_21", O7 = {
  topNavbar: gG,
  "topNavbar--hideOnTablet": "_topNavbar--hideOnTablet_1rvpd_14",
  "topNavbar--noMargin": "_topNavbar--noMargin_1rvpd_18",
  topNavbar__inner: _G
}, yG = Mn.bind(O7), moe = (n) => {
  const { children: e, hideTablet: t, noMargin: i } = n, c = yG([
    "topNavbar",
    {
      "topNavbar--hideOnTablet": t,
      "topNavbar--noMargin": !!i
    }
  ]);
  return /* @__PURE__ */ Re("nav", { className: c, children: /* @__PURE__ */ Re("div", { className: O7.topNavbar__inner, children: e }) });
}, vG = "_topNavbarItem_fgwki_1", bG = "_topNavbarItem__label_fgwki_33", D7 = {
  topNavbarItem: vG,
  "topNavbarItem--active": "_topNavbarItem--active_fgwki_25",
  topNavbarItem__label: bG
}, EG = Mn.bind(D7), goe = (n) => {
  const { label: e, active: t, badge: i } = n, c = EG("topNavbarItem", {
    "topNavbarItem--active": !!t
  });
  return /* @__PURE__ */ Mt("div", { className: c, children: [
    /* @__PURE__ */ Re("span", { className: D7.topNavbarItem__label, children: e }),
    i && /* @__PURE__ */ Re(vm, { size: "tiny", content: i })
  ] });
}, SG = "_navBarListItem_12ftd_1", CG = "_navBarListItem__icon_12ftd_14", wG = "_navBarListItem__label_12ftd_28", xG = "_navBarListItem__badge_12ftd_31", r1 = {
  navBarListItem: SG,
  navBarListItem__icon: CG,
  navBarListItem__label: wG,
  navBarListItem__badge: xG,
  "navBarListItem--active": "_navBarListItem--active_12ftd_45"
}, TG = Mn.bind(r1), _oe = (n) => {
  const { active: e, label: t, badge: i } = n, c = TG("navBarListItem", {
    "navBarListItem--active": e
  });
  return /* @__PURE__ */ Mt("div", { className: c, children: [
    /* @__PURE__ */ Re("div", { className: r1.navBarListItem__icon, children: /* @__PURE__ */ Re(n.icon, { className: r1.icon }) }),
    /* @__PURE__ */ Re("div", { className: r1.navBarListItem__label, children: t }),
    i && /* @__PURE__ */ Re("div", { className: r1.navBarListItem__badge, children: /* @__PURE__ */ Re(vm, { content: i, size: "normal", color: "info" }) })
  ] });
}, AG = "_header_10ddf_1", kG = "_header__inner_10ddf_1", OG = "_header__top_10ddf_7", DG = "_header__content_10ddf_12", RG = "_header__actions_10ddf_18", NG = "_header__titles_10ddf_24", im = {
  header: AG,
  header__inner: kG,
  header__top: OG,
  header__content: DG,
  header__actions: RG,
  header__titles: NG,
  "header--full-width": "_header--full-width_10ddf_45"
}, IG = Mn.bind(im), yoe = (n) => {
  const {
    title: e,
    subtitle: t,
    badge: i,
    badgeColor: c,
    type: a,
    fullWidth: s = !1,
    children: r,
    topAction: l,
    filters: d
  } = n, f = IG("header", {
    "header--section": a === "section",
    "header--with-top": !!l,
    "header--full-width": s
  });
  if (!e && !l) return null;
  const h = () => /* @__PURE__ */ Mt("div", { className: im.header__inner, children: [
    !!l && /* @__PURE__ */ Mt("div", { className: im.header__top, children: [
      /* @__PURE__ */ Re("div", { children: l }),
      !e && r && /* @__PURE__ */ Re("div", { children: r })
    ] }),
    !!e && /* @__PURE__ */ Mt("div", { className: im.header__content, children: [
      /* @__PURE__ */ Mt("div", { className: im.header__titles, children: [
        /* @__PURE__ */ Re(
          a0,
          {
            variant: a === "section" ? "h4" : "h3",
            badge: i,
            badgeColor: c,
            noMargin: !0,
            children: e
          }
        ),
        t && /* @__PURE__ */ Re(a0, { variant: "h6", noMargin: !0, children: t })
      ] }),
      /* @__PURE__ */ Re("div", { className: im.header__actions, children: r })
    ] }),
    !!d && /* @__PURE__ */ Re("div", { className: im.header__filters, children: d })
  ] });
  return s ? /* @__PURE__ */ Re("div", { className: f, children: h() }) : /* @__PURE__ */ Re("div", { className: f, children: /* @__PURE__ */ Re(Lz, { children: h() }) });
}, LG = "_pagination_1lt98_1", MG = "_paginationButtons_1lt98_8", PG = "_paginationText_1lt98_14", jG = "_paginationButton_1lt98_8", BG = "_paginationButton__label_1lt98_83", i1 = {
  pagination: LG,
  paginationButtons: MG,
  paginationText: PG,
  "pagination--dataGrid": "_pagination--dataGrid_1lt98_20",
  paginationButton: jG,
  paginationButton__label: BG,
  "paginationButton--active": "_paginationButton--active_1lt98_98",
  "paginationButton--disabled": "_paginationButton--disabled_1lt98_108"
}, R7 = Mn.bind(i1), voe = (n) => {
  const {
    activePage: e,
    itemsTotal: t,
    itemsPerPage: i,
    setActivePage: c,
    translations: a,
    dataGrid: s = !1
  } = n, r = Math.ceil(t / i), l = Math.max(1, Math.min(e - 1, r - 4)), d = Math.min(r, Math.max(e + 1, 5)), f = l > 2, h = d < r - 1, p = R7("pagination", {
    "pagination--dataGrid": s
  }), g = () => a.active_page.replace(
    "{{ firstItem }}",
    ((e - 1) * i + 1).toString()
  ).replace(
    "{{ lastItem }}",
    Math.min(e * i, t).toString()
  ).replace("{{ totalItems }}", t.toString());
  return t <= i ? null : /* @__PURE__ */ Mt("div", { className: p, children: [
    /* @__PURE__ */ Mt("div", { className: i1.paginationButtons, children: [
      /* @__PURE__ */ Mt(
        Jp,
        {
          onClick: () => c(e - 1),
          disabled: e === 1,
          children: [
            /* @__PURE__ */ Re(D6, {}),
            /* @__PURE__ */ Re("span", { className: i1.paginationButton__label, children: a.back })
          ]
        }
      ),
      l > 1 && /* @__PURE__ */ Re(
        Jp,
        {
          onClick: () => c(1),
          active: e === 1,
          children: "1"
        }
      ),
      f && /* @__PURE__ */ Mt(
        Jp,
        {
          onClick: () => c(l - 1),
          children: [
            "⋯",
            " "
          ]
        }
      ),
      Array.from(
        { length: d - l + 1 },
        (_, b) => b + l
      ).map((_) => /* @__PURE__ */ Re(
        Jp,
        {
          active: e === _,
          onClick: () => c(_),
          children: _
        },
        _
      )),
      h && /* @__PURE__ */ Mt(
        Jp,
        {
          onClick: () => c(d + 1),
          children: [
            "⋯",
            " "
          ]
        }
      ),
      d < r && /* @__PURE__ */ Re(
        Jp,
        {
          active: e === r,
          onClick: () => c(r),
          children: r
        }
      ),
      /* @__PURE__ */ Mt(
        Jp,
        {
          disabled: e === r,
          onClick: () => c(e + 1),
          children: [
            /* @__PURE__ */ Re("span", { className: i1.paginationButton__label, children: a.next }),
            /* @__PURE__ */ Re(R6, {})
          ]
        }
      )
    ] }),
    /* @__PURE__ */ Re("div", { className: i1.paginationText, children: g() })
  ] });
}, Jp = (n) => {
  const { children: e, onClick: t, disabled: i = !1, active: c = !1 } = n, a = R7("paginationButton", {
    "paginationButton--active": c,
    "paginationButton--disabled": i
  });
  return /* @__PURE__ */ Re(
    "button",
    {
      onClick: t,
      disabled: i,
      className: a,
      children: e
    }
  );
}, FG = "_paymentIcon_oagj4_1", UG = {
  paymentIcon: FG,
  "paymentIcon--borderRadius": "_paymentIcon--borderRadius_oagj4_14",
  "paymentIcon--small": "_paymentIcon--small_oagj4_17",
  "paymentIcon--medium": "_paymentIcon--medium_oagj4_21"
}, A4 = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_30)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M33.75 78.75C47.3116 78.75 53.2192 69.0411 60 60H15V78.75H33.75Z", fill: "url(#paint0_linear_1_30)" }), /* @__PURE__ */ Ce.createElement("path", { d: "M86.2501 41.25C72.6885 41.25 66.7809 50.9589 60.0001 60H105V41.25H86.2501Z", fill: "url(#paint1_linear_1_30)" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint0_linear_1_30", x1: 24.1021, y1: 69.208, x2: 57.0215, y2: 56.9808, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "#005AB9" }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "#1E3764" })), /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint1_linear_1_30", x1: 62.7246, y1: 60.9005, x2: 97.6783, y2: 48.9751, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "#FBA900" }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "#FFD800" })), /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_30" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), HG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_34)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "#D50043" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.75 42.5965C33.75 37.7107 37.696 33.75 42.5965 33.75H77.4035C82.2893 33.75 86.25 37.696 86.25 42.5965V86.25H42.5965C37.7107 86.25 33.75 82.304 33.75 77.4035V42.5965ZM45 52.0614V52.9386C45 54.7323 46.4887 56.25 48.3252 56.25H71.6749C73.5123 56.25 75 54.7674 75 52.9386V52.0614C75 50.2677 73.5113 48.75 71.6749 48.75H48.3252C46.4877 48.75 45 50.2326 45 52.0614ZM45 67.0614V67.9386C45 69.7323 46.4887 71.25 48.3252 71.25H71.6749C73.5123 71.25 75 69.7674 75 67.9386V67.0614C75 65.2677 73.5113 63.75 71.6749 63.75H48.3252C46.4877 63.75 45 65.2326 45 67.0614Z", fill: "white" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_34" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), zG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_2_248)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "#F7931A" }), /* @__PURE__ */ Ce.createElement("path", { d: "M91.0276 67.3619C86.6865 84.7728 69.0501 95.3688 51.6352 91.027C34.2275 86.6864 23.6304 69.0509 27.9734 51.6414C32.3126 34.2286 49.949 23.6319 67.3585 27.9725C84.7722 32.3131 95.3687 49.9506 91.0271 67.3622L91.0274 67.3619H91.0276Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M73.8327 54.8695C74.4797 50.5444 71.1865 48.2196 66.6834 46.6686L68.1442 40.81L64.5775 39.9213L63.1554 45.6257C62.2177 45.3919 61.2548 45.1716 60.2977 44.9531L61.7301 39.2111L58.1656 38.3224L56.704 44.1792C55.928 44.0025 55.1659 43.828 54.4265 43.644L54.4306 43.6256L49.512 42.3975L48.5632 46.2065C48.5632 46.2065 51.2094 46.813 51.1537 46.8504C52.598 47.2108 52.8592 48.1668 52.8158 48.9246L51.1518 55.599C51.2512 55.6242 51.3802 55.6608 51.5226 55.7179C51.4036 55.6884 51.2769 55.6561 51.1456 55.6247L48.8131 64.9745C48.6366 65.4133 48.1886 66.0718 47.1788 65.8217C47.2145 65.8735 44.5864 65.1749 44.5864 65.1749L42.8156 69.2572L47.4571 70.4141C48.3206 70.6307 49.1668 70.8572 50.0001 71.0702L48.5241 76.9961L52.0867 77.8847L53.5484 72.0218C54.5216 72.2859 55.4662 72.5296 56.3908 72.7593L54.9341 78.5946L58.501 79.4833L59.9768 73.5686C66.0588 74.7195 70.632 74.2555 72.557 68.7549C74.1081 64.3262 72.4798 61.7718 69.28 60.1061C71.6106 59.5686 73.366 58.036 73.834 54.87L73.8329 54.8692L73.8327 54.8695ZM65.6836 66.2954C64.5813 70.7241 57.124 68.3301 54.7063 67.7298L56.6649 59.879C59.0825 60.4825 66.8356 61.6768 65.6837 66.2954H65.6836ZM66.7866 54.8053C65.7811 58.8336 59.5743 56.787 57.5609 56.2852L59.3367 49.1651C61.3501 49.6669 67.8341 50.6035 66.787 54.8053H66.7866Z", fill: "#F7931A" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_2_248" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), VG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_2_238)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "#06B461" }), /* @__PURE__ */ Ce.createElement("path", { d: "M30.0163 30.0098H90.0163C91.8573 30.0098 93.3496 31.5021 93.3496 33.3431V86.6763C93.3496 88.5173 91.8573 90.0097 90.0163 90.0097H30.0163C28.1753 90.0097 26.6829 88.5173 26.6829 86.6763V33.3431C26.6829 31.5021 28.1753 30.0098 30.0163 30.0098ZM33.3496 36.6764V83.343H86.683V36.6764H33.3496ZM53.5163 56.6763H70.0163V63.343H53.5163C54.2883 67.1467 57.6513 70.0097 61.683 70.0097C63.7337 70.0097 65.611 69.269 67.0627 68.0407L72.7327 71.8207C69.991 74.8057 66.0553 76.6763 61.683 76.6763C53.962 76.6763 47.6036 70.843 46.7745 63.343H43.3496V56.6763H46.7745C47.6036 49.1765 53.962 43.3431 61.683 43.3431C66.0553 43.3431 69.991 45.214 72.7327 48.199L67.063 51.979C65.6113 50.7505 63.7337 50.0098 61.683 50.0098C57.6513 50.0098 54.2883 52.8727 53.5163 56.6763Z", fill: "url(#paint0_linear_2_238)" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint0_linear_2_238", x1: 60.0163, y1: 30.0098, x2: 60.0163, y2: 90.0097, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "white" }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "white", stopOpacity: 0.75 })), /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_2_238" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), qG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_42)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M0 0H120V120H0V0Z", fill: "#00ACEF" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.0661 66.0073C52.6464 67.5899 55.8021 68.5428 59.3181 68.5428C62.984 68.5428 66.5092 66.86 69.1444 64.2525L97.5 61.6444V75.4412H22.5V68.5428L50.0661 66.0073ZM61.7044 61.6444C55.1147 61.6444 49.7726 56.2395 49.7726 49.5722C49.7726 42.9049 55.1147 37.5 61.7044 37.5C68.2941 37.5 73.6362 42.9049 73.6362 49.5722C73.6362 56.2395 68.2941 61.6444 61.7044 61.6444Z", fill: "white" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_42" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), GG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_45)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "url(#paint0_linear_1_45)" }), /* @__PURE__ */ Ce.createElement("mask", { id: "mask0_1_45", style: {
  maskType: "luminance"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 120, height: 120 }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "white" })), /* @__PURE__ */ Ce.createElement("g", { mask: "url(#mask0_1_45)" }, /* @__PURE__ */ Ce.createElement("path", { opacity: 0.1, d: "M131.836 253.125C192.997 253.125 242.578 203.544 242.578 142.383C242.578 81.2216 192.997 31.6406 131.836 31.6406C70.6747 31.6406 21.0938 81.2216 21.0938 142.383C21.0938 203.544 70.6747 253.125 131.836 253.125Z", fill: "url(#paint1_linear_1_45)" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.1, d: "M22.8516 168.75C54.8884 168.75 80.8594 142.779 80.8594 110.742C80.8594 78.7054 54.8884 52.7344 22.8516 52.7344C-9.18527 52.7344 -35.1562 78.7054 -35.1562 110.742C-35.1562 142.779 -9.18527 168.75 22.8516 168.75Z", fill: "url(#paint2_linear_1_45)" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.1, d: "M149.414 87.8906C200.867 87.8906 242.578 46.1797 242.578 -5.27343C242.578 -56.7265 200.867 -98.4375 149.414 -98.4375C97.961 -98.4375 56.25 -56.7265 56.25 -5.27343C56.25 46.1797 97.961 87.8906 149.414 87.8906Z", fill: "url(#paint3_linear_1_45)" }), /* @__PURE__ */ Ce.createElement("g", { filter: "url(#filter0_d_1_45)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M35.1563 49.2188H17.5781C15.6365 49.2188 14.0625 50.7927 14.0625 52.7344V63.2813C14.0625 65.2229 15.6365 66.7969 17.5781 66.7969H35.1563C37.0979 66.7969 38.6719 65.2229 38.6719 63.2813V52.7344C38.6719 50.7927 37.0979 49.2188 35.1563 49.2188Z", fill: "black" })), /* @__PURE__ */ Ce.createElement("path", { d: "M35.1563 49.2188H17.5781C15.6365 49.2188 14.0625 50.7927 14.0625 52.7344V63.2813C14.0625 65.2229 15.6365 66.7969 17.5781 66.7969H35.1563C37.0979 66.7969 38.6719 65.2229 38.6719 63.2813V52.7344C38.6719 50.7927 37.0979 49.2188 35.1563 49.2188Z", fill: "url(#paint4_linear_1_45)" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.3, d: "M21.0938 52.7344H17.5781V63.2813H21.0938V52.7344Z", fill: "#7A3802" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.3, d: "M28.125 52.7344H24.6094V63.2813H28.125V52.7344Z", fill: "#7A3802" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.3, d: "M35.1563 52.7344H31.6406V63.2813H35.1563V52.7344Z", fill: "#7A3802" }), /* @__PURE__ */ Ce.createElement("path", { d: "M31.6406 77.3438H14.0625V80.8594H31.6406V77.3438Z", fill: "white", fillOpacity: 0.8 }), /* @__PURE__ */ Ce.createElement("path", { d: "M24.6094 84.375H14.0625V87.8906H24.6094V84.375Z", fill: "white", fillOpacity: 0.8 }), /* @__PURE__ */ Ce.createElement("path", { d: "M38.6719 84.375H28.125V87.8906H38.6719V84.375Z", fill: "white", fillOpacity: 0.8 }), /* @__PURE__ */ Ce.createElement("path", { d: "M52.7344 84.375H42.1875V87.8906H52.7344V84.375Z", fill: "white", fillOpacity: 0.8 }), /* @__PURE__ */ Ce.createElement("path", { d: "M52.7344 77.3438H35.1562V80.8594H52.7344V77.3438Z", fill: "white", fillOpacity: 0.8 }), /* @__PURE__ */ Ce.createElement("path", { d: "M73.8281 77.3438H56.25V80.8594H73.8281V77.3438Z", fill: "white", fillOpacity: 0.8 }), /* @__PURE__ */ Ce.createElement("path", { d: "M94.9219 77.3438H77.3438V80.8594H94.9219V77.3438Z", fill: "white", fillOpacity: 0.8 }))), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("filter", { id: "filter0_d_1_45", x: 9.375, y: 49.2188, width: 33.9844, height: 26.9531, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ Ce.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ Ce.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ Ce.createElement("feOffset", { dy: 4.6875 }), /* @__PURE__ */ Ce.createElement("feGaussianBlur", { stdDeviation: 2.34375 }), /* @__PURE__ */ Ce.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), /* @__PURE__ */ Ce.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_45" }), /* @__PURE__ */ Ce.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_1_45", result: "shape" })), /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint0_linear_1_45", x1: 0, y1: 120, x2: 120, y2: 0, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "#060B0E" }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "#254764" })), /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint1_linear_1_45", x1: 82.301, y1: 88.066, x2: 71.1271, y2: 57.448, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "white" })), /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint2_linear_1_45", x1: 22.8516, y1: 168.75, x2: 10.0237, y2: 117.156, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "white" })), /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint3_linear_1_45", x1: 128.812, y1: 5.02678, x2: 149.414, y2: 87.8906, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "white" })), /* @__PURE__ */ Ce.createElement("linearGradient", { id: "paint4_linear_1_45", x1: 26.3672, y1: 49.2188, x2: 26.3672, y2: 66.7969, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ Ce.createElement("stop", { stopColor: "#FAD961" }), /* @__PURE__ */ Ce.createElement("stop", { offset: 1, stopColor: "#F7955D" })), /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_45" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), WG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_84)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "#E664A5" }), /* @__PURE__ */ Ce.createElement("path", { d: "M22.5 31.25V87.5403C22.5 90.2823 24.7581 92.379 27.3387 92.379H61.0484C86.5323 92.379 97.5 78.1855 97.5 59.3145C97.5 40.4436 86.5323 26.25 61.0484 26.25H27.5C24.7581 26.4113 22.5 28.6694 22.5 31.25Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M45.0806 40.2838V81.8967H63.1451C79.5967 81.8967 86.6935 72.5419 86.6935 59.4774C86.6935 46.8967 79.5967 37.2193 63.1451 37.2193H48.1451C46.5322 37.058 45.0806 38.5096 45.0806 40.2838Z", fill: "#CC0066" }), /* @__PURE__ */ Ce.createElement("path", { d: "M61.0497 88.0284H31.8561C29.2755 88.0284 27.1787 85.9316 27.1787 83.351V35.6091C27.1787 33.0284 29.2755 30.9316 31.8561 30.9316H61.0497C88.7916 30.9316 92.9852 48.8349 92.9852 59.48C92.9852 77.8671 81.6948 88.0284 61.0497 88.0284ZM31.8561 32.5445C30.0819 32.5445 28.7916 33.9962 28.7916 35.6091V83.351C28.7916 85.1252 30.2432 86.4155 31.8561 86.4155H61.0497C80.5658 86.4155 91.3723 76.7381 91.3723 59.3187C91.3723 35.9316 72.34 32.3833 61.0497 32.3833L31.8561 32.5445Z", fill: "black" }), /* @__PURE__ */ Ce.createElement("path", { d: "M51.5321 53.8332C52.1772 53.8332 52.8224 53.9945 53.3063 54.1557C53.7901 54.317 54.274 54.6396 54.7579 55.1235C55.0805 55.6074 55.4031 56.0912 55.7256 56.5751C55.8869 57.2203 56.0482 57.8654 56.0482 58.6719C56.0482 59.4783 55.8869 60.1235 55.7256 60.6074C55.5643 61.2525 55.2418 61.7364 54.9192 62.2203C54.5966 62.7041 54.1127 63.0267 53.4676 63.3493C52.9837 63.6719 52.1772 63.6719 51.5321 63.6719H47.1772V53.6719L51.5321 53.8332ZM51.3708 61.8977C51.6934 61.8977 52.016 61.8977 52.3385 61.7364C52.6611 61.5751 52.8224 61.4138 53.145 61.2525C53.3063 60.9299 53.6289 60.7686 53.6289 60.2848C53.7902 59.9622 53.7901 59.4783 53.7901 58.8332C53.7901 58.3493 53.7902 57.8654 53.6289 57.5428C53.4676 57.2203 53.3063 56.7364 53.145 56.5751C52.9837 56.2525 52.6611 56.0912 52.3385 55.9299C52.016 55.7686 51.5321 55.7686 51.0482 55.7686H49.4353V62.059L51.3708 61.8977Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M64.92 53.8332V55.6074H59.5974V57.8654H64.4361V59.4783H59.5974V61.8977H64.92V63.6719H57.3394V53.6719L64.92 53.8332Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M72.338 53.834L76.0477 63.834H73.7896L72.9832 61.5759H69.2735L68.4671 63.834H66.209L69.9187 53.834C70.08 53.834 72.338 53.834 72.338 53.834ZM72.4993 59.963L71.209 56.2533L69.9187 59.963H72.4993Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M79.5964 53.8332V61.8977H84.4351V63.6719H77.3384V53.6719C77.4997 53.8332 79.5964 53.8332 79.5964 53.8332Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M36.8545 63.3487C39.3487 63.3487 41.3706 61.3267 41.3706 58.8325C41.3706 56.3383 39.3487 54.3164 36.8545 54.3164C34.3603 54.3164 32.3384 56.3383 32.3384 58.8325C32.3384 61.3267 34.3603 63.3487 36.8545 63.3487Z", fill: "black" }), /* @__PURE__ */ Ce.createElement("path", { d: "M40.4037 81.8935C36.5328 81.8935 33.4683 78.829 33.4683 74.958V69.4742C33.4683 67.5387 35.0812 65.9258 37.0167 65.9258C38.9521 65.9258 40.565 67.5387 40.565 69.4742L40.4037 81.8935Z", fill: "black" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_84" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), k4 = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_2_213)" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M94.4 81.4C96.82 81.4 97.79 82.85 99.73 83.34C99.73 83.34 100.21 80.92 100.21 80.43C98.76 79.95 97.79 78.98 94.88 79.46C94.4 79.95 94.4 79.95 94.4 81.4Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M103.61 72.2C105.55 72.2 101.19 70.26 98.77 68.32C98.29 68.32 97.8 67.84 97.8 67.84C97.32 66.87 96.83 64.93 94.89 64.45C94.89 64.45 94.41 64.45 94.41 63.97C94.41 62.52 93.93 57.19 93.93 57.19C94.9 58.64 96.84 58.64 97.81 58.64C99.26 58.64 101.2 58.16 102.17 57.19C102.17 56.71 102.65 55.74 103.14 55.74C104.11 55.26 105.08 54.77 105.56 53.8C106.04 53.8 106.53 52.83 106.53 52.83C102.17 52.35 92.96 52.35 92.96 52.35C91.51 52.83 90.05 54.29 90.05 54.77C90.05 54.77 91.02 59.61 91.02 60.1C91.02 63.49 91.5 63.49 91.5 66.88C92.95 67.85 93.44 67.85 94.41 68.82C94.89 70.27 95.38 71.24 95.86 72.21L101.67 75.12C102.16 75.11 103.61 73.17 103.61 72.2Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M37.23 113.87C37.23 113.87 44.5 110.96 46.44 110.96C46.92 111.93 47.41 113.38 48.38 114.35C47.44 115.29 44.67 118.06 43.63 120H74.2C73.11 118.65 72.11 117.17 72.11 116.29C72.11 114.84 70.17 112.41 72.59 112.41C72.59 111.44 75.01 112.89 75.98 112.89C76.95 112.89 77.92 113.37 78.4 114.34C78.88 115.79 78.4 117.25 78.88 119.19C78.88 119.44 78.93 119.71 78.99 119.99H82.75C82.73 118.94 82.63 117.96 82.27 117.25V113.37C82.27 111.92 86.15 111.43 88.08 110.95C88.56 113.37 89.05 115.79 88.56 117.25C88.27 118.41 87.81 119.22 87.28 119.99H92.59C92.44 119.42 92.44 118.56 92.44 117.25C92.44 116.28 91.96 114.34 91.96 112.4C91.96 111.43 92.93 110.95 94.38 109.98C94.86 109.98 95.35 109.5 97.29 109.01V116.76C97.48 117.72 97.67 118.9 97.83 119.98H105.89C105.5 119.91 105.18 119.81 105.04 119.66C104.07 119.18 101.65 114.33 101.65 112.88C101.17 111.43 101.17 108.52 101.65 107.07C101.65 107.07 104.56 108.04 105.53 108.52C107.95 108.52 106.01 111.91 106.98 112.88C106.98 113.36 107.46 116.27 109.4 119.66C109.4 119.66 109.04 119.66 108.62 119.98H117.28C118.1 119.31 119.16 119.02 119.97 118.34V105.69C119.19 104.98 118.41 104.22 117.63 103.19C118.57 102.72 119.06 102.25 119.97 101.78V85.92C113.84 82.35 107.36 81.86 104.06 80.92V84.8C106 85.28 106.97 86.25 108.91 86.74C109.88 87.22 116.66 90.62 119.08 92.07C119.08 93.04 119.08 94.98 118.11 94.98C111.81 90.62 107.45 89.65 102.12 87.23C101.15 88.2 100.18 89.65 98.73 90.14C98.25 90.62 95.34 88.2 93.4 87.23C91.95 86.26 89.04 85.78 87.1 85.29C86.62 85.29 86.62 84.32 86.62 83.84C86.14 82.39 85.65 80.93 86.14 80.45C88.56 79.48 89.53 77.54 89.53 76.09C89.53 74.64 90.98 76.57 92.44 76.09C93.41 75.12 93.89 74.15 93.41 73.67C93.41 72.7 92.93 71.73 91.96 71.73C87.11 69.31 82.27 69.31 77.42 71.73C75.97 72.21 75.97 74.15 76.45 75.12C76.93 77.06 78.87 76.09 80.33 75.12C80.81 75.12 79.85 76.57 80.81 78.03C81.78 79.97 83.23 80.45 83.23 80.94C83.23 82.39 83.23 82.39 82.75 83.36C82.75 84.33 82.75 85.3 82.27 85.78C79.36 86.26 76.94 87.23 74.03 88.2C72.58 88.68 71.12 89.65 69.67 89.65C68.7 89.65 67.73 88.2 67.25 87.71C66.77 87.71 66.77 87.23 64.83 87.71C59.98 89.65 53.2 92.55 48.36 95.46C47.39 94.49 47.88 93.04 47.39 92.07C52.72 89.16 58.53 86.26 64.35 83.83C64.83 83.35 64.35 81.89 63.87 80.92C63.87 80.92 60.48 80.44 54.18 82.37C50.3 83.34 45.94 85.76 45.46 85.76C45.46 85.76 44.98 84.31 44.98 82.37C47.89 80.92 50.79 79.46 54.19 78.49C57.58 77.52 60.97 77.52 64.37 77.04C63.89 77.04 63.89 76.07 63.89 75.59C62.44 73.17 60.01 70.74 57.59 67.84C56.62 65.9 55.65 63.48 55.65 62.51C56.62 61.54 57.59 62.99 59.04 62.99C58.56 61.54 58.07 59.6 58.07 57.66C57.59 56.21 57.59 56.21 57.59 53.78C57.59 50.87 58.56 49.42 58.07 48.94C57.59 48.46 55.65 47.49 55.16 47.49C54.19 47 53.7 47 53.22 46.03C51.28 43.61 50.31 42.15 50.31 39.73C50.31 37.31 50.79 35.37 52.25 32.95C52.73 31.01 55.16 30.04 56.61 29.07C58.06 28.1 59.52 28.59 60.97 28.59C64.36 28.59 66.78 30.53 69.21 31.98C71.15 33.43 72.12 35.37 72.6 37.31H76.96C79.38 37.79 81.8 38.28 84.23 39.73C87.62 36.82 93.44 36.34 96.34 36.34C96.34 31.01 99.73 28.1 103.12 28.1C105.54 27.62 107 27.13 110.39 28.58C112.81 30.03 115.72 34.88 115.72 35.36C116.69 37.3 116.2 39.72 116.2 42.14C115.72 44.08 115.72 45.53 115.72 46.02C115.24 47.96 113.3 49.41 111.84 49.9C111.84 53.29 110.87 55.23 110.39 57.65C110.39 59.1 109.91 60.56 109.42 62.01C110.87 61.53 111.36 60.56 112.81 60.56C111.84 66.86 110.39 65.89 108.93 68.8C108.45 71.22 107.48 73.16 106.02 74.61C105.54 75.09 105.05 75.58 103.6 76.55C102.63 77.03 103.6 77.52 103.6 78C108.1 78 113.43 79.26 119.99 82.54V73.32C119.68 73.16 119.38 72.95 119.11 72.68C117.66 71.23 117.66 68.8 117.17 66.87C116.2 65.42 117.65 64.45 118.62 62.99C118.62 62.51 119.1 61.54 119.59 61.05C119.72 61.25 119.86 61.44 119.99 61.63V31.3C119.55 29.99 119.04 28.67 118.62 27.63C117.65 26.66 117.65 23.75 117.65 23.75C118.48 24.08 119.25 24.36 119.99 24.61V0H0V120H39.99C39.21 117.97 38.37 115.77 37.23 113.87ZM111.36 105.15H113.78C113.78 106.12 115.23 109.51 116.69 110.96V111.93C115.24 111.93 113.78 111.45 112.81 110.96C112.33 110.96 111.36 109.99 110.87 109.02C109.9 106.6 109.42 104.66 109.42 104.66C109.91 104.66 110.88 104.66 111.36 105.15ZM83.74 89.64C88.58 89.64 93.43 89.64 97.31 92.06C97.31 94 97.31 96.42 96.34 98.36C96.34 98.84 95.37 100.78 94.4 101.75C92.95 99.81 90.04 97.87 90.04 97.87C90.52 99.81 90.04 100.29 89.56 102.72C89.56 103.2 86.17 103.2 86.17 103.2C83.26 101.75 82.78 99.81 82.78 99.81C82.78 100.29 82.3 103.69 80.84 103.69C78.9 103.69 77.45 103.69 77.45 102.24C76.97 100.79 76.97 99.82 76.97 98.36V96.42C75.52 96.9 74.55 98.36 73.58 99.33C73.1 99.33 72.61 98.36 72.13 98.36C71.16 96.42 70.68 94.97 70.19 93.03C75.02 89.64 79.87 89.64 83.74 89.64ZM62.91 103.69C63.39 103.21 64.36 104.17 64.85 104.17C66.3 105.14 66.79 105.62 66.79 106.59C67.27 107.56 67.76 109.98 67.76 109.98C67.76 113.37 66.79 114.34 66.31 116.28C65.34 114.83 64.86 112.89 64.37 111.43C63.89 109.98 62.92 109.01 61.95 107.55C62.42 107.09 62.91 103.69 62.91 103.69ZM53.22 99.82C54.19 100.3 55.64 100.79 56.13 101.76C57.1 103.21 56.13 105.15 56.61 106.12C57.09 108.54 58.55 112.9 58.55 112.9C57.1 111.93 55.64 111.45 54.19 110.48C53.22 110 52.25 109.51 52.25 109.03C51.28 107.58 50.8 104.67 50.8 103.7C50.8 101.75 52.25 99.82 53.22 99.82ZM44.5 25.2C46.44 22.29 49.34 19.39 50.8 17.45C56.61 15.51 56.61 14.54 62.91 13.57C65.33 16.48 71.63 21.32 71.63 21.32C71.63 22.29 72.11 20.35 74.05 14.54C75.5 15.51 76.47 15.51 77.93 16.48C78.41 16.48 79.87 16.96 79.87 16.96C80.35 16.96 82.78 15.51 83.26 15.02C84.23 14.54 88.59 13.57 88.59 13.57C89.07 14.05 87.14 17.45 87.14 17.93V22.29C87.62 22.29 88.11 22.29 89.08 21.81C91.5 20.36 91.99 16 92.96 12.6C94.41 13.08 95.38 13.08 96.84 13.08C96.84 15.02 95.87 17.93 97.32 17.93C98.29 17.93 100.23 15.99 103.62 13.57C108.47 15.51 113.31 18.41 117.19 21.81C115.74 22.78 114.28 24.72 112.83 24.72C111.38 24.72 110.41 24.24 108.95 23.75C107.98 22.78 103.62 21.33 101.2 21.33C97.81 21.33 96.36 25.21 92.96 26.66C91.51 27.14 88.6 27.63 85.69 28.6C83.75 29.57 82.78 30.05 82.78 29.08C82.3 27.14 82.3 25.69 82.3 23.75C81.33 23.27 79.39 23.27 77.94 22.3C76.97 25.69 76 26.66 75.03 28.11C73.09 27.14 71.15 26.66 69.22 25.69C66.8 24.24 61.47 20.36 60.98 19.39C59.04 21.81 53.23 25.2 49.84 26.66C49.36 27.63 46.93 31.02 46.45 31.51L41.61 29.57C42.56 27.62 43.53 26.65 44.5 25.2ZM39.17 38.77C39.17 37.32 39.17 35.86 40.14 34.41C41.11 32.47 43.53 32.47 45.47 32.96C44.99 36.35 44.5 37.32 44.5 41.2C44.5 41.68 45.47 43.62 45.95 44.59C46.43 45.56 46.92 46.53 46.92 47.5C46.92 47.98 46.44 48.47 45.95 48.95C44.5 49.92 44.01 49.43 43.53 50.4C41.11 52.34 40.14 53.31 38.2 54.76C37.23 55.73 37.23 55.73 36.26 57.18C36.26 57.18 35.78 51.85 35.29 48.94C37.23 47.97 38.2 47 40.14 45.55C39.65 42.64 39.17 41.19 39.17 38.77ZM35.77 58.15C35.77 57.67 40.13 56.21 42.55 55.73C43.52 55.73 47.4 54.76 47.88 55.73C48.36 56.7 47.4 56.7 47.4 59.12C46.92 60.09 46.43 59.6 45.46 60.57C44.98 61.05 39.65 64.93 39.16 65.42C38.19 65.9 37.71 66.39 36.25 67.84C35.77 66.39 35.77 64.93 35.28 63.48C35.29 62.99 35.29 59.6 35.77 58.15ZM32.87 78.01C32.39 76.56 32.39 76.56 32.39 74.13C34.81 72.68 35.3 71.71 37.72 70.25C38.69 68.8 42.08 67.83 46.93 66.37C46.93 68.31 46.45 70.25 45.96 72.18C41.12 74.12 39.18 76.54 38.21 77.51C36.76 79.45 34.33 82.36 33.37 83.81L32.87 78.01ZM34.81 99.82C34.81 98.37 34.81 96.91 34.33 95.46C34.33 94.01 33.85 89.16 33.85 88.19V85.77C35.3 84.8 37.73 83.35 39.66 82.38C39.18 84.8 38.69 85.77 38.69 89.65C38.69 90.13 39.66 93.04 40.14 96.43C39.17 98.37 38.69 99.82 37.23 101.28C36.75 102.25 35.78 102.73 35.78 102.73C35.77 101.75 35.29 100.79 34.81 99.82ZM38.68 102.72C39.16 101.75 41.59 100.3 42.07 99.81C43.52 101.26 44.01 101.75 44.98 104.17C44.5 104.65 41.59 106.59 39.17 109.5C39.17 110.47 37.72 111.44 37.72 111.44C37.72 109.5 37.24 107.08 37.24 106.11C36.76 105.14 36.27 105.14 36.27 104.17C36.74 103.69 37.71 103.21 38.68 102.72Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M91.5 47.97C93.92 47.97 96.35 48.45 97.31 47.49C102.64 45.07 94.4 43.13 93.43 43.13C91.01 42.65 86.16 41.68 88.1 43.13C88.1 44.1 89.55 44.1 90.52 45.07C91.5 45.06 91.5 47 91.5 47.97Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M68.24 38.28C67.27 34.89 66.79 34.89 64.85 33.92C63.4 32.95 62.43 32.95 61.46 32.95C59.52 33.43 56.13 34.4 55.16 37.31C55.16 37.79 54.68 39.73 56.13 41.67C57.1 43.12 59.04 44.58 60.01 45.55C61.46 45.55 61.95 43.13 64.37 42.16C65.34 41.19 67.76 39.25 67.76 39.25C68.24 39.25 68.24 38.77 68.24 38.28Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M67.75 80.44C67.75 80.44 68.23 82.38 68.72 83.35C70.17 82.87 70.66 82.38 71.63 81.9C71.63 81.9 73.57 80.93 74.05 80.45C73.08 79.97 72.11 79.97 71.14 79.97C69.69 79.95 67.75 80.44 67.75 80.44Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M80.84 43.13C80.84 42.16 78.9 42.65 77.93 43.13C76.96 43.13 75.51 44.1 74.05 45.07C72.6 46.52 71.63 47.01 71.63 48.46H74.05C76.47 48.46 76.96 49.43 77.93 47.98C79.38 46.03 80.84 45.06 80.84 43.13Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M112.33 42.16C112.81 40.22 113.3 36.35 111.85 34.41C110.88 33.44 110.4 32.96 107.97 32.47C106.03 31.99 104.09 32.47 102.64 33.92C101.67 35.37 99.73 37.31 100.22 39.25C104.1 40.22 106.52 42.16 108.94 44.58C110.39 44.58 111.85 43.61 112.33 42.16Z", fill: "#EC662C" }), /* @__PURE__ */ Ce.createElement("path", { d: "M76.48 67.84V66.39C76.96 62.03 76.96 61.06 77.45 58.15C77.45 57.67 77.93 55.24 77.93 54.76C77.93 53.79 76.96 52.82 75.51 52.34H69.21C66.79 52.34 65.33 52.34 62.91 52.82C63.88 54.76 66.3 56.7 66.79 57.67C67.76 58.15 68.73 59.12 70.67 59.12C72.61 58.64 72.61 59.12 73.58 58.64C73.58 59.61 74.06 61.06 73.58 62.03C73.58 62.51 74.06 66.39 72.13 66.88C70.68 67.36 68.74 68.33 67.77 70.27C66.8 71.72 66.8 74.15 67.77 74.63C68.74 75.11 69.71 74.15 71.16 73.66C72.61 73.18 72.61 72.21 73.1 70.75C74.05 69.29 75.99 68.81 76.48 67.84Z", fill: "#EC662C" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_2_213" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), $G = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_152)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M0 0H120V120H0V0Z", fill: "black" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.2922 82.5C57.4264 82.5 67.5 72.4264 67.5 60.2922C67.5 47.5736 57.4264 37.5 45.2922 37.5C32.5736 37.5 22.5 47.5736 22.5 60.2922C22.5 72.4264 32.5736 82.5 45.2922 82.5Z", fill: "#E7001A" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M75.2922 82.5C87.4264 82.5 97.5 72.4264 97.5 60.2922C97.5 47.5736 87.4264 37.5 75.2922 37.5C62.5736 37.5 52.5 47.5736 52.5 60.2922C52.5 72.4264 62.5736 82.5 75.2922 82.5Z", fill: "#F49B1C" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.3, fillRule: "evenodd", clipRule: "evenodd", d: "M60.0451 43.2578C55.3969 47.4114 52.5 53.4712 52.5 60.2917C52.5 66.7987 55.3969 72.7132 60.0451 76.7994C64.6031 72.7132 67.5 66.7987 67.5 60.2917C67.5 53.4712 64.6031 47.4114 60.0451 43.2578Z", fill: "#E7001A" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_152" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), YG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_2_224)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "#FF4785" }), /* @__PURE__ */ Ce.createElement("path", { d: "M75.9399 36C73.0444 36 70.3774 36.9144 68.1676 38.4765L56.2425 47.1632C55.2138 40.8386 49.7275 36 43.0982 36C35.745 36 29.7633 41.9816 29.7633 49.3348C29.7633 56.688 35.745 62.6697 43.0982 62.6697C45.9937 62.6697 48.6988 61.7172 50.9086 60.1551L62.7956 51.5065C63.8243 57.831 69.3106 62.6697 75.9399 62.6697C83.2931 62.6697 89.2748 56.688 89.2748 49.3348C89.2748 41.9816 83.3312 36 75.9399 36ZM43.0982 55.3165C39.7835 55.3165 37.1165 52.6495 37.1165 49.3348C37.1165 46.0202 39.7835 43.3532 43.0982 43.3532C46.4128 43.3532 49.0798 46.0202 49.0798 49.3348C49.0798 52.6495 46.4128 55.3165 43.0982 55.3165ZM75.9399 55.3165C72.6253 55.3165 69.9583 52.6495 69.9583 49.3348C69.9583 46.0202 72.6253 43.3532 75.9399 43.3532C79.2546 43.3532 81.9216 46.0202 81.9216 49.3348C81.9216 52.6495 79.2546 55.3165 75.9399 55.3165Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M86.7602 70.7849H89.8463V81.6051H86.7602V70.7849ZM88.2842 65.9843C87.2936 65.9843 86.4935 66.7844 86.4935 67.8131C86.4935 68.8037 87.2936 69.6419 88.2842 69.6419C89.2748 69.6419 90.0748 68.8418 90.0748 67.8131C90.1129 66.7844 89.2748 65.9843 88.2842 65.9843ZM102 70.7849V84.0816H98.9139V81.1098C98.19 81.4527 97.4281 81.6432 96.5899 81.6432C93.6181 81.6432 91.1797 79.2049 91.1797 76.195C91.1797 73.1852 93.58 70.7468 96.5899 70.7468C97.4281 70.7468 98.2281 70.9373 98.9139 71.2802V70.823H102V70.7849ZM98.9139 76.195C98.9139 74.8996 97.8853 73.8709 96.628 73.8709C95.3707 73.8709 94.342 74.8996 94.342 76.195C94.342 77.4904 95.3707 78.5191 96.628 78.5191C97.8853 78.5191 98.9139 77.4523 98.9139 76.195ZM57.195 73.8328C57.957 73.8328 58.6809 74.2138 59.1 74.8996L61.6907 73.1851C60.7001 71.6612 59.0238 70.7087 57.195 70.7087C54.2232 70.7087 51.7848 73.147 51.7848 76.1569C51.7848 79.1668 54.1851 81.6051 57.195 81.6051C58.9857 81.6051 60.662 80.6907 61.6907 79.1668L59.1381 77.4904C58.719 78.1381 57.9951 78.5191 57.2331 78.5191C55.9758 78.5191 54.9471 77.4904 54.9471 76.195C54.909 74.8996 55.9377 73.8328 57.195 73.8328ZM27.8584 76.195C27.8584 79.2049 25.4581 81.6432 22.4482 81.6432C21.61 81.6432 20.81 81.4527 20.0861 81.0717V84.0816H17V70.7849H20.0861V71.2802C20.81 70.9373 21.61 70.7087 22.4482 70.7087C25.4581 70.7087 27.8584 73.1852 27.8584 76.195ZM24.7723 76.195C24.7723 74.8996 23.7436 73.8709 22.4863 73.8709C21.229 73.8709 20.2004 74.8996 20.2004 76.195C20.2004 77.4904 21.229 78.5191 22.4863 78.5191C23.7436 78.5191 24.7723 77.4523 24.7723 76.195ZM39.593 81.6051H36.5069V81.1098C35.8212 81.4527 35.0211 81.6432 34.221 81.6432C31.2492 81.6432 28.8108 79.2049 28.8108 76.195C28.8108 73.1852 31.2111 70.7468 34.221 70.7468C35.0211 70.7468 35.8212 70.9373 36.5069 71.2802V70.823H39.593V81.6051ZM36.5069 75.8902C36.3926 74.7472 35.4021 73.8328 34.221 73.8328C32.9637 73.8328 31.935 74.8615 31.935 76.1569C31.935 77.4523 32.9637 78.481 34.221 78.481C35.4021 78.481 36.3545 77.5666 36.5069 76.4236V75.8902ZM79.788 70.823C79.1403 70.823 78.4545 70.9754 77.8068 71.204V70.7849H74.7208V81.6051H77.8068V75.9283C77.8068 74.0233 79.5594 73.9471 79.788 73.9471C80.3214 73.9471 80.7786 74.0995 81.1215 74.4424C81.5025 74.7853 81.693 75.3187 81.693 76.0045V81.5289H84.779V75.9664C84.779 72.5756 82.2644 70.823 79.788 70.823ZM51.8229 70.823H48.6988L46.489 76.5379L44.0887 70.823H40.736L45.0031 80.3479L43.5173 84.1197H46.6414L51.8229 70.823ZM73.3873 76.195C73.3873 79.2049 70.987 81.6432 67.9771 81.6432C65.0054 81.6432 62.567 79.2049 62.567 76.195C62.567 73.1852 64.9673 70.7468 67.9771 70.7468C70.9489 70.7087 73.3873 73.1852 73.3873 76.195ZM70.3012 76.195C70.3012 74.8996 69.2725 73.8709 68.0152 73.8709C66.758 73.8709 65.7293 74.8996 65.7293 76.195C65.7293 77.4904 66.758 78.5191 68.0152 78.5191C69.2725 78.5191 70.3012 77.4523 70.3012 76.195Z", fill: "white" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_2_224" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), XG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_160)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M120 0H0V120H120V0Z", fill: "#0171C0" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.6, d: "M80.2879 44.8398C80.2317 45.1886 80.1679 45.5411 80.0967 45.9048C77.5992 58.1973 69.0529 62.4423 58.1404 62.4423H52.5829C51.2479 62.4423 50.1229 63.3723 49.9129 64.6361L47.0704 81.9311L46.2642 86.8323C46.2004 87.2261 46.3167 87.6273 46.5867 87.9311C46.8567 88.2348 47.2504 88.4073 47.6667 88.4073H57.5217C58.6917 88.4073 59.6817 87.5936 59.8654 86.4911L59.9629 86.0111L61.8192 74.7236L61.9354 74.1048C62.1192 72.9986 63.1129 72.1848 64.2792 72.1848H65.7529C75.3004 72.1848 82.7779 68.4686 84.9604 57.7136C85.8754 53.2248 85.4029 49.4711 82.9879 46.8348C82.2229 46.0173 81.3079 45.3423 80.2879 44.8398Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { opacity: 0.8, d: "M77.6776 43.838C76.8788 43.6168 76.0688 43.4443 75.2476 43.3205C73.6276 43.0805 71.9889 42.968 70.3501 42.9793H55.5038C54.3376 42.9755 53.3438 43.793 53.1638 44.8993L50.0063 64.0693L49.9126 64.6318C50.1188 63.368 51.2513 62.438 52.5826 62.438H58.1401C69.0526 62.438 77.5988 58.1893 80.0963 45.9005C80.1713 45.5368 80.2314 45.1843 80.2876 44.8355C79.6314 44.5055 78.9451 44.228 78.2363 44.0068C78.0488 43.9468 77.8651 43.8905 77.6776 43.838Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { d: "M53.1636 44.9025C53.3399 43.7963 54.3336 42.9788 55.5036 42.9825H70.3499C72.1086 42.9825 73.7474 43.095 75.2474 43.3275C76.2599 43.4775 77.2611 43.7063 78.2361 44.01C78.9749 44.2425 79.6574 44.52 80.2911 44.8388C81.0336 40.2975 80.2836 37.2038 77.7224 34.4025C74.8986 31.32 69.7986 30 63.2736 30H44.3361C43.0011 30 41.8649 30.93 41.6586 32.1938L33.7686 80.1263C33.6974 80.5763 33.8324 81.0338 34.1399 81.3825C34.4474 81.7275 34.9011 81.93 35.3736 81.93H47.0699L50.0061 64.0725L53.1636 44.9025Z", fill: "white" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_160" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), KG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_169)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M0 0H120V120H0V0Z", fill: "#0054A5" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.0178 56.9571H28.8528C28.8528 55.9386 28.7342 55.2554 28.4976 54.9075C28.1305 54.3924 27.1182 54.1347 25.461 54.1347C23.8513 54.1347 22.7846 54.283 22.2639 54.5798C21.7436 54.8775 21.4828 55.5249 21.4828 56.5217C21.4828 57.4241 21.7137 58.0182 22.1761 58.303C22.5071 58.5051 22.945 58.6238 23.4904 58.6593L24.7336 58.7477C27.3981 58.9258 29.0622 59.0511 29.7259 59.1227C31.8333 59.3365 33.3606 59.9003 34.3087 60.8147C35.0542 61.5277 35.499 62.4599 35.6412 63.6109C35.7239 64.2995 35.7655 65.0789 35.7655 65.9446C35.7655 67.9398 35.5761 69.4012 35.1976 70.3273C34.5112 72.0265 32.9693 73.1 30.5698 73.5508C29.5646 73.7411 28.0272 73.8364 25.9589 73.8364C22.5062 73.8364 20.1004 73.6296 18.7419 73.2137C17.0745 72.7043 15.9753 71.6726 15.4433 70.1186C15.147 69.2535 15 67.8129 15 65.7961H21.1647C21.1647 66.021 21.1656 66.1927 21.1656 66.3112C21.1656 67.3877 21.4727 68.0796 22.0862 68.3881C22.5113 68.6007 23.0244 68.7123 23.6275 68.7255H25.8941C27.0504 68.7255 27.7888 68.6657 28.1069 68.546C28.6739 68.3217 29.0458 67.9608 29.2235 67.4611C29.3179 67.1531 29.3645 66.755 29.3645 66.2679C29.3645 65.1767 28.969 64.5127 28.1786 64.2746C27.8832 64.1804 26.5089 64.0493 24.0553 63.8831C22.0847 63.7414 20.716 63.6052 19.9499 63.4732C17.9315 63.0934 16.5864 62.3116 15.9152 61.1251C15.325 60.1168 15.0302 58.5914 15.0302 56.5508C15.0302 54.9968 15.1894 53.7507 15.5084 52.8135C15.8274 51.8762 16.3415 51.1641 17.0509 50.6776C18.0901 49.9301 19.4197 49.4914 21.0383 49.3603C22.3855 49.2421 23.8796 49.1816 25.5231 49.1816C28.1105 49.1816 29.9544 49.3317 31.0537 49.6282C33.7364 50.3541 35.0772 52.3865 35.0772 55.726C35.0772 56 35.0575 56.4098 35.0178 56.9571Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M68.5235 61.5196H72.6546C73.9644 61.4721 74.7611 61.3705 75.0478 61.212C75.4394 60.9952 75.7023 60.561 75.8331 59.9103C75.9168 59.477 75.9586 58.8326 75.9586 57.9771C75.9586 56.9286 75.8755 56.1516 75.7086 55.6443C75.4702 54.9335 74.8994 54.5004 73.9952 54.3432C73.8165 54.3194 73.3885 54.3068 72.7104 54.3068H68.5235V61.5196ZM61.897 73.6684V48.8828H71.555H73.071H74.2428C75.9362 48.8828 77.2284 49.022 78.1161 49.3002C80.1467 49.9407 81.5091 51.252 82.2072 53.2339C82.5671 54.274 82.7473 55.8401 82.7473 57.9311C82.7473 60.4452 82.5474 62.2521 82.1522 63.3521C81.3604 65.5273 79.7306 66.7803 77.269 67.1051C76.9798 67.1538 75.7483 67.1974 73.5743 67.2323L72.4745 67.2693H68.5235V73.6684H61.897Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M95.7063 64.5564L92.6012 53.8125L89.5885 64.5564H95.7063ZM97.0221 69.3853H88.1625L86.9721 73.6687H80.1162L87.5137 48.8828H97.5099L104.998 73.6687H98.2865L97.0221 69.3853Z", fill: "white" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M53.0255 52.0165C55.7583 52.0165 58.1976 53.2839 59.8013 55.2691L61.2297 52.1861C58.9954 50.0604 55.9552 48.75 52.6016 48.75C47.3802 48.75 42.9134 51.9245 41.0805 56.4181H38.2951L36.6504 59.9675H40.2337C40.2068 60.2968 40.1892 60.6264 40.1892 60.9625C40.1892 61.3694 40.2104 61.7714 40.2501 62.1686H38.4495L36.8051 65.7193H41.1659C43.0511 70.0992 47.4621 73.1742 52.6016 73.1742C55.1917 73.1742 57.5951 72.393 59.5851 71.0585V66.7071C57.9825 68.5437 55.6386 69.7044 53.0255 69.7044C49.9706 69.7044 47.2837 68.1188 45.7194 65.7193H54.8509L56.4955 62.1686H44.3758C44.3134 61.7413 44.2799 61.3047 44.2799 60.86C44.2799 60.5593 44.2952 60.2616 44.3242 59.9675H57.5147L59.1591 56.4181H45.4646C46.9794 53.787 49.7974 52.0165 53.0255 52.0165Z", fill: "#FEC10E" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_169" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), QG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_189)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M1.875 1.875H118.125V118.125H1.875V1.875Z", fill: "#EDEDED", stroke: "#EEEEEE", strokeWidth: 3.75 }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.2417 64.2981C33.2058 64.2981 31.7789 62.9756 31.7789 60.9048C31.7789 58.6079 33.5538 56.4675 36.1118 56.4675C38.1478 56.4675 39.5747 57.8596 39.5747 59.9304C39.5921 62.2099 37.7997 64.2981 35.2417 64.2981ZM36.4424 52.5C31.0828 52.5 27.0283 56.4153 27.0283 61.0962C27.0283 65.3422 30.3694 68.2656 34.9285 68.2656C40.2881 68.2656 44.3426 64.2285 44.3426 59.5475C44.3252 55.319 41.0016 52.5 36.4424 52.5Z", fill: "#393941" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67.5389 64.2981C65.503 64.2981 64.0761 62.9756 64.0761 60.9048C64.0761 58.6079 65.851 56.4675 68.409 56.4675C70.4449 56.4675 71.8718 57.8596 71.8718 59.9304C71.8718 62.2099 70.0969 64.2981 67.5389 64.2981ZM68.7222 52.5C63.3626 52.5 59.3081 56.4153 59.3081 61.0962C59.3081 65.3422 62.6492 68.2656 67.2083 68.2656C72.5679 68.2656 76.6224 64.2285 76.6224 59.5475C76.6224 55.319 73.2813 52.5 68.7222 52.5Z", fill: "#393941" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M84.7648 59.9664H84.0688L84.5908 56.7994H85.2173C86.6964 56.7994 87.4969 57.2518 87.4969 58.2089C87.4969 59.3921 86.3658 59.9664 84.7648 59.9664ZM92.3866 57.478C92.3866 54.6416 90.1593 52.8145 86.1396 52.8145H80.4493L77.9609 67.9536H82.7463L83.5294 63.1856H83.7556L86.2962 67.9536H91.7776L88.2625 62.6636C90.8379 61.7761 92.3866 59.8446 92.3866 57.478Z", fill: "#393941" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5472 58.8515C19.7375 57.9466 19.3199 57.703 19.3199 57.2158C19.3199 56.6067 20.0333 56.3109 21.0426 56.3109C22.1911 56.3109 23.9486 56.4327 25.6539 58.051C26.0716 56.7459 26.7676 55.58 27.6725 54.5534C25.2537 53.1961 23.0263 52.5 20.973 52.5C16.8837 52.5 14.5519 54.6752 14.5519 57.2854C14.5519 59.5301 16.2572 60.7134 18.2932 61.7401C20.1029 62.6798 20.5728 62.9582 20.5728 63.5324C20.5728 64.1415 19.8071 64.4895 18.7978 64.4895C17.0403 64.4895 15.0217 63.3932 13.8211 62.2795L13.125 66.4906C14.3779 67.3781 16.1702 68.3004 18.8674 68.3004C23.0785 68.3004 25.3581 66.1948 25.3581 63.4802C25.3233 61.2529 23.8616 60.0348 21.5472 58.8515Z", fill: "#393941" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56.9245 59.46H51.3213L51.7564 56.815H57.7598C58.5429 55.2141 59.7436 53.8568 61.2401 52.8301H51.4083C49.2332 52.8301 47.3712 54.3092 47.0406 56.3103L45.1265 67.9692H49.9118L50.6949 63.2013H56.3851L56.8027 60.6085C56.8201 60.2256 56.8549 59.8428 56.9245 59.46Z", fill: "#393941" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M92.4922 52.8145C93.7625 53.7889 94.5629 55.1462 94.7196 56.7994H98.7219L96.8773 67.9362H101.663L103.507 56.7994H107.945L108.606 52.8145H92.4922Z", fill: "#393941" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_189" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), ZG = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("g", { clipPath: "url(#clip0_1_125)" }, /* @__PURE__ */ Ce.createElement("path", { d: "M0 0H120V120H0V0Z", fill: "#1B16E6" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M59.7355 54.5908C59.682 58.7697 63.4937 61.1019 66.3652 62.4883C69.3156 63.9111 70.3066 64.8233 70.2953 66.0954C70.2727 68.0426 67.9418 68.9018 65.76 68.9353C61.9539 68.9939 59.7411 67.917 57.9816 67.1025L56.6106 73.4601C58.3757 74.2663 61.6442 74.9693 65.0337 75C72.9895 75 78.1947 71.1084 78.2228 65.0744C78.2538 57.4168 67.5335 56.9928 67.6068 53.5698C67.6321 52.5321 68.6315 51.4246 70.8217 51.1429C71.9055 51.0006 74.8981 50.8918 78.2904 52.44L79.622 46.2889C77.7977 45.6304 75.4527 45 72.5333 45C65.0449 45 59.7777 48.9446 59.7355 54.5908ZM92.4163 45.5302C90.9637 45.5302 89.7392 46.3698 89.1929 47.6586L77.8281 74.5482H85.7781L87.3603 70.2158H97.0755L97.9929 74.5482H105L98.8861 45.5302H92.4163ZM93.532 53.369L95.8264 64.2655H89.543L93.532 53.369ZM50.0959 45.5302L43.8293 74.5482H51.405L57.6687 45.5302H50.0959ZM38.8895 45.5302L31.0042 65.2809L27.8146 48.4871C27.4402 46.6125 25.9622 45.5302 24.3209 45.5302H11.4302L11.25 46.3726C13.8963 46.9417 16.9029 47.8595 18.7244 48.8414C19.8391 49.4412 20.1573 49.9656 20.5233 51.3912L26.5647 74.5482H34.5711L46.8453 45.5302H38.8895Z", fill: "white" })), /* @__PURE__ */ Ce.createElement("defs", null, /* @__PURE__ */ Ce.createElement("clipPath", { id: "clip0_1_125" }, /* @__PURE__ */ Ce.createElement("rect", { width: 120, height: 120, fill: "white" })))), JG = Mn.bind(UG), boe = (n) => {
  const { method: e, size: t, borderRadius: i } = n, c = JG("paymentIcon", {
    [`paymentIcon--${t}`]: !!t,
    "paymentIcon--borderRadius": !!i
  }), a = (s) => {
    if (s === "bancontact") return /* @__PURE__ */ Re(A4, {});
    if (s === "belfius") return /* @__PURE__ */ Re(HG, {});
    if (s === "bitcoin") return /* @__PURE__ */ Re(zG, {});
    if (s === "banktransfer") return /* @__PURE__ */ Re(KG, {});
    if (s === "cash") return /* @__PURE__ */ Re(VG, {});
    if (s === "creditcard") return /* @__PURE__ */ Re(GG, {});
    if (s === "ideal") return /* @__PURE__ */ Re(WG, {});
    if (s === "ing") return /* @__PURE__ */ Re(k4, {});
    if (s === "inghomepay") return /* @__PURE__ */ Re(k4, {});
    if (s === "kbc") return /* @__PURE__ */ Re(qG, {});
    if (s === "mastercard") return /* @__PURE__ */ Re($G, {});
    if (s === "mistercash") return /* @__PURE__ */ Re(A4, {});
    if (s === "payconiq") return /* @__PURE__ */ Re(YG, {});
    if (s === "paypal") return /* @__PURE__ */ Re(XG, {});
    if (s === "sofort") return /* @__PURE__ */ Re(QG, {});
    if (s === "visa") return /* @__PURE__ */ Re(ZG, {});
  };
  return e ? /* @__PURE__ */ Re("span", { className: c, children: a(e) }) : null;
}, eW = "_progressBar_1kxlv_25", tW = "_progressBar__bar_1kxlv_25", nW = "_progressBar__barFill_1kxlv_42", rW = "_slideFill_1kxlv_1", iW = "_slidePendingFill_1kxlv_1", oW = "_liveShine_1kxlv_1", aW = "_progressBar__bottom_1kxlv_123", sW = "_progressBar__label_1kxlv_129", lW = "_liveFill_1kxlv_1", Lb = {
  progressBar: eW,
  progressBar__bar: tW,
  "progressBar__bar--small": "_progressBar__bar--small_1kxlv_30",
  "progressBar__bar--medium": "_progressBar__bar--medium_1kxlv_34",
  "progressBar__bar--large": "_progressBar__bar--large_1kxlv_38",
  progressBar__barFill: nW,
  "progressBar__barFill--small": "_progressBar__barFill--small_1kxlv_48",
  "progressBar__barFill--medium": "_progressBar__barFill--medium_1kxlv_52",
  "progressBar__barFill--large": "_progressBar__barFill--large_1kxlv_56",
  "progressBar__barFill--pending": "_progressBar__barFill--pending_1kxlv_60",
  "progressBar__barFill--animate": "_progressBar__barFill--animate_1kxlv_64",
  slideFill: rW,
  "progressBar__barFill--pending--animate": "_progressBar__barFill--pending--animate_1kxlv_72",
  slidePendingFill: iW,
  "progressBar__barFill--success": "_progressBar__barFill--success_1kxlv_76",
  "progressBar__barFill--warning": "_progressBar__barFill--warning_1kxlv_79",
  "progressBar__barFill--error": "_progressBar__barFill--error_1kxlv_82",
  "progressBar__barFill--info": "_progressBar__barFill--info_1kxlv_85",
  "progressBar__barFill--disabled": "_progressBar__barFill--disabled_1kxlv_88",
  "progressBar__barFill--live": "_progressBar__barFill--live_1kxlv_91",
  liveShine: oW,
  progressBar__bottom: aW,
  progressBar__label: sW,
  "progressBar__label--right": "_progressBar__label--right_1kxlv_138",
  liveFill: lW
}, Jv = Mn.bind(Lb), Eoe = (n) => {
  const {
    total: e,
    value: t,
    pending: i,
    color: c,
    badge: a,
    index: s,
    animate: r = !0,
    size: l = "small",
    showLabel: d = !0
  } = n, f = t > e ? 100 : t / e * 100, h = t > e ? "error" : c, p = i ? t + i > e ? 100 : (t + i) / e * 100 : 0, g = Jv("progressBar__bar", {
    [`progressBar__bar--${l}`]: !!l
  }), _ = Jv("progressBar__barFill", {
    [`progressBar__barFill--${h}`]: !!h,
    "progressBar__barFill--animate": !!r,
    [`progressBar__barFill--${l}`]: !!l
  }), b = Jv("progressBar__barFill", {
    [`progressBar__barFill--${h}`]: !!h,
    "progressBar__barFill--pending": !0,
    "progressBar__barFill--animate": !!r,
    "progressBar__barFill--pending--animate": !!r,
    [`progressBar__barFill--${l}`]: !!l
  }), v = {
    "--percentage": `${f}%`,
    "--pendingPercentage": `${p}%`,
    "--delay": `${s ? s * 100 : 0}ms`,
    "--shineTime": `${f ? f * 50 : 0}ms`
  }, E = Jv("progressBar__label", {
    "progressBar__label--right": !!a
  });
  return /* @__PURE__ */ Mt("div", { className: Lb.progressBar, style: v, children: [
    /* @__PURE__ */ Mt("div", { className: g, children: [
      /* @__PURE__ */ Re("div", { className: b }),
      /* @__PURE__ */ Re("div", { className: _ })
    ] }),
    d && /* @__PURE__ */ Mt("div", { className: Lb.progressBar__bottom, children: [
      a && /* @__PURE__ */ Re("div", { className: Lb.progressBar__badge, children: /* @__PURE__ */ Re(
        vm,
        {
          content: a ?? "text",
          color: c,
          size: "small",
          popIn: !!r
        }
      ) }),
      /* @__PURE__ */ Mt("div", { className: E, children: [
        t,
        " / ",
        e
      ] })
    ] })
  ] });
}, uW = "_seatmap_az7jz_1", cW = "_seatmap__map_az7jz_5", dW = "_canvasWrapper_az7jz_11", fW = "_seatmap__toolbar_az7jz_14", hW = "_assignControls_az7jz_23", pW = "_seatmap__loading_az7jz_46", mW = "_seatmap__controls_az7jz_57", gW = "_controlButton_az7jz_69", _W = "_seatmap__types_az7jz_110", yW = "_seatmapType_az7jz_117", vW = "_seatmapType__color_az7jz_130", bW = "_seatmapType__places_az7jz_136", id = {
  seatmap: uW,
  seatmap__map: cW,
  canvasWrapper: dW,
  seatmap__toolbar: fW,
  assignControls: hW,
  seatmap__loading: pW,
  seatmap__controls: mW,
  controlButton: gW,
  "seatmap__controls--loading": "_seatmap__controls--loading_az7jz_107",
  seatmap__types: _W,
  seatmapType: yW,
  seatmapType__color: vW,
  seatmapType__places: bW
};
function it(n, e, t) {
  return (e = function(i) {
    var c = function(a, s) {
      if (typeof a != "object" || !a) return a;
      var r = a[Symbol.toPrimitive];
      if (r !== void 0) {
        var l = r.call(a, s || "default");
        if (typeof l != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (s === "string" ? String : Number)(a);
    }(i, "string");
    return typeof c == "symbol" ? c : c + "";
  }(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function O4(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);
    e && (i = i.filter(function(c) {
      return Object.getOwnPropertyDescriptor(n, c).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function lt(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? O4(Object(t), !0).forEach(function(i) {
      it(n, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : O4(Object(t)).forEach(function(i) {
      Object.defineProperty(n, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return n;
}
function Vi(n, e) {
  if (n == null) return {};
  var t, i, c = function(s, r) {
    if (s == null) return {};
    var l = {};
    for (var d in s) if ({}.hasOwnProperty.call(s, d)) {
      if (r.indexOf(d) >= 0) continue;
      l[d] = s[d];
    }
    return l;
  }(n, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);
    for (i = 0; i < a.length; i++) t = a[i], e.indexOf(t) >= 0 || {}.propertyIsEnumerable.call(n, t) && (c[t] = n[t]);
  }
  return c;
}
function Kh(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, { raw: { value: Object.freeze(e) } }));
}
class D4 {
  constructor() {
    it(this, "browserShadowBlurConstant", 1), it(this, "DPI", 96), it(this, "devicePixelRatio", typeof window < "u" ? window.devicePixelRatio : 1), it(this, "perfLimitSizeTotal", 2097152), it(this, "maxCacheSideLimit", 4096), it(this, "minCacheSideLimit", 256), it(this, "disableStyleCopyPaste", !1), it(this, "enableGLFiltering", !0), it(this, "textureSize", 4096), it(this, "forceGLPutImageData", !1), it(this, "cachesBoundsOfCurve", !1), it(this, "fontPaths", {}), it(this, "NUM_FRACTION_DIGITS", 4);
  }
}
const Br = new class extends D4 {
  constructor(n) {
    super(), this.configure(n);
  }
  configure() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Object.assign(this, n);
  }
  addFonts() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fontPaths = lt(lt({}, this.fontPaths), n);
  }
  removeFonts() {
    (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).forEach((n) => {
      delete this.fontPaths[n];
    });
  }
  clearFonts() {
    this.fontPaths = {};
  }
  restoreDefaults(n) {
    const e = new D4(), t = (n == null ? void 0 : n.reduce((i, c) => (i[c] = e[c], i), {})) || e;
    this.configure(t);
  }
}(), qh = function(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) t[i - 1] = arguments[i];
  return console[n]("fabric", ...t);
};
class ud extends Error {
  constructor(e, t) {
    super("fabric: ".concat(e), t);
  }
}
class N7 extends ud {
  constructor(e) {
    super("".concat(e, " 'options.signal' is in 'aborted' state"));
  }
}
class EW {
}
class SW extends EW {
  testPrecision(e, t) {
    const i = "precision ".concat(t, ` float;
void main(){}`), c = e.createShader(e.FRAGMENT_SHADER);
    return !!c && (e.shaderSource(c, i), e.compileShader(c), !!e.getShaderParameter(c, e.COMPILE_STATUS));
  }
  queryWebGL(e) {
    const t = e.getContext("webgl");
    t && (this.maxTextureSize = t.getParameter(t.MAX_TEXTURE_SIZE), this.GLPrecision = ["highp", "mediump", "lowp"].find((i) => this.testPrecision(t, i)), t.getExtension("WEBGL_lose_context").loseContext(), qh("log", "WebGL: max texture size ".concat(this.maxTextureSize)));
  }
  isSupported(e) {
    return !!this.maxTextureSize && this.maxTextureSize >= e;
  }
}
const CW = {};
let R4;
const fd = () => R4 || (R4 = { document, window, isTouchSupported: "ontouchstart" in window || "ontouchstart" in document || window && window.navigator && window.navigator.maxTouchPoints > 0, WebGLProbe: new SW(), dispose() {
}, copyPasteData: CW }), f0 = () => fd().document, A2 = () => fd().window, I7 = () => {
  var n;
  return Math.max((n = Br.devicePixelRatio) !== null && n !== void 0 ? n : A2().devicePixelRatio, 1);
}, h1 = new class {
  constructor() {
    it(this, "charWidthsCache", {}), it(this, "boundsOfCurveCache", {});
  }
  getFontCache(n) {
    let { fontFamily: e, fontStyle: t, fontWeight: i } = n;
    e = e.toLowerCase(), this.charWidthsCache[e] || (this.charWidthsCache[e] = {});
    const c = this.charWidthsCache[e], a = "".concat(t.toLowerCase(), "_").concat((i + "").toLowerCase());
    return c[a] || (c[a] = {}), c[a];
  }
  clearFontCache(n) {
    (n = (n || "").toLowerCase()) ? this.charWidthsCache[n] && delete this.charWidthsCache[n] : this.charWidthsCache = {};
  }
  limitDimsByArea(n) {
    const { perfLimitSizeTotal: e } = Br, t = Math.sqrt(e * n);
    return [Math.floor(t), Math.floor(e / t)];
  }
}(), nx = "6.5.4";
function mm() {
}
const Gh = Math.PI / 2, yf = 2 * Math.PI, eT = Math.PI / 180, gs = Object.freeze([1, 0, 0, 1, 0, 0]), tT = 16, Ih = 0.4477152502, pr = "center", ti = "left", Ks = "top", rx = "bottom", yo = "right", Qs = "none", nT = /\r?\n/, L7 = "moving", k2 = "scaling", M7 = "rotating", rT = "rotate", P7 = "skewing", T1 = "resizing", wW = "modifyPoly", xW = "modifyPath", Qb = "changed", O2 = "scale", _s = "scaleX", xl = "scaleY", h0 = "skewX", p0 = "skewY", ta = "fill", Zs = "stroke", Zb = "modified", Gg = "json", hw = "svg", pn = new class {
  constructor() {
    this[Gg] = /* @__PURE__ */ new Map(), this[hw] = /* @__PURE__ */ new Map();
  }
  has(n) {
    return this[Gg].has(n);
  }
  getClass(n) {
    const e = this[Gg].get(n);
    if (!e) throw new ud("No class registered for ".concat(n));
    return e;
  }
  setClass(n, e) {
    e ? this[Gg].set(e, n) : (this[Gg].set(n.type, n), this[Gg].set(n.type.toLowerCase(), n));
  }
  getSVGClass(n) {
    return this[hw].get(n);
  }
  setSVGClass(n, e) {
    this[hw].set(e ?? n.type.toLowerCase(), n);
  }
}(), Jb = new class extends Array {
  remove(n) {
    const e = this.indexOf(n);
    e > -1 && this.splice(e, 1);
  }
  cancelAll() {
    const n = this.splice(0);
    return n.forEach((e) => e.abort()), n;
  }
  cancelByCanvas(n) {
    if (!n) return [];
    const e = this.filter((t) => {
      var i;
      return t.target === n || typeof t.target == "object" && ((i = t.target) === null || i === void 0 ? void 0 : i.canvas) === n;
    });
    return e.forEach((t) => t.abort()), e;
  }
  cancelByTarget(n) {
    if (!n) return [];
    const e = this.filter((t) => t.target === n);
    return e.forEach((t) => t.abort()), e;
  }
}();
class TW {
  constructor() {
    it(this, "__eventListeners", {});
  }
  on(e, t) {
    if (this.__eventListeners || (this.__eventListeners = {}), typeof e == "object") return Object.entries(e).forEach((i) => {
      let [c, a] = i;
      this.on(c, a);
    }), () => this.off(e);
    if (t) {
      const i = e;
      return this.__eventListeners[i] || (this.__eventListeners[i] = []), this.__eventListeners[i].push(t), () => this.off(i, t);
    }
    return () => !1;
  }
  once(e, t) {
    if (typeof e == "object") {
      const i = [];
      return Object.entries(e).forEach((c) => {
        let [a, s] = c;
        i.push(this.once(a, s));
      }), () => i.forEach((c) => c());
    }
    if (t) {
      const i = this.on(e, function() {
        for (var c = arguments.length, a = new Array(c), s = 0; s < c; s++) a[s] = arguments[s];
        t.call(this, ...a), i();
      });
      return i;
    }
    return () => !1;
  }
  _removeEventListener(e, t) {
    if (this.__eventListeners[e]) if (t) {
      const i = this.__eventListeners[e], c = i.indexOf(t);
      c > -1 && i.splice(c, 1);
    } else this.__eventListeners[e] = [];
  }
  off(e, t) {
    if (this.__eventListeners) if (e === void 0) for (const i in this.__eventListeners) this._removeEventListener(i);
    else typeof e == "object" ? Object.entries(e).forEach((i) => {
      let [c, a] = i;
      this._removeEventListener(c, a);
    }) : this._removeEventListener(e, t);
  }
  fire(e, t) {
    var i;
    if (!this.__eventListeners) return;
    const c = (i = this.__eventListeners[e]) === null || i === void 0 ? void 0 : i.concat();
    if (c) for (let a = 0; a < c.length; a++) c[a].call(this, t || {});
  }
}
const am = (n, e) => {
  const t = n.indexOf(e);
  return t !== -1 && n.splice(t, 1), n;
}, ic = (n) => {
  if (n === 0) return 1;
  switch (Math.abs(n) / Gh) {
    case 1:
    case 3:
      return 0;
    case 2:
      return -1;
  }
  return Math.cos(n);
}, oc = (n) => {
  if (n === 0) return 0;
  const e = n / Gh, t = Math.sign(n);
  switch (e) {
    case 1:
      return t;
    case 2:
      return 0;
    case 3:
      return -t;
  }
  return Math.sin(n);
};
class St {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    typeof e == "object" ? (this.x = e.x, this.y = e.y) : (this.x = e, this.y = t);
  }
  add(e) {
    return new St(this.x + e.x, this.y + e.y);
  }
  addEquals(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  scalarAdd(e) {
    return new St(this.x + e, this.y + e);
  }
  scalarAddEquals(e) {
    return this.x += e, this.y += e, this;
  }
  subtract(e) {
    return new St(this.x - e.x, this.y - e.y);
  }
  subtractEquals(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  scalarSubtract(e) {
    return new St(this.x - e, this.y - e);
  }
  scalarSubtractEquals(e) {
    return this.x -= e, this.y -= e, this;
  }
  multiply(e) {
    return new St(this.x * e.x, this.y * e.y);
  }
  scalarMultiply(e) {
    return new St(this.x * e, this.y * e);
  }
  scalarMultiplyEquals(e) {
    return this.x *= e, this.y *= e, this;
  }
  divide(e) {
    return new St(this.x / e.x, this.y / e.y);
  }
  scalarDivide(e) {
    return new St(this.x / e, this.y / e);
  }
  scalarDivideEquals(e) {
    return this.x /= e, this.y /= e, this;
  }
  eq(e) {
    return this.x === e.x && this.y === e.y;
  }
  lt(e) {
    return this.x < e.x && this.y < e.y;
  }
  lte(e) {
    return this.x <= e.x && this.y <= e.y;
  }
  gt(e) {
    return this.x > e.x && this.y > e.y;
  }
  gte(e) {
    return this.x >= e.x && this.y >= e.y;
  }
  lerp(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.5;
    return t = Math.max(Math.min(1, t), 0), new St(this.x + (e.x - this.x) * t, this.y + (e.y - this.y) * t);
  }
  distanceFrom(e) {
    const t = this.x - e.x, i = this.y - e.y;
    return Math.sqrt(t * t + i * i);
  }
  midPointFrom(e) {
    return this.lerp(e);
  }
  min(e) {
    return new St(Math.min(this.x, e.x), Math.min(this.y, e.y));
  }
  max(e) {
    return new St(Math.max(this.x, e.x), Math.max(this.y, e.y));
  }
  toString() {
    return "".concat(this.x, ",").concat(this.y);
  }
  setXY(e, t) {
    return this.x = e, this.y = t, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setFromPoint(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  swap(e) {
    const t = this.x, i = this.y;
    this.x = e.x, this.y = e.y, e.x = t, e.y = i;
  }
  clone() {
    return new St(this.x, this.y);
  }
  rotate(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : iT;
    const i = oc(e), c = ic(e), a = this.subtract(t);
    return new St(a.x * c - a.y * i, a.x * i + a.y * c).add(t);
  }
  transform(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return new St(e[0] * this.x + e[2] * this.y + (t ? 0 : e[4]), e[1] * this.x + e[3] * this.y + (t ? 0 : e[5]));
  }
}
const iT = new St(0, 0), Mb = (n) => !!n && Array.isArray(n._objects);
function j7(n) {
  class e extends n {
    constructor() {
      super(...arguments), it(this, "_objects", []);
    }
    _onObjectAdded(i) {
    }
    _onObjectRemoved(i) {
    }
    _onStackOrderChanged(i) {
    }
    add() {
      for (var i = arguments.length, c = new Array(i), a = 0; a < i; a++) c[a] = arguments[a];
      const s = this._objects.push(...c);
      return c.forEach((r) => this._onObjectAdded(r)), s;
    }
    insertAt(i) {
      for (var c = arguments.length, a = new Array(c > 1 ? c - 1 : 0), s = 1; s < c; s++) a[s - 1] = arguments[s];
      return this._objects.splice(i, 0, ...a), a.forEach((r) => this._onObjectAdded(r)), this._objects.length;
    }
    remove() {
      const i = this._objects, c = [];
      for (var a = arguments.length, s = new Array(a), r = 0; r < a; r++) s[r] = arguments[r];
      return s.forEach((l) => {
        const d = i.indexOf(l);
        d !== -1 && (i.splice(d, 1), c.push(l), this._onObjectRemoved(l));
      }), c;
    }
    forEachObject(i) {
      this.getObjects().forEach((c, a, s) => i(c, a, s));
    }
    getObjects() {
      for (var i = arguments.length, c = new Array(i), a = 0; a < i; a++) c[a] = arguments[a];
      return c.length === 0 ? [...this._objects] : this._objects.filter((s) => s.isType(...c));
    }
    item(i) {
      return this._objects[i];
    }
    isEmpty() {
      return this._objects.length === 0;
    }
    size() {
      return this._objects.length;
    }
    contains(i, c) {
      return !!this._objects.includes(i) || !!c && this._objects.some((a) => a instanceof e && a.contains(i, !0));
    }
    complexity() {
      return this._objects.reduce((i, c) => i += c.complexity ? c.complexity() : 0, 0);
    }
    sendObjectToBack(i) {
      return !(!i || i === this._objects[0]) && (am(this._objects, i), this._objects.unshift(i), this._onStackOrderChanged(i), !0);
    }
    bringObjectToFront(i) {
      return !(!i || i === this._objects[this._objects.length - 1]) && (am(this._objects, i), this._objects.push(i), this._onStackOrderChanged(i), !0);
    }
    sendObjectBackwards(i, c) {
      if (!i) return !1;
      const a = this._objects.indexOf(i);
      if (a !== 0) {
        const s = this.findNewLowerIndex(i, a, c);
        return am(this._objects, i), this._objects.splice(s, 0, i), this._onStackOrderChanged(i), !0;
      }
      return !1;
    }
    bringObjectForward(i, c) {
      if (!i) return !1;
      const a = this._objects.indexOf(i);
      if (a !== this._objects.length - 1) {
        const s = this.findNewUpperIndex(i, a, c);
        return am(this._objects, i), this._objects.splice(s, 0, i), this._onStackOrderChanged(i), !0;
      }
      return !1;
    }
    moveObjectTo(i, c) {
      return i !== this._objects[c] && (am(this._objects, i), this._objects.splice(c, 0, i), this._onStackOrderChanged(i), !0);
    }
    findNewLowerIndex(i, c, a) {
      let s;
      if (a) {
        s = c;
        for (let r = c - 1; r >= 0; --r) if (i.isOverlapping(this._objects[r])) {
          s = r;
          break;
        }
      } else s = c - 1;
      return s;
    }
    findNewUpperIndex(i, c, a) {
      let s;
      if (a) {
        s = c;
        for (let r = c + 1; r < this._objects.length; ++r) if (i.isOverlapping(this._objects[r])) {
          s = r;
          break;
        }
      } else s = c + 1;
      return s;
    }
    collectObjects(i) {
      let { left: c, top: a, width: s, height: r } = i, { includeIntersecting: l = !0 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const d = [], f = new St(c, a), h = f.add(new St(s, r));
      for (let p = this._objects.length - 1; p >= 0; p--) {
        const g = this._objects[p];
        g.selectable && g.visible && (l && g.intersectsWithRect(f, h) || g.isContainedWithinRect(f, h) || l && g.containsPoint(f) || l && g.containsPoint(h)) && d.push(g);
      }
      return d;
    }
  }
  return e;
}
class B7 extends TW {
  _setOptions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    for (const t in e) this.set(t, e[t]);
  }
  _setObject(e) {
    for (const t in e) this._set(t, e[t]);
  }
  set(e, t) {
    return typeof e == "object" ? this._setObject(e) : this._set(e, t), this;
  }
  _set(e, t) {
    this[e] = t;
  }
  toggle(e) {
    const t = this.get(e);
    return typeof t == "boolean" && this.set(e, !t), this;
  }
  get(e) {
    return this[e];
  }
}
function p1(n) {
  return A2().requestAnimationFrame(n);
}
function F7(n) {
  return A2().cancelAnimationFrame(n);
}
let AW = 0;
const Wh = () => AW++, lu = () => {
  const n = f0().createElement("canvas");
  if (!n || n.getContext === void 0) throw new ud("Failed to create `canvas` element");
  return n;
}, U7 = () => f0().createElement("img"), ac = (n) => {
  const e = lu();
  return e.width = n.width, e.height = n.height, e;
}, oT = (n, e, t) => n.toDataURL("image/".concat(e), t), oo = (n) => n * eT, $h = (n) => n / eT, H7 = (n) => n.every((e, t) => e === gs[t]), Ja = (n, e, t) => new St(n).transform(e, t), Cl = (n) => {
  const e = 1 / (n[0] * n[3] - n[1] * n[2]), t = [e * n[3], -e * n[1], -e * n[2], e * n[0], 0, 0], { x: i, y: c } = new St(n[4], n[5]).transform(t, !0);
  return t[4] = -i, t[5] = -c, t;
}, Io = (n, e, t) => [n[0] * e[0] + n[2] * e[1], n[1] * e[0] + n[3] * e[1], n[0] * e[2] + n[2] * e[3], n[1] * e[2] + n[3] * e[3], t ? 0 : n[0] * e[4] + n[2] * e[5] + n[4], t ? 0 : n[1] * e[4] + n[3] * e[5] + n[5]], D2 = (n, e) => n.reduceRight((t, i) => i && t ? Io(i, t, e) : i || t, void 0) || gs.concat(), z7 = (n) => {
  let [e, t] = n;
  return Math.atan2(t, e);
}, s0 = (n) => {
  const e = z7(n), t = Math.pow(n[0], 2) + Math.pow(n[1], 2), i = Math.sqrt(t), c = (n[0] * n[3] - n[2] * n[1]) / i, a = Math.atan2(n[0] * n[2] + n[1] * n[3], t);
  return { angle: $h(e), scaleX: i, scaleY: c, skewX: $h(a), skewY: 0, translateX: n[4] || 0, translateY: n[5] || 0 };
}, m0 = function(n) {
  return [1, 0, 0, 1, n, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0];
};
function g0() {
  let { angle: n = 0 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { x: e = 0, y: t = 0 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const i = oo(n), c = ic(i), a = oc(i);
  return [c, a, -a, c, e ? e - (c * e - a * t) : 0, t ? t - (a * e + c * t) : 0];
}
const R2 = function(n) {
  return [n, 0, 0, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, 0, 0];
}, V7 = (n) => Math.tan(oo(n)), aT = (n) => [1, 0, V7(n), 1, 0, 0], sT = (n) => [1, V7(n), 0, 1, 0, 0], B1 = (n) => {
  let { scaleX: e = 1, scaleY: t = 1, flipX: i = !1, flipY: c = !1, skewX: a = 0, skewY: s = 0 } = n, r = R2(i ? -e : e, c ? -t : t);
  return a && (r = Io(r, aT(a), !0)), s && (r = Io(r, sT(s), !0)), r;
}, q7 = (n) => {
  const { translateX: e = 0, translateY: t = 0, angle: i = 0 } = n;
  let c = m0(e, t);
  i && (c = Io(c, g0({ angle: i })));
  const a = B1(n);
  return H7(a) || (c = Io(c, a)), c;
}, m1 = function(n) {
  let { signal: e, crossOrigin: t = null } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(i, c) {
    if (e && e.aborted) return c(new N7("loadImage"));
    const a = U7();
    let s;
    e && (s = function(l) {
      a.src = "", c(l);
    }, e.addEventListener("abort", s, { once: !0 }));
    const r = function() {
      a.onload = a.onerror = null, s && (e == null || e.removeEventListener("abort", s)), i(a);
    };
    n ? (a.onload = r, a.onerror = function() {
      s && (e == null || e.removeEventListener("abort", s)), c(new ud("Error loading ".concat(a.src)));
    }, t && (a.crossOrigin = t), a.src = n) : r();
  });
}, l0 = function(n) {
  let { signal: e, reviver: t = mm } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise((i, c) => {
    const a = [];
    e && e.addEventListener("abort", c, { once: !0 }), Promise.all(n.map((s) => pn.getClass(s.type).fromObject(s, { signal: e }).then((r) => (t(s, r), a.push(r), r)))).then(i).catch((s) => {
      a.forEach((r) => {
        r.dispose && r.dispose();
      }), c(s);
    }).finally(() => {
      e && e.removeEventListener("abort", c);
    });
  });
}, F1 = function(n) {
  let { signal: e } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise((t, i) => {
    const c = [];
    e && e.addEventListener("abort", i, { once: !0 });
    const a = Object.values(n).map((r) => r && r.type && pn.has(r.type) ? l0([r], { signal: e }).then((l) => {
      let [d] = l;
      return c.push(d), d;
    }) : r), s = Object.keys(n);
    Promise.all(a).then((r) => r.reduce((l, d, f) => (l[s[f]] = d, l), {})).then(t).catch((r) => {
      c.forEach((l) => {
        l.dispose && l.dispose();
      }), i(r);
    }).finally(() => {
      e && e.removeEventListener("abort", i);
    });
  });
}, Rm = function(n) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : []).reduce((e, t) => (t in n && (e[t] = n[t]), e), {});
}, lT = (n, e) => Object.keys(n).reduce((t, i) => (e(n[i], i, n) && (t[i] = n[i]), t), {}), N4 = { aliceblue: "#F0F8FF", antiquewhite: "#FAEBD7", aqua: "#0FF", aquamarine: "#7FFFD4", azure: "#F0FFFF", beige: "#F5F5DC", bisque: "#FFE4C4", black: "#000", blanchedalmond: "#FFEBCD", blue: "#00F", blueviolet: "#8A2BE2", brown: "#A52A2A", burlywood: "#DEB887", cadetblue: "#5F9EA0", chartreuse: "#7FFF00", chocolate: "#D2691E", coral: "#FF7F50", cornflowerblue: "#6495ED", cornsilk: "#FFF8DC", crimson: "#DC143C", cyan: "#0FF", darkblue: "#00008B", darkcyan: "#008B8B", darkgoldenrod: "#B8860B", darkgray: "#A9A9A9", darkgrey: "#A9A9A9", darkgreen: "#006400", darkkhaki: "#BDB76B", darkmagenta: "#8B008B", darkolivegreen: "#556B2F", darkorange: "#FF8C00", darkorchid: "#9932CC", darkred: "#8B0000", darksalmon: "#E9967A", darkseagreen: "#8FBC8F", darkslateblue: "#483D8B", darkslategray: "#2F4F4F", darkslategrey: "#2F4F4F", darkturquoise: "#00CED1", darkviolet: "#9400D3", deeppink: "#FF1493", deepskyblue: "#00BFFF", dimgray: "#696969", dimgrey: "#696969", dodgerblue: "#1E90FF", firebrick: "#B22222", floralwhite: "#FFFAF0", forestgreen: "#228B22", fuchsia: "#F0F", gainsboro: "#DCDCDC", ghostwhite: "#F8F8FF", gold: "#FFD700", goldenrod: "#DAA520", gray: "#808080", grey: "#808080", green: "#008000", greenyellow: "#ADFF2F", honeydew: "#F0FFF0", hotpink: "#FF69B4", indianred: "#CD5C5C", indigo: "#4B0082", ivory: "#FFFFF0", khaki: "#F0E68C", lavender: "#E6E6FA", lavenderblush: "#FFF0F5", lawngreen: "#7CFC00", lemonchiffon: "#FFFACD", lightblue: "#ADD8E6", lightcoral: "#F08080", lightcyan: "#E0FFFF", lightgoldenrodyellow: "#FAFAD2", lightgray: "#D3D3D3", lightgrey: "#D3D3D3", lightgreen: "#90EE90", lightpink: "#FFB6C1", lightsalmon: "#FFA07A", lightseagreen: "#20B2AA", lightskyblue: "#87CEFA", lightslategray: "#789", lightslategrey: "#789", lightsteelblue: "#B0C4DE", lightyellow: "#FFFFE0", lime: "#0F0", limegreen: "#32CD32", linen: "#FAF0E6", magenta: "#F0F", maroon: "#800000", mediumaquamarine: "#66CDAA", mediumblue: "#0000CD", mediumorchid: "#BA55D3", mediumpurple: "#9370DB", mediumseagreen: "#3CB371", mediumslateblue: "#7B68EE", mediumspringgreen: "#00FA9A", mediumturquoise: "#48D1CC", mediumvioletred: "#C71585", midnightblue: "#191970", mintcream: "#F5FFFA", mistyrose: "#FFE4E1", moccasin: "#FFE4B5", navajowhite: "#FFDEAD", navy: "#000080", oldlace: "#FDF5E6", olive: "#808000", olivedrab: "#6B8E23", orange: "#FFA500", orangered: "#FF4500", orchid: "#DA70D6", palegoldenrod: "#EEE8AA", palegreen: "#98FB98", paleturquoise: "#AFEEEE", palevioletred: "#DB7093", papayawhip: "#FFEFD5", peachpuff: "#FFDAB9", peru: "#CD853F", pink: "#FFC0CB", plum: "#DDA0DD", powderblue: "#B0E0E6", purple: "#800080", rebeccapurple: "#639", red: "#F00", rosybrown: "#BC8F8F", royalblue: "#4169E1", saddlebrown: "#8B4513", salmon: "#FA8072", sandybrown: "#F4A460", seagreen: "#2E8B57", seashell: "#FFF5EE", sienna: "#A0522D", silver: "#C0C0C0", skyblue: "#87CEEB", slateblue: "#6A5ACD", slategray: "#708090", slategrey: "#708090", snow: "#FFFAFA", springgreen: "#00FF7F", steelblue: "#4682B4", tan: "#D2B48C", teal: "#008080", thistle: "#D8BFD8", tomato: "#FF6347", turquoise: "#40E0D0", violet: "#EE82EE", wheat: "#F5DEB3", white: "#FFF", whitesmoke: "#F5F5F5", yellow: "#FF0", yellowgreen: "#9ACD32" }, pw = (n, e, t) => (t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? n + 6 * (e - n) * t : t < 0.5 ? e : t < 2 / 3 ? n + (e - n) * (2 / 3 - t) * 6 : n), I4 = (n, e, t, i) => {
  n /= 255, e /= 255, t /= 255;
  const c = Math.max(n, e, t), a = Math.min(n, e, t);
  let s, r;
  const l = (c + a) / 2;
  if (c === a) s = r = 0;
  else {
    const d = c - a;
    switch (r = l > 0.5 ? d / (2 - c - a) : d / (c + a), c) {
      case n:
        s = (e - t) / d + (e < t ? 6 : 0);
        break;
      case e:
        s = (t - n) / d + 2;
        break;
      case t:
        s = (n - e) / d + 4;
    }
    s /= 6;
  }
  return [Math.round(360 * s), Math.round(100 * r), Math.round(100 * l), i];
}, L4 = function() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1";
  return parseFloat(n) / (n.endsWith("%") ? 100 : 1);
}, eb = (n) => Math.min(Math.round(n), 255).toString(16).toUpperCase().padStart(2, "0"), M4 = (n) => {
  let [e, t, i, c = 1] = n;
  const a = Math.round(0.3 * e + 0.59 * t + 0.11 * i);
  return [a, a, a, c];
};
class Wr {
  constructor(e) {
    if (it(this, "isUnrecognised", !1), e) if (e instanceof Wr) this.setSource([...e._source]);
    else if (Array.isArray(e)) {
      const [t, i, c, a = 1] = e;
      this.setSource([t, i, c, a]);
    } else this.setSource(this._tryParsingColor(e));
    else this.setSource([0, 0, 0, 1]);
  }
  _tryParsingColor(e) {
    return (e = e.toLowerCase()) in N4 && (e = N4[e]), e === "transparent" ? [255, 255, 255, 0] : Wr.sourceFromHex(e) || Wr.sourceFromRgb(e) || Wr.sourceFromHsl(e) || (this.isUnrecognised = !0) && [0, 0, 0, 1];
  }
  getSource() {
    return this._source;
  }
  setSource(e) {
    this._source = e;
  }
  toRgb() {
    const [e, t, i] = this.getSource();
    return "rgb(".concat(e, ",").concat(t, ",").concat(i, ")");
  }
  toRgba() {
    return "rgba(".concat(this.getSource().join(","), ")");
  }
  toHsl() {
    const [e, t, i] = I4(...this.getSource());
    return "hsl(".concat(e, ",").concat(t, "%,").concat(i, "%)");
  }
  toHsla() {
    const [e, t, i, c] = I4(...this.getSource());
    return "hsla(".concat(e, ",").concat(t, "%,").concat(i, "%,").concat(c, ")");
  }
  toHex() {
    return this.toHexa().slice(0, 6);
  }
  toHexa() {
    const [e, t, i, c] = this.getSource();
    return "".concat(eb(e)).concat(eb(t)).concat(eb(i)).concat(eb(Math.round(255 * c)));
  }
  getAlpha() {
    return this.getSource()[3];
  }
  setAlpha(e) {
    return this._source[3] = e, this;
  }
  toGrayscale() {
    return this.setSource(M4(this.getSource())), this;
  }
  toBlackWhite(e) {
    const [t, , , i] = M4(this.getSource()), c = t < (e || 127) ? 0 : 255;
    return this.setSource([c, c, c, i]), this;
  }
  overlayWith(e) {
    e instanceof Wr || (e = new Wr(e));
    const t = this.getSource(), i = e.getSource(), [c, a, s] = t.map((r, l) => Math.round(0.5 * r + 0.5 * i[l]));
    return this.setSource([c, a, s, t[3]]), this;
  }
  static fromRgb(e) {
    return Wr.fromRgba(e);
  }
  static fromRgba(e) {
    return new Wr(Wr.sourceFromRgb(e));
  }
  static sourceFromRgb(e) {
    const t = e.match(/^rgba?\(\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d{0,3}(?:\.\d+)?%?)\s*)?\)$/i);
    if (t) {
      const [i, c, a] = t.slice(1, 4).map((s) => {
        const r = parseFloat(s);
        return s.endsWith("%") ? Math.round(2.55 * r) : r;
      });
      return [i, c, a, L4(t[4])];
    }
  }
  static fromHsl(e) {
    return Wr.fromHsla(e);
  }
  static fromHsla(e) {
    return new Wr(Wr.sourceFromHsl(e));
  }
  static sourceFromHsl(e) {
    const t = e.match(/^hsla?\(\s*([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d*(?:\.\d+)?%?)\s*)?\)$/i);
    if (!t) return;
    const i = (Wr.parseAngletoDegrees(t[1]) % 360 + 360) % 360 / 360, c = parseFloat(t[2]) / 100, a = parseFloat(t[3]) / 100;
    let s, r, l;
    if (c === 0) s = r = l = a;
    else {
      const d = a <= 0.5 ? a * (c + 1) : a + c - a * c, f = 2 * a - d;
      s = pw(f, d, i + 1 / 3), r = pw(f, d, i), l = pw(f, d, i - 1 / 3);
    }
    return [Math.round(255 * s), Math.round(255 * r), Math.round(255 * l), L4(t[4])];
  }
  static fromHex(e) {
    return new Wr(Wr.sourceFromHex(e));
  }
  static sourceFromHex(e) {
    if (e.match(/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i)) {
      const t = e.slice(e.indexOf("#") + 1);
      let i;
      i = t.length <= 4 ? t.split("").map((l) => l + l) : t.match(/.{2}/g);
      const [c, a, s, r = 255] = i.map((l) => parseInt(l, 16));
      return [c, a, s, r / 255];
    }
  }
  static parseAngletoDegrees(e) {
    const t = e.toLowerCase(), i = parseFloat(t);
    return t.includes("rad") ? $h(i) : t.includes("turn") ? 360 * i : i;
  }
}
const zi = (n, e) => parseFloat(Number(n).toFixed(e)), gm = function(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : tT;
  const t = /\D{0,2}$/.exec(n), i = parseFloat(n), c = Br.DPI;
  switch (t == null ? void 0 : t[0]) {
    case "mm":
      return i * c / 25.4;
    case "cm":
      return i * c / 2.54;
    case "in":
      return i * c;
    case "pt":
      return i * c / 72;
    case "pc":
      return i * c / 72 * 12;
    case "em":
      return i * e;
    default:
      return i;
  }
}, G7 = (n) => {
  const [e, t] = n.trim().split(" "), [i, c] = (a = e) && a !== Qs ? [a.slice(1, 4), a.slice(5, 8)] : a === Qs ? [a, a] : ["Mid", "Mid"];
  var a;
  return { meetOrSlice: t || "meet", alignX: i, alignY: c };
}, A1 = (n) => "matrix(" + n.map((e) => zi(e, Br.NUM_FRACTION_DIGITS)).join(" ") + ")", k1 = function(n, e) {
  let t, i, c = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
  if (e) if (e.toLive) t = "url(#SVGID_".concat(e.id, ")");
  else {
    const a = new Wr(e), s = a.getAlpha();
    t = a.toRgb(), s !== 1 && (i = s.toString());
  }
  else t = "none";
  return c ? "".concat(n, ": ").concat(t, "; ").concat(i ? "".concat(n, "-opacity: ").concat(i, "; ") : "") : "".concat(n, '="').concat(t, '" ').concat(i ? "".concat(n, '-opacity="').concat(i, '" ') : "");
}, au = (n) => !!n && n.toLive !== void 0, P4 = (n) => !!n && typeof n.toObject == "function", j4 = (n) => !!n && n.offsetX !== void 0 && "source" in n, sm = (n) => !!n && "multiSelectionStacking" in n;
function W7(n) {
  const e = n && tc(n);
  let t = 0, i = 0;
  if (!n || !e) return { left: t, top: i };
  let c = n;
  const a = e.documentElement, s = e.body || { scrollLeft: 0, scrollTop: 0 };
  for (; c && (c.parentNode || c.host) && (c = c.parentNode || c.host, c === e ? (t = s.scrollLeft || a.scrollLeft || 0, i = s.scrollTop || a.scrollTop || 0) : (t += c.scrollLeft || 0, i += c.scrollTop || 0), c.nodeType !== 1 || c.style.position !== "fixed"); ) ;
  return { left: t, top: i };
}
const tc = (n) => n.ownerDocument || null, $7 = (n) => {
  var e;
  return ((e = n.ownerDocument) === null || e === void 0 ? void 0 : e.defaultView) || null;
}, Y7 = function(n, e, t) {
  let { width: i, height: c } = t, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  n.width = i, n.height = c, a > 1 && (n.setAttribute("width", (i * a).toString()), n.setAttribute("height", (c * a).toString()), e.scale(a, a));
}, ix = (n, e) => {
  let { width: t, height: i } = e;
  t && (n.style.width = typeof t == "number" ? "".concat(t, "px") : t), i && (n.style.height = typeof i == "number" ? "".concat(i, "px") : i);
};
function B4(n) {
  return n.onselectstart !== void 0 && (n.onselectstart = () => !1), n.style.userSelect = Qs, n;
}
class X7 {
  constructor(e) {
    it(this, "_originalCanvasStyle", void 0), it(this, "lower", void 0);
    const t = this.createLowerCanvas(e);
    this.lower = { el: t, ctx: t.getContext("2d") };
  }
  createLowerCanvas(e) {
    const t = (i = e) && i.getContext !== void 0 ? e : e && f0().getElementById(e) || lu();
    var i;
    if (t.hasAttribute("data-fabric")) throw new ud("Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?");
    return this._originalCanvasStyle = t.style.cssText, t.setAttribute("data-fabric", "main"), t.classList.add("lower-canvas"), t;
  }
  cleanupDOM(e) {
    let { width: t, height: i } = e;
    const { el: c } = this.lower;
    c.classList.remove("lower-canvas"), c.removeAttribute("data-fabric"), c.setAttribute("width", "".concat(t)), c.setAttribute("height", "".concat(i)), c.style.cssText = this._originalCanvasStyle || "", this._originalCanvasStyle = void 0;
  }
  setDimensions(e, t) {
    const { el: i, ctx: c } = this.lower;
    Y7(i, c, e, t);
  }
  setCSSDimensions(e) {
    ix(this.lower.el, e);
  }
  calcOffset() {
    return function(e) {
      var t;
      const i = e && tc(e), c = { left: 0, top: 0 };
      if (!i) return c;
      const a = ((t = $7(e)) === null || t === void 0 ? void 0 : t.getComputedStyle(e, null)) || {};
      c.left += parseInt(a.borderLeftWidth, 10) || 0, c.top += parseInt(a.borderTopWidth, 10) || 0, c.left += parseInt(a.paddingLeft, 10) || 0, c.top += parseInt(a.paddingTop, 10) || 0;
      let s = { left: 0, top: 0 };
      const r = i.documentElement;
      e.getBoundingClientRect !== void 0 && (s = e.getBoundingClientRect());
      const l = W7(e);
      return { left: s.left + l.left - (r.clientLeft || 0) + c.left, top: s.top + l.top - (r.clientTop || 0) + c.top };
    }(this.lower.el);
  }
  dispose() {
    fd().dispose(this.lower.el), delete this.lower;
  }
}
const kW = { backgroundVpt: !0, backgroundColor: "", overlayVpt: !0, overlayColor: "", includeDefaultValues: !0, svgViewportTransformation: !0, renderOnAddRemove: !0, skipOffscreen: !0, enableRetinaScaling: !0, imageSmoothingEnabled: !0, controlsAboveOverlay: !1, allowTouchScrolling: !1, viewportTransform: [...gs] };
class U1 extends j7(B7) {
  get lowerCanvasEl() {
    var e;
    return (e = this.elements.lower) === null || e === void 0 ? void 0 : e.el;
  }
  get contextContainer() {
    var e;
    return (e = this.elements.lower) === null || e === void 0 ? void 0 : e.ctx;
  }
  static getDefaults() {
    return U1.ownDefaults;
  }
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Object.assign(this, this.constructor.getDefaults()), this.set(t), this.initElements(e), this._setDimensionsImpl({ width: this.width || this.elements.lower.el.width || 0, height: this.height || this.elements.lower.el.height || 0 }), this.skipControlsDrawing = !1, this.viewportTransform = [...this.viewportTransform], this.calcViewportBoundaries();
  }
  initElements(e) {
    this.elements = new X7(e);
  }
  add() {
    const e = super.add(...arguments);
    return arguments.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), e;
  }
  insertAt(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++) i[c - 1] = arguments[c];
    const a = super.insertAt(e, ...i);
    return i.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), a;
  }
  remove() {
    const e = super.remove(...arguments);
    return e.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), e;
  }
  _onObjectAdded(e) {
    e.canvas && e.canvas !== this && (qh("warn", `Canvas is trying to add an object that belongs to a different canvas.
Resulting to default behavior: removing object from previous canvas and adding to new canvas`), e.canvas.remove(e)), e._set("canvas", this), e.setCoords(), this.fire("object:added", { target: e }), e.fire("added", { target: this });
  }
  _onObjectRemoved(e) {
    e._set("canvas", void 0), this.fire("object:removed", { target: e }), e.fire("removed", { target: this });
  }
  _onStackOrderChanged() {
    this.renderOnAddRemove && this.requestRenderAll();
  }
  getRetinaScaling() {
    return this.enableRetinaScaling ? I7() : 1;
  }
  calcOffset() {
    return this._offset = this.elements.calcOffset();
  }
  getWidth() {
    return this.width;
  }
  getHeight() {
    return this.height;
  }
  setWidth(e, t) {
    return this.setDimensions({ width: e }, t);
  }
  setHeight(e, t) {
    return this.setDimensions({ height: e }, t);
  }
  _setDimensionsImpl(e) {
    let { cssOnly: t = !1, backstoreOnly: i = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!t) {
      const c = lt({ width: this.width, height: this.height }, e);
      this.elements.setDimensions(c, this.getRetinaScaling()), this.hasLostContext = !0, this.width = c.width, this.height = c.height;
    }
    i || this.elements.setCSSDimensions(e), this.calcOffset();
  }
  setDimensions(e, t) {
    this._setDimensionsImpl(e, t), t && t.cssOnly || this.requestRenderAll();
  }
  getZoom() {
    return this.viewportTransform[0];
  }
  setViewportTransform(e) {
    this.viewportTransform = e, this.calcViewportBoundaries(), this.renderOnAddRemove && this.requestRenderAll();
  }
  zoomToPoint(e, t) {
    const i = e, c = [...this.viewportTransform], a = Ja(e, Cl(c));
    c[0] = t, c[3] = t;
    const s = Ja(a, c);
    c[4] += i.x - s.x, c[5] += i.y - s.y, this.setViewportTransform(c);
  }
  setZoom(e) {
    this.zoomToPoint(new St(0, 0), e);
  }
  absolutePan(e) {
    const t = [...this.viewportTransform];
    return t[4] = -e.x, t[5] = -e.y, this.setViewportTransform(t);
  }
  relativePan(e) {
    return this.absolutePan(new St(-e.x - this.viewportTransform[4], -e.y - this.viewportTransform[5]));
  }
  getElement() {
    return this.elements.lower.el;
  }
  clearContext(e) {
    e.clearRect(0, 0, this.width, this.height);
  }
  getContext() {
    return this.elements.lower.ctx;
  }
  clear() {
    this.remove(...this.getObjects()), this.backgroundImage = void 0, this.overlayImage = void 0, this.backgroundColor = "", this.overlayColor = "", this.clearContext(this.getContext()), this.fire("canvas:cleared"), this.renderOnAddRemove && this.requestRenderAll();
  }
  renderAll() {
    this.cancelRequestedRender(), this.destroyed || this.renderCanvas(this.getContext(), this._objects);
  }
  renderAndReset() {
    this.nextRenderHandle = 0, this.renderAll();
  }
  requestRenderAll() {
    this.nextRenderHandle || this.disposed || this.destroyed || (this.nextRenderHandle = p1(() => this.renderAndReset()));
  }
  calcViewportBoundaries() {
    const e = this.width, t = this.height, i = Cl(this.viewportTransform), c = Ja({ x: 0, y: 0 }, i), a = Ja({ x: e, y: t }, i), s = c.min(a), r = c.max(a);
    return this.vptCoords = { tl: s, tr: new St(r.x, s.y), bl: new St(s.x, r.y), br: r };
  }
  cancelRequestedRender() {
    this.nextRenderHandle && (F7(this.nextRenderHandle), this.nextRenderHandle = 0);
  }
  drawControls(e) {
  }
  renderCanvas(e, t) {
    if (this.destroyed) return;
    const i = this.viewportTransform, c = this.clipPath;
    this.calcViewportBoundaries(), this.clearContext(e), e.imageSmoothingEnabled = this.imageSmoothingEnabled, e.patternQuality = "best", this.fire("before:render", { ctx: e }), this._renderBackground(e), e.save(), e.transform(i[0], i[1], i[2], i[3], i[4], i[5]), this._renderObjects(e, t), e.restore(), this.controlsAboveOverlay || this.skipControlsDrawing || this.drawControls(e), c && (c._set("canvas", this), c.shouldCache(), c._transformDone = !0, c.renderCache({ forClipping: !0 }), this.drawClipPathOnCanvas(e, c)), this._renderOverlay(e), this.controlsAboveOverlay && !this.skipControlsDrawing && this.drawControls(e), this.fire("after:render", { ctx: e }), this.__cleanupTask && (this.__cleanupTask(), this.__cleanupTask = void 0);
  }
  drawClipPathOnCanvas(e, t) {
    const i = this.viewportTransform;
    e.save(), e.transform(...i), e.globalCompositeOperation = "destination-in", t.transform(e), e.scale(1 / t.zoomX, 1 / t.zoomY), e.drawImage(t._cacheCanvas, -t.cacheTranslationX, -t.cacheTranslationY), e.restore();
  }
  _renderObjects(e, t) {
    for (let i = 0, c = t.length; i < c; ++i) t[i] && t[i].render(e);
  }
  _renderBackgroundOrOverlay(e, t) {
    const i = this["".concat(t, "Color")], c = this["".concat(t, "Image")], a = this.viewportTransform, s = this["".concat(t, "Vpt")];
    if (!i && !c) return;
    const r = au(i);
    if (i) {
      if (e.save(), e.beginPath(), e.moveTo(0, 0), e.lineTo(this.width, 0), e.lineTo(this.width, this.height), e.lineTo(0, this.height), e.closePath(), e.fillStyle = r ? i.toLive(e) : i, s && e.transform(...a), r) {
        e.transform(1, 0, 0, 1, i.offsetX || 0, i.offsetY || 0);
        const l = i.gradientTransform || i.patternTransform;
        l && e.transform(...l);
      }
      e.fill(), e.restore();
    }
    if (c) {
      e.save();
      const { skipOffscreen: l } = this;
      this.skipOffscreen = s, s && e.transform(...a), c.render(e), this.skipOffscreen = l, e.restore();
    }
  }
  _renderBackground(e) {
    this._renderBackgroundOrOverlay(e, "background");
  }
  _renderOverlay(e) {
    this._renderBackgroundOrOverlay(e, "overlay");
  }
  getCenter() {
    return { top: this.height / 2, left: this.width / 2 };
  }
  getCenterPoint() {
    return new St(this.width / 2, this.height / 2);
  }
  centerObjectH(e) {
    return this._centerObject(e, new St(this.getCenterPoint().x, e.getCenterPoint().y));
  }
  centerObjectV(e) {
    return this._centerObject(e, new St(e.getCenterPoint().x, this.getCenterPoint().y));
  }
  centerObject(e) {
    return this._centerObject(e, this.getCenterPoint());
  }
  viewportCenterObject(e) {
    return this._centerObject(e, this.getVpCenter());
  }
  viewportCenterObjectH(e) {
    return this._centerObject(e, new St(this.getVpCenter().x, e.getCenterPoint().y));
  }
  viewportCenterObjectV(e) {
    return this._centerObject(e, new St(e.getCenterPoint().x, this.getVpCenter().y));
  }
  getVpCenter() {
    return Ja(this.getCenterPoint(), Cl(this.viewportTransform));
  }
  _centerObject(e, t) {
    e.setXY(t, pr, pr), e.setCoords(), this.renderOnAddRemove && this.requestRenderAll();
  }
  toDatalessJSON(e) {
    return this.toDatalessObject(e);
  }
  toObject(e) {
    return this._toObjectMethod("toObject", e);
  }
  toJSON() {
    return this.toObject();
  }
  toDatalessObject(e) {
    return this._toObjectMethod("toDatalessObject", e);
  }
  _toObjectMethod(e, t) {
    const i = this.clipPath, c = i && !i.excludeFromExport ? this._toObject(i, e, t) : null;
    return lt(lt(lt({ version: nx }, Rm(this, t)), {}, { objects: this._objects.filter((a) => !a.excludeFromExport).map((a) => this._toObject(a, e, t)) }, this.__serializeBgOverlay(e, t)), c ? { clipPath: c } : null);
  }
  _toObject(e, t, i) {
    let c;
    this.includeDefaultValues || (c = e.includeDefaultValues, e.includeDefaultValues = !1);
    const a = e[t](i);
    return this.includeDefaultValues || (e.includeDefaultValues = !!c), a;
  }
  __serializeBgOverlay(e, t) {
    const i = {}, c = this.backgroundImage, a = this.overlayImage, s = this.backgroundColor, r = this.overlayColor;
    return au(s) ? s.excludeFromExport || (i.background = s.toObject(t)) : s && (i.background = s), au(r) ? r.excludeFromExport || (i.overlay = r.toObject(t)) : r && (i.overlay = r), c && !c.excludeFromExport && (i.backgroundImage = this._toObject(c, e, t)), a && !a.excludeFromExport && (i.overlayImage = this._toObject(a, e, t)), i;
  }
  toSVG() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    e.reviver = t;
    const i = [];
    return this._setSVGPreamble(i, e), this._setSVGHeader(i, e), this.clipPath && i.push('<g clip-path="url(#'.concat(this.clipPath.clipPathId, `)" >
`)), this._setSVGBgOverlayColor(i, "background"), this._setSVGBgOverlayImage(i, "backgroundImage", t), this._setSVGObjects(i, t), this.clipPath && i.push(`</g>
`), this._setSVGBgOverlayColor(i, "overlay"), this._setSVGBgOverlayImage(i, "overlayImage", t), i.push("</svg>"), i.join("");
  }
  _setSVGPreamble(e, t) {
    t.suppressPreamble || e.push('<?xml version="1.0" encoding="', t.encoding || "UTF-8", `" standalone="no" ?>
`, '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', `"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
`);
  }
  _setSVGHeader(e, t) {
    const i = t.width || "".concat(this.width), c = t.height || "".concat(this.height), a = Br.NUM_FRACTION_DIGITS, s = t.viewBox;
    let r;
    if (s) r = 'viewBox="'.concat(s.x, " ").concat(s.y, " ").concat(s.width, " ").concat(s.height, '" ');
    else if (this.svgViewportTransformation) {
      const l = this.viewportTransform;
      r = 'viewBox="'.concat(zi(-l[4] / l[0], a), " ").concat(zi(-l[5] / l[3], a), " ").concat(zi(this.width / l[0], a), " ").concat(zi(this.height / l[3], a), '" ');
    } else r = 'viewBox="0 0 '.concat(this.width, " ").concat(this.height, '" ');
    e.push("<svg ", 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', i, '" ', 'height="', c, '" ', r, `xml:space="preserve">
`, "<desc>Created with Fabric.js ", nx, `</desc>
`, `<defs>
`, this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(t), `</defs>
`);
  }
  createSVGClipPathMarkup(e) {
    const t = this.clipPath;
    return t ? (t.clipPathId = "CLIPPATH_".concat(Wh()), '<clipPath id="'.concat(t.clipPathId, `" >
`).concat(t.toClipPathSVG(e.reviver), `</clipPath>
`)) : "";
  }
  createSVGRefElementsMarkup() {
    return ["background", "overlay"].map((e) => {
      const t = this["".concat(e, "Color")];
      if (au(t)) {
        const i = this["".concat(e, "Vpt")], c = this.viewportTransform, a = { isType: () => !1, width: this.width / (i ? c[0] : 1), height: this.height / (i ? c[3] : 1) };
        return t.toSVG(a, { additionalTransform: i ? A1(c) : "" });
      }
    }).join("");
  }
  createSVGFontFacesMarkup() {
    const e = [], t = {}, i = Br.fontPaths;
    this._objects.forEach(function a(s) {
      e.push(s), Mb(s) && s._objects.forEach(a);
    }), e.forEach((a) => {
      if (!(s = a) || typeof s._renderText != "function") return;
      var s;
      const { styles: r, fontFamily: l } = a;
      !t[l] && i[l] && (t[l] = !0, r && Object.values(r).forEach((d) => {
        Object.values(d).forEach((f) => {
          let { fontFamily: h = "" } = f;
          !t[h] && i[h] && (t[h] = !0);
        });
      }));
    });
    const c = Object.keys(t).map((a) => `		@font-face {
			font-family: '`.concat(a, `';
			src: url('`).concat(i[a], `');
		}
`)).join("");
    return c ? `	<style type="text/css"><![CDATA[
`.concat(c, `]]></style>
`) : "";
  }
  _setSVGObjects(e, t) {
    this.forEachObject((i) => {
      i.excludeFromExport || this._setSVGObject(e, i, t);
    });
  }
  _setSVGObject(e, t, i) {
    e.push(t.toSVG(i));
  }
  _setSVGBgOverlayImage(e, t, i) {
    const c = this[t];
    c && !c.excludeFromExport && c.toSVG && e.push(c.toSVG(i));
  }
  _setSVGBgOverlayColor(e, t) {
    const i = this["".concat(t, "Color")];
    if (i) if (au(i)) {
      const c = i.repeat || "", a = this.width, s = this.height, r = this["".concat(t, "Vpt")] ? A1(Cl(this.viewportTransform)) : "";
      e.push('<rect transform="'.concat(r, " translate(").concat(a / 2, ",").concat(s / 2, ')" x="').concat(i.offsetX - a / 2, '" y="').concat(i.offsetY - s / 2, '" width="').concat(c !== "repeat-y" && c !== "no-repeat" || !j4(i) ? a : i.source.width, '" height="').concat(c !== "repeat-x" && c !== "no-repeat" || !j4(i) ? s : i.source.height, '" fill="url(#SVGID_').concat(i.id, `)"></rect>
`));
    } else e.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', i, '"', `></rect>
`);
  }
  loadFromJSON(e, t) {
    let { signal: i } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!e) return Promise.reject(new ud("`json` is undefined"));
    const c = typeof e == "string" ? JSON.parse(e) : e, { objects: a = [], backgroundImage: s, background: r, overlayImage: l, overlay: d, clipPath: f } = c, h = this.renderOnAddRemove;
    return this.renderOnAddRemove = !1, Promise.all([l0(a, { reviver: t, signal: i }), F1({ backgroundImage: s, backgroundColor: r, overlayImage: l, overlayColor: d, clipPath: f }, { signal: i })]).then((p) => {
      let [g, _] = p;
      return this.clear(), this.add(...g), this.set(c), this.set(_), this.renderOnAddRemove = h, this;
    });
  }
  clone(e) {
    const t = this.toObject(e);
    return this.cloneWithoutData().loadFromJSON(t);
  }
  cloneWithoutData() {
    const e = ac(this);
    return new this.constructor(e);
  }
  toDataURL() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { format: t = "png", quality: i = 1, multiplier: c = 1, enableRetinaScaling: a = !1 } = e, s = c * (a ? this.getRetinaScaling() : 1);
    return oT(this.toCanvasElement(s, e), t, i);
  }
  toCanvasElement() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, { width: t, height: i, left: c, top: a, filter: s } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || this.width) * e, l = (i || this.height) * e, d = this.getZoom(), f = this.width, h = this.height, p = this.skipControlsDrawing, g = d * e, _ = this.viewportTransform, b = [g, 0, 0, g, (_[4] - (c || 0)) * e, (_[5] - (a || 0)) * e], v = this.enableRetinaScaling, E = ac({ width: r, height: l }), C = s ? this._objects.filter((y) => s(y)) : this._objects;
    return this.enableRetinaScaling = !1, this.viewportTransform = b, this.width = r, this.height = l, this.skipControlsDrawing = !0, this.calcViewportBoundaries(), this.renderCanvas(E.getContext("2d"), C), this.viewportTransform = _, this.width = f, this.height = h, this.calcViewportBoundaries(), this.enableRetinaScaling = v, this.skipControlsDrawing = p, E;
  }
  dispose() {
    return !this.disposed && this.elements.cleanupDOM({ width: this.width, height: this.height }), Jb.cancelByCanvas(this), this.disposed = !0, new Promise((e, t) => {
      const i = () => {
        this.destroy(), e(!0);
      };
      i.kill = t, this.__cleanupTask && this.__cleanupTask.kill("aborted"), this.destroyed ? e(!1) : this.nextRenderHandle ? this.__cleanupTask = i : i();
    });
  }
  destroy() {
    this.destroyed = !0, this.cancelRequestedRender(), this.forEachObject((e) => e.dispose()), this._objects = [], this.backgroundImage && this.backgroundImage.dispose(), this.backgroundImage = void 0, this.overlayImage && this.overlayImage.dispose(), this.overlayImage = void 0, this.elements.dispose();
  }
  toString() {
    return "#<Canvas (".concat(this.complexity(), "): { objects: ").concat(this._objects.length, " }>");
  }
}
it(U1, "ownDefaults", kW);
const OW = ["touchstart", "touchmove", "touchend"], K7 = (n) => {
  const e = W7(n.target), t = function(i) {
    const c = i.changedTouches;
    return c && c[0] ? c[0] : i;
  }(n);
  return new St(t.clientX + e.left, t.clientY + e.top);
}, e2 = (n) => OW.includes(n.type) || n.pointerType === "touch", ox = (n) => {
  n.preventDefault(), n.stopPropagation();
}, dd = (n) => {
  let e = 0, t = 0, i = 0, c = 0;
  for (let a = 0, s = n.length; a < s; a++) {
    const { x: r, y: l } = n[a];
    (r > i || !a) && (i = r), (r < e || !a) && (e = r), (l > c || !a) && (c = l), (l < t || !a) && (t = l);
  }
  return { left: e, top: t, width: i - e, height: c - t };
}, DW = ["translateX", "translateY", "scaleX", "scaleY"], Q7 = (n, e) => u0(n, Io(e, n.calcOwnMatrix())), u0 = (n, e) => {
  const t = s0(e), { translateX: i, translateY: c, scaleX: a, scaleY: s } = t, r = Vi(t, DW), l = new St(i, c);
  n.flipX = !1, n.flipY = !1, Object.assign(n, r), n.set({ scaleX: a, scaleY: s }), n.setPositionByOrigin(l, pr, pr);
}, Z7 = (n) => {
  n.scaleX = 1, n.scaleY = 1, n.skewX = 0, n.skewY = 0, n.flipX = !1, n.flipY = !1, n.rotate(0);
}, uT = (n) => ({ scaleX: n.scaleX, scaleY: n.scaleY, skewX: n.skewX, skewY: n.skewY, angle: n.angle, left: n.left, flipX: n.flipX, flipY: n.flipY, top: n.top }), N2 = (n, e, t) => {
  const i = n / 2, c = e / 2, a = [new St(-i, -c), new St(i, -c), new St(-i, c), new St(i, c)].map((r) => r.transform(t)), s = dd(a);
  return new St(s.width, s.height);
}, H1 = function() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : gs;
  return Io(Cl(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gs), n);
}, _m = function(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gs, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : gs;
  return n.transform(H1(e, t));
}, J7 = function(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gs, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : gs;
  return n.transform(H1(e, t), !0);
}, ax = (n, e, t) => {
  const i = H1(e, t);
  return u0(n, Io(i, n.calcOwnMatrix())), i;
}, e8 = (n, e) => {
  var t;
  const { transform: { target: i } } = e;
  (t = i.canvas) === null || t === void 0 || t.fire("object:".concat(n), lt(lt({}, e), {}, { target: i })), i.fire(n, e);
}, RW = { left: -0.5, top: -0.5, center: 0, bottom: 0.5, right: 0.5 }, No = (n) => typeof n == "string" ? RW[n] : n - 0.5, t2 = "not-allowed";
function t8(n) {
  return No(n.originX) === No(pr) && No(n.originY) === No(pr);
}
function F4(n) {
  return 0.5 - No(n);
}
const nc = (n, e) => n[e], n8 = (n, e, t, i) => ({ e: n, transform: e, pointer: new St(t, i) });
function r8(n, e) {
  const t = n.getTotalAngle() + $h(Math.atan2(e.y, e.x)) + 360;
  return Math.round(t % 360 / 45);
}
function cT(n, e, t, i, c) {
  var a;
  let { target: s, corner: r } = n;
  const l = s.controls[r], d = ((a = s.canvas) === null || a === void 0 ? void 0 : a.getZoom()) || 1, f = s.padding / d, h = function(p, g, _, b) {
    const v = p.getRelativeCenterPoint(), E = _ !== void 0 && b !== void 0 ? p.translateToGivenOrigin(v, pr, pr, _, b) : new St(p.left, p.top);
    return (p.angle ? g.rotate(-oo(p.angle), v) : g).subtract(E);
  }(s, new St(i, c), e, t);
  return h.x >= f && (h.x -= f), h.x <= -f && (h.x += f), h.y >= f && (h.y -= f), h.y <= f && (h.y += f), h.x -= l.offsetX, h.y -= l.offsetY, h;
}
const NW = (n, e, t, i) => {
  const { target: c, offsetX: a, offsetY: s } = e, r = t - a, l = i - s, d = !nc(c, "lockMovementX") && c.left !== r, f = !nc(c, "lockMovementY") && c.top !== l;
  return d && c.set(ti, r), f && c.set(Ks, l), (d || f) && e8(L7, n8(n, e, t, i)), d || f;
};
class i8 {
  getSvgStyles(e) {
    const t = this.fillRule ? this.fillRule : "nonzero", i = this.strokeWidth ? this.strokeWidth : "0", c = this.strokeDashArray ? this.strokeDashArray.join(" ") : Qs, a = this.strokeDashOffset ? this.strokeDashOffset : "0", s = this.strokeLineCap ? this.strokeLineCap : "butt", r = this.strokeLineJoin ? this.strokeLineJoin : "miter", l = this.strokeMiterLimit ? this.strokeMiterLimit : "4", d = this.opacity !== void 0 ? this.opacity : "1", f = this.visible ? "" : " visibility: hidden;", h = e ? "" : this.getSvgFilter(), p = k1(ta, this.fill);
    return [k1(Zs, this.stroke), "stroke-width: ", i, "; ", "stroke-dasharray: ", c, "; ", "stroke-linecap: ", s, "; ", "stroke-dashoffset: ", a, "; ", "stroke-linejoin: ", r, "; ", "stroke-miterlimit: ", l, "; ", p, "fill-rule: ", t, "; ", "opacity: ", d, ";", h, f].join("");
  }
  getSvgFilter() {
    return this.shadow ? "filter: url(#SVGID_".concat(this.shadow.id, ");") : "";
  }
  getSvgCommons() {
    return [this.id ? 'id="'.concat(this.id, '" ') : "", this.clipPath ? 'clip-path="url(#'.concat(this.clipPath.clipPathId, ')" ') : ""].join("");
  }
  getSvgTransform(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const i = e ? this.calcTransformMatrix() : this.calcOwnMatrix(), c = 'transform="'.concat(A1(i));
    return "".concat(c).concat(t, '" ');
  }
  _toSVG(e) {
    return [""];
  }
  toSVG(e) {
    return this._createBaseSVGMarkup(this._toSVG(e), { reviver: e });
  }
  toClipPathSVG(e) {
    return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(e), { reviver: e });
  }
  _createBaseClipPathSVGMarkup(e) {
    let { reviver: t, additionalTransform: i = "" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const c = [this.getSvgTransform(!0, i), this.getSvgCommons()].join(""), a = e.indexOf("COMMON_PARTS");
    return e[a] = c, t ? t(e.join("")) : e.join("");
  }
  _createBaseSVGMarkup(e) {
    let { noStyle: t, reviver: i, withShadow: c, additionalTransform: a } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = t ? "" : 'style="'.concat(this.getSvgStyles(), '" '), r = c ? 'style="'.concat(this.getSvgFilter(), '" ') : "", l = this.clipPath, d = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : "", f = l && l.absolutePositioned, h = this.stroke, p = this.fill, g = this.shadow, _ = [], b = e.indexOf("COMMON_PARTS");
    let v;
    l && (l.clipPathId = "CLIPPATH_".concat(Wh()), v = '<clipPath id="'.concat(l.clipPathId, `" >
`).concat(l.toClipPathSVG(i), `</clipPath>
`)), f && _.push("<g ", r, this.getSvgCommons(), ` >
`), _.push("<g ", this.getSvgTransform(!1), f ? "" : r + this.getSvgCommons(), ` >
`);
    const E = [s, d, t ? "" : this.addPaintOrder(), " ", a ? 'transform="'.concat(a, '" ') : ""].join("");
    return e[b] = E, au(p) && _.push(p.toSVG(this)), au(h) && _.push(h.toSVG(this)), g && _.push(g.toSVG(this)), l && _.push(v), _.push(e.join("")), _.push(`</g>
`), f && _.push(`</g>
`), i ? i(_.join("")) : _.join("");
  }
  addPaintOrder() {
    return this.paintFirst !== ta ? ' paint-order="'.concat(this.paintFirst, '" ') : "";
  }
}
function I2(n) {
  return new RegExp("^(" + n.join("|") + ")\\b", "i");
}
var U4;
const Sm = String.raw(U4 || (U4 = Kh(["(?:[-+]?(?:d*.d+|d+.?)(?:[eE][-+]?d+)?)"], ["(?:[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?)"]))), IW = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + Sm + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + Sm + "))?\\s+(.*)"), LW = { cx: ti, x: ti, r: "radius", cy: Ks, y: Ks, display: "visible", visibility: "visible", transform: "transformMatrix", "fill-opacity": "fillOpacity", "fill-rule": "fillRule", "font-family": "fontFamily", "font-size": "fontSize", "font-style": "fontStyle", "font-weight": "fontWeight", "letter-spacing": "charSpacing", "paint-order": "paintFirst", "stroke-dasharray": "strokeDashArray", "stroke-dashoffset": "strokeDashOffset", "stroke-linecap": "strokeLineCap", "stroke-linejoin": "strokeLineJoin", "stroke-miterlimit": "strokeMiterLimit", "stroke-opacity": "strokeOpacity", "stroke-width": "strokeWidth", "text-decoration": "textDecoration", "text-anchor": "textAnchor", opacity: "opacity", "clip-path": "clipPath", "clip-rule": "clipRule", "vector-effect": "strokeUniform", "image-rendering": "imageSmoothing" }, mw = "font-size", gw = "clip-path";
I2(["path", "circle", "polygon", "polyline", "ellipse", "rect", "line", "image", "text"]);
I2(["symbol", "image", "marker", "pattern", "view", "svg"]);
const H4 = I2(["symbol", "g", "a", "svg", "clipPath", "defs"]), MW = new St(1, 0), o8 = new St(), dT = (n, e) => n.rotate(e), n2 = (n, e) => new St(e).subtract(n), r2 = (n) => n.distanceFrom(o8), i2 = (n, e) => Math.atan2(e0(n, e), s8(n, e)), a8 = (n) => i2(MW, n), L2 = (n) => n.eq(o8) ? n : n.scalarDivide(r2(n)), fT = function(n) {
  let e = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
  return L2(new St(-n.y, n.x).scalarMultiply(e ? 1 : -1));
}, e0 = (n, e) => n.x * e.y - n.y * e.x, s8 = (n, e) => n.x * e.x + n.y * e.y, sx = (n, e, t) => {
  if (n.eq(e) || n.eq(t)) return !0;
  const i = e0(e, t), c = e0(e, n), a = e0(t, n);
  return i >= 0 ? c >= 0 && a <= 0 : !(c <= 0 && a >= 0);
}, z4 = "(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?", V4 = new RegExp("(?:\\s|^)" + z4 + z4 + "(" + Sm + "?(?:px)?)?(?:\\s?|$)(?:$|\\s)");
class gf {
  constructor(e) {
    const t = typeof e == "string" ? gf.parseShadow(e) : e;
    Object.assign(this, gf.ownDefaults, t), this.id = Wh();
  }
  static parseShadow(e) {
    const t = e.trim(), [, i = 0, c = 0, a = 0] = (V4.exec(t) || []).map((s) => parseFloat(s) || 0);
    return { color: (t.replace(V4, "") || "rgb(0,0,0)").trim(), offsetX: i, offsetY: c, blur: a };
  }
  toString() {
    return [this.offsetX, this.offsetY, this.blur, this.color].join("px ");
  }
  toSVG(e) {
    const t = dT(new St(this.offsetX, this.offsetY), oo(-e.angle)), i = new Wr(this.color);
    let c = 40, a = 40;
    return e.width && e.height && (c = 100 * zi((Math.abs(t.x) + this.blur) / e.width, Br.NUM_FRACTION_DIGITS) + 20, a = 100 * zi((Math.abs(t.y) + this.blur) / e.height, Br.NUM_FRACTION_DIGITS) + 20), e.flipX && (t.x *= -1), e.flipY && (t.y *= -1), '<filter id="SVGID_'.concat(this.id, '" y="-').concat(a, '%" height="').concat(100 + 2 * a, '%" x="-').concat(c, '%" width="').concat(100 + 2 * c, `%" >
	<feGaussianBlur in="SourceAlpha" stdDeviation="`).concat(zi(this.blur ? this.blur / 2 : 0, Br.NUM_FRACTION_DIGITS), `"></feGaussianBlur>
	<feOffset dx="`).concat(zi(t.x, Br.NUM_FRACTION_DIGITS), '" dy="').concat(zi(t.y, Br.NUM_FRACTION_DIGITS), `" result="oBlur" ></feOffset>
	<feFlood flood-color="`).concat(i.toRgb(), '" flood-opacity="').concat(i.getAlpha(), `"/>
	<feComposite in2="oBlur" operator="in" />
	<feMerge>
		<feMergeNode></feMergeNode>
		<feMergeNode in="SourceGraphic"></feMergeNode>
	</feMerge>
</filter>
`);
  }
  toObject() {
    const e = { color: this.color, blur: this.blur, offsetX: this.offsetX, offsetY: this.offsetY, affectStroke: this.affectStroke, nonScaling: this.nonScaling, type: this.constructor.type }, t = gf.ownDefaults;
    return this.includeDefaultValues ? e : lT(e, (i, c) => i !== t[c]);
  }
  static async fromObject(e) {
    return new this(e);
  }
}
it(gf, "ownDefaults", { color: "rgb(0,0,0)", blur: 0, offsetX: 0, offsetY: 0, affectStroke: !1, includeDefaultValues: !0, nonScaling: !1 }), it(gf, "type", "shadow"), pn.setClass(gf, "shadow");
const Cm = (n, e, t) => Math.max(n, Math.min(e, t)), PW = [Ks, ti, _s, xl, "flipX", "flipY", "originX", "originY", "angle", "opacity", "globalCompositeOperation", "shadow", "visible", h0, p0], Cf = [ta, Zs, "strokeWidth", "strokeDashArray", "width", "height", "paintFirst", "strokeUniform", "strokeLineCap", "strokeDashOffset", "strokeLineJoin", "strokeMiterLimit", "backgroundColor", "clipPath"], jW = { top: 0, left: 0, width: 0, height: 0, angle: 0, flipX: !1, flipY: !1, scaleX: 1, scaleY: 1, minScaleLimit: 0, skewX: 0, skewY: 0, originX: ti, originY: Ks, strokeWidth: 1, strokeUniform: !1, padding: 0, opacity: 1, paintFirst: ta, fill: "rgb(0,0,0)", fillRule: "nonzero", stroke: null, strokeDashArray: null, strokeDashOffset: 0, strokeLineCap: "butt", strokeLineJoin: "miter", strokeMiterLimit: 4, globalCompositeOperation: "source-over", backgroundColor: "", shadow: null, visible: !0, includeDefaultValues: !0, excludeFromExport: !1, objectCaching: !0, clipPath: void 0, inverted: !1, absolutePositioned: !1, centeredRotation: !0, centeredScaling: !1, dirty: !0 }, _w = (n, e, t, i) => (n < Math.abs(e) ? (n = e, i = t / 4) : i = e === 0 && n === 0 ? t / yf * Math.asin(1) : t / yf * Math.asin(e / n), { a: n, c: e, p: t, s: i }), q4 = (n, e, t, i, c) => n * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * c - e) * yf / t), l8 = (n, e, t, i) => -t * Math.cos(n / i * Gh) + t + e, lx = (n, e, t, i) => (n /= i) < 1 / 2.75 ? t * (7.5625 * n * n) + e : n < 2 / 2.75 ? t * (7.5625 * (n -= 1.5 / 2.75) * n + 0.75) + e : n < 2.5 / 2.75 ? t * (7.5625 * (n -= 2.25 / 2.75) * n + 0.9375) + e : t * (7.5625 * (n -= 2.625 / 2.75) * n + 0.984375) + e, G4 = (n, e, t, i) => t - lx(i - n, 0, t, i) + e;
var BW = Object.freeze({ __proto__: null, defaultEasing: l8, easeInBack: function(n, e, t, i) {
  let c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.70158;
  return t * (n /= i) * n * ((c + 1) * n - c) + e;
}, easeInBounce: G4, easeInCirc: (n, e, t, i) => -t * (Math.sqrt(1 - (n /= i) * n) - 1) + e, easeInCubic: (n, e, t, i) => t * (n / i) ** 3 + e, easeInElastic: (n, e, t, i) => {
  const c = t;
  let a = 0;
  if (n === 0) return e;
  if ((n /= i) === 1) return e + t;
  a || (a = 0.3 * i);
  const { a: s, s: r, p: l } = _w(c, t, a, 1.70158);
  return -q4(s, r, l, n, i) + e;
}, easeInExpo: (n, e, t, i) => n === 0 ? e : t * 2 ** (10 * (n / i - 1)) + e, easeInOutBack: function(n, e, t, i) {
  let c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.70158;
  return (n /= i / 2) < 1 ? t / 2 * (n * n * ((1 + (c *= 1.525)) * n - c)) + e : t / 2 * ((n -= 2) * n * ((1 + (c *= 1.525)) * n + c) + 2) + e;
}, easeInOutBounce: (n, e, t, i) => n < i / 2 ? 0.5 * G4(2 * n, 0, t, i) + e : 0.5 * lx(2 * n - i, 0, t, i) + 0.5 * t + e, easeInOutCirc: (n, e, t, i) => (n /= i / 2) < 1 ? -t / 2 * (Math.sqrt(1 - n ** 2) - 1) + e : t / 2 * (Math.sqrt(1 - (n -= 2) * n) + 1) + e, easeInOutCubic: (n, e, t, i) => (n /= i / 2) < 1 ? t / 2 * n ** 3 + e : t / 2 * ((n - 2) ** 3 + 2) + e, easeInOutElastic: (n, e, t, i) => {
  const c = t;
  let a = 0;
  if (n === 0) return e;
  if ((n /= i / 2) === 2) return e + t;
  a || (a = i * (0.3 * 1.5));
  const { a: s, s: r, p: l, c: d } = _w(c, t, a, 1.70158);
  return n < 1 ? -0.5 * q4(s, r, l, n, i) + e : s * Math.pow(2, -10 * (n -= 1)) * Math.sin((n * i - r) * yf / l) * 0.5 + d + e;
}, easeInOutExpo: (n, e, t, i) => n === 0 ? e : n === i ? e + t : (n /= i / 2) < 1 ? t / 2 * 2 ** (10 * (n - 1)) + e : t / 2 * -(2 ** (-10 * --n) + 2) + e, easeInOutQuad: (n, e, t, i) => (n /= i / 2) < 1 ? t / 2 * n ** 2 + e : -t / 2 * (--n * (n - 2) - 1) + e, easeInOutQuart: (n, e, t, i) => (n /= i / 2) < 1 ? t / 2 * n ** 4 + e : -t / 2 * ((n -= 2) * n ** 3 - 2) + e, easeInOutQuint: (n, e, t, i) => (n /= i / 2) < 1 ? t / 2 * n ** 5 + e : t / 2 * ((n - 2) ** 5 + 2) + e, easeInOutSine: (n, e, t, i) => -t / 2 * (Math.cos(Math.PI * n / i) - 1) + e, easeInQuad: (n, e, t, i) => t * (n /= i) * n + e, easeInQuart: (n, e, t, i) => t * (n /= i) * n ** 3 + e, easeInQuint: (n, e, t, i) => t * (n / i) ** 5 + e, easeInSine: (n, e, t, i) => -t * Math.cos(n / i * Gh) + t + e, easeOutBack: function(n, e, t, i) {
  let c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.70158;
  return t * ((n = n / i - 1) * n * ((c + 1) * n + c) + 1) + e;
}, easeOutBounce: lx, easeOutCirc: (n, e, t, i) => t * Math.sqrt(1 - (n = n / i - 1) * n) + e, easeOutCubic: (n, e, t, i) => t * ((n / i - 1) ** 3 + 1) + e, easeOutElastic: (n, e, t, i) => {
  const c = t;
  let a = 0;
  if (n === 0) return e;
  if ((n /= i) === 1) return e + t;
  a || (a = 0.3 * i);
  const { a: s, s: r, p: l, c: d } = _w(c, t, a, 1.70158);
  return s * 2 ** (-10 * n) * Math.sin((n * i - r) * yf / l) + d + e;
}, easeOutExpo: (n, e, t, i) => n === i ? e + t : t * -(2 ** (-10 * n / i) + 1) + e, easeOutQuad: (n, e, t, i) => -t * (n /= i) * (n - 2) + e, easeOutQuart: (n, e, t, i) => -t * ((n = n / i - 1) * n ** 3 - 1) + e, easeOutQuint: (n, e, t, i) => t * ((n / i - 1) ** 5 + 1) + e, easeOutSine: (n, e, t, i) => t * Math.sin(n / i * Gh) + e });
const FW = () => !1;
class hT {
  constructor(e) {
    let { startValue: t, byValue: i, duration: c = 500, delay: a = 0, easing: s = l8, onStart: r = mm, onChange: l = mm, onComplete: d = mm, abort: f = FW, target: h } = e;
    it(this, "_state", "pending"), it(this, "durationProgress", 0), it(this, "valueProgress", 0), this.tick = this.tick.bind(this), this.duration = c, this.delay = a, this.easing = s, this._onStart = r, this._onChange = l, this._onComplete = d, this._abort = f, this.target = h, this.startValue = t, this.byValue = i, this.value = this.startValue, this.endValue = Object.freeze(this.calculate(this.duration).value);
  }
  get state() {
    return this._state;
  }
  isDone() {
    return this._state === "aborted" || this._state === "completed";
  }
  start() {
    const e = (t) => {
      this._state === "pending" && (this.startTime = t || +/* @__PURE__ */ new Date(), this._state = "running", this._onStart(), this.tick(this.startTime));
    };
    this.register(), this.delay > 0 ? setTimeout(() => p1(e), this.delay) : p1(e);
  }
  tick(e) {
    const t = (e || +/* @__PURE__ */ new Date()) - this.startTime, i = Math.min(t, this.duration);
    this.durationProgress = i / this.duration;
    const { value: c, valueProgress: a } = this.calculate(i);
    this.value = Object.freeze(c), this.valueProgress = a, this._state !== "aborted" && (this._abort(this.value, this.valueProgress, this.durationProgress) ? (this._state = "aborted", this.unregister()) : t >= this.duration ? (this.durationProgress = this.valueProgress = 1, this._onChange(this.endValue, this.valueProgress, this.durationProgress), this._state = "completed", this._onComplete(this.endValue, this.valueProgress, this.durationProgress), this.unregister()) : (this._onChange(this.value, this.valueProgress, this.durationProgress), p1(this.tick)));
  }
  register() {
    Jb.push(this);
  }
  unregister() {
    Jb.remove(this);
  }
  abort() {
    this._state = "aborted", this.unregister();
  }
}
const UW = ["startValue", "endValue"];
class HW extends hT {
  constructor(e) {
    let { startValue: t = 0, endValue: i = 100 } = e;
    super(lt(lt({}, Vi(e, UW)), {}, { startValue: t, byValue: i - t }));
  }
  calculate(e) {
    const t = this.easing(e, this.startValue, this.byValue, this.duration);
    return { value: t, valueProgress: Math.abs((t - this.startValue) / this.byValue) };
  }
}
const zW = ["startValue", "endValue"];
class VW extends hT {
  constructor(e) {
    let { startValue: t = [0], endValue: i = [100] } = e;
    super(lt(lt({}, Vi(e, zW)), {}, { startValue: t, byValue: i.map((c, a) => c - t[a]) }));
  }
  calculate(e) {
    const t = this.startValue.map((i, c) => this.easing(e, i, this.byValue[c], this.duration, c));
    return { value: t, valueProgress: Math.abs((t[0] - this.startValue[0]) / this.byValue[0]) };
  }
}
const qW = ["startValue", "endValue", "easing", "onChange", "onComplete", "abort"], GW = (n, e, t, i) => e + t * (1 - Math.cos(n / i * Gh)), yw = (n) => n && ((e, t, i) => n(new Wr(e).toRgba(), t, i));
class WW extends hT {
  constructor(e) {
    let { startValue: t, endValue: i, easing: c = GW, onChange: a, onComplete: s, abort: r } = e, l = Vi(e, qW);
    const d = new Wr(t).getSource(), f = new Wr(i).getSource();
    super(lt(lt({}, l), {}, { startValue: d, byValue: f.map((h, p) => h - d[p]), easing: c, onChange: yw(a), onComplete: yw(s), abort: yw(r) }));
  }
  calculate(e) {
    const [t, i, c, a] = this.startValue.map((r, l) => this.easing(e, r, this.byValue[l], this.duration, l)), s = [...[t, i, c].map(Math.round), Cm(0, a, 1)];
    return { value: s, valueProgress: s.map((r, l) => this.byValue[l] !== 0 ? Math.abs((r - this.startValue[l]) / this.byValue[l]) : 0).find((r) => r !== 0) || 0 };
  }
}
function pT(n) {
  const e = ((t) => Array.isArray(t.startValue) || Array.isArray(t.endValue))(n) ? new VW(n) : new HW(n);
  return e.start(), e;
}
function u8(n) {
  const e = new WW(n);
  return e.start(), e;
}
class Qi {
  constructor(e) {
    this.status = e, this.points = [];
  }
  includes(e) {
    return this.points.some((t) => t.eq(e));
  }
  append() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    return this.points = this.points.concat(t.filter((c) => !this.includes(c))), this;
  }
  static isPointContained(e, t, i) {
    let c = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    if (t.eq(i)) return e.eq(t);
    if (t.x === i.x) return e.x === t.x && (c || e.y >= Math.min(t.y, i.y) && e.y <= Math.max(t.y, i.y));
    if (t.y === i.y) return e.y === t.y && (c || e.x >= Math.min(t.x, i.x) && e.x <= Math.max(t.x, i.x));
    {
      const a = n2(t, i), s = n2(t, e).divide(a);
      return c ? Math.abs(s.x) === Math.abs(s.y) : s.x === s.y && s.x >= 0 && s.x <= 1;
    }
  }
  static isPointInPolygon(e, t) {
    const i = new St(e).setX(Math.min(e.x - 1, ...t.map((a) => a.x)));
    let c = 0;
    for (let a = 0; a < t.length; a++) {
      const s = this.intersectSegmentSegment(t[a], t[(a + 1) % t.length], e, i);
      if (s.includes(e)) return !0;
      c += +(s.status === "Intersection");
    }
    return c % 2 == 1;
  }
  static intersectLineLine(e, t, i, c) {
    let a = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], s = !(arguments.length > 5 && arguments[5] !== void 0) || arguments[5];
    const r = t.x - e.x, l = t.y - e.y, d = c.x - i.x, f = c.y - i.y, h = e.x - i.x, p = e.y - i.y, g = d * p - f * h, _ = r * p - l * h, b = f * r - d * l;
    if (b !== 0) {
      const v = g / b, E = _ / b;
      return (a || 0 <= v && v <= 1) && (s || 0 <= E && E <= 1) ? new Qi("Intersection").append(new St(e.x + v * r, e.y + v * l)) : new Qi();
    }
    if (g === 0 || _ === 0) {
      const v = a || s || Qi.isPointContained(e, i, c) || Qi.isPointContained(t, i, c) || Qi.isPointContained(i, e, t) || Qi.isPointContained(c, e, t);
      return new Qi(v ? "Coincident" : void 0);
    }
    return new Qi("Parallel");
  }
  static intersectSegmentLine(e, t, i, c) {
    return Qi.intersectLineLine(e, t, i, c, !1, !0);
  }
  static intersectSegmentSegment(e, t, i, c) {
    return Qi.intersectLineLine(e, t, i, c, !1, !1);
  }
  static intersectLinePolygon(e, t, i) {
    let c = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
    const a = new Qi(), s = i.length;
    for (let r, l, d, f = 0; f < s; f++) {
      if (r = i[f], l = i[(f + 1) % s], d = Qi.intersectLineLine(e, t, r, l, c, !1), d.status === "Coincident") return d;
      a.append(...d.points);
    }
    return a.points.length > 0 && (a.status = "Intersection"), a;
  }
  static intersectSegmentPolygon(e, t, i) {
    return Qi.intersectLinePolygon(e, t, i, !1);
  }
  static intersectPolygonPolygon(e, t) {
    const i = new Qi(), c = e.length, a = [];
    for (let s = 0; s < c; s++) {
      const r = e[s], l = e[(s + 1) % c], d = Qi.intersectSegmentPolygon(r, l, t);
      d.status === "Coincident" ? (a.push(d), i.append(r, l)) : i.append(...d.points);
    }
    return a.length > 0 && a.length === e.length ? new Qi("Coincident") : (i.points.length > 0 && (i.status = "Intersection"), i);
  }
  static intersectPolygonRectangle(e, t, i) {
    const c = t.min(i), a = t.max(i), s = new St(a.x, c.y), r = new St(c.x, a.y);
    return Qi.intersectPolygonPolygon(e, [c, s, a, r]);
  }
}
class $W extends B7 {
  getX() {
    return this.getXY().x;
  }
  setX(e) {
    this.setXY(this.getXY().setX(e));
  }
  getY() {
    return this.getXY().y;
  }
  setY(e) {
    this.setXY(this.getXY().setY(e));
  }
  getRelativeX() {
    return this.left;
  }
  setRelativeX(e) {
    this.left = e;
  }
  getRelativeY() {
    return this.top;
  }
  setRelativeY(e) {
    this.top = e;
  }
  getXY() {
    const e = this.getRelativeXY();
    return this.group ? Ja(e, this.group.calcTransformMatrix()) : e;
  }
  setXY(e, t, i) {
    this.group && (e = Ja(e, Cl(this.group.calcTransformMatrix()))), this.setRelativeXY(e, t, i);
  }
  getRelativeXY() {
    return new St(this.left, this.top);
  }
  setRelativeXY(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.originX, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.originY;
    this.setPositionByOrigin(e, t, i);
  }
  isStrokeAccountedForInDimensions() {
    return !1;
  }
  getCoords() {
    const { tl: e, tr: t, br: i, bl: c } = this.aCoords || (this.aCoords = this.calcACoords()), a = [e, t, i, c];
    if (this.group) {
      const s = this.group.calcTransformMatrix();
      return a.map((r) => Ja(r, s));
    }
    return a;
  }
  intersectsWithRect(e, t) {
    return Qi.intersectPolygonRectangle(this.getCoords(), e, t).status === "Intersection";
  }
  intersectsWithObject(e) {
    const t = Qi.intersectPolygonPolygon(this.getCoords(), e.getCoords());
    return t.status === "Intersection" || t.status === "Coincident" || e.isContainedWithinObject(this) || this.isContainedWithinObject(e);
  }
  isContainedWithinObject(e) {
    return this.getCoords().every((t) => e.containsPoint(t));
  }
  isContainedWithinRect(e, t) {
    const { left: i, top: c, width: a, height: s } = this.getBoundingRect();
    return i >= e.x && i + a <= t.x && c >= e.y && c + s <= t.y;
  }
  isOverlapping(e) {
    return this.intersectsWithObject(e) || this.isContainedWithinObject(e) || e.isContainedWithinObject(this);
  }
  containsPoint(e) {
    return Qi.isPointInPolygon(e, this.getCoords());
  }
  isOnScreen() {
    if (!this.canvas) return !1;
    const { tl: e, br: t } = this.canvas.vptCoords;
    return !!this.getCoords().some((i) => i.x <= t.x && i.x >= e.x && i.y <= t.y && i.y >= e.y) || !!this.intersectsWithRect(e, t) || this.containsPoint(e.midPointFrom(t));
  }
  isPartiallyOnScreen() {
    if (!this.canvas) return !1;
    const { tl: e, br: t } = this.canvas.vptCoords;
    return this.intersectsWithRect(e, t) ? !0 : this.getCoords().every((i) => (i.x >= t.x || i.x <= e.x) && (i.y >= t.y || i.y <= e.y)) && this.containsPoint(e.midPointFrom(t));
  }
  getBoundingRect() {
    return dd(this.getCoords());
  }
  getScaledWidth() {
    return this._getTransformedDimensions().x;
  }
  getScaledHeight() {
    return this._getTransformedDimensions().y;
  }
  scale(e) {
    this._set(_s, e), this._set(xl, e), this.setCoords();
  }
  scaleToWidth(e) {
    const t = this.getBoundingRect().width / this.getScaledWidth();
    return this.scale(e / this.width / t);
  }
  scaleToHeight(e) {
    const t = this.getBoundingRect().height / this.getScaledHeight();
    return this.scale(e / this.height / t);
  }
  getCanvasRetinaScaling() {
    var e;
    return ((e = this.canvas) === null || e === void 0 ? void 0 : e.getRetinaScaling()) || 1;
  }
  getTotalAngle() {
    return this.group ? $h(z7(this.calcTransformMatrix())) : this.angle;
  }
  getViewportTransform() {
    var e;
    return ((e = this.canvas) === null || e === void 0 ? void 0 : e.viewportTransform) || gs.concat();
  }
  calcACoords() {
    const e = g0({ angle: this.angle }), { x: t, y: i } = this.getRelativeCenterPoint(), c = m0(t, i), a = Io(c, e), s = this._getTransformedDimensions(), r = s.x / 2, l = s.y / 2;
    return { tl: Ja({ x: -r, y: -l }, a), tr: Ja({ x: r, y: -l }, a), bl: Ja({ x: -r, y: l }, a), br: Ja({ x: r, y: l }, a) };
  }
  setCoords() {
    this.aCoords = this.calcACoords();
  }
  transformMatrixKey() {
    let e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], t = [];
    return !e && this.group && (t = this.group.transformMatrixKey(e)), t.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, No(this.originX), No(this.originY)), t;
  }
  calcTransformMatrix() {
    let e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], t = this.calcOwnMatrix();
    if (e || !this.group) return t;
    const i = this.transformMatrixKey(e), c = this.matrixCache;
    return c && c.key.every((a, s) => a === i[s]) ? c.value : (this.group && (t = Io(this.group.calcTransformMatrix(!1), t)), this.matrixCache = { key: i, value: t }, t);
  }
  calcOwnMatrix() {
    const e = this.transformMatrixKey(!0), t = this.ownMatrixCache;
    if (t && t.key === e) return t.value;
    const i = this.getRelativeCenterPoint(), c = { angle: this.angle, translateX: i.x, translateY: i.y, scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, flipX: this.flipX, flipY: this.flipY }, a = q7(c);
    return this.ownMatrixCache = { key: e, value: a }, a;
  }
  _getNonTransformedDimensions() {
    return new St(this.width, this.height).scalarAdd(this.strokeWidth);
  }
  _calculateCurrentDimensions(e) {
    return this._getTransformedDimensions(e).transform(this.getViewportTransform(), !0).scalarAdd(2 * this.padding);
  }
  _getTransformedDimensions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = lt({ scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, width: this.width, height: this.height, strokeWidth: this.strokeWidth }, e), i = t.strokeWidth;
    let c = i, a = 0;
    this.strokeUniform && (c = 0, a = i);
    const s = t.width + c, r = t.height + c;
    let l;
    return l = t.skewX === 0 && t.skewY === 0 ? new St(s * t.scaleX, r * t.scaleY) : N2(s, r, B1(t)), l.scalarAdd(a);
  }
  translateToGivenOrigin(e, t, i, c, a) {
    let s = e.x, r = e.y;
    const l = No(c) - No(t), d = No(a) - No(i);
    if (l || d) {
      const f = this._getTransformedDimensions();
      s += l * f.x, r += d * f.y;
    }
    return new St(s, r);
  }
  translateToCenterPoint(e, t, i) {
    if (t === pr && i === pr) return e;
    const c = this.translateToGivenOrigin(e, t, i, pr, pr);
    return this.angle ? c.rotate(oo(this.angle), e) : c;
  }
  translateToOriginPoint(e, t, i) {
    const c = this.translateToGivenOrigin(e, pr, pr, t, i);
    return this.angle ? c.rotate(oo(this.angle), e) : c;
  }
  getCenterPoint() {
    const e = this.getRelativeCenterPoint();
    return this.group ? Ja(e, this.group.calcTransformMatrix()) : e;
  }
  getRelativeCenterPoint() {
    return this.translateToCenterPoint(new St(this.left, this.top), this.originX, this.originY);
  }
  getPointByOrigin(e, t) {
    return this.translateToOriginPoint(this.getRelativeCenterPoint(), e, t);
  }
  setPositionByOrigin(e, t, i) {
    const c = this.translateToCenterPoint(e, t, i), a = this.translateToOriginPoint(c, this.originX, this.originY);
    this.set({ left: a.x, top: a.y });
  }
  _getLeftTopCoords() {
    return this.translateToOriginPoint(this.getRelativeCenterPoint(), ti, Ks);
  }
}
const YW = ["type"], XW = ["extraParam"];
let uf = class Pb extends $W {
  static getDefaults() {
    return Pb.ownDefaults;
  }
  get type() {
    const e = this.constructor.type;
    return e === "FabricObject" ? "object" : e.toLowerCase();
  }
  set type(e) {
    qh("warn", "Setting type has no effect", e);
  }
  constructor(e) {
    super(), it(this, "_cacheContext", null), Object.assign(this, Pb.ownDefaults), this.setOptions(e);
  }
  _createCacheCanvas() {
    this._cacheCanvas = lu(), this._cacheContext = this._cacheCanvas.getContext("2d"), this._updateCacheCanvas(), this.dirty = !0;
  }
  _limitCacheSize(e) {
    const t = e.width, i = e.height, c = Br.maxCacheSideLimit, a = Br.minCacheSideLimit;
    if (t <= c && i <= c && t * i <= Br.perfLimitSizeTotal) return t < a && (e.width = a), i < a && (e.height = a), e;
    const s = t / i, [r, l] = h1.limitDimsByArea(s), d = Cm(a, r, c), f = Cm(a, l, c);
    return t > d && (e.zoomX /= t / d, e.width = d, e.capped = !0), i > f && (e.zoomY /= i / f, e.height = f, e.capped = !0), e;
  }
  _getCacheCanvasDimensions() {
    const e = this.getTotalObjectScaling(), t = this._getTransformedDimensions({ skewX: 0, skewY: 0 }), i = t.x * e.x / this.scaleX, c = t.y * e.y / this.scaleY;
    return { width: Math.ceil(i + 2), height: Math.ceil(c + 2), zoomX: e.x, zoomY: e.y, x: i, y: c };
  }
  _updateCacheCanvas() {
    const e = this._cacheCanvas, t = this._cacheContext, { width: i, height: c, zoomX: a, zoomY: s, x: r, y: l } = this._limitCacheSize(this._getCacheCanvasDimensions()), d = i !== e.width || c !== e.height, f = this.zoomX !== a || this.zoomY !== s;
    if (!e || !t) return !1;
    if (d || f) {
      i !== e.width || c !== e.height ? (e.width = i, e.height = c) : (t.setTransform(1, 0, 0, 1, 0, 0), t.clearRect(0, 0, e.width, e.height));
      const h = r / 2, p = l / 2;
      return this.cacheTranslationX = Math.round(e.width / 2 - h) + h, this.cacheTranslationY = Math.round(e.height / 2 - p) + p, t.translate(this.cacheTranslationX, this.cacheTranslationY), t.scale(a, s), this.zoomX = a, this.zoomY = s, !0;
    }
    return !1;
  }
  setOptions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._setOptions(e);
  }
  transform(e) {
    const t = this.group && !this.group._transformDone || this.group && this.canvas && e === this.canvas.contextTop, i = this.calcTransformMatrix(!t);
    e.transform(i[0], i[1], i[2], i[3], i[4], i[5]);
  }
  getObjectScaling() {
    if (!this.group) return new St(Math.abs(this.scaleX), Math.abs(this.scaleY));
    const e = s0(this.calcTransformMatrix());
    return new St(Math.abs(e.scaleX), Math.abs(e.scaleY));
  }
  getTotalObjectScaling() {
    const e = this.getObjectScaling();
    if (this.canvas) {
      const t = this.canvas.getZoom(), i = this.getCanvasRetinaScaling();
      return e.scalarMultiply(t * i);
    }
    return e;
  }
  getObjectOpacity() {
    let e = this.opacity;
    return this.group && (e *= this.group.getObjectOpacity()), e;
  }
  _constrainScale(e) {
    return Math.abs(e) < this.minScaleLimit ? e < 0 ? -this.minScaleLimit : this.minScaleLimit : e === 0 ? 1e-4 : e;
  }
  _set(e, t) {
    e !== _s && e !== xl || (t = this._constrainScale(t)), e === _s && t < 0 ? (this.flipX = !this.flipX, t *= -1) : e === "scaleY" && t < 0 ? (this.flipY = !this.flipY, t *= -1) : e !== "shadow" || !t || t instanceof gf || (t = new gf(t));
    const i = this[e] !== t;
    return this[e] = t, i && this.constructor.cacheProperties.includes(e) && (this.dirty = !0), this.parent && (this.dirty || i && this.constructor.stateProperties.includes(e)) && this.parent._set("dirty", !0), this;
  }
  isNotVisible() {
    return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
  }
  render(e) {
    this.isNotVisible() || this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (e.save(), this._setupCompositeOperation(e), this.drawSelectionBackground(e), this.transform(e), this._setOpacity(e), this._setShadow(e), this.shouldCache() ? (this.renderCache(), this.drawCacheOnCanvas(e)) : (this._removeCacheCanvas(), this.drawObject(e, !1, {}), this.dirty = !1), e.restore());
  }
  drawSelectionBackground(e) {
  }
  renderCache(e) {
    if (e = e || {}, this._cacheCanvas && this._cacheContext || this._createCacheCanvas(), this.isCacheDirty() && this._cacheContext) {
      const { zoomX: t, zoomY: i, cacheTranslationX: c, cacheTranslationY: a } = this, { width: s, height: r } = this._cacheCanvas;
      this.drawObject(this._cacheContext, e.forClipping, { zoomX: t, zoomY: i, cacheTranslationX: c, cacheTranslationY: a, width: s, height: r, parentClipPaths: [] }), this.dirty = !1;
    }
  }
  _removeCacheCanvas() {
    this._cacheCanvas = void 0, this._cacheContext = null;
  }
  hasStroke() {
    return this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
  }
  hasFill() {
    return this.fill && this.fill !== "transparent";
  }
  needsItsOwnCache() {
    return !!(this.paintFirst === Zs && this.hasFill() && this.hasStroke() && this.shadow) || !!this.clipPath;
  }
  shouldCache() {
    return this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache(), this.ownCaching;
  }
  willDrawShadow() {
    return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
  }
  drawClipPathOnCache(e, t, i) {
    e.save(), t.inverted ? e.globalCompositeOperation = "destination-out" : e.globalCompositeOperation = "destination-in", e.setTransform(1, 0, 0, 1, 0, 0), e.drawImage(i, 0, 0), e.restore();
  }
  drawObject(e, t, i) {
    const c = this.fill, a = this.stroke;
    t ? (this.fill = "black", this.stroke = "", this._setClippingProperties(e)) : this._renderBackground(e), this._render(e), this._drawClipPath(e, this.clipPath, i), this.fill = c, this.stroke = a;
  }
  createClipPathLayer(e, t) {
    const i = ac(t), c = i.getContext("2d");
    if (c.translate(t.cacheTranslationX, t.cacheTranslationY), c.scale(t.zoomX, t.zoomY), e._cacheCanvas = i, t.parentClipPaths.forEach((a) => {
      a.transform(c);
    }), t.parentClipPaths.push(e), e.absolutePositioned) {
      const a = Cl(this.calcTransformMatrix());
      c.transform(a[0], a[1], a[2], a[3], a[4], a[5]);
    }
    return e.transform(c), e.drawObject(c, !0, t), i;
  }
  _drawClipPath(e, t, i) {
    if (!t) return;
    t._transformDone = !0;
    const c = this.createClipPathLayer(t, i);
    this.drawClipPathOnCache(e, t, c);
  }
  drawCacheOnCanvas(e) {
    e.scale(1 / this.zoomX, 1 / this.zoomY), e.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
  }
  isCacheDirty() {
    let e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    if (this.isNotVisible()) return !1;
    const t = this._cacheCanvas, i = this._cacheContext;
    return !(!t || !i || e || !this._updateCacheCanvas()) || !!(this.dirty || this.clipPath && this.clipPath.absolutePositioned) && (t && i && !e && (i.save(), i.setTransform(1, 0, 0, 1, 0, 0), i.clearRect(0, 0, t.width, t.height), i.restore()), !0);
  }
  _renderBackground(e) {
    if (!this.backgroundColor) return;
    const t = this._getNonTransformedDimensions();
    e.fillStyle = this.backgroundColor, e.fillRect(-t.x / 2, -t.y / 2, t.x, t.y), this._removeShadow(e);
  }
  _setOpacity(e) {
    this.group && !this.group._transformDone ? e.globalAlpha = this.getObjectOpacity() : e.globalAlpha *= this.opacity;
  }
  _setStrokeStyles(e, t) {
    const i = t.stroke;
    i && (e.lineWidth = t.strokeWidth, e.lineCap = t.strokeLineCap, e.lineDashOffset = t.strokeDashOffset, e.lineJoin = t.strokeLineJoin, e.miterLimit = t.strokeMiterLimit, au(i) ? i.gradientUnits === "percentage" || i.gradientTransform || i.patternTransform ? this._applyPatternForTransformedGradient(e, i) : (e.strokeStyle = i.toLive(e), this._applyPatternGradientTransform(e, i)) : e.strokeStyle = t.stroke);
  }
  _setFillStyles(e, t) {
    let { fill: i } = t;
    i && (au(i) ? (e.fillStyle = i.toLive(e), this._applyPatternGradientTransform(e, i)) : e.fillStyle = i);
  }
  _setClippingProperties(e) {
    e.globalAlpha = 1, e.strokeStyle = "transparent", e.fillStyle = "#000000";
  }
  _setLineDash(e, t) {
    t && t.length !== 0 && e.setLineDash(t);
  }
  _setShadow(e) {
    if (!this.shadow) return;
    const t = this.shadow, i = this.canvas, c = this.getCanvasRetinaScaling(), [a, , , s] = (i == null ? void 0 : i.viewportTransform) || gs, r = a * c, l = s * c, d = t.nonScaling ? new St(1, 1) : this.getObjectScaling();
    e.shadowColor = t.color, e.shadowBlur = t.blur * Br.browserShadowBlurConstant * (r + l) * (d.x + d.y) / 4, e.shadowOffsetX = t.offsetX * r * d.x, e.shadowOffsetY = t.offsetY * l * d.y;
  }
  _removeShadow(e) {
    this.shadow && (e.shadowColor = "", e.shadowBlur = e.shadowOffsetX = e.shadowOffsetY = 0);
  }
  _applyPatternGradientTransform(e, t) {
    if (!au(t)) return { offsetX: 0, offsetY: 0 };
    const i = t.gradientTransform || t.patternTransform, c = -this.width / 2 + t.offsetX || 0, a = -this.height / 2 + t.offsetY || 0;
    return t.gradientUnits === "percentage" ? e.transform(this.width, 0, 0, this.height, c, a) : e.transform(1, 0, 0, 1, c, a), i && e.transform(i[0], i[1], i[2], i[3], i[4], i[5]), { offsetX: c, offsetY: a };
  }
  _renderPaintInOrder(e) {
    this.paintFirst === Zs ? (this._renderStroke(e), this._renderFill(e)) : (this._renderFill(e), this._renderStroke(e));
  }
  _render(e) {
  }
  _renderFill(e) {
    this.fill && (e.save(), this._setFillStyles(e, this), this.fillRule === "evenodd" ? e.fill("evenodd") : e.fill(), e.restore());
  }
  _renderStroke(e) {
    if (this.stroke && this.strokeWidth !== 0) {
      if (this.shadow && !this.shadow.affectStroke && this._removeShadow(e), e.save(), this.strokeUniform) {
        const t = this.getObjectScaling();
        e.scale(1 / t.x, 1 / t.y);
      }
      this._setLineDash(e, this.strokeDashArray), this._setStrokeStyles(e, this), e.stroke(), e.restore();
    }
  }
  _applyPatternForTransformedGradient(e, t) {
    var i;
    const c = this._limitCacheSize(this._getCacheCanvasDimensions()), a = this.getCanvasRetinaScaling(), s = c.x / this.scaleX / a, r = c.y / this.scaleY / a, l = ac({ width: Math.ceil(s), height: Math.ceil(r) }), d = l.getContext("2d");
    d && (d.beginPath(), d.moveTo(0, 0), d.lineTo(s, 0), d.lineTo(s, r), d.lineTo(0, r), d.closePath(), d.translate(s / 2, r / 2), d.scale(c.zoomX / this.scaleX / a, c.zoomY / this.scaleY / a), this._applyPatternGradientTransform(d, t), d.fillStyle = t.toLive(e), d.fill(), e.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2), e.scale(a * this.scaleX / c.zoomX, a * this.scaleY / c.zoomY), e.strokeStyle = (i = d.createPattern(l, "no-repeat")) !== null && i !== void 0 ? i : "");
  }
  _findCenterFromElement() {
    return new St(this.left + this.width / 2, this.top + this.height / 2);
  }
  clone(e) {
    const t = this.toObject(e);
    return this.constructor.fromObject(t);
  }
  cloneAsImage(e) {
    const t = this.toCanvasElement(e);
    return new (pn.getClass("image"))(t);
  }
  toCanvasElement() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = uT(this), i = this.group, c = this.shadow, a = Math.abs, s = e.enableRetinaScaling ? I7() : 1, r = (e.multiplier || 1) * s, l = e.canvasProvider || ((C) => new U1(C, { enableRetinaScaling: !1, renderOnAddRemove: !1, skipOffscreen: !1 }));
    delete this.group, e.withoutTransform && Z7(this), e.withoutShadow && (this.shadow = null), e.viewportTransform && ax(this, this.getViewportTransform()), this.setCoords();
    const d = lu(), f = this.getBoundingRect(), h = this.shadow, p = new St();
    if (h) {
      const C = h.blur, y = h.nonScaling ? new St(1, 1) : this.getObjectScaling();
      p.x = 2 * Math.round(a(h.offsetX) + C) * a(y.x), p.y = 2 * Math.round(a(h.offsetY) + C) * a(y.y);
    }
    const g = f.width + p.x, _ = f.height + p.y;
    d.width = Math.ceil(g), d.height = Math.ceil(_);
    const b = l(d);
    e.format === "jpeg" && (b.backgroundColor = "#fff"), this.setPositionByOrigin(new St(b.width / 2, b.height / 2), pr, pr);
    const v = this.canvas;
    b._objects = [this], this.set("canvas", b), this.setCoords();
    const E = b.toCanvasElement(r || 1, e);
    return this.set("canvas", v), this.shadow = c, i && (this.group = i), this.set(t), this.setCoords(), b._objects = [], b.destroy(), E;
  }
  toDataURL() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return oT(this.toCanvasElement(e), e.format || "png", e.quality || 1);
  }
  isType() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    return t.includes(this.constructor.type) || t.includes(this.type);
  }
  complexity() {
    return 1;
  }
  toJSON() {
    return this.toObject();
  }
  rotate(e) {
    const { centeredRotation: t, originX: i, originY: c } = this;
    if (t) {
      const { x: a, y: s } = this.getRelativeCenterPoint();
      this.originX = pr, this.originY = pr, this.left = a, this.top = s;
    }
    if (this.set("angle", e), t) {
      const { x: a, y: s } = this.translateToOriginPoint(this.getRelativeCenterPoint(), i, c);
      this.left = a, this.top = s, this.originX = i, this.originY = c;
    }
  }
  setOnGroup() {
  }
  _setupCompositeOperation(e) {
    this.globalCompositeOperation && (e.globalCompositeOperation = this.globalCompositeOperation);
  }
  dispose() {
    Jb.cancelByTarget(this), this.off(), this._set("canvas", void 0), this._cacheCanvas && fd().dispose(this._cacheCanvas), this._cacheCanvas = void 0, this._cacheContext = null;
  }
  animate(e, t) {
    return Object.entries(e).reduce((i, c) => {
      let [a, s] = c;
      return i[a] = this._animate(a, s, t), i;
    }, {});
  }
  _animate(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const c = e.split("."), a = this.constructor.colorProperties.includes(c[c.length - 1]), { abort: s, startValue: r, onChange: l, onComplete: d } = i, f = lt(lt({}, i), {}, { target: this, startValue: r ?? c.reduce((h, p) => h[p], this), endValue: t, abort: s == null ? void 0 : s.bind(this), onChange: (h, p, g) => {
      c.reduce((_, b, v) => (v === c.length - 1 && (_[b] = h), _[b]), this), l && l(h, p, g);
    }, onComplete: (h, p, g) => {
      this.setCoords(), d && d(h, p, g);
    } });
    return a ? u8(f) : pT(f);
  }
  isDescendantOf(e) {
    const { parent: t, group: i } = this;
    return t === e || i === e || !!t && t.isDescendantOf(e) || !!i && i !== t && i.isDescendantOf(e);
  }
  getAncestors() {
    const e = [];
    let t = this;
    do
      t = t.parent, t && e.push(t);
    while (t);
    return e;
  }
  findCommonAncestors(e) {
    if (this === e) return { fork: [], otherFork: [], common: [this, ...this.getAncestors()] };
    const t = this.getAncestors(), i = e.getAncestors();
    if (t.length === 0 && i.length > 0 && this === i[i.length - 1]) return { fork: [], otherFork: [e, ...i.slice(0, i.length - 1)], common: [this] };
    for (let c, a = 0; a < t.length; a++) {
      if (c = t[a], c === e) return { fork: [this, ...t.slice(0, a)], otherFork: [], common: t.slice(a) };
      for (let s = 0; s < i.length; s++) {
        if (this === i[s]) return { fork: [], otherFork: [e, ...i.slice(0, s)], common: [this, ...t] };
        if (c === i[s]) return { fork: [this, ...t.slice(0, a)], otherFork: [e, ...i.slice(0, s)], common: t.slice(a) };
      }
    }
    return { fork: [this, ...t], otherFork: [e, ...i], common: [] };
  }
  hasCommonAncestors(e) {
    const t = this.findCommonAncestors(e);
    return t && !!t.common.length;
  }
  isInFrontOf(e) {
    if (this === e) return;
    const t = this.findCommonAncestors(e);
    if (t.fork.includes(e)) return !0;
    if (t.otherFork.includes(this)) return !1;
    const i = t.common[0] || this.canvas;
    if (!i) return;
    const c = t.fork.pop(), a = t.otherFork.pop(), s = i._objects.indexOf(c), r = i._objects.indexOf(a);
    return s > -1 && s > r;
  }
  toObject() {
    const e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).concat(Pb.customProperties, this.constructor.customProperties || []);
    let t;
    const i = Br.NUM_FRACTION_DIGITS, { clipPath: c, fill: a, stroke: s, shadow: r, strokeDashArray: l, left: d, top: f, originX: h, originY: p, width: g, height: _, strokeWidth: b, strokeLineCap: v, strokeDashOffset: E, strokeLineJoin: C, strokeUniform: y, strokeMiterLimit: T, scaleX: A, scaleY: k, angle: N, flipX: j, flipY: I, opacity: B, visible: U, backgroundColor: H, fillRule: Q, paintFirst: Y, globalCompositeOperation: ie, skewX: ce, skewY: $ } = this;
    c && !c.excludeFromExport && (t = c.toObject(e.concat("inverted", "absolutePositioned")));
    const te = (K) => zi(K, i), V = lt(lt({}, Rm(this, e)), {}, { type: this.constructor.type, version: nx, originX: h, originY: p, left: te(d), top: te(f), width: te(g), height: te(_), fill: P4(a) ? a.toObject() : a, stroke: P4(s) ? s.toObject() : s, strokeWidth: te(b), strokeDashArray: l && l.concat(), strokeLineCap: v, strokeDashOffset: E, strokeLineJoin: C, strokeUniform: y, strokeMiterLimit: te(T), scaleX: te(A), scaleY: te(k), angle: te(N), flipX: j, flipY: I, opacity: te(B), shadow: r && r.toObject(), visible: U, backgroundColor: H, fillRule: Q, paintFirst: Y, globalCompositeOperation: ie, skewX: te(ce), skewY: te($) }, t ? { clipPath: t } : null);
    return this.includeDefaultValues ? V : this._removeDefaultValues(V);
  }
  toDatalessObject(e) {
    return this.toObject(e);
  }
  _removeDefaultValues(e) {
    const t = this.constructor.getDefaults(), i = Object.keys(t).length > 0 ? t : Object.getPrototypeOf(this);
    return lT(e, (c, a) => {
      if (a === ti || a === Ks || a === "type") return !0;
      const s = i[a];
      return c !== s && !(Array.isArray(c) && Array.isArray(s) && c.length === 0 && s.length === 0);
    });
  }
  toString() {
    return "#<".concat(this.constructor.type, ">");
  }
  static _fromObject(e) {
    let t = Vi(e, YW), i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { extraParam: c } = i, a = Vi(i, XW);
    return F1(t, a).then((s) => c ? (delete s[c], new this(t[c], s)) : new this(s));
  }
  static fromObject(e, t) {
    return this._fromObject(e, t);
  }
};
it(uf, "stateProperties", PW), it(uf, "cacheProperties", Cf), it(uf, "ownDefaults", jW), it(uf, "type", "FabricObject"), it(uf, "colorProperties", [ta, Zs, "backgroundColor"]), it(uf, "customProperties", []), pn.setClass(uf), pn.setClass(uf, "object");
const _0 = (n, e, t) => (i, c, a, s) => {
  const r = e(i, c, a, s);
  return r && e8(n, lt(lt({}, n8(i, c, a, s)), t)), r;
};
function y0(n) {
  return (e, t, i, c) => {
    const { target: a, originX: s, originY: r } = t, l = a.getRelativeCenterPoint(), d = a.translateToOriginPoint(l, s, r), f = n(e, t, i, c);
    return a.setPositionByOrigin(d, t.originX, t.originY), f;
  };
}
const W4 = _0(T1, y0((n, e, t, i) => {
  const c = cT(e, e.originX, e.originY, t, i);
  if (No(e.originX) === No(pr) || No(e.originX) === No(yo) && c.x < 0 || No(e.originX) === No(ti) && c.x > 0) {
    const { target: a } = e, s = a.strokeWidth / (a.strokeUniform ? a.scaleX : 1), r = t8(e) ? 2 : 1, l = a.width, d = Math.abs(c.x * r / a.scaleX) - s;
    return a.set("width", Math.max(d, 1)), l !== a.width;
  }
  return !1;
}));
function KW(n, e, t, i, c) {
  i = i || {};
  const a = this.sizeX || i.cornerSize || c.cornerSize, s = this.sizeY || i.cornerSize || c.cornerSize, r = i.transparentCorners !== void 0 ? i.transparentCorners : c.transparentCorners, l = r ? Zs : ta, d = !r && (i.cornerStrokeColor || c.cornerStrokeColor);
  let f, h = e, p = t;
  n.save(), n.fillStyle = i.cornerColor || c.cornerColor || "", n.strokeStyle = i.cornerStrokeColor || c.cornerStrokeColor || "", a > s ? (f = a, n.scale(1, s / a), p = t * a / s) : s > a ? (f = s, n.scale(a / s, 1), h = e * s / a) : f = a, n.beginPath(), n.arc(h, p, f / 2, 0, yf, !1), n[l](), d && n.stroke(), n.restore();
}
function QW(n, e, t, i, c) {
  i = i || {};
  const a = this.sizeX || i.cornerSize || c.cornerSize, s = this.sizeY || i.cornerSize || c.cornerSize, r = i.transparentCorners !== void 0 ? i.transparentCorners : c.transparentCorners, l = r ? Zs : ta, d = !r && (i.cornerStrokeColor || c.cornerStrokeColor), f = a / 2, h = s / 2;
  n.save(), n.fillStyle = i.cornerColor || c.cornerColor || "", n.strokeStyle = i.cornerStrokeColor || c.cornerStrokeColor || "", n.translate(e, t);
  const p = c.getTotalAngle();
  n.rotate(oo(p)), n["".concat(l, "Rect")](-f, -h, a, s), d && n.strokeRect(-f, -h, a, s), n.restore();
}
class Xu {
  constructor(e) {
    it(this, "visible", !0), it(this, "actionName", O2), it(this, "angle", 0), it(this, "x", 0), it(this, "y", 0), it(this, "offsetX", 0), it(this, "offsetY", 0), it(this, "sizeX", 0), it(this, "sizeY", 0), it(this, "touchSizeX", 0), it(this, "touchSizeY", 0), it(this, "cursorStyle", "crosshair"), it(this, "withConnection", !1), Object.assign(this, e);
  }
  shouldActivate(e, t, i, c) {
    var a;
    let { tl: s, tr: r, br: l, bl: d } = c;
    return ((a = t.canvas) === null || a === void 0 ? void 0 : a.getActiveObject()) === t && t.isControlVisible(e) && Qi.isPointInPolygon(i, [s, r, l, d]);
  }
  getActionHandler(e, t, i) {
    return this.actionHandler;
  }
  getMouseDownHandler(e, t, i) {
    return this.mouseDownHandler;
  }
  getMouseUpHandler(e, t, i) {
    return this.mouseUpHandler;
  }
  cursorStyleHandler(e, t, i) {
    return t.cursorStyle;
  }
  getActionName(e, t, i) {
    return t.actionName;
  }
  getVisibility(e, t) {
    var i, c;
    return (i = (c = e._controlsVisibility) === null || c === void 0 ? void 0 : c[t]) !== null && i !== void 0 ? i : this.visible;
  }
  setVisibility(e, t, i) {
    this.visible = e;
  }
  positionHandler(e, t, i, c) {
    return new St(this.x * e.x + this.offsetX, this.y * e.y + this.offsetY).transform(t);
  }
  calcCornerCoords(e, t, i, c, a, s) {
    const r = D2([m0(i, c), g0({ angle: e }), R2((a ? this.touchSizeX : this.sizeX) || t, (a ? this.touchSizeY : this.sizeY) || t)]);
    return { tl: new St(-0.5, -0.5).transform(r), tr: new St(0.5, -0.5).transform(r), br: new St(0.5, 0.5).transform(r), bl: new St(-0.5, 0.5).transform(r) };
  }
  render(e, t, i, c, a) {
    ((c = c || {}).cornerStyle || a.cornerStyle) === "circle" ? KW.call(this, e, t, i, c, a) : QW.call(this, e, t, i, c, a);
  }
}
const ZW = (n, e, t) => t.lockRotation ? t2 : e.cursorStyle, JW = _0(M7, y0((n, e, t, i) => {
  let { target: c, ex: a, ey: s, theta: r, originX: l, originY: d } = e;
  const f = c.translateToOriginPoint(c.getRelativeCenterPoint(), l, d);
  if (nc(c, "lockRotation")) return !1;
  const h = Math.atan2(s - f.y, a - f.x), p = Math.atan2(i - f.y, t - f.x);
  let g = $h(p - h + r);
  if (c.snapAngle && c.snapAngle > 0) {
    const b = c.snapAngle, v = c.snapThreshold || b, E = Math.ceil(g / b) * b, C = Math.floor(g / b) * b;
    Math.abs(g - C) < v ? g = C : Math.abs(g - E) < v && (g = E);
  }
  g < 0 && (g = 360 + g), g %= 360;
  const _ = c.angle !== g;
  return c.angle = g, _;
}));
function c8(n, e) {
  const t = e.canvas, i = n[t.uniScaleKey];
  return t.uniformScaling && !i || !t.uniformScaling && i;
}
function d8(n, e, t) {
  const i = nc(n, "lockScalingX"), c = nc(n, "lockScalingY");
  if (i && c || !e && (i || c) && t || i && e === "x" || c && e === "y") return !0;
  const { width: a, height: s, strokeWidth: r } = n;
  return a === 0 && r === 0 && e !== "y" || s === 0 && r === 0 && e !== "x";
}
const e$ = ["e", "se", "s", "sw", "w", "nw", "n", "ne", "e"], o1 = (n, e, t) => {
  const i = c8(n, t);
  if (d8(t, e.x !== 0 && e.y === 0 ? "x" : e.x === 0 && e.y !== 0 ? "y" : "", i)) return t2;
  const c = r8(t, e);
  return "".concat(e$[c], "-resize");
};
function mT(n, e, t, i) {
  let c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
  const a = e.target, s = c.by, r = c8(n, a);
  let l, d, f, h, p, g;
  if (d8(a, s, r)) return !1;
  if (e.gestureScale) d = e.scaleX * e.gestureScale, f = e.scaleY * e.gestureScale;
  else {
    if (l = cT(e, e.originX, e.originY, t, i), p = s !== "y" ? Math.sign(l.x || e.signX || 1) : 1, g = s !== "x" ? Math.sign(l.y || e.signY || 1) : 1, e.signX || (e.signX = p), e.signY || (e.signY = g), nc(a, "lockScalingFlip") && (e.signX !== p || e.signY !== g)) return !1;
    if (h = a._getTransformedDimensions(), r && !s) {
      const v = Math.abs(l.x) + Math.abs(l.y), { original: E } = e, C = v / (Math.abs(h.x * E.scaleX / a.scaleX) + Math.abs(h.y * E.scaleY / a.scaleY));
      d = E.scaleX * C, f = E.scaleY * C;
    } else d = Math.abs(l.x * a.scaleX / h.x), f = Math.abs(l.y * a.scaleY / h.y);
    t8(e) && (d *= 2, f *= 2), e.signX !== p && s !== "y" && (e.originX = F4(e.originX), d *= -1, e.signX = p), e.signY !== g && s !== "x" && (e.originY = F4(e.originY), f *= -1, e.signY = g);
  }
  const _ = a.scaleX, b = a.scaleY;
  return s ? (s === "x" && a.set(_s, d), s === "y" && a.set(xl, f)) : (!nc(a, "lockScalingX") && a.set(_s, d), !nc(a, "lockScalingY") && a.set(xl, f)), _ !== a.scaleX || b !== a.scaleY;
}
const tb = _0(k2, y0((n, e, t, i) => mT(n, e, t, i))), t$ = _0(k2, y0((n, e, t, i) => mT(n, e, t, i, { by: "x" }))), n$ = _0(k2, y0((n, e, t, i) => mT(n, e, t, i, { by: "y" }))), r$ = ["target", "ex", "ey", "skewingSide"], vw = { x: { counterAxis: "y", scale: _s, skew: h0, lockSkewing: "lockSkewingX", origin: "originX", flip: "flipX" }, y: { counterAxis: "x", scale: xl, skew: p0, lockSkewing: "lockSkewingY", origin: "originY", flip: "flipY" } }, i$ = ["ns", "nesw", "ew", "nwse"], o$ = (n, e, t) => {
  if (e.x !== 0 && nc(t, "lockSkewingY") || e.y !== 0 && nc(t, "lockSkewingX")) return t2;
  const i = r8(t, e) % 4;
  return "".concat(i$[i], "-resize");
};
function f8(n, e, t, i, c) {
  const { target: a } = t, { counterAxis: s, origin: r, lockSkewing: l, skew: d, flip: f } = vw[n];
  if (nc(a, l)) return !1;
  const { origin: h, flip: p } = vw[s], g = No(t[h]) * (a[p] ? -1 : 1), _ = -Math.sign(g) * (a[f] ? -1 : 1), b = 0.5 * -((a[d] === 0 && cT(t, pr, pr, i, c)[n] > 0 || a[d] > 0 ? 1 : -1) * _) + 0.5;
  return _0(P7, y0((E, C, y, T) => function(A, k, N) {
    let { target: j, ex: I, ey: B, skewingSide: U } = k, H = Vi(k, r$);
    const { skew: Q } = vw[A], Y = N.subtract(new St(I, B)).divide(new St(j.scaleX, j.scaleY))[A], ie = j[Q], ce = H[Q], $ = Math.tan(oo(ce)), te = A === "y" ? j._getTransformedDimensions({ scaleX: 1, scaleY: 1, skewX: 0 }).x : j._getTransformedDimensions({ scaleX: 1, scaleY: 1 }).y, V = 2 * Y * U / Math.max(te, 1) + $, K = $h(Math.atan(V));
    j.set(Q, K);
    const ne = ie !== j[Q];
    if (ne && A === "y") {
      const { skewX: J, scaleX: L } = j, z = j._getTransformedDimensions({ skewY: ie }), ee = j._getTransformedDimensions(), q = J !== 0 ? z.x / ee.x : 1;
      q !== 1 && j.set(_s, q * L);
    }
    return ne;
  }(n, C, new St(y, T))))(e, lt(lt({}, t), {}, { [r]: b, skewingSide: _ }), i, c);
}
const a$ = (n, e, t, i) => f8("x", n, e, t, i), s$ = (n, e, t, i) => f8("y", n, e, t, i);
function M2(n, e) {
  return n[e.canvas.altActionKey];
}
const nb = (n, e, t) => {
  const i = M2(n, t);
  return e.x === 0 ? i ? h0 : xl : e.y === 0 ? i ? p0 : _s : "";
}, Kg = (n, e, t) => M2(n, t) ? o$(0, e, t) : o1(n, e, t), $4 = (n, e, t, i) => M2(n, e.target) ? s$(n, e, t, i) : t$(n, e, t, i), Y4 = (n, e, t, i) => M2(n, e.target) ? a$(n, e, t, i) : n$(n, e, t, i), h8 = () => ({ ml: new Xu({ x: -0.5, y: 0, cursorStyleHandler: Kg, actionHandler: $4, getActionName: nb }), mr: new Xu({ x: 0.5, y: 0, cursorStyleHandler: Kg, actionHandler: $4, getActionName: nb }), mb: new Xu({ x: 0, y: 0.5, cursorStyleHandler: Kg, actionHandler: Y4, getActionName: nb }), mt: new Xu({ x: 0, y: -0.5, cursorStyleHandler: Kg, actionHandler: Y4, getActionName: nb }), tl: new Xu({ x: -0.5, y: -0.5, cursorStyleHandler: o1, actionHandler: tb }), tr: new Xu({ x: 0.5, y: -0.5, cursorStyleHandler: o1, actionHandler: tb }), bl: new Xu({ x: -0.5, y: 0.5, cursorStyleHandler: o1, actionHandler: tb }), br: new Xu({ x: 0.5, y: 0.5, cursorStyleHandler: o1, actionHandler: tb }), mtr: new Xu({ x: 0, y: -0.5, actionHandler: JW, cursorStyleHandler: ZW, offsetY: -40, withConnection: !0, actionName: rT }) }), l$ = () => ({ mr: new Xu({ x: 0.5, y: 0, actionHandler: W4, cursorStyleHandler: Kg, actionName: T1 }), ml: new Xu({ x: -0.5, y: 0, actionHandler: W4, cursorStyleHandler: Kg, actionName: T1 }) }), u$ = () => lt(lt({}, h8()), l$());
class O1 extends uf {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), O1.ownDefaults);
  }
  constructor(e) {
    super(), Object.assign(this, this.constructor.createControls(), O1.ownDefaults), this.setOptions(e);
  }
  static createControls() {
    return { controls: h8() };
  }
  _updateCacheCanvas() {
    const e = this.canvas;
    if (this.noScaleCache && e && e._currentTransform) {
      const t = e._currentTransform, i = t.target, c = t.action;
      if (this === i && c && c.startsWith(O2)) return !1;
    }
    return super._updateCacheCanvas();
  }
  getActiveControl() {
    const e = this.__corner;
    return e ? { key: e, control: this.controls[e], coord: this.oCoords[e] } : void 0;
  }
  findControl(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    if (!this.hasControls || !this.canvas) return;
    this.__corner = void 0;
    const i = Object.entries(this.oCoords);
    for (let c = i.length - 1; c >= 0; c--) {
      const [a, s] = i[c], r = this.controls[a];
      if (r.shouldActivate(a, this, e, t ? s.touchCorner : s.corner)) return this.__corner = a, { key: a, control: r, coord: this.oCoords[a] };
    }
  }
  calcOCoords() {
    const e = this.getViewportTransform(), t = this.getCenterPoint(), i = m0(t.x, t.y), c = g0({ angle: this.getTotalAngle() - (this.group && this.flipX ? 180 : 0) }), a = Io(i, c), s = Io(e, a), r = Io(s, [1 / e[0], 0, 0, 1 / e[3], 0, 0]), l = this.group ? s0(this.calcTransformMatrix()) : void 0;
    l && (l.scaleX = Math.abs(l.scaleX), l.scaleY = Math.abs(l.scaleY));
    const d = this._calculateCurrentDimensions(l), f = {};
    return this.forEachControl((h, p) => {
      const g = h.positionHandler(d, r, this, h);
      f[p] = Object.assign(g, this._calcCornerCoords(h, g));
    }), f;
  }
  _calcCornerCoords(e, t) {
    const i = this.getTotalAngle();
    return { corner: e.calcCornerCoords(i, this.cornerSize, t.x, t.y, !1, this), touchCorner: e.calcCornerCoords(i, this.touchCornerSize, t.x, t.y, !0, this) };
  }
  setCoords() {
    super.setCoords(), this.canvas && (this.oCoords = this.calcOCoords());
  }
  forEachControl(e) {
    for (const t in this.controls) e(this.controls[t], t, this);
  }
  drawSelectionBackground(e) {
    if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
    e.save();
    const t = this.getRelativeCenterPoint(), i = this._calculateCurrentDimensions(), c = this.getViewportTransform();
    e.translate(t.x, t.y), e.scale(1 / c[0], 1 / c[3]), e.rotate(oo(this.angle)), e.fillStyle = this.selectionBackgroundColor, e.fillRect(-i.x / 2, -i.y / 2, i.x, i.y), e.restore();
  }
  strokeBorders(e, t) {
    e.strokeRect(-t.x / 2, -t.y / 2, t.x, t.y);
  }
  _drawBorders(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const c = lt({ hasControls: this.hasControls, borderColor: this.borderColor, borderDashArray: this.borderDashArray }, i);
    e.save(), e.strokeStyle = c.borderColor, this._setLineDash(e, c.borderDashArray), this.strokeBorders(e, t), c.hasControls && this.drawControlsConnectingLines(e, t), e.restore();
  }
  _renderControls(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { hasBorders: i, hasControls: c } = this, a = lt({ hasBorders: i, hasControls: c }, t), s = this.getViewportTransform(), r = a.hasBorders, l = a.hasControls, d = Io(s, this.calcTransformMatrix()), f = s0(d);
    e.save(), e.translate(f.translateX, f.translateY), e.lineWidth = this.borderScaleFactor, this.group === this.parent && (e.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1), this.flipX && (f.angle -= 180), e.rotate(oo(this.group ? f.angle : this.angle)), r && this.drawBorders(e, f, t), l && this.drawControls(e, t), e.restore();
  }
  drawBorders(e, t, i) {
    let c;
    if (i && i.forActiveSelection || this.group) {
      const a = N2(this.width, this.height, B1(t)), s = this.isStrokeAccountedForInDimensions() ? iT : (this.strokeUniform ? new St().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : new St(t.scaleX, t.scaleY)).scalarMultiply(this.strokeWidth);
      c = a.add(s).scalarAdd(this.borderScaleFactor).scalarAdd(2 * this.padding);
    } else c = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
    this._drawBorders(e, c, i);
  }
  drawControlsConnectingLines(e, t) {
    let i = !1;
    e.beginPath(), this.forEachControl((c, a) => {
      c.withConnection && c.getVisibility(this, a) && (i = !0, e.moveTo(c.x * t.x, c.y * t.y), e.lineTo(c.x * t.x + c.offsetX, c.y * t.y + c.offsetY));
    }), i && e.stroke();
  }
  drawControls(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    e.save();
    const i = this.getCanvasRetinaScaling(), { cornerStrokeColor: c, cornerDashArray: a, cornerColor: s } = this, r = lt({ cornerStrokeColor: c, cornerDashArray: a, cornerColor: s }, t);
    e.setTransform(i, 0, 0, i, 0, 0), e.strokeStyle = e.fillStyle = r.cornerColor, this.transparentCorners || (e.strokeStyle = r.cornerStrokeColor), this._setLineDash(e, r.cornerDashArray), this.forEachControl((l, d) => {
      if (l.getVisibility(this, d)) {
        const f = this.oCoords[d];
        l.render(e, f.x, f.y, r, this);
      }
    }), e.restore();
  }
  isControlVisible(e) {
    return this.controls[e] && this.controls[e].getVisibility(this, e);
  }
  setControlVisible(e, t) {
    this._controlsVisibility || (this._controlsVisibility = {}), this._controlsVisibility[e] = t;
  }
  setControlsVisibility() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Object.entries(e).forEach((t) => {
      let [i, c] = t;
      return this.setControlVisible(i, c);
    });
  }
  clearContextTop(e) {
    if (!this.canvas) return;
    const t = this.canvas.contextTop;
    if (!t) return;
    const i = this.canvas.viewportTransform;
    t.save(), t.transform(i[0], i[1], i[2], i[3], i[4], i[5]), this.transform(t);
    const c = this.width + 4, a = this.height + 4;
    return t.clearRect(-c / 2, -a / 2, c, a), e || t.restore(), t;
  }
  onDeselect(e) {
    return !1;
  }
  onSelect(e) {
    return !1;
  }
  shouldStartDragging(e) {
    return !1;
  }
  onDragStart(e) {
    return !1;
  }
  canDrop(e) {
    return !1;
  }
  renderDragSourceEffect(e) {
  }
  renderDropTargetEffect(e) {
  }
}
function p8(n, e) {
  return e.forEach((t) => {
    Object.getOwnPropertyNames(t.prototype).forEach((i) => {
      i !== "constructor" && Object.defineProperty(n.prototype, i, Object.getOwnPropertyDescriptor(t.prototype, i) || /* @__PURE__ */ Object.create(null));
    });
  }), n;
}
it(O1, "ownDefaults", { noScaleCache: !0, lockMovementX: !1, lockMovementY: !1, lockRotation: !1, lockScalingX: !1, lockScalingY: !1, lockSkewingX: !1, lockSkewingY: !1, lockScalingFlip: !1, cornerSize: 13, touchCornerSize: 24, transparentCorners: !0, cornerColor: "rgb(178,204,255)", cornerStrokeColor: "", cornerStyle: "rect", cornerDashArray: null, hasControls: !0, borderColor: "rgb(178,204,255)", borderDashArray: null, borderOpacityWhenMoving: 0.4, borderScaleFactor: 1, hasBorders: !0, selectionBackgroundColor: "", selectable: !0, evented: !0, perPixelTargetFind: !1, activeOn: "down", hoverCursor: null, moveCursor: null });
class es extends O1 {
}
p8(es, [i8]), pn.setClass(es), pn.setClass(es, "object");
const m8 = (n, e, t, i) => {
  const c = 2 * (i = Math.round(i)) + 1, { data: a } = n.getImageData(e - i, t - i, c, c);
  for (let s = 3; s < a.length; s += 4)
    if (a[s] > 0) return !1;
  return !0;
};
class g8 {
  constructor(e) {
    this.options = e, this.strokeProjectionMagnitude = this.options.strokeWidth / 2, this.scale = new St(this.options.scaleX, this.options.scaleY), this.strokeUniformScalar = this.options.strokeUniform ? new St(1 / this.options.scaleX, 1 / this.options.scaleY) : new St(1, 1);
  }
  createSideVector(e, t) {
    const i = n2(e, t);
    return this.options.strokeUniform ? i.multiply(this.scale) : i;
  }
  projectOrthogonally(e, t, i) {
    return this.applySkew(e.add(this.calcOrthogonalProjection(e, t, i)));
  }
  isSkewed() {
    return this.options.skewX !== 0 || this.options.skewY !== 0;
  }
  applySkew(e) {
    const t = new St(e);
    return t.y += t.x * Math.tan(oo(this.options.skewY)), t.x += t.y * Math.tan(oo(this.options.skewX)), t;
  }
  scaleUnitVector(e, t) {
    return e.multiply(this.strokeUniformScalar).scalarMultiply(t);
  }
}
const c$ = new St();
class t0 extends g8 {
  static getOrthogonalRotationFactor(e, t) {
    const i = t ? i2(e, t) : a8(e);
    return Math.abs(i) < Gh ? -1 : 1;
  }
  constructor(e, t, i, c) {
    super(c), it(this, "AB", void 0), it(this, "AC", void 0), it(this, "alpha", void 0), it(this, "bisector", void 0), this.A = new St(e), this.B = new St(t), this.C = new St(i), this.AB = this.createSideVector(this.A, this.B), this.AC = this.createSideVector(this.A, this.C), this.alpha = i2(this.AB, this.AC), this.bisector = L2(dT(this.AB.eq(c$) ? this.AC : this.AB, this.alpha / 2));
  }
  calcOrthogonalProjection(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.strokeProjectionMagnitude;
    const c = this.createSideVector(e, t), a = fT(c), s = t0.getOrthogonalRotationFactor(a, this.bisector);
    return this.scaleUnitVector(a, i * s);
  }
  projectBevel() {
    const e = [];
    return (this.alpha % yf == 0 ? [this.B] : [this.B, this.C]).forEach((t) => {
      e.push(this.projectOrthogonally(this.A, t)), e.push(this.projectOrthogonally(this.A, t, -this.strokeProjectionMagnitude));
    }), e;
  }
  projectMiter() {
    const e = [], t = Math.abs(this.alpha), i = 1 / Math.sin(t / 2), c = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * i), a = this.options.strokeUniform ? r2(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
    return r2(c) / this.strokeProjectionMagnitude <= a && e.push(this.applySkew(this.A.add(c))), e.push(...this.projectBevel()), e;
  }
  projectRoundNoSkew(e, t) {
    const i = [], c = new St(t0.getOrthogonalRotationFactor(this.bisector), t0.getOrthogonalRotationFactor(new St(this.bisector.y, this.bisector.x)));
    return [new St(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(c), new St(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(c)].forEach((a) => {
      sx(a, e, t) && i.push(this.A.add(a));
    }), i;
  }
  projectRoundWithSkew(e, t) {
    const i = [], { skewX: c, skewY: a, scaleX: s, scaleY: r, strokeUniform: l } = this.options, d = new St(Math.tan(oo(c)), Math.tan(oo(a))), f = this.strokeProjectionMagnitude, h = l ? f / r / Math.sqrt(1 / r ** 2 + 1 / s ** 2 * d.y ** 2) : f / Math.sqrt(1 + d.y ** 2), p = new St(Math.sqrt(Math.max(f ** 2 - h ** 2, 0)), h), g = l ? f / Math.sqrt(1 + d.x ** 2 * (1 / r) ** 2 / (1 / s + 1 / s * d.x * d.y) ** 2) : f / Math.sqrt(1 + d.x ** 2 / (1 + d.x * d.y) ** 2), _ = new St(g, Math.sqrt(Math.max(f ** 2 - g ** 2, 0)));
    return [_, _.scalarMultiply(-1), p, p.scalarMultiply(-1)].map((b) => this.applySkew(l ? b.multiply(this.strokeUniformScalar) : b)).forEach((b) => {
      sx(b, e, t) && i.push(this.applySkew(this.A).add(b));
    }), i;
  }
  projectRound() {
    const e = [];
    e.push(...this.projectBevel());
    const t = this.alpha % yf == 0, i = this.applySkew(this.A), c = e[t ? 0 : 2].subtract(i), a = e[t ? 1 : 0].subtract(i), s = t ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1)), r = e0(c, s) > 0, l = r ? c : a, d = r ? a : c;
    return this.isSkewed() ? e.push(...this.projectRoundWithSkew(l, d)) : e.push(...this.projectRoundNoSkew(l, d)), e;
  }
  projectPoints() {
    switch (this.options.strokeLineJoin) {
      case "miter":
        return this.projectMiter();
      case "round":
        return this.projectRound();
      default:
        return this.projectBevel();
    }
  }
  project() {
    return this.projectPoints().map((e) => ({ originPoint: this.A, projectedPoint: e, angle: this.alpha, bisector: this.bisector }));
  }
}
class X4 extends g8 {
  constructor(e, t, i) {
    super(i), this.A = new St(e), this.T = new St(t);
  }
  calcOrthogonalProjection(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.strokeProjectionMagnitude;
    const c = this.createSideVector(e, t);
    return this.scaleUnitVector(fT(c), i);
  }
  projectButt() {
    return [this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude), this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)];
  }
  projectRound() {
    const e = [];
    if (!this.isSkewed() && this.A.eq(this.T)) {
      const t = new St(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
      e.push(this.applySkew(this.A.add(t)), this.applySkew(this.A.subtract(t)));
    } else e.push(...new t0(this.A, this.T, this.T, this.options).projectRound());
    return e;
  }
  projectSquare() {
    const e = [];
    if (this.A.eq(this.T)) {
      const t = new St(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
      e.push(this.A.add(t), this.A.subtract(t));
    } else {
      const t = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude), i = this.scaleUnitVector(L2(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude), c = this.A.add(i);
      e.push(c.add(t), c.subtract(t));
    }
    return e.map((t) => this.applySkew(t));
  }
  projectPoints() {
    switch (this.options.strokeLineCap) {
      case "round":
        return this.projectRound();
      case "square":
        return this.projectSquare();
      default:
        return this.projectButt();
    }
  }
  project() {
    return this.projectPoints().map((e) => ({ originPoint: this.A, projectedPoint: e }));
  }
}
const _8 = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
  const i = [];
  if (n.length === 0) return i;
  const c = n.reduce((a, s) => (a[a.length - 1].eq(s) || a.push(new St(s)), a), [new St(n[0])]);
  if (c.length === 1) t = !0;
  else if (!t) {
    const a = c[0], s = ((r, l) => {
      for (let d = r.length - 1; d >= 0; d--) if (l(r[d], d, r)) return d;
      return -1;
    })(c, (r) => !r.eq(a));
    c.splice(s + 1);
  }
  return c.forEach((a, s, r) => {
    let l, d;
    s === 0 ? (d = r[1], l = t ? a : r[r.length - 1]) : s === r.length - 1 ? (l = r[s - 1], d = t ? a : r[0]) : (l = r[s - 1], d = r[s + 1]), t && r.length === 1 ? i.push(...new X4(a, a, e).project()) : !t || s !== 0 && s !== r.length - 1 ? i.push(...new t0(a, l, d, e).project()) : i.push(...new X4(a, s === 0 ? d : l, e).project());
  }), i;
}, gT = (n) => {
  const e = {};
  return Object.keys(n).forEach((t) => {
    e[t] = {}, Object.keys(n[t]).forEach((i) => {
      e[t][i] = lt({}, n[t][i]);
    });
  }), e;
}, y8 = (n) => n.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), P2 = (n) => {
  const e = [];
  for (let t, i = 0; i < n.length; i++) (t = d$(n, i)) !== !1 && e.push(t);
  return e;
}, d$ = (n, e) => {
  const t = n.charCodeAt(e);
  if (isNaN(t)) return "";
  if (t < 55296 || t > 57343) return n.charAt(e);
  if (55296 <= t && t <= 56319) {
    if (n.length <= e + 1) throw "High surrogate without following low surrogate";
    const c = n.charCodeAt(e + 1);
    if (56320 > c || c > 57343) throw "High surrogate without following low surrogate";
    return n.charAt(e) + n.charAt(e + 1);
  }
  if (e === 0) throw "Low surrogate without preceding high surrogate";
  const i = n.charCodeAt(e - 1);
  if (55296 > i || i > 56319) throw "Low surrogate without preceding high surrogate";
  return !1;
};
var f$ = Object.freeze({ __proto__: null, capitalize: function(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  return "".concat(n.charAt(0).toUpperCase()).concat(e ? n.slice(1) : n.slice(1).toLowerCase());
}, escapeXml: y8, graphemeSplit: P2 });
const j2 = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
  return n.fill !== e.fill || n.stroke !== e.stroke || n.strokeWidth !== e.strokeWidth || n.fontSize !== e.fontSize || n.fontFamily !== e.fontFamily || n.fontWeight !== e.fontWeight || n.fontStyle !== e.fontStyle || n.textBackgroundColor !== e.textBackgroundColor || n.deltaY !== e.deltaY || t && (n.overline !== e.overline || n.underline !== e.underline || n.linethrough !== e.linethrough);
}, v8 = (n, e) => {
  const t = e.split(`
`), i = [];
  let c = -1, a = {};
  n = gT(n);
  for (let s = 0; s < t.length; s++) {
    const r = P2(t[s]);
    if (n[s]) for (let l = 0; l < r.length; l++) {
      c++;
      const d = n[s][l];
      d && Object.keys(d).length > 0 && (j2(a, d, !0) ? i.push({ start: c, end: c + 1, style: d }) : i[i.length - 1].end++), a = d || {};
    }
    else c += r.length, a = {};
  }
  return i;
}, b8 = (n, e) => {
  if (!Array.isArray(n)) return gT(n);
  const t = e.split(nT), i = {};
  let c = -1, a = 0;
  for (let s = 0; s < t.length; s++) {
    const r = P2(t[s]);
    for (let l = 0; l < r.length; l++) c++, n[a] && n[a].start <= c && c < n[a].end && (i[s] = i[s] || {}, i[s][l] = lt({}, n[a].style), c === n[a].end - 1 && a++);
  }
  return i;
}, Qh = ["display", "transform", ta, "fill-opacity", "fill-rule", "opacity", Zs, "stroke-dasharray", "stroke-linecap", "stroke-dashoffset", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "id", "paint-order", "vector-effect", "instantiated_by_use", "clip-path"];
function K4(n, e) {
  const t = n.nodeName, i = n.getAttribute("class"), c = n.getAttribute("id"), a = "(?![a-zA-Z\\-]+)";
  let s;
  if (s = new RegExp("^" + t, "i"), e = e.replace(s, ""), c && e.length && (s = new RegExp("#" + c + a, "i"), e = e.replace(s, "")), i && e.length) {
    const r = i.split(" ");
    for (let l = r.length; l--; ) s = new RegExp("\\." + r[l] + a, "i"), e = e.replace(s, "");
  }
  return e.length === 0;
}
function h$(n, e) {
  let t = !0;
  const i = K4(n, e.pop());
  return i && e.length && (t = function(c, a) {
    let s, r = !0;
    for (; c.parentElement && c.parentElement.nodeType === 1 && a.length; ) r && (s = a.pop()), r = K4(c = c.parentElement, s);
    return a.length === 0;
  }(n, e)), i && t && e.length === 0;
}
const p$ = (n) => {
  var e;
  return (e = LW[n]) !== null && e !== void 0 ? e : n;
}, m$ = new RegExp("(".concat(Sm, ")"), "gi"), g$ = (n) => n.replace(m$, " $1 ").replace(/,/gi, " ").replace(/\s+/gi, " ");
var Q4, Z4, J4, eO, tO, nO, rO;
const ms = "(".concat(Sm, ")"), _$ = String.raw(Q4 || (Q4 = Kh(["(skewX)(", ")"], ["(skewX)\\(", "\\)"])), ms), y$ = String.raw(Z4 || (Z4 = Kh(["(skewY)(", ")"], ["(skewY)\\(", "\\)"])), ms), v$ = String.raw(J4 || (J4 = Kh(["(rotate)(", "(?: ", " ", ")?)"], ["(rotate)\\(", "(?: ", " ", ")?\\)"])), ms, ms, ms), b$ = String.raw(eO || (eO = Kh(["(scale)(", "(?: ", ")?)"], ["(scale)\\(", "(?: ", ")?\\)"])), ms, ms), E$ = String.raw(tO || (tO = Kh(["(translate)(", "(?: ", ")?)"], ["(translate)\\(", "(?: ", ")?\\)"])), ms, ms), S$ = String.raw(nO || (nO = Kh(["(matrix)(", " ", " ", " ", " ", " ", ")"], ["(matrix)\\(", " ", " ", " ", " ", " ", "\\)"])), ms, ms, ms, ms, ms, ms), _T = "(?:".concat(S$, "|").concat(E$, "|").concat(v$, "|").concat(b$, "|").concat(_$, "|").concat(y$, ")"), C$ = "(?:".concat(_T, "*)"), w$ = String.raw(rO || (rO = Kh(["^s*(?:", "?)s*$"], ["^\\s*(?:", "?)\\s*$"])), C$), x$ = new RegExp(w$), T$ = new RegExp(_T), A$ = new RegExp(_T, "g");
function ux(n) {
  const e = [];
  if (!(n = g$(n).replace(/\s*([()])\s*/gi, "$1")) || n && !x$.test(n)) return [...gs];
  for (const t of n.matchAll(A$)) {
    const i = T$.exec(t[0]);
    if (!i) continue;
    let c = gs;
    const a = i.filter((_) => !!_), [, s, ...r] = a, [l, d, f, h, p, g] = r.map((_) => parseFloat(_));
    switch (s) {
      case "translate":
        c = m0(l, d);
        break;
      case rT:
        c = g0({ angle: l }, { x: d, y: f });
        break;
      case O2:
        c = R2(l, d);
        break;
      case h0:
        c = aT(l);
        break;
      case p0:
        c = sT(l);
        break;
      case "matrix":
        c = [l, d, f, h, p, g];
    }
    e.push(c);
  }
  return D2(e);
}
function k$(n, e, t, i) {
  const c = Array.isArray(e);
  let a, s = e;
  if (n !== ta && n !== Zs || e !== Qs) {
    if (n === "strokeUniform") return e === "non-scaling-stroke";
    if (n === "strokeDashArray") s = e === Qs ? null : e.replace(/,/g, " ").split(/\s+/).map(parseFloat);
    else if (n === "transformMatrix") s = t && t.transformMatrix ? Io(t.transformMatrix, ux(e)) : ux(e);
    else if (n === "visible") s = e !== Qs && e !== "hidden", t && t.visible === !1 && (s = !1);
    else if (n === "opacity") s = parseFloat(e), t && t.opacity !== void 0 && (s *= t.opacity);
    else if (n === "textAnchor") s = e === "start" ? ti : e === "end" ? yo : pr;
    else if (n === "charSpacing") a = gm(e, i) / i * 1e3;
    else if (n === "paintFirst") {
      const r = e.indexOf(ta), l = e.indexOf(Zs);
      s = ta, (r > -1 && l > -1 && l < r || r === -1 && l > -1) && (s = Zs);
    } else {
      if (n === "href" || n === "xlink:href" || n === "font" || n === "id") return e;
      if (n === "imageSmoothing") return e === "optimizeQuality";
      a = c ? e.map(gm) : gm(e, i);
    }
  } else s = "";
  return !c && isNaN(a) ? s : a;
}
function O$(n, e) {
  const t = n.match(IW);
  if (!t) return;
  const i = t[1], c = t[3], a = t[4], s = t[5], r = t[6];
  i && (e.fontStyle = i), c && (e.fontWeight = isNaN(parseFloat(c)) ? c : parseFloat(c)), a && (e.fontSize = gm(a)), r && (e.fontFamily = r), s && (e.lineHeight = s === "normal" ? 1 : s);
}
function D$(n, e) {
  n.replace(/;\s*$/, "").split(";").forEach((t) => {
    if (!t) return;
    const [i, c] = t.split(":");
    e[i.trim().toLowerCase()] = c.trim();
  });
}
function R$(n) {
  const e = {}, t = n.getAttribute("style");
  return t && (typeof t == "string" ? D$(t, e) : function(i, c) {
    Object.entries(i).forEach((a) => {
      let [s, r] = a;
      r !== void 0 && (c[s.toLowerCase()] = r);
    });
  }(t, e)), e;
}
const N$ = { stroke: "strokeOpacity", fill: "fillOpacity" };
function wf(n, e, t) {
  if (!n) return {};
  let i, c = {}, a = tT;
  n.parentNode && H4.test(n.parentNode.nodeName) && (c = wf(n.parentElement, e, t), c.fontSize && (i = a = gm(c.fontSize)));
  const s = lt(lt(lt({}, e.reduce((d, f) => {
    const h = n.getAttribute(f);
    return h && (d[f] = h), d;
  }, {})), function(d) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = {};
    for (const p in f) h$(d, p.split(" ")) && (h = lt(lt({}, h), f[p]));
    return h;
  }(n, t)), R$(n));
  s[gw] && n.setAttribute(gw, s[gw]), s[mw] && (i = gm(s[mw], a), s[mw] = "".concat(i));
  const r = {};
  for (const d in s) {
    const f = p$(d), h = k$(f, s[d], c, i);
    r[f] = h;
  }
  r && r.font && O$(r.font, r);
  const l = lt(lt({}, c), r);
  return H4.test(n.nodeName) ? l : function(d) {
    const f = es.getDefaults();
    return Object.entries(N$).forEach((h) => {
      let [p, g] = h;
      if (d[g] === void 0 || d[p] === "") return;
      if (d[p] === void 0) {
        if (!f[p]) return;
        d[p] = f[p];
      }
      if (d[p].indexOf("url(") === 0) return;
      const _ = new Wr(d[p]);
      d[p] = _.setAlpha(zi(_.getAlpha() * d[g], 2)).toRgba();
    }), d;
  }(l);
}
const I$ = ["left", "top", "width", "height", "visible"], E8 = ["rx", "ry"];
class Zu extends es {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), Zu.ownDefaults);
  }
  constructor(e) {
    super(), Object.assign(this, Zu.ownDefaults), this.setOptions(e), this._initRxRy();
  }
  _initRxRy() {
    const { rx: e, ry: t } = this;
    e && !t ? this.ry = e : t && !e && (this.rx = t);
  }
  _render(e) {
    const { width: t, height: i } = this, c = -t / 2, a = -i / 2, s = this.rx ? Math.min(this.rx, t / 2) : 0, r = this.ry ? Math.min(this.ry, i / 2) : 0, l = s !== 0 || r !== 0;
    e.beginPath(), e.moveTo(c + s, a), e.lineTo(c + t - s, a), l && e.bezierCurveTo(c + t - Ih * s, a, c + t, a + Ih * r, c + t, a + r), e.lineTo(c + t, a + i - r), l && e.bezierCurveTo(c + t, a + i - Ih * r, c + t - Ih * s, a + i, c + t - s, a + i), e.lineTo(c + s, a + i), l && e.bezierCurveTo(c + Ih * s, a + i, c, a + i - Ih * r, c, a + i - r), e.lineTo(c, a + r), l && e.bezierCurveTo(c, a + Ih * r, c + Ih * s, a, c + s, a), e.closePath(), this._renderPaintInOrder(e);
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject([...E8, ...e]);
  }
  _toSVG() {
    const { width: e, height: t, rx: i, ry: c } = this;
    return ["<rect ", "COMMON_PARTS", 'x="'.concat(-e / 2, '" y="').concat(-t / 2, '" rx="').concat(i, '" ry="').concat(c, '" width="').concat(e, '" height="').concat(t, `" />
`)];
  }
  static async fromElement(e, t, i) {
    const c = wf(e, this.ATTRIBUTE_NAMES, i), { left: a = 0, top: s = 0, width: r = 0, height: l = 0, visible: d = !0 } = c, f = Vi(c, I$);
    return new this(lt(lt(lt({}, t), f), {}, { left: a, top: s, width: r, height: l, visible: !!(d && r && l) }));
  }
}
it(Zu, "type", "Rect"), it(Zu, "cacheProperties", [...Cf, ...E8]), it(Zu, "ownDefaults", { rx: 0, ry: 0 }), it(Zu, "ATTRIBUTE_NAMES", [...Qh, "x", "y", "rx", "ry", "width", "height"]), pn.setClass(Zu), pn.setSVGClass(Zu);
const pf = "initialization", o2 = "added", yT = "removed", a2 = "imperative", S8 = (n, e) => {
  const { strokeUniform: t, strokeWidth: i, width: c, height: a, group: s } = e, r = s && s !== n ? H1(s.calcTransformMatrix(), n.calcTransformMatrix()) : null, l = r ? e.getRelativeCenterPoint().transform(r) : e.getRelativeCenterPoint(), d = !e.isStrokeAccountedForInDimensions(), f = t && d ? J7(new St(i, i), void 0, n.calcTransformMatrix()) : iT, h = !t && d ? i : 0, p = N2(c + h, a + h, D2([r, e.calcOwnMatrix()], !0)).add(f).scalarDivide(2);
  return [l.subtract(p), l.add(p)];
};
class B2 {
  calcLayoutResult(e, t) {
    if (this.shouldPerformLayout(e)) return this.calcBoundingBox(t, e);
  }
  shouldPerformLayout(e) {
    let { type: t, prevStrategy: i, strategy: c } = e;
    return t === pf || t === a2 || !!i && c !== i;
  }
  shouldLayoutClipPath(e) {
    let { type: t, target: { clipPath: i } } = e;
    return t !== pf && i && !i.absolutePositioned;
  }
  getInitialSize(e, t) {
    return t.size;
  }
  calcBoundingBox(e, t) {
    const { type: i, target: c } = t;
    if (i === a2 && t.overrides) return t.overrides;
    if (e.length === 0) return;
    const { left: a, top: s, width: r, height: l } = dd(e.map((h) => S8(c, h)).reduce((h, p) => h.concat(p), [])), d = new St(r, l), f = new St(a, s).add(d.scalarDivide(2));
    if (i === pf) {
      const h = this.getInitialSize(t, { size: d, center: f });
      return { center: f, relativeCorrection: new St(0, 0), size: h };
    }
    return { center: f.transform(c.calcOwnMatrix()), size: d };
  }
}
it(B2, "type", "strategy");
class cx extends B2 {
  shouldPerformLayout(e) {
    return !0;
  }
}
it(cx, "type", "fit-content"), pn.setClass(cx);
const L$ = ["strategy"], M$ = ["target", "strategy", "bubbles", "prevStrategy"], C8 = "layoutManager";
class D1 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new cx();
    it(this, "strategy", void 0), this.strategy = e, this._subscriptions = /* @__PURE__ */ new Map();
  }
  performLayout(e) {
    const t = lt(lt({ bubbles: !0, strategy: this.strategy }, e), {}, { prevStrategy: this._prevLayoutStrategy, stopPropagation() {
      this.bubbles = !1;
    } });
    this.onBeforeLayout(t);
    const i = this.getLayoutResult(t);
    i && this.commitLayout(t, i), this.onAfterLayout(t, i), this._prevLayoutStrategy = t.strategy;
  }
  attachHandlers(e, t) {
    const { target: i } = t;
    return [Zb, L7, T1, M7, k2, P7, Qb, wW, xW].map((c) => e.on(c, (a) => this.performLayout(c === Zb ? { type: "object_modified", trigger: c, e: a, target: i } : { type: "object_modifying", trigger: c, e: a, target: i })));
  }
  subscribe(e, t) {
    this.unsubscribe(e, t);
    const i = this.attachHandlers(e, t);
    this._subscriptions.set(e, i);
  }
  unsubscribe(e, t) {
    (this._subscriptions.get(e) || []).forEach((i) => i()), this._subscriptions.delete(e);
  }
  unsubscribeTargets(e) {
    e.targets.forEach((t) => this.unsubscribe(t, e));
  }
  subscribeTargets(e) {
    e.targets.forEach((t) => this.subscribe(t, e));
  }
  onBeforeLayout(e) {
    const { target: t, type: i } = e, { canvas: c } = t;
    if (i === pf || i === o2 ? this.subscribeTargets(e) : i === yT && this.unsubscribeTargets(e), t.fire("layout:before", { context: e }), c && c.fire("object:layout:before", { target: t, context: e }), i === a2 && e.deep) {
      const a = Vi(e, L$);
      t.forEachObject((s) => s.layoutManager && s.layoutManager.performLayout(lt(lt({}, a), {}, { bubbles: !1, target: s })));
    }
  }
  getLayoutResult(e) {
    const { target: t, strategy: i, type: c } = e, a = i.calcLayoutResult(e, t.getObjects());
    if (!a) return;
    const s = c === pf ? new St() : t.getRelativeCenterPoint(), { center: r, correction: l = new St(), relativeCorrection: d = new St() } = a, f = s.subtract(r).add(l).transform(c === pf ? gs : Cl(t.calcOwnMatrix()), !0).add(d);
    return { result: a, prevCenter: s, nextCenter: r, offset: f };
  }
  commitLayout(e, t) {
    const { target: i } = e, { result: { size: c }, nextCenter: a } = t;
    var s, r;
    i.set({ width: c.x, height: c.y }), this.layoutObjects(e, t), e.type === pf ? i.set({ left: (s = e.x) !== null && s !== void 0 ? s : a.x + c.x * No(i.originX), top: (r = e.y) !== null && r !== void 0 ? r : a.y + c.y * No(i.originY) }) : (i.setPositionByOrigin(a, pr, pr), i.setCoords(), i.set("dirty", !0));
  }
  layoutObjects(e, t) {
    const { target: i } = e;
    i.forEachObject((c) => {
      c.group === i && this.layoutObject(e, t, c);
    }), e.strategy.shouldLayoutClipPath(e) && this.layoutObject(e, t, i.clipPath);
  }
  layoutObject(e, t, i) {
    let { offset: c } = t;
    i.set({ left: i.left + c.x, top: i.top + c.y });
  }
  onAfterLayout(e, t) {
    const { target: i, strategy: c, bubbles: a, prevStrategy: s } = e, r = Vi(e, M$), { canvas: l } = i;
    i.fire("layout:after", { context: e, result: t }), l && l.fire("object:layout:after", { context: e, result: t, target: i });
    const d = i.parent;
    a && d != null && d.layoutManager && ((r.path || (r.path = [])).push(i), d.layoutManager.performLayout(lt(lt({}, r), {}, { target: d }))), i.set("dirty", !0);
  }
  dispose() {
    const { _subscriptions: e } = this;
    e.forEach((t) => t.forEach((i) => i())), e.clear();
  }
  toObject() {
    return { type: C8, strategy: this.strategy.constructor.type };
  }
  toJSON() {
    return this.toObject();
  }
}
pn.setClass(D1, C8);
const P$ = ["type", "objects", "layoutManager"];
class j$ extends D1 {
  performLayout() {
  }
}
class _f extends j7(es) {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), _f.ownDefaults);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), it(this, "_activeObjects", []), it(this, "__objectSelectionTracker", void 0), it(this, "__objectSelectionDisposer", void 0), Object.assign(this, _f.ownDefaults), this.setOptions(t), this.groupInit(e, t);
  }
  groupInit(e, t) {
    var i;
    this._objects = [...e], this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, !0), this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, !1), this.forEachObject((c) => {
      this.enterGroup(c, !1);
    }), this.layoutManager = (i = t.layoutManager) !== null && i !== void 0 ? i : new D1(), this.layoutManager.performLayout({ type: pf, target: this, targets: [...e], x: t.left, y: t.top });
  }
  canEnterGroup(e) {
    return e === this || this.isDescendantOf(e) ? (qh("error", "Group: circular object trees are not supported, this call has no effect"), !1) : this._objects.indexOf(e) === -1 || (qh("error", "Group: duplicate objects are not supported inside group, this call has no effect"), !1);
  }
  _filterObjectsBeforeEnteringGroup(e) {
    return e.filter((t, i, c) => this.canEnterGroup(t) && c.indexOf(t) === i);
  }
  add() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    const c = this._filterObjectsBeforeEnteringGroup(t), a = super.add(...c);
    return this._onAfterObjectsChange(o2, c), a;
  }
  insertAt(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++) i[c - 1] = arguments[c];
    const a = this._filterObjectsBeforeEnteringGroup(i), s = super.insertAt(e, ...a);
    return this._onAfterObjectsChange(o2, a), s;
  }
  remove() {
    const e = super.remove(...arguments);
    return this._onAfterObjectsChange(yT, e), e;
  }
  _onObjectAdded(e) {
    this.enterGroup(e, !0), this.fire("object:added", { target: e }), e.fire("added", { target: this });
  }
  _onObjectRemoved(e, t) {
    this.exitGroup(e, t), this.fire("object:removed", { target: e }), e.fire("removed", { target: this });
  }
  _onAfterObjectsChange(e, t) {
    this.layoutManager.performLayout({ type: e, targets: t, target: this });
  }
  _onStackOrderChanged() {
    this._set("dirty", !0);
  }
  _set(e, t) {
    const i = this[e];
    return super._set(e, t), e === "canvas" && i !== t && (this._objects || []).forEach((c) => {
      c._set(e, t);
    }), this;
  }
  _shouldSetNestedCoords() {
    return this.subTargetCheck;
  }
  removeAll() {
    return this._activeObjects = [], this.remove(...this._objects);
  }
  __objectSelectionMonitor(e, t) {
    let { target: i } = t;
    const c = this._activeObjects;
    if (e) c.push(i), this._set("dirty", !0);
    else if (c.length > 0) {
      const a = c.indexOf(i);
      a > -1 && (c.splice(a, 1), this._set("dirty", !0));
    }
  }
  _watchObject(e, t) {
    e && this._watchObject(!1, t), e ? (t.on("selected", this.__objectSelectionTracker), t.on("deselected", this.__objectSelectionDisposer)) : (t.off("selected", this.__objectSelectionTracker), t.off("deselected", this.__objectSelectionDisposer));
  }
  enterGroup(e, t) {
    e.group && e.group.remove(e), e._set("parent", this), this._enterGroup(e, t);
  }
  _enterGroup(e, t) {
    t && u0(e, Io(Cl(this.calcTransformMatrix()), e.calcTransformMatrix())), this._shouldSetNestedCoords() && e.setCoords(), e._set("group", this), e._set("canvas", this.canvas), this._watchObject(!0, e);
    const i = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
    i && (i === e || e.isDescendantOf(i)) && this._activeObjects.push(e);
  }
  exitGroup(e, t) {
    this._exitGroup(e, t), e._set("parent", void 0), e._set("canvas", void 0);
  }
  _exitGroup(e, t) {
    e._set("group", void 0), t || (u0(e, Io(this.calcTransformMatrix(), e.calcTransformMatrix())), e.setCoords()), this._watchObject(!1, e);
    const i = this._activeObjects.length > 0 ? this._activeObjects.indexOf(e) : -1;
    i > -1 && this._activeObjects.splice(i, 1);
  }
  shouldCache() {
    const e = es.prototype.shouldCache.call(this);
    if (e) {
      for (let t = 0; t < this._objects.length; t++) if (this._objects[t].willDrawShadow()) return this.ownCaching = !1, !1;
    }
    return e;
  }
  willDrawShadow() {
    if (super.willDrawShadow()) return !0;
    for (let e = 0; e < this._objects.length; e++) if (this._objects[e].willDrawShadow()) return !0;
    return !1;
  }
  isOnACache() {
    return this.ownCaching || !!this.parent && this.parent.isOnACache();
  }
  drawObject(e, t, i) {
    this._renderBackground(e);
    for (let a = 0; a < this._objects.length; a++) {
      var c;
      const s = this._objects[a];
      (c = this.canvas) !== null && c !== void 0 && c.preserveObjectStacking && s.group !== this ? (e.save(), e.transform(...Cl(this.calcTransformMatrix())), s.render(e), e.restore()) : s.group === this && s.render(e);
    }
    this._drawClipPath(e, this.clipPath, i);
  }
  setCoords() {
    super.setCoords(), this._shouldSetNestedCoords() && this.forEachObject((e) => e.setCoords());
  }
  triggerLayout() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.layoutManager.performLayout(lt({ target: this, type: a2 }, e));
  }
  render(e) {
    this._transformDone = !0, super.render(e), this._transformDone = !1;
  }
  __serializeObjects(e, t) {
    const i = this.includeDefaultValues;
    return this._objects.filter(function(c) {
      return !c.excludeFromExport;
    }).map(function(c) {
      const a = c.includeDefaultValues;
      c.includeDefaultValues = i;
      const s = c[e || "toObject"](t);
      return c.includeDefaultValues = a, s;
    });
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const t = this.layoutManager.toObject();
    return lt(lt(lt({}, super.toObject(["subTargetCheck", "interactive", ...e])), t.strategy !== "fit-content" || this.includeDefaultValues ? { layoutManager: t } : {}), {}, { objects: this.__serializeObjects("toObject", e) });
  }
  toString() {
    return "#<Group: (".concat(this.complexity(), ")>");
  }
  dispose() {
    this.layoutManager.unsubscribeTargets({ targets: this.getObjects(), target: this }), this._activeObjects = [], this.forEachObject((e) => {
      this._watchObject(!1, e), e.dispose();
    }), super.dispose();
  }
  _createSVGBgRect(e) {
    if (!this.backgroundColor) return "";
    const t = Zu.prototype._toSVG.call(this), i = t.indexOf("COMMON_PARTS");
    t[i] = 'for="group" ';
    const c = t.join("");
    return e ? e(c) : c;
  }
  _toSVG(e) {
    const t = ["<g ", "COMMON_PARTS", ` >
`], i = this._createSVGBgRect(e);
    i && t.push("		", i);
    for (let c = 0; c < this._objects.length; c++) t.push("		", this._objects[c].toSVG(e));
    return t.push(`</g>
`), t;
  }
  getSvgStyles() {
    const e = this.opacity !== void 0 && this.opacity !== 1 ? "opacity: ".concat(this.opacity, ";") : "", t = this.visible ? "" : " visibility: hidden;";
    return [e, this.getSvgFilter(), t].join("");
  }
  toClipPathSVG(e) {
    const t = [], i = this._createSVGBgRect(e);
    i && t.push("	", i);
    for (let c = 0; c < this._objects.length; c++) t.push("	", this._objects[c].toClipPathSVG(e));
    return this._createBaseClipPathSVGMarkup(t, { reviver: e });
  }
  static fromObject(e, t) {
    let { type: i, objects: c = [], layoutManager: a } = e, s = Vi(e, P$);
    return Promise.all([l0(c, t), F1(s, t)]).then((r) => {
      let [l, d] = r;
      const f = new this(l, lt(lt(lt({}, s), d), {}, { layoutManager: new j$() }));
      if (a) {
        const h = pn.getClass(a.type), p = pn.getClass(a.strategy);
        f.layoutManager = new h(new p());
      } else f.layoutManager = new D1();
      return f.layoutManager.subscribeTargets({ type: pf, target: f, targets: f.getObjects() }), f.setCoords(), f;
    });
  }
}
it(_f, "type", "Group"), it(_f, "ownDefaults", { strokeWidth: 0, subTargetCheck: !1, interactive: !1 }), pn.setClass(_f);
const w8 = (n, e) => Math.min(e.width / n.width, e.height / n.height), x8 = (n, e) => Math.max(e.width / n.width, e.height / n.height), dx = "\\s*,?\\s*", X_ = "".concat(dx, "(").concat(Sm, ")"), B$ = "".concat(X_).concat(X_).concat(X_).concat(dx, "([01])").concat(dx, "([01])").concat(X_).concat(X_), F$ = { m: "l", M: "L" }, U$ = (n, e, t, i, c, a, s, r, l, d, f) => {
  const h = ic(n), p = oc(n), g = ic(e), _ = oc(e), b = t * c * g - i * a * _ + s, v = i * c * g + t * a * _ + r;
  return ["C", d + l * (-t * c * p - i * a * h), f + l * (-i * c * p + t * a * h), b + l * (t * c * _ + i * a * g), v + l * (i * c * _ - t * a * g), b, v];
}, iO = (n, e, t, i) => {
  const c = Math.atan2(e, n), a = Math.atan2(i, t);
  return a >= c ? a - c : 2 * Math.PI - (c - a);
};
function fx(n, e, t, i, c, a, s, r) {
  let l;
  if (Br.cachesBoundsOfCurve && (l = [...arguments].join(), h1.boundsOfCurveCache[l])) return h1.boundsOfCurveCache[l];
  const d = Math.sqrt, f = Math.abs, h = [], p = [[0, 0], [0, 0]];
  let g = 6 * n - 12 * t + 6 * c, _ = -3 * n + 9 * t - 9 * c + 3 * s, b = 3 * t - 3 * n;
  for (let T = 0; T < 2; ++T) {
    if (T > 0 && (g = 6 * e - 12 * i + 6 * a, _ = -3 * e + 9 * i - 9 * a + 3 * r, b = 3 * i - 3 * e), f(_) < 1e-12) {
      if (f(g) < 1e-12) continue;
      const I = -b / g;
      0 < I && I < 1 && h.push(I);
      continue;
    }
    const A = g * g - 4 * b * _;
    if (A < 0) continue;
    const k = d(A), N = (-g + k) / (2 * _);
    0 < N && N < 1 && h.push(N);
    const j = (-g - k) / (2 * _);
    0 < j && j < 1 && h.push(j);
  }
  let v = h.length;
  const E = v, C = A8(n, e, t, i, c, a, s, r);
  for (; v--; ) {
    const { x: T, y: A } = C(h[v]);
    p[0][v] = T, p[1][v] = A;
  }
  p[0][E] = n, p[1][E] = e, p[0][E + 1] = s, p[1][E + 1] = r;
  const y = [new St(Math.min(...p[0]), Math.min(...p[1])), new St(Math.max(...p[0]), Math.max(...p[1]))];
  return Br.cachesBoundsOfCurve && (h1.boundsOfCurveCache[l] = y), y;
}
const H$ = (n, e, t) => {
  let [i, c, a, s, r, l, d, f] = t;
  const h = ((p, g, _, b, v, E, C) => {
    if (_ === 0 || b === 0) return [];
    let y = 0, T = 0, A = 0;
    const k = Math.PI, N = C * eT, j = oc(N), I = ic(N), B = 0.5 * (-I * p - j * g), U = 0.5 * (-I * g + j * p), H = _ ** 2, Q = b ** 2, Y = U ** 2, ie = B ** 2, ce = H * Q - H * Y - Q * ie;
    let $ = Math.abs(_), te = Math.abs(b);
    if (ce < 0) {
      const _e = Math.sqrt(1 - ce / (H * Q));
      $ *= _e, te *= _e;
    } else A = (v === E ? -1 : 1) * Math.sqrt(ce / (H * Y + Q * ie));
    const V = A * $ * U / te, K = -A * te * B / $, ne = I * V - j * K + 0.5 * p, J = j * V + I * K + 0.5 * g;
    let L = iO(1, 0, (B - V) / $, (U - K) / te), z = iO((B - V) / $, (U - K) / te, (-B - V) / $, (-U - K) / te);
    E === 0 && z > 0 ? z -= 2 * k : E === 1 && z < 0 && (z += 2 * k);
    const ee = Math.ceil(Math.abs(z / k * 2)), q = [], X = z / ee, oe = 8 / 3 * Math.sin(X / 4) * Math.sin(X / 4) / Math.sin(X / 2);
    let ae = L + X;
    for (let _e = 0; _e < ee; _e++) q[_e] = U$(L, ae, I, j, $, te, ne, J, oe, y, T), y = q[_e][5], T = q[_e][6], L = ae, ae += X;
    return q;
  })(d - n, f - e, c, a, r, l, s);
  for (let p = 0, g = h.length; p < g; p++) h[p][1] += n, h[p][2] += e, h[p][3] += n, h[p][4] += e, h[p][5] += n, h[p][6] += e;
  return h;
}, T8 = (n) => {
  let e = 0, t = 0, i = 0, c = 0;
  const a = [];
  let s, r = 0, l = 0;
  for (const d of n) {
    const f = [...d];
    let h;
    switch (f[0]) {
      case "l":
        f[1] += e, f[2] += t;
      case "L":
        e = f[1], t = f[2], h = ["L", e, t];
        break;
      case "h":
        f[1] += e;
      case "H":
        e = f[1], h = ["L", e, t];
        break;
      case "v":
        f[1] += t;
      case "V":
        t = f[1], h = ["L", e, t];
        break;
      case "m":
        f[1] += e, f[2] += t;
      case "M":
        e = f[1], t = f[2], i = f[1], c = f[2], h = ["M", e, t];
        break;
      case "c":
        f[1] += e, f[2] += t, f[3] += e, f[4] += t, f[5] += e, f[6] += t;
      case "C":
        r = f[3], l = f[4], e = f[5], t = f[6], h = ["C", f[1], f[2], r, l, e, t];
        break;
      case "s":
        f[1] += e, f[2] += t, f[3] += e, f[4] += t;
      case "S":
        s === "C" ? (r = 2 * e - r, l = 2 * t - l) : (r = e, l = t), e = f[3], t = f[4], h = ["C", r, l, f[1], f[2], e, t], r = h[3], l = h[4];
        break;
      case "q":
        f[1] += e, f[2] += t, f[3] += e, f[4] += t;
      case "Q":
        r = f[1], l = f[2], e = f[3], t = f[4], h = ["Q", r, l, e, t];
        break;
      case "t":
        f[1] += e, f[2] += t;
      case "T":
        s === "Q" ? (r = 2 * e - r, l = 2 * t - l) : (r = e, l = t), e = f[1], t = f[2], h = ["Q", r, l, e, t];
        break;
      case "a":
        f[6] += e, f[7] += t;
      case "A":
        H$(e, t, f).forEach((p) => a.push(p)), e = f[6], t = f[7];
        break;
      case "z":
      case "Z":
        e = i, t = c, h = ["Z"];
    }
    h ? (a.push(h), s = h[0]) : s = "";
  }
  return a;
}, s2 = (n, e, t, i) => Math.sqrt((t - n) ** 2 + (i - e) ** 2), A8 = (n, e, t, i, c, a, s, r) => (l) => {
  const d = l ** 3, f = ((g) => 3 * g ** 2 * (1 - g))(l), h = ((g) => 3 * g * (1 - g) ** 2)(l), p = ((g) => (1 - g) ** 3)(l);
  return new St(s * d + c * f + t * h + n * p, r * d + a * f + i * h + e * p);
}, k8 = (n) => n ** 2, O8 = (n) => 2 * n * (1 - n), D8 = (n) => (1 - n) ** 2, z$ = (n, e, t, i, c, a, s, r) => (l) => {
  const d = k8(l), f = O8(l), h = D8(l), p = 3 * (h * (t - n) + f * (c - t) + d * (s - c)), g = 3 * (h * (i - e) + f * (a - i) + d * (r - a));
  return Math.atan2(g, p);
}, V$ = (n, e, t, i, c, a) => (s) => {
  const r = k8(s), l = O8(s), d = D8(s);
  return new St(c * r + t * l + n * d, a * r + i * l + e * d);
}, q$ = (n, e, t, i, c, a) => (s) => {
  const r = 1 - s, l = 2 * (r * (t - n) + s * (c - t)), d = 2 * (r * (i - e) + s * (a - i));
  return Math.atan2(d, l);
}, oO = (n, e, t) => {
  let i = new St(e, t), c = 0;
  for (let a = 1; a <= 100; a += 1) {
    const s = n(a / 100);
    c += s2(i.x, i.y, s.x, s.y), i = s;
  }
  return c;
}, G$ = (n, e) => {
  let t, i = 0, c = 0, a = { x: n.x, y: n.y }, s = lt({}, a), r = 0.01, l = 0;
  const d = n.iterator, f = n.angleFinder;
  for (; c < e && r > 1e-4; ) s = d(i), l = i, t = s2(a.x, a.y, s.x, s.y), t + c > e ? (i -= r, r /= 2) : (a = s, i += r, c += t);
  return lt(lt({}, s), {}, { angle: f(l) });
}, vT = (n) => {
  let e, t, i = 0, c = 0, a = 0, s = 0, r = 0;
  const l = [];
  for (const d of n) {
    const f = { x: c, y: a, command: d[0], length: 0 };
    switch (d[0]) {
      case "M":
        t = f, t.x = s = c = d[1], t.y = r = a = d[2];
        break;
      case "L":
        t = f, t.length = s2(c, a, d[1], d[2]), c = d[1], a = d[2];
        break;
      case "C":
        e = A8(c, a, d[1], d[2], d[3], d[4], d[5], d[6]), t = f, t.iterator = e, t.angleFinder = z$(c, a, d[1], d[2], d[3], d[4], d[5], d[6]), t.length = oO(e, c, a), c = d[5], a = d[6];
        break;
      case "Q":
        e = V$(c, a, d[1], d[2], d[3], d[4]), t = f, t.iterator = e, t.angleFinder = q$(c, a, d[1], d[2], d[3], d[4]), t.length = oO(e, c, a), c = d[3], a = d[4];
        break;
      case "Z":
        t = f, t.destX = s, t.destY = r, t.length = s2(c, a, s, r), c = s, a = r;
    }
    i += t.length, l.push(t);
  }
  return l.push({ length: i, x: c, y: a }), l;
}, R8 = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vT(n), i = 0;
  for (; e - t[i].length > 0 && i < t.length - 2; ) e -= t[i].length, i++;
  const c = t[i], a = e / c.length, s = n[i];
  switch (c.command) {
    case "M":
      return { x: c.x, y: c.y, angle: 0 };
    case "Z":
      return lt(lt({}, new St(c.x, c.y).lerp(new St(c.destX, c.destY), a)), {}, { angle: Math.atan2(c.destY - c.y, c.destX - c.x) });
    case "L":
      return lt(lt({}, new St(c.x, c.y).lerp(new St(s[1], s[2]), a)), {}, { angle: Math.atan2(s[2] - c.y, s[1] - c.x) });
    case "C":
    case "Q":
      return G$(c, e);
  }
}, W$ = new RegExp("[mzlhvcsqta][^mzlhvcsqta]*", "gi"), aO = new RegExp(B$, "g"), $$ = new RegExp(Sm, "gi"), Y$ = { m: 2, l: 2, h: 1, v: 1, c: 6, s: 4, q: 4, t: 2, a: 7 }, N8 = (n) => {
  var e;
  const t = [], i = (e = n.match(W$)) !== null && e !== void 0 ? e : [];
  for (const c of i) {
    const a = c[0];
    if (a === "z" || a === "Z") {
      t.push([a]);
      continue;
    }
    const s = Y$[a.toLowerCase()];
    let r = [];
    if (a === "a" || a === "A") {
      aO.lastIndex = 0;
      for (let l = null; l = aO.exec(c); ) r.push(...l.slice(1));
    } else r = c.match($$) || [];
    for (let l = 0; l < r.length; l += s) {
      const d = new Array(s), f = F$[a];
      d[0] = l > 0 && f ? f : a;
      for (let h = 0; h < s; h++) d[h + 1] = parseFloat(r[l + h]);
      t.push(d);
    }
  }
  return t;
}, X$ = function(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = new St(n[0]), i = new St(n[1]), c = 1, a = 0;
  const s = [], r = n.length, l = r > 2;
  let d;
  for (l && (c = n[2].x < i.x ? -1 : n[2].x === i.x ? 0 : 1, a = n[2].y < i.y ? -1 : n[2].y === i.y ? 0 : 1), s.push(["M", t.x - c * e, t.y - a * e]), d = 1; d < r; d++) {
    if (!t.eq(i)) {
      const f = t.midPointFrom(i);
      s.push(["Q", t.x, t.y, f.x, f.y]);
    }
    t = n[d], d + 1 < n.length && (i = n[d + 1]);
  }
  return l && (c = t.x > n[d - 2].x ? 1 : t.x === n[d - 2].x ? 0 : -1, a = t.y > n[d - 2].y ? 1 : t.y === n[d - 2].y ? 0 : -1), s.push(["L", t.x + c * e, t.y + a * e]), s;
}, I8 = (n, e) => n.map((t) => t.map((i, c) => c === 0 || e === void 0 ? i : zi(i, e)).join(" ")).join(" ");
function l2(n, e) {
  const t = n.style;
  t && e && (typeof e == "string" ? t.cssText += ";" + e : Object.entries(e).forEach((i) => {
    let [c, a] = i;
    return t.setProperty(c, a);
  }));
}
const K$ = (n, e) => Math.floor(Math.random() * (e - n + 1)) + n;
function Q$(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const t = e.onComplete || mm, i = new (A2()).XMLHttpRequest(), c = e.signal, a = function() {
    i.abort();
  }, s = function() {
    c && c.removeEventListener("abort", a), i.onerror = i.ontimeout = mm;
  };
  if (c && c.aborted) throw new N7("request");
  return c && c.addEventListener("abort", a, { once: !0 }), i.onreadystatechange = function() {
    i.readyState === 4 && (s(), t(i), i.onreadystatechange = mm);
  }, i.onerror = i.ontimeout = s, i.open("get", n, !0), i.send(), i;
}
const Z$ = (n, e) => {
  let t = n._findCenterFromElement();
  n.transformMatrix && (((i) => {
    if (i.transformMatrix) {
      const { scaleX: c, scaleY: a, angle: s, skewX: r } = s0(i.transformMatrix);
      i.flipX = !1, i.flipY = !1, i.set(_s, c), i.set(xl, a), i.angle = s, i.skewX = r, i.skewY = 0;
    }
  })(n), t = t.transform(n.transformMatrix)), delete n.transformMatrix, e && (n.scaleX *= e.scaleX, n.scaleY *= e.scaleY, n.cropX = e.cropX, n.cropY = e.cropY, t.x += e.offsetLeft, t.y += e.offsetTop, n.width = e.width, n.height = e.height), n.setPositionByOrigin(t, pr, pr);
};
var rb = Object.freeze({ __proto__: null, addTransformToObject: Q7, animate: pT, animateColor: u8, applyTransformToObject: u0, calcAngleBetweenVectors: i2, calcDimensionsMatrix: B1, calcPlaneChangeMatrix: H1, calcVectorRotation: a8, cancelAnimFrame: F7, capValue: Cm, composeMatrix: q7, copyCanvasElement: (n) => {
  var e;
  const t = ac(n);
  return (e = t.getContext("2d")) === null || e === void 0 || e.drawImage(n, 0, 0), t;
}, cos: ic, createCanvasElement: lu, createImage: U7, createRotateMatrix: g0, createScaleMatrix: R2, createSkewXMatrix: aT, createSkewYMatrix: sT, createTranslateMatrix: m0, createVector: n2, crossProduct: e0, degreesToRadians: oo, dotProduct: s8, ease: BW, enlivenObjectEnlivables: F1, enlivenObjects: l0, findScaleToCover: x8, findScaleToFit: w8, getBoundsOfCurve: fx, getOrthonormalVector: fT, getPathSegmentsInfo: vT, getPointOnPath: R8, getPointer: K7, getRandomInt: K$, getRegularPolygonPath: (n, e) => {
  const t = 2 * Math.PI / n;
  let i = -Gh;
  n % 2 == 0 && (i += t / 2);
  const c = new Array(n + 1);
  for (let a = 0; a < n; a++) {
    const s = a * t + i, { x: r, y: l } = new St(ic(s), oc(s)).scalarMultiply(e);
    c[a] = [a === 0 ? "M" : "L", r, l];
  }
  return c[n] = ["Z"], c;
}, getSmoothPathFromPoints: X$, getSvgAttributes: (n) => {
  const e = ["instantiated_by_use", "style", "id", "class"];
  switch (n) {
    case "linearGradient":
      return e.concat(["x1", "y1", "x2", "y2", "gradientUnits", "gradientTransform"]);
    case "radialGradient":
      return e.concat(["gradientUnits", "gradientTransform", "cx", "cy", "r", "fx", "fy", "fr"]);
    case "stop":
      return e.concat(["offset", "stop-color", "stop-opacity"]);
  }
  return e;
}, getUnitVector: L2, groupSVGElements: (n, e) => n && n.length === 1 ? n[0] : new _f(n, e), hasStyleChanged: j2, invertTransform: Cl, isBetweenVectors: sx, isIdentityMatrix: H7, isTouchEvent: e2, isTransparent: m8, joinPath: I8, loadImage: m1, magnitude: r2, makeBoundingBoxFromPoints: dd, makePathSimpler: T8, matrixToSVG: A1, mergeClipPaths: (n, e) => {
  var t;
  let i = n, c = e;
  i.inverted && !c.inverted && (i = e, c = n), ax(c, (t = c.group) === null || t === void 0 ? void 0 : t.calcTransformMatrix(), i.calcTransformMatrix());
  const a = i.inverted && c.inverted;
  return a && (i.inverted = c.inverted = !1), new _f([i], { clipPath: c, inverted: a });
}, multiplyTransformMatrices: Io, multiplyTransformMatrixArray: D2, parsePath: N8, parsePreserveAspectRatioAttribute: G7, parseUnit: gm, pick: Rm, projectStrokeOnPoints: _8, qrDecompose: s0, radiansToDegrees: $h, removeFromArray: am, removeTransformFromObject: (n, e) => {
  const t = Cl(e), i = Io(t, n.calcOwnMatrix());
  u0(n, i);
}, removeTransformMatrixForSvgParsing: Z$, request: Q$, requestAnimFrame: p1, resetObjectTransform: Z7, rotatePoint: (n, e, t) => n.rotate(t, e), rotateVector: dT, saveObjectTransform: uT, sendObjectToPlane: ax, sendPointToPlane: _m, sendVectorToPlane: J7, setStyle: l2, sin: oc, sizeAfterTransform: N2, string: f$, stylesFromArray: b8, stylesToArray: v8, toDataURL: oT, toFixed: zi, transformPath: (n, e, t) => (t && (e = Io(e, [1, 0, 0, 1, -t.x, -t.y])), n.map((i) => {
  const c = [...i];
  for (let a = 1; a < i.length - 1; a += 2) {
    const { x: s, y: r } = Ja({ x: i[a], y: i[a + 1] }, e);
    c[a] = s, c[a + 1] = r;
  }
  return c;
})), transformPoint: Ja });
class J$ extends X7 {
  constructor(e) {
    let { allowTouchScrolling: t = !1, containerClass: i = "" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(e), it(this, "upper", void 0), it(this, "container", void 0);
    const { el: c } = this.lower, a = this.createUpperCanvas();
    this.upper = { el: a, ctx: a.getContext("2d") }, this.applyCanvasStyle(c, { allowTouchScrolling: t }), this.applyCanvasStyle(a, { allowTouchScrolling: t, styles: { position: "absolute", left: "0", top: "0" } });
    const s = this.createContainerElement();
    s.classList.add(i), c.parentNode && c.parentNode.replaceChild(s, c), s.append(c, a), this.container = s;
  }
  createUpperCanvas() {
    const { el: e } = this.lower, t = lu();
    return t.className = e.className, t.classList.remove("lower-canvas"), t.classList.add("upper-canvas"), t.setAttribute("data-fabric", "top"), t.style.cssText = e.style.cssText, t.setAttribute("draggable", "true"), t;
  }
  createContainerElement() {
    const e = f0().createElement("div");
    return e.setAttribute("data-fabric", "wrapper"), l2(e, { position: "relative" }), B4(e), e;
  }
  applyCanvasStyle(e, t) {
    const { styles: i, allowTouchScrolling: c } = t;
    l2(e, lt(lt({}, i), {}, { "touch-action": c ? "manipulation" : Qs })), B4(e);
  }
  setDimensions(e, t) {
    super.setDimensions(e, t);
    const { el: i, ctx: c } = this.upper;
    Y7(i, c, e, t);
  }
  setCSSDimensions(e) {
    super.setCSSDimensions(e), ix(this.upper.el, e), ix(this.container, e);
  }
  cleanupDOM(e) {
    const t = this.container, { el: i } = this.lower, { el: c } = this.upper;
    super.cleanupDOM(e), t.removeChild(c), t.removeChild(i), t.parentNode && t.parentNode.replaceChild(i, t);
  }
  dispose() {
    super.dispose(), fd().dispose(this.upper.el), delete this.upper, delete this.container;
  }
}
class F2 extends U1 {
  constructor() {
    super(...arguments), it(this, "targets", []), it(this, "_hoveredTargets", []), it(this, "_objectsToRender", void 0), it(this, "_currentTransform", null), it(this, "_groupSelector", null), it(this, "contextTopDirty", !1);
  }
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), F2.ownDefaults);
  }
  get upperCanvasEl() {
    var e;
    return (e = this.elements.upper) === null || e === void 0 ? void 0 : e.el;
  }
  get contextTop() {
    var e;
    return (e = this.elements.upper) === null || e === void 0 ? void 0 : e.ctx;
  }
  get wrapperEl() {
    return this.elements.container;
  }
  initElements(e) {
    this.elements = new J$(e, { allowTouchScrolling: this.allowTouchScrolling, containerClass: this.containerClass }), this._createCacheCanvas();
  }
  _onObjectAdded(e) {
    this._objectsToRender = void 0, super._onObjectAdded(e);
  }
  _onObjectRemoved(e) {
    this._objectsToRender = void 0, e === this._activeObject && (this.fire("before:selection:cleared", { deselected: [e] }), this._discardActiveObject(), this.fire("selection:cleared", { deselected: [e] }), e.fire("deselected", { target: e })), e === this._hoveredTarget && (this._hoveredTarget = void 0, this._hoveredTargets = []), super._onObjectRemoved(e);
  }
  _onStackOrderChanged() {
    this._objectsToRender = void 0, super._onStackOrderChanged();
  }
  _chooseObjectsToRender() {
    const e = this._activeObject;
    return !this.preserveObjectStacking && e ? this._objects.filter((t) => !t.group && t !== e).concat(e) : this._objects;
  }
  renderAll() {
    this.cancelRequestedRender(), this.destroyed || (!this.contextTopDirty || this._groupSelector || this.isDrawingMode || (this.clearContext(this.contextTop), this.contextTopDirty = !1), this.hasLostContext && (this.renderTopLayer(this.contextTop), this.hasLostContext = !1), !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender()), this.renderCanvas(this.getContext(), this._objectsToRender));
  }
  renderTopLayer(e) {
    e.save(), this.isDrawingMode && this._isCurrentlyDrawing && (this.freeDrawingBrush && this.freeDrawingBrush._render(), this.contextTopDirty = !0), this.selection && this._groupSelector && (this._drawSelection(e), this.contextTopDirty = !0), e.restore();
  }
  renderTop() {
    const e = this.contextTop;
    this.clearContext(e), this.renderTopLayer(e), this.fire("after:render", { ctx: e });
  }
  setTargetFindTolerance(e) {
    e = Math.round(e), this.targetFindTolerance = e;
    const t = this.getRetinaScaling(), i = Math.ceil((2 * e + 1) * t);
    this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = i, this.pixelFindContext.scale(t, t);
  }
  isTargetTransparent(e, t, i) {
    const c = this.targetFindTolerance, a = this.pixelFindContext;
    this.clearContext(a), a.save(), a.translate(-t + c, -i + c), a.transform(...this.viewportTransform);
    const s = e.selectionBackgroundColor;
    e.selectionBackgroundColor = "", e.render(a), e.selectionBackgroundColor = s, a.restore();
    const r = Math.round(c * this.getRetinaScaling());
    return m8(a, r, r, r);
  }
  _isSelectionKeyPressed(e) {
    const t = this.selectionKey;
    return !!t && (Array.isArray(t) ? !!t.find((i) => !!i && e[i] === !0) : e[t]);
  }
  _shouldClearSelection(e, t) {
    const i = this.getActiveObjects(), c = this._activeObject;
    return !!(!t || t && c && i.length > 1 && i.indexOf(t) === -1 && c !== t && !this._isSelectionKeyPressed(e) || t && !t.evented || t && !t.selectable && c && c !== t);
  }
  _shouldCenterTransform(e, t, i) {
    if (!e) return;
    let c;
    return t === O2 || t === _s || t === xl || t === T1 ? c = this.centeredScaling || e.centeredScaling : t === rT && (c = this.centeredRotation || e.centeredRotation), c ? !i : i;
  }
  _getOriginFromCorner(e, t) {
    const i = { x: e.originX, y: e.originY };
    return t && (["ml", "tl", "bl"].includes(t) ? i.x = yo : ["mr", "tr", "br"].includes(t) && (i.x = ti), ["tl", "mt", "tr"].includes(t) ? i.y = rx : ["bl", "mb", "br"].includes(t) && (i.y = Ks)), i;
  }
  _setupCurrentTransform(e, t, i) {
    var c;
    const a = t.group ? _m(this.getScenePoint(e), void 0, t.group.calcTransformMatrix()) : this.getScenePoint(e), { key: s = "", control: r } = t.getActiveControl() || {}, l = i && r ? (c = r.getActionHandler(e, t, r)) === null || c === void 0 ? void 0 : c.bind(r) : NW, d = ((g, _, b, v) => {
      if (!_ || !g) return "drag";
      const E = v.controls[_];
      return E.getActionName(b, E, v);
    })(i, s, e, t), f = e[this.centeredKey], h = this._shouldCenterTransform(t, d, f) ? { x: pr, y: pr } : this._getOriginFromCorner(t, s), p = { target: t, action: d, actionHandler: l, actionPerformed: !1, corner: s, scaleX: t.scaleX, scaleY: t.scaleY, skewX: t.skewX, skewY: t.skewY, offsetX: a.x - t.left, offsetY: a.y - t.top, originX: h.x, originY: h.y, ex: a.x, ey: a.y, lastX: a.x, lastY: a.y, theta: oo(t.angle), width: t.width, height: t.height, shiftKey: e.shiftKey, altKey: f, original: lt(lt({}, uT(t)), {}, { originX: h.x, originY: h.y }) };
    this._currentTransform = p, this.fire("before:transform", { e, transform: p });
  }
  setCursor(e) {
    this.upperCanvasEl.style.cursor = e;
  }
  _drawSelection(e) {
    const { x: t, y: i, deltaX: c, deltaY: a } = this._groupSelector, s = new St(t, i).transform(this.viewportTransform), r = new St(t + c, i + a).transform(this.viewportTransform), l = this.selectionLineWidth / 2;
    let d = Math.min(s.x, r.x), f = Math.min(s.y, r.y), h = Math.max(s.x, r.x), p = Math.max(s.y, r.y);
    this.selectionColor && (e.fillStyle = this.selectionColor, e.fillRect(d, f, h - d, p - f)), this.selectionLineWidth && this.selectionBorderColor && (e.lineWidth = this.selectionLineWidth, e.strokeStyle = this.selectionBorderColor, d += l, f += l, h -= l, p -= l, es.prototype._setLineDash.call(this, e, this.selectionDashArray), e.strokeRect(d, f, h - d, p - f));
  }
  findTarget(e) {
    if (this.skipTargetFind) return;
    const t = this.getViewportPoint(e), i = this._activeObject, c = this.getActiveObjects();
    if (this.targets = [], i && c.length >= 1) {
      if (i.findControl(t, e2(e)) || c.length > 1 && this.searchPossibleTargets([i], t)) return i;
      if (i === this.searchPossibleTargets([i], t)) {
        if (this.preserveObjectStacking) {
          const a = this.targets;
          this.targets = [];
          const s = this.searchPossibleTargets(this._objects, t);
          return e[this.altSelectionKey] && s && s !== i ? (this.targets = a, i) : s;
        }
        return i;
      }
    }
    return this.searchPossibleTargets(this._objects, t);
  }
  _pointIsInObjectSelectionArea(e, t) {
    let i = e.getCoords();
    const c = this.getZoom(), a = e.padding / c;
    if (a) {
      const [s, r, l, d] = i, f = Math.atan2(r.y - s.y, r.x - s.x), h = ic(f) * a, p = oc(f) * a, g = h + p, _ = h - p;
      i = [new St(s.x - _, s.y - g), new St(r.x + g, r.y - _), new St(l.x + _, l.y + g), new St(d.x - g, d.y + _)];
    }
    return Qi.isPointInPolygon(t, i);
  }
  _checkTarget(e, t) {
    return !!(e && e.visible && e.evented && this._pointIsInObjectSelectionArea(e, _m(t, void 0, this.viewportTransform)) && (!this.perPixelTargetFind && !e.perPixelTargetFind || e.isEditing || !this.isTargetTransparent(e, t.x, t.y)));
  }
  _searchPossibleTargets(e, t) {
    let i = e.length;
    for (; i--; ) {
      const c = e[i];
      if (this._checkTarget(c, t)) {
        if (Mb(c) && c.subTargetCheck) {
          const a = this._searchPossibleTargets(c._objects, t);
          a && this.targets.push(a);
        }
        return c;
      }
    }
  }
  searchPossibleTargets(e, t) {
    const i = this._searchPossibleTargets(e, t);
    if (i && Mb(i) && i.interactive && this.targets[0]) {
      const c = this.targets;
      for (let a = c.length - 1; a > 0; a--) {
        const s = c[a];
        if (!Mb(s) || !s.interactive) return s;
      }
      return c[0];
    }
    return i;
  }
  getViewportPoint(e) {
    return this._pointer ? this._pointer : this.getPointer(e, !0);
  }
  getScenePoint(e) {
    return this._absolutePointer ? this._absolutePointer : this.getPointer(e);
  }
  getPointer(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    const i = this.upperCanvasEl, c = i.getBoundingClientRect();
    let a = K7(e), s = c.width || 0, r = c.height || 0;
    s && r || (Ks in c && rx in c && (r = Math.abs(c.top - c.bottom)), yo in c && ti in c && (s = Math.abs(c.right - c.left))), this.calcOffset(), a.x = a.x - this._offset.left, a.y = a.y - this._offset.top, t || (a = _m(a, void 0, this.viewportTransform));
    const l = this.getRetinaScaling();
    l !== 1 && (a.x /= l, a.y /= l);
    const d = s === 0 || r === 0 ? new St(1, 1) : new St(i.width / s, i.height / r);
    return a.multiply(d);
  }
  _setDimensionsImpl(e, t) {
    this._resetTransformEventData(), super._setDimensionsImpl(e, t), this._isCurrentlyDrawing && this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
  }
  _createCacheCanvas() {
    this.pixelFindCanvasEl = lu(), this.pixelFindContext = this.pixelFindCanvasEl.getContext("2d", { willReadFrequently: !0 }), this.setTargetFindTolerance(this.targetFindTolerance);
  }
  getTopContext() {
    return this.elements.upper.ctx;
  }
  getSelectionContext() {
    return this.elements.upper.ctx;
  }
  getSelectionElement() {
    return this.elements.upper.el;
  }
  getActiveObject() {
    return this._activeObject;
  }
  getActiveObjects() {
    const e = this._activeObject;
    return sm(e) ? e.getObjects() : e ? [e] : [];
  }
  _fireSelectionEvents(e, t) {
    let i = !1, c = !1;
    const a = this.getActiveObjects(), s = [], r = [];
    e.forEach((l) => {
      a.includes(l) || (i = !0, l.fire("deselected", { e: t, target: l }), r.push(l));
    }), a.forEach((l) => {
      e.includes(l) || (i = !0, l.fire("selected", { e: t, target: l }), s.push(l));
    }), e.length > 0 && a.length > 0 ? (c = !0, i && this.fire("selection:updated", { e: t, selected: s, deselected: r })) : a.length > 0 ? (c = !0, this.fire("selection:created", { e: t, selected: s })) : e.length > 0 && (c = !0, this.fire("selection:cleared", { e: t, deselected: r })), c && (this._objectsToRender = void 0);
  }
  setActiveObject(e, t) {
    const i = this.getActiveObjects(), c = this._setActiveObject(e, t);
    return this._fireSelectionEvents(i, t), c;
  }
  _setActiveObject(e, t) {
    const i = this._activeObject;
    return i !== e && !(!this._discardActiveObject(t, e) && this._activeObject) && !e.onSelect({ e: t }) && (this._activeObject = e, sm(e) && i !== e && e.set("canvas", this), e.setCoords(), !0);
  }
  _discardActiveObject(e, t) {
    const i = this._activeObject;
    return !!i && !i.onDeselect({ e, object: t }) && (this._currentTransform && this._currentTransform.target === i && this.endCurrentTransform(e), sm(i) && i === this._hoveredTarget && (this._hoveredTarget = void 0), this._activeObject = void 0, !0);
  }
  discardActiveObject(e) {
    const t = this.getActiveObjects(), i = this.getActiveObject();
    t.length && this.fire("before:selection:cleared", { e, deselected: [i] });
    const c = this._discardActiveObject(e);
    return this._fireSelectionEvents(t, e), c;
  }
  endCurrentTransform(e) {
    const t = this._currentTransform;
    this._finalizeCurrentTransform(e), t && t.target && (t.target.isMoving = !1), this._currentTransform = null;
  }
  _finalizeCurrentTransform(e) {
    const t = this._currentTransform, i = t.target, c = { e, target: i, transform: t, action: t.action };
    i._scaling && (i._scaling = !1), i.setCoords(), t.actionPerformed && (this.fire("object:modified", c), i.fire(Zb, c));
  }
  setViewportTransform(e) {
    super.setViewportTransform(e);
    const t = this._activeObject;
    t && t.setCoords();
  }
  destroy() {
    const e = this._activeObject;
    sm(e) && (e.removeAll(), e.dispose()), delete this._activeObject, super.destroy(), this.pixelFindContext = null, this.pixelFindCanvasEl = void 0;
  }
  clear() {
    this.discardActiveObject(), this._activeObject = void 0, this.clearContext(this.contextTop), super.clear();
  }
  drawControls(e) {
    const t = this._activeObject;
    t && t._renderControls(e);
  }
  _toObject(e, t, i) {
    const c = this._realizeGroupTransformOnObject(e), a = super._toObject(e, t, i);
    return e.set(c), a;
  }
  _realizeGroupTransformOnObject(e) {
    const { group: t } = e;
    if (t && sm(t) && this._activeObject === t) {
      const i = Rm(e, ["angle", "flipX", "flipY", ti, _s, xl, h0, p0, Ks]);
      return Q7(e, t.calcOwnMatrix()), i;
    }
    return {};
  }
  _setSVGObject(e, t, i) {
    const c = this._realizeGroupTransformOnObject(t);
    super._setSVGObject(e, t, i), t.set(c);
  }
}
it(F2, "ownDefaults", { uniformScaling: !0, uniScaleKey: "shiftKey", centeredScaling: !1, centeredRotation: !1, centeredKey: "altKey", altActionKey: "shiftKey", selection: !0, selectionKey: "shiftKey", selectionColor: "rgba(100, 100, 255, 0.3)", selectionDashArray: [], selectionBorderColor: "rgba(255, 255, 255, 0.3)", selectionLineWidth: 1, selectionFullyContained: !1, hoverCursor: "move", moveCursor: "move", defaultCursor: "default", freeDrawingCursor: "crosshair", notAllowedCursor: "not-allowed", perPixelTargetFind: !1, targetFindTolerance: 0, skipTargetFind: !1, stopContextMenu: !1, fireRightClick: !1, fireMiddleClick: !1, enablePointerEvents: !1, containerClass: "canvas-container", preserveObjectStacking: !1 });
class eY {
  constructor(e) {
    it(this, "targets", []), it(this, "__disposer", void 0);
    const t = () => {
      const { hiddenTextarea: c } = e.getActiveObject() || {};
      c && c.focus();
    }, i = e.upperCanvasEl;
    i.addEventListener("click", t), this.__disposer = () => i.removeEventListener("click", t);
  }
  exitTextEditing() {
    this.target = void 0, this.targets.forEach((e) => {
      e.isEditing && e.exitEditing();
    });
  }
  add(e) {
    this.targets.push(e);
  }
  remove(e) {
    this.unregister(e), am(this.targets, e);
  }
  register(e) {
    this.target = e;
  }
  unregister(e) {
    e === this.target && (this.target = void 0);
  }
  onMouseMove(e) {
    var t;
    !((t = this.target) === null || t === void 0) && t.isEditing && this.target.updateSelectionOnMouseMove(e);
  }
  clear() {
    this.targets = [], this.target = void 0;
  }
  dispose() {
    this.clear(), this.__disposer(), delete this.__disposer;
  }
}
const tY = ["target", "oldTarget", "fireCanvas", "e"], El = { passive: !1 }, Wg = (n, e) => {
  const t = n.getViewportPoint(e), i = n.getScenePoint(e);
  return { viewportPoint: t, scenePoint: i, pointer: t, absolutePointer: i };
}, Lh = function(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) t[i - 1] = arguments[i];
  return n.addEventListener(...t);
}, nu = function(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) t[i - 1] = arguments[i];
  return n.removeEventListener(...t);
}, nY = { mouse: { in: "over", out: "out", targetIn: "mouseover", targetOut: "mouseout", canvasIn: "mouse:over", canvasOut: "mouse:out" }, drag: { in: "enter", out: "leave", targetIn: "dragenter", targetOut: "dragleave", canvasIn: "drag:enter", canvasOut: "drag:leave" } };
class hx extends F2 {
  constructor(e) {
    super(e, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}), it(this, "_isClick", void 0), it(this, "textEditingManager", new eY(this)), ["_onMouseDown", "_onTouchStart", "_onMouseMove", "_onMouseUp", "_onTouchEnd", "_onResize", "_onMouseWheel", "_onMouseOut", "_onMouseEnter", "_onContextMenu", "_onDoubleClick", "_onDragStart", "_onDragEnd", "_onDragProgress", "_onDragOver", "_onDragEnter", "_onDragLeave", "_onDrop"].forEach((t) => {
      this[t] = this[t].bind(this);
    }), this.addOrRemove(Lh, "add");
  }
  _getEventPrefix() {
    return this.enablePointerEvents ? "pointer" : "mouse";
  }
  addOrRemove(e, t) {
    const i = this.upperCanvasEl, c = this._getEventPrefix();
    e($7(i), "resize", this._onResize), e(i, c + "down", this._onMouseDown), e(i, "".concat(c, "move"), this._onMouseMove, El), e(i, "".concat(c, "out"), this._onMouseOut), e(i, "".concat(c, "enter"), this._onMouseEnter), e(i, "wheel", this._onMouseWheel), e(i, "contextmenu", this._onContextMenu), e(i, "dblclick", this._onDoubleClick), e(i, "dragstart", this._onDragStart), e(i, "dragend", this._onDragEnd), e(i, "dragover", this._onDragOver), e(i, "dragenter", this._onDragEnter), e(i, "dragleave", this._onDragLeave), e(i, "drop", this._onDrop), this.enablePointerEvents || e(i, "touchstart", this._onTouchStart, El);
  }
  removeListeners() {
    this.addOrRemove(nu, "remove");
    const e = this._getEventPrefix(), t = tc(this.upperCanvasEl);
    nu(t, "".concat(e, "up"), this._onMouseUp), nu(t, "touchend", this._onTouchEnd, El), nu(t, "".concat(e, "move"), this._onMouseMove, El), nu(t, "touchmove", this._onMouseMove, El), clearTimeout(this._willAddMouseDown);
  }
  _onMouseWheel(e) {
    this.__onMouseWheel(e);
  }
  _onMouseOut(e) {
    const t = this._hoveredTarget, i = lt({ e }, Wg(this, e));
    this.fire("mouse:out", lt(lt({}, i), {}, { target: t })), this._hoveredTarget = void 0, t && t.fire("mouseout", lt({}, i)), this._hoveredTargets.forEach((c) => {
      this.fire("mouse:out", lt(lt({}, i), {}, { target: c })), c && c.fire("mouseout", lt({}, i));
    }), this._hoveredTargets = [];
  }
  _onMouseEnter(e) {
    this._currentTransform || this.findTarget(e) || (this.fire("mouse:over", lt({ e }, Wg(this, e))), this._hoveredTarget = void 0, this._hoveredTargets = []);
  }
  _onDragStart(e) {
    this._isClick = !1;
    const t = this.getActiveObject();
    if (t && t.onDragStart(e)) {
      this._dragSource = t;
      const i = { e, target: t };
      return this.fire("dragstart", i), t.fire("dragstart", i), void Lh(this.upperCanvasEl, "drag", this._onDragProgress);
    }
    ox(e);
  }
  _renderDragEffects(e, t, i) {
    let c = !1;
    const a = this._dropTarget;
    a && a !== t && a !== i && (a.clearContextTop(), c = !0), t == null || t.clearContextTop(), i !== t && (i == null || i.clearContextTop());
    const s = this.contextTop;
    s.save(), s.transform(...this.viewportTransform), t && (s.save(), t.transform(s), t.renderDragSourceEffect(e), s.restore(), c = !0), i && (s.save(), i.transform(s), i.renderDropTargetEffect(e), s.restore(), c = !0), s.restore(), c && (this.contextTopDirty = !0);
  }
  _onDragEnd(e) {
    const t = !!e.dataTransfer && e.dataTransfer.dropEffect !== Qs, i = t ? this._activeObject : void 0, c = { e, target: this._dragSource, subTargets: this.targets, dragSource: this._dragSource, didDrop: t, dropTarget: i };
    nu(this.upperCanvasEl, "drag", this._onDragProgress), this.fire("dragend", c), this._dragSource && this._dragSource.fire("dragend", c), delete this._dragSource, this._onMouseUp(e);
  }
  _onDragProgress(e) {
    const t = { e, target: this._dragSource, dragSource: this._dragSource, dropTarget: this._draggedoverTarget };
    this.fire("drag", t), this._dragSource && this._dragSource.fire("drag", t);
  }
  findDragTargets(e) {
    return this.targets = [], { target: this._searchPossibleTargets(this._objects, this.getViewportPoint(e)), targets: [...this.targets] };
  }
  _onDragOver(e) {
    const t = "dragover", { target: i, targets: c } = this.findDragTargets(e), a = this._dragSource, s = { e, target: i, subTargets: c, dragSource: a, canDrop: !1, dropTarget: void 0 };
    let r;
    this.fire(t, s), this._fireEnterLeaveEvents(i, s), i && (i.canDrop(e) && (r = i), i.fire(t, s));
    for (let l = 0; l < c.length; l++) {
      const d = c[l];
      d.canDrop(e) && (r = d), d.fire(t, s);
    }
    this._renderDragEffects(e, a, r), this._dropTarget = r;
  }
  _onDragEnter(e) {
    const { target: t, targets: i } = this.findDragTargets(e), c = { e, target: t, subTargets: i, dragSource: this._dragSource };
    this.fire("dragenter", c), this._fireEnterLeaveEvents(t, c);
  }
  _onDragLeave(e) {
    const t = { e, target: this._draggedoverTarget, subTargets: this.targets, dragSource: this._dragSource };
    this.fire("dragleave", t), this._fireEnterLeaveEvents(void 0, t), this._renderDragEffects(e, this._dragSource), this._dropTarget = void 0, this.targets = [], this._hoveredTargets = [];
  }
  _onDrop(e) {
    const { target: t, targets: i } = this.findDragTargets(e), c = this._basicEventHandler("drop:before", lt({ e, target: t, subTargets: i, dragSource: this._dragSource }, Wg(this, e)));
    c.didDrop = !1, c.dropTarget = void 0, this._basicEventHandler("drop", c), this.fire("drop:after", c);
  }
  _onContextMenu(e) {
    const t = this.findTarget(e), i = this.targets || [], c = this._basicEventHandler("contextmenu:before", { e, target: t, subTargets: i });
    return this.stopContextMenu && ox(e), this._basicEventHandler("contextmenu", c), !1;
  }
  _onDoubleClick(e) {
    this._cacheTransformEventData(e), this._handleEvent(e, "dblclick"), this._resetTransformEventData();
  }
  getPointerId(e) {
    const t = e.changedTouches;
    return t ? t[0] && t[0].identifier : this.enablePointerEvents ? e.pointerId : -1;
  }
  _isMainEvent(e) {
    return e.isPrimary === !0 || e.isPrimary !== !1 && (e.type === "touchend" && e.touches.length === 0 || !e.changedTouches || e.changedTouches[0].identifier === this.mainTouchId);
  }
  _onTouchStart(e) {
    let t = !this.allowTouchScrolling;
    const i = this._activeObject;
    this.mainTouchId === void 0 && (this.mainTouchId = this.getPointerId(e)), this.__onMouseDown(e), (this.isDrawingMode || i && this._target === i) && (t = !0), t && e.preventDefault(), this._resetTransformEventData();
    const c = this.upperCanvasEl, a = this._getEventPrefix(), s = tc(c);
    Lh(s, "touchend", this._onTouchEnd, El), t && Lh(s, "touchmove", this._onMouseMove, El), nu(c, "".concat(a, "down"), this._onMouseDown);
  }
  _onMouseDown(e) {
    this.__onMouseDown(e), this._resetTransformEventData();
    const t = this.upperCanvasEl, i = this._getEventPrefix();
    nu(t, "".concat(i, "move"), this._onMouseMove, El);
    const c = tc(t);
    Lh(c, "".concat(i, "up"), this._onMouseUp), Lh(c, "".concat(i, "move"), this._onMouseMove, El);
  }
  _onTouchEnd(e) {
    if (e.touches.length > 0) return;
    this.__onMouseUp(e), this._resetTransformEventData(), delete this.mainTouchId;
    const t = this._getEventPrefix(), i = tc(this.upperCanvasEl);
    nu(i, "touchend", this._onTouchEnd, El), nu(i, "touchmove", this._onMouseMove, El), this._willAddMouseDown && clearTimeout(this._willAddMouseDown), this._willAddMouseDown = setTimeout(() => {
      Lh(this.upperCanvasEl, "".concat(t, "down"), this._onMouseDown), this._willAddMouseDown = 0;
    }, 400);
  }
  _onMouseUp(e) {
    this.__onMouseUp(e), this._resetTransformEventData();
    const t = this.upperCanvasEl, i = this._getEventPrefix();
    if (this._isMainEvent(e)) {
      const c = tc(this.upperCanvasEl);
      nu(c, "".concat(i, "up"), this._onMouseUp), nu(c, "".concat(i, "move"), this._onMouseMove, El), Lh(t, "".concat(i, "move"), this._onMouseMove, El);
    }
  }
  _onMouseMove(e) {
    const t = this.getActiveObject();
    !this.allowTouchScrolling && (!t || !t.shouldStartDragging(e)) && e.preventDefault && e.preventDefault(), this.__onMouseMove(e);
  }
  _onResize() {
    this.calcOffset(), this._resetTransformEventData();
  }
  _shouldRender(e) {
    const t = this.getActiveObject();
    return !!t != !!e || t && e && t !== e;
  }
  __onMouseUp(e) {
    var t;
    this._cacheTransformEventData(e), this._handleEvent(e, "up:before");
    const i = this._currentTransform, c = this._isClick, a = this._target, { button: s } = e;
    if (s) return (this.fireMiddleClick && s === 1 || this.fireRightClick && s === 2) && this._handleEvent(e, "up"), void this._resetTransformEventData();
    if (this.isDrawingMode && this._isCurrentlyDrawing) return void this._onMouseUpInDrawingMode(e);
    if (!this._isMainEvent(e)) return;
    let r, l, d = !1;
    if (i && (this._finalizeCurrentTransform(e), d = i.actionPerformed), !c) {
      const f = a === this._activeObject;
      this.handleSelection(e), d || (d = this._shouldRender(a) || !f && a === this._activeObject);
    }
    if (a) {
      const f = a.findControl(this.getViewportPoint(e), e2(e)), { key: h, control: p } = f || {};
      if (l = h, a.selectable && a !== this._activeObject && a.activeOn === "up") this.setActiveObject(a, e), d = !0;
      else if (p) {
        const g = p.getMouseUpHandler(e, a, p);
        g && (r = this.getScenePoint(e), g.call(p, e, i, r.x, r.y));
      }
      a.isMoving = !1;
    }
    if (i && (i.target !== a || i.corner !== l)) {
      const f = i.target && i.target.controls[i.corner], h = f && f.getMouseUpHandler(e, i.target, f);
      r = r || this.getScenePoint(e), h && h.call(f, e, i, r.x, r.y);
    }
    this._setCursorFromEvent(e, a), this._handleEvent(e, "up"), this._groupSelector = null, this._currentTransform = null, a && (a.__corner = void 0), d ? this.requestRenderAll() : c || (t = this._activeObject) !== null && t !== void 0 && t.isEditing || this.renderTop();
  }
  _basicEventHandler(e, t) {
    const { target: i, subTargets: c = [] } = t;
    this.fire(e, t), i && i.fire(e, t);
    for (let a = 0; a < c.length; a++) c[a] !== i && c[a].fire(e, t);
    return t;
  }
  _handleEvent(e, t) {
    const i = this._target, c = this.targets || [], a = lt(lt({ e, target: i, subTargets: c }, Wg(this, e)), {}, { transform: this._currentTransform }, t === "up:before" || t === "up" ? { isClick: this._isClick, currentTarget: this.findTarget(e), currentSubTargets: this.targets } : {});
    this.fire("mouse:".concat(t), a), i && i.fire("mouse".concat(t), a);
    for (let s = 0; s < c.length; s++) c[s] !== i && c[s].fire("mouse".concat(t), a);
  }
  _onMouseDownInDrawingMode(e) {
    this._isCurrentlyDrawing = !0, this.getActiveObject() && (this.discardActiveObject(e), this.requestRenderAll());
    const t = this.getScenePoint(e);
    this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(t, { e, pointer: t }), this._handleEvent(e, "down");
  }
  _onMouseMoveInDrawingMode(e) {
    if (this._isCurrentlyDrawing) {
      const t = this.getScenePoint(e);
      this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(t, { e, pointer: t });
    }
    this.setCursor(this.freeDrawingCursor), this._handleEvent(e, "move");
  }
  _onMouseUpInDrawingMode(e) {
    const t = this.getScenePoint(e);
    this.freeDrawingBrush ? this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({ e, pointer: t }) : this._isCurrentlyDrawing = !1, this._handleEvent(e, "up");
  }
  __onMouseDown(e) {
    this._isClick = !0, this._cacheTransformEventData(e), this._handleEvent(e, "down:before");
    let t = this._target;
    const { button: i } = e;
    if (i) return (this.fireMiddleClick && i === 1 || this.fireRightClick && i === 2) && this._handleEvent(e, "down"), void this._resetTransformEventData();
    if (this.isDrawingMode) return void this._onMouseDownInDrawingMode(e);
    if (!this._isMainEvent(e) || this._currentTransform) return;
    let c = this._shouldRender(t), a = !1;
    if (this.handleMultiSelection(e, t) ? (t = this._activeObject, a = !0, c = !0) : this._shouldClearSelection(e, t) && this.discardActiveObject(e), this.selection && (!t || !t.selectable && !t.isEditing && t !== this._activeObject)) {
      const s = this.getScenePoint(e);
      this._groupSelector = { x: s.x, y: s.y, deltaY: 0, deltaX: 0 };
    }
    if (t) {
      const s = t === this._activeObject;
      t.selectable && t.activeOn === "down" && this.setActiveObject(t, e);
      const r = t.findControl(this.getViewportPoint(e), e2(e));
      if (t === this._activeObject && (r || !a)) {
        this._setupCurrentTransform(e, t, s);
        const l = r ? r.control : void 0, d = this.getScenePoint(e), f = l && l.getMouseDownHandler(e, t, l);
        f && f.call(l, e, this._currentTransform, d.x, d.y);
      }
    }
    c && (this._objectsToRender = void 0), this._handleEvent(e, "down"), c && this.requestRenderAll();
  }
  _resetTransformEventData() {
    this._target = this._pointer = this._absolutePointer = void 0;
  }
  _cacheTransformEventData(e) {
    this._resetTransformEventData(), this._pointer = this.getViewportPoint(e), this._absolutePointer = _m(this._pointer, void 0, this.viewportTransform), this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e);
  }
  __onMouseMove(e) {
    if (this._isClick = !1, this._cacheTransformEventData(e), this._handleEvent(e, "move:before"), this.isDrawingMode) return void this._onMouseMoveInDrawingMode(e);
    if (!this._isMainEvent(e)) return;
    const t = this._groupSelector;
    if (t) {
      const i = this.getScenePoint(e);
      t.deltaX = i.x - t.x, t.deltaY = i.y - t.y, this.renderTop();
    } else if (this._currentTransform) this._transformObject(e);
    else {
      const i = this.findTarget(e);
      this._setCursorFromEvent(e, i), this._fireOverOutEvents(e, i);
    }
    this.textEditingManager.onMouseMove(e), this._handleEvent(e, "move"), this._resetTransformEventData();
  }
  _fireOverOutEvents(e, t) {
    const i = this._hoveredTarget, c = this._hoveredTargets, a = this.targets, s = Math.max(c.length, a.length);
    this.fireSyntheticInOutEvents("mouse", { e, target: t, oldTarget: i, fireCanvas: !0 });
    for (let r = 0; r < s; r++) this.fireSyntheticInOutEvents("mouse", { e, target: a[r], oldTarget: c[r] });
    this._hoveredTarget = t, this._hoveredTargets = this.targets.concat();
  }
  _fireEnterLeaveEvents(e, t) {
    const i = this._draggedoverTarget, c = this._hoveredTargets, a = this.targets, s = Math.max(c.length, a.length);
    this.fireSyntheticInOutEvents("drag", lt(lt({}, t), {}, { target: e, oldTarget: i, fireCanvas: !0 }));
    for (let r = 0; r < s; r++) this.fireSyntheticInOutEvents("drag", lt(lt({}, t), {}, { target: a[r], oldTarget: c[r] }));
    this._draggedoverTarget = e;
  }
  fireSyntheticInOutEvents(e, t) {
    let { target: i, oldTarget: c, fireCanvas: a, e: s } = t, r = Vi(t, tY);
    const { targetIn: l, targetOut: d, canvasIn: f, canvasOut: h } = nY[e], p = c !== i;
    if (c && p) {
      const g = lt(lt({}, r), {}, { e: s, target: c, nextTarget: i }, Wg(this, s));
      a && this.fire(h, g), c.fire(d, g);
    }
    if (i && p) {
      const g = lt(lt({}, r), {}, { e: s, target: i, previousTarget: c }, Wg(this, s));
      a && this.fire(f, g), i.fire(l, g);
    }
  }
  __onMouseWheel(e) {
    this._cacheTransformEventData(e), this._handleEvent(e, "wheel"), this._resetTransformEventData();
  }
  _transformObject(e) {
    const t = this.getScenePoint(e), i = this._currentTransform, c = i.target, a = c.group ? _m(t, void 0, c.group.calcTransformMatrix()) : t;
    i.shiftKey = e.shiftKey, i.altKey = !!this.centeredKey && e[this.centeredKey], this._performTransformAction(e, i, a), i.actionPerformed && this.requestRenderAll();
  }
  _performTransformAction(e, t, i) {
    const { action: c, actionHandler: a, target: s } = t, r = !!a && a(e, t, i.x, i.y);
    r && s.setCoords(), c === "drag" && r && (t.target.isMoving = !0, this.setCursor(t.target.moveCursor || this.moveCursor)), t.actionPerformed = t.actionPerformed || r;
  }
  _setCursorFromEvent(e, t) {
    if (!t) return void this.setCursor(this.defaultCursor);
    let i = t.hoverCursor || this.hoverCursor;
    const c = sm(this._activeObject) ? this._activeObject : null, a = (!c || t.group !== c) && t.findControl(this.getViewportPoint(e));
    if (a) {
      const s = a.control;
      this.setCursor(s.cursorStyleHandler(e, s, t));
    } else t.subTargetCheck && this.targets.concat().reverse().map((s) => {
      i = s.hoverCursor || i;
    }), this.setCursor(i);
  }
  handleMultiSelection(e, t) {
    const i = this._activeObject, c = sm(i);
    if (i && this._isSelectionKeyPressed(e) && this.selection && t && t.selectable && (i !== t || c) && (c || !t.isDescendantOf(i) && !i.isDescendantOf(t)) && !t.onSelect({ e }) && !i.getActiveControl()) {
      if (c) {
        const a = i.getObjects();
        if (t === i) {
          const s = this.getViewportPoint(e);
          if (!(t = this.searchPossibleTargets(a, s) || this.searchPossibleTargets(this._objects, s)) || !t.selectable) return !1;
        }
        t.group === i ? (i.remove(t), this._hoveredTarget = t, this._hoveredTargets = [...this.targets], i.size() === 1 && this._setActiveObject(i.item(0), e)) : (i.multiSelectAdd(t), this._hoveredTarget = i, this._hoveredTargets = [...this.targets]), this._fireSelectionEvents(a, e);
      } else {
        i.isEditing && i.exitEditing();
        const a = new (pn.getClass("ActiveSelection"))([], { canvas: this });
        a.multiSelectAdd(i, t), this._hoveredTarget = a, this._setActiveObject(a, e), this._fireSelectionEvents([i], e);
      }
      return !0;
    }
    return !1;
  }
  handleSelection(e) {
    if (!this.selection || !this._groupSelector) return !1;
    const { x: t, y: i, deltaX: c, deltaY: a } = this._groupSelector, s = new St(t, i), r = s.add(new St(c, a)), l = s.min(r), d = s.max(r).subtract(l), f = this.collectObjects({ left: l.x, top: l.y, width: d.x, height: d.y }, { includeIntersecting: !this.selectionFullyContained }), h = s.eq(r) ? f[0] ? [f[0]] : [] : f.length > 1 ? f.filter((p) => !p.onSelect({ e })).reverse() : f;
    if (h.length === 1) this.setActiveObject(h[0], e);
    else if (h.length > 1) {
      const p = pn.getClass("ActiveSelection");
      this.setActiveObject(new p(h, { canvas: this }), e);
    }
    return this._groupSelector = null, !0;
  }
  clear() {
    this.textEditingManager.clear(), super.clear();
  }
  destroy() {
    this.removeListeners(), this.textEditingManager.dispose(), super.destroy();
  }
}
const L8 = { x1: 0, y1: 0, x2: 0, y2: 0 }, rY = lt(lt({}, L8), {}, { r1: 0, r2: 0 }), Qg = (n, e) => isNaN(n) && typeof e == "number" ? e : n, iY = /^(\d+\.\d+)%|(\d+)%$/;
function M8(n) {
  return n && iY.test(n);
}
function P8(n, e) {
  const t = typeof n == "number" ? n : typeof n == "string" ? parseFloat(n) / (M8(n) ? 100 : 1) : NaN;
  return Cm(0, Qg(t, e), 1);
}
const oY = /\s*;\s*/, aY = /\s*:\s*/;
function sY(n, e) {
  let t, i;
  const c = n.getAttribute("style");
  if (c) {
    const s = c.split(oY);
    s[s.length - 1] === "" && s.pop();
    for (let r = s.length; r--; ) {
      const [l, d] = s[r].split(aY).map((f) => f.trim());
      l === "stop-color" ? t = d : l === "stop-opacity" && (i = d);
    }
  }
  const a = new Wr(t || n.getAttribute("stop-color") || "rgb(0,0,0)");
  return { offset: P8(n.getAttribute("offset"), 0), color: a.toRgb(), opacity: Qg(parseFloat(i || n.getAttribute("stop-opacity") || ""), 1) * a.getAlpha() * e };
}
function lY(n, e) {
  const t = [], i = n.getElementsByTagName("stop"), c = P8(e, 1);
  for (let a = i.length; a--; ) t.push(sY(i[a], c));
  return t;
}
function j8(n) {
  return n.nodeName === "linearGradient" || n.nodeName === "LINEARGRADIENT" ? "linear" : "radial";
}
function B8(n) {
  return n.getAttribute("gradientUnits") === "userSpaceOnUse" ? "pixels" : "percentage";
}
function Yu(n, e) {
  return n.getAttribute(e);
}
function uY(n, e) {
  return function(t, i) {
    let c, { width: a, height: s, gradientUnits: r } = i;
    return Object.keys(t).reduce((l, d) => {
      const f = t[d];
      return f === "Infinity" ? c = 1 : f === "-Infinity" ? c = 0 : (c = typeof f == "string" ? parseFloat(f) : f, typeof f == "string" && M8(f) && (c *= 0.01, r === "pixels" && (d !== "x1" && d !== "x2" && d !== "r2" || (c *= a), d !== "y1" && d !== "y2" || (c *= s)))), l[d] = c, l;
    }, {});
  }(j8(n) === "linear" ? function(t) {
    return { x1: Yu(t, "x1") || 0, y1: Yu(t, "y1") || 0, x2: Yu(t, "x2") || "100%", y2: Yu(t, "y2") || 0 };
  }(n) : function(t) {
    return { x1: Yu(t, "fx") || Yu(t, "cx") || "50%", y1: Yu(t, "fy") || Yu(t, "cy") || "50%", r1: 0, x2: Yu(t, "cx") || "50%", y2: Yu(t, "cy") || "50%", r2: Yu(t, "r") || "50%" };
  }(n), lt(lt({}, e), {}, { gradientUnits: B8(n) }));
}
class ib {
  constructor(e) {
    const { type: t = "linear", gradientUnits: i = "pixels", coords: c = {}, colorStops: a = [], offsetX: s = 0, offsetY: r = 0, gradientTransform: l, id: d } = e || {};
    Object.assign(this, { type: t, gradientUnits: i, coords: lt(lt({}, t === "radial" ? rY : L8), c), colorStops: a, offsetX: s, offsetY: r, gradientTransform: l, id: d ? "".concat(d, "_").concat(Wh()) : Wh() });
  }
  addColorStop(e) {
    for (const t in e) {
      const i = new Wr(e[t]);
      this.colorStops.push({ offset: parseFloat(t), color: i.toRgb(), opacity: i.getAlpha() });
    }
    return this;
  }
  toObject(e) {
    return lt(lt({}, Rm(this, e)), {}, { type: this.type, coords: lt({}, this.coords), colorStops: this.colorStops.map((t) => lt({}, t)), offsetX: this.offsetX, offsetY: this.offsetY, gradientUnits: this.gradientUnits, gradientTransform: this.gradientTransform ? [...this.gradientTransform] : void 0 });
  }
  toSVG(e) {
    let { additionalTransform: t } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = [], c = this.gradientTransform ? this.gradientTransform.concat() : gs.concat(), a = this.gradientUnits === "pixels" ? "userSpaceOnUse" : "objectBoundingBox", s = this.colorStops.map((h) => lt({}, h)).sort((h, p) => h.offset - p.offset);
    let r = -this.offsetX, l = -this.offsetY;
    var d;
    a === "objectBoundingBox" ? (r /= e.width, l /= e.height) : (r += e.width / 2, l += e.height / 2), (d = e) && typeof d._renderPathCommands == "function" && this.gradientUnits !== "percentage" && (r -= e.pathOffset.x, l -= e.pathOffset.y), c[4] -= r, c[5] -= l;
    const f = ['id="SVGID_'.concat(this.id, '"'), 'gradientUnits="'.concat(a, '"'), 'gradientTransform="'.concat(t ? t + " " : "").concat(A1(c), '"'), ""].join(" ");
    if (this.type === "linear") {
      const { x1: h, y1: p, x2: g, y2: _ } = this.coords;
      i.push("<linearGradient ", f, ' x1="', h, '" y1="', p, '" x2="', g, '" y2="', _, `">
`);
    } else if (this.type === "radial") {
      const { x1: h, y1: p, x2: g, y2: _, r1: b, r2: v } = this.coords, E = b > v;
      i.push("<radialGradient ", f, ' cx="', E ? h : g, '" cy="', E ? p : _, '" r="', E ? b : v, '" fx="', E ? g : h, '" fy="', E ? _ : p, `">
`), E && (s.reverse(), s.forEach((y) => {
        y.offset = 1 - y.offset;
      }));
      const C = Math.min(b, v);
      if (C > 0) {
        const y = C / Math.max(b, v);
        s.forEach((T) => {
          T.offset += y * (1 - T.offset);
        });
      }
    }
    return s.forEach((h) => {
      let { color: p, offset: g, opacity: _ } = h;
      i.push("<stop ", 'offset="', 100 * g + "%", '" style="stop-color:', p, _ !== void 0 ? ";stop-opacity: " + _ : ";", `"/>
`);
    }), i.push(this.type === "linear" ? "</linearGradient>" : "</radialGradient>", `
`), i.join("");
  }
  toLive(e) {
    const { x1: t, y1: i, x2: c, y2: a, r1: s, r2: r } = this.coords, l = this.type === "linear" ? e.createLinearGradient(t, i, c, a) : e.createRadialGradient(t, i, s, c, a, r);
    return this.colorStops.forEach((d) => {
      let { color: f, opacity: h, offset: p } = d;
      l.addColorStop(p, h !== void 0 ? new Wr(f).setAlpha(h).toRgba() : f);
    }), l;
  }
  static async fromObject(e) {
    const { colorStops: t, gradientTransform: i } = e;
    return new this(lt(lt({}, e), {}, { colorStops: t ? t.map((c) => lt({}, c)) : void 0, gradientTransform: i ? [...i] : void 0 }));
  }
  static fromElement(e, t, i) {
    const c = B8(e), a = t._findCenterFromElement();
    return new this(lt({ id: e.getAttribute("id") || void 0, type: j8(e), coords: uY(e, { width: i.viewBoxWidth || i.width, height: i.viewBoxHeight || i.height }), colorStops: lY(e, i.opacity), gradientUnits: c, gradientTransform: ux(e.getAttribute("gradientTransform") || "") }, c === "pixels" ? { offsetX: t.width / 2 - a.x, offsetY: t.height / 2 - a.y } : { offsetX: 0, offsetY: 0 }));
  }
}
it(ib, "type", "Gradient"), pn.setClass(ib, "gradient"), pn.setClass(ib, "linear"), pn.setClass(ib, "radial");
const cY = ["type", "source", "patternTransform"];
class bw {
  get type() {
    return "pattern";
  }
  set type(e) {
    qh("warn", "Setting type has no effect", e);
  }
  constructor(e) {
    it(this, "repeat", "repeat"), it(this, "offsetX", 0), it(this, "offsetY", 0), it(this, "crossOrigin", ""), this.id = Wh(), Object.assign(this, e);
  }
  isImageSource() {
    return !!this.source && typeof this.source.src == "string";
  }
  isCanvasSource() {
    return !!this.source && !!this.source.toDataURL;
  }
  sourceToString() {
    return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : "";
  }
  toLive(e) {
    return this.source && (!this.isImageSource() || this.source.complete && this.source.naturalWidth !== 0 && this.source.naturalHeight !== 0) ? e.createPattern(this.source, this.repeat) : null;
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const { repeat: t, crossOrigin: i } = this;
    return lt(lt({}, Rm(this, e)), {}, { type: "pattern", source: this.sourceToString(), repeat: t, crossOrigin: i, offsetX: zi(this.offsetX, Br.NUM_FRACTION_DIGITS), offsetY: zi(this.offsetY, Br.NUM_FRACTION_DIGITS), patternTransform: this.patternTransform ? [...this.patternTransform] : null });
  }
  toSVG(e) {
    let { width: t, height: i } = e;
    const { source: c, repeat: a, id: s } = this, r = Qg(this.offsetX / t, 0), l = Qg(this.offsetY / i, 0), d = a === "repeat-y" || a === "no-repeat" ? 1 + Math.abs(r || 0) : Qg(c.width / t, 0), f = a === "repeat-x" || a === "no-repeat" ? 1 + Math.abs(l || 0) : Qg(c.height / i, 0);
    return ['<pattern id="SVGID_'.concat(s, '" x="').concat(r, '" y="').concat(l, '" width="').concat(d, '" height="').concat(f, '">'), '<image x="0" y="0" width="'.concat(c.width, '" height="').concat(c.height, '" xlink:href="').concat(this.sourceToString(), '"></image>'), "</pattern>", ""].join(`
`);
  }
  static async fromObject(e, t) {
    let { type: i, source: c, patternTransform: a } = e, s = Vi(e, cY);
    const r = await m1(c, lt(lt({}, t), {}, { crossOrigin: s.crossOrigin }));
    return new this(lt(lt({}, s), {}, { patternTransform: a && a.slice(0), source: r }));
  }
}
it(bw, "type", "Pattern"), pn.setClass(bw), pn.setClass(bw, "pattern");
const dY = ["path", "left", "top"], fY = ["d"];
class lm extends es {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { path: i, left: c, top: a } = t, s = Vi(t, dY);
    super(), Object.assign(this, lm.ownDefaults), this.setOptions(s), this._setPath(e || [], !0), typeof c == "number" && this.set(ti, c), typeof a == "number" && this.set(Ks, a);
  }
  _setPath(e, t) {
    this.path = T8(Array.isArray(e) ? e : N8(e)), this.setBoundingBox(t);
  }
  _findCenterFromElement() {
    const e = this._calcBoundsFromPath();
    return new St(e.left + e.width / 2, e.top + e.height / 2);
  }
  _renderPathCommands(e) {
    const t = -this.pathOffset.x, i = -this.pathOffset.y;
    e.beginPath();
    for (const c of this.path) switch (c[0]) {
      case "L":
        e.lineTo(c[1] + t, c[2] + i);
        break;
      case "M":
        e.moveTo(c[1] + t, c[2] + i);
        break;
      case "C":
        e.bezierCurveTo(c[1] + t, c[2] + i, c[3] + t, c[4] + i, c[5] + t, c[6] + i);
        break;
      case "Q":
        e.quadraticCurveTo(c[1] + t, c[2] + i, c[3] + t, c[4] + i);
        break;
      case "Z":
        e.closePath();
    }
  }
  _render(e) {
    this._renderPathCommands(e), this._renderPaintInOrder(e);
  }
  toString() {
    return "#<Path (".concat(this.complexity(), '): { "top": ').concat(this.top, ', "left": ').concat(this.left, " }>");
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return lt(lt({}, super.toObject(e)), {}, { path: this.path.map((t) => t.slice()) });
  }
  toDatalessObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const t = this.toObject(e);
    return this.sourcePath && (delete t.path, t.sourcePath = this.sourcePath), t;
  }
  _toSVG() {
    const e = I8(this.path, Br.NUM_FRACTION_DIGITS);
    return ["<path ", "COMMON_PARTS", 'd="'.concat(e, `" stroke-linecap="round" />
`)];
  }
  _getOffsetTransform() {
    const e = Br.NUM_FRACTION_DIGITS;
    return " translate(".concat(zi(-this.pathOffset.x, e), ", ").concat(zi(-this.pathOffset.y, e), ")");
  }
  toClipPathSVG(e) {
    const t = this._getOffsetTransform();
    return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(), { reviver: e, additionalTransform: t });
  }
  toSVG(e) {
    const t = this._getOffsetTransform();
    return this._createBaseSVGMarkup(this._toSVG(), { reviver: e, additionalTransform: t });
  }
  complexity() {
    return this.path.length;
  }
  setDimensions() {
    this.setBoundingBox();
  }
  setBoundingBox(e) {
    const { width: t, height: i, pathOffset: c } = this._calcDimensions();
    this.set({ width: t, height: i, pathOffset: c }), e && this.setPositionByOrigin(c, pr, pr);
  }
  _calcBoundsFromPath() {
    const e = [];
    let t = 0, i = 0, c = 0, a = 0;
    for (const s of this.path) switch (s[0]) {
      case "L":
        c = s[1], a = s[2], e.push({ x: t, y: i }, { x: c, y: a });
        break;
      case "M":
        c = s[1], a = s[2], t = c, i = a;
        break;
      case "C":
        e.push(...fx(c, a, s[1], s[2], s[3], s[4], s[5], s[6])), c = s[5], a = s[6];
        break;
      case "Q":
        e.push(...fx(c, a, s[1], s[2], s[1], s[2], s[3], s[4])), c = s[3], a = s[4];
        break;
      case "Z":
        c = t, a = i;
    }
    return dd(e);
  }
  _calcDimensions() {
    const e = this._calcBoundsFromPath();
    return lt(lt({}, e), {}, { pathOffset: new St(e.left + e.width / 2, e.top + e.height / 2) });
  }
  static fromObject(e) {
    return this._fromObject(e, { extraParam: "path" });
  }
  static async fromElement(e, t, i) {
    const c = wf(e, this.ATTRIBUTE_NAMES, i), { d: a } = c;
    return new this(a, lt(lt(lt({}, Vi(c, fY)), t), {}, { left: void 0, top: void 0 }));
  }
}
it(lm, "type", "Path"), it(lm, "cacheProperties", [...Cf, "path", "fillRule"]), it(lm, "ATTRIBUTE_NAMES", [...Qh, "d"]), pn.setClass(lm), pn.setSVGClass(lm);
const hY = ["left", "top", "radius"], F8 = ["radius", "startAngle", "endAngle", "counterClockwise"];
class ff extends es {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), ff.ownDefaults);
  }
  constructor(e) {
    super(), Object.assign(this, ff.ownDefaults), this.setOptions(e);
  }
  _set(e, t) {
    return super._set(e, t), e === "radius" && this.setRadius(t), this;
  }
  _render(e) {
    e.beginPath(), e.arc(0, 0, this.radius, oo(this.startAngle), oo(this.endAngle), this.counterClockwise), this._renderPaintInOrder(e);
  }
  getRadiusX() {
    return this.get("radius") * this.get(_s);
  }
  getRadiusY() {
    return this.get("radius") * this.get(xl);
  }
  setRadius(e) {
    this.radius = e, this.set({ width: 2 * e, height: 2 * e });
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject([...F8, ...e]);
  }
  _toSVG() {
    const e = (this.endAngle - this.startAngle) % 360;
    if (e === 0) return ["<circle ", "COMMON_PARTS", 'cx="0" cy="0" ', 'r="', "".concat(this.radius), `" />
`];
    {
      const { radius: t } = this, i = oo(this.startAngle), c = oo(this.endAngle), a = ic(i) * t, s = oc(i) * t, r = ic(c) * t, l = oc(c) * t, d = e > 180 ? 1 : 0, f = this.counterClockwise ? 0 : 1;
      return ['<path d="M '.concat(a, " ").concat(s, " A ").concat(t, " ").concat(t, " 0 ").concat(d, " ").concat(f, " ").concat(r, " ").concat(l, '" '), "COMMON_PARTS", ` />
`];
    }
  }
  static async fromElement(e, t, i) {
    const c = wf(e, this.ATTRIBUTE_NAMES, i), { left: a = 0, top: s = 0, radius: r = 0 } = c;
    return new this(lt(lt({}, Vi(c, hY)), {}, { radius: r, left: a - r, top: s - r }));
  }
  static fromObject(e) {
    return super._fromObject(e);
  }
}
it(ff, "type", "Circle"), it(ff, "cacheProperties", [...Cf, ...F8]), it(ff, "ownDefaults", { radius: 0, startAngle: 0, endAngle: 360, counterClockwise: !1 }), it(ff, "ATTRIBUTE_NAMES", ["cx", "cy", "r", ...Qh]), pn.setClass(ff), pn.setSVGClass(ff);
const pY = ["x1", "y1", "x2", "y2"], mY = ["x1", "y1", "x2", "y2"], px = ["x1", "x2", "y1", "y2"];
class um extends es {
  constructor() {
    let [e, t, i, c] = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [0, 0, 0, 0], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Object.assign(this, um.ownDefaults), this.setOptions(a), this.x1 = e, this.x2 = i, this.y1 = t, this.y2 = c, this._setWidthHeight();
    const { left: s, top: r } = a;
    typeof s == "number" && this.set(ti, s), typeof r == "number" && this.set(Ks, r);
  }
  _setWidthHeight() {
    const { x1: e, y1: t, x2: i, y2: c } = this;
    this.width = Math.abs(i - e), this.height = Math.abs(c - t);
    const { left: a, top: s, width: r, height: l } = dd([{ x: e, y: t }, { x: i, y: c }]), d = new St(a + r / 2, s + l / 2);
    this.setPositionByOrigin(d, pr, pr);
  }
  _set(e, t) {
    return super._set(e, t), px.includes(e) && this._setWidthHeight(), this;
  }
  _render(e) {
    e.beginPath();
    const t = this.calcLinePoints();
    e.moveTo(t.x1, t.y1), e.lineTo(t.x2, t.y2), e.lineWidth = this.strokeWidth;
    const i = e.strokeStyle;
    var c;
    au(this.stroke) ? e.strokeStyle = this.stroke.toLive(e) : e.strokeStyle = (c = this.stroke) !== null && c !== void 0 ? c : e.fillStyle, this.stroke && this._renderStroke(e), e.strokeStyle = i;
  }
  _findCenterFromElement() {
    return new St((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return lt(lt({}, super.toObject(e)), this.calcLinePoints());
  }
  _getNonTransformedDimensions() {
    const e = super._getNonTransformedDimensions();
    return this.strokeLineCap === "butt" && (this.width === 0 && (e.y -= this.strokeWidth), this.height === 0 && (e.x -= this.strokeWidth)), e;
  }
  calcLinePoints() {
    const { x1: e, x2: t, y1: i, y2: c, width: a, height: s } = this, r = e <= t ? -1 : 1, l = i <= c ? -1 : 1;
    return { x1: r * a / 2, x2: r * -a / 2, y1: l * s / 2, y2: l * -s / 2 };
  }
  _toSVG() {
    const { x1: e, x2: t, y1: i, y2: c } = this.calcLinePoints();
    return ["<line ", "COMMON_PARTS", 'x1="'.concat(e, '" y1="').concat(i, '" x2="').concat(t, '" y2="').concat(c, `" />
`)];
  }
  static async fromElement(e, t, i) {
    const c = wf(e, this.ATTRIBUTE_NAMES, i), { x1: a = 0, y1: s = 0, x2: r = 0, y2: l = 0 } = c;
    return new this([a, s, r, l], Vi(c, pY));
  }
  static fromObject(e) {
    let { x1: t, y1: i, x2: c, y2: a } = e, s = Vi(e, mY);
    return this._fromObject(lt(lt({}, s), {}, { points: [t, i, c, a] }), { extraParam: "points" });
  }
}
it(um, "type", "Line"), it(um, "cacheProperties", [...Cf, ...px]), it(um, "ATTRIBUTE_NAMES", Qh.concat(px)), pn.setClass(um), pn.setSVGClass(um);
class dm extends es {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), dm.ownDefaults);
  }
  constructor(e) {
    super(), Object.assign(this, dm.ownDefaults), this.setOptions(e);
  }
  _render(e) {
    const t = this.width / 2, i = this.height / 2;
    e.beginPath(), e.moveTo(-t, i), e.lineTo(0, -i), e.lineTo(t, i), e.closePath(), this._renderPaintInOrder(e);
  }
  _toSVG() {
    const e = this.width / 2, t = this.height / 2;
    return ["<polygon ", "COMMON_PARTS", 'points="', "".concat(-e, " ").concat(t, ",0 ").concat(-t, ",").concat(e, " ").concat(t), '" />'];
  }
}
it(dm, "type", "Triangle"), it(dm, "ownDefaults", { width: 100, height: 100 }), pn.setClass(dm), pn.setSVGClass(dm);
const U8 = ["rx", "ry"];
class hf extends es {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), hf.ownDefaults);
  }
  constructor(e) {
    super(), Object.assign(this, hf.ownDefaults), this.setOptions(e);
  }
  _set(e, t) {
    switch (super._set(e, t), e) {
      case "rx":
        this.rx = t, this.set("width", 2 * t);
        break;
      case "ry":
        this.ry = t, this.set("height", 2 * t);
    }
    return this;
  }
  getRx() {
    return this.get("rx") * this.get(_s);
  }
  getRy() {
    return this.get("ry") * this.get(xl);
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject([...U8, ...e]);
  }
  _toSVG() {
    return ["<ellipse ", "COMMON_PARTS", 'cx="0" cy="0" rx="'.concat(this.rx, '" ry="').concat(this.ry, `" />
`)];
  }
  _render(e) {
    e.beginPath(), e.save(), e.transform(1, 0, 0, this.ry / this.rx, 0, 0), e.arc(0, 0, this.rx, 0, yf, !1), e.restore(), this._renderPaintInOrder(e);
  }
  static async fromElement(e, t, i) {
    const c = wf(e, this.ATTRIBUTE_NAMES, i);
    return c.left = (c.left || 0) - c.rx, c.top = (c.top || 0) - c.ry, new this(c);
  }
}
function gY(n) {
  if (!n) return [];
  const e = n.replace(/,/g, " ").trim().split(/\s+/), t = [];
  for (let i = 0; i < e.length; i += 2) t.push({ x: parseFloat(e[i]), y: parseFloat(e[i + 1]) });
  return t;
}
it(hf, "type", "Ellipse"), it(hf, "cacheProperties", [...Cf, ...U8]), it(hf, "ownDefaults", { rx: 0, ry: 0 }), it(hf, "ATTRIBUTE_NAMES", [...Qh, "cx", "cy", "rx", "ry"]), pn.setClass(hf), pn.setSVGClass(hf);
const _Y = ["left", "top"], H8 = { exactBoundingBox: !1 };
class Qu extends es {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), Qu.ownDefaults);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), it(this, "strokeDiff", void 0), Object.assign(this, Qu.ownDefaults), this.setOptions(t), this.points = e;
    const { left: i, top: c } = t;
    this.initialized = !0, this.setBoundingBox(!0), typeof i == "number" && this.set(ti, i), typeof c == "number" && this.set(Ks, c);
  }
  isOpen() {
    return !0;
  }
  _projectStrokeOnPoints(e) {
    return _8(this.points, e, this.isOpen());
  }
  _calcDimensions(e) {
    e = lt({ scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, strokeLineCap: this.strokeLineCap, strokeLineJoin: this.strokeLineJoin, strokeMiterLimit: this.strokeMiterLimit, strokeUniform: this.strokeUniform, strokeWidth: this.strokeWidth }, e || {});
    const t = this.exactBoundingBox ? this._projectStrokeOnPoints(e).map((d) => d.projectedPoint) : this.points;
    if (t.length === 0) return { left: 0, top: 0, width: 0, height: 0, pathOffset: new St(), strokeOffset: new St(), strokeDiff: new St() };
    const i = dd(t), c = B1(lt(lt({}, e), {}, { scaleX: 1, scaleY: 1 })), a = dd(this.points.map((d) => Ja(d, c, !0))), s = new St(this.scaleX, this.scaleY);
    let r = i.left + i.width / 2, l = i.top + i.height / 2;
    return this.exactBoundingBox && (r -= l * Math.tan(oo(this.skewX)), l -= r * Math.tan(oo(this.skewY))), lt(lt({}, i), {}, { pathOffset: new St(r, l), strokeOffset: new St(a.left, a.top).subtract(new St(i.left, i.top)).multiply(s), strokeDiff: new St(i.width, i.height).subtract(new St(a.width, a.height)).multiply(s) });
  }
  _findCenterFromElement() {
    const e = dd(this.points);
    return new St(e.left + e.width / 2, e.top + e.height / 2);
  }
  setDimensions() {
    this.setBoundingBox();
  }
  setBoundingBox(e) {
    const { left: t, top: i, width: c, height: a, pathOffset: s, strokeOffset: r, strokeDiff: l } = this._calcDimensions();
    this.set({ width: c, height: a, pathOffset: s, strokeOffset: r, strokeDiff: l }), e && this.setPositionByOrigin(new St(t + c / 2, i + a / 2), pr, pr);
  }
  isStrokeAccountedForInDimensions() {
    return this.exactBoundingBox;
  }
  _getNonTransformedDimensions() {
    return this.exactBoundingBox ? new St(this.width, this.height) : super._getNonTransformedDimensions();
  }
  _getTransformedDimensions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (this.exactBoundingBox) {
      let s;
      if (Object.keys(e).some((r) => this.strokeUniform || this.constructor.layoutProperties.includes(r))) {
        var t, i;
        const { width: r, height: l } = this._calcDimensions(e);
        s = new St((t = e.width) !== null && t !== void 0 ? t : r, (i = e.height) !== null && i !== void 0 ? i : l);
      } else {
        var c, a;
        s = new St((c = e.width) !== null && c !== void 0 ? c : this.width, (a = e.height) !== null && a !== void 0 ? a : this.height);
      }
      return s.multiply(new St(e.scaleX || this.scaleX, e.scaleY || this.scaleY));
    }
    return super._getTransformedDimensions(e);
  }
  _set(e, t) {
    const i = this.initialized && this[e] !== t, c = super._set(e, t);
    return this.exactBoundingBox && i && ((e === _s || e === xl) && this.strokeUniform && this.constructor.layoutProperties.includes("strokeUniform") || this.constructor.layoutProperties.includes(e)) && this.setDimensions(), c;
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return lt(lt({}, super.toObject(e)), {}, { points: this.points.map((t) => {
      let { x: i, y: c } = t;
      return { x: i, y: c };
    }) });
  }
  _toSVG() {
    const e = [], t = this.pathOffset.x, i = this.pathOffset.y, c = Br.NUM_FRACTION_DIGITS;
    for (let a = 0, s = this.points.length; a < s; a++) e.push(zi(this.points[a].x - t, c), ",", zi(this.points[a].y - i, c), " ");
    return ["<".concat(this.constructor.type.toLowerCase(), " "), "COMMON_PARTS", 'points="'.concat(e.join(""), `" />
`)];
  }
  _render(e) {
    const t = this.points.length, i = this.pathOffset.x, c = this.pathOffset.y;
    if (t && !isNaN(this.points[t - 1].y)) {
      e.beginPath(), e.moveTo(this.points[0].x - i, this.points[0].y - c);
      for (let a = 0; a < t; a++) {
        const s = this.points[a];
        e.lineTo(s.x - i, s.y - c);
      }
      !this.isOpen() && e.closePath(), this._renderPaintInOrder(e);
    }
  }
  complexity() {
    return this.points.length;
  }
  static async fromElement(e, t, i) {
    return new this(gY(e.getAttribute("points")), lt(lt({}, Vi(wf(e, this.ATTRIBUTE_NAMES, i), _Y)), t));
  }
  static fromObject(e) {
    return this._fromObject(e, { extraParam: "points" });
  }
}
it(Qu, "ownDefaults", H8), it(Qu, "type", "Polyline"), it(Qu, "layoutProperties", [h0, p0, "strokeLineCap", "strokeLineJoin", "strokeMiterLimit", "strokeWidth", "strokeUniform", "points"]), it(Qu, "cacheProperties", [...Cf, "points"]), it(Qu, "ATTRIBUTE_NAMES", [...Qh]), pn.setClass(Qu), pn.setSVGClass(Qu);
class ob extends Qu {
  isOpen() {
    return !1;
  }
}
it(ob, "ownDefaults", H8), it(ob, "type", "Polygon"), pn.setClass(ob), pn.setSVGClass(ob);
const z8 = ["fontSize", "fontWeight", "fontFamily", "fontStyle"], V8 = ["underline", "overline", "linethrough"], q8 = [...z8, "lineHeight", "text", "charSpacing", "textAlign", "styles", "path", "pathStartOffset", "pathSide", "pathAlign"], G8 = [...q8, ...V8, "textBackgroundColor", "direction"], yY = [...z8, ...V8, Zs, "strokeWidth", ta, "deltaY", "textBackgroundColor"], vY = { _reNewline: nT, _reSpacesAndTabs: /[ \t\r]/g, _reSpaceAndTab: /[ \t\r]/, _reWords: /\S+/g, fontSize: 40, fontWeight: "normal", fontFamily: "Times New Roman", underline: !1, overline: !1, linethrough: !1, textAlign: ti, fontStyle: "normal", lineHeight: 1.16, superscript: { size: 0.6, baseline: -0.35 }, subscript: { size: 0.6, baseline: 0.11 }, textBackgroundColor: "", stroke: null, shadow: null, path: void 0, pathStartOffset: 0, pathSide: ti, pathAlign: "baseline", _fontSizeFraction: 0.222, offsets: { underline: 0.1, linethrough: -0.315, overline: -0.88 }, _fontSizeMult: 1.13, charSpacing: 0, deltaY: 0, direction: "ltr", CACHE_FONT_SIZE: 400, MIN_TEXT_WIDTH: 2 }, sd = "justify", u2 = "justify-left", g1 = "justify-right", _1 = "justify-center";
class W8 extends es {
  isEmptyStyles(e) {
    if (!this.styles || e !== void 0 && !this.styles[e]) return !0;
    const t = e === void 0 ? this.styles : { line: this.styles[e] };
    for (const i in t) for (const c in t[i]) for (const a in t[i][c]) return !1;
    return !0;
  }
  styleHas(e, t) {
    if (!this.styles || t !== void 0 && !this.styles[t]) return !1;
    const i = t === void 0 ? this.styles : { 0: this.styles[t] };
    for (const c in i) for (const a in i[c]) if (i[c][a][e] !== void 0) return !0;
    return !1;
  }
  cleanStyle(e) {
    if (!this.styles) return !1;
    const t = this.styles;
    let i, c, a = 0, s = !0, r = 0;
    for (const l in t) {
      i = 0;
      for (const d in t[l]) {
        const f = t[l][d] || {};
        a++, f[e] !== void 0 ? (c ? f[e] !== c && (s = !1) : c = f[e], f[e] === this[e] && delete f[e]) : s = !1, Object.keys(f).length !== 0 ? i++ : delete t[l][d];
      }
      i === 0 && delete t[l];
    }
    for (let l = 0; l < this._textLines.length; l++) r += this._textLines[l].length;
    s && a === r && (this[e] = c, this.removeStyle(e));
  }
  removeStyle(e) {
    if (!this.styles) return;
    const t = this.styles;
    let i, c, a;
    for (c in t) {
      for (a in i = t[c], i) delete i[a][e], Object.keys(i[a]).length === 0 && delete i[a];
      Object.keys(i).length === 0 && delete t[c];
    }
  }
  _extendStyles(e, t) {
    const { lineIndex: i, charIndex: c } = this.get2DCursorLocation(e);
    this._getLineStyle(i) || this._setLineStyle(i);
    const a = lT(lt(lt({}, this._getStyleDeclaration(i, c)), t), (s) => s !== void 0);
    this._setStyleDeclaration(i, c, a);
  }
  getSelectionStyles(e, t, i) {
    const c = [];
    for (let a = e; a < (t || e); a++) c.push(this.getStyleAtPosition(a, i));
    return c;
  }
  getStyleAtPosition(e, t) {
    const { lineIndex: i, charIndex: c } = this.get2DCursorLocation(e);
    return t ? this.getCompleteStyleDeclaration(i, c) : this._getStyleDeclaration(i, c);
  }
  setSelectionStyles(e, t, i) {
    for (let c = t; c < (i || t); c++) this._extendStyles(c, e);
    this._forceClearCache = !0;
  }
  _getStyleDeclaration(e, t) {
    var i;
    const c = this.styles && this.styles[e];
    return c && (i = c[t]) !== null && i !== void 0 ? i : {};
  }
  getCompleteStyleDeclaration(e, t) {
    return lt(lt({}, Rm(this, this.constructor._styleProperties)), this._getStyleDeclaration(e, t));
  }
  _setStyleDeclaration(e, t, i) {
    this.styles[e][t] = i;
  }
  _deleteStyleDeclaration(e, t) {
    delete this.styles[e][t];
  }
  _getLineStyle(e) {
    return !!this.styles[e];
  }
  _setLineStyle(e) {
    this.styles[e] = {};
  }
  _deleteLineStyle(e) {
    delete this.styles[e];
  }
}
it(W8, "_styleProperties", yY);
const bY = /  +/g, EY = /"/g;
function Ew(n, e, t, i, c) {
  return "		".concat(function(a, s) {
    let { left: r, top: l, width: d, height: f } = s, h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Br.NUM_FRACTION_DIGITS;
    const p = k1(ta, a, !1), [g, _, b, v] = [r, l, d, f].map((E) => zi(E, h));
    return "<rect ".concat(p, ' x="').concat(g, '" y="').concat(_, '" width="').concat(b, '" height="').concat(v, '"></rect>');
  }(n, { left: e, top: t, width: i, height: c }), `
`);
}
const SY = ["textAnchor", "textDecoration", "dx", "dy", "top", "left", "fontSize", "strokeWidth"];
let Sw;
class Za extends W8 {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), Za.ownDefaults);
  }
  constructor(e, t) {
    super(), it(this, "__charBounds", []), Object.assign(this, Za.ownDefaults), this.setOptions(t), this.styles || (this.styles = {}), this.text = e, this.initialized = !0, this.path && this.setPathInfo(), this.initDimensions(), this.setCoords();
  }
  setPathInfo() {
    const e = this.path;
    e && (e.segmentsInfo = vT(e.path));
  }
  _splitText() {
    const e = this._splitTextIntoLines(this.text);
    return this.textLines = e.lines, this._textLines = e.graphemeLines, this._unwrappedTextLines = e._unwrappedLines, this._text = e.graphemeText, e;
  }
  initDimensions() {
    this._splitText(), this._clearCache(), this.dirty = !0, this.path ? (this.width = this.path.width, this.height = this.path.height) : (this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH, this.height = this.calcTextHeight()), this.textAlign.includes(sd) && this.enlargeSpaces();
  }
  enlargeSpaces() {
    let e, t, i, c, a, s, r;
    for (let l = 0, d = this._textLines.length; l < d; l++) if ((this.textAlign === sd || l !== d - 1 && !this.isEndOfWrapping(l)) && (c = 0, a = this._textLines[l], t = this.getLineWidth(l), t < this.width && (r = this.textLines[l].match(this._reSpacesAndTabs)))) {
      i = r.length, e = (this.width - t) / i;
      for (let f = 0; f <= a.length; f++) s = this.__charBounds[l][f], this._reSpaceAndTab.test(a[f]) ? (s.width += e, s.kernedWidth += e, s.left += c, c += e) : s.left += c;
    }
  }
  isEndOfWrapping(e) {
    return e === this._textLines.length - 1;
  }
  missingNewlineOffset(e) {
    return 1;
  }
  get2DCursorLocation(e, t) {
    const i = t ? this._unwrappedTextLines : this._textLines;
    let c;
    for (c = 0; c < i.length; c++) {
      if (e <= i[c].length) return { lineIndex: c, charIndex: e };
      e -= i[c].length + this.missingNewlineOffset(c, t);
    }
    return { lineIndex: c - 1, charIndex: i[c - 1].length < e ? i[c - 1].length : e };
  }
  toString() {
    return "#<Text (".concat(this.complexity(), '): { "text": "').concat(this.text, '", "fontFamily": "').concat(this.fontFamily, '" }>');
  }
  _getCacheCanvasDimensions() {
    const e = super._getCacheCanvasDimensions(), t = this.fontSize;
    return e.width += t * e.zoomX, e.height += t * e.zoomY, e;
  }
  _render(e) {
    const t = this.path;
    t && !t.isNotVisible() && t._render(e), this._setTextStyles(e), this._renderTextLinesBackground(e), this._renderTextDecoration(e, "underline"), this._renderText(e), this._renderTextDecoration(e, "overline"), this._renderTextDecoration(e, "linethrough");
  }
  _renderText(e) {
    this.paintFirst === Zs ? (this._renderTextStroke(e), this._renderTextFill(e)) : (this._renderTextFill(e), this._renderTextStroke(e));
  }
  _setTextStyles(e, t, i) {
    if (e.textBaseline = "alphabetic", this.path) switch (this.pathAlign) {
      case pr:
        e.textBaseline = "middle";
        break;
      case "ascender":
        e.textBaseline = Ks;
        break;
      case "descender":
        e.textBaseline = rx;
    }
    e.font = this._getFontDeclaration(t, i);
  }
  calcTextWidth() {
    let e = this.getLineWidth(0);
    for (let t = 1, i = this._textLines.length; t < i; t++) {
      const c = this.getLineWidth(t);
      c > e && (e = c);
    }
    return e;
  }
  _renderTextLine(e, t, i, c, a, s) {
    this._renderChars(e, t, i, c, a, s);
  }
  _renderTextLinesBackground(e) {
    if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) return;
    const t = e.fillStyle, i = this._getLeftOffset();
    let c = this._getTopOffset();
    for (let a = 0, s = this._textLines.length; a < s; a++) {
      const r = this.getHeightOfLine(a);
      if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", a)) {
        c += r;
        continue;
      }
      const l = this._textLines[a].length, d = this._getLineLeftOffset(a);
      let f, h, p = 0, g = 0, _ = this.getValueOfPropertyAt(a, 0, "textBackgroundColor");
      for (let b = 0; b < l; b++) {
        const v = this.__charBounds[a][b];
        h = this.getValueOfPropertyAt(a, b, "textBackgroundColor"), this.path ? (e.save(), e.translate(v.renderLeft, v.renderTop), e.rotate(v.angle), e.fillStyle = h, h && e.fillRect(-v.width / 2, -r / this.lineHeight * (1 - this._fontSizeFraction), v.width, r / this.lineHeight), e.restore()) : h !== _ ? (f = i + d + g, this.direction === "rtl" && (f = this.width - f - p), e.fillStyle = _, _ && e.fillRect(f, c, p, r / this.lineHeight), g = v.left, p = v.width, _ = h) : p += v.kernedWidth;
      }
      h && !this.path && (f = i + d + g, this.direction === "rtl" && (f = this.width - f - p), e.fillStyle = h, e.fillRect(f, c, p, r / this.lineHeight)), c += r;
    }
    e.fillStyle = t, this._removeShadow(e);
  }
  _measureChar(e, t, i, c) {
    const a = h1.getFontCache(t), s = this._getFontDeclaration(t), r = i + e, l = i && s === this._getFontDeclaration(c), d = t.fontSize / this.CACHE_FONT_SIZE;
    let f, h, p, g;
    if (i && a[i] !== void 0 && (p = a[i]), a[e] !== void 0 && (g = f = a[e]), l && a[r] !== void 0 && (h = a[r], g = h - p), f === void 0 || p === void 0 || h === void 0) {
      const _ = function() {
        return Sw || (Sw = ac({ width: 0, height: 0 }).getContext("2d")), Sw;
      }();
      this._setTextStyles(_, t, !0), f === void 0 && (g = f = _.measureText(e).width, a[e] = f), p === void 0 && l && i && (p = _.measureText(i).width, a[i] = p), l && h === void 0 && (h = _.measureText(r).width, a[r] = h, g = h - p);
    }
    return { width: f * d, kernedWidth: g * d };
  }
  getHeightOfChar(e, t) {
    return this.getValueOfPropertyAt(e, t, "fontSize");
  }
  measureLine(e) {
    const t = this._measureLine(e);
    return this.charSpacing !== 0 && (t.width -= this._getWidthOfCharSpacing()), t.width < 0 && (t.width = 0), t;
  }
  _measureLine(e) {
    let t, i, c = 0;
    const a = this.pathSide === yo, s = this.path, r = this._textLines[e], l = r.length, d = new Array(l);
    this.__charBounds[e] = d;
    for (let f = 0; f < l; f++) {
      const h = r[f];
      i = this._getGraphemeBox(h, e, f, t), d[f] = i, c += i.kernedWidth, t = h;
    }
    if (d[l] = { left: i ? i.left + i.width : 0, width: 0, kernedWidth: 0, height: this.fontSize, deltaY: 0 }, s && s.segmentsInfo) {
      let f = 0;
      const h = s.segmentsInfo[s.segmentsInfo.length - 1].length;
      switch (this.textAlign) {
        case ti:
          f = a ? h - c : 0;
          break;
        case pr:
          f = (h - c) / 2;
          break;
        case yo:
          f = a ? 0 : h - c;
      }
      f += this.pathStartOffset * (a ? -1 : 1);
      for (let p = a ? l - 1 : 0; a ? p >= 0 : p < l; a ? p-- : p++) i = d[p], f > h ? f %= h : f < 0 && (f += h), this._setGraphemeOnPath(f, i), f += i.kernedWidth;
    }
    return { width: c, numOfSpaces: 0 };
  }
  _setGraphemeOnPath(e, t) {
    const i = e + t.kernedWidth / 2, c = this.path, a = R8(c.path, i, c.segmentsInfo);
    t.renderLeft = a.x - c.pathOffset.x, t.renderTop = a.y - c.pathOffset.y, t.angle = a.angle + (this.pathSide === yo ? Math.PI : 0);
  }
  _getGraphemeBox(e, t, i, c, a) {
    const s = this.getCompleteStyleDeclaration(t, i), r = c ? this.getCompleteStyleDeclaration(t, i - 1) : {}, l = this._measureChar(e, s, c, r);
    let d, f = l.kernedWidth, h = l.width;
    this.charSpacing !== 0 && (d = this._getWidthOfCharSpacing(), h += d, f += d);
    const p = { width: h, left: 0, height: s.fontSize, kernedWidth: f, deltaY: s.deltaY };
    if (i > 0 && !a) {
      const g = this.__charBounds[t][i - 1];
      p.left = g.left + g.width + l.kernedWidth - l.width;
    }
    return p;
  }
  getHeightOfLine(e) {
    if (this.__lineHeights[e]) return this.__lineHeights[e];
    let t = this.getHeightOfChar(e, 0);
    for (let i = 1, c = this._textLines[e].length; i < c; i++) t = Math.max(this.getHeightOfChar(e, i), t);
    return this.__lineHeights[e] = t * this.lineHeight * this._fontSizeMult;
  }
  calcTextHeight() {
    let e, t = 0;
    for (let i = 0, c = this._textLines.length; i < c; i++) e = this.getHeightOfLine(i), t += i === c - 1 ? e / this.lineHeight : e;
    return t;
  }
  _getLeftOffset() {
    return this.direction === "ltr" ? -this.width / 2 : this.width / 2;
  }
  _getTopOffset() {
    return -this.height / 2;
  }
  _renderTextCommon(e, t) {
    e.save();
    let i = 0;
    const c = this._getLeftOffset(), a = this._getTopOffset();
    for (let s = 0, r = this._textLines.length; s < r; s++) {
      const l = this.getHeightOfLine(s), d = l / this.lineHeight, f = this._getLineLeftOffset(s);
      this._renderTextLine(t, e, this._textLines[s], c + f, a + i + d, s), i += l;
    }
    e.restore();
  }
  _renderTextFill(e) {
    (this.fill || this.styleHas(ta)) && this._renderTextCommon(e, "fillText");
  }
  _renderTextStroke(e) {
    (this.stroke && this.strokeWidth !== 0 || !this.isEmptyStyles()) && (this.shadow && !this.shadow.affectStroke && this._removeShadow(e), e.save(), this._setLineDash(e, this.strokeDashArray), e.beginPath(), this._renderTextCommon(e, "strokeText"), e.closePath(), e.restore());
  }
  _renderChars(e, t, i, c, a, s) {
    const r = this.getHeightOfLine(s), l = this.textAlign.includes(sd), d = this.path, f = !l && this.charSpacing === 0 && this.isEmptyStyles(s) && !d, h = this.direction === "ltr", p = this.direction === "ltr" ? 1 : -1, g = t.direction;
    let _, b, v, E, C, y = "", T = 0;
    if (t.save(), g !== this.direction && (t.canvas.setAttribute("dir", h ? "ltr" : "rtl"), t.direction = h ? "ltr" : "rtl", t.textAlign = h ? ti : yo), a -= r * this._fontSizeFraction / this.lineHeight, f) return this._renderChar(e, t, s, 0, i.join(""), c, a), void t.restore();
    for (let A = 0, k = i.length - 1; A <= k; A++) E = A === k || this.charSpacing || d, y += i[A], v = this.__charBounds[s][A], T === 0 ? (c += p * (v.kernedWidth - v.width), T += v.width) : T += v.kernedWidth, l && !E && this._reSpaceAndTab.test(i[A]) && (E = !0), E || (_ = _ || this.getCompleteStyleDeclaration(s, A), b = this.getCompleteStyleDeclaration(s, A + 1), E = j2(_, b, !1)), E && (d ? (t.save(), t.translate(v.renderLeft, v.renderTop), t.rotate(v.angle), this._renderChar(e, t, s, A, y, -T / 2, 0), t.restore()) : (C = c, this._renderChar(e, t, s, A, y, C, a)), y = "", _ = b, c += p * T, T = 0);
    t.restore();
  }
  _applyPatternGradientTransformText(e) {
    const t = this.width + this.strokeWidth, i = this.height + this.strokeWidth, c = ac({ width: t, height: i }), a = c.getContext("2d");
    return c.width = t, c.height = i, a.beginPath(), a.moveTo(0, 0), a.lineTo(t, 0), a.lineTo(t, i), a.lineTo(0, i), a.closePath(), a.translate(t / 2, i / 2), a.fillStyle = e.toLive(a), this._applyPatternGradientTransform(a, e), a.fill(), a.createPattern(c, "no-repeat");
  }
  handleFiller(e, t, i) {
    let c, a;
    return au(i) ? i.gradientUnits === "percentage" || i.gradientTransform || i.patternTransform ? (c = -this.width / 2, a = -this.height / 2, e.translate(c, a), e[t] = this._applyPatternGradientTransformText(i), { offsetX: c, offsetY: a }) : (e[t] = i.toLive(e), this._applyPatternGradientTransform(e, i)) : (e[t] = i, { offsetX: 0, offsetY: 0 });
  }
  _setStrokeStyles(e, t) {
    let { stroke: i, strokeWidth: c } = t;
    return e.lineWidth = c, e.lineCap = this.strokeLineCap, e.lineDashOffset = this.strokeDashOffset, e.lineJoin = this.strokeLineJoin, e.miterLimit = this.strokeMiterLimit, this.handleFiller(e, "strokeStyle", i);
  }
  _setFillStyles(e, t) {
    let { fill: i } = t;
    return this.handleFiller(e, "fillStyle", i);
  }
  _renderChar(e, t, i, c, a, s, r) {
    const l = this._getStyleDeclaration(i, c), d = this.getCompleteStyleDeclaration(i, c), f = e === "fillText" && d.fill, h = e === "strokeText" && d.stroke && d.strokeWidth;
    if (h || f) {
      if (t.save(), t.font = this._getFontDeclaration(d), l.textBackgroundColor && this._removeShadow(t), l.deltaY && (r += l.deltaY), f) {
        const p = this._setFillStyles(t, d);
        t.fillText(a, s - p.offsetX, r - p.offsetY);
      }
      if (h) {
        const p = this._setStrokeStyles(t, d);
        t.strokeText(a, s - p.offsetX, r - p.offsetY);
      }
      t.restore();
    }
  }
  setSuperscript(e, t) {
    this._setScript(e, t, this.superscript);
  }
  setSubscript(e, t) {
    this._setScript(e, t, this.subscript);
  }
  _setScript(e, t, i) {
    const c = this.get2DCursorLocation(e, !0), a = this.getValueOfPropertyAt(c.lineIndex, c.charIndex, "fontSize"), s = this.getValueOfPropertyAt(c.lineIndex, c.charIndex, "deltaY"), r = { fontSize: a * i.size, deltaY: s + a * i.baseline };
    this.setSelectionStyles(r, e, t);
  }
  _getLineLeftOffset(e) {
    const t = this.getLineWidth(e), i = this.width - t, c = this.textAlign, a = this.direction, s = this.isEndOfWrapping(e);
    let r = 0;
    return c === sd || c === _1 && !s || c === g1 && !s || c === u2 && !s ? 0 : (c === pr && (r = i / 2), c === yo && (r = i), c === _1 && (r = i / 2), c === g1 && (r = i), a === "rtl" && (c === yo || c === sd || c === g1 ? r = 0 : c === ti || c === u2 ? r = -i : c !== pr && c !== _1 || (r = -i / 2)), r);
  }
  _clearCache() {
    this._forceClearCache = !1, this.__lineWidths = [], this.__lineHeights = [], this.__charBounds = [];
  }
  getLineWidth(e) {
    if (this.__lineWidths[e] !== void 0) return this.__lineWidths[e];
    const { width: t } = this.measureLine(e);
    return this.__lineWidths[e] = t, t;
  }
  _getWidthOfCharSpacing() {
    return this.charSpacing !== 0 ? this.fontSize * this.charSpacing / 1e3 : 0;
  }
  getValueOfPropertyAt(e, t, i) {
    var c;
    return (c = this._getStyleDeclaration(e, t)[i]) !== null && c !== void 0 ? c : this[i];
  }
  _renderTextDecoration(e, t) {
    if (!this[t] && !this.styleHas(t)) return;
    let i = this._getTopOffset();
    const c = this._getLeftOffset(), a = this.path, s = this._getWidthOfCharSpacing(), r = this.offsets[t];
    for (let l = 0, d = this._textLines.length; l < d; l++) {
      const f = this.getHeightOfLine(l);
      if (!this[t] && !this.styleHas(t, l)) {
        i += f;
        continue;
      }
      const h = this._textLines[l], p = f / this.lineHeight, g = this._getLineLeftOffset(l);
      let _, b, v = 0, E = 0, C = this.getValueOfPropertyAt(l, 0, t), y = this.getValueOfPropertyAt(l, 0, ta);
      const T = i + p * (1 - this._fontSizeFraction);
      let A = this.getHeightOfChar(l, 0), k = this.getValueOfPropertyAt(l, 0, "deltaY");
      for (let j = 0, I = h.length; j < I; j++) {
        const B = this.__charBounds[l][j];
        _ = this.getValueOfPropertyAt(l, j, t), b = this.getValueOfPropertyAt(l, j, ta);
        const U = this.getHeightOfChar(l, j), H = this.getValueOfPropertyAt(l, j, "deltaY");
        if (a && _ && b) e.save(), e.fillStyle = y, e.translate(B.renderLeft, B.renderTop), e.rotate(B.angle), e.fillRect(-B.kernedWidth / 2, r * U + H, B.kernedWidth, this.fontSize / 15), e.restore();
        else if ((_ !== C || b !== y || U !== A || H !== k) && E > 0) {
          let Q = c + g + v;
          this.direction === "rtl" && (Q = this.width - Q - E), C && y && (e.fillStyle = y, e.fillRect(Q, T + r * A + k, E, this.fontSize / 15)), v = B.left, E = B.width, C = _, y = b, A = U, k = H;
        } else E += B.kernedWidth;
      }
      let N = c + g + v;
      this.direction === "rtl" && (N = this.width - N - E), e.fillStyle = b, _ && b && e.fillRect(N, T + r * A + k, E - s, this.fontSize / 15), i += f;
    }
    this._removeShadow(e);
  }
  _getFontDeclaration() {
    let { fontFamily: e = this.fontFamily, fontStyle: t = this.fontStyle, fontWeight: i = this.fontWeight, fontSize: c = this.fontSize } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    const s = e.includes("'") || e.includes('"') || e.includes(",") || Za.genericFonts.includes(e.toLowerCase()) ? e : '"'.concat(e, '"');
    return [t, i, "".concat(a ? this.CACHE_FONT_SIZE : c, "px"), s].join(" ");
  }
  render(e) {
    this.visible && (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (this._forceClearCache && this.initDimensions(), super.render(e)));
  }
  graphemeSplit(e) {
    return P2(e);
  }
  _splitTextIntoLines(e) {
    const t = e.split(this._reNewline), i = new Array(t.length), c = [`
`];
    let a = [];
    for (let s = 0; s < t.length; s++) i[s] = this.graphemeSplit(t[s]), a = a.concat(i[s], c);
    return a.pop(), { _unwrappedLines: i, lines: t, graphemeText: a, graphemeLines: i };
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return lt(lt({}, super.toObject([...G8, ...e])), {}, { styles: v8(this.styles, this.text) }, this.path ? { path: this.path.toObject() } : {});
  }
  set(e, t) {
    const { textLayoutProperties: i } = this.constructor;
    super.set(e, t);
    let c = !1, a = !1;
    if (typeof e == "object") for (const s in e) s === "path" && this.setPathInfo(), c = c || i.includes(s), a = a || s === "path";
    else c = i.includes(e), a = e === "path";
    return a && this.setPathInfo(), c && this.initialized && (this.initDimensions(), this.setCoords()), this;
  }
  complexity() {
    return 1;
  }
  static async fromElement(e, t, i) {
    const c = wf(e, Za.ATTRIBUTE_NAMES, i), a = lt(lt({}, t), c), { textAnchor: s = ti, textDecoration: r = "", dx: l = 0, dy: d = 0, top: f = 0, left: h = 0, fontSize: p = tT, strokeWidth: g = 1 } = a, _ = Vi(a, SY), b = new this((e.textContent || "").replace(/^\s+|\s+$|\n+/g, "").replace(/\s+/g, " "), lt({ left: h + l, top: f + d, underline: r.includes("underline"), overline: r.includes("overline"), linethrough: r.includes("line-through"), strokeWidth: 0, fontSize: p }, _)), v = b.getScaledHeight() / b.height, E = ((b.height + b.strokeWidth) * b.lineHeight - b.height) * v, C = b.getScaledHeight() + E;
    let y = 0;
    return s === pr && (y = b.getScaledWidth() / 2), s === yo && (y = b.getScaledWidth()), b.set({ left: b.left - y, top: b.top - (C - b.fontSize * (0.07 + b._fontSizeFraction)) / b.lineHeight, strokeWidth: g }), b;
  }
  static fromObject(e) {
    return this._fromObject(lt(lt({}, e), {}, { styles: b8(e.styles || {}, e.text) }), { extraParam: "text" });
  }
}
it(Za, "textLayoutProperties", q8), it(Za, "cacheProperties", [...Cf, ...G8]), it(Za, "ownDefaults", vY), it(Za, "type", "Text"), it(Za, "genericFonts", ["serif", "sans-serif", "monospace", "cursive", "fantasy", "system-ui", "ui-serif", "ui-sans-serif", "ui-monospace", "ui-rounded", "math", "emoji", "fangsong"]), it(Za, "ATTRIBUTE_NAMES", Qh.concat("x", "y", "dx", "dy", "font-family", "font-style", "font-weight", "font-size", "letter-spacing", "text-decoration", "text-anchor")), p8(Za, [class extends i8 {
  _toSVG() {
    const n = this._getSVGLeftTopOffsets(), e = this._getSVGTextAndBg(n.textTop, n.textLeft);
    return this._wrapSVGTextAndBg(e);
  }
  toSVG(n) {
    return this._createBaseSVGMarkup(this._toSVG(), { reviver: n, noStyle: !0, withShadow: !0 });
  }
  _getSVGLeftTopOffsets() {
    return { textLeft: -this.width / 2, textTop: -this.height / 2, lineTop: this.getHeightOfLine(0) };
  }
  _wrapSVGTextAndBg(n) {
    let { textBgRects: e, textSpans: t } = n;
    const i = this.getSvgTextDecoration(this);
    return [e.join(""), '		<text xml:space="preserve" ', this.fontFamily ? 'font-family="'.concat(this.fontFamily.replace(EY, "'"), '" ') : "", this.fontSize ? 'font-size="'.concat(this.fontSize, '" ') : "", this.fontStyle ? 'font-style="'.concat(this.fontStyle, '" ') : "", this.fontWeight ? 'font-weight="'.concat(this.fontWeight, '" ') : "", i ? 'text-decoration="'.concat(i, '" ') : "", this.direction === "rtl" ? 'direction="'.concat(this.direction, '" ') : "", 'style="', this.getSvgStyles(!0), '"', this.addPaintOrder(), " >", t.join(""), `</text>
`];
  }
  _getSVGTextAndBg(n, e) {
    const t = [], i = [];
    let c, a = n;
    this.backgroundColor && i.push(...Ew(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
    for (let s = 0, r = this._textLines.length; s < r; s++) c = this._getLineLeftOffset(s), this.direction === "rtl" && (c += this.width), (this.textBackgroundColor || this.styleHas("textBackgroundColor", s)) && this._setSVGTextLineBg(i, s, e + c, a), this._setSVGTextLineText(t, s, e + c, a), a += this.getHeightOfLine(s);
    return { textSpans: t, textBgRects: i };
  }
  _createTextCharSpan(n, e, t, i) {
    const c = this.getSvgSpanStyles(e, n !== n.trim() || !!n.match(bY)), a = c ? 'style="'.concat(c, '"') : "", s = e.deltaY, r = s ? ' dy="'.concat(zi(s, Br.NUM_FRACTION_DIGITS), '" ') : "";
    return '<tspan x="'.concat(zi(t, Br.NUM_FRACTION_DIGITS), '" y="').concat(zi(i, Br.NUM_FRACTION_DIGITS), '" ').concat(r).concat(a, ">").concat(y8(n), "</tspan>");
  }
  _setSVGTextLineText(n, e, t, i) {
    const c = this.getHeightOfLine(e), a = this.textAlign.includes(sd), s = this._textLines[e];
    let r, l, d, f, h, p = "", g = 0;
    i += c * (1 - this._fontSizeFraction) / this.lineHeight;
    for (let _ = 0, b = s.length - 1; _ <= b; _++) h = _ === b || this.charSpacing, p += s[_], d = this.__charBounds[e][_], g === 0 ? (t += d.kernedWidth - d.width, g += d.width) : g += d.kernedWidth, a && !h && this._reSpaceAndTab.test(s[_]) && (h = !0), h || (r = r || this.getCompleteStyleDeclaration(e, _), l = this.getCompleteStyleDeclaration(e, _ + 1), h = j2(r, l, !0)), h && (f = this._getStyleDeclaration(e, _), n.push(this._createTextCharSpan(p, f, t, i)), p = "", r = l, this.direction === "rtl" ? t -= g : t += g, g = 0);
  }
  _setSVGTextLineBg(n, e, t, i) {
    const c = this._textLines[e], a = this.getHeightOfLine(e) / this.lineHeight;
    let s, r = 0, l = 0, d = this.getValueOfPropertyAt(e, 0, "textBackgroundColor");
    for (let f = 0; f < c.length; f++) {
      const { left: h, width: p, kernedWidth: g } = this.__charBounds[e][f];
      s = this.getValueOfPropertyAt(e, f, "textBackgroundColor"), s !== d ? (d && n.push(...Ew(d, t + l, i, r, a)), l = h, r = p, d = s) : r += g;
    }
    s && n.push(...Ew(d, t + l, i, r, a));
  }
  _getSVGLineTopOffset(n) {
    let e, t = 0;
    for (e = 0; e < n; e++) t += this.getHeightOfLine(e);
    const i = this.getHeightOfLine(e);
    return { lineTop: t, offset: (this._fontSizeMult - this._fontSizeFraction) * i / (this.lineHeight * this._fontSizeMult) };
  }
  getSvgStyles(n) {
    return "".concat(super.getSvgStyles(n), " white-space: pre;");
  }
  getSvgSpanStyles(n, e) {
    const { fontFamily: t, strokeWidth: i, stroke: c, fill: a, fontSize: s, fontStyle: r, fontWeight: l, deltaY: d } = n, f = this.getSvgTextDecoration(n);
    return [c ? k1(Zs, c) : "", i ? "stroke-width: ".concat(i, "; ") : "", t ? "font-family: ".concat(t.includes("'") || t.includes('"') ? t : "'".concat(t, "'"), "; ") : "", s ? "font-size: ".concat(s, "px; ") : "", r ? "font-style: ".concat(r, "; ") : "", l ? "font-weight: ".concat(l, "; ") : "", f && "text-decoration: ".concat(f, "; "), a ? k1(ta, a) : "", d ? "baseline-shift: ".concat(-d, "; ") : "", e ? "white-space: pre; " : ""].join("");
  }
  getSvgTextDecoration(n) {
    return ["overline", "underline", "line-through"].filter((e) => n[e.replace("-", "")]).join(" ");
  }
}]), pn.setClass(Za), pn.setSVGClass(Za);
class CY {
  constructor(e) {
    it(this, "target", void 0), it(this, "__mouseDownInPlace", !1), it(this, "__dragStartFired", !1), it(this, "__isDraggingOver", !1), it(this, "__dragStartSelection", void 0), it(this, "__dragImageDisposer", void 0), it(this, "_dispose", void 0), this.target = e;
    const t = [this.target.on("dragenter", this.dragEnterHandler.bind(this)), this.target.on("dragover", this.dragOverHandler.bind(this)), this.target.on("dragleave", this.dragLeaveHandler.bind(this)), this.target.on("dragend", this.dragEndHandler.bind(this)), this.target.on("drop", this.dropHandler.bind(this))];
    this._dispose = () => {
      t.forEach((i) => i()), this._dispose = void 0;
    };
  }
  isPointerOverSelection(e) {
    const t = this.target, i = t.getSelectionStartFromPointer(e);
    return t.isEditing && i >= t.selectionStart && i <= t.selectionEnd && t.selectionStart < t.selectionEnd;
  }
  start(e) {
    return this.__mouseDownInPlace = this.isPointerOverSelection(e);
  }
  isActive() {
    return this.__mouseDownInPlace;
  }
  end(e) {
    const t = this.isActive();
    return t && !this.__dragStartFired && (this.target.setCursorByClick(e), this.target.initDelayedCursor(!0)), this.__mouseDownInPlace = !1, this.__dragStartFired = !1, this.__isDraggingOver = !1, t;
  }
  getDragStartSelection() {
    return this.__dragStartSelection;
  }
  setDragImage(e, t) {
    var i;
    let { selectionStart: c, selectionEnd: a } = t;
    const s = this.target, r = s.canvas, l = new St(s.flipX ? -1 : 1, s.flipY ? -1 : 1), d = s._getCursorBoundaries(c), f = new St(d.left + d.leftOffset, d.top + d.topOffset).multiply(l).transform(s.calcTransformMatrix()), h = r.getScenePoint(e).subtract(f), p = s.getCanvasRetinaScaling(), g = s.getBoundingRect(), _ = f.subtract(new St(g.left, g.top)), b = r.viewportTransform, v = _.add(h).transform(b, !0), E = s.backgroundColor, C = gT(s.styles);
    s.backgroundColor = "";
    const y = { stroke: "transparent", fill: "transparent", textBackgroundColor: "transparent" };
    s.setSelectionStyles(y, 0, c), s.setSelectionStyles(y, a, s.text.length), s.dirty = !0;
    const T = s.toCanvasElement({ enableRetinaScaling: r.enableRetinaScaling, viewportTransform: !0 });
    s.backgroundColor = E, s.styles = C, s.dirty = !0, l2(T, { position: "fixed", left: "".concat(-T.width, "px"), border: Qs, width: "".concat(T.width / p, "px"), height: "".concat(T.height / p, "px") }), this.__dragImageDisposer && this.__dragImageDisposer(), this.__dragImageDisposer = () => {
      T.remove();
    }, tc(e.target || this.target.hiddenTextarea).body.appendChild(T), (i = e.dataTransfer) === null || i === void 0 || i.setDragImage(T, v.x, v.y);
  }
  onDragStart(e) {
    this.__dragStartFired = !0;
    const t = this.target, i = this.isActive();
    if (i && e.dataTransfer) {
      const c = this.__dragStartSelection = { selectionStart: t.selectionStart, selectionEnd: t.selectionEnd }, a = t._text.slice(c.selectionStart, c.selectionEnd).join(""), s = lt({ text: t.text, value: a }, c);
      e.dataTransfer.setData("text/plain", a), e.dataTransfer.setData("application/fabric", JSON.stringify({ value: a, styles: t.getSelectionStyles(c.selectionStart, c.selectionEnd, !0) })), e.dataTransfer.effectAllowed = "copyMove", this.setDragImage(e, s);
    }
    return t.abortCursorAnimation(), i;
  }
  canDrop(e) {
    if (this.target.editable && !this.target.getActiveControl() && !e.defaultPrevented) {
      if (this.isActive() && this.__dragStartSelection) {
        const t = this.target.getSelectionStartFromPointer(e), i = this.__dragStartSelection;
        return t < i.selectionStart || t > i.selectionEnd;
      }
      return !0;
    }
    return !1;
  }
  targetCanDrop(e) {
    return this.target.canDrop(e);
  }
  dragEnterHandler(e) {
    let { e: t } = e;
    const i = this.targetCanDrop(t);
    !this.__isDraggingOver && i && (this.__isDraggingOver = !0);
  }
  dragOverHandler(e) {
    const { e: t } = e, i = this.targetCanDrop(t);
    !this.__isDraggingOver && i ? this.__isDraggingOver = !0 : this.__isDraggingOver && !i && (this.__isDraggingOver = !1), this.__isDraggingOver && (t.preventDefault(), e.canDrop = !0, e.dropTarget = this.target);
  }
  dragLeaveHandler() {
    (this.__isDraggingOver || this.isActive()) && (this.__isDraggingOver = !1);
  }
  dropHandler(e) {
    var t;
    const { e: i } = e, c = i.defaultPrevented;
    this.__isDraggingOver = !1, i.preventDefault();
    let a = (t = i.dataTransfer) === null || t === void 0 ? void 0 : t.getData("text/plain");
    if (a && !c) {
      const s = this.target, r = s.canvas;
      let l = s.getSelectionStartFromPointer(i);
      const { styles: d } = i.dataTransfer.types.includes("application/fabric") ? JSON.parse(i.dataTransfer.getData("application/fabric")) : {}, f = a[Math.max(0, a.length - 1)], h = 0;
      if (this.__dragStartSelection) {
        const p = this.__dragStartSelection.selectionStart, g = this.__dragStartSelection.selectionEnd;
        l > p && l <= g ? l = p : l > g && (l -= g - p), s.removeChars(p, g), delete this.__dragStartSelection;
      }
      s._reNewline.test(f) && (s._reNewline.test(s._text[l]) || l === s._text.length) && (a = a.trimEnd()), e.didDrop = !0, e.dropTarget = s, s.insertChars(a, d, l), r.setActiveObject(s), s.enterEditing(i), s.selectionStart = Math.min(l + h, s._text.length), s.selectionEnd = Math.min(s.selectionStart + a.length, s._text.length), s.hiddenTextarea.value = s.text, s._updateTextarea(), s.hiddenTextarea.focus(), s.fire(Qb, { index: l + h, action: "drop" }), r.fire("text:changed", { target: s }), r.contextTopDirty = !0, r.requestRenderAll();
    }
  }
  dragEndHandler(e) {
    let { e: t } = e;
    if (this.isActive() && this.__dragStartFired && this.__dragStartSelection) {
      var i;
      const c = this.target, a = this.target.canvas, { selectionStart: s, selectionEnd: r } = this.__dragStartSelection, l = ((i = t.dataTransfer) === null || i === void 0 ? void 0 : i.dropEffect) || Qs;
      l === Qs ? (c.selectionStart = s, c.selectionEnd = r, c._updateTextarea(), c.hiddenTextarea.focus()) : (c.clearContextTop(), l === "move" && (c.removeChars(s, r), c.selectionStart = c.selectionEnd = s, c.hiddenTextarea && (c.hiddenTextarea.value = c.text), c._updateTextarea(), c.fire(Qb, { index: s, action: "dragend" }), a.fire("text:changed", { target: c }), a.requestRenderAll()), c.exitEditing());
    }
    this.__dragImageDisposer && this.__dragImageDisposer(), delete this.__dragImageDisposer, delete this.__dragStartSelection, this.__isDraggingOver = !1;
  }
  dispose() {
    this._dispose && this._dispose();
  }
}
const sO = /[ \n\.,;!\?\-]/;
class wY extends Za {
  constructor() {
    super(...arguments), it(this, "_currentCursorOpacity", 1);
  }
  initBehavior() {
    this._tick = this._tick.bind(this), this._onTickComplete = this._onTickComplete.bind(this), this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
  }
  onDeselect(e) {
    return this.isEditing && this.exitEditing(), this.selected = !1, super.onDeselect(e);
  }
  _animateCursor(e) {
    let { toValue: t, duration: i, delay: c, onComplete: a } = e;
    return pT({ startValue: this._currentCursorOpacity, endValue: t, duration: i, delay: c, onComplete: a, abort: () => !this.canvas || this.selectionStart !== this.selectionEnd, onChange: (s) => {
      this._currentCursorOpacity = s, this.renderCursorOrSelection();
    } });
  }
  _tick(e) {
    this._currentTickState = this._animateCursor({ toValue: 0, duration: this.cursorDuration / 2, delay: Math.max(e || 0, 100), onComplete: this._onTickComplete });
  }
  _onTickComplete() {
    var e;
    (e = this._currentTickCompleteState) === null || e === void 0 || e.abort(), this._currentTickCompleteState = this._animateCursor({ toValue: 1, duration: this.cursorDuration, onComplete: this._tick });
  }
  initDelayedCursor(e) {
    this.abortCursorAnimation(), this._tick(e ? 0 : this.cursorDelay);
  }
  abortCursorAnimation() {
    let e = !1;
    [this._currentTickState, this._currentTickCompleteState].forEach((t) => {
      t && !t.isDone() && (e = !0, t.abort());
    }), this._currentCursorOpacity = 1, e && this.clearContextTop();
  }
  restartCursorIfNeeded() {
    [this._currentTickState, this._currentTickCompleteState].some((e) => !e || e.isDone()) && this.initDelayedCursor();
  }
  selectAll() {
    return this.selectionStart = 0, this.selectionEnd = this._text.length, this._fireSelectionChanged(), this._updateTextarea(), this;
  }
  getSelectedText() {
    return this._text.slice(this.selectionStart, this.selectionEnd).join("");
  }
  findWordBoundaryLeft(e) {
    let t = 0, i = e - 1;
    if (this._reSpace.test(this._text[i])) for (; this._reSpace.test(this._text[i]); ) t++, i--;
    for (; /\S/.test(this._text[i]) && i > -1; ) t++, i--;
    return e - t;
  }
  findWordBoundaryRight(e) {
    let t = 0, i = e;
    if (this._reSpace.test(this._text[i])) for (; this._reSpace.test(this._text[i]); ) t++, i++;
    for (; /\S/.test(this._text[i]) && i < this._text.length; ) t++, i++;
    return e + t;
  }
  findLineBoundaryLeft(e) {
    let t = 0, i = e - 1;
    for (; !/\n/.test(this._text[i]) && i > -1; ) t++, i--;
    return e - t;
  }
  findLineBoundaryRight(e) {
    let t = 0, i = e;
    for (; !/\n/.test(this._text[i]) && i < this._text.length; ) t++, i++;
    return e + t;
  }
  searchWordBoundary(e, t) {
    const i = this._text;
    let c = e > 0 && this._reSpace.test(i[e]) && (t === -1 || !nT.test(i[e - 1])) ? e - 1 : e, a = i[c];
    for (; c > 0 && c < i.length && !sO.test(a); ) c += t, a = i[c];
    return t === -1 && sO.test(a) && c++, c;
  }
  selectWord(e) {
    e = e || this.selectionStart;
    const t = this.searchWordBoundary(e, -1), i = Math.max(t, this.searchWordBoundary(e, 1));
    this.selectionStart = t, this.selectionEnd = i, this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection();
  }
  selectLine(e) {
    e = e || this.selectionStart;
    const t = this.findLineBoundaryLeft(e), i = this.findLineBoundaryRight(e);
    return this.selectionStart = t, this.selectionEnd = i, this._fireSelectionChanged(), this._updateTextarea(), this;
  }
  enterEditing(e) {
    !this.isEditing && this.editable && (this.enterEditingImpl(), this.fire("editing:entered", e ? { e } : void 0), this._fireSelectionChanged(), this.canvas && (this.canvas.fire("text:editing:entered", { target: this, e }), this.canvas.requestRenderAll()));
  }
  enterEditingImpl() {
    this.canvas && (this.canvas.calcOffset(), this.canvas.textEditingManager.exitTextEditing()), this.isEditing = !0, this.initHiddenTextarea(), this.hiddenTextarea.focus(), this.hiddenTextarea.value = this.text, this._updateTextarea(), this._saveEditingProps(), this._setEditingProps(), this._textBeforeEdit = this.text, this._tick();
  }
  updateSelectionOnMouseMove(e) {
    if (this.getActiveControl()) return;
    const t = this.hiddenTextarea;
    tc(t).activeElement !== t && t.focus();
    const i = this.getSelectionStartFromPointer(e), c = this.selectionStart, a = this.selectionEnd;
    (i === this.__selectionStartOnMouseDown && c !== a || c !== i && a !== i) && (i > this.__selectionStartOnMouseDown ? (this.selectionStart = this.__selectionStartOnMouseDown, this.selectionEnd = i) : (this.selectionStart = i, this.selectionEnd = this.__selectionStartOnMouseDown), this.selectionStart === c && this.selectionEnd === a || (this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection()));
  }
  _setEditingProps() {
    this.hoverCursor = "text", this.canvas && (this.canvas.defaultCursor = this.canvas.moveCursor = "text"), this.borderColor = this.editingBorderColor, this.hasControls = this.selectable = !1, this.lockMovementX = this.lockMovementY = !0;
  }
  fromStringToGraphemeSelection(e, t, i) {
    const c = i.slice(0, e), a = this.graphemeSplit(c).length;
    if (e === t) return { selectionStart: a, selectionEnd: a };
    const s = i.slice(e, t);
    return { selectionStart: a, selectionEnd: a + this.graphemeSplit(s).length };
  }
  fromGraphemeToStringSelection(e, t, i) {
    const c = i.slice(0, e).join("").length;
    return e === t ? { selectionStart: c, selectionEnd: c } : { selectionStart: c, selectionEnd: c + i.slice(e, t).join("").length };
  }
  _updateTextarea() {
    if (this.cursorOffsetCache = {}, this.hiddenTextarea) {
      if (!this.inCompositionMode) {
        const e = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = e.selectionStart, this.hiddenTextarea.selectionEnd = e.selectionEnd;
      }
      this.updateTextareaPosition();
    }
  }
  updateFromTextArea() {
    if (!this.hiddenTextarea) return;
    this.cursorOffsetCache = {};
    const e = this.hiddenTextarea;
    this.text = e.value, this.set("dirty", !0), this.initDimensions(), this.setCoords();
    const t = this.fromStringToGraphemeSelection(e.selectionStart, e.selectionEnd, e.value);
    this.selectionEnd = this.selectionStart = t.selectionEnd, this.inCompositionMode || (this.selectionStart = t.selectionStart), this.updateTextareaPosition();
  }
  updateTextareaPosition() {
    if (this.selectionStart === this.selectionEnd) {
      const e = this._calcTextareaPosition();
      this.hiddenTextarea.style.left = e.left, this.hiddenTextarea.style.top = e.top;
    }
  }
  _calcTextareaPosition() {
    if (!this.canvas) return { left: "1px", top: "1px" };
    const e = this.inCompositionMode ? this.compositionStart : this.selectionStart, t = this._getCursorBoundaries(e), i = this.get2DCursorLocation(e), c = i.lineIndex, a = i.charIndex, s = this.getValueOfPropertyAt(c, a, "fontSize") * this.lineHeight, r = t.leftOffset, l = this.getCanvasRetinaScaling(), d = this.canvas.upperCanvasEl, f = d.width / l, h = d.height / l, p = f - s, g = h - s, _ = new St(t.left + r, t.top + t.topOffset + s).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new St(d.clientWidth / f, d.clientHeight / h));
    return _.x < 0 && (_.x = 0), _.x > p && (_.x = p), _.y < 0 && (_.y = 0), _.y > g && (_.y = g), _.x += this.canvas._offset.left, _.y += this.canvas._offset.top, { left: "".concat(_.x, "px"), top: "".concat(_.y, "px"), fontSize: "".concat(s, "px"), charHeight: s };
  }
  _saveEditingProps() {
    this._savedProps = { hasControls: this.hasControls, borderColor: this.borderColor, lockMovementX: this.lockMovementX, lockMovementY: this.lockMovementY, hoverCursor: this.hoverCursor, selectable: this.selectable, defaultCursor: this.canvas && this.canvas.defaultCursor, moveCursor: this.canvas && this.canvas.moveCursor };
  }
  _restoreEditingProps() {
    this._savedProps && (this.hoverCursor = this._savedProps.hoverCursor, this.hasControls = this._savedProps.hasControls, this.borderColor = this._savedProps.borderColor, this.selectable = this._savedProps.selectable, this.lockMovementX = this._savedProps.lockMovementX, this.lockMovementY = this._savedProps.lockMovementY, this.canvas && (this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor, this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor), delete this._savedProps);
  }
  _exitEditing() {
    const e = this.hiddenTextarea;
    this.selected = !1, this.isEditing = !1, e && (e.blur && e.blur(), e.parentNode && e.parentNode.removeChild(e)), this.hiddenTextarea = null, this.abortCursorAnimation(), this.selectionStart !== this.selectionEnd && this.clearContextTop();
  }
  exitEditingImpl() {
    this._exitEditing(), this.selectionEnd = this.selectionStart, this._restoreEditingProps(), this._forceClearCache && (this.initDimensions(), this.setCoords());
  }
  exitEditing() {
    const e = this._textBeforeEdit !== this.text;
    return this.exitEditingImpl(), this.fire("editing:exited"), e && this.fire(Zb), this.canvas && (this.canvas.fire("text:editing:exited", { target: this }), e && this.canvas.fire("object:modified", { target: this })), this;
  }
  _removeExtraneousStyles() {
    for (const e in this.styles) this._textLines[e] || delete this.styles[e];
  }
  removeStyleFromTo(e, t) {
    const { lineIndex: i, charIndex: c } = this.get2DCursorLocation(e, !0), { lineIndex: a, charIndex: s } = this.get2DCursorLocation(t, !0);
    if (i !== a) {
      if (this.styles[i]) for (let r = c; r < this._unwrappedTextLines[i].length; r++) delete this.styles[i][r];
      if (this.styles[a]) for (let r = s; r < this._unwrappedTextLines[a].length; r++) {
        const l = this.styles[a][r];
        l && (this.styles[i] || (this.styles[i] = {}), this.styles[i][c + r - s] = l);
      }
      for (let r = i + 1; r <= a; r++) delete this.styles[r];
      this.shiftLineStyles(a, i - a);
    } else if (this.styles[i]) {
      const r = this.styles[i], l = s - c;
      for (let d = c; d < s; d++) delete r[d];
      for (const d in this.styles[i]) {
        const f = parseInt(d, 10);
        f >= s && (r[f - l] = r[d], delete r[d]);
      }
    }
  }
  shiftLineStyles(e, t) {
    const i = Object.assign({}, this.styles);
    for (const c in this.styles) {
      const a = parseInt(c, 10);
      a > e && (this.styles[a + t] = i[a], i[a - t] || delete this.styles[a]);
    }
  }
  insertNewlineStyleObject(e, t, i, c) {
    const a = {}, s = this._unwrappedTextLines[e].length, r = s === t;
    let l = !1;
    i || (i = 1), this.shiftLineStyles(e, i);
    const d = this.styles[e] ? this.styles[e][t === 0 ? t : t - 1] : void 0;
    for (const h in this.styles[e]) {
      const p = parseInt(h, 10);
      p >= t && (l = !0, a[p - t] = this.styles[e][h], r && t === 0 || delete this.styles[e][h]);
    }
    let f = !1;
    for (l && !r && (this.styles[e + i] = a, f = !0), (f || s > t) && i--; i > 0; ) c && c[i - 1] ? this.styles[e + i] = { 0: lt({}, c[i - 1]) } : d ? this.styles[e + i] = { 0: lt({}, d) } : delete this.styles[e + i], i--;
    this._forceClearCache = !0;
  }
  insertCharStyleObject(e, t, i, c) {
    this.styles || (this.styles = {});
    const a = this.styles[e], s = a ? lt({}, a) : {};
    i || (i = 1);
    for (const l in s) {
      const d = parseInt(l, 10);
      d >= t && (a[d + i] = s[d], s[d - i] || delete a[d]);
    }
    if (this._forceClearCache = !0, c) {
      for (; i--; ) Object.keys(c[i]).length && (this.styles[e] || (this.styles[e] = {}), this.styles[e][t + i] = lt({}, c[i]));
      return;
    }
    if (!a) return;
    const r = a[t ? t - 1 : 1];
    for (; r && i--; ) this.styles[e][t + i] = lt({}, r);
  }
  insertNewStyleBlock(e, t, i) {
    const c = this.get2DCursorLocation(t, !0), a = [0];
    let s, r = 0;
    for (let l = 0; l < e.length; l++) e[l] === `
` ? (r++, a[r] = 0) : a[r]++;
    for (a[0] > 0 && (this.insertCharStyleObject(c.lineIndex, c.charIndex, a[0], i), i = i && i.slice(a[0] + 1)), r && this.insertNewlineStyleObject(c.lineIndex, c.charIndex + a[0], r), s = 1; s < r; s++) a[s] > 0 ? this.insertCharStyleObject(c.lineIndex + s, 0, a[s], i) : i && this.styles[c.lineIndex + s] && i[0] && (this.styles[c.lineIndex + s][0] = i[0]), i = i && i.slice(a[s] + 1);
    a[s] > 0 && this.insertCharStyleObject(c.lineIndex + s, 0, a[s], i);
  }
  removeChars(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e + 1;
    this.removeStyleFromTo(e, t), this._text.splice(e, t - e), this.text = this._text.join(""), this.set("dirty", !0), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
  }
  insertChars(e, t, i) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : i;
    c > i && this.removeStyleFromTo(i, c);
    const a = this.graphemeSplit(e);
    this.insertNewStyleBlock(a, i, t), this._text = [...this._text.slice(0, i), ...a, ...this._text.slice(c)], this.text = this._text.join(""), this.set("dirty", !0), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
  }
  setSelectionStartEndWithShift(e, t, i) {
    i <= e ? (t === e ? this._selectionDirection = ti : this._selectionDirection === yo && (this._selectionDirection = ti, this.selectionEnd = e), this.selectionStart = i) : i > e && i < t ? this._selectionDirection === yo ? this.selectionEnd = i : this.selectionStart = i : (t === e ? this._selectionDirection = yo : this._selectionDirection === ti && (this._selectionDirection = yo, this.selectionStart = t), this.selectionEnd = i);
  }
}
class xY extends wY {
  initHiddenTextarea() {
    const e = this.canvas && tc(this.canvas.getElement()) || f0(), t = e.createElement("textarea");
    Object.entries({ autocapitalize: "off", autocorrect: "off", autocomplete: "off", spellcheck: "false", "data-fabric": "textarea", wrap: "off" }).map((s) => {
      let [r, l] = s;
      return t.setAttribute(r, l);
    });
    const { top: i, left: c, fontSize: a } = this._calcTextareaPosition();
    t.style.cssText = "position: absolute; top: ".concat(i, "; left: ").concat(c, "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ").concat(a, ";"), (this.hiddenTextareaContainer || e.body).appendChild(t), Object.entries({ blur: "blur", keydown: "onKeyDown", keyup: "onKeyUp", input: "onInput", copy: "copy", cut: "copy", paste: "paste", compositionstart: "onCompositionStart", compositionupdate: "onCompositionUpdate", compositionend: "onCompositionEnd" }).map((s) => {
      let [r, l] = s;
      return t.addEventListener(r, this[l].bind(this));
    }), this.hiddenTextarea = t;
  }
  blur() {
    this.abortCursorAnimation();
  }
  onKeyDown(e) {
    if (!this.isEditing) return;
    const t = this.direction === "rtl" ? this.keysMapRtl : this.keysMap;
    if (e.keyCode in t) this[t[e.keyCode]](e);
    else {
      if (!(e.keyCode in this.ctrlKeysMapDown) || !e.ctrlKey && !e.metaKey) return;
      this[this.ctrlKeysMapDown[e.keyCode]](e);
    }
    e.stopImmediatePropagation(), e.preventDefault(), e.keyCode >= 33 && e.keyCode <= 40 ? (this.inCompositionMode = !1, this.clearContextTop(), this.renderCursorOrSelection()) : this.canvas && this.canvas.requestRenderAll();
  }
  onKeyUp(e) {
    !this.isEditing || this._copyDone || this.inCompositionMode ? this._copyDone = !1 : e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey) && (this[this.ctrlKeysMapUp[e.keyCode]](e), e.stopImmediatePropagation(), e.preventDefault(), this.canvas && this.canvas.requestRenderAll());
  }
  onInput(e) {
    const t = this.fromPaste;
    if (this.fromPaste = !1, e && e.stopPropagation(), !this.isEditing) return;
    const i = () => {
      this.updateFromTextArea(), this.fire(Qb), this.canvas && (this.canvas.fire("text:changed", { target: this }), this.canvas.requestRenderAll());
    };
    if (this.hiddenTextarea.value === "") return this.styles = {}, void i();
    const c = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText, a = this._text.length, s = c.length, r = this.selectionStart, l = this.selectionEnd, d = r !== l;
    let f, h, p, g, _ = s - a;
    const b = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value), v = r > b.selectionStart;
    d ? (h = this._text.slice(r, l), _ += l - r) : s < a && (h = v ? this._text.slice(l + _, l) : this._text.slice(r, r - _));
    const E = c.slice(b.selectionEnd - _, b.selectionEnd);
    if (h && h.length && (E.length && (f = this.getSelectionStyles(r, r + 1, !1), f = E.map(() => f[0])), d ? (p = r, g = l) : v ? (p = l - h.length, g = l) : (p = l, g = l + h.length), this.removeStyleFromTo(p, g)), E.length) {
      const { copyPasteData: C } = fd();
      t && E.join("") === C.copiedText && !Br.disableStyleCopyPaste && (f = C.copiedTextStyle), this.insertNewStyleBlock(E, r, f);
    }
    i();
  }
  onCompositionStart() {
    this.inCompositionMode = !0;
  }
  onCompositionEnd() {
    this.inCompositionMode = !1;
  }
  onCompositionUpdate(e) {
    let { target: t } = e;
    const { selectionStart: i, selectionEnd: c } = t;
    this.compositionStart = i, this.compositionEnd = c, this.updateTextareaPosition();
  }
  copy() {
    if (this.selectionStart === this.selectionEnd) return;
    const { copyPasteData: e } = fd();
    e.copiedText = this.getSelectedText(), Br.disableStyleCopyPaste ? e.copiedTextStyle = void 0 : e.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, !0), this._copyDone = !0;
  }
  paste() {
    this.fromPaste = !0;
  }
  _getWidthBeforeCursor(e, t) {
    let i, c = this._getLineLeftOffset(e);
    return t > 0 && (i = this.__charBounds[e][t - 1], c += i.left + i.width), c;
  }
  getDownCursorOffset(e, t) {
    const i = this._getSelectionForOffset(e, t), c = this.get2DCursorLocation(i), a = c.lineIndex;
    if (a === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) return this._text.length - i;
    const s = c.charIndex, r = this._getWidthBeforeCursor(a, s), l = this._getIndexOnLine(a + 1, r);
    return this._textLines[a].slice(s).length + l + 1 + this.missingNewlineOffset(a);
  }
  _getSelectionForOffset(e, t) {
    return e.shiftKey && this.selectionStart !== this.selectionEnd && t ? this.selectionEnd : this.selectionStart;
  }
  getUpCursorOffset(e, t) {
    const i = this._getSelectionForOffset(e, t), c = this.get2DCursorLocation(i), a = c.lineIndex;
    if (a === 0 || e.metaKey || e.keyCode === 33) return -i;
    const s = c.charIndex, r = this._getWidthBeforeCursor(a, s), l = this._getIndexOnLine(a - 1, r), d = this._textLines[a].slice(0, s), f = this.missingNewlineOffset(a - 1);
    return -this._textLines[a - 1].length + l - d.length + (1 - f);
  }
  _getIndexOnLine(e, t) {
    const i = this._textLines[e];
    let c, a, s = this._getLineLeftOffset(e), r = 0;
    for (let l = 0, d = i.length; l < d; l++) if (c = this.__charBounds[e][l].width, s += c, s > t) {
      a = !0;
      const f = s - c, h = s, p = Math.abs(f - t);
      r = Math.abs(h - t) < p ? l : l - 1;
      break;
    }
    return a || (r = i.length - 1), r;
  }
  moveCursorDown(e) {
    this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorUpOrDown("Down", e);
  }
  moveCursorUp(e) {
    this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorUpOrDown("Up", e);
  }
  _moveCursorUpOrDown(e, t) {
    const i = this["get".concat(e, "CursorOffset")](t, this._selectionDirection === yo);
    if (t.shiftKey ? this.moveCursorWithShift(i) : this.moveCursorWithoutShift(i), i !== 0) {
      const c = this.text.length;
      this.selectionStart = Cm(0, this.selectionStart, c), this.selectionEnd = Cm(0, this.selectionEnd, c), this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea();
    }
  }
  moveCursorWithShift(e) {
    const t = this._selectionDirection === ti ? this.selectionStart + e : this.selectionEnd + e;
    return this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, t), e !== 0;
  }
  moveCursorWithoutShift(e) {
    return e < 0 ? (this.selectionStart += e, this.selectionEnd = this.selectionStart) : (this.selectionEnd += e, this.selectionStart = this.selectionEnd), e !== 0;
  }
  moveCursorLeft(e) {
    this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorLeftOrRight("Left", e);
  }
  _move(e, t, i) {
    let c;
    if (e.altKey) c = this["findWordBoundary".concat(i)](this[t]);
    else {
      if (!e.metaKey && e.keyCode !== 35 && e.keyCode !== 36) return this[t] += i === "Left" ? -1 : 1, !0;
      c = this["findLineBoundary".concat(i)](this[t]);
    }
    return c !== void 0 && this[t] !== c && (this[t] = c, !0);
  }
  _moveLeft(e, t) {
    return this._move(e, t, "Left");
  }
  _moveRight(e, t) {
    return this._move(e, t, "Right");
  }
  moveCursorLeftWithoutShift(e) {
    let t = !0;
    return this._selectionDirection = ti, this.selectionEnd === this.selectionStart && this.selectionStart !== 0 && (t = this._moveLeft(e, "selectionStart")), this.selectionEnd = this.selectionStart, t;
  }
  moveCursorLeftWithShift(e) {
    return this._selectionDirection === yo && this.selectionStart !== this.selectionEnd ? this._moveLeft(e, "selectionEnd") : this.selectionStart !== 0 ? (this._selectionDirection = ti, this._moveLeft(e, "selectionStart")) : void 0;
  }
  moveCursorRight(e) {
    this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorLeftOrRight("Right", e);
  }
  _moveCursorLeftOrRight(e, t) {
    const i = "moveCursor".concat(e).concat(t.shiftKey ? "WithShift" : "WithoutShift");
    this._currentCursorOpacity = 1, this[i](t) && (this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea());
  }
  moveCursorRightWithShift(e) {
    return this._selectionDirection === ti && this.selectionStart !== this.selectionEnd ? this._moveRight(e, "selectionStart") : this.selectionEnd !== this._text.length ? (this._selectionDirection = yo, this._moveRight(e, "selectionEnd")) : void 0;
  }
  moveCursorRightWithoutShift(e) {
    let t = !0;
    return this._selectionDirection = yo, this.selectionStart === this.selectionEnd ? (t = this._moveRight(e, "selectionStart"), this.selectionEnd = this.selectionStart) : this.selectionStart = this.selectionEnd, t;
  }
}
const Cw = (n) => !!n.button;
class TY extends xY {
  constructor() {
    super(...arguments), it(this, "draggableTextDelegate", void 0);
  }
  initBehavior() {
    this.on("mousedown", this._mouseDownHandler), this.on("mousedown:before", this._mouseDownHandlerBefore), this.on("mouseup", this.mouseUpHandler), this.on("mousedblclick", this.doubleClickHandler), this.on("tripleclick", this.tripleClickHandler), this.__lastClickTime = +/* @__PURE__ */ new Date(), this.__lastLastClickTime = +/* @__PURE__ */ new Date(), this.__lastPointer = {}, this.on("mousedown", this.onMouseDown), this.draggableTextDelegate = new CY(this), super.initBehavior();
  }
  shouldStartDragging() {
    return this.draggableTextDelegate.isActive();
  }
  onDragStart(e) {
    return this.draggableTextDelegate.onDragStart(e);
  }
  canDrop(e) {
    return this.draggableTextDelegate.canDrop(e);
  }
  onMouseDown(e) {
    if (!this.canvas) return;
    this.__newClickTime = +/* @__PURE__ */ new Date();
    const t = e.pointer;
    this.isTripleClick(t) && (this.fire("tripleclick", e), ox(e.e)), this.__lastLastClickTime = this.__lastClickTime, this.__lastClickTime = this.__newClickTime, this.__lastPointer = t, this.__lastSelected = this.selected && !this.getActiveControl();
  }
  isTripleClick(e) {
    return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === e.x && this.__lastPointer.y === e.y;
  }
  doubleClickHandler(e) {
    this.isEditing && this.selectWord(this.getSelectionStartFromPointer(e.e));
  }
  tripleClickHandler(e) {
    this.isEditing && this.selectLine(this.getSelectionStartFromPointer(e.e));
  }
  _mouseDownHandler(e) {
    let { e: t } = e;
    this.canvas && this.editable && !Cw(t) && !this.getActiveControl() && (this.draggableTextDelegate.start(t) || (this.canvas.textEditingManager.register(this), this.selected && (this.inCompositionMode = !1, this.setCursorByClick(t)), this.isEditing && (this.__selectionStartOnMouseDown = this.selectionStart, this.selectionStart === this.selectionEnd && this.abortCursorAnimation(), this.renderCursorOrSelection())));
  }
  _mouseDownHandlerBefore(e) {
    let { e: t } = e;
    this.canvas && this.editable && !Cw(t) && (this.selected = this === this.canvas._activeObject);
  }
  mouseUpHandler(e) {
    let { e: t, transform: i } = e;
    const c = this.draggableTextDelegate.end(t);
    if (this.canvas) {
      this.canvas.textEditingManager.unregister(this);
      const a = this.canvas._activeObject;
      if (a && a !== this) return;
    }
    !this.editable || this.group && !this.group.interactive || i && i.actionPerformed || Cw(t) || c || (this.__lastSelected && !this.getActiveControl() ? (this.selected = !1, this.__lastSelected = !1, this.enterEditing(t), this.selectionStart === this.selectionEnd ? this.initDelayedCursor(!0) : this.renderCursorOrSelection()) : this.selected = !0);
  }
  setCursorByClick(e) {
    const t = this.getSelectionStartFromPointer(e), i = this.selectionStart, c = this.selectionEnd;
    e.shiftKey ? this.setSelectionStartEndWithShift(i, c, t) : (this.selectionStart = t, this.selectionEnd = t), this.isEditing && (this._fireSelectionChanged(), this._updateTextarea());
  }
  getSelectionStartFromPointer(e) {
    const t = this.canvas.getScenePoint(e).transform(Cl(this.calcTransformMatrix())).add(new St(-this._getLeftOffset(), -this._getTopOffset()));
    let i = 0, c = 0, a = 0;
    for (let d = 0; d < this._textLines.length && i <= t.y; d++) i += this.getHeightOfLine(d), a = d, d > 0 && (c += this._textLines[d - 1].length + this.missingNewlineOffset(d - 1));
    let s = Math.abs(this._getLineLeftOffset(a));
    const r = this._textLines[a].length, l = this.__charBounds[a];
    for (let d = 0; d < r; d++) {
      const f = s + l[d].kernedWidth;
      if (t.x <= f) {
        Math.abs(t.x - f) <= Math.abs(t.x - s) && c++;
        break;
      }
      s = f, c++;
    }
    return Math.min(this.flipX ? r - c : c, this._text.length);
  }
}
const ab = "moveCursorUp", sb = "moveCursorDown", lb = "moveCursorLeft", ub = "moveCursorRight", cb = "exitEditing", AY = lt({ selectionStart: 0, selectionEnd: 0, selectionColor: "rgba(17,119,255,0.3)", isEditing: !1, editable: !0, editingBorderColor: "rgba(102,153,255,0.25)", cursorWidth: 2, cursorColor: "", cursorDelay: 1e3, cursorDuration: 600, caching: !0, hiddenTextareaContainer: null, keysMap: { 9: cb, 27: cb, 33: ab, 34: sb, 35: ub, 36: lb, 37: lb, 38: ab, 39: ub, 40: sb }, keysMapRtl: { 9: cb, 27: cb, 33: ab, 34: sb, 35: lb, 36: ub, 37: ub, 38: ab, 39: lb, 40: sb }, ctrlKeysMapDown: { 65: "selectAll" }, ctrlKeysMapUp: { 67: "copy", 88: "cut" } }, { _selectionDirection: null, _reSpace: /\s|\r?\n/, inCompositionMode: !1 });
class mf extends TY {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), mf.ownDefaults);
  }
  get type() {
    const e = super.type;
    return e === "itext" ? "i-text" : e;
  }
  constructor(e, t) {
    super(e, lt(lt({}, mf.ownDefaults), t)), this.initBehavior();
  }
  _set(e, t) {
    return this.isEditing && this._savedProps && e in this._savedProps ? (this._savedProps[e] = t, this) : (e === "canvas" && (this.canvas instanceof hx && this.canvas.textEditingManager.remove(this), t instanceof hx && t.textEditingManager.add(this)), super._set(e, t));
  }
  setSelectionStart(e) {
    e = Math.max(e, 0), this._updateAndFire("selectionStart", e);
  }
  setSelectionEnd(e) {
    e = Math.min(e, this.text.length), this._updateAndFire("selectionEnd", e);
  }
  _updateAndFire(e, t) {
    this[e] !== t && (this._fireSelectionChanged(), this[e] = t), this._updateTextarea();
  }
  _fireSelectionChanged() {
    this.fire("selection:changed"), this.canvas && this.canvas.fire("text:selection:changed", { target: this });
  }
  initDimensions() {
    this.isEditing && this.initDelayedCursor(), super.initDimensions();
  }
  getSelectionStyles() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart || 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.selectionEnd, i = arguments.length > 2 ? arguments[2] : void 0;
    return super.getSelectionStyles(e, t, i);
  }
  setSelectionStyles(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.selectionStart || 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.selectionEnd;
    return super.setSelectionStyles(e, t, i);
  }
  get2DCursorLocation() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart, t = arguments.length > 1 ? arguments[1] : void 0;
    return super.get2DCursorLocation(e, t);
  }
  render(e) {
    super.render(e), this.cursorOffsetCache = {}, this.renderCursorOrSelection();
  }
  toCanvasElement(e) {
    const t = this.isEditing;
    this.isEditing = !1;
    const i = super.toCanvasElement(e);
    return this.isEditing = t, i;
  }
  renderCursorOrSelection() {
    if (!this.isEditing) return;
    const e = this.clearContextTop(!0);
    if (!e) return;
    const t = this._getCursorBoundaries();
    this.selectionStart !== this.selectionEnd || this.inCompositionMode ? this.renderSelection(e, t) : this.renderCursor(e, t), this.canvas.contextTopDirty = !0, e.restore();
  }
  _getCursorBoundaries() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart, t = arguments.length > 1 ? arguments[1] : void 0;
    const i = this._getLeftOffset(), c = this._getTopOffset(), a = this._getCursorBoundariesOffsets(e, t);
    return { left: i, top: c, leftOffset: a.left, topOffset: a.top };
  }
  _getCursorBoundariesOffsets(e, t) {
    return t ? this.__getCursorBoundariesOffsets(e) : this.cursorOffsetCache && "top" in this.cursorOffsetCache ? this.cursorOffsetCache : this.cursorOffsetCache = this.__getCursorBoundariesOffsets(e);
  }
  __getCursorBoundariesOffsets(e) {
    let t = 0, i = 0;
    const { charIndex: c, lineIndex: a } = this.get2DCursorLocation(e);
    for (let d = 0; d < a; d++) t += this.getHeightOfLine(d);
    const s = this._getLineLeftOffset(a), r = this.__charBounds[a][c];
    r && (i = r.left), this.charSpacing !== 0 && c === this._textLines[a].length && (i -= this._getWidthOfCharSpacing());
    const l = { top: t, left: s + (i > 0 ? i : 0) };
    return this.direction === "rtl" && (this.textAlign === yo || this.textAlign === sd || this.textAlign === g1 ? l.left *= -1 : this.textAlign === ti || this.textAlign === u2 ? l.left = s - (i > 0 ? i : 0) : this.textAlign !== pr && this.textAlign !== _1 || (l.left = s - (i > 0 ? i : 0))), l;
  }
  renderCursorAt(e) {
    this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(e, !0), e);
  }
  renderCursor(e, t) {
    this._renderCursor(e, t, this.selectionStart);
  }
  getCursorRenderingData() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._getCursorBoundaries(e);
    const i = this.get2DCursorLocation(e), c = i.lineIndex, a = i.charIndex > 0 ? i.charIndex - 1 : 0, s = this.getValueOfPropertyAt(c, a, "fontSize"), r = this.getObjectScaling().x * this.canvas.getZoom(), l = this.cursorWidth / r, d = this.getValueOfPropertyAt(c, a, "deltaY"), f = t.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(c) / this.lineHeight - s * (1 - this._fontSizeFraction);
    return { color: this.cursorColor || this.getValueOfPropertyAt(c, a, "fill"), opacity: this._currentCursorOpacity, left: t.left + t.leftOffset - l / 2, top: f + t.top + d, width: l, height: s };
  }
  _renderCursor(e, t, i) {
    const { color: c, opacity: a, left: s, top: r, width: l, height: d } = this.getCursorRenderingData(i, t);
    e.fillStyle = c, e.globalAlpha = a, e.fillRect(s, r, l, d);
  }
  renderSelection(e, t) {
    const i = { selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd };
    this._renderSelection(e, i, t);
  }
  renderDragSourceEffect() {
    const e = this.draggableTextDelegate.getDragStartSelection();
    this._renderSelection(this.canvas.contextTop, e, this._getCursorBoundaries(e.selectionStart, !0));
  }
  renderDropTargetEffect(e) {
    const t = this.getSelectionStartFromPointer(e);
    this.renderCursorAt(t);
  }
  _renderSelection(e, t, i) {
    const c = t.selectionStart, a = t.selectionEnd, s = this.textAlign.includes(sd), r = this.get2DCursorLocation(c), l = this.get2DCursorLocation(a), d = r.lineIndex, f = l.lineIndex, h = r.charIndex < 0 ? 0 : r.charIndex, p = l.charIndex < 0 ? 0 : l.charIndex;
    for (let g = d; g <= f; g++) {
      const _ = this._getLineLeftOffset(g) || 0;
      let b = this.getHeightOfLine(g), v = 0, E = 0, C = 0;
      if (g === d && (E = this.__charBounds[d][h].left), g >= d && g < f) C = s && !this.isEndOfWrapping(g) ? this.width : this.getLineWidth(g) || 5;
      else if (g === f) if (p === 0) C = this.__charBounds[f][p].left;
      else {
        const N = this._getWidthOfCharSpacing();
        C = this.__charBounds[f][p - 1].left + this.__charBounds[f][p - 1].width - N;
      }
      v = b, (this.lineHeight < 1 || g === f && this.lineHeight > 1) && (b /= this.lineHeight);
      let y = i.left + _ + E, T = b, A = 0;
      const k = C - E;
      this.inCompositionMode ? (e.fillStyle = this.compositionColor || "black", T = 1, A = b) : e.fillStyle = this.selectionColor, this.direction === "rtl" && (this.textAlign === yo || this.textAlign === sd || this.textAlign === g1 ? y = this.width - y - k : this.textAlign === ti || this.textAlign === u2 ? y = i.left + _ - C : this.textAlign !== pr && this.textAlign !== _1 || (y = i.left + _ - C)), e.fillRect(y, i.top + i.topOffset + A, k, T), i.topOffset += v;
    }
  }
  getCurrentCharFontSize() {
    const e = this._getCurrentCharIndex();
    return this.getValueOfPropertyAt(e.l, e.c, "fontSize");
  }
  getCurrentCharColor() {
    const e = this._getCurrentCharIndex();
    return this.getValueOfPropertyAt(e.l, e.c, ta);
  }
  _getCurrentCharIndex() {
    const e = this.get2DCursorLocation(this.selectionStart, !0), t = e.charIndex > 0 ? e.charIndex - 1 : 0;
    return { l: e.lineIndex, c: t };
  }
  dispose() {
    this.exitEditingImpl(), this.draggableTextDelegate.dispose(), super.dispose();
  }
}
it(mf, "ownDefaults", AY), it(mf, "type", "IText"), pn.setClass(mf), pn.setClass(mf, "i-text");
class fm extends mf {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), fm.ownDefaults);
  }
  constructor(e, t) {
    super(e, lt(lt({}, fm.ownDefaults), t));
  }
  static createControls() {
    return { controls: u$() };
  }
  initDimensions() {
    this.initialized && (this.isEditing && this.initDelayedCursor(), this._clearCache(), this.dynamicMinWidth = 0, this._styleMap = this._generateStyleMap(this._splitText()), this.dynamicMinWidth > this.width && this._set("width", this.dynamicMinWidth), this.textAlign.includes(sd) && this.enlargeSpaces(), this.height = this.calcTextHeight());
  }
  _generateStyleMap(e) {
    let t = 0, i = 0, c = 0;
    const a = {};
    for (let s = 0; s < e.graphemeLines.length; s++) e.graphemeText[c] === `
` && s > 0 ? (i = 0, c++, t++) : !this.splitByGrapheme && this._reSpaceAndTab.test(e.graphemeText[c]) && s > 0 && (i++, c++), a[s] = { line: t, offset: i }, c += e.graphemeLines[s].length, i += e.graphemeLines[s].length;
    return a;
  }
  styleHas(e, t) {
    if (this._styleMap && !this.isWrapping) {
      const i = this._styleMap[t];
      i && (t = i.line);
    }
    return super.styleHas(e, t);
  }
  isEmptyStyles(e) {
    if (!this.styles) return !0;
    let t, i = 0, c = e + 1, a = !1;
    const s = this._styleMap[e], r = this._styleMap[e + 1];
    s && (e = s.line, i = s.offset), r && (c = r.line, a = c === e, t = r.offset);
    const l = e === void 0 ? this.styles : { line: this.styles[e] };
    for (const d in l) for (const f in l[d]) {
      const h = parseInt(f, 10);
      if (h >= i && (!a || h < t)) for (const p in l[d][f]) return !1;
    }
    return !0;
  }
  _getStyleDeclaration(e, t) {
    if (this._styleMap && !this.isWrapping) {
      const i = this._styleMap[e];
      if (!i) return {};
      e = i.line, t = i.offset + t;
    }
    return super._getStyleDeclaration(e, t);
  }
  _setStyleDeclaration(e, t, i) {
    const c = this._styleMap[e];
    super._setStyleDeclaration(c.line, c.offset + t, i);
  }
  _deleteStyleDeclaration(e, t) {
    const i = this._styleMap[e];
    super._deleteStyleDeclaration(i.line, i.offset + t);
  }
  _getLineStyle(e) {
    const t = this._styleMap[e];
    return !!this.styles[t.line];
  }
  _setLineStyle(e) {
    const t = this._styleMap[e];
    super._setLineStyle(t.line);
  }
  _wrapText(e, t) {
    this.isWrapping = !0;
    const i = this.getGraphemeDataForRender(e), c = [];
    for (let a = 0; a < i.wordsData.length; a++) c.push(...this._wrapLine(a, t, i));
    return this.isWrapping = !1, c;
  }
  getGraphemeDataForRender(e) {
    const t = this.splitByGrapheme, i = t ? "" : " ";
    let c = 0;
    return { wordsData: e.map((a, s) => {
      let r = 0;
      const l = t ? this.graphemeSplit(a) : this.wordSplit(a);
      return l.length === 0 ? [{ word: [], width: 0 }] : l.map((d) => {
        const f = t ? [d] : this.graphemeSplit(d), h = this._measureWord(f, s, r);
        return c = Math.max(h, c), r += f.length + i.length, { word: f, width: h };
      });
    }), largestWordWidth: c };
  }
  _measureWord(e, t) {
    let i, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = 0;
    for (let s = 0, r = e.length; s < r; s++)
      a += this._getGraphemeBox(e[s], t, s + c, i, !0).kernedWidth, i = e[s];
    return a;
  }
  wordSplit(e) {
    return e.split(this._wordJoiners);
  }
  _wrapLine(e, t, i) {
    let { largestWordWidth: c, wordsData: a } = i, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    const r = this._getWidthOfCharSpacing(), l = this.splitByGrapheme, d = [], f = l ? "" : " ";
    let h = 0, p = [], g = 0, _ = 0, b = !0;
    t -= s;
    const v = Math.max(t, c, this.dynamicMinWidth), E = a[e];
    let C;
    for (g = 0, C = 0; C < E.length; C++) {
      const { word: y, width: T } = E[C];
      g += y.length, h += _ + T - r, h > v && !b ? (d.push(p), p = [], h = T, b = !0) : h += r, b || l || p.push(f), p = p.concat(y), _ = l ? 0 : this._measureWord([f], e, g), g++, b = !1;
    }
    return C && d.push(p), c + s > this.dynamicMinWidth && (this.dynamicMinWidth = c - r + s), d;
  }
  isEndOfWrapping(e) {
    return !this._styleMap[e + 1] || this._styleMap[e + 1].line !== this._styleMap[e].line;
  }
  missingNewlineOffset(e, t) {
    return this.splitByGrapheme && !t ? this.isEndOfWrapping(e) ? 1 : 0 : 1;
  }
  _splitTextIntoLines(e) {
    const t = super._splitTextIntoLines(e), i = this._wrapText(t.lines, this.width), c = new Array(i.length);
    for (let a = 0; a < i.length; a++) c[a] = i[a].join("");
    return t.lines = c, t.graphemeLines = i, t;
  }
  getMinWidth() {
    return Math.max(this.minWidth, this.dynamicMinWidth);
  }
  _removeExtraneousStyles() {
    const e = /* @__PURE__ */ new Map();
    for (const t in this._styleMap) {
      const i = parseInt(t, 10);
      if (this._textLines[i]) {
        const c = this._styleMap[t].line;
        e.set("".concat(c), !0);
      }
    }
    for (const t in this.styles) e.has(t) || delete this.styles[t];
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject(["minWidth", "splitByGrapheme", ...e]);
  }
}
it(fm, "type", "Textbox"), it(fm, "textLayoutProperties", [...mf.textLayoutProperties, "width"]), it(fm, "ownDefaults", { minWidth: 20, dynamicMinWidth: 2, lockScalingFlip: !0, noScaleCache: !1, _wordJoiners: /[ \t\r]/, splitByGrapheme: !1 }), pn.setClass(fm);
class lO extends B2 {
  shouldPerformLayout(e) {
    return !!e.target.clipPath && super.shouldPerformLayout(e);
  }
  shouldLayoutClipPath() {
    return !1;
  }
  calcLayoutResult(e, t) {
    const { target: i } = e, { clipPath: c, group: a } = i;
    if (!c || !this.shouldPerformLayout(e)) return;
    const { width: s, height: r } = dd(S8(i, c)), l = new St(s, r);
    if (c.absolutePositioned)
      return { center: _m(c.getRelativeCenterPoint(), void 0, a ? a.calcTransformMatrix() : void 0), size: l };
    {
      const d = c.getRelativeCenterPoint().transform(i.calcOwnMatrix(), !0);
      if (this.shouldPerformLayout(e)) {
        const { center: f = new St(), correction: h = new St() } = this.calcBoundingBox(t, e) || {};
        return { center: f.add(d), correction: h.subtract(d), size: l };
      }
      return { center: i.getRelativeCenterPoint().add(d), size: l };
    }
  }
}
it(lO, "type", "clip-path"), pn.setClass(lO);
class uO extends B2 {
  getInitialSize(e, t) {
    let { target: i } = e, { size: c } = t;
    return new St(i.width || c.x, i.height || c.y);
  }
}
it(uO, "type", "fixed"), pn.setClass(uO);
class kY extends D1 {
  subscribeTargets(e) {
    const t = e.target;
    e.targets.reduce((i, c) => (c.parent && i.add(c.parent), i), /* @__PURE__ */ new Set()).forEach((i) => {
      i.layoutManager.subscribeTargets({ target: i, targets: [t] });
    });
  }
  unsubscribeTargets(e) {
    const t = e.target, i = t.getObjects();
    e.targets.reduce((c, a) => (a.parent && c.add(a.parent), c), /* @__PURE__ */ new Set()).forEach((c) => {
      !i.some((a) => a.parent === c) && c.layoutManager.unsubscribeTargets({ target: c, targets: [t] });
    });
  }
}
class hm extends _f {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), hm.ownDefaults);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Object.assign(this, hm.ownDefaults), this.setOptions(t);
    const { left: i, top: c, layoutManager: a } = t;
    this.groupInit(e, { left: i, top: c, layoutManager: a ?? new kY() });
  }
  _shouldSetNestedCoords() {
    return !0;
  }
  __objectSelectionMonitor() {
  }
  multiSelectAdd() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    this.multiSelectionStacking === "selection-order" ? this.add(...t) : t.forEach((c) => {
      const a = this._objects.findIndex((r) => r.isInFrontOf(c)), s = a === -1 ? this.size() : a;
      this.insertAt(s, c);
    });
  }
  canEnterGroup(e) {
    return this.getObjects().some((t) => t.isDescendantOf(e) || e.isDescendantOf(t)) ? (qh("error", "ActiveSelection: circular object trees are not supported, this call has no effect"), !1) : super.canEnterGroup(e);
  }
  enterGroup(e, t) {
    e.parent && e.parent === e.group ? e.parent._exitGroup(e) : e.group && e.parent !== e.group && e.group.remove(e), this._enterGroup(e, t);
  }
  exitGroup(e, t) {
    this._exitGroup(e, t), e.parent && e.parent._enterGroup(e, !0);
  }
  _onAfterObjectsChange(e, t) {
    super._onAfterObjectsChange(e, t);
    const i = /* @__PURE__ */ new Set();
    t.forEach((c) => {
      const { parent: a } = c;
      a && i.add(a);
    }), e === yT ? i.forEach((c) => {
      c._onAfterObjectsChange(o2, t);
    }) : i.forEach((c) => {
      c._set("dirty", !0);
    });
  }
  onDeselect() {
    return this.removeAll(), !1;
  }
  toString() {
    return "#<ActiveSelection: (".concat(this.complexity(), ")>");
  }
  shouldCache() {
    return !1;
  }
  isOnACache() {
    return !1;
  }
  _renderControls(e, t, i) {
    e.save(), e.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
    const c = lt(lt({ hasControls: !1 }, i), {}, { forActiveSelection: !0 });
    for (let a = 0; a < this._objects.length; a++) this._objects[a]._renderControls(e, c);
    super._renderControls(e, t), e.restore();
  }
}
it(hm, "type", "ActiveSelection"), it(hm, "ownDefaults", { multiSelectionStacking: "canvas-stacking" }), pn.setClass(hm), pn.setClass(hm, "activeSelection");
class OY {
  constructor() {
    it(this, "resources", {});
  }
  applyFilters(e, t, i, c, a) {
    const s = a.getContext("2d");
    if (!s) return;
    s.drawImage(t, 0, 0, i, c);
    const r = { sourceWidth: i, sourceHeight: c, imageData: s.getImageData(0, 0, i, c), originalEl: t, originalImageData: s.getImageData(0, 0, i, c), canvasEl: a, ctx: s, filterBackend: this };
    e.forEach((d) => {
      d.applyTo(r);
    });
    const { imageData: l } = r;
    return l.width === i && l.height === c || (a.width = l.width, a.height = l.height), s.putImageData(l, 0, 0), r;
  }
}
class $8 {
  constructor() {
    let { tileSize: e = Br.textureSize } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    it(this, "aPosition", new Float32Array([0, 0, 0, 1, 1, 0, 1, 1])), it(this, "resources", {}), this.tileSize = e, this.setupGLContext(e, e), this.captureGPUInfo();
  }
  setupGLContext(e, t) {
    this.dispose(), this.createWebGLCanvas(e, t);
  }
  createWebGLCanvas(e, t) {
    const i = ac({ width: e, height: t }), c = i.getContext("webgl", { alpha: !0, premultipliedAlpha: !1, depth: !1, stencil: !1, antialias: !1 });
    c && (c.clearColor(0, 0, 0, 0), this.canvas = i, this.gl = c);
  }
  applyFilters(e, t, i, c, a, s) {
    const r = this.gl, l = a.getContext("2d");
    if (!r || !l) return;
    let d;
    s && (d = this.getCachedTexture(s, t));
    const f = { originalWidth: t.width || t.naturalWidth || 0, originalHeight: t.height || t.naturalHeight || 0, sourceWidth: i, sourceHeight: c, destinationWidth: i, destinationHeight: c, context: r, sourceTexture: this.createTexture(r, i, c, d ? void 0 : t), targetTexture: this.createTexture(r, i, c), originalTexture: d || this.createTexture(r, i, c, d ? void 0 : t), passes: e.length, webgl: !0, aPosition: this.aPosition, programCache: this.programCache, pass: 0, filterBackend: this, targetCanvas: a }, h = r.createFramebuffer();
    return r.bindFramebuffer(r.FRAMEBUFFER, h), e.forEach((p) => {
      p && p.applyTo(f);
    }), function(p) {
      const g = p.targetCanvas, _ = g.width, b = g.height, v = p.destinationWidth, E = p.destinationHeight;
      _ === v && b === E || (g.width = v, g.height = E);
    }(f), this.copyGLTo2D(r, f), r.bindTexture(r.TEXTURE_2D, null), r.deleteTexture(f.sourceTexture), r.deleteTexture(f.targetTexture), r.deleteFramebuffer(h), l.setTransform(1, 0, 0, 1, 0, 0), f;
  }
  dispose() {
    this.canvas && (this.canvas = null, this.gl = null), this.clearWebGLCaches();
  }
  clearWebGLCaches() {
    this.programCache = {}, this.textureCache = {};
  }
  createTexture(e, t, i, c, a) {
    const { NEAREST: s, TEXTURE_2D: r, RGBA: l, UNSIGNED_BYTE: d, CLAMP_TO_EDGE: f, TEXTURE_MAG_FILTER: h, TEXTURE_MIN_FILTER: p, TEXTURE_WRAP_S: g, TEXTURE_WRAP_T: _ } = e, b = e.createTexture();
    return e.bindTexture(r, b), e.texParameteri(r, h, a || s), e.texParameteri(r, p, a || s), e.texParameteri(r, g, f), e.texParameteri(r, _, f), c ? e.texImage2D(r, 0, l, l, d, c) : e.texImage2D(r, 0, l, t, i, 0, l, d, null), b;
  }
  getCachedTexture(e, t, i) {
    const { textureCache: c } = this;
    if (c[e]) return c[e];
    {
      const a = this.createTexture(this.gl, t.width, t.height, t, i);
      return a && (c[e] = a), a;
    }
  }
  evictCachesForKey(e) {
    this.textureCache[e] && (this.gl.deleteTexture(this.textureCache[e]), delete this.textureCache[e]);
  }
  copyGLTo2D(e, t) {
    const i = e.canvas, c = t.targetCanvas, a = c.getContext("2d");
    if (!a) return;
    a.translate(0, c.height), a.scale(1, -1);
    const s = i.height - c.height;
    a.drawImage(i, 0, s, c.width, c.height, 0, 0, c.width, c.height);
  }
  copyGLTo2DPutImageData(e, t) {
    const i = t.targetCanvas.getContext("2d"), c = t.destinationWidth, a = t.destinationHeight, s = c * a * 4;
    if (!i) return;
    const r = new Uint8Array(this.imageBuffer, 0, s), l = new Uint8ClampedArray(this.imageBuffer, 0, s);
    e.readPixels(0, 0, c, a, e.RGBA, e.UNSIGNED_BYTE, r);
    const d = new ImageData(l, c, a);
    i.putImageData(d, 0, 0);
  }
  captureGPUInfo() {
    if (this.gpuInfo) return this.gpuInfo;
    const e = this.gl, t = { renderer: "", vendor: "" };
    if (!e) return t;
    const i = e.getExtension("WEBGL_debug_renderer_info");
    if (i) {
      const c = e.getParameter(i.UNMASKED_RENDERER_WEBGL), a = e.getParameter(i.UNMASKED_VENDOR_WEBGL);
      c && (t.renderer = c.toLowerCase()), a && (t.vendor = a.toLowerCase());
    }
    return this.gpuInfo = t, t;
  }
}
let ww;
function DY() {
  const { WebGLProbe: n } = fd();
  return n.queryWebGL(lu()), Br.enableGLFiltering && n.isSupported(Br.textureSize) ? new $8({ tileSize: Br.textureSize }) : new OY();
}
function xw() {
  return !ww && (!(arguments.length > 0 && arguments[0] !== void 0) || arguments[0]) && (ww = DY()), ww;
}
const RY = ["filters", "resizeFilter", "src", "crossOrigin", "type"], Y8 = ["cropX", "cropY"];
class ru extends es {
  static getDefaults() {
    return lt(lt({}, super.getDefaults()), ru.ownDefaults);
  }
  constructor(e, t) {
    super(), it(this, "_lastScaleX", 1), it(this, "_lastScaleY", 1), it(this, "_filterScalingX", 1), it(this, "_filterScalingY", 1), this.filters = [], Object.assign(this, ru.ownDefaults), this.setOptions(t), this.cacheKey = "texture".concat(Wh()), this.setElement(typeof e == "string" ? (this.canvas && tc(this.canvas.getElement()) || f0()).getElementById(e) : e, t);
  }
  getElement() {
    return this._element;
  }
  setElement(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.removeTexture(this.cacheKey), this.removeTexture("".concat(this.cacheKey, "_filtered")), this._element = e, this._originalElement = e, this._setWidthHeight(t), e.classList.add(ru.CSS_CANVAS), this.filters.length !== 0 && this.applyFilters(), this.resizeFilter && this.applyResizeFilters();
  }
  removeTexture(e) {
    const t = xw(!1);
    t instanceof $8 && t.evictCachesForKey(e);
  }
  dispose() {
    super.dispose(), this.removeTexture(this.cacheKey), this.removeTexture("".concat(this.cacheKey, "_filtered")), this._cacheContext = null, ["_originalElement", "_element", "_filteredEl", "_cacheCanvas"].forEach((e) => {
      const t = this[e];
      t && fd().dispose(t), this[e] = void 0;
    });
  }
  getCrossOrigin() {
    return this._originalElement && (this._originalElement.crossOrigin || null);
  }
  getOriginalSize() {
    const e = this.getElement();
    return e ? { width: e.naturalWidth || e.width, height: e.naturalHeight || e.height } : { width: 0, height: 0 };
  }
  _stroke(e) {
    if (!this.stroke || this.strokeWidth === 0) return;
    const t = this.width / 2, i = this.height / 2;
    e.beginPath(), e.moveTo(-t, -i), e.lineTo(t, -i), e.lineTo(t, i), e.lineTo(-t, i), e.lineTo(-t, -i), e.closePath();
  }
  toObject() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const t = [];
    return this.filters.forEach((i) => {
      i && t.push(i.toObject());
    }), lt(lt({}, super.toObject([...Y8, ...e])), {}, { src: this.getSrc(), crossOrigin: this.getCrossOrigin(), filters: t }, this.resizeFilter ? { resizeFilter: this.resizeFilter.toObject() } : {});
  }
  hasCrop() {
    return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
  }
  _toSVG() {
    const e = [], t = this._element, i = -this.width / 2, c = -this.height / 2;
    let a = [], s = [], r = "", l = "";
    if (!t) return [];
    if (this.hasCrop()) {
      const d = Wh();
      a.push('<clipPath id="imageCrop_' + d + `">
`, '	<rect x="' + i + '" y="' + c + '" width="' + this.width + '" height="' + this.height + `" />
`, `</clipPath>
`), r = ' clip-path="url(#imageCrop_' + d + ')" ';
    }
    if (this.imageSmoothing || (l = ' image-rendering="optimizeSpeed"'), e.push("	<image ", "COMMON_PARTS", 'xlink:href="'.concat(this.getSvgSrc(!0), '" x="').concat(i - this.cropX, '" y="').concat(c - this.cropY, '" width="').concat(t.width || t.naturalWidth, '" height="').concat(t.height || t.naturalHeight, '"').concat(l).concat(r, `></image>
`)), this.stroke || this.strokeDashArray) {
      const d = this.fill;
      this.fill = null, s = ['	<rect x="'.concat(i, '" y="').concat(c, '" width="').concat(this.width, '" height="').concat(this.height, '" style="').concat(this.getSvgStyles(), `" />
`)], this.fill = d;
    }
    return a = this.paintFirst !== ta ? a.concat(s, e) : a.concat(e, s), a;
  }
  getSrc(e) {
    const t = e ? this._element : this._originalElement;
    return t ? t.toDataURL ? t.toDataURL() : this.srcFromAttribute ? t.getAttribute("src") || "" : t.src : this.src || "";
  }
  getSvgSrc(e) {
    return this.getSrc(e);
  }
  setSrc(e) {
    let { crossOrigin: t, signal: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return m1(e, { crossOrigin: t, signal: i }).then((c) => {
      t !== void 0 && this.set({ crossOrigin: t }), this.setElement(c);
    });
  }
  toString() {
    return '#<Image: { src: "'.concat(this.getSrc(), '" }>');
  }
  applyResizeFilters() {
    const e = this.resizeFilter, t = this.minimumScaleTrigger, i = this.getTotalObjectScaling(), c = i.x, a = i.y, s = this._filteredEl || this._originalElement;
    if (this.group && this.set("dirty", !0), !e || c > t && a > t) return this._element = s, this._filterScalingX = 1, this._filterScalingY = 1, this._lastScaleX = c, void (this._lastScaleY = a);
    const r = ac(s), { width: l, height: d } = s;
    this._element = r, this._lastScaleX = e.scaleX = c, this._lastScaleY = e.scaleY = a, xw().applyFilters([e], s, l, d, this._element), this._filterScalingX = r.width / this._originalElement.width, this._filterScalingY = r.height / this._originalElement.height;
  }
  applyFilters() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.filters || [];
    if (e = e.filter((a) => a && !a.isNeutralState()), this.set("dirty", !0), this.removeTexture("".concat(this.cacheKey, "_filtered")), e.length === 0) return this._element = this._originalElement, this._filteredEl = void 0, this._filterScalingX = 1, void (this._filterScalingY = 1);
    const t = this._originalElement, i = t.naturalWidth || t.width, c = t.naturalHeight || t.height;
    if (this._element === this._originalElement) {
      const a = ac({ width: i, height: c });
      this._element = a, this._filteredEl = a;
    } else this._filteredEl && (this._element = this._filteredEl, this._filteredEl.getContext("2d").clearRect(0, 0, i, c), this._lastScaleX = 1, this._lastScaleY = 1);
    xw().applyFilters(e, this._originalElement, i, c, this._element), this._originalElement.width === this._element.width && this._originalElement.height === this._element.height || (this._filterScalingX = this._element.width / this._originalElement.width, this._filterScalingY = this._element.height / this._originalElement.height);
  }
  _render(e) {
    e.imageSmoothingEnabled = this.imageSmoothing, this.isMoving !== !0 && this.resizeFilter && this._needsResize() && this.applyResizeFilters(), this._stroke(e), this._renderPaintInOrder(e);
  }
  drawCacheOnCanvas(e) {
    e.imageSmoothingEnabled = this.imageSmoothing, super.drawCacheOnCanvas(e);
  }
  shouldCache() {
    return this.needsItsOwnCache();
  }
  _renderFill(e) {
    const t = this._element;
    if (!t) return;
    const i = this._filterScalingX, c = this._filterScalingY, a = this.width, s = this.height, r = Math.max(this.cropX, 0), l = Math.max(this.cropY, 0), d = t.naturalWidth || t.width, f = t.naturalHeight || t.height, h = r * i, p = l * c, g = Math.min(a * i, d - h), _ = Math.min(s * c, f - p), b = -a / 2, v = -s / 2, E = Math.min(a, d / i - r), C = Math.min(s, f / c - l);
    t && e.drawImage(t, h, p, g, _, b, v, E, C);
  }
  _needsResize() {
    const e = this.getTotalObjectScaling();
    return e.x !== this._lastScaleX || e.y !== this._lastScaleY;
  }
  _resetWidthHeight() {
    this.set(this.getOriginalSize());
  }
  _setWidthHeight() {
    let { width: e, height: t } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const i = this.getOriginalSize();
    this.width = e || i.width, this.height = t || i.height;
  }
  parsePreserveAspectRatioAttribute() {
    const e = G7(this.preserveAspectRatio || ""), t = this.width, i = this.height, c = { width: t, height: i };
    let a, s = this._element.width, r = this._element.height, l = 1, d = 1, f = 0, h = 0, p = 0, g = 0;
    return !e || e.alignX === Qs && e.alignY === Qs ? (l = t / s, d = i / r) : (e.meetOrSlice === "meet" && (l = d = w8(this._element, c), a = (t - s * l) / 2, e.alignX === "Min" && (f = -a), e.alignX === "Max" && (f = a), a = (i - r * d) / 2, e.alignY === "Min" && (h = -a), e.alignY === "Max" && (h = a)), e.meetOrSlice === "slice" && (l = d = x8(this._element, c), a = s - t / l, e.alignX === "Mid" && (p = a / 2), e.alignX === "Max" && (p = a), a = r - i / d, e.alignY === "Mid" && (g = a / 2), e.alignY === "Max" && (g = a), s = t / l, r = i / d)), { width: s, height: r, scaleX: l, scaleY: d, offsetLeft: f, offsetTop: h, cropX: p, cropY: g };
  }
  static fromObject(e, t) {
    let { filters: i, resizeFilter: c, src: a, crossOrigin: s, type: r } = e, l = Vi(e, RY);
    return Promise.all([m1(a, lt(lt({}, t), {}, { crossOrigin: s })), i && l0(i, t), c && l0([c], t), F1(l, t)]).then((d) => {
      let [f, h = [], [p] = [], g = {}] = d;
      return new this(f, lt(lt({}, l), {}, { src: a, filters: h, resizeFilter: p }, g));
    });
  }
  static fromURL(e) {
    let { crossOrigin: t = null, signal: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = arguments.length > 2 ? arguments[2] : void 0;
    return m1(e, { crossOrigin: t, signal: i }).then((a) => new this(a, c));
  }
  static async fromElement(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 ? arguments[2] : void 0;
    const c = wf(e, this.ATTRIBUTE_NAMES, i);
    return this.fromURL(c["xlink:href"], t, c).catch((a) => (qh("log", "Unable to parse Image", a), null));
  }
}
it(ru, "type", "Image"), it(ru, "cacheProperties", [...Cf, ...Y8]), it(ru, "ownDefaults", { strokeWidth: 0, srcFromAttribute: !1, minimumScaleTrigger: 0.5, cropX: 0, cropY: 0, imageSmoothing: !0 }), it(ru, "CSS_CANVAS", "canvas-img"), it(ru, "ATTRIBUTE_NAMES", [...Qh, "x", "y", "width", "height", "preserveAspectRatio", "xlink:href", "crossOrigin", "image-rendering"]), pn.setClass(ru), pn.setSVGClass(ru);
I2(["pattern", "defs", "symbol", "metadata", "clipPath", "mask", "desc"]);
const U2 = (n) => n.webgl !== void 0, bT = "precision highp float", NY = `
    `.concat(bT, `;
    varying vec2 vTexCoord;
    uniform sampler2D uTexture;
    void main() {
      gl_FragColor = texture2D(uTexture, vTexCoord);
    }`), IY = ["type"], LY = ["type"], MY = new RegExp(bT, "g");
class na {
  get type() {
    return this.constructor.type;
  }
  constructor() {
    let e = Vi(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, IY);
    Object.assign(this, this.constructor.defaults, e);
  }
  getFragmentSource() {
    return NY;
  }
  getVertexSource() {
    return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    void main() {
      vTexCoord = aPosition;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }`;
  }
  createProgram(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getFragmentSource(), i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.getVertexSource();
    const { WebGLProbe: { GLPrecision: c = "highp" } } = fd();
    c !== "highp" && (t = t.replace(MY, bT.replace("highp", c)));
    const a = e.createShader(e.VERTEX_SHADER), s = e.createShader(e.FRAGMENT_SHADER), r = e.createProgram();
    if (!a || !s || !r) throw new ud("Vertex, fragment shader or program creation error");
    if (e.shaderSource(a, i), e.compileShader(a), !e.getShaderParameter(a, e.COMPILE_STATUS)) throw new ud("Vertex shader compile error for ".concat(this.type, ": ").concat(e.getShaderInfoLog(a)));
    if (e.shaderSource(s, t), e.compileShader(s), !e.getShaderParameter(s, e.COMPILE_STATUS)) throw new ud("Fragment shader compile error for ".concat(this.type, ": ").concat(e.getShaderInfoLog(s)));
    if (e.attachShader(r, a), e.attachShader(r, s), e.linkProgram(r), !e.getProgramParameter(r, e.LINK_STATUS)) throw new ud('Shader link error for "'.concat(this.type, '" ').concat(e.getProgramInfoLog(r)));
    const l = this.getUniformLocations(e, r) || {};
    return l.uStepW = e.getUniformLocation(r, "uStepW"), l.uStepH = e.getUniformLocation(r, "uStepH"), { program: r, attributeLocations: this.getAttributeLocations(e, r), uniformLocations: l };
  }
  getAttributeLocations(e, t) {
    return { aPosition: e.getAttribLocation(t, "aPosition") };
  }
  getUniformLocations(e, t) {
    const i = this.constructor.uniformLocations, c = {};
    for (let a = 0; a < i.length; a++) c[i[a]] = e.getUniformLocation(t, i[a]);
    return c;
  }
  sendAttributeData(e, t, i) {
    const c = t.aPosition, a = e.createBuffer();
    e.bindBuffer(e.ARRAY_BUFFER, a), e.enableVertexAttribArray(c), e.vertexAttribPointer(c, 2, e.FLOAT, !1, 0, 0), e.bufferData(e.ARRAY_BUFFER, i, e.STATIC_DRAW);
  }
  _setupFrameBuffer(e) {
    const t = e.context;
    if (e.passes > 1) {
      const i = e.destinationWidth, c = e.destinationHeight;
      e.sourceWidth === i && e.sourceHeight === c || (t.deleteTexture(e.targetTexture), e.targetTexture = e.filterBackend.createTexture(t, i, c)), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e.targetTexture, 0);
    } else t.bindFramebuffer(t.FRAMEBUFFER, null), t.finish();
  }
  _swapTextures(e) {
    e.passes--, e.pass++;
    const t = e.targetTexture;
    e.targetTexture = e.sourceTexture, e.sourceTexture = t;
  }
  isNeutralState(e) {
    return !1;
  }
  applyTo(e) {
    U2(e) ? (this._setupFrameBuffer(e), this.applyToWebGL(e), this._swapTextures(e)) : this.applyTo2d(e);
  }
  applyTo2d(e) {
  }
  getCacheKey() {
    return this.type;
  }
  retrieveShader(e) {
    const t = this.getCacheKey();
    return e.programCache[t] || (e.programCache[t] = this.createProgram(e.context)), e.programCache[t];
  }
  applyToWebGL(e) {
    const t = e.context, i = this.retrieveShader(e);
    e.pass === 0 && e.originalTexture ? t.bindTexture(t.TEXTURE_2D, e.originalTexture) : t.bindTexture(t.TEXTURE_2D, e.sourceTexture), t.useProgram(i.program), this.sendAttributeData(t, i.attributeLocations, e.aPosition), t.uniform1f(i.uniformLocations.uStepW, 1 / e.sourceWidth), t.uniform1f(i.uniformLocations.uStepH, 1 / e.sourceHeight), this.sendUniformData(t, i.uniformLocations), t.viewport(0, 0, e.destinationWidth, e.destinationHeight), t.drawArrays(t.TRIANGLE_STRIP, 0, 4);
  }
  bindAdditionalTexture(e, t, i) {
    e.activeTexture(i), e.bindTexture(e.TEXTURE_2D, t), e.activeTexture(e.TEXTURE0);
  }
  unbindAdditionalTexture(e, t) {
    e.activeTexture(t), e.bindTexture(e.TEXTURE_2D, null), e.activeTexture(e.TEXTURE0);
  }
  sendUniformData(e, t) {
  }
  createHelpLayer(e) {
    if (!e.helpLayer) {
      const { sourceWidth: t, sourceHeight: i } = e, c = ac({ width: t, height: i });
      e.helpLayer = c;
    }
  }
  toObject() {
    const e = Object.keys(this.constructor.defaults || {});
    return lt({ type: this.type }, e.reduce((t, i) => (t[i] = this[i], t), {}));
  }
  toJSON() {
    return this.toObject();
  }
  static async fromObject(e, t) {
    return new this(Vi(e, LY));
  }
}
it(na, "type", "BaseFilter"), it(na, "uniformLocations", []);
const PY = { multiply: `gl_FragColor.rgb *= uColor.rgb;
`, screen: `gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);
`, add: `gl_FragColor.rgb += uColor.rgb;
`, difference: `gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);
`, subtract: `gl_FragColor.rgb -= uColor.rgb;
`, lighten: `gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);
`, darken: `gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);
`, exclusion: `gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);
`, overlay: `
    if (uColor.r < 0.5) {
      gl_FragColor.r *= 2.0 * uColor.r;
    } else {
      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);
    }
    if (uColor.g < 0.5) {
      gl_FragColor.g *= 2.0 * uColor.g;
    } else {
      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);
    }
    if (uColor.b < 0.5) {
      gl_FragColor.b *= 2.0 * uColor.b;
    } else {
      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);
    }
    `, tint: `
    gl_FragColor.rgb *= (1.0 - uColor.a);
    gl_FragColor.rgb += uColor.rgb;
    ` };
class db extends na {
  getCacheKey() {
    return "".concat(this.type, "_").concat(this.mode);
  }
  getFragmentSource() {
    return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec4 uColor;
      varying vec2 vTexCoord;
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        gl_FragColor = color;
        if (color.a > 0.0) {
          `.concat(PY[this.mode], `
        }
      }
      `);
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = new Wr(this.color).getSource(), c = this.alpha, a = i[0] * c, s = i[1] * c, r = i[2] * c, l = 1 - c;
    for (let d = 0; d < t.length; d += 4) {
      const f = t[d], h = t[d + 1], p = t[d + 2];
      let g, _, b;
      switch (this.mode) {
        case "multiply":
          g = f * a / 255, _ = h * s / 255, b = p * r / 255;
          break;
        case "screen":
          g = 255 - (255 - f) * (255 - a) / 255, _ = 255 - (255 - h) * (255 - s) / 255, b = 255 - (255 - p) * (255 - r) / 255;
          break;
        case "add":
          g = f + a, _ = h + s, b = p + r;
          break;
        case "difference":
          g = Math.abs(f - a), _ = Math.abs(h - s), b = Math.abs(p - r);
          break;
        case "subtract":
          g = f - a, _ = h - s, b = p - r;
          break;
        case "darken":
          g = Math.min(f, a), _ = Math.min(h, s), b = Math.min(p, r);
          break;
        case "lighten":
          g = Math.max(f, a), _ = Math.max(h, s), b = Math.max(p, r);
          break;
        case "overlay":
          g = a < 128 ? 2 * f * a / 255 : 255 - 2 * (255 - f) * (255 - a) / 255, _ = s < 128 ? 2 * h * s / 255 : 255 - 2 * (255 - h) * (255 - s) / 255, b = r < 128 ? 2 * p * r / 255 : 255 - 2 * (255 - p) * (255 - r) / 255;
          break;
        case "exclusion":
          g = a + f - 2 * a * f / 255, _ = s + h - 2 * s * h / 255, b = r + p - 2 * r * p / 255;
          break;
        case "tint":
          g = a + f * l, _ = s + h * l, b = r + p * l;
      }
      t[d] = g, t[d + 1] = _, t[d + 2] = b;
    }
  }
  sendUniformData(e, t) {
    const i = new Wr(this.color).getSource();
    i[0] = this.alpha * i[0] / 255, i[1] = this.alpha * i[1] / 255, i[2] = this.alpha * i[2] / 255, i[3] = this.alpha, e.uniform4fv(t.uColor, i);
  }
}
it(db, "defaults", { color: "#F95C63", mode: "multiply", alpha: 1 }), it(db, "type", "BlendColor"), it(db, "uniformLocations", ["uColor"]), pn.setClass(db);
const jY = { multiply: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.rgba *= color2.rgba;
      gl_FragColor = color;
    }
    `, mask: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.a = color2.a;
      gl_FragColor = color;
    }
    ` }, BY = ["type", "image"];
class fb extends na {
  getCacheKey() {
    return "".concat(this.type, "_").concat(this.mode);
  }
  getFragmentSource() {
    return jY[this.mode];
  }
  getVertexSource() {
    return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    uniform mat3 uTransformMatrix;
    void main() {
      vTexCoord = aPosition;
      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }
    `;
  }
  applyToWebGL(e) {
    const t = e.context, i = this.createTexture(e.filterBackend, this.image);
    this.bindAdditionalTexture(t, i, t.TEXTURE1), super.applyToWebGL(e), this.unbindAdditionalTexture(t, t.TEXTURE1);
  }
  createTexture(e, t) {
    return e.getCachedTexture(t.cacheKey, t.getElement());
  }
  calculateMatrix() {
    const e = this.image, { width: t, height: i } = e.getElement();
    return [1 / e.scaleX, 0, 0, 0, 1 / e.scaleY, 0, -e.left / t, -e.top / i, 1];
  }
  applyTo2d(e) {
    let { imageData: { data: t, width: i, height: c }, filterBackend: { resources: a } } = e;
    const s = this.image;
    a.blendImage || (a.blendImage = lu());
    const r = a.blendImage, l = r.getContext("2d");
    r.width !== i || r.height !== c ? (r.width = i, r.height = c) : l.clearRect(0, 0, i, c), l.setTransform(s.scaleX, 0, 0, s.scaleY, s.left, s.top), l.drawImage(s.getElement(), 0, 0, i, c);
    const d = l.getImageData(0, 0, i, c).data;
    for (let f = 0; f < t.length; f += 4) {
      const h = t[f], p = t[f + 1], g = t[f + 2], _ = t[f + 3], b = d[f], v = d[f + 1], E = d[f + 2], C = d[f + 3];
      switch (this.mode) {
        case "multiply":
          t[f] = h * b / 255, t[f + 1] = p * v / 255, t[f + 2] = g * E / 255, t[f + 3] = _ * C / 255;
          break;
        case "mask":
          t[f + 3] = C;
      }
    }
  }
  sendUniformData(e, t) {
    const i = this.calculateMatrix();
    e.uniform1i(t.uImage, 1), e.uniformMatrix3fv(t.uTransformMatrix, !1, i);
  }
  toObject() {
    return lt(lt({}, super.toObject()), {}, { image: this.image && this.image.toObject() });
  }
  static async fromObject(e, t) {
    let { type: i, image: c } = e, a = Vi(e, BY);
    return ru.fromObject(c, t).then((s) => new this(lt(lt({}, a), {}, { image: s })));
  }
}
it(fb, "type", "BlendImage"), it(fb, "defaults", { mode: "multiply", alpha: 1 }), it(fb, "uniformLocations", ["uTransformMatrix", "uImage"]), pn.setClass(fb);
class hb extends na {
  getFragmentSource() {
    return `
    precision highp float;
    uniform sampler2D uTexture;
    uniform vec2 uDelta;
    varying vec2 vTexCoord;
    const float nSamples = 15.0;
    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);
    float random(vec3 scale) {
      /* use the fragment position for a different seed per-pixel */
      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);
    }
    void main() {
      vec4 color = vec4(0.0);
      float total = 0.0;
      float offset = random(v3offset);
      for (float t = -nSamples; t <= nSamples; t++) {
        float percent = (t + offset - 0.5) / nSamples;
        float weight = 1.0 - abs(percent);
        color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;
        total += weight;
      }
      gl_FragColor = color / total;
    }
  `;
  }
  applyTo(e) {
    U2(e) ? (this.aspectRatio = e.sourceWidth / e.sourceHeight, e.passes++, this._setupFrameBuffer(e), this.horizontal = !0, this.applyToWebGL(e), this._swapTextures(e), this._setupFrameBuffer(e), this.horizontal = !1, this.applyToWebGL(e), this._swapTextures(e)) : this.applyTo2d(e);
  }
  applyTo2d(e) {
    e.imageData = this.simpleBlur(e);
  }
  simpleBlur(e) {
    let { ctx: t, imageData: i, filterBackend: { resources: c } } = e;
    const { width: a, height: s } = i;
    c.blurLayer1 || (c.blurLayer1 = lu(), c.blurLayer2 = lu());
    const r = c.blurLayer1, l = c.blurLayer2;
    r.width === a && r.height === s || (l.width = r.width = a, l.height = r.height = s);
    const d = r.getContext("2d"), f = l.getContext("2d"), h = 15, p = 0.06 * this.blur * 0.5;
    let g, _, b, v;
    for (d.putImageData(i, 0, 0), f.clearRect(0, 0, a, s), v = -15; v <= h; v++) g = (Math.random() - 0.5) / 4, _ = v / h, b = p * _ * a + g, f.globalAlpha = 1 - Math.abs(_), f.drawImage(r, b, g), d.drawImage(l, 0, 0), f.globalAlpha = 1, f.clearRect(0, 0, l.width, l.height);
    for (v = -15; v <= h; v++) g = (Math.random() - 0.5) / 4, _ = v / h, b = p * _ * s + g, f.globalAlpha = 1 - Math.abs(_), f.drawImage(r, g, b), d.drawImage(l, 0, 0), f.globalAlpha = 1, f.clearRect(0, 0, l.width, l.height);
    t.drawImage(r, 0, 0);
    const E = t.getImageData(0, 0, r.width, r.height);
    return d.globalAlpha = 1, d.clearRect(0, 0, r.width, r.height), E;
  }
  sendUniformData(e, t) {
    const i = this.chooseRightDelta();
    e.uniform2fv(t.uDelta, i);
  }
  isNeutralState() {
    return this.blur === 0;
  }
  chooseRightDelta() {
    let e = 1;
    const t = [0, 0];
    this.horizontal ? this.aspectRatio > 1 && (e = 1 / this.aspectRatio) : this.aspectRatio < 1 && (e = this.aspectRatio);
    const i = e * this.blur * 0.12;
    return this.horizontal ? t[0] = i : t[1] = i, t;
  }
}
it(hb, "type", "Blur"), it(hb, "defaults", { blur: 0 }), it(hb, "uniformLocations", ["uDelta"]), pn.setClass(hb);
class pb extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBrightness;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += uBrightness;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = Math.round(255 * this.brightness);
    for (let c = 0; c < t.length; c += 4) t[c] += i, t[c + 1] += i, t[c + 2] += i;
  }
  isNeutralState() {
    return this.brightness === 0;
  }
  sendUniformData(e, t) {
    e.uniform1f(t.uBrightness, this.brightness);
  }
}
it(pb, "type", "Brightness"), it(pb, "defaults", { brightness: 0 }), it(pb, "uniformLocations", ["uBrightness"]), pn.setClass(pb);
const X8 = { matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], colorsOnly: !0 };
class Zg extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  varying vec2 vTexCoord;
  uniform mat4 uColorMatrix;
  uniform vec4 uConstants;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color *= uColorMatrix;
    color += uConstants;
    gl_FragColor = color;
  }`;
  }
  applyTo2d(e) {
    const t = e.imageData.data, i = this.matrix, c = this.colorsOnly;
    for (let a = 0; a < t.length; a += 4) {
      const s = t[a], r = t[a + 1], l = t[a + 2];
      if (t[a] = s * i[0] + r * i[1] + l * i[2] + 255 * i[4], t[a + 1] = s * i[5] + r * i[6] + l * i[7] + 255 * i[9], t[a + 2] = s * i[10] + r * i[11] + l * i[12] + 255 * i[14], !c) {
        const d = t[a + 3];
        t[a] += d * i[3], t[a + 1] += d * i[8], t[a + 2] += d * i[13], t[a + 3] = s * i[15] + r * i[16] + l * i[17] + d * i[18] + 255 * i[19];
      }
    }
  }
  sendUniformData(e, t) {
    const i = this.matrix, c = [i[0], i[1], i[2], i[3], i[5], i[6], i[7], i[8], i[10], i[11], i[12], i[13], i[15], i[16], i[17], i[18]], a = [i[4], i[9], i[14], i[19]];
    e.uniformMatrix4fv(t.uColorMatrix, !1, c), e.uniform4fv(t.uConstants, a);
  }
  toObject() {
    return lt(lt({}, super.toObject()), {}, { matrix: [...this.matrix] });
  }
}
function Nm(n, e) {
  var t;
  const i = (it(t = class extends Zg {
    toObject() {
      return { type: this.type, colorsOnly: this.colorsOnly };
    }
  }, "type", n), it(t, "defaults", { colorsOnly: !1, matrix: e }), t);
  return pn.setClass(i, n), i;
}
it(Zg, "type", "ColorMatrix"), it(Zg, "defaults", X8), it(Zg, "uniformLocations", ["uColorMatrix", "uConstants"]), pn.setClass(Zg);
Nm("Brownie", [0.5997, 0.34553, -0.27082, 0, 0.186, -0.0377, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0]);
Nm("Vintage", [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.0466, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0]);
Nm("Kodachrome", [1.12855, -0.39673, -0.03992, 0, 0.24991, -0.16404, 1.08352, -0.05498, 0, 0.09698, -0.16786, -0.56034, 1.60148, 0, 0.13972, 0, 0, 0, 1, 0]);
Nm("Technicolor", [1.91252, -0.85453, -0.09155, 0, 0.04624, -0.30878, 1.76589, -0.10601, 0, -0.27589, -0.2311, -0.75018, 1.84759, 0, 0.12137, 0, 0, 0, 1, 0]);
Nm("Polaroid", [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0]);
Nm("Sepia", [0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0]);
Nm("BlackWhite", [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]);
class cO extends na {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(e), this.subFilters = e.subFilters || [];
  }
  applyTo(e) {
    U2(e) && (e.passes += this.subFilters.length - 1), this.subFilters.forEach((t) => {
      t.applyTo(e);
    });
  }
  toObject() {
    return { type: this.type, subFilters: this.subFilters.map((e) => e.toObject()) };
  }
  isNeutralState() {
    return !this.subFilters.some((e) => !e.isNeutralState());
  }
  static fromObject(e, t) {
    return Promise.all((e.subFilters || []).map((i) => pn.getClass(i.type).fromObject(i, t))).then((i) => new this({ subFilters: i }));
  }
}
it(cO, "type", "Composed"), pn.setClass(cO);
class mb extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uContrast;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));
    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;
    gl_FragColor = color;
  }`;
  }
  isNeutralState() {
    return this.contrast === 0;
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = Math.floor(255 * this.contrast), c = 259 * (i + 255) / (255 * (259 - i));
    for (let a = 0; a < t.length; a += 4) t[a] = c * (t[a] - 128) + 128, t[a + 1] = c * (t[a + 1] - 128) + 128, t[a + 2] = c * (t[a + 2] - 128) + 128;
  }
  sendUniformData(e, t) {
    e.uniform1f(t.uContrast, this.contrast);
  }
}
it(mb, "type", "Contrast"), it(mb, "defaults", { contrast: 0 }), it(mb, "uniformLocations", ["uContrast"]), pn.setClass(mb);
const FY = { Convolute_3_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_3_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_5_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_5_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_7_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_7_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_9_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_9_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    ` };
class gb extends na {
  getCacheKey() {
    return "".concat(this.type, "_").concat(Math.sqrt(this.matrix.length), "_").concat(this.opaque ? 1 : 0);
  }
  getFragmentSource() {
    return FY[this.getCacheKey()];
  }
  applyTo2d(e) {
    const t = e.imageData, i = t.data, c = this.matrix, a = Math.round(Math.sqrt(c.length)), s = Math.floor(a / 2), r = t.width, l = t.height, d = e.ctx.createImageData(r, l), f = d.data, h = this.opaque ? 1 : 0;
    let p, g, _, b, v, E, C, y, T, A, k, N, j;
    for (k = 0; k < l; k++) for (A = 0; A < r; A++) {
      for (v = 4 * (k * r + A), p = 0, g = 0, _ = 0, b = 0, j = 0; j < a; j++) for (N = 0; N < a; N++) C = k + j - s, E = A + N - s, C < 0 || C >= l || E < 0 || E >= r || (y = 4 * (C * r + E), T = c[j * a + N], p += i[y] * T, g += i[y + 1] * T, _ += i[y + 2] * T, h || (b += i[y + 3] * T));
      f[v] = p, f[v + 1] = g, f[v + 2] = _, f[v + 3] = h ? i[v + 3] : b;
    }
    e.imageData = d;
  }
  sendUniformData(e, t) {
    e.uniform1fv(t.uMatrix, this.matrix);
  }
  toObject() {
    return lt(lt({}, super.toObject()), {}, { opaque: this.opaque, matrix: [...this.matrix] });
  }
}
it(gb, "type", "Convolute"), it(gb, "defaults", { opaque: !1, matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0] }), it(gb, "uniformLocations", ["uMatrix", "uOpaque", "uHalfSize", "uSize"]), pn.setClass(gb);
const K8 = "Gamma";
class _b extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform vec3 uGamma;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    vec3 correction = (1.0 / uGamma);
    color.r = pow(color.r, correction.r);
    color.g = pow(color.g, correction.g);
    color.b = pow(color.b, correction.b);
    gl_FragColor = color;
    gl_FragColor.rgb *= color.a;
  }
`;
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(e), this.gamma = e.gamma || this.constructor.defaults.gamma.concat();
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = this.gamma, c = 1 / i[0], a = 1 / i[1], s = 1 / i[2];
    this.rgbValues || (this.rgbValues = { r: new Uint8Array(256), g: new Uint8Array(256), b: new Uint8Array(256) });
    const r = this.rgbValues;
    for (let l = 0; l < 256; l++) r.r[l] = 255 * Math.pow(l / 255, c), r.g[l] = 255 * Math.pow(l / 255, a), r.b[l] = 255 * Math.pow(l / 255, s);
    for (let l = 0; l < t.length; l += 4) t[l] = r.r[t[l]], t[l + 1] = r.g[t[l + 1]], t[l + 2] = r.b[t[l + 2]];
  }
  sendUniformData(e, t) {
    e.uniform3fv(t.uGamma, this.gamma);
  }
  isNeutralState() {
    const { gamma: e } = this;
    return e[0] === 1 && e[1] === 1 && e[2] === 1;
  }
  toObject() {
    return { type: K8, gamma: this.gamma.concat() };
  }
}
it(_b, "type", K8), it(_b, "defaults", { gamma: [1, 1, 1] }), it(_b, "uniformLocations", ["uGamma"]), pn.setClass(_b);
const UY = { average: `
    precision highp float;
    uniform sampler2D uTexture;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      float average = (color.r + color.b + color.g) / 3.0;
      gl_FragColor = vec4(average, average, average, color.a);
    }
    `, lightness: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    `, luminosity: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    ` };
class yb extends na {
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    for (let i, c = 0; c < t.length; c += 4) {
      const a = t[c], s = t[c + 1], r = t[c + 2];
      switch (this.mode) {
        case "average":
          i = (a + s + r) / 3;
          break;
        case "lightness":
          i = (Math.min(a, s, r) + Math.max(a, s, r)) / 2;
          break;
        case "luminosity":
          i = 0.21 * a + 0.72 * s + 0.07 * r;
      }
      t[c + 2] = t[c + 1] = t[c] = i;
    }
  }
  getCacheKey() {
    return "".concat(this.type, "_").concat(this.mode);
  }
  getFragmentSource() {
    return UY[this.mode];
  }
  sendUniformData(e, t) {
    e.uniform1i(t.uMode, 1);
  }
  isNeutralState() {
    return !1;
  }
}
it(yb, "type", "Grayscale"), it(yb, "defaults", { mode: "average" }), it(yb, "uniformLocations", ["uMode"]), pn.setClass(yb);
const HY = lt(lt({}, X8), {}, { rotation: 0 });
class Tw extends Zg {
  calculateMatrix() {
    const e = this.rotation * Math.PI, t = ic(e), i = oc(e), c = 1 / 3, a = Math.sqrt(c) * i, s = 1 - t;
    this.matrix = [t + s / 3, c * s - a, c * s + a, 0, 0, c * s + a, t + c * s, c * s - a, 0, 0, c * s - a, c * s + a, t + c * s, 0, 0, 0, 0, 0, 1, 0];
  }
  isNeutralState() {
    return this.rotation === 0;
  }
  applyTo(e) {
    this.calculateMatrix(), super.applyTo(e);
  }
  toObject() {
    return { type: this.type, rotation: this.rotation };
  }
}
it(Tw, "type", "HueRotation"), it(Tw, "defaults", HY), pn.setClass(Tw);
class vb extends na {
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    for (let i = 0; i < t.length; i += 4) t[i] = 255 - t[i], t[i + 1] = 255 - t[i + 1], t[i + 2] = 255 - t[i + 2], this.alpha && (t[i + 3] = 255 - t[i + 3]);
  }
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform int uInvert;
  uniform int uAlpha;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    if (uInvert == 1) {
      if (uAlpha == 1) {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);
      } else {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);
      }
    } else {
      gl_FragColor = color;
    }
  }
`;
  }
  isNeutralState() {
    return !this.invert;
  }
  sendUniformData(e, t) {
    e.uniform1i(t.uInvert, Number(this.invert)), e.uniform1i(t.uAlpha, Number(this.alpha));
  }
}
it(vb, "type", "Invert"), it(vb, "defaults", { alpha: !1, invert: !0 }), it(vb, "uniformLocations", ["uInvert", "uAlpha"]), pn.setClass(vb);
class bb extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uStepH;
  uniform float uNoise;
  uniform float uSeed;
  varying vec2 vTexCoord;
  float rand(vec2 co, float seed, float vScale) {
    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);
  }
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = this.noise;
    for (let c = 0; c < t.length; c += 4) {
      const a = (0.5 - Math.random()) * i;
      t[c] += a, t[c + 1] += a, t[c + 2] += a;
    }
  }
  sendUniformData(e, t) {
    e.uniform1f(t.uNoise, this.noise / 255), e.uniform1f(t.uSeed, Math.random());
  }
  isNeutralState() {
    return this.noise === 0;
  }
}
it(bb, "type", "Noise"), it(bb, "defaults", { noise: 0 }), it(bb, "uniformLocations", ["uNoise", "uSeed"]), pn.setClass(bb);
class Eb extends na {
  applyTo2d(e) {
    let { imageData: { data: t, width: i, height: c } } = e;
    for (let a = 0; a < c; a += this.blocksize) for (let s = 0; s < i; s += this.blocksize) {
      const r = 4 * a * i + 4 * s, l = t[r], d = t[r + 1], f = t[r + 2], h = t[r + 3];
      for (let p = a; p < Math.min(a + this.blocksize, c); p++) for (let g = s; g < Math.min(s + this.blocksize, i); g++) {
        const _ = 4 * p * i + 4 * g;
        t[_] = l, t[_ + 1] = d, t[_ + 2] = f, t[_ + 3] = h;
      }
    }
  }
  isNeutralState() {
    return this.blocksize === 1;
  }
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBlocksize;
  uniform float uStepW;
  uniform float uStepH;
  varying vec2 vTexCoord;
  void main() {
    float blockW = uBlocksize * uStepW;
    float blockH = uBlocksize * uStepH;
    int posX = int(vTexCoord.x / blockW);
    int posY = int(vTexCoord.y / blockH);
    float fposX = float(posX);
    float fposY = float(posY);
    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);
    vec4 color = texture2D(uTexture, squareCoords);
    gl_FragColor = color;
  }
`;
  }
  sendUniformData(e, t) {
    e.uniform1f(t.uBlocksize, this.blocksize);
  }
}
it(Eb, "type", "Pixelate"), it(Eb, "defaults", { blocksize: 4 }), it(Eb, "uniformLocations", ["uBlocksize"]), pn.setClass(Eb);
class Sb extends na {
  getFragmentSource() {
    return `
precision highp float;
uniform sampler2D uTexture;
uniform vec4 uLow;
uniform vec4 uHigh;
varying vec2 vTexCoord;
void main() {
  gl_FragColor = texture2D(uTexture, vTexCoord);
  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {
    gl_FragColor.a = 0.0;
  }
}
`;
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = 255 * this.distance, c = new Wr(this.color).getSource(), a = [c[0] - i, c[1] - i, c[2] - i], s = [c[0] + i, c[1] + i, c[2] + i];
    for (let r = 0; r < t.length; r += 4) {
      const l = t[r], d = t[r + 1], f = t[r + 2];
      l > a[0] && d > a[1] && f > a[2] && l < s[0] && d < s[1] && f < s[2] && (t[r + 3] = 0);
    }
  }
  sendUniformData(e, t) {
    const i = new Wr(this.color).getSource(), c = this.distance, a = [0 + i[0] / 255 - c, 0 + i[1] / 255 - c, 0 + i[2] / 255 - c, 1], s = [i[0] / 255 + c, i[1] / 255 + c, i[2] / 255 + c, 1];
    e.uniform4fv(t.uLow, a), e.uniform4fv(t.uHigh, s);
  }
}
it(Sb, "type", "RemoveColor"), it(Sb, "defaults", { color: "#FFFFFF", distance: 0.02, useAlpha: !1 }), it(Sb, "uniformLocations", ["uLow", "uHigh"]), pn.setClass(Sb);
class Cb extends na {
  sendUniformData(e, t) {
    e.uniform2fv(t.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]), e.uniform1fv(t.uTaps, this.taps);
  }
  getFilterWindow() {
    const e = this.tempScale;
    return Math.ceil(this.lanczosLobes / e);
  }
  getCacheKey() {
    const e = this.getFilterWindow();
    return "".concat(this.type, "_").concat(e);
  }
  getFragmentSource() {
    const e = this.getFilterWindow();
    return this.generateShader(e);
  }
  getTaps() {
    const e = this.lanczosCreate(this.lanczosLobes), t = this.tempScale, i = this.getFilterWindow(), c = new Array(i);
    for (let a = 1; a <= i; a++) c[a - 1] = e(a * t);
    return c;
  }
  generateShader(e) {
    const t = new Array(e);
    for (let i = 1; i <= e; i++) t[i - 1] = "".concat(i, ".0 * uDelta");
    return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec2 uDelta;
      varying vec2 vTexCoord;
      uniform float uTaps[`.concat(e, `];
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        float sum = 1.0;
        `).concat(t.map((i, c) => `
              color += texture2D(uTexture, vTexCoord + `.concat(i, ") * uTaps[").concat(c, "] + texture2D(uTexture, vTexCoord - ").concat(i, ") * uTaps[").concat(c, `];
              sum += 2.0 * uTaps[`).concat(c, `];
            `)).join(`
`), `
        gl_FragColor = color / sum;
      }
    `);
  }
  applyToForWebgl(e) {
    e.passes++, this.width = e.sourceWidth, this.horizontal = !0, this.dW = Math.round(this.width * this.scaleX), this.dH = e.sourceHeight, this.tempScale = this.dW / this.width, this.taps = this.getTaps(), e.destinationWidth = this.dW, super.applyTo(e), e.sourceWidth = e.destinationWidth, this.height = e.sourceHeight, this.horizontal = !1, this.dH = Math.round(this.height * this.scaleY), this.tempScale = this.dH / this.height, this.taps = this.getTaps(), e.destinationHeight = this.dH, super.applyTo(e), e.sourceHeight = e.destinationHeight;
  }
  applyTo(e) {
    U2(e) ? this.applyToForWebgl(e) : this.applyTo2d(e);
  }
  isNeutralState() {
    return this.scaleX === 1 && this.scaleY === 1;
  }
  lanczosCreate(e) {
    return (t) => {
      if (t >= e || t <= -e) return 0;
      if (t < 11920929e-14 && t > -11920929e-14) return 1;
      const i = (t *= Math.PI) / e;
      return Math.sin(t) / t * Math.sin(i) / i;
    };
  }
  applyTo2d(e) {
    const t = e.imageData, i = this.scaleX, c = this.scaleY;
    this.rcpScaleX = 1 / i, this.rcpScaleY = 1 / c;
    const a = t.width, s = t.height, r = Math.round(a * i), l = Math.round(s * c);
    let d;
    d = this.resizeType === "sliceHack" ? this.sliceByTwo(e, a, s, r, l) : this.resizeType === "hermite" ? this.hermiteFastResize(e, a, s, r, l) : this.resizeType === "bilinear" ? this.bilinearFiltering(e, a, s, r, l) : this.resizeType === "lanczos" ? this.lanczosResize(e, a, s, r, l) : new ImageData(r, l), e.imageData = d;
  }
  sliceByTwo(e, t, i, c, a) {
    const s = e.imageData, r = 0.5;
    let l = !1, d = !1, f = t * r, h = i * r;
    const p = e.filterBackend.resources;
    let g = 0, _ = 0;
    const b = t;
    let v = 0;
    p.sliceByTwo || (p.sliceByTwo = lu());
    const E = p.sliceByTwo;
    (E.width < 1.5 * t || E.height < i) && (E.width = 1.5 * t, E.height = i);
    const C = E.getContext("2d");
    for (C.clearRect(0, 0, 1.5 * t, i), C.putImageData(s, 0, 0), c = Math.floor(c), a = Math.floor(a); !l || !d; ) t = f, i = h, c < Math.floor(f * r) ? f = Math.floor(f * r) : (f = c, l = !0), a < Math.floor(h * r) ? h = Math.floor(h * r) : (h = a, d = !0), C.drawImage(E, g, _, t, i, b, v, f, h), g = b, _ = v, v += h;
    return C.getImageData(g, _, c, a);
  }
  lanczosResize(e, t, i, c, a) {
    const s = e.imageData.data, r = e.ctx.createImageData(c, a), l = r.data, d = this.lanczosCreate(this.lanczosLobes), f = this.rcpScaleX, h = this.rcpScaleY, p = 2 / this.rcpScaleX, g = 2 / this.rcpScaleY, _ = Math.ceil(f * this.lanczosLobes / 2), b = Math.ceil(h * this.lanczosLobes / 2), v = {}, E = { x: 0, y: 0 }, C = { x: 0, y: 0 };
    return function y(T) {
      let A, k, N, j, I, B, U, H, Q, Y, ie;
      for (E.x = (T + 0.5) * f, C.x = Math.floor(E.x), A = 0; A < a; A++) {
        for (E.y = (A + 0.5) * h, C.y = Math.floor(E.y), I = 0, B = 0, U = 0, H = 0, Q = 0, k = C.x - _; k <= C.x + _; k++) if (!(k < 0 || k >= t)) {
          Y = Math.floor(1e3 * Math.abs(k - E.x)), v[Y] || (v[Y] = {});
          for (let ce = C.y - b; ce <= C.y + b; ce++) ce < 0 || ce >= i || (ie = Math.floor(1e3 * Math.abs(ce - E.y)), v[Y][ie] || (v[Y][ie] = d(Math.sqrt(Math.pow(Y * p, 2) + Math.pow(ie * g, 2)) / 1e3)), N = v[Y][ie], N > 0 && (j = 4 * (ce * t + k), I += N, B += N * s[j], U += N * s[j + 1], H += N * s[j + 2], Q += N * s[j + 3]));
        }
        j = 4 * (A * c + T), l[j] = B / I, l[j + 1] = U / I, l[j + 2] = H / I, l[j + 3] = Q / I;
      }
      return ++T < c ? y(T) : r;
    }(0);
  }
  bilinearFiltering(e, t, i, c, a) {
    let s, r, l, d, f, h, p, g, _, b, v, E, C, y = 0;
    const T = this.rcpScaleX, A = this.rcpScaleY, k = 4 * (t - 1), N = e.imageData.data, j = e.ctx.createImageData(c, a), I = j.data;
    for (p = 0; p < a; p++) for (g = 0; g < c; g++) for (f = Math.floor(T * g), h = Math.floor(A * p), _ = T * g - f, b = A * p - h, C = 4 * (h * t + f), v = 0; v < 4; v++) s = N[C + v], r = N[C + 4 + v], l = N[C + k + v], d = N[C + k + 4 + v], E = s * (1 - _) * (1 - b) + r * _ * (1 - b) + l * b * (1 - _) + d * _ * b, I[y++] = E;
    return j;
  }
  hermiteFastResize(e, t, i, c, a) {
    const s = this.rcpScaleX, r = this.rcpScaleY, l = Math.ceil(s / 2), d = Math.ceil(r / 2), f = e.imageData.data, h = e.ctx.createImageData(c, a), p = h.data;
    for (let g = 0; g < a; g++) for (let _ = 0; _ < c; _++) {
      const b = 4 * (_ + g * c);
      let v = 0, E = 0, C = 0, y = 0, T = 0, A = 0, k = 0;
      const N = (g + 0.5) * r;
      for (let j = Math.floor(g * r); j < (g + 1) * r; j++) {
        const I = Math.abs(N - (j + 0.5)) / d, B = (_ + 0.5) * s, U = I * I;
        for (let H = Math.floor(_ * s); H < (_ + 1) * s; H++) {
          let Q = Math.abs(B - (H + 0.5)) / l;
          const Y = Math.sqrt(U + Q * Q);
          Y > 1 && Y < -1 || (v = 2 * Y * Y * Y - 3 * Y * Y + 1, v > 0 && (Q = 4 * (H + j * t), k += v * f[Q + 3], C += v, f[Q + 3] < 255 && (v = v * f[Q + 3] / 250), y += v * f[Q], T += v * f[Q + 1], A += v * f[Q + 2], E += v));
        }
      }
      p[b] = y / E, p[b + 1] = T / E, p[b + 2] = A / E, p[b + 3] = k / C;
    }
    return h;
  }
}
it(Cb, "type", "Resize"), it(Cb, "defaults", { resizeType: "hermite", scaleX: 1, scaleY: 1, lanczosLobes: 3 }), it(Cb, "uniformLocations", ["uDelta", "uTaps"]), pn.setClass(Cb);
class wb extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uSaturation;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float rgMax = max(color.r, color.g);
    float rgbMax = max(rgMax, color.b);
    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;
    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;
    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = -this.saturation;
    for (let c = 0; c < t.length; c += 4) {
      const a = t[c], s = t[c + 1], r = t[c + 2], l = Math.max(a, s, r);
      t[c] += l !== a ? (l - a) * i : 0, t[c + 1] += l !== s ? (l - s) * i : 0, t[c + 2] += l !== r ? (l - r) * i : 0;
    }
  }
  sendUniformData(e, t) {
    e.uniform1f(t.uSaturation, -this.saturation);
  }
  isNeutralState() {
    return this.saturation === 0;
  }
}
it(wb, "type", "Saturation"), it(wb, "defaults", { saturation: 0 }), it(wb, "uniformLocations", ["uSaturation"]), pn.setClass(wb);
class xb extends na {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uVibrance;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float max = max(color.r, max(color.g, color.b));
    float avg = (color.r + color.g + color.b) / 3.0;
    float amt = (abs(max - avg) * 2.0) * uVibrance;
    color.r += max != color.r ? (max - color.r) * amt : 0.00;
    color.g += max != color.g ? (max - color.g) * amt : 0.00;
    color.b += max != color.b ? (max - color.b) * amt : 0.00;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(e) {
    let { imageData: { data: t } } = e;
    const i = -this.vibrance;
    for (let c = 0; c < t.length; c += 4) {
      const a = t[c], s = t[c + 1], r = t[c + 2], l = Math.max(a, s, r), d = (a + s + r) / 3, f = 2 * Math.abs(l - d) / 255 * i;
      t[c] += l !== a ? (l - a) * f : 0, t[c + 1] += l !== s ? (l - s) * f : 0, t[c + 2] += l !== r ? (l - r) * f : 0;
    }
  }
  sendUniformData(e, t) {
    e.uniform1f(t.uVibrance, -this.vibrance);
  }
  isNeutralState() {
    return this.vibrance === 0;
  }
}
it(xb, "type", "Vibrance"), it(xb, "defaults", { vibrance: 0 }), it(xb, "uniformLocations", ["uVibrance"]), pn.setClass(xb);
const dO = (n) => n.e instanceof TouchEvent && n.e.touches.length > 1, fO = (n) => {
  const e = Q8(n);
  return Math.sqrt(
    Math.pow(e.x2 - e.x1, 2) + Math.pow(e.y2 - e.y1, 2)
  );
}, Q8 = (n) => ({
  x1: n[0].clientX,
  y1: n[0].clientY,
  x2: n[1].clientX,
  y2: n[1].clientY
}), hO = (n) => {
  const e = Q8(n);
  return new St((e.x1 + e.x2) / 2, (e.y1 + e.y2) / 2);
}, $g = {
  fill: "#e8eef2",
  stroke: null,
  strokeWidth: 0,
  selectable: !1,
  opacity: 1,
  scaleX: 1,
  scaleY: 1
}, zY = (n, e) => {
  const c = new Wr(n).toHsl().replace("hsl(", "").replace(")", "").split(",").map((s) => parseInt(s));
  return c[2] = Math.max(0, c[2] - e), new Wr(`hsl(${c[0]},${c[1]}%,${c[2]}%)`).toRgb();
};
class VY {
  constructor(e) {
    Bn(this, "canvas");
    Bn(this, "canvasWrapper", null);
    Bn(this, "_editor", !1);
    Bn(this, "_mode", "view");
    Bn(this, "_selectionMode", "place");
    Bn(this, "_isSpacebarDown", !1);
    Bn(this, "_wasPanning", !1);
    Bn(this, "_minZoom", 0.01);
    Bn(this, "canvasPadding", 0.2);
    // Padding in percent of canvas size
    Bn(this, "colorSelected", "#1dc98d");
    Bn(this, "zoomAnimationSpeed", 200);
    Bn(this, "_seatmapData", null);
    Bn(this, "_seatmapTypes", []);
    Bn(this, "_seatmapPlaces", []);
    Bn(this, "_mouseDownEvent", null);
    Bn(this, "_mouseDownPinchDistance", 0);
    Bn(this, "_mouseDownZoom", 1);
    Bn(this, "_selectionBox", null);
    Bn(this, "selectedPlaces", []);
    Bn(this, "hoveredPlaces", []);
    Bn(this, "hoveredPlace", null);
    Bn(this, "onPlaceSelect");
    Bn(this, "_resizeObserver", null);
    Bn(this, "_resizeDebounce", 0);
    Bn(this, "unmount", () => {
      this._resizeObserver && this._resizeObserver.disconnect(), window.removeEventListener("keydown", this.keyDownListener), window.removeEventListener("keyup", this.keyUpListener), this.canvas && this.canvas.dispose();
    });
    Bn(this, "keyDownListener", (e) => {
      e.key === " " && (e.target === document.body && e.preventDefault(), this._isSpacebarDown = !0, this.canvas.defaultCursor = "move"), e.metaKey && (e.key === "+" || e.key === "=") && (e.preventDefault(), this.zoomIn()), e.metaKey && e.key === "-" && (e.preventDefault(), this.zoomOut()), e.metaKey && (e.key === "0" || e.key === "à") && (e.preventDefault(), this.fitSeatmap()), this._editor && e.metaKey && e.key === "d" && (e.preventDefault(), this.clearSelection());
    });
    Bn(this, "keyUpListener", (e) => {
      e.key === " " && (this._isSpacebarDown = !1, this.canvas.defaultCursor = "default");
    });
    Bn(this, "parseSeatmapData", () => {
      var t, i;
      this._seatmapTypes = ((t = this._seatmapData) == null ? void 0 : t.types.map((c) => ({
        id: c.id,
        name: c.name,
        brand_color: c.branding.color,
        places: 0
      }))) ?? [];
      const e = [];
      (i = this._seatmapData) == null || i.types.forEach((c) => {
        var s;
        const a = (s = this._seatmapTypes) == null ? void 0 : s.find(
          (r) => r.id === c.id
        );
        a && c.places.forEach((r) => {
          a.places++;
          const l = e.find(
            (d) => d.id === r
          );
          if (l) {
            l.types.push(c.id);
            return;
          }
          e.push({
            id: r,
            types: [c.id]
          });
        });
      }), this._seatmapPlaces = e;
    });
    Bn(this, "fitCanvasToWrapper", () => {
      this.canvasWrapper && (this.canvas.setDimensions({
        width: this.canvasWrapper.clientWidth,
        height: this.canvasWrapper.clientHeight
      }), this.canvas.requestRenderAll());
    });
    Bn(this, "addMapToCanvas", async (e) => {
      await this.canvas.loadFromJSON(JSON.stringify(e)), this.cleanupSeatmap();
    });
    Bn(this, "cleanupSeatmap", () => {
      const e = this.canvas.getObjects();
      e == null || e.forEach((t) => {
        t.set({
          selectable: !1,
          objectCaching: !0,
          subTargetCheck: !0,
          hasControls: !1,
          hoverCursor: "default",
          lockMovementX: !0,
          lockMovementY: !0,
          hasBorders: !0,
          hasRotatingPoint: !1
        }), t.mapType === "zone" && t.getObjects().forEach((c) => {
          c.set($g);
        });
      });
    });
    Bn(this, "fitSeatmap", (e = !0) => {
      const t = this.getCanvasBoundingRect();
      if (!t) return;
      const i = Math.max(
        this.canvas.width * this.canvasPadding,
        this.canvas.height * this.canvasPadding
      ), c = this.canvas.width / (t.width + i), a = this.canvas.height / (t.height + i), s = Math.min(c, a);
      this._minZoom = s;
      const r = t.left + t.width / 2, l = t.top + t.height / 2, d = this.canvas.viewportTransform, f = d[0], h = s, p = d[4], g = d[5], _ = -r * s + this.canvas.width / 2, b = -l * s + this.canvas.height / 2;
      e ? rb.animate({
        startValue: [f, p, g],
        endValue: [h, _, b],
        duration: this.zoomAnimationSpeed,
        easing: rb.ease.easeOutQuint,
        onChange: ([v, E, C]) => {
          d[0] = v, d[3] = v, d[4] = E, d[5] = C, this.canvas.setViewportTransform(d), this.canvas.requestRenderAll();
        },
        onComplete: () => {
          d[0] = h, d[3] = h, d[4] = _, d[5] = b, this.canvas.setViewportTransform(d), this.canvas.requestRenderAll();
        }
      }) : (d[0] = h, d[3] = h, d[4] = _, d[5] = b, this.canvas.setViewportTransform(d), this.canvas.renderAll());
    });
    Bn(this, "zoomIn", () => {
      let e = this.canvas.getZoom();
      e *= 1.5, e = this.clampZoom(e);
      const t = this.canvas.getCenterPoint();
      this.zoomToPoint(t, e);
    });
    Bn(this, "zoomOut", () => {
      let e = this.canvas.getZoom();
      e *= 0.5, e = this.clampZoom(e);
      const t = this.canvas.getCenterPoint();
      this.zoomToPoint(t, e);
    });
    Bn(this, "zoomToPoint", (e, t) => {
      rb.animate({
        startValue: this.canvas.getZoom(),
        endValue: t,
        duration: this.zoomAnimationSpeed,
        easing: rb.ease.easeOutQuint,
        onChange: (i) => {
          this.canvas.zoomToPoint(e, i), this.canvas.requestRenderAll();
        },
        onComplete: () => {
          this.canvas.requestRenderAll();
        }
      });
    });
    Bn(this, "clampZoom", (e) => (e > 20 && (e = 20), Math.max(this._minZoom, e)));
    Bn(this, "drawPlaces", (e = null) => {
      switch (e || (e = this.getPlaces()), this._mode) {
        case "view": {
          const t = this.getDisabledPlaces();
          e.forEach((i) => {
            const c = this.findSeatmapPlaceById(
              String(i.mapId)
            );
            let a = [];
            c && (a = this._seatmapTypes.filter(
              (f) => c.types.includes(f.id)
            ));
            const s = this.selectedPlaces.includes(i), r = t.includes(String(i.mapId)), l = a.length > 0 ? a[0] : null, d = l ? l.brand_color : $g.fill;
            this._editor ? i.set({
              ...$g,
              evented: !!r,
              hoverCursor: r ? "pointer" : "default",
              selectable: !1,
              fill: r ? s ? this.colorSelected : d : null,
              scaleX: r ? 1 : 0.8,
              scaleY: r ? 1 : 0.8,
              stroke: r ? null : d,
              strokeWidth: r ? 0 : 4
            }) : i.set({
              ...$g,
              evented: !r,
              hoverCursor: r ? "default" : "pointer",
              selectable: !1,
              defaultCursor: "default",
              fill: s ? this.colorSelected : r ? "#e8eef2" : d,
              scaleX: r ? 0.8 : 1,
              scaleY: r ? 0.8 : 1,
              stroke: null,
              strokeWidth: 0
            });
          });
          break;
        }
        default:
        case "assign":
          e.forEach((t) => {
            const i = this.findSeatmapPlaceById(
              String(t.mapId)
            );
            let c = [];
            i && (c = this._seatmapTypes.filter(
              (s) => i.types.includes(s.id)
            ));
            const a = this.selectedPlaces.includes(t);
            t.set({
              ...$g,
              fill: a ? this.colorSelected : c.length > 0 ? c[0].brand_color : $g.fill
            });
          });
          break;
      }
    });
    Bn(this, "drawRowLabels", () => {
      this.hideRowLabels(), this.canvas.getObjects().filter((t) => t.mapType === "zone").forEach((t) => {
        if (t.rowLabel === void 0)
          return;
        const [i, c, a, s] = t.getCoords(), r = 15;
        let l;
        l = new St((i.x + s.x) / 2, (i.y + s.y) / 2);
        const f = t.angle * Math.PI / 180;
        let h, p;
        h = l.x - Math.cos(f) * r, p = l.y - Math.sin(f) * r;
        const g = new Za(String(t.rowLabel), {
          left: h,
          top: p,
          fontSize: 12,
          angle: t.angle,
          fontFamily: "Arial",
          fill: "#5e84a4",
          selectable: !1,
          objectCaching: !0,
          evented: !1,
          originX: "center",
          originY: "center",
          mapType: "rowLabel",
          subTargetCheck: !1,
          hasControls: !1,
          hasBorders: !1,
          hasRotatingPoint: !1
        });
        this.canvas.add(g);
      }), this.canvas.requestRenderAll();
    });
    Bn(this, "hideRowLabels", () => {
      this.canvas.getObjects().forEach((e) => {
        e.mapType === "rowLabel" && this.canvas.remove(e);
      });
    });
    Bn(this, "getPlaces", () => this.canvas.getObjects().filter((t) => t.mapType === "zone").flatMap(
      (t) => t.getObjects().filter((i) => i.mapType === "place")
    ));
    Bn(this, "findSeatmapPlaceById", (e) => this._seatmapPlaces.find((t) => t.id === e));
    // Todo: should be renamed since it returns 'booked' places
    Bn(this, "getDisabledPlaces", () => {
      var e;
      return ((e = this._seatmapData) == null ? void 0 : e.places.disabled) ?? [];
    });
    Bn(this, "getCanvasBoundingRect", () => this.canvas.getObjects() ? this.canvas.getObjects().reduce(
      (i, c) => {
        const a = c.getBoundingRect();
        return i ? {
          left: Math.min(i.left, a.left),
          top: Math.min(i.top, a.top),
          width: Math.max(
            i.left + i.width,
            a.left + a.width
          ) - Math.min(i.left, a.left),
          height: Math.max(
            i.top + i.height,
            a.top + a.height
          ) - Math.min(i.top, a.top)
        } : a;
      },
      null
    ) : null);
    Bn(this, "handleMouseDown", (e) => {
      if (this._wasPanning = !1, this._mouseDownEvent = e, this._mouseDownZoom = this.canvas.getZoom() || 1, dO(e)) {
        const t = e.e;
        this._mouseDownPinchDistance = fO(t.touches);
      } else
        this._mode == "assign" && (this._selectionBox && (this.canvas.remove(this._selectionBox), this._selectionBox = null), this._selectionBox = new Zu({
          left: e.scenePoint.x,
          top: e.scenePoint.y,
          width: 0,
          height: 0,
          stroke: "#068CFC",
          strokeWidth: 1,
          fill: "rgba(220,239,255,0.6)",
          selectable: !1,
          evented: !1
        }), this.canvas.add(this._selectionBox), this.canvas.requestRenderAll());
    });
    Bn(this, "handleMouseMove", (e) => {
      if (!this._mouseDownEvent) {
        if (e.target) {
          if (e.target.mapType === "zone") {
            const i = e.target;
            let c = [];
            switch (this._selectionMode) {
              case "row":
                c = i.getObjects().filter((a) => a.mapType === "place" && a.mapId);
                break;
              case "place":
                e.subTargets && e.subTargets.length > 0 && typeof e.subTargets[0].mapType < "u" && e.subTargets[0].mapType === "place" && (c = [e.subTargets[0]]);
                break;
            }
            this.hoveredPlaces.length > 0 && this.drawPlaces(this.hoveredPlaces), c.forEach((a) => {
              const s = this.selectedPlaces.includes(a);
              a.set({
                fill: s ? this.colorSelected : zY(a.fill, 30)
              });
            }), this.hoveredPlaces = c, this.handleHoveredPlaces(), this.canvas.requestRenderAll();
          }
        } else
          this.hoveredPlaces.length > 0 && (this.drawPlaces(this.hoveredPlaces), this.hoveredPlaces = [], this.canvas.requestRenderAll());
        return;
      }
      const t = 5;
      if (!(!this._wasPanning && Math.abs(
        e.viewportPoint.x - this._mouseDownEvent.viewportPoint.x
      ) < t && Math.abs(
        e.viewportPoint.y - this._mouseDownEvent.viewportPoint.y
      ) < t))
        if (this._wasPanning = !0, dO(e))
          this.pinchCanvas(e), this._mouseDownEvent = e;
        else {
          if (this._mode == "view" || this._mode == "assign" && this._isSpacebarDown) {
            this.panCanvas(e), this._mouseDownEvent = e;
            return;
          }
          if (this._mode == "assign" && this._selectionBox) {
            const i = e.scenePoint;
            if (!i) return;
            const c = this._mouseDownEvent.scenePoint.x, a = this._mouseDownEvent.scenePoint.y;
            c > i.x && this._selectionBox.set({ left: i.x }), a > i.y && this._selectionBox.set({ top: i.y }), this._selectionBox.set({
              width: Math.abs(c - i.x)
            }), this._selectionBox.set({
              height: Math.abs(a - i.y)
            }), this._selectionBox.setCoords(), this.canvas.requestRenderAll();
          }
        }
    });
    Bn(this, "handleMouseUp", (e) => {
      if (this._wasPanning) {
        if (this._mode == "assign" && this._selectionBox) {
          this.canvas.remove(this._selectionBox);
          const t = this.canvas.getObjects();
          if (!t) return;
          const i = t.filter((c) => c.mapType === "zone").flatMap((c) => c.getObjects().filter(
            (s) => (
              // Fully contained
              // this._selectionBox
              //     ? place.isContainedWithinObject(
              //           this._selectionBox,
              //       )
              //     : false,
              // Alternative
              this._selectionBox ? s.intersectsWithObject(
                this._selectionBox
              ) : !1
            )
          ));
          this.updateSelection(
            i,
            !!e.e.shiftKey
            // Deselect when shift key is pressed
          );
        }
      } else if (e.subTargets && e.subTargets.length > 0 && typeof e.subTargets[0].mapType < "u" && e.subTargets[0].mapType === "place") {
        const t = e.subTargets[0], i = this.selectedPlaces.includes(t);
        switch (this._selectionMode) {
          case "place":
            this.updateSelection([t], i);
            break;
          case "row":
            if (e.target && e.target.mapType === "zone") {
              const a = e.target.getObjects().filter((s) => s.mapType === "place");
              this.updateSelection(a, i);
            }
            break;
        }
      }
      this._mouseDownEvent = null, this._wasPanning = !1;
    });
    Bn(this, "handleMouseWheel", (e) => {
      if (!e.e.shiftKey) return;
      e.e.preventDefault(), e.e.stopPropagation();
      const t = e.e.deltaY;
      let i = this.canvas.getZoom();
      i *= 0.999 ** t, i = this.clampZoom(i);
      const c = new St(e.e.offsetX, e.e.offsetY);
      this.canvas.zoomToPoint(c, i), this.canvas.requestRenderAll();
    });
    Bn(this, "panCanvas", (e) => {
      if (!this._mouseDownEvent) return;
      const t = e.viewportPoint, i = this.canvas.viewportTransform;
      i[4] += t.x - this._mouseDownEvent.viewportPoint.x, i[5] += t.y - this._mouseDownEvent.viewportPoint.y, this.canvas.setViewportTransform(i), this.canvas.requestRenderAll();
    });
    Bn(this, "pinchCanvas", (e) => {
      if (!this._mouseDownEvent) return;
      const t = e.e.touches, c = fO(t) / this._mouseDownPinchDistance, a = hO(
        this._mouseDownEvent.e.touches
      ), s = hO(t);
      let r = this._mouseDownZoom * c;
      r = this.clampZoom(r), this.canvas.zoomToPoint(s, r);
      const l = this.canvas.viewportTransform;
      l[4] += s.x - a.x, l[5] += s.y - a.y, this.canvas.setViewportTransform(l), this.canvas.requestRenderAll();
    });
    Bn(this, "handleHoveredPlaces", () => {
      if (this._selectionMode === "place") {
        if (this.hoveredPlaces.length === 0 && this.hoveredPlace) {
          this.hoveredPlace = null;
          return;
        }
        this.hoveredPlaces.length !== 0 && (this.hoveredPlace && this.hoveredPlace == this.hoveredPlaces[0] || (this.hoveredPlace = this.hoveredPlaces[0]));
      }
    });
    Bn(this, "clearSelection", () => {
      this.selectedPlaces = [], this.onPlaceSelect(this.selectedPlaces.map((e) => String(e.mapId))), this.drawPlaces(), this.canvas.requestRenderAll();
    });
    Bn(this, "selectPlacesById", (e) => {
      const i = this.getPlaces().filter(
        (c) => e.includes(String(c.mapId))
      );
      this.updateSelection(i);
    });
    Bn(this, "updateSelection", (e, t = !1) => {
      if (t)
        this.selectedPlaces = this.selectedPlaces.filter(
          (i) => !e.includes(i)
        );
      else if (this._mode === "view") {
        const i = this.getDisabledPlaces();
        if (this._editor) {
          const c = [...this.selectedPlaces];
          e = [e[0]], e = e.filter(
            (a) => i.includes(String(a.mapId))
          ), this.selectedPlaces = [...e], e.push(...c);
        } else {
          const c = this.getDisabledPlaces();
          e = e.filter(
            (a) => !c.includes(String(a.mapId))
          ), this.selectedPlaces.push(...e);
        }
      } else
        this.selectedPlaces.push(...e);
      this.selectedPlaces = this.selectedPlaces.filter(
        (i, c, a) => a.indexOf(i) === c
      ), this.onPlaceSelect(this.selectedPlaces.map((i) => String(i.mapId))), this.drawPlaces(e), this.canvas.renderAll();
    });
    const { mode: t, editor: i, element: c, canvasWrapper: a, onPlaceSelect: s } = e;
    this._mode = t, this._editor = i, this.canvasWrapper = a, this.onPlaceSelect = s, this.canvas = new hx(c ?? "seatmap", {
      selection: !1,
      defaultCursor: "default",
      allowTouchScrolling: !1,
      renderOnAddRemove: !1,
      stopContextMenu: !0,
      centeredScaling: !0,
      preserveObjectStacking: !0,
      svgViewportTransformation: !0,
      skipOffscreen: !0
    }), this.fitCanvasToWrapper(), this.canvas.on("mouse:down:before", this.handleMouseDown), this.canvas.on("mouse:up", this.handleMouseUp), this.canvas.on("mouse:move", this.handleMouseMove), this.canvas.on("mouse:wheel", this.handleMouseWheel), this.canvasWrapper && (this._resizeObserver = new ResizeObserver(() => {
      clearTimeout(this._resizeDebounce), this._resizeDebounce = window.setTimeout(() => {
        this.fitCanvasToWrapper(), this.fitSeatmap();
      }, 500);
    }), this._resizeObserver.observe(this.canvasWrapper)), window.addEventListener("keydown", this.keyDownListener), window.addEventListener("keyup", this.keyUpListener);
  }
  setMode(e) {
    this._mode !== e && this.clearSelection(), this._mode = e, this.setSelectionMode("place"), this.drawPlaces(), this.fitSeatmap(!1);
  }
  setEditor(e) {
    this._editor = e, this.setMode("view");
  }
  setSelectionMode(e) {
    this._selectionMode = e;
  }
  setSeatmapData(e) {
    return this._seatmapData = e, this.parseSeatmapData(), {
      types: this._seatmapTypes,
      places: this._seatmapPlaces
    };
  }
}
const qY = Mn.bind(id), GY = [
  { title: "View", value: "view", icon: /* @__PURE__ */ Re(Ix, {}), disabled: !1 },
  {
    title: "Tickets",
    value: "assign",
    icon: /* @__PURE__ */ Re(CP, {}),
    disabled: !1
  }
  // { title: "Block", value: "block", icon: <RiLockLine />, disabled: true },
], WY = [
  {
    title: "Select Places",
    value: "place",
    disabled: !1,
    icon: /* @__PURE__ */ Re(wP, {})
  },
  {
    title: "Select Rows",
    value: "row",
    disabled: !1,
    icon: /* @__PURE__ */ Re(xP, {})
  }
], Soe = Ef((n, e) => {
  var ce, $, te;
  const {
    apiClient: t,
    seatmapId: i,
    editor: c = !1,
    onSelect: a,
    onRequestEdit: s,
    onTypesChange: r
  } = n, l = zn(null), d = zn(null), f = zn(null), [h, p] = Wn(!0), [g, _] = Wn("view"), [b, v] = Wn("place"), [, E] = Wn(null), [C, y] = Wn([]), [, T] = Wn([]), [A, k] = Wn([]);
  Lx(e, () => ({
    reload: I,
    selectPlacesById: (V) => {
      var K;
      return (K = l.current) == null ? void 0 : K.selectPlacesById(V);
    }
  })), An(() => (f.current && d.current && (l.current = new VY({
    mode: g,
    editor: c,
    element: f.current,
    canvasWrapper: d.current,
    onPlaceSelect: N
  }), H("view"), j()), () => {
    var V;
    (V = l.current) == null || V.unmount(), l.current = null;
  }), []), An(() => {
    r && r(C);
  }, [r, C]), An(() => {
    a && a(A);
  }, [a, A]), An(() => {
    var V;
    (V = l.current) == null || V.setEditor(c);
  }, [c]);
  const N = (V) => {
    k(() => [...V]);
  }, j = async () => {
    const V = await B();
    V && (await U(V.json), p(!1));
  }, I = async () => {
    var K, ne;
    await B() && ((K = l.current) == null || K.drawPlaces(), (ne = l.current) == null || ne.clearSelection(), p(!1));
  }, B = async () => {
    var V;
    p(!0);
    try {
      const K = await (t == null ? void 0 : t.get("/seatmap/" + i));
      E(K.seatmap);
      const ne = (V = l.current) == null ? void 0 : V.setSeatmapData(K.seatmap);
      return y((ne == null ? void 0 : ne.types) || []), T((ne == null ? void 0 : ne.places) || []), K.seatmap;
    } catch (K) {
      t != null && t.isApiError(K) && console.log(K.response.body);
    }
  }, U = async (V) => {
    var K, ne, J, L;
    try {
      const z = await fetch(V);
      if (z.ok) {
        const ee = await z.json();
        await ((K = l.current) == null ? void 0 : K.addMapToCanvas(ee.map)), (ne = l.current) == null || ne.drawPlaces(), (J = l.current) == null || J.drawRowLabels(), (L = l.current) == null || L.fitSeatmap(!1);
      } else
        console.error("Promise resolved but HTTP status failed");
    } catch (z) {
      console.error("Promise rejected", z);
    }
  }, H = (V) => {
    var K;
    _(V), V === "view" && Q("place"), (K = l.current) == null || K.setMode(V);
  }, Q = (V) => {
    var K;
    v(V), (K = l.current) == null || K.setSelectionMode(V);
  }, Y = () => {
    c && s && s();
  }, ie = qY("seatmap__controls", {
    "seatmap__controls--loading": h
  });
  return /* @__PURE__ */ Re("div", { className: id.seatmap, children: /* @__PURE__ */ Mt("div", { className: id.seatmap__map, children: [
    /* @__PURE__ */ Re("div", { ref: d, className: id.canvasWrapper, children: /* @__PURE__ */ Re("canvas", { ref: f }) }),
    c && /* @__PURE__ */ Mt("div", { className: id.seatmap__toolbar, children: [
      /* @__PURE__ */ Re(
        k3,
        {
          value: g,
          options: GY,
          onChange: H
        }
      ),
      g === "assign" && /* @__PURE__ */ Re(
        k3,
        {
          value: b,
          options: WY,
          onChange: Q
        }
      ),
      g === "assign" && /* @__PURE__ */ Mt("div", { className: id.assignControls, children: [
        /* @__PURE__ */ Mt(
          Fh,
          {
            size: "small",
            disabled: A.length == 0,
            onClick: Y,
            color: "secondary",
            children: [
              /* @__PURE__ */ Re(vP, {}),
              "Edit",
              " ",
              A.length > 0 && /* @__PURE__ */ Re(
                vm,
                {
                  color: "success-inverted",
                  content: A.length,
                  size: "small"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ Re(
          Fh,
          {
            variant: "outline",
            size: "small",
            disabled: A.length == 0,
            onClick: (ce = l.current) == null ? void 0 : ce.clearSelection,
            children: "Deselect"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ Mt("ul", { className: ie, children: [
      /* @__PURE__ */ Re("li", { children: /* @__PURE__ */ Re(
        "button",
        {
          onClick: () => {
            var V;
            return (V = l.current) == null ? void 0 : V.fitSeatmap();
          },
          className: id.controlButton,
          children: /* @__PURE__ */ Re(bP, {})
        }
      ) }),
      /* @__PURE__ */ Re("li", { children: /* @__PURE__ */ Re(
        "button",
        {
          onClick: ($ = l.current) == null ? void 0 : $.zoomIn,
          className: id.controlButton,
          children: /* @__PURE__ */ Re(EP, {})
        }
      ) }),
      /* @__PURE__ */ Re("li", { children: /* @__PURE__ */ Re(
        "button",
        {
          onClick: (te = l.current) == null ? void 0 : te.zoomOut,
          className: id.controlButton,
          children: /* @__PURE__ */ Re(SP, {})
        }
      ) })
    ] }),
    h && /* @__PURE__ */ Re("div", { className: id.seatmap__loading, children: /* @__PURE__ */ Re(Ux, { size: "small", rotate: !0 }) })
  ] }) });
}), $Y = "_section_oujt2_1", YY = {
  section: $Y,
  "section--noMargin": "_section--noMargin_oujt2_14",
  "section--marginTop": "_section--marginTop_oujt2_17",
  "section--boxed": "_section--boxed_oujt2_20"
}, XY = Mn.bind(YY), Coe = ({
  children: n,
  boxed: e,
  maxWidth: t = "none"
}) => /* @__PURE__ */ Re("section", { style: { maxWidth: t }, className: XY([
  "section",
  {
    "section--boxed": e
  }
]), children: n }), KY = "_sidebarButton_dsh7f_1", QY = "_buttonIcon_dsh7f_21", ZY = "_icon_dsh7f_30", JY = "_buttonLabel_dsh7f_36", eX = "_active_dsh7f_52", jb = {
  sidebarButton: KY,
  buttonIcon: QY,
  icon: ZY,
  buttonLabel: JY,
  active: eX
}, tX = Mn.bind(jb), woe = (n) => {
  const { active: e, onClick: t } = n, i = tX("sidebarButton", { active: e }), { toggleSidebar: c } = Bx();
  return /* @__PURE__ */ Mt("div", { className: i, onClick: () => {
    t && t(), c();
  }, children: [
    /* @__PURE__ */ Re("div", { className: jb.buttonIcon, children: /* @__PURE__ */ Re(n.icon, { className: jb.icon }) }),
    n.label && /* @__PURE__ */ Re("div", { className: jb.buttonLabel, children: n.label })
  ] });
}, nX = (n) => /* @__PURE__ */ Ce.createElement("svg", { width: 197, height: 24, viewBox: "0 0 197 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ Ce.createElement("mask", { id: "mask0", "mask-type": "alpha", maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 41, height: 23 }, /* @__PURE__ */ Ce.createElement("path", { d: "M0 0.000488281H40.0361V22.1665H0V0.000488281Z", fill: "currentColor" })), /* @__PURE__ */ Ce.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 9.33349L40.0362 0.000488281L27.1378 22.1665L18.4265 18.3335L12.0612 22.0005L11.224 16.6665L33.8388 3.66649L9.88417 14.6675L0 9.33349Z", fill: "currentColor" })), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M57.0395 10.0728C57.0395 8.45779 56.7149 6.69479 53.9931 6.69479C51.3466 6.69479 50.9466 8.48279 50.9466 10.0728V10.2968H57.0395V10.0728ZM50.9225 12.4328V12.6808C50.9225 14.7178 51.222 16.0348 54.6675 16.0348C56.14 16.0348 57.8888 15.8858 59.7362 15.7118V18.1708C58.6879 18.4198 56.8646 18.7668 54.5177 18.7668C49.449 18.7668 47.6509 16.8298 47.6509 11.9108V11.0418C47.6509 6.34679 49.7988 4.06079 53.9931 4.06079C58.6879 4.06079 60.3353 7.09179 60.3353 11.3398V12.4328H50.9225Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M69.9988 18.394H65.3291L60.9609 4.409H64.4064L66.7031 12.383C67.078 13.7 67.3775 14.991 67.7022 16.184C68.0017 14.991 68.2761 13.725 68.65 12.383L70.9225 4.409H74.369L69.9988 18.394Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M84.3078 10.0728C84.3078 8.45779 83.9832 6.69479 81.2614 6.69479C78.615 6.69479 78.2149 8.48279 78.2149 10.0728V10.2968H84.3078V10.0728ZM78.1908 12.4328V12.6808C78.1908 14.7178 78.4903 16.0348 81.9358 16.0348C83.4083 16.0348 85.1572 15.8858 87.0045 15.7118V18.1708C85.9562 18.4198 84.133 18.7668 81.786 18.7668C76.7173 18.7668 74.9192 16.8298 74.9192 11.9108V11.0418C74.9192 6.34679 77.0671 4.06079 81.2614 4.06079C85.9562 4.06079 87.6036 7.09179 87.6036 11.3398V12.4328H78.1908Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M99.0654 18.394V9.52597C99.0654 7.51397 98.7146 6.81797 97.0923 6.81797C96.1435 6.81797 94.8952 7.16597 93.3966 7.76297V18.394H90.126V4.40897H93.2719V5.52697C94.7957 4.65697 96.3184 4.06097 97.8914 4.06097C101.862 4.06097 102.386 6.34697 102.386 9.52597V18.394H99.0654Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M110.178 18.7671C107.405 18.7671 106.307 17.6741 106.307 14.7431V7.04208L103.686 6.81808V4.40908H106.307V0.856079H109.604V4.40908H113.024V7.04208H109.604V14.6931C109.604 15.9851 109.702 16.2331 110.902 16.2331C111.625 16.2331 112.625 16.1841 113.024 16.1341V18.3701C112.649 18.4691 111.426 18.7671 110.178 18.7671Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M119.016 18.7173C117.194 18.7173 115.32 18.3943 114.672 18.2203V16.9533C115.521 17.0533 117.344 17.3253 118.966 17.3253C121.513 17.3253 122.312 16.4573 122.312 15.0913C122.312 13.7493 121.713 13.2273 119.266 12.2343L118.292 11.8613C115.695 10.8183 114.497 9.75029 114.497 7.83729C114.497 5.60129 116.069 4.55829 119.341 4.55829C121.013 4.55829 122.662 4.83129 123.31 5.02929V6.27229C122.038 6.09829 120.464 5.97329 119.415 5.97329C117.169 5.97329 116.146 6.37129 116.146 7.83729C116.146 9.10429 116.844 9.65029 118.942 10.4953L119.916 10.8923C122.936 12.1593 123.935 13.0293 123.935 15.0663C123.935 16.9783 122.837 18.7173 119.016 18.7173Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M134.847 6.12298C133.898 6.04798 132.574 5.99798 131.875 5.99798C128.879 5.99798 127.505 6.81798 127.505 11.24V12.234C127.505 16.06 128.48 17.277 131.076 17.277C131.901 17.277 133.323 17.127 134.847 16.531V6.12298ZM134.847 23.586V17.873C133.474 18.494 131.976 18.717 130.827 18.717C127.431 18.717 125.883 17.003 125.883 12.234V11.24C125.883 6.02298 127.781 4.55798 131.901 4.55798C133.224 4.55798 134.347 4.60698 136.47 4.88098V23.586H134.847Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M148.805 18.394V17.301C147.157 18.146 145.609 18.717 143.987 18.717C140.666 18.717 139.867 16.656 139.867 13.451V4.90598H141.465V13.451C141.465 16.332 142.114 17.326 144.286 17.326C145.635 17.326 147.133 16.804 148.805 16.01V4.90598H150.428V18.394H148.805Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M161.691 11.6128H159.393C156.123 11.6128 154.824 12.0598 154.824 14.4698V14.9418C154.824 16.8038 155.873 17.4508 157.57 17.4508C159.269 17.4508 160.941 16.7048 161.691 16.2338V11.6128ZM161.765 18.3938V17.4248C160.817 17.9968 159.269 18.7168 157.246 18.7168C154.599 18.7168 153.202 17.5248 153.202 14.8418V14.4698C153.202 11.0418 155.424 10.3458 159.393 10.3458H161.691V9.2028C161.691 6.5708 161.116 5.9488 158.095 5.9488C156.771 5.9488 155.648 6.0488 154.126 6.2218V5.0298C155.398 4.8058 156.473 4.5578 158.22 4.5578C162.539 4.5578 163.338 6.0238 163.338 9.2028V18.3938H161.765Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M168.233 7.26559V18.3936H166.635V4.90559H168.233V5.99859C169.831 4.85559 171.754 4.55759 173.326 4.55759V6.02359C171.828 6.02359 169.73 6.37059 168.233 7.26559Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M183.315 10.6191C183.315 8.20907 182.641 5.97307 179.37 5.97307C176.074 5.97307 175.4 8.28407 175.4 10.6191L175.376 10.8431H183.315V10.6191ZM175.376 12.2091V12.5071C175.376 15.5871 176.223 17.3011 179.919 17.3011C181.417 17.3011 183.315 17.1271 184.563 16.9281V18.2201C183.589 18.4441 181.892 18.7171 179.869 18.7171C175.25 18.7171 173.752 16.6561 173.752 12.1591V11.2151C173.752 6.99207 175.474 4.55807 179.37 4.55807C183.29 4.55807 185.012 6.94307 185.012 11.3891V12.2091H175.376Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M190.859 5.30907V8.45608H190.152V5.30907H189.032V4.72607H191.978V5.30907H190.859Z", fill: "currentColor" }), /* @__PURE__ */ Ce.createElement("mask", { id: "mask1", "mask-type": "alpha", maskUnits: "userSpaceOnUse", x: 192, y: 4, width: 5, height: 5 }, /* @__PURE__ */ Ce.createElement("path", { d: "M192.517 4.7265H196.033V8.4565H192.517V4.7265Z", fill: "currentColor" })), /* @__PURE__ */ Ce.createElement("g", { mask: "url(#mask1)" }, /* @__PURE__ */ Ce.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M195.347 8.4565V6.3885C195.347 6.1525 195.357 5.9815 195.371 5.7455H195.362C195.282 5.9315 195.19 6.0975 195.105 6.2625L194.55 7.3115H193.989L193.444 6.2625C193.358 6.1025 193.282 5.9215 193.192 5.7455H193.182C193.192 5.9815 193.202 6.1475 193.202 6.3885V8.4565H192.517V4.7265H193.282L194.034 6.1875C194.111 6.3325 194.192 6.5035 194.262 6.6595H194.272C194.343 6.4985 194.423 6.3285 194.504 6.1775L195.267 4.7265H196.033V8.4565H195.347Z", fill: "currentColor" }))), rX = "_userMenu_i4d8f_1", iX = "_userMenu__button_i4d8f_4", oX = "_popIn_i4d8f_1", aX = "_userMenu__name_i4d8f_40", sX = "_userMenu__avatar_i4d8f_47", lX = "_userMenu__dropdown_i4d8f_53", uX = "_userMenu__selectGrid_i4d8f_79", cX = {
  userMenu: rX,
  userMenu__button: iX,
  popIn: oX,
  userMenu__name: aX,
  userMenu__avatar: sX,
  userMenu__dropdown: lX,
  "userMenu__dropdown--open": "_userMenu__dropdown--open_i4d8f_74",
  userMenu__selectGrid: uX
}, dX = "_colorpicker_t7vjw_1", fX = "_colorpicker__color_t7vjw_21", hX = "_colorpicker__input_t7vjw_32", pX = "_colorpicker__dropdownButton_t7vjw_63", mX = "_colorpicker__dropdownButtonIcon_t7vjw_72", gX = "_colorpicker__presets_t7vjw_85", _X = "_colorpicker__preset_t7vjw_85", Bb = {
  colorpicker: dX,
  "colorpicker--disabled": "_colorpicker--disabled_t7vjw_17",
  colorpicker__color: fX,
  "colorpicker__color--null": "_colorpicker__color--null_t7vjw_28",
  colorpicker__input: hX,
  colorpicker__dropdownButton: pX,
  colorpicker__dropdownButtonIcon: mX,
  "colorpicker__dropdownButtonIcon--up": "_colorpicker__dropdownButtonIcon--up_t7vjw_78",
  "colorpicker__dropdownButtonIcon--disabled": "_colorpicker__dropdownButtonIcon--disabled_t7vjw_81",
  colorpicker__presets: gX,
  "colorpicker__presets--show": "_colorpicker__presets--show_t7vjw_99",
  colorpicker__preset: _X
}, Tb = Mn.bind(Bb), xoe = (n) => {
  const e = [
    "#068cfc",
    "#1dc98d",
    "#ffbb33",
    "#fc3636",
    "#fb2d6e",
    "#ff5e24",
    "#9633ff",
    "#5e84a4",
    "#ffc7b3",
    "#c8d5e0",
    "#183853",
    "#334c61"
  ], { name: t, placeholder: i = "", presets: c, disabled: a } = n, { setFieldValue: s, values: r } = gd(), [l, d] = Wn(!1), f = zn(null), h = zn(null);
  An(() => {
    const k = (j) => {
      const I = j.target;
      f.current && !f.current.contains(I) && d(!1);
    }, N = (j) => {
      j.key === "Escape" && d(!1);
    };
    return document.addEventListener("click", k), document.addEventListener("keydown", N), () => {
      document.removeEventListener("click", k), document.removeEventListener("keydown", N);
    };
  }, [f, l]);
  const p = Tb("colorpicker", {
    "colorpicker--disabled": a
  }), g = Tb("colorpicker__color", {
    "colorpicker__color--null": !r[t]
  }), _ = Tb("colorpicker__presets", {
    "colorpicker__presets--show": !a && l
  }), b = Tb("colorpicker__dropdownButtonIcon", {
    "colorpicker__dropdownButtonIcon--up": l,
    "colorpicker__dropdownButtonIcon--disabled": a
  }), v = (k) => /^#[0-9A-F]{6}$/i.test(k), E = (k) => {
    k.target.select(), d(!0);
  }, C = (k) => {
    v(k.target.value) || s(t, null), k.relatedTarget && d(!1);
  }, y = () => {
    a || d(!l);
  }, T = () => c && c.length >= 1 ? c : e, A = (k, N) => {
    k.stopPropagation(), s(t, N), d(!1);
  };
  return /* @__PURE__ */ Mt("div", { className: p, ref: f, children: [
    /* @__PURE__ */ Re(
      "div",
      {
        className: g,
        style: { backgroundColor: r[t] ?? "" },
        onClick: y
      }
    ),
    /* @__PURE__ */ Re(
      Dm,
      {
        name: t,
        className: Bb.colorpicker__input,
        type: "text",
        innerRef: h,
        onFocus: E,
        onBlur: C,
        placeholder: i,
        id: t,
        disabled: a
      }
    ),
    /* @__PURE__ */ Re(
      "div",
      {
        className: Bb.colorpicker__dropdownButton,
        onClick: y,
        children: /* @__PURE__ */ Re(E2, { className: b })
      }
    ),
    /* @__PURE__ */ Re("div", { className: _, children: T().map((k) => /* @__PURE__ */ Re(
      "div",
      {
        className: Bb.colorpicker__preset,
        style: { backgroundColor: k },
        onClick: (N) => A(N, k)
      },
      k
    )) }),
    /* @__PURE__ */ Re(Xh, { name: t })
  ] });
}, yX = "_formDate__container_6qw0v_1", vX = "_formDate__input_6qw0v_11", bX = "_formDate__divider_6qw0v_40", EX = "_formDate__clearButton_6qw0v_61", SX = "_formDate__clearButtonIcon_6qw0v_79", Ph = {
  formDate__container: yX,
  formDate__input: vX,
  formDate__divider: bX,
  "formDate__container--disabled": "_formDate__container--disabled_6qw0v_47",
  "formDate__container--error": "_formDate__container--error_6qw0v_58",
  formDate__clearButton: EX,
  formDate__clearButtonIcon: SX
}, CX = Mn.bind(Ph), Toe = (n) => {
  const { name: e, disabled: t = !1, clearButton: i = !0 } = n, c = gd(), { setFieldValue: a, values: s, errors: r, setFieldTouched: l, touched: d } = c, f = zn(null), h = zn(null), p = zn(null);
  An(() => {
    rr(r, e) && l(e, !0);
  }, [r, e, l]);
  const [g, _] = Wn(""), [b, v] = Wn(""), [E, C] = Wn("");
  An(() => {
    const B = rr(s, e);
    B ? (_(B.getDate().toString().padStart(2, "0")), v((B.getMonth() + 1).toString().padStart(2, "0")), C(B.getFullYear().toString())) : (_(""), v(""), C(""));
  }, [s, e]);
  const y = (B) => {
    var U, H;
    switch (B.target.name) {
      case "day":
        parseInt(B.target.value) > k() ? _(k().toString()) : _(B.target.value), B.target.value.length >= 2 && B.nativeEvent instanceof InputEvent && ((U = h.current) == null || U.focus());
        break;
      case "month":
        parseInt(B.target.value) < 0 || parseInt(B.target.value) > 12 ? v("12") : v(B.target.value), B.target.value.length >= 2 && B.nativeEvent instanceof InputEvent && ((H = p.current) == null || H.focus());
        break;
      case "year":
        C(B.target.value.slice(0, 4));
        break;
    }
  }, T = (B) => {
    var U, H;
    if (B.key === "Backspace" && B.currentTarget.value === "")
      switch (B.currentTarget.name) {
        case "month":
          (U = f.current) == null || U.focus();
          break;
        case "year":
          (H = h.current) == null || H.focus();
          break;
      }
  }, A = (B) => {
    if (B.target.value !== "") {
      if (parseInt(B.target.value) < 1) {
        switch (B.target.name) {
          case "day":
            _("01");
            break;
          case "month":
            v("01");
            break;
          case "year":
            C((/* @__PURE__ */ new Date()).getFullYear().toString());
            break;
        }
        return;
      }
      B.target.name === "day" && _(B.target.value.padStart(2, "0")), B.target.name === "month" && v(B.target.value.padStart(2, "0"));
    }
  }, k = hr(() => {
    if (!b) return 31;
    const B = parseInt(b);
    return B === 2 ? E && parseInt(E) % 4 === 0 ? 29 : 28 : [4, 6, 9, 11].includes(B) ? 30 : 31;
  }, [b, E]);
  An(() => {
    if (parseInt(g) && parseInt(b) >= 1 && parseInt(b) < 13 && parseInt(E) > 1900) {
      const B = new Date(
        parseInt(E),
        parseInt(b) - 1,
        parseInt(g)
      );
      a(e, B);
    }
  }, [g, b, E, a, e]);
  const N = (/* @__PURE__ */ new Date()).getFullYear() + 10, j = CX("formDate__container", {
    "formDate__container--disabled": t,
    "formDate__container--error": e in r && e in d
  }), I = () => {
    _(""), v(""), C(""), a(e, null);
  };
  return /* @__PURE__ */ Re(pd, { children: /* @__PURE__ */ Mt("div", { children: [
    /* @__PURE__ */ Mt("div", { className: j, children: [
      /* @__PURE__ */ Re(
        "input",
        {
          disabled: t,
          pattern: "[0-9]*",
          inputMode: "numeric",
          ref: f,
          type: "number",
          autoComplete: "off",
          value: g,
          min: "1",
          max: k(),
          name: "day",
          onFocus: (B) => B.target.select(),
          onChange: y,
          className: Ph.formDate__input,
          onKeyUp: T,
          onBlur: A
        }
      ),
      /* @__PURE__ */ Re("span", { className: Ph.formDate__divider, children: "/" }),
      /* @__PURE__ */ Re(
        "input",
        {
          disabled: t,
          pattern: "[0-9]*",
          inputMode: "numeric",
          ref: h,
          type: "number",
          autoComplete: "off",
          value: b,
          min: "1",
          max: "12",
          name: "month",
          onFocus: (B) => B.target.select(),
          onChange: y,
          className: Ph.formDate__input,
          onKeyUp: T,
          onBlur: A
        }
      ),
      /* @__PURE__ */ Re("span", { className: Ph.formDate__divider, children: "/" }),
      /* @__PURE__ */ Re(
        "input",
        {
          disabled: t,
          pattern: "[0-9]*",
          inputMode: "numeric",
          ref: p,
          type: "number",
          autoComplete: "off",
          value: E,
          min: 1900,
          max: N,
          name: "year",
          onFocus: (B) => B.target.select(),
          onChange: y,
          className: Ph.formDate__input,
          onKeyUp: T,
          onBlur: A
        }
      ),
      i && (g || b || E) && /* @__PURE__ */ Re(
        "button",
        {
          className: Ph.formDate__clearButton,
          type: "button",
          onClick: I,
          children: /* @__PURE__ */ Re(
            S2,
            {
              className: Ph.formDate__clearButtonIcon
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Re(Xh, { name: e })
  ] }) });
}, wX = "_datePicker_7emup_1", xX = "_datePicker__grid_7emup_8", TX = "_datePickerDate_7emup_16", AX = "_datePickerDate__button_7emup_21", kX = "_datePickerDate__buttonIcon_7emup_59", OX = "_datePickerDate__buttonLabel_7emup_64", DX = "_datePickerDate__clearButton_7emup_75", RX = "_datePickerDate__clearButtonIcon_7emup_93", NX = "_datePickerDate__calendar_7emup_101", IX = "_datePickerTime_7emup_119", LX = "_datePickerTime__select_7emup_123", MX = "_datePickerTime__icon_7emup_158", cf = {
  datePicker: wX,
  datePicker__grid: xX,
  datePickerDate: TX,
  datePickerDate__button: AX,
  "datePickerDate__button--error": "_datePickerDate__button--error_7emup_56",
  datePickerDate__buttonIcon: kX,
  datePickerDate__buttonLabel: OX,
  "datePickerDate__buttonLabel--placeholder": "_datePickerDate__buttonLabel--placeholder_7emup_71",
  datePickerDate__clearButton: DX,
  datePickerDate__clearButtonIcon: RX,
  datePickerDate__calendar: NX,
  "datePickerDate__calendar--show": "_datePickerDate__calendar--show_7emup_115",
  datePickerTime: IX,
  datePickerTime__select: LX,
  "datePickerTime__select--error": "_datePickerTime__select--error_7emup_155",
  datePickerTime__icon: MX
}, Ab = Mn.bind(cf), Aoe = (n) => {
  const {
    name: e,
    placeholder: t,
    disabled: i = !1,
    clearButton: c = !1,
    hideHours: a = !0,
    timeInterval: s = 15,
    defaultTime: r = "00:00",
    minDate: l,
    maxDate: d
  } = n, f = gd(), { setFieldValue: h, values: p, errors: g, setFieldTouched: _, touched: b } = f, v = zn(null), [E, C] = Wn(!1);
  An(() => {
    rr(g, e) && rr(p, e) && _(e, !0);
  }, [g, e, _, p]), Fx([v], () => {
    C(!1);
  });
  const y = () => {
    C(!E);
  }, T = ($) => {
    const te = N(l), V = N(d);
    te && $ < te && ($ = te), V && $ > V && ($ = V), j(a) && $.setHours(0, 0, 0, 0), h(e, $), C(!1);
  }, A = () => {
    h(e, null), C(!1);
  }, k = ($) => {
    const [te, V] = $.target.value.split(":"), K = new Date(rr(p, e) ?? /* @__PURE__ */ new Date());
    K.setHours(parseInt(te), parseInt(V)), h(e, K);
  }, N = ($) => $ ? typeof $ == "string" ? p[$] : $ : null, j = ($) => typeof $ == "string" ? p[$] : $, I = () => {
    if (rr(p, e)) {
      const $ = rr(p, e).getHours(), te = rr(p, e).getMinutes();
      return `${$}:${te}`;
    }
    return "";
  }, B = () => document.documentElement.getAttribute("lang") ?? navigator.language, U = () => rr(p, e) ? rr(p, e).toLocaleString(B(), {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric"
  }) : t, H = ($) => {
    if (j(a)) return !0;
    if (!l && !d) return !1;
    const [te, V] = $.split(":"), K = N(l), ne = N(d);
    if (K && rr(p, e) && K.toDateString() === rr(p, e).toDateString()) {
      const J = new Date(rr(p, e));
      if (J.setHours(parseInt(te), parseInt(V)), J < K)
        return !0;
    }
    if (ne && rr(p, e) && ne.toDateString() === rr(p, e).toDateString()) {
      const J = new Date(rr(p, e));
      if (J.setHours(parseInt(te), parseInt(V)), J > ne)
        return !0;
    }
    return !1;
  }, Q = Ab("datePickerDate__button", {
    "datePickerDate__button--error": e in g && e in b
  }), Y = Ab("datePickerTime__select", {
    "datePickerTime__select--error": e in g && e in b
  }), ie = Ab("datePickerDate__calendar", {
    "datePickerDate__calendar--show": E
  }), ce = Ab("datePickerDate__buttonLabel", {
    "datePickerDate__buttonLabel--placeholder": !rr(p, e)
  });
  return /* @__PURE__ */ Mt(pd, { children: [
    /* @__PURE__ */ Re("div", { className: cf.datePicker, children: /* @__PURE__ */ Mt("div", { className: cf.datePicker__grid, children: [
      /* @__PURE__ */ Mt("div", { ref: v, className: cf.datePickerDate, children: [
        /* @__PURE__ */ Mt(
          "button",
          {
            type: "button",
            className: Q,
            onClick: y,
            children: [
              /* @__PURE__ */ Re(
                TP,
                {
                  className: cf.datePickerDate__buttonIcon
                }
              ),
              /* @__PURE__ */ Re("span", { className: ce, children: U() })
            ]
          }
        ),
        c && rr(p, e) && /* @__PURE__ */ Re(
          "button",
          {
            className: cf.datePickerDate__clearButton,
            type: "button",
            onClick: A,
            children: /* @__PURE__ */ Re(
              S2,
              {
                className: cf.datePickerDate__clearButtonIcon
              }
            )
          }
        ),
        E && /* @__PURE__ */ Re("div", { className: ie, children: /* @__PURE__ */ Re(
          Gj,
          {
            value: rr(p, e),
            onChange: T,
            defaultTime: r,
            minDate: N(l),
            maxDate: N(d)
          }
        ) })
      ] }),
      !j(a) && /* @__PURE__ */ Mt("div", { className: cf.datePickerTime, children: [
        /* @__PURE__ */ Mt(
          "select",
          {
            value: I(),
            className: Y,
            onChange: k,
            disabled: i || !rr(p, e),
            children: [
              /* @__PURE__ */ Re("option", { disabled: !0, value: "" }),
              Array.from({
                length: 24 * 60 / s
              }).map(($, te) => {
                const V = Math.floor(
                  te * s / 60
                ), K = te * s % 60, ne = `${V}:${K}`;
                return /* @__PURE__ */ Re(
                  "option",
                  {
                    disabled: H(ne),
                    value: ne,
                    children: `${V.toString().padStart(2, "0")}:${K.toString().padStart(2, "0")}`
                  },
                  te
                );
              })
            ]
          }
        ),
        /* @__PURE__ */ Re(
          AP,
          {
            className: cf.datePickerTime__icon
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ Re(Xh, { name: e })
  ] });
}, PX = "_fieldset_136e4_1", jX = {
  fieldset: PX,
  "fieldset--noMargin": "_fieldset--noMargin_136e4_17",
  "fieldset--marginTop": "_fieldset--marginTop_136e4_20"
}, BX = Mn.bind(jX), koe = (n) => {
  const { disabled: e, children: t, noMargin: i = !1 } = n, c = BX("fieldset", {
    "fieldset--noMargin": i
  });
  return /* @__PURE__ */ Re("fieldset", { className: c, disabled: e, children: t });
}, FX = "_formGroup_1vum0_1", UX = {
  formGroup: FX,
  "formGroup--horizontal": "_formGroup--horizontal_1vum0_7"
}, HX = Mn.bind(UX), Ooe = (n) => {
  const { children: e, noMargin: t, horizontal: i } = n, c = HX("formGroup", {
    "formGroup--noMargin": !!t,
    "formGroup--horizontal": !!i
  });
  return /* @__PURE__ */ Re("div", { className: c, children: e });
}, zX = {}, VX = Mn.bind(zX), Doe = (n) => {
  const { marginTop: e = !1, marginBottom: t = !1, children: i } = n, c = VX("helper", {
    "helper--marginTop": e,
    "helper--marginBottom": t
  });
  return /* @__PURE__ */ Re("div", { className: c, children: /* @__PURE__ */ Re(a0, { variant: "small", noMargin: !0, children: i }) });
}, qX = "_label_jor7p_1", GX = "_label__helper_jor7p_14", mx = {
  label: qX,
  label__helper: GX,
  "label--horizontal": "_label--horizontal_jor7p_23"
}, WX = Mn.bind(mx), pO = (n) => {
  const { children: e, htmlFor: t, helperText: i, horizontal: c } = n, a = WX("label", {
    "label--horizontal": !!c
  });
  return t ? /* @__PURE__ */ Mt("label", { className: a, htmlFor: t, children: [
    e,
    /* @__PURE__ */ Re("span", { className: mx.label__helper, children: i })
  ] }) : /* @__PURE__ */ Mt("legend", { className: a, children: [
    e,
    /* @__PURE__ */ Re("span", { className: mx.label__helper, children: i })
  ] });
}, $X = "_markdown_1f2pr_1", YX = "_markdown__bottom_1f2pr_16", XX = "_markdown__textarea_1f2pr_47", KX = "_markdown__preview_1f2pr_54", QX = "_markdown__editor_1f2pr_57", a1 = {
  markdown: $X,
  "markdown--error": "_markdown--error_1f2pr_13",
  markdown__bottom: YX,
  markdown__textarea: XX,
  markdown__preview: KX,
  markdown__editor: QX,
  "markdown--open": "_markdown--open_1f2pr_101"
};
function ZX(n, e) {
  const t = {};
  return (n[n.length - 1] === "" ? [...n, ""] : n).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const JX = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, eK = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, tK = {};
function mO(n, e) {
  return (tK.jsx ? eK : JX).test(n);
}
const nK = /[ \t\n\f\r]/g;
function rK(n) {
  return typeof n == "object" ? n.type === "text" ? gO(n.value) : !1 : gO(n);
}
function gO(n) {
  return n.replace(nK, "") === "";
}
let z1 = class {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(e, t, i) {
    this.property = e, this.normal = t, i && (this.space = i);
  }
};
z1.prototype.property = {};
z1.prototype.normal = {};
z1.prototype.space = null;
function Z8(n, e) {
  const t = {}, i = {};
  let c = -1;
  for (; ++c < n.length; )
    Object.assign(t, n[c].property), Object.assign(i, n[c].normal);
  return new z1(t, i, e);
}
function gx(n) {
  return n.toLowerCase();
}
class cu {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(e, t) {
    this.property = e, this.attribute = t;
  }
}
cu.prototype.space = null;
cu.prototype.boolean = !1;
cu.prototype.booleanish = !1;
cu.prototype.overloadedBoolean = !1;
cu.prototype.number = !1;
cu.prototype.commaSeparated = !1;
cu.prototype.spaceSeparated = !1;
cu.prototype.commaOrSpaceSeparated = !1;
cu.prototype.mustUseProperty = !1;
cu.prototype.defined = !1;
let iK = 0;
const dr = Im(), Ro = Im(), J8 = Im(), Yt = Im(), xi = Im(), n0 = Im(), Sl = Im();
function Im() {
  return 2 ** ++iK;
}
const _x = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: dr,
  booleanish: Ro,
  commaOrSpaceSeparated: Sl,
  commaSeparated: n0,
  number: Yt,
  overloadedBoolean: J8,
  spaceSeparated: xi
}, Symbol.toStringTag, { value: "Module" })), Aw = Object.keys(_x);
class ET extends cu {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(e, t, i, c) {
    let a = -1;
    if (super(e, t), _O(this, "space", c), typeof i == "number")
      for (; ++a < Aw.length; ) {
        const s = Aw[a];
        _O(this, Aw[a], (i & _x[s]) === _x[s]);
      }
  }
}
ET.prototype.defined = !0;
function _O(n, e, t) {
  t && (n[e] = t);
}
const oK = {}.hasOwnProperty;
function v0(n) {
  const e = {}, t = {};
  let i;
  for (i in n.properties)
    if (oK.call(n.properties, i)) {
      const c = n.properties[i], a = new ET(
        i,
        n.transform(n.attributes || {}, i),
        c,
        n.space
      );
      n.mustUseProperty && n.mustUseProperty.includes(i) && (a.mustUseProperty = !0), e[i] = a, t[gx(i)] = i, t[gx(a.attribute)] = i;
    }
  return new z1(e, t, n.space);
}
const e9 = v0({
  space: "xlink",
  transform(n, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), t9 = v0({
  space: "xml",
  transform(n, e) {
    return "xml:" + e.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function n9(n, e) {
  return e in n ? n[e] : e;
}
function r9(n, e) {
  return n9(n, e.toLowerCase());
}
const i9 = v0({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: r9,
  properties: { xmlns: null, xmlnsXLink: null }
}), o9 = v0({
  transform(n, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ro,
    ariaAutoComplete: null,
    ariaBusy: Ro,
    ariaChecked: Ro,
    ariaColCount: Yt,
    ariaColIndex: Yt,
    ariaColSpan: Yt,
    ariaControls: xi,
    ariaCurrent: null,
    ariaDescribedBy: xi,
    ariaDetails: null,
    ariaDisabled: Ro,
    ariaDropEffect: xi,
    ariaErrorMessage: null,
    ariaExpanded: Ro,
    ariaFlowTo: xi,
    ariaGrabbed: Ro,
    ariaHasPopup: null,
    ariaHidden: Ro,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: xi,
    ariaLevel: Yt,
    ariaLive: null,
    ariaModal: Ro,
    ariaMultiLine: Ro,
    ariaMultiSelectable: Ro,
    ariaOrientation: null,
    ariaOwns: xi,
    ariaPlaceholder: null,
    ariaPosInSet: Yt,
    ariaPressed: Ro,
    ariaReadOnly: Ro,
    ariaRelevant: null,
    ariaRequired: Ro,
    ariaRoleDescription: xi,
    ariaRowCount: Yt,
    ariaRowIndex: Yt,
    ariaRowSpan: Yt,
    ariaSelected: Ro,
    ariaSetSize: Yt,
    ariaSort: null,
    ariaValueMax: Yt,
    ariaValueMin: Yt,
    ariaValueNow: Yt,
    ariaValueText: null,
    role: null
  }
}), aK = v0({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: r9,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: n0,
    acceptCharset: xi,
    accessKey: xi,
    action: null,
    allow: null,
    allowFullScreen: dr,
    allowPaymentRequest: dr,
    allowUserMedia: dr,
    alt: null,
    as: null,
    async: dr,
    autoCapitalize: null,
    autoComplete: xi,
    autoFocus: dr,
    autoPlay: dr,
    blocking: xi,
    capture: null,
    charSet: null,
    checked: dr,
    cite: null,
    className: xi,
    cols: Yt,
    colSpan: null,
    content: null,
    contentEditable: Ro,
    controls: dr,
    controlsList: xi,
    coords: Yt | n0,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: dr,
    defer: dr,
    dir: null,
    dirName: null,
    disabled: dr,
    download: J8,
    draggable: Ro,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: dr,
    formTarget: null,
    headers: xi,
    height: Yt,
    hidden: dr,
    high: Yt,
    href: null,
    hrefLang: null,
    htmlFor: xi,
    httpEquiv: xi,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: dr,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: dr,
    itemId: null,
    itemProp: xi,
    itemRef: xi,
    itemScope: dr,
    itemType: xi,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: dr,
    low: Yt,
    manifest: null,
    max: null,
    maxLength: Yt,
    media: null,
    method: null,
    min: null,
    minLength: Yt,
    multiple: dr,
    muted: dr,
    name: null,
    nonce: null,
    noModule: dr,
    noValidate: dr,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: dr,
    optimum: Yt,
    pattern: null,
    ping: xi,
    placeholder: null,
    playsInline: dr,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: dr,
    referrerPolicy: null,
    rel: xi,
    required: dr,
    reversed: dr,
    rows: Yt,
    rowSpan: Yt,
    sandbox: xi,
    scope: null,
    scoped: dr,
    seamless: dr,
    selected: dr,
    shadowRootClonable: dr,
    shadowRootDelegatesFocus: dr,
    shadowRootMode: null,
    shape: null,
    size: Yt,
    sizes: null,
    slot: null,
    span: Yt,
    spellCheck: Ro,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Yt,
    step: null,
    style: null,
    tabIndex: Yt,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: dr,
    useMap: null,
    value: Ro,
    width: Yt,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: xi,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Yt,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Yt,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: dr,
    // Lists. Use CSS to reduce space between items instead
    declare: dr,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Yt,
    // `<img>` and `<object>`
    leftMargin: Yt,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Yt,
    // `<body>`
    marginWidth: Yt,
    // `<body>`
    noResize: dr,
    // `<frame>`
    noHref: dr,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: dr,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: dr,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Yt,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ro,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Yt,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Yt,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: dr,
    disableRemotePlayback: dr,
    prefix: null,
    property: null,
    results: Yt,
    security: null,
    unselectable: null
  }
}), sK = v0({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: n9,
  properties: {
    about: Sl,
    accentHeight: Yt,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Yt,
    amplitude: Yt,
    arabicForm: null,
    ascent: Yt,
    attributeName: null,
    attributeType: null,
    azimuth: Yt,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Yt,
    by: null,
    calcMode: null,
    capHeight: Yt,
    className: xi,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Yt,
    diffuseConstant: Yt,
    direction: null,
    display: null,
    dur: null,
    divisor: Yt,
    dominantBaseline: null,
    download: dr,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Yt,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Yt,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Yt,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: n0,
    g2: n0,
    glyphName: n0,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Yt,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Yt,
    horizOriginX: Yt,
    horizOriginY: Yt,
    id: null,
    ideographic: Yt,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Yt,
    k: Yt,
    k1: Yt,
    k2: Yt,
    k3: Yt,
    k4: Yt,
    kernelMatrix: Sl,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Yt,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Yt,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Yt,
    overlineThickness: Yt,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Yt,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: xi,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Yt,
    pointsAtY: Yt,
    pointsAtZ: Yt,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Sl,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Sl,
    rev: Sl,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Sl,
    requiredFeatures: Sl,
    requiredFonts: Sl,
    requiredFormats: Sl,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Yt,
    specularExponent: Yt,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Yt,
    strikethroughThickness: Yt,
    string: null,
    stroke: null,
    strokeDashArray: Sl,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Yt,
    strokeOpacity: Yt,
    strokeWidth: null,
    style: null,
    surfaceScale: Yt,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Sl,
    tabIndex: Yt,
    tableValues: null,
    target: null,
    targetX: Yt,
    targetY: Yt,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Sl,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Yt,
    underlineThickness: Yt,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Yt,
    values: null,
    vAlphabetic: Yt,
    vMathematical: Yt,
    vectorEffect: null,
    vHanging: Yt,
    vIdeographic: Yt,
    version: null,
    vertAdvY: Yt,
    vertOriginX: Yt,
    vertOriginY: Yt,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Yt,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), lK = /^data[-\w.:]+$/i, yO = /-[a-z]/g, uK = /[A-Z]/g;
function cK(n, e) {
  const t = gx(e);
  let i = e, c = cu;
  if (t in n.normal)
    return n.property[n.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && lK.test(e)) {
    if (e.charAt(4) === "-") {
      const a = e.slice(5).replace(yO, fK);
      i = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = e.slice(4);
      if (!yO.test(a)) {
        let s = a.replace(uK, dK);
        s.charAt(0) !== "-" && (s = "-" + s), e = "data" + s;
      }
    }
    c = ET;
  }
  return new c(i, e);
}
function dK(n) {
  return "-" + n.toLowerCase();
}
function fK(n) {
  return n.charAt(1).toUpperCase();
}
const hK = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, pK = Z8([t9, e9, i9, o9, aK], "html"), ST = Z8([t9, e9, i9, o9, sK], "svg");
function mK(n) {
  return n.join(" ").trim();
}
var a9 = {}, vO = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, gK = /\n/g, _K = /^\s*/, yK = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, vK = /^:\s*/, bK = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, EK = /^[;\s]*/, SK = /^\s+|\s+$/g, CK = `
`, bO = "/", EO = "*", cm = "", wK = "comment", xK = "declaration", TK = function(n, e) {
  if (typeof n != "string")
    throw new TypeError("First argument must be a string");
  if (!n) return [];
  e = e || {};
  var t = 1, i = 1;
  function c(_) {
    var b = _.match(gK);
    b && (t += b.length);
    var v = _.lastIndexOf(CK);
    i = ~v ? _.length - v : i + _.length;
  }
  function a() {
    var _ = { line: t, column: i };
    return function(b) {
      return b.position = new s(_), d(), b;
    };
  }
  function s(_) {
    this.start = _, this.end = { line: t, column: i }, this.source = e.source;
  }
  s.prototype.content = n;
  function r(_) {
    var b = new Error(
      e.source + ":" + t + ":" + i + ": " + _
    );
    if (b.reason = _, b.filename = e.source, b.line = t, b.column = i, b.source = n, !e.silent) throw b;
  }
  function l(_) {
    var b = _.exec(n);
    if (b) {
      var v = b[0];
      return c(v), n = n.slice(v.length), b;
    }
  }
  function d() {
    l(_K);
  }
  function f(_) {
    var b;
    for (_ = _ || []; b = h(); )
      b !== !1 && _.push(b);
    return _;
  }
  function h() {
    var _ = a();
    if (!(bO != n.charAt(0) || EO != n.charAt(1))) {
      for (var b = 2; cm != n.charAt(b) && (EO != n.charAt(b) || bO != n.charAt(b + 1)); )
        ++b;
      if (b += 2, cm === n.charAt(b - 1))
        return r("End of comment missing");
      var v = n.slice(2, b - 2);
      return i += 2, c(v), n = n.slice(b), i += 2, _({
        type: wK,
        comment: v
      });
    }
  }
  function p() {
    var _ = a(), b = l(yK);
    if (b) {
      if (h(), !l(vK)) return r("property missing ':'");
      var v = l(bK), E = _({
        type: xK,
        property: SO(b[0].replace(vO, cm)),
        value: v ? SO(v[0].replace(vO, cm)) : cm
      });
      return l(EK), E;
    }
  }
  function g() {
    var _ = [];
    f(_);
    for (var b; b = p(); )
      b !== !1 && (_.push(b), f(_));
    return _;
  }
  return d(), g();
};
function SO(n) {
  return n ? n.replace(SK, cm) : cm;
}
var AK = O3 && O3.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(a9, "__esModule", { value: !0 });
var CO = a9.default = OK, kK = AK(TK);
function OK(n, e) {
  var t = null;
  if (!n || typeof n != "string")
    return t;
  var i = (0, kK.default)(n), c = typeof e == "function";
  return i.forEach(function(a) {
    if (a.type === "declaration") {
      var s = a.property, r = a.value;
      c ? e(s, r, a) : r && (t = t || {}, t[s] = r);
    }
  }), t;
}
const DK = CO.default || CO, s9 = l9("end"), CT = l9("start");
function l9(n) {
  return e;
  function e(t) {
    const i = t && t.position && t.position[n] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function RK(n) {
  const e = CT(n), t = s9(n);
  if (e && t)
    return { start: e, end: t };
}
function y1(n) {
  return !n || typeof n != "object" ? "" : "position" in n || "type" in n ? wO(n.position) : "start" in n || "end" in n ? wO(n) : "line" in n || "column" in n ? yx(n) : "";
}
function yx(n) {
  return xO(n && n.line) + ":" + xO(n && n.column);
}
function wO(n) {
  return yx(n && n.start) + "-" + yx(n && n.end);
}
function xO(n) {
  return n && typeof n == "number" ? n : 1;
}
class ts extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(e, t, i) {
    super(), typeof t == "string" && (i = t, t = void 0);
    let c = "", a = {}, s = !1;
    if (t && ("line" in t && "column" in t ? a = { place: t } : "start" in t && "end" in t ? a = { place: t } : "type" in t ? a = {
      ancestors: [t],
      place: t.position
    } : a = { ...t }), typeof e == "string" ? c = e : !a.cause && e && (s = !0, c = e.message, a.cause = e), !a.ruleId && !a.source && typeof i == "string") {
      const l = i.indexOf(":");
      l === -1 ? a.ruleId = i : (a.source = i.slice(0, l), a.ruleId = i.slice(l + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const l = a.ancestors[a.ancestors.length - 1];
      l && (a.place = l.position);
    }
    const r = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = r ? r.column : void 0, this.fatal = void 0, this.file, this.message = c, this.line = r ? r.line : void 0, this.name = y1(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = s && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
ts.prototype.file = "";
ts.prototype.name = "";
ts.prototype.reason = "";
ts.prototype.message = "";
ts.prototype.stack = "";
ts.prototype.column = void 0;
ts.prototype.line = void 0;
ts.prototype.ancestors = void 0;
ts.prototype.cause = void 0;
ts.prototype.fatal = void 0;
ts.prototype.place = void 0;
ts.prototype.ruleId = void 0;
ts.prototype.source = void 0;
const wT = {}.hasOwnProperty, NK = /* @__PURE__ */ new Map(), IK = /[A-Z]/g, LK = /-([a-z])/g, MK = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), PK = /* @__PURE__ */ new Set(["td", "th"]), u9 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function jK(n, e) {
  if (!e || e.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = e.filePath || void 0;
  let i;
  if (e.development) {
    if (typeof e.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = GK(t, e.jsxDEV);
  } else {
    if (typeof e.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof e.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = qK(t, e.jsx, e.jsxs);
  }
  const c = {
    Fragment: e.Fragment,
    ancestors: [],
    components: e.components || {},
    create: i,
    elementAttributeNameCase: e.elementAttributeNameCase || "react",
    evaluater: e.createEvaluater ? e.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: e.ignoreInvalidStyle || !1,
    passKeys: e.passKeys !== !1,
    passNode: e.passNode || !1,
    schema: e.space === "svg" ? ST : pK,
    stylePropertyNameCase: e.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: e.tableCellAlignToStyle !== !1
  }, a = c9(c, n, void 0);
  return a && typeof a != "string" ? a : c.create(
    n,
    c.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function c9(n, e, t) {
  if (e.type === "element")
    return BK(n, e, t);
  if (e.type === "mdxFlowExpression" || e.type === "mdxTextExpression")
    return FK(n, e);
  if (e.type === "mdxJsxFlowElement" || e.type === "mdxJsxTextElement")
    return HK(n, e, t);
  if (e.type === "mdxjsEsm")
    return UK(n, e);
  if (e.type === "root")
    return zK(n, e, t);
  if (e.type === "text")
    return VK(n, e);
}
function BK(n, e, t) {
  const i = n.schema;
  let c = i;
  e.tagName.toLowerCase() === "svg" && i.space === "html" && (c = ST, n.schema = c), n.ancestors.push(e);
  const a = f9(n, e.tagName, !1), s = WK(n, e);
  let r = TT(n, e);
  return MK.has(e.tagName) && (r = r.filter(function(l) {
    return typeof l == "string" ? !rK(l) : !0;
  })), d9(n, s, a, e), xT(s, r), n.ancestors.pop(), n.schema = i, n.create(e, a, s, t);
}
function FK(n, e) {
  if (e.data && e.data.estree && n.evaluater) {
    const i = e.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    n.evaluater.evaluateExpression(i.expression);
  }
  R1(n, e.position);
}
function UK(n, e) {
  if (e.data && e.data.estree && n.evaluater)
    return (
      /** @type {Child | undefined} */
      n.evaluater.evaluateProgram(e.data.estree)
    );
  R1(n, e.position);
}
function HK(n, e, t) {
  const i = n.schema;
  let c = i;
  e.name === "svg" && i.space === "html" && (c = ST, n.schema = c), n.ancestors.push(e);
  const a = e.name === null ? n.Fragment : f9(n, e.name, !0), s = $K(n, e), r = TT(n, e);
  return d9(n, s, a, e), xT(s, r), n.ancestors.pop(), n.schema = i, n.create(e, a, s, t);
}
function zK(n, e, t) {
  const i = {};
  return xT(i, TT(n, e)), n.create(e, n.Fragment, i, t);
}
function VK(n, e) {
  return e.value;
}
function d9(n, e, t, i) {
  typeof t != "string" && t !== n.Fragment && n.passNode && (e.node = i);
}
function xT(n, e) {
  if (e.length > 0) {
    const t = e.length > 1 ? e : e[0];
    t && (n.children = t);
  }
}
function qK(n, e, t) {
  return i;
  function i(c, a, s, r) {
    const d = Array.isArray(s.children) ? t : e;
    return r ? d(a, s, r) : d(a, s);
  }
}
function GK(n, e) {
  return t;
  function t(i, c, a, s) {
    const r = Array.isArray(a.children), l = CT(i);
    return e(
      c,
      a,
      s,
      r,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: n,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function WK(n, e) {
  const t = {};
  let i, c;
  for (c in e.properties)
    if (c !== "children" && wT.call(e.properties, c)) {
      const a = YK(n, c, e.properties[c]);
      if (a) {
        const [s, r] = a;
        n.tableCellAlignToStyle && s === "align" && typeof r == "string" && PK.has(e.tagName) ? i = r : t[s] = r;
      }
    }
  if (i) {
    const a = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    a[n.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return t;
}
function $K(n, e) {
  const t = {};
  for (const i of e.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && n.evaluater) {
        const a = i.data.estree.body[0];
        a.type;
        const s = a.expression;
        s.type;
        const r = s.properties[0];
        r.type, Object.assign(
          t,
          n.evaluater.evaluateExpression(r.argument)
        );
      } else
        R1(n, e.position);
    else {
      const c = i.name;
      let a;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && n.evaluater) {
          const r = i.value.data.estree.body[0];
          r.type, a = n.evaluater.evaluateExpression(r.expression);
        } else
          R1(n, e.position);
      else
        a = i.value === null ? !0 : i.value;
      t[c] = /** @type {Props[keyof Props]} */
      a;
    }
  return t;
}
function TT(n, e) {
  const t = [];
  let i = -1;
  const c = n.passKeys ? /* @__PURE__ */ new Map() : NK;
  for (; ++i < e.children.length; ) {
    const a = e.children[i];
    let s;
    if (n.passKeys) {
      const l = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (l) {
        const d = c.get(l) || 0;
        s = l + "-" + d, c.set(l, d + 1);
      }
    }
    const r = c9(n, a, s);
    r !== void 0 && t.push(r);
  }
  return t;
}
function YK(n, e, t) {
  const i = cK(n.schema, e);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = i.commaSeparated ? ZX(t) : mK(t)), i.property === "style") {
      let c = typeof t == "object" ? t : XK(n, String(t));
      return n.stylePropertyNameCase === "css" && (c = KK(c)), ["style", c];
    }
    return [
      n.elementAttributeNameCase === "react" && i.space ? hK[i.property] || i.property : i.attribute,
      t
    ];
  }
}
function XK(n, e) {
  const t = {};
  try {
    DK(e, i);
  } catch (c) {
    if (!n.ignoreInvalidStyle) {
      const a = (
        /** @type {Error} */
        c
      ), s = new ts("Cannot parse `style` attribute", {
        ancestors: n.ancestors,
        cause: a,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = n.filePath || void 0, s.url = u9 + "#cannot-parse-style-attribute", s;
    }
  }
  return t;
  function i(c, a) {
    let s = c;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(LK, ZK)), t[s] = a;
  }
}
function f9(n, e, t) {
  let i;
  if (!t)
    i = { type: "Literal", value: e };
  else if (e.includes(".")) {
    const c = e.split(".");
    let a = -1, s;
    for (; ++a < c.length; ) {
      const r = mO(c[a]) ? { type: "Identifier", name: c[a] } : { type: "Literal", value: c[a] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: r,
        computed: !!(a && r.type === "Literal"),
        optional: !1
      } : r;
    }
    i = s;
  } else
    i = mO(e) && !/^[a-z]/.test(e) ? { type: "Identifier", name: e } : { type: "Literal", value: e };
  if (i.type === "Literal") {
    const c = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return wT.call(n.components, c) ? n.components[c] : c;
  }
  if (n.evaluater)
    return n.evaluater.evaluateExpression(i);
  R1(n);
}
function R1(n, e) {
  const t = new ts(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: n.ancestors,
      place: e,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = n.filePath || void 0, t.url = u9 + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function KK(n) {
  const e = {};
  let t;
  for (t in n)
    wT.call(n, t) && (e[QK(t)] = n[t]);
  return e;
}
function QK(n) {
  let e = n.replace(IK, JK);
  return e.slice(0, 3) === "ms-" && (e = "-" + e), e;
}
function ZK(n, e) {
  return e.toUpperCase();
}
function JK(n) {
  return "-" + n.toLowerCase();
}
const kw = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, eQ = {};
function tQ(n, e) {
  const t = eQ, i = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, c = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return h9(n, i, c);
}
function h9(n, e, t) {
  if (nQ(n)) {
    if ("value" in n)
      return n.type === "html" && !t ? "" : n.value;
    if (e && "alt" in n && n.alt)
      return n.alt;
    if ("children" in n)
      return TO(n.children, e, t);
  }
  return Array.isArray(n) ? TO(n, e, t) : "";
}
function TO(n, e, t) {
  const i = [];
  let c = -1;
  for (; ++c < n.length; )
    i[c] = h9(n[c], e, t);
  return i.join("");
}
function nQ(n) {
  return !!(n && typeof n == "object");
}
const AO = document.createElement("i");
function AT(n) {
  const e = "&" + n + ";";
  AO.innerHTML = e;
  const t = AO.textContent;
  return t.charCodeAt(t.length - 1) === 59 && n !== "semi" || t === e ? !1 : t;
}
function vf(n, e, t, i) {
  const c = n.length;
  let a = 0, s;
  if (e < 0 ? e = -e > c ? 0 : c + e : e = e > c ? c : e, t = t > 0 ? t : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(e, t), n.splice(...s);
  else
    for (t && n.splice(e, t); a < i.length; )
      s = i.slice(a, a + 1e4), s.unshift(e, 0), n.splice(...s), a += 1e4, e += 1e4;
}
function ou(n, e) {
  return n.length > 0 ? (vf(n, n.length, 0, e), n) : e;
}
const kO = {}.hasOwnProperty;
function rQ(n) {
  const e = {};
  let t = -1;
  for (; ++t < n.length; )
    iQ(e, n[t]);
  return e;
}
function iQ(n, e) {
  let t;
  for (t in e) {
    const c = (kO.call(n, t) ? n[t] : void 0) || (n[t] = {}), a = e[t];
    let s;
    if (a)
      for (s in a) {
        kO.call(c, s) || (c[s] = []);
        const r = a[s];
        oQ(
          // @ts-expect-error Looks like a list.
          c[s],
          Array.isArray(r) ? r : r ? [r] : []
        );
      }
  }
}
function oQ(n, e) {
  let t = -1;
  const i = [];
  for (; ++t < e.length; )
    (e[t].add === "after" ? n : i).push(e[t]);
  vf(n, 0, 0, i);
}
function p9(n, e) {
  const t = Number.parseInt(n, e);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function r0(n) {
  return n.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const ld = Zh(/[A-Za-z]/), wl = Zh(/[\dA-Za-z]/), aQ = Zh(/[#-'*+\--9=?A-Z^-~]/);
function vx(n) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    n !== null && (n < 32 || n === 127)
  );
}
const bx = Zh(/\d/), sQ = Zh(/[\dA-Fa-f]/), lQ = Zh(/[!-/:-@[-`{-~]/);
function ir(n) {
  return n !== null && n < -2;
}
function Js(n) {
  return n !== null && (n < 0 || n === 32);
}
function $r(n) {
  return n === -2 || n === -1 || n === 32;
}
const uQ = Zh(new RegExp("\\p{P}|\\p{S}", "u")), cQ = Zh(/\s/);
function Zh(n) {
  return e;
  function e(t) {
    return t !== null && t > -1 && n.test(String.fromCharCode(t));
  }
}
function b0(n) {
  const e = [];
  let t = -1, i = 0, c = 0;
  for (; ++t < n.length; ) {
    const a = n.charCodeAt(t);
    let s = "";
    if (a === 37 && wl(n.charCodeAt(t + 1)) && wl(n.charCodeAt(t + 2)))
      c = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (s = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const r = n.charCodeAt(t + 1);
      a < 56320 && r > 56319 && r < 57344 ? (s = String.fromCharCode(a, r), c = 1) : s = "�";
    } else
      s = String.fromCharCode(a);
    s && (e.push(n.slice(i, t), encodeURIComponent(s)), i = t + c + 1, s = ""), c && (t += c, c = 0);
  }
  return e.join("") + n.slice(i);
}
function Ti(n, e, t, i) {
  const c = i ? i - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return s;
  function s(l) {
    return $r(l) ? (n.enter(t), r(l)) : e(l);
  }
  function r(l) {
    return $r(l) && a++ < c ? (n.consume(l), r) : (n.exit(t), e(l));
  }
}
const dQ = {
  tokenize: fQ
};
function fQ(n) {
  const e = n.attempt(
    this.parser.constructs.contentInitial,
    i,
    c
  );
  let t;
  return e;
  function i(r) {
    if (r === null) {
      n.consume(r);
      return;
    }
    return n.enter("lineEnding"), n.consume(r), n.exit("lineEnding"), Ti(n, e, "linePrefix");
  }
  function c(r) {
    return n.enter("paragraph"), a(r);
  }
  function a(r) {
    const l = n.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = l), t = l, s(r);
  }
  function s(r) {
    if (r === null) {
      n.exit("chunkText"), n.exit("paragraph"), n.consume(r);
      return;
    }
    return ir(r) ? (n.consume(r), n.exit("chunkText"), a) : (n.consume(r), s);
  }
}
const hQ = {
  tokenize: pQ
}, OO = {
  tokenize: mQ
};
function pQ(n) {
  const e = this, t = [];
  let i = 0, c, a, s;
  return r;
  function r(y) {
    if (i < t.length) {
      const T = t[i];
      return e.containerState = T[1], n.attempt(
        T[0].continuation,
        l,
        d
      )(y);
    }
    return d(y);
  }
  function l(y) {
    if (i++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, c && C();
      const T = e.events.length;
      let A = T, k;
      for (; A--; )
        if (e.events[A][0] === "exit" && e.events[A][1].type === "chunkFlow") {
          k = e.events[A][1].end;
          break;
        }
      E(i);
      let N = T;
      for (; N < e.events.length; )
        e.events[N][1].end = Object.assign({}, k), N++;
      return vf(
        e.events,
        A + 1,
        0,
        e.events.slice(T)
      ), e.events.length = N, d(y);
    }
    return r(y);
  }
  function d(y) {
    if (i === t.length) {
      if (!c)
        return p(y);
      if (c.currentConstruct && c.currentConstruct.concrete)
        return _(y);
      e.interrupt = !!(c.currentConstruct && !c._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, n.check(
      OO,
      f,
      h
    )(y);
  }
  function f(y) {
    return c && C(), E(i), p(y);
  }
  function h(y) {
    return e.parser.lazy[e.now().line] = i !== t.length, s = e.now().offset, _(y);
  }
  function p(y) {
    return e.containerState = {}, n.attempt(
      OO,
      g,
      _
    )(y);
  }
  function g(y) {
    return i++, t.push([e.currentConstruct, e.containerState]), p(y);
  }
  function _(y) {
    if (y === null) {
      c && C(), E(0), n.consume(y);
      return;
    }
    return c = c || e.parser.flow(e.now()), n.enter("chunkFlow", {
      contentType: "flow",
      previous: a,
      _tokenizer: c
    }), b(y);
  }
  function b(y) {
    if (y === null) {
      v(n.exit("chunkFlow"), !0), E(0), n.consume(y);
      return;
    }
    return ir(y) ? (n.consume(y), v(n.exit("chunkFlow")), i = 0, e.interrupt = void 0, r) : (n.consume(y), b);
  }
  function v(y, T) {
    const A = e.sliceStream(y);
    if (T && A.push(null), y.previous = a, a && (a.next = y), a = y, c.defineSkip(y.start), c.write(A), e.parser.lazy[y.start.line]) {
      let k = c.events.length;
      for (; k--; )
        if (
          // The token starts before the line ending…
          c.events[k][1].start.offset < s && // …and either is not ended yet…
          (!c.events[k][1].end || // …or ends after it.
          c.events[k][1].end.offset > s)
        )
          return;
      const N = e.events.length;
      let j = N, I, B;
      for (; j--; )
        if (e.events[j][0] === "exit" && e.events[j][1].type === "chunkFlow") {
          if (I) {
            B = e.events[j][1].end;
            break;
          }
          I = !0;
        }
      for (E(i), k = N; k < e.events.length; )
        e.events[k][1].end = Object.assign({}, B), k++;
      vf(
        e.events,
        j + 1,
        0,
        e.events.slice(N)
      ), e.events.length = k;
    }
  }
  function E(y) {
    let T = t.length;
    for (; T-- > y; ) {
      const A = t[T];
      e.containerState = A[1], A[0].exit.call(e, n);
    }
    t.length = y;
  }
  function C() {
    c.write([null]), a = void 0, c = void 0, e.containerState._closeFlow = void 0;
  }
}
function mQ(n, e, t) {
  return Ti(
    n,
    n.attempt(this.parser.constructs.document, e, t),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function DO(n) {
  if (n === null || Js(n) || cQ(n))
    return 1;
  if (uQ(n))
    return 2;
}
function kT(n, e, t) {
  const i = [];
  let c = -1;
  for (; ++c < n.length; ) {
    const a = n[c].resolveAll;
    a && !i.includes(a) && (e = a(e, t), i.push(a));
  }
  return e;
}
const Ex = {
  name: "attention",
  tokenize: _Q,
  resolveAll: gQ
};
function gQ(n, e) {
  let t = -1, i, c, a, s, r, l, d, f;
  for (; ++t < n.length; )
    if (n[t][0] === "enter" && n[t][1].type === "attentionSequence" && n[t][1]._close) {
      for (i = t; i--; )
        if (n[i][0] === "exit" && n[i][1].type === "attentionSequence" && n[i][1]._open && // If the markers are the same:
        e.sliceSerialize(n[i][1]).charCodeAt(0) === e.sliceSerialize(n[t][1]).charCodeAt(0)) {
          if ((n[i][1]._close || n[t][1]._open) && (n[t][1].end.offset - n[t][1].start.offset) % 3 && !((n[i][1].end.offset - n[i][1].start.offset + n[t][1].end.offset - n[t][1].start.offset) % 3))
            continue;
          l = n[i][1].end.offset - n[i][1].start.offset > 1 && n[t][1].end.offset - n[t][1].start.offset > 1 ? 2 : 1;
          const h = Object.assign({}, n[i][1].end), p = Object.assign({}, n[t][1].start);
          RO(h, -l), RO(p, l), s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: Object.assign({}, n[i][1].end)
          }, r = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, n[t][1].start),
            end: p
          }, a = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, n[i][1].end),
            end: Object.assign({}, n[t][1].start)
          }, c = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, s.start),
            end: Object.assign({}, r.end)
          }, n[i][1].end = Object.assign({}, s.start), n[t][1].start = Object.assign({}, r.end), d = [], n[i][1].end.offset - n[i][1].start.offset && (d = ou(d, [["enter", n[i][1], e], ["exit", n[i][1], e]])), d = ou(d, [["enter", c, e], ["enter", s, e], ["exit", s, e], ["enter", a, e]]), d = ou(d, kT(e.parser.constructs.insideSpan.null, n.slice(i + 1, t), e)), d = ou(d, [["exit", a, e], ["enter", r, e], ["exit", r, e], ["exit", c, e]]), n[t][1].end.offset - n[t][1].start.offset ? (f = 2, d = ou(d, [["enter", n[t][1], e], ["exit", n[t][1], e]])) : f = 0, vf(n, i - 1, t - i + 3, d), t = i + d.length - f - 2;
          break;
        }
    }
  for (t = -1; ++t < n.length; )
    n[t][1].type === "attentionSequence" && (n[t][1].type = "data");
  return n;
}
function _Q(n, e) {
  const t = this.parser.constructs.attentionMarkers.null, i = this.previous, c = DO(i);
  let a;
  return s;
  function s(l) {
    return a = l, n.enter("attentionSequence"), r(l);
  }
  function r(l) {
    if (l === a)
      return n.consume(l), r;
    const d = n.exit("attentionSequence"), f = DO(l), h = !f || f === 2 && c || t.includes(l), p = !c || c === 2 && f || t.includes(i);
    return d._open = !!(a === 42 ? h : h && (c || !p)), d._close = !!(a === 42 ? p : p && (f || !h)), e(l);
  }
}
function RO(n, e) {
  n.column += e, n.offset += e, n._bufferIndex += e;
}
const yQ = {
  name: "autolink",
  tokenize: vQ
};
function vQ(n, e, t) {
  let i = 0;
  return c;
  function c(g) {
    return n.enter("autolink"), n.enter("autolinkMarker"), n.consume(g), n.exit("autolinkMarker"), n.enter("autolinkProtocol"), a;
  }
  function a(g) {
    return ld(g) ? (n.consume(g), s) : g === 64 ? t(g) : d(g);
  }
  function s(g) {
    return g === 43 || g === 45 || g === 46 || wl(g) ? (i = 1, r(g)) : d(g);
  }
  function r(g) {
    return g === 58 ? (n.consume(g), i = 0, l) : (g === 43 || g === 45 || g === 46 || wl(g)) && i++ < 32 ? (n.consume(g), r) : (i = 0, d(g));
  }
  function l(g) {
    return g === 62 ? (n.exit("autolinkProtocol"), n.enter("autolinkMarker"), n.consume(g), n.exit("autolinkMarker"), n.exit("autolink"), e) : g === null || g === 32 || g === 60 || vx(g) ? t(g) : (n.consume(g), l);
  }
  function d(g) {
    return g === 64 ? (n.consume(g), f) : aQ(g) ? (n.consume(g), d) : t(g);
  }
  function f(g) {
    return wl(g) ? h(g) : t(g);
  }
  function h(g) {
    return g === 46 ? (n.consume(g), i = 0, f) : g === 62 ? (n.exit("autolinkProtocol").type = "autolinkEmail", n.enter("autolinkMarker"), n.consume(g), n.exit("autolinkMarker"), n.exit("autolink"), e) : p(g);
  }
  function p(g) {
    if ((g === 45 || wl(g)) && i++ < 63) {
      const _ = g === 45 ? p : h;
      return n.consume(g), _;
    }
    return t(g);
  }
}
const H2 = {
  tokenize: bQ,
  partial: !0
};
function bQ(n, e, t) {
  return i;
  function i(a) {
    return $r(a) ? Ti(n, c, "linePrefix")(a) : c(a);
  }
  function c(a) {
    return a === null || ir(a) ? e(a) : t(a);
  }
}
const m9 = {
  name: "blockQuote",
  tokenize: EQ,
  continuation: {
    tokenize: SQ
  },
  exit: CQ
};
function EQ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    if (s === 62) {
      const r = i.containerState;
      return r.open || (n.enter("blockQuote", {
        _container: !0
      }), r.open = !0), n.enter("blockQuotePrefix"), n.enter("blockQuoteMarker"), n.consume(s), n.exit("blockQuoteMarker"), a;
    }
    return t(s);
  }
  function a(s) {
    return $r(s) ? (n.enter("blockQuotePrefixWhitespace"), n.consume(s), n.exit("blockQuotePrefixWhitespace"), n.exit("blockQuotePrefix"), e) : (n.exit("blockQuotePrefix"), e(s));
  }
}
function SQ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    return $r(s) ? Ti(n, a, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : a(s);
  }
  function a(s) {
    return n.attempt(m9, e, t)(s);
  }
}
function CQ(n) {
  n.exit("blockQuote");
}
const g9 = {
  name: "characterEscape",
  tokenize: wQ
};
function wQ(n, e, t) {
  return i;
  function i(a) {
    return n.enter("characterEscape"), n.enter("escapeMarker"), n.consume(a), n.exit("escapeMarker"), c;
  }
  function c(a) {
    return lQ(a) ? (n.enter("characterEscapeValue"), n.consume(a), n.exit("characterEscapeValue"), n.exit("characterEscape"), e) : t(a);
  }
}
const _9 = {
  name: "characterReference",
  tokenize: xQ
};
function xQ(n, e, t) {
  const i = this;
  let c = 0, a, s;
  return r;
  function r(h) {
    return n.enter("characterReference"), n.enter("characterReferenceMarker"), n.consume(h), n.exit("characterReferenceMarker"), l;
  }
  function l(h) {
    return h === 35 ? (n.enter("characterReferenceMarkerNumeric"), n.consume(h), n.exit("characterReferenceMarkerNumeric"), d) : (n.enter("characterReferenceValue"), a = 31, s = wl, f(h));
  }
  function d(h) {
    return h === 88 || h === 120 ? (n.enter("characterReferenceMarkerHexadecimal"), n.consume(h), n.exit("characterReferenceMarkerHexadecimal"), n.enter("characterReferenceValue"), a = 6, s = sQ, f) : (n.enter("characterReferenceValue"), a = 7, s = bx, f(h));
  }
  function f(h) {
    if (h === 59 && c) {
      const p = n.exit("characterReferenceValue");
      return s === wl && !AT(i.sliceSerialize(p)) ? t(h) : (n.enter("characterReferenceMarker"), n.consume(h), n.exit("characterReferenceMarker"), n.exit("characterReference"), e);
    }
    return s(h) && c++ < a ? (n.consume(h), f) : t(h);
  }
}
const NO = {
  tokenize: AQ,
  partial: !0
}, IO = {
  name: "codeFenced",
  tokenize: TQ,
  concrete: !0
};
function TQ(n, e, t) {
  const i = this, c = {
    tokenize: A,
    partial: !0
  };
  let a = 0, s = 0, r;
  return l;
  function l(k) {
    return d(k);
  }
  function d(k) {
    const N = i.events[i.events.length - 1];
    return a = N && N[1].type === "linePrefix" ? N[2].sliceSerialize(N[1], !0).length : 0, r = k, n.enter("codeFenced"), n.enter("codeFencedFence"), n.enter("codeFencedFenceSequence"), f(k);
  }
  function f(k) {
    return k === r ? (s++, n.consume(k), f) : s < 3 ? t(k) : (n.exit("codeFencedFenceSequence"), $r(k) ? Ti(n, h, "whitespace")(k) : h(k));
  }
  function h(k) {
    return k === null || ir(k) ? (n.exit("codeFencedFence"), i.interrupt ? e(k) : n.check(NO, b, T)(k)) : (n.enter("codeFencedFenceInfo"), n.enter("chunkString", {
      contentType: "string"
    }), p(k));
  }
  function p(k) {
    return k === null || ir(k) ? (n.exit("chunkString"), n.exit("codeFencedFenceInfo"), h(k)) : $r(k) ? (n.exit("chunkString"), n.exit("codeFencedFenceInfo"), Ti(n, g, "whitespace")(k)) : k === 96 && k === r ? t(k) : (n.consume(k), p);
  }
  function g(k) {
    return k === null || ir(k) ? h(k) : (n.enter("codeFencedFenceMeta"), n.enter("chunkString", {
      contentType: "string"
    }), _(k));
  }
  function _(k) {
    return k === null || ir(k) ? (n.exit("chunkString"), n.exit("codeFencedFenceMeta"), h(k)) : k === 96 && k === r ? t(k) : (n.consume(k), _);
  }
  function b(k) {
    return n.attempt(c, T, v)(k);
  }
  function v(k) {
    return n.enter("lineEnding"), n.consume(k), n.exit("lineEnding"), E;
  }
  function E(k) {
    return a > 0 && $r(k) ? Ti(n, C, "linePrefix", a + 1)(k) : C(k);
  }
  function C(k) {
    return k === null || ir(k) ? n.check(NO, b, T)(k) : (n.enter("codeFlowValue"), y(k));
  }
  function y(k) {
    return k === null || ir(k) ? (n.exit("codeFlowValue"), C(k)) : (n.consume(k), y);
  }
  function T(k) {
    return n.exit("codeFenced"), e(k);
  }
  function A(k, N, j) {
    let I = 0;
    return B;
    function B(ie) {
      return k.enter("lineEnding"), k.consume(ie), k.exit("lineEnding"), U;
    }
    function U(ie) {
      return k.enter("codeFencedFence"), $r(ie) ? Ti(k, H, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ie) : H(ie);
    }
    function H(ie) {
      return ie === r ? (k.enter("codeFencedFenceSequence"), Q(ie)) : j(ie);
    }
    function Q(ie) {
      return ie === r ? (I++, k.consume(ie), Q) : I >= s ? (k.exit("codeFencedFenceSequence"), $r(ie) ? Ti(k, Y, "whitespace")(ie) : Y(ie)) : j(ie);
    }
    function Y(ie) {
      return ie === null || ir(ie) ? (k.exit("codeFencedFence"), N(ie)) : j(ie);
    }
  }
}
function AQ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    return s === null ? t(s) : (n.enter("lineEnding"), n.consume(s), n.exit("lineEnding"), a);
  }
  function a(s) {
    return i.parser.lazy[i.now().line] ? t(s) : e(s);
  }
}
const Ow = {
  name: "codeIndented",
  tokenize: OQ
}, kQ = {
  tokenize: DQ,
  partial: !0
};
function OQ(n, e, t) {
  const i = this;
  return c;
  function c(d) {
    return n.enter("codeIndented"), Ti(n, a, "linePrefix", 5)(d);
  }
  function a(d) {
    const f = i.events[i.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? s(d) : t(d);
  }
  function s(d) {
    return d === null ? l(d) : ir(d) ? n.attempt(kQ, s, l)(d) : (n.enter("codeFlowValue"), r(d));
  }
  function r(d) {
    return d === null || ir(d) ? (n.exit("codeFlowValue"), s(d)) : (n.consume(d), r);
  }
  function l(d) {
    return n.exit("codeIndented"), e(d);
  }
}
function DQ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    return i.parser.lazy[i.now().line] ? t(s) : ir(s) ? (n.enter("lineEnding"), n.consume(s), n.exit("lineEnding"), c) : Ti(n, a, "linePrefix", 5)(s);
  }
  function a(s) {
    const r = i.events[i.events.length - 1];
    return r && r[1].type === "linePrefix" && r[2].sliceSerialize(r[1], !0).length >= 4 ? e(s) : ir(s) ? c(s) : t(s);
  }
}
const RQ = {
  name: "codeText",
  tokenize: LQ,
  resolve: NQ,
  previous: IQ
};
function NQ(n) {
  let e = n.length - 4, t = 3, i, c;
  if ((n[t][1].type === "lineEnding" || n[t][1].type === "space") && (n[e][1].type === "lineEnding" || n[e][1].type === "space")) {
    for (i = t; ++i < e; )
      if (n[i][1].type === "codeTextData") {
        n[t][1].type = "codeTextPadding", n[e][1].type = "codeTextPadding", t += 2, e -= 2;
        break;
      }
  }
  for (i = t - 1, e++; ++i <= e; )
    c === void 0 ? i !== e && n[i][1].type !== "lineEnding" && (c = i) : (i === e || n[i][1].type === "lineEnding") && (n[c][1].type = "codeTextData", i !== c + 2 && (n[c][1].end = n[i - 1][1].end, n.splice(c + 2, i - c - 2), e -= i - c - 2, i = c + 2), c = void 0);
  return n;
}
function IQ(n) {
  return n !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function LQ(n, e, t) {
  let i = 0, c, a;
  return s;
  function s(h) {
    return n.enter("codeText"), n.enter("codeTextSequence"), r(h);
  }
  function r(h) {
    return h === 96 ? (n.consume(h), i++, r) : (n.exit("codeTextSequence"), l(h));
  }
  function l(h) {
    return h === null ? t(h) : h === 32 ? (n.enter("space"), n.consume(h), n.exit("space"), l) : h === 96 ? (a = n.enter("codeTextSequence"), c = 0, f(h)) : ir(h) ? (n.enter("lineEnding"), n.consume(h), n.exit("lineEnding"), l) : (n.enter("codeTextData"), d(h));
  }
  function d(h) {
    return h === null || h === 32 || h === 96 || ir(h) ? (n.exit("codeTextData"), l(h)) : (n.consume(h), d);
  }
  function f(h) {
    return h === 96 ? (n.consume(h), c++, f) : c === i ? (n.exit("codeTextSequence"), n.exit("codeText"), e(h)) : (a.type = "codeTextData", d(h));
  }
}
class MQ {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(e) {
    this.left = e ? [...e] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(e) {
    if (e < 0 || e >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + e + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return e < this.left.length ? this.left[e] : this.right[this.right.length - e + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(e, t) {
    const i = t ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(e, i) : e > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - e + this.left.length).reverse() : this.left.slice(e).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(e, t, i) {
    const c = t || 0;
    this.setCursor(Math.trunc(e));
    const a = this.right.splice(this.right.length - c, Number.POSITIVE_INFINITY);
    return i && K_(this.left, i), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(e) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(e);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(e) {
    this.setCursor(Number.POSITIVE_INFINITY), K_(this.left, e);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(e) {
    this.setCursor(0), this.right.push(e);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(e) {
    this.setCursor(0), K_(this.right, e.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(e) {
    if (!(e === this.left.length || e > this.left.length && this.right.length === 0 || e < 0 && this.left.length === 0))
      if (e < this.left.length) {
        const t = this.left.splice(e, Number.POSITIVE_INFINITY);
        K_(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - e, Number.POSITIVE_INFINITY);
        K_(this.left, t.reverse());
      }
  }
}
function K_(n, e) {
  let t = 0;
  if (e.length < 1e4)
    n.push(...e);
  else
    for (; t < e.length; )
      n.push(...e.slice(t, t + 1e4)), t += 1e4;
}
function y9(n) {
  const e = {};
  let t = -1, i, c, a, s, r, l, d;
  const f = new MQ(n);
  for (; ++t < f.length; ) {
    for (; t in e; )
      t = e[t];
    if (i = f.get(t), t && i[1].type === "chunkFlow" && f.get(t - 1)[1].type === "listItemPrefix" && (l = i[1]._tokenizer.events, a = 0, a < l.length && l[a][1].type === "lineEndingBlank" && (a += 2), a < l.length && l[a][1].type === "content"))
      for (; ++a < l.length && l[a][1].type !== "content"; )
        l[a][1].type === "chunkText" && (l[a][1]._isInFirstContentOfListItem = !0, a++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(e, PQ(f, t)), t = e[t], d = !0);
    else if (i[1]._container) {
      for (a = t, c = void 0; a-- && (s = f.get(a), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (c && (f.get(c)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", c = a);
      c && (i[1].end = Object.assign({}, f.get(c)[1].start), r = f.slice(c, t), r.unshift(i), f.splice(c, t - c + 1, r));
    }
  }
  return vf(n, 0, Number.POSITIVE_INFINITY, f.slice(0)), !d;
}
function PQ(n, e) {
  const t = n.get(e)[1], i = n.get(e)[2];
  let c = e - 1;
  const a = [], s = t._tokenizer || i.parser[t.contentType](t.start), r = s.events, l = [], d = {};
  let f, h, p = -1, g = t, _ = 0, b = 0;
  const v = [b];
  for (; g; ) {
    for (; n.get(++c)[1] !== g; )
      ;
    a.push(c), g._tokenizer || (f = i.sliceStream(g), g.next || f.push(null), h && s.defineSkip(g.start), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(f), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), h = g, g = g.next;
  }
  for (g = t; ++p < r.length; )
    // Find a void token that includes a break.
    r[p][0] === "exit" && r[p - 1][0] === "enter" && r[p][1].type === r[p - 1][1].type && r[p][1].start.line !== r[p][1].end.line && (b = p + 1, v.push(b), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (s.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : v.pop(), p = v.length; p--; ) {
    const E = r.slice(v[p], v[p + 1]), C = a.pop();
    l.push([C, C + E.length - 1]), n.splice(C, 2, E);
  }
  for (l.reverse(), p = -1; ++p < l.length; )
    d[_ + l[p][0]] = _ + l[p][1], _ += l[p][1] - l[p][0] - 1;
  return d;
}
const jQ = {
  tokenize: UQ,
  resolve: FQ
}, BQ = {
  tokenize: HQ,
  partial: !0
};
function FQ(n) {
  return y9(n), n;
}
function UQ(n, e) {
  let t;
  return i;
  function i(r) {
    return n.enter("content"), t = n.enter("chunkContent", {
      contentType: "content"
    }), c(r);
  }
  function c(r) {
    return r === null ? a(r) : ir(r) ? n.check(BQ, s, a)(r) : (n.consume(r), c);
  }
  function a(r) {
    return n.exit("chunkContent"), n.exit("content"), e(r);
  }
  function s(r) {
    return n.consume(r), n.exit("chunkContent"), t.next = n.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, c;
  }
}
function HQ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    return n.exit("chunkContent"), n.enter("lineEnding"), n.consume(s), n.exit("lineEnding"), Ti(n, a, "linePrefix");
  }
  function a(s) {
    if (s === null || ir(s))
      return t(s);
    const r = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && r && r[1].type === "linePrefix" && r[2].sliceSerialize(r[1], !0).length >= 4 ? e(s) : n.interrupt(i.parser.constructs.flow, t, e)(s);
  }
}
function v9(n, e, t, i, c, a, s, r, l) {
  const d = l || Number.POSITIVE_INFINITY;
  let f = 0;
  return h;
  function h(E) {
    return E === 60 ? (n.enter(i), n.enter(c), n.enter(a), n.consume(E), n.exit(a), p) : E === null || E === 32 || E === 41 || vx(E) ? t(E) : (n.enter(i), n.enter(s), n.enter(r), n.enter("chunkString", {
      contentType: "string"
    }), b(E));
  }
  function p(E) {
    return E === 62 ? (n.enter(a), n.consume(E), n.exit(a), n.exit(c), n.exit(i), e) : (n.enter(r), n.enter("chunkString", {
      contentType: "string"
    }), g(E));
  }
  function g(E) {
    return E === 62 ? (n.exit("chunkString"), n.exit(r), p(E)) : E === null || E === 60 || ir(E) ? t(E) : (n.consume(E), E === 92 ? _ : g);
  }
  function _(E) {
    return E === 60 || E === 62 || E === 92 ? (n.consume(E), g) : g(E);
  }
  function b(E) {
    return !f && (E === null || E === 41 || Js(E)) ? (n.exit("chunkString"), n.exit(r), n.exit(s), n.exit(i), e(E)) : f < d && E === 40 ? (n.consume(E), f++, b) : E === 41 ? (n.consume(E), f--, b) : E === null || E === 32 || E === 40 || vx(E) ? t(E) : (n.consume(E), E === 92 ? v : b);
  }
  function v(E) {
    return E === 40 || E === 41 || E === 92 ? (n.consume(E), b) : b(E);
  }
}
function b9(n, e, t, i, c, a) {
  const s = this;
  let r = 0, l;
  return d;
  function d(g) {
    return n.enter(i), n.enter(c), n.consume(g), n.exit(c), n.enter(a), f;
  }
  function f(g) {
    return r > 999 || g === null || g === 91 || g === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !r && "_hiddenFootnoteSupport" in s.parser.constructs ? t(g) : g === 93 ? (n.exit(a), n.enter(c), n.consume(g), n.exit(c), n.exit(i), e) : ir(g) ? (n.enter("lineEnding"), n.consume(g), n.exit("lineEnding"), f) : (n.enter("chunkString", {
      contentType: "string"
    }), h(g));
  }
  function h(g) {
    return g === null || g === 91 || g === 93 || ir(g) || r++ > 999 ? (n.exit("chunkString"), f(g)) : (n.consume(g), l || (l = !$r(g)), g === 92 ? p : h);
  }
  function p(g) {
    return g === 91 || g === 92 || g === 93 ? (n.consume(g), r++, h) : h(g);
  }
}
function E9(n, e, t, i, c, a) {
  let s;
  return r;
  function r(p) {
    return p === 34 || p === 39 || p === 40 ? (n.enter(i), n.enter(c), n.consume(p), n.exit(c), s = p === 40 ? 41 : p, l) : t(p);
  }
  function l(p) {
    return p === s ? (n.enter(c), n.consume(p), n.exit(c), n.exit(i), e) : (n.enter(a), d(p));
  }
  function d(p) {
    return p === s ? (n.exit(a), l(s)) : p === null ? t(p) : ir(p) ? (n.enter("lineEnding"), n.consume(p), n.exit("lineEnding"), Ti(n, d, "linePrefix")) : (n.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === s || p === null || ir(p) ? (n.exit("chunkString"), d(p)) : (n.consume(p), p === 92 ? h : f);
  }
  function h(p) {
    return p === s || p === 92 ? (n.consume(p), f) : f(p);
  }
}
function v1(n, e) {
  let t;
  return i;
  function i(c) {
    return ir(c) ? (n.enter("lineEnding"), n.consume(c), n.exit("lineEnding"), t = !0, i) : $r(c) ? Ti(
      n,
      i,
      t ? "linePrefix" : "lineSuffix"
    )(c) : e(c);
  }
}
const zQ = {
  name: "definition",
  tokenize: qQ
}, VQ = {
  tokenize: GQ,
  partial: !0
};
function qQ(n, e, t) {
  const i = this;
  let c;
  return a;
  function a(g) {
    return n.enter("definition"), s(g);
  }
  function s(g) {
    return b9.call(
      i,
      n,
      r,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function r(g) {
    return c = r0(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), g === 58 ? (n.enter("definitionMarker"), n.consume(g), n.exit("definitionMarker"), l) : t(g);
  }
  function l(g) {
    return Js(g) ? v1(n, d)(g) : d(g);
  }
  function d(g) {
    return v9(
      n,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function f(g) {
    return n.attempt(VQ, h, h)(g);
  }
  function h(g) {
    return $r(g) ? Ti(n, p, "whitespace")(g) : p(g);
  }
  function p(g) {
    return g === null || ir(g) ? (n.exit("definition"), i.parser.defined.push(c), e(g)) : t(g);
  }
}
function GQ(n, e, t) {
  return i;
  function i(r) {
    return Js(r) ? v1(n, c)(r) : t(r);
  }
  function c(r) {
    return E9(n, a, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(r);
  }
  function a(r) {
    return $r(r) ? Ti(n, s, "whitespace")(r) : s(r);
  }
  function s(r) {
    return r === null || ir(r) ? e(r) : t(r);
  }
}
const WQ = {
  name: "hardBreakEscape",
  tokenize: $Q
};
function $Q(n, e, t) {
  return i;
  function i(a) {
    return n.enter("hardBreakEscape"), n.consume(a), c;
  }
  function c(a) {
    return ir(a) ? (n.exit("hardBreakEscape"), e(a)) : t(a);
  }
}
const YQ = {
  name: "headingAtx",
  tokenize: KQ,
  resolve: XQ
};
function XQ(n, e) {
  let t = n.length - 2, i = 3, c, a;
  return n[i][1].type === "whitespace" && (i += 2), t - 2 > i && n[t][1].type === "whitespace" && (t -= 2), n[t][1].type === "atxHeadingSequence" && (i === t - 1 || t - 4 > i && n[t - 2][1].type === "whitespace") && (t -= i + 1 === t ? 2 : 4), t > i && (c = {
    type: "atxHeadingText",
    start: n[i][1].start,
    end: n[t][1].end
  }, a = {
    type: "chunkText",
    start: n[i][1].start,
    end: n[t][1].end,
    contentType: "text"
  }, vf(n, i, t - i + 1, [["enter", c, e], ["enter", a, e], ["exit", a, e], ["exit", c, e]])), n;
}
function KQ(n, e, t) {
  let i = 0;
  return c;
  function c(f) {
    return n.enter("atxHeading"), a(f);
  }
  function a(f) {
    return n.enter("atxHeadingSequence"), s(f);
  }
  function s(f) {
    return f === 35 && i++ < 6 ? (n.consume(f), s) : f === null || Js(f) ? (n.exit("atxHeadingSequence"), r(f)) : t(f);
  }
  function r(f) {
    return f === 35 ? (n.enter("atxHeadingSequence"), l(f)) : f === null || ir(f) ? (n.exit("atxHeading"), e(f)) : $r(f) ? Ti(n, r, "whitespace")(f) : (n.enter("atxHeadingText"), d(f));
  }
  function l(f) {
    return f === 35 ? (n.consume(f), l) : (n.exit("atxHeadingSequence"), r(f));
  }
  function d(f) {
    return f === null || f === 35 || Js(f) ? (n.exit("atxHeadingText"), r(f)) : (n.consume(f), d);
  }
}
const QQ = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], LO = ["pre", "script", "style", "textarea"], ZQ = {
  name: "htmlFlow",
  tokenize: nZ,
  resolveTo: tZ,
  concrete: !0
}, JQ = {
  tokenize: iZ,
  partial: !0
}, eZ = {
  tokenize: rZ,
  partial: !0
};
function tZ(n) {
  let e = n.length;
  for (; e-- && !(n[e][0] === "enter" && n[e][1].type === "htmlFlow"); )
    ;
  return e > 1 && n[e - 2][1].type === "linePrefix" && (n[e][1].start = n[e - 2][1].start, n[e + 1][1].start = n[e - 2][1].start, n.splice(e - 2, 2)), n;
}
function nZ(n, e, t) {
  const i = this;
  let c, a, s, r, l;
  return d;
  function d(L) {
    return f(L);
  }
  function f(L) {
    return n.enter("htmlFlow"), n.enter("htmlFlowData"), n.consume(L), h;
  }
  function h(L) {
    return L === 33 ? (n.consume(L), p) : L === 47 ? (n.consume(L), a = !0, b) : L === 63 ? (n.consume(L), c = 3, i.interrupt ? e : K) : ld(L) ? (n.consume(L), s = String.fromCharCode(L), v) : t(L);
  }
  function p(L) {
    return L === 45 ? (n.consume(L), c = 2, g) : L === 91 ? (n.consume(L), c = 5, r = 0, _) : ld(L) ? (n.consume(L), c = 4, i.interrupt ? e : K) : t(L);
  }
  function g(L) {
    return L === 45 ? (n.consume(L), i.interrupt ? e : K) : t(L);
  }
  function _(L) {
    const z = "CDATA[";
    return L === z.charCodeAt(r++) ? (n.consume(L), r === z.length ? i.interrupt ? e : H : _) : t(L);
  }
  function b(L) {
    return ld(L) ? (n.consume(L), s = String.fromCharCode(L), v) : t(L);
  }
  function v(L) {
    if (L === null || L === 47 || L === 62 || Js(L)) {
      const z = L === 47, ee = s.toLowerCase();
      return !z && !a && LO.includes(ee) ? (c = 1, i.interrupt ? e(L) : H(L)) : QQ.includes(s.toLowerCase()) ? (c = 6, z ? (n.consume(L), E) : i.interrupt ? e(L) : H(L)) : (c = 7, i.interrupt && !i.parser.lazy[i.now().line] ? t(L) : a ? C(L) : y(L));
    }
    return L === 45 || wl(L) ? (n.consume(L), s += String.fromCharCode(L), v) : t(L);
  }
  function E(L) {
    return L === 62 ? (n.consume(L), i.interrupt ? e : H) : t(L);
  }
  function C(L) {
    return $r(L) ? (n.consume(L), C) : B(L);
  }
  function y(L) {
    return L === 47 ? (n.consume(L), B) : L === 58 || L === 95 || ld(L) ? (n.consume(L), T) : $r(L) ? (n.consume(L), y) : B(L);
  }
  function T(L) {
    return L === 45 || L === 46 || L === 58 || L === 95 || wl(L) ? (n.consume(L), T) : A(L);
  }
  function A(L) {
    return L === 61 ? (n.consume(L), k) : $r(L) ? (n.consume(L), A) : y(L);
  }
  function k(L) {
    return L === null || L === 60 || L === 61 || L === 62 || L === 96 ? t(L) : L === 34 || L === 39 ? (n.consume(L), l = L, N) : $r(L) ? (n.consume(L), k) : j(L);
  }
  function N(L) {
    return L === l ? (n.consume(L), l = null, I) : L === null || ir(L) ? t(L) : (n.consume(L), N);
  }
  function j(L) {
    return L === null || L === 34 || L === 39 || L === 47 || L === 60 || L === 61 || L === 62 || L === 96 || Js(L) ? A(L) : (n.consume(L), j);
  }
  function I(L) {
    return L === 47 || L === 62 || $r(L) ? y(L) : t(L);
  }
  function B(L) {
    return L === 62 ? (n.consume(L), U) : t(L);
  }
  function U(L) {
    return L === null || ir(L) ? H(L) : $r(L) ? (n.consume(L), U) : t(L);
  }
  function H(L) {
    return L === 45 && c === 2 ? (n.consume(L), ce) : L === 60 && c === 1 ? (n.consume(L), $) : L === 62 && c === 4 ? (n.consume(L), ne) : L === 63 && c === 3 ? (n.consume(L), K) : L === 93 && c === 5 ? (n.consume(L), V) : ir(L) && (c === 6 || c === 7) ? (n.exit("htmlFlowData"), n.check(JQ, J, Q)(L)) : L === null || ir(L) ? (n.exit("htmlFlowData"), Q(L)) : (n.consume(L), H);
  }
  function Q(L) {
    return n.check(eZ, Y, J)(L);
  }
  function Y(L) {
    return n.enter("lineEnding"), n.consume(L), n.exit("lineEnding"), ie;
  }
  function ie(L) {
    return L === null || ir(L) ? Q(L) : (n.enter("htmlFlowData"), H(L));
  }
  function ce(L) {
    return L === 45 ? (n.consume(L), K) : H(L);
  }
  function $(L) {
    return L === 47 ? (n.consume(L), s = "", te) : H(L);
  }
  function te(L) {
    if (L === 62) {
      const z = s.toLowerCase();
      return LO.includes(z) ? (n.consume(L), ne) : H(L);
    }
    return ld(L) && s.length < 8 ? (n.consume(L), s += String.fromCharCode(L), te) : H(L);
  }
  function V(L) {
    return L === 93 ? (n.consume(L), K) : H(L);
  }
  function K(L) {
    return L === 62 ? (n.consume(L), ne) : L === 45 && c === 2 ? (n.consume(L), K) : H(L);
  }
  function ne(L) {
    return L === null || ir(L) ? (n.exit("htmlFlowData"), J(L)) : (n.consume(L), ne);
  }
  function J(L) {
    return n.exit("htmlFlow"), e(L);
  }
}
function rZ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    return ir(s) ? (n.enter("lineEnding"), n.consume(s), n.exit("lineEnding"), a) : t(s);
  }
  function a(s) {
    return i.parser.lazy[i.now().line] ? t(s) : e(s);
  }
}
function iZ(n, e, t) {
  return i;
  function i(c) {
    return n.enter("lineEnding"), n.consume(c), n.exit("lineEnding"), n.attempt(H2, e, t);
  }
}
const oZ = {
  name: "htmlText",
  tokenize: aZ
};
function aZ(n, e, t) {
  const i = this;
  let c, a, s;
  return r;
  function r(K) {
    return n.enter("htmlText"), n.enter("htmlTextData"), n.consume(K), l;
  }
  function l(K) {
    return K === 33 ? (n.consume(K), d) : K === 47 ? (n.consume(K), A) : K === 63 ? (n.consume(K), y) : ld(K) ? (n.consume(K), j) : t(K);
  }
  function d(K) {
    return K === 45 ? (n.consume(K), f) : K === 91 ? (n.consume(K), a = 0, _) : ld(K) ? (n.consume(K), C) : t(K);
  }
  function f(K) {
    return K === 45 ? (n.consume(K), g) : t(K);
  }
  function h(K) {
    return K === null ? t(K) : K === 45 ? (n.consume(K), p) : ir(K) ? (s = h, $(K)) : (n.consume(K), h);
  }
  function p(K) {
    return K === 45 ? (n.consume(K), g) : h(K);
  }
  function g(K) {
    return K === 62 ? ce(K) : K === 45 ? p(K) : h(K);
  }
  function _(K) {
    const ne = "CDATA[";
    return K === ne.charCodeAt(a++) ? (n.consume(K), a === ne.length ? b : _) : t(K);
  }
  function b(K) {
    return K === null ? t(K) : K === 93 ? (n.consume(K), v) : ir(K) ? (s = b, $(K)) : (n.consume(K), b);
  }
  function v(K) {
    return K === 93 ? (n.consume(K), E) : b(K);
  }
  function E(K) {
    return K === 62 ? ce(K) : K === 93 ? (n.consume(K), E) : b(K);
  }
  function C(K) {
    return K === null || K === 62 ? ce(K) : ir(K) ? (s = C, $(K)) : (n.consume(K), C);
  }
  function y(K) {
    return K === null ? t(K) : K === 63 ? (n.consume(K), T) : ir(K) ? (s = y, $(K)) : (n.consume(K), y);
  }
  function T(K) {
    return K === 62 ? ce(K) : y(K);
  }
  function A(K) {
    return ld(K) ? (n.consume(K), k) : t(K);
  }
  function k(K) {
    return K === 45 || wl(K) ? (n.consume(K), k) : N(K);
  }
  function N(K) {
    return ir(K) ? (s = N, $(K)) : $r(K) ? (n.consume(K), N) : ce(K);
  }
  function j(K) {
    return K === 45 || wl(K) ? (n.consume(K), j) : K === 47 || K === 62 || Js(K) ? I(K) : t(K);
  }
  function I(K) {
    return K === 47 ? (n.consume(K), ce) : K === 58 || K === 95 || ld(K) ? (n.consume(K), B) : ir(K) ? (s = I, $(K)) : $r(K) ? (n.consume(K), I) : ce(K);
  }
  function B(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || wl(K) ? (n.consume(K), B) : U(K);
  }
  function U(K) {
    return K === 61 ? (n.consume(K), H) : ir(K) ? (s = U, $(K)) : $r(K) ? (n.consume(K), U) : I(K);
  }
  function H(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? t(K) : K === 34 || K === 39 ? (n.consume(K), c = K, Q) : ir(K) ? (s = H, $(K)) : $r(K) ? (n.consume(K), H) : (n.consume(K), Y);
  }
  function Q(K) {
    return K === c ? (n.consume(K), c = void 0, ie) : K === null ? t(K) : ir(K) ? (s = Q, $(K)) : (n.consume(K), Q);
  }
  function Y(K) {
    return K === null || K === 34 || K === 39 || K === 60 || K === 61 || K === 96 ? t(K) : K === 47 || K === 62 || Js(K) ? I(K) : (n.consume(K), Y);
  }
  function ie(K) {
    return K === 47 || K === 62 || Js(K) ? I(K) : t(K);
  }
  function ce(K) {
    return K === 62 ? (n.consume(K), n.exit("htmlTextData"), n.exit("htmlText"), e) : t(K);
  }
  function $(K) {
    return n.exit("htmlTextData"), n.enter("lineEnding"), n.consume(K), n.exit("lineEnding"), te;
  }
  function te(K) {
    return $r(K) ? Ti(n, V, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(K) : V(K);
  }
  function V(K) {
    return n.enter("htmlTextData"), s(K);
  }
}
const OT = {
  name: "labelEnd",
  tokenize: fZ,
  resolveTo: dZ,
  resolveAll: cZ
}, sZ = {
  tokenize: hZ
}, lZ = {
  tokenize: pZ
}, uZ = {
  tokenize: mZ
};
function cZ(n) {
  let e = -1;
  for (; ++e < n.length; ) {
    const t = n[e][1];
    (t.type === "labelImage" || t.type === "labelLink" || t.type === "labelEnd") && (n.splice(e + 1, t.type === "labelImage" ? 4 : 2), t.type = "data", e++);
  }
  return n;
}
function dZ(n, e) {
  let t = n.length, i = 0, c, a, s, r;
  for (; t--; )
    if (c = n[t][1], a) {
      if (c.type === "link" || c.type === "labelLink" && c._inactive)
        break;
      n[t][0] === "enter" && c.type === "labelLink" && (c._inactive = !0);
    } else if (s) {
      if (n[t][0] === "enter" && (c.type === "labelImage" || c.type === "labelLink") && !c._balanced && (a = t, c.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else c.type === "labelEnd" && (s = t);
  const l = {
    type: n[a][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, n[a][1].start),
    end: Object.assign({}, n[n.length - 1][1].end)
  }, d = {
    type: "label",
    start: Object.assign({}, n[a][1].start),
    end: Object.assign({}, n[s][1].end)
  }, f = {
    type: "labelText",
    start: Object.assign({}, n[a + i + 2][1].end),
    end: Object.assign({}, n[s - 2][1].start)
  };
  return r = [["enter", l, e], ["enter", d, e]], r = ou(r, n.slice(a + 1, a + i + 3)), r = ou(r, [["enter", f, e]]), r = ou(r, kT(e.parser.constructs.insideSpan.null, n.slice(a + i + 4, s - 3), e)), r = ou(r, [["exit", f, e], n[s - 2], n[s - 1], ["exit", d, e]]), r = ou(r, n.slice(s + 1)), r = ou(r, [["exit", l, e]]), vf(n, a, n.length, r), n;
}
function fZ(n, e, t) {
  const i = this;
  let c = i.events.length, a, s;
  for (; c--; )
    if ((i.events[c][1].type === "labelImage" || i.events[c][1].type === "labelLink") && !i.events[c][1]._balanced) {
      a = i.events[c][1];
      break;
    }
  return r;
  function r(p) {
    return a ? a._inactive ? h(p) : (s = i.parser.defined.includes(r0(i.sliceSerialize({
      start: a.end,
      end: i.now()
    }))), n.enter("labelEnd"), n.enter("labelMarker"), n.consume(p), n.exit("labelMarker"), n.exit("labelEnd"), l) : t(p);
  }
  function l(p) {
    return p === 40 ? n.attempt(sZ, f, s ? f : h)(p) : p === 91 ? n.attempt(lZ, f, s ? d : h)(p) : s ? f(p) : h(p);
  }
  function d(p) {
    return n.attempt(uZ, f, h)(p);
  }
  function f(p) {
    return e(p);
  }
  function h(p) {
    return a._balanced = !0, t(p);
  }
}
function hZ(n, e, t) {
  return i;
  function i(h) {
    return n.enter("resource"), n.enter("resourceMarker"), n.consume(h), n.exit("resourceMarker"), c;
  }
  function c(h) {
    return Js(h) ? v1(n, a)(h) : a(h);
  }
  function a(h) {
    return h === 41 ? f(h) : v9(n, s, r, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function s(h) {
    return Js(h) ? v1(n, l)(h) : f(h);
  }
  function r(h) {
    return t(h);
  }
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? E9(n, d, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : f(h);
  }
  function d(h) {
    return Js(h) ? v1(n, f)(h) : f(h);
  }
  function f(h) {
    return h === 41 ? (n.enter("resourceMarker"), n.consume(h), n.exit("resourceMarker"), n.exit("resource"), e) : t(h);
  }
}
function pZ(n, e, t) {
  const i = this;
  return c;
  function c(r) {
    return b9.call(i, n, a, s, "reference", "referenceMarker", "referenceString")(r);
  }
  function a(r) {
    return i.parser.defined.includes(r0(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? e(r) : t(r);
  }
  function s(r) {
    return t(r);
  }
}
function mZ(n, e, t) {
  return i;
  function i(a) {
    return n.enter("reference"), n.enter("referenceMarker"), n.consume(a), n.exit("referenceMarker"), c;
  }
  function c(a) {
    return a === 93 ? (n.enter("referenceMarker"), n.consume(a), n.exit("referenceMarker"), n.exit("reference"), e) : t(a);
  }
}
const gZ = {
  name: "labelStartImage",
  tokenize: _Z,
  resolveAll: OT.resolveAll
};
function _Z(n, e, t) {
  const i = this;
  return c;
  function c(r) {
    return n.enter("labelImage"), n.enter("labelImageMarker"), n.consume(r), n.exit("labelImageMarker"), a;
  }
  function a(r) {
    return r === 91 ? (n.enter("labelMarker"), n.consume(r), n.exit("labelMarker"), n.exit("labelImage"), s) : t(r);
  }
  function s(r) {
    return r === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(r) : e(r);
  }
}
const yZ = {
  name: "labelStartLink",
  tokenize: vZ,
  resolveAll: OT.resolveAll
};
function vZ(n, e, t) {
  const i = this;
  return c;
  function c(s) {
    return n.enter("labelLink"), n.enter("labelMarker"), n.consume(s), n.exit("labelMarker"), n.exit("labelLink"), a;
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(s) : e(s);
  }
}
const Dw = {
  name: "lineEnding",
  tokenize: bZ
};
function bZ(n, e) {
  return t;
  function t(i) {
    return n.enter("lineEnding"), n.consume(i), n.exit("lineEnding"), Ti(n, e, "linePrefix");
  }
}
const Fb = {
  name: "thematicBreak",
  tokenize: EZ
};
function EZ(n, e, t) {
  let i = 0, c;
  return a;
  function a(d) {
    return n.enter("thematicBreak"), s(d);
  }
  function s(d) {
    return c = d, r(d);
  }
  function r(d) {
    return d === c ? (n.enter("thematicBreakSequence"), l(d)) : i >= 3 && (d === null || ir(d)) ? (n.exit("thematicBreak"), e(d)) : t(d);
  }
  function l(d) {
    return d === c ? (n.consume(d), i++, l) : (n.exit("thematicBreakSequence"), $r(d) ? Ti(n, r, "whitespace")(d) : r(d));
  }
}
const $s = {
  name: "list",
  tokenize: wZ,
  continuation: {
    tokenize: xZ
  },
  exit: AZ
}, SZ = {
  tokenize: kZ,
  partial: !0
}, CZ = {
  tokenize: TZ,
  partial: !0
};
function wZ(n, e, t) {
  const i = this, c = i.events[i.events.length - 1];
  let a = c && c[1].type === "linePrefix" ? c[2].sliceSerialize(c[1], !0).length : 0, s = 0;
  return r;
  function r(g) {
    const _ = i.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (_ === "listUnordered" ? !i.containerState.marker || g === i.containerState.marker : bx(g)) {
      if (i.containerState.type || (i.containerState.type = _, n.enter(_, {
        _container: !0
      })), _ === "listUnordered")
        return n.enter("listItemPrefix"), g === 42 || g === 45 ? n.check(Fb, t, d)(g) : d(g);
      if (!i.interrupt || g === 49)
        return n.enter("listItemPrefix"), n.enter("listItemValue"), l(g);
    }
    return t(g);
  }
  function l(g) {
    return bx(g) && ++s < 10 ? (n.consume(g), l) : (!i.interrupt || s < 2) && (i.containerState.marker ? g === i.containerState.marker : g === 41 || g === 46) ? (n.exit("listItemValue"), d(g)) : t(g);
  }
  function d(g) {
    return n.enter("listItemMarker"), n.consume(g), n.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || g, n.check(
      H2,
      // Can’t be empty when interrupting.
      i.interrupt ? t : f,
      n.attempt(SZ, p, h)
    );
  }
  function f(g) {
    return i.containerState.initialBlankLine = !0, a++, p(g);
  }
  function h(g) {
    return $r(g) ? (n.enter("listItemPrefixWhitespace"), n.consume(g), n.exit("listItemPrefixWhitespace"), p) : t(g);
  }
  function p(g) {
    return i.containerState.size = a + i.sliceSerialize(n.exit("listItemPrefix"), !0).length, e(g);
  }
}
function xZ(n, e, t) {
  const i = this;
  return i.containerState._closeFlow = void 0, n.check(H2, c, a);
  function c(r) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Ti(n, e, "listItemIndent", i.containerState.size + 1)(r);
  }
  function a(r) {
    return i.containerState.furtherBlankLines || !$r(r) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(r)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, n.attempt(CZ, e, s)(r));
  }
  function s(r) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Ti(n, n.attempt($s, e, t), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(r);
  }
}
function TZ(n, e, t) {
  const i = this;
  return Ti(n, c, "listItemIndent", i.containerState.size + 1);
  function c(a) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? e(a) : t(a);
  }
}
function AZ(n) {
  n.exit(this.containerState.type);
}
function kZ(n, e, t) {
  const i = this;
  return Ti(n, c, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function c(a) {
    const s = i.events[i.events.length - 1];
    return !$r(a) && s && s[1].type === "listItemPrefixWhitespace" ? e(a) : t(a);
  }
}
const MO = {
  name: "setextUnderline",
  tokenize: DZ,
  resolveTo: OZ
};
function OZ(n, e) {
  let t = n.length, i, c, a;
  for (; t--; )
    if (n[t][0] === "enter") {
      if (n[t][1].type === "content") {
        i = t;
        break;
      }
      n[t][1].type === "paragraph" && (c = t);
    } else
      n[t][1].type === "content" && n.splice(t, 1), !a && n[t][1].type === "definition" && (a = t);
  const s = {
    type: "setextHeading",
    start: Object.assign({}, n[c][1].start),
    end: Object.assign({}, n[n.length - 1][1].end)
  };
  return n[c][1].type = "setextHeadingText", a ? (n.splice(c, 0, ["enter", s, e]), n.splice(a + 1, 0, ["exit", n[i][1], e]), n[i][1].end = Object.assign({}, n[a][1].end)) : n[i][1] = s, n.push(["exit", s, e]), n;
}
function DZ(n, e, t) {
  const i = this;
  let c;
  return a;
  function a(d) {
    let f = i.events.length, h;
    for (; f--; )
      if (i.events[f][1].type !== "lineEnding" && i.events[f][1].type !== "linePrefix" && i.events[f][1].type !== "content") {
        h = i.events[f][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || h) ? (n.enter("setextHeadingLine"), c = d, s(d)) : t(d);
  }
  function s(d) {
    return n.enter("setextHeadingLineSequence"), r(d);
  }
  function r(d) {
    return d === c ? (n.consume(d), r) : (n.exit("setextHeadingLineSequence"), $r(d) ? Ti(n, l, "lineSuffix")(d) : l(d));
  }
  function l(d) {
    return d === null || ir(d) ? (n.exit("setextHeadingLine"), e(d)) : t(d);
  }
}
const RZ = {
  tokenize: NZ
};
function NZ(n) {
  const e = this, t = n.attempt(
    // Try to parse a blank line.
    H2,
    i,
    // Try to parse initial flow (essentially, only code).
    n.attempt(
      this.parser.constructs.flowInitial,
      c,
      Ti(
        n,
        n.attempt(
          this.parser.constructs.flow,
          c,
          n.attempt(jQ, c)
        ),
        "linePrefix"
      )
    )
  );
  return t;
  function i(a) {
    if (a === null) {
      n.consume(a);
      return;
    }
    return n.enter("lineEndingBlank"), n.consume(a), n.exit("lineEndingBlank"), e.currentConstruct = void 0, t;
  }
  function c(a) {
    if (a === null) {
      n.consume(a);
      return;
    }
    return n.enter("lineEnding"), n.consume(a), n.exit("lineEnding"), e.currentConstruct = void 0, t;
  }
}
const IZ = {
  resolveAll: C9()
}, LZ = S9("string"), MZ = S9("text");
function S9(n) {
  return {
    tokenize: e,
    resolveAll: C9(
      n === "text" ? PZ : void 0
    )
  };
  function e(t) {
    const i = this, c = this.parser.constructs[n], a = t.attempt(c, s, r);
    return s;
    function s(f) {
      return d(f) ? a(f) : r(f);
    }
    function r(f) {
      if (f === null) {
        t.consume(f);
        return;
      }
      return t.enter("data"), t.consume(f), l;
    }
    function l(f) {
      return d(f) ? (t.exit("data"), a(f)) : (t.consume(f), l);
    }
    function d(f) {
      if (f === null)
        return !0;
      const h = c[f];
      let p = -1;
      if (h)
        for (; ++p < h.length; ) {
          const g = h[p];
          if (!g.previous || g.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function C9(n) {
  return e;
  function e(t, i) {
    let c = -1, a;
    for (; ++c <= t.length; )
      a === void 0 ? t[c] && t[c][1].type === "data" && (a = c, c++) : (!t[c] || t[c][1].type !== "data") && (c !== a + 2 && (t[a][1].end = t[c - 1][1].end, t.splice(a + 2, c - a - 2), c = a + 2), a = void 0);
    return n ? n(t, i) : t;
  }
}
function PZ(n, e) {
  let t = 0;
  for (; ++t <= n.length; )
    if ((t === n.length || n[t][1].type === "lineEnding") && n[t - 1][1].type === "data") {
      const i = n[t - 1][1], c = e.sliceStream(i);
      let a = c.length, s = -1, r = 0, l;
      for (; a--; ) {
        const d = c[a];
        if (typeof d == "string") {
          for (s = d.length; d.charCodeAt(s - 1) === 32; )
            r++, s--;
          if (s) break;
          s = -1;
        } else if (d === -2)
          l = !0, r++;
        else if (d !== -1) {
          a++;
          break;
        }
      }
      if (r) {
        const d = {
          type: t === n.length || l || r < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: i.end.line,
            column: i.end.column - r,
            offset: i.end.offset - r,
            _index: i.start._index + a,
            _bufferIndex: a ? s : i.start._bufferIndex + s
          },
          end: Object.assign({}, i.end)
        };
        i.end = Object.assign({}, d.start), i.start.offset === i.end.offset ? Object.assign(i, d) : (n.splice(
          t,
          0,
          ["enter", d, e],
          ["exit", d, e]
        ), t += 2);
      }
      t++;
    }
  return n;
}
function jZ(n, e, t) {
  let i = Object.assign(
    t ? Object.assign({}, t) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const c = {}, a = [];
  let s = [], r = [];
  const l = {
    consume: C,
    enter: y,
    exit: T,
    attempt: N(A),
    check: N(k),
    interrupt: N(k, {
      interrupt: !0
    })
  }, d = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: n,
    sliceStream: g,
    sliceSerialize: p,
    now: _,
    defineSkip: b,
    write: h
  };
  let f = e.tokenize.call(d, l);
  return e.resolveAll && a.push(e), d;
  function h(U) {
    return s = ou(s, U), v(), s[s.length - 1] !== null ? [] : (j(e, 0), d.events = kT(a, d.events, d), d.events);
  }
  function p(U, H) {
    return FZ(g(U), H);
  }
  function g(U) {
    return BZ(s, U);
  }
  function _() {
    const { line: U, column: H, offset: Q, _index: Y, _bufferIndex: ie } = i;
    return {
      line: U,
      column: H,
      offset: Q,
      _index: Y,
      _bufferIndex: ie
    };
  }
  function b(U) {
    c[U.line] = U.column, B();
  }
  function v() {
    let U;
    for (; i._index < s.length; ) {
      const H = s[i._index];
      if (typeof H == "string")
        for (U = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === U && i._bufferIndex < H.length; )
          E(H.charCodeAt(i._bufferIndex));
      else
        E(H);
    }
  }
  function E(U) {
    f = f(U);
  }
  function C(U) {
    ir(U) ? (i.line++, i.column = 1, i.offset += U === -3 ? 2 : 1, B()) : U !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === s[i._index].length && (i._bufferIndex = -1, i._index++)), d.previous = U;
  }
  function y(U, H) {
    const Q = H || {};
    return Q.type = U, Q.start = _(), d.events.push(["enter", Q, d]), r.push(Q), Q;
  }
  function T(U) {
    const H = r.pop();
    return H.end = _(), d.events.push(["exit", H, d]), H;
  }
  function A(U, H) {
    j(U, H.from);
  }
  function k(U, H) {
    H.restore();
  }
  function N(U, H) {
    return Q;
    function Q(Y, ie, ce) {
      let $, te, V, K;
      return Array.isArray(Y) ? J(Y) : "tokenize" in Y ? (
        // @ts-expect-error Looks like a construct.
        J([Y])
      ) : ne(Y);
      function ne(q) {
        return X;
        function X(oe) {
          const ae = oe !== null && q[oe], _e = oe !== null && q.null, ve = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ae) ? ae : ae ? [ae] : [],
            ...Array.isArray(_e) ? _e : _e ? [_e] : []
          ];
          return J(ve)(oe);
        }
      }
      function J(q) {
        return $ = q, te = 0, q.length === 0 ? ce : L(q[te]);
      }
      function L(q) {
        return X;
        function X(oe) {
          return K = I(), V = q, q.partial || (d.currentConstruct = q), q.name && d.parser.constructs.disable.null.includes(q.name) ? ee() : q.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            H ? Object.assign(Object.create(d), H) : d,
            l,
            z,
            ee
          )(oe);
        }
      }
      function z(q) {
        return U(V, K), ie;
      }
      function ee(q) {
        return K.restore(), ++te < $.length ? L($[te]) : ce;
      }
    }
  }
  function j(U, H) {
    U.resolveAll && !a.includes(U) && a.push(U), U.resolve && vf(
      d.events,
      H,
      d.events.length - H,
      U.resolve(d.events.slice(H), d)
    ), U.resolveTo && (d.events = U.resolveTo(d.events, d));
  }
  function I() {
    const U = _(), H = d.previous, Q = d.currentConstruct, Y = d.events.length, ie = Array.from(r);
    return {
      restore: ce,
      from: Y
    };
    function ce() {
      i = U, d.previous = H, d.currentConstruct = Q, d.events.length = Y, r = ie, B();
    }
  }
  function B() {
    i.line in c && i.column < 2 && (i.column = c[i.line], i.offset += c[i.line] - 1);
  }
}
function BZ(n, e) {
  const t = e.start._index, i = e.start._bufferIndex, c = e.end._index, a = e.end._bufferIndex;
  let s;
  if (t === c)
    s = [n[t].slice(i, a)];
  else {
    if (s = n.slice(t, c), i > -1) {
      const r = s[0];
      typeof r == "string" ? s[0] = r.slice(i) : s.shift();
    }
    a > 0 && s.push(n[c].slice(0, a));
  }
  return s;
}
function FZ(n, e) {
  let t = -1;
  const i = [];
  let c;
  for (; ++t < n.length; ) {
    const a = n[t];
    let s;
    if (typeof a == "string")
      s = a;
    else
      switch (a) {
        case -5: {
          s = "\r";
          break;
        }
        case -4: {
          s = `
`;
          break;
        }
        case -3: {
          s = `\r
`;
          break;
        }
        case -2: {
          s = e ? " " : "	";
          break;
        }
        case -1: {
          if (!e && c) continue;
          s = " ";
          break;
        }
        default:
          s = String.fromCharCode(a);
      }
    c = a === -2, i.push(s);
  }
  return i.join("");
}
const UZ = {
  42: $s,
  43: $s,
  45: $s,
  48: $s,
  49: $s,
  50: $s,
  51: $s,
  52: $s,
  53: $s,
  54: $s,
  55: $s,
  56: $s,
  57: $s,
  62: m9
}, HZ = {
  91: zQ
}, zZ = {
  [-2]: Ow,
  [-1]: Ow,
  32: Ow
}, VZ = {
  35: YQ,
  42: Fb,
  45: [MO, Fb],
  60: ZQ,
  61: MO,
  95: Fb,
  96: IO,
  126: IO
}, qZ = {
  38: _9,
  92: g9
}, GZ = {
  [-5]: Dw,
  [-4]: Dw,
  [-3]: Dw,
  33: gZ,
  38: _9,
  42: Ex,
  60: [yQ, oZ],
  91: yZ,
  92: [WQ, g9],
  93: OT,
  95: Ex,
  96: RQ
}, WZ = {
  null: [Ex, IZ]
}, $Z = {
  null: [42, 95]
}, YZ = {
  null: []
}, XZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: $Z,
  contentInitial: HZ,
  disable: YZ,
  document: UZ,
  flow: VZ,
  flowInitial: zZ,
  insideSpan: WZ,
  string: qZ,
  text: GZ
}, Symbol.toStringTag, { value: "Module" }));
function KZ(n) {
  const t = (
    /** @type {FullNormalizedExtension} */
    rQ([XZ, ...(n || {}).extensions || []])
  ), i = {
    defined: [],
    lazy: {},
    constructs: t,
    content: c(dQ),
    document: c(hQ),
    flow: c(RZ),
    string: c(LZ),
    text: c(MZ)
  };
  return i;
  function c(a) {
    return s;
    function s(r) {
      return jZ(i, a, r);
    }
  }
}
function QZ(n) {
  for (; !y9(n); )
    ;
  return n;
}
const PO = /[\0\t\n\r]/g;
function ZZ() {
  let n = 1, e = "", t = !0, i;
  return c;
  function c(a, s, r) {
    const l = [];
    let d, f, h, p, g;
    for (a = e + (typeof a == "string" ? a.toString() : new TextDecoder(s || void 0).decode(a)), h = 0, e = "", t && (a.charCodeAt(0) === 65279 && h++, t = void 0); h < a.length; ) {
      if (PO.lastIndex = h, d = PO.exec(a), p = d && d.index !== void 0 ? d.index : a.length, g = a.charCodeAt(p), !d) {
        e = a.slice(h);
        break;
      }
      if (g === 10 && h === p && i)
        l.push(-3), i = void 0;
      else
        switch (i && (l.push(-5), i = void 0), h < p && (l.push(a.slice(h, p)), n += p - h), g) {
          case 0: {
            l.push(65533), n++;
            break;
          }
          case 9: {
            for (f = Math.ceil(n / 4) * 4, l.push(-2); n++ < f; ) l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), n = 1;
            break;
          }
          default:
            i = !0, n = 1;
        }
      h = p + 1;
    }
    return r && (i && l.push(-5), e && l.push(e), l.push(null)), l;
  }
}
const JZ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function eJ(n) {
  return n.replace(JZ, tJ);
}
function tJ(n, e, t) {
  if (e)
    return e;
  if (t.charCodeAt(0) === 35) {
    const c = t.charCodeAt(1), a = c === 120 || c === 88;
    return p9(t.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return AT(t) || n;
}
const w9 = {}.hasOwnProperty;
function nJ(n, e, t) {
  return typeof e != "string" && (t = e, e = void 0), rJ(t)(QZ(KZ(t).document().write(ZZ()(n, e, !0))));
}
function rJ(n) {
  const e = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Ze),
      autolinkProtocol: I,
      autolinkEmail: I,
      atxHeading: a(Ie),
      blockQuote: a(_e),
      characterEscape: I,
      characterReference: I,
      codeFenced: a(ve),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: a(ve, s),
      codeText: a(Ee, s),
      codeTextData: I,
      data: I,
      codeFlowValue: I,
      definition: a(we),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: a(ze),
      hardBreakEscape: a(je),
      hardBreakTrailing: a(je),
      htmlFlow: a(qe, s),
      htmlFlowData: I,
      htmlText: a(qe, s),
      htmlTextData: I,
      image: a(Ge),
      label: s,
      link: a(Ze),
      listItem: a(Qe),
      listItemValue: p,
      listOrdered: a(tt, h),
      listUnordered: a(tt),
      paragraph: a(ke),
      reference: L,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: a(Ie),
      strong: a(pe),
      thematicBreak: a(he)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: A,
      autolink: l(),
      autolinkEmail: ae,
      autolinkProtocol: oe,
      blockQuote: l(),
      characterEscapeValue: B,
      characterReferenceMarkerHexadecimal: ee,
      characterReferenceMarkerNumeric: ee,
      characterReferenceValue: q,
      characterReference: X,
      codeFenced: l(v),
      codeFencedFence: b,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: _,
      codeFlowValue: B,
      codeIndented: l(E),
      codeText: l(ie),
      codeTextData: B,
      data: B,
      definition: l(),
      definitionDestinationString: T,
      definitionLabelString: C,
      definitionTitleString: y,
      emphasis: l(),
      hardBreakEscape: l(H),
      hardBreakTrailing: l(H),
      htmlFlow: l(Q),
      htmlFlowData: B,
      htmlText: l(Y),
      htmlTextData: B,
      image: l($),
      label: V,
      labelText: te,
      lineEnding: U,
      link: l(ce),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: z,
      resourceDestinationString: K,
      resourceTitleString: ne,
      resource: J,
      setextHeading: l(j),
      setextHeadingLineSequence: N,
      setextHeadingText: k,
      strong: l(),
      thematicBreak: l()
    }
  };
  x9(e, (n || {}).mdastExtensions || []);
  const t = {};
  return i;
  function i(Te) {
    let Me = {
      type: "root",
      children: []
    };
    const Ye = {
      stack: [Me],
      tokenStack: [],
      config: e,
      enter: r,
      exit: d,
      buffer: s,
      resume: f,
      data: t
    }, et = [];
    let dt = -1;
    for (; ++dt < Te.length; )
      if (Te[dt][1].type === "listOrdered" || Te[dt][1].type === "listUnordered")
        if (Te[dt][0] === "enter")
          et.push(dt);
        else {
          const We = et.pop();
          dt = c(Te, We, dt);
        }
    for (dt = -1; ++dt < Te.length; ) {
      const We = e[Te[dt][0]];
      w9.call(We, Te[dt][1].type) && We[Te[dt][1].type].call(Object.assign({
        sliceSerialize: Te[dt][2].sliceSerialize
      }, Ye), Te[dt][1]);
    }
    if (Ye.tokenStack.length > 0) {
      const We = Ye.tokenStack[Ye.tokenStack.length - 1];
      (We[1] || jO).call(Ye, void 0, We[0]);
    }
    for (Me.position = {
      start: Mh(Te.length > 0 ? Te[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Mh(Te.length > 0 ? Te[Te.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, dt = -1; ++dt < e.transforms.length; )
      Me = e.transforms[dt](Me) || Me;
    return Me;
  }
  function c(Te, Me, Ye) {
    let et = Me - 1, dt = -1, We = !1, nt, ft, At, ln;
    for (; ++et <= Ye; ) {
      const Jt = Te[et];
      switch (Jt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Jt[0] === "enter" ? dt++ : dt--, ln = void 0;
          break;
        }
        case "lineEndingBlank": {
          Jt[0] === "enter" && (nt && !ln && !dt && !At && (At = et), ln = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          ln = void 0;
      }
      if (!dt && Jt[0] === "enter" && Jt[1].type === "listItemPrefix" || dt === -1 && Jt[0] === "exit" && (Jt[1].type === "listUnordered" || Jt[1].type === "listOrdered")) {
        if (nt) {
          let zt = et;
          for (ft = void 0; zt--; ) {
            const kt = Te[zt];
            if (kt[1].type === "lineEnding" || kt[1].type === "lineEndingBlank") {
              if (kt[0] === "exit") continue;
              ft && (Te[ft][1].type = "lineEndingBlank", We = !0), kt[1].type = "lineEnding", ft = zt;
            } else if (!(kt[1].type === "linePrefix" || kt[1].type === "blockQuotePrefix" || kt[1].type === "blockQuotePrefixWhitespace" || kt[1].type === "blockQuoteMarker" || kt[1].type === "listItemIndent")) break;
          }
          At && (!ft || At < ft) && (nt._spread = !0), nt.end = Object.assign({}, ft ? Te[ft][1].start : Jt[1].end), Te.splice(ft || et, 0, ["exit", nt, Jt[2]]), et++, Ye++;
        }
        if (Jt[1].type === "listItemPrefix") {
          const zt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Jt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          nt = zt, Te.splice(et, 0, ["enter", zt, Jt[2]]), et++, Ye++, At = void 0, ln = !0;
        }
      }
    }
    return Te[Me][1]._spread = We, Ye;
  }
  function a(Te, Me) {
    return Ye;
    function Ye(et) {
      r.call(this, Te(et), et), Me && Me.call(this, et);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function r(Te, Me, Ye) {
    this.stack[this.stack.length - 1].children.push(Te), this.stack.push(Te), this.tokenStack.push([Me, Ye]), Te.position = {
      start: Mh(Me.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(Te) {
    return Me;
    function Me(Ye) {
      Te && Te.call(this, Ye), d.call(this, Ye);
    }
  }
  function d(Te, Me) {
    const Ye = this.stack.pop(), et = this.tokenStack.pop();
    if (et)
      et[0].type !== Te.type && (Me ? Me.call(this, Te, et[0]) : (et[1] || jO).call(this, Te, et[0]));
    else throw new Error("Cannot close `" + Te.type + "` (" + y1({
      start: Te.start,
      end: Te.end
    }) + "): it’s not open");
    Ye.position.end = Mh(Te.end);
  }
  function f() {
    return tQ(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p(Te) {
    if (this.data.expectingFirstListItemValue) {
      const Me = this.stack[this.stack.length - 2];
      Me.start = Number.parseInt(this.sliceSerialize(Te), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.lang = Te;
  }
  function _() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.meta = Te;
  }
  function b() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function v() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.value = Te.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function E() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.value = Te.replace(/(\r?\n|\r)$/g, "");
  }
  function C(Te) {
    const Me = this.resume(), Ye = this.stack[this.stack.length - 1];
    Ye.label = Me, Ye.identifier = r0(this.sliceSerialize(Te)).toLowerCase();
  }
  function y() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.title = Te;
  }
  function T() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.url = Te;
  }
  function A(Te) {
    const Me = this.stack[this.stack.length - 1];
    if (!Me.depth) {
      const Ye = this.sliceSerialize(Te).length;
      Me.depth = Ye;
    }
  }
  function k() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function N(Te) {
    const Me = this.stack[this.stack.length - 1];
    Me.depth = this.sliceSerialize(Te).codePointAt(0) === 61 ? 1 : 2;
  }
  function j() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function I(Te) {
    const Ye = this.stack[this.stack.length - 1].children;
    let et = Ye[Ye.length - 1];
    (!et || et.type !== "text") && (et = Se(), et.position = {
      start: Mh(Te.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Ye.push(et)), this.stack.push(et);
  }
  function B(Te) {
    const Me = this.stack.pop();
    Me.value += this.sliceSerialize(Te), Me.position.end = Mh(Te.end);
  }
  function U(Te) {
    const Me = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Ye = Me.children[Me.children.length - 1];
      Ye.position.end = Mh(Te.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && e.canContainEols.includes(Me.type) && (I.call(this, Te), B.call(this, Te));
  }
  function H() {
    this.data.atHardBreak = !0;
  }
  function Q() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.value = Te;
  }
  function Y() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.value = Te;
  }
  function ie() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.value = Te;
  }
  function ce() {
    const Te = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Me = this.data.referenceType || "shortcut";
      Te.type += "Reference", Te.referenceType = Me, delete Te.url, delete Te.title;
    } else
      delete Te.identifier, delete Te.label;
    this.data.referenceType = void 0;
  }
  function $() {
    const Te = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Me = this.data.referenceType || "shortcut";
      Te.type += "Reference", Te.referenceType = Me, delete Te.url, delete Te.title;
    } else
      delete Te.identifier, delete Te.label;
    this.data.referenceType = void 0;
  }
  function te(Te) {
    const Me = this.sliceSerialize(Te), Ye = this.stack[this.stack.length - 2];
    Ye.label = eJ(Me), Ye.identifier = r0(Me).toLowerCase();
  }
  function V() {
    const Te = this.stack[this.stack.length - 1], Me = this.resume(), Ye = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Ye.type === "link") {
      const et = Te.children;
      Ye.children = et;
    } else
      Ye.alt = Me;
  }
  function K() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.url = Te;
  }
  function ne() {
    const Te = this.resume(), Me = this.stack[this.stack.length - 1];
    Me.title = Te;
  }
  function J() {
    this.data.inReference = void 0;
  }
  function L() {
    this.data.referenceType = "collapsed";
  }
  function z(Te) {
    const Me = this.resume(), Ye = this.stack[this.stack.length - 1];
    Ye.label = Me, Ye.identifier = r0(this.sliceSerialize(Te)).toLowerCase(), this.data.referenceType = "full";
  }
  function ee(Te) {
    this.data.characterReferenceType = Te.type;
  }
  function q(Te) {
    const Me = this.sliceSerialize(Te), Ye = this.data.characterReferenceType;
    let et;
    Ye ? (et = p9(Me, Ye === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : et = AT(Me);
    const dt = this.stack[this.stack.length - 1];
    dt.value += et;
  }
  function X(Te) {
    const Me = this.stack.pop();
    Me.position.end = Mh(Te.end);
  }
  function oe(Te) {
    B.call(this, Te);
    const Me = this.stack[this.stack.length - 1];
    Me.url = this.sliceSerialize(Te);
  }
  function ae(Te) {
    B.call(this, Te);
    const Me = this.stack[this.stack.length - 1];
    Me.url = "mailto:" + this.sliceSerialize(Te);
  }
  function _e() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ve() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function we() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ze() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ie() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function je() {
    return {
      type: "break"
    };
  }
  function qe() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ge() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ze() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function tt(Te) {
    return {
      type: "list",
      ordered: Te.type === "listOrdered",
      start: null,
      spread: Te._spread,
      children: []
    };
  }
  function Qe(Te) {
    return {
      type: "listItem",
      spread: Te._spread,
      checked: null,
      children: []
    };
  }
  function ke() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function pe() {
    return {
      type: "strong",
      children: []
    };
  }
  function Se() {
    return {
      type: "text",
      value: ""
    };
  }
  function he() {
    return {
      type: "thematicBreak"
    };
  }
}
function Mh(n) {
  return {
    line: n.line,
    column: n.column,
    offset: n.offset
  };
}
function x9(n, e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const i = e[t];
    Array.isArray(i) ? x9(n, i) : iJ(n, i);
  }
}
function iJ(n, e) {
  let t;
  for (t in e)
    if (w9.call(e, t))
      switch (t) {
        case "canContainEols": {
          const i = e[t];
          i && n[t].push(...i);
          break;
        }
        case "transforms": {
          const i = e[t];
          i && n[t].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = e[t];
          i && Object.assign(n[t], i);
          break;
        }
      }
}
function jO(n, e) {
  throw n ? new Error("Cannot close `" + n.type + "` (" + y1({
    start: n.start,
    end: n.end
  }) + "): a different token (`" + e.type + "`, " + y1({
    start: e.start,
    end: e.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + e.type + "`, " + y1({
    start: e.start,
    end: e.end
  }) + ") is still open");
}
function oJ(n) {
  const e = this;
  e.parser = t;
  function t(i) {
    return nJ(i, {
      ...e.data("settings"),
      ...n,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: e.data("micromarkExtensions") || [],
      mdastExtensions: e.data("fromMarkdownExtensions") || []
    });
  }
}
function aJ(n, e) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: n.wrap(n.all(e), !0)
  };
  return n.patch(e, t), n.applyData(e, t);
}
function sJ(n, e) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return n.patch(e, t), [n.applyData(e, t), { type: "text", value: `
` }];
}
function lJ(n, e) {
  const t = e.value ? e.value + `
` : "", i = {};
  e.lang && (i.className = ["language-" + e.lang]);
  let c = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: t }]
  };
  return e.meta && (c.data = { meta: e.meta }), n.patch(e, c), c = n.applyData(e, c), c = { type: "element", tagName: "pre", properties: {}, children: [c] }, n.patch(e, c), c;
}
function uJ(n, e) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, t), n.applyData(e, t);
}
function cJ(n, e) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, t), n.applyData(e, t);
}
function dJ(n, e) {
  const t = typeof n.options.clobberPrefix == "string" ? n.options.clobberPrefix : "user-content-", i = String(e.identifier).toUpperCase(), c = b0(i.toLowerCase()), a = n.footnoteOrder.indexOf(i);
  let s, r = n.footnoteCounts.get(i);
  r === void 0 ? (r = 0, n.footnoteOrder.push(i), s = n.footnoteOrder.length) : s = a + 1, r += 1, n.footnoteCounts.set(i, r);
  const l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + c,
      id: t + "fnref-" + c + (r > 1 ? "-" + r : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  n.patch(e, l);
  const d = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return n.patch(e, d), n.applyData(e, d);
}
function fJ(n, e) {
  const t = {
    type: "element",
    tagName: "h" + e.depth,
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, t), n.applyData(e, t);
}
function hJ(n, e) {
  if (n.options.allowDangerousHtml) {
    const t = { type: "raw", value: e.value };
    return n.patch(e, t), n.applyData(e, t);
  }
}
function T9(n, e) {
  const t = e.referenceType;
  let i = "]";
  if (t === "collapsed" ? i += "[]" : t === "full" && (i += "[" + (e.label || e.identifier) + "]"), e.type === "imageReference")
    return [{ type: "text", value: "![" + e.alt + i }];
  const c = n.all(e), a = c[0];
  a && a.type === "text" ? a.value = "[" + a.value : c.unshift({ type: "text", value: "[" });
  const s = c[c.length - 1];
  return s && s.type === "text" ? s.value += i : c.push({ type: "text", value: i }), c;
}
function pJ(n, e) {
  const t = String(e.identifier).toUpperCase(), i = n.definitionById.get(t);
  if (!i)
    return T9(n, e);
  const c = { src: b0(i.url || ""), alt: e.alt };
  i.title !== null && i.title !== void 0 && (c.title = i.title);
  const a = { type: "element", tagName: "img", properties: c, children: [] };
  return n.patch(e, a), n.applyData(e, a);
}
function mJ(n, e) {
  const t = { src: b0(e.url) };
  e.alt !== null && e.alt !== void 0 && (t.alt = e.alt), e.title !== null && e.title !== void 0 && (t.title = e.title);
  const i = { type: "element", tagName: "img", properties: t, children: [] };
  return n.patch(e, i), n.applyData(e, i);
}
function gJ(n, e) {
  const t = { type: "text", value: e.value.replace(/\r?\n|\r/g, " ") };
  n.patch(e, t);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return n.patch(e, i), n.applyData(e, i);
}
function _J(n, e) {
  const t = String(e.identifier).toUpperCase(), i = n.definitionById.get(t);
  if (!i)
    return T9(n, e);
  const c = { href: b0(i.url || "") };
  i.title !== null && i.title !== void 0 && (c.title = i.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: c,
    children: n.all(e)
  };
  return n.patch(e, a), n.applyData(e, a);
}
function yJ(n, e) {
  const t = { href: b0(e.url) };
  e.title !== null && e.title !== void 0 && (t.title = e.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: t,
    children: n.all(e)
  };
  return n.patch(e, i), n.applyData(e, i);
}
function vJ(n, e, t) {
  const i = n.all(e), c = t ? bJ(t) : A9(e), a = {}, s = [];
  if (typeof e.checked == "boolean") {
    const f = i[0];
    let h;
    f && f.type === "element" && f.tagName === "p" ? h = f : (h = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: e.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let r = -1;
  for (; ++r < i.length; ) {
    const f = i[r];
    (c || r !== 0 || f.type !== "element" || f.tagName !== "p") && s.push({ type: "text", value: `
` }), f.type === "element" && f.tagName === "p" && !c ? s.push(...f.children) : s.push(f);
  }
  const l = i[i.length - 1];
  l && (c || l.type !== "element" || l.tagName !== "p") && s.push({ type: "text", value: `
` });
  const d = { type: "element", tagName: "li", properties: a, children: s };
  return n.patch(e, d), n.applyData(e, d);
}
function bJ(n) {
  let e = !1;
  if (n.type === "list") {
    e = n.spread || !1;
    const t = n.children;
    let i = -1;
    for (; !e && ++i < t.length; )
      e = A9(t[i]);
  }
  return e;
}
function A9(n) {
  const e = n.spread;
  return e ?? n.children.length > 1;
}
function EJ(n, e) {
  const t = {}, i = n.all(e);
  let c = -1;
  for (typeof e.start == "number" && e.start !== 1 && (t.start = e.start); ++c < i.length; ) {
    const s = i[c];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: e.ordered ? "ol" : "ul",
    properties: t,
    children: n.wrap(i, !0)
  };
  return n.patch(e, a), n.applyData(e, a);
}
function SJ(n, e) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, t), n.applyData(e, t);
}
function CJ(n, e) {
  const t = { type: "root", children: n.wrap(n.all(e)) };
  return n.patch(e, t), n.applyData(e, t);
}
function wJ(n, e) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, t), n.applyData(e, t);
}
function xJ(n, e) {
  const t = n.all(e), i = t.shift(), c = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: n.wrap([i], !0)
    };
    n.patch(e.children[0], s), c.push(s);
  }
  if (t.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: n.wrap(t, !0)
    }, r = CT(e.children[1]), l = s9(e.children[e.children.length - 1]);
    r && l && (s.position = { start: r, end: l }), c.push(s);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: n.wrap(c, !0)
  };
  return n.patch(e, a), n.applyData(e, a);
}
function TJ(n, e, t) {
  const i = t ? t.children : void 0, a = (i ? i.indexOf(e) : 1) === 0 ? "th" : "td", s = t && t.type === "table" ? t.align : void 0, r = s ? s.length : e.children.length;
  let l = -1;
  const d = [];
  for (; ++l < r; ) {
    const h = e.children[l], p = {}, g = s ? s[l] : void 0;
    g && (p.align = g);
    let _ = { type: "element", tagName: a, properties: p, children: [] };
    h && (_.children = n.all(h), n.patch(h, _), _ = n.applyData(h, _)), d.push(_);
  }
  const f = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: n.wrap(d, !0)
  };
  return n.patch(e, f), n.applyData(e, f);
}
function AJ(n, e) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, t), n.applyData(e, t);
}
const BO = 9, FO = 32;
function kJ(n) {
  const e = String(n), t = /\r?\n|\r/g;
  let i = t.exec(e), c = 0;
  const a = [];
  for (; i; )
    a.push(
      UO(e.slice(c, i.index), c > 0, !0),
      i[0]
    ), c = i.index + i[0].length, i = t.exec(e);
  return a.push(UO(e.slice(c), c > 0, !1)), a.join("");
}
function UO(n, e, t) {
  let i = 0, c = n.length;
  if (e) {
    let a = n.codePointAt(i);
    for (; a === BO || a === FO; )
      i++, a = n.codePointAt(i);
  }
  if (t) {
    let a = n.codePointAt(c - 1);
    for (; a === BO || a === FO; )
      c--, a = n.codePointAt(c - 1);
  }
  return c > i ? n.slice(i, c) : "";
}
function OJ(n, e) {
  const t = { type: "text", value: kJ(String(e.value)) };
  return n.patch(e, t), n.applyData(e, t);
}
function DJ(n, e) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return n.patch(e, t), n.applyData(e, t);
}
const RJ = {
  blockquote: aJ,
  break: sJ,
  code: lJ,
  delete: uJ,
  emphasis: cJ,
  footnoteReference: dJ,
  heading: fJ,
  html: hJ,
  imageReference: pJ,
  image: mJ,
  inlineCode: gJ,
  linkReference: _J,
  link: yJ,
  listItem: vJ,
  list: EJ,
  paragraph: SJ,
  // @ts-expect-error: root is different, but hard to type.
  root: CJ,
  strong: wJ,
  table: xJ,
  tableCell: AJ,
  tableRow: TJ,
  text: OJ,
  thematicBreak: DJ,
  toml: kb,
  yaml: kb,
  definition: kb,
  footnoteDefinition: kb
};
function kb() {
}
const k9 = -1, z2 = 0, c2 = 1, d2 = 2, DT = 3, RT = 4, NT = 5, IT = 6, O9 = 7, D9 = 8, HO = typeof self == "object" ? self : globalThis, NJ = (n, e) => {
  const t = (c, a) => (n.set(a, c), c), i = (c) => {
    if (n.has(c))
      return n.get(c);
    const [a, s] = e[c];
    switch (a) {
      case z2:
      case k9:
        return t(s, c);
      case c2: {
        const r = t([], c);
        for (const l of s)
          r.push(i(l));
        return r;
      }
      case d2: {
        const r = t({}, c);
        for (const [l, d] of s)
          r[i(l)] = i(d);
        return r;
      }
      case DT:
        return t(new Date(s), c);
      case RT: {
        const { source: r, flags: l } = s;
        return t(new RegExp(r, l), c);
      }
      case NT: {
        const r = t(/* @__PURE__ */ new Map(), c);
        for (const [l, d] of s)
          r.set(i(l), i(d));
        return r;
      }
      case IT: {
        const r = t(/* @__PURE__ */ new Set(), c);
        for (const l of s)
          r.add(i(l));
        return r;
      }
      case O9: {
        const { name: r, message: l } = s;
        return t(new HO[r](l), c);
      }
      case D9:
        return t(BigInt(s), c);
      case "BigInt":
        return t(Object(BigInt(s)), c);
    }
    return t(new HO[a](s), c);
  };
  return i;
}, zO = (n) => NJ(/* @__PURE__ */ new Map(), n)(0), Yg = "", { toString: IJ } = {}, { keys: LJ } = Object, Q_ = (n) => {
  const e = typeof n;
  if (e !== "object" || !n)
    return [z2, e];
  const t = IJ.call(n).slice(8, -1);
  switch (t) {
    case "Array":
      return [c2, Yg];
    case "Object":
      return [d2, Yg];
    case "Date":
      return [DT, Yg];
    case "RegExp":
      return [RT, Yg];
    case "Map":
      return [NT, Yg];
    case "Set":
      return [IT, Yg];
  }
  return t.includes("Array") ? [c2, t] : t.includes("Error") ? [O9, t] : [d2, t];
}, Ob = ([n, e]) => n === z2 && (e === "function" || e === "symbol"), MJ = (n, e, t, i) => {
  const c = (s, r) => {
    const l = i.push(s) - 1;
    return t.set(r, l), l;
  }, a = (s) => {
    if (t.has(s))
      return t.get(s);
    let [r, l] = Q_(s);
    switch (r) {
      case z2: {
        let f = s;
        switch (l) {
          case "bigint":
            r = D9, f = s.toString();
            break;
          case "function":
          case "symbol":
            if (n)
              throw new TypeError("unable to serialize " + l);
            f = null;
            break;
          case "undefined":
            return c([k9], s);
        }
        return c([r, f], s);
      }
      case c2: {
        if (l)
          return c([l, [...s]], s);
        const f = [], h = c([r, f], s);
        for (const p of s)
          f.push(a(p));
        return h;
      }
      case d2: {
        if (l)
          switch (l) {
            case "BigInt":
              return c([l, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return c([l, s.valueOf()], s);
          }
        if (e && "toJSON" in s)
          return a(s.toJSON());
        const f = [], h = c([r, f], s);
        for (const p of LJ(s))
          (n || !Ob(Q_(s[p]))) && f.push([a(p), a(s[p])]);
        return h;
      }
      case DT:
        return c([r, s.toISOString()], s);
      case RT: {
        const { source: f, flags: h } = s;
        return c([r, { source: f, flags: h }], s);
      }
      case NT: {
        const f = [], h = c([r, f], s);
        for (const [p, g] of s)
          (n || !(Ob(Q_(p)) || Ob(Q_(g)))) && f.push([a(p), a(g)]);
        return h;
      }
      case IT: {
        const f = [], h = c([r, f], s);
        for (const p of s)
          (n || !Ob(Q_(p))) && f.push(a(p));
        return h;
      }
    }
    const { message: d } = s;
    return c([r, { name: l, message: d }], s);
  };
  return a;
}, VO = (n, { json: e, lossy: t } = {}) => {
  const i = [];
  return MJ(!(e || t), !!e, /* @__PURE__ */ new Map(), i)(n), i;
}, f2 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (n, e) => e && ("json" in e || "lossy" in e) ? zO(VO(n, e)) : structuredClone(n)
) : (n, e) => zO(VO(n, e));
function PJ(n, e) {
  const t = [{ type: "text", value: "↩" }];
  return e > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(e) }]
  }), t;
}
function jJ(n, e) {
  return "Back to reference " + (n + 1) + (e > 1 ? "-" + e : "");
}
function BJ(n) {
  const e = typeof n.options.clobberPrefix == "string" ? n.options.clobberPrefix : "user-content-", t = n.options.footnoteBackContent || PJ, i = n.options.footnoteBackLabel || jJ, c = n.options.footnoteLabel || "Footnotes", a = n.options.footnoteLabelTagName || "h2", s = n.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, r = [];
  let l = -1;
  for (; ++l < n.footnoteOrder.length; ) {
    const d = n.footnoteById.get(
      n.footnoteOrder[l]
    );
    if (!d)
      continue;
    const f = n.all(d), h = String(d.identifier).toUpperCase(), p = b0(h.toLowerCase());
    let g = 0;
    const _ = [], b = n.footnoteCounts.get(h);
    for (; b !== void 0 && ++g <= b; ) {
      _.length > 0 && _.push({ type: "text", value: " " });
      let C = typeof t == "string" ? t : t(l, g);
      typeof C == "string" && (C = { type: "text", value: C }), _.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e + "fnref-" + p + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(l, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(C) ? C : [C]
      });
    }
    const v = f[f.length - 1];
    if (v && v.type === "element" && v.tagName === "p") {
      const C = v.children[v.children.length - 1];
      C && C.type === "text" ? C.value += " " : v.children.push({ type: "text", value: " " }), v.children.push(..._);
    } else
      f.push(..._);
    const E = {
      type: "element",
      tagName: "li",
      properties: { id: e + "fn-" + p },
      children: n.wrap(f, !0)
    };
    n.patch(d, E), r.push(E);
  }
  if (r.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...f2(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: c }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: n.wrap(r, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const R9 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(n) {
    if (n == null)
      return zJ;
    if (typeof n == "function")
      return V2(n);
    if (typeof n == "object")
      return Array.isArray(n) ? FJ(n) : UJ(n);
    if (typeof n == "string")
      return HJ(n);
    throw new Error("Expected function, string, or object as test");
  }
);
function FJ(n) {
  const e = [];
  let t = -1;
  for (; ++t < n.length; )
    e[t] = R9(n[t]);
  return V2(i);
  function i(...c) {
    let a = -1;
    for (; ++a < e.length; )
      if (e[a].apply(this, c)) return !0;
    return !1;
  }
}
function UJ(n) {
  const e = (
    /** @type {Record<string, unknown>} */
    n
  );
  return V2(t);
  function t(i) {
    const c = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let a;
    for (a in n)
      if (c[a] !== e[a]) return !1;
    return !0;
  }
}
function HJ(n) {
  return V2(e);
  function e(t) {
    return t && t.type === n;
  }
}
function V2(n) {
  return e;
  function e(t, i, c) {
    return !!(VJ(t) && n.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      c || void 0
    ));
  }
}
function zJ() {
  return !0;
}
function VJ(n) {
  return n !== null && typeof n == "object" && "type" in n;
}
const N9 = [], qJ = !0, qO = !1, GJ = "skip";
function WJ(n, e, t, i) {
  let c;
  typeof e == "function" && typeof t != "function" ? (i = t, t = e) : c = e;
  const a = R9(c), s = i ? -1 : 1;
  r(n, void 0, [])();
  function r(l, d, f) {
    const h = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof h.type == "string") {
      const g = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(p, "name", {
        value: "node (" + (l.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return p;
    function p() {
      let g = N9, _, b, v;
      if ((!e || a(l, d, f[f.length - 1] || void 0)) && (g = $J(t(l, f)), g[0] === qO))
        return g;
      if ("children" in l && l.children) {
        const E = (
          /** @type {UnistParent} */
          l
        );
        if (E.children && g[0] !== GJ)
          for (b = (i ? E.children.length : -1) + s, v = f.concat(E); b > -1 && b < E.children.length; ) {
            const C = E.children[b];
            if (_ = r(C, b, v)(), _[0] === qO)
              return _;
            b = typeof _[1] == "number" ? _[1] : b + s;
          }
      }
      return g;
    }
  }
}
function $J(n) {
  return Array.isArray(n) ? n : typeof n == "number" ? [qJ, n] : n == null ? N9 : [n];
}
function I9(n, e, t, i) {
  let c, a, s;
  typeof e == "function" && typeof t != "function" ? (a = void 0, s = e, c = t) : (a = e, s = t, c = i), WJ(n, a, r, c);
  function r(l, d) {
    const f = d[d.length - 1], h = f ? f.children.indexOf(l) : void 0;
    return s(l, h, f);
  }
}
const Sx = {}.hasOwnProperty, YJ = {};
function XJ(n, e) {
  const t = e || YJ, i = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = { ...RJ, ...t.handlers }, r = {
    all: d,
    applyData: QJ,
    definitionById: i,
    footnoteById: c,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: s,
    one: l,
    options: t,
    patch: KJ,
    wrap: JJ
  };
  return I9(n, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const h = f.type === "definition" ? i : c, p = String(f.identifier).toUpperCase();
      h.has(p) || h.set(p, f);
    }
  }), r;
  function l(f, h) {
    const p = f.type, g = r.handlers[p];
    if (Sx.call(r.handlers, p) && g)
      return g(r, f, h);
    if (r.options.passThrough && r.options.passThrough.includes(p)) {
      if ("children" in f) {
        const { children: b, ...v } = f, E = f2(v);
        return E.children = r.all(f), E;
      }
      return f2(f);
    }
    return (r.options.unknownHandler || ZJ)(r, f, h);
  }
  function d(f) {
    const h = [];
    if ("children" in f) {
      const p = f.children;
      let g = -1;
      for (; ++g < p.length; ) {
        const _ = r.one(p[g], f);
        if (_) {
          if (g && p[g - 1].type === "break" && (!Array.isArray(_) && _.type === "text" && (_.value = GO(_.value)), !Array.isArray(_) && _.type === "element")) {
            const b = _.children[0];
            b && b.type === "text" && (b.value = GO(b.value));
          }
          Array.isArray(_) ? h.push(..._) : h.push(_);
        }
      }
    }
    return h;
  }
}
function KJ(n, e) {
  n.position && (e.position = RK(n));
}
function QJ(n, e) {
  let t = e;
  if (n && n.data) {
    const i = n.data.hName, c = n.data.hChildren, a = n.data.hProperties;
    if (typeof i == "string")
      if (t.type === "element")
        t.tagName = i;
      else {
        const s = "children" in t ? t.children : [t];
        t = { type: "element", tagName: i, properties: {}, children: s };
      }
    t.type === "element" && a && Object.assign(t.properties, f2(a)), "children" in t && t.children && c !== null && c !== void 0 && (t.children = c);
  }
  return t;
}
function ZJ(n, e) {
  const t = e.data || {}, i = "value" in e && !(Sx.call(t, "hProperties") || Sx.call(t, "hChildren")) ? { type: "text", value: e.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: n.all(e)
  };
  return n.patch(e, i), n.applyData(e, i);
}
function JJ(n, e) {
  const t = [];
  let i = -1;
  for (e && t.push({ type: "text", value: `
` }); ++i < n.length; )
    i && t.push({ type: "text", value: `
` }), t.push(n[i]);
  return e && n.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function GO(n) {
  let e = 0, t = n.charCodeAt(e);
  for (; t === 9 || t === 32; )
    e++, t = n.charCodeAt(e);
  return n.slice(e);
}
function WO(n, e) {
  const t = XJ(n, e), i = t.one(n, void 0), c = BJ(t), a = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return c && a.children.push({ type: "text", value: `
` }, c), a;
}
function eee(n, e) {
  return n && "run" in n ? async function(t, i) {
    const c = (
      /** @type {HastRoot} */
      WO(t, { file: i, ...e })
    );
    await n.run(c, i);
  } : function(t, i) {
    return (
      /** @type {HastRoot} */
      WO(t, { file: i, ...e || n })
    );
  };
}
function $O(n) {
  if (n)
    throw n;
}
var Ub = Object.prototype.hasOwnProperty, L9 = Object.prototype.toString, YO = Object.defineProperty, XO = Object.getOwnPropertyDescriptor, KO = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : L9.call(e) === "[object Array]";
}, QO = function(e) {
  if (!e || L9.call(e) !== "[object Object]")
    return !1;
  var t = Ub.call(e, "constructor"), i = e.constructor && e.constructor.prototype && Ub.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !t && !i)
    return !1;
  var c;
  for (c in e)
    ;
  return typeof c > "u" || Ub.call(e, c);
}, ZO = function(e, t) {
  YO && t.name === "__proto__" ? YO(e, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : e[t.name] = t.newValue;
}, JO = function(e, t) {
  if (t === "__proto__")
    if (Ub.call(e, t)) {
      if (XO)
        return XO(e, t).value;
    } else return;
  return e[t];
}, tee = function n() {
  var e, t, i, c, a, s, r = arguments[0], l = 1, d = arguments.length, f = !1;
  for (typeof r == "boolean" && (f = r, r = arguments[1] || {}, l = 2), (r == null || typeof r != "object" && typeof r != "function") && (r = {}); l < d; ++l)
    if (e = arguments[l], e != null)
      for (t in e)
        i = JO(r, t), c = JO(e, t), r !== c && (f && c && (QO(c) || (a = KO(c))) ? (a ? (a = !1, s = i && KO(i) ? i : []) : s = i && QO(i) ? i : {}, ZO(r, { name: t, newValue: n(f, s, c) })) : typeof c < "u" && ZO(r, { name: t, newValue: c }));
  return r;
};
const Rw = /* @__PURE__ */ c0(tee);
function Cx(n) {
  if (typeof n != "object" || n === null)
    return !1;
  const e = Object.getPrototypeOf(n);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in n) && !(Symbol.iterator in n);
}
function nee() {
  const n = [], e = { run: t, use: i };
  return e;
  function t(...c) {
    let a = -1;
    const s = c.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    r(null, ...c);
    function r(l, ...d) {
      const f = n[++a];
      let h = -1;
      if (l) {
        s(l);
        return;
      }
      for (; ++h < c.length; )
        (d[h] === null || d[h] === void 0) && (d[h] = c[h]);
      c = d, f ? ree(f, r)(...d) : s(null, ...d);
    }
  }
  function i(c) {
    if (typeof c != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + c
      );
    return n.push(c), e;
  }
}
function ree(n, e) {
  let t;
  return i;
  function i(...s) {
    const r = n.length > s.length;
    let l;
    r && s.push(c);
    try {
      l = n.apply(this, s);
    } catch (d) {
      const f = (
        /** @type {Error} */
        d
      );
      if (r && t)
        throw f;
      return c(f);
    }
    r || (l && l.then && typeof l.then == "function" ? l.then(a, c) : l instanceof Error ? c(l) : a(l));
  }
  function c(s, ...r) {
    t || (t = !0, e(s, ...r));
  }
  function a(s) {
    c(null, s);
  }
}
const od = { basename: iee, dirname: oee, extname: aee, join: see, sep: "/" };
function iee(n, e) {
  if (e !== void 0 && typeof e != "string")
    throw new TypeError('"ext" argument must be a string');
  V1(n);
  let t = 0, i = -1, c = n.length, a;
  if (e === void 0 || e.length === 0 || e.length > n.length) {
    for (; c--; )
      if (n.codePointAt(c) === 47) {
        if (a) {
          t = c + 1;
          break;
        }
      } else i < 0 && (a = !0, i = c + 1);
    return i < 0 ? "" : n.slice(t, i);
  }
  if (e === n)
    return "";
  let s = -1, r = e.length - 1;
  for (; c--; )
    if (n.codePointAt(c) === 47) {
      if (a) {
        t = c + 1;
        break;
      }
    } else
      s < 0 && (a = !0, s = c + 1), r > -1 && (n.codePointAt(c) === e.codePointAt(r--) ? r < 0 && (i = c) : (r = -1, i = s));
  return t === i ? i = s : i < 0 && (i = n.length), n.slice(t, i);
}
function oee(n) {
  if (V1(n), n.length === 0)
    return ".";
  let e = -1, t = n.length, i;
  for (; --t; )
    if (n.codePointAt(t) === 47) {
      if (i) {
        e = t;
        break;
      }
    } else i || (i = !0);
  return e < 0 ? n.codePointAt(0) === 47 ? "/" : "." : e === 1 && n.codePointAt(0) === 47 ? "//" : n.slice(0, e);
}
function aee(n) {
  V1(n);
  let e = n.length, t = -1, i = 0, c = -1, a = 0, s;
  for (; e--; ) {
    const r = n.codePointAt(e);
    if (r === 47) {
      if (s) {
        i = e + 1;
        break;
      }
      continue;
    }
    t < 0 && (s = !0, t = e + 1), r === 46 ? c < 0 ? c = e : a !== 1 && (a = 1) : c > -1 && (a = -1);
  }
  return c < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && c === t - 1 && c === i + 1 ? "" : n.slice(c, t);
}
function see(...n) {
  let e = -1, t;
  for (; ++e < n.length; )
    V1(n[e]), n[e] && (t = t === void 0 ? n[e] : t + "/" + n[e]);
  return t === void 0 ? "." : lee(t);
}
function lee(n) {
  V1(n);
  const e = n.codePointAt(0) === 47;
  let t = uee(n, !e);
  return t.length === 0 && !e && (t = "."), t.length > 0 && n.codePointAt(n.length - 1) === 47 && (t += "/"), e ? "/" + t : t;
}
function uee(n, e) {
  let t = "", i = 0, c = -1, a = 0, s = -1, r, l;
  for (; ++s <= n.length; ) {
    if (s < n.length)
      r = n.codePointAt(s);
    else {
      if (r === 47)
        break;
      r = 47;
    }
    if (r === 47) {
      if (!(c === s - 1 || a === 1)) if (c !== s - 1 && a === 2) {
        if (t.length < 2 || i !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (l = t.lastIndexOf("/"), l !== t.length - 1) {
              l < 0 ? (t = "", i = 0) : (t = t.slice(0, l), i = t.length - 1 - t.lastIndexOf("/")), c = s, a = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", i = 0, c = s, a = 0;
            continue;
          }
        }
        e && (t = t.length > 0 ? t + "/.." : "..", i = 2);
      } else
        t.length > 0 ? t += "/" + n.slice(c + 1, s) : t = n.slice(c + 1, s), i = s - c - 1;
      c = s, a = 0;
    } else r === 46 && a > -1 ? a++ : a = -1;
  }
  return t;
}
function V1(n) {
  if (typeof n != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(n)
    );
}
const cee = { cwd: dee };
function dee() {
  return "/";
}
function wx(n) {
  return !!(n !== null && typeof n == "object" && "href" in n && n.href && "protocol" in n && n.protocol && // @ts-expect-error: indexing is fine.
  n.auth === void 0);
}
function fee(n) {
  if (typeof n == "string")
    n = new URL(n);
  else if (!wx(n)) {
    const e = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + n + "`"
    );
    throw e.code = "ERR_INVALID_ARG_TYPE", e;
  }
  if (n.protocol !== "file:") {
    const e = new TypeError("The URL must be of scheme file");
    throw e.code = "ERR_INVALID_URL_SCHEME", e;
  }
  return hee(n);
}
function hee(n) {
  if (n.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const e = n.pathname;
  let t = -1;
  for (; ++t < e.length; )
    if (e.codePointAt(t) === 37 && e.codePointAt(t + 1) === 50) {
      const i = e.codePointAt(t + 2);
      if (i === 70 || i === 102) {
        const c = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw c.code = "ERR_INVALID_FILE_URL_PATH", c;
      }
    }
  return decodeURIComponent(e);
}
const Nw = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class M9 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(e) {
    let t;
    e ? wx(e) ? t = { path: e } : typeof e == "string" || pee(e) ? t = { value: e } : t = e : t = {}, this.cwd = "cwd" in t ? "" : cee.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Nw.length; ) {
      const a = Nw[i];
      a in t && t[a] !== void 0 && t[a] !== null && (this[a] = a === "history" ? [...t[a]] : t[a]);
    }
    let c;
    for (c in t)
      Nw.includes(c) || (this[c] = t[c]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? od.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(e) {
    Lw(e, "basename"), Iw(e, "basename"), this.path = od.join(this.dirname || "", e);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? od.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(e) {
    e6(this.basename, "dirname"), this.path = od.join(e || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? od.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(e) {
    if (Iw(e, "extname"), e6(this.dirname, "extname"), e) {
      if (e.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (e.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = od.join(this.dirname, this.stem + (e || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(e) {
    wx(e) && (e = fee(e)), Lw(e, "path"), this.path !== e && this.history.push(e);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? od.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(e) {
    Lw(e, "stem"), Iw(e, "stem"), this.path = od.join(this.dirname || "", e + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(e, t, i) {
    const c = this.message(e, t, i);
    throw c.fatal = !0, c;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(e, t, i) {
    const c = this.message(e, t, i);
    return c.fatal = void 0, c;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(e, t, i) {
    const c = new ts(
      // @ts-expect-error: the overloads are fine.
      e,
      t,
      i
    );
    return this.path && (c.name = this.path + ":" + c.name, c.file = this.path), c.fatal = !1, this.messages.push(c), c;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(e) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(e || void 0).decode(this.value);
  }
}
function Iw(n, e) {
  if (n && n.includes(od.sep))
    throw new Error(
      "`" + e + "` cannot be a path: did not expect `" + od.sep + "`"
    );
}
function Lw(n, e) {
  if (!n)
    throw new Error("`" + e + "` cannot be empty");
}
function e6(n, e) {
  if (!n)
    throw new Error("Setting `" + e + "` requires `path` to be set too");
}
function pee(n) {
  return !!(n && typeof n == "object" && "byteLength" in n && "byteOffset" in n);
}
const mee = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(n) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), c = i[n], a = function() {
      return c.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, i), a;
  }
), gee = {}.hasOwnProperty;
class LT extends mee {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = nee();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const e = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new LT()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const i = this.attachers[t];
      e.use(...i);
    }
    return e.data(Rw(!0, {}, this.namespace)), e;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(e, t) {
    return typeof e == "string" ? arguments.length === 2 ? (jw("data", this.frozen), this.namespace[e] = t, this) : gee.call(this.namespace, e) && this.namespace[e] || void 0 : e ? (jw("data", this.frozen), this.namespace = e, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const e = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const c = t.call(e, ...i);
      typeof c == "function" && this.transformers.use(c);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(e) {
    this.freeze();
    const t = Db(e), i = this.parser || this.Parser;
    return Mw("parse", i), i(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(e, t) {
    const i = this;
    return this.freeze(), Mw("process", this.parser || this.Parser), Pw("process", this.compiler || this.Compiler), t ? c(void 0, t) : new Promise(c);
    function c(a, s) {
      const r = Db(e), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(r)
      );
      i.run(l, r, function(f, h, p) {
        if (f || !h || !p)
          return d(f);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), _ = i.stringify(g, p);
        vee(_) ? p.value = _ : p.result = _, d(
          f,
          /** @type {VFileWithOutput<CompileResult>} */
          p
        );
      });
      function d(f, h) {
        f || !h ? s(f) : a ? a(h) : t(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(e) {
    let t = !1, i;
    return this.freeze(), Mw("processSync", this.parser || this.Parser), Pw("processSync", this.compiler || this.Compiler), this.process(e, c), n6("processSync", "process", t), i;
    function c(a, s) {
      t = !0, $O(a), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(e, t, i) {
    t6(e), this.freeze();
    const c = this.transformers;
    return !i && typeof t == "function" && (i = t, t = void 0), i ? a(void 0, i) : new Promise(a);
    function a(s, r) {
      const l = Db(t);
      c.run(e, l, d);
      function d(f, h, p) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || e
        );
        f ? r(f) : s ? s(g) : i(void 0, g, p);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(e, t) {
    let i = !1, c;
    return this.run(e, t, a), n6("runSync", "run", i), c;
    function a(s, r) {
      $O(s), c = r, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(e, t) {
    this.freeze();
    const i = Db(t), c = this.compiler || this.Compiler;
    return Pw("stringify", c), t6(e), c(e, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(e, ...t) {
    const i = this.attachers, c = this.namespace;
    if (jw("use", this.frozen), e != null) if (typeof e == "function")
      l(e, t);
    else if (typeof e == "object")
      Array.isArray(e) ? r(e) : s(e);
    else
      throw new TypeError("Expected usable value, not `" + e + "`");
    return this;
    function a(d) {
      if (typeof d == "function")
        l(d, []);
      else if (typeof d == "object")
        if (Array.isArray(d)) {
          const [f, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            d
          );
          l(f, h);
        } else
          s(d);
      else
        throw new TypeError("Expected usable value, not `" + d + "`");
    }
    function s(d) {
      if (!("plugins" in d) && !("settings" in d))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      r(d.plugins), d.settings && (c.settings = Rw(!0, c.settings, d.settings));
    }
    function r(d) {
      let f = -1;
      if (d != null) if (Array.isArray(d))
        for (; ++f < d.length; ) {
          const h = d[f];
          a(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + d + "`");
    }
    function l(d, f) {
      let h = -1, p = -1;
      for (; ++h < i.length; )
        if (i[h][0] === d) {
          p = h;
          break;
        }
      if (p === -1)
        i.push([d, ...f]);
      else if (f.length > 0) {
        let [g, ..._] = f;
        const b = i[p][1];
        Cx(b) && Cx(g) && (g = Rw(!0, b, g)), i[p] = [d, g, ..._];
      }
    }
  }
}
const _ee = new LT().freeze();
function Mw(n, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + n + "` without `parser`");
}
function Pw(n, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + n + "` without `compiler`");
}
function jw(n, e) {
  if (e)
    throw new Error(
      "Cannot call `" + n + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function t6(n) {
  if (!Cx(n) || typeof n.type != "string")
    throw new TypeError("Expected node, got `" + n + "`");
}
function n6(n, e, t) {
  if (!t)
    throw new Error(
      "`" + n + "` finished async. Use `" + e + "` instead"
    );
}
function Db(n) {
  return yee(n) ? n : new M9(n);
}
function yee(n) {
  return !!(n && typeof n == "object" && "message" in n && "messages" in n);
}
function vee(n) {
  return typeof n == "string" || bee(n);
}
function bee(n) {
  return !!(n && typeof n == "object" && "byteLength" in n && "byteOffset" in n);
}
const Eee = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", r6 = [], i6 = { allowDangerousHtml: !0 }, See = /^(https?|ircs?|mailto|xmpp)$/i, Cee = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function P9(n) {
  const e = n.allowedElements, t = n.allowElement, i = n.children || "", c = n.className, a = n.components, s = n.disallowedElements, r = n.rehypePlugins || r6, l = n.remarkPlugins || r6, d = n.remarkRehypeOptions ? { ...n.remarkRehypeOptions, ...i6 } : i6, f = n.skipHtml, h = n.unwrapDisallowed, p = n.urlTransform || wee, g = _ee().use(oJ).use(l).use(eee, d).use(r), _ = new M9();
  typeof i == "string" && (_.value = i);
  for (const C of Cee)
    Object.hasOwn(n, C.from) && ("" + C.from + (C.to ? "use `" + C.to + "` instead" : "remove it") + Eee + C.id, void 0);
  const b = g.parse(_);
  let v = g.runSync(b, _);
  return c && (v = {
    type: "element",
    tagName: "div",
    properties: { className: c },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      v.type === "root" ? v.children : [v]
    )
  }), I9(v, E), jK(v, {
    Fragment: pd,
    components: a,
    ignoreInvalidStyle: !0,
    jsx: Re,
    jsxs: Mt,
    passKeys: !0,
    passNode: !0
  });
  function E(C, y, T) {
    if (C.type === "raw" && T && typeof y == "number")
      return f ? T.children.splice(y, 1) : T.children[y] = { type: "text", value: C.value }, y;
    if (C.type === "element") {
      let A;
      for (A in kw)
        if (Object.hasOwn(kw, A) && Object.hasOwn(C.properties, A)) {
          const k = C.properties[A], N = kw[A];
          (N === null || N.includes(C.tagName)) && (C.properties[A] = p(String(k || ""), A, C));
        }
    }
    if (C.type === "element") {
      let A = e ? !e.includes(C.tagName) : s ? s.includes(C.tagName) : !1;
      if (!A && t && typeof y == "number" && (A = !t(C, y, T)), A && T && typeof y == "number")
        return h && C.children ? T.children.splice(y, 1, ...C.children) : T.children.splice(y, 1), y;
    }
  }
}
function wee(n) {
  const e = n.indexOf(":"), t = n.indexOf("?"), i = n.indexOf("#"), c = n.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    e < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    c > -1 && e > c || t > -1 && e > t || i > -1 && e > i || // It is a protocol, it should be allowed.
    See.test(n.slice(0, e)) ? n : ""
  );
}
const xee = Mn.bind(a1), Noe = (n) => {
  const { name: e, rows: t = 8, disabled: i, onPaste: c, onBlur: a } = n, { values: s, errors: r, touched: l } = gd(), [d, f] = Wn(!1), h = () => {
    f(!d);
  }, p = xee("markdown", {
    "markdown--open": d,
    "markdown--error": e in r && e in l
  });
  return /* @__PURE__ */ Mt(pd, { children: [
    /* @__PURE__ */ Mt("div", { className: p, children: [
      /* @__PURE__ */ Re("div", { className: a1.markdown__editor, children: /* @__PURE__ */ Re(
        Dm,
        {
          as: "textarea",
          className: a1.markdown__textarea,
          id: e,
          name: e,
          disabled: i,
          rows: t,
          ...a && { onBlur: a },
          ...c && { onPaste: c }
        }
      ) }),
      /* @__PURE__ */ Re("div", { className: a1.markdown__preview, children: /* @__PURE__ */ Re(P9, { children: s[e] ?? "" }) }),
      /* @__PURE__ */ Re("div", { className: a1.markdown__bottom, children: /* @__PURE__ */ Re("button", { type: "button", onClick: h, children: /* @__PURE__ */ Re(I6, {}) }) })
    ] }),
    /* @__PURE__ */ Re(Xh, { name: e })
  ] });
}, Tee = "_radioBar_1wsk2_1", Aee = "_radioOption_1wsk2_16", kee = "_radioOption__header_1wsk2_34", Oee = "_radioOption__label_1wsk2_38", Dee = "_radioOption__description_1wsk2_79", s1 = {
  radioBar: Tee,
  "radioBar--column": "_radioBar--column_1wsk2_12",
  radioOption: Aee,
  radioOption__header: kee,
  radioOption__label: Oee,
  radioOption__description: Dee
}, Ree = Mn.bind(s1), Ioe = (n) => {
  const { name: e, options: t, direction: i = "row", disabled: c } = n, a = Ree("radioBar", {
    "radioBar--column": i === "column"
  });
  return /* @__PURE__ */ Re("div", { className: a, children: t.map((s) => /* @__PURE__ */ Mt("label", { className: s1.radioOption, children: [
    /* @__PURE__ */ Mt("div", { className: s1.radioOption__header, children: [
      /* @__PURE__ */ Re("div", { className: s1.radioOption__label, children: s.label }),
      /* @__PURE__ */ Re(
        Dm,
        {
          type: "radio",
          name: e,
          value: s.value,
          disabled: c
        }
      )
    ] }),
    s.description && /* @__PURE__ */ Re("small", { className: s1.radioOption__description, children: s.description })
  ] }, s.value)) });
}, Nee = "_radioGroup_kel8i_1", Iee = "_radioOption_kel8i_9", j9 = {
  radioGroup: Nee,
  radioOption: Iee,
  "radioGroup--horizontal": "_radioGroup--horizontal_kel8i_67"
}, Lee = Mn.bind(j9), Loe = (n) => {
  const { name: e, options: t, direction: i = "column", disabled: c } = n, a = Lee("radioGroup", {
    "radioGroup--horizontal": i === "row"
  });
  return /* @__PURE__ */ Re("div", { className: a, children: t.map((s) => /* @__PURE__ */ Re("div", { children: /* @__PURE__ */ Mt("label", { className: j9.radioOption, children: [
    /* @__PURE__ */ Re(
      Dm,
      {
        type: "radio",
        name: e,
        value: s.value,
        disabled: c
      }
    ),
    s.label
  ] }) }, s.value)) });
}, Mee = "_select_x45ue_1", Pee = "_wrapper_x45ue_6", jee = "_selectButton_x45ue_11", Bee = "_selectArrow_x45ue_48", Fee = "_selectDropdown_x45ue_70", Uee = "_selectSearch_x45ue_97", Hee = "_selectDropdownList_x45ue_105", zee = "_selectDropdownOption_x45ue_111", Vee = "_optionCheck_x45ue_141", qee = "_optionLabel_x45ue_170", Gee = "_optionSublabel_x45ue_178", Wee = "_selectPlaceholder_x45ue_185", Hh = {
  select: Mee,
  wrapper: Pee,
  selectButton: jee,
  "selectButton--error": "_selectButton--error_x45ue_35",
  "selectButton--disabled": "_selectButton--disabled_x45ue_42",
  selectArrow: Bee,
  "selectArrow--open": "_selectArrow--open_x45ue_66",
  selectDropdown: Fee,
  "selectDropdown--open": "_selectDropdown--open_x45ue_91",
  selectSearch: Uee,
  "selectSearch--noResults": "_selectSearch--noResults_x45ue_101",
  selectDropdownList: Hee,
  selectDropdownOption: zee,
  optionCheck: Vee,
  "selectDropdownOption--selected": "_selectDropdownOption--selected_x45ue_163",
  optionLabel: qee,
  "selectDropdownOption--disabled": "_selectDropdownOption--disabled_x45ue_173",
  optionSublabel: Gee,
  selectPlaceholder: Wee
}, l1 = Mn.bind(Hh), Moe = (n) => {
  const { name: e, placeholder: t, options: i, multiple: c, search: a, disabled: s } = n, { errors: r, touched: l, setFieldValue: d, setFieldTouched: f, values: h } = gd(), p = zn(null), g = zn(null), _ = () => c ? h[e] || [] : h[e] || "", [b, v] = Wn(
    _()
  ), [E, C] = Wn(!1), [y, T] = Wn(i), [A, k] = Wn(""), N = l1("selectButton", {
    "selectButton--error": e in r && e in l,
    "selectButton--disabled": s
  }), j = l1("selectArrow", {
    "selectArrow--open": E
  }), I = l1("selectDropdown", {
    "selectDropdown--open": !s && E
  }), B = l1("selectSearch", {
    "selectSearch--noResults": y.length === 0
  });
  An(() => {
    const ie = setTimeout(() => {
      T(A === "" ? i : i.filter(
        (ce) => ce.label.toLowerCase().includes(A.toLowerCase())
      ));
    }, 200);
    return () => {
      clearTimeout(ie);
    };
  }, [A, i]), An(() => {
    if (!E)
      return;
    const ie = ($) => {
      const te = $.target;
      p.current && !p.current.contains(te) && (C(!1), f(e, !0));
    }, ce = ($) => {
      $.stopPropagation(), $.key === "Escape" && (C(!1), f(e, !0));
    };
    return document.addEventListener("click", ie), document.addEventListener("keydown", ce), () => {
      document.removeEventListener("click", ie), document.removeEventListener("keydown", ce);
    };
  }, [p, E, e, f]);
  const U = () => {
    s && !E || (E && f(e, !0), C(!E));
  }, H = async (ie) => {
    await d(e, ie), v(ie), await f(e, !0);
  }, Q = (ie) => {
    if (c && Array.isArray(b))
      if (b.includes(ie)) {
        const ce = b.filter(
          ($) => $ !== ie
        );
        H(ce);
      } else {
        const ce = [...b, ie];
        H(ce);
      }
    else
      H(ie), C(!1);
  }, Y = (ie) => {
    var ce;
    return Array.isArray(ie) ? ie.length > 0 ? ie.map(
      ($) => {
        var te;
        return (te = i.find((V) => V.value === $)) == null ? void 0 : te.label;
      }
    ).join(", ") : /* @__PURE__ */ Re("span", { className: Hh.selectPlaceholder, children: t }) : ((ce = i.find(($) => $.value === ie)) == null ? void 0 : ce.label) || /* @__PURE__ */ Re("span", { className: Hh.selectPlaceholder, children: t });
  };
  return /* @__PURE__ */ Mt(pd, { children: [
    /* @__PURE__ */ Mt("div", { className: Hh.wrapper, ref: p, children: [
      /* @__PURE__ */ Mt(
        "button",
        {
          type: "button",
          className: N,
          onClick: U,
          disabled: s,
          children: [
            Y(b),
            /* @__PURE__ */ Re("span", { className: j, children: /* @__PURE__ */ Re(E2, {}) })
          ]
        }
      ),
      /* @__PURE__ */ Mt("div", { className: I, ref: g, children: [
        a && /* @__PURE__ */ Re("div", { className: B, children: /* @__PURE__ */ Re(
          kP,
          {
            value: A,
            setValue: k,
            fullWidth: !0
          }
        ) }),
        /* @__PURE__ */ Re("ul", { className: Hh.selectDropdownList, children: y.map((ie) => /* @__PURE__ */ Re(
          $ee,
          {
            option: ie,
            selected: b,
            multiple: c,
            onClick: Q
          },
          ie.value
        )) })
      ] })
    ] }),
    /* @__PURE__ */ Re(Xh, { name: e })
  ] });
}, $ee = (n) => {
  const { option: e, selected: t, onClick: i, multiple: c } = n, a = l1("selectDropdownOption", {
    "selectDropdownOption--selected": c ? t.includes(e.value) : t === e.value,
    "selectDropdownOption--disabled": e.disabled
  });
  return /* @__PURE__ */ Mt("li", { className: a, onClick: () => {
    e.disabled || i(e.value);
  }, tabIndex: 0, children: [
    /* @__PURE__ */ Re("div", { className: Hh.optionCheck, children: /* @__PURE__ */ Re("span", { children: /* @__PURE__ */ Re(O6, {}) }) }),
    /* @__PURE__ */ Mt("div", { children: [
      /* @__PURE__ */ Re("div", { className: Hh.optionLabel, children: e.label }),
      e.sublabel && /* @__PURE__ */ Re("div", { className: Hh.optionSublabel, children: e.sublabel })
    ] })
  ] });
}, Yee = "_slider_d64wk_1", Xee = "_slider__bar_d64wk_7", Kee = "_slider__fill_d64wk_16", Qee = "_slider__thumb_d64wk_25", Zee = "_slider__tooltip_d64wk_38", Hb = {
  "slider--withTooltipBottom": "_slider--withTooltipBottom_d64wk_1",
  "slider--withTooltipTop": "_slider--withTooltipTop_d64wk_4",
  slider: Yee,
  slider__bar: Xee,
  slider__fill: Kee,
  slider__thumb: Qee,
  slider__tooltip: Zee,
  "slider__tooltip--visible": "_slider__tooltip--visible_d64wk_63",
  "slider__tooltip--bottom": "_slider__tooltip--bottom_d64wk_67",
  "slider__tooltip--top": "_slider__tooltip--top_d64wk_74"
}, o6 = Mn.bind(Hb), Poe = (n) => {
  var j;
  const { name: e, range: t, options: i, tooltip: c } = n, { setFieldValue: a, values: s, setFieldTouched: r } = gd(), l = zn(null), d = zn(null), [f, h] = Wn(!1);
  if ((!i || i.length === 0) && !t)
    throw new Error("You have to provide either options or a range");
  const p = o6("slider__tooltip", {
    "slider__tooltip--visible": !!c,
    "slider__tooltip--top": c === "top",
    "slider__tooltip--bottom": c === "bottom"
  }), g = o6("slider", {
    "slider--withTooltipBottom": c === "bottom",
    "slider--withTooltipTop": c === "top"
  }), _ = i && i.length > 0, b = _ ? i.findIndex((I) => I.value === s[e]) || 0 : Math.round((s[e] - t.min) / t.step || 0), v = _ ? i.length - 1 : Math.round((t.max - t.min) / t.step), E = () => b / v * 100, C = hr(
    (I) => {
      var B;
      return _ ? ((B = i.find((U) => U.value === I)) == null ? void 0 : B.value) || i[0].value : Math.min(t.max, Math.max(t.min, I));
    },
    [t, i, _]
  ), y = hr(
    (I) => {
      if (!l.current) return;
      const B = l.current.getBoundingClientRect(), U = (I - B.left) / B.width, H = Math.round(U * v), Q = _ ? i[H].value : C(t.min + H * t.step);
      a(e, Q), r(e, !0);
    },
    [
      C,
      _,
      e,
      i,
      t,
      r,
      a,
      v
    ]
  ), T = (I) => {
    y(I.clientX);
  }, A = (I) => {
    let B = b;
    switch (I.key) {
      case "ArrowRight":
      case "ArrowUp":
        B = Math.min(b + 1, v);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        B = Math.max(b - 1, 0);
        break;
      case "Home":
        B = 0;
        break;
      case "End":
        B = v;
        break;
      default:
        return;
    }
    const U = _ ? i[B].value : C(t.min + B * t.step);
    a(e, U), r(e, !0), I.preventDefault();
  };
  An(() => {
    const I = (U) => {
      y(U.clientX);
    }, B = () => {
      h(!1), document.removeEventListener("mousemove", I), document.removeEventListener("mouseup", B);
    };
    return f && (document.addEventListener("mousemove", I), document.addEventListener("mouseup", B)), () => {
      document.removeEventListener("mousemove", I), document.removeEventListener("mouseup", B);
    };
  }, [f, y]);
  const k = () => {
    h(!0);
  };
  An(() => {
    const I = (U) => {
      y(U.touches[0].clientX);
    }, B = () => {
      h(!1), document.removeEventListener("touchmove", I), document.removeEventListener("touchend", B);
    };
    return f && (document.addEventListener("touchmove", I), document.addEventListener("touchend", B)), () => {
      document.removeEventListener("touchmove", I), document.removeEventListener("touchend", B);
    };
  }, [f, y]);
  const N = () => {
    h(!0);
  };
  return !i && !t ? null : /* @__PURE__ */ Mt(pd, { children: [
    /* @__PURE__ */ Re("div", { className: g, children: /* @__PURE__ */ Mt(
      "div",
      {
        ref: l,
        onClick: T,
        className: Hb.slider__bar,
        children: [
          /* @__PURE__ */ Re(
            "div",
            {
              className: Hb.slider__fill,
              style: {
                width: `${E()}%`
              }
            }
          ),
          /* @__PURE__ */ Re(
            "div",
            {
              ref: d,
              role: "slider",
              "aria-labelledby": `${e}-label`,
              "aria-valuemin": _ ? i[0].value : t.min,
              "aria-valuemax": _ ? i[v].value : t.max,
              "aria-valuenow": s[e],
              tabIndex: 0,
              onKeyDown: A,
              className: Hb.slider__thumb,
              style: { left: `${E()}%` },
              onMouseDown: k,
              onTouchStart: N,
              children: c && /* @__PURE__ */ Re("div", { className: p, children: _ ? (j = i[b]) == null ? void 0 : j.label : s[e] })
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ Re(Xh, { name: e })
  ] });
}, Jee = "_formTextArea_1y8xc_1", ete = {
  formTextArea: Jee,
  "formTextArea--error": "_formTextArea--error_1y8xc_22"
}, tte = Mn.bind(ete), joe = (n) => {
  const { name: e, placeholder: t, rows: i = 8, disabled: c, onPaste: a, onBlur: s } = n, { errors: r, touched: l } = gd(), d = tte("formTextArea", {
    "formTextArea--error": e in r && e in l
  });
  return /* @__PURE__ */ Mt(pd, { children: [
    /* @__PURE__ */ Re(
      Dm,
      {
        as: "textarea",
        name: e,
        className: d,
        placeholder: t,
        rows: i,
        disabled: c,
        id: e,
        ...s && { onBlur: s },
        ...a && { onPaste: a }
      }
    ),
    /* @__PURE__ */ Re(Xh, { name: e })
  ] });
};
function Lm(n) {
  this._maxSize = n, this.clear();
}
Lm.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Lm.prototype.get = function(n) {
  return this._values[n];
};
Lm.prototype.set = function(n, e) {
  return this._size >= this._maxSize && this.clear(), n in this._values || this._size++, this._values[n] = e;
};
var nte = /[^.^\]^[]+|(?=\[\]|\.\.)/g, B9 = /^\d+$/, rte = /^\d/, ite = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, ote = /^\s*(['"]?)(.*?)(\1)\s*$/, MT = 512, a6 = new Lm(MT), s6 = new Lm(MT), l6 = new Lm(MT), ym = {
  Cache: Lm,
  split: xx,
  normalizePath: Bw,
  setter: function(n) {
    var e = Bw(n);
    return s6.get(n) || s6.set(n, function(i, c) {
      for (var a = 0, s = e.length, r = i; a < s - 1; ) {
        var l = e[a];
        if (l === "__proto__" || l === "constructor" || l === "prototype")
          return i;
        r = r[e[a++]];
      }
      r[e[a]] = c;
    });
  },
  getter: function(n, e) {
    var t = Bw(n);
    return l6.get(n) || l6.set(n, function(c) {
      for (var a = 0, s = t.length; a < s; )
        if (c != null || !e) c = c[t[a++]];
        else return;
      return c;
    });
  },
  join: function(n) {
    return n.reduce(function(e, t) {
      return e + (PT(t) || B9.test(t) ? "[" + t + "]" : (e ? "." : "") + t);
    }, "");
  },
  forEach: function(n, e, t) {
    ate(Array.isArray(n) ? n : xx(n), e, t);
  }
};
function Bw(n) {
  return a6.get(n) || a6.set(
    n,
    xx(n).map(function(e) {
      return e.replace(ote, "$2");
    })
  );
}
function xx(n) {
  return n.match(nte) || [""];
}
function ate(n, e, t) {
  var i = n.length, c, a, s, r;
  for (a = 0; a < i; a++)
    c = n[a], c && (ute(c) && (c = '"' + c + '"'), r = PT(c), s = !r && /^\d+$/.test(c), e.call(t, c, r, s, a, n));
}
function PT(n) {
  return typeof n == "string" && n && ["'", '"'].indexOf(n.charAt(0)) !== -1;
}
function ste(n) {
  return n.match(rte) && !n.match(B9);
}
function lte(n) {
  return ite.test(n);
}
function ute(n) {
  return !PT(n) && (ste(n) || lte(n));
}
const cte = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, q2 = (n) => n.match(cte) || [], G2 = (n) => n[0].toUpperCase() + n.slice(1), jT = (n, e) => q2(n).join(e).toLowerCase(), F9 = (n) => q2(n).reduce(
  (e, t) => `${e}${e ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t.toLowerCase()}`,
  ""
), dte = (n) => G2(F9(n)), fte = (n) => jT(n, "_"), hte = (n) => jT(n, "-"), pte = (n) => G2(jT(n, " ")), mte = (n) => q2(n).map(G2).join(" ");
var Fw = {
  words: q2,
  upperFirst: G2,
  camelCase: F9,
  pascalCase: dte,
  snakeCase: fte,
  kebabCase: hte,
  sentenceCase: pte,
  titleCase: mte
}, BT = { exports: {} };
BT.exports = function(n) {
  return U9(gte(n), n);
};
BT.exports.array = U9;
function U9(n, e) {
  var t = n.length, i = new Array(t), c = {}, a = t, s = _te(e), r = yte(n);
  for (e.forEach(function(d) {
    if (!r.has(d[0]) || !r.has(d[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    c[a] || l(n[a], a, /* @__PURE__ */ new Set());
  return i;
  function l(d, f, h) {
    if (h.has(d)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(d);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!r.has(d))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(d));
    if (!c[f]) {
      c[f] = !0;
      var g = s.get(d) || /* @__PURE__ */ new Set();
      if (g = Array.from(g), f = g.length) {
        h.add(d);
        do {
          var _ = g[--f];
          l(_, r.get(_), h);
        } while (f);
        h.delete(d);
      }
      i[--t] = d;
    }
  }
}
function gte(n) {
  for (var e = /* @__PURE__ */ new Set(), t = 0, i = n.length; t < i; t++) {
    var c = n[t];
    e.add(c[0]), e.add(c[1]);
  }
  return Array.from(e);
}
function _te(n) {
  for (var e = /* @__PURE__ */ new Map(), t = 0, i = n.length; t < i; t++) {
    var c = n[t];
    e.has(c[0]) || e.set(c[0], /* @__PURE__ */ new Set()), e.has(c[1]) || e.set(c[1], /* @__PURE__ */ new Set()), e.get(c[0]).add(c[1]);
  }
  return e;
}
function yte(n) {
  for (var e = /* @__PURE__ */ new Map(), t = 0, i = n.length; t < i; t++)
    e.set(n[t], t);
  return e;
}
var vte = BT.exports;
const bte = /* @__PURE__ */ c0(vte), Ete = Object.prototype.toString, Ste = Error.prototype.toString, Cte = RegExp.prototype.toString, wte = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", xte = /^Symbol\((.*)\)(.*)$/;
function Tte(n) {
  return n != +n ? "NaN" : n === 0 && 1 / n < 0 ? "-0" : "" + n;
}
function u6(n, e = !1) {
  if (n == null || n === !0 || n === !1) return "" + n;
  const t = typeof n;
  if (t === "number") return Tte(n);
  if (t === "string") return e ? `"${n}"` : n;
  if (t === "function") return "[Function " + (n.name || "anonymous") + "]";
  if (t === "symbol") return wte.call(n).replace(xte, "Symbol($1)");
  const i = Ete.call(n).slice(8, -1);
  return i === "Date" ? isNaN(n.getTime()) ? "" + n : n.toISOString(n) : i === "Error" || n instanceof Error ? "[" + Ste.call(n) + "]" : i === "RegExp" ? Cte.call(n) : null;
}
function zh(n, e) {
  let t = u6(n, e);
  return t !== null ? t : JSON.stringify(n, function(i, c) {
    let a = u6(this[i], e);
    return a !== null ? a : c;
  }, 2);
}
function H9(n) {
  return n == null ? [] : [].concat(n);
}
let z9, V9, q9, Ate = /\$\{\s*(\w+)\s*\}/g;
z9 = Symbol.toStringTag;
class c6 {
  constructor(e, t, i, c) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[z9] = "Error", this.name = "ValidationError", this.value = t, this.path = i, this.type = c, this.errors = [], this.inner = [], H9(e).forEach((a) => {
      if (Xs.isError(a)) {
        this.errors.push(...a.errors);
        const s = a.inner.length ? a.inner : [a];
        this.inner.push(...s);
      } else
        this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
V9 = Symbol.hasInstance;
q9 = Symbol.toStringTag;
class Xs extends Error {
  static formatError(e, t) {
    const i = t.label || t.path || "this";
    return i !== t.path && (t = Object.assign({}, t, {
      path: i
    })), typeof e == "string" ? e.replace(Ate, (c, a) => zh(t[a])) : typeof e == "function" ? e(t) : e;
  }
  static isError(e) {
    return e && e.name === "ValidationError";
  }
  constructor(e, t, i, c, a) {
    const s = new c6(e, t, i, c);
    if (a)
      return s;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[q9] = "Error", this.name = s.name, this.message = s.message, this.type = s.type, this.value = s.value, this.path = s.path, this.errors = s.errors, this.inner = s.inner, Error.captureStackTrace && Error.captureStackTrace(this, Xs);
  }
  static [V9](e) {
    return c6[Symbol.hasInstance](e) || super[Symbol.hasInstance](e);
  }
}
let ad = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: n,
    type: e,
    value: t,
    originalValue: i
  }) => {
    const c = i != null && i !== t ? ` (cast from the value \`${zh(i, !0)}\`).` : ".";
    return e !== "mixed" ? `${n} must be a \`${e}\` type, but the final value was: \`${zh(t, !0)}\`` + c : `${n} must match the configured type. The validated value was: \`${zh(t, !0)}\`` + c;
  }
}, Ys = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, kte = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Tx = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, Ote = {
  isValue: "${path} field must be ${value}"
}, Ax = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Dte = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, Rte = {
  notType: (n) => {
    const {
      path: e,
      value: t,
      spec: i
    } = n, c = i.types.length;
    if (Array.isArray(t)) {
      if (t.length < c) return `${e} tuple value has too few items, expected a length of ${c} but got ${t.length} for value: \`${zh(t, !0)}\``;
      if (t.length > c) return `${e} tuple value has too many items, expected a length of ${c} but got ${t.length} for value: \`${zh(t, !0)}\``;
    }
    return Xs.formatError(ad.notType, n);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: ad,
  string: Ys,
  number: kte,
  date: Tx,
  object: Ax,
  array: Dte,
  boolean: Ote,
  tuple: Rte
});
const FT = (n) => n && n.__isYupSchema__;
class h2 {
  static fromOptions(e, t) {
    if (!t.then && !t.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: c,
      otherwise: a
    } = t, s = typeof i == "function" ? i : (...r) => r.every((l) => l === i);
    return new h2(e, (r, l) => {
      var d;
      let f = s(...r) ? c : a;
      return (d = f == null ? void 0 : f(l)) != null ? d : l;
    });
  }
  constructor(e, t) {
    this.fn = void 0, this.refs = e, this.refs = e, this.fn = t;
  }
  resolve(e, t) {
    let i = this.refs.map((a) => (
      // TODO: ? operator here?
      a.getValue(t == null ? void 0 : t.value, t == null ? void 0 : t.parent, t == null ? void 0 : t.context)
    )), c = this.fn(i, e, t);
    if (c === void 0 || // @ts-ignore this can be base
    c === e)
      return e;
    if (!FT(c)) throw new TypeError("conditions must return a schema object");
    return c.resolve(t);
  }
}
const Rb = {
  context: "$",
  value: "."
};
class Mm {
  constructor(e, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string") throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Rb.context, this.isValue = this.key[0] === Rb.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? Rb.context : this.isValue ? Rb.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && ym.getter(this.path, !0), this.map = t.map;
  }
  getValue(e, t, i) {
    let c = this.isContext ? i : this.isValue ? e : t;
    return this.getter && (c = this.getter(c || {})), this.map && (c = this.map(c)), c;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(e, t) {
    return this.getValue(e, t == null ? void 0 : t.parent, t == null ? void 0 : t.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
}
Mm.prototype.__isYupRef = !0;
const pm = (n) => n == null;
function Xg(n) {
  function e({
    value: t,
    path: i = "",
    options: c,
    originalValue: a,
    schema: s
  }, r, l) {
    const {
      name: d,
      test: f,
      params: h,
      message: p,
      skipAbsent: g
    } = n;
    let {
      parent: _,
      context: b,
      abortEarly: v = s.spec.abortEarly,
      disableStackTrace: E = s.spec.disableStackTrace
    } = c;
    function C(U) {
      return Mm.isRef(U) ? U.getValue(t, _, b) : U;
    }
    function y(U = {}) {
      const H = Object.assign({
        value: t,
        originalValue: a,
        label: s.spec.label,
        path: U.path || i,
        spec: s.spec,
        disableStackTrace: U.disableStackTrace || E
      }, h, U.params);
      for (const Y of Object.keys(H)) H[Y] = C(H[Y]);
      const Q = new Xs(Xs.formatError(U.message || p, H), t, H.path, U.type || d, H.disableStackTrace);
      return Q.params = H, Q;
    }
    const T = v ? r : l;
    let A = {
      path: i,
      parent: _,
      type: d,
      from: c.from,
      createError: y,
      resolve: C,
      options: c,
      originalValue: a,
      schema: s
    };
    const k = (U) => {
      Xs.isError(U) ? T(U) : U ? l(null) : T(y());
    }, N = (U) => {
      Xs.isError(U) ? T(U) : r(U);
    };
    if (g && pm(t))
      return k(!0);
    let I;
    try {
      var B;
      if (I = f.call(A, t, A), typeof ((B = I) == null ? void 0 : B.then) == "function") {
        if (c.sync)
          throw new Error(`Validation test of type: "${A.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(I).then(k, N);
      }
    } catch (U) {
      N(U);
      return;
    }
    k(I);
  }
  return e.OPTIONS = n, e;
}
function Nte(n, e, t, i = t) {
  let c, a, s;
  return e ? (ym.forEach(e, (r, l, d) => {
    let f = l ? r.slice(1, r.length - 1) : r;
    n = n.resolve({
      context: i,
      parent: c,
      value: t
    });
    let h = n.type === "tuple", p = d ? parseInt(f, 10) : 0;
    if (n.innerType || h) {
      if (h && !d) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${s}" must contain an index to the tuple element, e.g. "${s}[0]"`);
      if (t && p >= t.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${r}, in the path: ${e}. because there is no value at that index. `);
      c = t, t = t && t[p], n = h ? n.spec.types[p] : n.innerType;
    }
    if (!d) {
      if (!n.fields || !n.fields[f]) throw new Error(`The schema does not contain the path: ${e}. (failed at: ${s} which is a type: "${n.type}")`);
      c = t, t = t && t[f], n = n.fields[f];
    }
    a = f, s = l ? "[" + r + "]" : "." + r;
  }), {
    schema: n,
    parent: c,
    parentPath: a
  }) : {
    parent: c,
    parentPath: e,
    schema: n
  };
}
class p2 extends Set {
  describe() {
    const e = [];
    for (const t of this.values())
      e.push(Mm.isRef(t) ? t.describe() : t);
    return e;
  }
  resolveAll(e) {
    let t = [];
    for (const i of this.values())
      t.push(e(i));
    return t;
  }
  clone() {
    return new p2(this.values());
  }
  merge(e, t) {
    const i = this.clone();
    return e.forEach((c) => i.add(c)), t.forEach((c) => i.delete(c)), i;
  }
}
function Jg(n, e = /* @__PURE__ */ new Map()) {
  if (FT(n) || !n || typeof n != "object") return n;
  if (e.has(n)) return e.get(n);
  let t;
  if (n instanceof Date)
    t = new Date(n.getTime()), e.set(n, t);
  else if (n instanceof RegExp)
    t = new RegExp(n), e.set(n, t);
  else if (Array.isArray(n)) {
    t = new Array(n.length), e.set(n, t);
    for (let i = 0; i < n.length; i++) t[i] = Jg(n[i], e);
  } else if (n instanceof Map) {
    t = /* @__PURE__ */ new Map(), e.set(n, t);
    for (const [i, c] of n.entries()) t.set(i, Jg(c, e));
  } else if (n instanceof Set) {
    t = /* @__PURE__ */ new Set(), e.set(n, t);
    for (const i of n) t.add(Jg(i, e));
  } else if (n instanceof Object) {
    t = {}, e.set(n, t);
    for (const [i, c] of Object.entries(n)) t[i] = Jg(c, e);
  } else
    throw Error(`Unable to clone ${n}`);
  return t;
}
class hd {
  constructor(e) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new p2(), this._blacklist = new p2(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(ad.notType);
    }), this.type = e.type, this._typeCheck = e.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, e == null ? void 0 : e.spec), this.withMutation((t) => {
      t.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(e) {
    if (this._mutate)
      return e && Object.assign(this.spec, e), this;
    const t = Object.create(Object.getPrototypeOf(this));
    return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = Jg(Object.assign({}, this.spec, e)), t;
  }
  label(e) {
    let t = this.clone();
    return t.spec.label = e, t;
  }
  meta(...e) {
    if (e.length === 0) return this.spec.meta;
    let t = this.clone();
    return t.spec.meta = Object.assign(t.spec.meta || {}, e[0]), t;
  }
  withMutation(e) {
    let t = this._mutate;
    this._mutate = !0;
    let i = e(this);
    return this._mutate = t, i;
  }
  concat(e) {
    if (!e || e === this) return this;
    if (e.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
    let t = this, i = e.clone();
    const c = Object.assign({}, t.spec, i.spec);
    return i.spec = c, i.internalTests = Object.assign({}, t.internalTests, i.internalTests), i._whitelist = t._whitelist.merge(e._whitelist, e._blacklist), i._blacklist = t._blacklist.merge(e._blacklist, e._whitelist), i.tests = t.tests, i.exclusiveTests = t.exclusiveTests, i.withMutation((a) => {
      e.tests.forEach((s) => {
        a.test(s.OPTIONS);
      });
    }), i.transforms = [...t.transforms, ...i.transforms], i;
  }
  isType(e) {
    return e == null ? !!(this.spec.nullable && e === null || this.spec.optional && e === void 0) : this._typeCheck(e);
  }
  resolve(e) {
    let t = this;
    if (t.conditions.length) {
      let i = t.conditions;
      t = t.clone(), t.conditions = [], t = i.reduce((c, a) => a.resolve(c, e), t), t = t.resolve(e);
    }
    return t;
  }
  resolveOptions(e) {
    var t, i, c, a;
    return Object.assign({}, e, {
      from: e.from || [],
      strict: (t = e.strict) != null ? t : this.spec.strict,
      abortEarly: (i = e.abortEarly) != null ? i : this.spec.abortEarly,
      recursive: (c = e.recursive) != null ? c : this.spec.recursive,
      disableStackTrace: (a = e.disableStackTrace) != null ? a : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(e, t = {}) {
    let i = this.resolve(Object.assign({
      value: e
    }, t)), c = t.assert === "ignore-optionality", a = i._cast(e, t);
    if (t.assert !== !1 && !i.isType(a)) {
      if (c && pm(a))
        return a;
      let s = zh(e), r = zh(a);
      throw new TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${i.type}". 

attempted value: ${s} 
` + (r !== s ? `result of cast: ${r}` : ""));
    }
    return a;
  }
  _cast(e, t) {
    let i = e === void 0 ? e : this.transforms.reduce((c, a) => a.call(this, c, e, this), e);
    return i === void 0 && (i = this.getDefault(t)), i;
  }
  _validate(e, t = {}, i, c) {
    let {
      path: a,
      originalValue: s = e,
      strict: r = this.spec.strict
    } = t, l = e;
    r || (l = this._cast(l, Object.assign({
      assert: !1
    }, t)));
    let d = [];
    for (let f of Object.values(this.internalTests))
      f && d.push(f);
    this.runTests({
      path: a,
      value: l,
      originalValue: s,
      options: t,
      tests: d
    }, i, (f) => {
      if (f.length)
        return c(f, l);
      this.runTests({
        path: a,
        value: l,
        originalValue: s,
        options: t,
        tests: this.tests
      }, i, c);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(e, t, i) {
    let c = !1, {
      tests: a,
      value: s,
      originalValue: r,
      path: l,
      options: d
    } = e, f = (b) => {
      c || (c = !0, t(b, s));
    }, h = (b) => {
      c || (c = !0, i(b, s));
    }, p = a.length, g = [];
    if (!p) return h([]);
    let _ = {
      value: s,
      originalValue: r,
      path: l,
      options: d,
      schema: this
    };
    for (let b = 0; b < a.length; b++) {
      const v = a[b];
      v(_, f, function(C) {
        C && (Array.isArray(C) ? g.push(...C) : g.push(C)), --p <= 0 && h(g);
      });
    }
  }
  asNestedTest({
    key: e,
    index: t,
    parent: i,
    parentPath: c,
    originalParent: a,
    options: s
  }) {
    const r = e ?? t;
    if (r == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const l = typeof r == "number";
    let d = i[r];
    const f = Object.assign({}, s, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: i,
      value: d,
      originalValue: a[r],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [l ? "index" : "key"]: r,
      path: l || r.includes(".") ? `${c || ""}[${l ? r : `"${r}"`}]` : (c ? `${c}.` : "") + e
    });
    return (h, p, g) => this.resolve(f)._validate(d, f, p, g);
  }
  validate(e, t) {
    var i;
    let c = this.resolve(Object.assign({}, t, {
      value: e
    })), a = (i = t == null ? void 0 : t.disableStackTrace) != null ? i : c.spec.disableStackTrace;
    return new Promise((s, r) => c._validate(e, t, (l, d) => {
      Xs.isError(l) && (l.value = d), r(l);
    }, (l, d) => {
      l.length ? r(new Xs(l, d, void 0, void 0, a)) : s(d);
    }));
  }
  validateSync(e, t) {
    var i;
    let c = this.resolve(Object.assign({}, t, {
      value: e
    })), a, s = (i = t == null ? void 0 : t.disableStackTrace) != null ? i : c.spec.disableStackTrace;
    return c._validate(e, Object.assign({}, t, {
      sync: !0
    }), (r, l) => {
      throw Xs.isError(r) && (r.value = l), r;
    }, (r, l) => {
      if (r.length) throw new Xs(r, e, void 0, void 0, s);
      a = l;
    }), a;
  }
  isValid(e, t) {
    return this.validate(e, t).then(() => !0, (i) => {
      if (Xs.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(e, t) {
    try {
      return this.validateSync(e, t), !0;
    } catch (i) {
      if (Xs.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault(e) {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this, e) : Jg(t);
  }
  getDefault(e) {
    return this.resolve(e || {})._getDefault(e);
  }
  default(e) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: e
    });
  }
  strict(e = !0) {
    return this.clone({
      strict: e
    });
  }
  nullability(e, t) {
    const i = this.clone({
      nullable: e
    });
    return i.internalTests.nullable = Xg({
      message: t,
      name: "nullable",
      test(c) {
        return c === null ? this.schema.spec.nullable : !0;
      }
    }), i;
  }
  optionality(e, t) {
    const i = this.clone({
      optional: e
    });
    return i.internalTests.optionality = Xg({
      message: t,
      name: "optionality",
      test(c) {
        return c === void 0 ? this.schema.spec.optional : !0;
      }
    }), i;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(e = ad.defined) {
    return this.optionality(!1, e);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(e = ad.notNull) {
    return this.nullability(!1, e);
  }
  required(e = ad.required) {
    return this.clone().withMutation((t) => t.nonNullable(e).defined(e));
  }
  notRequired() {
    return this.clone().withMutation((e) => e.nullable().optional());
  }
  transform(e) {
    let t = this.clone();
    return t.transforms.push(e), t;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...e) {
    let t;
    if (e.length === 1 ? typeof e[0] == "function" ? t = {
      test: e[0]
    } : t = e[0] : e.length === 2 ? t = {
      name: e[0],
      test: e[1]
    } : t = {
      name: e[0],
      message: e[1],
      test: e[2]
    }, t.message === void 0 && (t.message = ad.default), typeof t.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), c = Xg(t), a = t.exclusive || t.name && i.exclusiveTests[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return t.name && (i.exclusiveTests[t.name] = !!t.exclusive), i.tests = i.tests.filter((s) => !(s.OPTIONS.name === t.name && (a || s.OPTIONS.test === c.OPTIONS.test))), i.tests.push(c), i;
  }
  when(e, t) {
    !Array.isArray(e) && typeof e != "string" && (t = e, e = ".");
    let i = this.clone(), c = H9(e).map((a) => new Mm(a));
    return c.forEach((a) => {
      a.isSibling && i.deps.push(a.key);
    }), i.conditions.push(typeof t == "function" ? new h2(c, t) : h2.fromOptions(c, t)), i;
  }
  typeError(e) {
    let t = this.clone();
    return t.internalTests.typeError = Xg({
      message: e,
      name: "typeError",
      skipAbsent: !0,
      test(i) {
        return this.schema._typeCheck(i) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), t;
  }
  oneOf(e, t = ad.oneOf) {
    let i = this.clone();
    return e.forEach((c) => {
      i._whitelist.add(c), i._blacklist.delete(c);
    }), i.internalTests.whiteList = Xg({
      message: t,
      name: "oneOf",
      skipAbsent: !0,
      test(c) {
        let a = this.schema._whitelist, s = a.resolveAll(this.resolve);
        return s.includes(c) ? !0 : this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: s
          }
        });
      }
    }), i;
  }
  notOneOf(e, t = ad.notOneOf) {
    let i = this.clone();
    return e.forEach((c) => {
      i._blacklist.add(c), i._whitelist.delete(c);
    }), i.internalTests.blacklist = Xg({
      message: t,
      name: "notOneOf",
      test(c) {
        let a = this.schema._blacklist, s = a.resolveAll(this.resolve);
        return s.includes(c) ? this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: s
          }
        }) : !0;
      }
    }), i;
  }
  strip(e = !0) {
    let t = this.clone();
    return t.spec.strip = e, t;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(e) {
    const t = (e ? this.resolve(e) : this).clone(), {
      label: i,
      meta: c,
      optional: a,
      nullable: s
    } = t.spec;
    return {
      meta: c,
      label: i,
      optional: a,
      nullable: s,
      default: t.getDefault(e),
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((l) => ({
        name: l.OPTIONS.name,
        params: l.OPTIONS.params
      })).filter((l, d, f) => f.findIndex((h) => h.name === l.name) === d)
    };
  }
}
hd.prototype.__isYupSchema__ = !0;
for (const n of ["validate", "validateSync"]) hd.prototype[`${n}At`] = function(e, t, i = {}) {
  const {
    parent: c,
    parentPath: a,
    schema: s
  } = Nte(this, e, t, i.context);
  return s[n](c && c[a], Object.assign({}, i, {
    parent: c,
    path: e
  }));
};
for (const n of ["equals", "is"]) hd.prototype[n] = hd.prototype.oneOf;
for (const n of ["not", "nope"]) hd.prototype[n] = hd.prototype.notOneOf;
const Ite = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Lte(n) {
  const e = kx(n);
  if (!e) return Date.parse ? Date.parse(n) : Number.NaN;
  if (e.z === void 0 && e.plusMinus === void 0)
    return new Date(e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond).valueOf();
  let t = 0;
  return e.z !== "Z" && e.plusMinus !== void 0 && (t = e.hourOffset * 60 + e.minuteOffset, e.plusMinus === "+" && (t = 0 - t)), Date.UTC(e.year, e.month, e.day, e.hour, e.minute + t, e.second, e.millisecond);
}
function kx(n) {
  var e, t;
  const i = Ite.exec(n);
  return i ? {
    year: lf(i[1]),
    month: lf(i[2], 1) - 1,
    day: lf(i[3], 1),
    hour: lf(i[4]),
    minute: lf(i[5]),
    second: lf(i[6]),
    millisecond: i[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      lf(i[7].substring(0, 3))
    ) : 0,
    precision: (e = (t = i[7]) == null ? void 0 : t.length) != null ? e : void 0,
    z: i[8] || void 0,
    plusMinus: i[9] || void 0,
    hourOffset: lf(i[10]),
    minuteOffset: lf(i[11])
  } : null;
}
function lf(n, e = 0) {
  return Number(n) || e;
}
let Mte = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), Pte = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), jte = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Bte = "^\\d{4}-\\d{2}-\\d{2}", Fte = "\\d{2}:\\d{2}:\\d{2}", Ute = "(([+-]\\d{2}(:?\\d{2})?)|Z)", Hte = new RegExp(`${Bte}T${Fte}(\\.\\d+)?${Ute}$`), zte = (n) => pm(n) || n === n.trim(), Vte = {}.toString();
function qte() {
  return new G9();
}
class G9 extends hd {
  constructor() {
    super({
      type: "string",
      check(e) {
        return e instanceof String && (e = e.valueOf()), typeof e == "string";
      }
    }), this.withMutation(() => {
      this.transform((e, t, i) => {
        if (!i.spec.coerce || i.isType(e) || Array.isArray(e)) return e;
        const c = e != null && e.toString ? e.toString() : e;
        return c === Vte ? e : c;
      });
    });
  }
  required(e) {
    return super.required(e).withMutation((t) => t.test({
      message: e || ad.required,
      name: "required",
      skipAbsent: !0,
      test: (i) => !!i.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((e) => (e.tests = e.tests.filter((t) => t.OPTIONS.name !== "required"), e));
  }
  length(e, t = Ys.length) {
    return this.test({
      message: t,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      skipAbsent: !0,
      test(i) {
        return i.length === this.resolve(e);
      }
    });
  }
  min(e, t = Ys.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(i) {
        return i.length >= this.resolve(e);
      }
    });
  }
  max(e, t = Ys.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: t,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(i) {
        return i.length <= this.resolve(e);
      }
    });
  }
  matches(e, t) {
    let i = !1, c, a;
    return t && (typeof t == "object" ? {
      excludeEmptyString: i = !1,
      message: c,
      name: a
    } = t : c = t), this.test({
      name: a || "matches",
      message: c || Ys.matches,
      params: {
        regex: e
      },
      skipAbsent: !0,
      test: (s) => s === "" && i || s.search(e) !== -1
    });
  }
  email(e = Ys.email) {
    return this.matches(Mte, {
      name: "email",
      message: e,
      excludeEmptyString: !0
    });
  }
  url(e = Ys.url) {
    return this.matches(Pte, {
      name: "url",
      message: e,
      excludeEmptyString: !0
    });
  }
  uuid(e = Ys.uuid) {
    return this.matches(jte, {
      name: "uuid",
      message: e,
      excludeEmptyString: !1
    });
  }
  datetime(e) {
    let t = "", i, c;
    return e && (typeof e == "object" ? {
      message: t = "",
      allowOffset: i = !1,
      precision: c = void 0
    } = e : t = e), this.matches(Hte, {
      name: "datetime",
      message: t || Ys.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: t || Ys.datetime_offset,
      params: {
        allowOffset: i
      },
      skipAbsent: !0,
      test: (a) => {
        if (!a || i) return !0;
        const s = kx(a);
        return s ? !!s.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: t || Ys.datetime_precision,
      params: {
        precision: c
      },
      skipAbsent: !0,
      test: (a) => {
        if (!a || c == null) return !0;
        const s = kx(a);
        return s ? s.precision === c : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((e) => e === null ? "" : e);
  }
  trim(e = Ys.trim) {
    return this.transform((t) => t != null ? t.trim() : t).test({
      message: e,
      name: "trim",
      test: zte
    });
  }
  lowercase(e = Ys.lowercase) {
    return this.transform((t) => pm(t) ? t : t.toLowerCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => pm(t) || t === t.toLowerCase()
    });
  }
  uppercase(e = Ys.uppercase) {
    return this.transform((t) => pm(t) ? t : t.toUpperCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => pm(t) || t === t.toUpperCase()
    });
  }
}
qte.prototype = G9.prototype;
let Gte = /* @__PURE__ */ new Date(""), Wte = (n) => Object.prototype.toString.call(n) === "[object Date]";
class W2 extends hd {
  constructor() {
    super({
      type: "date",
      check(e) {
        return Wte(e) && !isNaN(e.getTime());
      }
    }), this.withMutation(() => {
      this.transform((e, t, i) => !i.spec.coerce || i.isType(e) || e === null ? e : (e = Lte(e), isNaN(e) ? W2.INVALID_DATE : new Date(e)));
    });
  }
  prepareParam(e, t) {
    let i;
    if (Mm.isRef(e))
      i = e;
    else {
      let c = this.cast(e);
      if (!this._typeCheck(c)) throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = c;
    }
    return i;
  }
  min(e, t = Tx.min) {
    let i = this.prepareParam(e, "min");
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(c) {
        return c >= this.resolve(i);
      }
    });
  }
  max(e, t = Tx.max) {
    let i = this.prepareParam(e, "max");
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(c) {
        return c <= this.resolve(i);
      }
    });
  }
}
W2.INVALID_DATE = Gte;
W2.prototype;
function $te(n, e = []) {
  let t = [], i = /* @__PURE__ */ new Set(), c = new Set(e.map(([s, r]) => `${s}-${r}`));
  function a(s, r) {
    let l = ym.split(s)[0];
    i.add(l), c.has(`${r}-${l}`) || t.push([r, l]);
  }
  for (const s of Object.keys(n)) {
    let r = n[s];
    i.add(s), Mm.isRef(r) && r.isSibling ? a(r.path, s) : FT(r) && "deps" in r && r.deps.forEach((l) => a(l, s));
  }
  return bte.array(Array.from(i), t).reverse();
}
function d6(n, e) {
  let t = 1 / 0;
  return n.some((i, c) => {
    var a;
    if ((a = e.path) != null && a.includes(i))
      return t = c, !0;
  }), t;
}
function W9(n) {
  return (e, t) => d6(n, e) - d6(n, t);
}
const Yte = (n, e, t) => {
  if (typeof n != "string")
    return n;
  let i = n;
  try {
    i = JSON.parse(n);
  } catch {
  }
  return t.isType(i) ? i : n;
};
function zb(n) {
  if ("fields" in n) {
    const e = {};
    for (const [t, i] of Object.entries(n.fields))
      e[t] = zb(i);
    return n.setFields(e);
  }
  if (n.type === "array") {
    const e = n.optional();
    return e.innerType && (e.innerType = zb(e.innerType)), e;
  }
  return n.type === "tuple" ? n.optional().clone({
    types: n.spec.types.map(zb)
  }) : "optional" in n ? n.optional() : n;
}
const Xte = (n, e) => {
  const t = [...ym.normalizePath(e)];
  if (t.length === 1) return t[0] in n;
  let i = t.pop(), c = ym.getter(ym.join(t), !0)(n);
  return !!(c && i in c);
};
let f6 = (n) => Object.prototype.toString.call(n) === "[object Object]";
function Kte(n, e) {
  let t = Object.keys(n.fields);
  return Object.keys(e).filter((i) => t.indexOf(i) === -1);
}
const Qte = W9([]);
function Zte(n) {
  return new $9(n);
}
class $9 extends hd {
  constructor(e) {
    super({
      type: "object",
      check(t) {
        return f6(t) || typeof t == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Qte, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      e && this.shape(e);
    });
  }
  _cast(e, t = {}) {
    var i;
    let c = super._cast(e, t);
    if (c === void 0) return this.getDefault(t);
    if (!this._typeCheck(c)) return c;
    let a = this.fields, s = (i = t.stripUnknown) != null ? i : this.spec.noUnknown, r = [].concat(this._nodes, Object.keys(c).filter((h) => !this._nodes.includes(h))), l = {}, d = Object.assign({}, t, {
      parent: l,
      __validating: t.__validating || !1
    }), f = !1;
    for (const h of r) {
      let p = a[h], g = h in c;
      if (p) {
        let _, b = c[h];
        d.path = (t.path ? `${t.path}.` : "") + h, p = p.resolve({
          value: b,
          context: t.context,
          parent: l
        });
        let v = p instanceof hd ? p.spec : void 0, E = v == null ? void 0 : v.strict;
        if (v != null && v.strip) {
          f = f || h in c;
          continue;
        }
        _ = !t.__validating || !E ? (
          // TODO: use _cast, this is double resolving
          p.cast(c[h], d)
        ) : c[h], _ !== void 0 && (l[h] = _);
      } else g && !s && (l[h] = c[h]);
      (g !== h in l || l[h] !== c[h]) && (f = !0);
    }
    return f ? l : c;
  }
  _validate(e, t = {}, i, c) {
    let {
      from: a = [],
      originalValue: s = e,
      recursive: r = this.spec.recursive
    } = t;
    t.from = [{
      schema: this,
      value: s
    }, ...a], t.__validating = !0, t.originalValue = s, super._validate(e, t, i, (l, d) => {
      if (!r || !f6(d)) {
        c(l, d);
        return;
      }
      s = s || d;
      let f = [];
      for (let h of this._nodes) {
        let p = this.fields[h];
        !p || Mm.isRef(p) || f.push(p.asNestedTest({
          options: t,
          key: h,
          parent: d,
          parentPath: t.path,
          originalParent: s
        }));
      }
      this.runTests({
        tests: f,
        value: d,
        originalValue: s,
        options: t
      }, i, (h) => {
        c(h.sort(this._sortErrors).concat(l), d);
      });
    });
  }
  clone(e) {
    const t = super.clone(e);
    return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(e) {
    let t = super.concat(e), i = t.fields;
    for (let [c, a] of Object.entries(this.fields)) {
      const s = i[c];
      i[c] = s === void 0 ? a : s;
    }
    return t.withMutation((c) => (
      // XXX: excludes here is wrong
      c.setFields(i, [...this._excludedEdges, ...e._excludedEdges])
    ));
  }
  _getDefault(e) {
    if ("default" in this.spec)
      return super._getDefault(e);
    if (!this._nodes.length)
      return;
    let t = {};
    return this._nodes.forEach((i) => {
      var c;
      const a = this.fields[i];
      let s = e;
      (c = s) != null && c.value && (s = Object.assign({}, s, {
        parent: s.value,
        value: s.value[i]
      })), t[i] = a && "getDefault" in a ? a.getDefault(s) : void 0;
    }), t;
  }
  setFields(e, t) {
    let i = this.clone();
    return i.fields = e, i._nodes = $te(e, t), i._sortErrors = W9(Object.keys(e)), t && (i._excludedEdges = t), i;
  }
  shape(e, t = []) {
    return this.clone().withMutation((i) => {
      let c = i._excludedEdges;
      return t.length && (Array.isArray(t[0]) || (t = [t]), c = [...i._excludedEdges, ...t]), i.setFields(Object.assign(i.fields, e), c);
    });
  }
  partial() {
    const e = {};
    for (const [t, i] of Object.entries(this.fields))
      e[t] = "optional" in i && i.optional instanceof Function ? i.optional() : i;
    return this.setFields(e);
  }
  deepPartial() {
    return zb(this);
  }
  pick(e) {
    const t = {};
    for (const i of e)
      this.fields[i] && (t[i] = this.fields[i]);
    return this.setFields(t, this._excludedEdges.filter(([i, c]) => e.includes(i) && e.includes(c)));
  }
  omit(e) {
    const t = [];
    for (const i of Object.keys(this.fields))
      e.includes(i) || t.push(i);
    return this.pick(t);
  }
  from(e, t, i) {
    let c = ym.getter(e, !0);
    return this.transform((a) => {
      if (!a) return a;
      let s = a;
      return Xte(a, e) && (s = Object.assign({}, a), i || delete s[e], s[t] = c(a)), s;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Yte);
  }
  noUnknown(e = !0, t = Ax.noUnknown) {
    typeof e != "boolean" && (t = e, e = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(c) {
        if (c == null) return !0;
        const a = Kte(this.schema, c);
        return !e || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = e, i;
  }
  unknown(e = !0, t = Ax.noUnknown) {
    return this.noUnknown(!e, t);
  }
  transformKeys(e) {
    return this.transform((t) => {
      if (!t) return t;
      const i = {};
      for (const c of Object.keys(t)) i[e(c)] = t[c];
      return i;
    });
  }
  camelCase() {
    return this.transformKeys(Fw.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Fw.snakeCase);
  }
  constantCase() {
    return this.transformKeys((e) => Fw.snakeCase(e).toUpperCase());
  }
  describe(e) {
    const t = (e ? this.resolve(e) : this).clone(), i = super.describe(e);
    i.fields = {};
    for (const [a, s] of Object.entries(t.fields)) {
      var c;
      let r = e;
      (c = r) != null && c.value && (r = Object.assign({}, r, {
        parent: r.value,
        value: r.value[a]
      })), i.fields[a] = s.describe(r);
    }
    return i;
  }
}
Zte.prototype = $9.prototype;
const Z_ = Mn.bind(cX), Boe = (n) => {
  const { translations: e } = n, { user: t, accountId: i, logout: c, changeAccount: a, changeLanguage: s } = U6(), [r, l] = Wn(!1), d = zn(null);
  Fx([d], () => {
    l(!1);
  });
  const f = () => {
    l(!r);
  }, h = () => {
    c && c();
  }, p = (v) => {
    l(!1), a(v);
  }, g = (v) => {
    l(!1), s(v);
  }, _ = (v) => {
    if (!t) return "";
    const E = t.accounts.find(
      (C) => C.id === v
    );
    return E ? E.name : "";
  }, b = () => {
    const v = t == null ? void 0 : t.accounts.find(
      (y) => y.id === i
    );
    if (!v) return "";
    const E = v.name.trim().split(" ");
    let C = "";
    return E.length > 1 ? C = E[0][0] + E[1][0] : C = v.name[0] + v.name[1], C;
  };
  return An(() => {
  }, [t]), !t || !i ? null : /* @__PURE__ */ Mt("div", { ref: d, className: Z_("userMenu"), children: [
    /* @__PURE__ */ Re("div", { className: Z_("userMenu__button"), onClick: f, children: /* @__PURE__ */ Re("div", { className: Z_("userMenu__name"), children: b() }) }),
    /* @__PURE__ */ Mt(
      "div",
      {
        className: Z_("userMenu__dropdown", {
          "userMenu__dropdown--open": r
        }),
        children: [
          /* @__PURE__ */ Mt(a0, { variant: "h4", children: [
            t.firstname,
            " ",
            t.lastname
          ] }),
          /* @__PURE__ */ Mt("div", { className: Z_("userMenu__selectGrid"), children: [
            t.accounts.length > 1 && /* @__PURE__ */ Mt("div", { style: { textAlign: "left" }, children: [
              /* @__PURE__ */ Re(pO, { htmlFor: "switch_account", children: e.switch_account }),
              /* @__PURE__ */ Re(
                y4,
                {
                  block: !0,
                  variant: "outline",
                  label: _(i),
                  children: t.accounts.map((v) => /* @__PURE__ */ Re(
                    Qv,
                    {
                      label: v.name,
                      onClick: () => {
                        p(v.id);
                      }
                    },
                    v.id
                  ))
                }
              )
            ] }),
            /* @__PURE__ */ Mt("div", { style: { textAlign: "left" }, children: [
              /* @__PURE__ */ Re(pO, { htmlFor: "switch_language", children: e.switch_language }),
              /* @__PURE__ */ Mt(
                y4,
                {
                  block: !0,
                  variant: "outline",
                  width: "100%",
                  label: e.languages[t.language],
                  children: [
                    /* @__PURE__ */ Re(
                      Qv,
                      {
                        onClick: () => g("nl"),
                        label: e.languages.nl
                      }
                    ),
                    /* @__PURE__ */ Re(
                      Qv,
                      {
                        onClick: () => g("fr"),
                        label: e.languages.fr
                      }
                    ),
                    /* @__PURE__ */ Re(
                      Qv,
                      {
                        onClick: () => g("en"),
                        label: e.languages.en
                      }
                    )
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ Re(
            Fh,
            {
              block: !0,
              variant: "link",
              onClick: h,
              color: "error",
              children: e.logout
            }
          )
        ]
      }
    )
  ] });
};
function Jte() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return li(
    () => (i) => {
      e.forEach((c) => c(i));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  );
}
const $2 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function E0(n) {
  const e = Object.prototype.toString.call(n);
  return e === "[object Window]" || // In Electron context the Window object serializes to [object global]
  e === "[object global]";
}
function UT(n) {
  return "nodeType" in n;
}
function ys(n) {
  var e, t;
  return n ? E0(n) ? n : UT(n) && (e = (t = n.ownerDocument) == null ? void 0 : t.defaultView) != null ? e : window : window;
}
function HT(n) {
  const {
    Document: e
  } = ys(n);
  return n instanceof e;
}
function q1(n) {
  return E0(n) ? !1 : n instanceof ys(n).HTMLElement;
}
function Y9(n) {
  return n instanceof ys(n).SVGElement;
}
function S0(n) {
  return n ? E0(n) ? n.document : UT(n) ? HT(n) ? n : q1(n) || Y9(n) ? n.ownerDocument : document : document : document;
}
const uu = $2 ? L6 : An;
function Y2(n) {
  const e = zn(n);
  return uu(() => {
    e.current = n;
  }), hr(function() {
    for (var t = arguments.length, i = new Array(t), c = 0; c < t; c++)
      i[c] = arguments[c];
    return e.current == null ? void 0 : e.current(...i);
  }, []);
}
function ene() {
  const n = zn(null), e = hr((i, c) => {
    n.current = setInterval(i, c);
  }, []), t = hr(() => {
    n.current !== null && (clearInterval(n.current), n.current = null);
  }, []);
  return [e, t];
}
function N1(n, e) {
  e === void 0 && (e = [n]);
  const t = zn(n);
  return uu(() => {
    t.current !== n && (t.current = n);
  }, e), t;
}
function G1(n, e) {
  const t = zn();
  return li(
    () => {
      const i = n(t.current);
      return t.current = i, i;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
}
function m2(n) {
  const e = Y2(n), t = zn(null), i = hr(
    (c) => {
      c !== t.current && (e == null || e(c, t.current)), t.current = c;
    },
    //eslint-disable-next-line
    []
  );
  return [t, i];
}
function g2(n) {
  const e = zn();
  return An(() => {
    e.current = n;
  }, [n]), e.current;
}
let Uw = {};
function W1(n, e) {
  return li(() => {
    if (e)
      return e;
    const t = Uw[n] == null ? 0 : Uw[n] + 1;
    return Uw[n] = t, n + "-" + t;
  }, [n, e]);
}
function X9(n) {
  return function(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++)
      i[c - 1] = arguments[c];
    return i.reduce((a, s) => {
      const r = Object.entries(s);
      for (const [l, d] of r) {
        const f = a[l];
        f != null && (a[l] = f + n * d);
      }
      return a;
    }, {
      ...e
    });
  };
}
const i0 = /* @__PURE__ */ X9(1), I1 = /* @__PURE__ */ X9(-1);
function tne(n) {
  return "clientX" in n && "clientY" in n;
}
function X2(n) {
  if (!n)
    return !1;
  const {
    KeyboardEvent: e
  } = ys(n.target);
  return e && n instanceof e;
}
function nne(n) {
  if (!n)
    return !1;
  const {
    TouchEvent: e
  } = ys(n.target);
  return e && n instanceof e;
}
function _2(n) {
  if (nne(n)) {
    if (n.touches && n.touches.length) {
      const {
        clientX: e,
        clientY: t
      } = n.touches[0];
      return {
        x: e,
        y: t
      };
    } else if (n.changedTouches && n.changedTouches.length) {
      const {
        clientX: e,
        clientY: t
      } = n.changedTouches[0];
      return {
        x: e,
        y: t
      };
    }
  }
  return tne(n) ? {
    x: n.clientX,
    y: n.clientY
  } : null;
}
const wm = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(n) {
      if (!n)
        return;
      const {
        x: e,
        y: t
      } = n;
      return "translate3d(" + (e ? Math.round(e) : 0) + "px, " + (t ? Math.round(t) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(n) {
      if (!n)
        return;
      const {
        scaleX: e,
        scaleY: t
      } = n;
      return "scaleX(" + e + ") scaleY(" + t + ")";
    }
  },
  Transform: {
    toString(n) {
      if (n)
        return [wm.Translate.toString(n), wm.Scale.toString(n)].join(" ");
    }
  },
  Transition: {
    toString(n) {
      let {
        property: e,
        duration: t,
        easing: i
      } = n;
      return e + " " + t + "ms " + i;
    }
  }
}), h6 = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function rne(n) {
  return n.matches(h6) ? n : n.querySelector(h6);
}
const ine = {
  display: "none"
};
function one(n) {
  let {
    id: e,
    value: t
  } = n;
  return si.createElement("div", {
    id: e,
    style: ine
  }, t);
}
function ane(n) {
  let {
    id: e,
    announcement: t,
    ariaLiveType: i = "assertive"
  } = n;
  const c = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return si.createElement("div", {
    id: e,
    style: c,
    role: "status",
    "aria-live": i,
    "aria-atomic": !0
  }, t);
}
function sne() {
  const [n, e] = Wn("");
  return {
    announce: hr((i) => {
      i != null && e(i);
    }, []),
    announcement: n
  };
}
const K9 = /* @__PURE__ */ bf(null);
function lne(n) {
  const e = rc(K9);
  An(() => {
    if (!e)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return e(n);
  }, [n, e]);
}
function une() {
  const [n] = Wn(() => /* @__PURE__ */ new Set()), e = hr((i) => (n.add(i), () => n.delete(i)), [n]);
  return [hr((i) => {
    let {
      type: c,
      event: a
    } = i;
    n.forEach((s) => {
      var r;
      return (r = s[c]) == null ? void 0 : r.call(s, a);
    });
  }, [n]), e];
}
const cne = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, dne = {
  onDragStart(n) {
    let {
      active: e
    } = n;
    return "Picked up draggable item " + e.id + ".";
  },
  onDragOver(n) {
    let {
      active: e,
      over: t
    } = n;
    return t ? "Draggable item " + e.id + " was moved over droppable area " + t.id + "." : "Draggable item " + e.id + " is no longer over a droppable area.";
  },
  onDragEnd(n) {
    let {
      active: e,
      over: t
    } = n;
    return t ? "Draggable item " + e.id + " was dropped over droppable area " + t.id : "Draggable item " + e.id + " was dropped.";
  },
  onDragCancel(n) {
    let {
      active: e
    } = n;
    return "Dragging was cancelled. Draggable item " + e.id + " was dropped.";
  }
};
function fne(n) {
  let {
    announcements: e = dne,
    container: t,
    hiddenTextDescribedById: i,
    screenReaderInstructions: c = cne
  } = n;
  const {
    announce: a,
    announcement: s
  } = sne(), r = W1("DndLiveRegion"), [l, d] = Wn(!1);
  if (An(() => {
    d(!0);
  }, []), lne(li(() => ({
    onDragStart(h) {
      let {
        active: p
      } = h;
      a(e.onDragStart({
        active: p
      }));
    },
    onDragMove(h) {
      let {
        active: p,
        over: g
      } = h;
      e.onDragMove && a(e.onDragMove({
        active: p,
        over: g
      }));
    },
    onDragOver(h) {
      let {
        active: p,
        over: g
      } = h;
      a(e.onDragOver({
        active: p,
        over: g
      }));
    },
    onDragEnd(h) {
      let {
        active: p,
        over: g
      } = h;
      a(e.onDragEnd({
        active: p,
        over: g
      }));
    },
    onDragCancel(h) {
      let {
        active: p,
        over: g
      } = h;
      a(e.onDragCancel({
        active: p,
        over: g
      }));
    }
  }), [a, e])), !l)
    return null;
  const f = si.createElement(si.Fragment, null, si.createElement(one, {
    id: i,
    value: c.draggable
  }), si.createElement(ane, {
    id: r,
    announcement: s
  }));
  return t ? om.createPortal(f, t) : f;
}
var ea;
(function(n) {
  n.DragStart = "dragStart", n.DragMove = "dragMove", n.DragEnd = "dragEnd", n.DragCancel = "dragCancel", n.DragOver = "dragOver", n.RegisterDroppable = "registerDroppable", n.SetDroppableDisabled = "setDroppableDisabled", n.UnregisterDroppable = "unregisterDroppable";
})(ea || (ea = {}));
function y2() {
}
function Foe(n, e) {
  return li(
    () => ({
      sensor: n,
      options: e ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, e]
  );
}
function Uoe() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return li(
    () => [...e].filter((i) => i != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
}
const sc = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function Q9(n, e) {
  return Math.sqrt(Math.pow(n.x - e.x, 2) + Math.pow(n.y - e.y, 2));
}
function hne(n, e) {
  const t = _2(n);
  if (!t)
    return "0 0";
  const i = {
    x: (t.x - e.left) / e.width * 100,
    y: (t.y - e.top) / e.height * 100
  };
  return i.x + "% " + i.y + "%";
}
function Z9(n, e) {
  let {
    data: {
      value: t
    }
  } = n, {
    data: {
      value: i
    }
  } = e;
  return t - i;
}
function pne(n, e) {
  let {
    data: {
      value: t
    }
  } = n, {
    data: {
      value: i
    }
  } = e;
  return i - t;
}
function p6(n) {
  let {
    left: e,
    top: t,
    height: i,
    width: c
  } = n;
  return [{
    x: e,
    y: t
  }, {
    x: e + c,
    y: t
  }, {
    x: e,
    y: t + i
  }, {
    x: e + c,
    y: t + i
  }];
}
function J9(n, e) {
  if (!n || n.length === 0)
    return null;
  const [t] = n;
  return t[e];
}
function m6(n, e, t) {
  return e === void 0 && (e = n.left), t === void 0 && (t = n.top), {
    x: e + n.width * 0.5,
    y: t + n.height * 0.5
  };
}
const Hoe = (n) => {
  let {
    collisionRect: e,
    droppableRects: t,
    droppableContainers: i
  } = n;
  const c = m6(e, e.left, e.top), a = [];
  for (const s of i) {
    const {
      id: r
    } = s, l = t.get(r);
    if (l) {
      const d = Q9(m6(l), c);
      a.push({
        id: r,
        data: {
          droppableContainer: s,
          value: d
        }
      });
    }
  }
  return a.sort(Z9);
}, mne = (n) => {
  let {
    collisionRect: e,
    droppableRects: t,
    droppableContainers: i
  } = n;
  const c = p6(e), a = [];
  for (const s of i) {
    const {
      id: r
    } = s, l = t.get(r);
    if (l) {
      const d = p6(l), f = c.reduce((p, g, _) => p + Q9(d[_], g), 0), h = Number((f / 4).toFixed(4));
      a.push({
        id: r,
        data: {
          droppableContainer: s,
          value: h
        }
      });
    }
  }
  return a.sort(Z9);
};
function gne(n, e) {
  const t = Math.max(e.top, n.top), i = Math.max(e.left, n.left), c = Math.min(e.left + e.width, n.left + n.width), a = Math.min(e.top + e.height, n.top + n.height), s = c - i, r = a - t;
  if (i < c && t < a) {
    const l = e.width * e.height, d = n.width * n.height, f = s * r, h = f / (l + d - f);
    return Number(h.toFixed(4));
  }
  return 0;
}
const _ne = (n) => {
  let {
    collisionRect: e,
    droppableRects: t,
    droppableContainers: i
  } = n;
  const c = [];
  for (const a of i) {
    const {
      id: s
    } = a, r = t.get(s);
    if (r) {
      const l = gne(r, e);
      l > 0 && c.push({
        id: s,
        data: {
          droppableContainer: a,
          value: l
        }
      });
    }
  }
  return c.sort(pne);
};
function yne(n, e, t) {
  return {
    ...n,
    scaleX: e && t ? e.width / t.width : 1,
    scaleY: e && t ? e.height / t.height : 1
  };
}
function eD(n, e) {
  return n && e ? {
    x: n.left - e.left,
    y: n.top - e.top
  } : sc;
}
function vne(n) {
  return function(t) {
    for (var i = arguments.length, c = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      c[a - 1] = arguments[a];
    return c.reduce((s, r) => ({
      ...s,
      top: s.top + n * r.y,
      bottom: s.bottom + n * r.y,
      left: s.left + n * r.x,
      right: s.right + n * r.x
    }), {
      ...t
    });
  };
}
const bne = /* @__PURE__ */ vne(1);
function tD(n) {
  if (n.startsWith("matrix3d(")) {
    const e = n.slice(9, -1).split(/, /);
    return {
      x: +e[12],
      y: +e[13],
      scaleX: +e[0],
      scaleY: +e[5]
    };
  } else if (n.startsWith("matrix(")) {
    const e = n.slice(7, -1).split(/, /);
    return {
      x: +e[4],
      y: +e[5],
      scaleX: +e[0],
      scaleY: +e[3]
    };
  }
  return null;
}
function Ene(n, e, t) {
  const i = tD(e);
  if (!i)
    return n;
  const {
    scaleX: c,
    scaleY: a,
    x: s,
    y: r
  } = i, l = n.left - s - (1 - c) * parseFloat(t), d = n.top - r - (1 - a) * parseFloat(t.slice(t.indexOf(" ") + 1)), f = c ? n.width / c : n.width, h = a ? n.height / a : n.height;
  return {
    width: f,
    height: h,
    top: d,
    right: l + f,
    bottom: d + h,
    left: l
  };
}
const Sne = {
  ignoreTransform: !1
};
function C0(n, e) {
  e === void 0 && (e = Sne);
  let t = n.getBoundingClientRect();
  if (e.ignoreTransform) {
    const {
      transform: d,
      transformOrigin: f
    } = ys(n).getComputedStyle(n);
    d && (t = Ene(t, d, f));
  }
  const {
    top: i,
    left: c,
    width: a,
    height: s,
    bottom: r,
    right: l
  } = t;
  return {
    top: i,
    left: c,
    width: a,
    height: s,
    bottom: r,
    right: l
  };
}
function g6(n) {
  return C0(n, {
    ignoreTransform: !0
  });
}
function Cne(n) {
  const e = n.innerWidth, t = n.innerHeight;
  return {
    top: 0,
    left: 0,
    right: e,
    bottom: t,
    width: e,
    height: t
  };
}
function wne(n, e) {
  return e === void 0 && (e = ys(n).getComputedStyle(n)), e.position === "fixed";
}
function xne(n, e) {
  e === void 0 && (e = ys(n).getComputedStyle(n));
  const t = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((c) => {
    const a = e[c];
    return typeof a == "string" ? t.test(a) : !1;
  });
}
function K2(n, e) {
  const t = [];
  function i(c) {
    if (e != null && t.length >= e || !c)
      return t;
    if (HT(c) && c.scrollingElement != null && !t.includes(c.scrollingElement))
      return t.push(c.scrollingElement), t;
    if (!q1(c) || Y9(c) || t.includes(c))
      return t;
    const a = ys(n).getComputedStyle(c);
    return c !== n && xne(c, a) && t.push(c), wne(c, a) ? t : i(c.parentNode);
  }
  return n ? i(n) : t;
}
function nD(n) {
  const [e] = K2(n, 1);
  return e ?? null;
}
function Hw(n) {
  return !$2 || !n ? null : E0(n) ? n : UT(n) ? HT(n) || n === S0(n).scrollingElement ? window : q1(n) ? n : null : null;
}
function rD(n) {
  return E0(n) ? n.scrollX : n.scrollLeft;
}
function iD(n) {
  return E0(n) ? n.scrollY : n.scrollTop;
}
function Ox(n) {
  return {
    x: rD(n),
    y: iD(n)
  };
}
var ha;
(function(n) {
  n[n.Forward = 1] = "Forward", n[n.Backward = -1] = "Backward";
})(ha || (ha = {}));
function oD(n) {
  return !$2 || !n ? !1 : n === document.scrollingElement;
}
function aD(n) {
  const e = {
    x: 0,
    y: 0
  }, t = oD(n) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: n.clientHeight,
    width: n.clientWidth
  }, i = {
    x: n.scrollWidth - t.width,
    y: n.scrollHeight - t.height
  }, c = n.scrollTop <= e.y, a = n.scrollLeft <= e.x, s = n.scrollTop >= i.y, r = n.scrollLeft >= i.x;
  return {
    isTop: c,
    isLeft: a,
    isBottom: s,
    isRight: r,
    maxScroll: i,
    minScroll: e
  };
}
const Tne = {
  x: 0.2,
  y: 0.2
};
function Ane(n, e, t, i, c) {
  let {
    top: a,
    left: s,
    right: r,
    bottom: l
  } = t;
  i === void 0 && (i = 10), c === void 0 && (c = Tne);
  const {
    isTop: d,
    isBottom: f,
    isLeft: h,
    isRight: p
  } = aD(n), g = {
    x: 0,
    y: 0
  }, _ = {
    x: 0,
    y: 0
  }, b = {
    height: e.height * c.y,
    width: e.width * c.x
  };
  return !d && a <= e.top + b.height ? (g.y = ha.Backward, _.y = i * Math.abs((e.top + b.height - a) / b.height)) : !f && l >= e.bottom - b.height && (g.y = ha.Forward, _.y = i * Math.abs((e.bottom - b.height - l) / b.height)), !p && r >= e.right - b.width ? (g.x = ha.Forward, _.x = i * Math.abs((e.right - b.width - r) / b.width)) : !h && s <= e.left + b.width && (g.x = ha.Backward, _.x = i * Math.abs((e.left + b.width - s) / b.width)), {
    direction: g,
    speed: _
  };
}
function kne(n) {
  if (n === document.scrollingElement) {
    const {
      innerWidth: a,
      innerHeight: s
    } = window;
    return {
      top: 0,
      left: 0,
      right: a,
      bottom: s,
      width: a,
      height: s
    };
  }
  const {
    top: e,
    left: t,
    right: i,
    bottom: c
  } = n.getBoundingClientRect();
  return {
    top: e,
    left: t,
    right: i,
    bottom: c,
    width: n.clientWidth,
    height: n.clientHeight
  };
}
function sD(n) {
  return n.reduce((e, t) => i0(e, Ox(t)), sc);
}
function One(n) {
  return n.reduce((e, t) => e + rD(t), 0);
}
function Dne(n) {
  return n.reduce((e, t) => e + iD(t), 0);
}
function lD(n, e) {
  if (e === void 0 && (e = C0), !n)
    return;
  const {
    top: t,
    left: i,
    bottom: c,
    right: a
  } = e(n);
  nD(n) && (c <= 0 || a <= 0 || t >= window.innerHeight || i >= window.innerWidth) && n.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const Rne = [["x", ["left", "right"], One], ["y", ["top", "bottom"], Dne]];
class zT {
  constructor(e, t) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const i = K2(t), c = sD(i);
    this.rect = {
      ...e
    }, this.width = e.width, this.height = e.height;
    for (const [a, s, r] of Rne)
      for (const l of s)
        Object.defineProperty(this, l, {
          get: () => {
            const d = r(i), f = c[a] - d;
            return this.rect[l] + f;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class b1 {
  constructor(e) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((t) => {
        var i;
        return (i = this.target) == null ? void 0 : i.removeEventListener(...t);
      });
    }, this.target = e;
  }
  add(e, t, i) {
    var c;
    (c = this.target) == null || c.addEventListener(e, t, i), this.listeners.push([e, t, i]);
  }
}
function Nne(n) {
  const {
    EventTarget: e
  } = ys(n);
  return n instanceof e ? n : S0(n);
}
function zw(n, e) {
  const t = Math.abs(n.x), i = Math.abs(n.y);
  return typeof e == "number" ? Math.sqrt(t ** 2 + i ** 2) > e : "x" in e && "y" in e ? t > e.x && i > e.y : "x" in e ? t > e.x : "y" in e ? i > e.y : !1;
}
var iu;
(function(n) {
  n.Click = "click", n.DragStart = "dragstart", n.Keydown = "keydown", n.ContextMenu = "contextmenu", n.Resize = "resize", n.SelectionChange = "selectionchange", n.VisibilityChange = "visibilitychange";
})(iu || (iu = {}));
function _6(n) {
  n.preventDefault();
}
function Ine(n) {
  n.stopPropagation();
}
var Lr;
(function(n) {
  n.Space = "Space", n.Down = "ArrowDown", n.Right = "ArrowRight", n.Left = "ArrowLeft", n.Up = "ArrowUp", n.Esc = "Escape", n.Enter = "Enter";
})(Lr || (Lr = {}));
const uD = {
  start: [Lr.Space, Lr.Enter],
  cancel: [Lr.Esc],
  end: [Lr.Space, Lr.Enter]
}, Lne = (n, e) => {
  let {
    currentCoordinates: t
  } = e;
  switch (n.code) {
    case Lr.Right:
      return {
        ...t,
        x: t.x + 25
      };
    case Lr.Left:
      return {
        ...t,
        x: t.x - 25
      };
    case Lr.Down:
      return {
        ...t,
        y: t.y + 25
      };
    case Lr.Up:
      return {
        ...t,
        y: t.y - 25
      };
  }
};
class cD {
  constructor(e) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = e;
    const {
      event: {
        target: t
      }
    } = e;
    this.props = e, this.listeners = new b1(S0(t)), this.windowListeners = new b1(ys(t)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(iu.Resize, this.handleCancel), this.windowListeners.add(iu.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(iu.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: e,
      onStart: t
    } = this.props, i = e.node.current;
    i && lD(i), t(sc);
  }
  handleKeyDown(e) {
    if (X2(e)) {
      const {
        active: t,
        context: i,
        options: c
      } = this.props, {
        keyboardCodes: a = uD,
        coordinateGetter: s = Lne,
        scrollBehavior: r = "smooth"
      } = c, {
        code: l
      } = e;
      if (a.end.includes(l)) {
        this.handleEnd(e);
        return;
      }
      if (a.cancel.includes(l)) {
        this.handleCancel(e);
        return;
      }
      const {
        collisionRect: d
      } = i.current, f = d ? {
        x: d.left,
        y: d.top
      } : sc;
      this.referenceCoordinates || (this.referenceCoordinates = f);
      const h = s(e, {
        active: t,
        context: i.current,
        currentCoordinates: f
      });
      if (h) {
        const p = I1(h, f), g = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: _
        } = i.current;
        for (const b of _) {
          const v = e.code, {
            isTop: E,
            isRight: C,
            isLeft: y,
            isBottom: T,
            maxScroll: A,
            minScroll: k
          } = aD(b), N = kne(b), j = {
            x: Math.min(v === Lr.Right ? N.right - N.width / 2 : N.right, Math.max(v === Lr.Right ? N.left : N.left + N.width / 2, h.x)),
            y: Math.min(v === Lr.Down ? N.bottom - N.height / 2 : N.bottom, Math.max(v === Lr.Down ? N.top : N.top + N.height / 2, h.y))
          }, I = v === Lr.Right && !C || v === Lr.Left && !y, B = v === Lr.Down && !T || v === Lr.Up && !E;
          if (I && j.x !== h.x) {
            const U = b.scrollLeft + p.x, H = v === Lr.Right && U <= A.x || v === Lr.Left && U >= k.x;
            if (H && !p.y) {
              b.scrollTo({
                left: U,
                behavior: r
              });
              return;
            }
            H ? g.x = b.scrollLeft - U : g.x = v === Lr.Right ? b.scrollLeft - A.x : b.scrollLeft - k.x, g.x && b.scrollBy({
              left: -g.x,
              behavior: r
            });
            break;
          } else if (B && j.y !== h.y) {
            const U = b.scrollTop + p.y, H = v === Lr.Down && U <= A.y || v === Lr.Up && U >= k.y;
            if (H && !p.x) {
              b.scrollTo({
                top: U,
                behavior: r
              });
              return;
            }
            H ? g.y = b.scrollTop - U : g.y = v === Lr.Down ? b.scrollTop - A.y : b.scrollTop - k.y, g.y && b.scrollBy({
              top: -g.y,
              behavior: r
            });
            break;
          }
        }
        this.handleMove(e, i0(I1(h, this.referenceCoordinates), g));
      }
    }
  }
  handleMove(e, t) {
    const {
      onMove: i
    } = this.props;
    e.preventDefault(), i(t);
  }
  handleEnd(e) {
    const {
      onEnd: t
    } = this.props;
    e.preventDefault(), this.detach(), t();
  }
  handleCancel(e) {
    const {
      onCancel: t
    } = this.props;
    e.preventDefault(), this.detach(), t();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
cD.activators = [{
  eventName: "onKeyDown",
  handler: (n, e, t) => {
    let {
      keyboardCodes: i = uD,
      onActivation: c
    } = e, {
      active: a
    } = t;
    const {
      code: s
    } = n.nativeEvent;
    if (i.start.includes(s)) {
      const r = a.activatorNode.current;
      return r && n.target !== r ? !1 : (n.preventDefault(), c == null || c({
        event: n.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function y6(n) {
  return !!(n && "distance" in n);
}
function v6(n) {
  return !!(n && "delay" in n);
}
class VT {
  constructor(e, t, i) {
    var c;
    i === void 0 && (i = Nne(e.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = e, this.events = t;
    const {
      event: a
    } = e, {
      target: s
    } = a;
    this.props = e, this.events = t, this.document = S0(s), this.documentListeners = new b1(this.document), this.listeners = new b1(i), this.windowListeners = new b1(ys(s)), this.initialCoordinates = (c = _2(a)) != null ? c : sc, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: e,
      props: {
        options: {
          activationConstraint: t,
          bypassActivationConstraint: i
        }
      }
    } = this;
    if (this.listeners.add(e.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(e.end.name, this.handleEnd), this.windowListeners.add(iu.Resize, this.handleCancel), this.windowListeners.add(iu.DragStart, _6), this.windowListeners.add(iu.VisibilityChange, this.handleCancel), this.windowListeners.add(iu.ContextMenu, _6), this.documentListeners.add(iu.Keydown, this.handleKeydown), t) {
      if (i != null && i({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (v6(t)) {
        this.timeoutId = setTimeout(this.handleStart, t.delay);
        return;
      }
      if (y6(t))
        return;
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: e
    } = this, {
      onStart: t
    } = this.props;
    e && (this.activated = !0, this.documentListeners.add(iu.Click, Ine, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(iu.SelectionChange, this.removeTextSelection), t(e));
  }
  handleMove(e) {
    var t;
    const {
      activated: i,
      initialCoordinates: c,
      props: a
    } = this, {
      onMove: s,
      options: {
        activationConstraint: r
      }
    } = a;
    if (!c)
      return;
    const l = (t = _2(e)) != null ? t : sc, d = I1(c, l);
    if (!i && r) {
      if (y6(r)) {
        if (r.tolerance != null && zw(d, r.tolerance))
          return this.handleCancel();
        if (zw(d, r.distance))
          return this.handleStart();
      }
      return v6(r) && zw(d, r.tolerance) ? this.handleCancel() : void 0;
    }
    e.cancelable && e.preventDefault(), s(l);
  }
  handleEnd() {
    const {
      onEnd: e
    } = this.props;
    this.detach(), e();
  }
  handleCancel() {
    const {
      onCancel: e
    } = this.props;
    this.detach(), e();
  }
  handleKeydown(e) {
    e.code === Lr.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var e;
    (e = this.document.getSelection()) == null || e.removeAllRanges();
  }
}
const Mne = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class dD extends VT {
  constructor(e) {
    const {
      event: t
    } = e, i = S0(t.target);
    super(e, Mne, i);
  }
}
dD.activators = [{
  eventName: "onPointerDown",
  handler: (n, e) => {
    let {
      nativeEvent: t
    } = n, {
      onActivation: i
    } = e;
    return !t.isPrimary || t.button !== 0 ? !1 : (i == null || i({
      event: t
    }), !0);
  }
}];
const Pne = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Dx;
(function(n) {
  n[n.RightClick = 2] = "RightClick";
})(Dx || (Dx = {}));
class jne extends VT {
  constructor(e) {
    super(e, Pne, S0(e.event.target));
  }
}
jne.activators = [{
  eventName: "onMouseDown",
  handler: (n, e) => {
    let {
      nativeEvent: t
    } = n, {
      onActivation: i
    } = e;
    return t.button === Dx.RightClick ? !1 : (i == null || i({
      event: t
    }), !0);
  }
}];
const Vw = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class Bne extends VT {
  constructor(e) {
    super(e, Vw);
  }
  static setup() {
    return window.addEventListener(Vw.move.name, e, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(Vw.move.name, e);
    };
    function e() {
    }
  }
}
Bne.activators = [{
  eventName: "onTouchStart",
  handler: (n, e) => {
    let {
      nativeEvent: t
    } = n, {
      onActivation: i
    } = e;
    const {
      touches: c
    } = t;
    return c.length > 1 ? !1 : (i == null || i({
      event: t
    }), !0);
  }
}];
var E1;
(function(n) {
  n[n.Pointer = 0] = "Pointer", n[n.DraggableRect = 1] = "DraggableRect";
})(E1 || (E1 = {}));
var v2;
(function(n) {
  n[n.TreeOrder = 0] = "TreeOrder", n[n.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(v2 || (v2 = {}));
function Fne(n) {
  let {
    acceleration: e,
    activator: t = E1.Pointer,
    canScroll: i,
    draggingRect: c,
    enabled: a,
    interval: s = 5,
    order: r = v2.TreeOrder,
    pointerCoordinates: l,
    scrollableAncestors: d,
    scrollableAncestorRects: f,
    delta: h,
    threshold: p
  } = n;
  const g = Hne({
    delta: h,
    disabled: !a
  }), [_, b] = ene(), v = zn({
    x: 0,
    y: 0
  }), E = zn({
    x: 0,
    y: 0
  }), C = li(() => {
    switch (t) {
      case E1.Pointer:
        return l ? {
          top: l.y,
          bottom: l.y,
          left: l.x,
          right: l.x
        } : null;
      case E1.DraggableRect:
        return c;
    }
  }, [t, c, l]), y = zn(null), T = hr(() => {
    const k = y.current;
    if (!k)
      return;
    const N = v.current.x * E.current.x, j = v.current.y * E.current.y;
    k.scrollBy(N, j);
  }, []), A = li(() => r === v2.TreeOrder ? [...d].reverse() : d, [r, d]);
  An(
    () => {
      if (!a || !d.length || !C) {
        b();
        return;
      }
      for (const k of A) {
        if ((i == null ? void 0 : i(k)) === !1)
          continue;
        const N = d.indexOf(k), j = f[N];
        if (!j)
          continue;
        const {
          direction: I,
          speed: B
        } = Ane(k, j, C, e, p);
        for (const U of ["x", "y"])
          g[U][I[U]] || (B[U] = 0, I[U] = 0);
        if (B.x > 0 || B.y > 0) {
          b(), y.current = k, _(T, s), v.current = B, E.current = I;
          return;
        }
      }
      v.current = {
        x: 0,
        y: 0
      }, E.current = {
        x: 0,
        y: 0
      }, b();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e,
      T,
      i,
      b,
      a,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(C),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(g),
      _,
      d,
      A,
      f,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(p)
    ]
  );
}
const Une = {
  x: {
    [ha.Backward]: !1,
    [ha.Forward]: !1
  },
  y: {
    [ha.Backward]: !1,
    [ha.Forward]: !1
  }
};
function Hne(n) {
  let {
    delta: e,
    disabled: t
  } = n;
  const i = g2(e);
  return G1((c) => {
    if (t || !i || !c)
      return Une;
    const a = {
      x: Math.sign(e.x - i.x),
      y: Math.sign(e.y - i.y)
    };
    return {
      x: {
        [ha.Backward]: c.x[ha.Backward] || a.x === -1,
        [ha.Forward]: c.x[ha.Forward] || a.x === 1
      },
      y: {
        [ha.Backward]: c.y[ha.Backward] || a.y === -1,
        [ha.Forward]: c.y[ha.Forward] || a.y === 1
      }
    };
  }, [t, e, i]);
}
function zne(n, e) {
  const t = e !== null ? n.get(e) : void 0, i = t ? t.node.current : null;
  return G1((c) => {
    var a;
    return e === null ? null : (a = i ?? c) != null ? a : null;
  }, [i, e]);
}
function Vne(n, e) {
  return li(() => n.reduce((t, i) => {
    const {
      sensor: c
    } = i, a = c.activators.map((s) => ({
      eventName: s.eventName,
      handler: e(s.handler, i)
    }));
    return [...t, ...a];
  }, []), [n, e]);
}
var L1;
(function(n) {
  n[n.Always = 0] = "Always", n[n.BeforeDragging = 1] = "BeforeDragging", n[n.WhileDragging = 2] = "WhileDragging";
})(L1 || (L1 = {}));
var Rx;
(function(n) {
  n.Optimized = "optimized";
})(Rx || (Rx = {}));
const b6 = /* @__PURE__ */ new Map();
function qne(n, e) {
  let {
    dragging: t,
    dependencies: i,
    config: c
  } = e;
  const [a, s] = Wn(null), {
    frequency: r,
    measure: l,
    strategy: d
  } = c, f = zn(n), h = v(), p = N1(h), g = hr(function(E) {
    E === void 0 && (E = []), !p.current && s((C) => C === null ? E : C.concat(E.filter((y) => !C.includes(y))));
  }, [p]), _ = zn(null), b = G1((E) => {
    if (h && !t)
      return b6;
    if (!E || E === b6 || f.current !== n || a != null) {
      const C = /* @__PURE__ */ new Map();
      for (let y of n) {
        if (!y)
          continue;
        if (a && a.length > 0 && !a.includes(y.id) && y.rect.current) {
          C.set(y.id, y.rect.current);
          continue;
        }
        const T = y.node.current, A = T ? new zT(l(T), T) : null;
        y.rect.current = A, A && C.set(y.id, A);
      }
      return C;
    }
    return E;
  }, [n, a, t, h, l]);
  return An(() => {
    f.current = n;
  }, [n]), An(
    () => {
      h || g();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, h]
  ), An(
    () => {
      a && a.length > 0 && s(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(a)]
  ), An(
    () => {
      h || typeof r != "number" || _.current !== null || (_.current = setTimeout(() => {
        g(), _.current = null;
      }, r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, h, g, ...i]
  ), {
    droppableRects: b,
    measureDroppableContainers: g,
    measuringScheduled: a != null
  };
  function v() {
    switch (d) {
      case L1.Always:
        return !1;
      case L1.BeforeDragging:
        return t;
      default:
        return !t;
    }
  }
}
function qT(n, e) {
  return G1((t) => n ? t || (typeof e == "function" ? e(n) : n) : null, [e, n]);
}
function Gne(n, e) {
  return qT(n, e);
}
function Wne(n) {
  let {
    callback: e,
    disabled: t
  } = n;
  const i = Y2(e), c = li(() => {
    if (t || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: a
    } = window;
    return new a(i);
  }, [i, t]);
  return An(() => () => c == null ? void 0 : c.disconnect(), [c]), c;
}
function Q2(n) {
  let {
    callback: e,
    disabled: t
  } = n;
  const i = Y2(e), c = li(
    () => {
      if (t || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: a
      } = window;
      return new a(i);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  );
  return An(() => () => c == null ? void 0 : c.disconnect(), [c]), c;
}
function $ne(n) {
  return new zT(C0(n), n);
}
function E6(n, e, t) {
  e === void 0 && (e = $ne);
  const [i, c] = Px(r, null), a = Wne({
    callback(l) {
      if (n)
        for (const d of l) {
          const {
            type: f,
            target: h
          } = d;
          if (f === "childList" && h instanceof HTMLElement && h.contains(n)) {
            c();
            break;
          }
        }
    }
  }), s = Q2({
    callback: c
  });
  return uu(() => {
    c(), n ? (s == null || s.observe(n), a == null || a.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (s == null || s.disconnect(), a == null || a.disconnect());
  }, [n]), i;
  function r(l) {
    if (!n)
      return null;
    if (n.isConnected === !1) {
      var d;
      return (d = l ?? t) != null ? d : null;
    }
    const f = e(n);
    return JSON.stringify(l) === JSON.stringify(f) ? l : f;
  }
}
function Yne(n) {
  const e = qT(n);
  return eD(n, e);
}
const S6 = [];
function Xne(n) {
  const e = zn(n), t = G1((i) => n ? i && i !== S6 && n && e.current && n.parentNode === e.current.parentNode ? i : K2(n) : S6, [n]);
  return An(() => {
    e.current = n;
  }, [n]), t;
}
function Kne(n) {
  const [e, t] = Wn(null), i = zn(n), c = hr((a) => {
    const s = Hw(a.target);
    s && t((r) => r ? (r.set(s, Ox(s)), new Map(r)) : null);
  }, []);
  return An(() => {
    const a = i.current;
    if (n !== a) {
      s(a);
      const r = n.map((l) => {
        const d = Hw(l);
        return d ? (d.addEventListener("scroll", c, {
          passive: !0
        }), [d, Ox(d)]) : null;
      }).filter((l) => l != null);
      t(r.length ? new Map(r) : null), i.current = n;
    }
    return () => {
      s(n), s(a);
    };
    function s(r) {
      r.forEach((l) => {
        const d = Hw(l);
        d == null || d.removeEventListener("scroll", c);
      });
    }
  }, [c, n]), li(() => n.length ? e ? Array.from(e.values()).reduce((a, s) => i0(a, s), sc) : sD(n) : sc, [n, e]);
}
function C6(n, e) {
  e === void 0 && (e = []);
  const t = zn(null);
  return An(
    () => {
      t.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), An(() => {
    const i = n !== sc;
    i && !t.current && (t.current = n), !i && t.current && (t.current = null);
  }, [n]), t.current ? I1(n, t.current) : sc;
}
function Qne(n) {
  An(
    () => {
      if (!$2)
        return;
      const e = n.map((t) => {
        let {
          sensor: i
        } = t;
        return i.setup == null ? void 0 : i.setup();
      });
      return () => {
        for (const t of e)
          t == null || t();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n.map((e) => {
      let {
        sensor: t
      } = e;
      return t;
    })
  );
}
function Zne(n, e) {
  return li(() => n.reduce((t, i) => {
    let {
      eventName: c,
      handler: a
    } = i;
    return t[c] = (s) => {
      a(s, e);
    }, t;
  }, {}), [n, e]);
}
function fD(n) {
  return li(() => n ? Cne(n) : null, [n]);
}
const qw = [];
function Jne(n, e) {
  e === void 0 && (e = C0);
  const [t] = n, i = fD(t ? ys(t) : null), [c, a] = Px(r, qw), s = Q2({
    callback: a
  });
  return n.length > 0 && c === qw && a(), uu(() => {
    n.length ? n.forEach((l) => s == null ? void 0 : s.observe(l)) : (s == null || s.disconnect(), a());
  }, [n]), c;
  function r() {
    return n.length ? n.map((l) => oD(l) ? i : new zT(e(l), l)) : qw;
  }
}
function hD(n) {
  if (!n)
    return null;
  if (n.children.length > 1)
    return n;
  const e = n.children[0];
  return q1(e) ? e : n;
}
function ere(n) {
  let {
    measure: e
  } = n;
  const [t, i] = Wn(null), c = hr((d) => {
    for (const {
      target: f
    } of d)
      if (q1(f)) {
        i((h) => {
          const p = e(f);
          return h ? {
            ...h,
            width: p.width,
            height: p.height
          } : p;
        });
        break;
      }
  }, [e]), a = Q2({
    callback: c
  }), s = hr((d) => {
    const f = hD(d);
    a == null || a.disconnect(), f && (a == null || a.observe(f)), i(f ? e(f) : null);
  }, [e, a]), [r, l] = m2(s);
  return li(() => ({
    nodeRef: r,
    rect: t,
    setRef: l
  }), [t, r, l]);
}
const tre = [{
  sensor: dD,
  options: {}
}, {
  sensor: cD,
  options: {}
}], nre = {
  current: {}
}, Vb = {
  draggable: {
    measure: g6
  },
  droppable: {
    measure: g6,
    strategy: L1.WhileDragging,
    frequency: Rx.Optimized
  },
  dragOverlay: {
    measure: C0
  }
};
class S1 extends Map {
  get(e) {
    var t;
    return e != null && (t = super.get(e)) != null ? t : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((e) => {
      let {
        disabled: t
      } = e;
      return !t;
    });
  }
  getNodeFor(e) {
    var t, i;
    return (t = (i = this.get(e)) == null ? void 0 : i.node.current) != null ? t : void 0;
  }
}
const rre = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new S1(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: y2
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: Vb,
  measureDroppableContainers: y2,
  windowRect: null,
  measuringScheduled: !1
}, pD = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: y2,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: y2
}, $1 = /* @__PURE__ */ bf(pD), mD = /* @__PURE__ */ bf(rre);
function ire() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new S1()
    }
  };
}
function ore(n, e) {
  switch (e.type) {
    case ea.DragStart:
      return {
        ...n,
        draggable: {
          ...n.draggable,
          initialCoordinates: e.initialCoordinates,
          active: e.active
        }
      };
    case ea.DragMove:
      return n.draggable.active ? {
        ...n,
        draggable: {
          ...n.draggable,
          translate: {
            x: e.coordinates.x - n.draggable.initialCoordinates.x,
            y: e.coordinates.y - n.draggable.initialCoordinates.y
          }
        }
      } : n;
    case ea.DragEnd:
    case ea.DragCancel:
      return {
        ...n,
        draggable: {
          ...n.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case ea.RegisterDroppable: {
      const {
        element: t
      } = e, {
        id: i
      } = t, c = new S1(n.droppable.containers);
      return c.set(i, t), {
        ...n,
        droppable: {
          ...n.droppable,
          containers: c
        }
      };
    }
    case ea.SetDroppableDisabled: {
      const {
        id: t,
        key: i,
        disabled: c
      } = e, a = n.droppable.containers.get(t);
      if (!a || i !== a.key)
        return n;
      const s = new S1(n.droppable.containers);
      return s.set(t, {
        ...a,
        disabled: c
      }), {
        ...n,
        droppable: {
          ...n.droppable,
          containers: s
        }
      };
    }
    case ea.UnregisterDroppable: {
      const {
        id: t,
        key: i
      } = e, c = n.droppable.containers.get(t);
      if (!c || i !== c.key)
        return n;
      const a = new S1(n.droppable.containers);
      return a.delete(t), {
        ...n,
        droppable: {
          ...n.droppable,
          containers: a
        }
      };
    }
    default:
      return n;
  }
}
function are(n) {
  let {
    disabled: e
  } = n;
  const {
    active: t,
    activatorEvent: i,
    draggableNodes: c
  } = rc($1), a = g2(i), s = g2(t == null ? void 0 : t.id);
  return An(() => {
    if (!e && !i && a && s != null) {
      if (!X2(a) || document.activeElement === a.target)
        return;
      const r = c.get(s);
      if (!r)
        return;
      const {
        activatorNode: l,
        node: d
      } = r;
      if (!l.current && !d.current)
        return;
      requestAnimationFrame(() => {
        for (const f of [l.current, d.current]) {
          if (!f)
            continue;
          const h = rne(f);
          if (h) {
            h.focus();
            break;
          }
        }
      });
    }
  }, [i, e, c, s, a]), null;
}
function gD(n, e) {
  let {
    transform: t,
    ...i
  } = e;
  return n != null && n.length ? n.reduce((c, a) => a({
    transform: c,
    ...i
  }), t) : t;
}
function sre(n) {
  return li(
    () => ({
      draggable: {
        ...Vb.draggable,
        ...n == null ? void 0 : n.draggable
      },
      droppable: {
        ...Vb.droppable,
        ...n == null ? void 0 : n.droppable
      },
      dragOverlay: {
        ...Vb.dragOverlay,
        ...n == null ? void 0 : n.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n == null ? void 0 : n.draggable, n == null ? void 0 : n.droppable, n == null ? void 0 : n.dragOverlay]
  );
}
function lre(n) {
  let {
    activeNode: e,
    measure: t,
    initialRect: i,
    config: c = !0
  } = n;
  const a = zn(!1), {
    x: s,
    y: r
  } = typeof c == "boolean" ? {
    x: c,
    y: c
  } : c;
  uu(() => {
    if (!s && !r || !e) {
      a.current = !1;
      return;
    }
    if (a.current || !i)
      return;
    const d = e == null ? void 0 : e.node.current;
    if (!d || d.isConnected === !1)
      return;
    const f = t(d), h = eD(f, i);
    if (s || (h.x = 0), r || (h.y = 0), a.current = !0, Math.abs(h.x) > 0 || Math.abs(h.y) > 0) {
      const p = nD(d);
      p && p.scrollBy({
        top: h.y,
        left: h.x
      });
    }
  }, [e, s, r, i, t]);
}
const Z2 = /* @__PURE__ */ bf({
  ...sc,
  scaleX: 1,
  scaleY: 1
});
var Bh;
(function(n) {
  n[n.Uninitialized = 0] = "Uninitialized", n[n.Initializing = 1] = "Initializing", n[n.Initialized = 2] = "Initialized";
})(Bh || (Bh = {}));
const zoe = /* @__PURE__ */ LP(function(e) {
  var t, i, c, a;
  let {
    id: s,
    accessibility: r,
    autoScroll: l = !0,
    children: d,
    sensors: f = tre,
    collisionDetection: h = _ne,
    measuring: p,
    modifiers: g,
    ..._
  } = e;
  const b = Px(ore, void 0, ire), [v, E] = b, [C, y] = une(), [T, A] = Wn(Bh.Uninitialized), k = T === Bh.Initialized, {
    draggable: {
      active: N,
      nodes: j,
      translate: I
    },
    droppable: {
      containers: B
    }
  } = v, U = N ? j.get(N) : null, H = zn({
    initial: null,
    translated: null
  }), Q = li(() => {
    var In;
    return N != null ? {
      id: N,
      // It's possible for the active node to unmount while dragging
      data: (In = U == null ? void 0 : U.data) != null ? In : nre,
      rect: H
    } : null;
  }, [N, U]), Y = zn(null), [ie, ce] = Wn(null), [$, te] = Wn(null), V = N1(_, Object.values(_)), K = W1("DndDescribedBy", s), ne = li(() => B.getEnabled(), [B]), J = sre(p), {
    droppableRects: L,
    measureDroppableContainers: z,
    measuringScheduled: ee
  } = qne(ne, {
    dragging: k,
    dependencies: [I.x, I.y],
    config: J.droppable
  }), q = zne(j, N), X = li(() => $ ? _2($) : null, [$]), oe = ar(), ae = Gne(q, J.draggable.measure);
  lre({
    activeNode: N ? j.get(N) : null,
    config: oe.layoutShiftCompensation,
    initialRect: ae,
    measure: J.draggable.measure
  });
  const _e = E6(q, J.draggable.measure, ae), ve = E6(q ? q.parentElement : null), Ee = zn({
    activatorEvent: null,
    active: null,
    activeNode: q,
    collisionRect: null,
    collisions: null,
    droppableRects: L,
    draggableNodes: j,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: B,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), we = B.getNodeFor((t = Ee.current.over) == null ? void 0 : t.id), ze = ere({
    measure: J.dragOverlay.measure
  }), Ie = (i = ze.nodeRef.current) != null ? i : q, je = k ? (c = ze.rect) != null ? c : _e : null, qe = !!(ze.nodeRef.current && ze.rect), Ge = Yne(qe ? null : _e), Ze = fD(Ie ? ys(Ie) : null), tt = Xne(k ? we ?? q : null), Qe = Jne(tt), ke = gD(g, {
    transform: {
      x: I.x - Ge.x,
      y: I.y - Ge.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: $,
    active: Q,
    activeNodeRect: _e,
    containerNodeRect: ve,
    draggingNodeRect: je,
    over: Ee.current.over,
    overlayNodeRect: ze.rect,
    scrollableAncestors: tt,
    scrollableAncestorRects: Qe,
    windowRect: Ze
  }), pe = X ? i0(X, I) : null, Se = Kne(tt), he = C6(Se), Te = C6(Se, [_e]), Me = i0(ke, he), Ye = je ? bne(je, ke) : null, et = Q && Ye ? h({
    active: Q,
    collisionRect: Ye,
    droppableRects: L,
    droppableContainers: ne,
    pointerCoordinates: pe
  }) : null, dt = J9(et, "id"), [We, nt] = Wn(null), ft = qe ? ke : i0(ke, Te), At = yne(ft, (a = We == null ? void 0 : We.rect) != null ? a : null, _e), ln = hr(
    (In, On) => {
      let {
        sensor: ui,
        options: Fr
      } = On;
      if (Y.current == null)
        return;
      const er = j.get(Y.current);
      if (!er)
        return;
      const $n = In.nativeEvent, un = new ui({
        active: Y.current,
        activeNode: er,
        event: $n,
        options: Fr,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: Ee,
        onStart(bt) {
          const Pt = Y.current;
          if (Pt == null)
            return;
          const fn = j.get(Pt);
          if (!fn)
            return;
          const {
            onDragStart: cn
          } = V.current, Vn = {
            active: {
              id: Pt,
              data: fn.data,
              rect: H
            }
          };
          om.unstable_batchedUpdates(() => {
            cn == null || cn(Vn), A(Bh.Initializing), E({
              type: ea.DragStart,
              initialCoordinates: bt,
              active: Pt
            }), C({
              type: "onDragStart",
              event: Vn
            });
          });
        },
        onMove(bt) {
          E({
            type: ea.DragMove,
            coordinates: bt
          });
        },
        onEnd: en(ea.DragEnd),
        onCancel: en(ea.DragCancel)
      });
      om.unstable_batchedUpdates(() => {
        ce(un), te(In.nativeEvent);
      });
      function en(bt) {
        return async function() {
          const {
            active: fn,
            collisions: cn,
            over: Vn,
            scrollAdjustedTranslate: En
          } = Ee.current;
          let Kt = null;
          if (fn && En) {
            const {
              cancelDrop: Dn
            } = V.current;
            Kt = {
              activatorEvent: $n,
              active: fn,
              collisions: cn,
              delta: En,
              over: Vn
            }, bt === ea.DragEnd && typeof Dn == "function" && await Promise.resolve(Dn(Kt)) && (bt = ea.DragCancel);
          }
          Y.current = null, om.unstable_batchedUpdates(() => {
            E({
              type: bt
            }), A(Bh.Uninitialized), nt(null), ce(null), te(null);
            const Dn = bt === ea.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Kt) {
              const Kn = V.current[Dn];
              Kn == null || Kn(Kt), C({
                type: Dn,
                event: Kt
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [j]
  ), Jt = hr((In, On) => (ui, Fr) => {
    const er = ui.nativeEvent, $n = j.get(Fr);
    if (
      // Another sensor is already instantiating
      Y.current !== null || // No active draggable
      !$n || // Event has already been captured
      er.dndKit || er.defaultPrevented
    )
      return;
    const un = {
      active: $n
    };
    In(ui, On.options, un) === !0 && (er.dndKit = {
      capturedBy: On.sensor
    }, Y.current = Fr, ln(ui, On));
  }, [j, ln]), zt = Vne(f, Jt);
  Qne(f), uu(() => {
    _e && T === Bh.Initializing && A(Bh.Initialized);
  }, [_e, T]), An(
    () => {
      const {
        onDragMove: In
      } = V.current, {
        active: On,
        activatorEvent: ui,
        collisions: Fr,
        over: er
      } = Ee.current;
      if (!On || !ui)
        return;
      const $n = {
        active: On,
        activatorEvent: ui,
        collisions: Fr,
        delta: {
          x: Me.x,
          y: Me.y
        },
        over: er
      };
      om.unstable_batchedUpdates(() => {
        In == null || In($n), C({
          type: "onDragMove",
          event: $n
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Me.x, Me.y]
  ), An(
    () => {
      const {
        active: In,
        activatorEvent: On,
        collisions: ui,
        droppableContainers: Fr,
        scrollAdjustedTranslate: er
      } = Ee.current;
      if (!In || Y.current == null || !On || !er)
        return;
      const {
        onDragOver: $n
      } = V.current, un = Fr.get(dt), en = un && un.rect.current ? {
        id: un.id,
        rect: un.rect.current,
        data: un.data,
        disabled: un.disabled
      } : null, bt = {
        active: In,
        activatorEvent: On,
        collisions: ui,
        delta: {
          x: er.x,
          y: er.y
        },
        over: en
      };
      om.unstable_batchedUpdates(() => {
        nt(en), $n == null || $n(bt), C({
          type: "onDragOver",
          event: bt
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dt]
  ), uu(() => {
    Ee.current = {
      activatorEvent: $,
      active: Q,
      activeNode: q,
      collisionRect: Ye,
      collisions: et,
      droppableRects: L,
      draggableNodes: j,
      draggingNode: Ie,
      draggingNodeRect: je,
      droppableContainers: B,
      over: We,
      scrollableAncestors: tt,
      scrollAdjustedTranslate: Me
    }, H.current = {
      initial: je,
      translated: Ye
    };
  }, [Q, q, et, Ye, j, Ie, je, L, B, We, tt, Me]), Fne({
    ...oe,
    delta: I,
    draggingRect: Ye,
    pointerCoordinates: pe,
    scrollableAncestors: tt,
    scrollableAncestorRects: Qe
  });
  const kt = li(() => ({
    active: Q,
    activeNode: q,
    activeNodeRect: _e,
    activatorEvent: $,
    collisions: et,
    containerNodeRect: ve,
    dragOverlay: ze,
    draggableNodes: j,
    droppableContainers: B,
    droppableRects: L,
    over: We,
    measureDroppableContainers: z,
    scrollableAncestors: tt,
    scrollableAncestorRects: Qe,
    measuringConfiguration: J,
    measuringScheduled: ee,
    windowRect: Ze
  }), [Q, q, _e, $, et, ve, ze, j, B, L, We, z, tt, Qe, J, ee, Ze]), Ft = li(() => ({
    activatorEvent: $,
    activators: zt,
    active: Q,
    activeNodeRect: _e,
    ariaDescribedById: {
      draggable: K
    },
    dispatch: E,
    draggableNodes: j,
    over: We,
    measureDroppableContainers: z
  }), [$, zt, Q, _e, E, K, j, We, z]);
  return si.createElement(K9.Provider, {
    value: y
  }, si.createElement($1.Provider, {
    value: Ft
  }, si.createElement(mD.Provider, {
    value: kt
  }, si.createElement(Z2.Provider, {
    value: At
  }, d)), si.createElement(are, {
    disabled: (r == null ? void 0 : r.restoreFocus) === !1
  })), si.createElement(fne, {
    ...r,
    hiddenTextDescribedById: K
  }));
  function ar() {
    const In = (ie == null ? void 0 : ie.autoScrollEnabled) === !1, On = typeof l == "object" ? l.enabled === !1 : l === !1, ui = k && !In && !On;
    return typeof l == "object" ? {
      ...l,
      enabled: ui
    } : {
      enabled: ui
    };
  }
}), ure = /* @__PURE__ */ bf(null), w6 = "button", cre = "Droppable";
function dre(n) {
  let {
    id: e,
    data: t,
    disabled: i = !1,
    attributes: c
  } = n;
  const a = W1(cre), {
    activators: s,
    activatorEvent: r,
    active: l,
    activeNodeRect: d,
    ariaDescribedById: f,
    draggableNodes: h,
    over: p
  } = rc($1), {
    role: g = w6,
    roleDescription: _ = "draggable",
    tabIndex: b = 0
  } = c ?? {}, v = (l == null ? void 0 : l.id) === e, E = rc(v ? Z2 : ure), [C, y] = m2(), [T, A] = m2(), k = Zne(s, e), N = N1(t);
  uu(
    () => (h.set(e, {
      id: e,
      key: a,
      node: C,
      activatorNode: T,
      data: N
    }), () => {
      const I = h.get(e);
      I && I.key === a && h.delete(e);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [h, e]
  );
  const j = li(() => ({
    role: g,
    tabIndex: b,
    "aria-disabled": i,
    "aria-pressed": v && g === w6 ? !0 : void 0,
    "aria-roledescription": _,
    "aria-describedby": f.draggable
  }), [i, g, b, v, _, f.draggable]);
  return {
    active: l,
    activatorEvent: r,
    activeNodeRect: d,
    attributes: j,
    isDragging: v,
    listeners: i ? void 0 : k,
    node: C,
    over: p,
    setNodeRef: y,
    setActivatorNodeRef: A,
    transform: E
  };
}
function _D() {
  return rc(mD);
}
const fre = "Droppable", hre = {
  timeout: 25
};
function pre(n) {
  let {
    data: e,
    disabled: t = !1,
    id: i,
    resizeObserverConfig: c
  } = n;
  const a = W1(fre), {
    active: s,
    dispatch: r,
    over: l,
    measureDroppableContainers: d
  } = rc($1), f = zn({
    disabled: t
  }), h = zn(!1), p = zn(null), g = zn(null), {
    disabled: _,
    updateMeasurementsFor: b,
    timeout: v
  } = {
    ...hre,
    ...c
  }, E = N1(b ?? i), C = hr(
    () => {
      if (!h.current) {
        h.current = !0;
        return;
      }
      g.current != null && clearTimeout(g.current), g.current = setTimeout(() => {
        d(Array.isArray(E.current) ? E.current : [E.current]), g.current = null;
      }, v);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), y = Q2({
    callback: C,
    disabled: _ || !s
  }), T = hr((j, I) => {
    y && (I && (y.unobserve(I), h.current = !1), j && y.observe(j));
  }, [y]), [A, k] = m2(T), N = N1(e);
  return An(() => {
    !y || !A.current || (y.disconnect(), h.current = !1, y.observe(A.current));
  }, [A, y]), uu(
    () => (r({
      type: ea.RegisterDroppable,
      element: {
        id: i,
        key: a,
        disabled: t,
        node: A,
        rect: p,
        data: N
      }
    }), () => r({
      type: ea.UnregisterDroppable,
      key: a,
      id: i
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i]
  ), An(() => {
    t !== f.current.disabled && (r({
      type: ea.SetDroppableDisabled,
      id: i,
      key: a,
      disabled: t
    }), f.current.disabled = t);
  }, [i, a, t, r]), {
    active: s,
    rect: p,
    isOver: (l == null ? void 0 : l.id) === i,
    node: A,
    over: l,
    setNodeRef: k
  };
}
function mre(n) {
  let {
    animation: e,
    children: t
  } = n;
  const [i, c] = Wn(null), [a, s] = Wn(null), r = g2(t);
  return !t && !i && r && c(r), uu(() => {
    if (!a)
      return;
    const l = i == null ? void 0 : i.key, d = i == null ? void 0 : i.props.id;
    if (l == null || d == null) {
      c(null);
      return;
    }
    Promise.resolve(e(d, a)).then(() => {
      c(null);
    });
  }, [e, i, a]), si.createElement(si.Fragment, null, t, i ? MP(i, {
    ref: s
  }) : null);
}
const gre = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function _re(n) {
  let {
    children: e
  } = n;
  return si.createElement($1.Provider, {
    value: pD
  }, si.createElement(Z2.Provider, {
    value: gre
  }, e));
}
const yre = {
  position: "fixed",
  touchAction: "none"
}, vre = (n) => X2(n) ? "transform 250ms ease" : void 0, bre = /* @__PURE__ */ Ef((n, e) => {
  let {
    as: t,
    activatorEvent: i,
    adjustScale: c,
    children: a,
    className: s,
    rect: r,
    style: l,
    transform: d,
    transition: f = vre
  } = n;
  if (!r)
    return null;
  const h = c ? d : {
    ...d,
    scaleX: 1,
    scaleY: 1
  }, p = {
    ...yre,
    width: r.width,
    height: r.height,
    top: r.top,
    left: r.left,
    transform: wm.Transform.toString(h),
    transformOrigin: c && i ? hne(i, r) : void 0,
    transition: typeof f == "function" ? f(i) : f,
    ...l
  };
  return si.createElement(t, {
    className: s,
    style: p,
    ref: e
  }, a);
}), Ere = (n) => (e) => {
  let {
    active: t,
    dragOverlay: i
  } = e;
  const c = {}, {
    styles: a,
    className: s
  } = n;
  if (a != null && a.active)
    for (const [r, l] of Object.entries(a.active))
      l !== void 0 && (c[r] = t.node.style.getPropertyValue(r), t.node.style.setProperty(r, l));
  if (a != null && a.dragOverlay)
    for (const [r, l] of Object.entries(a.dragOverlay))
      l !== void 0 && i.node.style.setProperty(r, l);
  return s != null && s.active && t.node.classList.add(s.active), s != null && s.dragOverlay && i.node.classList.add(s.dragOverlay), function() {
    for (const [l, d] of Object.entries(c))
      t.node.style.setProperty(l, d);
    s != null && s.active && t.node.classList.remove(s.active);
  };
}, Sre = (n) => {
  let {
    transform: {
      initial: e,
      final: t
    }
  } = n;
  return [{
    transform: wm.Transform.toString(e)
  }, {
    transform: wm.Transform.toString(t)
  }];
}, Cre = {
  duration: 250,
  easing: "ease",
  keyframes: Sre,
  sideEffects: /* @__PURE__ */ Ere({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function wre(n) {
  let {
    config: e,
    draggableNodes: t,
    droppableContainers: i,
    measuringConfiguration: c
  } = n;
  return Y2((a, s) => {
    if (e === null)
      return;
    const r = t.get(a);
    if (!r)
      return;
    const l = r.node.current;
    if (!l)
      return;
    const d = hD(s);
    if (!d)
      return;
    const {
      transform: f
    } = ys(s).getComputedStyle(s), h = tD(f);
    if (!h)
      return;
    const p = typeof e == "function" ? e : xre(e);
    return lD(l, c.draggable.measure), p({
      active: {
        id: a,
        data: r.data,
        node: l,
        rect: c.draggable.measure(l)
      },
      draggableNodes: t,
      dragOverlay: {
        node: s,
        rect: c.dragOverlay.measure(d)
      },
      droppableContainers: i,
      measuringConfiguration: c,
      transform: h
    });
  });
}
function xre(n) {
  const {
    duration: e,
    easing: t,
    sideEffects: i,
    keyframes: c
  } = {
    ...Cre,
    ...n
  };
  return (a) => {
    let {
      active: s,
      dragOverlay: r,
      transform: l,
      ...d
    } = a;
    if (!e)
      return;
    const f = {
      x: r.rect.left - s.rect.left,
      y: r.rect.top - s.rect.top
    }, h = {
      scaleX: l.scaleX !== 1 ? s.rect.width * l.scaleX / r.rect.width : 1,
      scaleY: l.scaleY !== 1 ? s.rect.height * l.scaleY / r.rect.height : 1
    }, p = {
      x: l.x - f.x,
      y: l.y - f.y,
      ...h
    }, g = c({
      ...d,
      active: s,
      dragOverlay: r,
      transform: {
        initial: l,
        final: p
      }
    }), [_] = g, b = g[g.length - 1];
    if (JSON.stringify(_) === JSON.stringify(b))
      return;
    const v = i == null ? void 0 : i({
      active: s,
      dragOverlay: r,
      ...d
    }), E = r.node.animate(g, {
      duration: e,
      easing: t,
      fill: "forwards"
    });
    return new Promise((C) => {
      E.onfinish = () => {
        v == null || v(), C();
      };
    });
  };
}
let x6 = 0;
function Tre(n) {
  return li(() => {
    if (n != null)
      return x6++, x6;
  }, [n]);
}
const Voe = /* @__PURE__ */ si.memo((n) => {
  let {
    adjustScale: e = !1,
    children: t,
    dropAnimation: i,
    style: c,
    transition: a,
    modifiers: s,
    wrapperElement: r = "div",
    className: l,
    zIndex: d = 999
  } = n;
  const {
    activatorEvent: f,
    active: h,
    activeNodeRect: p,
    containerNodeRect: g,
    draggableNodes: _,
    droppableContainers: b,
    dragOverlay: v,
    over: E,
    measuringConfiguration: C,
    scrollableAncestors: y,
    scrollableAncestorRects: T,
    windowRect: A
  } = _D(), k = rc(Z2), N = Tre(h == null ? void 0 : h.id), j = gD(s, {
    activatorEvent: f,
    active: h,
    activeNodeRect: p,
    containerNodeRect: g,
    draggingNodeRect: v.rect,
    over: E,
    overlayNodeRect: v.rect,
    scrollableAncestors: y,
    scrollableAncestorRects: T,
    transform: k,
    windowRect: A
  }), I = qT(p), B = wre({
    config: i,
    draggableNodes: _,
    droppableContainers: b,
    measuringConfiguration: C
  }), U = I ? v.setRef : void 0;
  return si.createElement(_re, null, si.createElement(mre, {
    animation: B
  }, h && N ? si.createElement(bre, {
    key: N,
    id: h.id,
    ref: U,
    as: r,
    activatorEvent: f,
    adjustScale: e,
    className: l,
    transition: a,
    rect: I,
    style: {
      zIndex: d,
      ...c
    },
    transform: j
  }, t) : null));
}), Are = "_tableWrapper_1l5ur_1", kre = "_table_1l5ur_1", Ore = "_tableHead_1l5ur_50", Dre = "_tableRow_1l5ur_50", Rre = "_tableHeadCell_1l5ur_53", Nre = "_tableHeadCell__sorting_1l5ur_65", Ire = "_tableBody_1l5ur_95", Lre = "_tableCell_1l5ur_98", Mre = "_tableCellTitle_1l5ur_114", Pre = "_draghandle_1l5ur_227", xm = {
  tableWrapper: Are,
  "tableWrapper--noMargin": "_tableWrapper--noMargin_1l5ur_16",
  "tableWrapper--marginTop": "_tableWrapper--marginTop_1l5ur_19",
  "tableWrapper--boxed": "_tableWrapper--boxed_1l5ur_22",
  "tableWrapper--boxed--boxed": "_tableWrapper--boxed--boxed_1l5ur_29",
  "tableWrapper--scrollable": "_tableWrapper--scrollable_1l5ur_38",
  table: kre,
  tableHead: Ore,
  tableRow: Dre,
  tableHeadCell: Rre,
  "tableHeadCell--sortable": "_tableHeadCell--sortable_1l5ur_62",
  tableHeadCell__sorting: Nre,
  "tableHeadCell--activeSort": "_tableHeadCell--activeSort_1l5ur_82",
  tableBody: Ire,
  tableCell: Lre,
  tableCellTitle: Mre,
  "tableRow--clickable": "_tableRow--clickable_1l5ur_118",
  "tableRow--opaque": "_tableRow--opaque_1l5ur_124",
  "tableRow--colorline": "_tableRow--colorline_1l5ur_127",
  "table--clickable": "_table--clickable_1l5ur_146",
  "table--dataGrid": "_table--dataGrid_1l5ur_152",
  "tableCell--hideMobile": "_tableCell--hideMobile_1l5ur_189",
  "tableHeadCell--hideMobile": "_tableHeadCell--hideMobile_1l5ur_190",
  "tableCell--hideTablet": "_tableCell--hideTablet_1l5ur_195",
  "tableHeadCell--hideTablet": "_tableHeadCell--hideTablet_1l5ur_196",
  "tableCell--noWrap": "_tableCell--noWrap_1l5ur_200",
  "tableHeadCell--noWrap": "_tableHeadCell--noWrap_1l5ur_201",
  "tableCell--center": "_tableCell--center_1l5ur_204",
  "tableHeadCell--center": "_tableHeadCell--center_1l5ur_205",
  "tableCell--right": "_tableCell--right_1l5ur_208",
  "tableHeadCell--right": "_tableHeadCell--right_1l5ur_209",
  "tableCell--left": "_tableCell--left_1l5ur_212",
  "tableHeadCell--left": "_tableHeadCell--left_1l5ur_213",
  draghandle: Pre
};
function yD(n, e, t) {
  const i = n.slice();
  return i.splice(t < 0 ? i.length + t : t, 0, i.splice(e, 1)[0]), i;
}
function jre(n, e) {
  return n.reduce((t, i, c) => {
    const a = e.get(i);
    return a && (t[c] = a), t;
  }, Array(n.length));
}
function Nb(n) {
  return n !== null && n >= 0;
}
function Bre(n, e) {
  if (n === e)
    return !0;
  if (n.length !== e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (n[t] !== e[t])
      return !1;
  return !0;
}
function Fre(n) {
  return typeof n == "boolean" ? {
    draggable: n,
    droppable: n
  } : n;
}
const vD = (n) => {
  let {
    rects: e,
    activeIndex: t,
    overIndex: i,
    index: c
  } = n;
  const a = yD(e, i, t), s = e[c], r = a[c];
  return !r || !s ? null : {
    x: r.left - s.left,
    y: r.top - s.top,
    scaleX: r.width / s.width,
    scaleY: r.height / s.height
  };
}, Ib = {
  scaleX: 1,
  scaleY: 1
}, qoe = (n) => {
  var e;
  let {
    activeIndex: t,
    activeNodeRect: i,
    index: c,
    rects: a,
    overIndex: s
  } = n;
  const r = (e = a[t]) != null ? e : i;
  if (!r)
    return null;
  if (c === t) {
    const d = a[s];
    return d ? {
      x: 0,
      y: t < s ? d.top + d.height - (r.top + r.height) : d.top - r.top,
      ...Ib
    } : null;
  }
  const l = Ure(a, c, t);
  return c > t && c <= s ? {
    x: 0,
    y: -r.height - l,
    ...Ib
  } : c < t && c >= s ? {
    x: 0,
    y: r.height + l,
    ...Ib
  } : {
    x: 0,
    y: 0,
    ...Ib
  };
};
function Ure(n, e, t) {
  const i = n[e], c = n[e - 1], a = n[e + 1];
  return i ? t < e ? c ? i.top - (c.top + c.height) : a ? a.top - (i.top + i.height) : 0 : a ? a.top - (i.top + i.height) : c ? i.top - (c.top + c.height) : 0 : 0;
}
const bD = "Sortable", ED = /* @__PURE__ */ si.createContext({
  activeIndex: -1,
  containerId: bD,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: vD,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function Goe(n) {
  let {
    children: e,
    id: t,
    items: i,
    strategy: c = vD,
    disabled: a = !1
  } = n;
  const {
    active: s,
    dragOverlay: r,
    droppableRects: l,
    over: d,
    measureDroppableContainers: f
  } = _D(), h = W1(bD, t), p = r.rect !== null, g = li(() => i.map((k) => typeof k == "object" && "id" in k ? k.id : k), [i]), _ = s != null, b = s ? g.indexOf(s.id) : -1, v = d ? g.indexOf(d.id) : -1, E = zn(g), C = !Bre(g, E.current), y = v !== -1 && b === -1 || C, T = Fre(a);
  uu(() => {
    C && _ && f(g);
  }, [C, g, _, f]), An(() => {
    E.current = g;
  }, [g]);
  const A = li(
    () => ({
      activeIndex: b,
      containerId: h,
      disabled: T,
      disableTransforms: y,
      items: g,
      overIndex: v,
      useDragOverlay: p,
      sortedRects: jre(g, l),
      strategy: c
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [b, h, T.draggable, T.droppable, y, g, v, l, p, c]
  );
  return si.createElement(ED.Provider, {
    value: A
  }, e);
}
const Hre = (n) => {
  let {
    id: e,
    items: t,
    activeIndex: i,
    overIndex: c
  } = n;
  return yD(t, i, c).indexOf(e);
}, zre = (n) => {
  let {
    containerId: e,
    isSorting: t,
    wasDragging: i,
    index: c,
    items: a,
    newIndex: s,
    previousItems: r,
    previousContainerId: l,
    transition: d
  } = n;
  return !d || !i || r !== a && c === s ? !1 : t ? !0 : s !== c && e === l;
}, Vre = {
  duration: 200,
  easing: "ease"
}, SD = "transform", qre = /* @__PURE__ */ wm.Transition.toString({
  property: SD,
  duration: 0,
  easing: "linear"
}), Gre = {
  roleDescription: "sortable"
};
function Wre(n) {
  let {
    disabled: e,
    index: t,
    node: i,
    rect: c
  } = n;
  const [a, s] = Wn(null), r = zn(t);
  return uu(() => {
    if (!e && t !== r.current && i.current) {
      const l = c.current;
      if (l) {
        const d = C0(i.current, {
          ignoreTransform: !0
        }), f = {
          x: l.left - d.left,
          y: l.top - d.top,
          scaleX: l.width / d.width,
          scaleY: l.height / d.height
        };
        (f.x || f.y) && s(f);
      }
    }
    t !== r.current && (r.current = t);
  }, [e, t, i, c]), An(() => {
    a && s(null);
  }, [a]), a;
}
function Woe(n) {
  let {
    animateLayoutChanges: e = zre,
    attributes: t,
    disabled: i,
    data: c,
    getNewIndex: a = Hre,
    id: s,
    strategy: r,
    resizeObserverConfig: l,
    transition: d = Vre
  } = n;
  const {
    items: f,
    containerId: h,
    activeIndex: p,
    disabled: g,
    disableTransforms: _,
    sortedRects: b,
    overIndex: v,
    useDragOverlay: E,
    strategy: C
  } = rc(ED), y = $re(i, g), T = f.indexOf(s), A = li(() => ({
    sortable: {
      containerId: h,
      index: T,
      items: f
    },
    ...c
  }), [h, c, T, f]), k = li(() => f.slice(f.indexOf(s)), [f, s]), {
    rect: N,
    node: j,
    isOver: I,
    setNodeRef: B
  } = pre({
    id: s,
    data: A,
    disabled: y.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: k,
      ...l
    }
  }), {
    active: U,
    activatorEvent: H,
    activeNodeRect: Q,
    attributes: Y,
    setNodeRef: ie,
    listeners: ce,
    isDragging: $,
    over: te,
    setActivatorNodeRef: V,
    transform: K
  } = dre({
    id: s,
    data: A,
    attributes: {
      ...Gre,
      ...t
    },
    disabled: y.draggable
  }), ne = Jte(B, ie), J = !!U, L = J && !_ && Nb(p) && Nb(v), z = !E && $, ee = z && L ? K : null, X = L ? ee ?? (r ?? C)({
    rects: b,
    activeNodeRect: Q,
    activeIndex: p,
    overIndex: v,
    index: T
  }) : null, oe = Nb(p) && Nb(v) ? a({
    id: s,
    items: f,
    activeIndex: p,
    overIndex: v
  }) : T, ae = U == null ? void 0 : U.id, _e = zn({
    activeId: ae,
    items: f,
    newIndex: oe,
    containerId: h
  }), ve = f !== _e.current.items, Ee = e({
    active: U,
    containerId: h,
    isDragging: $,
    isSorting: J,
    id: s,
    index: T,
    items: f,
    newIndex: _e.current.newIndex,
    previousItems: _e.current.items,
    previousContainerId: _e.current.containerId,
    transition: d,
    wasDragging: _e.current.activeId != null
  }), we = Wre({
    disabled: !Ee,
    index: T,
    node: j,
    rect: N
  });
  return An(() => {
    J && _e.current.newIndex !== oe && (_e.current.newIndex = oe), h !== _e.current.containerId && (_e.current.containerId = h), f !== _e.current.items && (_e.current.items = f);
  }, [J, oe, h, f]), An(() => {
    if (ae === _e.current.activeId)
      return;
    if (ae && !_e.current.activeId) {
      _e.current.activeId = ae;
      return;
    }
    const Ie = setTimeout(() => {
      _e.current.activeId = ae;
    }, 50);
    return () => clearTimeout(Ie);
  }, [ae]), {
    active: U,
    activeIndex: p,
    attributes: Y,
    data: A,
    rect: N,
    index: T,
    newIndex: oe,
    items: f,
    isOver: I,
    isSorting: J,
    isDragging: $,
    listeners: ce,
    node: j,
    overIndex: v,
    over: te,
    setNodeRef: ne,
    setActivatorNodeRef: V,
    setDroppableNodeRef: B,
    setDraggableNodeRef: ie,
    transform: we ?? X,
    transition: ze()
  };
  function ze() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      we || // Or to prevent items jumping to back to their "new" position when items change
      ve && _e.current.newIndex === T
    )
      return qre;
    if (!(z && !X2(H) || !d) && (J || Ee))
      return wm.Transition.toString({
        ...d,
        property: SD
      });
  }
}
function $re(n, e) {
  var t, i;
  return typeof n == "boolean" ? {
    draggable: n,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (t = n == null ? void 0 : n.draggable) != null ? t : e.draggable,
    droppable: (i = n == null ? void 0 : n.droppable) != null ? i : e.droppable
  };
}
function b2(n) {
  if (!n)
    return !1;
  const e = n.data.current;
  return !!(e && "sortable" in e && typeof e.sortable == "object" && "containerId" in e.sortable && "items" in e.sortable && "index" in e.sortable);
}
const Yre = [Lr.Down, Lr.Right, Lr.Up, Lr.Left], $oe = (n, e) => {
  let {
    context: {
      active: t,
      collisionRect: i,
      droppableRects: c,
      droppableContainers: a,
      over: s,
      scrollableAncestors: r
    }
  } = e;
  if (Yre.includes(n.code)) {
    if (n.preventDefault(), !t || !i)
      return;
    const l = [];
    a.getEnabled().forEach((h) => {
      if (!h || h != null && h.disabled)
        return;
      const p = c.get(h.id);
      if (p)
        switch (n.code) {
          case Lr.Down:
            i.top < p.top && l.push(h);
            break;
          case Lr.Up:
            i.top > p.top && l.push(h);
            break;
          case Lr.Left:
            i.left > p.left && l.push(h);
            break;
          case Lr.Right:
            i.left < p.left && l.push(h);
            break;
        }
    });
    const d = mne({
      active: t,
      collisionRect: i,
      droppableRects: c,
      droppableContainers: l,
      pointerCoordinates: null
    });
    let f = J9(d, "id");
    if (f === (s == null ? void 0 : s.id) && d.length > 1 && (f = d[1].id), f != null) {
      const h = a.get(t.id), p = a.get(f), g = p ? c.get(p.id) : null, _ = p == null ? void 0 : p.node.current;
      if (_ && g && h && p) {
        const v = K2(_).some((k, N) => r[N] !== k), E = CD(h, p), C = Xre(h, p), y = v || !E ? {
          x: 0,
          y: 0
        } : {
          x: C ? i.width - g.width : 0,
          y: C ? i.height - g.height : 0
        }, T = {
          x: g.left,
          y: g.top
        };
        return y.x && y.y ? T : I1(T, y);
      }
    }
  }
};
function CD(n, e) {
  return !b2(n) || !b2(e) ? !1 : n.data.current.sortable.containerId === e.data.current.sortable.containerId;
}
function Xre(n, e) {
  return !b2(n) || !b2(e) || !CD(n, e) ? !1 : n.data.current.sortable.index < e.data.current.sortable.index;
}
const Kre = Mn.bind(xm), Yoe = Ef(
  (n, e) => {
    const { children: t, onClick: i, opaque: c = !1, color: a, styles: s = {} } = n, r = Kre("tableRow", {
      "tableRow--clickable": i,
      "tableRow--opaque": c,
      "tableRow--colorline": !!a
    }), l = {
      "--tr-color": a ?? "transparent",
      ...s
    };
    return /* @__PURE__ */ Re(
      "tr",
      {
        className: r,
        onClick: i,
        style: l,
        ref: e,
        children: t
      }
    );
  }
), Qre = Mn.bind(xm), Xoe = Ef(
  (n, e) => {
    const {
      children: t,
      hideMobile: i,
      hideTablet: c,
      noWrap: a,
      textAlign: s = "left",
      gridArea: r,
      ...l
    } = n, d = [
      xm.tableCell,
      {
        "tableCell--hideMobile": i,
        "tableCell--hideTablet": c,
        "tableCell--noWrap": a,
        "tableCell--left": s === "left",
        "tableCell--center": s === "center",
        "tableCell--right": s === "right"
      }
    ], f = {
      gridArea: r || "auto"
    };
    return /* @__PURE__ */ Re("td", { className: Qre(d), style: f, ...l, ref: e, children: t });
  }
), T6 = Mn.bind(xm), Koe = ({
  children: n,
  boxed: e,
  scrollable: t,
  clickable: i,
  noMargin: c,
  dataGrid: a
}) => {
  const s = [
    "tableWrapper",
    {
      "tableWrapper--boxed": e,
      "tableWrapper--noMargin": c,
      "tableWrapper--scrollable": t
    }
  ], r = [
    "table",
    {
      "table--scrollable": t,
      "table--clickable": i,
      "table--dataGrid": a
    }
  ];
  return /* @__PURE__ */ Re("div", { className: T6(s), children: /* @__PURE__ */ Re("table", { className: T6(r), children: n }) });
}, Zre = Mn.bind(xm), Qoe = (n) => {
  const {
    children: e,
    hideMobile: t,
    hideTablet: i,
    noWrap: c,
    textAlign: a = "left",
    width: s,
    dragHandler: r = !1,
    sort: l
  } = n, d = [
    xm.tableHeadCell,
    {
      "tableHeadCell--hideMobile": t,
      "tableHeadCell--hideTablet": i,
      "tableHeadCell--nowWrap": c,
      "tableHeadCell--left": a === "left",
      "tableHeadCell--center": a === "center",
      "tableHeadCell--right": a === "right",
      "tableHeadCell--sortable": !!l,
      "tableHeadCell--activeSort": !!(l && l.name === l.sort)
    }
  ], f = () => {
    const p = {};
    return s && (p.width = s), r && (p.width = "2.5rem"), p;
  }, h = () => {
    l && (l.name === l.sort ? l.setOrder(l.order === "desc" ? "asc" : "desc") : (l.setSort(l.name), l.setOrder("asc")));
  };
  return /* @__PURE__ */ Mt("th", { className: Zre(d), style: f(), onClick: h, children: [
    e,
    l && /* @__PURE__ */ Mt("span", { className: xm.tableHeadCell__sorting, children: [
      l.name !== l.sort && /* @__PURE__ */ Re(OP, {}),
      l.name === l.sort && l.order === "asc" && /* @__PURE__ */ Re(DP, {}),
      l.name === l.sort && l.order === "desc" && /* @__PURE__ */ Re(RP, {})
    ] })
  ] });
}, Jre = "_tileWrapper_10jr9_6", eie = "_tile_10jr9_6", tie = "_tileTitle_10jr9_18", nie = "_tileValue_10jr9_47", rie = "_borderPulse_10jr9_1", iie = "_tileChild_10jr9_97", qb = {
  tileWrapper: Jre,
  tile: eie,
  tileTitle: tie,
  "tileTitle--small": "_tileTitle--small_10jr9_26",
  "tileTitle--color-info": "_tileTitle--color-info_10jr9_29",
  "tileTitle--color-success": "_tileTitle--color-success_10jr9_32",
  "tileTitle--color-warning": "_tileTitle--color-warning_10jr9_35",
  "tileTitle--color-error": "_tileTitle--color-error_10jr9_38",
  "tileTitle--color-live": "_tileTitle--color-live_10jr9_41",
  "tileTitle--color-pos": "_tileTitle--color-pos_10jr9_44",
  tileValue: nie,
  "tile--primary": "_tile--primary_10jr9_54",
  "tile--pulse": "_tile--pulse_10jr9_62",
  borderPulse: rie,
  tileChild: iie
}, A6 = Mn.bind(qb), Zoe = (n) => {
  const {
    children: e,
    title: t,
    titleColor: i = "info",
    value: c,
    primary: a,
    pulse: s,
    gridArea: r = "auto"
  } = n, l = A6("tile", {
    "tile--primary": !!a,
    "tile--pulse": !!s
  }), d = A6("tileTitle", {
    [`tileTitle--color-${i}`]: i && !a
  });
  return /* @__PURE__ */ Re("div", { className: qb.tileWrapper, style: { gridArea: r }, children: /* @__PURE__ */ Mt("div", { className: l, children: [
    /* @__PURE__ */ Re("h5", { className: d, children: t }),
    /* @__PURE__ */ Re("h6", { className: qb.tileValue, children: c }),
    e && /* @__PURE__ */ Re("div", { className: qb.tileChild, children: e })
  ] }) });
}, oie = "_toggle_yipul_1", aie = "_toggle__handle_yipul_27", sie = "_toggle__icon_yipul_46", lie = "_toggle__loading_yipul_47", uie = "_spinning_yipul_1", Gb = {
  toggle: oie,
  toggle__handle: aie,
  toggle__icon: sie,
  toggle__loading: lie,
  spinning: uie,
  "toggle--checked": "_toggle--checked_yipul_73",
  "toggle--size-small": "_toggle--size-small_yipul_85",
  "toggle--disabled": "_toggle--disabled_yipul_114",
  "toggle--color-primary": "_toggle--color-primary_yipul_118",
  "toggle--color-secondary": "_toggle--color-secondary_yipul_127",
  "toggle--color-error": "_toggle--color-error_yipul_136",
  "toggle--color-subtle": "_toggle--color-subtle_yipul_145",
  "toggle--color-warning": "_toggle--color-warning_yipul_154"
}, cie = Mn.bind(Gb), Joe = (n) => {
  const {
    checked: e,
    onChange: t,
    size: i,
    disabled: c,
    nonDisabledLook: a = !1,
    loading: s,
    onClick: r,
    color: l
  } = n, d = cie("toggle", {
    "toggle--checked": !!e,
    [`toggle--size-${i}`]: !!i,
    "toggle--disabled": !!(c && !a),
    "toggle--loading": !!s,
    [`toggle--color-${l}`]: !!l
  });
  return /* @__PURE__ */ Mt("label", { className: d, onClick: (p) => {
    p.stopPropagation(), r && r();
  }, children: [
    /* @__PURE__ */ Re("input", { type: "checkbox", checked: e, onChange: (p) => {
      p.stopPropagation(), !c && t(p.target.checked);
    } }),
    /* @__PURE__ */ Mt("div", { className: Gb.toggle__handle, children: [
      n.icon && !s && /* @__PURE__ */ Re("div", { className: Gb.toggle__icon, children: /* @__PURE__ */ Re(n.icon, {}) }),
      s && /* @__PURE__ */ Re("div", { className: Gb.toggle__loading, children: /* @__PURE__ */ Re(NP, {}) })
    ] })
  ] });
}, die = "_tooltipWrapper_1ajvs_1", fie = "_tooltip_1ajvs_1", wD = {
  tooltipWrapper: die,
  tooltip: fie,
  "tooltip--color-info": "_tooltip--color-info_1ajvs_29",
  "tooltip--color-success": "_tooltip--color-success_1ajvs_35",
  "tooltip--color-warning": "_tooltip--color-warning_1ajvs_41",
  "tooltip--color-error": "_tooltip--color-error_1ajvs_47",
  "tooltip--color-live": "_tooltip--color-live_1ajvs_53",
  "tooltip--color-pos": "_tooltip--color-pos_1ajvs_59"
}, hie = Mn.bind(wD), eae = (n) => {
  const { children: e, as: t = "span", text: i, color: c = "default", onLeave: a } = n, s = zn(null), [r, l] = Wn(!1), [d, f] = Wn({
    top: 0,
    left: 0
  }), h = t;
  An(() => {
    if (!s.current || !a) return;
    const b = () => {
      a();
    }, v = s.current;
    return v.addEventListener("mouseleave", b), () => {
      v.removeEventListener("mouseleave", b);
    };
  }, [a]);
  const p = hr(() => {
    if (s.current) {
      const b = s.current.getBoundingClientRect();
      f({
        top: b.top + window.scrollY,
        left: b.left + b.width / 2 + window.scrollX
      });
    }
  }, []);
  An(() => {
    if (r)
      return p(), window.addEventListener("scroll", p), window.addEventListener("resize", p), () => {
        window.removeEventListener("scroll", p), window.removeEventListener("resize", p);
      };
  }, [r, p]);
  const g = hie("tooltip", {
    [`tooltip--color-${c}`]: !!c
    // [`tooltip--${position}`]: position,
    // [`tooltip--${size}`]: size,
  }), _ = r ? om.createPortal(
    /* @__PURE__ */ Re(
      "div",
      {
        className: g,
        style: {
          top: d.top - 10,
          left: d.left
        },
        children: i
      }
    ),
    document.body
  ) : null;
  return /* @__PURE__ */ Mt(
    h,
    {
      className: wD.tooltipWrapper,
      ref: s,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => {
        l(!1), a && a();
      },
      children: [
        e,
        _
      ]
    }
  );
}, pie = "_topbar_xsuil_1", mie = "_topbar__toggle_xsuil_8", gie = "_topbar__mainLogo_xsuil_14", Wb = {
  topbar: pie,
  topbar__toggle: mie,
  topbar__mainLogo: gie,
  "topbar--hideOnTablet": "_topbar--hideOnTablet_xsuil_31"
}, _ie = Mn.bind(Wb), tae = (n) => {
  const { children: e, hideTablet: t } = n, { toggleSidebar: i } = Bx(), c = _ie([
    "topbar",
    {
      "topbar--hideOnTablet": t
    }
  ]);
  return /* @__PURE__ */ Mt("div", { className: c, children: [
    /* @__PURE__ */ Re("div", { className: Wb.topbar__toggle, onClick: i, children: /* @__PURE__ */ Re(IP, {}) }),
    /* @__PURE__ */ Re("div", { className: Wb.topbar__main, children: e || /* @__PURE__ */ Re("div", { className: Wb.topbar__mainLogo, children: /* @__PURE__ */ Re(nX, {}) }) })
  ] });
}, yie = "_sidebar_wv22s_1", vie = {
  sidebar: yie,
  "sidebar--pos": "_sidebar--pos_wv22s_16",
  "sidebar--open": "_sidebar--open_wv22s_19"
}, bie = Mn.bind(vie), nae = (n) => {
  const { children: e, variant: t = "admin" } = n, { isSidebarOpen: i, toggleSidebar: c } = Bx(), a = zn(null);
  An(() => {
    if (!i) return;
    const l = (d) => {
      a.current && !a.current.contains(d.target) && c();
    };
    return document.addEventListener("mouseup", l), document.addEventListener("touchend", l), () => {
      document.removeEventListener("mouseup", l), document.removeEventListener("touchend", l);
    };
  }, [i]);
  const r = bie([
    "sidebar",
    {
      "sidebar--pos": t === "pos",
      "sidebar--open": i
    }
  ]);
  return /* @__PURE__ */ Re(pd, { children: /* @__PURE__ */ Re("nav", { className: r, ref: a, children: e }) });
}, Eie = "_page_10frn_1", Sie = {
  page: Eie,
  "page--noPadding": "_page--noPadding_10frn_10",
  "page--noScroll": "_page--noScroll_10frn_13"
}, Cie = Mn.bind(Sie), rae = Ef((n, e) => {
  const { children: t, noPadding: i = !1, noScroll: c = !1 } = n;
  return /* @__PURE__ */ Re("div", { className: Cie([
    "page",
    {
      "page--noPadding": i,
      "page--noScroll": c
    }
  ]), ref: e, children: t });
}), wie = "_checkbox_gmjt6_1", xie = "_checkmark_gmjt6_18", xD = {
  checkbox: wie,
  checkmark: xie,
  "checkmark--checked": "_checkmark--checked_gmjt6_40"
}, Tie = Mn.bind(xD), iae = (n) => {
  const { checked: e, label: t, name: i, onChange: c } = n, a = Tie("checkmark", {
    "checkmark--checked": e
  });
  return /* @__PURE__ */ Re("div", { children: /* @__PURE__ */ Mt("label", { className: xD.checkbox, children: [
    /* @__PURE__ */ Re(
      "input",
      {
        type: "checkbox",
        name: i,
        checked: e,
        onChange: c
      }
    ),
    /* @__PURE__ */ Re("span", { className: a, children: /* @__PURE__ */ Re(Nx, {}) }),
    t
  ] }) });
}, Aie = "_wrapper_lzomt_1", kie = "_prefix_lzomt_14", Oie = "_suffix_lzomt_15", Die = "_input_lzomt_40", Rie = "_password_lzomt_59", Nie = "_eye_lzomt_83", u1 = {
  wrapper: Aie,
  prefix: kie,
  suffix: Oie,
  input: Die,
  password: Rie,
  eye: Nie
}, Iie = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...n }, /* @__PURE__ */ Ce.createElement("path", { d: "M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z" })), Lie = (n) => /* @__PURE__ */ Ce.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...n }, /* @__PURE__ */ Ce.createElement("path", { d: "M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z" })), Mie = Mn.bind(u1), oae = (n) => {
  const {
    autoComplete: e,
    name: t,
    onChange: i,
    password: c,
    placeholder: a,
    type: s,
    value: r,
    disabled: l,
    prefix: d,
    suffix: f
  } = n, [h, p] = Wn(!!c), g = Mie("input", { password: c }), _ = () => c ? h ? "password" : "text" : s ?? "text", b = () => {
    p(!h);
  };
  return /* @__PURE__ */ Mt("div", { className: u1.wrapper, children: [
    d && /* @__PURE__ */ Re("span", { className: u1.prefix, children: d }),
    /* @__PURE__ */ Re(
      "input",
      {
        className: g,
        id: t,
        type: _(),
        name: t,
        value: r,
        onChange: i,
        placeholder: a,
        autoComplete: e,
        disabled: l
      }
    ),
    c && /* @__PURE__ */ Re("span", { className: u1.eye, onClick: b, children: h ? /* @__PURE__ */ Re(Lie, {}) : /* @__PURE__ */ Re(Iie, {}) }),
    f && /* @__PURE__ */ Re("span", { className: u1.suffix, children: f })
  ] });
}, Pie = "_markdown_1r9lz_1", jie = "_markdown__bottom_1r9lz_13", Bie = "_markdown__textarea_1r9lz_43", Fie = "_markdown__preview_1r9lz_47", Uie = "_markdown__editor_1r9lz_50", c1 = {
  markdown: Pie,
  markdown__bottom: jie,
  markdown__textarea: Bie,
  markdown__preview: Fie,
  markdown__editor: Uie,
  "markdown--open": "_markdown--open_1r9lz_89"
}, Hie = Mn.bind(c1), aae = (n) => {
  const { id: e, name: t, value: i, onChange: c, rows: a, disabled: s } = n, [r, l] = Wn(!1), d = () => {
    l(!r);
  }, f = Hie("markdown", {
    "markdown--open": r
  });
  return /* @__PURE__ */ Mt("div", { className: f, children: [
    /* @__PURE__ */ Re("div", { className: c1.markdown__editor, children: /* @__PURE__ */ Re(
      "textarea",
      {
        className: c1.markdown__textarea,
        id: e,
        name: t,
        onChange: c,
        value: i,
        disabled: s,
        rows: a
      }
    ) }),
    /* @__PURE__ */ Re("div", { className: c1.markdown__preview, children: /* @__PURE__ */ Re(P9, { children: i }) }),
    /* @__PURE__ */ Re("div", { className: c1.markdown__bottom, children: /* @__PURE__ */ Re("button", { type: "button", onClick: d, children: /* @__PURE__ */ Re(I6, {}) }) })
  ] });
};
export {
  goe as $,
  oj as A,
  Fh as B,
  wm as C,
  zoe as D,
  cq as E,
  Mj as F,
  Gj as G,
  yoe as H,
  aoe as I,
  Lz as J,
  cD as K,
  Ux as L,
  y4 as M,
  eoe as N,
  Qv as O,
  Zie as P,
  uoe as Q,
  coe as R,
  nX as S,
  Joe as T,
  Tq as U,
  foe as V,
  hoe as W,
  fw as X,
  poe as Y,
  moe as Z,
  soe as _,
  Kie as a,
  eG as a0,
  rG as a1,
  _oe as a2,
  voe as a3,
  boe as a4,
  Eoe as a5,
  Soe as a6,
  Coe as a7,
  woe as a8,
  Boe as a9,
  Doe as aA,
  Noe as aB,
  Ioe as aC,
  Loe as aD,
  Poe as aE,
  joe as aF,
  Qoe as aa,
  Zoe as ab,
  eae as ac,
  tae as ad,
  nae as ae,
  rae as af,
  iae as ag,
  oae as ah,
  aae as ai,
  roe as aj,
  bz as ak,
  gd as al,
  rr as am,
  ioe as an,
  Xh as ao,
  Zte as ap,
  qte as aq,
  koe as ar,
  Ooe as as,
  pO as at,
  doe as au,
  Moe as av,
  ooe as aw,
  xoe as ax,
  Toe as ay,
  Aoe as az,
  Jie as b,
  Bx as c,
  a0 as d,
  Uoe as e,
  Foe as f,
  Hoe as g,
  $oe as h,
  dD as i,
  Qie as j,
  Goe as k,
  Woe as l,
  loe as m,
  Yoe as n,
  Xoe as o,
  Voe as p,
  Koe as q,
  om as r,
  xm as s,
  Xie as t,
  U6 as u,
  qoe as v,
  B6 as w,
  Fx as x,
  toe as y,
  noe as z
};
